(function() {
  'use strict';

  angular
    .module('OnlineAssessmentAngular', [
      'ngAnimate',
      'ngCookies',
      'ngTouch',
      'ngSanitize',
      'ngMessages',
      'ngAria',
      'ui.router',
      'ui.ace',
      'ui.bootstrap',
      'blockUI',
      'angular.filter',
      'angular-growl',
      'ng.deviceDetector',
      'mgcrea.ngStrap',
      'treeControl',
      'vcRecaptcha',
      'ckeditor'
    ])
    .config(function($sceDelegateProvider) {  
      $sceDelegateProvider.resourceUrlWhitelist([
      'self',
      'https://pearson.hirepro.in/**',
      'https://pearsonstg.hirepro.in/**',
      'https://versant.hirepro.in/**',
      'https://vet.hirepro.in/**',
      'https://versant-stg.hirepro.com.cn/**',
      'https://pearson1.hirepro.in/**',
      'https://qaassesscocubes.hirepro.in/**',
      'https://betaqaassesscocubes.hirepro.in/**',
      'https://qastaticcocubes.hirepro.in/**',
      'https://qascriptscocubes.hirepro.in/**',
      'https://assessccbs.hirepro.in/**',
      'https://scriptsccbs.hirepro.in/**',
      'https://staticccbs.hirepro.in/**',
      'https://nseitstg.hirepro.in/**',
      'https://nseit.hirepro.in/**',
      'https://talentlens.hirepro.in/**',
      'https://talentlensstg.hirepro.in/**',
      'https://talentlensstg1.hirepro.in/**'
      ]);
    });
})();

(function() {
    'use strict';

    angular.module('OnlineAssessmentAngular')
        .component('browserVersion', {
            controller: browserVersionController,
            controllerAs: 'vm',
            templateUrl: 'app/assessment/component/browserVersion/browserVersion.tpl.html'
        });

    function browserVersionController(assessmentUtility, openModalService) {
        var vm = this,
            browserInfo;

        vm.$onInit = function() {
            browserInfo = assessmentUtility.getBrowserInfo(navigator.userAgent);
            if (browserInfo.browser === 'chrome' && browserInfo.version > 40) {
                vm.browserApproved = false;
            } else if (browserInfo.browser === 'mozilla' && browserInfo.version > 55) {
                vm.browserApproved = false;
            } else {
                vm.browserApproved = true;
            }
            var template = "<div class='row'>" +
                "<div class='col-md-6' style='text-align: center;padding-top: 2%;'>" +
                "<div>Your current browser:</div>" +
                "<div class='current-browser'>" +
                "" + browserInfo.browser + "" + "&nbsp;" + "" + browserInfo.version + "" +
                "</div>" +
                "</div>" +
                "<div class='col-md-6' style='text-align: center;border-left: 1px solid #999999ad;'>" +
                "<span style='font-size: 1.1em;'>" +
                "Supported browsers:" +
                "</span>" +
                "<br>" +
                "<span style='color:green'>Mozila 55+</span>" +
                "<br>" +
                "<span style='color:green'>Chrome 40+</span>" +
                "</div>" +
                "</div>";
        };
        vm.showSupportedBrowserList = function() {
            var data = {
                bodyStr: template,
                headerStr: 'Brower Compatibility',
                isAction: true,
                action: {
                    isOkBtn: true,
                    isCancelBtn: false,
                    okText: 'Ok'
                }
            };
            openModalService.openModal('notificationTemplate', data);
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('OnlineAssessmentAngular')
        .service('CaptureCodeActivitySvc', Service);

    /* @ngInject */
    function Service(assessmentUtility, webService, $q, loggerService) {
        var seqOfEventsWithQuestionId = {},
            isOnlinePreview = assessmentUtility.localStorage.getData("_isOnlinePreview");
        isOnlinePreview = isOnlinePreview ? isOnlinePreview : false;
        this.setEventsSequenceWithQuestionId = setEventsSequenceWithQuestionId;
        this.submitUserQuestionHistory = submitUserQuestionHistory;

        ////////////////

        function setEventsSequenceWithQuestionId(qId, obj) {
            if (!seqOfEventsWithQuestionId[qId]) {
                seqOfEventsWithQuestionId[qId] = [];
            }
            seqOfEventsWithQuestionId[qId].push(obj);
            assessmentUtility.localStorage.setData('captureCodeActivityInformation', seqOfEventsWithQuestionId);
        }

        function submitUserQuestionHistory(qId) {
            if (!seqOfEventsWithQuestionId[qId] || isOnlinePreview) {
                return;
            }
            return pushReqTologgerSvc(qId).then(function() {
                delete seqOfEventsWithQuestionId[qId];
                assessmentUtility.localStorage.setData('captureCodeActivityInformation', seqOfEventsWithQuestionId);
            }).catch(function(err) {
                console.log(err);
            });
        }

        function pushReqTologgerSvc(qId) {
            return $q.when(_.chain(seqOfEventsWithQuestionId)
                .pick(qId)
                .transform(function(result, value, key) {
                    var obj = {};
                    obj['questionId'] = _.isString(key) ? _.parseInt(key) : key;
                    obj['code'] = value;
                    obj['timeStamp'] = new Date();
                    obj['testCaseResult'] = '';
                    obj['selectedLanguage'] = undefined;
                    loggerService.push({ 'compileTestCaseJson': obj, 'disableBlockUI': true, 'historyType': 1 }, {
                        'webServiceUrl': 'setTestHistory',
                        'groupReqData': false
                    });
                    return result;
                }, [])
                .value());
        }
    }
})();

(function() {
    "use strict";

    angular
        .module("OnlineAssessmentAngular")
        .directive("scrollMeUp", function($parse) {
            return {
                restrict: 'A',
                scope: {
                    'scrollMeUp': '<'
                },
                link: function(scope, elem, attrs) {
                    //scope.scrollMeUp = {
                    //	clbk: call back fn onScroll,
                    //	scrlOnEvnt: 'auto'(on element load) | 'click'  ...on which event you want to scroll
                    //}
                    var scrlOnEvnt = "auto",
                        clbk = null;
                    if (scope.scrollMeUp) {
                        clbk = scope.scrollMeUp.clbk;
                        scrlOnEvnt = scope.scrollMeUp.scrlOnEvnt ? scope.scrollMeUp.scrlOnEvnt : "auto";
                    }
                    if (scrlOnEvnt === "auto") {
                        clbk && clbk();
                        scrollIntoView(elem[0]);
                    } else if (scrlOnEvnt === "click") {
                        elem[0].addEventListener("click", function() {
                            clbk && clbk();
                            scrollIntoView(elem[0]);
                        });
                    }
                }
            }
        });

    function scrollIntoView(elm) {
        elm.scrollIntoView({ behavior: 'smooth' });
    }
})();

(function() {
    "use strict";
    angular
        .module("OnlineAssessmentAngular")
        .directive("fileInput", function() {
            return {
                restrict: 'A',
                link: onFileUpload
            }
        })
        .directive("parentToChildBubling", parentToChildBubling);

    function parentToChildBubling() {
        return function(scope, element, attrs) {
            var childIndex = attrs.childIndex;
            element[0].addEventListener('click', function() {
                var elem = element[0].children[childIndex - 1];
                elem.click();
            });
        }
    }

    function onFileUpload(scope, element, attrs) {
        var onChangeFunc = scope.vm[attrs.onUpload];
        element[0].addEventListener('change', onChangeFunc);
    }
})();

(function() {
    "use strict";
    angular
        .module("OnlineAssessmentAngular")
        .directive("fadeOnScroll", fadeOnScroll);

    function fadeOnScroll() {
        return function(scope, element, attrs) {
            var uiViewElement = document.getElementsByClassName('main-ui-view')[0];
            uiViewElement.onscroll = function() {
                if (uiViewElement.scrollTop > 0) {
                    if (attrs.qNav && attrs.qNav === "true") {
                        element[0].children[0].style.borderBottom = "1px solid #2a2b47";
                    } else {
                        element.css({ "bottom": "-60px" });
                    }
                } else {
                    if (attrs.qNav && attrs.qNav === "true") {
                        element[0].children[0].style.borderBottom = "0px";
                    } else {
                        element[0].css({ "bottom": "0px" });
                    }
                }
            };
        }
    }
})();

(function() {
    "use strict";
    angular
        .module("OnlineAssessmentAngular")
        .directive('angularAutoFocus', ['$timeout', function($timeout) {
            return {
                restrict: 'A',
                link: function($scope, $element) {
                    $timeout(function() {
                        $element[0].focus();
                    });
                }
            };
        }]);
})();

/* eslint-disable */

/**
 * tracking - A modern approach for Computer Vision on the web.
 * @author Eduardo Lundgren <edu@rdo.io>
 * @version v1.1.2
 * @link http://trackingjs.com
 * @license BSD
 */
(function(window, undefined) {
    window.tracking = window.tracking || {};

    /**
     * Inherit the prototype methods from one constructor into another.
     *
     * Usage:
     * <pre>
     * function ParentClass(a, b) { }
     * ParentClass.prototype.foo = function(a) { }
     *
     * function ChildClass(a, b, c) {
     *   tracking.base(this, a, b);
     * }
     * tracking.inherits(ChildClass, ParentClass);
     *
     * var child = new ChildClass('a', 'b', 'c');
     * child.foo();
     * </pre>
     *
     * @param {Function} childCtor Child class.
     * @param {Function} parentCtor Parent class.
     */
    tracking.inherits = function(childCtor, parentCtor) {
        function TempCtor() {}
        TempCtor.prototype = parentCtor.prototype;
        childCtor.superClass_ = parentCtor.prototype;
        childCtor.prototype = new TempCtor();
        childCtor.prototype.constructor = childCtor;

        /**
         * Calls superclass constructor/method.
         *
         * This function is only available if you use tracking.inherits to express
         * inheritance relationships between classes.
         *
         * @param {!object} me Should always be "this".
         * @param {string} methodName The method name to call. Calling superclass
         *     constructor can be done with the special string 'constructor'.
         * @param {...*} var_args The arguments to pass to superclass
         *     method/constructor.
         * @return {*} The return value of the superclass method/constructor.
         */
        childCtor.base = function(me, methodName) {
            var args = Array.prototype.slice.call(arguments, 2);
            return parentCtor.prototype[methodName].apply(me, args);
        };
    };

    /**
     * Captures the user camera when tracking a video element and set its source
     * to the camera stream.
     * @param {HTMLVideoElement} element Canvas element to track.
     * @param {object} opt_options Optional configuration to the tracker.
     */
    tracking.initUserMedia_ = function(element, _strm, opt_options) {
        /*if (navigator.mediaDevices === undefined) {
            navigator.mediaDevices = {};
        }
        // Some browsers partially implement mediaDevices. We can't just assign an object
        // with getUserMedia as it would overwrite existing properties.
        // Here, we will just add the getUserMedia property if it's missing.
        if (navigator.mediaDevices.getUserMedia === undefined) {
            navigator.mediaDevices.getUserMedia = function(constraints) {
                // First get ahold of the legacy getUserMedia, if present
                var getUserMedia = navigator.webkitGetUserMedia || navigator.mozGetUserMedia;

                // Some browsers just don't implement it - return a rejected promise with an error
                // to keep a consistent interface
                if (!getUserMedia) {
                    return Promise.reject(new Error('getUserMedia is not implemented in this browser'));
                }

                // Otherwise, wrap the call to the old navigator.getUserMedia with a Promise
                return new Promise(function(resolve, reject) {
                    getUserMedia.call(navigator, constraints, resolve, reject);
                });
            }
        }
        navigator.mediaDevices.getUserMedia({
            video: true,
            audio: !!(opt_options && opt_options.audio)
        }).then(function(stream) {
            if (!tracking.localStreams) {
                tracking.localStreams = [];
            }
            tracking.localStreams.push(stream);
            try {
                element.srcObject = angular.copy(stream);
            } catch (error) {
                element.src = URL.createObjectURL(stream);
            }
        }).catch(function(err) {
            console.log(err);
            throw Error('Cannot capture user camera.');
        });*/
        try {
            element.srcObject = _strm;
        } catch (error) {
            element.src = URL.createObjectURL(_strm);
        }
    };

    tracking.stopUserMedia = function() {
        if (!tracking.localStreams || tracking.localStreams.length === 0) {
            console.error("Error::trackingjs:NO local media stream found!");
            return false;
        }
        console.log('streamlenght', tracking.localStreams.length);
        try {
            tracking.localStreams.forEach(function(strm, i) {
                if (!strm) {
                    console.error("Error::trackingjs:Stream not found!");
                    return false;
                }
                var trks = strm.getTracks();
                if (trks && trks.length === 0) {
                    console.error("Error::trackingjs:No tracks found!");
                    return false;
                }
                trks.forEach(function(trk) {
                    if (trk) {
                        trk.stop();
                    }
                });
            });
            navigator.getUserMedia = null;
        } catch (e) {
            console.log('Error::trackingjs:error in stop user media', e);
        }
    };

    /**
     * Tests whether the object is a dom node.
     * @param {object} o Object to be tested.
     * @return {boolean} True if the object is a dom node.
     */
    tracking.isNode = function(o) {
        return o.nodeType || this.isWindow(o);
    };

    /**
     * Tests whether the object is the `window` object.
     * @param {object} o Object to be tested.
     * @return {boolean} True if the object is the `window` object.
     */
    tracking.isWindow = function(o) {
        return !!(o && o.alert && o.document);
    };

    /**
     * Selects a dom node from a CSS3 selector using `document.querySelector`.
     * @param {string} selector
     * @param {object} opt_element The root element for the query. When not
     *     specified `document` is used as root element.
     * @return {HTMLElement} The first dom element that matches to the selector.
     *     If not found, returns `null`.
     */
    tracking.one = function(selector, opt_element) {
        if (this.isNode(selector)) {
            return selector;
        }
        return (opt_element || document).querySelector(selector);
    };

    tracking._elem = null;

    tracking.updateMediaStream = function(_strm) {
        this.initUserMedia_(this._elem, _strm);
    }
    /**
     * Tracks a canvas, image or video element based on the specified `tracker`
     * instance. This method extract the pixel information of the input element
     * to pass to the `tracker` instance. When tracking a video, the
     * `tracker.track(pixels, width, height)` will be in a
     * `requestAnimationFrame` loop in order to track all video frames.
     *
     * Example:
     * var tracker = new tracking.ColorTracker();
     *
     * tracking.track('#video', tracker);
     * or
     * tracking.track('#video', tracker, { camera: true });
     *
     * tracker.on('track', function(event) {
     *   // console.log(event.data[0].x, event.data[0].y)
     * });
     *
     * @param {HTMLElement} element The element to track, canvas, image or
     *     video.
     * @param {tracking.Tracker} tracker The tracker instance used to track the
     *     element.
     * @param {object} opt_options Optional configuration to the tracker.
     */
    tracking.track = function(element, tracker, _strm) { //opt_options
        element = tracking.one(element);
        this._elem = element;
        if (!element) {
            throw new Error('Element not found, try a different element or selector.');
        }
        if (!tracker) {
            throw new Error('Tracker not specified, try `tracking.track(element, new tracking.FaceTracker())`.');
        }

        switch (element.nodeName.toLowerCase()) {
            case 'canvas':
                return this.trackCanvas_(element, tracker, opt_options);
            case 'img':
                return this.trackImg_(element, tracker, opt_options);
            case 'video':
                if (_strm) {
                    this.initUserMedia_(element, _strm);
                } else {
                    throw new Error('Media stream not found!');
                }
                return this.trackVideo_(element, tracker);
            default:
                throw new Error('Element not supported, try in a canvas, img, or video.');
        }
    };

    /**
     * Tracks a canvas element based on the specified `tracker` instance and
     * returns a `TrackerTask` for this track.
     * @param {HTMLCanvasElement} element Canvas element to track.
     * @param {tracking.Tracker} tracker The tracker instance used to track the
     *     element.
     * @param {object} opt_options Optional configuration to the tracker.
     * @return {tracking.TrackerTask}
     * @private
     */
    tracking.trackCanvas_ = function(element, tracker) {
        var self = this;
        var task = new tracking.TrackerTask(tracker);
        task.on('run', function() {
            self.trackCanvasInternal_(element, tracker);
        });
        return task.run();
    };

    /**
     * Tracks a canvas element based on the specified `tracker` instance. This
     * method extract the pixel information of the input element to pass to the
     * `tracker` instance.
     * @param {HTMLCanvasElement} element Canvas element to track.
     * @param {tracking.Tracker} tracker The tracker instance used to track the
     *     element.
     * @param {object} opt_options Optional configuration to the tracker.
     * @private
     */
    tracking.trackCanvasInternal_ = function(element, tracker) {
        var width = element.width;
        var height = element.height;
        var context = element.getContext('2d');
        var imageData = context.getImageData(0, 0, width, height);
        tracker.track(imageData.data, width, height);
    };

    /**
     * Tracks a image element based on the specified `tracker` instance. This
     * method extract the pixel information of the input element to pass to the
     * `tracker` instance.
     * @param {HTMLImageElement} element Canvas element to track.
     * @param {tracking.Tracker} tracker The tracker instance used to track the
     *     element.
     * @param {object} opt_options Optional configuration to the tracker.
     * @private
     */
    tracking.trackImg_ = function(element, tracker) {
        var width = element.width;
        var height = element.height;
        var canvas = document.createElement('canvas');

        canvas.width = width;
        canvas.height = height;

        var task = new tracking.TrackerTask(tracker);
        task.on('run', function() {
            tracking.Canvas.loadImage(canvas, element.src, 0, 0, width, height, function() {
                tracking.trackCanvasInternal_(canvas, tracker);
            });
        });
        return task.run();
    };

    /**
     * Tracks a video element based on the specified `tracker` instance. This
     * method extract the pixel information of the input element to pass to the
     * `tracker` instance. The `tracker.track(pixels, width, height)` will be in
     * a `requestAnimationFrame` loop in order to track all video frames.
     * @param {HTMLVideoElement} element Canvas element to track.
     * @param {tracking.Tracker} tracker The tracker instance used to track the
     *     element.
     * @param {object} opt_options Optional configuration to the tracker.
     * @private
     */
    tracking._fps = 0;

    tracking.trackVideo_ = function(element, tracker) {
        var canvas = document.createElement('canvas');
        var context = canvas.getContext('2d');
        var width;
        var height;
        var sscount = 0;

        var resizeCanvas_ = function() {
            width = element.offsetWidth;
            height = element.offsetHeight;
            canvas.width = width;
            canvas.height = height;
        };
        resizeCanvas_();
        element.addEventListener('resize', resizeCanvas_);

        var requestId,
            fpsCount = 0,
            timelapsed = 0,
            frameCountTimer1 = Date.now(),
            frameCountTimer2,
            isfpsUpdatedOnce = false;

        var typeOfTest = sessionStorage.getItem('typeOfTest'),
            testStatus = sessionStorage.getItem('testStarted'),
            isModifiedFPSRequired = sessionStorage.getItem('isModifiedFPSRequired') === 'true' ? true : false,
            isDesktop = sessionStorage.getItem('isDesktop') === 'true' ? true : false,
            frameDuration = parseInt(sessionStorage.getItem('frameDelayTime'));
            // sessionStorage.getItem('isModifiedFPSRequired');

        if ((typeOfTest === 'versant' && testStatus === 'continue') || (!isDesktop && testStatus === 'continue')) {
            var requestAnimationFrame_ = function() {
                requestId = window.requestAnimationFrame(function() {
                    frameCountTimer2 = Date.now();
                    timelapsed = frameCountTimer2 - frameCountTimer1;
                    if (element.readyState === element.HAVE_ENOUGH_DATA) {
                        //Caculation fps(Frame per second)
                        if (tracking._fps == 0 && (timelapsed >= 1000 && timelapsed < 1500)) {
                            isfpsUpdatedOnce = true;
                            tracking._fps = fpsCount;
                            tracker.updateFps();
                        } else {
                            fpsCount++;
                        }

                        if (timelapsed > frameDuration) { //*1000
                            frameCountTimer1 = Date.now();
                            try {
                                // Firefox v~30.0 gets confused with the video readyState firing an
                                // erroneous HAVE_ENOUGH_DATA just before HAVE_CURRENT_DATA state,
                                // hence keep trying to read it until resolved.
                                context.drawImage(element, 0, 0, width, height);
                            } catch (err) {}
                            tracking.trackCanvasInternal_(canvas, tracker);
                        }
                    }
                    if (!isfpsUpdatedOnce && timelapsed >= 5000) {
                        isfpsUpdatedOnce = true;
                        tracking._fps = 0;
                        tracker.updateFps();
                    }
                    requestAnimationFrame_();
                });
            };
        } else {
            var requestAnimationFrame_ = function() {
                requestId = window.requestAnimationFrame(function() {
                    frameCountTimer2 = Date.now();
                    timelapsed = frameCountTimer2 - frameCountTimer1;
                    if (element.readyState === element.HAVE_ENOUGH_DATA) {
                        //Caculation fps(Frame per second)
                        if (tracking._fps == 0 && (timelapsed >= 1000 && timelapsed < 1500)) {
                            isfpsUpdatedOnce = true;
                            tracking._fps = fpsCount;
                            tracker.updateFps();
                        } else {
                            fpsCount++;
                        }
                        try {
                            // Firefox v~30.0 gets confused with the video readyState firing an
                            // erroneous HAVE_ENOUGH_DATA just before HAVE_CURRENT_DATA state,
                            // hence keep trying to read it until resolved.
                            context.drawImage(element, 0, 0, width, height);
                        } catch (err) {}
                        tracking.trackCanvasInternal_(canvas, tracker);
                    }
                    if (!isfpsUpdatedOnce && timelapsed >= 5000) {
                        isfpsUpdatedOnce = true;
                        tracking._fps = 0;
                        tracker.updateFps();
                    }
                    requestAnimationFrame_();
                });
            };
        }

        var task = new tracking.TrackerTask(tracker);
        task.on('stop', function() {
            window.cancelAnimationFrame(requestId);
        });
        task.on('run', function() {
            requestAnimationFrame_();
        });
        return task.run();
    };

    // Browser polyfills
    //===================

    if (!window.URL) {
        window.URL = window.URL || window.webkitURL || window.msURL || window.oURL;
    }

    if (!navigator.getUserMedia) {
        navigator.getUserMedia = navigator.getUserMedia || navigator.webkitGetUserMedia ||
            navigator.mozGetUserMedia || navigator.msGetUserMedia;
    }
}(window));

(function() {
    /**
     * EventEmitter utility.
     * @constructor
     */
    tracking.EventEmitter = function() {};

    /**
     * Holds event listeners scoped by event type.
     * @type {object}
     * @private
     */
    tracking.EventEmitter.prototype.events_ = null;

    /**
     * Adds a listener to the end of the listeners array for the specified event.
     * @param {string} event
     * @param {function} listener
     * @return {object} Returns emitter, so calls can be chained.
     */
    tracking.EventEmitter.prototype.addListener = function(event, listener) {
        if (typeof listener !== 'function') {
            throw new TypeError('Listener must be a function');
        }
        if (!this.events_) {
            this.events_ = {};
        }

        this.emit('newListener', event, listener);

        if (!this.events_[event]) {
            this.events_[event] = [];
        }

        this.events_[event].push(listener);

        return this;
    };

    /**
     * Returns an array of listeners for the specified event.
     * @param {string} event
     * @return {array} Array of listeners.
     */
    tracking.EventEmitter.prototype.listeners = function(event) {
        return this.events_ && this.events_[event];
    };

    /**
     * Execute each of the listeners in order with the supplied arguments.
     * @param {string} event
     * @param {*} opt_args [arg1], [arg2], [...]
     * @return {boolean} Returns true if event had listeners, false otherwise.
     */
    tracking.EventEmitter.prototype.emit = function(event) {
        var listeners = this.listeners(event);
        if (listeners) {
            var args = Array.prototype.slice.call(arguments, 1);
            for (var i = 0; i < listeners.length; i++) {
                if (listeners[i]) {
                    listeners[i].apply(this, args);
                }
            }
            return true;
        }
        return false;
    };

    /**
     * Adds a listener to the end of the listeners array for the specified event.
     * @param {string} event
     * @param {function} listener
     * @return {object} Returns emitter, so calls can be chained.
     */
    tracking.EventEmitter.prototype.on = tracking.EventEmitter.prototype.addListener;

    /**
     * Adds a one time listener for the event. This listener is invoked only the
     * next time the event is fired, after which it is removed.
     * @param {string} event
     * @param {function} listener
     * @return {object} Returns emitter, so calls can be chained.
     */
    tracking.EventEmitter.prototype.once = function(event, listener) {
        var self = this;
        self.on(event, function handlerInternal() {
            self.removeListener(event, handlerInternal);
            listener.apply(this, arguments);
        });
    };

    /**
     * Removes all listeners, or those of the specified event. It's not a good
     * idea to remove listeners that were added elsewhere in the code,
     * especially when it's on an emitter that you didn't create.
     * @param {string} event
     * @return {object} Returns emitter, so calls can be chained.
     */
    tracking.EventEmitter.prototype.removeAllListeners = function(opt_event) {
        if (!this.events_) {
            return this;
        }
        if (opt_event) {
            delete this.events_[opt_event];
        } else {
            delete this.events_;
        }
        return this;
    };

    /**
     * Remove a listener from the listener array for the specified event.
     * Caution: changes array indices in the listener array behind the listener.
     * @param {string} event
     * @param {function} listener
     * @return {object} Returns emitter, so calls can be chained.
     */
    tracking.EventEmitter.prototype.removeListener = function(event, listener) {
        if (typeof listener !== 'function') {
            throw new TypeError('Listener must be a function');
        }
        if (!this.events_) {
            return this;
        }

        var listeners = this.listeners(event);
        if (Array.isArray(listeners)) {
            var i = listeners.indexOf(listener);
            if (i < 0) {
                return this;
            }
            listeners.splice(i, 1);
        }

        return this;
    };

    /**
     * By default EventEmitters will print a warning if more than 10 listeners
     * are added for a particular event. This is a useful default which helps
     * finding memory leaks. Obviously not all Emitters should be limited to 10.
     * This function allows that to be increased. Set to zero for unlimited.
     * @param {number} n The maximum number of listeners.
     */
    tracking.EventEmitter.prototype.setMaxListeners = function() {
        throw new Error('Not implemented');
    };

}());

(function() {
    /**
     * Canvas utility.
     * @static
     * @constructor
     */
    tracking.Canvas = {};

    /**
     * Loads an image source into the canvas.
     * @param {HTMLCanvasElement} canvas The canvas dom element.
     * @param {string} src The image source.
     * @param {number} x The canvas horizontal coordinate to load the image.
     * @param {number} y The canvas vertical coordinate to load the image.
     * @param {number} width The image width.
     * @param {number} height The image height.
     * @param {function} opt_callback Callback that fires when the image is loaded
     *     into the canvas.
     * @static
     */
    tracking.Canvas.loadImage = function(canvas, src, x, y, width, height, opt_callback) {
        var instance = this;
        var img = new window.Image();
        img.crossOrigin = '*';
        img.onload = function() {
            var context = canvas.getContext('2d');
            canvas.width = width;
            canvas.height = height;
            context.drawImage(img, x, y, width, height);
            if (opt_callback) {
                opt_callback.call(instance);
            }
            img = null;
        };
        img.src = src;
    };
}());

// (function() {
//     /**
//      * DisjointSet utility with path compression. Some applications involve
//      * grouping n distinct objects into a collection of disjoint sets. Two
//      * important operations are then finding which set a given object belongs to
//      * and uniting the two sets. A disjoint set data structure maintains a
//      * collection S={ S1 , S2 ,..., Sk } of disjoint dynamic sets. Each set is
//      * identified by a representative, which usually is a member in the set.
//      * @static
//      * @constructor
//      */
//     tracking.DisjointSet = function(length) {
//         if (length === undefined) {
//             throw new Error('DisjointSet length not specified.');
//         }
//         this.length = length;
//         this.parent = new Uint32Array(length);
//         for (var i = 0; i < length; i++) {
//             this.parent[i] = i;
//         }
//     };

//     /**
//      * Holds the length of the internal set.
//      * @type {number}
//      */
//     tracking.DisjointSet.prototype.length = null;

//     /**
//      * Holds the set containing the representative values.
//      * @type {Array.<number>}
//      */
//     tracking.DisjointSet.prototype.parent = null;

//     /**
//      * Finds a pointer to the representative of the set containing i.
//      * @param {number} i
//      * @return {number} The representative set of i.
//      */
//     tracking.DisjointSet.prototype.find = function(i) {
//         if (this.parent[i] === i) {
//             return i;
//         } else {
//             return (this.parent[i] = this.find(this.parent[i]));
//         }
//     };

//     /**
//      * Unites two dynamic sets containing objects i and j, say Si and Sj, into
//      * a new set that Si ∪ Sj, assuming that Si ∩ Sj = ∅;
//      * @param {number} i
//      * @param {number} j
//      */
//     tracking.DisjointSet.prototype.union = function(i, j) {
//         var iRepresentative = this.find(i);
//         var jRepresentative = this.find(j);
//         this.parent[iRepresentative] = jRepresentative;
//     };

// }());

(function() {
    /**
     * Image utility.
     * @static
     * @constructor
     */
    tracking.Image = {};

    /**
     * Computes gaussian blur. Adapted from
     * https://github.com/kig/canvasfilters.
     * @param {pixels} pixels The pixels in a linear [r,g,b,a,...] array.
     * @param {number} width The image width.
     * @param {number} height The image height.
     * @param {number} diameter Gaussian blur diameter, must be greater than 1.
     * @return {array} The edge pixels in a linear [r,g,b,a,...] array.
     */
    tracking.Image.blur = function(pixels, width, height, diameter) {
        diameter = Math.abs(diameter);
        if (diameter <= 1) {
            throw new Error('Diameter should be greater than 1.');
        }
        var radius = diameter / 2;
        var len = Math.ceil(diameter) + (1 - (Math.ceil(diameter) % 2));
        var weights = new Float32Array(len);
        var rho = (radius + 0.5) / 3;
        var rhoSq = rho * rho;
        var gaussianFactor = 1 / Math.sqrt(2 * Math.PI * rhoSq);
        var rhoFactor = -1 / (2 * rho * rho);
        var wsum = 0;
        var middle = Math.floor(len / 2);
        for (var i = 0; i < len; i++) {
            var x = i - middle;
            var gx = gaussianFactor * Math.exp(x * x * rhoFactor);
            weights[i] = gx;
            wsum += gx;
        }
        for (var j = 0; j < weights.length; j++) {
            weights[j] /= wsum;
        }
        return this.separableConvolve(pixels, width, height, weights, weights, false);
    };

    /**
     * Computes the integral image for summed, squared, rotated and sobel pixels.
     * @param {array} pixels The pixels in a linear [r,g,b,a,...] array to loop
     *     through.
     * @param {number} width The image width.
     * @param {number} height The image height.
     * @param {array} opt_integralImage Empty array of size `width * height` to
     *     be filled with the integral image values. If not specified compute sum
     *     values will be skipped.
     * @param {array} opt_integralImageSquare Empty array of size `width *
     *     height` to be filled with the integral image squared values. If not
     *     specified compute squared values will be skipped.
     * @param {array} opt_tiltedIntegralImage Empty array of size `width *
     *     height` to be filled with the rotated integral image values. If not
     *     specified compute sum values will be skipped.
     * @param {array} opt_integralImageSobel Empty array of size `width *
     *     height` to be filled with the integral image of sobel values. If not
     *     specified compute sobel filtering will be skipped.
     * @static
     */
    tracking.Image.computeIntegralImage = function(pixels, width, height, opt_integralImage, opt_integralImageSquare, opt_tiltedIntegralImage, opt_integralImageSobel) {
        if (arguments.length < 4) {
            throw new Error('You should specify at least one output array in the order: sum, square, tilted, sobel.');
        }
        var pixelsSobel;
        if (opt_integralImageSobel) {
            pixelsSobel = tracking.Image.sobel(pixels, width, height);
        }
        for (var i = 0; i < height; i++) {
            for (var j = 0; j < width; j++) {
                var w = i * width * 4 + j * 4;
                var pixel = ~~(pixels[w] * 0.299 + pixels[w + 1] * 0.587 + pixels[w + 2] * 0.114);
                if (opt_integralImage) {
                    this.computePixelValueSAT_(opt_integralImage, width, i, j, pixel);
                }
                if (opt_integralImageSquare) {
                    this.computePixelValueSAT_(opt_integralImageSquare, width, i, j, pixel * pixel);
                }
                if (opt_tiltedIntegralImage) {
                    var w1 = w - width * 4;
                    var pixelAbove = ~~(pixels[w1] * 0.299 + pixels[w1 + 1] * 0.587 + pixels[w1 + 2] * 0.114);
                    this.computePixelValueRSAT_(opt_tiltedIntegralImage, width, i, j, pixel, pixelAbove || 0);
                }
                if (opt_integralImageSobel) {
                    this.computePixelValueSAT_(opt_integralImageSobel, width, i, j, pixelsSobel[w]);
                }
            }
        }
    };

    /**
     * Helper method to compute the rotated summed area table (RSAT) by the
     * formula:
     *
     * RSAT(x, y) = RSAT(x-1, y-1) + RSAT(x+1, y-1) - RSAT(x, y-2) + I(x, y) + I(x, y-1)
     *
     * @param {number} width The image width.
     * @param {array} RSAT Empty array of size `width * height` to be filled with
     *     the integral image values. If not specified compute sum values will be
     *     skipped.
     * @param {number} i Vertical position of the pixel to be evaluated.
     * @param {number} j Horizontal position of the pixel to be evaluated.
     * @param {number} pixel Pixel value to be added to the integral image.
     * @static
     * @private
     */
    tracking.Image.computePixelValueRSAT_ = function(RSAT, width, i, j, pixel, pixelAbove) {
        var w = i * width + j;
        RSAT[w] = (RSAT[w - width - 1] || 0) + (RSAT[w - width + 1] || 0) - (RSAT[w - width - width] || 0) + pixel + pixelAbove;
    };

    /**
     * Helper method to compute the summed area table (SAT) by the formula:
     *
     * SAT(x, y) = SAT(x, y-1) + SAT(x-1, y) + I(x, y) - SAT(x-1, y-1)
     *
     * @param {number} width The image width.
     * @param {array} SAT Empty array of size `width * height` to be filled with
     *     the integral image values. If not specified compute sum values will be
     *     skipped.
     * @param {number} i Vertical position of the pixel to be evaluated.
     * @param {number} j Horizontal position of the pixel to be evaluated.
     * @param {number} pixel Pixel value to be added to the integral image.
     * @static
     * @private
     */
    tracking.Image.computePixelValueSAT_ = function(SAT, width, i, j, pixel) {
        var w = i * width + j;
        SAT[w] = (SAT[w - width] || 0) + (SAT[w - 1] || 0) + pixel - (SAT[w - width - 1] || 0);
    };

    /**
     * Converts a color from a colorspace based on an RGB color model to a
     * grayscale representation of its luminance. The coefficients represent the
     * measured intensity perception of typical trichromat humans, in
     * particular, human vision is most sensitive to green and least sensitive
     * to blue.
     * @param {pixels} pixels The pixels in a linear [r,g,b,a,...] array.
     * @param {number} width The image width.
     * @param {number} height The image height.
     * @param {boolean} fillRGBA If the result should fill all RGBA values with the gray scale
     *  values, instead of returning a single value per pixel.
     * @param {Uint8ClampedArray} The grayscale pixels in a linear array ([p,p,p,a,...] if fillRGBA
     *  is true and [p1, p2, p3, ...] if fillRGBA is false).
     * @static
     */
    tracking.Image.grayscale = function(pixels, width, height, fillRGBA) {
        var gray = new Uint8ClampedArray(fillRGBA ? pixels.length : pixels.length >> 2);
        var p = 0;
        var w = 0;
        for (var i = 0; i < height; i++) {
            for (var j = 0; j < width; j++) {
                var value = pixels[w] * 0.299 + pixels[w + 1] * 0.587 + pixels[w + 2] * 0.114;
                gray[p++] = value;

                if (fillRGBA) {
                    gray[p++] = value;
                    gray[p++] = value;
                    gray[p++] = pixels[w + 3];
                }

                w += 4;
            }
        }
        return gray;
    };

    /**
     * Fast horizontal separable convolution. A point spread function (PSF) is
     * said to be separable if it can be broken into two one-dimensional
     * signals: a vertical and a horizontal projection. The convolution is
     * performed by sliding the kernel over the image, generally starting at the
     * top left corner, so as to move the kernel through all the positions where
     * the kernel fits entirely within the boundaries of the image. Adapted from
     * https://github.com/kig/canvasfilters.
     * @param {pixels} pixels The pixels in a linear [r,g,b,a,...] array.
     * @param {number} width The image width.
     * @param {number} height The image height.
     * @param {array} weightsVector The weighting vector, e.g [-1,0,1].
     * @param {number} opaque
     * @return {array} The convoluted pixels in a linear [r,g,b,a,...] array.
     */
    tracking.Image.horizontalConvolve = function(pixels, width, height, weightsVector, opaque) {
        var side = weightsVector.length;
        var halfSide = Math.floor(side / 2);
        var output = new Float32Array(width * height * 4);
        var alphaFac = opaque ? 1 : 0;

        for (var y = 0; y < height; y++) {
            for (var x = 0; x < width; x++) {
                var sy = y;
                var sx = x;
                var offset = (y * width + x) * 4;
                var r = 0;
                var g = 0;
                var b = 0;
                var a = 0;
                for (var cx = 0; cx < side; cx++) {
                    var scy = sy;
                    var scx = Math.min(width - 1, Math.max(0, sx + cx - halfSide));
                    var poffset = (scy * width + scx) * 4;
                    var wt = weightsVector[cx];
                    r += pixels[poffset] * wt;
                    g += pixels[poffset + 1] * wt;
                    b += pixels[poffset + 2] * wt;
                    a += pixels[poffset + 3] * wt;
                }
                output[offset] = r;
                output[offset + 1] = g;
                output[offset + 2] = b;
                output[offset + 3] = a + alphaFac * (255 - a);
            }
        }
        return output;
    };

    /**
     * Fast vertical separable convolution. A point spread function (PSF) is
     * said to be separable if it can be broken into two one-dimensional
     * signals: a vertical and a horizontal projection. The convolution is
     * performed by sliding the kernel over the image, generally starting at the
     * top left corner, so as to move the kernel through all the positions where
     * the kernel fits entirely within the boundaries of the image. Adapted from
     * https://github.com/kig/canvasfilters.
     * @param {pixels} pixels The pixels in a linear [r,g,b,a,...] array.
     * @param {number} width The image width.
     * @param {number} height The image height.
     * @param {array} weightsVector The weighting vector, e.g [-1,0,1].
     * @param {number} opaque
     * @return {array} The convoluted pixels in a linear [r,g,b,a,...] array.
     */
    tracking.Image.verticalConvolve = function(pixels, width, height, weightsVector, opaque) {
        var side = weightsVector.length;
        var halfSide = Math.floor(side / 2);
        var output = new Float32Array(width * height * 4);
        var alphaFac = opaque ? 1 : 0;

        for (var y = 0; y < height; y++) {
            for (var x = 0; x < width; x++) {
                var sy = y;
                var sx = x;
                var offset = (y * width + x) * 4;
                var r = 0;
                var g = 0;
                var b = 0;
                var a = 0;
                for (var cy = 0; cy < side; cy++) {
                    var scy = Math.min(height - 1, Math.max(0, sy + cy - halfSide));
                    var scx = sx;
                    var poffset = (scy * width + scx) * 4;
                    var wt = weightsVector[cy];
                    r += pixels[poffset] * wt;
                    g += pixels[poffset + 1] * wt;
                    b += pixels[poffset + 2] * wt;
                    a += pixels[poffset + 3] * wt;
                }
                output[offset] = r;
                output[offset + 1] = g;
                output[offset + 2] = b;
                output[offset + 3] = a + alphaFac * (255 - a);
            }
        }
        return output;
    };

    /**
     * Fast separable convolution. A point spread function (PSF) is said to be
     * separable if it can be broken into two one-dimensional signals: a
     * vertical and a horizontal projection. The convolution is performed by
     * sliding the kernel over the image, generally starting at the top left
     * corner, so as to move the kernel through all the positions where the
     * kernel fits entirely within the boundaries of the image. Adapted from
     * https://github.com/kig/canvasfilters.
     * @param {pixels} pixels The pixels in a linear [r,g,b,a,...] array.
     * @param {number} width The image width.
     * @param {number} height The image height.
     * @param {array} horizWeights The horizontal weighting vector, e.g [-1,0,1].
     * @param {array} vertWeights The vertical vector, e.g [-1,0,1].
     * @param {number} opaque
     * @return {array} The convoluted pixels in a linear [r,g,b,a,...] array.
     */
    tracking.Image.separableConvolve = function(pixels, width, height, horizWeights, vertWeights, opaque) {
        var vertical = this.verticalConvolve(pixels, width, height, vertWeights, opaque);
        return this.horizontalConvolve(vertical, width, height, horizWeights, opaque);
    };

    /**
     * Compute image edges using Sobel operator. Computes the vertical and
     * horizontal gradients of the image and combines the computed images to
     * find edges in the image. The way we implement the Sobel filter here is by
     * first grayscaling the image, then taking the horizontal and vertical
     * gradients and finally combining the gradient images to make up the final
     * image. Adapted from https://github.com/kig/canvasfilters.
     * @param {pixels} pixels The pixels in a linear [r,g,b,a,...] array.
     * @param {number} width The image width.
     * @param {number} height The image height.
     * @return {array} The edge pixels in a linear [r,g,b,a,...] array.
     */
    tracking.Image.sobel = function(pixels, width, height) {
        pixels = this.grayscale(pixels, width, height, true);
        var output = new Float32Array(width * height * 4);
        var sobelSignVector = new Float32Array([-1, 0, 1]);
        var sobelScaleVector = new Float32Array([1, 2, 1]);
        var vertical = this.separableConvolve(pixels, width, height, sobelSignVector, sobelScaleVector);
        var horizontal = this.separableConvolve(pixels, width, height, sobelScaleVector, sobelSignVector);

        for (var i = 0; i < output.length; i += 4) {
            var v = vertical[i];
            var h = horizontal[i];
            var p = Math.sqrt(h * h + v * v);
            output[i] = p;
            output[i + 1] = p;
            output[i + 2] = p;
            output[i + 3] = 255;
        }

        return output;
    };

}());

// (function() {
//     /**
//      * ViolaJones utility.
//      * @static
//      * @constructor
//      */
//     tracking.ViolaJones = {};

//     /**
//      * Holds the minimum area of intersection that defines when a rectangle is
//      * from the same group. Often when a face is matched multiple rectangles are
//      * classified as possible rectangles to represent the face, when they
//      * intersects they are grouped as one face.
//      * @type {number}
//      * @default 0.5
//      * @static
//      */
//     tracking.ViolaJones.REGIONS_OVERLAP = 0.5;

//     /**
//      * Holds the HAAR cascade classifiers converted from OpenCV training.
//      * @type {array}
//      * @static
//      */
//     tracking.ViolaJones.classifiers = {};

//     /**
//      * Detects through the HAAR cascade data rectangles matches.
//      * @param {pixels} pixels The pixels in a linear [r,g,b,a,...] array.
//      * @param {number} width The image width.
//      * @param {number} height The image height.
//      * @param {number} initialScale The initial scale to start the block
//      *     scaling.
//      * @param {number} scaleFactor The scale factor to scale the feature block.
//      * @param {number} stepSize The block step size.
//      * @param {number} edgesDensity Percentage density edges inside the
//      *     classifier block. Value from [0.0, 1.0], defaults to 0.2. If specified
//      *     edge detection will be applied to the image to prune dead areas of the
//      *     image, this can improve significantly performance.
//      * @param {number} data The HAAR cascade data.
//      * @return {array} Found rectangles.
//      * @static
//      */
//     tracking.ViolaJones.detect = function(pixels, width, height, initialScale, scaleFactor, stepSize, edgesDensity, data) {
//         var total = 0;
//         var rects = [];
//         var integralImage = new Int32Array(width * height);
//         var integralImageSquare = new Int32Array(width * height);
//         var tiltedIntegralImage = new Int32Array(width * height);

//         var integralImageSobel;
//         if (edgesDensity > 0) {
//             integralImageSobel = new Int32Array(width * height);
//         }

//         tracking.Image.computeIntegralImage(pixels, width, height, integralImage, integralImageSquare, tiltedIntegralImage, integralImageSobel);

//         var minWidth = data[0];
//         var minHeight = data[1];
//         var scale = initialScale * scaleFactor;
//         var blockWidth = (scale * minWidth) | 0;
//         var blockHeight = (scale * minHeight) | 0;

//         while (blockWidth < width && blockHeight < height) {
//             var step = (scale * stepSize + 0.5) | 0;
//             for (var i = 0; i < (height - blockHeight); i += step) {
//                 for (var j = 0; j < (width - blockWidth); j += step) {

//                     if (edgesDensity > 0) {
//                         if (this.isTriviallyExcluded(edgesDensity, integralImageSobel, i, j, width, blockWidth, blockHeight)) {
//                             continue;
//                         }
//                     }

//                     if (this.evalStages_(data, integralImage, integralImageSquare, tiltedIntegralImage, i, j, width, blockWidth, blockHeight, scale)) {
//                         rects[total++] = {
//                             width: blockWidth,
//                             height: blockHeight,
//                             x: j,
//                             y: i
//                         };
//                     }
//                 }
//             }

//             scale *= scaleFactor;
//             blockWidth = (scale * minWidth) | 0;
//             blockHeight = (scale * minHeight) | 0;
//         }
//         return this.mergeRectangles_(rects);
//     };

//     /**
//      * Fast check to test whether the edges density inside the block is greater
//      * than a threshold, if true it tests the stages. This can improve
//      * significantly performance.
//      * @param {number} edgesDensity Percentage density edges inside the
//      *     classifier block.
//      * @param {array} integralImageSobel The integral image of a sobel image.
//      * @param {number} i Vertical position of the pixel to be evaluated.
//      * @param {number} j Horizontal position of the pixel to be evaluated.
//      * @param {number} width The image width.
//      * @return {boolean} True whether the block at position i,j can be skipped,
//      *     false otherwise.
//      * @static
//      * @protected
//      */
//     tracking.ViolaJones.isTriviallyExcluded = function(edgesDensity, integralImageSobel, i, j, width, blockWidth, blockHeight) {
//         var wbA = i * width + j;
//         var wbB = wbA + blockWidth;
//         var wbD = wbA + blockHeight * width;
//         var wbC = wbD + blockWidth;
//         var blockEdgesDensity = (integralImageSobel[wbA] - integralImageSobel[wbB] - integralImageSobel[wbD] + integralImageSobel[wbC]) / (blockWidth * blockHeight * 255);
//         if (blockEdgesDensity < edgesDensity) {
//             return true;
//         }
//         return false;
//     };

//     /**
//      * Evaluates if the block size on i,j position is a valid HAAR cascade
//      * stage.
//      * @param {number} data The HAAR cascade data.
//      * @param {number} i Vertical position of the pixel to be evaluated.
//      * @param {number} j Horizontal position of the pixel to be evaluated.
//      * @param {number} width The image width.
//      * @param {number} blockSize The block size.
//      * @param {number} scale The scale factor of the block size and its original
//      *     size.
//      * @param {number} inverseArea The inverse area of the block size.
//      * @return {boolean} Whether the region passes all the stage tests.
//      * @private
//      * @static
//      */
//     tracking.ViolaJones.evalStages_ = function(data, integralImage, integralImageSquare, tiltedIntegralImage, i, j, width, blockWidth, blockHeight, scale) {
//         var inverseArea = 1.0 / (blockWidth * blockHeight);
//         var wbA = i * width + j;
//         var wbB = wbA + blockWidth;
//         var wbD = wbA + blockHeight * width;
//         var wbC = wbD + blockWidth;
//         var mean = (integralImage[wbA] - integralImage[wbB] - integralImage[wbD] + integralImage[wbC]) * inverseArea;
//         var variance = (integralImageSquare[wbA] - integralImageSquare[wbB] - integralImageSquare[wbD] + integralImageSquare[wbC]) * inverseArea - mean * mean;

//         var standardDeviation = 1;
//         if (variance > 0) {
//             standardDeviation = Math.sqrt(variance);
//         }

//         var length = data.length;

//         for (var w = 2; w < length;) {
//             var stageSum = 0;
//             var stageThreshold = data[w++];
//             var nodeLength = data[w++];

//             while (nodeLength--) {
//                 var rectsSum = 0;
//                 var tilted = data[w++];
//                 var rectsLength = data[w++];

//                 for (var r = 0; r < rectsLength; r++) {
//                     var rectLeft = (j + data[w++] * scale + 0.5) | 0;
//                     var rectTop = (i + data[w++] * scale + 0.5) | 0;
//                     var rectWidth = (data[w++] * scale + 0.5) | 0;
//                     var rectHeight = (data[w++] * scale + 0.5) | 0;
//                     var rectWeight = data[w++];

//                     var w1;
//                     var w2;
//                     var w3;
//                     var w4;
//                     if (tilted) {
//                         // RectSum(r) = RSAT(x-h+w, y+w+h-1) + RSAT(x, y-1) - RSAT(x-h, y+h-1) - RSAT(x+w, y+w-1)
//                         w1 = (rectLeft - rectHeight + rectWidth) + (rectTop + rectWidth + rectHeight - 1) * width;
//                         w2 = rectLeft + (rectTop - 1) * width;
//                         w3 = (rectLeft - rectHeight) + (rectTop + rectHeight - 1) * width;
//                         w4 = (rectLeft + rectWidth) + (rectTop + rectWidth - 1) * width;
//                         rectsSum += (tiltedIntegralImage[w1] + tiltedIntegralImage[w2] - tiltedIntegralImage[w3] - tiltedIntegralImage[w4]) * rectWeight;
//                     } else {
//                         // RectSum(r) = SAT(x-1, y-1) + SAT(x+w-1, y+h-1) - SAT(x-1, y+h-1) - SAT(x+w-1, y-1)
//                         w1 = rectTop * width + rectLeft;
//                         w2 = w1 + rectWidth;
//                         w3 = w1 + rectHeight * width;
//                         w4 = w3 + rectWidth;
//                         rectsSum += (integralImage[w1] - integralImage[w2] - integralImage[w3] + integralImage[w4]) * rectWeight;
//                         // TODO: Review the code below to analyze performance when using it instead.
//                         // w1 = (rectLeft - 1) + (rectTop - 1) * width;
//                         // w2 = (rectLeft + rectWidth - 1) + (rectTop + rectHeight - 1) * width;
//                         // w3 = (rectLeft - 1) + (rectTop + rectHeight - 1) * width;
//                         // w4 = (rectLeft + rectWidth - 1) + (rectTop - 1) * width;
//                         // rectsSum += (integralImage[w1] + integralImage[w2] - integralImage[w3] - integralImage[w4]) * rectWeight;
//                     }
//                 }

//                 var nodeThreshold = data[w++];
//                 var nodeLeft = data[w++];
//                 var nodeRight = data[w++];

//                 if (rectsSum * inverseArea < nodeThreshold * standardDeviation) {
//                     stageSum += nodeLeft;
//                 } else {
//                     stageSum += nodeRight;
//                 }
//             }

//             if (stageSum < stageThreshold) {
//                 return false;
//             }
//         }
//         return true;
//     };

//     /**
//      * Postprocess the detected sub-windows in order to combine overlapping
//      * detections into a single detection.
//      * @param {array} rects
//      * @return {array}
//      * @private
//      * @static
//      */
//     tracking.ViolaJones.mergeRectangles_ = function(rects) {
//         var disjointSet = new tracking.DisjointSet(rects.length);

//         for (var i = 0; i < rects.length; i++) {
//             var r1 = rects[i];
//             for (var j = 0; j < rects.length; j++) {
//                 var r2 = rects[j];
//                 if (tracking.Math.intersectRect(r1.x, r1.y, r1.x + r1.width, r1.y + r1.height, r2.x, r2.y, r2.x + r2.width, r2.y + r2.height)) {
//                     var x1 = Math.max(r1.x, r2.x);
//                     var y1 = Math.max(r1.y, r2.y);
//                     var x2 = Math.min(r1.x + r1.width, r2.x + r2.width);
//                     var y2 = Math.min(r1.y + r1.height, r2.y + r2.height);
//                     var overlap = (x1 - x2) * (y1 - y2);
//                     var area1 = (r1.width * r1.height);
//                     var area2 = (r2.width * r2.height);

//                     if ((overlap / (area1 * (area1 / area2)) >= this.REGIONS_OVERLAP) &&
//                         (overlap / (area2 * (area1 / area2)) >= this.REGIONS_OVERLAP)) {
//                         disjointSet.union(i, j);
//                     }
//                 }
//             }
//         }

//         var map = {};
//         for (var k = 0; k < disjointSet.length; k++) {
//             var rep = disjointSet.find(k);
//             if (!map[rep]) {
//                 map[rep] = {
//                     total: 1,
//                     width: rects[k].width,
//                     height: rects[k].height,
//                     x: rects[k].x,
//                     y: rects[k].y
//                 };
//                 continue;
//             }
//             map[rep].total++;
//             map[rep].width += rects[k].width;
//             map[rep].height += rects[k].height;
//             map[rep].x += rects[k].x;
//             map[rep].y += rects[k].y;
//         }

//         var result = [];
//         Object.keys(map).forEach(function(key) {
//             var rect = map[key];
//             result.push({
//                 total: rect.total,
//                 width: (rect.width / rect.total + 0.5) | 0,
//                 height: (rect.height / rect.total + 0.5) | 0,
//                 x: (rect.x / rect.total + 0.5) | 0,
//                 y: (rect.y / rect.total + 0.5) | 0
//             });
//         });

//         return result;
//     };
// }());

(function() {
    /**
     * Brief intends for "Binary Robust Independent Elementary Features".This
     * method generates a binary string for each keypoint found by an extractor
     * method.
     * @static
     * @constructor
     */
    tracking.Brief = {};

    /**
     * The set of binary tests is defined by the nd (x,y)-location pairs
     * uniquely chosen during the initialization. Values could vary between N =
     * 128,256,512. N=128 yield good compromises between speed, storage
     * efficiency, and recognition rate.
     * @type {number}
     */
    tracking.Brief.N = 512;

    /**
     * Caches coordinates values of (x,y)-location pairs uniquely chosen during
     * the initialization.
     * @type {Object.<number, Int32Array>}
     * @private
     * @static
     */
    tracking.Brief.randomImageOffsets_ = {};

    /**
     * Caches delta values of (x,y)-location pairs uniquely chosen during
     * the initialization.
     * @type {Int32Array}
     * @private
     * @static
     */
    tracking.Brief.randomWindowOffsets_ = null;

    /**
     * Generates a binary string for each found keypoints extracted using an
     * extractor method.
     * @param {array} The grayscale pixels in a linear [p1,p2,...] array.
     * @param {number} width The image width.
     * @param {array} keypoints
     * @return {Int32Array} Returns an array where for each four sequence int
     *     values represent the descriptor binary string (128 bits) necessary
     *     to describe the corner, e.g. [0,0,0,0, 0,0,0,0, ...].
     * @static
     */
    tracking.Brief.getDescriptors = function(pixels, width, keypoints) {
        // Optimizing divide by 32 operation using binary shift
        // (this.N >> 5) === this.N/32.
        var descriptors = new Int32Array((keypoints.length >> 1) * (this.N >> 5));
        var descriptorWord = 0;
        var offsets = this.getRandomOffsets_(width);
        var position = 0;

        for (var i = 0; i < keypoints.length; i += 2) {
            var w = width * keypoints[i + 1] + keypoints[i];

            var offsetsPosition = 0;
            for (var j = 0, n = this.N; j < n; j++) {
                if (pixels[offsets[offsetsPosition++] + w] < pixels[offsets[offsetsPosition++] + w]) {
                    // The bit in the position `j % 32` of descriptorWord should be set to 1. We do
                    // this by making an OR operation with a binary number that only has the bit
                    // in that position set to 1. That binary number is obtained by shifting 1 left by
                    // `j % 32` (which is the same as `j & 31` left) positions.
                    descriptorWord |= 1 << (j & 31);
                }

                // If the next j is a multiple of 32, we will need to use a new descriptor word to hold
                // the next results.
                if (!((j + 1) & 31)) {
                    descriptors[position++] = descriptorWord;
                    descriptorWord = 0;
                }
            }
        }

        return descriptors;
    };

    /**
     * Matches sets of features {mi} and {m′j} extracted from two images taken
     * from similar, and often successive, viewpoints. A classical procedure
     * runs as follows. For each point {mi} in the first image, search in a
     * region of the second image around location {mi} for point {m′j}. The
     * search is based on the similarity of the local image windows, also known
     * as kernel windows, centered on the points, which strongly characterizes
     * the points when the images are sufficiently close. Once each keypoint is
     * described with its binary string, they need to be compared with the
     * closest matching point. Distance metric is critical to the performance of
     * in- trusion detection systems. Thus using binary strings reduces the size
     * of the descriptor and provides an interesting data structure that is fast
     * to operate whose similarity can be measured by the Hamming distance.
     * @param {array} keypoints1
     * @param {array} descriptors1
     * @param {array} keypoints2
     * @param {array} descriptors2
     * @return {Int32Array} Returns an array where the index is the corner1
     *     index coordinate, and the value is the corresponding match index of
     *     corner2, e.g. keypoints1=[x0,y0,x1,y1,...] and
     *     keypoints2=[x'0,y'0,x'1,y'1,...], if x0 matches x'1 and x1 matches x'0,
     *     the return array would be [3,0].
     * @static
     */
    tracking.Brief.match = function(keypoints1, descriptors1, keypoints2, descriptors2) {
        var len1 = keypoints1.length >> 1;
        var len2 = keypoints2.length >> 1;
        var matches = new Array(len1);

        for (var i = 0; i < len1; i++) {
            var min = Infinity;
            var minj = 0;
            for (var j = 0; j < len2; j++) {
                var dist = 0;
                // Optimizing divide by 32 operation using binary shift
                // (this.N >> 5) === this.N/32.
                for (var k = 0, n = this.N >> 5; k < n; k++) {
                    dist += tracking.Math.hammingWeight(descriptors1[i * n + k] ^ descriptors2[j * n + k]);
                }
                if (dist < min) {
                    min = dist;
                    minj = j;
                }
            }
            matches[i] = {
                index1: i,
                index2: minj,
                keypoint1: [keypoints1[2 * i], keypoints1[2 * i + 1]],
                keypoint2: [keypoints2[2 * minj], keypoints2[2 * minj + 1]],
                confidence: 1 - min / this.N
            };
        }

        return matches;
    };

    /**
     * Removes matches outliers by testing matches on both directions.
     * @param {array} keypoints1
     * @param {array} descriptors1
     * @param {array} keypoints2
     * @param {array} descriptors2
     * @return {Int32Array} Returns an array where the index is the corner1
     *     index coordinate, and the value is the corresponding match index of
     *     corner2, e.g. keypoints1=[x0,y0,x1,y1,...] and
     *     keypoints2=[x'0,y'0,x'1,y'1,...], if x0 matches x'1 and x1 matches x'0,
     *     the return array would be [3,0].
     * @static
     */
    tracking.Brief.reciprocalMatch = function(keypoints1, descriptors1, keypoints2, descriptors2) {
        var matches = [];
        if (keypoints1.length === 0 || keypoints2.length === 0) {
            return matches;
        }

        var matches1 = tracking.Brief.match(keypoints1, descriptors1, keypoints2, descriptors2);
        var matches2 = tracking.Brief.match(keypoints2, descriptors2, keypoints1, descriptors1);
        for (var i = 0; i < matches1.length; i++) {
            if (matches2[matches1[i].index2].index2 === i) {
                matches.push(matches1[i]);
            }
        }
        return matches;
    };

    /**
     * Gets the coordinates values of (x,y)-location pairs uniquely chosen
     * during the initialization.
     * @return {array} Array with the random offset values.
     * @private
     */
    tracking.Brief.getRandomOffsets_ = function(width) {
        if (!this.randomWindowOffsets_) {
            var windowPosition = 0;
            var windowOffsets = new Int32Array(4 * this.N);
            for (var i = 0; i < this.N; i++) {
                windowOffsets[windowPosition++] = Math.round(tracking.Math.uniformRandom(-15, 16));
                windowOffsets[windowPosition++] = Math.round(tracking.Math.uniformRandom(-15, 16));
                windowOffsets[windowPosition++] = Math.round(tracking.Math.uniformRandom(-15, 16));
                windowOffsets[windowPosition++] = Math.round(tracking.Math.uniformRandom(-15, 16));
            }
            this.randomWindowOffsets_ = windowOffsets;
        }

        if (!this.randomImageOffsets_[width]) {
            var imagePosition = 0;
            var imageOffsets = new Int32Array(2 * this.N);
            for (var j = 0; j < this.N; j++) {
                imageOffsets[imagePosition++] = this.randomWindowOffsets_[4 * j] * width + this.randomWindowOffsets_[4 * j + 1];
                imageOffsets[imagePosition++] = this.randomWindowOffsets_[4 * j + 2] * width + this.randomWindowOffsets_[4 * j + 3];
            }
            this.randomImageOffsets_[width] = imageOffsets;
        }

        return this.randomImageOffsets_[width];
    };
}());

(function() {
    /**
     * FAST intends for "Features from Accelerated Segment Test". This method
     * performs a point segment test corner detection. The segment test
     * criterion operates by considering a circle of sixteen pixels around the
     * corner candidate p. The detector classifies p as a corner if there exists
     * a set of n contiguous pixelsin the circle which are all brighter than the
     * intensity of the candidate pixel Ip plus a threshold t, or all darker
     * than Ip − t.
     *
     *       15 00 01
     *    14          02
     * 13                03
     * 12       []       04
     * 11                05
     *    10          06
     *       09 08 07
     *
     * For more reference:
     * http://citeseerx.ist.psu.edu/viewdoc/download?doi=10.1.1.60.3991&rep=rep1&type=pdf
     * @static
     * @constructor
     */
    tracking.Fast = {};

    /**
     * Holds the threshold to determine whether the tested pixel is brighter or
     * darker than the corner candidate p.
     * @type {number}
     * @default 40
     * @static
     */
    tracking.Fast.THRESHOLD = 40;

    /**
     * Caches coordinates values of the circle surrounding the pixel candidate p.
     * @type {Object.<number, Int32Array>}
     * @private
     * @static
     */
    tracking.Fast.circles_ = {};

    /**
     * Finds corners coordinates on the graysacaled image.
     * @param {array} The grayscale pixels in a linear [p1,p2,...] array.
     * @param {number} width The image width.
     * @param {number} height The image height.
     * @param {number} threshold to determine whether the tested pixel is brighter or
     *     darker than the corner candidate p. Default value is 40.
     * @return {array} Array containing the coordinates of all found corners,
     *     e.g. [x0,y0,x1,y1,...], where P(x0,y0) represents a corner coordinate.
     * @static
     */
    tracking.Fast.findCorners = function(pixels, width, height, opt_threshold) {
        var circleOffsets = this.getCircleOffsets_(width);
        var circlePixels = new Int32Array(16);
        var corners = [];

        if (opt_threshold === undefined) {
            opt_threshold = this.THRESHOLD;
        }

        // When looping through the image pixels, skips the first three lines from
        // the image boundaries to constrain the surrounding circle inside the image
        // area.
        for (var i = 3; i < height - 3; i++) {
            for (var j = 3; j < width - 3; j++) {
                var w = i * width + j;
                var p = pixels[w];

                // Loops the circle offsets to read the pixel value for the sixteen
                // surrounding pixels.
                for (var k = 0; k < 16; k++) {
                    circlePixels[k] = pixels[w + circleOffsets[k]];
                }

                if (this.isCorner(p, circlePixels, opt_threshold)) {
                    // The pixel p is classified as a corner, as optimization increment j
                    // by the circle radius 3 to skip the neighbor pixels inside the
                    // surrounding circle. This can be removed without compromising the
                    // result.
                    corners.push(j, i);
                    j += 3;
                }
            }
        }

        return corners;
    };

    /**
     * Checks if the circle pixel is brighter than the candidate pixel p by
     * a threshold.
     * @param {number} circlePixel The circle pixel value.
     * @param {number} p The value of the candidate pixel p.
     * @param {number} threshold
     * @return {Boolean}
     * @static
     */
    tracking.Fast.isBrighter = function(circlePixel, p, threshold) {
        return circlePixel - p > threshold;
    };

    /**
     * Checks if the circle pixel is within the corner of the candidate pixel p
     * by a threshold.
     * @param {number} p The value of the candidate pixel p.
     * @param {number} circlePixel The circle pixel value.
     * @param {number} threshold
     * @return {Boolean}
     * @static
     */
    tracking.Fast.isCorner = function(p, circlePixels, threshold) {
        if (this.isTriviallyExcluded(circlePixels, p, threshold)) {
            return false;
        }

        for (var x = 0; x < 16; x++) {
            var darker = true;
            var brighter = true;

            for (var y = 0; y < 9; y++) {
                var circlePixel = circlePixels[(x + y) & 15];

                if (!this.isBrighter(p, circlePixel, threshold)) {
                    brighter = false;
                    if (darker === false) {
                        break;
                    }
                }

                if (!this.isDarker(p, circlePixel, threshold)) {
                    darker = false;
                    if (brighter === false) {
                        break;
                    }
                }
            }

            if (brighter || darker) {
                return true;
            }
        }

        return false;
    };

    /**
     * Checks if the circle pixel is darker than the candidate pixel p by
     * a threshold.
     * @param {number} circlePixel The circle pixel value.
     * @param {number} p The value of the candidate pixel p.
     * @param {number} threshold
     * @return {Boolean}
     * @static
     */
    tracking.Fast.isDarker = function(circlePixel, p, threshold) {
        return p - circlePixel > threshold;
    };

    /**
     * Fast check to test if the candidate pixel is a trivially excluded value.
     * In order to be a corner, the candidate pixel value should be darker or
     * brighter than 9-12 surrounding pixels, when at least three of the top,
     * bottom, left and right pixels are brighter or darker it can be
     * automatically excluded improving the performance.
     * @param {number} circlePixel The circle pixel value.
     * @param {number} p The value of the candidate pixel p.
     * @param {number} threshold
     * @return {Boolean}
     * @static
     * @protected
     */
    tracking.Fast.isTriviallyExcluded = function(circlePixels, p, threshold) {
        var count = 0;
        var circleBottom = circlePixels[8];
        var circleLeft = circlePixels[12];
        var circleRight = circlePixels[4];
        var circleTop = circlePixels[0];

        if (this.isBrighter(circleTop, p, threshold)) {
            count++;
        }
        if (this.isBrighter(circleRight, p, threshold)) {
            count++;
        }
        if (this.isBrighter(circleBottom, p, threshold)) {
            count++;
        }
        if (this.isBrighter(circleLeft, p, threshold)) {
            count++;
        }

        if (count < 3) {
            count = 0;
            if (this.isDarker(circleTop, p, threshold)) {
                count++;
            }
            if (this.isDarker(circleRight, p, threshold)) {
                count++;
            }
            if (this.isDarker(circleBottom, p, threshold)) {
                count++;
            }
            if (this.isDarker(circleLeft, p, threshold)) {
                count++;
            }
            if (count < 3) {
                return true;
            }
        }

        return false;
    };

    /**
     * Gets the sixteen offset values of the circle surrounding pixel.
     * @param {number} width The image width.
     * @return {array} Array with the sixteen offset values of the circle
     *     surrounding pixel.
     * @private
     */
    tracking.Fast.getCircleOffsets_ = function(width) {
        if (this.circles_[width]) {
            return this.circles_[width];
        }

        var circle = new Int32Array(16);

        circle[0] = -width - width - width;
        circle[1] = circle[0] + 1;
        circle[2] = circle[1] + width + 1;
        circle[3] = circle[2] + width + 1;
        circle[4] = circle[3] + width;
        circle[5] = circle[4] + width;
        circle[6] = circle[5] + width - 1;
        circle[7] = circle[6] + width - 1;
        circle[8] = circle[7] - 1;
        circle[9] = circle[8] - 1;
        circle[10] = circle[9] - width - 1;
        circle[11] = circle[10] - width - 1;
        circle[12] = circle[11] - width;
        circle[13] = circle[12] - width;
        circle[14] = circle[13] - width + 1;
        circle[15] = circle[14] - width + 1;

        this.circles_[width] = circle;
        return circle;
    };
}());

(function() {
    /**
     * Math utility.
     * @static
     * @constructor
     */
    tracking.Math = {};

    /**
     * Euclidean distance between two points P(x0, y0) and P(x1, y1).
     * @param {number} x0 Horizontal coordinate of P0.
     * @param {number} y0 Vertical coordinate of P0.
     * @param {number} x1 Horizontal coordinate of P1.
     * @param {number} y1 Vertical coordinate of P1.
     * @return {number} The euclidean distance.
     */
    tracking.Math.distance = function(x0, y0, x1, y1) {
        var dx = x1 - x0;
        var dy = y1 - y0;

        return Math.sqrt(dx * dx + dy * dy);
    };

    /**
     * Calculates the Hamming weight of a string, which is the number of symbols that are
     * different from the zero-symbol of the alphabet used. It is thus
     * equivalent to the Hamming distance from the all-zero string of the same
     * length. For the most typical case, a string of bits, this is the number
     * of 1's in the string.
     *
     * Example:
     *
     * <pre>
     *  Binary string     Hamming weight
     *   11101                 4
     *   11101010              5
     * </pre>
     *
     * @param {number} i Number that holds the binary string to extract the hamming weight.
     * @return {number} The hamming weight.
     */
    tracking.Math.hammingWeight = function(i) {
        i = i - ((i >> 1) & 0x55555555);
        i = (i & 0x33333333) + ((i >> 2) & 0x33333333);

        return ((i + (i >> 4) & 0xF0F0F0F) * 0x1010101) >> 24;
    };

    /**
     * Generates a random number between [a, b] interval.
     * @param {number} a
     * @param {number} b
     * @return {number}
     */
    tracking.Math.uniformRandom = function(a, b) {
        return a + Math.random() * (b - a);
    };

    /**
     * Tests if a rectangle intersects with another.
     *
     *  <pre>
     *  x0y0 --------       x2y2 --------
     *      |       |           |       |
     *      -------- x1y1       -------- x3y3
     * </pre>
     *
     * @param {number} x0 Horizontal coordinate of P0.
     * @param {number} y0 Vertical coordinate of P0.
     * @param {number} x1 Horizontal coordinate of P1.
     * @param {number} y1 Vertical coordinate of P1.
     * @param {number} x2 Horizontal coordinate of P2.
     * @param {number} y2 Vertical coordinate of P2.
     * @param {number} x3 Horizontal coordinate of P3.
     * @param {number} y3 Vertical coordinate of P3.
     * @return {boolean}
     */
    tracking.Math.intersectRect = function(x0, y0, x1, y1, x2, y2, x3, y3) {
        return !(x2 > x1 || x3 < x0 || y2 > y1 || y3 < y0);
    };

}());

(function() {
    /**
     * Matrix utility.
     * @static
     * @constructor
     */
    tracking.Matrix = {};

    /**
     * Loops the array organized as major-row order and executes `fn` callback
     * for each iteration. The `fn` callback receives the following parameters:
     * `(r,g,b,a,index,i,j)`, where `r,g,b,a` represents the pixel color with
     * alpha channel, `index` represents the position in the major-row order
     * array and `i,j` the respective indexes positions in two dimensions.
     * @param {array} pixels The pixels in a linear [r,g,b,a,...] array to loop
     *     through.
     * @param {number} width The image width.
     * @param {number} height The image height.
     * @param {function} fn The callback function for each pixel.
     * @param {number} opt_jump Optional jump for the iteration, by default it
     *     is 1, hence loops all the pixels of the array.
     * @static
     */
    tracking.Matrix.forEach = function(pixels, width, height, fn, opt_jump) {
        opt_jump = opt_jump || 1;
        for (var i = 0; i < height; i += opt_jump) {
            for (var j = 0; j < width; j += opt_jump) {
                var w = i * width * 4 + j * 4;
                fn.call(this, pixels[w], pixels[w + 1], pixels[w + 2], pixels[w + 3], w, i, j);
            }
        }
    };

}());

(function() {
    /**
     * EPnp utility.
     * @static
     * @constructor
     */
    tracking.EPnP = {};

    tracking.EPnP.solve = function(objectPoints, imagePoints, cameraMatrix) {};
}());

(function() {
    /**
     * Tracker utility.
     * @constructor
     * @extends {tracking.EventEmitter}
     */
    tracking.Tracker = function() {
        tracking.Tracker.base(this, 'constructor');
    };

    tracking.inherits(tracking.Tracker, tracking.EventEmitter);

    /**
     * Tracks the pixels on the array. This method is called for each video
     * frame in order to emit `track` event.
     * @param {Uint8ClampedArray} pixels The pixels data to track.
     * @param {number} width The pixels canvas width.
     * @param {number} height The pixels canvas height.
     */
    tracking.Tracker.prototype.track = function() {};
}());

(function() {
    /**
     * TrackerTask utility.
     * @constructor
     * @extends {tracking.EventEmitter}
     */
    tracking.TrackerTask = function(tracker) {
        tracking.TrackerTask.base(this, 'constructor');

        if (!tracker) {
            throw new Error('Tracker instance not specified.');
        }

        this.setTracker(tracker);
    };

    tracking.inherits(tracking.TrackerTask, tracking.EventEmitter);

    /**
     * Holds the tracker instance managed by this task.
     * @type {tracking.Tracker}
     * @private
     */
    tracking.TrackerTask.prototype.tracker_ = null;

    /**
     * Holds if the tracker task is in running.
     * @type {boolean}
     * @private
     */
    tracking.TrackerTask.prototype.running_ = false;

    /**
     * Gets the tracker instance managed by this task.
     * @return {tracking.Tracker}
     */
    tracking.TrackerTask.prototype.getTracker = function() {
        return this.tracker_;
    };

    /**
     * Returns true if the tracker task is in running, false otherwise.
     * @return {boolean}
     * @private
     */
    tracking.TrackerTask.prototype.inRunning = function() {
        return this.running_;
    };

    /**
     * Sets if the tracker task is in running.
     * @param {boolean} running
     * @private
     */
    tracking.TrackerTask.prototype.setRunning = function(running) {
        this.running_ = running;
    };

    /**
     * Sets the tracker instance managed by this task.
     * @return {tracking.Tracker}
     */
    tracking.TrackerTask.prototype.setTracker = function(tracker) {
        this.tracker_ = tracker;
    };

    /**
     * Emits a `run` event on the tracker task for the implementers to run any
     * child action, e.g. `requestAnimationFrame`.
     * @return {object} Returns itself, so calls can be chained.
     */
    tracking.TrackerTask.prototype.run = function() {
        var self = this;

        if (this.inRunning()) {
            return;
        }

        this.setRunning(true);

        this.reemitTrackEvent_ = function(event) {
            self.emit('track', event);
        };
        this.tracker_.on('track', this.reemitTrackEvent_);

        this.emit('run');
        return this;
    };

    /**
     * Emits a `stop` event on the tracker task for the implementers to stop any
     * child action being done, e.g. `requestAnimationFrame`.
     * @return {object} Returns itself, so calls can be chained.
     */
    tracking.TrackerTask.prototype.stop = function() {
        if (!this.inRunning()) {
            return;
        }
        //tracking.stopUserMedia();
        this.setRunning(false);
        this.emit('stop');
        this.tracker_.removeListener('track', this.reemitTrackEvent_);
        return this;
    };
}());

(function() {
    /**
     * ColorTracker utility to track colored blobs in a frame using color
     * difference evaluation.
     * @constructor
     * @param {string|Array.<string>} opt_colors Optional colors to track.
     * @extends {tracking.Tracker}
     */
    tracking.ColorTracker = function(opt_colors) {
        tracking.ColorTracker.base(this, 'constructor');

        if (typeof opt_colors === 'string') {
            opt_colors = [opt_colors];
        }

        if (opt_colors) {
            opt_colors.forEach(function(color) {
                if (!tracking.ColorTracker.getColor(color)) {
                    throw new Error('Color not valid, try `new tracking.ColorTracker("magenta")`.');
                }
            });
            this.setColors(opt_colors);
        }
    };

    tracking.inherits(tracking.ColorTracker, tracking.Tracker);

    /**
     * Holds the known colors.
     * @type {Object.<string, function>}
     * @private
     * @static
     */
    tracking.ColorTracker.knownColors_ = {};

    /**
     * Caches coordinates values of the neighbours surrounding a pixel.
     * @type {Object.<number, Int32Array>}
     * @private
     * @static
     */
    tracking.ColorTracker.neighbours_ = {};

    /**
     * Registers a color as known color.
     * @param {string} name The color name.
     * @param {function} fn The color function to test if the passed (r,g,b) is
     *     the desired color.
     * @static
     */
    tracking.ColorTracker.registerColor = function(name, fn) {
        tracking.ColorTracker.knownColors_[name] = fn;
    };

    /**
     * Gets the known color function that is able to test whether an (r,g,b) is
     * the desired color.
     * @param {string} name The color name.
     * @return {function} The known color test function.
     * @static
     */
    tracking.ColorTracker.getColor = function(name) {
        return tracking.ColorTracker.knownColors_[name];
    };

    /**
     * Holds the colors to be tracked by the `ColorTracker` instance.
     * @default ['magenta']
     * @type {Array.<string>}
     */
    tracking.ColorTracker.prototype.colors = ['magenta'];

    /**
     * Holds the minimum dimension to classify a rectangle.
     * @default 20
     * @type {number}
     */
    tracking.ColorTracker.prototype.minDimension = 20;

    /**
     * Holds the maximum dimension to classify a rectangle.
     * @default Infinity
     * @type {number}
     */
    tracking.ColorTracker.prototype.maxDimension = Infinity;


    /**
     * Holds the minimum group size to be classified as a rectangle.
     * @default 30
     * @type {number}
     */
    tracking.ColorTracker.prototype.minGroupSize = 30;

    /**
     * Calculates the central coordinate from the cloud points. The cloud points
     * are all points that matches the desired color.
     * @param {Array.<number>} cloud Major row order array containing all the
     *     points from the desired color, e.g. [x1, y1, c2, y2, ...].
     * @param {number} total Total numbers of pixels of the desired color.
     * @return {object} Object containing the x, y and estimated z coordinate of
     *     the blog extracted from the cloud points.
     * @private
     */
    tracking.ColorTracker.prototype.calculateDimensions_ = function(cloud, total) {
        var maxx = -1;
        var maxy = -1;
        var minx = Infinity;
        var miny = Infinity;

        for (var c = 0; c < total; c += 2) {
            var x = cloud[c];
            var y = cloud[c + 1];

            if (x < minx) {
                minx = x;
            }
            if (x > maxx) {
                maxx = x;
            }
            if (y < miny) {
                miny = y;
            }
            if (y > maxy) {
                maxy = y;
            }
        }

        return {
            width: maxx - minx,
            height: maxy - miny,
            x: minx,
            y: miny
        };
    };

    /**
     * Gets the colors being tracked by the `ColorTracker` instance.
     * @return {Array.<string>}
     */
    tracking.ColorTracker.prototype.getColors = function() {
        return this.colors;
    };

    /**
     * Gets the minimum dimension to classify a rectangle.
     * @return {number}
     */
    tracking.ColorTracker.prototype.getMinDimension = function() {
        return this.minDimension;
    };

    /**
     * Gets the maximum dimension to classify a rectangle.
     * @return {number}
     */
    tracking.ColorTracker.prototype.getMaxDimension = function() {
        return this.maxDimension;
    };

    /**
     * Gets the minimum group size to be classified as a rectangle.
     * @return {number}
     */
    tracking.ColorTracker.prototype.getMinGroupSize = function() {
        return this.minGroupSize;
    };

    /**
     * Gets the eight offset values of the neighbours surrounding a pixel.
     * @param {number} width The image width.
     * @return {array} Array with the eight offset values of the neighbours
     *     surrounding a pixel.
     * @private
     */
    tracking.ColorTracker.prototype.getNeighboursForWidth_ = function(width) {
        if (tracking.ColorTracker.neighbours_[width]) {
            return tracking.ColorTracker.neighbours_[width];
        }

        var neighbours = new Int32Array(8);

        neighbours[0] = -width * 4;
        neighbours[1] = -width * 4 + 4;
        neighbours[2] = 4;
        neighbours[3] = width * 4 + 4;
        neighbours[4] = width * 4;
        neighbours[5] = width * 4 - 4;
        neighbours[6] = -4;
        neighbours[7] = -width * 4 - 4;

        tracking.ColorTracker.neighbours_[width] = neighbours;

        return neighbours;
    };

    /**
     * Unites groups whose bounding box intersect with each other.
     * @param {Array.<Object>} rects
     * @private
     */
    tracking.ColorTracker.prototype.mergeRectangles_ = function(rects) {
        var intersects;
        var results = [];
        var minDimension = this.getMinDimension();
        var maxDimension = this.getMaxDimension();

        for (var r = 0; r < rects.length; r++) {
            var r1 = rects[r];
            intersects = true;
            for (var s = r + 1; s < rects.length; s++) {
                var r2 = rects[s];
                if (tracking.Math.intersectRect(r1.x, r1.y, r1.x + r1.width, r1.y + r1.height, r2.x, r2.y, r2.x + r2.width, r2.y + r2.height)) {
                    intersects = false;
                    var x1 = Math.min(r1.x, r2.x);
                    var y1 = Math.min(r1.y, r2.y);
                    var x2 = Math.max(r1.x + r1.width, r2.x + r2.width);
                    var y2 = Math.max(r1.y + r1.height, r2.y + r2.height);
                    r2.height = y2 - y1;
                    r2.width = x2 - x1;
                    r2.x = x1;
                    r2.y = y1;
                    break;
                }
            }

            if (intersects) {
                if (r1.width >= minDimension && r1.height >= minDimension) {
                    if (r1.width <= maxDimension && r1.height <= maxDimension) {
                        results.push(r1);
                    }
                }
            }
        }

        return results;
    };

    /**
     * Sets the colors to be tracked by the `ColorTracker` instance.
     * @param {Array.<string>} colors
     */
    tracking.ColorTracker.prototype.setColors = function(colors) {
        this.colors = colors;
    };

    /**
     * Sets the minimum dimension to classify a rectangle.
     * @param {number} minDimension
     */
    tracking.ColorTracker.prototype.setMinDimension = function(minDimension) {
        this.minDimension = minDimension;
    };

    /**
     * Sets the maximum dimension to classify a rectangle.
     * @param {number} maxDimension
     */
    tracking.ColorTracker.prototype.setMaxDimension = function(maxDimension) {
        this.maxDimension = maxDimension;
    };

    /**
     * Sets the minimum group size to be classified as a rectangle.
     * @param {number} minGroupSize
     */
    tracking.ColorTracker.prototype.setMinGroupSize = function(minGroupSize) {
        this.minGroupSize = minGroupSize;
    };

    /**
     * Tracks the `Video` frames. This method is called for each video frame in
     * order to emit `track` event.
     * @param {Uint8ClampedArray} pixels The pixels data to track.
     * @param {number} width The pixels canvas width.
     * @param {number} height The pixels canvas height.
     */
    tracking.ColorTracker.prototype.track = function(pixels, width, height) {
        var self = this;
        var colors = this.getColors();

        if (!colors) {
            throw new Error('Colors not specified, try `new tracking.ColorTracker("magenta")`.');
        }

        var results = [];

        colors.forEach(function(color) {
            results = results.concat(self.trackColor_(pixels, width, height, color));
        });

        this.emit('track', {
            data: results
        });
    };

    /**
     * Find the given color in the given matrix of pixels using Flood fill
     * algorithm to determines the area connected to a given node in a
     * multi-dimensional array.
     * @param {Uint8ClampedArray} pixels The pixels data to track.
     * @param {number} width The pixels canvas width.
     * @param {number} height The pixels canvas height.
     * @param {string} color The color to be found
     * @private
     */
    tracking.ColorTracker.prototype.trackColor_ = function(pixels, width, height, color) {
        var colorFn = tracking.ColorTracker.knownColors_[color];
        var currGroup = new Int32Array(pixels.length >> 2);
        var currGroupSize;
        var currI;
        var currJ;
        var currW;
        var marked = new Int8Array(pixels.length);
        var minGroupSize = this.getMinGroupSize();
        var neighboursW = this.getNeighboursForWidth_(width);
        var queue = new Int32Array(pixels.length);
        var queuePosition;
        var results = [];
        var w = -4;

        if (!colorFn) {
            return results;
        }

        for (var i = 0; i < height; i++) {
            for (var j = 0; j < width; j++) {
                w += 4;

                if (marked[w]) {
                    continue;
                }

                currGroupSize = 0;

                queuePosition = -1;
                queue[++queuePosition] = w;
                queue[++queuePosition] = i;
                queue[++queuePosition] = j;

                marked[w] = 1;

                while (queuePosition >= 0) {
                    currJ = queue[queuePosition--];
                    currI = queue[queuePosition--];
                    currW = queue[queuePosition--];

                    if (colorFn(pixels[currW], pixels[currW + 1], pixels[currW + 2], pixels[currW + 3], currW, currI, currJ)) {
                        currGroup[currGroupSize++] = currJ;
                        currGroup[currGroupSize++] = currI;

                        for (var k = 0; k < neighboursW.length; k++) {
                            var otherW = currW + neighboursW[k];
                            var otherI = currI + neighboursI[k];
                            var otherJ = currJ + neighboursJ[k];
                            if (!marked[otherW] && otherI >= 0 && otherI < height && otherJ >= 0 && otherJ < width) {
                                queue[++queuePosition] = otherW;
                                queue[++queuePosition] = otherI;
                                queue[++queuePosition] = otherJ;

                                marked[otherW] = 1;
                            }
                        }
                    }
                }

                if (currGroupSize >= minGroupSize) {
                    var data = this.calculateDimensions_(currGroup, currGroupSize);
                    if (data) {
                        data.color = color;
                        results.push(data);
                    }
                }
            }
        }

        return this.mergeRectangles_(results);
    };

    // Default colors
    //===================

    tracking.ColorTracker.registerColor('cyan', function(r, g, b) {
        var thresholdGreen = 50,
            thresholdBlue = 70,
            dx = r - 0,
            dy = g - 255,
            dz = b - 255;

        if ((g - r) >= thresholdGreen && (b - r) >= thresholdBlue) {
            return true;
        }
        return dx * dx + dy * dy + dz * dz < 6400;
    });

    tracking.ColorTracker.registerColor('magenta', function(r, g, b) {
        var threshold = 50,
            dx = r - 255,
            dy = g - 0,
            dz = b - 255;

        if ((r - g) >= threshold && (b - g) >= threshold) {
            return true;
        }
        return dx * dx + dy * dy + dz * dz < 19600;
    });

    tracking.ColorTracker.registerColor('yellow', function(r, g, b) {
        var threshold = 50,
            dx = r - 255,
            dy = g - 255,
            dz = b - 0;

        if ((r - b) >= threshold && (g - b) >= threshold) {
            return true;
        }
        return dx * dx + dy * dy + dz * dz < 10000;
    });


    // Caching neighbour i/j offset values.
    //=====================================
    var neighboursI = new Int32Array([-1, -1, 0, 1, 1, 1, 0, -1]);
    var neighboursJ = new Int32Array([0, 1, 1, 1, 0, -1, -1, -1]);
}());

(function() {
    /**
     * ObjectTracker utility.
     * @constructor
     * @param {string|Array.<string|Array.<number>>} opt_classifiers Optional
     *     object classifiers to track.
     * @extends {tracking.Tracker}
     */
    tracking.ObjectTracker = function(opt_classifiers) {
        tracking.ObjectTracker.base(this, 'constructor');

        if (opt_classifiers) {
            if (!Array.isArray(opt_classifiers)) {
                opt_classifiers = [opt_classifiers];
            }

            // if (Array.isArray(opt_classifiers)) {
            //     opt_classifiers.forEach(function(classifier, i) {
            //         if (typeof classifier === 'string') {
            //             opt_classifiers[i] = tracking.ViolaJones.classifiers[classifier];
            //         }
            //         if (!opt_classifiers[i]) {
            //             throw new Error('Object classifier not valid, try `new tracking.ObjectTracker("face")`.');
            //         }
            //     });
            // }
        }

        this.setClassifiers(opt_classifiers);
    };

    tracking.inherits(tracking.ObjectTracker, tracking.Tracker);

    /**
     * Specifies the edges density of a block in order to decide whether to skip
     * it or not.
     * @default 0.2
     * @type {number}
     */
    tracking.ObjectTracker.prototype.edgesDensity = 0.2;

    /**
     * Specifies the initial scale to start the feature block scaling.
     * @default 1.0
     * @type {number}
     */
    tracking.ObjectTracker.prototype.initialScale = 1.0;

    /**
     * Specifies the scale factor to scale the feature block.
     * @default 1.25
     * @type {number}
     */
    tracking.ObjectTracker.prototype.scaleFactor = 1.25;

    /**
     * Specifies the block step size.
     * @default 1.5
     * @type {number}
     */
    tracking.ObjectTracker.prototype.stepSize = 1.5;

    /**
     * Gets the tracker HAAR classifiers.
     * @return {TypedArray.<number>}
     */
    tracking.ObjectTracker.prototype.getClassifiers = function() {
        return this.classifiers;
    };

    /**
     * Gets the edges density value.
     * @return {number}
     */
    tracking.ObjectTracker.prototype.getEdgesDensity = function() {
        return this.edgesDensity;
    };

    /**
     * Gets the initial scale to start the feature block scaling.
     * @return {number}
     */
    tracking.ObjectTracker.prototype.getInitialScale = function() {
        return this.initialScale;
    };

    /**
     * Gets the scale factor to scale the feature block.
     * @return {number}
     */
    tracking.ObjectTracker.prototype.getScaleFactor = function() {
        return this.scaleFactor;
    };

    /**
     * Gets the block step size.
     * @return {number}
     */
    tracking.ObjectTracker.prototype.getStepSize = function() {
        return this.stepSize;
    };

    /**
     * Tracks the `Video` frames. This method is called for each video frame in
     * order to emit `track` event.
     * @param {Uint8ClampedArray} pixels The pixels data to track.
     * @param {number} width The pixels canvas width.
     * @param {number} height The pixels canvas height.
     */
    tracking.ObjectTracker.prototype.track = function(pixels, width, height) {
        var self = this;
        var classifiers = this.getClassifiers();

        if (!classifiers) {
            throw new Error('Object classifier not specified, try `new tracking.ObjectTracker("face")`.');
        }

        // var results = [];

        // classifiers.forEach(function(classifier) {
        //     results = results.concat(tracking.ViolaJones.detect(pixels, width, height, self.getInitialScale(), self.getScaleFactor(), self.getStepSize(), self.getEdgesDensity(), classifier));
        // });
        results = [1];

        // this.emit('track', {
        //     data: results
        // });
        // if (window.senddata == true) {  
        var tosend = [pixels, width, height, self.getInitialScale(), self.getScaleFactor(), self.getStepSize(), self.getEdgesDensity()];
        window.myWorker.postMessage(tosend);
        // }
    };

    tracking.ObjectTracker.prototype.updateFps = function() {
        console.log("sap_fpsCount ", tracking._fps);
        this.emit('updateFps', {
            fps: tracking._fps
        });
    }

    /**
     * Sets the tracker HAAR classifiers.
     * @param {TypedArray.<number>} classifiers
     */
    tracking.ObjectTracker.prototype.setClassifiers = function(classifiers) {
        this.classifiers = classifiers;
    };

    /**
     * Sets the edges density.
     * @param {number} edgesDensity
     */
    tracking.ObjectTracker.prototype.setEdgesDensity = function(edgesDensity) {
        this.edgesDensity = edgesDensity;
    };

    /**
     * Sets the initial scale to start the block scaling.
     * @param {number} initialScale
     */
    tracking.ObjectTracker.prototype.setInitialScale = function(initialScale) {
        this.initialScale = initialScale;
    };

    /**
     * Sets the scale factor to scale the feature block.
     * @param {number} scaleFactor
     */
    tracking.ObjectTracker.prototype.setScaleFactor = function(scaleFactor) {
        this.scaleFactor = scaleFactor;
    };

    /**
     * Sets the block step size.
     * @param {number} stepSize
     */
    tracking.ObjectTracker.prototype.setStepSize = function(stepSize) {
        this.stepSize = stepSize;
    };

}());

/**
 * tracking.js - A modern approach for Computer Vision on the web.
 * @author Eduardo Lundgren <edu@rdo.io>
 * @version v1.0.0
 * @link http://trackingjs.com
 * @license BSD
 */
/*tracking.ViolaJones.classifiers.face = new Float64Array([20,20,0.822689414024353,3,0,2,3,7,14,4,-1,3,9,14,2,2,0.004014195874333382,0.0337941907346249,0.8378106951713562,0,2,1,2,18,4,-1,7,2,6,4,3,0.0151513395830989,0.1514132022857666,0.7488812208175659,0,2,1,7,15,9,-1,1,10,15,3,3,0.004210993181914091,0.0900492817163467,0.6374819874763489,6.956608772277832,16,0,2,5,6,2,6,-1,5,9,2,3,2,0.0016227109590545297,0.0693085864186287,0.7110946178436279,0,2,7,5,6,3,-1,9,5,2,3,3,0.002290664939209819,0.1795803010463715,0.6668692231178284,0,2,4,0,12,9,-1,4,3,12,3,3,0.005002570804208517,0.1693672984838486,0.6554006934165955,0,2,6,9,10,8,-1,6,13,10,4,2,0.007965989410877228,0.5866332054138184,0.0914145186543465,0,2,3,6,14,8,-1,3,10,14,4,2,-0.003522701095789671,0.1413166970014572,0.6031895875930786,0,2,14,1,6,10,-1,14,1,3,10,2,0.0366676896810532,0.3675672113895416,0.7920318245887756,0,2,7,8,5,12,-1,7,12,5,4,3,0.009336147457361221,0.6161385774612427,0.2088509947061539,0,2,1,1,18,3,-1,7,1,6,3,3,0.008696131408214569,0.2836230993270874,0.6360273957252502,0,2,1,8,17,2,-1,1,9,17,1,2,0.0011488880263641477,0.2223580926656723,0.5800700783729553,0,2,16,6,4,2,-1,16,7,4,1,2,-0.002148468978703022,0.2406464070081711,0.5787054896354675,0,2,5,17,2,2,-1,5,18,2,1,2,0.002121906029060483,0.5559654831886292,0.136223703622818,0,2,14,2,6,12,-1,14,2,3,12,2,-0.0939491465687752,0.8502737283706665,0.4717740118503571,0,3,4,0,4,12,-1,4,0,2,6,2,6,6,2,6,2,0.0013777789426967502,0.5993673801422119,0.2834529876708984,0,2,2,11,18,8,-1,8,11,6,8,3,0.0730631574988365,0.4341886043548584,0.7060034275054932,0,2,5,7,10,2,-1,5,8,10,1,2,0.00036767389974556863,0.3027887940406799,0.6051574945449829,0,2,15,11,5,3,-1,15,12,5,1,3,-0.0060479710809886456,0.17984339594841,0.5675256848335266,9.498542785644531,21,0,2,5,3,10,9,-1,5,6,10,3,3,-0.0165106896311045,0.6644225120544434,0.1424857974052429,0,2,9,4,2,14,-1,9,11,2,7,2,0.002705249935388565,0.6325352191925049,0.1288477033376694,0,2,3,5,4,12,-1,3,9,4,4,3,0.002806986914947629,0.1240288019180298,0.6193193197250366,0,2,4,5,12,5,-1,8,5,4,5,3,-0.0015402400167658925,0.1432143002748489,0.5670015811920166,0,2,5,6,10,8,-1,5,10,10,4,2,-0.0005638627917505801,0.1657433062791824,0.5905207991600037,0,2,8,0,6,9,-1,8,3,6,3,3,0.0019253729842603207,0.2695507109165192,0.5738824009895325,0,2,9,12,1,8,-1,9,16,1,4,2,-0.005021484103053808,0.1893538981676102,0.5782774090766907,0,2,0,7,20,6,-1,0,9,20,2,3,0.0026365420781075954,0.2309329062700272,0.5695425868034363,0,2,7,0,6,17,-1,9,0,2,17,3,-0.0015127769438549876,0.2759602069854736,0.5956642031669617,0,2,9,0,6,4,-1,11,0,2,4,3,-0.0101574398577213,0.1732538044452667,0.5522047281265259,0,2,5,1,6,4,-1,7,1,2,4,3,-0.011953660286963,0.1339409947395325,0.5559014081954956,0,2,12,1,6,16,-1,14,1,2,16,3,0.004885949194431305,0.3628703951835632,0.6188849210739136,0,3,0,5,18,8,-1,0,5,9,4,2,9,9,9,4,2,-0.0801329165697098,0.0912110507488251,0.5475944876670837,0,3,8,15,10,4,-1,13,15,5,2,2,8,17,5,2,2,0.0010643280111253262,0.3715142905712128,0.5711399912834167,0,3,3,1,4,8,-1,3,1,2,4,2,5,5,2,4,2,-0.0013419450260698795,0.5953313708305359,0.331809788942337,0,3,3,6,14,10,-1,10,6,7,5,2,3,11,7,5,2,-0.0546011403203011,0.1844065934419632,0.5602846145629883,0,2,2,1,6,16,-1,4,1,2,16,3,0.0029071690514683723,0.3594244122505188,0.6131715178489685,0,2,0,18,20,2,-1,0,19,20,1,2,0.0007471871795132756,0.5994353294372559,0.3459562957286835,0,2,8,13,4,3,-1,8,14,4,1,3,0.004301380831748247,0.4172652065753937,0.6990845203399658,0,2,9,14,2,3,-1,9,15,2,1,3,0.004501757211983204,0.4509715139865875,0.7801457047462463,0,2,0,12,9,6,-1,0,14,9,2,3,0.0241385009139776,0.5438212752342224,0.1319826990365982,18.4129695892334,39,0,2,5,7,3,4,-1,5,9,3,2,2,0.001921223010867834,0.1415266990661621,0.6199870705604553,0,2,9,3,2,16,-1,9,11,2,8,2,-0.00012748669541906565,0.6191074252128601,0.1884928941726685,0,2,3,6,13,8,-1,3,10,13,4,2,0.0005140993162058294,0.1487396955490112,0.5857927799224854,0,2,12,3,8,2,-1,12,3,4,2,2,0.004187860991805792,0.2746909856796265,0.6359239816665649,0,2,8,8,4,12,-1,8,12,4,4,3,0.005101571790874004,0.5870851278305054,0.2175628989934921,0,3,11,3,8,6,-1,15,3,4,3,2,11,6,4,3,2,-0.002144844038411975,0.5880944728851318,0.2979590892791748,0,2,7,1,6,19,-1,9,1,2,19,3,-0.0028977119363844395,0.2373327016830444,0.5876647233963013,0,2,9,0,6,4,-1,11,0,2,4,3,-0.0216106791049242,0.1220654994249344,0.5194202065467834,0,2,3,1,9,3,-1,6,1,3,3,3,-0.004629931878298521,0.263123095035553,0.5817409157752991,0,3,8,15,10,4,-1,13,15,5,2,2,8,17,5,2,2,0.000593937118537724,0.363862007856369,0.5698544979095459,0,2,0,3,6,10,-1,3,3,3,10,2,0.0538786612451077,0.4303531050682068,0.7559366226196289,0,2,3,4,15,15,-1,3,9,15,5,3,0.0018887349870055914,0.2122603058815002,0.561342716217041,0,2,6,5,8,6,-1,6,7,8,2,3,-0.0023635339457541704,0.563184916973114,0.2642767131328583,0,3,4,4,12,10,-1,10,4,6,5,2,4,9,6,5,2,0.0240177996456623,0.5797107815742493,0.2751705944538117,0,2,6,4,4,4,-1,8,4,2,4,2,0.00020543030404951423,0.2705242037773132,0.575256884098053,0,2,15,11,1,2,-1,15,12,1,1,2,0.0008479019743390381,0.5435624718666077,0.2334876954555512,0,2,3,11,2,2,-1,3,12,2,1,2,0.0014091329649090767,0.5319424867630005,0.2063155025243759,0,2,16,11,1,3,-1,16,12,1,1,3,0.0014642629539594054,0.5418980717658997,0.3068861067295075,0,3,3,15,6,4,-1,3,15,3,2,2,6,17,3,2,2,0.0016352549428120255,0.3695372939109802,0.6112868189811707,0,2,6,7,8,2,-1,6,8,8,1,2,0.0008317275205627084,0.3565036952495575,0.6025236248970032,0,2,3,11,1,3,-1,3,12,1,1,3,-0.0020998890977352858,0.1913982033729553,0.5362827181816101,0,2,6,0,12,2,-1,6,1,12,1,2,-0.0007421398186124861,0.3835555016994476,0.552931010723114,0,2,9,14,2,3,-1,9,15,2,1,3,0.0032655049581080675,0.4312896132469177,0.7101895809173584,0,2,7,15,6,2,-1,7,16,6,1,2,0.0008913499186746776,0.3984830975532532,0.6391963958740234,0,2,0,5,4,6,-1,0,7,4,2,3,-0.0152841797098517,0.2366732954978943,0.5433713793754578,0,2,4,12,12,2,-1,8,12,4,2,3,0.004838141147047281,0.5817500948905945,0.3239189088344574,0,2,6,3,1,9,-1,6,6,1,3,3,-0.0009109317907132208,0.5540593862533569,0.2911868989467621,0,2,10,17,3,2,-1,11,17,1,2,3,-0.006127506028860807,0.1775255054235458,0.5196629166603088,0,2,9,9,2,2,-1,9,10,2,1,2,-0.00044576259097084403,0.3024170100688934,0.5533593893051147,0,2,7,6,6,4,-1,9,6,2,4,3,0.0226465407758951,0.4414930939674377,0.6975377202033997,0,2,7,17,3,2,-1,8,17,1,2,3,-0.0018804960418492556,0.2791394889354706,0.5497952103614807,0,2,10,17,3,3,-1,11,17,1,3,3,0.007088910788297653,0.5263199210166931,0.2385547012090683,0,2,8,12,3,2,-1,8,13,3,1,2,0.0017318050377070904,0.4319379031658173,0.6983600854873657,0,2,9,3,6,2,-1,11,3,2,2,3,-0.006848270073533058,0.3082042932510376,0.5390920042991638,0,2,3,11,14,4,-1,3,13,14,2,2,-0.000015062530110299122,0.552192211151123,0.3120366036891937,0,3,1,10,18,4,-1,10,10,9,2,2,1,12,9,2,2,0.0294755697250366,0.5401322841644287,0.1770603060722351,0,2,0,10,3,3,-1,0,11,3,1,3,0.008138732984662056,0.5178617835044861,0.121101900935173,0,2,9,1,6,6,-1,11,1,2,6,3,0.0209429506212473,0.5290294289588928,0.3311221897602081,0,2,8,7,3,6,-1,9,7,1,6,3,-0.009566552937030792,0.7471994161605835,0.4451968967914581,15.324139595031738,33,0,2,1,0,18,9,-1,1,3,18,3,3,-0.00028206960996612906,0.2064086049795151,0.6076732277870178,0,2,12,10,2,6,-1,12,13,2,3,2,0.00167906004935503,0.5851997137069702,0.1255383938550949,0,2,0,5,19,8,-1,0,9,19,4,2,0.0006982791237533092,0.094018429517746,0.5728961229324341,0,2,7,0,6,9,-1,9,0,2,9,3,0.0007895901217125356,0.1781987994909287,0.5694308876991272,0,2,5,3,6,1,-1,7,3,2,1,3,-0.002856049919500947,0.1638399064540863,0.5788664817810059,0,2,11,3,6,1,-1,13,3,2,1,3,-0.0038122469559311867,0.2085440009832382,0.5508564710617065,0,2,5,10,4,6,-1,5,13,4,3,2,0.0015896620461717248,0.5702760815620422,0.1857215017080307,0,2,11,3,6,1,-1,13,3,2,1,3,0.0100783398374915,0.5116943120956421,0.2189770042896271,0,2,4,4,12,6,-1,4,6,12,2,3,-0.0635263025760651,0.7131379842758179,0.4043813049793243,0,2,15,12,2,6,-1,15,14,2,2,3,-0.009103149175643921,0.2567181885242462,0.54639732837677,0,2,9,3,2,2,-1,10,3,1,2,2,-0.002403500024229288,0.1700665950775147,0.559097409248352,0,2,9,3,3,1,-1,10,3,1,1,3,0.001522636041045189,0.5410556793212891,0.2619054019451141,0,2,1,1,4,14,-1,3,1,2,14,2,0.0179974399507046,0.3732436895370483,0.6535220742225647,0,3,9,0,4,4,-1,11,0,2,2,2,9,2,2,2,2,-0.00645381910726428,0.2626481950283051,0.5537446141242981,0,2,7,5,1,14,-1,7,12,1,7,2,-0.0118807600811124,0.2003753930330277,0.5544745922088623,0,2,19,0,1,4,-1,19,2,1,2,2,0.0012713660253211856,0.5591902732849121,0.303197592496872,0,2,5,5,6,4,-1,8,5,3,4,2,0.0011376109905540943,0.2730407118797302,0.5646508932113647,0,2,9,18,3,2,-1,10,18,1,2,3,-0.00426519988104701,0.1405909061431885,0.5461820960044861,0,2,8,18,3,2,-1,9,18,1,2,3,-0.0029602861031889915,0.1795035004615784,0.5459290146827698,0,2,4,5,12,6,-1,4,7,12,2,3,-0.008844822645187378,0.5736783146858215,0.280921995639801,0,2,3,12,2,6,-1,3,14,2,2,3,-0.006643068976700306,0.2370675951242447,0.5503826141357422,0,2,10,8,2,12,-1,10,12,2,4,3,0.003999780863523483,0.5608199834823608,0.3304282128810883,0,2,7,18,3,2,-1,8,18,1,2,3,-0.004122172016650438,0.1640105992555618,0.5378993153572083,0,2,9,0,6,2,-1,11,0,2,2,3,0.0156249096617103,0.5227649211883545,0.2288603931665421,0,2,5,11,9,3,-1,5,12,9,1,3,-0.0103564197197557,0.7016193866729736,0.4252927899360657,0,2,9,0,6,2,-1,11,0,2,2,3,-0.008796080946922302,0.2767347097396851,0.5355830192565918,0,2,1,1,18,5,-1,7,1,6,5,3,0.1622693985700607,0.434224009513855,0.744257926940918,0,3,8,0,4,4,-1,10,0,2,2,2,8,2,2,2,2,0.0045542530715465546,0.5726485848426819,0.2582125067710877,0,2,3,12,1,3,-1,3,13,1,1,3,-0.002130920998752117,0.2106848061084747,0.5361018776893616,0,2,8,14,5,3,-1,8,15,5,1,3,-0.0132084200158715,0.7593790888786316,0.4552468061447144,0,3,5,4,10,12,-1,5,4,5,6,2,10,10,5,6,2,-0.0659966766834259,0.125247597694397,0.5344039797782898,0,2,9,6,9,12,-1,9,10,9,4,3,0.007914265617728233,0.3315384089946747,0.5601043105125427,0,3,2,2,12,14,-1,2,2,6,7,2,8,9,6,7,2,0.0208942797034979,0.5506049990653992,0.2768838107585907,21.010639190673828,44,0,2,4,7,12,2,-1,8,7,4,2,3,0.0011961159761995077,0.1762690991163254,0.6156241297721863,0,2,7,4,6,4,-1,7,6,6,2,2,-0.0018679830245673656,0.6118106842041016,0.1832399964332581,0,2,4,5,11,8,-1,4,9,11,4,2,-0.00019579799845814705,0.0990442633628845,0.5723816156387329,0,2,3,10,16,4,-1,3,12,16,2,2,-0.0008025565766729414,0.5579879879951477,0.2377282977104187,0,2,0,0,16,2,-1,0,1,16,1,2,-0.0024510810617357492,0.2231457978487015,0.5858935117721558,0,2,7,5,6,2,-1,9,5,2,2,3,0.0005036185029894114,0.2653993964195252,0.5794103741645813,0,3,3,2,6,10,-1,3,2,3,5,2,6,7,3,5,2,0.0040293349884450436,0.5803827047348022,0.2484865039587021,0,2,10,5,8,15,-1,10,10,8,5,3,-0.0144517095759511,0.1830351948738098,0.5484204888343811,0,3,3,14,8,6,-1,3,14,4,3,2,7,17,4,3,2,0.0020380979403853416,0.3363558948040009,0.6051092743873596,0,2,14,2,2,2,-1,14,3,2,1,2,-0.0016155190533027053,0.2286642044782639,0.5441246032714844,0,2,1,10,7,6,-1,1,13,7,3,2,0.0033458340913057327,0.5625913143157959,0.2392338067293167,0,2,15,4,4,3,-1,15,4,2,3,2,0.0016379579901695251,0.3906993865966797,0.5964621901512146,0,3,2,9,14,6,-1,2,9,7,3,2,9,12,7,3,2,0.0302512105554342,0.524848222732544,0.1575746983289719,0,2,5,7,10,4,-1,5,9,10,2,2,0.037251990288496,0.4194310903549194,0.6748418807983398,0,3,6,9,8,8,-1,6,9,4,4,2,10,13,4,4,2,-0.0251097902655602,0.1882549971342087,0.5473451018333435,0,2,14,1,3,2,-1,14,2,3,1,2,-0.005309905856847763,0.133997306227684,0.5227110981941223,0,2,1,4,4,2,-1,3,4,2,2,2,0.0012086479691788554,0.3762088119983673,0.6109635829925537,0,2,11,10,2,8,-1,11,14,2,4,2,-0.0219076797366142,0.266314297914505,0.5404006838798523,0,2,0,0,5,3,-1,0,1,5,1,3,0.0054116579703986645,0.5363578796386719,0.2232273072004318,0,3,2,5,18,8,-1,11,5,9,4,2,2,9,9,4,2,0.069946326315403,0.5358232855796814,0.2453698068857193,0,2,6,6,1,6,-1,6,9,1,3,2,0.00034520021290518343,0.2409671992063522,0.5376930236816406,0,2,19,1,1,3,-1,19,2,1,1,3,0.0012627709656953812,0.5425856709480286,0.3155693113803864,0,2,7,6,6,6,-1,9,6,2,6,3,0.0227195098996162,0.4158405959606171,0.6597865223884583,0,2,19,1,1,3,-1,19,2,1,1,3,-0.001811100053600967,0.2811253070831299,0.5505244731903076,0,2,3,13,2,3,-1,3,14,2,1,3,0.0033469670452177525,0.526002824306488,0.1891465038061142,0,3,8,4,8,12,-1,12,4,4,6,2,8,10,4,6,2,0.00040791751234792173,0.5673509240150452,0.3344210088253021,0,2,5,2,6,3,-1,7,2,2,3,3,0.0127347996458411,0.5343592166900635,0.2395612001419067,0,2,6,1,9,10,-1,6,6,9,5,2,-0.007311972789466381,0.6010890007019043,0.4022207856178284,0,2,0,4,6,12,-1,2,4,2,12,3,-0.0569487512111664,0.8199151158332825,0.4543190896511078,0,2,15,13,2,3,-1,15,14,2,1,3,-0.005011659115552902,0.2200281023979187,0.5357710719108582,0,2,7,14,5,3,-1,7,15,5,1,3,0.006033436860889196,0.4413081109523773,0.7181751132011414,0,2,15,13,3,3,-1,15,14,3,1,3,0.0039437441155314445,0.547886073589325,0.2791733145713806,0,2,6,14,8,3,-1,6,15,8,1,3,-0.0036591119132936,0.635786771774292,0.3989723920822144,0,2,15,13,3,3,-1,15,14,3,1,3,-0.0038456181064248085,0.3493686020374298,0.5300664901733398,0,2,2,13,3,3,-1,2,14,3,1,3,-0.007192626129835844,0.1119614988565445,0.5229672789573669,0,3,4,7,12,12,-1,10,7,6,6,2,4,13,6,6,2,-0.0527989417314529,0.2387102991342545,0.54534512758255,0,2,9,7,2,6,-1,10,7,1,6,2,-0.007953766733407974,0.7586917877197266,0.4439376890659332,0,2,8,9,5,2,-1,8,10,5,1,2,-0.0027344180271029472,0.2565476894378662,0.5489321947097778,0,2,8,6,3,4,-1,9,6,1,4,3,-0.0018507939530536532,0.6734347939491272,0.4252474904060364,0,2,9,6,2,8,-1,9,10,2,4,2,0.0159189198166132,0.548835277557373,0.2292661964893341,0,2,7,7,3,6,-1,8,7,1,6,3,-0.0012687679845839739,0.6104331016540527,0.4022389948368073,0,2,11,3,3,3,-1,12,3,1,3,3,0.006288391072303057,0.5310853123664856,0.1536193042993546,0,2,5,4,6,1,-1,7,4,2,1,3,-0.0062259892001748085,0.1729111969470978,0.524160623550415,0,2,5,6,10,3,-1,5,7,10,1,3,-0.0121325999498367,0.659775972366333,0.4325182139873505,23.918790817260742,50,0,2,7,3,6,9,-1,7,6,6,3,3,-0.0039184908382594585,0.6103435158729553,0.1469330936670303,0,2,6,7,9,1,-1,9,7,3,1,3,0.0015971299726516008,0.2632363140583038,0.5896466970443726,0,2,2,8,16,8,-1,2,12,16,4,2,0.0177801102399826,0.587287425994873,0.1760361939668655,0,2,14,6,2,6,-1,14,9,2,3,2,0.0006533476989716291,0.1567801982164383,0.5596066117286682,0,2,1,5,6,15,-1,1,10,6,5,3,-0.00028353091329336166,0.1913153976202011,0.5732036232948303,0,2,10,0,6,9,-1,10,3,6,3,3,0.0016104689566418529,0.2914913892745972,0.5623080730438232,0,2,6,6,7,14,-1,6,13,7,7,2,-0.0977506190538406,0.194347694516182,0.5648233294487,0,2,13,7,3,6,-1,13,9,3,2,3,0.0005518235848285258,0.3134616911411285,0.5504639744758606,0,2,1,8,15,4,-1,6,8,5,4,3,-0.0128582203760743,0.253648191690445,0.5760142803192139,0,2,11,2,3,10,-1,11,7,3,5,2,0.004153023939579725,0.5767722129821777,0.36597740650177,0,2,3,7,4,6,-1,3,9,4,2,3,0.0017092459602281451,0.2843191027641296,0.5918939113616943,0,2,13,3,6,10,-1,15,3,2,10,3,0.007521735969930887,0.4052427113056183,0.6183109283447266,0,3,5,7,8,10,-1,5,7,4,5,2,9,12,4,5,2,0.0022479810286313295,0.578375518321991,0.3135401010513306,0,3,4,4,12,12,-1,10,4,6,6,2,4,10,6,6,2,0.0520062111318111,0.5541312098503113,0.1916636973619461,0,2,1,4,6,9,-1,3,4,2,9,3,0.0120855299755931,0.4032655954360962,0.6644591093063354,0,2,11,3,2,5,-1,11,3,1,5,2,0.000014687820112158079,0.3535977900028229,0.5709382891654968,0,2,7,3,2,5,-1,8,3,1,5,2,0.000007139518857002258,0.3037444949150085,0.5610269904136658,0,2,10,14,2,3,-1,10,15,2,1,3,-0.0046001640148460865,0.7181087136268616,0.4580326080322266,0,2,5,12,6,2,-1,8,12,3,2,2,0.0020058949012309313,0.5621951818466187,0.2953684031963348,0,2,9,14,2,3,-1,9,15,2,1,3,0.004505027085542679,0.4615387916564941,0.7619017958641052,0,2,4,11,12,6,-1,4,14,12,3,2,0.0117468303069472,0.5343837141990662,0.1772529035806656,0,2,11,11,5,9,-1,11,14,5,3,3,-0.0583163388073444,0.1686245948076248,0.5340772271156311,0,2,6,15,3,2,-1,6,16,3,1,2,0.00023629379575140774,0.3792056143283844,0.6026803851127625,0,2,11,0,3,5,-1,12,0,1,5,3,-0.007815618067979813,0.151286706328392,0.5324323773384094,0,2,5,5,6,7,-1,8,5,3,7,2,-0.0108761601150036,0.2081822007894516,0.5319945216178894,0,2,13,0,1,9,-1,13,3,1,3,3,-0.0027745519764721394,0.4098246991634369,0.5210328102111816,0,3,3,2,4,8,-1,3,2,2,4,2,5,6,2,4,2,-0.0007827638182789087,0.5693274140357971,0.3478842079639435,0,2,13,12,4,6,-1,13,14,4,2,3,0.0138704096898437,0.5326750874519348,0.2257698029279709,0,2,3,12,4,6,-1,3,14,4,2,3,-0.0236749108880758,0.1551305055618286,0.5200707912445068,0,2,13,11,3,4,-1,13,13,3,2,2,-0.000014879409718560055,0.5500566959381104,0.3820176124572754,0,2,4,4,4,3,-1,4,5,4,1,3,0.00361906411126256,0.4238683879375458,0.6639748215675354,0,2,7,5,11,8,-1,7,9,11,4,2,-0.0198171101510525,0.2150038033723831,0.5382357835769653,0,2,7,8,3,4,-1,8,8,1,4,3,-0.0038154039066284895,0.6675711274147034,0.4215297102928162,0,2,9,1,6,1,-1,11,1,2,1,3,-0.0049775829538702965,0.2267289012670517,0.5386328101158142,0,2,5,5,3,3,-1,5,6,3,1,3,0.002244102070108056,0.4308691024780273,0.6855735778808594,0,3,0,9,20,6,-1,10,9,10,3,2,0,12,10,3,2,0.0122824599966407,0.5836614966392517,0.3467479050159454,0,2,8,6,3,5,-1,9,6,1,5,3,-0.002854869933798909,0.7016944885253906,0.4311453998088837,0,2,11,0,1,3,-1,11,1,1,1,3,-0.0037875669077038765,0.2895345091819763,0.5224946141242981,0,2,4,2,4,2,-1,4,3,4,1,2,-0.0012201230274513364,0.2975570857524872,0.5481644868850708,0,2,12,6,4,3,-1,12,7,4,1,3,0.010160599835217,0.4888817965984345,0.8182697892189026,0,2,5,0,6,4,-1,7,0,2,4,3,-0.0161745697259903,0.1481492966413498,0.5239992737770081,0,2,9,7,3,8,-1,10,7,1,8,3,0.0192924607545137,0.4786309897899628,0.7378190755844116,0,2,9,7,2,2,-1,10,7,1,2,2,-0.003247953951358795,0.7374222874641418,0.4470643997192383,0,3,6,7,14,4,-1,13,7,7,2,2,6,9,7,2,2,-0.009380348026752472,0.3489154875278473,0.5537996292114258,0,2,0,5,3,6,-1,0,7,3,2,3,-0.0126061299815774,0.2379686981439591,0.5315443277359009,0,2,13,11,3,4,-1,13,13,3,2,2,-0.0256219301372766,0.1964688003063202,0.5138769745826721,0,2,4,11,3,4,-1,4,13,3,2,2,-0.00007574149640277028,0.5590522885322571,0.3365853130817413,0,3,5,9,12,8,-1,11,9,6,4,2,5,13,6,4,2,-0.0892108827829361,0.0634046569466591,0.516263484954834,0,2,9,12,1,3,-1,9,13,1,1,3,-0.002767048077657819,0.732346773147583,0.4490706026554108,0,2,10,15,2,4,-1,10,17,2,2,2,0.0002715257869567722,0.411483496427536,0.5985518097877502,24.52787971496582,51,0,2,7,7,6,1,-1,9,7,2,1,3,0.001478621968999505,0.266354501247406,0.6643316745758057,0,3,12,3,6,6,-1,15,3,3,3,2,12,6,3,3,2,-0.001874165958724916,0.6143848896026611,0.2518512904644013,0,2,0,4,10,6,-1,0,6,10,2,3,-0.001715100952424109,0.5766341090202332,0.2397463023662567,0,3,8,3,8,14,-1,12,3,4,7,2,8,10,4,7,2,-0.0018939269939437509,0.5682045817375183,0.2529144883155823,0,2,4,4,7,15,-1,4,9,7,5,3,-0.005300605203956366,0.1640675961971283,0.5556079745292664,0,3,12,2,6,8,-1,15,2,3,4,2,12,6,3,4,2,-0.0466625317931175,0.6123154163360596,0.4762830138206482,0,3,2,2,6,8,-1,2,2,3,4,2,5,6,3,4,2,-0.000794313324149698,0.5707858800888062,0.2839404046535492,0,2,2,13,18,7,-1,8,13,6,7,3,0.0148916700854898,0.4089672863483429,0.6006367206573486,0,3,4,3,8,14,-1,4,3,4,7,2,8,10,4,7,2,-0.0012046529445797205,0.5712450742721558,0.2705289125442505,0,2,18,1,2,6,-1,18,3,2,2,3,0.006061938125640154,0.526250422000885,0.3262225985527039,0,2,9,11,2,3,-1,9,12,2,1,3,-0.0025286648888140917,0.6853830814361572,0.4199256896972656,0,2,18,1,2,6,-1,18,3,2,2,3,-0.005901021882891655,0.3266282081604004,0.5434812903404236,0,2,0,1,2,6,-1,0,3,2,2,3,0.005670276004821062,0.5468410849571228,0.2319003939628601,0,2,1,5,18,6,-1,1,7,18,2,3,-0.003030410036444664,0.557066798210144,0.2708238065242767,0,2,0,2,6,7,-1,3,2,3,7,2,0.002980364952236414,0.3700568974018097,0.5890625715255737,0,2,7,3,6,14,-1,7,10,6,7,2,-0.0758405104279518,0.2140070050954819,0.5419948101043701,0,2,3,7,13,10,-1,3,12,13,5,2,0.0192625392228365,0.5526772141456604,0.2726590037345886,0,2,11,15,2,2,-1,11,16,2,1,2,0.00018888259364757687,0.3958011865615845,0.6017209887504578,0,3,2,11,16,4,-1,2,11,8,2,2,10,13,8,2,2,0.0293695498257875,0.5241373777389526,0.1435758024454117,0,3,13,7,6,4,-1,16,7,3,2,2,13,9,3,2,2,0.0010417619487270713,0.3385409116744995,0.5929983258247375,0,2,6,10,3,9,-1,6,13,3,3,3,0.0026125640142709017,0.5485377907752991,0.3021597862243652,0,2,14,6,1,6,-1,14,9,1,3,2,0.0009697746718302369,0.3375276029109955,0.553203284740448,0,2,5,10,4,1,-1,7,10,2,1,2,0.0005951265920884907,0.563174307346344,0.3359399139881134,0,2,3,8,15,5,-1,8,8,5,5,3,-0.1015655994415283,0.0637350380420685,0.5230425000190735,0,2,1,6,5,4,-1,1,8,5,2,2,0.0361566990613937,0.5136963129043579,0.1029528975486755,0,2,3,1,17,6,-1,3,3,17,2,3,0.003462414024397731,0.3879320025444031,0.5558289289474487,0,2,6,7,8,2,-1,10,7,4,2,2,0.0195549800992012,0.5250086784362793,0.1875859946012497,0,2,9,7,3,2,-1,10,7,1,2,3,-0.0023121440317481756,0.667202889919281,0.4679641127586365,0,2,8,7,3,2,-1,9,7,1,2,3,-0.001860528951510787,0.7163379192352295,0.4334670901298523,0,2,8,9,4,2,-1,8,10,4,1,2,-0.0009402636205777526,0.302136093378067,0.5650203227996826,0,2,8,8,4,3,-1,8,9,4,1,3,-0.005241833161562681,0.1820009052753449,0.5250256061553955,0,2,9,5,6,4,-1,9,5,3,4,2,0.00011729019752237946,0.3389188051223755,0.544597327709198,0,2,8,13,4,3,-1,8,14,4,1,3,0.0011878840159624815,0.4085349142551422,0.6253563165664673,0,3,4,7,12,6,-1,10,7,6,3,2,4,10,6,3,2,-0.0108813596889377,0.3378399014472961,0.5700082778930664,0,2,8,14,4,3,-1,8,15,4,1,3,0.0017354859737679362,0.4204635918140411,0.6523038744926453,0,2,9,7,3,3,-1,9,8,3,1,3,-0.00651190523058176,0.2595216035842896,0.5428143739700317,0,2,7,4,3,8,-1,8,4,1,8,3,-0.0012136430013924837,0.6165143847465515,0.3977893888950348,0,2,10,0,3,6,-1,11,0,1,6,3,-0.010354240424931,0.1628028005361557,0.5219504833221436,0,2,6,3,4,8,-1,8,3,2,8,2,0.0005585883045569062,0.3199650943279266,0.5503574013710022,0,2,14,3,6,13,-1,14,3,3,13,2,0.0152996499091387,0.4103994071483612,0.6122388243675232,0,2,8,13,3,6,-1,8,16,3,3,2,-0.021588210016489,0.103491298854351,0.519738495349884,0,2,14,3,6,13,-1,14,3,3,13,2,-0.1283462941646576,0.8493865132331848,0.4893102943897247,0,3,0,7,10,4,-1,0,7,5,2,2,5,9,5,2,2,-0.0022927189711481333,0.3130157887935638,0.5471575260162354,0,2,14,3,6,13,-1,14,3,3,13,2,0.0799151062965393,0.4856320917606354,0.6073989272117615,0,2,0,3,6,13,-1,3,3,3,13,2,-0.0794410929083824,0.8394674062728882,0.462453305721283,0,2,9,1,4,1,-1,9,1,2,1,2,-0.00528000108897686,0.1881695985794067,0.5306698083877563,0,2,8,0,2,1,-1,9,0,1,1,2,0.0010463109938427806,0.5271229147911072,0.2583065927028656,0,3,10,16,4,4,-1,12,16,2,2,2,10,18,2,2,2,0.00026317298761568964,0.4235304892063141,0.5735440850257874,0,2,9,6,2,3,-1,10,6,1,3,2,-0.0036173160187900066,0.6934396028518677,0.4495444893836975,0,2,4,5,12,2,-1,8,5,4,2,3,0.0114218797534704,0.590092122554779,0.4138193130493164,0,2,8,7,3,5,-1,9,7,1,5,3,-0.0019963278900831938,0.6466382741928101,0.4327239990234375,27.153350830078125,56,0,2,6,4,8,6,-1,6,6,8,2,3,-0.00996912457048893,0.6142324209213257,0.2482212036848068,0,2,9,5,2,12,-1,9,11,2,6,2,0.0007307305932044983,0.5704951882362366,0.2321965992450714,0,2,4,6,6,8,-1,4,10,6,4,2,0.0006404530140571296,0.2112251967191696,0.5814933180809021,0,2,12,2,8,5,-1,12,2,4,5,2,0.004542401991784573,0.2950482070446014,0.586631178855896,0,2,0,8,18,3,-1,0,9,18,1,3,0.00009247744310414419,0.2990990877151489,0.5791326761245728,0,2,8,12,4,8,-1,8,16,4,4,2,-0.008660314604640007,0.2813029885292053,0.5635542273521423,0,2,0,2,8,5,-1,4,2,4,5,2,0.008051581680774689,0.3535369038581848,0.6054757237434387,0,2,13,11,3,4,-1,13,13,3,2,2,0.00043835240649059415,0.5596532225608826,0.2731510996818543,0,2,5,11,6,1,-1,7,11,2,1,3,-0.0000981689736363478,0.5978031754493713,0.3638561069965363,0,2,11,3,3,1,-1,12,3,1,1,3,-0.0011298790341243148,0.2755252122879028,0.5432729125022888,0,2,7,13,5,3,-1,7,14,5,1,3,0.006435615010559559,0.4305641949176788,0.7069833278656006,0,2,11,11,7,6,-1,11,14,7,3,2,-0.0568293295800686,0.2495242953300476,0.5294997096061707,0,2,2,11,7,6,-1,2,14,7,3,2,0.004066816996783018,0.5478553175926208,0.2497723996639252,0,2,12,14,2,6,-1,12,16,2,2,3,0.0000481647984997835,0.3938601016998291,0.5706356167793274,0,2,8,14,3,3,-1,8,15,3,1,3,0.00617950176820159,0.440760612487793,0.7394766807556152,0,2,11,0,3,5,-1,12,0,1,5,3,0.006498575210571289,0.5445243120193481,0.2479152977466583,0,2,6,1,4,9,-1,8,1,2,9,2,-0.0010211090557277203,0.2544766962528229,0.5338971018791199,0,2,10,3,6,1,-1,12,3,2,1,3,-0.005424752831459045,0.2718858122825623,0.5324069261550903,0,2,8,8,3,4,-1,8,10,3,2,2,-0.0010559899965301156,0.3178288042545319,0.553450882434845,0,2,8,12,4,2,-1,8,13,4,1,2,0.0006646580877713859,0.4284219145774841,0.6558194160461426,0,2,5,18,4,2,-1,5,19,4,1,2,-0.00027524109464138746,0.5902860760688782,0.3810262978076935,0,2,2,1,18,6,-1,2,3,18,2,3,0.004229320213198662,0.381648987531662,0.5709385871887207,0,2,6,0,3,2,-1,7,0,1,2,3,-0.0032868210691958666,0.1747743934392929,0.5259544253349304,0,3,13,8,6,2,-1,16,8,3,1,2,13,9,3,1,2,0.0001561187964398414,0.3601722121238709,0.5725612044334412,0,2,6,10,3,6,-1,6,13,3,3,2,-0.000007362138148891972,0.540185809135437,0.3044497072696686,0,3,0,13,20,4,-1,10,13,10,2,2,0,15,10,2,2,-0.014767250046134,0.3220770061016083,0.5573434829711914,0,2,7,7,6,5,-1,9,7,2,5,3,0.0244895908981562,0.4301528036594391,0.6518812775611877,0,2,11,0,2,2,-1,11,1,2,1,2,-0.000376520911231637,0.356458306312561,0.5598236918449402,0,3,1,8,6,2,-1,1,8,3,1,2,4,9,3,1,2,0.00000736576885174145,0.3490782976150513,0.556189775466919,0,3,0,2,20,2,-1,10,2,10,1,2,0,3,10,1,2,-0.0150999398902059,0.1776272058486939,0.5335299968719482,0,2,7,14,5,3,-1,7,15,5,1,3,-0.0038316650316119194,0.6149687767028809,0.4221394062042236,0,3,7,13,6,6,-1,10,13,3,3,2,7,16,3,3,2,0.0169254001230001,0.5413014888763428,0.2166585028171539,0,2,9,12,2,3,-1,9,13,2,1,3,-0.003047785023227334,0.6449490785598755,0.4354617893695831,0,2,16,11,1,6,-1,16,13,1,2,3,0.003214058931916952,0.5400155186653137,0.3523217141628265,0,2,3,11,1,6,-1,3,13,1,2,3,-0.004002320114523172,0.2774524092674255,0.5338417291641235,0,3,4,4,14,12,-1,11,4,7,6,2,4,10,7,6,2,0.0074182129465043545,0.567673921585083,0.3702817857265472,0,2,5,4,3,3,-1,5,5,3,1,3,-0.008876458741724491,0.7749221920967102,0.4583688974380493,0,2,12,3,3,3,-1,13,3,1,3,3,0.002731173997744918,0.5338721871376038,0.3996661007404327,0,2,6,6,8,3,-1,6,7,8,1,3,-0.0025082379579544067,0.5611963272094727,0.377749890089035,0,2,12,3,3,3,-1,13,3,1,3,3,-0.008054107427597046,0.291522890329361,0.5179182887077332,0,3,3,1,4,10,-1,3,1,2,5,2,5,6,2,5,2,-0.0009793881326913834,0.5536432862281799,0.3700192868709564,0,2,5,7,10,2,-1,5,7,5,2,2,-0.005874590948224068,0.3754391074180603,0.5679376125335693,0,2,8,7,3,3,-1,9,7,1,3,3,-0.00449367193505168,0.7019699215888977,0.4480949938297272,0,2,15,12,2,3,-1,15,13,2,1,3,-0.00543892290443182,0.2310364991426468,0.5313386917114258,0,2,7,8,3,4,-1,8,8,1,4,3,-0.0007509464048780501,0.5864868760108948,0.4129343032836914,0,2,13,4,1,12,-1,13,10,1,6,2,0.000014528800420521293,0.3732407093048096,0.5619621276855469,0,3,4,5,12,12,-1,4,5,6,6,2,10,11,6,6,2,0.0407580696046352,0.5312091112136841,0.2720521986484528,0,2,7,14,7,3,-1,7,15,7,1,3,0.006650593131780624,0.4710015952587128,0.6693493723869324,0,2,3,12,2,3,-1,3,13,2,1,3,0.0045759351924061775,0.5167819261550903,0.1637275964021683,0,3,3,2,14,2,-1,10,2,7,1,2,3,3,7,1,2,0.0065269311890006065,0.5397608876228333,0.2938531935214996,0,2,0,1,3,10,-1,1,1,1,10,3,-0.0136603796854615,0.7086488008499146,0.453220009803772,0,2,9,0,6,5,-1,11,0,2,5,3,0.0273588690906763,0.5206481218338013,0.3589231967926025,0,2,5,7,6,2,-1,8,7,3,2,2,0.0006219755159690976,0.3507075905799866,0.5441123247146606,0,2,7,1,6,10,-1,7,6,6,5,2,-0.0033077080734074116,0.5859522819519043,0.402489185333252,0,2,1,1,18,3,-1,7,1,6,3,3,-0.0106311095878482,0.6743267178535461,0.4422602951526642,0,2,16,3,3,6,-1,16,5,3,2,3,0.0194416493177414,0.5282716155052185,0.1797904968261719,34.55411148071289,71,0,2,6,3,7,6,-1,6,6,7,3,2,-0.005505216773599386,0.5914731025695801,0.2626559138298035,0,2,4,7,12,2,-1,8,7,4,2,3,0.001956227933987975,0.2312581986188889,0.5741627216339111,0,2,0,4,17,10,-1,0,9,17,5,2,-0.008892478421330452,0.1656530052423477,0.5626654028892517,0,2,3,4,15,16,-1,3,12,15,8,2,0.0836383774876595,0.5423449873924255,0.1957294940948486,0,2,7,15,6,4,-1,7,17,6,2,2,0.0012282270472496748,0.3417904078960419,0.5992503762245178,0,2,15,2,4,9,-1,15,2,2,9,2,0.0057629169896245,0.3719581961631775,0.6079903841018677,0,2,2,3,3,2,-1,2,4,3,1,2,-0.0016417410224676132,0.2577486038208008,0.5576915740966797,0,2,13,6,7,9,-1,13,9,7,3,3,0.0034113149158656597,0.2950749099254608,0.5514171719551086,0,2,8,11,4,3,-1,8,12,4,1,3,-0.0110693201422691,0.7569358944892883,0.4477078914642334,0,3,0,2,20,6,-1,10,2,10,3,2,0,5,10,3,2,0.0348659716546535,0.5583708882331848,0.2669621109962463,0,3,3,2,6,10,-1,3,2,3,5,2,6,7,3,5,2,0.0006570109981112182,0.5627313256263733,0.2988890111446381,0,2,13,10,3,4,-1,13,12,3,2,2,-0.0243391301482916,0.2771185040473938,0.5108863115310669,0,2,4,10,3,4,-1,4,12,3,2,2,0.0005943520227447152,0.5580651760101318,0.3120341897010803,0,2,7,5,6,3,-1,9,5,2,3,3,0.0022971509024500847,0.3330250084400177,0.5679075717926025,0,2,7,6,6,8,-1,7,10,6,4,2,-0.0037801829166710377,0.2990534901618958,0.5344808101654053,0,2,0,11,20,6,-1,0,14,20,3,2,-0.13420669734478,0.1463858932256699,0.5392568111419678,0,3,4,13,4,6,-1,4,13,2,3,2,6,16,2,3,2,0.0007522454834543169,0.3746953904628754,0.5692734718322754,0,3,6,0,8,12,-1,10,0,4,6,2,6,6,4,6,2,-0.040545541793108,0.2754747867584229,0.5484297871589661,0,2,2,0,15,2,-1,2,1,15,1,2,0.0012572970008477569,0.3744584023952484,0.5756075978279114,0,2,9,12,2,3,-1,9,13,2,1,3,-0.007424994837492704,0.7513859272003174,0.4728231132030487,0,2,3,12,1,2,-1,3,13,1,1,2,0.0005090812919661403,0.540489673614502,0.2932321131229401,0,2,9,11,2,3,-1,9,12,2,1,3,-0.001280845026485622,0.6169779896736145,0.4273349046707153,0,2,7,3,3,1,-1,8,3,1,1,3,-0.0018348860321566463,0.2048496007919312,0.5206472277641296,0,2,17,7,3,6,-1,17,9,3,2,3,0.0274848695844412,0.5252984762191772,0.1675522029399872,0,2,7,2,3,2,-1,8,2,1,2,3,0.0022372419480234385,0.5267782807350159,0.2777658104896545,0,2,11,4,5,3,-1,11,5,5,1,3,-0.008863529190421104,0.69545578956604,0.4812048971652985,0,2,4,4,5,3,-1,4,5,5,1,3,0.004175397101789713,0.4291887879371643,0.6349195837974548,0,2,19,3,1,2,-1,19,4,1,1,2,-0.0017098189564421773,0.2930536866188049,0.5361248850822449,0,2,5,5,4,3,-1,5,6,4,1,3,0.006532854866236448,0.4495325088500977,0.7409694194793701,0,2,17,7,3,6,-1,17,9,3,2,3,-0.009537290781736374,0.3149119913578033,0.5416501760482788,0,2,0,7,3,6,-1,0,9,3,2,3,0.0253109894692898,0.5121892094612122,0.1311707943677902,0,2,14,2,6,9,-1,14,5,6,3,3,0.0364609695971012,0.5175911784172058,0.2591339945793152,0,2,0,4,5,6,-1,0,6,5,2,3,0.0208543296903372,0.5137140154838562,0.1582316011190414,0,2,10,5,6,2,-1,12,5,2,2,3,-0.0008720774785615504,0.5574309825897217,0.439897894859314,0,2,4,5,6,2,-1,6,5,2,2,3,-0.000015227000403683633,0.5548940896987915,0.3708069920539856,0,2,8,1,4,6,-1,8,3,4,2,3,-0.0008431650931015611,0.3387419879436493,0.5554211139678955,0,2,0,2,3,6,-1,0,4,3,2,3,0.0036037859972566366,0.5358061790466309,0.3411171138286591,0,2,6,6,8,3,-1,6,7,8,1,3,-0.006805789191275835,0.6125202775001526,0.4345862865447998,0,2,0,1,5,9,-1,0,4,5,3,3,-0.0470216609537601,0.2358165979385376,0.519373893737793,0,2,16,0,4,15,-1,16,0,2,15,2,-0.0369541086256504,0.7323111295700073,0.4760943949222565,0,2,1,10,3,2,-1,1,11,3,1,2,0.0010439479956403375,0.5419455170631409,0.3411330878734589,0,2,14,4,1,10,-1,14,9,1,5,2,-0.00021050689974799752,0.2821694016456604,0.5554947257041931,0,2,0,1,4,12,-1,2,1,2,12,2,-0.0808315873146057,0.9129930138587952,0.4697434902191162,0,2,11,11,4,2,-1,11,11,2,2,2,-0.0003657905908767134,0.6022670269012451,0.3978292942047119,0,2,5,11,4,2,-1,7,11,2,2,2,-0.00012545920617412776,0.5613213181495667,0.384553998708725,0,2,3,8,15,5,-1,8,8,5,5,3,-0.0687864869832993,0.2261611968278885,0.5300496816635132,0,2,0,0,6,10,-1,3,0,3,10,2,0.0124157899990678,0.4075691998004913,0.5828812122344971,0,2,11,4,3,2,-1,12,4,1,2,3,-0.004717481788247824,0.2827253937721252,0.5267757773399353,0,2,8,12,3,8,-1,8,16,3,4,2,0.0381368584930897,0.5074741244316101,0.1023615971207619,0,2,8,14,5,3,-1,8,15,5,1,3,-0.0028168049175292253,0.6169006824493408,0.4359692931175232,0,2,7,14,4,3,-1,7,15,4,1,3,0.008130360394716263,0.4524433016777039,0.76060950756073,0,2,11,4,3,2,-1,12,4,1,2,3,0.006005601957440376,0.5240408778190613,0.185971200466156,0,3,3,15,14,4,-1,3,15,7,2,2,10,17,7,2,2,0.0191393196582794,0.5209379196166992,0.2332071959972382,0,3,2,2,16,4,-1,10,2,8,2,2,2,4,8,2,2,0.0164457596838474,0.5450702905654907,0.3264234960079193,0,2,0,8,6,12,-1,3,8,3,12,2,-0.0373568907380104,0.6999046802520752,0.4533241987228394,0,2,5,7,10,2,-1,5,7,5,2,2,-0.0197279006242752,0.2653664946556091,0.54128098487854,0,2,9,7,2,5,-1,10,7,1,5,2,0.0066972579807043076,0.4480566084384918,0.7138652205467224,0,3,13,7,6,4,-1,16,7,3,2,2,13,9,3,2,2,0.0007445752853527665,0.4231350123882294,0.5471320152282715,0,2,0,13,8,2,-1,0,14,8,1,2,0.0011790640419349074,0.5341702103614807,0.3130455017089844,0,3,13,7,6,4,-1,16,7,3,2,2,13,9,3,2,2,0.0349806100130081,0.5118659734725952,0.343053013086319,0,3,1,7,6,4,-1,1,7,3,2,2,4,9,3,2,2,0.0005685979267582297,0.3532187044620514,0.5468639731407166,0,2,12,6,1,12,-1,12,12,1,6,2,-0.0113406497985125,0.2842353880405426,0.5348700881004333,0,2,9,5,2,6,-1,10,5,1,6,2,-0.00662281084805727,0.6883640289306641,0.4492664933204651,0,2,14,12,2,3,-1,14,13,2,1,3,-0.008016033098101616,0.1709893941879273,0.5224308967590332,0,2,4,12,2,3,-1,4,13,2,1,3,0.0014206819469109178,0.5290846228599548,0.299338310956955,0,2,8,12,4,3,-1,8,13,4,1,3,-0.002780171111226082,0.6498854160308838,0.4460499882698059,0,3,5,2,2,4,-1,5,2,1,2,2,6,4,1,2,2,-0.0014747589593753219,0.3260438144207001,0.5388113260269165,0,2,5,5,11,3,-1,5,6,11,1,3,-0.0238303393125534,0.7528941035270691,0.4801219999790192,0,2,7,6,4,12,-1,7,12,4,6,2,0.00693697901442647,0.5335165858268738,0.3261427879333496,0,2,12,13,8,5,-1,12,13,4,5,2,0.008280625566840172,0.458039402961731,0.5737829804420471,0,2,7,6,1,12,-1,7,12,1,6,2,-0.0104395002126694,0.2592320144176483,0.5233827829360962,39.1072883605957,80,0,2,1,2,6,3,-1,4,2,3,3,2,0.0072006587870419025,0.325888603925705,0.6849808096885681,0,3,9,5,6,10,-1,12,5,3,5,2,9,10,3,5,2,-0.002859358908608556,0.5838881134986877,0.2537829875946045,0,3,5,5,8,12,-1,5,5,4,6,2,9,11,4,6,2,0.0006858052802272141,0.5708081722259521,0.2812424004077911,0,2,0,7,20,6,-1,0,9,20,2,3,0.007958019152283669,0.2501051127910614,0.5544260740280151,0,2,4,2,2,2,-1,4,3,2,1,2,-0.0012124150525778532,0.2385368049144745,0.5433350205421448,0,2,4,18,12,2,-1,8,18,4,2,3,0.00794261321425438,0.3955070972442627,0.6220757961273193,0,2,7,4,4,16,-1,7,12,4,8,2,0.0024630590341985226,0.5639708042144775,0.2992357909679413,0,2,7,6,7,8,-1,7,10,7,4,2,-0.006039659958332777,0.218651294708252,0.541167676448822,0,2,6,3,3,1,-1,7,3,1,1,3,-0.0012988339876756072,0.23507060110569,0.5364584922790527,0,2,11,15,2,4,-1,11,17,2,2,2,0.00022299369447864592,0.380411297082901,0.572960615158081,0,2,3,5,4,8,-1,3,9,4,4,2,0.0014654280385002494,0.2510167956352234,0.5258268713951111,0,2,7,1,6,12,-1,7,7,6,6,2,-0.0008121004211716354,0.5992823839187622,0.3851158916950226,0,2,4,6,6,2,-1,6,6,2,2,3,-0.0013836020370945334,0.5681396126747131,0.3636586964130402,0,2,16,4,4,6,-1,16,6,4,2,3,-0.0279364492744207,0.1491317003965378,0.5377560257911682,0,2,3,3,5,2,-1,3,4,5,1,2,-0.0004691955109592527,0.3692429959774017,0.5572484731674194,0,2,9,11,2,3,-1,9,12,2,1,3,-0.004982965998351574,0.6758509278297424,0.4532504081726074,0,2,2,16,4,2,-1,2,17,4,1,2,0.001881530974060297,0.5368022918701172,0.2932539880275726,0,3,7,13,6,6,-1,10,13,3,3,2,7,16,3,3,2,-0.0190675500780344,0.1649377048015595,0.5330067276954651,0,2,7,0,3,4,-1,8,0,1,4,3,-0.0046906559728085995,0.1963925957679749,0.5119361877441406,0,2,8,15,4,3,-1,8,16,4,1,3,0.005977713968604803,0.467117190361023,0.7008398175239563,0,2,0,4,4,6,-1,0,6,4,2,3,-0.0333031304180622,0.1155416965484619,0.5104162096977234,0,2,5,6,12,3,-1,9,6,4,3,3,0.0907441079616547,0.5149660110473633,0.1306173056364059,0,2,7,6,6,14,-1,9,6,2,14,3,0.0009355589863844216,0.3605481088161469,0.543985903263092,0,2,9,7,3,3,-1,10,7,1,3,3,0.0149016501381993,0.4886212050914764,0.7687569856643677,0,2,6,12,2,4,-1,6,14,2,2,2,0.0006159411859698594,0.5356813073158264,0.3240939080715179,0,2,10,12,7,6,-1,10,14,7,2,3,-0.0506709888577461,0.1848621964454651,0.5230404138565063,0,2,1,0,15,2,-1,1,1,15,1,2,0.0006866574985906482,0.3840579986572266,0.5517945885658264,0,2,14,0,6,6,-1,14,0,3,6,2,0.008371243253350258,0.4288564026355743,0.6131753921508789,0,2,5,3,3,1,-1,6,3,1,1,3,-0.0012953069526702166,0.2913674116134644,0.528073787689209,0,2,14,0,6,6,-1,14,0,3,6,2,-0.0419416800141335,0.7554799914360046,0.4856030941009522,0,2,0,3,20,10,-1,0,8,20,5,2,-0.0235293805599213,0.2838279902935028,0.5256081223487854,0,2,14,0,6,6,-1,14,0,3,6,2,0.0408574491739273,0.4870935082435608,0.6277297139167786,0,2,0,0,6,6,-1,3,0,3,6,2,-0.0254068691283464,0.7099707722663879,0.4575029015541077,0,2,19,15,1,2,-1,19,16,1,1,2,-0.00041415440500713885,0.4030886888504028,0.5469412207603455,0,2,0,2,4,8,-1,2,2,2,8,2,0.0218241196125746,0.4502024054527283,0.6768701076507568,0,3,2,1,18,4,-1,11,1,9,2,2,2,3,9,2,2,0.0141140399500728,0.5442860722541809,0.3791700005531311,0,2,8,12,1,2,-1,8,13,1,1,2,0.00006721459067193791,0.4200463891029358,0.5873476266860962,0,3,5,2,10,6,-1,10,2,5,3,2,5,5,5,3,2,-0.00794176384806633,0.3792561888694763,0.5585265755653381,0,2,9,7,2,4,-1,10,7,1,4,2,-0.00721444096416235,0.7253103852272034,0.4603548943996429,0,2,9,7,3,3,-1,10,7,1,3,3,0.002581733977422118,0.4693301916122437,0.5900238752365112,0,2,4,5,12,8,-1,8,5,4,8,3,0.1340931951999664,0.5149213075637817,0.1808844953775406,0,2,15,15,4,3,-1,15,16,4,1,3,0.0022962710354477167,0.5399743914604187,0.3717867136001587,0,2,8,18,3,1,-1,9,18,1,1,3,-0.002157584996894002,0.2408495992422104,0.5148863792419434,0,2,9,13,4,3,-1,9,14,4,1,3,-0.004919618833810091,0.6573588252067566,0.4738740026950836,0,2,7,13,4,3,-1,7,14,4,1,3,0.0016267469618469477,0.4192821979522705,0.6303114295005798,0,2,19,15,1,2,-1,19,16,1,1,2,0.00033413388882763684,0.5540298223495483,0.3702101111412048,0,2,0,15,8,4,-1,0,17,8,2,2,-0.0266980808228254,0.1710917949676514,0.5101410746574402,0,2,9,3,6,4,-1,11,3,2,4,3,-0.0305618792772293,0.1904218047857285,0.5168793797492981,0,2,8,14,4,3,-1,8,15,4,1,3,0.002851154888048768,0.4447506964206696,0.6313853859901428,0,2,3,14,14,6,-1,3,16,14,2,3,-0.0362114794552326,0.2490727007389069,0.5377349257469177,0,2,6,3,6,6,-1,6,6,6,3,2,-0.002411518944427371,0.5381243228912354,0.3664236962795258,0,2,5,11,10,6,-1,5,14,10,3,2,-0.0007725320174358785,0.5530232191085815,0.3541550040245056,0,2,3,10,3,4,-1,4,10,1,4,3,0.0002948172914329916,0.4132699072360992,0.5667243003845215,0,2,13,9,2,2,-1,13,9,1,2,2,-0.006233456078916788,0.0987872332334518,0.5198668837547302,0,2,5,3,6,4,-1,7,3,2,4,3,-0.0262747295200825,0.0911274924874306,0.5028107166290283,0,2,9,7,3,3,-1,10,7,1,3,3,0.005321226082742214,0.4726648926734924,0.6222720742225647,0,2,2,12,2,3,-1,2,13,2,1,3,-0.004112905822694302,0.2157457023859024,0.5137804746627808,0,2,9,8,3,12,-1,9,12,3,4,3,0.0032457809429615736,0.5410770773887634,0.3721776902675629,0,3,3,14,4,6,-1,3,14,2,3,2,5,17,2,3,2,-0.0163597092032433,0.7787874937057495,0.4685291945934296,0,2,16,15,2,2,-1,16,16,2,1,2,0.00032166109303943813,0.5478987097740173,0.4240373969078064,0,2,2,15,2,2,-1,2,16,2,1,2,0.000644524407107383,0.5330560803413391,0.3501324951648712,0,2,8,12,4,3,-1,8,13,4,1,3,-0.0078909732401371,0.6923521161079407,0.4726569056510925,0,2,0,7,20,1,-1,10,7,10,1,2,0.048336211591959,0.50559002161026,0.0757492035627365,0,2,7,6,8,3,-1,7,6,4,3,2,-0.000751781277358532,0.3783741891384125,0.5538573861122131,0,2,5,7,8,2,-1,9,7,4,2,2,-0.002495391061529517,0.3081651031970978,0.5359612107276917,0,2,9,7,3,5,-1,10,7,1,5,3,-0.0022385010961443186,0.663395881652832,0.4649342894554138,0,2,8,7,3,5,-1,9,7,1,5,3,-0.0017988430336117744,0.6596844792366028,0.4347187876701355,0,2,11,1,3,5,-1,12,1,1,5,3,0.008786091580986977,0.523183286190033,0.2315579950809479,0,2,6,2,3,6,-1,7,2,1,6,3,0.003671538084745407,0.520425021648407,0.2977376878261566,0,2,14,14,6,5,-1,14,14,3,5,2,-0.0353364497423172,0.7238878011703491,0.4861505031585693,0,2,9,8,2,2,-1,9,9,2,1,2,-0.0006918924045749009,0.3105022013187408,0.5229824781417847,0,2,10,7,1,3,-1,10,8,1,1,3,-0.003394610946998,0.3138968050479889,0.5210173726081848,0,3,6,6,2,2,-1,6,6,1,1,2,7,7,1,1,2,0.0009856928372755647,0.4536580145359039,0.6585097908973694,0,3,2,11,18,4,-1,11,11,9,2,2,2,13,9,2,2,-0.0501631014049053,0.1804454028606415,0.5198916792869568,0,3,6,6,2,2,-1,6,6,1,1,2,7,7,1,1,2,-0.0022367259953171015,0.7255702018737793,0.4651359021663666,0,2,0,15,20,2,-1,0,16,20,1,2,0.0007432628772221506,0.4412921071052551,0.5898545980453491,0,2,4,14,2,3,-1,4,15,2,1,3,-0.0009348518215119839,0.3500052988529205,0.5366017818450928,0,2,8,14,4,3,-1,8,15,4,1,3,0.0174979399889708,0.4912194907665253,0.8315284848213196,0,2,8,7,2,3,-1,8,8,2,1,3,-0.0015200000489130616,0.3570275902748108,0.537056028842926,0,2,9,10,2,3,-1,9,11,2,1,3,0.0007800394087098539,0.4353772103786469,0.5967335104942322,50.61048126220703,103,0,2,5,4,10,4,-1,5,6,10,2,2,-0.00999455526471138,0.6162583231925964,0.3054533004760742,0,3,9,7,6,4,-1,12,7,3,2,2,9,9,3,2,2,-0.001108522992581129,0.5818294882774353,0.3155578076839447,0,2,4,7,3,6,-1,4,9,3,2,3,0.001036438043229282,0.2552052140235901,0.5692911744117737,0,3,11,15,4,4,-1,13,15,2,2,2,11,17,2,2,2,0.000682113110087812,0.3685089945793152,0.5934931039810181,0,2,7,8,4,2,-1,7,9,4,1,2,-0.0006805734010413289,0.2332392036914825,0.5474792122840881,0,2,13,1,4,3,-1,13,1,2,3,2,0.0002606878988444805,0.325745701789856,0.5667545795440674,0,3,5,15,4,4,-1,5,15,2,2,2,7,17,2,2,2,0.0005160737200640142,0.3744716942310333,0.5845472812652588,0,2,9,5,4,7,-1,9,5,2,7,2,0.0008500752155669034,0.3420371115207672,0.5522807240486145,0,2,5,6,8,3,-1,9,6,4,3,2,-0.0018607829697430134,0.2804419994354248,0.5375424027442932,0,2,9,9,2,2,-1,9,10,2,1,2,-0.001503397012129426,0.2579050958156586,0.5498952269554138,0,2,7,15,5,3,-1,7,16,5,1,3,0.0023478909861296415,0.4175156056880951,0.6313710808753967,0,2,11,10,4,3,-1,11,10,2,3,2,-0.00028880240279249847,0.5865169763565063,0.4052666127681732,0,2,6,9,8,10,-1,6,14,8,5,2,0.008940547704696655,0.5211141109466553,0.231865406036377,0,2,10,11,6,2,-1,10,11,3,2,2,-0.0193277392536402,0.2753432989120483,0.5241525769233704,0,2,4,11,6,2,-1,7,11,3,2,2,-0.0002020206011366099,0.5722978711128235,0.3677195906639099,0,2,11,3,8,1,-1,11,3,4,1,2,0.002117906929925084,0.4466108083724976,0.5542430877685547,0,2,6,3,3,2,-1,7,3,1,2,3,-0.0017743760254234076,0.2813253104686737,0.5300959944725037,0,2,14,5,6,5,-1,14,5,3,5,2,0.004223445896059275,0.439970999956131,0.5795428156852722,0,2,7,5,2,12,-1,7,11,2,6,2,-0.0143752200528979,0.2981117963790894,0.5292059183120728,0,2,8,11,4,3,-1,8,12,4,1,3,-0.0153491804376245,0.7705215215682983,0.4748171865940094,0,2,4,1,2,3,-1,5,1,1,3,2,0.000015152279956964776,0.3718844056129456,0.5576897263526917,0,2,18,3,2,6,-1,18,5,2,2,3,-0.009129391983151436,0.3615196049213409,0.5286766886711121,0,2,0,3,2,6,-1,0,5,2,2,3,0.0022512159775942564,0.5364704728126526,0.3486298024654388,0,2,9,12,2,3,-1,9,13,2,1,3,-0.0049696918576955795,0.6927651762962341,0.4676836133003235,0,2,7,13,4,3,-1,7,14,4,1,3,-0.0128290103748441,0.7712153792381287,0.4660735130310059,0,2,18,0,2,6,-1,18,2,2,2,3,-0.009366006590425968,0.3374983966350555,0.5351287722587585,0,2,0,0,2,6,-1,0,2,2,2,3,0.0032452319283038378,0.5325189828872681,0.3289610147476196,0,2,8,14,6,3,-1,8,15,6,1,3,-0.0117235602810979,0.6837652921676636,0.4754300117492676,0,2,7,4,2,4,-1,8,4,1,4,2,0.00002925794069597032,0.357208788394928,0.5360502004623413,0,2,8,5,4,6,-1,8,7,4,2,3,-0.000022244219508138485,0.5541427135467529,0.3552064001560211,0,2,6,4,2,2,-1,7,4,1,2,2,0.005088150966912508,0.5070844292640686,0.1256462037563324,0,3,3,14,14,4,-1,10,14,7,2,2,3,16,7,2,2,0.0274296794086695,0.5269560217857361,0.1625818014144898,0,3,6,15,6,2,-1,6,15,3,1,2,9,16,3,1,2,-0.00641428679227829,0.7145588994026184,0.4584197103977203,0,2,14,15,6,2,-1,14,16,6,1,2,0.003347995923832059,0.5398612022399902,0.3494696915149689,0,2,2,12,12,8,-1,2,16,12,4,2,-0.0826354920864105,0.2439192980527878,0.5160226225852966,0,2,7,7,7,2,-1,7,8,7,1,2,0.0010261740535497665,0.3886891901493073,0.5767908096313477,0,2,0,2,18,2,-1,0,3,18,1,2,-0.0016307090409100056,0.3389458060264587,0.5347700715065002,0,2,9,6,2,5,-1,9,6,1,5,2,0.0024546680506318808,0.4601413905620575,0.638724684715271,0,2,7,5,3,8,-1,8,5,1,8,3,-0.0009947651997208595,0.5769879221916199,0.4120396077632904,0,2,9,6,3,4,-1,10,6,1,4,3,0.0154091902077198,0.4878709018230438,0.7089822292327881,0,2,4,13,3,2,-1,4,14,3,1,2,0.001178440055809915,0.5263553261756897,0.2895244956016541,0,2,9,4,6,3,-1,11,4,2,3,3,-0.0277019198983908,0.149882897734642,0.5219606757164001,0,2,5,4,6,3,-1,7,4,2,3,3,-0.0295053999871016,0.024893319234252,0.4999816119670868,0,2,14,11,5,2,-1,14,12,5,1,2,0.0004515943001024425,0.5464622974395752,0.4029662907123566,0,2,1,2,6,9,-1,3,2,2,9,3,0.007177263963967562,0.4271056950092316,0.5866296887397766,0,2,14,6,6,13,-1,14,6,3,13,2,-0.0741820484399796,0.6874179244041443,0.4919027984142304,0,3,3,6,14,8,-1,3,6,7,4,2,10,10,7,4,2,-0.0172541607171297,0.3370676040649414,0.534873902797699,0,2,16,0,4,11,-1,16,0,2,11,2,0.0148515598848462,0.4626792967319489,0.6129904985427856,0,3,3,4,12,12,-1,3,4,6,6,2,9,10,6,6,2,0.0100020002573729,0.5346122980117798,0.3423453867435455,0,2,11,4,5,3,-1,11,5,5,1,3,0.0020138120744377375,0.4643830060958862,0.5824304223060608,0,2,4,11,4,2,-1,4,12,4,1,2,0.0015135470312088728,0.5196396112442017,0.2856149971485138,0,2,10,7,2,2,-1,10,7,1,2,2,0.003138143103569746,0.4838162958621979,0.5958529710769653,0,2,8,7,2,2,-1,9,7,1,2,2,-0.005145044066011906,0.8920302987098694,0.4741412103176117,0,2,9,17,3,2,-1,10,17,1,2,3,-0.004473670851439238,0.2033942937850952,0.5337278842926025,0,2,5,6,3,3,-1,5,7,3,1,3,0.001962847076356411,0.457163393497467,0.6725863218307495,0,2,10,0,3,3,-1,11,0,1,3,3,0.005426045041531324,0.5271108150482178,0.2845670878887177,0,3,5,6,6,2,-1,5,6,3,1,2,8,7,3,1,2,0.0004961146041750908,0.4138312935829163,0.5718597769737244,0,2,12,16,4,3,-1,12,17,4,1,3,0.009372878819704056,0.5225151181221008,0.2804847061634064,0,2,3,12,3,2,-1,3,13,3,1,2,0.0006050089723430574,0.523676872253418,0.3314523994922638,0,2,9,12,3,2,-1,9,13,3,1,2,0.0005679255118593574,0.4531059861183167,0.6276971101760864,0,3,1,11,16,4,-1,1,11,8,2,2,9,13,8,2,2,0.0246443394571543,0.5130851864814758,0.2017143964767456,0,2,12,4,3,3,-1,12,5,3,1,3,-0.0102904504165053,0.7786595225334167,0.4876641035079956,0,2,4,4,5,3,-1,4,5,5,1,3,0.002062941901385784,0.4288598895072937,0.5881264209747314,0,2,12,16,4,3,-1,12,17,4,1,3,-0.005051948130130768,0.3523977994918823,0.5286008715629578,0,2,5,4,3,3,-1,5,5,3,1,3,-0.0057692620903253555,0.6841086149215698,0.4588094055652618,0,2,9,0,2,2,-1,9,1,2,1,2,-0.0004578994121402502,0.356552004814148,0.5485978126525879,0,2,8,9,4,2,-1,8,10,4,1,2,-0.0007591883768327534,0.336879312992096,0.5254197120666504,0,2,8,8,4,3,-1,8,9,4,1,3,-0.001773725962266326,0.3422161042690277,0.5454015135765076,0,2,0,13,6,3,-1,2,13,2,3,3,-0.008561046794056892,0.6533612012863159,0.4485856890678406,0,2,16,14,3,2,-1,16,15,3,1,2,0.0017277270089834929,0.5307580232620239,0.3925352990627289,0,2,1,18,18,2,-1,7,18,6,2,3,-0.0281996093690395,0.685745894908905,0.4588584005832672,0,2,16,14,3,2,-1,16,15,3,1,2,-0.001778110978193581,0.4037851095199585,0.5369856953620911,0,2,1,14,3,2,-1,1,15,3,1,2,0.00033177141449414194,0.539979875087738,0.3705750107765198,0,2,7,14,6,3,-1,7,15,6,1,3,0.0026385399978607893,0.4665437042713165,0.6452730894088745,0,2,5,14,8,3,-1,5,15,8,1,3,-0.0021183069329708815,0.5914781093597412,0.4064677059650421,0,2,10,6,4,14,-1,10,6,2,14,2,-0.0147732896730304,0.3642038106918335,0.5294762849807739,0,2,6,6,4,14,-1,8,6,2,14,2,-0.0168154407292604,0.2664231956005096,0.5144972801208496,0,2,13,5,2,3,-1,13,6,2,1,3,-0.006337014026939869,0.6779531240463257,0.4852097928524017,0,2,7,16,6,1,-1,9,16,2,1,3,-0.000044560048991115764,0.5613964796066284,0.4153054058551788,0,2,9,12,3,3,-1,9,13,3,1,3,-0.0010240620467811823,0.5964478254318237,0.4566304087638855,0,2,7,0,3,3,-1,8,0,1,3,3,-0.00231616897508502,0.2976115047931671,0.5188159942626953,0,2,4,0,16,18,-1,4,9,16,9,2,0.5321757197380066,0.5187839269638062,0.220263198018074,0,2,1,1,16,14,-1,1,8,16,7,2,-0.1664305031299591,0.1866022944450378,0.5060343146324158,0,2,3,9,15,4,-1,8,9,5,4,3,0.112535297870636,0.5212125182151794,0.1185022965073586,0,2,6,12,7,3,-1,6,13,7,1,3,0.009304686449468136,0.4589937031269074,0.6826149225234985,0,2,14,15,2,3,-1,14,16,2,1,3,-0.004625509958714247,0.3079940974712372,0.5225008726119995,0,3,2,3,16,14,-1,2,3,8,7,2,10,10,8,7,2,-0.1111646965146065,0.2101044058799744,0.5080801844596863,0,3,16,2,4,18,-1,18,2,2,9,2,16,11,2,9,2,-0.0108884396031499,0.5765355229377747,0.4790464043617249,0,2,4,15,2,3,-1,4,16,2,1,3,0.005856430158019066,0.5065100193023682,0.1563598960638046,0,3,16,2,4,18,-1,18,2,2,9,2,16,11,2,9,2,0.0548543892800808,0.49669149518013,0.7230510711669922,0,2,1,1,8,3,-1,1,2,8,1,3,-0.0111973397433758,0.2194979041814804,0.5098798274993896,0,2,8,11,4,3,-1,8,12,4,1,3,0.004406907130032778,0.4778401851654053,0.6770902872085571,0,2,5,11,5,9,-1,5,14,5,3,3,-0.0636652931571007,0.1936362981796265,0.5081024169921875,0,2,16,0,4,11,-1,16,0,2,11,2,-0.009808149188756943,0.599906325340271,0.4810341000556946,0,2,7,0,6,1,-1,9,0,2,1,3,-0.0021717099007219076,0.3338333964347839,0.5235472917556763,0,2,16,3,3,7,-1,17,3,1,7,3,-0.0133155202493072,0.6617069840431213,0.4919213056564331,0,2,1,3,3,7,-1,2,3,1,7,3,0.002544207964092493,0.4488744139671326,0.6082184910774231,0,2,7,8,6,12,-1,7,12,6,4,3,0.0120378397405148,0.540939211845398,0.3292432129383087,0,2,0,0,4,11,-1,2,0,2,11,2,-0.0207010507583618,0.6819120049476624,0.4594995975494385,0,2,14,0,6,20,-1,14,0,3,20,2,0.0276082791388035,0.4630792140960693,0.5767282843589783,0,2,0,3,1,2,-1,0,4,1,1,2,0.0012370620388537645,0.5165379047393799,0.2635016143321991,0,3,5,5,10,8,-1,10,5,5,4,2,5,9,5,4,2,-0.037669338285923,0.2536393105983734,0.5278980135917664,0,3,4,7,12,4,-1,4,7,6,2,2,10,9,6,2,2,-0.0018057259730994701,0.3985156118869782,0.5517500042915344,54.62007141113281,111,0,2,2,1,6,4,-1,5,1,3,4,2,0.004429902881383896,0.2891018092632294,0.633522629737854,0,3,9,7,6,4,-1,12,7,3,2,2,9,9,3,2,2,-0.0023813319858163595,0.621178925037384,0.3477487862110138,0,2,5,6,2,6,-1,5,9,2,3,2,0.0022915711160749197,0.2254412025213242,0.5582118034362793,0,3,9,16,6,4,-1,12,16,3,2,2,9,18,3,2,2,0.0009945794008672237,0.3711710870265961,0.5930070877075195,0,2,9,4,2,12,-1,9,10,2,6,2,0.0007716466789133847,0.565172016620636,0.334799587726593,0,2,7,1,6,18,-1,9,1,2,18,3,-0.001138641033321619,0.3069126009941101,0.5508630871772766,0,2,4,12,12,2,-1,8,12,4,2,3,-0.0001640303962631151,0.576282799243927,0.3699047863483429,0,2,8,8,6,2,-1,8,9,6,1,2,0.000029793529392918572,0.2644244134426117,0.5437911152839661,0,2,8,0,3,6,-1,9,0,1,6,3,0.008577490225434303,0.5051138997077942,0.1795724928379059,0,2,11,18,3,2,-1,11,19,3,1,2,-0.0002603268949314952,0.5826969146728516,0.4446826875209808,0,2,1,1,17,4,-1,1,3,17,2,2,-0.006140463054180145,0.3113852143287659,0.5346971750259399,0,2,11,8,4,12,-1,11,8,2,12,2,-0.0230869501829147,0.32779461145401,0.533119797706604,0,2,8,14,4,3,-1,8,15,4,1,3,-0.0142436502501369,0.7381709814071655,0.4588063061237335,0,2,12,3,2,17,-1,12,3,1,17,2,0.0194871295243502,0.5256630778312683,0.2274471968412399,0,2,4,7,6,1,-1,6,7,2,1,3,-0.0009668110869824886,0.5511230826377869,0.3815006911754608,0,2,18,3,2,3,-1,18,4,2,1,3,0.003147470997646451,0.5425636768341064,0.2543726861476898,0,2,8,4,3,4,-1,8,6,3,2,2,-0.00018026070029009134,0.5380191802978516,0.3406304121017456,0,2,4,5,12,10,-1,4,10,12,5,2,-0.006026626098901033,0.3035801947116852,0.54205721616745,0,2,5,18,4,2,-1,7,18,2,2,2,0.00044462960795499384,0.3990997076034546,0.5660110116004944,0,2,17,2,3,6,-1,17,4,3,2,3,0.002260976005345583,0.5562806725502014,0.3940688073635101,0,2,7,7,6,6,-1,9,7,2,6,3,0.0511330589652061,0.4609653949737549,0.7118561863899231,0,2,17,2,3,6,-1,17,4,3,2,3,-0.0177863091230392,0.2316166013479233,0.5322144031524658,0,2,8,0,3,4,-1,9,0,1,4,3,-0.004967962857335806,0.233077198266983,0.5122029185295105,0,2,9,14,2,3,-1,9,15,2,1,3,0.002066768938675523,0.4657444059848785,0.6455488204956055,0,2,0,12,6,3,-1,0,13,6,1,3,0.007441376801580191,0.5154392123222351,0.236163392663002,0,2,8,14,4,3,-1,8,15,4,1,3,-0.003627727972343564,0.6219773292541504,0.4476661086082459,0,2,3,12,2,3,-1,3,13,2,1,3,-0.005353075917810202,0.1837355047464371,0.5102208256721497,0,2,5,6,12,7,-1,9,6,4,7,3,0.1453091949224472,0.5145987272262573,0.1535930931568146,0,2,0,2,3,6,-1,0,4,3,2,3,0.0024394490756094456,0.5343660116195679,0.3624661862850189,0,2,14,6,1,3,-1,14,7,1,1,3,-0.003128339070826769,0.6215007901191711,0.4845592081546783,0,2,2,0,3,14,-1,3,0,1,14,3,0.0017940260004252195,0.4299261868000031,0.5824198126792908,0,2,12,14,5,6,-1,12,16,5,2,3,0.0362538211047649,0.5260334014892578,0.1439467966556549,0,2,4,14,5,6,-1,4,16,5,2,3,-0.005174672231078148,0.350653886795044,0.5287045240402222,0,3,11,10,2,2,-1,12,10,1,1,2,11,11,1,1,2,0.0006538329762406647,0.4809640944004059,0.6122040152549744,0,2,5,0,3,14,-1,6,0,1,14,3,-0.0264802295714617,0.1139362007379532,0.5045586228370667,0,2,10,15,2,3,-1,10,16,2,1,3,-0.0030440660193562508,0.6352095007896423,0.4794734120368958,0,2,0,2,2,3,-1,0,3,2,1,3,0.0036993520334362984,0.5131118297576904,0.2498510926961899,0,2,5,11,12,6,-1,5,14,12,3,2,-0.0003676293126773089,0.54213947057724,0.3709532022476196,0,2,6,11,3,9,-1,6,14,3,3,3,-0.041382260620594,0.1894959956407547,0.5081691741943359,0,3,11,10,2,2,-1,12,10,1,1,2,11,11,1,1,2,-0.0010532729793339968,0.645436704158783,0.4783608913421631,0,2,5,6,1,3,-1,5,7,1,1,3,-0.0021648600231856108,0.6215031147003174,0.449982613325119,0,2,4,9,13,3,-1,4,10,13,1,3,-0.0005674774874933064,0.3712610900402069,0.5419334769248962,0,2,1,7,15,6,-1,6,7,5,6,3,0.173758402466774,0.5023643970489502,0.1215742006897926,0,2,4,5,12,6,-1,8,5,4,6,3,-0.0029049699660390615,0.3240267932415009,0.5381883978843689,0,2,8,10,4,3,-1,8,11,4,1,3,0.0012299539521336555,0.4165507853031158,0.5703486204147339,0,2,15,14,1,3,-1,15,15,1,1,3,-0.0005432923790067434,0.3854042887687683,0.554754912853241,0,2,1,11,5,3,-1,1,12,5,1,3,-0.008329725824296474,0.2204494029283524,0.5097082853317261,0,2,7,1,7,12,-1,7,7,7,6,2,-0.00010417630255687982,0.560706615447998,0.4303036034107208,0,3,0,1,6,10,-1,0,1,3,5,2,3,6,3,5,2,0.0312047004699707,0.4621657133102417,0.6982004046440125,0,2,16,1,4,3,-1,16,2,4,1,3,0.007894350215792656,0.5269594192504883,0.226906806230545,0,2,5,5,2,3,-1,5,6,2,1,3,-0.004364531021565199,0.6359223127365112,0.4537956118583679,0,2,12,2,3,5,-1,13,2,1,5,3,0.007679305970668793,0.5274767875671387,0.274048388004303,0,2,0,3,4,6,-1,0,5,4,2,3,-0.0254311393946409,0.2038519978523254,0.5071732997894287,0,2,8,12,4,2,-1,8,13,4,1,2,0.0008200060110539198,0.4587455093860626,0.6119868159294128,0,2,8,18,3,1,-1,9,18,1,1,3,0.002928460016846657,0.5071274042129517,0.2028204947710037,0,3,11,10,2,2,-1,12,10,1,1,2,11,11,1,1,2,0.00004525647091213614,0.4812104105949402,0.5430821776390076,0,3,7,10,2,2,-1,7,10,1,1,2,8,11,1,1,2,0.0013158309739083052,0.4625813961029053,0.6779323220252991,0,2,11,11,4,4,-1,11,13,4,2,2,0.0015870389761403203,0.5386291742324829,0.3431465029716492,0,2,8,12,3,8,-1,9,12,1,8,3,-0.0215396601706743,0.025942500680685,0.5003222823143005,0,2,13,0,6,3,-1,13,1,6,1,3,0.014334480278194,0.5202844738960266,0.1590632945299149,0,2,8,8,3,4,-1,9,8,1,4,3,-0.008388138376176357,0.728248119354248,0.4648044109344482,0,3,5,7,10,10,-1,10,7,5,5,2,5,12,5,5,2,0.00919068418443203,0.556235671043396,0.3923191130161285,0,3,3,18,8,2,-1,3,18,4,1,2,7,19,4,1,2,-0.005845305975526571,0.6803392767906189,0.4629127979278565,0,2,10,2,6,8,-1,12,2,2,8,3,-0.0547077991068363,0.2561671137809753,0.5206125974655151,0,2,4,2,6,8,-1,6,2,2,8,3,0.009114277549088001,0.518962025642395,0.3053877055644989,0,2,11,0,3,7,-1,12,0,1,7,3,-0.0155750000849366,0.1295074969530106,0.5169094800949097,0,2,7,11,2,1,-1,8,11,1,1,2,-0.0001205060034408234,0.5735098123550415,0.4230825006961823,0,2,15,14,1,3,-1,15,15,1,1,3,0.0012273970060050488,0.5289878249168396,0.4079791903495789,0,3,7,15,2,2,-1,7,15,1,1,2,8,16,1,1,2,-0.0012186600361019373,0.6575639843940735,0.4574409127235413,0,2,15,14,1,3,-1,15,15,1,1,3,-0.0033256649039685726,0.3628047108650208,0.5195019841194153,0,2,6,0,3,7,-1,7,0,1,7,3,-0.0132883097976446,0.1284265965223312,0.504348874092102,0,2,18,1,2,7,-1,18,1,1,7,2,-0.0033839771058410406,0.6292240023612976,0.475750595331192,0,2,2,0,8,20,-1,2,10,8,10,2,-0.2195422053337097,0.148773193359375,0.5065013766288757,0,2,3,0,15,6,-1,3,2,15,2,3,0.004911170806735754,0.425610214471817,0.5665838718414307,0,2,4,3,12,2,-1,4,4,12,1,2,-0.00018744950648397207,0.4004144072532654,0.5586857199668884,0,2,16,0,4,5,-1,16,0,2,5,2,-0.00521786417812109,0.6009116172790527,0.4812706112861633,0,2,7,0,3,4,-1,8,0,1,4,3,-0.0011111519997939467,0.3514933884143829,0.5287089943885803,0,2,16,0,4,5,-1,16,0,2,5,2,0.004403640050441027,0.4642275869846344,0.5924085974693298,0,2,1,7,6,13,-1,3,7,2,13,3,0.1229949966073036,0.5025529265403748,0.0691524818539619,0,2,16,0,4,5,-1,16,0,2,5,2,-0.0123135102912784,0.5884591937065125,0.4934012889862061,0,2,0,0,4,5,-1,2,0,2,5,2,0.004147103987634182,0.4372239112854004,0.589347779750824,0,2,14,12,3,6,-1,14,14,3,2,3,-0.003550264984369278,0.4327551126480103,0.5396270155906677,0,2,3,12,3,6,-1,3,14,3,2,3,-0.0192242693156004,0.1913134008646011,0.5068330764770508,0,2,16,1,4,3,-1,16,2,4,1,3,0.0014395059552043676,0.5308178067207336,0.424353301525116,0,3,8,7,2,10,-1,8,7,1,5,2,9,12,1,5,2,-0.00677519990131259,0.6365395784378052,0.4540086090564728,0,2,11,11,4,4,-1,11,13,4,2,2,0.007011963054537773,0.5189834237098694,0.302619993686676,0,2,0,1,4,3,-1,0,2,4,1,3,0.005401465110480785,0.5105062127113342,0.2557682991027832,0,2,13,4,1,3,-1,13,5,1,1,3,0.0009027498890645802,0.4696914851665497,0.5861827731132507,0,2,7,15,3,5,-1,8,15,1,5,3,0.0114744501188397,0.5053645968437195,0.152717798948288,0,2,9,7,3,5,-1,10,7,1,5,3,-0.006702343001961708,0.6508980989456177,0.4890604019165039,0,2,8,7,3,5,-1,9,7,1,5,3,-0.0020462959073483944,0.6241816878318787,0.4514600038528442,0,2,10,6,4,14,-1,10,6,2,14,2,-0.009995156899094582,0.3432781100273132,0.5400953888893127,0,2,0,5,5,6,-1,0,7,5,2,3,-0.0357007086277008,0.1878059059381485,0.5074077844619751,0,2,9,5,6,4,-1,9,5,3,4,2,0.0004558456130325794,0.3805277049541473,0.5402569770812988,0,2,0,0,18,10,-1,6,0,6,10,3,-0.0542606003582478,0.6843714714050293,0.4595097005367279,0,2,10,6,4,14,-1,10,6,2,14,2,0.0060600461438298225,0.5502905249595642,0.450052797794342,0,2,6,6,4,14,-1,8,6,2,14,2,-0.006479183211922646,0.3368858098983765,0.5310757160186768,0,2,13,4,1,3,-1,13,5,1,1,3,-0.0014939469983801246,0.6487640142440796,0.4756175875663757,0,2,5,1,2,3,-1,6,1,1,3,2,0.000014610530342906713,0.403457909822464,0.5451064109802246,0,3,18,1,2,18,-1,19,1,1,9,2,18,10,1,9,2,-0.00723219383507967,0.6386873722076416,0.4824739992618561,0,2,2,1,4,3,-1,2,2,4,1,3,-0.004064581822603941,0.2986421883106232,0.5157335996627808,0,3,18,1,2,18,-1,19,1,1,9,2,18,10,1,9,2,0.0304630808532238,0.5022199749946594,0.7159956097602844,0,3,1,14,4,6,-1,1,14,2,3,2,3,17,2,3,2,-0.008054491132497787,0.6492452025413513,0.4619275033473969,0,2,10,11,7,6,-1,10,13,7,2,3,0.0395051389932632,0.5150570869445801,0.2450613975524902,0,3,0,10,6,10,-1,0,10,3,5,2,3,15,3,5,2,0.008453020825982094,0.4573669135570526,0.6394037008285522,0,2,11,0,3,4,-1,12,0,1,4,3,-0.0011688120430335402,0.3865512013435364,0.548366129398346,0,2,5,10,5,6,-1,5,13,5,3,2,0.002807067008689046,0.5128579139709473,0.2701480090618134,0,2,14,6,1,8,-1,14,10,1,4,2,0.000473652093205601,0.4051581919193268,0.5387461185455322,0,3,1,7,18,6,-1,1,7,9,3,2,10,10,9,3,2,0.0117410803213716,0.5295950174331665,0.3719413876533508,0,2,9,7,2,2,-1,9,7,1,2,2,0.0031833238899707794,0.4789406955242157,0.6895126104354858,0,2,5,9,4,5,-1,7,9,2,5,2,0.0007024150108918548,0.5384489297866821,0.3918080925941467,50.16973114013672,102,0,2,7,6,6,3,-1,9,6,2,3,3,0.0170599296689034,0.3948527872562408,0.7142534852027893,0,2,1,0,18,4,-1,7,0,6,4,3,0.0218408405780792,0.3370316028594971,0.6090016961097717,0,2,7,15,2,4,-1,7,17,2,2,2,0.00024520049919374287,0.3500576019287109,0.5987902283668518,0,2,1,0,19,9,-1,1,3,19,3,3,0.008327260613441467,0.3267528116703033,0.5697240829467773,0,2,3,7,3,6,-1,3,9,3,2,3,0.0005714829894714057,0.3044599890708923,0.5531656742095947,0,3,13,7,4,4,-1,15,7,2,2,2,13,9,2,2,2,0.0006737398798577487,0.3650012016296387,0.567263126373291,0,3,3,7,4,4,-1,3,7,2,2,2,5,9,2,2,2,0.00003468159047770314,0.3313541114330292,0.5388727188110352,0,2,9,6,10,8,-1,9,10,10,4,2,-0.005856339819729328,0.2697942852973938,0.5498778820037842,0,2,3,8,14,12,-1,3,14,14,6,2,0.00851022731512785,0.5269358158111572,0.2762879133224487,0,3,6,5,10,12,-1,11,5,5,6,2,6,11,5,6,2,-0.0698172077536583,0.2909603118896484,0.5259246826171875,0,2,9,11,2,3,-1,9,12,2,1,3,-0.0008611367084085941,0.5892577171325684,0.4073697924613953,0,2,9,5,6,5,-1,9,5,3,5,2,0.0009714924963191152,0.3523564040660858,0.5415862202644348,0,2,9,4,2,4,-1,9,6,2,2,2,-0.00001472749045206001,0.5423017740249634,0.3503156006336212,0,2,9,5,6,5,-1,9,5,3,5,2,0.0484202913939953,0.51939457654953,0.3411195874214172,0,2,5,5,6,5,-1,8,5,3,5,2,0.0013257140526548028,0.315776914358139,0.5335376262664795,0,2,11,2,6,1,-1,13,2,2,1,3,0.00001492214960308047,0.4451299905776978,0.5536553859710693,0,2,3,2,6,1,-1,5,2,2,1,3,-0.002717339899390936,0.3031741976737976,0.5248088836669922,0,2,13,5,2,3,-1,13,6,2,1,3,0.0029219500720500946,0.4781453013420105,0.6606041789054871,0,2,0,10,1,4,-1,0,12,1,2,2,-0.0019804988987743855,0.3186308145523071,0.5287625193595886,0,2,13,5,2,3,-1,13,6,2,1,3,-0.004001210909336805,0.6413596868515015,0.4749928116798401,0,2,8,18,3,2,-1,9,18,1,2,3,-0.004349199123680592,0.1507498025894165,0.5098996758460999,0,2,6,15,9,2,-1,6,16,9,1,2,0.0013490889687091112,0.4316158890724182,0.5881167054176331,0,2,8,14,4,3,-1,8,15,4,1,3,0.0185970701277256,0.4735553860664368,0.9089794158935547,0,2,18,4,2,4,-1,18,6,2,2,2,-0.001856237999163568,0.3553189039230347,0.5577837228775024,0,2,5,5,2,3,-1,5,6,2,1,3,0.002294043079018593,0.4500094950199127,0.6580877900123596,0,2,15,16,3,2,-1,15,17,3,1,2,0.00029982850537635386,0.5629242062568665,0.3975878953933716,0,2,0,0,3,9,-1,0,3,3,3,3,0.0035455459728837013,0.5381547212600708,0.3605485856533051,0,2,9,7,3,3,-1,9,8,3,1,3,0.009610472247004509,0.5255997180938721,0.1796745955944061,0,2,8,7,3,3,-1,8,8,3,1,3,-0.0062783220782876015,0.227285698056221,0.5114030241966248,0,2,9,5,2,6,-1,9,5,1,6,2,0.0034598479978740215,0.4626308083534241,0.6608219146728516,0,2,8,6,3,4,-1,9,6,1,4,3,-0.0013112019514665008,0.6317539811134338,0.4436857998371124,0,3,7,6,8,12,-1,11,6,4,6,2,7,12,4,6,2,0.002687617903575301,0.5421109795570374,0.4054022133350372,0,3,5,6,8,12,-1,5,6,4,6,2,9,12,4,6,2,0.003911816980689764,0.5358477830886841,0.3273454904556274,0,2,12,4,3,3,-1,12,5,3,1,3,-0.014206450432539,0.7793576717376709,0.4975781142711639,0,2,2,16,3,2,-1,2,17,3,1,2,0.0007170552853494883,0.5297319889068604,0.3560903966426849,0,2,12,4,3,3,-1,12,5,3,1,3,0.001663501956500113,0.467809408903122,0.5816481709480286,0,2,2,12,6,6,-1,2,14,6,2,3,0.0033686188980937004,0.5276734232902527,0.3446420133113861,0,2,7,13,6,3,-1,7,14,6,1,3,0.0127995302900672,0.4834679961204529,0.7472159266471863,0,2,6,14,6,3,-1,6,15,6,1,3,0.0033901201095432043,0.4511859118938446,0.6401721239089966,0,2,14,15,5,3,-1,14,16,5,1,3,0.004707077983766794,0.533565878868103,0.355522096157074,0,2,5,4,3,3,-1,5,5,3,1,3,0.0014819339849054813,0.4250707030296326,0.5772724151611328,0,2,14,15,5,3,-1,14,16,5,1,3,-0.0069995759986341,0.3003320097923279,0.5292900204658508,0,2,5,3,6,2,-1,7,3,2,2,3,0.0159390103071928,0.5067319273948669,0.1675581932067871,0,2,8,15,4,3,-1,8,16,4,1,3,0.007637734990566969,0.4795069992542267,0.7085601091384888,0,2,1,15,5,3,-1,1,16,5,1,3,0.006733404006808996,0.5133113265037537,0.2162470072507858,0,3,8,13,4,6,-1,10,13,2,3,2,8,16,2,3,2,-0.012858809903264,0.1938841938972473,0.525137186050415,0,2,7,8,3,3,-1,8,8,1,3,3,-0.0006227080011740327,0.5686538219451904,0.419786810874939,0,2,12,0,5,4,-1,12,2,5,2,2,-0.0005265168147161603,0.4224168956279755,0.5429695844650269,0,3,0,2,20,2,-1,0,2,10,1,2,10,3,10,1,2,0.0110750999301672,0.5113775134086609,0.2514517903327942,0,2,1,0,18,4,-1,7,0,6,4,3,-0.0367282517254353,0.7194662094116211,0.4849618971347809,0,2,4,3,6,1,-1,6,3,2,1,3,-0.00028207109426148236,0.3840261995792389,0.539444625377655,0,2,4,18,13,2,-1,4,19,13,1,2,-0.0027489690110087395,0.593708872795105,0.4569182097911835,0,2,2,10,3,6,-1,2,12,3,2,3,0.0100475195795298,0.5138576030731201,0.2802298069000244,0,3,14,12,6,8,-1,17,12,3,4,2,14,16,3,4,2,-0.008149784058332443,0.6090037226676941,0.4636121094226837,0,3,4,13,10,6,-1,4,13,5,3,2,9,16,5,3,2,-0.006883388850837946,0.3458611071109772,0.5254660248756409,0,2,14,12,1,2,-1,14,13,1,1,2,-0.0000140393603942357,0.5693104267120361,0.4082083106040955,0,2,8,13,4,3,-1,8,14,4,1,3,0.001549841952510178,0.4350537061691284,0.5806517004966736,0,2,14,12,2,2,-1,14,13,2,1,2,-0.006784149911254644,0.1468873023986816,0.5182775259017944,0,2,4,12,2,2,-1,4,13,2,1,2,0.00021705629478674382,0.5293524265289307,0.345617413520813,0,2,8,12,9,2,-1,8,13,9,1,2,0.00031198898795992136,0.4652450978755951,0.5942413806915283,0,2,9,14,2,3,-1,9,15,2,1,3,0.005450753029435873,0.4653508961200714,0.7024846076965332,0,2,11,10,3,6,-1,11,13,3,3,2,-0.00025818689027801156,0.5497295260429382,0.3768967092037201,0,2,5,6,9,12,-1,5,12,9,6,2,-0.0174425393342972,0.3919087946414948,0.5457497835159302,0,2,11,10,3,6,-1,11,13,3,3,2,-0.045343529433012,0.1631357073783875,0.5154908895492554,0,2,6,10,3,6,-1,6,13,3,3,2,0.0019190689781680703,0.514589786529541,0.2791895866394043,0,2,5,4,11,3,-1,5,5,11,1,3,-0.006017786916345358,0.6517636179924011,0.4756332933902741,0,2,7,1,5,10,-1,7,6,5,5,2,-0.004072073847055435,0.5514652729034424,0.4092685878276825,0,2,2,8,18,2,-1,2,9,18,1,2,0.00039855059003457427,0.316524088382721,0.5285550951957703,0,2,7,17,5,3,-1,7,18,5,1,3,-0.0065418570302426815,0.6853377819061279,0.4652808904647827,0,2,5,9,12,1,-1,9,9,4,1,3,0.003484508953988552,0.5484588146209717,0.4502759873867035,0,3,0,14,6,6,-1,0,14,3,3,2,3,17,3,3,2,-0.0136967804282904,0.6395779848098755,0.4572555124759674,0,2,5,9,12,1,-1,9,9,4,1,3,-0.017347140237689,0.2751072943210602,0.5181614756584167,0,2,3,9,12,1,-1,7,9,4,1,3,-0.004088542889803648,0.3325636088848114,0.5194984078407288,0,2,14,10,6,7,-1,14,10,3,7,2,-0.009468790143728256,0.5942280888557434,0.485181987285614,0,2,1,0,16,2,-1,1,1,16,1,2,0.0017084840219467878,0.4167110919952393,0.5519806146621704,0,2,10,9,10,9,-1,10,12,10,3,3,0.009480909444391727,0.5433894991874695,0.4208514988422394,0,2,0,1,10,2,-1,5,1,5,2,2,-0.004738965071737766,0.6407189965248108,0.4560655057430267,0,2,17,3,2,3,-1,17,4,2,1,3,0.006576105020940304,0.5214555263519287,0.2258227020502091,0,2,1,3,2,3,-1,1,4,2,1,3,-0.0021690549328923225,0.3151527941226959,0.5156704783439636,0,2,9,7,3,6,-1,10,7,1,6,3,0.014660170301795,0.4870837032794952,0.668994128704071,0,2,6,5,4,3,-1,8,5,2,3,2,0.00017231999663636088,0.3569748997688294,0.5251078009605408,0,2,7,5,6,6,-1,9,5,2,6,3,-0.0218037609010935,0.8825920820236206,0.496632993221283,0,3,3,4,12,12,-1,3,4,6,6,2,9,10,6,6,2,-0.0947361066937447,0.1446162015199661,0.5061113834381104,0,2,9,2,6,15,-1,11,2,2,15,3,0.0055825551971793175,0.5396478772163391,0.4238066077232361,0,2,2,2,6,17,-1,4,2,2,17,3,0.001951709040440619,0.4170410931110382,0.5497786998748779,0,2,14,10,6,7,-1,14,10,3,7,2,0.0121499001979828,0.4698367118835449,0.5664274096488953,0,2,0,10,6,7,-1,3,10,3,7,2,-0.007516962010413408,0.6267772912979126,0.4463135898113251,0,2,9,2,6,15,-1,11,2,2,15,3,-0.0716679096221924,0.3097011148929596,0.5221003293991089,0,2,5,2,6,15,-1,7,2,2,15,3,-0.0882924199104309,0.0811238884925842,0.5006365180015564,0,2,17,9,3,6,-1,17,11,3,2,3,0.0310630798339844,0.5155503749847412,0.1282255947589874,0,2,6,7,6,6,-1,8,7,2,6,3,0.0466218404471874,0.4699777960777283,0.736396074295044,0,3,1,10,18,6,-1,10,10,9,3,2,1,13,9,3,2,-0.0121894897893071,0.3920530080795288,0.5518996715545654,0,2,0,9,10,9,-1,0,12,10,3,3,0.0130161102861166,0.5260658264160156,0.3685136139392853,0,2,8,15,4,3,-1,8,16,4,1,3,-0.003495289944112301,0.6339294910430908,0.4716280996799469,0,2,5,12,3,4,-1,5,14,3,2,2,-0.00004401503974804655,0.5333027243614197,0.3776184916496277,0,2,3,3,16,12,-1,3,9,16,6,2,-0.1096649020910263,0.1765342056751251,0.5198346972465515,0,3,1,1,12,12,-1,1,1,6,6,2,7,7,6,6,2,-0.0009027955820783973,0.5324159860610962,0.3838908076286316,0,3,10,4,2,4,-1,11,4,1,2,2,10,6,1,2,2,0.0007112664170563221,0.4647929966449738,0.5755224227905273,0,3,0,9,10,2,-1,0,9,5,1,2,5,10,5,1,2,-0.003125027986243367,0.323670893907547,0.5166770815849304,0,2,9,11,3,3,-1,9,12,3,1,3,0.002414467977359891,0.4787439107894898,0.6459717750549316,0,2,3,12,9,2,-1,3,13,9,1,2,0.00044391240226104856,0.4409308135509491,0.6010255813598633,0,2,9,9,2,2,-1,9,10,2,1,2,-0.0002261118934256956,0.4038113951683044,0.5493255853652954,66.66912078857422,135,0,2,3,4,13,6,-1,3,6,13,2,3,-0.0469012893736362,0.660017192363739,0.3743801116943359,0,3,9,7,6,4,-1,12,7,3,2,2,9,9,3,2,2,-0.001456834957934916,0.578399121761322,0.3437797129154205,0,2,1,0,6,8,-1,4,0,3,8,2,0.005559836979955435,0.3622266948223114,0.5908216238021851,0,2,9,5,2,12,-1,9,11,2,6,2,0.0007317048730328679,0.550041913986206,0.2873558104038239,0,2,4,4,3,10,-1,4,9,3,5,2,0.001331800944171846,0.267316997051239,0.5431019067764282,0,2,6,17,8,3,-1,6,18,8,1,3,0.00024347059661522508,0.3855027854442596,0.574138879776001,0,2,0,5,10,6,-1,0,7,10,2,3,-0.0030512469820678234,0.5503209829330444,0.3462845087051392,0,2,13,2,3,2,-1,13,3,3,1,2,-0.0006865719915367663,0.3291221857070923,0.5429509282112122,0,2,7,5,4,5,-1,9,5,2,5,2,0.001466820016503334,0.3588382005691528,0.5351811051368713,0,2,12,14,3,6,-1,12,16,3,2,3,0.0003202187072020024,0.429684191942215,0.5700234174728394,0,2,1,11,8,2,-1,1,12,8,1,2,0.0007412218837998807,0.5282164812088013,0.3366870880126953,0,2,7,13,6,3,-1,7,14,6,1,3,0.0038330298848450184,0.4559567868709564,0.6257336139678955,0,2,0,5,3,6,-1,0,7,3,2,3,-0.0154564399272203,0.2350116968154907,0.512945294380188,0,2,13,2,3,2,-1,13,3,3,1,2,0.002679677912965417,0.5329415202140808,0.4155062139034271,0,3,4,14,4,6,-1,4,14,2,3,2,6,17,2,3,2,0.0028296569362282753,0.4273087978363037,0.5804538130760193,0,2,13,2,3,2,-1,13,3,3,1,2,-0.0039444249123334885,0.2912611961364746,0.5202686190605164,0,2,8,2,4,12,-1,8,6,4,4,3,0.002717955969274044,0.5307688117027283,0.3585677146911621,0,3,14,0,6,8,-1,17,0,3,4,2,14,4,3,4,2,0.005907762795686722,0.470377504825592,0.5941585898399353,0,2,7,17,3,2,-1,8,17,1,2,3,-0.004224034957587719,0.2141567021608353,0.5088796019554138,0,2,8,12,4,2,-1,8,13,4,1,2,0.0040725888684391975,0.4766413867473602,0.6841061115264893,0,3,6,0,8,12,-1,6,0,4,6,2,10,6,4,6,2,0.0101495301350951,0.5360798835754395,0.3748497068881989,0,3,14,0,2,10,-1,15,0,1,5,2,14,5,1,5,2,-0.00018864999583456665,0.5720130205154419,0.3853805065155029,0,3,5,3,8,6,-1,5,3,4,3,2,9,6,4,3,2,-0.0048864358104765415,0.3693122863769531,0.5340958833694458,0,3,14,0,6,10,-1,17,0,3,5,2,14,5,3,5,2,0.0261584799736738,0.4962374866008759,0.6059989929199219,0,2,9,14,1,2,-1,9,15,1,1,2,0.0004856075975112617,0.4438945949077606,0.6012468934059143,0,2,15,10,4,3,-1,15,11,4,1,3,0.0112687097862363,0.5244250297546387,0.1840388029813767,0,2,8,14,2,3,-1,8,15,2,1,3,-0.0028114619199186563,0.6060283780097961,0.4409897029399872,0,3,3,13,14,4,-1,10,13,7,2,2,3,15,7,2,2,-0.005611272994428873,0.3891170918941498,0.5589237213134766,0,2,1,10,4,3,-1,1,11,4,1,3,0.008568009361624718,0.5069345831871033,0.2062619030475617,0,2,9,11,6,1,-1,11,11,2,1,3,-0.00038172779022715986,0.5882201790809631,0.41926109790802,0,2,5,11,6,1,-1,7,11,2,1,3,-0.00017680290329735726,0.5533605813980103,0.400336891412735,0,2,3,5,16,15,-1,3,10,16,5,3,0.006511253770440817,0.3310146927833557,0.5444191098213196,0,2,6,12,4,2,-1,8,12,2,2,2,-0.00006594868318643421,0.5433831810951233,0.3944905996322632,0,3,4,4,12,10,-1,10,4,6,5,2,4,9,6,5,2,0.006993905175477266,0.5600358247756958,0.4192714095115662,0,2,8,6,3,4,-1,9,6,1,4,3,-0.0046744439750909805,0.6685466766357422,0.4604960978031158,0,3,8,12,4,8,-1,10,12,2,4,2,8,16,2,4,2,0.0115898502990603,0.5357121229171753,0.2926830053329468,0,2,8,14,4,3,-1,8,15,4,1,3,0.013007840141654,0.4679817855358124,0.730746328830719,0,2,12,2,3,2,-1,13,2,1,2,3,-0.0011008579749614,0.3937501013278961,0.5415065288543701,0,2,8,15,3,2,-1,8,16,3,1,2,0.0006047264905646443,0.4242376089096069,0.5604041218757629,0,2,6,0,9,14,-1,9,0,3,14,3,-0.0144948400557041,0.3631210029125214,0.5293182730674744,0,2,9,6,2,3,-1,10,6,1,3,2,-0.005305694881826639,0.686045229434967,0.4621821045875549,0,2,10,8,2,3,-1,10,9,2,1,3,-0.00081829127157107,0.3944096863269806,0.542043924331665,0,2,0,9,4,6,-1,0,11,4,2,3,-0.0190775208175182,0.1962621957063675,0.5037891864776611,0,2,6,0,8,2,-1,6,1,8,1,2,0.00035549470339901745,0.4086259007453919,0.5613973140716553,0,2,6,14,7,3,-1,6,15,7,1,3,0.0019679730758070946,0.448912113904953,0.5926123261451721,0,2,8,10,8,9,-1,8,13,8,3,3,0.006918914150446653,0.5335925817489624,0.3728385865688324,0,2,5,2,3,2,-1,6,2,1,2,3,0.002987277926877141,0.5111321210861206,0.2975643873214722,0,3,14,1,6,8,-1,17,1,3,4,2,14,5,3,4,2,-0.006226461846381426,0.5541489720344543,0.4824537932872772,0,3,0,1,6,8,-1,0,1,3,4,2,3,5,3,4,2,0.013353300280869,0.4586423933506012,0.6414797902107239,0,3,1,2,18,6,-1,10,2,9,3,2,1,5,9,3,2,0.0335052385926247,0.5392425060272217,0.3429994881153107,0,2,9,3,2,1,-1,10,3,1,1,2,-0.0025294460356235504,0.1703713983297348,0.5013315081596375,0,3,13,2,4,6,-1,15,2,2,3,2,13,5,2,3,2,-0.001280162949115038,0.5305461883544922,0.4697405099868774,0,2,5,4,3,3,-1,5,5,3,1,3,0.007068738806992769,0.4615545868873596,0.643650472164154,0,2,13,5,1,3,-1,13,6,1,1,3,0.0009688049904070795,0.4833599030971527,0.6043894290924072,0,2,2,16,5,3,-1,2,17,5,1,3,0.003964765928685665,0.5187637209892273,0.323181688785553,0,3,13,2,4,6,-1,15,2,2,3,2,13,5,2,3,2,-0.022057730704546,0.4079256951808929,0.520098090171814,0,3,3,2,4,6,-1,3,2,2,3,2,5,5,2,3,2,-0.0006690631271339953,0.533160924911499,0.3815600872039795,0,2,13,5,1,2,-1,13,6,1,1,2,-0.0006700932863168418,0.5655422210693359,0.4688901901245117,0,2,5,5,2,2,-1,5,6,2,1,2,0.000742845528293401,0.4534381031990051,0.6287400126457214,0,2,13,9,2,2,-1,13,9,1,2,2,0.0022227810695767403,0.5350633263587952,0.3303655982017517,0,2,5,9,2,2,-1,6,9,1,2,2,-0.005413052160292864,0.1113687008619309,0.500543475151062,0,2,13,17,3,2,-1,13,18,3,1,2,-0.000014520040167553816,0.5628737807273865,0.4325133860111237,0,3,6,16,4,4,-1,6,16,2,2,2,8,18,2,2,2,0.00023369169502984732,0.4165835082530975,0.5447791218757629,0,2,9,16,2,3,-1,9,17,2,1,3,0.004289454780519009,0.4860391020774841,0.6778649091720581,0,2,0,13,9,6,-1,0,15,9,2,3,0.0059103150852024555,0.52623051404953,0.3612113893032074,0,2,9,14,2,6,-1,9,17,2,3,2,0.0129005396738648,0.5319377183914185,0.32502880692482,0,2,9,15,2,3,-1,9,16,2,1,3,0.004698297940194607,0.461824506521225,0.6665925979614258,0,2,1,10,18,6,-1,1,12,18,2,3,0.0104398597031832,0.550567090511322,0.3883604109287262,0,2,8,11,4,2,-1,8,12,4,1,2,0.0030443191062659025,0.4697853028774262,0.7301844954490662,0,2,7,9,6,2,-1,7,10,6,1,2,-0.0006159375188872218,0.3830839097499847,0.5464984178543091,0,2,8,8,2,3,-1,8,9,2,1,3,-0.0034247159492224455,0.256630003452301,0.5089530944824219,0,2,17,5,3,4,-1,18,5,1,4,3,-0.009353856556117535,0.6469966173171997,0.49407958984375,0,2,1,19,18,1,-1,7,19,6,1,3,0.0523389987647533,0.4745982885360718,0.787877082824707,0,2,9,0,3,2,-1,10,0,1,2,3,0.0035765620414167643,0.5306664705276489,0.2748498022556305,0,2,1,8,1,6,-1,1,10,1,2,3,0.0007155531784519553,0.541312575340271,0.4041908979415894,0,2,12,17,8,3,-1,12,17,4,3,2,-0.0105166798457503,0.6158512234687805,0.4815283119678497,0,2,0,5,3,4,-1,1,5,1,4,3,0.007734792772680521,0.4695805907249451,0.7028980851173401,0,2,9,7,2,3,-1,9,8,2,1,3,-0.004322677850723267,0.2849566042423248,0.5304684042930603,0,3,7,11,2,2,-1,7,11,1,1,2,8,12,1,1,2,-0.0025534399319440126,0.7056984901428223,0.4688892066478729,0,2,11,3,2,5,-1,11,3,1,5,2,0.00010268510231981054,0.3902932107448578,0.5573464035987854,0,2,7,3,2,5,-1,8,3,1,5,2,0.000007139518857002258,0.368423193693161,0.526398777961731,0,2,15,13,2,3,-1,15,14,2,1,3,-0.0016711989883333445,0.3849175870418549,0.5387271046638489,0,2,5,6,2,3,-1,5,7,2,1,3,0.004926044959574938,0.4729771912097931,0.7447251081466675,0,2,4,19,15,1,-1,9,19,5,1,3,0.0043908702209591866,0.4809181094169617,0.5591921806335449,0,2,1,19,15,1,-1,6,19,5,1,3,-0.0177936293184757,0.6903678178787231,0.4676927030086517,0,2,15,13,2,3,-1,15,14,2,1,3,0.002046966925263405,0.5370690226554871,0.3308162093162537,0,2,5,0,4,15,-1,7,0,2,15,2,0.0298914890736341,0.5139865279197693,0.3309059143066406,0,2,9,6,2,5,-1,9,6,1,5,2,0.0015494900289922953,0.466023713350296,0.6078342795372009,0,2,9,5,2,7,-1,10,5,1,7,2,0.001495696953497827,0.4404835999011993,0.5863919854164124,0,2,16,11,3,3,-1,16,12,3,1,3,0.0009588592802174389,0.5435971021652222,0.4208523035049439,0,2,1,11,3,3,-1,1,12,3,1,3,0.0004964370164088905,0.5370578169822693,0.4000622034072876,0,2,6,6,8,3,-1,6,7,8,1,3,-0.00272808107547462,0.5659412741661072,0.4259642958641052,0,2,0,15,6,2,-1,0,16,6,1,2,0.0023026480339467525,0.5161657929420471,0.3350869119167328,0,2,1,0,18,6,-1,7,0,6,6,3,0.2515163123607636,0.4869661927223206,0.714730978012085,0,2,6,0,3,4,-1,7,0,1,4,3,-0.004632802214473486,0.27274489402771,0.5083789825439453,0,3,14,10,4,10,-1,16,10,2,5,2,14,15,2,5,2,-0.0404344908893108,0.6851438879966736,0.5021767020225525,0,2,3,2,3,2,-1,4,2,1,2,3,0.000014972220014897175,0.428446501493454,0.5522555112838745,0,2,11,2,2,2,-1,11,3,2,1,2,-0.00024050309730228037,0.4226118922233582,0.5390074849128723,0,3,2,10,4,10,-1,2,10,2,5,2,4,15,2,5,2,0.0236578397452831,0.4744631946086884,0.7504366040229797,0,3,0,13,20,6,-1,10,13,10,3,2,0,16,10,3,2,-0.00814491044729948,0.424505889415741,0.5538362860679626,0,2,0,5,2,15,-1,1,5,1,15,2,-0.003699213033542037,0.5952357053756714,0.4529713094234467,0,3,1,7,18,4,-1,10,7,9,2,2,1,9,9,2,2,-0.0067718601785600185,0.4137794077396393,0.5473399758338928,0,2,0,0,2,17,-1,1,0,1,17,2,0.004266953095793724,0.4484114944934845,0.5797994136810303,0,3,2,6,16,6,-1,10,6,8,3,2,2,9,8,3,2,0.0017791989957913756,0.5624858736991882,0.4432444870471954,0,2,8,14,1,3,-1,8,15,1,1,3,0.0016774770338088274,0.4637751877307892,0.63642418384552,0,2,8,15,4,2,-1,8,16,4,1,2,0.0011732629500329494,0.4544503092765808,0.5914415717124939,0,3,5,2,8,2,-1,5,2,4,1,2,9,3,4,1,2,0.000869981711730361,0.5334752798080444,0.3885917961597443,0,2,6,11,8,6,-1,6,14,8,3,2,0.0007637834060005844,0.5398585200309753,0.374494194984436,0,2,9,13,2,2,-1,9,14,2,1,2,0.00015684569370932877,0.4317873120307922,0.5614616274833679,0,2,18,4,2,6,-1,18,6,2,2,3,-0.0215113703161478,0.1785925030708313,0.5185542702674866,0,2,9,12,2,2,-1,9,13,2,1,2,0.00013081369979772717,0.4342499077320099,0.5682849884033203,0,2,18,4,2,6,-1,18,6,2,2,3,0.021992040798068,0.5161716938018799,0.2379394024610519,0,2,9,13,1,3,-1,9,14,1,1,3,-0.0008013650076463819,0.598676323890686,0.4466426968574524,0,2,18,4,2,6,-1,18,6,2,2,3,-0.008273609913885593,0.410821795463562,0.5251057147979736,0,2,0,4,2,6,-1,0,6,2,2,3,0.0036831789184361696,0.5173814296722412,0.339751809835434,0,2,9,12,3,3,-1,9,13,3,1,3,-0.007952568121254444,0.6888983249664307,0.4845924079418182,0,2,3,13,2,3,-1,3,14,2,1,3,0.0015382299898192286,0.5178567171096802,0.3454113900661469,0,2,13,13,4,3,-1,13,14,4,1,3,-0.0140435304492712,0.1678421050310135,0.518866777420044,0,2,5,4,3,3,-1,5,5,3,1,3,0.0014315890148282051,0.436825692653656,0.5655773878097534,0,2,5,2,10,6,-1,5,4,10,2,3,-0.0340142287313938,0.7802296280860901,0.4959217011928558,0,2,3,13,4,3,-1,3,14,4,1,3,-0.0120272999629378,0.1585101038217545,0.503223180770874,0,2,3,7,15,5,-1,8,7,5,5,3,0.1331661939620972,0.5163304805755615,0.2755128145217896,0,2,3,7,12,2,-1,7,7,4,2,3,-0.0015221949433907866,0.372831791639328,0.5214552283287048,0,2,10,3,3,9,-1,11,3,1,9,3,-0.000939292716793716,0.5838379263877869,0.4511165022850037,0,2,8,6,4,6,-1,10,6,2,6,2,0.0277197398245335,0.4728286862373352,0.7331544756889343,0,2,9,7,4,3,-1,9,8,4,1,3,0.003103015013039112,0.5302202105522156,0.4101563096046448,0,2,0,9,4,9,-1,2,9,2,9,2,0.0778612196445465,0.4998334050178528,0.127296194434166,0,2,9,13,3,5,-1,10,13,1,5,3,-0.0158549398183823,0.0508333593606949,0.5165656208992004,0,2,7,7,6,3,-1,9,7,2,3,3,-0.00497253006324172,0.6798133850097656,0.4684231877326965,0,2,9,7,3,5,-1,10,7,1,5,3,-0.0009767650626599789,0.6010771989822388,0.4788931906223297,0,2,5,7,8,2,-1,9,7,4,2,2,-0.0024647710379213095,0.3393397927284241,0.5220503807067871,0,2,5,9,12,2,-1,9,9,4,2,3,-0.006793770007789135,0.4365136921405792,0.5239663124084473,0,2,5,6,10,3,-1,10,6,5,3,2,0.0326080210506916,0.505272388458252,0.2425214946269989,0,2,10,12,3,1,-1,11,12,1,1,3,-0.0005851442110724747,0.5733973979949951,0.4758574068546295,0,2,0,1,11,15,-1,0,6,11,5,3,-0.0296326000243425,0.3892289102077484,0.5263597965240479,67.69892120361328,137,0,2,1,0,18,6,-1,7,0,6,6,3,0.0465508513152599,0.3276950120925903,0.6240522861480713,0,2,7,7,6,1,-1,9,7,2,1,3,0.007953712716698647,0.4256485104560852,0.6942939162254333,0,3,5,16,6,4,-1,5,16,3,2,2,8,18,3,2,2,0.0006822156137786806,0.3711487054824829,0.59007328748703,0,2,6,5,9,8,-1,6,9,9,4,2,-0.00019348249770700932,0.2041133940219879,0.53005450963974,0,2,5,10,2,6,-1,5,13,2,3,2,-0.0002671050897333771,0.5416126251220703,0.3103179037570953,0,3,7,6,8,10,-1,11,6,4,5,2,7,11,4,5,2,0.0027818060480058193,0.5277832746505737,0.3467069864273071,0,3,5,6,8,10,-1,5,6,4,5,2,9,11,4,5,2,-0.000467790785478428,0.5308231115341187,0.3294492065906525,0,2,9,5,2,2,-1,9,6,2,1,2,-0.000030335160772665404,0.577387273311615,0.3852097094058991,0,2,5,12,8,2,-1,5,13,8,1,2,0.0007803800981491804,0.4317438900470734,0.6150057911872864,0,2,10,2,8,2,-1,10,3,8,1,2,-0.004255385138094425,0.2933903932571411,0.5324292778968811,0,3,4,0,2,10,-1,4,0,1,5,2,5,5,1,5,2,-0.0002473561035003513,0.5468844771385193,0.3843030035495758,0,2,9,10,2,2,-1,9,11,2,1,2,-0.00014724259381182492,0.4281542897224426,0.5755587220191956,0,2,2,8,15,3,-1,2,9,15,1,3,0.0011864770203828812,0.374730110168457,0.5471466183662415,0,2,8,13,4,3,-1,8,14,4,1,3,0.0023936580400913954,0.4537783861160278,0.6111528873443604,0,2,7,2,3,2,-1,8,2,1,2,3,-0.0015390539774671197,0.2971341907978058,0.518953800201416,0,2,7,13,6,3,-1,7,14,6,1,3,-0.007196879014372826,0.6699066758155823,0.4726476967334747,0,2,9,9,2,2,-1,9,10,2,1,2,-0.0004149978922214359,0.3384954035282135,0.5260317921638489,0,2,17,2,3,6,-1,17,4,3,2,3,0.004435983020812273,0.539912223815918,0.3920140862464905,0,2,1,5,3,4,-1,2,5,1,4,3,0.0026606200262904167,0.4482578039169312,0.6119617819786072,0,2,14,8,4,6,-1,14,10,4,2,3,-0.0015287200221791863,0.3711237907409668,0.5340266227722168,0,2,1,4,3,8,-1,2,4,1,8,3,-0.0047397250309586525,0.603108823299408,0.4455145001411438,0,2,8,13,4,6,-1,8,16,4,3,2,-0.0148291299119592,0.2838754057884216,0.5341861844062805,0,2,3,14,2,2,-1,3,15,2,1,2,0.0009227555710822344,0.5209547281265259,0.3361653983592987,0,2,14,8,4,6,-1,14,10,4,2,3,0.0835298076272011,0.5119969844818115,0.0811644494533539,0,2,2,8,4,6,-1,2,10,4,2,3,-0.0007563314866274595,0.331712007522583,0.5189831256866455,0,2,10,14,1,6,-1,10,17,1,3,2,0.009840385988354683,0.524759829044342,0.233495905995369,0,2,7,5,3,6,-1,8,5,1,6,3,-0.0015953830443322659,0.5750094056129456,0.4295622110366821,0,3,11,2,2,6,-1,12,2,1,3,2,11,5,1,3,2,0.000034766020689858124,0.4342445135116577,0.5564029216766357,0,2,6,6,6,5,-1,8,6,2,5,3,0.0298629105091095,0.4579147100448608,0.6579188108444214,0,2,17,1,3,6,-1,17,3,3,2,3,0.0113255903124809,0.5274311900138855,0.3673888146877289,0,2,8,7,3,5,-1,9,7,1,5,3,-0.008782864548265934,0.7100368738174438,0.4642167091369629,0,2,9,18,3,2,-1,10,18,1,2,3,0.004363995976746082,0.5279216170310974,0.2705877125263214,0,2,8,18,3,2,-1,9,18,1,2,3,0.004180472809821367,0.5072525143623352,0.2449083030223846,0,2,12,3,5,2,-1,12,4,5,1,2,-0.0004566851130221039,0.4283105134963989,0.5548691153526306,0,2,7,1,5,12,-1,7,7,5,6,2,-0.0037140368949621916,0.5519387722015381,0.4103653132915497,0,2,1,0,18,4,-1,7,0,6,4,3,-0.025304289534688,0.6867002248764038,0.48698890209198,0,2,4,2,2,2,-1,4,3,2,1,2,-0.0003445408074185252,0.3728874027729034,0.528769314289093,0,3,11,14,4,2,-1,13,14,2,1,2,11,15,2,1,2,-0.0008393523166887462,0.6060152053833008,0.4616062045097351,0,2,0,2,3,6,-1,0,4,3,2,3,0.0172800496220589,0.5049635767936707,0.1819823980331421,0,2,9,7,2,3,-1,9,8,2,1,3,-0.006359507795423269,0.1631239950656891,0.5232778787612915,0,2,5,5,1,3,-1,5,6,1,1,3,0.0010298109846189618,0.446327805519104,0.6176549196243286,0,2,10,10,6,1,-1,10,10,3,1,2,0.0010117109632119536,0.5473384857177734,0.4300698935985565,0,2,4,10,6,1,-1,7,10,3,1,2,-0.010308800265193,0.1166985034942627,0.5000867247581482,0,2,9,17,3,3,-1,9,18,3,1,3,0.005468201823532581,0.4769287109375,0.6719213724136353,0,2,4,14,1,3,-1,4,15,1,1,3,-0.0009169646073132753,0.3471089899539948,0.5178164839744568,0,2,12,5,3,3,-1,12,6,3,1,3,0.002392282010987401,0.4785236120223999,0.6216310858726501,0,2,4,5,12,3,-1,4,6,12,1,3,-0.007557381875813007,0.5814796090126038,0.4410085082054138,0,2,9,8,2,3,-1,9,9,2,1,3,-0.0007702403236180544,0.387800008058548,0.546572208404541,0,2,4,9,3,3,-1,5,9,1,3,3,-0.00871259905397892,0.1660051047801971,0.4995836019515991,0,2,6,0,9,17,-1,9,0,3,17,3,-0.0103063201531768,0.4093391001224518,0.5274233818054199,0,2,9,12,1,3,-1,9,13,1,1,3,-0.002094097901135683,0.6206194758415222,0.4572280049324036,0,2,9,5,2,15,-1,9,10,2,5,3,0.006809905171394348,0.5567759275436401,0.4155600070953369,0,2,8,14,2,3,-1,8,15,2,1,3,-0.0010746059706434608,0.5638927817344666,0.4353024959564209,0,2,10,14,1,3,-1,10,15,1,1,3,0.0021550289820879698,0.4826265871524811,0.6749758124351501,0,2,7,1,6,5,-1,9,1,2,5,3,0.0317423194646835,0.5048379898071289,0.188324898481369,0,2,0,0,20,2,-1,0,0,10,2,2,-0.0783827230334282,0.2369548976421356,0.5260158181190491,0,2,2,13,5,3,-1,2,14,5,1,3,0.005741511937230825,0.5048828721046448,0.2776469886302948,0,2,9,11,2,3,-1,9,12,2,1,3,-0.0029014600440859795,0.6238604784011841,0.4693317115306854,0,2,2,5,9,15,-1,2,10,9,5,3,-0.0026427931152284145,0.3314141929149628,0.5169777274131775,0,3,5,0,12,10,-1,11,0,6,5,2,5,5,6,5,2,-0.1094966009259224,0.2380045056343079,0.5183441042900085,0,2,5,1,2,3,-1,6,1,1,3,2,0.00007407591328956187,0.406963586807251,0.5362150073051453,0,2,10,7,6,1,-1,12,7,2,1,3,-0.0005059380200691521,0.5506706237792969,0.437459409236908,0,3,3,1,2,10,-1,3,1,1,5,2,4,6,1,5,2,-0.0008213177789002657,0.5525709986686707,0.4209375977516174,0,2,13,7,2,1,-1,13,7,1,1,2,-0.000060276539443293586,0.5455474853515625,0.4748266041278839,0,2,4,13,4,6,-1,4,15,4,2,3,0.006806514225900173,0.5157995820045471,0.3424577116966248,0,2,13,7,2,1,-1,13,7,1,1,2,0.0017202789895236492,0.5013207793235779,0.6331263780593872,0,2,5,7,2,1,-1,6,7,1,1,2,-0.0001301692973356694,0.5539718270301819,0.4226869940757752,0,3,2,12,18,4,-1,11,12,9,2,2,2,14,9,2,2,-0.004801638890057802,0.4425095021724701,0.5430780053138733,0,3,5,7,2,2,-1,5,7,1,1,2,6,8,1,1,2,-0.002539931097999215,0.7145782113075256,0.4697605073451996,0,2,16,3,4,2,-1,16,4,4,1,2,-0.0014278929447755218,0.4070445001125336,0.539960503578186,0,3,0,2,2,18,-1,0,2,1,9,2,1,11,1,9,2,-0.0251425504684448,0.7884690761566162,0.4747352004051209,0,3,1,2,18,4,-1,10,2,9,2,2,1,4,9,2,2,-0.0038899609353393316,0.4296191930770874,0.5577110052108765,0,2,9,14,1,3,-1,9,15,1,1,3,0.004394745919853449,0.4693162143230438,0.702394425868988,0,3,2,12,18,4,-1,11,12,9,2,2,2,14,9,2,2,0.0246784202754498,0.5242322087287903,0.3812510073184967,0,3,0,12,18,4,-1,0,12,9,2,2,9,14,9,2,2,0.0380476787686348,0.5011739730834961,0.1687828004360199,0,2,11,4,5,3,-1,11,5,5,1,3,0.007942486554384232,0.4828582108020783,0.6369568109512329,0,2,6,4,7,3,-1,6,5,7,1,3,-0.0015110049862414598,0.5906485915184021,0.4487667977809906,0,2,13,17,3,3,-1,13,18,3,1,3,0.0064201741479337215,0.5241097807884216,0.2990570068359375,0,2,8,1,3,4,-1,9,1,1,4,3,-0.0029802159406244755,0.3041465878486633,0.5078489780426025,0,2,11,4,2,4,-1,11,4,1,4,2,-0.0007458007894456387,0.4128139019012451,0.5256826281547546,0,2,0,17,9,3,-1,3,17,3,3,3,-0.0104709500446916,0.5808395147323608,0.4494296014308929,0,3,11,0,2,8,-1,12,0,1,4,2,11,4,1,4,2,0.009336920455098152,0.524655282497406,0.265894889831543,0,3,0,8,6,12,-1,0,8,3,6,2,3,14,3,6,2,0.0279369000345469,0.4674955010414124,0.7087256908416748,0,2,10,7,4,12,-1,10,13,4,6,2,0.007427767850458622,0.5409486889839172,0.3758518099784851,0,2,5,3,8,14,-1,5,10,8,7,2,-0.0235845092684031,0.3758639991283417,0.5238550901412964,0,2,14,10,6,1,-1,14,10,3,1,2,0.0011452640173956752,0.4329578876495361,0.5804247260093689,0,2,0,4,10,4,-1,0,6,10,2,2,-0.0004346866044215858,0.5280618071556091,0.3873069882392883,0,2,10,0,5,8,-1,10,4,5,4,2,0.0106485402211547,0.4902113080024719,0.5681251883506775,0,3,8,1,4,8,-1,8,1,2,4,2,10,5,2,4,2,-0.0003941805043723434,0.5570880174636841,0.4318251013755798,0,2,9,11,6,1,-1,11,11,2,1,3,-0.00013270479394122958,0.5658439993858337,0.4343554973602295,0,2,8,9,3,4,-1,9,9,1,4,3,-0.002012551063671708,0.6056739091873169,0.4537523984909058,0,2,18,4,2,6,-1,18,6,2,2,3,0.0024854319635778666,0.5390477180480957,0.4138010144233704,0,2,8,8,3,4,-1,9,8,1,4,3,0.0018237880431115627,0.4354828894138336,0.5717188715934753,0,2,7,1,13,3,-1,7,2,13,1,3,-0.0166566595435143,0.3010913133621216,0.521612286567688,0,2,7,13,6,1,-1,9,13,2,1,3,0.0008034955826587975,0.5300151109695435,0.3818396925926209,0,2,12,11,3,6,-1,12,13,3,2,3,0.003417037893086672,0.5328028798103333,0.4241400063037872,0,2,5,11,6,1,-1,7,11,2,1,3,-0.00036222729249857366,0.5491728186607361,0.418697714805603,0,3,1,4,18,10,-1,10,4,9,5,2,1,9,9,5,2,-0.1163002029061317,0.1440722048282623,0.522645115852356,0,2,8,6,4,9,-1,8,9,4,3,3,-0.0146950101479888,0.7747725248336792,0.4715717136859894,0,2,8,6,4,3,-1,8,7,4,1,3,0.0021972130052745342,0.5355433821678162,0.3315644860267639,0,2,8,7,3,3,-1,9,7,1,3,3,-0.00046965209185145795,0.5767235159873962,0.4458136856555939,0,2,14,15,4,3,-1,14,16,4,1,3,0.006514499895274639,0.5215674042701721,0.3647888898849487,0,2,5,10,3,10,-1,6,10,1,10,3,0.0213000606745481,0.4994204938411713,0.1567950993776321,0,2,8,15,4,3,-1,8,16,4,1,3,0.0031881409231573343,0.4742200076580048,0.6287270188331604,0,2,0,8,1,6,-1,0,10,1,2,3,0.0009001977741718292,0.5347954034805298,0.394375205039978,0,2,10,15,1,3,-1,10,16,1,1,3,-0.005177227780222893,0.6727191805839539,0.5013138055801392,0,2,2,15,4,3,-1,2,16,4,1,3,-0.004376464989036322,0.3106675148010254,0.5128793120384216,0,3,18,3,2,8,-1,19,3,1,4,2,18,7,1,4,2,0.002629996044561267,0.488631010055542,0.5755215883255005,0,3,0,3,2,8,-1,0,3,1,4,2,1,7,1,4,2,-0.002045868895947933,0.6025794148445129,0.4558076858520508,0,3,3,7,14,10,-1,10,7,7,5,2,3,12,7,5,2,0.0694827064871788,0.5240747928619385,0.2185259014368057,0,2,0,7,19,3,-1,0,8,19,1,3,0.0240489393472672,0.501186728477478,0.2090622037649155,0,2,12,6,3,3,-1,12,7,3,1,3,0.003109534038230777,0.4866712093353272,0.7108548283576965,0,2,0,6,1,3,-1,0,7,1,1,3,-0.00125032605137676,0.3407891094684601,0.5156195163726807,0,2,12,6,3,3,-1,12,7,3,1,3,-0.0010281190043315291,0.557557225227356,0.443943202495575,0,2,5,6,3,3,-1,5,7,3,1,3,-0.008889362215995789,0.6402000784873962,0.4620442092418671,0,2,8,2,4,2,-1,8,3,4,1,2,-0.0006109480164013803,0.3766441941261292,0.5448899865150452,0,2,6,3,4,12,-1,8,3,2,12,2,-0.005768635775893927,0.3318648934364319,0.5133677124977112,0,2,13,6,2,3,-1,13,7,2,1,3,0.0018506490159779787,0.4903570115566254,0.6406934857368469,0,2,0,10,20,4,-1,0,12,20,2,2,-0.0997994691133499,0.1536051034927368,0.5015562176704407,0,2,2,0,17,14,-1,2,7,17,7,2,-0.3512834906578064,0.0588231310248375,0.5174378752708435,0,3,0,0,6,10,-1,0,0,3,5,2,3,5,3,5,2,-0.0452445708215237,0.6961488723754883,0.4677872955799103,0,2,14,6,6,4,-1,14,6,3,4,2,0.0714815780520439,0.5167986154556274,0.1038092970848084,0,2,0,6,6,4,-1,3,6,3,4,2,0.0021895780228078365,0.4273078143596649,0.5532060861587524,0,2,13,2,7,2,-1,13,3,7,1,2,-0.0005924265133216977,0.46389439702034,0.5276389122009277,0,2,0,2,7,2,-1,0,3,7,1,2,0.0016788389766588807,0.530164897441864,0.3932034969329834,0,3,6,11,14,2,-1,13,11,7,1,2,6,12,7,1,2,-0.0022163488902151585,0.5630694031715393,0.4757033884525299,0,3,8,5,2,2,-1,8,5,1,1,2,9,6,1,1,2,0.00011568699846975505,0.4307535886764526,0.5535702705383301,0,2,13,9,2,3,-1,13,9,1,3,2,-0.007201728876680136,0.144488200545311,0.5193064212799072,0,2,1,1,3,12,-1,2,1,1,12,3,0.0008908127201721072,0.4384432137012482,0.5593621134757996,0,2,17,4,1,3,-1,17,5,1,1,3,0.00019605009583756328,0.5340415835380554,0.4705956876277924,0,2,2,4,1,3,-1,2,5,1,1,3,0.0005202214233577251,0.5213856101036072,0.3810079097747803,0,2,14,5,1,3,-1,14,6,1,1,3,0.0009458857239224017,0.4769414961338043,0.6130738854408264,0,2,7,16,2,3,-1,7,17,2,1,3,0.0000916984718060121,0.4245009124279022,0.5429363250732422,0,3,8,13,4,6,-1,10,13,2,3,2,8,16,2,3,2,0.002183320000767708,0.5457730889320374,0.419107586145401,0,2,5,5,1,3,-1,5,6,1,1,3,-0.0008603967144154012,0.5764588713645935,0.4471659958362579,0,2,16,0,4,20,-1,16,0,2,20,2,-0.0132362395524979,0.6372823119163513,0.4695009887218475,0,3,5,1,2,6,-1,5,1,1,3,2,6,4,1,3,2,0.0004337670106906444,0.5317873954772949,0.394582986831665,69.22987365722656,140,0,2,5,4,10,4,-1,5,6,10,2,2,-0.024847149848938,0.6555516719818115,0.3873311877250671,0,2,15,2,4,12,-1,15,2,2,12,2,0.006134861148893833,0.374807208776474,0.5973997712135315,0,2,7,6,4,12,-1,7,12,4,6,2,0.006449849810451269,0.542549192905426,0.2548811137676239,0,2,14,5,1,8,-1,14,9,1,4,2,0.0006349121103994548,0.2462442070245743,0.5387253761291504,0,3,1,4,14,10,-1,1,4,7,5,2,8,9,7,5,2,0.0014023890253156424,0.5594322085380554,0.3528657853603363,0,3,11,6,6,14,-1,14,6,3,7,2,11,13,3,7,2,0.0003004400059580803,0.3958503901958466,0.576593816280365,0,3,3,6,6,14,-1,3,6,3,7,2,6,13,3,7,2,0.00010042409849120304,0.3698996901512146,0.5534998178482056,0,2,4,9,15,2,-1,9,9,5,2,3,-0.005084149073809385,0.3711090981960297,0.5547800064086914,0,2,7,14,6,3,-1,7,15,6,1,3,-0.0195372607558966,0.7492755055427551,0.4579297006130219,0,3,6,3,14,4,-1,13,3,7,2,2,6,5,7,2,2,-0.000007453274065483129,0.5649787187576294,0.390406996011734,0,2,1,9,15,2,-1,6,9,5,2,3,-0.0036079459823668003,0.3381088078022003,0.5267801284790039,0,2,6,11,8,9,-1,6,14,8,3,3,0.002069750102236867,0.5519291162490845,0.3714388906955719,0,2,7,4,3,8,-1,8,4,1,8,3,-0.0004646384040825069,0.5608214735984802,0.4113566875457764,0,2,14,6,2,6,-1,14,9,2,3,2,0.0007549045258201659,0.3559206128120422,0.532935619354248,0,3,5,7,6,4,-1,5,7,3,2,2,8,9,3,2,2,-0.0009832223877310753,0.5414795875549316,0.3763205111026764,0,2,1,1,18,19,-1,7,1,6,19,3,-0.0199406407773495,0.634790301322937,0.4705299139022827,0,2,1,2,6,5,-1,4,2,3,5,2,0.0037680300883948803,0.3913489878177643,0.5563716292381287,0,2,12,17,6,2,-1,12,18,6,1,2,-0.009452850557863712,0.2554892897605896,0.5215116739273071,0,2,2,17,6,2,-1,2,18,6,1,2,0.002956084907054901,0.5174679160118103,0.3063920140266419,0,2,17,3,3,6,-1,17,5,3,2,3,0.009107873775064945,0.5388448238372803,0.2885963022708893,0,2,8,17,3,3,-1,8,18,3,1,3,0.0018219229532405734,0.4336043000221252,0.58521968126297,0,2,10,13,2,6,-1,10,16,2,3,2,0.0146887395530939,0.5287361741065979,0.2870005965232849,0,2,7,13,6,3,-1,7,14,6,1,3,-0.0143879903480411,0.701944887638092,0.4647370874881744,0,2,17,3,3,6,-1,17,5,3,2,3,-0.0189866498112679,0.2986552119255066,0.5247011780738831,0,2,8,13,2,3,-1,8,14,2,1,3,0.0011527639580890536,0.4323473870754242,0.593166172504425,0,2,9,3,6,2,-1,11,3,2,2,3,0.0109336702153087,0.5286864042282104,0.3130319118499756,0,2,0,3,3,6,-1,0,5,3,2,3,-0.0149327302351594,0.2658419013023377,0.508407711982727,0,2,8,5,4,6,-1,8,7,4,2,3,-0.0002997053961735219,0.5463526844978333,0.374072402715683,0,2,5,5,3,2,-1,5,6,3,1,2,0.004167762119323015,0.4703496992588043,0.7435721755027771,0,2,10,1,3,4,-1,11,1,1,4,3,-0.00639053201302886,0.2069258987903595,0.5280538201332092,0,2,1,2,5,9,-1,1,5,5,3,3,0.004502960946410894,0.518264889717102,0.348354309797287,0,2,13,6,2,3,-1,13,7,2,1,3,-0.009204036556184292,0.680377721786499,0.4932360053062439,0,2,0,6,14,3,-1,7,6,7,3,2,0.0813272595405579,0.5058398842811584,0.2253051996231079,0,2,2,11,18,8,-1,2,15,18,4,2,-0.150792807340622,0.2963424921035767,0.5264679789543152,0,2,5,6,2,3,-1,5,7,2,1,3,0.0033179009333252907,0.4655495882034302,0.7072932124137878,0,3,10,6,4,2,-1,12,6,2,1,2,10,7,2,1,2,0.0007740280125290155,0.4780347943305969,0.5668237805366516,0,3,6,6,4,2,-1,6,6,2,1,2,8,7,2,1,2,0.0006819954141974449,0.4286996126174927,0.5722156763076782,0,2,10,1,3,4,-1,11,1,1,4,3,0.0053671570494771,0.5299307107925415,0.3114621937274933,0,2,7,1,2,7,-1,8,1,1,7,2,0.00009701866656541824,0.3674638867378235,0.5269461870193481,0,2,4,2,15,14,-1,4,9,15,7,2,-0.1253408938646317,0.2351492047309876,0.5245791077613831,0,2,8,7,3,2,-1,9,7,1,2,3,-0.005251626949757338,0.7115936875343323,0.4693767130374908,0,3,2,3,18,4,-1,11,3,9,2,2,2,5,9,2,2,-0.007834210991859436,0.4462651014328003,0.5409085750579834,0,2,9,7,2,2,-1,10,7,1,2,2,-0.001131006982177496,0.5945618748664856,0.4417662024497986,0,2,13,9,2,3,-1,13,9,1,3,2,0.0017601120052859187,0.5353249907493591,0.3973453044891357,0,2,5,2,6,2,-1,7,2,2,2,3,-0.00081581249833107,0.3760268092155457,0.5264726877212524,0,2,9,5,2,7,-1,9,5,1,7,2,-0.003868758911266923,0.6309912800788879,0.4749819934368134,0,2,5,9,2,3,-1,6,9,1,3,2,0.0015207129763439298,0.5230181813240051,0.3361223936080933,0,2,6,0,14,18,-1,6,9,14,9,2,0.545867383480072,0.5167139768600464,0.1172635033726692,0,2,2,16,6,3,-1,2,17,6,1,3,0.0156501904129982,0.4979439079761505,0.1393294930458069,0,2,9,7,3,6,-1,10,7,1,6,3,-0.0117318602278829,0.7129650712013245,0.4921196103096008,0,2,7,8,4,3,-1,7,9,4,1,3,-0.006176512222737074,0.2288102954626083,0.5049701929092407,0,2,7,12,6,3,-1,7,13,6,1,3,0.0022457661107182503,0.4632433950901032,0.6048725843429565,0,2,9,12,2,3,-1,9,13,2,1,3,-0.005191586911678314,0.6467421054840088,0.4602192938327789,0,2,7,12,6,2,-1,9,12,2,2,3,-0.0238278806209564,0.1482000946998596,0.5226079225540161,0,2,5,11,4,6,-1,5,14,4,3,2,0.0010284580057486892,0.5135489106178284,0.3375957012176514,0,2,11,12,7,2,-1,11,13,7,1,2,-0.0100788502022624,0.2740561068058014,0.5303567051887512,0,3,6,10,8,6,-1,6,10,4,3,2,10,13,4,3,2,0.002616893034428358,0.533267080783844,0.3972454071044922,0,2,11,10,3,4,-1,11,12,3,2,2,0.000543853675480932,0.5365604162216187,0.4063411951065064,0,2,9,16,2,3,-1,9,17,2,1,3,0.005351051222532988,0.4653759002685547,0.6889045834541321,0,2,13,3,1,9,-1,13,6,1,3,3,-0.0015274790348485112,0.5449501276016235,0.3624723851680756,0,2,1,13,14,6,-1,1,15,14,2,3,-0.0806244164705276,0.1656087040901184,0.5000287294387817,0,2,13,6,1,6,-1,13,9,1,3,2,0.0221920292824507,0.5132731199264526,0.2002808004617691,0,2,0,4,3,8,-1,1,4,1,8,3,0.007310063112527132,0.4617947936058044,0.6366536021232605,0,2,18,0,2,18,-1,18,0,1,18,2,-0.006406307220458984,0.5916250944137573,0.4867860972881317,0,2,2,3,6,2,-1,2,4,6,1,2,-0.0007641504053026438,0.388840913772583,0.5315797924995422,0,2,9,0,8,6,-1,9,2,8,2,3,0.0007673448999412358,0.4159064888954163,0.5605279803276062,0,2,6,6,1,6,-1,6,9,1,3,2,0.0006147450185380876,0.3089022040367127,0.5120148062705994,0,2,14,8,6,3,-1,14,9,6,1,3,-0.005010527092963457,0.3972199857234955,0.5207306146621704,0,2,0,0,2,18,-1,1,0,1,18,2,-0.008690913207828999,0.6257408261299133,0.4608575999736786,0,3,1,18,18,2,-1,10,18,9,1,2,1,19,9,1,2,-0.016391459852457,0.2085209935903549,0.5242266058921814,0,2,3,15,2,2,-1,3,16,2,1,2,0.00040973909199237823,0.5222427248954773,0.3780320882797241,0,2,8,14,5,3,-1,8,15,5,1,3,-0.002524228999391198,0.5803927183151245,0.4611890017986298,0,2,8,14,2,3,-1,8,15,2,1,3,0.0005094531225040555,0.4401271939277649,0.5846015810966492,0,2,12,3,3,3,-1,13,3,1,3,3,0.001965641975402832,0.5322325229644775,0.4184590876102448,0,2,7,5,6,2,-1,9,5,2,2,3,0.0005629889783449471,0.3741844892501831,0.5234565734863281,0,2,15,5,5,2,-1,15,6,5,1,2,-0.0006794679793529212,0.4631041884422302,0.5356478095054626,0,2,0,5,5,2,-1,0,6,5,1,2,0.007285634987056255,0.5044670104980469,0.2377564013004303,0,2,17,14,1,6,-1,17,17,1,3,2,-0.0174594894051552,0.7289121150970459,0.5050435066223145,0,2,2,9,9,3,-1,5,9,3,3,3,-0.0254217498004436,0.6667134761810303,0.4678100049495697,0,2,12,3,3,3,-1,13,3,1,3,3,-0.0015647639520466328,0.4391759037971497,0.532362699508667,0,2,0,0,4,18,-1,2,0,2,18,2,0.0114443600177765,0.4346440136432648,0.5680012106895447,0,2,17,6,1,3,-1,17,7,1,1,3,-0.0006735255010426044,0.44771409034729,0.5296812057495117,0,2,2,14,1,6,-1,2,17,1,3,2,0.009319420903921127,0.4740200042724609,0.7462607026100159,0,2,19,8,1,2,-1,19,9,1,1,2,0.00013328490604180843,0.536506175994873,0.475213497877121,0,2,5,3,3,3,-1,6,3,1,3,3,-0.007881579920649529,0.1752219051122665,0.5015255212783813,0,2,9,16,2,3,-1,9,17,2,1,3,-0.005798568017780781,0.7271236777305603,0.4896200895309448,0,2,2,6,1,3,-1,2,7,1,1,3,-0.0003892249951604754,0.4003908932209015,0.5344941020011902,0,3,12,4,8,2,-1,16,4,4,1,2,12,5,4,1,2,-0.0019288610201328993,0.5605612993240356,0.4803955852985382,0,3,0,4,8,2,-1,0,4,4,1,2,4,5,4,1,2,0.008421415463089943,0.4753246903419495,0.7623608708381653,0,2,2,16,18,4,-1,2,18,18,2,2,0.008165587671101093,0.5393261909484863,0.419164389371872,0,2,7,15,2,4,-1,7,17,2,2,2,0.00048280550981871784,0.4240800142288208,0.5399821996688843,0,2,4,0,14,3,-1,4,1,14,1,3,-0.002718663075938821,0.4244599938392639,0.5424923896789551,0,2,0,0,4,20,-1,2,0,2,20,2,-0.0125072300434113,0.5895841717720032,0.4550411105155945,0,3,12,4,4,8,-1,14,4,2,4,2,12,8,2,4,2,-0.0242865197360516,0.2647134959697723,0.518917977809906,0,3,6,7,2,2,-1,6,7,1,1,2,7,8,1,1,2,-0.0029676330741494894,0.734768271446228,0.4749749898910523,0,2,10,6,2,3,-1,10,7,2,1,3,-0.0125289997085929,0.2756049931049347,0.5177599787712097,0,2,8,7,3,2,-1,8,8,3,1,2,-0.0010104000102728605,0.3510560989379883,0.5144724249839783,0,2,8,2,6,12,-1,8,8,6,6,2,-0.0021348530426621437,0.5637925863265991,0.466731995344162,0,2,4,0,11,12,-1,4,4,11,4,3,0.0195642597973347,0.4614573121070862,0.6137639880180359,0,2,14,9,6,11,-1,16,9,2,11,3,-0.0971463471651077,0.2998378872871399,0.5193555951118469,0,2,0,14,4,3,-1,0,15,4,1,3,0.00450145686045289,0.5077884793281555,0.3045755922794342,0,2,9,10,2,3,-1,9,11,2,1,3,0.006370697170495987,0.486101895570755,0.6887500882148743,0,2,5,11,3,2,-1,5,12,3,1,2,-0.009072152897715569,0.1673395931720734,0.5017563104629517,0,2,9,15,3,3,-1,10,15,1,3,3,-0.005353720858693123,0.2692756950855255,0.524263322353363,0,2,8,8,3,4,-1,9,8,1,4,3,-0.0109328404068947,0.7183864116668701,0.4736028909683228,0,2,9,15,3,3,-1,10,15,1,3,3,0.008235607296228409,0.5223966836929321,0.2389862984418869,0,2,7,7,3,2,-1,8,7,1,2,3,-0.0010038160253316164,0.5719355940818787,0.4433943033218384,0,3,2,10,16,4,-1,10,10,8,2,2,2,12,8,2,2,0.004085912834852934,0.5472841858863831,0.4148836135864258,0,2,2,3,4,17,-1,4,3,2,17,2,0.1548541933298111,0.4973812103271484,0.0610615983605385,0,2,15,13,2,7,-1,15,13,1,7,2,0.00020897459762636572,0.4709174036979675,0.542388916015625,0,2,2,2,6,1,-1,5,2,3,1,2,0.0003331699117552489,0.4089626967906952,0.5300992131233215,0,2,5,2,12,4,-1,9,2,4,4,3,-0.0108134001493454,0.6104369759559631,0.4957334101200104,0,3,6,0,8,12,-1,6,0,4,6,2,10,6,4,6,2,0.0456560105085373,0.5069689154624939,0.2866660058498383,0,3,13,7,2,2,-1,14,7,1,1,2,13,8,1,1,2,0.0012569549726322293,0.484691709280014,0.631817102432251,0,2,0,12,20,6,-1,0,14,20,2,3,-0.120150700211525,0.0605261400341988,0.4980959892272949,0,2,14,7,2,3,-1,14,7,1,3,2,-0.00010533799650147557,0.5363109707832336,0.4708042144775391,0,2,0,8,9,12,-1,3,8,3,12,3,-0.2070319056510925,0.059660330414772,0.497909814119339,0,2,3,0,16,2,-1,3,0,8,2,2,0.00012909180077258497,0.4712977111339569,0.5377997756004333,0,2,6,15,3,3,-1,6,16,3,1,3,0.000388185289921239,0.4363538026809692,0.5534191131591797,0,2,8,15,6,3,-1,8,16,6,1,3,-0.0029243610333651304,0.5811185836791992,0.4825215935707092,0,2,0,10,1,6,-1,0,12,1,2,3,0.0008388233254663646,0.5311700105667114,0.403813898563385,0,2,10,9,4,3,-1,10,10,4,1,3,-0.0019061550265178084,0.3770701885223389,0.526001513004303,0,2,9,15,2,3,-1,9,16,2,1,3,0.00895143486559391,0.4766167998313904,0.7682183980941772,0,2,5,7,10,1,-1,5,7,5,1,2,0.0130834598094225,0.5264462828636169,0.3062222003936768,0,2,4,0,12,19,-1,10,0,6,19,2,-0.2115933001041412,0.6737198233604431,0.4695810079574585,0,3,0,6,20,6,-1,10,6,10,3,2,0,9,10,3,2,0.0031493250280618668,0.5644835233688354,0.4386953115463257,0,3,3,6,2,2,-1,3,6,1,1,2,4,7,1,1,2,0.00039754100725986063,0.4526061117649078,0.5895630121231079,0,3,15,6,2,2,-1,16,6,1,1,2,15,7,1,1,2,-0.0013814480043947697,0.6070582270622253,0.4942413866519928,0,3,3,6,2,2,-1,3,6,1,1,2,4,7,1,1,2,-0.0005812218878418207,0.5998213291168213,0.4508252143859863,0,2,14,4,1,12,-1,14,10,1,6,2,-0.002390532987192273,0.420558899641037,0.5223848223686218,0,3,2,5,16,10,-1,2,5,8,5,2,10,10,8,5,2,0.0272689294070005,0.5206447243690491,0.3563301861286163,0,2,9,17,3,2,-1,10,17,1,2,3,-0.0037658358924090862,0.3144704103469849,0.5218814015388489,0,2,1,4,2,2,-1,1,5,2,1,2,-0.0014903489500284195,0.338019609451294,0.5124437212944031,0,2,5,0,15,5,-1,10,0,5,5,3,-0.0174282304942608,0.5829960703849792,0.4919725954532623,0,2,0,0,15,5,-1,5,0,5,5,3,-0.0152780301868916,0.6163144707679749,0.4617887139320374,0,2,11,2,2,17,-1,11,2,1,17,2,0.0319956094026566,0.5166357159614563,0.171276405453682,0,2,7,2,2,17,-1,8,2,1,17,2,-0.003825671039521694,0.3408012092113495,0.5131387710571289,0,2,15,11,2,9,-1,15,11,1,9,2,-0.00851864367723465,0.6105518937110901,0.4997941851615906,0,2,3,11,2,9,-1,4,11,1,9,2,0.0009064162150025368,0.4327270984649658,0.5582311153411865,0,2,5,16,14,4,-1,5,16,7,4,2,0.0103448498994112,0.4855653047561646,0.5452420115470886,79.24907684326172,160,0,2,1,4,18,1,-1,7,4,6,1,3,0.007898182608187199,0.333252489566803,0.5946462154388428,0,3,13,7,6,4,-1,16,7,3,2,2,13,9,3,2,2,0.0016170160379260778,0.3490641117095947,0.5577868819236755,0,2,9,8,2,12,-1,9,12,2,4,3,-0.0005544974119402468,0.5542566180229187,0.3291530013084412,0,2,12,1,6,6,-1,12,3,6,2,3,0.001542898011393845,0.3612579107284546,0.5545979142189026,0,3,5,2,6,6,-1,5,2,3,3,2,8,5,3,3,2,-0.0010329450014978647,0.3530139029026032,0.5576140284538269,0,3,9,16,6,4,-1,12,16,3,2,2,9,18,3,2,2,0.0007769815856590867,0.3916778862476349,0.5645321011543274,0,2,1,2,18,3,-1,7,2,6,3,3,0.143203005194664,0.4667482078075409,0.7023633122444153,0,2,7,4,9,10,-1,7,9,9,5,2,-0.007386649027466774,0.3073684871196747,0.5289257764816284,0,2,5,9,4,4,-1,7,9,2,4,2,-0.0006293674232438207,0.562211811542511,0.4037049114704132,0,2,11,10,3,6,-1,11,13,3,3,2,0.0007889352855272591,0.5267661213874817,0.3557874858379364,0,2,7,11,5,3,-1,7,12,5,1,3,-0.0122280502691865,0.6668320894241333,0.4625549912452698,0,3,7,11,6,6,-1,10,11,3,3,2,7,14,3,3,2,0.0035420239437371492,0.5521438121795654,0.3869673013687134,0,2,0,0,10,9,-1,0,3,10,3,3,-0.0010585320414975286,0.3628678023815155,0.5320926904678345,0,2,13,14,1,6,-1,13,16,1,2,3,0.000014935660146875307,0.4632444977760315,0.5363323092460632,0,2,0,2,3,6,-1,0,4,3,2,3,0.005253770854324102,0.5132231712341309,0.3265708982944489,0,2,8,14,4,3,-1,8,15,4,1,3,-0.008233802393078804,0.6693689823150635,0.4774140119552612,0,2,6,14,1,6,-1,6,16,1,2,3,0.00002186681012972258,0.405386209487915,0.5457931160926819,0,2,9,15,2,3,-1,9,16,2,1,3,-0.0038150229956954718,0.645499587059021,0.4793178141117096,0,2,6,4,3,3,-1,7,4,1,3,3,0.0011105879675596952,0.5270407199859619,0.3529678881168366,0,2,9,0,11,3,-1,9,1,11,1,3,-0.005770768970251083,0.3803547024726868,0.5352957844734192,0,2,0,6,20,3,-1,0,7,20,1,3,-0.003015833906829357,0.533940315246582,0.3887133002281189,0,2,10,1,1,2,-1,10,2,1,1,2,-0.0008545368909835815,0.3564616143703461,0.5273603796958923,0,2,9,6,2,6,-1,10,6,1,6,2,0.0110505102202296,0.4671907126903534,0.6849737763404846,0,2,5,8,12,1,-1,9,8,4,1,3,0.0426058396697044,0.51514732837677,0.0702200904488564,0,2,3,8,12,1,-1,7,8,4,1,3,-0.0030781750101596117,0.3041661083698273,0.5152602195739746,0,2,9,7,3,5,-1,10,7,1,5,3,-0.005481572821736336,0.6430295705795288,0.4897229969501495,0,2,3,9,6,2,-1,6,9,3,2,2,0.003188186092302203,0.5307493209838867,0.3826209902763367,0,2,12,9,3,3,-1,12,10,3,1,3,0.00035947180003859103,0.4650047123432159,0.5421904921531677,0,2,7,0,6,1,-1,9,0,2,1,3,-0.004070503171533346,0.2849679887294769,0.5079116225242615,0,2,12,9,3,3,-1,12,10,3,1,3,-0.0145941702648997,0.2971645891666412,0.5128461718559265,0,2,7,10,2,1,-1,8,10,1,1,2,-0.00011947689927183092,0.563109815120697,0.4343082010746002,0,2,6,4,9,13,-1,9,4,3,13,3,-0.0006934464909136295,0.4403578042984009,0.5359959006309509,0,2,6,8,4,2,-1,6,9,4,1,2,0.000014834799912932795,0.3421008884906769,0.5164697766304016,0,2,16,2,4,6,-1,16,2,2,6,2,0.009029698558151722,0.4639343023300171,0.6114075183868408,0,2,0,17,6,3,-1,0,18,6,1,3,-0.008064081892371178,0.2820158898830414,0.5075494050979614,0,2,10,10,3,10,-1,10,15,3,5,2,0.0260621197521687,0.5208905935287476,0.2688778042793274,0,2,8,7,3,5,-1,9,7,1,5,3,0.0173146594315767,0.4663713872432709,0.6738539934158325,0,2,10,4,4,3,-1,10,4,2,3,2,0.0226666405797005,0.5209349989891052,0.2212723940610886,0,2,8,4,3,8,-1,9,4,1,8,3,-0.002196592977270484,0.6063101291656494,0.4538190066814423,0,2,6,6,9,13,-1,9,6,3,13,3,-0.009528247639536858,0.4635204970836639,0.5247430801391602,0,3,6,0,8,12,-1,6,0,4,6,2,10,6,4,6,2,0.00809436198323965,0.5289440155029297,0.3913882076740265,0,2,14,2,6,8,-1,16,2,2,8,3,-0.0728773325681686,0.7752001881599426,0.4990234971046448,0,2,6,0,3,6,-1,7,0,1,6,3,-0.006900952197611332,0.2428039014339447,0.5048090219497681,0,2,14,2,6,8,-1,16,2,2,8,3,-0.0113082397729158,0.5734364986419678,0.4842376112937927,0,2,0,5,6,6,-1,0,8,6,3,2,0.0596132017672062,0.5029836297035217,0.2524977028369904,0,3,9,12,6,2,-1,12,12,3,1,2,9,13,3,1,2,-0.0028624620754271746,0.6073045134544373,0.4898459911346436,0,2,8,17,3,2,-1,9,17,1,2,3,0.00447814492508769,0.5015289187431335,0.2220316976308823,0,3,11,6,2,2,-1,12,6,1,1,2,11,7,1,1,2,-0.001751324045471847,0.6614428758621216,0.4933868944644928,0,2,1,9,18,2,-1,7,9,6,2,3,0.0401634201407433,0.5180878043174744,0.3741044998168945,0,3,11,6,2,2,-1,12,6,1,1,2,11,7,1,1,2,0.0003476894926279783,0.4720416963100433,0.5818032026290894,0,2,3,4,12,8,-1,7,4,4,8,3,0.00265516503714025,0.3805010914802551,0.5221335887908936,0,2,13,11,5,3,-1,13,12,5,1,3,-0.008770627900958061,0.294416606426239,0.5231295228004456,0,2,9,10,2,3,-1,9,11,2,1,3,-0.005512209143489599,0.7346177101135254,0.4722816944122315,0,2,14,7,2,3,-1,14,7,1,3,2,0.0006867204210720956,0.5452876091003418,0.424241304397583,0,2,5,4,1,3,-1,5,5,1,1,3,0.0005601966986432672,0.439886212348938,0.5601285099983215,0,2,13,4,2,3,-1,13,5,2,1,3,0.0024143769405782223,0.4741686880588532,0.6136621832847595,0,2,5,4,2,3,-1,5,5,2,1,3,-0.0015680900542065501,0.604455292224884,0.4516409933567047,0,2,9,8,2,3,-1,9,9,2,1,3,-0.0036827491130679846,0.2452459037303925,0.5294982194900513,0,2,8,9,2,2,-1,8,10,2,1,2,-0.000294091907562688,0.3732838034629822,0.5251451134681702,0,2,15,14,1,4,-1,15,16,1,2,2,0.00042847759323194623,0.5498809814453125,0.4065535068511963,0,2,3,12,2,2,-1,3,13,2,1,2,-0.004881707020103931,0.2139908969402313,0.4999957084655762,0,3,12,15,2,2,-1,13,15,1,1,2,12,16,1,1,2,0.00027272020815871656,0.465028703212738,0.581342875957489,0,2,9,13,2,2,-1,9,14,2,1,2,0.00020947199664078653,0.4387486875057221,0.5572792887687683,0,2,4,11,14,9,-1,4,14,14,3,3,0.0485011897981167,0.5244972705841064,0.3212889134883881,0,2,7,13,4,3,-1,7,14,4,1,3,-0.004516641143709421,0.605681300163269,0.4545882046222687,0,2,15,14,1,4,-1,15,16,1,2,2,-0.0122916800901294,0.2040929049253464,0.5152214169502258,0,2,4,14,1,4,-1,4,16,1,2,2,0.0004854967992287129,0.5237604975700378,0.3739503026008606,0,2,14,0,6,13,-1,16,0,2,13,3,0.0305560491979122,0.4960533976554871,0.5938246250152588,0,3,4,1,2,12,-1,4,1,1,6,2,5,7,1,6,2,-0.00015105320198927075,0.5351303815841675,0.4145204126834869,0,3,11,14,6,6,-1,14,14,3,3,2,11,17,3,3,2,0.0024937440175563097,0.4693366885185242,0.5514941215515137,0,3,3,14,6,6,-1,3,14,3,3,2,6,17,3,3,2,-0.012382130138576,0.6791396737098694,0.4681667983531952,0,2,14,17,3,2,-1,14,18,3,1,2,-0.005133346188813448,0.3608739078044891,0.5229160189628601,0,2,3,17,3,2,-1,3,18,3,1,2,0.0005191927775740623,0.5300073027610779,0.3633613884449005,0,2,14,0,6,13,-1,16,0,2,13,3,0.1506042033433914,0.515731692314148,0.2211782038211823,0,2,0,0,6,13,-1,2,0,2,13,3,0.007714414969086647,0.4410496950149536,0.5776609182357788,0,2,10,10,7,6,-1,10,12,7,2,3,0.009444352239370346,0.5401855111122131,0.375665009021759,0,3,6,15,2,2,-1,6,15,1,1,2,7,16,1,1,2,0.00025006249779835343,0.4368270933628082,0.5607374906539917,0,3,6,11,8,6,-1,10,11,4,3,2,6,14,4,3,2,-0.003307715058326721,0.4244799017906189,0.551823079586029,0,3,7,6,2,2,-1,7,6,1,1,2,8,7,1,1,2,0.0007404891075566411,0.4496962130069733,0.5900576710700989,0,3,2,2,16,6,-1,10,2,8,3,2,2,5,8,3,2,0.0440920516848564,0.5293493270874023,0.3156355023384094,0,2,5,4,3,3,-1,5,5,3,1,3,0.0033639909233897924,0.4483296871185303,0.5848662257194519,0,2,11,7,3,10,-1,11,12,3,5,2,-0.003976007923483849,0.4559507071971893,0.5483639240264893,0,2,6,7,3,10,-1,6,12,3,5,2,0.0027716930489987135,0.534178614616394,0.3792484104633331,0,2,10,7,3,2,-1,11,7,1,2,3,-0.00024123019829858094,0.5667188763618469,0.4576973021030426,0,2,8,12,4,2,-1,8,13,4,1,2,0.0004942566738463938,0.4421244859695435,0.5628787279129028,0,2,10,1,1,3,-1,10,2,1,1,3,-0.0003887646889779717,0.4288370907306671,0.5391063094139099,0,3,1,2,4,18,-1,1,2,2,9,2,3,11,2,9,2,-0.0500488989055157,0.6899513006210327,0.4703742861747742,0,2,12,4,4,12,-1,12,10,4,6,2,-0.0366354808211327,0.2217779010534287,0.5191826224327087,0,2,0,0,1,6,-1,0,2,1,2,3,0.0024273579474538565,0.5136224031448364,0.3497397899627686,0,2,9,11,2,3,-1,9,12,2,1,3,0.001955803018063307,0.4826192855834961,0.640838086605072,0,2,8,7,4,3,-1,8,8,4,1,3,-0.0017494610510766506,0.3922835886478424,0.5272685289382935,0,2,10,7,3,2,-1,11,7,1,2,3,0.0139550799503922,0.507820188999176,0.8416504859924316,0,2,7,7,3,2,-1,8,7,1,2,3,-0.00021896739781368524,0.5520489811897278,0.4314234852790833,0,2,9,4,6,1,-1,11,4,2,1,3,-0.0015131309628486633,0.3934605121612549,0.5382571220397949,0,2,8,7,2,3,-1,9,7,1,3,2,-0.004362280014902353,0.7370628714561462,0.4736475944519043,0,3,12,7,8,6,-1,16,7,4,3,2,12,10,4,3,2,0.0651605874300003,0.5159279704093933,0.328159511089325,0,3,0,7,8,6,-1,0,7,4,3,2,4,10,4,3,2,-0.0023567399475723505,0.3672826886177063,0.5172886252403259,0,3,18,2,2,10,-1,19,2,1,5,2,18,7,1,5,2,0.0151466596871614,0.5031493902206421,0.6687604188919067,0,2,0,2,6,4,-1,3,2,3,4,2,-0.0228509604930878,0.676751971244812,0.4709596931934357,0,2,9,4,6,1,-1,11,4,2,1,3,0.004886765033006668,0.5257998108863831,0.4059878885746002,0,3,7,15,2,2,-1,7,15,1,1,2,8,16,1,1,2,0.0017619599821045995,0.4696272909641266,0.6688278913497925,0,2,11,13,1,6,-1,11,16,1,3,2,-0.0012942519970238209,0.4320712983608246,0.5344281792640686,0,2,8,13,1,6,-1,8,16,1,3,2,0.0109299495816231,0.4997706115245819,0.1637486070394516,0,2,14,3,2,1,-1,14,3,1,1,2,0.00002995848990394734,0.4282417893409729,0.5633224248886108,0,2,8,15,2,3,-1,8,16,2,1,3,-0.0065884361974895,0.677212119102478,0.4700526893138886,0,2,12,15,7,4,-1,12,17,7,2,2,0.0032527779694646597,0.531339704990387,0.4536148905754089,0,2,4,14,12,3,-1,4,15,12,1,3,-0.00404357397928834,0.5660061836242676,0.4413388967514038,0,2,10,3,3,2,-1,11,3,1,2,3,-0.0012523540062829852,0.3731913864612579,0.5356451869010925,0,2,4,12,2,2,-1,4,13,2,1,2,0.00019246719602961093,0.5189986228942871,0.3738811016082764,0,2,10,11,4,6,-1,10,14,4,3,2,-0.038589671254158,0.2956373989582062,0.51888108253479,0,3,7,13,2,2,-1,7,13,1,1,2,8,14,1,1,2,0.0001548987056594342,0.4347135126590729,0.5509533286094666,0,3,4,11,14,4,-1,11,11,7,2,2,4,13,7,2,2,-0.0337638482451439,0.3230330049991608,0.5195475816726685,0,2,1,18,18,2,-1,7,18,6,2,3,-0.008265706710517406,0.5975489020347595,0.4552114009857178,0,3,11,18,2,2,-1,12,18,1,1,2,11,19,1,1,2,0.000014481440302915871,0.4745678007602692,0.5497426986694336,0,3,7,18,2,2,-1,7,18,1,1,2,8,19,1,1,2,0.000014951299817766994,0.4324473142623901,0.5480644106864929,0,2,12,18,8,2,-1,12,19,8,1,2,-0.018741799518466,0.1580052971839905,0.517853319644928,0,2,7,14,6,2,-1,7,15,6,1,2,0.0017572239739820361,0.4517636895179749,0.5773764252662659,0,3,8,12,4,8,-1,10,12,2,4,2,8,16,2,4,2,-0.0031391119118779898,0.4149647951126099,0.5460842251777649,0,2,4,9,3,3,-1,4,10,3,1,3,0.00006665677938144654,0.4039090871810913,0.5293084979057312,0,2,7,10,6,2,-1,9,10,2,2,3,0.006774342153221369,0.4767651855945587,0.612195611000061,0,2,5,0,4,15,-1,7,0,2,15,2,-0.0073868161998689175,0.3586258888244629,0.5187280774116516,0,2,8,6,12,14,-1,12,6,4,14,3,0.0140409301966429,0.4712139964103699,0.5576155781745911,0,2,5,16,3,3,-1,5,17,3,1,3,-0.005525832995772362,0.2661027014255524,0.5039281249046326,0,2,8,1,12,19,-1,12,1,4,19,3,0.3868423998355866,0.5144339799880981,0.2525899112224579,0,2,3,0,3,2,-1,3,1,3,1,2,0.0001145924034062773,0.4284994900226593,0.5423371195793152,0,2,10,12,4,5,-1,10,12,2,5,2,-0.0184675697237253,0.3885835111141205,0.5213062167167664,0,2,6,12,4,5,-1,8,12,2,5,2,-0.0004590701137203723,0.541256308555603,0.4235909879207611,0,3,11,11,2,2,-1,12,11,1,1,2,11,12,1,1,2,0.0012527540093287826,0.4899305105209351,0.6624091267585754,0,2,0,2,3,6,-1,0,4,3,2,3,0.001491060946136713,0.5286778211593628,0.4040051996707916,0,3,11,11,2,2,-1,12,11,1,1,2,11,12,1,1,2,-0.0007543556275777519,0.6032990217208862,0.4795120060443878,0,2,7,6,4,10,-1,7,11,4,5,2,-0.0069478838704526424,0.408440113067627,0.5373504161834717,0,3,11,11,2,2,-1,12,11,1,1,2,11,12,1,1,2,0.0002809292054735124,0.4846062958240509,0.5759382247924805,0,2,2,13,5,2,-1,2,14,5,1,2,0.0009607371757738292,0.5164741277694702,0.3554979860782623,0,3,11,11,2,2,-1,12,11,1,1,2,11,12,1,1,2,-0.0002688392996788025,0.5677582025527954,0.4731765985488892,0,3,7,11,2,2,-1,7,11,1,1,2,8,12,1,1,2,0.0021599370520561934,0.4731487035751343,0.7070567011833191,0,2,14,13,3,3,-1,14,14,3,1,3,0.005623530130833387,0.5240243077278137,0.2781791985034943,0,2,3,13,3,3,-1,3,14,3,1,3,-0.005024399142712355,0.2837013900279999,0.5062304139137268,0,2,9,14,2,3,-1,9,15,2,1,3,-0.009761163964867592,0.7400717735290527,0.4934569001197815,0,2,8,7,3,3,-1,8,8,3,1,3,0.004151510074734688,0.5119131207466125,0.3407008051872253,0,2,13,5,3,3,-1,13,6,3,1,3,0.006246508099138737,0.4923788011074066,0.6579058766365051,0,2,0,9,5,3,-1,0,10,5,1,3,-0.007059747818857431,0.2434711009263992,0.503284215927124,0,2,13,5,3,3,-1,13,6,3,1,3,-0.0020587709732353687,0.590031087398529,0.469508707523346,0,3,9,12,2,8,-1,9,12,1,4,2,10,16,1,4,2,-0.0024146060459315777,0.3647317886352539,0.5189201831817627,0,3,11,7,2,2,-1,12,7,1,1,2,11,8,1,1,2,-0.0014817609917372465,0.6034948229789734,0.4940128028392792,0,2,0,16,6,4,-1,3,16,3,4,2,-0.0063016400672495365,0.5818989872932434,0.4560427963733673,0,2,10,6,2,3,-1,10,7,2,1,3,0.00347634288482368,0.5217475891113281,0.3483993113040924,0,2,9,5,2,6,-1,9,7,2,2,3,-0.0222508702427149,0.2360700070858002,0.5032082796096802,0,2,12,15,8,4,-1,12,15,4,4,2,-0.030612550675869,0.6499186754226685,0.4914919137954712,0,2,0,14,8,6,-1,4,14,4,6,2,0.013057479634881,0.4413323104381561,0.5683764219284058,0,2,9,0,3,2,-1,10,0,1,2,3,-0.0006009574281051755,0.4359731078147888,0.5333483219146729,0,2,4,15,4,2,-1,6,15,2,2,2,-0.0004151425091549754,0.550406277179718,0.4326060116291046,0,2,12,7,3,13,-1,13,7,1,13,3,-0.013776290230453,0.4064112901687622,0.5201548933982849,0,2,5,7,3,13,-1,6,7,1,13,3,-0.0322965085506439,0.0473519712686539,0.4977194964885712,0,2,9,6,3,9,-1,9,9,3,3,3,0.0535569787025452,0.4881733059883118,0.666693925857544,0,2,4,4,7,12,-1,4,10,7,6,2,0.008188954554498196,0.5400037169456482,0.4240820109844208,0,3,12,12,2,2,-1,13,12,1,1,2,12,13,1,1,2,0.00021055320394225419,0.4802047908306122,0.5563852787017822,0,3,6,12,2,2,-1,6,12,1,1,2,7,13,1,1,2,-0.00243827304802835,0.7387793064117432,0.4773685038089752,0,3,8,9,4,2,-1,10,9,2,1,2,8,10,2,1,2,0.003283557016402483,0.5288546085357666,0.3171291947364807,0,3,3,6,2,2,-1,3,6,1,1,2,4,7,1,1,2,0.00237295706756413,0.4750812947750092,0.7060170769691467,0,2,16,6,3,2,-1,16,7,3,1,2,-0.0014541699783876538,0.3811730146408081,0.533073902130127,87.69602966308594,177,0,2,0,7,19,4,-1,0,9,19,2,2,0.0557552389800549,0.4019156992435455,0.6806036829948425,0,2,10,2,10,1,-1,10,2,5,1,2,0.002473024884238839,0.3351148962974548,0.5965719819068909,0,2,9,4,2,12,-1,9,10,2,6,2,-0.00035031698644161224,0.5557708144187927,0.3482286930084229,0,2,12,18,4,1,-1,12,18,2,1,2,0.0005416763015091419,0.426085889339447,0.5693380832672119,0,3,1,7,6,4,-1,1,7,3,2,2,4,9,3,2,2,0.0007719367858953774,0.3494240045547485,0.5433688759803772,0,2,12,0,6,13,-1,14,0,2,13,3,-0.0015999219613149762,0.4028499126434326,0.5484359264373779,0,2,2,0,6,13,-1,4,0,2,13,3,-0.00011832080053864047,0.3806901872158051,0.5425465106964111,0,2,10,5,8,8,-1,10,9,8,4,2,0.0003290903114248067,0.262010008096695,0.5429521799087524,0,2,8,3,2,5,-1,9,3,1,5,2,0.0002951810893137008,0.379976898431778,0.5399264097213745,0,2,8,4,9,1,-1,11,4,3,1,3,0.00009046671038959175,0.4433645009994507,0.5440226197242737,0,2,3,4,9,1,-1,6,4,3,1,3,0.000015007190086180344,0.3719654977321625,0.5409119725227356,0,2,1,0,18,10,-1,7,0,6,10,3,0.1393561065196991,0.552539587020874,0.4479042887687683,0,2,7,17,5,3,-1,7,18,5,1,3,0.0016461990308016539,0.4264501035213471,0.5772169828414917,0,2,7,11,6,1,-1,9,11,2,1,3,0.0004998443182557821,0.4359526038169861,0.5685871243476868,0,2,2,2,3,2,-1,2,3,3,1,2,-0.001097128028050065,0.3390136957168579,0.5205408930778503,0,2,8,12,4,2,-1,8,13,4,1,2,0.0006691989256069064,0.4557456076145172,0.598065972328186,0,2,6,10,3,6,-1,6,13,3,3,2,0.0008647104259580374,0.5134841203689575,0.2944033145904541,0,2,11,4,2,4,-1,11,4,1,4,2,-0.0002718259929679334,0.3906578123569489,0.5377181172370911,0,2,7,4,2,4,-1,8,4,1,4,2,0.00003024949910468422,0.3679609894752502,0.5225688815116882,0,2,9,6,2,4,-1,9,6,1,4,2,-0.008522589690983295,0.7293102145195007,0.4892365038394928,0,2,6,13,8,3,-1,6,14,8,1,3,0.0016705560265108943,0.43453249335289,0.5696138143539429,0,2,9,15,3,4,-1,10,15,1,4,3,-0.0071433838456869125,0.2591280043125153,0.5225623846054077,0,2,9,2,2,17,-1,10,2,1,17,2,-0.0163193698972464,0.6922279000282288,0.4651575982570648,0,2,7,0,6,1,-1,9,0,2,1,3,0.004803426098078489,0.5352262854576111,0.3286302983760834,0,2,8,15,3,4,-1,9,15,1,4,3,-0.0075421929359436035,0.2040544003248215,0.5034546256065369,0,2,7,13,7,3,-1,7,14,7,1,3,-0.0143631100654602,0.6804888844490051,0.4889059066772461,0,2,8,16,3,3,-1,9,16,1,3,3,0.0008906358852982521,0.5310695767402649,0.3895480930805206,0,2,6,2,8,10,-1,6,7,8,5,2,-0.004406019113957882,0.5741562843322754,0.4372426867485046,0,2,2,5,8,8,-1,2,9,8,4,2,-0.0001886254030978307,0.2831785976886749,0.5098205208778381,0,2,14,16,2,2,-1,14,17,2,1,2,-0.0037979281041771173,0.3372507989406586,0.5246580243110657,0,2,4,16,2,2,-1,4,17,2,1,2,0.00014627049677073956,0.5306674242019653,0.391171008348465,0,2,10,11,4,6,-1,10,14,4,3,2,-0.000049164638767251745,0.5462496280670166,0.3942720890045166,0,2,6,11,4,6,-1,6,14,4,3,2,-0.0335825011134148,0.2157824039459229,0.5048211812973022,0,2,10,14,1,3,-1,10,15,1,1,3,-0.0035339309833943844,0.6465312242507935,0.4872696995735169,0,2,8,14,4,3,-1,8,15,4,1,3,0.005014411173760891,0.4617668092250824,0.6248074769973755,0,3,10,0,4,6,-1,12,0,2,3,2,10,3,2,3,2,0.0188173707574606,0.5220689177513123,0.2000052034854889,0,2,0,3,20,2,-1,0,4,20,1,2,-0.001343433978036046,0.4014537930488586,0.53016197681427,0,3,12,0,8,2,-1,16,0,4,1,2,12,1,4,1,2,0.001755796023644507,0.4794039130210877,0.5653169751167297,0,2,2,12,10,8,-1,2,16,10,4,2,-0.0956374630331993,0.2034195065498352,0.5006706714630127,0,3,17,7,2,10,-1,18,7,1,5,2,17,12,1,5,2,-0.0222412291914225,0.7672473192214966,0.5046340227127075,0,3,1,7,2,10,-1,1,7,1,5,2,2,12,1,5,2,-0.0155758196488023,0.7490342259407043,0.4755851030349731,0,2,15,10,3,6,-1,15,12,3,2,3,0.005359911825507879,0.5365303754806519,0.4004670977592468,0,2,4,4,6,2,-1,6,4,2,2,3,-0.0217634998261929,0.0740154981613159,0.4964174926280975,0,2,0,5,20,6,-1,0,7,20,2,3,-0.165615901350975,0.2859103083610535,0.5218086242675781,0,3,0,0,8,2,-1,0,0,4,1,2,4,1,4,1,2,0.0001646132004680112,0.4191615879535675,0.5380793213844299,0,2,1,0,18,4,-1,7,0,6,4,3,-0.008907750248908997,0.6273192763328552,0.4877404868602753,0,2,1,13,6,2,-1,1,14,6,1,2,0.0008634644909761846,0.5159940719604492,0.3671025931835175,0,2,10,8,3,4,-1,11,8,1,4,3,-0.0013751760125160217,0.5884376764297485,0.4579083919525147,0,2,6,1,6,1,-1,8,1,2,1,3,-0.0014081239933148026,0.3560509979724884,0.5139945149421692,0,2,8,14,4,3,-1,8,15,4,1,3,-0.003934288863092661,0.5994288921356201,0.466427206993103,0,2,1,6,18,2,-1,10,6,9,2,2,-0.0319669283926487,0.3345462083816528,0.5144183039665222,0,2,15,11,1,2,-1,15,12,1,1,2,-0.000015089280168467667,0.5582656264305115,0.441405713558197,0,2,6,5,1,2,-1,6,6,1,1,2,0.0005199447041377425,0.4623680114746094,0.6168993711471558,0,2,13,4,1,3,-1,13,5,1,1,3,-0.0034220460802316666,0.6557074785232544,0.4974805116653442,0,2,2,15,1,2,-1,2,16,1,1,2,0.00017723299970384687,0.5269501805305481,0.3901908099651337,0,2,12,4,4,3,-1,12,5,4,1,3,0.0015716759953647852,0.4633373022079468,0.5790457725524902,0,2,0,0,7,3,-1,0,1,7,1,3,-0.00890413299202919,0.2689608037471771,0.5053591132164001,0,2,9,12,6,2,-1,9,12,3,2,2,0.00040677518700249493,0.5456603169441223,0.4329898953437805,0,2,5,4,2,3,-1,5,5,2,1,3,0.0067604780197143555,0.4648993909358978,0.6689761877059937,0,2,18,4,2,3,-1,18,5,2,1,3,0.0029100088868290186,0.5309703946113586,0.3377839922904968,0,2,3,0,8,6,-1,3,2,8,2,3,0.0013885459629818797,0.4074738919734955,0.5349133014678955,0,3,0,2,20,6,-1,10,2,10,3,2,0,5,10,3,2,-0.0767642632126808,0.1992176026105881,0.522824227809906,0,2,4,7,2,4,-1,5,7,1,4,2,-0.00022688310127705336,0.5438501834869385,0.4253072142601013,0,2,3,10,15,2,-1,8,10,5,2,3,-0.006309415213763714,0.4259178936481476,0.5378909707069397,0,2,3,0,12,11,-1,9,0,6,11,2,-0.1100727990269661,0.6904156804084778,0.4721749126911163,0,2,13,0,2,6,-1,13,0,1,6,2,0.0002861965913325548,0.4524914920330048,0.5548306107521057,0,2,0,19,2,1,-1,1,19,1,1,2,0.00002942532955785282,0.5370373725891113,0.4236463904380798,0,3,16,10,4,10,-1,18,10,2,5,2,16,15,2,5,2,-0.0248865708708763,0.6423557996749878,0.4969303905963898,0,2,4,8,10,3,-1,4,9,10,1,3,0.0331488512456417,0.4988475143909454,0.1613811999559403,0,2,14,12,3,3,-1,14,13,3,1,3,0.0007849169196560979,0.541602611541748,0.4223009049892426,0,3,0,10,4,10,-1,0,10,2,5,2,2,15,2,5,2,0.004708718974143267,0.4576328992843628,0.6027557849884033,0,2,18,3,2,6,-1,18,5,2,2,3,0.0024144479539245367,0.530897319316864,0.4422498941421509,0,2,6,6,1,3,-1,6,7,1,1,3,0.0019523180089890957,0.4705634117126465,0.666332483291626,0,2,7,7,7,2,-1,7,8,7,1,2,0.0013031980488449335,0.4406126141548157,0.5526962280273438,0,2,0,3,2,6,-1,0,5,2,2,3,0.004473549779504538,0.5129023790359497,0.3301498889923096,0,2,11,1,3,1,-1,12,1,1,1,3,-0.002665286883711815,0.3135471045970917,0.5175036191940308,0,2,5,0,2,6,-1,6,0,1,6,2,0.0001366677024634555,0.4119370877742767,0.530687689781189,0,2,1,1,18,14,-1,7,1,6,14,3,-0.0171264503151178,0.6177806258201599,0.4836578965187073,0,2,4,6,8,3,-1,8,6,4,3,2,-0.0002660143072716892,0.3654330968856812,0.5169736742973328,0,2,9,12,6,2,-1,9,12,3,2,2,-0.022932380437851,0.349091500043869,0.5163992047309875,0,2,5,12,6,2,-1,8,12,3,2,2,0.0023316550068557262,0.5166299939155579,0.3709389865398407,0,2,10,7,3,5,-1,11,7,1,5,3,0.016925660893321,0.501473605632782,0.8053988218307495,0,2,7,7,3,5,-1,8,7,1,5,3,-0.008985882624983788,0.6470788717269897,0.465702086687088,0,2,13,0,3,10,-1,14,0,1,10,3,-0.0118746999651194,0.3246378898620606,0.5258755087852478,0,2,4,11,3,2,-1,4,12,3,1,2,0.00019350569345988333,0.5191941857337952,0.3839643895626068,0,2,17,3,3,6,-1,18,3,1,6,3,0.005871349014341831,0.4918133914470673,0.6187043190002441,0,2,1,8,18,10,-1,1,13,18,5,2,-0.2483879029750824,0.1836802959442139,0.4988150000572205,0,2,13,0,3,10,-1,14,0,1,10,3,0.0122560001909733,0.5227053761482239,0.3632029891014099,0,2,9,14,2,3,-1,9,15,2,1,3,0.0008399017970077693,0.4490250051021576,0.5774148106575012,0,2,16,3,3,7,-1,17,3,1,7,3,0.002540736924856901,0.4804787039756775,0.5858299136161804,0,2,4,0,3,10,-1,5,0,1,10,3,-0.0148224299773574,0.2521049976348877,0.5023537278175354,0,2,16,3,3,7,-1,17,3,1,7,3,-0.005797395948320627,0.5996695756912231,0.4853715002536774,0,2,0,9,1,2,-1,0,10,1,1,2,0.000726621481589973,0.5153716802597046,0.3671779930591583,0,2,18,1,2,10,-1,18,1,1,10,2,-0.0172325801104307,0.6621719002723694,0.4994656145572662,0,2,0,1,2,10,-1,1,1,1,10,2,0.007862408645451069,0.4633395075798035,0.6256101727485657,0,2,10,16,3,4,-1,11,16,1,4,3,-0.004734362009912729,0.3615573048591614,0.5281885266304016,0,2,2,8,3,3,-1,3,8,1,3,3,0.0008304847870022058,0.4442889094352722,0.5550957918167114,0,3,11,0,2,6,-1,12,0,1,3,2,11,3,1,3,2,0.00766021991148591,0.5162935256958008,0.2613354921340942,0,3,7,0,2,6,-1,7,0,1,3,2,8,3,1,3,2,-0.004104837775230408,0.2789632081985474,0.5019031763076782,0,2,16,3,3,7,-1,17,3,1,7,3,0.004851257894188166,0.4968984127044678,0.5661668181419373,0,2,1,3,3,7,-1,2,3,1,7,3,0.0009989645332098007,0.4445607960224152,0.5551813244819641,0,2,14,1,6,16,-1,16,1,2,16,3,-0.2702363133430481,0.0293882098048925,0.515131413936615,0,2,0,1,6,16,-1,2,1,2,16,3,-0.0130906803533435,0.5699399709701538,0.4447459876537323,0,3,2,0,16,8,-1,10,0,8,4,2,2,4,8,4,2,-0.009434279054403305,0.4305466115474701,0.5487895011901855,0,2,6,8,5,3,-1,6,9,5,1,3,-0.0015482039889320731,0.3680317103862763,0.512808084487915,0,2,9,7,3,3,-1,10,7,1,3,3,0.005374613218009472,0.4838916957378388,0.6101555824279785,0,2,8,8,4,3,-1,8,9,4,1,3,0.0015786769799888134,0.5325223207473755,0.4118548035621643,0,2,9,6,2,4,-1,9,6,1,4,2,0.003685605013743043,0.4810948073863983,0.6252303123474121,0,2,0,7,15,1,-1,5,7,5,1,3,0.009388701990246773,0.520022988319397,0.3629410862922669,0,2,8,2,7,9,-1,8,5,7,3,3,0.0127926301211119,0.4961709976196289,0.673801600933075,0,3,1,7,16,4,-1,1,7,8,2,2,9,9,8,2,2,-0.003366104094311595,0.4060279130935669,0.5283598899841309,0,2,6,12,8,2,-1,6,13,8,1,2,0.00039771420415490866,0.4674113988876343,0.5900775194168091,0,2,8,11,3,3,-1,8,12,3,1,3,0.0014868030557408929,0.4519116878509522,0.6082053780555725,0,3,4,5,14,10,-1,11,5,7,5,2,4,10,7,5,2,-0.0886867493391037,0.2807899117469788,0.5180991888046265,0,2,4,12,3,2,-1,4,13,3,1,2,-0.00007429611287079751,0.5295584201812744,0.408762514591217,0,2,9,11,6,1,-1,11,11,2,1,3,-0.000014932939848222304,0.5461400151252747,0.4538542926311493,0,2,4,9,7,6,-1,4,11,7,2,3,0.005916223861277103,0.5329161286354065,0.4192134141921997,0,2,7,10,6,3,-1,7,11,6,1,3,0.001114164013415575,0.4512017965316773,0.5706217288970947,0,2,9,11,2,2,-1,9,12,2,1,2,0.00008924936264520511,0.4577805995941162,0.5897638201713562,0,2,0,5,20,6,-1,0,7,20,2,3,0.0025319510605186224,0.5299603939056396,0.3357639014720917,0,2,6,4,6,1,-1,8,4,2,1,3,0.0124262003228068,0.4959059059619904,0.1346601992845535,0,2,9,11,6,1,-1,11,11,2,1,3,0.0283357501029968,0.5117079019546509,0.0006104363710619509,0,2,5,11,6,1,-1,7,11,2,1,3,0.006616588216274977,0.4736349880695343,0.7011628150939941,0,2,10,16,3,4,-1,11,16,1,4,3,0.008046876639127731,0.5216417908668518,0.3282819986343384,0,2,8,7,3,3,-1,9,7,1,3,3,-0.001119398046284914,0.5809860825538635,0.4563739001750946,0,2,2,12,16,8,-1,2,16,16,4,2,0.0132775902748108,0.5398362278938293,0.4103901088237763,0,2,0,15,15,2,-1,0,16,15,1,2,0.0004879473999608308,0.424928605556488,0.5410590767860413,0,2,15,4,5,6,-1,15,6,5,2,3,0.0112431701272726,0.526996374130249,0.3438215851783752,0,2,9,5,2,4,-1,10,5,1,4,2,-0.0008989666821435094,0.5633075833320618,0.4456613063812256,0,2,8,10,9,6,-1,8,12,9,2,3,0.006667715962976217,0.5312889218330383,0.4362679123878479,0,2,2,19,15,1,-1,7,19,5,1,3,0.0289472993463278,0.4701794981956482,0.657579779624939,0,2,10,16,3,4,-1,11,16,1,4,3,-0.0234000496566296,0,0.5137398838996887,0,2,0,15,20,4,-1,0,17,20,2,2,-0.0891170501708984,0.0237452797591686,0.4942430853843689,0,2,10,16,3,4,-1,11,16,1,4,3,-0.0140546001493931,0.3127323091030121,0.511751115322113,0,2,7,16,3,4,-1,8,16,1,4,3,0.008123939856886864,0.50090491771698,0.2520025968551636,0,2,9,16,3,3,-1,9,17,3,1,3,-0.004996465053409338,0.6387143731117249,0.4927811920642853,0,2,8,11,4,6,-1,8,14,4,3,2,0.0031253970228135586,0.5136849880218506,0.3680452108383179,0,2,9,6,2,12,-1,9,10,2,4,3,0.006766964215785265,0.5509843826293945,0.4363631904125214,0,2,8,17,4,3,-1,8,18,4,1,3,-0.002371144015341997,0.6162335276603699,0.4586946964263916,0,3,9,18,8,2,-1,13,18,4,1,2,9,19,4,1,2,-0.005352279171347618,0.6185457706451416,0.4920490980148315,0,2,1,18,8,2,-1,1,19,8,1,2,-0.0159688591957092,0.1382617950439453,0.4983252882957459,0,2,13,5,6,15,-1,15,5,2,15,3,0.004767606034874916,0.4688057899475098,0.5490046143531799,0,2,9,8,2,2,-1,9,9,2,1,2,-0.002471469109877944,0.2368514984846115,0.5003952980041504,0,2,9,5,2,3,-1,9,5,1,3,2,-0.0007103378884494305,0.5856394171714783,0.4721533060073853,0,2,1,5,6,15,-1,3,5,2,15,3,-0.1411755979061127,0.0869000628590584,0.4961591064929962,0,3,4,1,14,8,-1,11,1,7,4,2,4,5,7,4,2,0.1065180972218514,0.5138837099075317,0.1741005033254623,0,3,2,4,4,16,-1,2,4,2,8,2,4,12,2,8,2,-0.0527447499334812,0.7353636026382446,0.4772881865501404,0,2,12,4,3,12,-1,12,10,3,6,2,-0.00474317604675889,0.3884406089782715,0.5292701721191406,0,3,4,5,10,12,-1,4,5,5,6,2,9,11,5,6,2,0.0009967676596716046,0.5223492980003357,0.4003424048423767,0,2,9,14,2,3,-1,9,15,2,1,3,0.00802841316908598,0.4959106147289276,0.7212964296340942,0,2,5,4,2,3,-1,5,5,2,1,3,0.0008602585876360536,0.4444884061813355,0.55384761095047,0,3,12,2,4,10,-1,14,2,2,5,2,12,7,2,5,2,0.0009319150121882558,0.539837121963501,0.4163244068622589,0,2,6,4,7,3,-1,6,5,7,1,3,-0.002508206060156226,0.5854265093803406,0.456250011920929,0,3,2,0,18,2,-1,11,0,9,1,2,2,1,9,1,2,-0.0021378761157393456,0.4608069062232971,0.5280259251594543,0,3,0,0,18,2,-1,0,0,9,1,2,9,1,9,1,2,-0.002154604997485876,0.3791126906871796,0.5255997180938721,0,3,13,13,4,6,-1,15,13,2,3,2,13,16,2,3,2,-0.007621400989592075,0.5998609066009521,0.4952073991298676,0,3,3,13,4,6,-1,3,13,2,3,2,5,16,2,3,2,0.002205536002293229,0.4484206140041351,0.5588530898094177,0,2,10,12,2,6,-1,10,15,2,3,2,0.0012586950324475765,0.5450747013092041,0.4423840939998627,0,3,5,9,10,10,-1,5,9,5,5,2,10,14,5,5,2,-0.005092672072350979,0.4118275046348572,0.5263035893440247,0,3,11,4,4,2,-1,13,4,2,1,2,11,5,2,1,2,-0.0025095739401876926,0.5787907838821411,0.4998494982719421,0,2,7,12,6,8,-1,10,12,3,8,2,-0.0773275569081306,0.8397865891456604,0.481112003326416,0,3,12,2,4,10,-1,14,2,2,5,2,12,7,2,5,2,-0.041485819965601,0.240861102938652,0.5176993012428284,0,2,8,11,2,1,-1,9,11,1,1,2,0.00010355669655837119,0.4355360865592957,0.5417054295539856,0,2,10,5,1,12,-1,10,9,1,4,3,0.0013255809899419546,0.5453971028327942,0.4894095063209534,0,2,0,11,6,9,-1,3,11,3,9,2,-0.00805987324565649,0.5771024227142334,0.4577918946743012,0,3,12,2,4,10,-1,14,2,2,5,2,12,7,2,5,2,0.019058620557189,0.5169867873191833,0.3400475084781647,0,3,4,2,4,10,-1,4,2,2,5,2,6,7,2,5,2,-0.0350578911602497,0.2203243970870972,0.5000503063201904,0,3,11,4,4,2,-1,13,4,2,1,2,11,5,2,1,2,0.005729605909436941,0.5043408274650574,0.6597570776939392,0,2,0,14,6,3,-1,0,15,6,1,3,-0.0116483299061656,0.2186284959316254,0.4996652901172638,0,3,11,4,4,2,-1,13,4,2,1,2,11,5,2,1,2,0.0014544479781761765,0.5007681846618652,0.5503727793693542,0,2,6,1,3,2,-1,7,1,1,2,3,-0.00025030909455381334,0.4129841029644013,0.524167001247406,0,3,11,4,4,2,-1,13,4,2,1,2,11,5,2,1,2,-0.000829072727356106,0.541286826133728,0.4974496066570282,0,3,5,4,4,2,-1,5,4,2,1,2,7,5,2,1,2,0.0010862209601327777,0.460552990436554,0.5879228711128235,0,3,13,0,2,12,-1,14,0,1,6,2,13,6,1,6,2,0.0002000050008064136,0.5278854966163635,0.4705209136009216,0,2,6,0,3,10,-1,7,0,1,10,3,0.0029212920926511288,0.5129609704017639,0.375553697347641,0,2,3,0,17,8,-1,3,4,17,4,2,0.0253874007612467,0.4822691977024078,0.5790768265724182,0,2,0,4,20,4,-1,0,6,20,2,2,-0.00319684692658484,0.5248395204544067,0.3962840139865875,90.25334930419922,182,0,2,0,3,8,2,-1,4,3,4,2,2,0.005803173873573542,0.3498983979225159,0.596198320388794,0,2,8,11,4,3,-1,8,12,4,1,3,-0.009000306949019432,0.6816636919975281,0.4478552043437958,0,3,5,7,6,4,-1,5,7,3,2,2,8,9,3,2,2,-0.00115496595390141,0.5585706233978271,0.3578251004219055,0,2,8,3,4,9,-1,8,6,4,3,3,-0.0011069850297644734,0.5365036129951477,0.3050428032875061,0,2,8,15,1,4,-1,8,17,1,2,2,0.00010308309720130637,0.363909512758255,0.5344635844230652,0,2,4,5,12,7,-1,8,5,4,7,3,-0.005098483990877867,0.2859157025814056,0.5504264831542969,0,3,4,2,4,10,-1,4,2,2,5,2,6,7,2,5,2,0.0008257220033556223,0.5236523747444153,0.3476041853427887,0,2,3,0,17,2,-1,3,1,17,1,2,0.009978332556784153,0.4750322103500366,0.621964693069458,0,2,2,2,16,15,-1,2,7,16,5,3,-0.0374025292694569,0.334337592124939,0.527806282043457,0,2,15,2,5,2,-1,15,3,5,1,2,0.0048548257909715176,0.5192180871963501,0.3700444102287293,0,2,9,3,2,2,-1,10,3,1,2,2,-0.001866447040811181,0.2929843962192535,0.5091944932937622,0,2,4,5,16,15,-1,4,10,16,5,3,0.0168888904154301,0.3686845898628235,0.5431225895881653,0,2,7,13,5,6,-1,7,16,5,3,2,-0.005837262142449617,0.3632183969020844,0.5221335887908936,0,2,10,7,3,2,-1,11,7,1,2,3,-0.00147137395106256,0.5870683789253235,0.4700650870800018,0,2,8,3,3,1,-1,9,3,1,1,3,-0.0011522950371727347,0.3195894956588745,0.5140954256057739,0,2,9,16,3,3,-1,9,17,3,1,3,-0.004256030078977346,0.6301859021186829,0.4814921021461487,0,2,0,2,5,2,-1,0,3,5,1,2,-0.006737829186022282,0.1977048069238663,0.5025808215141296,0,2,12,5,4,3,-1,12,6,4,1,3,0.0113826701417565,0.495413213968277,0.6867045760154724,0,2,1,7,12,1,-1,5,7,4,1,3,0.005179470870643854,0.5164427757263184,0.3350647985935211,0,2,7,5,6,14,-1,7,12,6,7,2,-0.1174378991127014,0.2315246015787125,0.5234413743019104,0,3,0,0,8,10,-1,0,0,4,5,2,4,5,4,5,2,0.0287034492939711,0.4664297103881836,0.6722521185874939,0,2,9,1,3,2,-1,10,1,1,2,3,0.004823103081434965,0.5220875144004822,0.2723532915115356,0,2,8,1,3,2,-1,9,1,1,2,3,0.0026798530016094446,0.5079277157783508,0.2906948924064636,0,2,12,4,3,3,-1,12,5,3,1,3,0.008050408214330673,0.4885950982570648,0.6395021080970764,0,2,7,4,6,16,-1,7,12,6,8,2,0.004805495962500572,0.5197256803512573,0.365666389465332,0,2,12,4,3,3,-1,12,5,3,1,3,-0.0022420159075409174,0.6153467893600464,0.4763701856136322,0,2,2,3,2,6,-1,2,5,2,2,3,-0.0137577103450894,0.2637344896793366,0.5030903220176697,0,2,14,2,6,9,-1,14,5,6,3,3,-0.1033829972147942,0.2287521958351135,0.5182461142539978,0,2,5,4,3,3,-1,5,5,3,1,3,-0.009443208575248718,0.6953303813934326,0.4694949090480804,0,2,9,17,3,2,-1,10,17,1,2,3,0.0008027118165045977,0.5450655221939087,0.4268783926963806,0,2,5,5,2,3,-1,5,6,2,1,3,-0.004194566980004311,0.6091387867927551,0.4571642875671387,0,2,13,11,3,6,-1,13,13,3,2,3,0.0109422104433179,0.5241063237190247,0.3284547030925751,0,2,3,14,2,6,-1,3,17,2,3,2,-0.0005784106906503439,0.5387929081916809,0.4179368913173676,0,2,14,3,6,2,-1,14,4,6,1,2,-0.002088862005621195,0.4292691051959992,0.5301715731620789,0,2,0,8,16,2,-1,0,9,16,1,2,0.0032383969519287348,0.379234790802002,0.5220744013786316,0,2,14,3,6,2,-1,14,4,6,1,2,0.004907502792775631,0.5237283110618591,0.4126757979393005,0,2,0,0,5,6,-1,0,2,5,2,3,-0.0322779417037964,0.1947655975818634,0.4994502067565918,0,2,12,5,4,3,-1,12,6,4,1,3,-0.008971123024821281,0.6011285185813904,0.4929032027721405,0,2,4,11,3,6,-1,4,13,3,2,3,0.0153210898861289,0.5009753704071045,0.2039822041988373,0,2,12,5,4,3,-1,12,6,4,1,3,0.002085556974634528,0.4862189888954163,0.5721694827079773,0,2,9,5,1,3,-1,9,6,1,1,3,0.005061502102762461,0.5000218749046326,0.1801805943250656,0,2,12,5,4,3,-1,12,6,4,1,3,-0.0037174751050770283,0.5530117154121399,0.4897592961788178,0,2,6,6,8,12,-1,6,12,8,6,2,-0.0121705001220107,0.4178605973720551,0.5383723974227905,0,2,12,5,4,3,-1,12,6,4,1,3,0.004624839872121811,0.4997169971466065,0.5761327147483826,0,2,5,12,9,2,-1,8,12,3,2,3,-0.0002104042941937223,0.5331807136535645,0.4097681045532227,0,2,12,5,4,3,-1,12,6,4,1,3,-0.0146417804062366,0.5755925178527832,0.5051776170730591,0,2,4,5,4,3,-1,4,6,4,1,3,0.00331994891166687,0.4576976895332336,0.6031805872917175,0,2,6,6,9,2,-1,9,6,3,2,3,0.003723687957972288,0.4380396902561188,0.541588306427002,0,2,4,11,1,3,-1,4,12,1,1,3,0.0008295116131193936,0.5163031816482544,0.3702219128608704,0,2,14,12,6,6,-1,14,12,3,6,2,-0.0114084901288152,0.6072946786880493,0.4862565100193024,0,2,7,0,3,7,-1,8,0,1,7,3,-0.004532012157142162,0.3292475938796997,0.5088962912559509,0,2,9,8,3,3,-1,10,8,1,3,3,0.00512760179117322,0.4829767942428589,0.6122708916664124,0,2,8,8,3,3,-1,9,8,1,3,3,0.00985831581056118,0.4660679996013641,0.6556177139282227,0,2,5,10,11,3,-1,5,11,11,1,3,0.036985918879509,0.5204849243164062,0.1690472066402435,0,2,5,7,10,1,-1,10,7,5,1,2,0.004649116192013025,0.5167322158813477,0.3725225031375885,0,2,9,7,3,2,-1,10,7,1,2,3,-0.004266470205038786,0.6406493186950684,0.4987342953681946,0,2,8,7,3,2,-1,9,7,1,2,3,-0.0004795659042429179,0.5897293090820312,0.4464873969554901,0,2,11,9,4,2,-1,11,9,2,2,2,0.0036827160511165857,0.5441560745239258,0.347266286611557,0,2,5,9,4,2,-1,7,9,2,2,2,-0.0100598800927401,0.2143162935972214,0.500482976436615,0,2,14,10,2,4,-1,14,12,2,2,2,-0.0003036184061784297,0.538642406463623,0.4590323865413666,0,2,7,7,3,2,-1,8,7,1,2,3,-0.0014545479789376259,0.5751184225082397,0.4497095048427582,0,2,14,17,6,3,-1,14,18,6,1,3,0.0016515209572389722,0.5421937704086304,0.4238520860671997,0,3,4,5,12,12,-1,4,5,6,6,2,10,11,6,6,2,-0.007846863940358162,0.4077920913696289,0.5258157253265381,0,3,6,9,8,8,-1,10,9,4,4,2,6,13,4,4,2,-0.005125985015183687,0.422927588224411,0.5479453206062317,0,2,0,4,15,4,-1,5,4,5,4,3,-0.0368909612298012,0.6596375703811646,0.4674678146839142,0,2,13,2,4,1,-1,13,2,2,1,2,0.0002403563994448632,0.4251135885715485,0.5573202967643738,0,2,4,12,2,2,-1,4,13,2,1,2,-0.000015150169929256663,0.5259246826171875,0.4074114859104157,0,2,8,13,4,3,-1,8,14,4,1,3,0.0022108471021056175,0.4671722948551178,0.5886352062225342,0,2,9,13,2,3,-1,9,14,2,1,3,-0.0011568620102480054,0.5711066126823425,0.4487161934375763,0,2,13,11,2,3,-1,13,12,2,1,3,0.004999629221856594,0.5264198184013367,0.2898327112197876,0,3,7,12,4,4,-1,7,12,2,2,2,9,14,2,2,2,-0.0014656189596280456,0.3891738057136536,0.5197871923446655,0,3,10,11,2,2,-1,11,11,1,1,2,10,12,1,1,2,-0.0011975039960816503,0.5795872807502747,0.4927955865859985,0,2,8,17,3,2,-1,9,17,1,2,3,-0.0044954330660402775,0.2377603054046631,0.5012555122375488,0,3,10,11,2,2,-1,11,11,1,1,2,10,12,1,1,2,0.00014997160178609192,0.4876626133918762,0.5617607831954956,0,2,0,17,6,3,-1,0,18,6,1,3,0.002639150945469737,0.516808807849884,0.3765509128570557,0,3,10,11,2,2,-1,11,11,1,1,2,10,12,1,1,2,-0.0002936813107226044,0.5446649193763733,0.4874630868434906,0,3,8,11,2,2,-1,8,11,1,1,2,9,12,1,1,2,0.0014211760135367513,0.4687897861003876,0.669133186340332,0,2,12,5,8,4,-1,12,5,4,4,2,0.0794276371598244,0.5193443894386292,0.273294597864151,0,2,0,5,8,4,-1,4,5,4,4,2,0.0799375027418137,0.4971731007099152,0.1782083958387375,0,2,13,2,4,1,-1,13,2,2,1,2,0.0110892597585917,0.5165994763374329,0.3209475874900818,0,2,3,2,4,1,-1,5,2,2,1,2,0.00016560709627810866,0.4058471918106079,0.5307276248931885,0,3,10,0,4,2,-1,12,0,2,1,2,10,1,2,1,2,-0.0053354292176663876,0.3445056974887848,0.5158129930496216,0,2,7,12,3,1,-1,8,12,1,1,3,0.0011287260567769408,0.4594863057136536,0.6075533032417297,0,3,8,11,4,8,-1,10,11,2,4,2,8,15,2,4,2,-0.0219692196696997,0.1680400967597961,0.5228595733642578,0,2,9,9,2,2,-1,9,10,2,1,2,-0.00021775320055894554,0.3861596882343292,0.5215672850608826,0,2,3,18,15,2,-1,3,19,15,1,2,0.00020200149447191507,0.5517979264259338,0.4363039135932922,0,3,2,6,2,12,-1,2,6,1,6,2,3,12,1,6,2,-0.0217331498861313,0.7999460101127625,0.4789851009845734,0,2,9,8,2,3,-1,9,9,2,1,3,-0.0008439993252977729,0.4085975885391235,0.5374773144721985,0,2,7,10,3,2,-1,8,10,1,2,3,-0.00043895249837078154,0.5470405220985413,0.4366143047809601,0,2,11,11,3,1,-1,12,11,1,1,3,0.0015092400135472417,0.4988996982574463,0.5842149257659912,0,2,6,11,3,1,-1,7,11,1,1,3,-0.003554783994331956,0.6753690242767334,0.4721005856990814,0,3,9,2,4,2,-1,11,2,2,1,2,9,3,2,1,2,0.00048191400128416717,0.541585385799408,0.4357109069824219,0,2,4,12,2,3,-1,4,13,2,1,3,-0.00602643983438611,0.2258509993553162,0.499188095331192,0,2,2,1,18,3,-1,8,1,6,3,3,-0.0116681400686502,0.625655472278595,0.4927498996257782,0,2,5,1,4,14,-1,7,1,2,14,2,-0.0028718370012938976,0.3947784900665283,0.524580180644989,0,2,8,16,12,3,-1,8,16,6,3,2,0.0170511696487665,0.4752511084079742,0.5794224143028259,0,2,1,17,18,3,-1,7,17,6,3,3,-0.0133520802482963,0.6041104793548584,0.4544535875320435,0,2,9,14,2,6,-1,9,17,2,3,2,-0.0003930180100724101,0.4258275926113129,0.5544905066490173,0,2,9,12,1,8,-1,9,16,1,4,2,0.0030483349692076445,0.5233420133590698,0.3780272901058197,0,2,9,14,2,3,-1,9,15,2,1,3,-0.00435792887583375,0.6371889114379883,0.4838674068450928,0,2,9,6,2,12,-1,9,10,2,4,3,0.0056661018170416355,0.5374705791473389,0.4163666069507599,0,2,12,9,3,3,-1,12,10,3,1,3,0.00006067733920644969,0.4638795852661133,0.5311625003814697,0,2,0,1,4,8,-1,2,1,2,8,2,0.0367381609976292,0.4688656032085419,0.6466524004936218,0,3,9,1,6,2,-1,12,1,3,1,2,9,2,3,1,2,0.008652813732624054,0.5204318761825562,0.2188657969236374,0,2,1,3,12,14,-1,1,10,12,7,2,-0.1537135988473892,0.1630371958017349,0.4958840012550354,0,3,8,12,4,2,-1,10,12,2,1,2,8,13,2,1,2,-0.00041560421232134104,0.577445924282074,0.4696458876132965,0,3,1,9,10,2,-1,1,9,5,1,2,6,10,5,1,2,-0.0012640169588848948,0.3977175951004028,0.5217198133468628,0,2,8,15,4,3,-1,8,16,4,1,3,-0.003547334112226963,0.6046528220176697,0.480831503868103,0,2,6,8,8,3,-1,6,9,8,1,3,0.00003001906952704303,0.3996723890304565,0.5228201150894165,0,2,9,15,5,3,-1,9,16,5,1,3,0.00131130195222795,0.4712158143520355,0.5765997767448425,0,2,8,7,4,3,-1,8,8,4,1,3,-0.0013374709524214268,0.4109584987163544,0.5253170132637024,0,2,7,7,6,2,-1,7,8,6,1,2,0.0208767093718052,0.5202993750572205,0.1757981926202774,0,3,5,7,8,2,-1,5,7,4,1,2,9,8,4,1,2,-0.007549794856458902,0.6566609740257263,0.4694975018501282,0,2,12,9,3,3,-1,12,10,3,1,3,0.0241885501891375,0.5128673911094666,0.3370220959186554,0,2,4,7,4,2,-1,4,8,4,1,2,-0.002935882890596986,0.658078670501709,0.4694541096687317,0,2,14,2,6,9,-1,14,5,6,3,3,0.0575579293072224,0.5146445035934448,0.2775259912014008,0,2,4,9,3,3,-1,5,9,1,3,3,-0.0011343370424583554,0.3836601972579956,0.5192667245864868,0,2,12,9,3,3,-1,12,10,3,1,3,0.0168169997632504,0.5085592865943909,0.6177260875701904,0,2,0,2,6,9,-1,0,5,6,3,3,0.005053517874330282,0.5138763189315796,0.3684791922569275,0,2,17,3,3,6,-1,18,3,1,6,3,-0.004587471019476652,0.5989655256271362,0.4835202097892761,0,2,0,3,3,6,-1,1,3,1,6,3,0.001688246033154428,0.4509486854076386,0.5723056793212891,0,2,17,14,1,2,-1,17,15,1,1,2,-0.0016554000321775675,0.3496770858764648,0.5243319272994995,0,2,4,9,4,3,-1,6,9,2,3,2,-0.0193738006055355,0.1120536997914314,0.496871292591095,0,2,12,9,3,3,-1,12,10,3,1,3,0.0103744501248002,0.5148196816444397,0.4395213127136231,0,2,5,9,3,3,-1,5,10,3,1,3,0.00014973050565458834,0.4084999859333038,0.526988685131073,0,3,9,5,6,8,-1,12,5,3,4,2,9,9,3,4,2,-0.042981930077076,0.6394104957580566,0.501850426197052,0,3,5,5,6,8,-1,5,5,3,4,2,8,9,3,4,2,0.008306593634188175,0.470755398273468,0.6698353290557861,0,2,16,1,4,6,-1,16,4,4,3,2,-0.0041285790503025055,0.4541369080543518,0.5323647260665894,0,2,1,0,6,20,-1,3,0,2,20,3,0.0017399420030415058,0.433396190404892,0.5439866185188293,0,2,12,11,3,2,-1,13,11,1,2,3,0.00011739750334527344,0.4579687118530273,0.5543426275253296,0,2,5,11,3,2,-1,6,11,1,2,3,0.00018585780344437808,0.4324643909931183,0.5426754951477051,0,2,9,4,6,1,-1,11,4,2,1,3,0.005558769218623638,0.525722086429596,0.3550611138343811,0,2,0,0,8,3,-1,4,0,4,3,2,-0.007985156029462814,0.6043018102645874,0.4630635976791382,0,2,15,0,2,5,-1,15,0,1,5,2,0.0006059412262402475,0.4598254859447479,0.55331951379776,0,2,4,1,3,2,-1,5,1,1,2,3,-0.0002298304025316611,0.4130752086639404,0.5322461128234863,0,2,7,0,6,15,-1,9,0,2,15,3,0.0004374021082185209,0.4043039977550507,0.5409289002418518,0,2,6,11,3,1,-1,7,11,1,1,3,0.0002948202018160373,0.4494963884353638,0.5628852248191833,0,2,12,0,3,4,-1,13,0,1,4,3,0.0103126596659422,0.5177510976791382,0.2704316973686218,0,2,5,4,6,1,-1,7,4,2,1,3,-0.007724110968410969,0.1988019049167633,0.4980553984642029,0,2,12,7,3,2,-1,12,8,3,1,2,-0.004679720848798752,0.6644750237464905,0.5018296241760254,0,2,0,1,4,6,-1,0,4,4,3,2,-0.005075545981526375,0.3898304998874664,0.5185269117355347,0,2,12,7,3,2,-1,12,8,3,1,2,0.00224797404371202,0.4801808893680573,0.5660336017608643,0,2,2,16,3,3,-1,2,17,3,1,3,0.0008332700817845762,0.5210919976234436,0.3957188129425049,0,3,13,8,6,10,-1,16,8,3,5,2,13,13,3,5,2,-0.0412793308496475,0.6154541969299316,0.5007054209709167,0,2,0,9,5,2,-1,0,10,5,1,2,-0.0005093018990010023,0.3975942134857178,0.5228403806686401,0,3,12,11,2,2,-1,13,11,1,1,2,12,12,1,1,2,0.0012568780221045017,0.4979138076305389,0.5939183235168457,0,2,3,15,3,3,-1,3,16,3,1,3,0.008004849776625633,0.4984497129917145,0.1633366048336029,0,2,12,7,3,2,-1,12,8,3,1,2,-0.0011879300000146031,0.5904964804649353,0.4942624866962433,0,2,5,7,3,2,-1,5,8,3,1,2,0.0006194895249791443,0.4199557900428772,0.5328726172447205,0,2,9,5,9,9,-1,9,8,9,3,3,0.006682985927909613,0.5418602824211121,0.490588903427124,0,2,5,0,3,7,-1,6,0,1,7,3,-0.0037062340416014194,0.3725939095020294,0.5138000249862671,0,2,5,2,12,5,-1,9,2,4,5,3,-0.0397394113242626,0.6478961110115051,0.5050346851348877,0,3,6,11,2,2,-1,6,11,1,1,2,7,12,1,1,2,0.0014085009461268783,0.4682339131832123,0.6377884149551392,0,2,15,15,3,2,-1,15,16,3,1,2,0.0003932268882635981,0.5458530187606812,0.415048211812973,0,2,2,15,3,2,-1,2,16,3,1,2,-0.0018979819724336267,0.3690159916877747,0.5149704217910767,0,3,14,12,6,8,-1,17,12,3,4,2,14,16,3,4,2,-0.0139704402536154,0.6050562858581543,0.4811357855796814,0,2,2,8,15,6,-1,7,8,5,6,3,-0.1010081991553307,0.2017080038785934,0.4992361962795258,0,2,2,2,18,17,-1,8,2,6,17,3,-0.0173469204455614,0.5713148713111877,0.4899486005306244,0,2,5,1,4,1,-1,7,1,2,1,2,0.000156197595060803,0.4215388894081116,0.5392642021179199,0,2,5,2,12,5,-1,9,2,4,5,3,0.1343892961740494,0.5136151909828186,0.3767612874507904,0,2,3,2,12,5,-1,7,2,4,5,3,-0.0245822407305241,0.7027357816696167,0.4747906923294067,0,3,4,9,12,4,-1,10,9,6,2,2,4,11,6,2,2,-0.0038553720805794,0.4317409098148346,0.5427716970443726,0,3,5,15,6,2,-1,5,15,3,1,2,8,16,3,1,2,-0.002316524973139167,0.594269871711731,0.4618647992610931,0,2,10,14,2,3,-1,10,15,2,1,3,-0.004851812031120062,0.6191568970680237,0.4884895086288452,0,3,0,13,20,2,-1,0,13,10,1,2,10,14,10,1,2,0.002469993894919753,0.5256664752960205,0.4017199873924255,0,3,4,9,12,8,-1,10,9,6,4,2,4,13,6,4,2,0.0454969592392445,0.5237867832183838,0.2685773968696594,0,2,8,13,3,6,-1,8,16,3,3,2,-0.0203195996582508,0.213044598698616,0.4979738891124725,0,2,10,12,2,2,-1,10,13,2,1,2,0.0002699499891605228,0.481404185295105,0.5543122291564941,0,3,9,12,2,2,-1,9,12,1,1,2,10,13,1,1,2,-0.0018232699949294329,0.6482579708099365,0.4709989130496979,0,3,4,11,14,4,-1,11,11,7,2,2,4,13,7,2,2,-0.006301579065620899,0.4581927955150604,0.5306236147880554,0,2,8,5,4,2,-1,8,6,4,1,2,-0.0002413949987385422,0.5232086777687073,0.4051763117313385,0,2,10,10,6,3,-1,12,10,2,3,3,-0.001033036969602108,0.5556201934814453,0.4789193868637085,0,2,2,14,1,2,-1,2,15,1,1,2,0.0001804116036510095,0.5229442715644836,0.4011810123920441,0,3,13,8,6,12,-1,16,8,3,6,2,13,14,3,6,2,-0.0614078603684902,0.62986820936203,0.5010703206062317,0,3,1,8,6,12,-1,1,8,3,6,2,4,14,3,6,2,-0.0695439130067825,0.7228280901908875,0.4773184061050415,0,2,10,0,6,10,-1,12,0,2,10,3,-0.0705426633358002,0.2269513010978699,0.5182529091835022,0,3,5,11,8,4,-1,5,11,4,2,2,9,13,4,2,2,0.0024423799477517605,0.5237097144126892,0.4098151028156281,0,3,10,16,8,4,-1,14,16,4,2,2,10,18,4,2,2,0.0015494349645450711,0.4773750901222229,0.5468043088912964,0,2,7,7,6,6,-1,9,7,2,6,3,-0.0239142198115587,0.7146975994110107,0.4783824980258942,0,2,10,2,4,10,-1,10,2,2,10,2,-0.0124536901712418,0.2635296881198883,0.5241122841835022,0,2,6,1,4,9,-1,8,1,2,9,2,-0.00020760179904755205,0.3623757064342499,0.5113608837127686,0,2,12,19,2,1,-1,12,19,1,1,2,0.000029781080229440704,0.4705932140350342,0.5432801842689514,104.74919891357422,211,0,2,1,2,4,9,-1,3,2,2,9,2,0.0117727499455214,0.3860518932342529,0.6421167254447937,0,2,7,5,6,4,-1,9,5,2,4,3,0.0270375702530146,0.4385654926300049,0.675403892993927,0,2,9,4,2,4,-1,9,6,2,2,2,-0.00003641950024757534,0.5487101078033447,0.34233158826828,0,2,14,5,2,8,-1,14,9,2,4,2,0.001999540952965617,0.3230532109737396,0.5400317907333374,0,2,7,6,5,12,-1,7,12,5,6,2,0.0045278300531208515,0.5091639757156372,0.2935043871402741,0,2,14,6,2,6,-1,14,9,2,3,2,0.00047890920541249216,0.4178153872489929,0.5344064235687256,0,2,4,6,2,6,-1,4,9,2,3,2,0.0011720920447260141,0.2899182140827179,0.5132070779800415,0,3,8,15,10,4,-1,13,15,5,2,2,8,17,5,2,2,0.0009530570241622627,0.428012490272522,0.5560845136642456,0,2,6,18,2,2,-1,7,18,1,2,2,0.000015099150004971307,0.4044871926307678,0.5404760241508484,0,2,11,3,6,2,-1,11,4,6,1,2,-0.0006081790197640657,0.4271768927574158,0.5503466129302979,0,2,2,0,16,6,-1,2,2,16,2,3,0.003322452073916793,0.3962723910808563,0.5369734764099121,0,2,11,3,6,2,-1,11,4,6,1,2,-0.0011037490330636501,0.4727177917957306,0.5237749814987183,0,2,4,11,10,3,-1,4,12,10,1,3,-0.0014350269921123981,0.5603008270263672,0.4223509132862091,0,2,11,3,6,2,-1,11,4,6,1,2,0.0020767399109899998,0.5225917100906372,0.4732725918292999,0,2,3,3,6,2,-1,3,4,6,1,2,-0.00016412809782195836,0.3999075889587402,0.5432739853858948,0,2,16,0,4,7,-1,16,0,2,7,2,0.008830243721604347,0.4678385853767395,0.6027327179908752,0,2,0,14,9,6,-1,0,16,9,2,3,-0.0105520701035857,0.3493967056274414,0.5213974714279175,0,2,9,16,3,3,-1,9,17,3,1,3,-0.00227316003292799,0.6185818910598755,0.4749062955379486,0,2,4,6,6,2,-1,6,6,2,2,3,-0.0008478633244521916,0.5285341143608093,0.3843482136726379,0,2,15,11,1,3,-1,15,12,1,1,3,0.0012081359745934606,0.536064088344574,0.3447335958480835,0,2,5,5,2,3,-1,5,6,2,1,3,0.002651273040100932,0.4558292031288147,0.6193962097167969,0,2,10,9,2,2,-1,10,10,2,1,2,-0.0011012479662895203,0.368023008108139,0.5327628254890442,0,2,3,1,4,3,-1,5,1,2,3,2,0.0004956151824444532,0.396059513092041,0.5274940729141235,0,2,16,0,4,7,-1,16,0,2,7,2,-0.0439017713069916,0.7020444869995117,0.4992839097976685,0,2,0,0,20,1,-1,10,0,10,1,2,0.0346903502941132,0.5049164295196533,0.276660293340683,0,2,15,11,1,3,-1,15,12,1,1,3,-0.002744219033047557,0.2672632932662964,0.5274971127510071,0,2,0,4,3,4,-1,1,4,1,4,3,0.003331658896058798,0.4579482972621918,0.6001101732254028,0,2,16,3,3,6,-1,16,5,3,2,3,-0.0200445707887411,0.3171594142913818,0.523571789264679,0,2,1,3,3,6,-1,1,5,3,2,3,0.0013492030557245016,0.5265362858772278,0.4034324884414673,0,3,6,2,12,6,-1,12,2,6,3,2,6,5,6,3,2,0.0029702018946409225,0.5332456827163696,0.4571984112262726,0,2,8,10,4,3,-1,8,11,4,1,3,0.006303998176008463,0.4593310952186585,0.6034635901451111,0,3,4,2,14,6,-1,11,2,7,3,2,4,5,7,3,2,-0.0129365902394056,0.4437963962554932,0.5372971296310425,0,2,9,11,2,3,-1,9,12,2,1,3,0.004014872945845127,0.4680323898792267,0.6437833905220032,0,2,15,13,2,3,-1,15,14,2,1,3,-0.002640167949721217,0.3709631860256195,0.5314332842826843,0,2,8,12,4,3,-1,8,13,4,1,3,0.0139184398576617,0.4723555147647858,0.713080883026123,0,2,15,11,1,3,-1,15,12,1,1,3,-0.00045087869511917233,0.4492394030094147,0.5370404124259949,0,2,7,13,5,2,-1,7,14,5,1,2,0.00025384349282830954,0.4406864047050476,0.5514402985572815,0,2,7,12,6,3,-1,7,13,6,1,3,0.002271000063046813,0.4682416915893555,0.5967984199523926,0,2,5,11,4,4,-1,5,13,4,2,2,0.002412077970802784,0.5079392194747925,0.3018598854541779,0,2,11,4,3,3,-1,12,4,1,3,3,-0.00003602567085181363,0.560103714466095,0.4471096992492676,0,2,6,4,3,3,-1,7,4,1,3,3,-0.0074905529618263245,0.2207535058259964,0.4989944100379944,0,2,16,5,3,6,-1,17,5,1,6,3,-0.017513120546937,0.6531215906143188,0.5017648935317993,0,2,3,6,12,7,-1,7,6,4,7,3,0.1428163051605225,0.4967963099479675,0.1482062041759491,0,2,16,5,3,6,-1,17,5,1,6,3,0.005534526892006397,0.4898946881294251,0.5954223871231079,0,2,3,13,2,3,-1,3,14,2,1,3,-0.0009632359142415226,0.3927116990089417,0.519607424736023,0,2,16,5,3,6,-1,17,5,1,6,3,-0.0020370010752230883,0.5613325238227844,0.4884858131408691,0,2,1,5,3,6,-1,2,5,1,6,3,0.0016614829655736685,0.4472880065441132,0.5578880906105042,0,2,1,9,18,1,-1,7,9,6,1,3,-0.0031188090797513723,0.3840532898902893,0.5397477746009827,0,2,0,9,8,7,-1,4,9,4,7,2,-0.006400061771273613,0.5843983888626099,0.4533218145370483,0,2,12,11,8,2,-1,12,12,8,1,2,0.0003131960111204535,0.5439221858978271,0.4234727919101715,0,2,0,11,8,2,-1,0,12,8,1,2,-0.0182220991700888,0.1288464963436127,0.4958404898643494,0,2,9,13,2,3,-1,9,14,2,1,3,0.008796924725174904,0.49512979388237,0.7153480052947998,0,3,4,10,12,4,-1,4,10,6,2,2,10,12,6,2,2,-0.004239507019519806,0.3946599960327148,0.5194936990737915,0,2,9,3,3,7,-1,10,3,1,7,3,0.009708627127110958,0.4897503852844238,0.6064900159835815,0,2,7,2,3,5,-1,8,2,1,5,3,-0.003993417136371136,0.3245440125465393,0.5060828924179077,0,3,9,12,4,6,-1,11,12,2,3,2,9,15,2,3,2,-0.0167850591242313,0.1581953018903732,0.5203778743743896,0,2,8,7,3,6,-1,9,7,1,6,3,0.018272090703249,0.4680935144424439,0.6626979112625122,0,2,15,4,4,2,-1,15,5,4,1,2,0.00568728381767869,0.5211697816848755,0.3512184917926788,0,2,8,7,3,3,-1,9,7,1,3,3,-0.0010739039862528443,0.5768386125564575,0.4529845118522644,0,2,14,2,6,4,-1,14,4,6,2,2,-0.00370938703417778,0.4507763087749481,0.5313581228256226,0,2,7,16,6,1,-1,9,16,2,1,3,-0.0002111070934915915,0.5460820198059082,0.4333376884460449,0,2,15,13,2,3,-1,15,14,2,1,3,0.0010670139454305172,0.5371856093406677,0.4078390896320343,0,2,8,7,3,10,-1,9,7,1,10,3,0.0035943021066486835,0.4471287131309509,0.5643836259841919,0,2,11,10,2,6,-1,11,12,2,2,3,-0.005177603103220463,0.4499393105506897,0.5280330181121826,0,2,6,10,4,1,-1,8,10,2,1,2,-0.00025414369883947074,0.5516173243522644,0.4407708048820496,0,2,10,9,2,2,-1,10,10,2,1,2,0.006352256052196026,0.5194190144538879,0.2465227991342545,0,2,8,9,2,2,-1,8,10,2,1,2,-0.00044205080484971404,0.3830705881118774,0.5139682292938232,0,3,12,7,2,2,-1,13,7,1,1,2,12,8,1,1,2,0.0007448872784152627,0.4891090989112854,0.5974786877632141,0,3,5,7,2,2,-1,5,7,1,1,2,6,8,1,1,2,-0.0035116379149258137,0.7413681745529175,0.4768764972686768,0,2,13,0,3,14,-1,14,0,1,14,3,-0.0125409103929996,0.3648819029331207,0.5252826809883118,0,2,4,0,3,14,-1,5,0,1,14,3,0.009493185207247734,0.5100492835044861,0.362958699464798,0,2,13,4,3,14,-1,14,4,1,14,3,0.0129611501470208,0.5232442021369934,0.4333561062812805,0,2,9,14,2,3,-1,9,15,2,1,3,0.004720944911241531,0.4648149013519287,0.6331052780151367,0,2,8,14,4,3,-1,8,15,4,1,3,-0.0023119079414755106,0.5930309891700745,0.4531058073043823,0,2,4,2,3,16,-1,5,2,1,16,3,-0.002826229901984334,0.3870477974414825,0.5257101058959961,0,2,7,2,8,10,-1,7,7,8,5,2,-0.0014311339473351836,0.552250325679779,0.4561854898929596,0,2,6,14,7,3,-1,6,15,7,1,3,0.0019378310535103083,0.4546220898628235,0.5736966729164124,0,3,9,2,10,12,-1,14,2,5,6,2,9,8,5,6,2,0.00026343559147790074,0.5345739126205444,0.4571875035762787,0,2,6,7,8,2,-1,6,8,8,1,2,0.0007825752254575491,0.3967815935611725,0.5220187902450562,0,2,8,13,4,6,-1,8,16,4,3,2,-0.0195504408329725,0.282964289188385,0.5243508219718933,0,2,6,6,1,3,-1,6,7,1,1,3,0.00043914958951063454,0.4590066969394684,0.589909017086029,0,2,16,2,4,6,-1,16,4,4,2,3,0.0214520003646612,0.523141086101532,0.2855378985404968,0,3,6,6,4,2,-1,6,6,2,1,2,8,7,2,1,2,0.0005897358059883118,0.4397256970405579,0.550642192363739,0,2,16,2,4,6,-1,16,4,4,2,3,-0.0261576101183891,0.3135079145431519,0.5189175009727478,0,2,0,2,4,6,-1,0,4,4,2,3,-0.0139598604291677,0.3213272988796234,0.5040717720985413,0,2,9,6,2,6,-1,9,6,1,6,2,-0.006369901821017265,0.6387544870376587,0.4849506914615631,0,2,3,4,6,10,-1,3,9,6,5,2,-0.008561382070183754,0.2759132087230682,0.5032019019126892,0,2,9,5,2,6,-1,9,5,1,6,2,0.000966229010373354,0.4685640931129456,0.5834879279136658,0,2,3,13,2,3,-1,3,14,2,1,3,0.0007655026856809855,0.5175207257270813,0.389642208814621,0,2,13,13,3,2,-1,13,14,3,1,2,-0.008183334022760391,0.2069136947393417,0.5208122134208679,0,3,2,16,10,4,-1,2,16,5,2,2,7,18,5,2,2,-0.009397693909704685,0.6134091019630432,0.4641222953796387,0,3,5,6,10,6,-1,10,6,5,3,2,5,9,5,3,2,0.004802898038178682,0.5454108119010925,0.439521998167038,0,2,7,14,1,3,-1,7,15,1,1,3,-0.003568056970834732,0.6344485282897949,0.4681093990802765,0,2,14,16,6,3,-1,14,17,6,1,3,0.0040733120404183865,0.5292683243751526,0.4015620052814484,0,2,5,4,3,3,-1,5,5,3,1,3,0.0012568129459396005,0.4392988085746765,0.5452824831008911,0,2,7,4,10,3,-1,7,5,10,1,3,-0.0029065010603517294,0.5898832082748413,0.4863379895687103,0,2,0,4,5,4,-1,0,6,5,2,2,-0.00244093406945467,0.4069364964962006,0.5247421860694885,0,2,13,11,3,9,-1,13,14,3,3,3,0.0248307008296251,0.5182725787162781,0.3682524859905243,0,2,4,11,3,9,-1,4,14,3,3,3,-0.0488540083169937,0.1307577937841415,0.496128112077713,0,2,9,7,2,1,-1,9,7,1,1,2,-0.001611037994734943,0.6421005725860596,0.4872662127017975,0,2,5,0,6,17,-1,7,0,2,17,3,-0.0970094799995422,0.0477693490684032,0.495098888874054,0,2,10,3,6,3,-1,10,3,3,3,2,0.0011209240183234215,0.4616267085075378,0.5354745984077454,0,2,2,2,15,4,-1,7,2,5,4,3,-0.001306409016251564,0.626185417175293,0.4638805985450745,0,3,8,2,8,2,-1,12,2,4,1,2,8,3,4,1,2,0.00045771620352752507,0.5384417772293091,0.4646640121936798,0,2,8,1,3,6,-1,8,3,3,2,3,-0.0006314995116554201,0.3804047107696533,0.51302570104599,0,2,9,17,2,2,-1,9,18,2,1,2,0.0001450597046641633,0.4554310142993927,0.5664461851119995,0,2,0,0,2,14,-1,1,0,1,14,2,-0.0164745505899191,0.6596958041191101,0.4715859889984131,0,2,12,0,7,3,-1,12,1,7,1,3,0.0133695797994733,0.519546627998352,0.3035964965820313,0,2,1,14,1,2,-1,1,15,1,1,2,0.00010271780047332868,0.522917628288269,0.4107066094875336,0,3,14,12,2,8,-1,15,12,1,4,2,14,16,1,4,2,-0.0055311559699475765,0.6352887749671936,0.4960907101631165,0,2,1,0,7,3,-1,1,1,7,1,3,-0.0026187049224972725,0.3824546039104462,0.5140984058380127,0,3,14,12,2,8,-1,15,12,1,4,2,14,16,1,4,2,0.005083426833152771,0.4950439929962158,0.6220818758010864,0,3,6,0,8,12,-1,6,0,4,6,2,10,6,4,6,2,0.0798181593418121,0.4952335953712463,0.1322475969791412,0,2,6,1,8,9,-1,6,4,8,3,3,-0.0992265865206718,0.7542728781700134,0.5008416771888733,0,2,5,2,2,2,-1,5,3,2,1,2,-0.0006517401780001819,0.3699302971363068,0.5130121111869812,0,3,13,14,6,6,-1,16,14,3,3,2,13,17,3,3,2,-0.018996849656105,0.6689178943634033,0.4921202957630158,0,3,0,17,20,2,-1,0,17,10,1,2,10,18,10,1,2,0.0173468999564648,0.4983300864696503,0.1859198063611984,0,3,10,3,2,6,-1,11,3,1,3,2,10,6,1,3,2,0.0005508210160769522,0.4574424028396606,0.5522121787071228,0,2,5,12,6,2,-1,8,12,3,2,2,0.002005605027079582,0.5131744742393494,0.3856469988822937,0,2,10,7,6,13,-1,10,7,3,13,2,-0.007768819108605385,0.4361700117588043,0.5434309244155884,0,2,5,15,10,5,-1,10,15,5,5,2,0.0508782789111137,0.4682720899581909,0.6840639710426331,0,2,10,4,4,10,-1,10,4,2,10,2,-0.0022901780903339386,0.4329245090484619,0.5306099057197571,0,2,5,7,2,1,-1,6,7,1,1,2,-0.00015715380141045898,0.5370057225227356,0.4378164112567902,0,2,10,3,6,7,-1,10,3,3,7,2,0.1051924005150795,0.5137274265289307,0.0673614665865898,0,2,4,3,6,7,-1,7,3,3,7,2,0.002719891956076026,0.4112060964107513,0.5255665183067322,0,2,1,7,18,5,-1,7,7,6,5,3,0.0483377799391747,0.5404623746871948,0.4438967108726502,0,2,3,17,4,3,-1,5,17,2,3,2,0.0009570376132614911,0.4355969130992889,0.5399510860443115,0,3,8,14,12,6,-1,14,14,6,3,2,8,17,6,3,2,-0.0253712590783834,0.5995175242424011,0.5031024813652039,0,3,0,13,20,4,-1,0,13,10,2,2,10,15,10,2,2,0.0524579510092735,0.4950287938117981,0.1398351043462753,0,3,4,5,14,2,-1,11,5,7,1,2,4,6,7,1,2,-0.0123656298965216,0.639729917049408,0.496410608291626,0,3,1,2,10,12,-1,1,2,5,6,2,6,8,5,6,2,-0.1458971947431564,0.1001669988036156,0.494632214307785,0,2,6,1,14,3,-1,6,2,14,1,3,-0.0159086007624865,0.3312329947948456,0.5208340883255005,0,2,8,16,2,3,-1,8,17,2,1,3,0.00039486068999394774,0.4406363964080811,0.5426102876663208,0,2,9,17,3,2,-1,10,17,1,2,3,-0.0052454001270234585,0.2799589931964874,0.5189967155456543,0,3,5,15,4,2,-1,5,15,2,1,2,7,16,2,1,2,-0.005042179953306913,0.6987580060958862,0.4752142131328583,0,2,10,15,1,3,-1,10,16,1,1,3,0.0029812189750373363,0.4983288943767548,0.6307479739189148,0,3,8,16,4,4,-1,8,16,2,2,2,10,18,2,2,2,-0.007288430817425251,0.298233300447464,0.5026869773864746,0,2,6,11,8,6,-1,6,14,8,3,2,0.0015094350092113018,0.5308442115783691,0.3832970857620239,0,2,2,13,5,2,-1,2,14,5,1,2,-0.009334079921245575,0.2037964016199112,0.4969817101955414,0,3,13,14,6,6,-1,16,14,3,3,2,13,17,3,3,2,0.0286671407520771,0.5025696754455566,0.6928027272224426,0,2,1,9,18,4,-1,7,9,6,4,3,0.1701968014240265,0.4960052967071533,0.1476442962884903,0,3,13,14,6,6,-1,16,14,3,3,2,13,17,3,3,2,-0.003261447884142399,0.5603063702583313,0.4826056063175201,0,2,0,2,1,6,-1,0,4,1,2,3,0.0005576927796937525,0.5205562114715576,0.4129633009433746,0,2,5,0,15,20,-1,5,10,15,10,2,0.3625833988189697,0.5221652984619141,0.3768612146377564,0,3,1,14,6,6,-1,1,14,3,3,2,4,17,3,3,2,-0.0116151301190257,0.6022682785987854,0.4637489914894104,0,3,8,14,4,6,-1,10,14,2,3,2,8,17,2,3,2,-0.004079519771039486,0.4070447087287903,0.5337479114532471,0,2,7,11,2,1,-1,8,11,1,1,2,0.0005720430053770542,0.4601835012435913,0.5900393128395081,0,2,9,17,3,2,-1,10,17,1,2,3,0.000675433489959687,0.5398252010345459,0.4345428943634033,0,2,8,17,3,2,-1,9,17,1,2,3,0.0006329569732770324,0.5201563239097595,0.4051358997821808,0,3,12,14,4,6,-1,14,14,2,3,2,12,17,2,3,2,0.00124353205319494,0.4642387926578522,0.5547441244125366,0,3,4,14,4,6,-1,4,14,2,3,2,6,17,2,3,2,-0.004736385773867369,0.6198567152023315,0.4672552049160004,0,3,13,14,2,6,-1,14,14,1,3,2,13,17,1,3,2,-0.006465846206992865,0.6837332844734192,0.5019000768661499,0,3,5,14,2,6,-1,5,14,1,3,2,6,17,1,3,2,0.000350173213519156,0.4344803094863892,0.5363622903823853,0,2,7,0,6,12,-1,7,4,6,4,3,0.00015754920605104417,0.4760079085826874,0.5732020735740662,0,2,0,7,12,2,-1,4,7,4,2,3,0.009977436624467373,0.5090985894203186,0.3635039925575256,0,2,10,3,3,13,-1,11,3,1,13,3,-0.0004146452993154526,0.5570064783096313,0.4593802094459534,0,2,7,3,3,13,-1,8,3,1,13,3,-0.00035888899583369493,0.5356845855712891,0.4339134991168976,0,2,10,8,6,3,-1,10,9,6,1,3,0.0004046325047966093,0.4439803063869476,0.5436776876449585,0,2,3,11,3,2,-1,4,11,1,2,3,-0.0008218478760682046,0.4042294919490814,0.5176299214363098,0,3,13,12,6,8,-1,16,12,3,4,2,13,16,3,4,2,0.005946741905063391,0.4927651882171631,0.5633779764175415,0,2,7,6,6,5,-1,9,6,2,5,3,-0.0217533893883228,0.8006293773651123,0.480084091424942,0,2,17,11,2,7,-1,17,11,1,7,2,-0.0145403798669577,0.3946054875850678,0.5182222723960876,0,2,3,13,8,2,-1,7,13,4,2,2,-0.0405107699334621,0.0213249903172255,0.4935792982578278,0,2,6,9,8,3,-1,6,10,8,1,3,-0.0005845826817676425,0.4012795984745026,0.5314025282859802,0,2,4,3,4,3,-1,4,4,4,1,3,0.005515180062502623,0.4642418920993805,0.5896260738372803,0,2,11,3,4,3,-1,11,4,4,1,3,-0.006062622182071209,0.6502159237861633,0.5016477704048157,0,2,1,4,17,12,-1,1,8,17,4,3,0.0945358425378799,0.5264708995819092,0.4126827120780945,0,2,11,3,4,3,-1,11,4,4,1,3,0.004731505177915096,0.4879199862480164,0.5892447829246521,0,2,4,8,6,3,-1,4,9,6,1,3,-0.0005257147131487727,0.391728013753891,0.5189412832260132,0,2,12,3,5,3,-1,12,4,5,1,3,-0.002546404954046011,0.5837599039077759,0.498570591211319,0,2,1,11,2,7,-1,2,11,1,7,2,-0.0260756891220808,0.1261983960866928,0.4955821931362152,0,3,15,12,2,8,-1,16,12,1,4,2,15,16,1,4,2,-0.00547797093167901,0.5722513794898987,0.5010265707969666,0,2,4,8,11,3,-1,4,9,11,1,3,0.005133774131536484,0.527326226234436,0.4226376116275787,0,3,9,13,6,2,-1,12,13,3,1,2,9,14,3,1,2,0.000479449809063226,0.4450066983699799,0.5819587111473083,0,2,6,13,4,3,-1,6,14,4,1,3,-0.0021114079281687737,0.5757653117179871,0.451171487569809,0,2,9,12,3,3,-1,10,12,1,3,3,-0.0131799904629588,0.1884381026029587,0.5160734057426453,0,2,5,3,3,3,-1,5,4,3,1,3,-0.004796809982508421,0.6589789986610413,0.4736118912696838,0,2,9,4,2,3,-1,9,5,2,1,3,0.0067483168095350266,0.5259429812431335,0.3356395065784454,0,2,0,2,16,3,-1,0,3,16,1,3,0.0014623369788751006,0.5355271100997925,0.4264092147350311,0,3,15,12,2,8,-1,16,12,1,4,2,15,16,1,4,2,0.004764515906572342,0.5034406781196594,0.5786827802658081,0,3,3,12,2,8,-1,3,12,1,4,2,4,16,1,4,2,0.0068066660314798355,0.475660502910614,0.6677829027175903,0,2,14,13,3,6,-1,14,15,3,2,3,0.0036608621012419462,0.5369611978530884,0.4311546981334686,0,2,3,13,3,6,-1,3,15,3,2,3,0.0214496403932571,0.4968641996383667,0.1888816058635712,0,3,6,5,10,2,-1,11,5,5,1,2,6,6,5,1,2,0.004167890176177025,0.4930733144283295,0.5815368890762329,0,2,2,14,14,6,-1,2,17,14,3,2,0.008646756410598755,0.5205205082893372,0.4132595062255859,0,2,10,14,1,3,-1,10,15,1,1,3,-0.0003611407882999629,0.5483555197715759,0.4800927937030792,0,3,4,16,2,2,-1,4,16,1,1,2,5,17,1,1,2,0.0010808729566633701,0.4689902067184448,0.6041421294212341,0,2,10,6,2,3,-1,10,7,2,1,3,0.005771995987743139,0.5171142220497131,0.3053277134895325,0,3,0,17,20,2,-1,0,17,10,1,2,10,18,10,1,2,0.001572077046148479,0.5219978094100952,0.4178803861141205,0,2,13,6,1,3,-1,13,7,1,1,3,-0.0019307859474793077,0.5860369801521301,0.4812920093536377,0,2,8,13,3,2,-1,9,13,1,2,3,-0.007892627269029617,0.1749276965856552,0.497173398733139,0,2,12,2,3,3,-1,13,2,1,3,3,-0.002222467912361026,0.434258908033371,0.521284818649292,0,3,3,18,2,2,-1,3,18,1,1,2,4,19,1,1,2,0.0019011989934369922,0.4765186905860901,0.689205527305603,0,2,9,16,3,4,-1,10,16,1,4,3,0.0027576119173318148,0.5262191295623779,0.4337486028671265,0,2,6,6,1,3,-1,6,7,1,1,3,0.005178744904696941,0.4804069101810455,0.7843729257583618,0,2,13,1,5,2,-1,13,2,5,1,2,-0.0009027334162965417,0.412084698677063,0.5353423953056335,0,3,7,14,6,2,-1,7,14,3,1,2,10,15,3,1,2,0.005179795902222395,0.4740372896194458,0.6425960063934326,0,2,11,3,3,4,-1,12,3,1,4,3,-0.0101140001788735,0.2468792051076889,0.5175017714500427,0,2,1,13,12,6,-1,5,13,4,6,3,-0.0186170600354671,0.5756294131278992,0.4628978967666626,0,2,14,11,5,2,-1,14,12,5,1,2,0.0059225959703326225,0.5169625878334045,0.3214271068572998,0,3,2,15,14,4,-1,2,15,7,2,2,9,17,7,2,2,-0.006294507998973131,0.3872014880180359,0.5141636729240417,0,3,3,7,14,2,-1,10,7,7,1,2,3,8,7,1,2,0.0065353019163012505,0.4853048920631409,0.6310489773750305,0,2,1,11,4,2,-1,1,12,4,1,2,0.0010878399480134249,0.5117315053939819,0.3723258972167969,0,2,14,0,6,14,-1,16,0,2,14,3,-0.0225422400981188,0.5692740082740784,0.4887112975120544,0,2,4,11,1,3,-1,4,12,1,1,3,-0.003006566083058715,0.2556012868881226,0.5003992915153503,0,2,14,0,6,14,-1,16,0,2,14,3,0.007474127225577831,0.4810872972011566,0.5675926804542542,0,2,1,10,3,7,-1,2,10,1,7,3,0.0261623207479715,0.4971194863319397,0.1777237057685852,0,2,8,12,9,2,-1,8,13,9,1,2,0.0009435273823328316,0.4940010905265808,0.549125075340271,0,2,0,6,20,1,-1,10,6,10,1,2,0.0333632417023182,0.5007612109184265,0.2790724039077759,0,2,8,4,4,4,-1,8,4,2,4,2,-0.0151186501607299,0.7059578895568848,0.4973031878471375,0,2,0,0,2,2,-1,0,1,2,1,2,0.0009864894673228264,0.5128620266914368,0.3776761889457703,105.76110076904297,213,0,2,5,3,10,9,-1,5,6,10,3,3,-0.0951507985591888,0.6470757126808167,0.4017286896705627,0,2,15,2,4,10,-1,15,2,2,10,2,0.006270234007388353,0.399982213973999,0.574644923210144,0,2,8,2,2,7,-1,9,2,1,7,2,0.000300180894555524,0.355877012014389,0.5538809895515442,0,2,7,4,12,1,-1,11,4,4,1,3,0.0011757409665733576,0.425653487443924,0.5382617712020874,0,2,3,4,9,1,-1,6,4,3,1,3,0.00004423526843311265,0.3682908117771149,0.5589926838874817,0,2,15,10,1,4,-1,15,12,1,2,2,-0.000029936920327600092,0.5452470183372498,0.4020367860794067,0,2,4,10,6,4,-1,7,10,3,4,2,0.003007319988682866,0.5239058136940002,0.3317843973636627,0,2,15,9,1,6,-1,15,12,1,3,2,-0.0105138896033168,0.4320689141750336,0.5307983756065369,0,2,7,17,6,3,-1,7,18,6,1,3,0.008347682654857635,0.4504637122154236,0.6453298926353455,0,3,14,3,2,16,-1,15,3,1,8,2,14,11,1,8,2,-0.0031492270063608885,0.4313425123691559,0.5370525121688843,0,2,4,9,1,6,-1,4,12,1,3,2,-0.00001443564997316571,0.5326603055000305,0.381797194480896,0,2,12,1,5,2,-1,12,2,5,1,2,-0.00042855090578086674,0.430516391992569,0.5382009744644165,0,3,6,18,4,2,-1,6,18,2,1,2,8,19,2,1,2,0.00015062429883982986,0.4235970973968506,0.5544965267181396,0,3,2,4,16,10,-1,10,4,8,5,2,2,9,8,5,2,0.0715598315000534,0.5303059816360474,0.2678802907466888,0,2,6,5,1,10,-1,6,10,1,5,2,0.0008409518050029874,0.3557108938694,0.5205433964729309,0,2,4,8,15,2,-1,9,8,5,2,3,0.0629865005612373,0.5225362777709961,0.2861376106739044,0,2,1,8,15,2,-1,6,8,5,2,3,-0.0033798629883676767,0.3624185919761658,0.5201697945594788,0,2,9,5,3,6,-1,9,7,3,2,3,-0.00011810739670181647,0.547447681427002,0.3959893882274628,0,2,5,7,8,2,-1,9,7,4,2,2,-0.0005450560129247606,0.3740422129631043,0.5215715765953064,0,2,9,11,2,3,-1,9,12,2,1,3,-0.0018454910023137927,0.5893052220344543,0.4584448933601379,0,2,1,0,16,3,-1,1,1,16,1,3,-0.0004383237101137638,0.4084582030773163,0.5385351181030273,0,2,11,2,7,2,-1,11,3,7,1,2,-0.002400083001703024,0.377745509147644,0.5293580293655396,0,2,5,1,10,18,-1,5,7,10,6,3,-0.0987957417964935,0.2963612079620361,0.5070089101791382,0,2,17,4,3,2,-1,18,4,1,2,3,0.0031798239797353745,0.4877632856369019,0.6726443767547607,0,2,8,13,1,3,-1,8,14,1,1,3,0.00032406419632025063,0.4366911053657532,0.5561109781265259,0,2,3,14,14,6,-1,3,16,14,2,3,-0.0325472503900528,0.31281578540802,0.5308616161346436,0,2,0,2,3,4,-1,1,2,1,4,3,-0.007756113074719906,0.6560224890708923,0.4639872014522553,0,2,12,1,5,2,-1,12,2,5,1,2,0.0160272493958473,0.5172680020332336,0.3141897916793823,0,2,3,1,5,2,-1,3,2,5,1,2,0.00000710023505234858,0.4084446132183075,0.5336294770240784,0,2,10,13,2,3,-1,10,14,2,1,3,0.007342280820012093,0.4966922104358673,0.660346508026123,0,2,8,13,2,3,-1,8,14,2,1,3,-0.0016970280557870865,0.5908237099647522,0.4500182867050171,0,2,14,12,2,3,-1,14,13,2,1,3,0.0024118260480463505,0.5315160751342773,0.3599720895290375,0,2,7,2,2,3,-1,7,3,2,1,3,-0.005530093796551228,0.2334040999412537,0.4996814131736755,0,3,5,6,10,4,-1,10,6,5,2,2,5,8,5,2,2,-0.0026478730142116547,0.5880935788154602,0.4684734046459198,0,2,9,13,1,6,-1,9,16,1,3,2,0.0112956296652555,0.4983777105808258,0.1884590983390808,0,3,10,12,2,2,-1,11,12,1,1,2,10,13,1,1,2,-0.000669528788421303,0.5872138142585754,0.4799019992351532,0,2,4,12,2,3,-1,4,13,2,1,3,0.0014410680159926414,0.5131189227104187,0.350101113319397,0,2,14,4,6,6,-1,14,6,6,2,3,0.0024637870956212282,0.5339372158050537,0.4117639064788818,0,2,8,17,2,3,-1,8,18,2,1,3,0.0003311451873742044,0.4313383102416992,0.5398246049880981,0,2,16,4,4,6,-1,16,6,4,2,3,-0.0335572697222233,0.26753368973732,0.5179154872894287,0,2,0,4,4,6,-1,0,6,4,2,3,0.0185394193977118,0.4973869919776917,0.2317177057266235,0,2,14,6,2,3,-1,14,6,1,3,2,-0.00029698139405809343,0.552970826625824,0.4643664062023163,0,2,4,9,8,1,-1,8,9,4,1,2,-0.0004557725915219635,0.5629584193229675,0.4469191133975983,0,2,8,12,4,3,-1,8,13,4,1,3,-0.0101589802652597,0.6706212759017944,0.4925918877124786,0,2,5,12,10,6,-1,5,14,10,2,3,-0.000022413829356082715,0.5239421725273132,0.3912901878356934,0,2,11,12,1,2,-1,11,13,1,1,2,0.00007203496352303773,0.4799438118934631,0.5501788854598999,0,2,8,15,4,2,-1,8,16,4,1,2,-0.006926720961928368,0.6930009722709656,0.4698084890842438,0,3,6,9,8,8,-1,10,9,4,4,2,6,13,4,4,2,-0.007699783891439438,0.409962385892868,0.5480883121490479,0,3,7,12,4,6,-1,7,12,2,3,2,9,15,2,3,2,-0.007313054986298084,0.3283475935459137,0.5057886242866516,0,2,10,11,3,1,-1,11,11,1,1,3,0.0019650589674711227,0.4978047013282776,0.6398249864578247,0,3,9,7,2,10,-1,9,7,1,5,2,10,12,1,5,2,0.007164760027080774,0.4661160111427307,0.6222137212753296,0,2,8,0,6,6,-1,10,0,2,6,3,-0.0240786392241716,0.2334644943475723,0.5222162008285522,0,2,3,11,2,6,-1,3,13,2,2,3,-0.0210279691964388,0.1183653995394707,0.4938226044178009,0,2,16,12,1,2,-1,16,13,1,1,2,0.00036017020465806127,0.5325019955635071,0.4116711020469666,0,3,1,14,6,6,-1,1,14,3,3,2,4,17,3,3,2,-0.0172197297215462,0.6278762221336365,0.4664269089698792,0,2,13,1,3,6,-1,14,1,1,6,3,-0.007867214269936085,0.3403415083885193,0.5249736905097961,0,2,8,8,2,2,-1,8,9,2,1,2,-0.000447773898486048,0.3610411882400513,0.5086259245872498,0,2,9,9,3,3,-1,10,9,1,3,3,0.005548601038753986,0.4884265959262848,0.6203498244285583,0,2,8,7,3,3,-1,8,8,3,1,3,-0.00694611482322216,0.262593001127243,0.5011097192764282,0,2,14,0,2,3,-1,14,0,1,3,2,0.00013569870498031378,0.4340794980525971,0.5628312230110168,0,2,1,0,18,9,-1,7,0,6,9,3,-0.0458802506327629,0.6507998704910278,0.4696274995803833,0,2,11,5,4,15,-1,11,5,2,15,2,-0.0215825606137514,0.3826502859592438,0.5287616848945618,0,2,5,5,4,15,-1,7,5,2,15,2,-0.0202095396816731,0.3233368098735809,0.5074477195739746,0,2,14,0,2,3,-1,14,0,1,3,2,0.005849671084433794,0.5177603960037231,0.4489670991897583,0,2,4,0,2,3,-1,5,0,1,3,2,-0.00005747637987951748,0.4020850956439972,0.5246363878250122,0,3,11,12,2,2,-1,12,12,1,1,2,11,13,1,1,2,-0.001151310047134757,0.6315072178840637,0.490515410900116,0,3,7,12,2,2,-1,7,12,1,1,2,8,13,1,1,2,0.0019862831104546785,0.4702459871768951,0.6497151255607605,0,2,12,0,3,4,-1,13,0,1,4,3,-0.005271951202303171,0.3650383949279785,0.5227652788162231,0,2,4,11,3,3,-1,4,12,3,1,3,0.0012662699446082115,0.5166100859642029,0.387761801481247,0,2,12,7,4,2,-1,12,8,4,1,2,-0.006291944067925215,0.737589418888092,0.5023847818374634,0,2,8,10,3,2,-1,9,10,1,2,3,0.000673601112794131,0.4423226118087769,0.5495585799217224,0,2,9,9,3,2,-1,10,9,1,2,3,-0.0010523450328037143,0.5976396203041077,0.4859583079814911,0,2,8,9,3,2,-1,9,9,1,2,3,-0.00044216238893568516,0.5955939292907715,0.4398930966854096,0,2,12,0,3,4,-1,13,0,1,4,3,0.0011747940443456173,0.5349888205528259,0.4605058133602142,0,2,5,0,3,4,-1,6,0,1,4,3,0.005245743785053492,0.5049191117286682,0.2941577136516571,0,3,4,14,12,4,-1,10,14,6,2,2,4,16,6,2,2,-0.0245397202670574,0.2550177872180939,0.5218586921691895,0,2,8,13,2,3,-1,8,14,2,1,3,0.0007379304151982069,0.4424861073493958,0.5490816235542297,0,2,10,10,3,8,-1,10,14,3,4,2,0.0014233799884095788,0.5319514274597168,0.4081355929374695,0,3,8,10,4,8,-1,8,10,2,4,2,10,14,2,4,2,-0.0024149110540747643,0.4087659120559692,0.5238950252532959,0,2,10,8,3,1,-1,11,8,1,1,3,-0.0012165299849584699,0.567457914352417,0.4908052980899811,0,2,9,12,1,6,-1,9,15,1,3,2,-0.0012438809499144554,0.4129425883293152,0.5256118178367615,0,2,10,8,3,1,-1,11,8,1,1,3,0.006194273941218853,0.5060194134712219,0.7313653230667114,0,2,7,8,3,1,-1,8,8,1,1,3,-0.0016607169527560472,0.5979632139205933,0.4596369862556458,0,2,5,2,15,14,-1,5,9,15,7,2,-0.0273162592202425,0.4174365103244782,0.5308842062950134,0,3,2,1,2,10,-1,2,1,1,5,2,3,6,1,5,2,-0.00158455700147897,0.56158047914505,0.4519486129283905,0,2,14,14,2,3,-1,14,15,2,1,3,-0.0015514739789068699,0.4076187014579773,0.5360785126686096,0,2,2,7,3,3,-1,3,7,1,3,3,0.0003844655875582248,0.4347293972969055,0.5430442094802856,0,2,17,4,3,3,-1,17,5,3,1,3,-0.0146722598001361,0.1659304946660996,0.5146093964576721,0,2,0,4,3,3,-1,0,5,3,1,3,0.008160888217389584,0.4961819052696228,0.1884745955467224,0,3,13,5,6,2,-1,16,5,3,1,2,13,6,3,1,2,0.0011121659772470593,0.4868263900279999,0.6093816161155701,0,2,4,19,12,1,-1,8,19,4,1,3,-0.007260377053171396,0.6284325122833252,0.4690375924110413,0,2,12,12,2,4,-1,12,14,2,2,2,-0.00024046430189628154,0.5575000047683716,0.4046044051647186,0,2,3,15,1,3,-1,3,16,1,1,3,-0.00023348190006799996,0.4115762114524841,0.5252848267555237,0,2,11,16,6,4,-1,11,16,3,4,2,0.005573648028075695,0.4730072915554047,0.5690100789070129,0,2,2,10,3,10,-1,3,10,1,10,3,0.0306237693876028,0.4971886873245239,0.1740095019340515,0,2,12,8,2,4,-1,12,8,1,4,2,0.0009207479888573289,0.5372117757797241,0.4354872107505798,0,2,6,8,2,4,-1,7,8,1,4,2,-0.00004355073906481266,0.5366883873939514,0.4347316920757294,0,2,10,14,2,3,-1,10,14,1,3,2,-0.006645271088927984,0.3435518145561218,0.516053318977356,0,2,5,1,10,3,-1,10,1,5,3,2,0.0432219989597797,0.4766792058944702,0.7293652892112732,0,2,10,7,3,2,-1,11,7,1,2,3,0.0022331769578158855,0.5029315948486328,0.5633171200752258,0,2,5,6,9,2,-1,8,6,3,2,3,0.0031829739455133677,0.4016092121601105,0.5192136764526367,0,2,9,8,2,2,-1,9,9,2,1,2,-0.00018027749320026487,0.4088315963745117,0.5417919754981995,0,3,2,11,16,6,-1,2,11,8,3,2,10,14,8,3,2,-0.0052934689447283745,0.407567709684372,0.5243561863899231,0,3,12,7,2,2,-1,13,7,1,1,2,12,8,1,1,2,0.0012750959722325206,0.4913282990455627,0.6387010812759399,0,2,9,5,2,3,-1,9,6,2,1,3,0.004338532220572233,0.5031672120094299,0.2947346866130829,0,2,9,7,3,2,-1,10,7,1,2,3,0.00852507445961237,0.4949789047241211,0.6308869123458862,0,2,5,1,8,12,-1,5,7,8,6,2,-0.0009426635224372149,0.5328366756439209,0.4285649955272675,0,2,13,5,2,2,-1,13,6,2,1,2,0.0013609660090878606,0.4991525113582611,0.5941501259803772,0,2,5,5,2,2,-1,5,6,2,1,2,0.0004478250921238214,0.4573504030704498,0.5854480862617493,0,2,12,4,3,3,-1,12,5,3,1,3,0.001336005050688982,0.4604358971118927,0.584905207157135,0,2,4,14,2,3,-1,4,15,2,1,3,-0.0006096754805184901,0.3969388902187347,0.522942304611206,0,2,12,4,3,3,-1,12,5,3,1,3,-0.002365678083151579,0.5808320045471191,0.4898357093334198,0,2,5,4,3,3,-1,5,5,3,1,3,0.001073434017598629,0.435121089220047,0.5470039248466492,0,3,9,14,2,6,-1,10,14,1,3,2,9,17,1,3,2,0.0021923359017819166,0.535506010055542,0.3842903971672058,0,2,8,14,3,2,-1,9,14,1,2,3,0.005496861878782511,0.5018138885498047,0.2827191948890686,0,2,9,5,6,6,-1,11,5,2,6,3,-0.0753688216209412,0.1225076019763947,0.5148826837539673,0,2,5,5,6,6,-1,7,5,2,6,3,0.0251344703137875,0.4731766879558563,0.702544629573822,0,2,13,13,1,2,-1,13,14,1,1,2,-0.00002935859993158374,0.5430532097816467,0.465608686208725,0,2,0,2,10,2,-1,0,3,10,1,2,-0.0005835591000504792,0.4031040072441101,0.5190119743347168,0,2,13,13,1,2,-1,13,14,1,1,2,-0.0026639450807124376,0.4308126866817474,0.5161771178245544,0,3,5,7,2,2,-1,5,7,1,1,2,6,8,1,1,2,-0.0013804089976474643,0.621982991695404,0.4695515930652618,0,2,13,5,2,7,-1,13,5,1,7,2,0.0012313219485804439,0.5379363894462585,0.4425831139087677,0,2,6,13,1,2,-1,6,14,1,1,2,-0.000014644179827882908,0.5281640291213989,0.4222503006458283,0,2,11,0,3,7,-1,12,0,1,7,3,-0.0128188095986843,0.2582092881202698,0.5179932713508606,0,3,0,3,2,16,-1,0,3,1,8,2,1,11,1,8,2,0.0228521898388863,0.4778693020343781,0.7609264254570007,0,2,11,0,3,7,-1,12,0,1,7,3,0.0008230597013607621,0.5340992212295532,0.4671724140644074,0,2,6,0,3,7,-1,7,0,1,7,3,0.0127701200544834,0.4965761005878449,0.1472366005182266,0,2,11,16,8,4,-1,11,16,4,4,2,-0.0500515103340149,0.641499400138855,0.5016592144966125,0,2,1,16,8,4,-1,5,16,4,4,2,0.0157752707600594,0.4522320032119751,0.5685362219810486,0,2,13,5,2,7,-1,13,5,1,7,2,-0.0185016207396984,0.2764748930931091,0.5137959122657776,0,2,5,5,2,7,-1,6,5,1,7,2,0.0024626250378787518,0.5141941905021667,0.3795408010482788,0,2,18,6,2,14,-1,18,13,2,7,2,0.0629161670804024,0.5060648918151855,0.658043384552002,0,2,6,10,3,4,-1,6,12,3,2,2,-0.000021648500478477217,0.5195388197898865,0.401988685131073,0,2,14,7,1,2,-1,14,8,1,1,2,0.0021180990152060986,0.4962365031242371,0.5954458713531494,0,3,0,1,18,6,-1,0,1,9,3,2,9,4,9,3,2,-0.0166348908096552,0.3757933080196381,0.517544686794281,0,2,14,7,1,2,-1,14,8,1,1,2,-0.002889947034418583,0.6624013781547546,0.5057178735733032,0,2,0,6,2,14,-1,0,13,2,7,2,0.076783262193203,0.4795796871185303,0.8047714829444885,0,2,17,0,3,12,-1,18,0,1,12,3,0.003917067777365446,0.4937882125377655,0.5719941854476929,0,2,0,6,18,3,-1,0,7,18,1,3,-0.0726706013083458,0.0538945607841015,0.4943903982639313,0,2,6,0,14,16,-1,6,8,14,8,2,0.5403950214385986,0.5129774212837219,0.1143338978290558,0,2,0,0,3,12,-1,1,0,1,12,3,0.0029510019812732935,0.4528343975543976,0.5698574185371399,0,2,13,0,3,7,-1,14,0,1,7,3,0.0034508369863033295,0.5357726812362671,0.4218730926513672,0,2,5,7,1,2,-1,5,8,1,1,2,-0.0004207793972454965,0.5916172862052917,0.4637925922870636,0,2,14,4,6,6,-1,14,6,6,2,3,0.0033051050268113613,0.5273385047912598,0.438204288482666,0,2,5,7,7,2,-1,5,8,7,1,2,0.0004773506079800427,0.4046528041362763,0.5181884765625,0,2,8,6,6,9,-1,8,9,6,3,3,-0.0259285103529692,0.7452235817909241,0.5089386105537415,0,2,5,4,6,1,-1,7,4,2,1,3,-0.002972979098558426,0.3295435905456543,0.5058795213699341,0,3,13,0,6,4,-1,16,0,3,2,2,13,2,3,2,2,0.005850832909345627,0.4857144057750702,0.5793024897575378,0,2,1,2,18,12,-1,1,6,18,4,3,-0.0459675192832947,0.4312731027603149,0.5380653142929077,0,2,3,2,17,12,-1,3,6,17,4,3,0.1558596044778824,0.5196170210838318,0.1684713959693909,0,2,5,14,7,3,-1,5,15,7,1,3,0.0151648297905922,0.4735757112503052,0.6735026836395264,0,2,10,14,1,3,-1,10,15,1,1,3,-0.0010604249546304345,0.5822926759719849,0.4775702953338623,0,2,3,14,3,3,-1,3,15,3,1,3,0.006647629197686911,0.4999198913574219,0.231953501701355,0,2,14,4,6,6,-1,14,6,6,2,3,-0.0122311301529408,0.4750893115997315,0.5262982249259949,0,2,0,4,6,6,-1,0,6,6,2,3,0.005652888212352991,0.5069767832756042,0.3561818897724152,0,2,12,5,4,3,-1,12,6,4,1,3,0.0012977829901501536,0.4875693917274475,0.5619062781333923,0,2,4,5,4,3,-1,4,6,4,1,3,0.0107815898954868,0.4750770032405853,0.6782308220863342,0,2,18,0,2,6,-1,18,2,2,2,3,0.002865477930754423,0.5305461883544922,0.4290736019611359,0,2,8,1,4,9,-1,10,1,2,9,2,0.0028663428965955973,0.4518479108810425,0.5539351105690002,0,2,6,6,8,2,-1,6,6,4,2,2,-0.005198332015424967,0.4149119853973389,0.5434188842773438,0,3,6,5,4,2,-1,6,5,2,1,2,8,6,2,1,2,0.005373999010771513,0.471789687871933,0.6507657170295715,0,2,10,5,2,3,-1,10,6,2,1,3,-0.0146415298804641,0.2172164022922516,0.5161777138710022,0,2,9,5,1,3,-1,9,6,1,1,3,-0.000015042580344015732,0.533738374710083,0.4298836886882782,0,2,9,10,2,2,-1,9,11,2,1,2,-0.0001187566012958996,0.4604594111442566,0.5582447052001953,0,2,0,8,4,3,-1,0,9,4,1,3,0.0169955305755138,0.4945895075798035,0.0738800764083862,0,2,6,0,8,6,-1,6,3,8,3,2,-0.0350959412753582,0.70055091381073,0.4977591037750244,0,3,1,0,6,4,-1,1,0,3,2,2,4,2,3,2,2,0.0024217350874096155,0.4466265141963959,0.5477694272994995,0,2,13,0,3,7,-1,14,0,1,7,3,-0.0009634033776819706,0.4714098870754242,0.5313338041305542,0,2,9,16,2,2,-1,9,17,2,1,2,0.00016391130338888615,0.4331546127796173,0.5342242121696472,0,2,11,4,6,10,-1,11,9,6,5,2,-0.0211414601653814,0.2644700109958649,0.5204498767852783,0,2,0,10,19,2,-1,0,11,19,1,2,0.0008777520270086825,0.5208349823951721,0.4152742922306061,0,2,9,5,8,9,-1,9,8,8,3,3,-0.0279439203441143,0.6344125270843506,0.5018811821937561,0,2,4,0,3,7,-1,5,0,1,7,3,0.006729737855494022,0.5050438046455383,0.3500863909721375,0,3,8,6,4,12,-1,10,6,2,6,2,8,12,2,6,2,0.0232810396701097,0.4966318011283875,0.6968677043914795,0,2,0,2,6,4,-1,0,4,6,2,2,-0.0116449799388647,0.3300260007381439,0.5049629807472229,0,2,8,15,4,3,-1,8,16,4,1,3,0.0157643090933561,0.4991598129272461,0.7321153879165649,0,2,8,0,3,7,-1,9,0,1,7,3,-0.001361147966235876,0.3911735117435455,0.5160670876502991,0,2,9,5,3,4,-1,10,5,1,4,3,-0.0008152233785949647,0.5628911256790161,0.49497190117836,0,2,8,5,3,4,-1,9,5,1,4,3,-0.0006006627227179706,0.585359513759613,0.4550595879554749,0,2,7,6,6,1,-1,9,6,2,1,3,0.0004971551825292408,0.4271470010280609,0.5443599224090576,0,3,7,14,4,4,-1,7,14,2,2,2,9,16,2,2,2,0.0023475370835512877,0.5143110752105713,0.3887656927108765,0,3,13,14,4,6,-1,15,14,2,3,2,13,17,2,3,2,-0.008926156908273697,0.6044502258300781,0.497172087430954,0,2,7,8,1,8,-1,7,12,1,4,2,-0.013919910416007,0.2583160996437073,0.5000367760658264,0,3,16,0,2,8,-1,17,0,1,4,2,16,4,1,4,2,0.0010209949687123299,0.4857374131679535,0.5560358166694641,0,3,2,0,2,8,-1,2,0,1,4,2,3,4,1,4,2,-0.0027441629208624363,0.5936884880065918,0.464577704668045,0,2,6,1,14,3,-1,6,2,14,1,3,-0.0162001308053732,0.3163014948368073,0.5193495154380798,0,2,7,9,3,10,-1,7,14,3,5,2,0.004333198070526123,0.5061224102973938,0.3458878993988037,0,2,9,14,2,2,-1,9,15,2,1,2,0.0005849793087691069,0.4779017865657806,0.5870177745819092,0,2,7,7,6,8,-1,7,11,6,4,2,-0.0022466450463980436,0.4297851026058197,0.5374773144721985,0,2,9,7,3,6,-1,9,10,3,3,2,0.0023146099410951138,0.5438671708106995,0.4640969932079315,0,2,7,13,3,3,-1,7,14,3,1,3,0.008767912164330482,0.472689300775528,0.6771789789199829,0,2,9,9,2,2,-1,9,10,2,1,2,-0.00022448020172305405,0.4229173064231873,0.5428048968315125,0,2,0,1,18,2,-1,6,1,6,2,3,-0.007433602120727301,0.6098880767822266,0.4683673977851868,0,2,7,1,6,14,-1,7,8,6,7,2,-0.0023189240600913763,0.5689436793327332,0.4424242079257965,0,2,1,9,18,1,-1,7,9,6,1,3,-0.0021042178850620985,0.3762221038341522,0.5187087059020996,0,2,9,7,2,2,-1,9,7,1,2,2,0.000460348412161693,0.4699405133724213,0.5771207213401794,0,2,9,3,2,9,-1,10,3,1,9,2,0.0010547629790380597,0.4465216994285584,0.5601701736450195,0,2,18,14,2,3,-1,18,15,2,1,3,0.0008714881842024624,0.544980525970459,0.3914709091186523,0,2,7,11,3,1,-1,8,11,1,1,3,0.00033364820410497487,0.4564009010791779,0.5645738840103149,0,2,10,8,3,4,-1,11,8,1,4,3,-0.0014853250468149781,0.5747377872467041,0.4692778885364533,0,2,7,14,3,6,-1,8,14,1,6,3,0.0030251620337367058,0.5166196823120117,0.3762814104557037,0,2,10,8,3,4,-1,11,8,1,4,3,0.005028074141591787,0.5002111792564392,0.6151527166366577,0,2,7,8,3,4,-1,8,8,1,4,3,-0.0005816451157443225,0.5394598245620728,0.4390751123428345,0,2,7,9,6,9,-1,7,12,6,3,3,0.0451415292918682,0.5188326835632324,0.206303596496582,0,2,0,14,2,3,-1,0,15,2,1,3,-0.001079562003724277,0.3904685080051422,0.5137907266616821,0,2,11,12,1,2,-1,11,13,1,1,2,0.00015995999274309725,0.4895322918891907,0.5427504181861877,0,2,4,3,8,3,-1,8,3,4,3,2,-0.0193592701107264,0.6975228786468506,0.4773507118225098,0,2,0,4,20,6,-1,0,4,10,6,2,0.207255095243454,0.5233635902404785,0.3034991919994354,0,2,9,14,1,3,-1,9,15,1,1,3,-0.00041953290929086506,0.5419396758079529,0.4460186064243317,0,2,8,14,4,3,-1,8,15,4,1,3,0.0022582069505006075,0.4815764129161835,0.6027408838272095,0,2,0,15,14,4,-1,0,17,14,2,2,-0.0067811207845807076,0.3980278968811035,0.5183305740356445,0,2,1,14,18,6,-1,1,17,18,3,2,0.0111543098464608,0.543123185634613,0.4188759922981262,0,3,0,0,10,6,-1,0,0,5,3,2,5,3,5,3,2,0.0431624315679073,0.4738228023052216,0.6522961258888245]);*/

/* eslint-disable */

!function(t,e){"object"==typeof exports&&"object"==typeof module?module.exports=e():"function"==typeof define&&define.amd?define("SecureLS",[],e):"object"==typeof exports?exports.SecureLS=e():t.SecureLS=e()}(this,function(){return function(t){function e(i){if(r[i])return r[i].exports;var n=r[i]={exports:{},id:i,loaded:!1};return t[i].call(n.exports,n,n.exports,e),n.loaded=!0,n.exports}var r={};return e.m=t,e.c=r,e.p="",e(0)}([function(t,e,r){"use strict";function i(t){return t&&t.__esModule?t:{"default":t}}function n(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(e,"__esModule",{value:!0});var s=function(){function t(t,e){for(var r=0;r<e.length;r++){var i=e[r];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(t,i.key,i)}}return function(e,r,i){return r&&t(e.prototype,r),i&&t(e,i),e}}(),o=r(1),a=i(o),c=r(2),u=i(c),h=r(8),f=i(h),l=r(9),p=i(l),d=r(10),y=i(d),v=r(11),_=i(v),g=r(16),S=i(g),m=r(17),k=i(m),B=r(18),E=i(B),C=function(){function t(e){n(this,t),e=e||{},this._name="secure-ls",this.utils=a["default"],this.constants=u["default"],this.Base64=p["default"],this.LZString=y["default"],this.AES=_["default"],this.DES=S["default"],this.RABBIT=k["default"],this.RC4=E["default"],this.enc=f["default"],this.config={isCompression:!0,encodingType:u["default"].EncrytionTypes.BASE64},this.config.isCompression="undefined"==typeof e.isCompression||e.isCompression,this.config.encodingType="undefined"!=typeof e.encodingType||""===e.encodingType?e.encodingType.toLowerCase():u["default"].EncrytionTypes.BASE64,this.config.encryptionSecret=e.encryptionSecret,this.ls=localStorage,this.init()}return s(t,[{key:"init",value:function(){var t=this.getMetaData()||{};this.WarningEnum=this.constants.WarningEnum,this.WarningTypes=this.constants.WarningTypes,this.EncrytionTypes=this.constants.EncrytionTypes,this._isBase64=this._isBase64EncryptionType(),this._isAES=this._isAESEncryptionType(),this._isDES=this._isDESEncryptionType(),this._isRabbit=this._isRabbitEncryptionType(),this._isRC4=this._isRC4EncryptionType(),this._isCompression=this._isDataCompressionEnabled(),this.utils.allKeys=t.keys||this.resetAllKeys()}},{key:"_isBase64EncryptionType",value:function(){return p["default"]&&("undefined"==typeof this.config.encodingType||this.config.encodingType===this.constants.EncrytionTypes.BASE64)}},{key:"_isAESEncryptionType",value:function(){return _["default"]&&this.config.encodingType===this.constants.EncrytionTypes.AES}},{key:"_isDESEncryptionType",value:function(){return S["default"]&&this.config.encodingType===this.constants.EncrytionTypes.DES}},{key:"_isRabbitEncryptionType",value:function(){return k["default"]&&this.config.encodingType===this.constants.EncrytionTypes.RABBIT}},{key:"_isRC4EncryptionType",value:function(){return E["default"]&&this.config.encodingType===this.constants.EncrytionTypes.RC4}},{key:"_isDataCompressionEnabled",value:function(){return this.config.isCompression}},{key:"getEncyptionSecret",value:function(t){var e=this.getMetaData()||{},r=this.utils.getObjectFromKey(e.keys,t);r&&(this._isAES||this._isDES||this._isRabbit||this._isRC4)&&("undefined"==typeof this.config.encryptionSecret?(this.utils.encryptionSecret=r.s,this.utils.encryptionSecret||(this.utils.encryptionSecret=this.utils.generateSecretKey(),this.setMetaData())):this.utils.encryptionSecret=this.config.encryptionSecret||r.s||"")}},{key:"get",value:function(t,e){var r="",i="",n=void 0,s=void 0,o=void 0;if(!this.utils.is(t))return this.utils.warn(this.WarningEnum.KEY_NOT_PROVIDED),i;if(o=this.getDataFromLocalStorage(t),!o)return i;n=o,(this._isCompression||e)&&(n=y["default"].decompress(o)),r=n,this._isBase64||e?r=p["default"].decode(n):(this.getEncyptionSecret(t),this._isAES?s=_["default"].decrypt(n.toString(),this.utils.encryptionSecret):this._isDES?s=S["default"].decrypt(n.toString(),this.utils.encryptionSecret):this._isRabbit?s=k["default"].decrypt(n.toString(),this.utils.encryptionSecret):this._isRC4&&(s=E["default"].decrypt(n.toString(),this.utils.encryptionSecret)),s&&(r=s.toString(f["default"]._Utf8)));try{i=JSON.parse(r)}catch(a){throw new Error("Could not parse JSON")}return i}},{key:"getDataFromLocalStorage",value:function(t){return this.ls.getItem(t,!0)}},{key:"getAllKeys",value:function(){var t=this.getMetaData();return this.utils.extractKeyNames(t)||[]}},{key:"set",value:function(t,e){var r="";return this.utils.is(t)?(this.getEncyptionSecret(t),String(t)!==String(this.utils.metaKey)&&(this.utils.isKeyPresent(t)||(this.utils.addToKeysList(t),this.setMetaData())),r=this.processData(e),void this.setDataToLocalStorage(t,r)):void this.utils.warn(this.WarningEnum.KEY_NOT_PROVIDED)}},{key:"setDataToLocalStorage",value:function(t,e){this.ls.setItem(t,e)}},{key:"remove",value:function(t){return this.utils.is(t)?t===this.utils.metaKey&&this.getAllKeys().length?void this.utils.warn(this.WarningEnum.META_KEY_REMOVE):(this.utils.isKeyPresent(t)&&(this.utils.removeFromKeysList(t),this.setMetaData()),void this.ls.removeItem(t)):void this.utils.warn(this.WarningEnum.KEY_NOT_PROVIDED)}},{key:"removeAll",value:function(){var t=void 0,e=void 0;for(t=this.getAllKeys(),e=0;e<t.length;e++)this.ls.removeItem(t[e]);this.ls.removeItem(this.utils.metaKey),this.resetAllKeys()}},{key:"clear",value:function(){this.ls.clear(),this.resetAllKeys()}},{key:"resetAllKeys",value:function(){return this.utils.allKeys=[],[]}},{key:"processData",value:function(t,e){if(!t)return"";var r=void 0,i=void 0,n=void 0;try{r=JSON.stringify(t)}catch(s){throw new Error("Could not stringify data.")}return i=r,this._isBase64||e?i=p["default"].encode(r):(this._isAES?i=_["default"].encrypt(r,this.utils.encryptionSecret):this._isDES?i=S["default"].encrypt(r,this.utils.encryptionSecret):this._isRabbit?i=k["default"].encrypt(r,this.utils.encryptionSecret):this._isRC4&&(i=E["default"].encrypt(r,this.utils.encryptionSecret)),i=i&&i.toString()),n=i,(this._isCompression||e)&&(n=y["default"].compress(i)),n}},{key:"setMetaData",value:function(){var t=this.processData({keys:this.utils.allKeys},!0);this.setDataToLocalStorage(this.utils.metaKey,t)}},{key:"getMetaData",value:function(){return this.get(this.utils.metaKey,!0)}}]),t}();e["default"]=C,t.exports=e["default"]},function(t,e,r){"use strict";function i(t){return t&&t.__esModule?t:{"default":t}}var n=r(2),s=i(n),o=r(3),a=i(o),c=r(4),u=i(c),h={metaKey:"_secure__ls__metadata",encryptionSecret:"",secretPhrase:"s3cr3t$#@135^&*246",allKeys:[],is:function(t){return!!t},warn:function(t){t=t?t:s["default"].WarningEnum.DEFAULT_TEXT,console.warn(s["default"].WarningTypes[t])},generateSecretKey:function(){var t=a["default"].random(16),e=(0,u["default"])(this.secretPhrase,t,{keySize:4});return e&&e.toString()},getObjectFromKey:function(t,e){if(!t||!t.length)return{};var r=void 0,i={};for(r=0;r<t.length;r++)if(t[r].k===e){i=t[r];break}return i},extractKeyNames:function(t){return t&&t.keys&&t.keys.length?t.keys.map(function(t){return t.k}):[]},getAllKeys:function(){return this.allKeys},isKeyPresent:function(t){for(var e=!1,r=0;r<this.allKeys.length;r++)if(String(this.allKeys[r].k)===String(t)){e=!0;break}return e},addToKeysList:function(t){this.allKeys.push({k:t,s:this.encryptionSecret})},removeFromKeysList:function(t){var e=void 0,r=-1;for(e=0;e<this.allKeys.length;e++)if(this.allKeys[e].k===t){r=e;break}return r!==-1&&this.allKeys.splice(r,1),r}};t.exports=h},function(t,e){"use strict";var r={KEY_NOT_PROVIDED:"keyNotProvided",META_KEY_REMOVE:"metaKeyRemove",DEFAULT_TEXT:"defaultText"},i={};i[r.KEY_NOT_PROVIDED]="Secure LS: Key not provided. Aborting operation!",i[r.META_KEY_REMOVE]="Secure LS: Meta key can not be removed\nunless all keys created by Secure LS are removed!",i[r.DEFAULT_TEXT]="Unexpected output";var n={WarningEnum:r,WarningTypes:i,EncrytionTypes:{BASE64:"base64",AES:"aes",DES:"des",RABBIT:"rabbit",RC4:"rc4"}};t.exports=n},function(t,e){"use strict";var r={};r.random=function(t){for(var e,r=[],i=function(t){var e=987654321,r=4294967295;return function(){e=36969*(65535&e)+(e>>16)&r,t=18e3*(65535&t)+(t>>16)&r;var i=(e<<16)+t&r;return i/=4294967296,i+=.5,i*(Math.random()>.5?1:-1)}},n=0;n<t;n+=4){var s=i(4294967296*(e||Math.random()));e=987654071*s(),r.push(4294967296*s()|0)}return new this.Set(r,t)},r.Set=function(t,e){t=this.words=t||[],void 0!==e?this.sigBytes=e:this.sigBytes=8*t.length},t.exports=r},function(t,e,r){!function(i,n,s){t.exports=e=n(r(5),r(6),r(7))}(this,function(t){return function(){var e=t,r=e.lib,i=r.Base,n=r.WordArray,s=e.algo,o=s.SHA1,a=s.HMAC,c=s.PBKDF2=i.extend({cfg:i.extend({keySize:4,hasher:o,iterations:1}),init:function(t){this.cfg=this.cfg.extend(t)},compute:function(t,e){for(var r=this.cfg,i=a.create(r.hasher,t),s=n.create(),o=n.create([1]),c=s.words,u=o.words,h=r.keySize,f=r.iterations;c.length<h;){var l=i.update(e).finalize(o);i.reset();for(var p=l.words,d=p.length,y=l,v=1;v<f;v++){y=i.finalize(y),i.reset();for(var _=y.words,g=0;g<d;g++)p[g]^=_[g]}s.concat(l),u[0]++}return s.sigBytes=4*h,s}});e.PBKDF2=function(t,e,r){return c.create(r).compute(t,e)}}(),t.PBKDF2})},function(t,e,r){!function(r,i){t.exports=e=i()}(this,function(){var t=t||function(t,e){var r={},i=r.lib={},n=i.Base=function(){function t(){}return{extend:function(e){t.prototype=this;var r=new t;return e&&r.mixIn(e),r.hasOwnProperty("init")||(r.init=function(){r.$super.init.apply(this,arguments)}),r.init.prototype=r,r.$super=this,r},create:function(){var t=this.extend();return t.init.apply(t,arguments),t},init:function(){},mixIn:function(t){for(var e in t)t.hasOwnProperty(e)&&(this[e]=t[e]);t.hasOwnProperty("toString")&&(this.toString=t.toString)},clone:function(){return this.init.prototype.extend(this)}}}(),s=i.WordArray=n.extend({init:function(t,r){t=this.words=t||[],r!=e?this.sigBytes=r:this.sigBytes=4*t.length},toString:function(t){return(t||a).stringify(this)},concat:function(t){var e=this.words,r=t.words,i=this.sigBytes,n=t.sigBytes;if(this.clamp(),i%4)for(var s=0;s<n;s++){var o=r[s>>>2]>>>24-s%4*8&255;e[i+s>>>2]|=o<<24-(i+s)%4*8}else for(var s=0;s<n;s+=4)e[i+s>>>2]=r[s>>>2];return this.sigBytes+=n,this},clamp:function(){var e=this.words,r=this.sigBytes;e[r>>>2]&=4294967295<<32-r%4*8,e.length=t.ceil(r/4)},clone:function(){var t=n.clone.call(this);return t.words=this.words.slice(0),t},random:function(e){for(var r,i=[],n=function(e){var e=e,r=987654321,i=4294967295;return function(){r=36969*(65535&r)+(r>>16)&i,e=18e3*(65535&e)+(e>>16)&i;var n=(r<<16)+e&i;return n/=4294967296,n+=.5,n*(t.random()>.5?1:-1)}},o=0;o<e;o+=4){var a=n(4294967296*(r||t.random()));r=987654071*a(),i.push(4294967296*a()|0)}return new s.init(i,e)}}),o=r.enc={},a=o.Hex={stringify:function(t){for(var e=t.words,r=t.sigBytes,i=[],n=0;n<r;n++){var s=e[n>>>2]>>>24-n%4*8&255;i.push((s>>>4).toString(16)),i.push((15&s).toString(16))}return i.join("")},parse:function(t){for(var e=t.length,r=[],i=0;i<e;i+=2)r[i>>>3]|=parseInt(t.substr(i,2),16)<<24-i%8*4;return new s.init(r,e/2)}},c=o.Latin1={stringify:function(t){for(var e=t.words,r=t.sigBytes,i=[],n=0;n<r;n++){var s=e[n>>>2]>>>24-n%4*8&255;i.push(String.fromCharCode(s))}return i.join("")},parse:function(t){for(var e=t.length,r=[],i=0;i<e;i++)r[i>>>2]|=(255&t.charCodeAt(i))<<24-i%4*8;return new s.init(r,e)}},u=o.Utf8={stringify:function(t){try{return decodeURIComponent(escape(c.stringify(t)))}catch(e){throw new Error("Malformed UTF-8 data")}},parse:function(t){return c.parse(unescape(encodeURIComponent(t)))}},h=i.BufferedBlockAlgorithm=n.extend({reset:function(){this._data=new s.init,this._nDataBytes=0},_append:function(t){"string"==typeof t&&(t=u.parse(t)),this._data.concat(t),this._nDataBytes+=t.sigBytes},_process:function(e){var r=this._data,i=r.words,n=r.sigBytes,o=this.blockSize,a=4*o,c=n/a;c=e?t.ceil(c):t.max((0|c)-this._minBufferSize,0);var u=c*o,h=t.min(4*u,n);if(u){for(var f=0;f<u;f+=o)this._doProcessBlock(i,f);var l=i.splice(0,u);r.sigBytes-=h}return new s.init(l,h)},clone:function(){var t=n.clone.call(this);return t._data=this._data.clone(),t},_minBufferSize:0}),f=(i.Hasher=h.extend({cfg:n.extend(),init:function(t){this.cfg=this.cfg.extend(t),this.reset()},reset:function(){h.reset.call(this),this._doReset()},update:function(t){return this._append(t),this._process(),this},finalize:function(t){t&&this._append(t);var e=this._doFinalize();return e},blockSize:16,_createHelper:function(t){return function(e,r){return new t.init(r).finalize(e)}},_createHmacHelper:function(t){return function(e,r){return new f.HMAC.init(t,r).finalize(e)}}}),r.algo={});return r}(Math);return t})},function(t,e,r){!function(i,n){t.exports=e=n(r(5))}(this,function(t){return function(){var e=t,r=e.lib,i=r.WordArray,n=r.Hasher,s=e.algo,o=[],a=s.SHA1=n.extend({_doReset:function(){this._hash=new i.init([1732584193,4023233417,2562383102,271733878,3285377520])},_doProcessBlock:function(t,e){for(var r=this._hash.words,i=r[0],n=r[1],s=r[2],a=r[3],c=r[4],u=0;u<80;u++){if(u<16)o[u]=0|t[e+u];else{var h=o[u-3]^o[u-8]^o[u-14]^o[u-16];o[u]=h<<1|h>>>31}var f=(i<<5|i>>>27)+c+o[u];f+=u<20?(n&s|~n&a)+1518500249:u<40?(n^s^a)+1859775393:u<60?(n&s|n&a|s&a)-1894007588:(n^s^a)-899497514,c=a,a=s,s=n<<30|n>>>2,n=i,i=f}r[0]=r[0]+i|0,r[1]=r[1]+n|0,r[2]=r[2]+s|0,r[3]=r[3]+a|0,r[4]=r[4]+c|0},_doFinalize:function(){var t=this._data,e=t.words,r=8*this._nDataBytes,i=8*t.sigBytes;return e[i>>>5]|=128<<24-i%32,e[(i+64>>>9<<4)+14]=Math.floor(r/4294967296),e[(i+64>>>9<<4)+15]=r,t.sigBytes=4*e.length,this._process(),this._hash},clone:function(){var t=n.clone.call(this);return t._hash=this._hash.clone(),t}});e.SHA1=n._createHelper(a),e.HmacSHA1=n._createHmacHelper(a)}(),t.SHA1})},function(t,e,r){!function(i,n){t.exports=e=n(r(5))}(this,function(t){!function(){var e=t,r=e.lib,i=r.Base,n=e.enc,s=n.Utf8,o=e.algo;o.HMAC=i.extend({init:function(t,e){t=this._hasher=new t.init,"string"==typeof e&&(e=s.parse(e));var r=t.blockSize,i=4*r;e.sigBytes>i&&(e=t.finalize(e)),e.clamp();for(var n=this._oKey=e.clone(),o=this._iKey=e.clone(),a=n.words,c=o.words,u=0;u<r;u++)a[u]^=1549556828,c[u]^=909522486;n.sigBytes=o.sigBytes=i,this.reset()},reset:function(){var t=this._hasher;t.reset(),t.update(this._iKey)},update:function(t){return this._hasher.update(t),this},finalize:function(t){var e=this._hasher,r=e.finalize(t);e.reset();var i=e.finalize(this._oKey.clone().concat(r));return i}})}()})},function(t,e){"use strict";var r={};r.Latin1={stringify:function(t){var e=t.words,r=t.sigBytes,i=[],n=void 0,s=void 0;for(n=0;n<r;n++)s=e[n>>>2]>>>24-n%4*8&255,i.push(String.fromCharCode(s));return i.join("")}},r._Utf8={stringify:function(t){try{return decodeURIComponent(escape(r.Latin1.stringify(t)))}catch(e){throw new Error("Malformed UTF-8 data")}}},t.exports=r},function(t,e){"use strict";var r={_keyStr:"ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",encode:function(t){var e="",i=void 0,n=void 0,s=void 0,o=void 0,a=void 0,c=void 0,u=void 0,h=0;for(t=r._utf8Encode(t);h<t.length;)i=t.charCodeAt(h++),n=t.charCodeAt(h++),s=t.charCodeAt(h++),o=i>>2,a=(3&i)<<4|n>>4,c=(15&n)<<2|s>>6,u=63&s,isNaN(n)?c=u=64:isNaN(s)&&(u=64),e=e+this._keyStr.charAt(o)+this._keyStr.charAt(a)+this._keyStr.charAt(c)+this._keyStr.charAt(u);return e},decode:function(t){var e="",i=void 0,n=void 0,s=void 0,o=void 0,a=void 0,c=void 0,u=void 0,h=0;for(t=t.replace(/[^A-Za-z0-9\+\/\=]/g,"");h<t.length;)o=this._keyStr.indexOf(t.charAt(h++)),a=this._keyStr.indexOf(t.charAt(h++)),c=this._keyStr.indexOf(t.charAt(h++)),u=this._keyStr.indexOf(t.charAt(h++)),i=o<<2|a>>4,n=(15&a)<<4|c>>2,s=(3&c)<<6|u,e+=String.fromCharCode(i),64!==c&&(e+=String.fromCharCode(n)),64!==u&&(e+=String.fromCharCode(s));return e=r._utf8Decode(e)},_utf8Encode:function(t){t=t.replace(/\r\n/g,"\n");for(var e="",r=0;r<t.length;r++){var i=t.charCodeAt(r);i<128?e+=String.fromCharCode(i):i>127&&i<2048?(e+=String.fromCharCode(i>>6|192),e+=String.fromCharCode(63&i|128)):(e+=String.fromCharCode(i>>12|224),e+=String.fromCharCode(i>>6&63|128),e+=String.fromCharCode(63&i|128))}return e},_utf8Decode:function(t){var e="",r=0,i=void 0,n=void 0,s=void 0;for(i=n=0;r<t.length;)i=t.charCodeAt(r),i<128?(e+=String.fromCharCode(i),r++):i>191&&i<224?(n=t.charCodeAt(r+1),e+=String.fromCharCode((31&i)<<6|63&n),r+=2):(n=t.charCodeAt(r+1),s=t.charCodeAt(r+2),e+=String.fromCharCode((15&i)<<12|(63&n)<<6|63&s),r+=3);return e}};t.exports=r},function(t,e,r){var i,n=function(){function t(t,e){if(!n[t]){n[t]={};for(var r=0;r<t.length;r++)n[t][t.charAt(r)]=r}return n[t][e]}var e=String.fromCharCode,r="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",i="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+-$",n={},s={compressToBase64:function(t){if(null==t)return"";var e=s._compress(t,6,function(t){return r.charAt(t)});switch(e.length%4){default:case 0:return e;case 1:return e+"===";case 2:return e+"==";case 3:return e+"="}},decompressFromBase64:function(e){return null==e?"":""==e?null:s._decompress(e.length,32,function(i){return t(r,e.charAt(i))})},compressToUTF16:function(t){return null==t?"":s._compress(t,15,function(t){return e(t+32)})+" "},decompressFromUTF16:function(t){return null==t?"":""==t?null:s._decompress(t.length,16384,function(e){return t.charCodeAt(e)-32})},compressToUint8Array:function(t){for(var e=s.compress(t),r=new Uint8Array(2*e.length),i=0,n=e.length;i<n;i++){var o=e.charCodeAt(i);r[2*i]=o>>>8,r[2*i+1]=o%256}return r},decompressFromUint8Array:function(t){if(null===t||void 0===t)return s.decompress(t);for(var r=new Array(t.length/2),i=0,n=r.length;i<n;i++)r[i]=256*t[2*i]+t[2*i+1];var o=[];return r.forEach(function(t){o.push(e(t))}),s.decompress(o.join(""))},compressToEncodedURIComponent:function(t){return null==t?"":s._compress(t,6,function(t){return i.charAt(t)})},decompressFromEncodedURIComponent:function(e){return null==e?"":""==e?null:(e=e.replace(/ /g,"+"),s._decompress(e.length,32,function(r){return t(i,e.charAt(r))}))},compress:function(t){return s._compress(t,16,function(t){return e(t)})},_compress:function(t,e,r){if(null==t)return"";var i,n,s,o={},a={},c="",u="",h="",f=2,l=3,p=2,d=[],y=0,v=0;for(s=0;s<t.length;s+=1)if(c=t.charAt(s),Object.prototype.hasOwnProperty.call(o,c)||(o[c]=l++,a[c]=!0),u=h+c,Object.prototype.hasOwnProperty.call(o,u))h=u;else{if(Object.prototype.hasOwnProperty.call(a,h)){if(h.charCodeAt(0)<256){for(i=0;i<p;i++)y<<=1,v==e-1?(v=0,d.push(r(y)),y=0):v++;for(n=h.charCodeAt(0),i=0;i<8;i++)y=y<<1|1&n,v==e-1?(v=0,d.push(r(y)),y=0):v++,n>>=1}else{for(n=1,i=0;i<p;i++)y=y<<1|n,v==e-1?(v=0,d.push(r(y)),y=0):v++,n=0;for(n=h.charCodeAt(0),i=0;i<16;i++)y=y<<1|1&n,v==e-1?(v=0,d.push(r(y)),y=0):v++,n>>=1}f--,0==f&&(f=Math.pow(2,p),p++),delete a[h]}else for(n=o[h],i=0;i<p;i++)y=y<<1|1&n,v==e-1?(v=0,d.push(r(y)),y=0):v++,n>>=1;f--,0==f&&(f=Math.pow(2,p),p++),o[u]=l++,h=String(c)}if(""!==h){if(Object.prototype.hasOwnProperty.call(a,h)){if(h.charCodeAt(0)<256){for(i=0;i<p;i++)y<<=1,v==e-1?(v=0,d.push(r(y)),y=0):v++;for(n=h.charCodeAt(0),i=0;i<8;i++)y=y<<1|1&n,v==e-1?(v=0,d.push(r(y)),y=0):v++,n>>=1}else{for(n=1,i=0;i<p;i++)y=y<<1|n,v==e-1?(v=0,d.push(r(y)),y=0):v++,n=0;for(n=h.charCodeAt(0),i=0;i<16;i++)y=y<<1|1&n,v==e-1?(v=0,d.push(r(y)),y=0):v++,n>>=1}f--,0==f&&(f=Math.pow(2,p),p++),delete a[h]}else for(n=o[h],i=0;i<p;i++)y=y<<1|1&n,v==e-1?(v=0,d.push(r(y)),y=0):v++,n>>=1;f--,0==f&&(f=Math.pow(2,p),p++)}for(n=2,i=0;i<p;i++)y=y<<1|1&n,v==e-1?(v=0,d.push(r(y)),y=0):v++,n>>=1;for(;;){if(y<<=1,v==e-1){d.push(r(y));break}v++}return d.join("")},decompress:function(t){return null==t?"":""==t?null:s._decompress(t.length,32768,function(e){return t.charCodeAt(e)})},_decompress:function(t,r,i){var n,s,o,a,c,u,h,f,l=[],p=4,d=4,y=3,v="",_=[],g={val:i(0),position:r,index:1};for(s=0;s<3;s+=1)l[s]=s;for(a=0,u=Math.pow(2,2),h=1;h!=u;)c=g.val&g.position,g.position>>=1,0==g.position&&(g.position=r,g.val=i(g.index++)),a|=(c>0?1:0)*h,h<<=1;switch(n=a){case 0:for(a=0,u=Math.pow(2,8),h=1;h!=u;)c=g.val&g.position,g.position>>=1,0==g.position&&(g.position=r,g.val=i(g.index++)),a|=(c>0?1:0)*h,h<<=1;f=e(a);break;case 1:for(a=0,u=Math.pow(2,16),h=1;h!=u;)c=g.val&g.position,g.position>>=1,0==g.position&&(g.position=r,g.val=i(g.index++)),a|=(c>0?1:0)*h,h<<=1;f=e(a);break;case 2:return""}for(l[3]=f,o=f,_.push(f);;){if(g.index>t)return"";for(a=0,u=Math.pow(2,y),h=1;h!=u;)c=g.val&g.position,g.position>>=1,0==g.position&&(g.position=r,g.val=i(g.index++)),a|=(c>0?1:0)*h,h<<=1;switch(f=a){case 0:for(a=0,u=Math.pow(2,8),h=1;h!=u;)c=g.val&g.position,g.position>>=1,0==g.position&&(g.position=r,g.val=i(g.index++)),a|=(c>0?1:0)*h,h<<=1;l[d++]=e(a),f=d-1,p--;break;case 1:for(a=0,u=Math.pow(2,16),h=1;h!=u;)c=g.val&g.position,g.position>>=1,0==g.position&&(g.position=r,g.val=i(g.index++)),a|=(c>0?1:0)*h,h<<=1;l[d++]=e(a),f=d-1,p--;break;case 2:return _.join("")}if(0==p&&(p=Math.pow(2,y),y++),l[f])v=l[f];else{if(f!==d)return null;v=o+o.charAt(0)}_.push(v),l[d++]=o+v.charAt(0),p--,o=v,0==p&&(p=Math.pow(2,y),y++)}}};return s}();i=function(){return n}.call(e,r,e,t),!(void 0!==i&&(t.exports=i))},function(t,e,r){!function(i,n,s){t.exports=e=n(r(5),r(12),r(13),r(14),r(15))}(this,function(t){return function(){var e=t,r=e.lib,i=r.BlockCipher,n=e.algo,s=[],o=[],a=[],c=[],u=[],h=[],f=[],l=[],p=[],d=[];!function(){for(var t=[],e=0;e<256;e++)e<128?t[e]=e<<1:t[e]=e<<1^283;for(var r=0,i=0,e=0;e<256;e++){var n=i^i<<1^i<<2^i<<3^i<<4;n=n>>>8^255&n^99,s[r]=n,o[n]=r;var y=t[r],v=t[y],_=t[v],g=257*t[n]^16843008*n;a[r]=g<<24|g>>>8,c[r]=g<<16|g>>>16,u[r]=g<<8|g>>>24,h[r]=g;var g=16843009*_^65537*v^257*y^16843008*r;f[n]=g<<24|g>>>8,l[n]=g<<16|g>>>16,p[n]=g<<8|g>>>24,d[n]=g,r?(r=y^t[t[t[_^y]]],i^=t[t[i]]):r=i=1}}();var y=[0,1,2,4,8,16,32,64,128,27,54],v=n.AES=i.extend({_doReset:function(){for(var t=this._key,e=t.words,r=t.sigBytes/4,i=this._nRounds=r+6,n=4*(i+1),o=this._keySchedule=[],a=0;a<n;a++)if(a<r)o[a]=e[a];else{var c=o[a-1];a%r?r>6&&a%r==4&&(c=s[c>>>24]<<24|s[c>>>16&255]<<16|s[c>>>8&255]<<8|s[255&c]):(c=c<<8|c>>>24,c=s[c>>>24]<<24|s[c>>>16&255]<<16|s[c>>>8&255]<<8|s[255&c],c^=y[a/r|0]<<24),o[a]=o[a-r]^c}for(var u=this._invKeySchedule=[],h=0;h<n;h++){var a=n-h;if(h%4)var c=o[a];else var c=o[a-4];h<4||a<=4?u[h]=c:u[h]=f[s[c>>>24]]^l[s[c>>>16&255]]^p[s[c>>>8&255]]^d[s[255&c]]}},encryptBlock:function(t,e){this._doCryptBlock(t,e,this._keySchedule,a,c,u,h,s)},decryptBlock:function(t,e){var r=t[e+1];t[e+1]=t[e+3],t[e+3]=r,this._doCryptBlock(t,e,this._invKeySchedule,f,l,p,d,o);var r=t[e+1];t[e+1]=t[e+3],t[e+3]=r},_doCryptBlock:function(t,e,r,i,n,s,o,a){for(var c=this._nRounds,u=t[e]^r[0],h=t[e+1]^r[1],f=t[e+2]^r[2],l=t[e+3]^r[3],p=4,d=1;d<c;d++){var y=i[u>>>24]^n[h>>>16&255]^s[f>>>8&255]^o[255&l]^r[p++],v=i[h>>>24]^n[f>>>16&255]^s[l>>>8&255]^o[255&u]^r[p++],_=i[f>>>24]^n[l>>>16&255]^s[u>>>8&255]^o[255&h]^r[p++],g=i[l>>>24]^n[u>>>16&255]^s[h>>>8&255]^o[255&f]^r[p++];u=y,h=v,f=_,l=g}var y=(a[u>>>24]<<24|a[h>>>16&255]<<16|a[f>>>8&255]<<8|a[255&l])^r[p++],v=(a[h>>>24]<<24|a[f>>>16&255]<<16|a[l>>>8&255]<<8|a[255&u])^r[p++],_=(a[f>>>24]<<24|a[l>>>16&255]<<16|a[u>>>8&255]<<8|a[255&h])^r[p++],g=(a[l>>>24]<<24|a[u>>>16&255]<<16|a[h>>>8&255]<<8|a[255&f])^r[p++];t[e]=y,t[e+1]=v,t[e+2]=_,t[e+3]=g},keySize:8});e.AES=i._createHelper(v)}(),t.AES})},function(t,e,r){!function(i,n){t.exports=e=n(r(5))}(this,function(t){return function(){var e=t,r=e.lib,i=r.WordArray,n=e.enc;n.Base64={stringify:function(t){var e=t.words,r=t.sigBytes,i=this._map;t.clamp();for(var n=[],s=0;s<r;s+=3)for(var o=e[s>>>2]>>>24-s%4*8&255,a=e[s+1>>>2]>>>24-(s+1)%4*8&255,c=e[s+2>>>2]>>>24-(s+2)%4*8&255,u=o<<16|a<<8|c,h=0;h<4&&s+.75*h<r;h++)n.push(i.charAt(u>>>6*(3-h)&63));var f=i.charAt(64);if(f)for(;n.length%4;)n.push(f);return n.join("")},parse:function(t){var e=t.length,r=this._map,n=r.charAt(64);if(n){var s=t.indexOf(n);s!=-1&&(e=s)}for(var o=[],a=0,c=0;c<e;c++)if(c%4){var u=r.indexOf(t.charAt(c-1))<<c%4*2,h=r.indexOf(t.charAt(c))>>>6-c%4*2,f=u|h;o[a>>>2]|=f<<24-a%4*8,a++}return i.create(o,a)},_map:"ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/="}}(),t.enc.Base64})},function(t,e,r){!function(i,n){t.exports=e=n(r(5))}(this,function(t){return function(e){function r(t,e,r,i,n,s,o){var a=t+(e&r|~e&i)+n+o;return(a<<s|a>>>32-s)+e}function i(t,e,r,i,n,s,o){var a=t+(e&i|r&~i)+n+o;return(a<<s|a>>>32-s)+e}function n(t,e,r,i,n,s,o){var a=t+(e^r^i)+n+o;return(a<<s|a>>>32-s)+e}function s(t,e,r,i,n,s,o){var a=t+(r^(e|~i))+n+o;return(a<<s|a>>>32-s)+e}var o=t,a=o.lib,c=a.WordArray,u=a.Hasher,h=o.algo,f=[];!function(){for(var t=0;t<64;t++)f[t]=4294967296*e.abs(e.sin(t+1))|0}();var l=h.MD5=u.extend({_doReset:function(){this._hash=new c.init([1732584193,4023233417,2562383102,271733878])},_doProcessBlock:function(t,e){for(var o=0;o<16;o++){var a=e+o,c=t[a];t[a]=16711935&(c<<8|c>>>24)|4278255360&(c<<24|c>>>8)}var u=this._hash.words,h=t[e+0],l=t[e+1],p=t[e+2],d=t[e+3],y=t[e+4],v=t[e+5],_=t[e+6],g=t[e+7],S=t[e+8],m=t[e+9],k=t[e+10],B=t[e+11],E=t[e+12],C=t[e+13],x=t[e+14],A=t[e+15],w=u[0],b=u[1],D=u[2],T=u[3];w=r(w,b,D,T,h,7,f[0]),T=r(T,w,b,D,l,12,f[1]),D=r(D,T,w,b,p,17,f[2]),b=r(b,D,T,w,d,22,f[3]),w=r(w,b,D,T,y,7,f[4]),T=r(T,w,b,D,v,12,f[5]),D=r(D,T,w,b,_,17,f[6]),b=r(b,D,T,w,g,22,f[7]),w=r(w,b,D,T,S,7,f[8]),T=r(T,w,b,D,m,12,f[9]),D=r(D,T,w,b,k,17,f[10]),b=r(b,D,T,w,B,22,f[11]),w=r(w,b,D,T,E,7,f[12]),T=r(T,w,b,D,C,12,f[13]),D=r(D,T,w,b,x,17,f[14]),b=r(b,D,T,w,A,22,f[15]),w=i(w,b,D,T,l,5,f[16]),T=i(T,w,b,D,_,9,f[17]),D=i(D,T,w,b,B,14,f[18]),b=i(b,D,T,w,h,20,f[19]),w=i(w,b,D,T,v,5,f[20]),T=i(T,w,b,D,k,9,f[21]),D=i(D,T,w,b,A,14,f[22]),b=i(b,D,T,w,y,20,f[23]),w=i(w,b,D,T,m,5,f[24]),T=i(T,w,b,D,x,9,f[25]),D=i(D,T,w,b,d,14,f[26]),b=i(b,D,T,w,S,20,f[27]),w=i(w,b,D,T,C,5,f[28]),T=i(T,w,b,D,p,9,f[29]),D=i(D,T,w,b,g,14,f[30]),b=i(b,D,T,w,E,20,f[31]),w=n(w,b,D,T,v,4,f[32]),T=n(T,w,b,D,S,11,f[33]),D=n(D,T,w,b,B,16,f[34]),b=n(b,D,T,w,x,23,f[35]),w=n(w,b,D,T,l,4,f[36]),T=n(T,w,b,D,y,11,f[37]),D=n(D,T,w,b,g,16,f[38]),b=n(b,D,T,w,k,23,f[39]),w=n(w,b,D,T,C,4,f[40]),T=n(T,w,b,D,h,11,f[41]),D=n(D,T,w,b,d,16,f[42]),b=n(b,D,T,w,_,23,f[43]),w=n(w,b,D,T,m,4,f[44]),T=n(T,w,b,D,E,11,f[45]),D=n(D,T,w,b,A,16,f[46]),b=n(b,D,T,w,p,23,f[47]),w=s(w,b,D,T,h,6,f[48]),T=s(T,w,b,D,g,10,f[49]),D=s(D,T,w,b,x,15,f[50]),b=s(b,D,T,w,v,21,f[51]),w=s(w,b,D,T,E,6,f[52]),T=s(T,w,b,D,d,10,f[53]),D=s(D,T,w,b,k,15,f[54]),b=s(b,D,T,w,l,21,f[55]),w=s(w,b,D,T,S,6,f[56]),T=s(T,w,b,D,A,10,f[57]),D=s(D,T,w,b,_,15,f[58]),b=s(b,D,T,w,C,21,f[59]),w=s(w,b,D,T,y,6,f[60]),T=s(T,w,b,D,B,10,f[61]),D=s(D,T,w,b,p,15,f[62]),b=s(b,D,T,w,m,21,f[63]),u[0]=u[0]+w|0,u[1]=u[1]+b|0,u[2]=u[2]+D|0,u[3]=u[3]+T|0},_doFinalize:function(){var t=this._data,r=t.words,i=8*this._nDataBytes,n=8*t.sigBytes;r[n>>>5]|=128<<24-n%32;var s=e.floor(i/4294967296),o=i;r[(n+64>>>9<<4)+15]=16711935&(s<<8|s>>>24)|4278255360&(s<<24|s>>>8),r[(n+64>>>9<<4)+14]=16711935&(o<<8|o>>>24)|4278255360&(o<<24|o>>>8),t.sigBytes=4*(r.length+1),this._process();for(var a=this._hash,c=a.words,u=0;u<4;u++){var h=c[u];c[u]=16711935&(h<<8|h>>>24)|4278255360&(h<<24|h>>>8)}return a},clone:function(){var t=u.clone.call(this);return t._hash=this._hash.clone(),t}});o.MD5=u._createHelper(l),o.HmacMD5=u._createHmacHelper(l)}(Math),t.MD5})},function(t,e,r){!function(i,n,s){t.exports=e=n(r(5),r(6),r(7))}(this,function(t){return function(){var e=t,r=e.lib,i=r.Base,n=r.WordArray,s=e.algo,o=s.MD5,a=s.EvpKDF=i.extend({cfg:i.extend({keySize:4,hasher:o,iterations:1}),init:function(t){this.cfg=this.cfg.extend(t)},compute:function(t,e){for(var r=this.cfg,i=r.hasher.create(),s=n.create(),o=s.words,a=r.keySize,c=r.iterations;o.length<a;){u&&i.update(u);var u=i.update(t).finalize(e);i.reset();for(var h=1;h<c;h++)u=i.finalize(u),i.reset();s.concat(u)}return s.sigBytes=4*a,s}});e.EvpKDF=function(t,e,r){return a.create(r).compute(t,e)}}(),t.EvpKDF})},function(t,e,r){!function(i,n){t.exports=e=n(r(5))}(this,function(t){t.lib.Cipher||function(e){var r=t,i=r.lib,n=i.Base,s=i.WordArray,o=i.BufferedBlockAlgorithm,a=r.enc,c=(a.Utf8,a.Base64),u=r.algo,h=u.EvpKDF,f=i.Cipher=o.extend({cfg:n.extend(),createEncryptor:function(t,e){return this.create(this._ENC_XFORM_MODE,t,e)},createDecryptor:function(t,e){return this.create(this._DEC_XFORM_MODE,t,e)},init:function(t,e,r){this.cfg=this.cfg.extend(r),this._xformMode=t,this._key=e,this.reset()},reset:function(){o.reset.call(this),this._doReset()},process:function(t){return this._append(t),this._process()},finalize:function(t){t&&this._append(t);var e=this._doFinalize();return e},keySize:4,ivSize:4,_ENC_XFORM_MODE:1,_DEC_XFORM_MODE:2,_createHelper:function(){function t(t){return"string"==typeof t?E:m}return function(e){return{encrypt:function(r,i,n){return t(i).encrypt(e,r,i,n)},decrypt:function(r,i,n){return t(i).decrypt(e,r,i,n)}}}}()}),l=(i.StreamCipher=f.extend({_doFinalize:function(){var t=this._process(!0);return t},blockSize:1}),r.mode={}),p=i.BlockCipherMode=n.extend({createEncryptor:function(t,e){return this.Encryptor.create(t,e)},createDecryptor:function(t,e){return this.Decryptor.create(t,e)},init:function(t,e){this._cipher=t,this._iv=e}}),d=l.CBC=function(){function t(t,r,i){var n=this._iv;if(n){var s=n;this._iv=e}else var s=this._prevBlock;for(var o=0;o<i;o++)t[r+o]^=s[o]}var r=p.extend();return r.Encryptor=r.extend({processBlock:function(e,r){var i=this._cipher,n=i.blockSize;t.call(this,e,r,n),i.encryptBlock(e,r),this._prevBlock=e.slice(r,r+n)}}),r.Decryptor=r.extend({processBlock:function(e,r){var i=this._cipher,n=i.blockSize,s=e.slice(r,r+n);i.decryptBlock(e,r),t.call(this,e,r,n),this._prevBlock=s}}),r}(),y=r.pad={},v=y.Pkcs7={pad:function(t,e){for(var r=4*e,i=r-t.sigBytes%r,n=i<<24|i<<16|i<<8|i,o=[],a=0;a<i;a+=4)o.push(n);var c=s.create(o,i);t.concat(c)},unpad:function(t){var e=255&t.words[t.sigBytes-1>>>2];t.sigBytes-=e}},_=(i.BlockCipher=f.extend({cfg:f.cfg.extend({mode:d,padding:v}),reset:function(){f.reset.call(this);var t=this.cfg,e=t.iv,r=t.mode;if(this._xformMode==this._ENC_XFORM_MODE)var i=r.createEncryptor;else{var i=r.createDecryptor;this._minBufferSize=1}this._mode=i.call(r,this,e&&e.words)},_doProcessBlock:function(t,e){this._mode.processBlock(t,e)},_doFinalize:function(){var t=this.cfg.padding;if(this._xformMode==this._ENC_XFORM_MODE){t.pad(this._data,this.blockSize);var e=this._process(!0)}else{var e=this._process(!0);t.unpad(e)}return e},blockSize:4}),i.CipherParams=n.extend({init:function(t){this.mixIn(t)},toString:function(t){return(t||this.formatter).stringify(this)}})),g=r.format={},S=g.OpenSSL={stringify:function(t){var e=t.ciphertext,r=t.salt;if(r)var i=s.create([1398893684,1701076831]).concat(r).concat(e);else var i=e;return i.toString(c)},parse:function(t){var e=c.parse(t),r=e.words;if(1398893684==r[0]&&1701076831==r[1]){var i=s.create(r.slice(2,4));r.splice(0,4),e.sigBytes-=16}return _.create({ciphertext:e,salt:i})}},m=i.SerializableCipher=n.extend({cfg:n.extend({format:S}),encrypt:function(t,e,r,i){i=this.cfg.extend(i);var n=t.createEncryptor(r,i),s=n.finalize(e),o=n.cfg;return _.create({ciphertext:s,key:r,iv:o.iv,algorithm:t,mode:o.mode,padding:o.padding,blockSize:t.blockSize,formatter:i.format})},decrypt:function(t,e,r,i){i=this.cfg.extend(i),e=this._parse(e,i.format);var n=t.createDecryptor(r,i).finalize(e.ciphertext);return n},_parse:function(t,e){return"string"==typeof t?e.parse(t,this):t}}),k=r.kdf={},B=k.OpenSSL={execute:function(t,e,r,i){i||(i=s.random(8));var n=h.create({keySize:e+r}).compute(t,i),o=s.create(n.words.slice(e),4*r);return n.sigBytes=4*e,_.create({key:n,iv:o,salt:i})}},E=i.PasswordBasedCipher=m.extend({cfg:m.cfg.extend({kdf:B}),encrypt:function(t,e,r,i){i=this.cfg.extend(i);var n=i.kdf.execute(r,t.keySize,t.ivSize);i.iv=n.iv;var s=m.encrypt.call(this,t,e,n.key,i);return s.mixIn(n),s},decrypt:function(t,e,r,i){i=this.cfg.extend(i),e=this._parse(e,i.format);var n=i.kdf.execute(r,t.keySize,t.ivSize,e.salt);i.iv=n.iv;var s=m.decrypt.call(this,t,e,n.key,i);return s}})}()})},function(t,e,r){!function(i,n,s){t.exports=e=n(r(5),r(12),r(13),r(14),r(15))}(this,function(t){return function(){function e(t,e){var r=(this._lBlock>>>t^this._rBlock)&e;this._rBlock^=r,this._lBlock^=r<<t}function r(t,e){
var r=(this._rBlock>>>t^this._lBlock)&e;this._lBlock^=r,this._rBlock^=r<<t}var i=t,n=i.lib,s=n.WordArray,o=n.BlockCipher,a=i.algo,c=[57,49,41,33,25,17,9,1,58,50,42,34,26,18,10,2,59,51,43,35,27,19,11,3,60,52,44,36,63,55,47,39,31,23,15,7,62,54,46,38,30,22,14,6,61,53,45,37,29,21,13,5,28,20,12,4],u=[14,17,11,24,1,5,3,28,15,6,21,10,23,19,12,4,26,8,16,7,27,20,13,2,41,52,31,37,47,55,30,40,51,45,33,48,44,49,39,56,34,53,46,42,50,36,29,32],h=[1,2,4,6,8,10,12,14,15,17,19,21,23,25,27,28],f=[{0:8421888,268435456:32768,536870912:8421378,805306368:2,1073741824:512,1342177280:8421890,1610612736:8389122,1879048192:8388608,2147483648:514,2415919104:8389120,2684354560:33280,2952790016:8421376,3221225472:32770,3489660928:8388610,3758096384:0,4026531840:33282,134217728:0,402653184:8421890,671088640:33282,939524096:32768,1207959552:8421888,1476395008:512,1744830464:8421378,2013265920:2,2281701376:8389120,2550136832:33280,2818572288:8421376,3087007744:8389122,3355443200:8388610,3623878656:32770,3892314112:514,4160749568:8388608,1:32768,268435457:2,536870913:8421888,805306369:8388608,1073741825:8421378,1342177281:33280,1610612737:512,1879048193:8389122,2147483649:8421890,2415919105:8421376,2684354561:8388610,2952790017:33282,3221225473:514,3489660929:8389120,3758096385:32770,4026531841:0,134217729:8421890,402653185:8421376,671088641:8388608,939524097:512,1207959553:32768,1476395009:8388610,1744830465:2,2013265921:33282,2281701377:32770,2550136833:8389122,2818572289:514,3087007745:8421888,3355443201:8389120,3623878657:0,3892314113:33280,4160749569:8421378},{0:1074282512,16777216:16384,33554432:524288,50331648:1074266128,67108864:1073741840,83886080:1074282496,100663296:1073758208,117440512:16,134217728:540672,150994944:1073758224,167772160:1073741824,184549376:540688,201326592:524304,218103808:0,234881024:16400,251658240:1074266112,8388608:1073758208,25165824:540688,41943040:16,58720256:1073758224,75497472:1074282512,92274688:1073741824,109051904:524288,125829120:1074266128,142606336:524304,159383552:0,176160768:16384,192937984:1074266112,209715200:1073741840,226492416:540672,243269632:1074282496,260046848:16400,268435456:0,285212672:1074266128,301989888:1073758224,318767104:1074282496,335544320:1074266112,352321536:16,369098752:540688,385875968:16384,402653184:16400,419430400:524288,436207616:524304,452984832:1073741840,469762048:540672,486539264:1073758208,503316480:1073741824,520093696:1074282512,276824064:540688,293601280:524288,310378496:1074266112,327155712:16384,343932928:1073758208,360710144:1074282512,377487360:16,394264576:1073741824,411041792:1074282496,427819008:1073741840,444596224:1073758224,461373440:524304,478150656:0,494927872:16400,511705088:1074266128,528482304:540672},{0:260,1048576:0,2097152:67109120,3145728:65796,4194304:65540,5242880:67108868,6291456:67174660,7340032:67174400,8388608:67108864,9437184:67174656,10485760:65792,11534336:67174404,12582912:67109124,13631488:65536,14680064:4,15728640:256,524288:67174656,1572864:67174404,2621440:0,3670016:67109120,4718592:67108868,5767168:65536,6815744:65540,7864320:260,8912896:4,9961472:256,11010048:67174400,12058624:65796,13107200:65792,14155776:67109124,15204352:67174660,16252928:67108864,16777216:67174656,17825792:65540,18874368:65536,19922944:67109120,20971520:256,22020096:67174660,23068672:67108868,24117248:0,25165824:67109124,26214400:67108864,27262976:4,28311552:65792,29360128:67174400,30408704:260,31457280:65796,32505856:67174404,17301504:67108864,18350080:260,19398656:67174656,20447232:0,21495808:65540,22544384:67109120,23592960:256,24641536:67174404,25690112:65536,26738688:67174660,27787264:65796,28835840:67108868,29884416:67109124,30932992:67174400,31981568:4,33030144:65792},{0:2151682048,65536:2147487808,131072:4198464,196608:2151677952,262144:0,327680:4198400,393216:2147483712,458752:4194368,524288:2147483648,589824:4194304,655360:64,720896:2147487744,786432:2151678016,851968:4160,917504:4096,983040:2151682112,32768:2147487808,98304:64,163840:2151678016,229376:2147487744,294912:4198400,360448:2151682112,425984:0,491520:2151677952,557056:4096,622592:2151682048,688128:4194304,753664:4160,819200:2147483648,884736:4194368,950272:4198464,1015808:2147483712,1048576:4194368,1114112:4198400,1179648:2147483712,1245184:0,1310720:4160,1376256:2151678016,1441792:2151682048,1507328:2147487808,1572864:2151682112,1638400:2147483648,1703936:2151677952,1769472:4198464,1835008:2147487744,1900544:4194304,1966080:64,2031616:4096,1081344:2151677952,1146880:2151682112,1212416:0,1277952:4198400,1343488:4194368,1409024:2147483648,1474560:2147487808,1540096:64,1605632:2147483712,1671168:4096,1736704:2147487744,1802240:2151678016,1867776:4160,1933312:2151682048,1998848:4194304,2064384:4198464},{0:128,4096:17039360,8192:262144,12288:536870912,16384:537133184,20480:16777344,24576:553648256,28672:262272,32768:16777216,36864:537133056,40960:536871040,45056:553910400,49152:553910272,53248:0,57344:17039488,61440:553648128,2048:17039488,6144:553648256,10240:128,14336:17039360,18432:262144,22528:537133184,26624:553910272,30720:536870912,34816:537133056,38912:0,43008:553910400,47104:16777344,51200:536871040,55296:553648128,59392:16777216,63488:262272,65536:262144,69632:128,73728:536870912,77824:553648256,81920:16777344,86016:553910272,90112:537133184,94208:16777216,98304:553910400,102400:553648128,106496:17039360,110592:537133056,114688:262272,118784:536871040,122880:0,126976:17039488,67584:553648256,71680:16777216,75776:17039360,79872:537133184,83968:536870912,88064:17039488,92160:128,96256:553910272,100352:262272,104448:553910400,108544:0,112640:553648128,116736:16777344,120832:262144,124928:537133056,129024:536871040},{0:268435464,256:8192,512:270532608,768:270540808,1024:268443648,1280:2097152,1536:2097160,1792:268435456,2048:0,2304:268443656,2560:2105344,2816:8,3072:270532616,3328:2105352,3584:8200,3840:270540800,128:270532608,384:270540808,640:8,896:2097152,1152:2105352,1408:268435464,1664:268443648,1920:8200,2176:2097160,2432:8192,2688:268443656,2944:270532616,3200:0,3456:270540800,3712:2105344,3968:268435456,4096:268443648,4352:270532616,4608:270540808,4864:8200,5120:2097152,5376:268435456,5632:268435464,5888:2105344,6144:2105352,6400:0,6656:8,6912:270532608,7168:8192,7424:268443656,7680:270540800,7936:2097160,4224:8,4480:2105344,4736:2097152,4992:268435464,5248:268443648,5504:8200,5760:270540808,6016:270532608,6272:270540800,6528:270532616,6784:8192,7040:2105352,7296:2097160,7552:0,7808:268435456,8064:268443656},{0:1048576,16:33555457,32:1024,48:1049601,64:34604033,80:0,96:1,112:34603009,128:33555456,144:1048577,160:33554433,176:34604032,192:34603008,208:1025,224:1049600,240:33554432,8:34603009,24:0,40:33555457,56:34604032,72:1048576,88:33554433,104:33554432,120:1025,136:1049601,152:33555456,168:34603008,184:1048577,200:1024,216:34604033,232:1,248:1049600,256:33554432,272:1048576,288:33555457,304:34603009,320:1048577,336:33555456,352:34604032,368:1049601,384:1025,400:34604033,416:1049600,432:1,448:0,464:34603008,480:33554433,496:1024,264:1049600,280:33555457,296:34603009,312:1,328:33554432,344:1048576,360:1025,376:34604032,392:33554433,408:34603008,424:0,440:34604033,456:1049601,472:1024,488:33555456,504:1048577},{0:134219808,1:131072,2:134217728,3:32,4:131104,5:134350880,6:134350848,7:2048,8:134348800,9:134219776,10:133120,11:134348832,12:2080,13:0,14:134217760,15:133152,2147483648:2048,2147483649:134350880,2147483650:134219808,2147483651:134217728,2147483652:134348800,2147483653:133120,2147483654:133152,2147483655:32,2147483656:134217760,2147483657:2080,2147483658:131104,2147483659:134350848,2147483660:0,2147483661:134348832,2147483662:134219776,2147483663:131072,16:133152,17:134350848,18:32,19:2048,20:134219776,21:134217760,22:134348832,23:131072,24:0,25:131104,26:134348800,27:134219808,28:134350880,29:133120,30:2080,31:134217728,2147483664:131072,2147483665:2048,2147483666:134348832,2147483667:133152,2147483668:32,2147483669:134348800,2147483670:134217728,2147483671:134219808,2147483672:134350880,2147483673:134217760,2147483674:134219776,2147483675:0,2147483676:133120,2147483677:2080,2147483678:131104,2147483679:134350848}],l=[4160749569,528482304,33030144,2064384,129024,8064,504,2147483679],p=a.DES=o.extend({_doReset:function(){for(var t=this._key,e=t.words,r=[],i=0;i<56;i++){var n=c[i]-1;r[i]=e[n>>>5]>>>31-n%32&1}for(var s=this._subKeys=[],o=0;o<16;o++){for(var a=s[o]=[],f=h[o],i=0;i<24;i++)a[i/6|0]|=r[(u[i]-1+f)%28]<<31-i%6,a[4+(i/6|0)]|=r[28+(u[i+24]-1+f)%28]<<31-i%6;a[0]=a[0]<<1|a[0]>>>31;for(var i=1;i<7;i++)a[i]=a[i]>>>4*(i-1)+3;a[7]=a[7]<<5|a[7]>>>27}for(var l=this._invSubKeys=[],i=0;i<16;i++)l[i]=s[15-i]},encryptBlock:function(t,e){this._doCryptBlock(t,e,this._subKeys)},decryptBlock:function(t,e){this._doCryptBlock(t,e,this._invSubKeys)},_doCryptBlock:function(t,i,n){this._lBlock=t[i],this._rBlock=t[i+1],e.call(this,4,252645135),e.call(this,16,65535),r.call(this,2,858993459),r.call(this,8,16711935),e.call(this,1,1431655765);for(var s=0;s<16;s++){for(var o=n[s],a=this._lBlock,c=this._rBlock,u=0,h=0;h<8;h++)u|=f[h][((c^o[h])&l[h])>>>0];this._lBlock=c,this._rBlock=a^u}var p=this._lBlock;this._lBlock=this._rBlock,this._rBlock=p,e.call(this,1,1431655765),r.call(this,8,16711935),r.call(this,2,858993459),e.call(this,16,65535),e.call(this,4,252645135),t[i]=this._lBlock,t[i+1]=this._rBlock},keySize:2,ivSize:2,blockSize:2});i.DES=o._createHelper(p);var d=a.TripleDES=o.extend({_doReset:function(){var t=this._key,e=t.words;this._des1=p.createEncryptor(s.create(e.slice(0,2))),this._des2=p.createEncryptor(s.create(e.slice(2,4))),this._des3=p.createEncryptor(s.create(e.slice(4,6)))},encryptBlock:function(t,e){this._des1.encryptBlock(t,e),this._des2.decryptBlock(t,e),this._des3.encryptBlock(t,e)},decryptBlock:function(t,e){this._des3.decryptBlock(t,e),this._des2.encryptBlock(t,e),this._des1.decryptBlock(t,e)},keySize:6,ivSize:2,blockSize:2});i.TripleDES=o._createHelper(d)}(),t.TripleDES})},function(t,e,r){!function(i,n,s){t.exports=e=n(r(5),r(12),r(13),r(14),r(15))}(this,function(t){return function(){function e(){for(var t=this._X,e=this._C,r=0;r<8;r++)a[r]=e[r];e[0]=e[0]+1295307597+this._b|0,e[1]=e[1]+3545052371+(e[0]>>>0<a[0]>>>0?1:0)|0,e[2]=e[2]+886263092+(e[1]>>>0<a[1]>>>0?1:0)|0,e[3]=e[3]+1295307597+(e[2]>>>0<a[2]>>>0?1:0)|0,e[4]=e[4]+3545052371+(e[3]>>>0<a[3]>>>0?1:0)|0,e[5]=e[5]+886263092+(e[4]>>>0<a[4]>>>0?1:0)|0,e[6]=e[6]+1295307597+(e[5]>>>0<a[5]>>>0?1:0)|0,e[7]=e[7]+3545052371+(e[6]>>>0<a[6]>>>0?1:0)|0,this._b=e[7]>>>0<a[7]>>>0?1:0;for(var r=0;r<8;r++){var i=t[r]+e[r],n=65535&i,s=i>>>16,o=((n*n>>>17)+n*s>>>15)+s*s,u=((4294901760&i)*i|0)+((65535&i)*i|0);c[r]=o^u}t[0]=c[0]+(c[7]<<16|c[7]>>>16)+(c[6]<<16|c[6]>>>16)|0,t[1]=c[1]+(c[0]<<8|c[0]>>>24)+c[7]|0,t[2]=c[2]+(c[1]<<16|c[1]>>>16)+(c[0]<<16|c[0]>>>16)|0,t[3]=c[3]+(c[2]<<8|c[2]>>>24)+c[1]|0,t[4]=c[4]+(c[3]<<16|c[3]>>>16)+(c[2]<<16|c[2]>>>16)|0,t[5]=c[5]+(c[4]<<8|c[4]>>>24)+c[3]|0,t[6]=c[6]+(c[5]<<16|c[5]>>>16)+(c[4]<<16|c[4]>>>16)|0,t[7]=c[7]+(c[6]<<8|c[6]>>>24)+c[5]|0}var r=t,i=r.lib,n=i.StreamCipher,s=r.algo,o=[],a=[],c=[],u=s.Rabbit=n.extend({_doReset:function(){for(var t=this._key.words,r=this.cfg.iv,i=0;i<4;i++)t[i]=16711935&(t[i]<<8|t[i]>>>24)|4278255360&(t[i]<<24|t[i]>>>8);var n=this._X=[t[0],t[3]<<16|t[2]>>>16,t[1],t[0]<<16|t[3]>>>16,t[2],t[1]<<16|t[0]>>>16,t[3],t[2]<<16|t[1]>>>16],s=this._C=[t[2]<<16|t[2]>>>16,4294901760&t[0]|65535&t[1],t[3]<<16|t[3]>>>16,4294901760&t[1]|65535&t[2],t[0]<<16|t[0]>>>16,4294901760&t[2]|65535&t[3],t[1]<<16|t[1]>>>16,4294901760&t[3]|65535&t[0]];this._b=0;for(var i=0;i<4;i++)e.call(this);for(var i=0;i<8;i++)s[i]^=n[i+4&7];if(r){var o=r.words,a=o[0],c=o[1],u=16711935&(a<<8|a>>>24)|4278255360&(a<<24|a>>>8),h=16711935&(c<<8|c>>>24)|4278255360&(c<<24|c>>>8),f=u>>>16|4294901760&h,l=h<<16|65535&u;s[0]^=u,s[1]^=f,s[2]^=h,s[3]^=l,s[4]^=u,s[5]^=f,s[6]^=h,s[7]^=l;for(var i=0;i<4;i++)e.call(this)}},_doProcessBlock:function(t,r){var i=this._X;e.call(this),o[0]=i[0]^i[5]>>>16^i[3]<<16,o[1]=i[2]^i[7]>>>16^i[5]<<16,o[2]=i[4]^i[1]>>>16^i[7]<<16,o[3]=i[6]^i[3]>>>16^i[1]<<16;for(var n=0;n<4;n++)o[n]=16711935&(o[n]<<8|o[n]>>>24)|4278255360&(o[n]<<24|o[n]>>>8),t[r+n]^=o[n]},blockSize:4,ivSize:2});r.Rabbit=n._createHelper(u)}(),t.Rabbit})},function(t,e,r){!function(i,n,s){t.exports=e=n(r(5),r(12),r(13),r(14),r(15))}(this,function(t){return function(){function e(){for(var t=this._S,e=this._i,r=this._j,i=0,n=0;n<4;n++){e=(e+1)%256,r=(r+t[e])%256;var s=t[e];t[e]=t[r],t[r]=s,i|=t[(t[e]+t[r])%256]<<24-8*n}return this._i=e,this._j=r,i}var r=t,i=r.lib,n=i.StreamCipher,s=r.algo,o=s.RC4=n.extend({_doReset:function(){for(var t=this._key,e=t.words,r=t.sigBytes,i=this._S=[],n=0;n<256;n++)i[n]=n;for(var n=0,s=0;n<256;n++){var o=n%r,a=e[o>>>2]>>>24-o%4*8&255;s=(s+i[n]+a)%256;var c=i[n];i[n]=i[s],i[s]=c}this._i=this._j=0},_doProcessBlock:function(t,r){t[r]^=e.call(this)},keySize:8,ivSize:0});r.RC4=n._createHelper(o);var a=s.RC4Drop=o.extend({cfg:o.cfg.extend({drop:192}),_doReset:function(){o._doReset.call(this);for(var t=this.cfg.drop;t>0;t--)e.call(this)}});r.RC4Drop=n._createHelper(a)}(),t.RC4})}])});
//# sourceMappingURL=secure-ls.min.js.map

(function() {
    'use strict';
    angular
        .module('OnlineAssessmentAngular')
        .controller('videoAnswerController', videoAnswerController)
        .controller('videoCompatibilityController', videoCompatibilityController);

    function videoAnswerController($scope, $window, $log, $timeout, $interval, $sce, webService, assessmentUtility, loginService, proctoringService, growl, $rootScope, faceTracker, faceLandmarks) {
        var vm = this,
            ft = faceTracker,
            loginInfo = loginService.getLoginInfo(),
            tenantId = -1,
            testId = -1,
            candidateId = -1,
            candidateEmail = null,
            growlError = null,
            recordingTime = 60,
            networkFailureCount = 0,
            videoStrmWatch = null,
            recordinCountIntervalObj = null, //In seconds
            isFaceTrackingEnabled = false,
            timerCheckStart = null,
            timerCheckStop = null,
            isSystemSlow = false,
            isAuthenticated = true,
            networkFaliureInfos = [],
            recordedVideos = [],
            recordingStat = {
                isStartedSuccessfully: false,
                initiatedAt: null,
                gotResponseAt: null
            };

        vm.winHeight = assessmentUtility.resize($window);
        vm.qPanelBodyHeight = (vm.winHeight * 74) / 100;
        vm.panelHeight = (vm.winHeight * 92.90) / 100;
        vm.videoElementHeight = (vm.panelHeight - 160);

        vm.isRecordingStarted = false;
        vm.isRecordingStopped = false;
        vm.isSelfReviewDone = false;
        vm.playbackVideo = '';
        vm.count = recordingTime;
        vm.startRecordingLabel = "Start Recording Answer";
        vm.recordingPanelHeading = "Record Sample Answer";
        vm.isProctoting = false;
        vm.isErrorOcured = false;

        vm.headingStr = "Checking your system and network stability";
        vm.trustedQString = "<p>Dolphins are marine mammals that are related to whales and porpoises. A marine mammal is one that lives in the water. Dolphins are found all over the world’s oceans as well as in rivers and marshes. Dolphins are carnivores (meat eaters) and feed on fish, squid, and other marine life. They often swim together in groups called “pods.” They are thought to have powerful eyesight and hearing, but do not have a sense of smell.</p>" +
            "<p>Dolphins come in different sizes. Some are smaller than the average person, but others, such as the orca, can be 30 feet long, or more than five times as long as the average person. Dolphins are thought to be very intelligent and communicate with each other using clicks and whistles. All dolphins are powerful swimmers. Have you ever seen a dolphin? Groups of dolphins can often be seen bobbing in and out of waves close to the shoreline.</p>";

        init();

        function init() {
            angular.merge(vm, $scope.data);
            if (vm.opts && vm.opts.isAuthenticated === false) {
                testId = vm.opts.testId;
                tenantId = vm.opts.tenantId;
                candidateId = 0;
                candidateEmail = vm.opts.candidateEmail;
                isAuthenticated = vm.opts.isAuthenticated;
            } else if (loginInfo && loginInfo.Config) {
                testId = loginInfo.TestId;
                candidateId = loginInfo.CandidateId;
                isFaceTrackingEnabled = loginInfo.Config.isFaceTrackingEnabled;
            }
            if (vm.opts.type === "videoProctoring") {
                vm.isProctoting = true;
                vm.startRecordingLabel = "Start Recording Video";
                vm.recordingPanelHeading = "Record Sample Video";
            }
        }

        vm.startRecording = function() {
            var isFaceLandmarks = JSON.parse(sessionStorage.getItem('faceLandmarks'));
            if (isFaceLandmarks) {
                ft = faceLandmarks;
            }
            vm.isErrorOcured = false;
            networkFailureCount = 0;
            if (growlError) {
                growlError.destroy();
            }
            var vidElem = document.getElementById("recording-video"),
                rq = {
                    vidElem: vidElem,
                    tenantId: tenantId,
                    testId: testId,
                    candidateEmail: candidateEmail,
                    isAuthenticated: isAuthenticated
                };
            if (vm.opts && vm.opts.isAuthenticated) {
                rq.vqId = null;
            } else {
                rq.vqId = 0;
            }
            recordingStat.initiatedAt = new Date();
            proctoringService.start(rq)
                .then(function(res) {
                        recordingStat.gotResponseAt = new Date();
                        if (!res || !res.strm) {
                            recordingStat.isStartedSuccessfully = false;
                            $log.log("video recording test:", res);
                            handleRecodingError(res);
                            proctoringService.stop();
                            if (isFaceTrackingEnabled) {
                                ft.stop();
                            }
                            return false;
                        }
                        recordingStat.isStartedSuccessfully = true;
                        if (isFaceTrackingEnabled) {
                            ft.start({ videoElementId: "recording-video" });
                        }
                        registerRecordingStatWatch();
                        proctoringService.setConfig({ 'videoStrmWatch': videoStrmWatch });
                        vm.isRecordingStarted = true;
                        timerCheckStart = new Date();
                        recordinCountIntervalObj = $interval(function() {
                            vm.count -= 1;
                            if (vm.count < 0) {
                                timerCheckStop = new Date();
                                var lagging = timerCheckStop - timerCheckStart;
                                if (lagging > (vm.recordingTime * 1000) + 1999) {
                                    isSystemSlow = true;
                                    handleRecodingError({
                                        onlyDisplayMsg: true,
                                        displayMsg: "Slow System detected."
                                    });
                                }
                                recordinCountIntervalObj && $interval.cancel(recordinCountIntervalObj);
                                recordinCountIntervalObj = null;
                                vm.stopRecording();
                            }
                        }, 1000);
                    },
                    function(res) {
                        $log.log(res);
                    });
        };

        function handleRecodingError(res) {
            vm.isRecordingStopped = true;
            vm.isErrorOcured = true;
            var errorMsg = "Not able to start recording!";
            if (res && res.displayMsg) {
                errorMsg = res.displayMsg;
            }
            if (!navigator.onLine) {
                errorMsg += "<br>No Internet Connection!";
            } else if (res && !res.isOnline) {
                errorMsg += "<br>Poor Internet Connection! Switch to a better network.";
            }
            if (res && res.displayMsg) {
                errorMsg += "<br>Recording will be started automatically,once network will come back.";
                errorMsg += "<br>Check your Internet connection."
            } else {
                errorMsg += "<br>Try Again.";
            }
            if (res && res.displayMsg && res.onlyDisplayMsg) {
                errorMsg = res.displayMsg;
            }
            networkFaliureInfos.push({
                "timeStamp": new Date(),
                "msg": errorMsg
            });
            growlError = growl.error(errorMsg, {
                disableCloseButton: false,
                onopen: function() {
                    $timeout(function() {
                        document.getElementsByClassName("growl-item")[0].classList.add("growl-error-custom");
                    }, 1);
                }
            });
        }

        function registerRecordingStatWatch() {
            videoStrmWatch = $rootScope.$watch('vidStrmId', function() {
                if (!$rootScope.vidStrm) {
                    networkFailureCount++;
                    var failureRes = {};
                    if (networkFailureCount == 1) {
                        failureRes = {
                            isOnline: false,
                            onlyDisplayMsg: true,
                            displayMsg: "Your network connection is poor.<br>Switch to a better network and retry."
                        };
                        recordinCountIntervalObj && $interval.cancel(recordinCountIntervalObj);
                        recordinCountIntervalObj = null;
                        proctoringService.stop();
                        if (isFaceTrackingEnabled) {
                            ft.stop();
                        }
                        vm.isRecordingStopped = true;
                        vm.count = 0;
                    } else {
                        failureRes = {
                            isOnline: false,
                            displayMsg: "Recording stopped!"
                        };
                    }
                    handleRecodingError(failureRes);
                } else {
                    growlError && growlError.destroy();
                }
            });
        }

        vm.stopRecording = function() {
            vm.isRecordingStopped = true;
            proctoringService.stop();
            if (isFaceTrackingEnabled) {
                ft.stop();
            }
            //isSystemSlow = true;
            if (isSystemSlow) {
                return false;
            }
            var url = "videoAnswers",
                httpMethodType = "GET",
                rq = null,
                header = null,
                hostName = location.hostname === "localhost" ? "amsin.hirepro.in" : location.hostname,
                recordedVideoId = hostName + "-" + tenantId + "-" + candidateEmail + "-" + testId;

            if (vm.opts && vm.opts.isAuthenticated === false && vm.opts.videoServerHost) {
                url = "https://" + vm.opts.videoServerHost + "/py/proctoring/api/v1/recordedFilePathList_v2/";
                httpMethodType = "POST";
                rq = {
                    "testList": [recordedVideoId]
                };
                header = {
                    "X-TEST-AUTHENTICATION": false,
                    "X-TENANT-ID": tenantId,
                    "X-USER-ID": 0,
                    "X-ASSESSMENT-SERVER-HOST": hostName
                };
            }
            webService.execute(url, rq, httpMethodType, null, header)
                .then(function(res) {
                    res = res.data.data;
                    if (!res || !res.pathList) {
                        handleRecodingError({
                            onlyDisplayMsg: true,
                            displayMsg: "You are experiencing a poor network connection.<br>Try again."
                        });
                        $log.log("video not found.");
                        return;
                    }
                    var lastRecordedVideo = null;
                    if (vm.opts && vm.opts.isAuthenticated === false) {
                        recordedVideos = res.pathList[recordedVideoId].videoLink;
                        lastRecordedVideo = recordedVideos &&
                            recordedVideos.length > 0 &&
                            recordedVideos[recordedVideos.length - 1];
                    } else {
                        lastRecordedVideo = res.pathList[res.pathList.length - 1];
                    }
                    vm.isSelfReviewDone = !!lastRecordedVideo;
                    if (vm.opts && vm.opts.isAuthenticated === false) {
                        vm.isCompatible = !!lastRecordedVideo;
                    } else {
                        vm.isCompatible = !!lastRecordedVideo && !isSystemSlow;
                    }
                    var timeOut = $timeout(function() {
                        vm.playbackVideo = $sce.trustAsResourceUrl(lastRecordedVideo);
                    }, 10);
                }, function(res) {
                    handleRecodingError({
                        onlyDisplayMsg: true,
                        displayMsg: "You are experiencing a poor network connection.<br>Try again."
                    });
                });
        };

        vm.reStartRecording = function() {
            stopVideo();
            vm.startRecording();
        };

        vm.onOk = function() {
            $scope.data.isCanceled = false;
            $scope.$hide();
            $scope.data.isCanceled = false;
            $scope.data.videoCompatibilityInfo = {
                "networkFaliureInfos": networkFaliureInfos,
                "isSystemSlow": isSystemSlow,
                "recordedVideos": recordedVideos,
                "recordingStat": recordingStat
            };
        };

        vm.cancel = function() {
            stopVideo();
            recordinCountIntervalObj && $interval.cancel(recordinCountIntervalObj);
            recordinCountIntervalObj = null;
            proctoringService.stop();
            if (isFaceTrackingEnabled) {
                ft.stop();
            }
            $scope.data.isCanceled = true;
            $scope.data.videoCompatibilityInfo = {
                "networkFaliureInfos": networkFaliureInfos,
                "isSystemSlow": isSystemSlow,
                "recordedVideos": recordedVideos,
                "recordingStat": recordingStat
            };
            $scope.$hide();
        };

        function stopVideo() {
            vm.isRecordingStarted = true;
            vm.isRecordingStopped = false;
            vm.isSelfReviewDone = false;
            vm.isCompatible = false;
            vm.playbackVideo = '';
            vm.count = recordingTime;
        }
    }

    function videoCompatibilityController($scope) {
        var vm = this;

        vm.onOk = onOk;

        init();

        function init() {
            angular.merge(vm, $scope.data);
        }

        function onOk(info) {
            $scope.$hide();
            $scope.data.videoCompatibilityInfo = info;
        }
    }
})();

 (function() {
     'use strict';
     angular
         .module('OnlineAssessmentAngular')
         .controller('RandomGroupSelection', RandomGroupSelection);
     /* @ngInject */

     function RandomGroupSelection(assessmentUtility, $scope) {
         var vm = this;

         var selectedGroups;
         var colors = [
             "rgba(0, 0, 0, 0.3)",
             "rgba(239, 95, 19, 0.42)",
             "rgba(19, 173, 239, 0.42)",
             "rgba(9, 123, 46, 0.42)",
             "rgba(228, 148, 18, 0.42)",
             "rgba(228, 42, 18, 0.42)",
             "rgba(18, 127, 228, 0.42)",
             "rgba(11, 171, 124, 0.42)",
             "rgba(228, 18, 43, 0.42)",
             "rgba(51, 122, 183, 0.592157)",
             "rgba(51, 122, 183, 0.59)",
             "rgba(19, 173, 239, 0.419608)",
             "rgba(239, 95, 19, 0.419608)",
             "rgba(0, 0, 0, 0.298039)"
         ];

         vm.addGroup = addGroup;
         vm.getDisabilityStat = getDisabilityStat;
         vm.getLockingStat = getLockingStat;

         init();

         function init() {
             angular.merge(vm, $scope.data);
             vm.groups = _.flatMap(vm.groups, function(item) {
                 // item.groups.color = colors[Math.floor(Math.random()*colors.length)];
                 return _.map(item.groups, function(grp) {
                     grp.color = colors[Math.floor(Math.random() * colors.length)];
                     return grp;
                 });
             });
             selectedGroups = assessmentUtility.localStorage.getData("selectedOptionalGroupIdCollection");
         }

         function addGroup(gpId, isMandat) {
             var isAlreadyAdded = -1;
             if (isMandat === false) {
                 var ucIsAllMandatoryGrpSelected = getUcIsAllMandatoryGrpSelectionStat(vm.groups, selectedGroups);
                 if (!ucIsAllMandatoryGrpSelected) {
                     return false;
                 }
             }
             if (selectedGroups && selectedGroups.length > 0) {
                 isAlreadyAdded = _.indexOf(selectedGroups, gpId);
             }
             if (selectedGroups && isAlreadyAdded > -1) {
                 return false;
             }
             $scope.data.selectedGroup = gpId;
             $scope.$hide();
         }

         function getDisabilityStat(gpId, isOptional) {
             var isAlreadyAdded = -1;
             if (selectedGroups && selectedGroups.length > 0) {
                 isAlreadyAdded = _.indexOf(selectedGroups, gpId);
             }
             if (isOptional) {
                 var ucIsAllMandatoryGrpSelected = assessmentUtility.localStorage.getData("ucIsAllMandatoryGrpSelected");
                 if (!selectedGroups) {
                     return true;
                 } else if (!ucIsAllMandatoryGrpSelected) {
                     ucIsAllMandatoryGrpSelected = getUcIsAllMandatoryGrpSelectionStat(vm.groups, selectedGroups);
                     if (!ucIsAllMandatoryGrpSelected) {
                         return true;
                     } else {
                         assessmentUtility.localStorage.setData("ucIsAllMandatoryGrpSelected", true);
                     }
                 }
             }
             return isAlreadyAdded > -1;
         }

         function getLockingStat() {
             return !assessmentUtility.localStorage.getData("ucIsAllMandatoryGrpSelected");
         }

         function getUcIsAllMandatoryGrpSelectionStat(grps, selectedGroups) {
             var ucIsAllMandatoryGrpSelected = true;
             var mandatGrpIds = _.map(_.filter(grps, function(grp) {
                 if (grp.isMandat) {
                     return grp;
                 }
             }), 'gpId');
             if (mandatGrpIds && mandatGrpIds.length > 0 && selectedGroups && selectedGroups.length > 0) {
                 _.forEach(mandatGrpIds, function(gpId) {
                     var isAlreadyAdded = _.indexOf(selectedGroups, gpId);
                     if (isAlreadyAdded === -1) {
                         ucIsAllMandatoryGrpSelected = false;
                         return ucIsAllMandatoryGrpSelected;
                     }
                 });
             } else {
                 ucIsAllMandatoryGrpSelected = false;
             }
             return ucIsAllMandatoryGrpSelected;
         }
     }
 })();

 (function() {
     'use strict';
     angular
         .module('OnlineAssessmentAngular')
         .controller('SecurityKeyValidate', SecurityKeyValidate);
     /* @ngInject */

     function SecurityKeyValidate(loginService, $scope, webService) {
         var vm = this;

         vm.onOk = onOk;

         init();

         function init() {
            angular.merge(vm, $scope.data);
            console.log(vm);
            if(!vm.isOnlinePreview) {
                loginService.getCandidateDetails()
                .then(function(res) {
                    vm.candidateDetails = res;
                },function(res){
                    if(res && res.data && res.data.error && 
                        res.data.error.errorCode == 440){
                        $scope.$hide();
                    }
                });
            }
         }

         function onOk() {
             if (vm.data) {
                 loginService.getTestSecurityKeyEncryptString(vm.data).then(function(res) {
                     if (res && res.data.isAuthorised === true) {
                         $scope.data.result = res.data;
                         $scope.$hide();
                     } else {
                         vm.errorMessage = 'Invalid Security Key!';
                     }
                 });
             } else {
                vm.errorMessage = 'Please enter valid Security Key';
             }
         }
     }
 })();

 (function() {
     'use strict';
     angular
         .module('OnlineAssessmentAngular')
         .controller('RoomScan', RoomScanCtrl);
     /* @ngInject */

     function RoomScanCtrl(assessmentService, assessmentUtility, $scope) {
         var vm = this;
         vm.data = {};
         vm.closeWindow = closeWindow;
         
         init();

         function init() {
             angular.merge(vm, $scope.data);
             //console.log('SS modal control VM',vm);
             vm.data = $scope.data;
             console.log('SS modal control Data',vm.data);
             assessmentUtility.timer.pauseFor360RoomScan();
         }

         function closeWindow(action,type){
             if(type == 'midTestroomScan' && action === true){
                var isGroupWiseTimingEnable = assessmentService.getGroupWiseTimingStatus(),
                    isLastGroup = angular.fromJson(assessmentUtility.localStorage.getData("isLastGroup"));
                 $scope.$hide();
                 assessmentUtility.timer.start(assessmentService.handleTestSubmission, isGroupWiseTimingEnable, isLastGroup);
             }
             sessionStorage.setItem('roomScanModalVisible',false);
         }

     }
 })();

(function() {
    'use strict';
    angular
        .module('OnlineAssessmentAngular')
        .controller('QaTakePhoto', QaTakePhoto);
    /* @ngInject */

    function QaTakePhoto($scope, $sce) {
        var vm = this,
            track = null,
            video = null,
            newCanvasHolder = null,
            imageCapture;

        vm.enableTakePhoto = false;
        vm.uploadedPhotos = [];
        vm.newUploadedPhotos = [];

        vm.grabFrame = grabFrame;
        vm.takePhoto = takePhoto;
        vm.stopCamera = stopCamera;
        vm.onOk = onOk;

        init();

        function init() {
            angular.merge(vm, $scope.data);
            startCamera();
        }

        function onOk() {
            stopCamera();
            if (vm.newUploadedPhotos) {
                $scope.data.fileList = vm.newUploadedPhotos;
            }
            $scope.$hide();
        }

        function takePhoto() {
            console.time('takePhoto');
            vm.enableTakePhoto = false;
            imageCapture.takePhoto().then(
                function(imageBlob) {
                    vm.newUploadedPhotos.push(URL.createObjectURL(imageBlob));
                    vm.enableTakePhoto = true;
                    console.timeEnd('takePhoto');
                },
                function(error) {
                    vm.enableTakePhoto = true;
                    console.log(error);
                }
            );
        }

        function grabFrame() {
            vm.enableTakePhoto = false;
            console.time('grabFrame');
            imageCapture.grabFrame().then(
                function(imageBitmap) {
                    drawCanvas(imageBitmap);
                    // vm.enableTakePhoto = true;
                    // console.timeEnd('grabFrame');
                    // vm.newUploadedPhotos.push(URL.createObjectURL(imageBitmap));
                },
                function(error) {
                    console.log(error);
                }
            );
        }

        function startCamera() {
            navigator.mediaDevices.getUserMedia({video: true}).then(
                function(mediaStream) {
                    video = document.getElementById('video');
                    video.srcObject = mediaStream;
                    // video.play();
                    track = mediaStream.getVideoTracks()[0];
                    imageCapture = new ImageCapture(track);
                    vm.enableTakePhoto = true;
                },
                function(error) {
                    console.log(error);
                });
        }

        function stopCamera() {
            if (track) {
                track.stop();
            }
        }

        function drawCanvas(img) {
            var canvas = document.getElementById('canvas'),
                context, ratio, w, h, data;
            context = canvas.getContext('2d');
            ratio = video.videoWidth/video.videoHeight;
            w = video.videoWidth-100;
            h = parseInt(w/ratio,10);
            canvas.width = w;
            canvas.height = h;
            context.drawImage(img, 0, 0, w, h);
            data = canvas.toDataURL('image/png');
            vm.newUploadedPhotos.push(data);
            vm.enableTakePhoto = true;
            console.timeEnd('grabFrame');
        }
    }
})();

 (function() {

     'use strict';
     angular
         .module('OnlineAssessmentAngular')
         .controller('OptionalPreviewModal', OptionalPreviewModal);
     /* @ngInject */

     function OptionalPreviewModal(loginService, $scope, assessmentUtility, assessmentService, $interval) {
         var vm = this;
         var previewTimerInterval = null;

         vm.previewTimer = 0;
         vm.clockClass = 'fa-hourglass-start';

         vm.onOk = onOk;
         vm.onSelectGroup = onSelectGroup;

         init();

         function init() {
             angular.merge(vm, $scope.data);
             var ls_totalPreviewTime = assessmentUtility.localStorage.getData("previewTimer");
             vm.previewTimer = (ls_totalPreviewTime != null && ls_totalPreviewTime >= 0) ? ls_totalPreviewTime : vm.totalPreviewtime;
             if (vm.previewTimer > 0) {
                 vm.grpInfo = vm.groups[0];
                 assessmentUtility.timer.pause();
                 if (previewTimerInterval) {
                     $interval.cancel(previewTimerInterval);
                 }
                 previewTimerInterval = $interval(runPreviewTimer, 1000);
             } else {
                 $scope.$hide();
             }
         }

         function runPreviewTimer() {
             vm.previewTimer--;
             if (vm.previewTimer <= (vm.totalPreviewtime / 2) && vm.previewTimer > 0)
                 vm.clockClass = 'fa-hourglass-half';
             else if (vm.previewTimer === 0)
                 vm.clockClass = 'fa-hourglass-end';
             assessmentUtility.localStorage.setData("previewTimer", vm.previewTimer);
             if (vm.previewTimer == 0) {
                 assessmentUtility.localStorage.setData("isOptionalPreviewTimeOver", true);
                 onOk();
             }
         }

         function onOk() {
             var isGroupWiseTimingEnable = assessmentService.getGroupWiseTimingStatus();
             var isLastGroup = angular.fromJson(assessmentUtility.localStorage.getData("isLastGroup"));
             var activeGrpWiseTimeOver = assessmentUtility.localStorage.getData("groupWiseTimeOver");
             var isGrpTimerToBeStarted = activeGrpWiseTimeOver ? false : true;
             var isOnlyOptional = assessmentService.checkOnlyOptionalStatus();
             if (previewTimerInterval) {
                 $interval.cancel(previewTimerInterval);
             }
             $scope.data.previewTimer = vm.previewTimer;
             isGrpTimerToBeStarted = isOnlyOptional ? false : isGrpTimerToBeStarted;
             if (isGrpTimerToBeStarted) {
                 assessmentUtility.timer.start(assessmentService.handleTestSubmission, isGroupWiseTimingEnable, isLastGroup);
             }
             $scope.$hide();
         }

         function onSelectGroup(grp) {
            angular.element(document.querySelector('.group-info-questions'))[0].scrollTop = 0;
            vm.grpInfo = grp;
         }

         // $scope.$on("$destroy", function() {
         //     assessmentUtility.localStorage.setData("previewTimer", vm.previewTimer);
         //     if (previewTimerInterval) {
         //         $interval.cancel(previewTimerInterval);
         //     }
         // });
     }
 })();

 (function() {
     'use strict';
     angular
         .module('OnlineAssessmentAngular')
         .controller('OptionalGroups', OptionalGroups);
     /* @ngInject */

     function OptionalGroups($scope, $interval, openModalService, assessmentUtility, assessmentService) {
         var vm = this,
            previewTimerInterval = null;

         vm.previewTimer = assessmentUtility.localStorage.getData("previewTimer");
         vm.grpInfo = null;

         vm.onOk = onOk;
         vm.onCancel = onCancel;
         vm.onPreview = onPreview;
         vm.showPreview = showPreview;
         vm.resetPreview = resetPreview;
         init();

         function init() {
             angular.merge(vm, $scope.data);
             var selectedOptionalGroupIdCollection = assessmentUtility.localStorage.getData("selectedOptionalGroupIdCollection");
             vm.activeGroupId = assessmentUtility.localStorage.getData('activeGroupId');
             if (_.size(selectedOptionalGroupIdCollection) > 0) {
                 vm.groups = _.filter(vm.groups, function(grp) {
                     return _.indexOf(selectedOptionalGroupIdCollection, grp.gpId) == -1;
                 });
             }
             if (vm.activeGroupId == -1) {
                vm.headerStr = 'Choose your group';
             }
             vm.headerStr = vm.headerStr ? vm.headerStr : 'Choose your next group';
             vm.previewTimer = (vm.previewTimer != null && vm.previewTimer >= 0) ? vm.previewTimer : vm.totalPreviewtime;
             //vm.previewTimer = 20000;
         }

         function onOk() {
            resetPreview();
             if (vm.selectedGroup) {
                 $scope.data.selectedGroup = vm.selectedGroup;
                 $scope.$hide();
             } else {
                 vm.errorMessage = "Please select any group";
             }
         }

         function onCancel() {
            resetPreview();
             var totalTime = assessmentService.getAllocatedTimeForGroupOrTest();
             var timeSpent = assessmentUtility.timer._time;
             if (timeSpent && (totalTime > timeSpent)) {
                 $scope.$hide();
             } else {
                 vm.isCancelEnable = false;
                 vm.errorMessage = "<b>The timer for this group has ended.</b> <br/><span>Please click \"Take me to the next group\".</span>";
             }
         }

         function onPreview() {
             var requestObj = {
                 totalPreviewtime: vm.totalPreviewtime,
                 groups: vm.groups
             };
             openModalService.openModal('optionalGroupsPreview', requestObj).then(function(res) {
                 vm.previewTimer = res.result.previewTimer;
             });
         }

         function showPreview() {
            vm.grpInfo = _.find(vm.groups, { gpId: parseInt(vm.selectedGroup)});
            vm.previewTimer = (vm.previewTimer != null && vm.previewTimer >= 0) ? vm.previewTimer : vm.totalPreviewtime;
            if (vm.previewTimer > 0) {
                assessmentUtility.timer.pause();
                if (previewTimerInterval) {
                    $interval.cancel(previewTimerInterval);
                }
                previewTimerInterval = $interval(runPreviewTimer, 1000);
            } else {
                vm.previewTimer = 0;
            }
        }

        function runPreviewTimer() {
             vm.previewTimer--;
             if (vm.previewTimer <= (vm.totalPreviewtime / 2) && vm.previewTimer > 0)
                 vm.clockClass = 'fa-hourglass-half';
             else if (vm.previewTimer === 0)
                 vm.clockClass = 'fa-hourglass-end';
             assessmentUtility.localStorage.setData("previewTimer", vm.previewTimer);
             if (vm.previewTimer == 0) {
                 assessmentUtility.localStorage.setData("isOptionalPreviewTimeOver", true);
                 resetPreview();
             }
         }

        function resetPreview() {
            vm.grpInfo = null;

            var isGroupWiseTimingEnable = assessmentService.getGroupWiseTimingStatus();
            var isLastGroup = angular.fromJson(assessmentUtility.localStorage.getData("isLastGroup"));
            var activeGrpWiseTimeOver = assessmentUtility.localStorage.getData("groupWiseTimeOver");
            var isGrpTimerToBeStarted = activeGrpWiseTimeOver ? false : true;
            var isOnlyOptional = assessmentService.checkOnlyOptionalStatus();
            if (previewTimerInterval) {
                $interval.cancel(previewTimerInterval);
            }
            isGrpTimerToBeStarted = isOnlyOptional ? false : isGrpTimerToBeStarted;
            if (isGrpTimerToBeStarted) {
                assessmentUtility.timer.start(assessmentService.handleTestSubmission, isGroupWiseTimingEnable, isLastGroup);
            }
        }
     }
 })();

(function() {
    'use strict';
    angular
        .module('OnlineAssessmentAngular')
        .controller('OnlineProctoringCtrl', OnlineProctoringCtrl);

    /* @ngInject */

    function OnlineProctoringCtrl($q, $http, $scope, $sce, $state, $window, $timeout, blockUI, webService, proctorService, trackerService, imageTracker, loginService, loggerService, assessmentUtility, faceRecognitionService, hps, deviceDetector, commonService, faceLandmarks) {
        var vm = this,
            isFaceLandmarks = false,
            delayOnConsentInterval = null,
            selfieImageUrl = null,
            idProofUrl = null,
            isMediaQuestion,
            videoProctoringMode,
            loginInfo,
            isVersantTest = false,
            MACAddress = 'dummy',
            isSecureBrowserMandatory,
            isRefresh = false,
            isMicDistortionCheck = false,
            isSecondaryCamera = false,
            isSecondaryCameraRecheck = $scope.data.opts && $scope.data.opts.openedby === "secondaryCameraRecheck",
            surroundCameraPage = (sessionStorage.isSecondaryCamera && sessionStorage.isSecondaryCamera === "true") ? true : false,
            roomScan = (sessionStorage.isroomScanEnabled && sessionStorage.isroomScanEnabled === "true") ? true : false,
            initialCheatingWarning = assessmentUtility.parseFlagValToBoolean(sessionStorage.getItem("initialCheatingWarning"));
        vm.onlyProctoringTest = false;
        vm.privacyPolicy = null;
        vm.consentPage = 'app/assessment/consentFormDefault.tpl.html';
        vm.versantFileIssueStatue = 'start';
        vm.isNoiseCheckEnable = false;
        vm.isSampleVideoRecordingEnable = false;
        vm.isCaptureIdEnabled = true;
        vm.isIdApproval = false;
        vm.wizard = !isSecondaryCameraRecheck ? [{
            type: 'consent',
            stateCheck: false,
            nextLabel: 'Next'
        }] : [];

        vm.wizardStep = 0;
        vm.wizardCurrentStep = -1;
        vm.threshold = 8;
        vm.noiseInstantCheck = false;

        vm.noiseChecked = false;
        vm.isLocalHost = location.hostname === "localhost" ? true : false;
        // vm.selfieTaken = vm.isLocalHost ? true : false;
        // vm.idProofTaken = false;
        vm.idProofApproved = false;
        // vm.videoRecorded = false;

        vm.submitOrNext = 'Next';
        vm.slowSystemInstruction = '<div>' +
            '<p>Processor: <strong>i3 5th gen, 2.2Ghz equivalent/higher</strong></p>' +
            '<p>RAM: <strong>4 GB or higher</strong></p>' +
            '<p>Resolution: <strong>1366 X 768 or higher</strong></p>' +
            '</div>';

        vm.setConsentStatusCheck = setConsentStatusCheck;
        vm.onNextClick = onNextClick;
        vm.callBackFormComponent = callBackFormComponent;
        vm.reloadPage = reloadPage;

        init();

        function init() {
            var tenantName = sessionStorage.getItem("oa_tenantAlias");
            // isFaceLandmarks = JSON.parse(sessionStorage.getItem('faceLandmarks'));
            // if (isFaceLandmarks) {
            //     faceLandmarks.init('init');
            // }
            isSecondaryCamera = sessionStorage.getItem("isSecondaryCamera") === 'true' ? true : false;
            MACAddress = assessmentUtility.sessionStorage.getData("MACAddress") || MACAddress;
            if (tenantName && tenantName.toLowerCase().startsWith('accenture')) {
                vm.consentPage = 'app/assessment/consentFormAccenture.tpl.html';
            }
            loginInfo = loginService.getLoginInfo();

            if (sessionStorage.privacyPolicy) {
                vm.privacyPolicy = $sce.trustAsHtml(sessionStorage.privacyPolicy);
            }
            if (loginInfo && loginInfo.Config) {
                if (loginInfo.Config.isSecureBrowserMandatory) {
                    isSecureBrowserMandatory = loginInfo.Config.isSecureBrowserMandatory ? true : false;
                    if (deviceDetector.os === 'mac') {
                        startSEBSecureKeyWatch();
                    } else {
                        initMacSocket();
                    }
                }
                if (loginInfo.Config.thirdPartyTestType && (loginInfo.Config.thirdPartyTestType.toLowerCase() === "testnav" || loginInfo.Config.thirdPartyTestType.toLowerCase() === "thirdpartyproctoring" || loginInfo.Config.thirdPartyTestType.toLowerCase() === "force")) {
                    vm.onlyProctoringTest = true;
                }
                if (loginInfo.Config.thirdPartyTestType && loginInfo.Config.thirdPartyTestType.toLowerCase() === "versant") {
                    if (tenantName && tenantName.toLowerCase().startsWith('accenture')) {
                        vm.consentPage = 'app/assessment/consentFormAccenture.tpl.html';
                    } else {
                        vm.consentPage = 'app/assessment/consentFormVersant.tpl.html';
                    }
                    isVersantTest = true;
                    checkVersantFileAccess();
                } else {
                    goToConsentPage();
                }

                /*...............Assessment Terms And Conditons.............*/
                if (initialCheatingWarning) {
                    vm.wizard.push({
                        type: 'assessmentTermsAndConditons',
                        stateCheck: false,
                        nextLabel: 'Next'
                    });
                }

                /*...............Proctor Compatibility.............*/
                if (!isSecondaryCameraRecheck) {
                    vm.wizard.push({
                        type: 'proctor',
                        stateCheck: vm.isLocalHost ? true : false,
                        callBack: 'savePersistance',
                        nextLabel: 'Next'
                    });
                }

                /*.......................Room Scan 360 video Wizard.............*/
                if (roomScan) {
                    vm.wizard.push({
                        type: 'roomScan',
                        stateCheck: false,
                        nextLabel: 'Next'
                    });
                }
                /*.............................................................*/

                vm.isCaptureIdEnabled = !!loginInfo.Config.isCaptureIdEnabled;
                if (vm.isCaptureIdEnabled && !isSecondaryCamera && !isSecondaryCameraRecheck) {
                    vm.wizard.push({
                        type: 'captureId',
                        stateCheck: false,
                        callBack: 'saveIdProof',
                        nextLabel: 'Next'
                    });
                }
                vm.isIdApproval = loginInfo.Config.isIdApproval && loginInfo.Config.isIdApproval.toLowerCase() === 'manual' ? true : false;
                if (vm.isIdApproval && !isSecondaryCamera && !isSecondaryCameraRecheck) {
                    vm.wizard.push({
                        type: 'idApproval',
                        stateCheck: false,
                        nextLabel: 'Next'
                    });
                }
            }

            if (loginInfo && loginInfo.assessmentConfig) {
                isMicDistortionCheck = !!loginInfo.assessmentConfig.micDistortionCheck;
            }

            if (isVersantTest && loginInfo && loginInfo.assessmentConfig) {
                vm.isNoiseCheckEnable = !!loginInfo.assessmentConfig.noiseCheckEnabled;
                if (loginInfo.assessmentConfig.noiseCheckThreshold) {
                    vm.threshold = loginInfo.assessmentConfig.noiseCheckThreshold;
                    vm.noiseInstantCheck = loginInfo.assessmentConfig.noiseInstantCheck;
                    if (vm.noiseInstantCheck && loginInfo.assessmentConfig.noiseInstantCheckThreshold) {
                        vm.threshold = loginInfo.assessmentConfig.noiseInstantCheckThreshold;
                    }
                    console.log('SS assessconfig', loginInfo.assessmentConfig);
                    vm.maxnoiseAttempt = loginInfo.assessmentConfig.maxnoiseAttempt;
                    vm.videoInMicTest = loginInfo.assessmentConfig.videoInMicTest;
                    if (vm.threshold && !isSecondaryCamera && !isSecondaryCameraRecheck) {
                        vm.wizard.push({
                            type: 'noiseCheck',
                            stateCheck: false,
                            nextLabel: 'Next'
                        });
                    }
                }
            }

            /*................Sound Quality Check Wizard.............*/
            if (isVersantTest && isMicDistortionCheck && !isSecondaryCamera && !isSecondaryCameraRecheck) {
                vm.wizard.push({
                    type: 'soundQualityCheck',
                    stateCheck: false,
                    nextLabel: 'Next'
                });
            }
            /*.............................................................*/

            /*................Secondary Camera Wizard.............*/
            var isSecondaryCameraEnable = sessionStorage.getItem("isSecondaryCameraEnable") === "true" ? true : false;
            if (isSecondaryCameraEnable && !isSecondaryCamera) {
                vm.wizard.push({
                    type: 'secondaryCamera',
                    stateCheck: false,
                    nextLabel: 'Next'
                });
            }
            /*.............................................................*/

            /*.................Secondary Camera Preview Wizard.............*/
            if (isSecondaryCameraEnable && !isSecondaryCamera) {
                vm.wizard.push({
                    type: 'secondaryCameraPreview',
                    stateCheck: false,
                    nextLabel: 'Next'
                });
            }


            isMediaQuestion = (proctorService.localVar.mediaQuestion && proctorService.localVar.mediaQuestion.ContainsMediaQuestion) || false;
            videoProctoringMode = (proctorService.localVar.mediaQuestion && proctorService.localVar.mediaQuestion.Config && proctorService.localVar.mediaQuestion.Config.VideoProctoring && proctorService.localVar.videoProctoringMode == 'strict') || false;
            vm.isSampleVideoRecordingEnable = (isMediaQuestion || videoProctoringMode) && trackerService.config.isSampleVideoRecordingEnable;
            if (vm.isSampleVideoRecordingEnable && !isSecondaryCamera && !isSecondaryCameraRecheck) {
                vm.wizard.push({
                    type: 'sampleVideo',
                    stateCheck: false,
                    nextLabel: 'Proceed to test'
                });

            }
            vm.isProctor = !isMediaQuestion;
            angular.merge(vm, $scope.data);

            var currentState = $state.current.name,
                previousState = window.sessionStorage.previousStateName;
            isRefresh = currentState === previousState;
            window.sessionStorage.setItem("previousStateName", currentState);
        }

        function goToConsentPage() {
            vm.wizardCurrentStep = 0;
            vm.versantFileIssueStatue = 'end';
            // if (isFaceLandmarks) {
            //     vm.delayOnConsentCounter = 10;
            //     delayOnConsent();
            // }
        }

        // function delayOnConsent() {
        //     delayOnConsentInterval = $timeout(function(){
        //         vm.delayOnConsentCounter--;
        //         if (vm.delayOnConsentCounter <= 0) {
        //             delayOnConsentInterval = null;
        //             $timeout.cancel(delayOnConsentInterval);
        //             setConsentStatusCheck();
        //         } else {
        //             delayOnConsent();
        //         }
        //     }, 1000);
        // }

        function checkVersantFileAccess() {
            $http.get(location.origin + '/microphone.mp3').then(function(res) {
                    goToConsentPage();
                },
                function(res) {
                    vm.versantFileIssueStatue = 'error';
                    var versantFileIssueLogInfoRq = {
                        "canLoginActivityLog": {
                            "versantFileIssue": true
                        }
                    };
                    loggerService.push(versantFileIssueLogInfoRq);
                });
        }

        function setConsentStatusCheck() {
            vm.wizard[vm.wizardCurrentStep].stateCheck = vm.acceptPrivacyPolicy && vm.acceptPersonalInfo && vm.acceptDataCapture;
        }

        function onNextClick() {
            if (vm.wizard[vm.wizardCurrentStep].callBack === 'savePersistance' && selfieImageUrl && !surroundCameraPage) {
                onSelfieCompleted(selfieImageUrl);
            }

            if (vm.wizard[vm.wizardCurrentStep].callBack === 'saveIdProof' && idProofUrl) {
                sendForApproval(idProofUrl);
                if (!vm.isIdApproval) {
                    trackerService.stopMediaStream();
                }
            }
            if (surroundCameraPage) {
                trackerService.stopMediaStream();
            }

            // if (vm.wizard[vm.wizardCurrentStep].type === 'idApproval') { //(vm.wizard[vm.wizardCurrentStep].callBack === 'saveIdProof' && idProofUrl) {
            //     // saveIdProof(idProofUrl);
            //     // if (!vm.isIdApproval) {
            //     //     trackerService.stopMediaStream();
            //     // }
            //     savePersistance(idProofUrl);
            // }
            blockUI.start();
            joinIfNotJoined()
                .then(function() {
                    if (vm.wizardCurrentStep + 1 == vm.wizard.length) {
                        $scope.$hide();
                        isFaceLandmarks = JSON.parse(sessionStorage.getItem('faceLandmarks'));
                        if (isFaceLandmarks) {
                            faceLandmarks.init('init');
                        }
                    } else {
                        vm.wizardCurrentStep = vm.wizardCurrentStep + 1;
                    }
                })
                .finally(function() {
                    blockUI.stop();
                });

            // if (vm.submitOrNext == 'Proceed to test') {
            //     $scope.$hide();
            // }
            // if (vm.wizardStep == 2 && selfieImageUrl) {
            //     savePersistance(selfieImageUrl);
            // }
            // if (vm.wizardStep == 3 && idProofUrl) {
            //     saveIdProof(idProofUrl);
            //     if (!vm.isIdApproval) {
            //         trackerService.stopMediaStream();
            //         if (vm.isNoiseCheckEnable) {
            //             vm.wizardStep = 4;
            //         } else if (vm.isSampleVideoRecordingEnable) {
            //             vm.wizardStep = 5;
            //         }
            //     }
            // }
            // if (vm.wizardStep == 2) {
            //     if (!vm.isCaptureIdEnabled && !vm.isNoiseCheckEnable && vm.isSampleVideoRecordingEnable) {
            //         vm.wizardStep = 5;
            //     } else if (!vm.isCaptureIdEnabled && vm.isNoiseCheckEnable) {
            //         vm.wizardStep = 4;
            //     }
            // }
            // vm.wizardStep = vm.wizardStep + 1;
            // changesNextButtonText();
        }

        function joinIfNotJoined() {
            var opts = isSecondaryCamera ? { "rqst": { "streamType": "SECONDARY_CAMERA" } } : null;
            if (!isMediaQuestion && vm.wizard[vm.wizardCurrentStep].callBack === 'savePersistance' && selfieImageUrl) {
                return hps.join(!!loginInfo.Config.ScreenProctoringIsMandat, isRefresh, opts);
            }
            return $q.when();
        }

        // function changesNextButtonText() {
        //     if (vm.wizardStep == 2 && !vm.isSampleVideoRecordingEnable && !vm.isNoiseCheckEnable && !vm.isCaptureIdEnabled) {
        //         vm.submitOrNext = 'Proceed to test';
        //     } else if (vm.wizardStep == 3 && !vm.isIdApproval && !vm.isSampleVideoRecordingEnable && !vm.isNoiseCheckEnable) {
        //         vm.submitOrNext = 'Proceed to test';
        //     } else if (vm.wizardStep == 4 && !vm.isSampleVideoRecordingEnable && !vm.isNoiseCheckEnable) {
        //         vm.submitOrNext = 'Proceed to test';
        //     } else if (vm.wizardStep == 5 && !vm.isSampleVideoRecordingEnable) {
        //         vm.submitOrNext = 'Proceed to test';
        //     } else if (vm.wizardStep == 6) {
        //         vm.submitOrNext = 'Proceed to test';
        //     } else {
        //         vm.submitOrNext = 'Next';
        //     }
        // }

        function callBackFormComponent(proceed, type, url, systemSlow, reloadEnabled, showReloadOnGetMyRoomFailure) {
            var wizardItem, wizardType;
            vm.reloadEnabled = reloadEnabled ? true : false;
            vm.showReloadOnGetMyRoomFailure = showReloadOnGetMyRoomFailure ? true : false;
            switch (type) {
                case 'consent':
                    wizardType = 'consent';
                    break;
                case 'assessmentTermsAndConditons':
                    wizardType = 'assessmentTermsAndConditons';
                    break;
                case 'image':
                    wizardType = 'proctor';
                    vm.isSystemSlow = systemSlow;
                    if (url) {
                        selfieImageUrl = url;
                    }
                    break;
                case 'roomScan':
                    wizardType = 'roomScan';
                    break;
                case 'video':
                    wizardType = 'sampleVideo';
                    break;
                case 'noise':
                    wizardType = 'noiseCheck';
                    break;
                case 'soundQuality':
                    wizardType = 'soundQualityCheck';
                    break;
                case 'secondaryCamera':
                    wizardType = 'secondaryCamera';
                    break;
                case 'secondaryCameraPreview':
                    wizardType = 'secondaryCameraPreview';
                    break;
                case 'idProof':
                    wizardType = 'captureId';
                    if (url) {
                        idProofUrl = url;
                    }
                    break;
                case 'idProofApprove':
                    var idProof;
                    wizardType = 'idApproval';
                    if (proceed) {
                        trackerService.stopMediaStream();
                        onNextClick();
                    } else {
                        idProof = _.find(vm.wizard, { type: 'captureId' });
                        if (idProof) {
                            idProof.stateCheck = false;
                        }
                        vm.wizardCurrentStep = _.findIndex(vm.wizard, { type: 'captureId' });
                    }
                    break;
            }
            wizardItem = _.find(vm.wizard, { type: wizardType });
            if (wizardItem) {
                wizardItem.stateCheck = proceed ? true : false;
            }
            // if (type == 'image'){
            // vm.isSystemSlow = systemSlow;
            // if (url) {
            //     selfieImageUrl = url;
            // }
            // } else if (type == 'video') {
            //     wizardItem = _.find(vm.wizard, {type: 'sampleVideo'});
            //     if (wizardItem) {
            //         wizardItem.stateCheck = proceed ? true : false;
            //     }
            // } else if (type == 'noise') {
            //     wizardItem = _.find(vm.wizard, {type: 'noiseCheck'});
            //     if (wizardItem) {
            //         wizardItem.stateCheck = proceed ? true : false;
            //     }
            // } else if (type == 'idProof') {
            //     if (url) {
            //         idProofUrl = url;
            //     }
            //     wizardItem = _.find(vm.wizard, {type: 'captureId'});
            //     if (wizardItem) {
            //         wizardItem.stateCheck = proceed ? true : false;
            //     }
            // } else if (type == 'idProofApprove') {
            //     if (proceed) {
            //         vm.idProofApproved = true;
            //         $scope.$hide();
            //         trackerService.stopMediaStream();
            //     } else {
            //         vm.wizardStep = 3;
            //         vm.idProofTaken = false;
            //         vm.idProofApproved = false;
            //         changesNextButtonText();
            //     }
            //     _.forEach(vm.wizard, function(item){
            //         if (item.type == 'captureId') {
            //             item.stateCheck = vm.idProofTaken;
            //         }
            //         if (item.type == 'idApproval') {
            //             item.stateCheck = vm.idProofApproved;
            //         }
            //     });
            // }
        }

        function savePersistance(url) {
            //proctorService.savePersistence(url);
            var s3Url = null;
            proctorService.savePersistence(url)
                .then(function(res) {
                    s3Url = res.s3_url;
                    return assessmentUtility.getPrivateIP();
                })
                .then(function(ipInfo) {
                    // alert('selfieCompleted-address');
                    // alert(MACAddress);
                    if (!commonService.testIsOnlinePreview()) {
                        var ip = _.size(ipInfo) > 0 ? ipInfo[0] : "dummy",
                            rq = {
                                selfieImage: s3Url,
                                ipAddress: ip,
                                MACAddress: MACAddress,
                                disableBlockUI: true
                            };
                        webService.execute('selfieCompleted', rq)
                            .then(function(res) {
                                console.log("selfieCompleted", res);
                            }, function(res) {
                                console.log("selfieCompleted_error", res);
                            });
                    }
                    assessmentUtility.localStorage.setData('savedinS3GoldenImagePath', s3Url);
                    $timeout(loadGoldenImageDataForFaceRecog(), 100);
                });
            trackerService.stopMediaStream();
        }

        function saveIdProof(url) {
            imageTracker.saveImageToS3(url, null, { isIdProof: true })
                .then(function(res) {
                    console.log("sap_saveIdProof", res.s3_url);
                    sendForApproval(res.s3_url);
                });
        }

        function sendForApproval(s3Url) {
            webService.execute('setTestUserAuthorization', { photoIdUrl: s3Url, disableBlockUI: true })
                .then(function(res) {
                    //if(res && res)
                    console.log(res);
                }, function(res) {
                    console.log(res);
                });
        }

        function reloadPage() {
            window.location.reload(true);
        }

        function onSelfieCompleted(url) {
            return assessmentUtility.getPrivateIP()
                .then(function(ipInfo) {
                    if (!commonService.testIsOnlinePreview()) {
                        var ip = _.size(ipInfo) > 0 ? ipInfo[0] : "dummy",
                            rq = {
                                selfieImage: url,
                                ipAddress: ip,
                                MACAddress: MACAddress,
                                disableBlockUI: true
                            };
                        webService.execute('selfieCompleted', rq)
                            .then(function(res) {
                                console.log("selfieCompleted", res);
                            }, function(res) {
                                console.log("selfieCompleted_error", res);
                            });
                    }
                    assessmentUtility.localStorage.setData('savedinS3GoldenImagePath', url);
                    trackerService.stopMediaStream();
                    $timeout(loadGoldenImageDataForFaceRecog(), 100);
                });
        }

        function loadGoldenImageDataForFaceRecog() {
            var loginInfo = assessmentUtility.localStorage.getData('TestLoginInformation'),
                goldenImageUrl = assessmentUtility.localStorage.getData('savedinS3GoldenImagePath'),
                isFaceRecognitionRequired = assessmentUtility.sessionStorage.getData("isFaceRecognitionRequired");
            assessmentUtility.sessionStorage.setData("isGoldenImageProcessedEnd", false);
            assessmentUtility.sessionStorage.setData("isGoldenImageProcessedStarted", false);
            if (!loginInfo || !loginInfo.Config || !loginInfo.Config.VideoProctoring || !loginInfo.Config.VideoProctoringIsMandat) {
                return;
            }
            if (goldenImageUrl && isFaceRecognitionRequired) {
                assessmentUtility.sessionStorage.setData("isGoldenImageProcessedStarted", true);
                faceRecognitionService.getImageInfo(goldenImageUrl)
                    .then(function() {
                        assessmentUtility.sessionStorage.setData("isGoldenImageProcessedEnd", true);
                    });
            }

        }

        function startSEBSecureKeyWatch() {
            const startTime = new Date();
            var secureEnvironmentInterval = setInterval(sebSecureKeyExists, 100);

            function sebSecureKeyExists() {
                if (window && window.sebSecureVariable) {
                    // You can use the variable here
                    //document.getElementsByClassName("mac-id")[0].innerHTML = Mac Address here on new page isis: ${window.sebSecureVariable};
                    //alert(`Mac Address here on new page in proctoring ctrl: ${window.sebSecureVariable}`);
                    assessmentUtility.sessionStorage.setData('MACAddress', window.sebSecureVariable);
                    clearInterval(secureEnvironmentInterval);

                } else {
                    if (((new Date() - startTime) / (1000 * 60)) > (1)) {
                        clearInterval(secureEnvironmentInterval);
                        redirectToMsgPage()
                    }
                }
            }
        }

        function initMacSocket() {
            // alert('connecting to ws://127.0.0.1:8706');
            var macSocket = new WebSocket('ws://127.0.0.1:8706');

            macSocket.onopen = function() {
                // alert('onopen');
                var request = {
                    Handler: 'MacAddress'
                };
                // alert(JSON.stringify(request));
                macSocket.send(JSON.stringify(request));
            };

            macSocket.onmessage = function(evt) {
                // alert('onmessage');
                // alert(JSON.stringify(evt.data));
                var result = JSON.parse(evt.data);
                // alert('ommessage-result');
                // alert(JSON.stringify(result));
                if (result) {
                    loggerService.push({
                        "canLoginActivityLog": {
                            "systemInformation": result
                        }
                    });
                }
                if (result && result.OnLineMacAddress) {
                    MACAddress = result.OnLineMacAddress;
                } else if (isSecureBrowserMandatory) {
                    redirectToMsgPage();
                }
                // alert('ommessage-address');
                // alert(result.OnLineMacAddress);
                macSocket.close();
            };

            macSocket.onerror = function(evt) {
                // alert('onerror');
                // alert(JSON.stringify(evt));
                console.log(evt);
                MACAddress = 'dummy';
                if (isSecureBrowserMandatory) {
                    redirectToMsgPage();
                }
            };
        }

        function redirectToMsgPage() {
            var msgStr = "Please take this test in secure browser !";
            var messageHtml = "<h2>" + msgStr + "</h2>";
            $state.go('msgPage', { stateParams: btoa(messageHtml) }, { location: 'replace', reload: true });
        }
    }
})();

 (function() {
     'use strict';
     angular
         .module('OnlineAssessmentAngular')
         .controller('NotificationModal', NotificationModal);
     /* @ngInject */

     function NotificationModal($scope, $sce) {
         var vm = this;

         vm.action = {
             okText: 'OK',
             cancelText: 'Cancel'
         };

         vm.onOkCall = onOkCall;
         vm.onCancelCall = onCancelCall;

         init();

         function init() {
             angular.merge(vm, $scope.data);
             vm.bodyStr = $sce.trustAsHtml(vm.bodyStr);
         }

         function onOkCall() {
             if (vm.action && vm.action.onOk) {
                 vm.action.onOk(vm);
             }
             $scope.data.result = {
                 modalResponse: 1
             };
             $scope.$hide();
         }

         function onCancelCall() {
             if (vm.action && vm.action.onCancel) {
                 vm.action.onCancel(vm);
             }
             $scope.data.result = {
                 modalResponse: 0
             };
             $scope.$hide();
         }
     }
 })();

(function() {
    'use strict';
    angular
        .module('OnlineAssessmentAngular')
        .controller('link', link);
    /* @ngInject */

    function link($scope, $sce) {
        var vm = this;
        vm.close = close;
        init();

        function init() {
            angular.merge(vm, $scope.data);
            vm.header = $scope.data.header;
            vm.url = $sce.trustAsResourceUrl($scope.data.url);
        }

        function close() {
            $scope.$hide();
        }   
    }
})();

 (function() {
     'use strict';
     angular
         .module('OnlineAssessmentAngular')
         .controller('GenerateKey', GenerateKey);
     /* @ngInject */

     function GenerateKey(assessmentService, assessmentUtility, $scope) {
         var vm = this;

         vm.onOk = onOk;

         init();

         function init() {
             angular.merge(vm, $scope.data);
             var offlineAnswerKey;
             offlineAnswerKey = assessmentUtility.localStorage.getData('OfflineAnswerKey');
             offlineAnswerKey.IsOfflineTestResult = true;
             vm.encAnswerKey = btoa(angular.toJson(offlineAnswerKey));
         }

         function onOk() {
             assessmentService.submitTest(false).then(function(res) {
                 if (res) {
                    $scope.data.result = res;
                     $scope.$hide();
                 }
             });
         }
     }
 })();

 (function() {
     'use strict';
     angular
         .module('OnlineAssessmentAngular')
         .controller('GetCandidateEmail', GetCandidateEmail);
     /* @ngInject */

     function GetCandidateEmail($scope) {
         var vm = this;

         vm.onOk = onOk;

         init();

         function init() {
             angular.merge(vm, $scope.data);
         }

         function onOk() {
             if (vm.email) {
                 $scope.data.email = vm.email;
                 $scope.$hide();
             } else {
                 vm.errorMessage = "Please provide registered email id.";
             }
         }
     }
 })();
(function() {
    'use strict';
    angular
        .module('OnlineAssessmentAngular')
        .controller('ShowBasicInstruction', ShowBasicInstruction);
    /* @ngInject */

    function ShowBasicInstruction($scope, $sce, loginService) {
        var vm = this;

        init();

        function init() {
            angular.merge(vm, $scope.data);
            var loginInfo = loginService.getLoginInfo(),
                testIns = loginInfo && loginInfo.TestInstructions,
                testInstructions;
            if (testIns) {
                testIns = testIns.replace(/<a.*?>(.*?)<\/a>/g, "");
                testInstructions = $sce.trustAsHtml(testIns);
            }
            vm.questionPaper = angular.fromJson(sessionStorage.getItem('questionPaperInfo'));
            vm.questionPaper.testInstructions = testInstructions;
        }
    }
})();
(function() {
    'use strict';
    angular
        .module('OnlineAssessmentAngular')
        .controller('GetTenantAlias', GetTenantAlias);
    /* @ngInject */

    function GetTenantAlias(loginService, $scope, $sce) {
        var vm = this;

        vm.onOk = onOk;

        init();

        function init() {
            angular.merge(vm, $scope.data);
        }

        function onOk() {
            if (vm.alias) {
                $scope.data.alias = vm.alias;
                loginService.getCompanyInfo(vm.alias)
                .then(function(res) {
                    if (!res.tenantId) {
                        vm.errorMessage = 'Please provide correct Tenant alias.';
                        return false;
                    }
                    if (res.content.CompanyWebsiteURL) {
                        $scope.data.ogrUrl = $sce.trustAsResourceUrl(res.content.CompanyWebsiteURL);
                    }
                    if (res.content.isNseitTenant) {
                        sessionStorage.isNseitTenant = true;
                    }
                    $scope.$hide();
                },
                function() {
                    vm.errorMessage = 'Please provide correct Tenant alias.';
                    return false;
                });
            } else {
                vm.errorMessage = "Please provide Tenant alias.";
            }
        }
    }
})();

/*
	The MIT License (MIT)

	Copyright (c) 2016 Meetecho

	Permission is hereby granted, free of charge, to any person obtaining
	a copy of this software and associated documentation files (the "Software"),
	to deal in the Software without restriction, including without limitation
	the rights to use, copy, modify, merge, publish, distribute, sublicense,
	and/or sell copies of the Software, and to permit persons to whom the
	Software is furnished to do so, subject to the following conditions:

	The above copyright notice and this permission notice shall be included
	in all copies or substantial portions of the Software.

	THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL
	THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR
	OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE,
	ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR
	OTHER DEALINGS IN THE SOFTWARE.
 */

// List of sessions
Janus.sessions = {};

Janus.isExtensionEnabled = function() {
    if (navigator.mediaDevices && navigator.mediaDevices.getDisplayMedia) {
        // No need for the extension, getDisplayMedia is supported
        return true;
    }
    if (window.navigator.userAgent.match('Chrome')) {
        var chromever = parseInt(window.navigator.userAgent.match(/Chrome\/(.*) /)[1], 10);
        var maxver = 33;
        if (window.navigator.userAgent.match('Linux'))
            maxver = 35; // "known" crash in chrome 34 and 35 on linux
        if (chromever >= 26 && chromever <= maxver) {
            // Older versions of Chrome don't support this extension-based approach, so lie
            return true;
        }
        return Janus.extension.isInstalled();
    } else {
        // Firefox of others, no need for the extension (but this doesn't mean it will work)
        return true;
    }
};

var defaultExtension = {
    // Screensharing Chrome Extension ID
    extensionId: 'befiebhbjcgnkpppjgjmgjoppeickdjp',
    isInstalled: function() { return document.querySelector('#hpro-extension-installed') !== null; },
    getScreen: function(callback) {
        var pending = window.setTimeout(function() {
            var error = new Error('NavigatorUserMediaError');
            error.name = 'The required Chrome extension is not installed: click <a href="#">here</a> to install it. (NOTE: this will need you to refresh the page)';
            return callback(error);
        }, 1000);
        this.cache[pending] = callback;
        window.postMessage({ type: 'hproGetScreen', id: pending }, '*');
    },
    init: function() {
        var cache = {};
        this.cache = cache;
        // Wait for events from the Chrome Extension
        window.addEventListener('message', function(event) {
            if (event.origin != window.location.origin)
                return;
            if (event.data.type == 'hproGotScreen' && cache[event.data.id]) {
                var callback = cache[event.data.id];
                delete cache[event.data.id];

                if (event.data.sourceId === '') {
                    // user canceled
                    var error = new Error('NavigatorUserMediaError');
                    error.name = 'You cancelled the request for permission, giving up...';
                    callback(error);
                } else {
                    callback(null, event.data.sourceId);
                }
            } else if (event.data.type == 'hproGetScreenPending') {
                console.log('clearing ', event.data.id);
                window.clearTimeout(event.data.id);
            }
        });
    }
};

Janus.useDefaultDependencies = function(deps) {
    var f = (deps && deps.fetch) || fetch;
    var p = (deps && deps.Promise) || Promise;
    var socketCls = (deps && deps.WebSocket) || WebSocket;

    return {
        newWebSocket: function(server, proto) { return new socketCls(server, proto); },
        extension: (deps && deps.extension) || defaultExtension,
        isArray: function(arr) { return Array.isArray(arr); },
        webRTCAdapter: (deps && deps.adapter) || adapter,
        httpAPICall: function(url, options) {
            var fetchOptions = {
                method: options.verb,
                headers: {
                    'Accept': 'application/json, text/plain, */*'
                },
                cache: 'no-cache'
            };
            if (options.verb === "POST") {
                fetchOptions.headers['Content-Type'] = 'application/json';
            }
            if (options.withCredentials !== undefined) {
                fetchOptions.credentials = options.withCredentials === true ? 'include' : (options.withCredentials ? options.withCredentials : 'omit');
            }
            if (options.body !== undefined) {
                fetchOptions.body = JSON.stringify(options.body);
            }

            var fetching = f(url, fetchOptions).catch(function(error) {
                return p.reject({ message: 'Probably a network error, is the server down?', error: error });
            });

            /*
             * fetch() does not natively support timeouts.
             * Work around this by starting a timeout manually, and racing it agains the fetch() to see which thing resolves first.
             */

            if (options.timeout !== undefined) {
                var timeout = new p(function(resolve, reject) {
                    var timerId = setTimeout(function() {
                        clearTimeout(timerId);
                        return reject({ message: 'Request timed out', timeout: options.timeout });
                    }, options.timeout);
                });
                fetching = p.race([fetching, timeout]);
            }

            fetching.then(function(response) {
                if (response.ok) {
                    if (typeof(options.success) === typeof(Janus.noop)) {
                        return response.json().then(function(parsed) {
                            options.success(parsed);
                        }).catch(function(error) {
                            return p.reject({ message: 'Failed to parse response body', error: error, response: response });
                        });
                    }
                } else {
                    return p.reject({ message: 'API call failed', response: response });
                }
            }).catch(function(error) {
                if (typeof(options.error) === typeof(Janus.noop)) {
                    options.error(error.message || '<< internal error >>', error);
                }
            });

            return fetching;
        }
    }
};

Janus.useOldDependencies = function(deps) {
    var jq = (deps && deps.jQuery) || jQuery;
    var socketCls = (deps && deps.WebSocket) || WebSocket;
    return {
        newWebSocket: function(server, proto) { return new socketCls(server, proto); },
        isArray: function(arr) { return jq.isArray(arr); },
        extension: (deps && deps.extension) || defaultExtension,
        webRTCAdapter: (deps && deps.adapter) || adapter,
        httpAPICall: function(url, options) {
            var payload = options.body !== undefined ? {
                contentType: 'application/json',
                data: JSON.stringify(options.body)
            } : {};
            var credentials = options.withCredentials !== undefined ? { xhrFields: { withCredentials: options.withCredentials } } : {};

            return jq.ajax(jq.extend(payload, credentials, {
                url: url,
                type: options.verb,
                cache: false,
                dataType: 'json',
                async: options.async,
                timeout: options.timeout,
                success: function(result) {
                    if (typeof(options.success) === typeof(Janus.noop)) {
                        options.success(result);
                    }
                },
                error: function(xhr, status, err) {
                    if (typeof(options.error) === typeof(Janus.noop)) {
                        options.error(status, err);
                    }
                }
            }));
        },
    };
};

Janus.noop = function() {};

Janus.dataChanDefaultLabel = "JanusDataChannel";

// Note: in the future we may want to change this, e.g., as was
// attempted in https://github.com/meetecho/janus-gateway/issues/1670
Janus.endOfCandidates = null;

// Initialization
Janus.init = function(options) {
    options = options || {};
    options.callback = (typeof options.callback == "function") ? options.callback : Janus.noop;
    if (Janus.initDone === true) {
        // Already initialized
        options.callback();
    } else {
        if (typeof console == "undefined" || typeof console.log == "undefined")
            console = { log: function() {} };
        // Console logging (all debugging disabled by default)
        Janus.trace = Janus.noop;
        Janus.debug = Janus.noop;
        Janus.vdebug = Janus.noop;
        Janus.log = Janus.noop;
        Janus.warn = Janus.noop;
        Janus.error = Janus.noop;
        if (options.debug === true || options.debug === "all") {
            // Enable all debugging levels
            Janus.trace = console.trace.bind(console);
            Janus.debug = console.debug.bind(console);
            Janus.vdebug = console.debug.bind(console);
            Janus.log = console.log.bind(console);
            Janus.warn = console.warn.bind(console);
            Janus.error = console.error.bind(console);
        } else if (Array.isArray(options.debug)) {
            for (var i in options.debug) {
                var d = options.debug[i];
                switch (d) {
                    case "trace":
                        Janus.trace = console.trace.bind(console);
                        break;
                    case "debug":
                        Janus.debug = console.debug.bind(console);
                        break;
                    case "vdebug":
                        Janus.vdebug = console.debug.bind(console);
                        break;
                    case "log":
                        Janus.log = console.log.bind(console);
                        break;
                    case "warn":
                        Janus.warn = console.warn.bind(console);
                        break;
                    case "error":
                        Janus.error = console.error.bind(console);
                        break;
                    default:
                        console.error("Unknown debugging option '" + d + "' (supported: 'trace', 'debug', 'vdebug', 'log', warn', 'error')");
                        break;
                }
            }
        }
        Janus.log("Initializing library");

        var usedDependencies = options.dependencies || Janus.useDefaultDependencies();
        Janus.isArray = usedDependencies.isArray;
        Janus.webRTCAdapter = usedDependencies.webRTCAdapter;
        Janus.httpAPICall = usedDependencies.httpAPICall;
        Janus.newWebSocket = usedDependencies.newWebSocket;
        Janus.extension = usedDependencies.extension;
        Janus.extension.init();

        // Helper method to enumerate devices
        Janus.listDevices = function(callback, config) {
            callback = (typeof callback == "function") ? callback : Janus.noop;
            if (config == null) config = { audio: true, video: true };
            if (Janus.isGetUserMediaAvailable()) {
                navigator.mediaDevices.getUserMedia(config)
                    .then(function(stream) {
                        navigator.mediaDevices.enumerateDevices().then(function(devices) {
                            Janus.debug(devices);
                            callback(devices);
                            // Get rid of the now useless stream
                            try {
                                var tracks = stream.getTracks();
                                for (var i in tracks) {
                                    var mst = tracks[i];
                                    if (mst !== null && mst !== undefined)
                                        mst.stop();
                                }
                            } catch (e) {}
                        });
                    })
                    .catch(function(err) {
                        Janus.error(err);
                        callback([]);
                    });
            } else {
                Janus.warn("navigator.mediaDevices unavailable");
                callback([]);
            }
        }
        // Helper methods to attach/reattach a stream to a video element (previously part of adapter.js)
        Janus.attachMediaStream = function(element, stream) {
            if (Janus.webRTCAdapter.browserDetails.browser === 'chrome') {
                var chromever = Janus.webRTCAdapter.browserDetails.version;
                if (chromever >= 52) {
                    element.srcObject = stream;
                } else if (typeof element.src !== 'undefined') {
                    element.src = URL.createObjectURL(stream);
                } else {
                    Janus.error("Error attaching stream to element");
                }
            } else {
                element.srcObject = stream;
            }
        };
        Janus.reattachMediaStream = function(to, from) {
            if (Janus.webRTCAdapter.browserDetails.browser === 'chrome') {
                var chromever = Janus.webRTCAdapter.browserDetails.version;
                if (chromever >= 52) {
                    to.srcObject = from.srcObject;
                } else if (typeof to.src !== 'undefined') {
                    to.src = from.src;
                } else {
                    Janus.error("Error reattaching stream to element");
                }
            } else {
                to.srcObject = from.srcObject;
            }
        };
        // Detect tab close: make sure we don't loose existing onbeforeunload handlers
        // (note: for iOS we need to subscribe to a different event, 'pagehide', see
        // https://gist.github.com/thehunmonkgroup/6bee8941a49b86be31a787fe8f4b8cfe)
        var iOS = ['iPad', 'iPhone', 'iPod'].indexOf(navigator.platform) >= 0;
        var eventName = iOS ? 'pagehide' : 'beforeunload';
        var oldOBF = window["on" + eventName];
        window.addEventListener(eventName, function(event) {
            Janus.log("Closing window");
            for (var s in Janus.sessions) {
                if (Janus.sessions[s] !== null && Janus.sessions[s] !== undefined &&
                    Janus.sessions[s].destroyOnUnload) {
                    Janus.log("Destroying session " + s);
                    Janus.sessions[s].destroy({ asyncRequest: false, notifyDestroyed: false });
                }
            }
            if (oldOBF && typeof oldOBF == "function")
                oldOBF();
        });
        // If this is a Safari Technology Preview, check if VP8 is supported
        Janus.safariVp8 = false;
        if (Janus.webRTCAdapter.browserDetails.browser === 'safari' &&
            Janus.webRTCAdapter.browserDetails.version >= 605) {
            // Let's see if RTCRtpSender.getCapabilities() is there
            if (RTCRtpSender && RTCRtpSender.getCapabilities && RTCRtpSender.getCapabilities("video") &&
                RTCRtpSender.getCapabilities("video").codecs && RTCRtpSender.getCapabilities("video").codecs.length) {
                for (var i in RTCRtpSender.getCapabilities("video").codecs) {
                    var codec = RTCRtpSender.getCapabilities("video").codecs[i];
                    if (codec && codec.mimeType && codec.mimeType.toLowerCase() === "video/vp8") {
                        Janus.safariVp8 = true;
                        break;
                    }
                }
                if (Janus.safariVp8) {
                    Janus.log("This version of Safari supports VP8");
                } else {
                    Janus.warn("This version of Safari does NOT support VP8: if you're using a Technology Preview, " +
                        "try enabling the 'WebRTC VP8 codec' setting in the 'Experimental Features' Develop menu");
                }
            } else {
                // We do it in a very ugly way, as there's no alternative...
                // We create a PeerConnection to see if VP8 is in an offer
                var testpc = new RTCPeerConnection({}, {});
                testpc.createOffer({ offerToReceiveVideo: true }).then(function(offer) {
                    Janus.safariVp8 = offer.sdp.indexOf("VP8") !== -1;
                    if (Janus.safariVp8) {
                        Janus.log("This version of Safari supports VP8");
                    } else {
                        Janus.warn("This version of Safari does NOT support VP8: if you're using a Technology Preview, " +
                            "try enabling the 'WebRTC VP8 codec' setting in the 'Experimental Features' Develop menu");
                    }
                    testpc.close();
                    testpc = null;
                });
            }
        }
        // Check if this browser supports Unified Plan and transceivers
        // Based on https://codepen.io/anon/pen/ZqLwWV?editors=0010
        Janus.unifiedPlan = false;
        if (Janus.webRTCAdapter.browserDetails.browser === 'firefox' &&
            Janus.webRTCAdapter.browserDetails.version >= 59) {
            // Firefox definitely does, starting from version 59
            Janus.unifiedPlan = true;
        } else if (Janus.webRTCAdapter.browserDetails.browser === 'chrome' &&
            Janus.webRTCAdapter.browserDetails.version < 72) {
            // Chrome does, but it's only usable from version 72 on
            Janus.unifiedPlan = false;
        } else if (!window.RTCRtpTransceiver || !('currentDirection' in RTCRtpTransceiver.prototype)) {
            // Safari supports addTransceiver() but not Unified Plan when
            // currentDirection is not defined (see codepen above).
            Janus.unifiedPlan = false;
        } else {
            // Check if addTransceiver() throws an exception
            const tempPc = new RTCPeerConnection();
            try {
                tempPc.addTransceiver('audio');
                Janus.unifiedPlan = true;
            } catch (e) {}
            tempPc.close();
        }
        Janus.initDone = true;
        options.callback();
    }
};

// Helper method to check whether WebRTC is supported by this browser
Janus.isWebrtcSupported = function() {
    return window.RTCPeerConnection !== undefined && window.RTCPeerConnection !== null;
};
// Helper method to check whether devices can be accessed by this browser (e.g., not possible via plain HTTP)
Janus.isGetUserMediaAvailable = function() {
    return navigator.mediaDevices !== undefined && navigator.mediaDevices !== null &&
        navigator.mediaDevices.getUserMedia !== undefined && navigator.mediaDevices.getUserMedia !== null;
};

// Helper method to create random identifiers (e.g., transaction)
Janus.randomString = function(len) {
    var charSet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var randomString = '';
    for (var i = 0; i < len; i++) {
        var randomPoz = Math.floor(Math.random() * charSet.length);
        randomString += charSet.substring(randomPoz, randomPoz + 1);
    }
    return randomString;
}


function Janus(gatewayCallbacks) {
    if (Janus.initDone === undefined) {
        gatewayCallbacks.error("Library not initialized");
        return {};
    }
    if (!Janus.isWebrtcSupported()) {
        gatewayCallbacks.error("WebRTC not supported by this browser");
        return {};
    }
    Janus.log("Library initialized: " + Janus.initDone);
    gatewayCallbacks = gatewayCallbacks || {};
    gatewayCallbacks.success = (typeof gatewayCallbacks.success == "function") ? gatewayCallbacks.success : Janus.noop;
    gatewayCallbacks.error = (typeof gatewayCallbacks.error == "function") ? gatewayCallbacks.error : Janus.noop;
    gatewayCallbacks.destroyed = (typeof gatewayCallbacks.destroyed == "function") ? gatewayCallbacks.destroyed : Janus.noop;
    if (gatewayCallbacks.server === null || gatewayCallbacks.server === undefined) {
        gatewayCallbacks.error("Invalid server url");
        return {};
    }
    var websockets = false;
    var ws = null;
    var wsHandlers = {};
    var wsKeepaliveTimeoutId = null;

    var servers = null,
        serversIndex = 0;
    var server = gatewayCallbacks.server;
    if (Janus.isArray(server)) {
        Janus.log("Multiple servers provided (" + server.length + "), will use the first that works");
        server = null;
        servers = gatewayCallbacks.server;
        Janus.debug(servers);
    } else {
        if (server.indexOf("ws") === 0) {
            websockets = true;
            Janus.log("Using WebSockets to contact Janus: " + server);
        } else {
            websockets = false;
            Janus.log("Using REST API to contact Janus: " + server);
        }
    }
    var iceServers = gatewayCallbacks.iceServers;
    // iceServers = [{urls: ["turn:15.206.176.140:443;transport=tcp"],username:"uctrtc",credential:"hpro2019#"}];
    if (iceServers === undefined || iceServers === null)
        iceServers = [{ urls: "stun:stun.l.google.com:19302" }];
    var iceTransportPolicy = gatewayCallbacks.iceTransportPolicy;
    var bundlePolicy = gatewayCallbacks.bundlePolicy;
    // Whether IPv6 candidates should be gathered
    var ipv6Support = gatewayCallbacks.ipv6;
    if (ipv6Support === undefined || ipv6Support === null)
        ipv6Support = false;
    // Whether we should enable the withCredentials flag for XHR requests
    var withCredentials = false;
    if (gatewayCallbacks.withCredentials !== undefined && gatewayCallbacks.withCredentials !== null)
        withCredentials = gatewayCallbacks.withCredentials === true;
    // Optional max events
    var maxev = 1;
    if (gatewayCallbacks.max_poll_events !== undefined && gatewayCallbacks.max_poll_events !== null)
        maxev = gatewayCallbacks.max_poll_events;
    if (maxev < 1)
        maxev = 1;
    // Token to use (only if the token based authentication mechanism is enabled)
    var token = null;
    if (gatewayCallbacks.token !== undefined && gatewayCallbacks.token !== null)
        token = gatewayCallbacks.token;
    // API secret to use (only if the shared API secret is enabled)
    var apisecret = null;
    if (gatewayCallbacks.apisecret !== undefined && gatewayCallbacks.apisecret !== null)
        apisecret = gatewayCallbacks.apisecret;
    // Whether we should destroy this session when onbeforeunload is called
    this.destroyOnUnload = true;
    if (gatewayCallbacks.destroyOnUnload !== undefined && gatewayCallbacks.destroyOnUnload !== null)
        this.destroyOnUnload = (gatewayCallbacks.destroyOnUnload === true);
    // Some timeout-related values
    var keepAlivePeriod = 25000;
    if (gatewayCallbacks.keepAlivePeriod !== undefined && gatewayCallbacks.keepAlivePeriod !== null)
        keepAlivePeriod = gatewayCallbacks.keepAlivePeriod;
    if (isNaN(keepAlivePeriod))
        keepAlivePeriod = 25000;
    var longPollTimeout = 60000;
    if (gatewayCallbacks.longPollTimeout !== undefined && gatewayCallbacks.longPollTimeout !== null)
        longPollTimeout = gatewayCallbacks.longPollTimeout;
    if (isNaN(longPollTimeout))
        longPollTimeout = 60000;

    // overrides for default maxBitrate values for simulcasting
    function getMaxBitrates(simulcastMaxBitrates) {
        var maxBitrates = {
            high: 50000,
            medium: 30000,
            low: 10000,
        };

        if (simulcastMaxBitrates !== undefined && simulcastMaxBitrates !== null) {
            if (simulcastMaxBitrates.high)
                maxBitrates.high = simulcastMaxBitrates.high;
            if (simulcastMaxBitrates.medium)
                maxBitrates.medium = simulcastMaxBitrates.medium;
            if (simulcastMaxBitrates.low)
                maxBitrates.low = simulcastMaxBitrates.low;
        }
        Janus.log('sap_ss_MaxBitrate returned - 3', maxBitrates);
        return maxBitrates;
    }

    var connected = false;
    var sessionId = null;
    var pluginHandles = {};
    var that = this;
    var retries = 0;
    var transactions = {};
    createSession(gatewayCallbacks);

    // Public methods
    this.getServer = function() { return server; };
    this.isConnected = function() { return connected; };
    this.reconnect = function(callbacks) {
        callbacks = callbacks || {};
        callbacks.success = (typeof callbacks.success == "function") ? callbacks.success : Janus.noop;
        callbacks.error = (typeof callbacks.error == "function") ? callbacks.error : Janus.noop;
        callbacks["reconnect"] = true;
        createSession(callbacks);
    };
    this.getSessionId = function() { return sessionId; };
    this.destroy = function(callbacks) { destroySession(callbacks); };
    this.attach = function(callbacks) { createHandle(callbacks); };

    function eventHandler() {
        if (sessionId == null)
            return;
        Janus.debug('Long poll...');
        if (!connected) {
            Janus.warn("Is the server down? (connected=false)");
            return;
        }
        var longpoll = server + "/" + sessionId + "?rid=" + new Date().getTime();
        if (maxev !== undefined && maxev !== null)
            longpoll = longpoll + "&maxev=" + maxev;
        if (token !== null && token !== undefined)
            longpoll = longpoll + "&token=" + encodeURIComponent(token);
        if (apisecret !== null && apisecret !== undefined)
            longpoll = longpoll + "&apisecret=" + encodeURIComponent(apisecret);
        Janus.httpAPICall(longpoll, {
            verb: 'GET',
            withCredentials: withCredentials,
            success: handleEvent,
            timeout: longPollTimeout,
            error: function(textStatus, errorThrown) {
                Janus.error(textStatus + ":", errorThrown);
                retries++;
                if (retries > 3) {
                    // Did we just lose the server? :-(
                    connected = false;
                    gatewayCallbacks.error("Lost connection to the server (is it down?)");
                    return;
                }
                eventHandler();
            }
        });
    }

    // Private event handler: this will trigger plugin callbacks, if set
    function handleEvent(json, skipTimeout) {
        retries = 0;
        if (!websockets && sessionId !== undefined && sessionId !== null && skipTimeout !== true)
            eventHandler();
        if (!websockets && Janus.isArray(json)) {
            // We got an array: it means we passed a maxev > 1, iterate on all objects
            for (var i = 0; i < json.length; i++) {
                handleEvent(json[i], true);
            }
            return;
        }
        if (json["janus"] === "keepalive") {
            // Nothing happened
            Janus.vdebug("Got a keepalive on session " + sessionId);
            return;
        } else if (json["janus"] === "ack") {
            // Just an ack, we can probably ignore
            Janus.debug("Got an ack on session " + sessionId);
            Janus.debug(json);
            var transaction = json["transaction"];
            if (transaction !== null && transaction !== undefined) {
                var reportSuccess = transactions[transaction];
                if (reportSuccess !== null && reportSuccess !== undefined) {
                    reportSuccess(json);
                }
                delete transactions[transaction];
            }
            return;
        } else if (json["janus"] === "success") {
            // Success!
            Janus.debug("Got a success on session " + sessionId);
            Janus.debug(json);
            var transaction = json["transaction"];
            if (transaction !== null && transaction !== undefined) {
                var reportSuccess = transactions[transaction];
                if (reportSuccess !== null && reportSuccess !== undefined) {
                    reportSuccess(json);
                }
                delete transactions[transaction];
            }
            return;
        } else if (json["janus"] === "trickle") {
            // We got a trickle candidate from Janus
            var sender = json["sender"];
            if (sender === undefined || sender === null) {
                Janus.warn("Missing sender...");
                return;
            }
            var pluginHandle = pluginHandles[sender];
            if (pluginHandle === undefined || pluginHandle === null) {
                Janus.debug("This handle is not attached to this session");
                return;
            }
            var candidate = json["candidate"];
            Janus.debug("Got a trickled candidate on session " + sessionId);
            Janus.debug(candidate);
            var config = pluginHandle.webrtcStuff;
            if (config.pc && config.remoteSdp) {
                // Add candidate right now
                Janus.debug("Adding remote candidate:", candidate);
                if (!candidate || candidate.completed === true) {
                    // end-of-candidates
                    config.pc.addIceCandidate(Janus.endOfCandidates);
                } else {
                    // New candidate
                    config.pc.addIceCandidate(candidate);
                }
            } else {
                // We didn't do setRemoteDescription (trickle got here before the offer?)
                Janus.debug("We didn't do setRemoteDescription (trickle got here before the offer?), caching candidate");
                if (!config.candidates)
                    config.candidates = [];
                config.candidates.push(candidate);
                Janus.debug(config.candidates);
            }
        } else if (json["janus"] === "webrtcup") {
            // The PeerConnection with the server is up! Notify this
            Janus.debug("Got a webrtcup event on session " + sessionId);
            Janus.debug(json);
            var sender = json["sender"];
            if (sender === undefined || sender === null) {
                Janus.warn("Missing sender...");
                return;
            }
            var pluginHandle = pluginHandles[sender];
            if (pluginHandle === undefined || pluginHandle === null) {
                Janus.debug("This handle is not attached to this session");
                return;
            }
            pluginHandle.webrtcState(true);
            return;
        } else if (json["janus"] === "hangup") {
            // A plugin asked the core to hangup a PeerConnection on one of our handles
            Janus.debug("Got a hangup event on session " + sessionId);
            Janus.debug(json);
            var sender = json["sender"];
            if (sender === undefined || sender === null) {
                Janus.warn("Missing sender...");
                return;
            }
            var pluginHandle = pluginHandles[sender];
            if (pluginHandle === undefined || pluginHandle === null) {
                Janus.debug("This handle is not attached to this session");
                return;
            }
            pluginHandle.webrtcState(false, json["reason"]);
            pluginHandle.hangup();
        } else if (json["janus"] === "detached") {
            // A plugin asked the core to detach one of our handles
            Janus.debug("Got a detached event on session " + sessionId);
            Janus.debug(json);
            var sender = json["sender"];
            if (sender === undefined || sender === null) {
                Janus.warn("Missing sender...");
                return;
            }
            var pluginHandle = pluginHandles[sender];
            if (pluginHandle === undefined || pluginHandle === null) {
                // Don't warn here because destroyHandle causes this situation.
                return;
            }
            pluginHandle.detached = true;
            pluginHandle.ondetached();
            pluginHandle.detach();
        } else if (json["janus"] === "media") {
            // Media started/stopped flowing
            Janus.debug("Got a media event on session " + sessionId);
            Janus.debug(json);
            var sender = json["sender"];
            if (sender === undefined || sender === null) {
                Janus.warn("Missing sender...");
                return;
            }
            var pluginHandle = pluginHandles[sender];
            if (pluginHandle === undefined || pluginHandle === null) {
                Janus.debug("This handle is not attached to this session");
                return;
            }
            pluginHandle.mediaState(json["type"], json["receiving"]);
        } else if (json["janus"] === "slowlink") {
            Janus.debug("Got a slowlink event on session " + sessionId);
            Janus.debug(json);
            // Trouble uplink or downlink
            var sender = json["sender"];
            if (sender === undefined || sender === null) {
                Janus.warn("Missing sender...");
                return;
            }
            var pluginHandle = pluginHandles[sender];
            if (pluginHandle === undefined || pluginHandle === null) {
                Janus.debug("This handle is not attached to this session");
                return;
            }
            pluginHandle.slowLink(json["uplink"], json["lost"]);
        } else if (json["janus"] === "error") {
            // Oops, something wrong happened
            Janus.error("Ooops: " + json["error"].code + " " + json["error"].reason); // FIXME
            Janus.debug(json);
            var transaction = json["transaction"];
            if (transaction !== null && transaction !== undefined) {
                var reportSuccess = transactions[transaction];
                if (reportSuccess !== null && reportSuccess !== undefined) {
                    reportSuccess(json);
                }
                delete transactions[transaction];
            }
            return;
        } else if (json["janus"] === "event") {
            Janus.debug("Got a plugin event on session " + sessionId);
            Janus.debug(json);
            var sender = json["sender"];
            if (sender === undefined || sender === null) {
                Janus.warn("Missing sender...");
                return;
            }
            var plugindata = json["plugindata"];
            if (plugindata === undefined || plugindata === null) {
                Janus.warn("Missing plugindata...");
                return;
            }
            Janus.debug("  -- Event is coming from " + sender + " (" + plugindata["plugin"] + ")");
            var data = plugindata["data"];
            Janus.debug(data);
            var pluginHandle = pluginHandles[sender];
            if (pluginHandle === undefined || pluginHandle === null) {
                Janus.warn("This handle is not attached to this session");
                return;
            }
            var jsep = json["jsep"];
            if (jsep !== undefined && jsep !== null) {
                Janus.debug("Handling SDP as well...");
                Janus.debug(jsep);
            }
            var callback = pluginHandle.onmessage;
            if (callback !== null && callback !== undefined) {
                Janus.debug("Notifying application...");
                // Send to callback specified when attaching plugin handle
                callback(data, jsep);
            } else {
                // Send to generic callback (?)
                Janus.debug("No provided notification callback");
            }
        } else if (json["janus"] === "timeout") {
            Janus.error("Timeout on session " + sessionId);
            Janus.debug(json);
            if (websockets) {
                ws.close(3504, "Gateway timeout");
            }
            return;
        } else {
            Janus.warn("Unknown message/event  '" + json["janus"] + "' on session " + sessionId);
            Janus.debug(json);
        }
    }

    // Private helper to send keep-alive messages on WebSockets
    function keepAlive() {
        if (server === null || !websockets || !connected)
            return;
        wsKeepaliveTimeoutId = setTimeout(keepAlive, keepAlivePeriod);
        var request = { "janus": "keepalive", "session_id": sessionId, "transaction": Janus.randomString(12) };
        if (token !== null && token !== undefined)
            request["token"] = token;
        if (apisecret !== null && apisecret !== undefined)
            request["apisecret"] = apisecret;
        ws.send(JSON.stringify(request));
    }

    // Private method to create a session
    function createSession(callbacks) {
        var transaction = Janus.randomString(12);
        var request = { "janus": "create", "transaction": transaction };
        if (callbacks["reconnect"]) {
            // We're reconnecting, claim the session
            connected = false;
            request["janus"] = "claim";
            request["session_id"] = sessionId;
            // If we were using websockets, ignore the old connection
            if (ws) {
                ws.onopen = null;
                ws.onerror = null;
                ws.onclose = null;
                if (wsKeepaliveTimeoutId) {
                    clearTimeout(wsKeepaliveTimeoutId);
                    wsKeepaliveTimeoutId = null;
                }
            }
        }
        if (token !== null && token !== undefined)
            request["token"] = token;
        if (apisecret !== null && apisecret !== undefined)
            request["apisecret"] = apisecret;
        if (server === null && Janus.isArray(servers)) {
            // We still need to find a working server from the list we were given
            server = servers[serversIndex];
            if (server.indexOf("ws") === 0) {
                websockets = true;
                Janus.log("Server #" + (serversIndex + 1) + ": trying WebSockets to contact Janus (" + server + ")");
            } else {
                websockets = false;
                Janus.log("Server #" + (serversIndex + 1) + ": trying REST API to contact Janus (" + server + ")");
            }
        }
        if (websockets) {
            ws = Janus.newWebSocket(server, 'janus-protocol');
            wsHandlers = {
                'error': function() {
                    Janus.error("Error connecting to the Janus WebSockets server... " + server);
                    if (Janus.isArray(servers) && !callbacks["reconnect"]) {
                        serversIndex++;
                        if (serversIndex == servers.length) {
                            // We tried all the servers the user gave us and they all failed
                            callbacks.error("Error connecting to any of the provided Janus servers: Is the server down?");
                            return;
                        }
                        // Let's try the next server
                        server = null;
                        setTimeout(function() {
                            createSession(callbacks);
                        }, 200);
                        return;
                    }
                    callbacks.error("Error connecting to the Janus WebSockets server: Is the server down?");
                },

                'open': function() {
                    // We need to be notified about the success
                    transactions[transaction] = function(json) {
                        Janus.debug(json);
                        if (json["janus"] !== "success") {
                            Janus.error("Ooops: " + json["error"].code + " " + json["error"].reason); // FIXME
                            callbacks.error(json["error"].reason);
                            return;
                        }
                        wsKeepaliveTimeoutId = setTimeout(keepAlive, keepAlivePeriod);
                        connected = true;
                        sessionId = json["session_id"] ? json["session_id"] : json.data["id"];
                        if (callbacks["reconnect"]) {
                            Janus.log("Claimed session: " + sessionId);
                        } else {
                            Janus.log("Created session: " + sessionId);
                        }
                        Janus.sessions[sessionId] = that;
                        callbacks.success();
                    };
                    ws.send(JSON.stringify(request));
                },

                'message': function(event) {
                    handleEvent(JSON.parse(event.data));
                },

                'close': function() {
                    if (server === null || !connected) {
                        return;
                    }
                    connected = false;
                    // FIXME What if this is called when the page is closed?
                    gatewayCallbacks.error("Lost connection to the server (is it down?)");
                }
            };

            for (var eventName in wsHandlers) {
                ws.addEventListener(eventName, wsHandlers[eventName]);
            }

            return;
        }
        Janus.httpAPICall(server, {
            verb: 'POST',
            withCredentials: withCredentials,
            body: request,
            success: function(json) {
                Janus.debug(json);
                if (json["janus"] !== "success") {
                    Janus.error("Ooops: " + json["error"].code + " " + json["error"].reason); // FIXME
                    callbacks.error(json["error"].reason);
                    return;
                }
                connected = true;
                sessionId = json["session_id"] ? json["session_id"] : json.data["id"];
                if (callbacks["reconnect"]) {
                    Janus.log("Claimed session: " + sessionId);
                } else {
                    Janus.log("Created session: " + sessionId);
                }
                Janus.sessions[sessionId] = that;
                eventHandler();
                callbacks.success();
            },
            error: function(textStatus, errorThrown) {
                Janus.error(textStatus + ":", errorThrown); // FIXME
                if (Janus.isArray(servers) && !callbacks["reconnect"]) {
                    serversIndex++;
                    if (serversIndex == servers.length) {
                        // We tried all the servers the user gave us and they all failed
                        callbacks.error("Error connecting to any of the provided Janus servers: Is the server down?");
                        return;
                    }
                    // Let's try the next server
                    server = null;
                    setTimeout(function() { createSession(callbacks); }, 200);
                    return;
                }
                if (errorThrown === "")
                    callbacks.error(textStatus + ": Is the server down?");
                else
                    callbacks.error(textStatus + ": " + errorThrown);
            }
        });
    }

    // Private method to destroy a session
    function destroySession(callbacks) {
        callbacks = callbacks || {};
        // FIXME This method triggers a success even when we fail
        callbacks.success = (typeof callbacks.success == "function") ? callbacks.success : Janus.noop;
        var asyncRequest = true;
        if (callbacks.asyncRequest !== undefined && callbacks.asyncRequest !== null)
            asyncRequest = (callbacks.asyncRequest === true);
        var notifyDestroyed = true;
        if (callbacks.notifyDestroyed !== undefined && callbacks.notifyDestroyed !== null)
            notifyDestroyed = (callbacks.notifyDestroyed === true);
        var cleanupHandles = false;
        if (callbacks.cleanupHandles !== undefined && callbacks.cleanupHandles !== null)
            cleanupHandles = (callbacks.cleanupHandles === true);
        Janus.log("Destroying session " + sessionId + " (async=" + asyncRequest + ")");
        if (sessionId === undefined || sessionId === null) {
            Janus.warn("No session to destroy");
            callbacks.success();
            if (notifyDestroyed)
                gatewayCallbacks.destroyed();
            return;
        }
        if (cleanupHandles) {
            for (var handleId in pluginHandles)
                destroyHandle(handleId, { noRequest: true });
        }
        if (!connected) {
            Janus.warn("Is the server down? (connected=false)");
            callbacks.success();
            return;
        }
        // No need to destroy all handles first, Janus will do that itself
        var request = { "janus": "destroy", "transaction": Janus.randomString(12) };
        if (token !== null && token !== undefined)
            request["token"] = token;
        if (apisecret !== null && apisecret !== undefined)
            request["apisecret"] = apisecret;
        if (websockets) {
            request["session_id"] = sessionId;

            var unbindWebSocket = function() {
                for (var eventName in wsHandlers) {
                    ws.removeEventListener(eventName, wsHandlers[eventName]);
                }
                ws.removeEventListener('message', onUnbindMessage);
                ws.removeEventListener('error', onUnbindError);
                if (wsKeepaliveTimeoutId) {
                    clearTimeout(wsKeepaliveTimeoutId);
                }
                ws.close();
            };

            var onUnbindMessage = function(event) {
                var data = JSON.parse(event.data);
                if (data.session_id == request.session_id && data.transaction == request.transaction) {
                    unbindWebSocket();
                    callbacks.success();
                    if (notifyDestroyed)
                        gatewayCallbacks.destroyed();
                }
            };
            var onUnbindError = function(event) {
                unbindWebSocket();
                callbacks.error("Failed to destroy the server: Is the server down?");
                if (notifyDestroyed)
                    gatewayCallbacks.destroyed();
            };

            ws.addEventListener('message', onUnbindMessage);
            ws.addEventListener('error', onUnbindError);

            ws.send(JSON.stringify(request));
            return;
        }
        Janus.httpAPICall(server + "/" + sessionId, {
            verb: 'POST',
            async: asyncRequest, // Sometimes we need false here, or destroying in onbeforeunload won't work
            withCredentials: withCredentials,
            body: request,
            success: function(json) {
                Janus.log("Destroyed session:");
                Janus.debug(json);
                sessionId = null;
                connected = false;
                if (json["janus"] !== "success") {
                    Janus.error("Ooops: " + json["error"].code + " " + json["error"].reason); // FIXME
                }
                callbacks.success();
                if (notifyDestroyed)
                    gatewayCallbacks.destroyed();
            },
            error: function(textStatus, errorThrown) {
                Janus.error(textStatus + ":", errorThrown); // FIXME
                // Reset everything anyway
                sessionId = null;
                connected = false;
                callbacks.success();
                if (notifyDestroyed)
                    gatewayCallbacks.destroyed();
            }
        });
    }

    // Private method to create a plugin handle
    function createHandle(callbacks) {
        callbacks = callbacks || {};
        callbacks.success = (typeof callbacks.success == "function") ? callbacks.success : Janus.noop;
        callbacks.error = (typeof callbacks.error == "function") ? callbacks.error : Janus.noop;
        callbacks.consentDialog = (typeof callbacks.consentDialog == "function") ? callbacks.consentDialog : Janus.noop;
        callbacks.iceState = (typeof callbacks.iceState == "function") ? callbacks.iceState : Janus.noop;
        callbacks.mediaState = (typeof callbacks.mediaState == "function") ? callbacks.mediaState : Janus.noop;
        callbacks.webrtcState = (typeof callbacks.webrtcState == "function") ? callbacks.webrtcState : Janus.noop;
        callbacks.slowLink = (typeof callbacks.slowLink == "function") ? callbacks.slowLink : Janus.noop;
        callbacks.onmessage = (typeof callbacks.onmessage == "function") ? callbacks.onmessage : Janus.noop;
        callbacks.onlocalstream = (typeof callbacks.onlocalstream == "function") ? callbacks.onlocalstream : Janus.noop;
        callbacks.onremotestream = (typeof callbacks.onremotestream == "function") ? callbacks.onremotestream : Janus.noop;
        callbacks.ondata = (typeof callbacks.ondata == "function") ? callbacks.ondata : Janus.noop;
        callbacks.ondataopen = (typeof callbacks.ondataopen == "function") ? callbacks.ondataopen : Janus.noop;
        callbacks.oncleanup = (typeof callbacks.oncleanup == "function") ? callbacks.oncleanup : Janus.noop;
        callbacks.ondetached = (typeof callbacks.ondetached == "function") ? callbacks.ondetached : Janus.noop;
        if (!connected) {
            Janus.warn("Is the server down? (connected=false)");
            callbacks.error("Is the server down? (connected=false)");
            return;
        }
        var plugin = callbacks.plugin;
        if (plugin === undefined || plugin === null) {
            Janus.error("Invalid plugin");
            callbacks.error("Invalid plugin");
            return;
        }
        var opaqueId = callbacks.opaqueId;
        var handleToken = callbacks.token ? callbacks.token : token;
        var transaction = Janus.randomString(12);
        var request = { "janus": "attach", "plugin": plugin, "opaque_id": opaqueId, "transaction": transaction };
        if (handleToken !== null && handleToken !== undefined)
            request["token"] = handleToken;
        if (apisecret !== null && apisecret !== undefined)
            request["apisecret"] = apisecret;
        if (websockets) {
            transactions[transaction] = function(json) {
                Janus.debug(json);
                if (json["janus"] !== "success") {
                    Janus.error("Ooops: " + json["error"].code + " " + json["error"].reason); // FIXME
                    callbacks.error("Ooops: " + json["error"].code + " " + json["error"].reason);
                    return;
                }
                var handleId = json.data["id"];
                Janus.log("Created handle: " + handleId);
                var pluginHandle = {
                    session: that,
                    plugin: plugin,
                    id: handleId,
                    token: handleToken,
                    detached: false,
                    webrtcStuff: {
                        started: false,
                        myStream: null,
                        streamExternal: false,
                        remoteStream: null,
                        mySdp: null,
                        mediaConstraints: null,
                        pc: null,
                        dataChannel: {},
                        dtmfSender: null,
                        trickle: true,
                        iceDone: false,
                        volume: {
                            value: null,
                            timer: null
                        },
                        bitrate: {
                            value: null,
                            bsnow: null,
                            bsbefore: null,
                            tsnow: null,
                            tsbefore: null,
                            timer: null
                        }
                    },
                    getId: function() { return handleId; },
                    getPlugin: function() { return plugin; },
                    getVolume: function() { return getVolume(handleId, true); },
                    getRemoteVolume: function() { return getVolume(handleId, true); },
                    getLocalVolume: function() { return getVolume(handleId, false); },
                    isAudioMuted: function() { return isMuted(handleId, false); },
                    muteAudio: function() { return mute(handleId, false, true); },
                    unmuteAudio: function() { return mute(handleId, false, false); },
                    isVideoMuted: function() { return isMuted(handleId, true); },
                    muteVideo: function() { return mute(handleId, true, true); },
                    unmuteVideo: function() { return mute(handleId, true, false); },
                    getBitrate: function() { return getBitrate(handleId); },
                    send: function(callbacks) { sendMessage(handleId, callbacks); },
                    data: function(callbacks) { sendData(handleId, callbacks); },
                    dtmf: function(callbacks) { sendDtmf(handleId, callbacks); },
                    consentDialog: callbacks.consentDialog,
                    iceState: callbacks.iceState,
                    mediaState: callbacks.mediaState,
                    webrtcState: callbacks.webrtcState,
                    slowLink: callbacks.slowLink,
                    onmessage: callbacks.onmessage,
                    createOffer: function(callbacks) { prepareWebrtc(handleId, true, callbacks); },
                    createAnswer: function(callbacks) { prepareWebrtc(handleId, false, callbacks); },
                    handleRemoteJsep: function(callbacks) { prepareWebrtcPeer(handleId, callbacks); },
                    onlocalstream: callbacks.onlocalstream,
                    onremotestream: callbacks.onremotestream,
                    ondata: callbacks.ondata,
                    ondataopen: callbacks.ondataopen,
                    oncleanup: callbacks.oncleanup,
                    ondetached: callbacks.ondetached,
                    hangup: function(sendRequest) { cleanupWebrtc(handleId, sendRequest === true); },
                    detach: function(callbacks) { destroyHandle(handleId, callbacks); }
                }
                pluginHandles[handleId] = pluginHandle;
                callbacks.success(pluginHandle);
            };
            request["session_id"] = sessionId;
            ws.send(JSON.stringify(request));
            return;
        }
        Janus.httpAPICall(server + "/" + sessionId, {
            verb: 'POST',
            withCredentials: withCredentials,
            body: request,
            success: function(json) {
                Janus.debug(json);
                if (json["janus"] !== "success") {
                    Janus.error("Ooops: " + json["error"].code + " " + json["error"].reason); // FIXME
                    callbacks.error("Ooops: " + json["error"].code + " " + json["error"].reason);
                    return;
                }
                var handleId = json.data["id"];
                Janus.log("Created handle: " + handleId);
                var pluginHandle = {
                    session: that,
                    plugin: plugin,
                    id: handleId,
                    token: handleToken,
                    detached: false,
                    webrtcStuff: {
                        started: false,
                        myStream: null,
                        streamExternal: false,
                        remoteStream: null,
                        mySdp: null,
                        mediaConstraints: null,
                        pc: null,
                        dataChannel: {},
                        dtmfSender: null,
                        trickle: true,
                        iceDone: false,
                        volume: {
                            value: null,
                            timer: null
                        },
                        bitrate: {
                            value: null,
                            bsnow: null,
                            bsbefore: null,
                            tsnow: null,
                            tsbefore: null,
                            timer: null
                        }
                    },
                    getId: function() { return handleId; },
                    getPlugin: function() { return plugin; },
                    getVolume: function() { return getVolume(handleId, true); },
                    getRemoteVolume: function() { return getVolume(handleId, true); },
                    getLocalVolume: function() { return getVolume(handleId, false); },
                    isAudioMuted: function() { return isMuted(handleId, false); },
                    muteAudio: function() { return mute(handleId, false, true); },
                    unmuteAudio: function() { return mute(handleId, false, false); },
                    isVideoMuted: function() { return isMuted(handleId, true); },
                    muteVideo: function() { return mute(handleId, true, true); },
                    unmuteVideo: function() { return mute(handleId, true, false); },
                    getBitrate: function() { return getBitrate(handleId); },
                    send: function(callbacks) { sendMessage(handleId, callbacks); },
                    data: function(callbacks) { sendData(handleId, callbacks); },
                    dtmf: function(callbacks) { sendDtmf(handleId, callbacks); },
                    consentDialog: callbacks.consentDialog,
                    iceState: callbacks.iceState,
                    mediaState: callbacks.mediaState,
                    webrtcState: callbacks.webrtcState,
                    slowLink: callbacks.slowLink,
                    onmessage: callbacks.onmessage,
                    createOffer: function(callbacks) { prepareWebrtc(handleId, true, callbacks); },
                    createAnswer: function(callbacks) { prepareWebrtc(handleId, false, callbacks); },
                    handleRemoteJsep: function(callbacks) { prepareWebrtcPeer(handleId, callbacks); },
                    onlocalstream: callbacks.onlocalstream,
                    onremotestream: callbacks.onremotestream,
                    ondata: callbacks.ondata,
                    ondataopen: callbacks.ondataopen,
                    oncleanup: callbacks.oncleanup,
                    ondetached: callbacks.ondetached,
                    hangup: function(sendRequest) { cleanupWebrtc(handleId, sendRequest === true); },
                    detach: function(callbacks) { destroyHandle(handleId, callbacks); }
                }
                pluginHandles[handleId] = pluginHandle;
                callbacks.success(pluginHandle);
            },
            error: function(textStatus, errorThrown) {
                Janus.error(textStatus + ":", errorThrown); // FIXME
            }
        });
    }

    // Private method to send a message
    function sendMessage(handleId, callbacks) {
        callbacks = callbacks || {};
        callbacks.success = (typeof callbacks.success == "function") ? callbacks.success : Janus.noop;
        callbacks.error = (typeof callbacks.error == "function") ? callbacks.error : Janus.noop;
        if (!connected) {
            Janus.warn("Is the server down? (connected=false)");
            callbacks.error("Is the server down? (connected=false)");
            return;
        }
        var pluginHandle = pluginHandles[handleId];
        if (pluginHandle === null || pluginHandle === undefined ||
            pluginHandle.webrtcStuff === null || pluginHandle.webrtcStuff === undefined) {
            Janus.warn("Invalid handle");
            callbacks.error("Invalid handle");
            return;
        }
        var message = callbacks.message;
        var jsep = callbacks.jsep;
        var transaction = Janus.randomString(12);
        var request = { "janus": "message", "body": message, "transaction": transaction };
        if (pluginHandle.token !== null && pluginHandle.token !== undefined)
            request["token"] = pluginHandle.token;
        if (apisecret !== null && apisecret !== undefined)
            request["apisecret"] = apisecret;
        if (jsep !== null && jsep !== undefined)
            request.jsep = jsep;
        Janus.debug("Sending message to plugin (handle=" + handleId + "):");
        Janus.debug(request);
        if (websockets) {
            request["session_id"] = sessionId;
            request["handle_id"] = handleId;
            transactions[transaction] = function(json) {
                Janus.debug("Message sent!");
                Janus.debug(json);
                if (json["janus"] === "success") {
                    // We got a success, must have been a synchronous transaction
                    var plugindata = json["plugindata"];
                    if (plugindata === undefined || plugindata === null) {
                        Janus.warn("Request succeeded, but missing plugindata...");
                        callbacks.success();
                        return;
                    }
                    Janus.log("Synchronous transaction successful (" + plugindata["plugin"] + ")");
                    var data = plugindata["data"];
                    Janus.debug(data);
                    callbacks.success(data);
                    return;
                } else if (json["janus"] !== "ack") {
                    // Not a success and not an ack, must be an error
                    if (json["error"] !== undefined && json["error"] !== null) {
                        Janus.error("Ooops: " + json["error"].code + " " + json["error"].reason); // FIXME
                        callbacks.error(json["error"].code + " " + json["error"].reason);
                    } else {
                        Janus.error("Unknown error"); // FIXME
                        callbacks.error("Unknown error");
                    }
                    return;
                }
                // If we got here, the plugin decided to handle the request asynchronously
                callbacks.success();
            };
            ws.send(JSON.stringify(request));
            return;
        }
        Janus.httpAPICall(server + "/" + sessionId + "/" + handleId, {
            verb: 'POST',
            withCredentials: withCredentials,
            body: request,
            success: function(json) {
                Janus.debug("Message sent!");
                Janus.debug(json);
                if (json["janus"] === "success") {
                    // We got a success, must have been a synchronous transaction
                    var plugindata = json["plugindata"];
                    if (plugindata === undefined || plugindata === null) {
                        Janus.warn("Request succeeded, but missing plugindata...");
                        callbacks.success();
                        return;
                    }
                    Janus.log("Synchronous transaction successful (" + plugindata["plugin"] + ")");
                    var data = plugindata["data"];
                    Janus.debug(data);
                    callbacks.success(data);
                    return;
                } else if (json["janus"] !== "ack") {
                    // Not a success and not an ack, must be an error
                    if (json["error"] !== undefined && json["error"] !== null) {
                        Janus.error("Ooops: " + json["error"].code + " " + json["error"].reason); // FIXME
                        callbacks.error(json["error"].code + " " + json["error"].reason);
                    } else {
                        Janus.error("Unknown error"); // FIXME
                        callbacks.error("Unknown error");
                    }
                    return;
                }
                // If we got here, the plugin decided to handle the request asynchronously
                callbacks.success();
            },
            error: function(textStatus, errorThrown) {
                Janus.error(textStatus + ":", errorThrown); // FIXME
                callbacks.error(textStatus + ": " + errorThrown);
            }
        });
    }

    // Private method to send a trickle candidate
    function sendTrickleCandidate(handleId, candidate) {
        if (!connected) {
            Janus.warn("Is the server down? (connected=false)");
            return;
        }
        var pluginHandle = pluginHandles[handleId];
        if (pluginHandle === null || pluginHandle === undefined ||
            pluginHandle.webrtcStuff === null || pluginHandle.webrtcStuff === undefined) {
            Janus.warn("Invalid handle");
            return;
        }
        var request = { "janus": "trickle", "candidate": candidate, "transaction": Janus.randomString(12) };
        if (pluginHandle.token !== null && pluginHandle.token !== undefined)
            request["token"] = pluginHandle.token;
        if (apisecret !== null && apisecret !== undefined)
            request["apisecret"] = apisecret;
        Janus.vdebug("Sending trickle candidate (handle=" + handleId + "):");
        Janus.vdebug(request);
        if (websockets) {
            request["session_id"] = sessionId;
            request["handle_id"] = handleId;
            ws.send(JSON.stringify(request));
            return;
        }
        Janus.httpAPICall(server + "/" + sessionId + "/" + handleId, {
            verb: 'POST',
            withCredentials: withCredentials,
            body: request,
            success: function(json) {
                Janus.vdebug("Candidate sent!");
                Janus.vdebug(json);
                if (json["janus"] !== "ack") {
                    Janus.error("Ooops: " + json["error"].code + " " + json["error"].reason); // FIXME
                    return;
                }
            },
            error: function(textStatus, errorThrown) {
                Janus.error(textStatus + ":", errorThrown); // FIXME
            }
        });
    }

    // Private method to create a data channel
    function createDataChannel(handleId, dclabel, incoming, pendingText) {
        var pluginHandle = pluginHandles[handleId];
        if (pluginHandle === null || pluginHandle === undefined ||
            pluginHandle.webrtcStuff === null || pluginHandle.webrtcStuff === undefined) {
            Janus.warn("Invalid handle");
            return;
        }
        var config = pluginHandle.webrtcStuff;
        var onDataChannelMessage = function(event) {
            Janus.log('Received message on data channel:', event);
            var label = event.target.label;
            pluginHandle.ondata(event.data, label);
        }
        var onDataChannelStateChange = function(event) {
            Janus.log('Received state change on data channel:', event);
            var label = event.target.label;
            var dcState = config.dataChannel[label] ? config.dataChannel[label].readyState : "null";
            Janus.log('State change on <' + label + '> data channel: ' + dcState);
            if (dcState === 'open') {
                // Any pending messages to send?
                if (config.dataChannel[label].pending && config.dataChannel[label].pending.length > 0) {
                    Janus.log("Sending pending messages on <" + label + ">:", config.dataChannel[label].pending.length);
                    for (var i in config.dataChannel[label].pending) {
                        var text = config.dataChannel[label].pending[i];
                        Janus.log("Sending string on data channel <" + label + ">: " + text);
                        config.dataChannel[label].send(text);
                    }
                    config.dataChannel[label].pending = [];
                }
                // Notify the open data channel
                pluginHandle.ondataopen(label);
            }
        }
        var onDataChannelError = function(error) {
            Janus.error('Got error on data channel:', error);
            // TODO
        }
        if (!incoming) {
            // FIXME Add options (ordered, maxRetransmits, etc.)
            config.dataChannel[dclabel] = config.pc.createDataChannel(dclabel, { ordered: false });
        } else {
            // The channel was created by Janus
            config.dataChannel[dclabel] = incoming;
        }
        config.dataChannel[dclabel].onmessage = onDataChannelMessage;
        config.dataChannel[dclabel].onopen = onDataChannelStateChange;
        config.dataChannel[dclabel].onclose = onDataChannelStateChange;
        config.dataChannel[dclabel].onerror = onDataChannelError;
        config.dataChannel[dclabel].pending = [];
        if (pendingText)
            config.dataChannel[dclabel].pending.push(pendingText);
    }

    // Private method to send a data channel message
    function sendData(handleId, callbacks) {
        callbacks = callbacks || {};
        callbacks.success = (typeof callbacks.success == "function") ? callbacks.success : Janus.noop;
        callbacks.error = (typeof callbacks.error == "function") ? callbacks.error : Janus.noop;
        var pluginHandle = pluginHandles[handleId];
        if (pluginHandle === null || pluginHandle === undefined ||
            pluginHandle.webrtcStuff === null || pluginHandle.webrtcStuff === undefined) {
            Janus.warn("Invalid handle");
            callbacks.error("Invalid handle");
            return;
        }
        var config = pluginHandle.webrtcStuff;
        var text = callbacks.text;
        if (text === null || text === undefined) {
            Janus.warn("Invalid text");
            callbacks.error("Invalid text");
            return;
        }
        var label = callbacks.label ? callbacks.label : Janus.dataChanDefaultLabel;
        if (!config.dataChannel[label]) {
            // Create new data channel and wait for it to open
            createDataChannel(handleId, label, false, text);
            callbacks.success();
            return;
        }
        if (config.dataChannel[label].readyState !== "open") {
            config.dataChannel[label].pending.push(text);
            callbacks.success();
            return;
        }
        Janus.log("Sending string on data channel <" + label + ">: " + text);
        config.dataChannel[label].send(text);
        callbacks.success();
    }

    // Private method to send a DTMF tone
    function sendDtmf(handleId, callbacks) {
        callbacks = callbacks || {};
        callbacks.success = (typeof callbacks.success == "function") ? callbacks.success : Janus.noop;
        callbacks.error = (typeof callbacks.error == "function") ? callbacks.error : Janus.noop;
        var pluginHandle = pluginHandles[handleId];
        if (pluginHandle === null || pluginHandle === undefined ||
            pluginHandle.webrtcStuff === null || pluginHandle.webrtcStuff === undefined) {
            Janus.warn("Invalid handle");
            callbacks.error("Invalid handle");
            return;
        }
        var config = pluginHandle.webrtcStuff;
        if (config.dtmfSender === null || config.dtmfSender === undefined) {
            // Create the DTMF sender the proper way, if possible
            if (config.pc !== undefined && config.pc !== null) {
                var senders = config.pc.getSenders();
                var audioSender = senders.find(function(sender) {
                    return sender.track && sender.track.kind === 'audio';
                });
                if (!audioSender) {
                    Janus.warn("Invalid DTMF configuration (no audio track)");
                    callbacks.error("Invalid DTMF configuration (no audio track)");
                    return;
                }
                config.dtmfSender = audioSender.dtmf;
                if (config.dtmfSender) {
                    Janus.log("Created DTMF Sender");
                    config.dtmfSender.ontonechange = function(tone) { Janus.debug("Sent DTMF tone: " + tone.tone); };
                }
            }
            if (config.dtmfSender === null || config.dtmfSender === undefined) {
                Janus.warn("Invalid DTMF configuration");
                callbacks.error("Invalid DTMF configuration");
                return;
            }
        }
        var dtmf = callbacks.dtmf;
        if (dtmf === null || dtmf === undefined) {
            Janus.warn("Invalid DTMF parameters");
            callbacks.error("Invalid DTMF parameters");
            return;
        }
        var tones = dtmf.tones;
        if (tones === null || tones === undefined) {
            Janus.warn("Invalid DTMF string");
            callbacks.error("Invalid DTMF string");
            return;
        }
        var duration = dtmf.duration;
        if (duration === null || duration === undefined)
            duration = 500; // We choose 500ms as the default duration for a tone
        var gap = dtmf.gap;
        if (gap === null || gap === undefined)
            gap = 50; // We choose 50ms as the default gap between tones
        Janus.debug("Sending DTMF string " + tones + " (duration " + duration + "ms, gap " + gap + "ms)");
        config.dtmfSender.insertDTMF(tones, duration, gap);
        callbacks.success();
    }

    // Private method to destroy a plugin handle
    function destroyHandle(handleId, callbacks) {
        callbacks = callbacks || {};
        callbacks.success = (typeof callbacks.success == "function") ? callbacks.success : Janus.noop;
        callbacks.error = (typeof callbacks.error == "function") ? callbacks.error : Janus.noop;
        var asyncRequest = true;
        if (callbacks.asyncRequest !== undefined && callbacks.asyncRequest !== null)
            asyncRequest = (callbacks.asyncRequest === true);
        var noRequest = true;
        if (callbacks.noRequest !== undefined && callbacks.noRequest !== null)
            noRequest = (callbacks.noRequest === true);
        Janus.log("Destroying handle " + handleId + " (async=" + asyncRequest + ")");
        cleanupWebrtc(handleId);
        var pluginHandle = pluginHandles[handleId];
        if (pluginHandle === null || pluginHandle === undefined || pluginHandle.detached) {
            // Plugin was already detached by Janus, calling detach again will return a handle not found error, so just exit here
            delete pluginHandles[handleId];
            callbacks.success();
            return;
        }
        if (noRequest) {
            // We're only removing the handle locally
            delete pluginHandles[handleId];
            callbacks.success();
            return;
        }
        if (!connected) {
            Janus.warn("Is the server down? (connected=false)");
            callbacks.error("Is the server down? (connected=false)");
            return;
        }
        var request = { "janus": "detach", "transaction": Janus.randomString(12) };
        if (pluginHandle.token !== null && pluginHandle.token !== undefined)
            request["token"] = pluginHandle.token;
        if (apisecret !== null && apisecret !== undefined)
            request["apisecret"] = apisecret;
        if (websockets) {
            request["session_id"] = sessionId;
            request["handle_id"] = handleId;
            ws.send(JSON.stringify(request));
            delete pluginHandles[handleId];
            callbacks.success();
            return;
        }
        Janus.httpAPICall(server + "/" + sessionId + "/" + handleId, {
            verb: 'POST',
            async: asyncRequest, // Sometimes we need false here, or destroying in onbeforeunload won't work
            withCredentials: withCredentials,
            body: request,
            success: function(json) {
                Janus.log("Destroyed handle:");
                Janus.debug(json);
                if (json["janus"] !== "success") {
                    Janus.error("Ooops: " + json["error"].code + " " + json["error"].reason); // FIXME
                }
                delete pluginHandles[handleId];
                callbacks.success();
            },
            error: function(textStatus, errorThrown) {
                Janus.error(textStatus + ":", errorThrown); // FIXME
                // We cleanup anyway
                delete pluginHandles[handleId];
                callbacks.success();
            }
        });
    }

    // WebRTC stuff
    function streamsDone(handleId, jsep, media, callbacks, stream) {
        var pluginHandle = pluginHandles[handleId];
        if (pluginHandle === null || pluginHandle === undefined ||
            pluginHandle.webrtcStuff === null || pluginHandle.webrtcStuff === undefined) {
            Janus.warn("Invalid handle");
            callbacks.error("Invalid handle");
            return;
        }
        var config = pluginHandle.webrtcStuff;
        Janus.debug("streamsDone:", stream);
        if (stream) {
            Janus.debug("  -- Audio tracks:", stream.getAudioTracks());
            Janus.debug("  -- Video tracks:", stream.getVideoTracks());
        }
        // We're now capturing the new stream: check if we're updating or if it's a new thing
        var addTracks = false;
        if (!config.myStream || !media.update || config.streamExternal) {
            config.myStream = stream;
            addTracks = true;
        } else {
            // We only need to update the existing stream
            if (((!media.update && isAudioSendEnabled(media)) || (media.update && (media.addAudio || media.replaceAudio))) &&
                stream.getAudioTracks() && stream.getAudioTracks().length) {
                config.myStream.addTrack(stream.getAudioTracks()[0]);
                if (Janus.unifiedPlan) {
                    // Use Transceivers
                    Janus.log((media.replaceAudio ? "Replacing" : "Adding") + " audio track:", stream.getAudioTracks()[0]);
                    var audioTransceiver = null;
                    var transceivers = config.pc.getTransceivers();
                    if (transceivers && transceivers.length > 0) {
                        for (var i in transceivers) {
                            var t = transceivers[i];
                            if ((t.sender && t.sender.track && t.sender.track.kind === "audio") ||
                                (t.receiver && t.receiver.track && t.receiver.track.kind === "audio")) {
                                audioTransceiver = t;
                                break;
                            }
                        }
                    }
                    if (audioTransceiver && audioTransceiver.sender) {
                        audioTransceiver.sender.replaceTrack(stream.getAudioTracks()[0]);
                    } else {
                        config.pc.addTrack(stream.getAudioTracks()[0], stream);
                    }
                } else {
                    Janus.log((media.replaceAudio ? "Replacing" : "Adding") + " audio track:", stream.getAudioTracks()[0]);
                    config.pc.addTrack(stream.getAudioTracks()[0], stream);
                }
            }
            if (((!media.update && isVideoSendEnabled(media)) || (media.update && (media.addVideo || media.replaceVideo))) &&
                stream.getVideoTracks() && stream.getVideoTracks().length) {
                config.myStream.addTrack(stream.getVideoTracks()[0]);
                if (Janus.unifiedPlan) {
                    // Use Transceivers
                    Janus.log((media.replaceVideo ? "Replacing" : "Adding") + " video track:", stream.getVideoTracks()[0]);
                    var videoTransceiver = null;
                    var transceivers = config.pc.getTransceivers();
                    if (transceivers && transceivers.length > 0) {
                        for (var i in transceivers) {
                            var t = transceivers[i];
                            if ((t.sender && t.sender.track && t.sender.track.kind === "video") ||
                                (t.receiver && t.receiver.track && t.receiver.track.kind === "video")) {
                                videoTransceiver = t;
                                break;
                            }
                        }
                    }
                    if (videoTransceiver && videoTransceiver.sender) {
                        videoTransceiver.sender.replaceTrack(stream.getVideoTracks()[0]);
                    } else {
                        config.pc.addTrack(stream.getVideoTracks()[0], stream);
                    }
                } else {
                    Janus.log((media.replaceVideo ? "Replacing" : "Adding") + " video track:", stream.getVideoTracks()[0]);
                    config.pc.addTrack(stream.getVideoTracks()[0], stream);
                }
            }
        }
        // If we still need to create a PeerConnection, let's do that
        // iceTransportPolicy="relay";
        if (!config.pc) {
            var pc_config = { "iceServers": iceServers, "iceTransportPolicy": iceTransportPolicy, "bundlePolicy": bundlePolicy };
            if (Janus.webRTCAdapter.browserDetails.browser === "chrome") {
                // For Chrome versions before 72, we force a plan-b semantic, and unified-plan otherwise
                pc_config["sdpSemantics"] = (Janus.webRTCAdapter.browserDetails.version < 72) ? "plan-b" : "unified-plan";
            }
            var pc_constraints = {
                "optional": [{ "DtlsSrtpKeyAgreement": true }]
            };
            if (ipv6Support === true) {
                pc_constraints.optional.push({ "googIPv6": true });
            }
            // Any custom constraint to add?
            if (callbacks.rtcConstraints && typeof callbacks.rtcConstraints === 'object') {
                Janus.debug("Adding custom PeerConnection constraints:", callbacks.rtcConstraints);
                for (var i in callbacks.rtcConstraints) {
                    pc_constraints.optional.push(callbacks.rtcConstraints[i]);
                }
            }
            if (Janus.webRTCAdapter.browserDetails.browser === "edge") {
                // This is Edge, enable BUNDLE explicitly
                pc_config.bundlePolicy = "max-bundle";
            }
            Janus.log("Creating PeerConnection");
            Janus.debug(pc_constraints);
            config.pc = new RTCPeerConnection(pc_config, pc_constraints);
            Janus.debug(config.pc);
            if (config.pc.getStats) { // FIXME
                config.volume = {};
                config.bitrate.value = "0 kbits/sec";
            }
            Janus.log("Preparing local SDP and gathering candidates (trickle=" + config.trickle + ")");
            config.pc.oniceconnectionstatechange = function(e) {
                if (config.pc)
                    pluginHandle.iceState(config.pc.iceConnectionState);
            };
            config.pc.onicecandidate = function(event) {
                if (event.candidate == null ||
                    (Janus.webRTCAdapter.browserDetails.browser === 'edge' && event.candidate.candidate.indexOf('endOfCandidates') > 0)) {
                    Janus.log("End of candidates.");
                    config.iceDone = true;
                    if (config.trickle === true) {
                        // Notify end of candidates
                        sendTrickleCandidate(handleId, { "completed": true });
                    } else {
                        // No trickle, time to send the complete SDP (including all candidates)
                        sendSDP(handleId, callbacks);
                    }
                } else {
                    // JSON.stringify doesn't work on some WebRTC objects anymore
                    // See https://code.google.com/p/chromium/issues/detail?id=467366
                    var candidate = {
                        "candidate": event.candidate.candidate,
                        "sdpMid": event.candidate.sdpMid,
                        "sdpMLineIndex": event.candidate.sdpMLineIndex
                    };
                    if (config.trickle === true) {
                        // Send candidate
                        sendTrickleCandidate(handleId, candidate);
                    }
                }
            };
            config.pc.ontrack = function(event) {
                Janus.log("Handling Remote Track");
                Janus.debug(event);
                if (!event.streams)
                    return;
                config.remoteStream = event.streams[0];
                pluginHandle.onremotestream(config.remoteStream);
                if (event.track.onended)
                    return;
                Janus.log("Adding onended callback to track:", event.track);
                event.track.onended = function(ev) {
                    Janus.log("Remote track muted/removed:", ev);
                    if (config.remoteStream) {
                        config.remoteStream.removeTrack(ev.target);
                        pluginHandle.onremotestream(config.remoteStream);
                    }
                };
                event.track.onmute = event.track.onended;
                event.track.onunmute = function(ev) {
                    Janus.log("Remote track flowing again:", ev);
                    try {
                        config.remoteStream.addTrack(ev.target);
                        pluginHandle.onremotestream(config.remoteStream);
                    } catch (e) {
                        Janus.error(e);
                    };
                };
            };
        }
        if (addTracks && stream !== null && stream !== undefined) {
            Janus.log('Adding local stream');
            var simulcast2 = callbacks.simulcast2 === true ? true : false;
            stream.getTracks().forEach(function(track) {
                Janus.log('Adding local track:', track);
                if (!simulcast2) {
                    config.pc.addTrack(track, stream);
                    window.testWebRTC = config;
                } else {
                    if (track.kind === "audio") {
                        config.pc.addTrack(track, stream);
                    } else {
                        Janus.log('Enabling rid-based simulcasting:', track);
                        const maxBitrates = getMaxBitrates(callbacks.simulcastMaxBitrates);
                        Janus.log('sap_ss_MaxBitrate', maxBitrates);
                        config.pc.addTransceiver(track, {
                            direction: "sendrecv",
                            streams: [stream],
                            sendEncodings: [
                                { rid: "h", active: true, maxBitrate: maxBitrates.high },
                                { rid: "m", active: true, maxBitrate: maxBitrates.medium, scaleResolutionDownBy: 2 },
                                { rid: "l", active: true, maxBitrate: maxBitrates.low, scaleResolutionDownBy: 4 }
                            ]
                        });
                    }
                }
            });
        }
        // Any data channel to create?
        if (isDataEnabled(media) && !config.dataChannel[Janus.dataChanDefaultLabel]) {
            Janus.log("Creating data channel");
            createDataChannel(handleId, Janus.dataChanDefaultLabel, false);
            config.pc.ondatachannel = function(event) {
                Janus.log("Data channel created by Janus:", event);
                createDataChannel(handleId, event.channel.label, event.channel);
            };
        }
        // If there's a new local stream, let's notify the application
        if (config.myStream)
            pluginHandle.onlocalstream(config.myStream);
        // Create offer/answer now
        if (jsep === null || jsep === undefined) {
            createOffer(handleId, media, callbacks);
        } else {
            config.pc.setRemoteDescription(jsep)
                .then(function() {
                    Janus.log("Remote description accepted!");
                    config.remoteSdp = jsep.sdp;
                    // Any trickle candidate we cached?
                    if (config.candidates && config.candidates.length > 0) {
                        for (var i = 0; i < config.candidates.length; i++) {
                            var candidate = config.candidates[i];
                            Janus.debug("Adding remote candidate:", candidate);
                            if (!candidate || candidate.completed === true) {
                                // end-of-candidates
                                config.pc.addIceCandidate(Janus.endOfCandidates);
                            } else {
                                // New candidate
                                config.pc.addIceCandidate(candidate);
                            }
                        }
                        config.candidates = [];
                    }
                    // Create the answer now
                    createAnswer(handleId, media, callbacks);
                }, callbacks.error);
        }
    }

    function prepareWebrtc(handleId, offer, callbacks) {
        callbacks = callbacks || {};
        callbacks.success = (typeof callbacks.success == "function") ? callbacks.success : Janus.noop;
        callbacks.error = (typeof callbacks.error == "function") ? callbacks.error : webrtcError;
        var jsep = callbacks.jsep;
        if (offer && jsep) {
            Janus.error("Provided a JSEP to a createOffer");
            callbacks.error("Provided a JSEP to a createOffer");
            return;
        } else if (!offer && (!jsep || !jsep.type || !jsep.sdp)) {
            Janus.error("A valid JSEP is required for createAnswer");
            callbacks.error("A valid JSEP is required for createAnswer");
            return;
        }
        callbacks.media = callbacks.media || { audio: true, video: true };
        var media = callbacks.media;
        var pluginHandle = pluginHandles[handleId];
        if (pluginHandle === null || pluginHandle === undefined ||
            pluginHandle.webrtcStuff === null || pluginHandle.webrtcStuff === undefined) {
            Janus.warn("Invalid handle");
            callbacks.error("Invalid handle");
            return;
        }
        var config = pluginHandle.webrtcStuff;
        config.trickle = isTrickleEnabled(callbacks.trickle);
        // Are we updating a session?
        if (config.pc === undefined || config.pc === null) {
            // Nope, new PeerConnection
            media.update = false;
            media.keepAudio = false;
            media.keepVideo = false;
        } else if (config.pc !== undefined && config.pc !== null) {
            Janus.log("Updating existing media session");
            media.update = true;
            // Check if there's anything to add/remove/replace, or if we
            // can go directly to preparing the new SDP offer or answer
            if (callbacks.stream !== null && callbacks.stream !== undefined) {
                // External stream: is this the same as the one we were using before?
                if (callbacks.stream !== config.myStream) {
                    Janus.log("Renegotiation involves a new external stream");
                }
            } else {
                // Check if there are changes on audio
                if (media.addAudio) {
                    media.keepAudio = false;
                    media.replaceAudio = false;
                    media.removeAudio = false;
                    media.audioSend = true;
                    if (config.myStream && config.myStream.getAudioTracks() && config.myStream.getAudioTracks().length) {
                        Janus.error("Can't add audio stream, there already is one");
                        callbacks.error("Can't add audio stream, there already is one");
                        return;
                    }
                } else if (media.removeAudio) {
                    media.keepAudio = false;
                    media.replaceAudio = false;
                    media.addAudio = false;
                    media.audioSend = false;
                } else if (media.replaceAudio) {
                    media.keepAudio = false;
                    media.addAudio = false;
                    media.removeAudio = false;
                    media.audioSend = true;
                }
                if (config.myStream === null || config.myStream === undefined) {
                    // No media stream: if we were asked to replace, it's actually an "add"
                    if (media.replaceAudio) {
                        media.keepAudio = false;
                        media.replaceAudio = false;
                        media.addAudio = true;
                        media.audioSend = true;
                    }
                    if (isAudioSendEnabled(media)) {
                        media.keepAudio = false;
                        media.addAudio = true;
                    }
                } else {
                    if (config.myStream.getAudioTracks() === null ||
                        config.myStream.getAudioTracks() === undefined ||
                        config.myStream.getAudioTracks().length === 0) {
                        // No audio track: if we were asked to replace, it's actually an "add"
                        if (media.replaceAudio) {
                            media.keepAudio = false;
                            media.replaceAudio = false;
                            media.addAudio = true;
                            media.audioSend = true;
                        }
                        if (isAudioSendEnabled(media)) {
                            media.keepVideo = false;
                            media.addAudio = true;
                        }
                    } else {
                        // We have an audio track: should we keep it as it is?
                        if (isAudioSendEnabled(media) &&
                            !media.removeAudio && !media.replaceAudio) {
                            media.keepAudio = true;
                        }
                    }
                }
                // Check if there are changes on video
                if (media.addVideo) {
                    media.keepVideo = false;
                    media.replaceVideo = false;
                    media.removeVideo = false;
                    media.videoSend = true;
                    if (config.myStream && config.myStream.getVideoTracks() && config.myStream.getVideoTracks().length) {
                        Janus.error("Can't add video stream, there already is one");
                        callbacks.error("Can't add video stream, there already is one");
                        return;
                    }
                } else if (media.removeVideo) {
                    media.keepVideo = false;
                    media.replaceVideo = false;
                    media.addVideo = false;
                    media.videoSend = false;
                } else if (media.replaceVideo) {
                    media.keepVideo = false;
                    media.addVideo = false;
                    media.removeVideo = false;
                    media.videoSend = true;
                }
                if (config.myStream === null || config.myStream === undefined) {
                    // No media stream: if we were asked to replace, it's actually an "add"
                    if (media.replaceVideo) {
                        media.keepVideo = false;
                        media.replaceVideo = false;
                        media.addVideo = true;
                        media.videoSend = true;
                    }
                    if (isVideoSendEnabled(media)) {
                        media.keepVideo = false;
                        media.addVideo = true;
                    }
                } else {
                    if (config.myStream.getVideoTracks() === null ||
                        config.myStream.getVideoTracks() === undefined ||
                        config.myStream.getVideoTracks().length === 0) {
                        // No video track: if we were asked to replace, it's actually an "add"
                        if (media.replaceVideo) {
                            media.keepVideo = false;
                            media.replaceVideo = false;
                            media.addVideo = true;
                            media.videoSend = true;
                        }
                        if (isVideoSendEnabled(media)) {
                            media.keepVideo = false;
                            media.addVideo = true;
                        }
                    } else {
                        // We have a video track: should we keep it as it is?
                        if (isVideoSendEnabled(media) &&
                            !media.removeVideo && !media.replaceVideo) {
                            media.keepVideo = true;
                        }
                    }
                }
                // Data channels can only be added
                if (media.addData)
                    media.data = true;
            }
            // If we're updating and keeping all tracks, let's skip the getUserMedia part
            if ((isAudioSendEnabled(media) && media.keepAudio) &&
                (isVideoSendEnabled(media) && media.keepVideo)) {
                pluginHandle.consentDialog(false);
                streamsDone(handleId, jsep, media, callbacks, config.myStream);
                return;
            }
        }
        // If we're updating, check if we need to remove/replace one of the tracks
        if (media.update && !config.streamExternal) {
            if (media.removeAudio || media.replaceAudio) {
                if (config.myStream && config.myStream.getAudioTracks() && config.myStream.getAudioTracks().length) {
                    var s = config.myStream.getAudioTracks()[0];
                    Janus.log("Removing audio track:", s);
                    config.myStream.removeTrack(s);
                    try {
                        s.stop();
                    } catch (e) {};
                }
                if (config.pc.getSenders() && config.pc.getSenders().length) {
                    var ra = true;
                    if (media.replaceAudio && Janus.unifiedPlan) {
                        // We can use replaceTrack
                        ra = false;
                    }
                    if (ra) {
                        for (var index in config.pc.getSenders()) {
                            var s = config.pc.getSenders()[index];
                            if (s && s.track && s.track.kind === "audio") {
                                Janus.log("Removing audio sender:", s);
                                config.pc.removeTrack(s);
                            }
                        }
                    }
                }
            }
            if (media.removeVideo || media.replaceVideo) {
                if (config.myStream && config.myStream.getVideoTracks() && config.myStream.getVideoTracks().length) {
                    var s = config.myStream.getVideoTracks()[0];
                    Janus.log("Removing video track:", s);
                    config.myStream.removeTrack(s);
                    try {
                        s.stop();
                    } catch (e) {};
                }
                if (config.pc.getSenders() && config.pc.getSenders().length) {
                    var rv = true;
                    if (media.replaceVideo && Janus.unifiedPlan) {
                        // We can use replaceTrack
                        rv = false;
                    }
                    if (rv) {
                        for (var index in config.pc.getSenders()) {
                            var s = config.pc.getSenders()[index];
                            if (s && s.track && s.track.kind === "video") {
                                Janus.log("Removing video sender:", s);
                                config.pc.removeTrack(s);
                            }
                        }
                    }
                }
            }
        }
        // Was a MediaStream object passed, or do we need to take care of that?
        if (callbacks.stream !== null && callbacks.stream !== undefined) {
            var stream = callbacks.stream;
            Janus.log("MediaStream provided by the application");
            Janus.debug(stream);
            // If this is an update, let's check if we need to release the previous stream
            if (media.update) {
                if (config.myStream && config.myStream !== callbacks.stream && !config.streamExternal) {
                    // We're replacing a stream we captured ourselves with an external one
                    try {
                        // Try a MediaStreamTrack.stop() for each track
                        var tracks = config.myStream.getTracks();
                        for (var i in tracks) {
                            var mst = tracks[i];
                            Janus.log(mst);
                            if (mst !== null && mst !== undefined)
                                mst.stop();
                        }
                    } catch (e) {
                        // Do nothing if this fails
                    }
                    config.myStream = null;
                }
            }
            // Skip the getUserMedia part
            config.streamExternal = true;
            pluginHandle.consentDialog(false);
            streamsDone(handleId, jsep, media, callbacks, stream);
            return;
        }
        if (isAudioSendEnabled(media) || isVideoSendEnabled(media)) {
            if (!Janus.isGetUserMediaAvailable()) {
                callbacks.error("getUserMedia not available");
                return;
            }
            var constraints = { mandatory: {}, optional: [] };
            pluginHandle.consentDialog(true);
            var audioSupport = isAudioSendEnabled(media);
            if (audioSupport === true && media != undefined && media != null) {
                if (typeof media.audio === 'object') {
                    audioSupport = media.audio;
                }
            }
            var videoSupport = isVideoSendEnabled(media);
            if (videoSupport === true && media != undefined && media != null) {
                var simulcast = callbacks.simulcast === true ? true : false;
                var simulcast2 = callbacks.simulcast2 === true ? true : false;
                if ((simulcast || simulcast2) && !jsep && (media.video === undefined || media.video === false))
                    media.video = "hires";
                if (media.video && media.video != 'screen' && media.video != 'window') {
                    if (typeof media.video === 'object') {
                        videoSupport = media.video;
                    } else {
                        var width = 0;
                        var height = 0,
                            maxHeight = 0;
                        if (media.video === 'lowres') {
                            // Small resolution, 4:3
                            height = 240;
                            maxHeight = 240;
                            width = 320;
                        } else if (media.video === 'lowres-16:9') {
                            // Small resolution, 16:9
                            height = 180;
                            maxHeight = 180;
                            width = 320;
                        } else if (media.video === 'hires' || media.video === 'hires-16:9' || media.video === 'hdres') {
                            // High(HD) resolution is only 16:9
                            height = 720;
                            maxHeight = 720;
                            width = 1280;
                        } else if (media.video === 'fhdres') {
                            // Full HD resolution is only 16:9
                            height = 1080;
                            maxHeight = 1080;
                            width = 1920;
                        } else if (media.video === '4kres') {
                            // 4K resolution is only 16:9
                            height = 2160;
                            maxHeight = 2160;
                            width = 3840;
                        } else if (media.video === 'stdres') {
                            // Normal resolution, 4:3
                            height = 480;
                            maxHeight = 480;
                            width = 640;
                        } else if (media.video === 'stdres-16:9') {
                            // Normal resolution, 16:9
                            height = 360;
                            maxHeight = 360;
                            width = 640;
                        } else {
                            Janus.log("Default video setting is stdres 4:3");
                            height = 480;
                            maxHeight = 480;
                            width = 640;
                        }
                        Janus.log("Adding media constraint:", media.video);
                        videoSupport = {
                            'height': { 'ideal': height },
                            'width': { 'ideal': width }
                        };
                        Janus.log("Adding video constraint:", videoSupport);
                    }
                } else if (media.video === 'screen' || media.video === 'window') {
                    if (!media.screenshareFrameRate) {
                        media.screenshareFrameRate = 3;
                    }
                    if (navigator.mediaDevices && navigator.mediaDevices.getDisplayMedia) {
                        // The new experimental getDisplayMedia API is available, let's use that
                        // https://groups.google.com/forum/#!topic/discuss-webrtc/Uf0SrR4uxzk
                        // https://webrtchacks.com/chrome-screensharing-getdisplaymedia/
                        var vidConstraints = media.screenRecordConstraints ? media.screenRecordConstraints : true;
                        navigator.mediaDevices.getDisplayMedia({ video: vidConstraints, audio: media.captureDesktopAudio })
                            .then(function(stream) {
                                pluginHandle.consentDialog(false);
                                if (isAudioSendEnabled(media) && !media.keepAudio) {
                                    navigator.mediaDevices.getUserMedia({ audio: true, video: false })
                                        .then(function(audioStream) {
                                            stream.addTrack(audioStream.getAudioTracks()[0]);
                                            streamsDone(handleId, jsep, media, callbacks, stream);
                                        })
                                } else {
                                    streamsDone(handleId, jsep, media, callbacks, stream);
                                }
                            }, function(error) {
                                pluginHandle.consentDialog(false);
                                callbacks.error(error);
                            });
                        return;
                    }
                    // We're going to try and use the extension for Chrome 34+, the old approach
                    // for older versions of Chrome, or the experimental support in Firefox 33+
                    function callbackUserMedia(error, stream) {
                        pluginHandle.consentDialog(false);
                        if (error) {
                            callbacks.error(error);
                        } else {
                            streamsDone(handleId, jsep, media, callbacks, stream);
                        }
                    };

                    function getScreenMedia(constraints, gsmCallback, useAudio) {
                        Janus.log("Adding media constraint (screen capture)");
                        Janus.debug(constraints);
                        navigator.mediaDevices.getUserMedia(constraints)
                            .then(function(stream) {
                                if (useAudio) {
                                    navigator.mediaDevices.getUserMedia({ audio: true, video: false })
                                        .then(function(audioStream) {
                                            stream.addTrack(audioStream.getAudioTracks()[0]);
                                            gsmCallback(null, stream);
                                        })
                                } else {
                                    gsmCallback(null, stream);
                                }
                            })
                            .catch(function(error) {
                                pluginHandle.consentDialog(false);
                                gsmCallback(error);
                            });
                    };
                    if (Janus.webRTCAdapter.browserDetails.browser === 'chrome') {
                        var chromever = Janus.webRTCAdapter.browserDetails.version;
                        var maxver = 33;
                        if (window.navigator.userAgent.match('Linux'))
                            maxver = 35; // "known" crash in chrome 34 and 35 on linux
                        if (chromever >= 26 && chromever <= maxver) {
                            // Chrome 26->33 requires some awkward chrome://flags manipulation
                            constraints = {
                                video: {
                                    mandatory: {
                                        googLeakyBucket: true,
                                        maxWidth: window.screen.width,
                                        maxHeight: window.screen.height,
                                        minFrameRate: media.screenshareFrameRate,
                                        maxFrameRate: media.screenshareFrameRate,
                                        chromeMediaSource: 'screen'
                                    }
                                },
                                audio: isAudioSendEnabled(media) && !media.keepAudio
                            };
                            getScreenMedia(constraints, callbackUserMedia);
                        } else {
                            // Chrome 34+ requires an extension
                            Janus.extension.getScreen(function(error, sourceId) {
                                if (error) {
                                    pluginHandle.consentDialog(false);
                                    return callbacks.error(error);
                                }
                                constraints = {
                                    audio: false,
                                    video: {
                                        mandatory: {
                                            chromeMediaSource: 'desktop',
                                            maxWidth: window.screen.width,
                                            maxHeight: window.screen.height,
                                            minFrameRate: media.screenshareFrameRate,
                                            maxFrameRate: media.screenshareFrameRate,
                                        },
                                        optional: [
                                            { googLeakyBucket: true },
                                            { googTemporalLayeredScreencast: true }
                                        ]
                                    }
                                };
                                constraints.video.mandatory.chromeMediaSourceId = sourceId;
                                getScreenMedia(constraints, callbackUserMedia,
                                    isAudioSendEnabled(media) && !media.keepAudio);
                            });
                        }
                    } else if (Janus.webRTCAdapter.browserDetails.browser === 'firefox') {
                        if (Janus.webRTCAdapter.browserDetails.version >= 33) {
                            // Firefox 33+ has experimental support for screen sharing
                            constraints = {
                                video: {
                                    mozMediaSource: media.video,
                                    mediaSource: media.video
                                },
                                audio: isAudioSendEnabled(media) && !media.keepAudio
                            };
                            getScreenMedia(constraints, function(err, stream) {
                                callbackUserMedia(err, stream);
                                // Workaround for https://bugzilla.mozilla.org/show_bug.cgi?id=1045810
                                if (!err) {
                                    var lastTime = stream.currentTime;
                                    var polly = window.setInterval(function() {
                                        if (!stream)
                                            window.clearInterval(polly);
                                        if (stream.currentTime == lastTime) {
                                            window.clearInterval(polly);
                                            if (stream.onended) {
                                                stream.onended();
                                            }
                                        }
                                        lastTime = stream.currentTime;
                                    }, 500);
                                }
                            });
                        } else {
                            var error = new Error('NavigatorUserMediaError');
                            error.name = 'Your version of Firefox does not support screen sharing, please install Firefox 33 (or more recent versions)';
                            pluginHandle.consentDialog(false);
                            callbacks.error(error);
                            return;
                        }
                    }
                    return;
                }
            }
            // If we got here, we're not screensharing
            if (media === null || media === undefined || media.video !== 'screen') {
                // Check whether all media sources are actually available or not
                navigator.mediaDevices.enumerateDevices().then(function(devices) {
                        var audioExist = devices.some(function(device) {
                                return device.kind === 'audioinput';
                            }),
                            videoExist = isScreenSendEnabled(media) || devices.some(function(device) {
                                return device.kind === 'videoinput';
                            });

                        // Check whether a missing device is really a problem
                        var audioSend = isAudioSendEnabled(media);
                        var videoSend = isVideoSendEnabled(media);
                        var needAudioDevice = isAudioSendRequired(media);
                        var needVideoDevice = isVideoSendRequired(media);
                        if (audioSend || videoSend || needAudioDevice || needVideoDevice) {
                            // We need to send either audio or video
                            var haveAudioDevice = audioSend ? audioExist : false;
                            var haveVideoDevice = videoSend ? videoExist : false;
                            if (!haveAudioDevice && !haveVideoDevice) {
                                // FIXME Should we really give up, or just assume recvonly for both?
                                pluginHandle.consentDialog(false);
                                callbacks.error('No capture device found');
                                return false;
                            } else if (!haveAudioDevice && needAudioDevice) {
                                pluginHandle.consentDialog(false);
                                callbacks.error('Audio capture is required, but no capture device found');
                                return false;
                            } else if (!haveVideoDevice && needVideoDevice) {
                                pluginHandle.consentDialog(false);
                                callbacks.error('Video capture is required, but no capture device found');
                                return false;
                            }
                        }

                        var gumConstraints = {
                                audio: (audioExist && !media.keepAudio) ? audioSupport : false,
                                video: (videoExist && !media.keepVideo) ? videoSupport : false
                            },
                            frameRateVal;
                        if (sessionStorage.getItem('frameRate')) {
                            frameRateVal = JSON.parse(sessionStorage.getItem('frameRate'));
                        }
                        if (frameRateVal === undefined || frameRateVal === null) {
                            frameRateVal = { "ideal": 10, "min": 1, "max": 10 }
                        }
                        Janus.debug("getUserMedia constraints", gumConstraints);
                        if (!gumConstraints.audio && !gumConstraints.video) {
                            pluginHandle.consentDialog(false);
                            streamsDone(handleId, jsep, media, callbacks, stream);
                        } else {
                            gumConstraints.video = { "frameRate": frameRateVal, "width": { "ideal": 320 }, "height": { "ideal": 180 } };
                            userMediaResTimeOut = setTimeout(function() {
                                callbacks.error({
                                    code: 1000,
                                    name: "custom_getUserMedia_error",
                                    message: "GetUserMedia Error(10sec timeOut)::not supported resolution"
                                });
                            }, 10 * 1000);
                            navigator.mediaDevices.getUserMedia(gumConstraints)
                                .then(function(stream) {
                                    clearTimeout(userMediaResTimeOut);
                                    pluginHandle.consentDialog(false);
                                    streamsDone(handleId, jsep, media, callbacks, stream);
                                }).catch(function(error) {
                                    clearTimeout(userMediaResTimeOut);
                                    pluginHandle.consentDialog(false);
                                    callbacks.error({ code: error.code, name: error.name, message: error.message });
                                });

                        }
                    })
                    .catch(function(error) {
                        pluginHandle.consentDialog(false);
                        callbacks.error('enumerateDevices error', error);
                    });
            }
        } else {
            // No need to do a getUserMedia, create offer/answer right away
            streamsDone(handleId, jsep, media, callbacks);
        }
    }

    function prepareWebrtcPeer(handleId, callbacks) {
        callbacks = callbacks || {};
        callbacks.success = (typeof callbacks.success == "function") ? callbacks.success : Janus.noop;
        callbacks.error = (typeof callbacks.error == "function") ? callbacks.error : webrtcError;
        var jsep = callbacks.jsep;
        var pluginHandle = pluginHandles[handleId];
        if (pluginHandle === null || pluginHandle === undefined ||
            pluginHandle.webrtcStuff === null || pluginHandle.webrtcStuff === undefined) {
            Janus.warn("Invalid handle");
            callbacks.error("Invalid handle");
            return;
        }
        var config = pluginHandle.webrtcStuff;
        if (jsep !== undefined && jsep !== null) {
            if (config.pc === null) {
                Janus.warn("Wait, no PeerConnection?? if this is an answer, use createAnswer and not handleRemoteJsep");
                callbacks.error("No PeerConnection: if this is an answer, use createAnswer and not handleRemoteJsep");
                return;
            }
            config.pc.setRemoteDescription(jsep)
                .then(function() {
                    Janus.log("Remote description accepted!");
                    config.remoteSdp = jsep.sdp;
                    // Any trickle candidate we cached?
                    if (config.candidates && config.candidates.length > 0) {
                        for (var i = 0; i < config.candidates.length; i++) {
                            var candidate = config.candidates[i];
                            Janus.debug("Adding remote candidate:", candidate);
                            if (!candidate || candidate.completed === true) {
                                // end-of-candidates
                                config.pc.addIceCandidate(Janus.endOfCandidates);
                            } else {
                                // New candidate
                                config.pc.addIceCandidate(candidate);
                            }
                        }
                        config.candidates = [];
                    }
                    // Done
                    callbacks.success();
                }, callbacks.error);
        } else {
            callbacks.error("Invalid JSEP");
        }
    }

    function createOffer(handleId, media, callbacks) {
        callbacks = callbacks || {};
        callbacks.success = (typeof callbacks.success == "function") ? callbacks.success : Janus.noop;
        callbacks.error = (typeof callbacks.error == "function") ? callbacks.error : Janus.noop;
        callbacks.customizeSdp = (typeof callbacks.customizeSdp == "function") ? callbacks.customizeSdp : Janus.noop;
        var pluginHandle = pluginHandles[handleId];
        if (pluginHandle === null || pluginHandle === undefined ||
            pluginHandle.webrtcStuff === null || pluginHandle.webrtcStuff === undefined) {
            Janus.warn("Invalid handle");
            callbacks.error("Invalid handle");
            return;
        }
        var config = pluginHandle.webrtcStuff;
        var simulcast = callbacks.simulcast === true ? true : false;
        if (!simulcast) {
            Janus.log("Creating offer (iceDone=" + config.iceDone + ")");
        } else {
            Janus.log("Creating offer (iceDone=" + config.iceDone + ", simulcast=" + simulcast + ")");
        }
        // https://code.google.com/p/webrtc/issues/detail?id=3508
        var mediaConstraints = {};
        if (Janus.unifiedPlan) {
            // We can use Transceivers
            var audioTransceiver = null,
                videoTransceiver = null;
            var transceivers = config.pc.getTransceivers();
            if (transceivers && transceivers.length > 0) {
                for (var i in transceivers) {
                    var t = transceivers[i];
                    if ((t.sender && t.sender.track && t.sender.track.kind === "audio") ||
                        (t.receiver && t.receiver.track && t.receiver.track.kind === "audio")) {
                        if (!audioTransceiver)
                            audioTransceiver = t;
                        continue;
                    }
                    if ((t.sender && t.sender.track && t.sender.track.kind === "video") ||
                        (t.receiver && t.receiver.track && t.receiver.track.kind === "video")) {
                        if (!videoTransceiver)
                            videoTransceiver = t;
                        continue;
                    }
                }
            }
            // Handle audio (and related changes, if any)
            var audioSend = isAudioSendEnabled(media);
            var audioRecv = isAudioRecvEnabled(media);
            if (!audioSend && !audioRecv) {
                // Audio disabled: have we removed it?
                if (media.removeAudio && audioTransceiver) {
                    if (audioTransceiver.setDirection) {
                        audioTransceiver.setDirection("inactive");
                    } else {
                        audioTransceiver.direction = "inactive";
                    }
                    Janus.log("Setting audio transceiver to inactive:", audioTransceiver);
                }
            } else {
                // Take care of audio m-line
                if (audioSend && audioRecv) {
                    if (audioTransceiver) {
                        if (audioTransceiver.setDirection) {
                            audioTransceiver.setDirection("sendrecv");
                        } else {
                            audioTransceiver.direction = "sendrecv";
                        }
                        Janus.log("Setting audio transceiver to sendrecv:", audioTransceiver);
                    }
                } else if (audioSend && !audioRecv) {
                    if (audioTransceiver) {
                        if (audioTransceiver.setDirection) {
                            audioTransceiver.setDirection("sendonly");
                        } else {
                            audioTransceiver.direction = "sendonly";
                        }
                        Janus.log("Setting audio transceiver to sendonly:", audioTransceiver);
                    }
                } else if (!audioSend && audioRecv) {
                    if (audioTransceiver) {
                        if (audioTransceiver.setDirection) {
                            audioTransceiver.setDirection("recvonly");
                        } else {
                            audioTransceiver.direction = "recvonly";
                        }
                        Janus.log("Setting audio transceiver to recvonly:", audioTransceiver);
                    } else {
                        // In theory, this is the only case where we might not have a transceiver yet
                        audioTransceiver = config.pc.addTransceiver("audio", { direction: "recvonly" });
                        Janus.log("Adding recvonly audio transceiver:", audioTransceiver);
                    }
                }
            }
            // Handle video (and related changes, if any)
            var videoSend = isVideoSendEnabled(media);
            var videoRecv = isVideoRecvEnabled(media);
            if (!videoSend && !videoRecv) {
                // Video disabled: have we removed it?
                if (media.removeVideo && videoTransceiver) {
                    if (videoTransceiver.setDirection) {
                        videoTransceiver.setDirection("inactive");
                    } else {
                        videoTransceiver.direction = "inactive";
                    }
                    Janus.log("Setting video transceiver to inactive:", videoTransceiver);
                }
            } else {
                // Take care of video m-line
                if (videoSend && videoRecv) {
                    if (videoTransceiver) {
                        if (videoTransceiver.setDirection) {
                            videoTransceiver.setDirection("sendrecv");
                        } else {
                            videoTransceiver.direction = "sendrecv";
                        }
                        Janus.log("Setting video transceiver to sendrecv:", videoTransceiver);
                    }
                } else if (videoSend && !videoRecv) {
                    if (videoTransceiver) {
                        if (videoTransceiver.setDirection) {
                            videoTransceiver.setDirection("sendonly");
                        } else {
                            videoTransceiver.direction = "sendonly";
                        }
                        Janus.log("Setting video transceiver to sendonly:", videoTransceiver);
                    }
                } else if (!videoSend && videoRecv) {
                    if (videoTransceiver) {
                        if (videoTransceiver.setDirection) {
                            videoTransceiver.setDirection("recvonly");
                        } else {
                            videoTransceiver.direction = "recvonly";
                        }
                        Janus.log("Setting video transceiver to recvonly:", videoTransceiver);
                    } else {
                        // In theory, this is the only case where we might not have a transceiver yet
                        videoTransceiver = config.pc.addTransceiver("video", { direction: "recvonly" });
                        Janus.log("Adding recvonly video transceiver:", videoTransceiver);
                    }
                }
            }
        } else {
            mediaConstraints["offerToReceiveAudio"] = isAudioRecvEnabled(media);
            mediaConstraints["offerToReceiveVideo"] = isVideoRecvEnabled(media);
        }
        var iceRestart = callbacks.iceRestart === true ? true : false;
        if (iceRestart) {
            mediaConstraints["iceRestart"] = true;
        }
        Janus.debug(mediaConstraints);
        // Check if this is Firefox and we've been asked to do simulcasting
        var sendVideo = isVideoSendEnabled(media);
        if (sendVideo && simulcast && Janus.webRTCAdapter.browserDetails.browser === "firefox") {
            // FIXME Based on https://gist.github.com/voluntas/088bc3cc62094730647b
            Janus.log("Enabling Simulcasting for Firefox (RID)");
            var sender = config.pc.getSenders().find(function(s) { return s.track.kind == "video" });
            if (sender) {
                var parameters = sender.getParameters();
                if (!parameters)
                    parameters = {};


                const maxBitrates = getMaxBitrates(callbacks.simulcastMaxBitrates);
                Janus.log('sap_ss_MaxBitrate - 2', maxBitrates)
                parameters.encodings = [
                    { rid: "h", active: true, maxBitrate: maxBitrates.high },
                    { rid: "m", active: true, maxBitrate: maxBitrates.medium, scaleResolutionDownBy: 2 },
                    { rid: "l", active: true, maxBitrate: maxBitrates.low, scaleResolutionDownBy: 4 }
                ];
                sender.setParameters(parameters);
            }
        }
        config.pc.createOffer(mediaConstraints)
            .then(function(offer) {
                Janus.debug(offer);
                // JSON.stringify doesn't work on some WebRTC objects anymore
                // See https://code.google.com/p/chromium/issues/detail?id=467366
                var jsep = {
                    "type": offer.type,
                    "sdp": offer.sdp
                };
                callbacks.customizeSdp(jsep);
                offer.sdp = jsep.sdp;
                Janus.log("Setting local description");
                if (sendVideo && simulcast) {
                    // This SDP munging only works with Chrome (Safari STP may support it too)
                    if (Janus.webRTCAdapter.browserDetails.browser === "chrome" ||
                        Janus.webRTCAdapter.browserDetails.browser === "safari") {
                        Janus.log("Enabling Simulcasting for Chrome (SDP munging)");
                        offer.sdp = mungeSdpForSimulcasting(offer.sdp);
                    } else if (Janus.webRTCAdapter.browserDetails.browser !== "firefox") {
                        Janus.warn("simulcast=true, but this is not Chrome nor Firefox, ignoring");
                    }
                }
                config.mySdp = offer.sdp;
                config.pc.setLocalDescription(offer)
                    .catch(callbacks.error);
                config.mediaConstraints = mediaConstraints;
                if (!config.iceDone && !config.trickle) {
                    // Don't do anything until we have all candidates
                    Janus.log("Waiting for all candidates...");
                    return;
                }
                Janus.log("Offer ready");
                Janus.debug(callbacks);
                callbacks.success(offer);
            }, callbacks.error);
    }

    function createAnswer(handleId, media, callbacks) {
        callbacks = callbacks || {};
        callbacks.success = (typeof callbacks.success == "function") ? callbacks.success : Janus.noop;
        callbacks.error = (typeof callbacks.error == "function") ? callbacks.error : Janus.noop;
        callbacks.customizeSdp = (typeof callbacks.customizeSdp == "function") ? callbacks.customizeSdp : Janus.noop;
        var pluginHandle = pluginHandles[handleId];
        if (pluginHandle === null || pluginHandle === undefined ||
            pluginHandle.webrtcStuff === null || pluginHandle.webrtcStuff === undefined) {
            Janus.warn("Invalid handle");
            callbacks.error("Invalid handle");
            return;
        }
        var config = pluginHandle.webrtcStuff;
        var simulcast = callbacks.simulcast === true ? true : false;
        if (!simulcast) {
            Janus.log("Creating answer (iceDone=" + config.iceDone + ")");
        } else {
            Janus.log("Creating answer (iceDone=" + config.iceDone + ", simulcast=" + simulcast + ")");
        }
        var mediaConstraints = null;
        if (Janus.unifiedPlan) {
            // We can use Transceivers
            mediaConstraints = {};
            var audioTransceiver = null,
                videoTransceiver = null;
            var transceivers = config.pc.getTransceivers();
            if (transceivers && transceivers.length > 0) {
                for (var i in transceivers) {
                    var t = transceivers[i];
                    if ((t.sender && t.sender.track && t.sender.track.kind === "audio") ||
                        (t.receiver && t.receiver.track && t.receiver.track.kind === "audio")) {
                        if (!audioTransceiver)
                            audioTransceiver = t;
                        continue;
                    }
                    if ((t.sender && t.sender.track && t.sender.track.kind === "video") ||
                        (t.receiver && t.receiver.track && t.receiver.track.kind === "video")) {
                        if (!videoTransceiver)
                            videoTransceiver = t;
                        continue;
                    }
                }
            }
            // Handle audio (and related changes, if any)
            var audioSend = isAudioSendEnabled(media);
            var audioRecv = isAudioRecvEnabled(media);
            if (!audioSend && !audioRecv) {
                // Audio disabled: have we removed it?
                if (media.removeAudio && audioTransceiver) {
                    try {
                        if (audioTransceiver.setDirection) {
                            audioTransceiver.setDirection("inactive");
                        } else {
                            audioTransceiver.direction = "inactive";
                        }
                        Janus.log("Setting audio transceiver to inactive:", audioTransceiver);
                    } catch (e) {
                        Janus.error(e);
                    }
                }
            } else {
                // Take care of audio m-line
                if (audioSend && audioRecv) {
                    if (audioTransceiver) {
                        try {
                            if (audioTransceiver.setDirection) {
                                audioTransceiver.setDirection("sendrecv");
                            } else {
                                audioTransceiver.direction = "sendrecv";
                            }
                            Janus.log("Setting audio transceiver to sendrecv:", audioTransceiver);
                        } catch (e) {
                            Janus.error(e);
                        }
                    }
                } else if (audioSend && !audioRecv) {
                    try {
                        if (audioTransceiver) {
                            if (audioTransceiver.setDirection) {
                                audioTransceiver.setDirection("sendonly");
                            } else {
                                audioTransceiver.direction = "sendonly";
                            }
                            Janus.log("Setting audio transceiver to sendonly:", audioTransceiver);
                        }
                    } catch (e) {
                        Janus.error(e);
                    }
                } else if (!audioSend && audioRecv) {
                    if (audioTransceiver) {
                        try {
                            if (audioTransceiver.setDirection) {
                                audioTransceiver.setDirection("recvonly");
                            } else {
                                audioTransceiver.direction = "recvonly";
                            }
                            Janus.log("Setting audio transceiver to recvonly:", audioTransceiver);
                        } catch (e) {
                            Janus.error(e);
                        }
                    } else {
                        // In theory, this is the only case where we might not have a transceiver yet
                        audioTransceiver = config.pc.addTransceiver("audio", { direction: "recvonly" });
                        Janus.log("Adding recvonly audio transceiver:", audioTransceiver);
                    }
                }
            }
            // Handle video (and related changes, if any)
            var videoSend = isVideoSendEnabled(media);
            var videoRecv = isVideoRecvEnabled(media);
            if (!videoSend && !videoRecv) {
                // Video disabled: have we removed it?
                if (media.removeVideo && videoTransceiver) {
                    try {
                        if (videoTransceiver.setDirection) {
                            videoTransceiver.setDirection("inactive");
                        } else {
                            videoTransceiver.direction = "inactive";
                        }
                        Janus.log("Setting video transceiver to inactive:", videoTransceiver);
                    } catch (e) {
                        Janus.error(e);
                    }
                }
            } else {
                // Take care of video m-line
                if (videoSend && videoRecv) {
                    if (videoTransceiver) {
                        try {
                            if (videoTransceiver.setDirection) {
                                videoTransceiver.setDirection("sendrecv");
                            } else {
                                videoTransceiver.direction = "sendrecv";
                            }
                            Janus.log("Setting video transceiver to sendrecv:", videoTransceiver);
                        } catch (e) {
                            Janus.error(e);
                        }
                    }
                } else if (videoSend && !videoRecv) {
                    if (videoTransceiver) {
                        try {
                            if (videoTransceiver.setDirection) {
                                videoTransceiver.setDirection("sendonly");
                            } else {
                                videoTransceiver.direction = "sendonly";
                            }
                            Janus.log("Setting video transceiver to sendonly:", videoTransceiver);
                        } catch (e) {
                            Janus.error(e);
                        }
                    }
                } else if (!videoSend && videoRecv) {
                    if (videoTransceiver) {
                        try {
                            if (videoTransceiver.setDirection) {
                                videoTransceiver.setDirection("recvonly");
                            } else {
                                videoTransceiver.direction = "recvonly";
                            }
                            Janus.log("Setting video transceiver to recvonly:", videoTransceiver);
                        } catch (e) {
                            Janus.error(e);
                        }
                    } else {
                        // In theory, this is the only case where we might not have a transceiver yet
                        videoTransceiver = config.pc.addTransceiver("video", { direction: "recvonly" });
                        Janus.log("Adding recvonly video transceiver:", videoTransceiver);
                    }
                }
            }
        } else {
            if (Janus.webRTCAdapter.browserDetails.browser == "firefox" || Janus.webRTCAdapter.browserDetails.browser == "edge") {
                mediaConstraints = {
                    offerToReceiveAudio: isAudioRecvEnabled(media),
                    offerToReceiveVideo: isVideoRecvEnabled(media)
                };
            } else {
                mediaConstraints = {
                    mandatory: {
                        OfferToReceiveAudio: isAudioRecvEnabled(media),
                        OfferToReceiveVideo: isVideoRecvEnabled(media)
                    }
                };
            }
        }
        Janus.debug(mediaConstraints);
        // Check if this is Firefox and we've been asked to do simulcasting
        var sendVideo = isVideoSendEnabled(media);
        if (sendVideo && simulcast && Janus.webRTCAdapter.browserDetails.browser === "firefox") {
            // FIXME Based on https://gist.github.com/voluntas/088bc3cc62094730647b
            Janus.log("Enabling Simulcasting for Firefox (RID)");
            var sender = config.pc.getSenders()[1];
            Janus.log(sender);
            var parameters = sender.getParameters();
            Janus.log(parameters);

            const maxBitrates = getMaxBitrates(callbacks.simulcastMaxBitrates);
            sender.setParameters({
                encodings: [
                    { rid: "high", active: true, priority: "high", maxBitrate: maxBitrates.high },
                    { rid: "medium", active: true, priority: "medium", maxBitrate: maxBitrates.medium },
                    { rid: "low", active: true, priority: "low", maxBitrate: maxBitrates.low }
                ]
            });
        }
        config.pc.createAnswer(mediaConstraints)
            .then(function(answer) {
                Janus.debug(answer);
                // JSON.stringify doesn't work on some WebRTC objects anymore
                // See https://code.google.com/p/chromium/issues/detail?id=467366
                var jsep = {
                    "type": answer.type,
                    "sdp": answer.sdp
                };
                callbacks.customizeSdp(jsep);
                answer.sdp = jsep.sdp;
                Janus.log("Setting local description");
                if (sendVideo && simulcast) {
                    // This SDP munging only works with Chrome
                    if (Janus.webRTCAdapter.browserDetails.browser === "chrome") {
                        // FIXME Apparently trying to simulcast when answering breaks video in Chrome...
                        //~ Janus.log("Enabling Simulcasting for Chrome (SDP munging)");
                        //~ answer.sdp = mungeSdpForSimulcasting(answer.sdp);
                        Janus.warn("simulcast=true, but this is an answer, and video breaks in Chrome if we enable it");
                    } else if (Janus.webRTCAdapter.browserDetails.browser !== "firefox") {
                        Janus.warn("simulcast=true, but this is not Chrome nor Firefox, ignoring");
                    }
                }
                config.mySdp = answer.sdp;
                config.pc.setLocalDescription(answer)
                    .catch(callbacks.error);
                config.mediaConstraints = mediaConstraints;
                if (!config.iceDone && !config.trickle) {
                    // Don't do anything until we have all candidates
                    Janus.log("Waiting for all candidates...");
                    return;
                }
                callbacks.success(answer);
            }, callbacks.error);
    }

    function sendSDP(handleId, callbacks) {
        callbacks = callbacks || {};
        callbacks.success = (typeof callbacks.success == "function") ? callbacks.success : Janus.noop;
        callbacks.error = (typeof callbacks.error == "function") ? callbacks.error : Janus.noop;
        var pluginHandle = pluginHandles[handleId];
        if (pluginHandle === null || pluginHandle === undefined ||
            pluginHandle.webrtcStuff === null || pluginHandle.webrtcStuff === undefined) {
            Janus.warn("Invalid handle, not sending anything");
            return;
        }
        var config = pluginHandle.webrtcStuff;
        Janus.log("Sending offer/answer SDP...");
        if (config.mySdp === null || config.mySdp === undefined) {
            Janus.warn("Local SDP instance is invalid, not sending anything...");
            return;
        }
        config.mySdp = {
            "type": config.pc.localDescription.type,
            "sdp": config.pc.localDescription.sdp
        };
        if (config.trickle === false)
            config.mySdp["trickle"] = false;
        Janus.debug(callbacks);
        config.sdpSent = true;
        callbacks.success(config.mySdp);
    }

    function getVolume(handleId, remote) {
        var pluginHandle = pluginHandles[handleId];
        if (pluginHandle === null || pluginHandle === undefined ||
            pluginHandle.webrtcStuff === null || pluginHandle.webrtcStuff === undefined) {
            Janus.warn("Invalid handle");
            return 0;
        }
        var stream = remote ? "remote" : "local";
        var config = pluginHandle.webrtcStuff;
        if (!config.volume[stream])
            config.volume[stream] = { value: 0 };
        // Start getting the volume, if getStats is supported
        if (config.pc.getStats && Janus.webRTCAdapter.browserDetails.browser === "chrome") {
            if (remote && (config.remoteStream === null || config.remoteStream === undefined)) {
                Janus.warn("Remote stream unavailable");
                return 0;
            } else if (!remote && (config.myStream === null || config.myStream === undefined)) {
                Janus.warn("Local stream unavailable");
                return 0;
            }
            if (config.volume[stream].timer === null || config.volume[stream].timer === undefined) {
                Janus.log("Starting " + stream + " volume monitor");
                config.volume[stream].timer = setInterval(function() {
                    config.pc.getStats(function(stats) {
                        var results = stats.result();
                        for (var i = 0; i < results.length; i++) {
                            var res = results[i];
                            if (res.type == 'ssrc') {
                                if (remote && res.stat('audioOutputLevel'))
                                    config.volume[stream].value = parseInt(res.stat('audioOutputLevel'));
                                else if (!remote && res.stat('audioInputLevel'))
                                    config.volume[stream].value = parseInt(res.stat('audioInputLevel'));
                            }
                        }
                    });
                }, 200);
                return 0; // We don't have a volume to return yet
            }
            return config.volume[stream].value;
        } else {
            // audioInputLevel and audioOutputLevel seem only available in Chrome? audioLevel
            // seems to be available on Chrome and Firefox, but they don't seem to work
            Janus.warn("Getting the " + stream + " volume unsupported by browser");
            return 0;
        }
    }

    function isMuted(handleId, video) {
        var pluginHandle = pluginHandles[handleId];
        if (pluginHandle === null || pluginHandle === undefined ||
            pluginHandle.webrtcStuff === null || pluginHandle.webrtcStuff === undefined) {
            Janus.warn("Invalid handle");
            return true;
        }
        var config = pluginHandle.webrtcStuff;
        if (config.pc === null || config.pc === undefined) {
            Janus.warn("Invalid PeerConnection");
            return true;
        }
        if (config.myStream === undefined || config.myStream === null) {
            Janus.warn("Invalid local MediaStream");
            return true;
        }
        if (video) {
            // Check video track
            if (config.myStream.getVideoTracks() === null ||
                config.myStream.getVideoTracks() === undefined ||
                config.myStream.getVideoTracks().length === 0) {
                Janus.warn("No video track");
                return true;
            }
            return !config.myStream.getVideoTracks()[0].enabled;
        } else {
            // Check audio track
            if (config.myStream.getAudioTracks() === null ||
                config.myStream.getAudioTracks() === undefined ||
                config.myStream.getAudioTracks().length === 0) {
                Janus.warn("No audio track");
                return true;
            }
            return !config.myStream.getAudioTracks()[0].enabled;
        }
    }

    function mute(handleId, video, mute) {
        var pluginHandle = pluginHandles[handleId];
        if (pluginHandle === null || pluginHandle === undefined ||
            pluginHandle.webrtcStuff === null || pluginHandle.webrtcStuff === undefined) {
            Janus.warn("Invalid handle");
            return false;
        }
        var config = pluginHandle.webrtcStuff;
        if (config.pc === null || config.pc === undefined) {
            Janus.warn("Invalid PeerConnection");
            return false;
        }
        if (config.myStream === undefined || config.myStream === null) {
            Janus.warn("Invalid local MediaStream");
            return false;
        }
        if (video) {
            // Mute/unmute video track
            if (config.myStream.getVideoTracks() === null ||
                config.myStream.getVideoTracks() === undefined ||
                config.myStream.getVideoTracks().length === 0) {
                Janus.warn("No video track");
                return false;
            }
            config.myStream.getVideoTracks()[0].enabled = mute ? false : true;
            return true;
        } else {
            // Mute/unmute audio track
            if (config.myStream.getAudioTracks() === null ||
                config.myStream.getAudioTracks() === undefined ||
                config.myStream.getAudioTracks().length === 0) {
                Janus.warn("No audio track");
                return false;
            }
            config.myStream.getAudioTracks()[0].enabled = mute ? false : true;
            return true;
        }
    }

    function getBitrate(handleId) {
        var pluginHandle = pluginHandles[handleId];
        if (pluginHandle === null || pluginHandle === undefined ||
            pluginHandle.webrtcStuff === null || pluginHandle.webrtcStuff === undefined) {
            Janus.warn("Invalid handle");
            return "Invalid handle";
        }
        var config = pluginHandle.webrtcStuff;
        if (config.pc === null || config.pc === undefined)
            return "Invalid PeerConnection";
        // Start getting the bitrate, if getStats is supported
        if (config.pc.getStats) {
            if (config.bitrate.timer === null || config.bitrate.timer === undefined) {
                Janus.log("Starting bitrate timer (via getStats)");
                config.bitrate.timer = setInterval(function() {
                    config.pc.getStats()
                        .then(function(stats) {
                            stats.forEach(function(res) {
                                if (!res)
                                    return;
                                var inStats = false;
                                // Check if these are statistics on incoming media
                                if ((res.mediaType === "video" || res.id.toLowerCase().indexOf("video") > -1) &&
                                    res.type === "inbound-rtp" && res.id.indexOf("rtcp") < 0) {
                                    // New stats
                                    inStats = true;
                                } else if (res.type == 'ssrc' && res.bytesReceived &&
                                    (res.googCodecName === "VP8" || res.googCodecName === "")) {
                                    // Older Chromer versions
                                    inStats = true;
                                }
                                // Parse stats now
                                if (inStats) {
                                    config.bitrate.bsnow = res.bytesReceived;
                                    config.bitrate.tsnow = res.timestamp;
                                    if (config.bitrate.bsbefore === null || config.bitrate.tsbefore === null) {
                                        // Skip this round
                                        config.bitrate.bsbefore = config.bitrate.bsnow;
                                        config.bitrate.tsbefore = config.bitrate.tsnow;
                                    } else {
                                        // Calculate bitrate
                                        var timePassed = config.bitrate.tsnow - config.bitrate.tsbefore;
                                        if (Janus.webRTCAdapter.browserDetails.browser == "safari")
                                            timePassed = timePassed / 1000; // Apparently the timestamp is in microseconds, in Safari
                                        var bitRate = Math.round((config.bitrate.bsnow - config.bitrate.bsbefore) * 8 / timePassed);
                                        if (Janus.webRTCAdapter.browserDetails.browser === 'safari')
                                            bitRate = parseInt(bitRate / 1000);
                                        config.bitrate.value = bitRate + ' kbits/sec';
                                        //~ Janus.log("Estimated bitrate is " + config.bitrate.value);
                                        config.bitrate.bsbefore = config.bitrate.bsnow;
                                        config.bitrate.tsbefore = config.bitrate.tsnow;
                                    }
                                }
                            });
                        });
                }, 1000);
                return "0 kbits/sec"; // We don't have a bitrate value yet
            }
            return config.bitrate.value;
        } else {
            Janus.warn("Getting the video bitrate unsupported by browser");
            return "Feature unsupported by browser";
        }
    }

    function webrtcError(error) {
        Janus.error("WebRTC error:", error);
    }

    function cleanupWebrtc(handleId, hangupRequest) {
        Janus.log("Cleaning WebRTC stuff");
        var pluginHandle = pluginHandles[handleId];
        if (pluginHandle === null || pluginHandle === undefined) {
            // Nothing to clean
            return;
        }
        var config = pluginHandle.webrtcStuff;
        if (config !== null && config !== undefined) {
            if (hangupRequest === true) {
                // Send a hangup request (we don't really care about the response)
                var request = { "janus": "hangup", "transaction": Janus.randomString(12) };
                if (pluginHandle.token !== null && pluginHandle.token !== undefined)
                    request["token"] = pluginHandle.token;
                if (apisecret !== null && apisecret !== undefined)
                    request["apisecret"] = apisecret;
                Janus.debug("Sending hangup request (handle=" + handleId + "):");
                Janus.debug(request);
                if (websockets) {
                    request["session_id"] = sessionId;
                    request["handle_id"] = handleId;
                    ws.send(JSON.stringify(request));
                } else {
                    Janus.httpAPICall(server + "/" + sessionId + "/" + handleId, {
                        verb: 'POST',
                        withCredentials: withCredentials,
                        body: request
                    });
                }
            }
            // Cleanup stack
            config.remoteStream = null;
            if (config.volume) {
                if (config.volume["local"] && config.volume["local"].timer)
                    clearInterval(config.volume["local"].timer);
                if (config.volume["remote"] && config.volume["remote"].timer)
                    clearInterval(config.volume["remote"].timer);
            }
            config.volume = {};
            if (config.bitrate.timer)
                clearInterval(config.bitrate.timer);
            config.bitrate.timer = null;
            config.bitrate.bsnow = null;
            config.bitrate.bsbefore = null;
            config.bitrate.tsnow = null;
            config.bitrate.tsbefore = null;
            config.bitrate.value = null;
            try {
                // Try a MediaStreamTrack.stop() for each track
                if (!config.streamExternal && config.myStream !== null && config.myStream !== undefined) {
                    Janus.log("Stopping local stream tracks");
                    var tracks = config.myStream.getTracks();
                    for (var i in tracks) {
                        var mst = tracks[i];
                        Janus.log(mst);
                        if (mst !== null && mst !== undefined)
                            mst.stop();
                    }
                }
            } catch (e) {
                // Do nothing if this fails
            }
            config.streamExternal = false;
            config.myStream = null;
            // Close PeerConnection
            try {
                config.pc.close();
            } catch (e) {
                // Do nothing
            }
            config.pc = null;
            config.candidates = null;
            config.mySdp = null;
            config.remoteSdp = null;
            config.iceDone = false;
            config.dataChannel = {};
            config.dtmfSender = null;
        }
        pluginHandle.oncleanup();
    }

    // Helper method to munge an SDP to enable simulcasting (Chrome only)
    function mungeSdpForSimulcasting(sdp) {
        // Let's munge the SDP to add the attributes for enabling simulcasting
        // (based on https://gist.github.com/ggarber/a19b4c33510028b9c657)
        var lines = sdp.split("\r\n");
        var video = false;
        var ssrc = [-1],
            ssrc_fid = [-1];
        var cname = null,
            msid = null,
            mslabel = null,
            label = null;
        var insertAt = -1;
        for (var i = 0; i < lines.length; i++) {
            var mline = lines[i].match(/m=(\w+) */);
            if (mline) {
                var medium = mline[1];
                if (medium === "video") {
                    // New video m-line: make sure it's the first one
                    if (ssrc[0] < 0) {
                        video = true;
                    } else {
                        // We're done, let's add the new attributes here
                        insertAt = i;
                        break;
                    }
                } else {
                    // New non-video m-line: do we have what we were looking for?
                    if (ssrc[0] > -1) {
                        // We're done, let's add the new attributes here
                        insertAt = i;
                        break;
                    }
                }
                continue;
            }
            if (!video)
                continue;
            var fid = lines[i].match(/a=ssrc-group:FID (\d+) (\d+)/);
            if (fid) {
                ssrc[0] = fid[1];
                ssrc_fid[0] = fid[2];
                lines.splice(i, 1);
                i--;
                continue;
            }
            if (ssrc[0]) {
                var match = lines[i].match('a=ssrc:' + ssrc[0] + ' cname:(.+)')
                if (match) {
                    cname = match[1];
                }
                match = lines[i].match('a=ssrc:' + ssrc[0] + ' msid:(.+)')
                if (match) {
                    msid = match[1];
                }
                match = lines[i].match('a=ssrc:' + ssrc[0] + ' mslabel:(.+)')
                if (match) {
                    mslabel = match[1];
                }
                match = lines[i].match('a=ssrc:' + ssrc[0] + ' label:(.+)')
                if (match) {
                    label = match[1];
                }
                if (lines[i].indexOf('a=ssrc:' + ssrc_fid[0]) === 0) {
                    lines.splice(i, 1);
                    i--;
                    continue;
                }
                if (lines[i].indexOf('a=ssrc:' + ssrc[0]) === 0) {
                    lines.splice(i, 1);
                    i--;
                    continue;
                }
            }
            if (lines[i].length == 0) {
                lines.splice(i, 1);
                i--;
                continue;
            }
        }
        if (ssrc[0] < 0) {
            // Couldn't find a FID attribute, let's just take the first video SSRC we find
            insertAt = -1;
            video = false;
            for (var i = 0; i < lines.length; i++) {
                var mline = lines[i].match(/m=(\w+) */);
                if (mline) {
                    var medium = mline[1];
                    if (medium === "video") {
                        // New video m-line: make sure it's the first one
                        if (ssrc[0] < 0) {
                            video = true;
                        } else {
                            // We're done, let's add the new attributes here
                            insertAt = i;
                            break;
                        }
                    } else {
                        // New non-video m-line: do we have what we were looking for?
                        if (ssrc[0] > -1) {
                            // We're done, let's add the new attributes here
                            insertAt = i;
                            break;
                        }
                    }
                    continue;
                }
                if (!video)
                    continue;
                if (ssrc[0] < 0) {
                    var value = lines[i].match(/a=ssrc:(\d+)/);
                    if (value) {
                        ssrc[0] = value[1];
                        lines.splice(i, 1);
                        i--;
                        continue;
                    }
                } else {
                    var match = lines[i].match('a=ssrc:' + ssrc[0] + ' cname:(.+)')
                    if (match) {
                        cname = match[1];
                    }
                    match = lines[i].match('a=ssrc:' + ssrc[0] + ' msid:(.+)')
                    if (match) {
                        msid = match[1];
                    }
                    match = lines[i].match('a=ssrc:' + ssrc[0] + ' mslabel:(.+)')
                    if (match) {
                        mslabel = match[1];
                    }
                    match = lines[i].match('a=ssrc:' + ssrc[0] + ' label:(.+)')
                    if (match) {
                        label = match[1];
                    }
                    if (lines[i].indexOf('a=ssrc:' + ssrc_fid[0]) === 0) {
                        lines.splice(i, 1);
                        i--;
                        continue;
                    }
                    if (lines[i].indexOf('a=ssrc:' + ssrc[0]) === 0) {
                        lines.splice(i, 1);
                        i--;
                        continue;
                    }
                }
                if (lines[i].length == 0) {
                    lines.splice(i, 1);
                    i--;
                    continue;
                }
            }
        }
        if (ssrc[0] < 0) {
            // Still nothing, let's just return the SDP we were asked to munge
            Janus.warn("Couldn't find the video SSRC, simulcasting NOT enabled");
            return sdp;
        }
        if (insertAt < 0) {
            // Append at the end
            insertAt = lines.length;
        }
        // Generate a couple of SSRCs (for retransmissions too)
        // Note: should we check if there are conflicts, here?
        ssrc[1] = Math.floor(Math.random() * 0xFFFFFFFF);
        ssrc[2] = Math.floor(Math.random() * 0xFFFFFFFF);
        ssrc_fid[1] = Math.floor(Math.random() * 0xFFFFFFFF);
        ssrc_fid[2] = Math.floor(Math.random() * 0xFFFFFFFF);
        // Add attributes to the SDP
        for (var i = 0; i < ssrc.length; i++) {
            if (cname) {
                lines.splice(insertAt, 0, 'a=ssrc:' + ssrc[i] + ' cname:' + cname);
                insertAt++;
            }
            if (msid) {
                lines.splice(insertAt, 0, 'a=ssrc:' + ssrc[i] + ' msid:' + msid);
                insertAt++;
            }
            if (mslabel) {
                lines.splice(insertAt, 0, 'a=ssrc:' + ssrc[i] + ' mslabel:' + mslabel);
                insertAt++;
            }
            if (label) {
                lines.splice(insertAt, 0, 'a=ssrc:' + ssrc[i] + ' label:' + label);
                insertAt++;
            }
            // Add the same info for the retransmission SSRC
            if (cname) {
                lines.splice(insertAt, 0, 'a=ssrc:' + ssrc_fid[i] + ' cname:' + cname);
                insertAt++;
            }
            if (msid) {
                lines.splice(insertAt, 0, 'a=ssrc:' + ssrc_fid[i] + ' msid:' + msid);
                insertAt++;
            }
            if (mslabel) {
                lines.splice(insertAt, 0, 'a=ssrc:' + ssrc_fid[i] + ' mslabel:' + mslabel);
                insertAt++;
            }
            if (label) {
                lines.splice(insertAt, 0, 'a=ssrc:' + ssrc_fid[i] + ' label:' + label);
                insertAt++;
            }
        }
        lines.splice(insertAt, 0, 'a=ssrc-group:FID ' + ssrc[2] + ' ' + ssrc_fid[2]);
        lines.splice(insertAt, 0, 'a=ssrc-group:FID ' + ssrc[1] + ' ' + ssrc_fid[1]);
        lines.splice(insertAt, 0, 'a=ssrc-group:FID ' + ssrc[0] + ' ' + ssrc_fid[0]);
        lines.splice(insertAt, 0, 'a=ssrc-group:SIM ' + ssrc[0] + ' ' + ssrc[1] + ' ' + ssrc[2]);
        sdp = lines.join("\r\n");
        if (!sdp.endsWith("\r\n"))
            sdp += "\r\n";
        return sdp;
    }

    // Helper methods to parse a media object
    function isAudioSendEnabled(media) {
        Janus.debug("isAudioSendEnabled:", media);
        if (media === undefined || media === null)
            return true; // Default
        if (media.audio === false)
            return false; // Generic audio has precedence
        if (media.audioSend === undefined || media.audioSend === null)
            return true; // Default
        return (media.audioSend === true);
    }

    function isAudioSendRequired(media) {
        Janus.debug("isAudioSendRequired:", media);
        if (media === undefined || media === null)
            return false; // Default
        if (media.audio === false || media.audioSend === false)
            return false; // If we're not asking to capture audio, it's not required
        if (media.failIfNoAudio === undefined || media.failIfNoAudio === null)
            return false; // Default
        return (media.failIfNoAudio === true);
    }

    function isAudioRecvEnabled(media) {
        Janus.debug("isAudioRecvEnabled:", media);
        if (media === undefined || media === null)
            return true; // Default
        if (media.audio === false)
            return false; // Generic audio has precedence
        if (media.audioRecv === undefined || media.audioRecv === null)
            return true; // Default
        return (media.audioRecv === true);
    }

    function isVideoSendEnabled(media) {
        Janus.debug("isVideoSendEnabled:", media);
        if (media === undefined || media === null)
            return true; // Default
        if (media.video === false)
            return false; // Generic video has precedence
        if (media.videoSend === undefined || media.videoSend === null)
            return true; // Default
        return (media.videoSend === true);
    }

    function isVideoSendRequired(media) {
        Janus.debug("isVideoSendRequired:", media);
        if (media === undefined || media === null)
            return false; // Default
        if (media.video === false || media.videoSend === false)
            return false; // If we're not asking to capture video, it's not required
        if (media.failIfNoVideo === undefined || media.failIfNoVideo === null)
            return false; // Default
        return (media.failIfNoVideo === true);
    }

    function isVideoRecvEnabled(media) {
        Janus.debug("isVideoRecvEnabled:", media);
        if (media === undefined || media === null)
            return true; // Default
        if (media.video === false)
            return false; // Generic video has precedence
        if (media.videoRecv === undefined || media.videoRecv === null)
            return true; // Default
        return (media.videoRecv === true);
    }

    function isScreenSendEnabled(media) {
        Janus.debug("isScreenSendEnabled:", media);
        if (media === undefined || media === null)
            return false;
        if (typeof media.video !== 'object' || typeof media.video.mandatory !== 'object')
            return false;
        var constraints = media.video.mandatory;
        if (constraints.chromeMediaSource)
            return constraints.chromeMediaSource === 'desktop' || constraints.chromeMediaSource === 'screen';
        else if (constraints.mozMediaSource)
            return constraints.mozMediaSource === 'window' || constraints.mozMediaSource === 'screen';
        else if (constraints.mediaSource)
            return constraints.mediaSource === 'window' || constraints.mediaSource === 'screen';
        return false;
    }

    function isDataEnabled(media) {
        Janus.debug("isDataEnabled:", media);
        if (Janus.webRTCAdapter.browserDetails.browser == "edge") {
            Janus.warn("Edge doesn't support data channels yet");
            return false;
        }
        if (media === undefined || media === null)
            return false; // Default
        return (media.data === true);
    }

    function isTrickleEnabled(trickle) {
        Janus.debug("isTrickleEnabled:", trickle);
        if (trickle === undefined || trickle === null)
            return true; // Default is true
        return (trickle === true);
    }
};

(function() {
    'use strict';

    angular
        .module('OnlineAssessmentAngular')
        .component('uploadCapture', {
            bindings: {
                controlList: '<',
                jsonAnswer: '=',
                isAnswered: '=',
                callBack: '&'
            },
            templateUrl: 'app/template/default/uploadCapture.tpl.html',
            controller: uploadCaptureController,
            controllerAs: 'vm'
        });

    function uploadCaptureController($q, growl, blockUI, fileIOHelper, openModalService) {
        var vm = this;

        vm.isInproccessing = false;
        vm.jsonAnswer = {};

        vm.openCameraModal = openCameraModal;
        vm.uploadAttachmentFiles = uploadAttachmentFiles;
        vm.removeUrl = removeUrl;
        vm.checkForImg = checkForImg;

        vm.$onInit = function() {
            vm.controlList = vm.controlList;
            vm.isAnswered = vm.isAnswered;
            vm.jsonAnswer = vm.jsonAnswer;
            vm.callBack = vm.callBack;
        };
        active();

        function active() {
            console.log(vm.controlList);
        }

        function openCameraModal() {
            openModalService.openModal('qaTakePhotoTemplate').then(function(res) {
                if (res.result.fileList && res.result.fileList.length > 0) {
                    blockUI.start();
                    var controlId, data, promiseList = [];
                    _.forEach(res.result.fileList, function(base64, index){
                        promiseList.push(fileIOHelper.dataURItoBlob(base64, 'photoCapture' + index + '.png').then(function(file) {
                            return file;
                        }));
                    });
                    $q.all(promiseList).then(
                        function(res){
                            if (res && res.length > 0) {
                                controlId = _.get(vm.controlList, 'capture.id');
                                data = {
                                    files: res
                                };
                                uploadFileToServer(data, controlId);
                            } else {
                                blockUI.stop();
                                growl.error("No files to upload", { ttl: 4000, disableCountDown: true });
                            }
                        },
                        function(res) {
                            growl.error("Unable to upload file", { ttl: 4000, disableCountDown: true });
                            console.log(res);
                            blockUI.stop();
                        }
                    );
                }
            });
        }

        function uploadAttachmentFiles(evt) {
            var data, qaControlId;
            blockUI.start();
            var files = evt.target.files;
            if (files && files.length > 0) {
                qaControlId = _.get(vm.controlList, 'attachment.id');
                data = {
                    files: files,
                    allowedExtentions: vm.controlList.attachment.accept,
                    allowedFileSize: vm.controlList.attachment.allowedFileSize
                };
                uploadFileToServer(data, qaControlId);
            } else {
                blockUI.stop();
                growl.error("No files to upload", { ttl: 4000, disableCountDown: true });
            }
        }

        function uploadFileToServer(data, controlId) {
            var fd = new FormData();
            _.forEach(data.files, function(file){
                fd.append("fileAttachment", file, file.name);
            });
            fileIOHelper.uploadWithVirusScan(fd, data.allowedExtentions, data.allowedFileSize).then(
                function(res) {
                    blockUI.stop();
                    if (res && res.length > 0) {
                        if (controlId) {
                            vm.jsonAnswer[controlId] = _.union(vm.jsonAnswer[controlId], res);
                        }
                        // growl.success("File Uploaded Successfully", { ttl: 4000, disableCountDown: true });
                        vm.isAnswered = true;
                        // _.forIn(vm.jsonAnswer, function(value, key) {
                        //     vm.isAnswered = vm.isAnswered || _.isEmpty(value)? false : true;
                        // });
                        vm.callBack();
                    } else {
                        // growl.error("Unable to upload file", { ttl: 4000, disableCountDown: true });
                    }
                },
                function(res) {
                    // growl.error("Unable to upload file", { ttl: 4000, disableCountDown: true });
                    console.log(res);
                    blockUI.stop();
                }
            );
        }

        function removeUrl(array, index) {
            _.pullAt(array, [index]);
            vm.isAnswered = false;
            _.forIn(vm.jsonAnswer, function(value, key) {
                if (vm.isAnswered) {
                    return false;
                }
                vm.isAnswered = vm.isAnswered || (_.isEmpty(value)? false : true);
            });
            vm.callBack();
        }

        function checkForImg(url) {
            var split = _.split(url, '?');
            return !!split[0].match(/\w+\.(jpg|jpeg|gif|png|tiff|bmp)$/gi);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('OnlineAssessmentAngular')
        .component('typingTest', {
            bindings: {
                question: '=',
                callBack: '&'
            },
            templateUrl: 'app/template/default/typing.tpl.html',
            controller: typingTestController,
            controllerAs: 'vm'
        });

    function typingTestController($rootScope, $sce, assessmentUtility) {
        var vm = this,
            startTimeOnTicker = assessmentUtility.timer.time(),
            timeforWord = 0,
            typingTestTime = null,
            typingResult = {
                totalTimeSpent: 0,
                TotalKeyStrokes: 0,
                strokesforWord: 0,
                Details: [],
                WrongKeyStrokes: 0,
                CorrectKeyStrokes: 0,
                startTimeOnTicker: startTimeOnTicker,
                totalCharsInCurrentPara: 0
            };

        vm.typingWordIndex = 0;
        vm.typedArray = [];
        vm.enteredValue = "";

        vm.enterWord = enterWord;

        vm.$onInit = function() {
            vm.question = vm.question;
            active();
        };

        vm.$onDestroy = function() {
            calculateResult();
        };

        function active() {
            vm.trustedQString = $sce.trustAsHtml(vm.question.htmlString);
            vm.typingText = String(vm.trustedQString).replace(/<[^>]+>/gm, '').replace(/\n/gm, '').replace(/&nbsp;/g," ").trim();
            vm.typingText = _.unescape(vm.typingText);
            vm.typingArray = _.compact(_.split(vm.typingText, ' '));
            vm.typingArray = _.map(vm.typingArray, _.trim);
            _.forEach(vm.typingArray, function(value){
                typingResult.totalCharsInCurrentPara += value.length;
            });
            vm.typedText = "";
        }

        function enterWord($event, status) {
            if(!typingTestTime) {
                typingTestTime = new Date();
            }
            typingResult.totalTimeSpent = (new Date() - typingTestTime)/1000;
            vm.question.isAnswered = true;
            typingResult.TotalKeyStrokes++;
            typingResult.strokesforWord++;
            var onKeyPressResult = getKeyboardEventResult($event);
            if (onKeyPressResult == 32 || onKeyPressResult == 13) {
                typingResult.TotalKeyStrokes--;
                typingResult.strokesforWord--;
                updateResult();
                $event.preventDefault();
            }
        }

        function getKeyboardEventResult (keyEvent) {
            return (window.event ? keyEvent.keyCode : keyEvent.which);
        }

        function updateResult() {
            var result = {
                Correct: false,
                TimeElapsed: 0,
                KeyStrokes: 0,
                CorrectWord: vm.typingArray[vm.typingWordIndex],
                WordEntered: vm.enteredValue,
                CorrectKeystrokes: 0,
                WrongKeyStrokes: 0
            };
            if (vm.typingArray[vm.typingWordIndex] == vm.enteredValue) {
                result.Correct = true;
            }
            if (result.CorrectWord && result.WordEntered) {
                var length = result.CorrectWord.length < result.WordEntered.length ? result.CorrectWord.length : result.WordEntered.length;
                for (var i = 0; i < length; i++) {
                    result.CorrectWord[i] == result.WordEntered[i] ? result.CorrectKeystrokes++ : result.WrongKeyStrokes++;
                }
                if (length < result.WordEntered.length) {
                    result.WrongKeyStrokes += result.WordEntered.length - length;
                }
            }
            result.TimeElapsed = timeforWord;
            result.KeyStrokes = typingResult.strokesforWord;
            typingResult.CorrectKeyStrokes += result.CorrectKeystrokes;
            typingResult.WrongKeyStrokes += result.WrongKeyStrokes;
            typingResult.Details[vm.typingWordIndex] = result;
            vm.typedText += vm.enteredValue;
            vm.typedArray.push(vm.enteredValue);
            if (vm.enteredValue.length > 0) {
                vm.typedText += " ";
            }
            vm.enteredValue = "";
            vm.typingWordIndex++;
            typingResult.strokesforWord = 0;
            timeforWord = 0;
            vm.callBack();
        }

        function calculateResult() {
            var wordsEntered = 0,
                correctWords = 0,
                wrongWords = 0,
                finalResult = {
                    correctKeyStrokes: 0,
                    WrongKeyStrokes: 0,
                    totalCharsInCurrentPara: 0,
                    attempted: 0,
                    timeTaken: 0,
                    charsPerMin: 0,
                    wpm: 0,
                    grossWpm: 0,
                    netWpm: 0,
                    accuracy: 0
                };

            if (typingResult && typingResult.totalTimeSpent > 0) {
                typingResult.TotalTimeElapased = typingResult.totalTimeSpent;
                for (var i = 0; i < typingResult.Details.length; i++) {
                    // typingResult.Details[i].Correct == true ? correctWords++ : wrongWords++;
                    if (typingResult.Details[i].KeyStrokes > 0) {
                        wordsEntered++;
                    }
                }

                if (wordsEntered) {
                    typingResult.WPM = (wordsEntered / (typingResult.TotalTimeElapased / 60)).toFixed(2);
                } else {
                    typingResult.WPM = 0;
                }

                if (typingResult.CorrectKeyStrokes + typingResult.WrongKeyStrokes > 0) {
                    typingResult.Accuracy = (typingResult.CorrectKeyStrokes * 100 / (typingResult.CorrectKeyStrokes + typingResult.WrongKeyStrokes)).toFixed(2);
                } else {
                    typingResult.Accuracy = 0;
                }

                finalResult.correctKeyStrokes = typingResult.CorrectKeyStrokes;
                finalResult.WrongKeyStrokes = typingResult.WrongKeyStrokes;
                finalResult.totalCharsInCurrentPara = typingResult.totalCharsInCurrentPara;
                finalResult.attempted = parseFloat(((typingResult.CorrectKeyStrokes + typingResult.WrongKeyStrokes) * 100 / typingResult.totalCharsInCurrentPara).toFixed(2));
                finalResult.timeTaken = parseFloat((typingResult.TotalTimeElapased).toFixed(2));
                finalResult.charsPerMin = parseFloat((typingResult.CorrectKeyStrokes + typingResult.WrongKeyStrokes) / (finalResult.timeTaken / 60).toFixed(2));
                finalResult.wpm = typingResult.WPM;
                finalResult.grossWpm = parseFloat(((typingResult.CorrectKeyStrokes + typingResult.WrongKeyStrokes) / 5) / (finalResult.timeTaken / 60).toFixed(2));
                finalResult.netWpm = parseFloat(((typingResult.CorrectKeyStrokes) / 5) / (finalResult.timeTaken / 60).toFixed(2));
                finalResult.accuracy = parseFloat(parseFloat(typingResult.Accuracy).toFixed(2));
            }
            vm.question.jAns = finalResult;
            vm.callBack();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('OnlineAssessmentAngular')
        .component('submitAnswerLog', {
            bindings: {
                'questionId': '<',
                'loadAnswer': '&'
            },
            templateUrl: 'app/template/default/submitAnswerLog.tpl.html',
            controller: submitAnswerLogController,
            controllerAs: 'vm'
        });

    function submitAnswerLogController($sce, growl, webService) {
        var vm = this;


        vm.$onInit = function() {
            active();
        }

        function active() {
            var data = {
                    questionId: vm.questionId
                },
                errorMsg = null;
            vm.questionLog = [];
            webService.execute('getAnswerHistory', data)
                .then(function(response) {
                        if (response && response.data) {
                            if (response.data.error && response.data.status == 'KO') {
                                errorMsg = response.data.error.errorDescription || "Error occurred while fetching question history";
                                //growl.error(errorMsg, { ttl: 4000, disableCountDown: true });
                                return false;
                            }
                            if (response.data) {
                                vm.questionLog = angular.copy(response.data.submittedAnswerList);
                                _.forEach(vm.questionLog, function(log) {
                                    var totalExecutionTime = 0,
                                        totalMemoryConsumed = 0;
                                    log.testCasePassed = 0;
                                    log.testCasePassedCountLavel = "-";
                                    if (log && log.submittedAnswerResult && log.submittedAnswerResult.coding_execution_result) {
                                        log.testCaseResults = angular.copy(log.submittedAnswerResult.coding_execution_result.testCaseResults);
                                        log.codingCompileResponse = angular.copy(log.submittedAnswerResult.coding_execution_result.codingCompileResponse);
                                        log.codingCompileResponse.compilationMessage = $sce.trustAsHtml(log.codingCompileResponse.compilationMessage);
                                        log.codingCompileResponse.stat = log.codingCompileResponse.compilationStatus === 1 ? "Failed" : "Compiled";
                                    }
                                    if (log.testCaseResults) {
                                        _.forEach(log.testCaseResults, function(testCase) {
                                            if (testCase.testCaseResult.toLowerCase() == 'pass') {
                                                log.testCasePassed++;
                                            }
                                            totalExecutionTime += testCase.time;
                                            totalMemoryConsumed += testCase.memory;
                                        });
                                        log.testCasePassedCountLavel = log.testCasePassed + " / " + log.testCaseResults.length;
                                        log.avgExecutionTime = (totalExecutionTime / log.testCaseResults.length).toFixed(5);
                                        log.avgMemoryConsumed = (totalMemoryConsumed / log.testCaseResults.length).toFixed(0);
                                    }
                                });
                            }
                        }
                    },
                    function(res) {
                        console.log(res);
                        return false;
                    }
                );
        }
    }
})();

(function() {
    'use strict';
    angular
        .module('OnlineAssessmentAngular')
        .component('sampleVideoRecording', {
            bindings: {
                "isProctoring": "<",
                "responseData": "&",
                "options": "<"
            },
            templateUrl: 'app/template/default/sampleVideoRecording.tpl.html',
            controller: sampleVideoRecording,
            controllerAs: 'vm'
        });

    function sampleVideoRecording($q, $scope, $window, $log, $timeout, $interval, $sce, webService, assessmentUtility, loginService, proctoringService, growl, $rootScope, faceTracker, faceLandmarks) {
        var vm = this,
            ft = faceTracker,
            loginInfo = loginService.getLoginInfo(),
            tenantId = -1,
            testId = -1,
            candidateId = 0,
            candidateEmail = null,
            growlError = null,
            recordingTime = 60,
            networkFailureCount = 0,
            videoStrmWatch = null,
            recordinCountIntervalObj = null, //In seconds
            isFaceTrackingEnabled = false,
            timerCheckStart = null,
            timerCheckStop = null,
            isSystemSlow = false,
            isAuthenticated = true,
            networkFaliureInfos = [],
            recordedVideos = [],
            recordingStat = {
                isStartedSuccessfully: false,
                initiatedAt: null,
                gotResponseAt: null
            };

        vm.isRecordingStarted = false;
        vm.isRecordingStopped = false;
        vm.isSelfReviewDone = false;
        vm.playbackVideo = '';
        vm.count = recordingTime;
        vm.startRecordingLabel = vm.isProctoring ? "Start recording video" : "Start recording video"; //: "Start recording your answer";
        vm.isErrorOcured = false;

        vm.sampleText = "<p style='line-height:16px;'>Dolphins are marine mammals that are related to whales and porpoises. A marine mammal is one that lives in the water. Dolphins are found all over the world’s oceans as well as in rivers and marshes. Dolphins are carnivores (meat eaters) and feed on fish, squid, and other marine life. They often swim together in groups called “pods.” They are thought to have powerful eyesight and hearing, but do not have a sense of smell.</p>" +
            "<p style='line-height:16px;'>Dolphins come in different sizes. Some are smaller than the average person, but others can be 30 feet long. Dolphins are thought to be very intelligent & communicate with each other using clicks & whistles. All dolphins are powerful swimmers.</p>";

        vm.onSubmit = onSubmit;

        vm.$onInit = function() {
            init();
        }

        function init() {
            tenantId = loginService.getTenantId();
            if (vm.options && vm.options.candidateEmail) {
                candidateEmail = vm.options.candidateEmail;
            }
            if (loginInfo && loginInfo.Config) {
                testId = loginInfo.TestId;
                candidateId = loginInfo.CandidateId;
                isFaceTrackingEnabled = loginInfo.Config.isFaceTrackingEnabled;
            }
        }

        vm.startRecording = function() {
            var isFaceLandmarks = JSON.parse(sessionStorage.getItem('faceLandmarks'));
            if (isFaceLandmarks) {
                ft = faceLandmarks;
            }
            vm.isErrorOcured = false;
            networkFailureCount = 0;
            if (growlError) {
                growlError.destroy();
            }
            var vidElem = document.getElementById("recording-video"),
                rq = {
                    vidElem: vidElem,
                    tenantId: tenantId,
                    testId: testId,
                    candidateEmail: candidateEmail,
                    isAuthenticated: vm.isProctoring
                };
            if (vm.opts && vm.opts.isAuthenticated) {
                rq.vqId = null;
            } else {
                rq.vqId = 0;
            }
            recordingStat.initiatedAt = new Date();
            proctoringService.start(rq)
                .then(function(res) {
                        recordingStat.gotResponseAt = new Date();
                        if (!res || !res.strm) {
                            recordingStat.isStartedSuccessfully = false;
                            $log.log("video recording test:", res);
                            handleRecodingError(res);
                            proctoringService.stop();
                            if (isFaceTrackingEnabled) {
                                ft.stop();
                            }
                            return false;
                        }
                        recordingStat.isStartedSuccessfully = true;
                        if (isFaceTrackingEnabled) {
                            ft.start({ videoElementId: "recording-video" });
                        }
                        registerRecordingStatWatch();
                        proctoringService.setConfig({ 'videoStrmWatch': videoStrmWatch });
                        vm.isRecordingStarted = true;
                        timerCheckStart = new Date();
                        recordinCountIntervalObj = $interval(function() {
                            vm.count -= 1;
                            if (vm.count < 0) {
                                timerCheckStop = new Date();
                                var lagging = timerCheckStop - timerCheckStart;
                                if (lagging > (vm.recordingTime * 1000) + 1999) {
                                    isSystemSlow = true;
                                    handleRecodingError({
                                        onlyDisplayMsg: true,
                                        displayMsg: "Slow System detected."
                                    });
                                }
                                recordinCountIntervalObj && $interval.cancel(recordinCountIntervalObj);
                                recordinCountIntervalObj = null;
                                stopRecording(res);
                            }
                        }, 1000);
                    },
                    function(res) {
                        $log.log(res);
                    });
        };

        function handleRecodingError(res) {
            vm.isRecordingStopped = true;
            vm.isErrorOcured = true;
            vm.responseData({ proceed: false, type: 'video' });
            var errorMsg = "Not able to start recording!";
            if (res && res.displayMsg) {
                errorMsg = res.displayMsg;
            }
            if (!navigator.onLine) {
                errorMsg += "<br>No Internet Connection!";
            } else if (res && !res.isOnline) {
                errorMsg += "<br>Poor Internet Connection! Switch to a better network.";
            }
            if (res && res.displayMsg) {
                errorMsg += "<br>Recording will be started automatically,once network will come back.";
                errorMsg += "<br>Check your Internet connection."
            } else {
                errorMsg += "<br>Try Again.";
            }
            if (res && res.displayMsg && res.onlyDisplayMsg) {
                errorMsg = res.displayMsg;
            }
            networkFaliureInfos.push({
                "timeStamp": new Date(),
                "msg": errorMsg
            });
            growlError = growl.error(errorMsg, {
                disableCloseButton: false,
                onopen: function() {
                    $timeout(function() {
                        document.getElementsByClassName("growl-item")[0].classList.add("growl-error-custom");
                    }, 1);
                }
            });
        }

        function registerRecordingStatWatch() {
            videoStrmWatch = $rootScope.$watch('vidStrmId', function() {
                if (!$rootScope.vidStrm) {
                    networkFailureCount++;
                    var failureRes = {};
                    if (networkFailureCount == 1) {
                        failureRes = {
                            isOnline: false,
                            onlyDisplayMsg: true,
                            displayMsg: "Your network connection is poor.<br>Switch to a better network and retry."
                        };
                        recordinCountIntervalObj && $interval.cancel(recordinCountIntervalObj);
                        recordinCountIntervalObj = null;
                        proctoringService.stop();
                        if (isFaceTrackingEnabled) {
                            ft.stop();
                        }
                        vm.isRecordingStopped = true;
                        vm.count = 0;
                    } else {
                        failureRes = {
                            isOnline: false,
                            displayMsg: "Recording stopped!"
                        };
                    }
                    handleRecodingError(failureRes);
                } else {
                    growlError && growlError.destroy();
                }
            });
        }

        function stopRecording(initProcRes) {
            var checkIfRecordingIsFlawlessUrl = "https://" + initProcRes.recordingServerHost + "/py/proctoring/api/v1/check-if-recording-is-flawless/",
                httpMethodType = "POST",
                canIdOrEmail = candidateId,
                //hostName = location.hostname === "localhost" ? "amsin.hirepro.in" : location.hostname,
                hostName = (location.hostname == 'localhost' ||
                    location.hostname == 'amsin.hirepro.in' ||
                    location.hostname == 'pearson.hirepro.in' ||
                    location.hostname == 'pearson1.hirepro.in' ||
                    location.hostname == 'pearsonstg.hirepro.in' ||
                    location.hostname == 'talentlensstg.hirepro.in' ||
                    location.hostname == 'talentlensstg1.hirepro.in' ||
                    location.hostname == 'qaassesscocubes.hirepro.in' ||
                    location.hostname == 'betaqaassesscocubes.hirepro.in') ? 'amsin.hirepro.in' : 'ams.hirepro.in',
                cnfName = hostName + "-" + tenantId + "-" + candidateId + "-" + testId + "-" + 0,
                header = {
                    "X-ASSESSMENT-SERVER-HOST": hostName
                },
                rqst1 = {
                    "confName": cnfName,
                    "confId": initProcRes.recordingConfId,
                    "durationOfRecordingInSec": recordingTime
                };

            vm.isRecordingStopped = true;
            proctoringService.stop();
            if (isFaceTrackingEnabled) {
                ft.stop();
            }
            if (isSystemSlow) {
                return false;
            }
            if (vm.isProctoring) {
                webService.execute(checkIfRecordingIsFlawlessUrl, rqst1, httpMethodType, null, header)
                    .then(function(res) {
                        if (!res || !res.data || res.data.status === "KO") {
                            handleRecodingError({
                                onlyDisplayMsg: true,
                                displayMsg: "You are experiencing a poor network connection.<br>Try again."
                            });
                            return $q.reject(res);
                        }
                        res = res.data.data;
                        if (!res.recordingSucceeded || !res.playbackLink) {
                            handleRecodingError({
                                onlyDisplayMsg: true,
                                displayMsg: "You are experiencing a poor network connection.<br>Try again."
                            });
                            return $q.reject(res);
                        }
                        $timeout(function() {
                            vm.playbackVideo = $sce.trustAsResourceUrl(res.playbackLink);
                            vm.responseData({ proceed: true, type: 'video' });
                        }, 10);
                    })
                    .catch(function(res) {
                        $log.log(res);
                    });
            } else {
                var urlSample = "videoAnswers",
                    httpMethodTypeSample = "GET",
                    rq = null,
                    headerSample = null,
                    hostNameSample = location.hostname === "localhost" ? "amsin.hirepro.in" : location.hostname,
                    recordedVideoId = hostNameSample + "-" + tenantId + "-" + candidateEmail + "-" + testId;
                // recordedVideoId = hostName + "-" + tenantId + "-" + candidateEmail + "-" + testId;
                urlSample = "https://" + initProcRes.recordingServerHost + "/py/proctoring/api/v1/recorded-file-pathlist-noauth/";
                httpMethodTypeSample = "POST";
                rq = {
                    "testList": [recordedVideoId]
                };
                headerSample = {
                    "X-TEST-AUTHENTICATION": false,
                    "X-TENANT-ID": tenantId,
                    "X-USER-ID": 0,
                    "X-ASSESSMENT-SERVER-HOST": hostNameSample
                };
                webService.execute(urlSample, rq, httpMethodTypeSample, null, headerSample)
                    .then(function(res) {
                        res = res.data.data;
                        if (!res || !res.pathList) {
                            handleRecodingError({
                                onlyDisplayMsg: true,
                                displayMsg: "You are experiencing a poor network connection.<br>Try again."
                            });
                            return $q.reject(res);
                        }
                        var lastRecordedVideo = null;
                        recordedVideos = res.pathList[recordedVideoId].videoLink;
                        lastRecordedVideo = recordedVideos &&
                            recordedVideos.length > 0 &&
                            recordedVideos[recordedVideos.length - 1];
                        var timeOut = $timeout(function() {
                            vm.playbackVideo = $sce.trustAsResourceUrl(lastRecordedVideo);
                        }, 10);
                    }, function(res) {
                        $log.log(res);
                    });
            }
        }

        vm.reStartRecording = function() {
            stopVideo();
            if (vm.isProctoring) {
                vm.responseData({ proceed: false, type: 'video' });
            }
            vm.startRecording();
        };

        function stopVideo() {
            vm.isRecordingStarted = true;
            vm.isRecordingStopped = false;
            vm.isSelfReviewDone = false;
            vm.isCompatible = false;
            vm.playbackVideo = '';
            vm.count = recordingTime;
        }

        function onSubmit() {
            var videoCompatibilityInfo = {
                "networkFaliureInfos": networkFaliureInfos,
                "isSystemSlow": isSystemSlow,
                "recordedVideos": recordedVideos,
                "recordingStat": recordingStat
            };
            vm.responseData({ info: videoCompatibilityInfo });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('OnlineAssessmentAngular')
        .component('questionActionPanel', {
            bindings: {
                currentQuestion: '=',
                options: '<',
                qNav: '='
            },
            templateUrl: 'app/template/default/questionAction.tpl.html',
            controller: questionActionTemplateController,
            controllerAs: 'vm'
        });

    questionActionTemplateController.$inject = ['$scope', '$window', 'assessmentUtility', 'commonQuestionActions', 'assessmentService'];

    function questionActionTemplateController($scope, $window, assessmentUtility, commonQuestionActions, assessmentService) {
        var vm = this;
        vm.isSecureBrowserMandatory = false;
        if(sessionStorage.isSecureBrowserMandatory == 'true') {
            vm.isSecureBrowserMandatory = true;
        }
        vm.ApplicationViewType = sessionStorage.getItem('ApplicationViewType');
        $scope.tm = assessmentUtility;
        assessmentService.questionpaper.get().then(
            function(response) {
                commonQuestionActions.updateQpInfos(response);
                vm.cmnQserv = commonQuestionActions;
                vm.isFirstQIndex = !!commonQuestionActions.isFirstQ();
                vm.currentQuestionIndex = commonQuestionActions.getCurrentQuestionIndex();
                vm.totalQuestionCount = commonQuestionActions.getTotalQuestionCount();
                vm.isAnswerMandatory = !!commonQuestionActions.getIsAnswerMandatory();
                vm.isLastIndex = !!commonQuestionActions.getIsLastIndex();

                //vm.isQForwardNavAllowed = vm.isAnswerMandatory ? !!vm.currentQuestion.isAnswered : !vm.isLastIndex;

                vm.isQBackwardNavAllowed = !vm.cmnQserv.isFirstQ();
            }
        );
        $scope.$watch('tm.timer._time', function(time) {
            var totaltestTime = assessmentUtility.timer.totalTestTime();
            var isLastGroup = angular.fromJson($window.sessionStorage.getItem("isLastGroup"));
            //var activeGrpId = assessmentService.questionpaper.activeGroup.getId();
            var isSwitchedToNextGroup = assessmentUtility.localStorage.getData("isManuallySwitchedToNextGroup");
            var isTimerStarted = $window.sessionStorage.getItem("isTimerStarted");
            var manualRefresh = $window.sessionStorage.getItem("manualRefresh");
            if (isTimerStarted && !isSwitchedToNextGroup && !isLastGroup && commonQuestionActions.getIsGroupWiseTimingEnabled() && time >= totaltestTime) {
                commonQuestionActions.setIsgroupWiseTimeOver(true);
                commonQuestionActions.switchToNextGroup();
            }
        });
        vm.moveToPrevQuestion = commonQuestionActions.moveToPrevQuestion;
        vm.moveToNextQuestion = commonQuestionActions.moveToNextQuestion;
        vm.flagQuestion = commonQuestionActions.flagQuestion;
        /*....Disable Next Button....*/
        $scope.$watch(function() {
            return assessmentUtility.localStorage.getData('isQuestionVideoStarted');
        }, function() {
            var isQuestionVideoStarted = assessmentUtility.localStorage.getData('isQuestionVideoStarted');
            vm.isDisabled = isQuestionVideoStarted === null ? false : isQuestionVideoStarted;
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('OnlineAssessmentAngular')
        .component('answerActionPanel', {
            bindings: {
                'currentQuestion': '=',
                'questionPaper': '=',
                'editorInstance': '=',
                'isDisabled': '<'
            },
            templateUrl: 'app/template/default/answerAction.tpl.html',
            controller: answerActionTemplateController,
            controllerAs: 'vm'
        })
        .component('questionAnswerActionPanel', {
            bindings: {
                'currentQuestion': '=',
                'questionPaper': '='
            },
            templateUrl: 'app/template/default/questionAnswerAction.tpl.html',
            controller: questionAnswerActionTemplateController,
            controllerAs: 'vm'
        })
        .component('questionIndexes', {
            bindings: {
                'traversalAllowed': '=',
                'currentQindex': '=',
                'mandatQCollection': "=",
                'qNav': "="
            },
            templateUrl: 'app/template/default/questionTraverser.tpl.html',
            controller: questionTraverserTemplateController,
            controllerAs: 'vm'
        });

    answerActionTemplateController.$inject = ['commonQuestionActions'];

    function answerActionTemplateController(commonQuestionActions) {
        var vm = this;
        vm.ApplicationViewType = sessionStorage.getItem('ApplicationViewType');
        vm.unAnswerQuestion = function() {
            commonQuestionActions.unAnswerQuestion(vm.currentQuestion, vm.questionPaper, vm.editorInstance);
        };
    }

    questionAnswerActionTemplateController.$inject = ['$scope', '$window', 'assessmentUtility', 'commonQuestionActions', 'assessmentService'];

    function questionAnswerActionTemplateController($scope, $window, assessmentUtility, commonQuestionActions, assessmentService) {
        var vm = this;
        $scope.tm = assessmentUtility;
        // vm.isExecuted = false;
        assessmentService.questionpaper.get().then(
            function(response) {
                commonQuestionActions.updateQpInfos(response);
                vm.cmnQserv = commonQuestionActions;
                vm.isFirstQIndex = commonQuestionActions.isFirstQ();
                vm.currentQuestionIndex = commonQuestionActions.getCurrentQuestionIndex();
                vm.totalQuestionCount = commonQuestionActions.getTotalQuestionCount();
                vm.isAnswerMandatory = commonQuestionActions.getIsAnswerMandatory();
                vm.isLastIndex = commonQuestionActions.getIsLastIndex();
            }
        );
        $scope.$watch('tm.timer._time', function(time) {
            var totaltestTime = assessmentUtility.timer.totalTestTime();
            var isLastGroup = angular.fromJson($window.sessionStorage.getItem("isLastGroup"));
            //var activeGrpId = assessmentService.questionpaper.activeGroup.getId();
            var isSwitchedToNextGroup = assessmentUtility.localStorage.getData("isManuallySwitchedToNextGroup");
            if (!isSwitchedToNextGroup && !isLastGroup && commonQuestionActions.getIsGroupWiseTimingEnabled() && time === totaltestTime) {
                commonQuestionActions.setIsgroupWiseTimeOver(true);
                commonQuestionActions.switchToNextGroup();
            }
        });
        vm.moveToPrevQuestion = commonQuestionActions.moveToPrevQuestion;
        vm.moveToNextQuestion = commonQuestionActions.moveToNextQuestion;
        vm.unAnswerQuestion = function() {
            commonQuestionActions.unAnswerQuestion(vm.currentQuestion, vm.questionPaper, vm.editorInstance);
        };
    }

    questionTraverserTemplateController.$inject = ['$timeout', '$state', 'assessmentService', 'assessmentUtility', 'loginService', 'commonQuestionActions'];

    function questionTraverserTemplateController($timeout, $state, assessmentService, assessmentUtility, loginService, commonQuestionActions) {
        var vm = this;
        var loginInfo = loginService.getLoginInfo();
        var testConfig = loginInfo.Config;
        vm.isIndexTraversingAllowed = !testConfig.isAnsMandt;
        vm.GroupWiseTimingEnabled = loginInfo.Config ? loginInfo.Config.isGroupWiseTimingEnabled || loginInfo.Config.IsUserGroupChoiceEnable : false;
        var paramObj = assessmentUtility.getSateParameters($state.params);
        if (paramObj) {
            vm.alias = paramObj.alias;
        }
        vm.testConfig = {
            IsFlagAllowed: false
        };
        vm.activeGrpId = assessmentService.questionpaper.activeGroup.getId();
        vm.flagQuestion = commonQuestionActions.flagQuestion;
        vm.isMediaQueston = loginInfo.ContainsMediaQuestion ? true : false;
        vm.setOffSet = function() {
            // var offSet = sessionStorage.getItem('sideIndexOffSet') || 0;
            // var ele = angular.element(document.getElementById('side-index-panel'));
            // ele.prop('scrollTop', parseInt(offSet));
            var currentIndexBar = angular.element(document.getElementsByClassName('side-index-bar active')[0]);
            if (currentIndexBar.prop('offsetTop') > 481 / 2) {
                var ele = angular.element(document.getElementById('side-index-panel'));
                var calOffsetTop = currentIndexBar.prop('offsetTop');
                if (currentIndexBar.prop('offsetTop') > (481 * 1.5)) {

                }
                calOffsetTop -= (481 / 2);
                if (calOffsetTop >= 0) {
                    ele.prop('scrollTop', calOffsetTop);
                }
            }

        };
        vm.goToQuestion = function(qIndex) {
            vm.currentQindex = qIndex;
            if (!vm.isIndexTraversingAllowed) {
                return false;
            }
            /*$state.go('assess.loadTest', { 'questionIndex': (qIndex) }, { location: 'replace' }).then(function(data) {
                assessmentUtility.scrollToElement();
            });*/
            var activeQindex = assessmentUtility.getActiveQuestionIndex();
            if (activeQindex === qIndex) {
                return false;
            }
            commonQuestionActions.showQuestion(qIndex);
            // var ele = angular.element(document.getElementById('side-index-panel'));
            // sessionStorage.setItem('sideIndexOffSet', ele.prop('scrollTop'));
        };
        vm.isActiveGroup = function(q) {
            return !vm.GroupWiseTimingEnabled || vm.activeGrpId == q.gpId;
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('OnlineAssessmentAngular')
        .component('drawIo', {
            bindings: {
                question: '<',
                attachImage: '&'
            },
            templateUrl: 'app/template/default/drawio.tpl.html',
            controller: drawIOController,
            controllerAs: 'vm'
        });

    function drawIOController($sce, $http, fileIOHelper, blockUI) {
        var vm = this,
            loadDrawImage = null;

        vm.drawioUrl = null;

        vm.saveDrawImage = saveDrawImage;
        vm.$onDestroy = onDestroy;

        vm.$onInit = function() {
            active();
        }

        function active() {
            // vm.fileToLoad = '';
            if (vm.question && vm.question.ansFiles) {
                vm.fileToLoad = vm.question.ansFiles[0];
            } else if (vm.question && vm.question.dataSetJson && vm.question.dataSetJson.questionDataSet && vm.question.dataSetJson.questionDataSet[0].fileUrl) {
                vm.fileToLoad = vm.question.dataSetJson.questionDataSet[0].fileUrl;
            }
            console.log('activate', vm.fileToLoad);
            if (vm.fileToLoad) {
                if (vm.fileToLoad.indexOf('s3-ap-southeast-1.amazonaws.com') > -1) {
                    vm.fileToLoad = vm.fileToLoad.replace('https://s3-ap-southeast-1.amazonaws.com/', '/s3_cached/');
                }
                $http.get(vm.fileToLoad, { responseType: 'blob' })
                    .then(function(response) {
                        fileIOHelper.blobToBase(response.data).then(function(res) {
                            vm.imgFile = res;
                            setDrawIO();
                        });
                        // var reader = new FileReader();
                        // reader.readAsDataURL(response.data);
                        // reader.onloadend = function() {
                        //     var base64data = reader.result;
                        //     console.log(base64data);
                        //     loadDrawImage = base64data;
                        //     vm.imgFile = loadDrawImage;
                        // };
                        // setDrawIO();
                    });
            } else {
                setDrawIO();
            }
        }

        function setDrawIO() { //?embed=1&spin=1&modified=unsavedChanges&sb=0&proto=json&configure=0&nowarn=1 
            var drawioUrl = '/drawio/?embed=1&ui=atlas&spin=1&modified=unsavedChanges&proto=json&configure=1';
            vm.drawioUrl = $sce.trustAsResourceUrl(drawioUrl);
            addEventListenerToWindow();
        }

        function addEventListenerToWindow() {
            // var drawioIframeDiv = document.getElementById("drawioIframeDiv");
            // if(drawioIframeDiv.removeEventListener) {
            //     drawioIframeDiv.removeEventListener('message', setDrawSetup);
            // } else if(drawioIframeDiv.detachEvent) {
            //     drawioIframeDiv.detachEvent('message', setDrawSetup);
            // }
            window.addEventListener('message', setDrawSetup);
        }

        function setDrawSetup(evt) {
            var iframe = document.getElementById('drawioIframe'),
                s3URL;
            // if (evt.data.length > 0 && evt.source == source.drawIoWindow)
            if (evt.data.length > 0) {
                var msg = JSON.parse(evt.data);
                if (msg.event == 'configure') {
                    //"flowchart;general;uml" libraries: ["flowchart","general","uml"]   enabledLibraries: ["flowchart","general","uml"]
                    iframe.contentWindow.postMessage(JSON.stringify({ action: 'configure', config: { "css": ".geTabContainer, .geMenubarContainer {display: none !important;} .geItem[title='Language'], .geMenubarContainer .geMenubar, a[title='Exit'] { display: none !important; } .geBigButton { margin-right: 10px;} .geSidebarContainer:not(.geSidebarFooter), .geDiagramContainer, .geHsplit { top: 41px !important;} .geToolbarContainer { top: 0px !important;}" } }), '*');
                }
                // Received if the editor is ready
                else if (msg.event == 'init') {
                    // Sends the data URI with embedded XML to editor
                    // source.drawIoWindow.postMessage(JSON.stringify({action: 'load', xmlpng: source.getAttribute('src')}), '*');
                    // if (vm.loadDrawImage) {
                    // loadDrawImage = "data:image/png;base64,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";
                    iframe.contentWindow.postMessage(JSON.stringify({ action: 'load', xmlpng: vm.imgFile }), '*');
                    // }
                }
                // Received if the user clicks save
                else if (msg.event == 'save') {
                    // Sends a request to export the diagram as XML with embedded PNG
                    // source.drawIoWindow.postMessage(JSON.stringify({action: 'export', format: 'xmlpng', spinKey: 'saving'}), '*');
                    iframe.contentWindow.postMessage(JSON.stringify({ action: 'export', format: 'xmlpng', xml: msg.xml, spinKey: 'saving' }), '*');
                }
                // Received if the export request was processed
                else if (msg.event == 'export') {
                    // Updates the data URI of the image
                    // var svg = atob(msg.data.substring(msg.data.indexOf(',') + 1));
                    // source.setAttribute('src', msg.data);
                    blockUI.start();
                    fileIOHelper.dataURItoBlob(msg.data, "drawAnswer.png").then(function(res) {
                        var fd = new FormData();
                        fd.append('file', res);
                        fileIOHelper.uploadToTemp(fd).then(function(res) {
                            if (res && res.length > 0) {
                                s3URL = res[0];
                                vm.attachImage({ fileUrls: s3URL });
                            }
                            blockUI.stop();
                        });
                    });
                }
                // Received if the user clicks exit or after export
                if (msg.event == 'exit') {
                    // Closes the editor
                    // window.removeEventListener('message', receive);
                    // source.drawIoWindow.close();
                    // source.drawIoWindow = null;
                    close();
                }
            }
        }

        function saveDrawImage() {
            var iframe = document.getElementById('drawioIframe');
            iframe.contentWindow.postMessage(JSON.stringify({ action: 'save', format: 'xmlpng', spinKey: 'saving' }), '*');
        }

        function onDestroy() {
            // var drawioIframeDiv = document.getElementById("drawioIframeDiv");
            if (window.removeEventListener) {
                window.removeEventListener('message', setDrawSetup);
            } else if (window.detachEvent) {
                window.detachEvent('message', setDrawSetup);
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('OnlineAssessmentAngular')
        .component('codingExecutionPanel', {
            bindings: {
                'currentQuestion': '=',
                'editorInstance': '=',
                'isAccordianOpen': '=',
                'saveCodeHistory': '&',
                'isExecuting': '='
            },
            // templateUrl: 'app/template/default/codingExecutionPanel.tpl.html',
            templateUrl: 'app/template/default/codingExecution.tpl.html',
            controller: codingExecutionTemplateController,
            controllerAs: 'vm'
        });

    function codingExecutionTemplateController(growl, commonQuestionActions, $log, loginService, assessmentUtility, $scope, CaptureCodeActivitySvc, commonService, webService) {
        var vm = this,
            testId = -1,
            candidateId = -1,
            ls = assessmentUtility.localStorage,
            loginInfo = loginService.getLoginInfo(),
            allowedFileExtensionForAnsAttachment = ".gif,.png,.jpg,.jpeg,.doc,.docx,.rtf,.pdf,.txt,.xls,.xlsx,.csv,.zip,.rar,.7z,.gz,.r,.ipynb,.ppt,.pps,.pptx,.ods,.rmd,.py,.json";
        vm.eveluationMode = {
            testCases: false,
            customInput: false
        };
        vm.allowedFileSize = 5; // In MB
        vm.customInputVal = null;
        vm.isExecuting = false;
        vm.isExecuted = false;
        vm.isButtonExecuteEnabled = false;
        vm.disableCustomInput = false;
        vm.testAgainstInputLabel = 'Test against custom input';
        vm.compileAndExecuteButtonLabel = " Compile & Execute";

        /*component onInit life hook*/
        vm.$onInit = function() {
            vm.isAccordianOpen = _.size(vm.currentQuestion.selectedAns) > 0 ||
                vm.currentQuestion.isAnswered ||
                _.size(vm.currentQuestion.codingLangs) === 1;

            if (loginInfo && loginInfo.Config) {
                candidateId = loginInfo.CandidateId;
                testId = loginInfo.TestId;
            }

            /*...............Evaluation Method Type...............*/
            //Auto Evaluation..........
            if (vm.currentQuestion.evaluationMethodtype === 0) {
                vm.eveluationMode.testCases = true;
                vm.eveluationMode.customInput = true;
            }
            //Manual with Compiler Evaluation..........
            else if (vm.currentQuestion.evaluationMethodtype === 1) {
                vm.eveluationMode.testCases = false;
                vm.eveluationMode.customInput = true;
            }
            //Manual without Compiler Evaluation..........
            else if (vm.currentQuestion.evaluationMethodtype === 2) {
                vm.eveluationMode.testCases = false;
                vm.eveluationMode.customInput = false;
            }

            //sql type question.......
            if (vm.currentQuestion.codingQuestionSubTypeText === 'SQLProgramming') {
                vm.compileAndExecuteButtonLabel = " Execute";
                vm.eveluationMode.customInput = false;
            }
            vm.isButtonExecuteEnabled = vm.eveluationMode.testCases || vm.eveluationMode.customInput;
        }


        vm.execute = function(isTestCaseExecution) {
            vm.isErrorOccured = false;
            vm.isExecuted = false;
            vm.isExecuting = true;
            vm.testcaseResultCollection = null;
            vm.isCompilationError = false;
            vm.disableCustomInput = true;
            if (isTestCaseExecution) {
                vm.testCaseExecutionMessage = "Executing Test Cases...";
                vm.isVisibleTestCaseExecutionMessage = true;
            }
            var isExecutionAgainstTestCases = !vm.isCustomInputChecked && vm.eveluationMode.testCases;
            vm.onlyCompilation = (vm.currentQuestion.evaluationMethodtype === 1) && !vm.isCustomInputChecked;
            commonQuestionActions.execute(
                    vm.editorInstance,
                    vm.currentQuestion,
                    vm.customInputVal,
                    isExecutionAgainstTestCases)
                .then(
                    function(res) {
                        /*..........code replay......*/
                        CaptureCodeActivitySvc.setEventsSequenceWithQuestionId(vm.currentQuestion.id, _.assign({}, _.chain(res).get('response').omit(['status', 'statusId']).value(), {
                            type: 'codeExcecuteResult',
                            t: new Date().getTime()
                        }));
                        /*.........................*/
                        vm.compilationMsg = "NA";
                        vm.executionStat = "NA";
                        vm.time = 0;
                        vm.memory = 0;
                        vm.lang = "NA";
                        vm.tcRslts = null;
                        vm.input = null;
                        vm.yourOutput = null;
                        vm.expectedOutput = null;

                        var tcStdout = null;

                        if (!res && !res.response) {
                            return null;
                        }
                        vm.isExecuted = true;
                        res = res.response;
                        vm.lang = res.languageText;
                        if (res.codingCompileResponse) {;
                            vm.compilationMsg = res.codingCompileResponse.compilationMessage;
                            /*..............Compilation Message color.............*/
                            //res.codingCompileResponse.compilationStatus = 0 //Success...
                            vm.compilationMessageColor = 'color-green'; //Success
                            if (res.codingCompileResponse.compilationStatus === 1) { //Error...
                                vm.compilationMessageColor = 'color-red';
                                vm.isCompilationError = true;
                            } else if (res.codingCompileResponse.compilationStatus === 2) { //Warning...
                                vm.compilationMessageColor = 'color-orange';
                            }
                            tcStdout = res.codingCompileResponse.output;
                        }
                        /*..............Compilation error............*/
                        if (vm.isCompilationError) {
                            vm.showTcRslt({
                                time: 0,
                                memory: 0,
                                testCaseResult: "Fail",
                                reason: "Compilation error"
                            });
                        }
                        /*..............Only Compile(Manual with compiler-->not against custom input)..........*/
                        if (vm.onlyCompilation && tcStdout && tcStdout.length > 0) {
                            tcStdout = tcStdout[0];
                            vm.showTcRslt({
                                time: tcStdout.time,
                                memory: tcStdout.memory,
                                reason: "Executed Successfully",
                                output: tcStdout.stdOut,
                                error: tcStdout.error
                            });
                        }
                        /*............Execution against Custom Input.............*/
                        if (!vm.onlyCompilation && tcStdout && tcStdout.length > 0) {
                            tcStdout = tcStdout[0];
                            vm.tcRslts = [{
                                time: tcStdout.time,
                                memory: tcStdout.memory,
                                reason: "Executed Successfully",
                                sysInput: vm.customInputVal,
                                output: tcStdout.stdOut,
                                error: tcStdout.error
                            }];
                        }
                        /*............Execution against Test cases.............*/
                        if (res.testCaseResults && res.testCaseResults.length > 0) {
                            vm.tcRslts = _.sortBy(res.testCaseResults, "isSystem");
                        }
                    },
                    function(res) {
                        console.log(res);
                        vm.isErrorOccured = true;
                        vm.errorMsg = "Something went wrong!";
                    }
                )
                .finally(function() {
                    vm.isExecuting = false;
                    vm.disableCustomInput = false;
                });
        };

        vm.showTcRslt = function(tcRslt) {
            if (tcRslt && tcRslt.testCaseResult === "Pass") {
                tcRslt.reason = "Test case passed"
            }
            vm.time = tcRslt.time;
            vm.memory = tcRslt.memory;
            vm.tcRsltStat = tcRslt.testCaseResult;
            vm.tcRsltReason = tcRslt.reason;
            vm.errorMsg = (tcRslt.error && tcRslt.error.trim() !== "") ? tcRslt.error : null;
            vm.isSystem = tcRslt.isSystem;
            if (!vm.isCompilationError) {
                vm.yourOutput = tcRslt.output ? tcRslt.output : "NA";
                if (!vm.onlyCompilation) {
                    vm.input = tcRslt.sysInput ? tcRslt.sysInput : "NA";
                    vm.expectedOutput = vm.isCustomInputChecked ? null : (tcRslt.sysOutput ? tcRslt.sysOutput : "NA");
                }
            }
        };

        vm.clearCustomInput = function() {
            resetFlags();
        };

        vm.saveCode = function() {
            vm.execute(vm.isExecuteAgainstTestCases);
            vm.saveCodeHistory();
        };

        $scope.$watch('[vm.currentQuestion.selectedLanguage.languageId,vm.currentQuestion.isAnswered]', function() {
            clearCodeExecutionPanel();
        });

        function clearCodeExecutionPanel() {
            vm.isCustomInputChecked = false;
            resetFlags();
        }

        function resetFlags() {
            vm.isErrorOccured = false;
            vm.customInputVal = null;
            vm.isExecuted = false;
        }

        var getFormData = function(files) {
            if (_.size(files) == 0) {
                return null;
            }
            var formdata = new FormData();
            for (var i = 0; i < files.length; i++) {
                var file = files[i];
                formdata.append("fileAttachment", file, file.name);
            }
            if (!formdata) {
                growl.error("Invalid file or file extension", { ttl: 4000, disableCountDown: true });
            }
            return formdata;
        };

        var getAttachmentUrls = function(res, prop) {
            var fileUrls = [];
            res = res.successList || res.SuccessList || res;
            if (res[prop]) {
                fileUrls.push(res[prop]);
            } else if (_.size(res) > 0) {
                _.map(res, function(file) {
                    fileUrls.push(file[prop]);
                });
            }
            return fileUrls;
        };

        vm.isSwitchingFromCurrentQuestionEnable = true;
        vm.uploadRelatedFiles = function(evt) {
            var errorUploadedAttachment = "",
                files = evt.target.files,
                data = getFormData(files);
            evt.target.value = '';
            if (commonService.testIsOnlinePreview() || !data) {
                return false;
            }
            vm.isSwitchingFromCurrentQuestionEnable = false;
            var constraint = {
                "fileExtentions": allowedFileExtensionForAnsAttachment,
                "fileSizeLimit": (vm.allowedFileSize * 1024)
            };
            webService.execute("uploadFileToS3WithVirusScan", data, "POST", null, null, constraint)
                .then(function(res) {
                        if (!res || !res.data) {
                            $log.error("Unable to upload file!");
                            return false;
                        }
                        res = res.data;
                        if (res.error && res.status == 'KO') {
                            errorUploadedAttachment = res.error.errorDescription || "File upload failed";
                            growl.error(errorUploadedAttachment, { ttl: 4000, disableCountDown: true });
                            vm.isSwitchingFromCurrentQuestionEnable = true;
                            return false;
                        }
                        if (res.data) {
                            $log.log("File Uploaded Successfully");
                            //console.log(response.data.data.fileUrl);
                            var fileUrls = getAttachmentUrls(res.data, "fileUrl");
                            persistenceSave(fileUrls);
                        }
                    },
                    function(res) {
                        growl.error("Error occurred when Uploading File", { ttl: 4000, disableCountDown: true });
                        vm.isSwitchingFromCurrentQuestionEnable = true;
                        return false;
                    }
                );
        };

        function persistenceSave(fileUrls) {
            var aliasText = assessmentUtility.getAlias(),
                persistentSaveRq = [];
            if (aliasText) {
                aliasText = aliasText.toLowerCase();
            }
            if (_.size(fileUrls) == 0) {
                return false;
            }
            _.forEach(fileUrls, function(fileUrl) {
                var rq = {
                    "origFileUrl": fileUrl,
                    "relativePath": aliasText + "/testResultAnswers/" + testId + "/" + candidateId,
                    "isSync": true
                };
                rq.metaData = {
                    "timeStamp": new Date()
                };
                persistentSaveRq.push(rq);
            });
            if (commonService.testIsOnlinePreview()) {
                return false;
            }
            vm.isSwitchingFromCurrentQuestionEnable = false;
            webService.execute("persistentSave", persistentSaveRq)
                .then(
                    function(response) {
                        if (response) {
                            $log.log("Files saved Successfully");
                            growl.success("File Uploaded Successfully", { ttl: 4000, disableCountDown: true });
                            var s3Urls = getAttachmentUrls(response.data.data, "s3_url");
                            appendAttachmentsToQuestionObj(s3Urls);
                        }
                    },
                    function() {
                        $log.log("Error occurred when persisting File");
                    }
                )
                .finally(function() {
                    vm.isSwitchingFromCurrentQuestionEnable = true;
                });
        }

        vm.removeUploadedFile = function(fileIndex) {
            vm.currentQuestion.ansFiles.splice(fileIndex, 1);
            updateQuestionPaper();
        };

        function updateQuestionPaper() {
            var questionpaper = ls.getData("questionPaper"),
                mandatQs = questionpaper.mandatoryQuestionCollection;
            _.forEach(mandatQs, function(q) {
                if (vm.currentQuestion.id === q.id) {
                    q.ansFiles = vm.currentQuestion.ansFiles;
                }
            });
            ls.setData("questionPaper", questionpaper);
        }

        var appendAttachmentsToQuestionObj = function(fileUrls) {
            vm.currentQuestion.ansFiles = vm.currentQuestion.ansFiles || [];
            vm.currentQuestion.ansFiles = _.concat(vm.currentQuestion.ansFiles, fileUrls);
            updateQuestionPaper();
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('OnlineAssessmentAngular')
        .component('hpChatting', {
            bindings: {
                'chatUserId': '<',
                'sendMessage': '&'
            },
            templateUrl: 'app/template/default/chat.tpl.html',
            controller: chatController,
            controllerAs: 'vm'
        });

    function chatController($rootScope, $scope, $timeout, loginService, webService, socketService) {
        var vm = this,
            adminUserId = 0,
            candidateId = 0,
            chatWillCloseAfter = 300, //sec
            loginInfo = loginService.getLoginInfo(),
            socket = null,
            stateChangeSuccess_rootScope = null,
            testId = 0,
            userInput = null;
        // newMessage = '',

        vm.showIcon = true;
        vm.removeChat = false;

        vm.openElement = openElement;
        vm.closeElement = closeElement;
        vm.sendNewMessage = sendNewMessage;
        vm.onMetaAndEnter = onMetaAndEnter;

        vm.$onInit = function() {
            vm.chatUserId = vm.chatUserId;
            active();
            selfDestroy();
        };

        function active() {
            if (loginInfo) {
                candidateId = loginInfo.CandidateId;
                testId = loginInfo.TestId;
            }
            if (!vm.chatList) {
                vm.chatList = [];
            }
            startMyChat();
        }

        function startMyChat() {
            var data = {
                chatUserId: vm.chatUserId,
                eventCallback: {
                    chat: showMessage,
                    chatStat: handleOnDelivered
                }
            };
            socket = socketService.init(data);
        }

        function openElement() {
            vm.showIcon = false;
        }

        function closeElement() {
            vm.showIcon = true;
        }

        function selfDestroy() {
            stateChangeSuccess_rootScope = $rootScope.$on("$stateChangeSuccess", function(event, toState, toParams, fromState, fromParams) {
                var currentStateName = toState.name;
                if (currentStateName === "submitConfirmation") {
                    $timeout(function() {
                        vm.removeChat = true;
                        socketService.close(1000, "EndTest");
                    }, chatWillCloseAfter * 1000);
                    $scope.$on('$destroy', stateChangeSuccess_rootScope);
                }
            });
        }

        function sendNewMessage() {
            userInput = userInput ? userInput : angular.element(document.querySelector(".text-box"));
            var newMessage = userInput.html(), //.replace(/\<div\>|\<br.*?\>/ig, '\n').replace(/\<\/div\>/g, '').trim().replace(/\n/g, '<br>');
                guid = window.getUUID(),
                data = {
                    guid: guid,
                    msgType: "chat",
                    msgBody: newMessage
                };
            if (!newMessage) {
                return;
            }
            socketService.sendMessage(data);
            vm.chatList.push({
                msg: newMessage,
                guid: guid,
                status: 'pending',
                send: true,
                timeStamp: new Date()
            });
            userInput.html('');
        }

        function onMetaAndEnter(event) {
            if (event.keyCode == 13 && !(event.metaKey || event.shiftKey)) {
                event.preventDefault();
                sendNewMessage();
            }
        }

        function showMessage(msg) {
            vm.chatList.push({
                msg: msg.body.text,
                send: false,
                timeStamp: new Date()
            });
            if (vm.showIcon == true) {
                openElement();
            }
        }

        function handleOnDelivered(res) {
            var chatObj = _.filter(vm.chatList, { "guid": res.guid })[0],
                rqst = null;
            if (!res || !res.body || !res.body.userId || !chatObj) {
                return false;
            }
            rqst = {
                deliverTo: res.body.userId,
                namespace: "generic_msg_delivery",
                guid: res.guid,
                message: chatObj.msg,
                messageType: "chat"
            };
            webService.execute("saveChatDataForTu", rqst)
                .then(function(res) {
                    console.log("chat_saveChatDataForTu_success", res);
                }, function(res) {
                    console.log("chat_saveChatDataForTu_error", res);
                });
        }
    }
})();

(function(){
    var consolelog = console.log;
    console.log = function (message) {
        storeConsoleinTemp(arguments, 'log');
        if(sessionStorage.donotshowinconsole == 'true') {
            return;
        }
        consolelog.apply(console, arguments);
    };

    var consoleinfo = console.info;
    console.info = function (message) {
        storeConsoleinTemp(arguments, 'info');
        if(sessionStorage.donotshowinconsole == 'true') {
            return;
        }
        consoleinfo.apply(console, arguments);
    };

    var consolewarn = console.warn;
    console.warn = function (message) {
        storeConsoleinTemp(arguments, 'warn');
        if(sessionStorage.donotshowinconsole == 'true') {
            return;
        }
        consolewarn.apply(console, arguments);
    };

    var consoleerror = console.error;
    console.error = function (message) {
        storeConsoleinTemp(arguments, 'error');
        if(sessionStorage.donotshowinconsole == 'true') {
            return;
        }
        consoleerror.apply(console, arguments);
    };

    //  This code is for capturing console logs from third party tests (which are on same domain or are proxied via our lb)

    setInterval(function() {
        if(sessionStorage.consolelogEnabled == 'true') {
            var iframe = document.getElementById('thirdPartyIframe');
            if(iframe) {
                try{
                    var window1 = iframe.contentWindow;
                    if(!window1.__consoleLogoverridden) {
                        window1.__consoleLogoverridden = true;
                        var consolelog = window1.console.log;
                        window1.console.log = function (message) {
                            storeConsoleinTemp(arguments, 'TPlog');
                            if(sessionStorage.donotshowinconsole == 'true') {
                                return;
                            }
                            consolelog.apply(window1.console, arguments);
                        };

                        var consoleinfo = window1.console.info;
                        window1.console.info = function (message) {
                            storeConsoleinTemp(arguments, 'TPinfo');
                            if(sessionStorage.donotshowinconsole == 'true') {
                                return;
                            }
                            consoleinfo.apply(window1.console, arguments);
                        };

                        var consolewarn = window1.console.warn;
                        window1.console.warn = function (message) {
                            storeConsoleinTemp(arguments, 'TPwarn');
                            if(sessionStorage.donotshowinconsole == 'true') {
                                return;
                            }
                            consolewarn.apply(window1.console, arguments);
                        };

                        var consoleerror = window1.console.error;
                        window1.console.error = function (message) {
                            storeConsoleinTemp(arguments, 'TPerror');
                            if(sessionStorage.donotshowinconsole == 'true') {
                                return;
                            }
                            consoleerror.apply(window1.console, arguments);
                        };
                        window1.onerror = function (msg, url, lineNo, columnNo, error) {
                            try {
                                url = url ? url : '';
                                msg = msg ? msg : '';
                                if(sessionStorage.consolelogEnabled == 'true') {
                                    var string = msg.toLowerCase();
                                    var substring = "script error";
                                    var obj = {};
                                    if (string.indexOf(substring) > -1){
                                        obj = {
                                            time: new Date(),
                                            page: location.href.replace('https://', ''),
                                            message: msg.replace(/https:\/\//g, ""),
                                            activity: 'Werror'
                                        };
                                    }
                                    else {
                                        obj = {
                                            time: new Date(),
                                            page: url.replace('https://', ''),
                                            message: msg.replace(/https:\/\//g, ""),
                                            lineNo: lineNo,
                                            columnNo: columnNo,
                                            activity: 'WTPerror',
                                            error: JSON.circularstringify(error)
                                        };
                                    }
                                    if (!window._consolelogs) {
                                        window._consolelogs = [];
                                    }
                                    window._consolelogs.push(obj);
                                }
                            } catch(ex){}
                        }
                    }
                } catch(ex) {}
            }
        }
    }, 1000);

    var storeConsoleinTemp = function(message, type) {
        try {
            if(sessionStorage.consolelogEnabled == 'true') {
                var obj = {
                    time: new Date(),
                    page: location.href.replace('https://', ''),
                    activity: 'C' + type
                };
                var temp = message;
                if(_.isArguments(message)) {
                    temp = {};
                    _.each(message, function(a,b) {
                        temp[b] = a;
                    });
                }
                obj.message = JSON.circularstringify(temp).replace(/https:\/\//g, "");
                if (!window._consolelogs) {
                    window._consolelogs = [];
                }
                window._consolelogs.push(obj);
            }
        } catch(ex){}
    }

    window.onerror = function (msg, url, lineNo, columnNo, error) {
        try {
            url = url ? url : '';
            msg = msg ? msg : '';
            if(sessionStorage.consolelogEnabled == 'true') {
                var string = msg.toLowerCase();
                var substring = "script error";
                var obj = {};
                if (string.indexOf(substring) > -1){
                    obj = {
                        time: new Date(),
                        page: location.href.replace('https://', ''),
                        message: msg.replace(/https:\/\//g, ""),
                        activity: 'Werror'
                    };
                }
                else {
                    obj = {
                        time: new Date(),
                        page: url.replace('https://', ''),
                        message: msg.replace(/https:\/\//g, ""),
                        lineNo: lineNo,
                        columnNo: columnNo,
                        activity: 'Werror',
                        error: JSON.circularstringify(error)
                    };
                }
                if (!window._consolelogs) {
                    window._consolelogs = [];
                }
                window._consolelogs.push(obj);
            }
        } catch(ex){}
    }

    JSON.circularstringify = function (json) {
      var cache = [];
      return JSON.stringify(json, function (key, value) {
        if (typeof value === 'object' && value !== null) {
          if (cache.indexOf(value) !== -1) {
            return;
          }
          cache.push(value);
        }
        return value;
      });
    }
})();
(function() {
    'use strict';

    angular
        .module('OnlineAssessmentAngular')
        .factory('webService', webService);

    function webService($http, $q) {
        var apiInfoCollection = {
            GetCompanyInfo: {
                url: '/py/assessment/htmltest/api/v1/company-info/',
                config: {
                    isLambda: true,
                    removeBlockUI: false,
                    addDebugTimeStamp: true
                }
            },
            LoginToTest: {
                url: '/py/assessment/htmltest/api/v2/login_to_test/',
                config: {
                    isLambda: true,
                    removeBlockUI: false,
                    addDebugTimeStamp: true
                }
            },
            getTestBasicInfo: {
                url: '/py/assessment/htmltest/api/v1/get-test-basic-info/',
                config: {
                    isLambda: true,
                    removeBlockUI: false,
                    addDebugTimeStamp: true
                }
            },
            initiateTua: {
                url: '/py/assessment/htmltest/api/v1/initiate-tua/',
                config: {
                    isLambda: true,
                    removeBlockUI: false,
                    addDebugTimeStamp: true
                }
            },
            LoadTest: {
                url: '/py/assessment/htmltest/api/v1/loadtest/',
                config: {
                    isLambda: true,
                    removeBlockUI: false,
                    addDebugTimeStamp: true
                }
            },
            SubmitTestResult: {
                url: '/py/assessment/htmltest/api/v1/submitTestResult/',
                config: {
                    isLambda: true,
                    removeBlockUI: false,
                    addDebugTimeStamp: true
                }
            },
            finalSubmitTestResult: {
                url: '/py/assessment/htmltest/api/v1/finalSubmitTestResult/',
                config: {
                    isLambda: true,
                    removeBlockUI: false,
                    addDebugTimeStamp: true
                }
            },
            GetTestResult: {
                url: '/py/assessment/htmltest/api/v1/getTestResult/',
                config: {
                    isLambda: true,
                    removeBlockUI: false,
                    addDebugTimeStamp: true
                }
            },
            GetAllAppPreference: {
                url: '/py/common/common_app_utils/api/v1/getAppPreference/',
                config: {
                    isLambda: true,
                    removeBlockUI: false,
                    addDebugTimeStamp: true
                }
            },
            CodingCompile: {
                url: '/py/assessment/htmltest/api/v1/code-compiler/',
                config: {
                    isLambda: true,
                    removeBlockUI: false,
                    addDebugTimeStamp: true
                }
            },
            GetLoginCredentialsByCandidateIdOrEmail: {
                url: '/py/assessment/testuser/api/v1/fetch_tu_cred/',
                config: {
                    isLambda: true,
                    removeBlockUI: false,
                    addDebugTimeStamp: true
                }
            },
            setloginstats: {
                url: '/py/assessment/htmltest/api/v1/setloginstats/',
                config: {
                    isLambda: true,
                    removeBlockUI: false,
                    addDebugTimeStamp: true
                }
            },
            GetTestSecurityKeyEncryptString: {
                url: '/py/assessment/htmltest/api/v1/validate/test-security/',
                config: {
                    isLambda: true,
                    removeBlockUI: false,
                    addDebugTimeStamp: true
                }
            },
            generateS3Form: {
                url: '/py/common/filehandler/api/v2/generate-form-for-saving-snapshots/',
                config: {
                    isLambda: true,
                    removeBlockUI: false,
                    addDebugTimeStamp: false
                }
            },
            generateS3MultipleForms: {
                url: '/py/common/filehandler/api/v1/generate-forms-for-snapshots/',
                config: {
                    isLambda: true,
                    removeBlockUI: false,
                    addDebugTimeStamp: false
                }
            },
            persistentSave: {
                url: '/py/common/filehandler/api/v2/persistent-save/',
                config: {
                    isLambda: true,
                    removeBlockUI: false,
                    addDebugTimeStamp: false
                }
            },
            /*uploadFileToS3: {
                url: '/py/common/filehandler/api/v3/upload/',
                config: {
                    isLambda: true,
                    removeBlockUI: false,
                    addDebugTimeStamp: false
                }
            },*/
            uploadGoldenImageForTraining: {
                url: '/py/common/filehandler/api/v2/generate-form-for-saving-snapshots/',
                config: {
                    isLambda: true,
                    removeBlockUI: false,
                    addDebugTimeStamp: false
                }
            },
            uploadFileToS3WithOutVirusScan: {
                url: '/py/common/filehandler/api/v3/upload/',
                config: {
                    isLambda: true,
                    removeBlockUI: false,
                    addDebugTimeStamp: false
                }
            },
            uploadFileToS3WithVirusScan: {
                url: '/py/common/filehandler/api/v2/upload/',
                config: {
                    isLambda: false,
                    removeBlockUI: false,
                    addDebugTimeStamp: false
                }
            },
            GetTestUserMessagesLogs: {
                url: '/py/assessment/testuser/api/v1/get_test_user_messages_logs/',
                config: {
                    isLambda: true,
                    removeBlockUI: false,
                    addDebugTimeStamp: true
                }
            },
            GetStatusOfAsyncAPI: {
                url: '/py/crpo/api/v1/getStatusOfAsyncAPI',
                config: {
                    isLambda: true,
                    removeBlockUI: false,
                    addDebugTimeStamp: true
                }
            },
            initiateAutomation: {
                url: '/py/assessment/testuser/api/v2/initiate_automation/',
                config: {
                    isLambda: true,
                    removeBlockUI: false,
                    addDebugTimeStamp: true
                }
            },
            videoAnswers: {
                url: '/py/assessment/htmltest/api/v1/get-recordings-of-testuser-checksetup/',
                config: {
                    isLambda: false,
                    removeBlockUI: false,
                    addDebugTimeStamp: true
                }
            },
            storefileContentGetUrl: {
                url: '/py/common/api/v1/get-file-url-from-file-content/',
                config: {
                    isLambda: false,
                    removeBlockUI: false,
                    addDebugTimeStamp: true
                }
            },
            isAlive: {
                url: '/is-alive.txt',
                config: {
                    isLambda: false,
                    removeBlockUI: false,
                    addDebugTimeStamp: true
                }
            },
            compatibiltyLog: {
                url: '/py/proctoring/log/api/v1/video-logs/',
                config: {
                    isLambda: false,
                    removeBlockUI: false,
                    addDebugTimeStamp: true
                }
            },
            GetCandidateDetails: {
                url: '/py/assessment/testuser/api/v1/get_test_user_basic_info/',
                config: {
                    isLambda: true,
                    removeBlockUI: false,
                    addDebugTimeStamp: true
                }
            },
            setTestHistory: {
                url: '/py/assessment/htmltest/api/v1/create-test-user-history/',
                config: {
                    isLambda: true,
                    removeBlockUI: true,
                    addDebugTimeStamp: false
                }
            },
            getTestHistory: {
                url: '/py/assessment/htmltest/api/v1/get-test-user-history/',
                config: {
                    isLambda: true,
                    removeBlockUI: false,
                    addDebugTimeStamp: true
                }
            },
            getAnswerHistory: {
                url: '/py/assessment/htmltest/api/v1/view-can-ans-history/',
                config: {
                    isLambda: true,
                    removeBlockUI: false,
                    addDebugTimeStamp: true
                }
            },
            recordedFilePathlistNoAuth: {
                url: '/py/proctoring/api/v1/recorded-file-pathlist-noauth/',
                config: {
                    isLambda: false,
                    removeBlockUI: false,
                    addDebugTimeStamp: true
                }
            },
            hireproLanguageTools: {
                url: '/s3_cached/hirepro-content/hirepro/static-resources/hirepro_language_tools_v4.json',
                config: {
                    removeBlockUI: true
                }
            },
            cAndCppTools: {
                url: '/s3_cached/hirepro-content/hirepro/static-resources/c_and_cpp_data.json',
                config: {
                    removeBlockUI: true
                }
            },
            java7WithDescriptionTools: {
                url: '/s3_cached/hirepro-content/hirepro/static-resources/Java7.json',
                config: {
                    removeBlockUI: true
                }
            },
            java8WithDescriptionTools: {
                url: '/s3_cached/hirepro-content/hirepro/static-resources/Java8.json',
                config: {
                    removeBlockUI: true
                }
            },
            java7WithOutDescriptionTools: {
                url: '/s3_cached/hirepro-content/hirepro/static-resources/Java7WithoutDescription.json',
                config: {
                    removeBlockUI: true
                }
            },
            java8WithOutDescriptionTools: {
                url: '/s3_cached/hirepro-content/hirepro/static-resources/Java8WithoutDescription.json',
                config: {
                    removeBlockUI: true
                }
            },
            submitVideoAnswer: {
                url: '/py/assessment/htmltest/api/v1/submit-video-answer/',
                config: {
                    isLambda: false,
                    removeBlockUI: false,
                    addDebugTimeStamp: true
                }
            },
            setTestUserAuthorization: {
                url: '/py/assessment/liveproctoring/api/v1/request_for_photoid_approval/',
                config: {
                    isLambda: true,
                    removeBlockUI: true,
                    addDebugTimeStamp: false
                }
            },
            getTestUserAuthorization: {
                url: '/py/assessment/htmltest/api/v1/get-test-user-authorization/',
                config: {
                    isLambda: true,
                    removeBlockUI: true,
                    addDebugTimeStamp: true
                }
            },
            selfieCompleted: {
                url: '/py/assessment/htmltest/api/v1/selfie-completed/',
                config: {
                    isLambda: true,
                    removeBlockUI: true,
                    addDebugTimeStamp: true
                }
            },
            sendMessageToUser: {
                url: '/py/common/websocket/chat/v2/send_message_to_user/',
                config: {
                    isLambda: true,
                    removeBlockUI: true,
                    addDebugTimeStamp: false
                }
            },
            sendMessageToTestUser: {
                url: '/py/common/websocket/chat/send_message_to_test_user/',
                config: {
                    isLambda: true,
                    removeBlockUI: true,
                    addDebugTimeStamp: false
                }
            },
            makePersistanceSaveCandidateFiles: {
                url: 'py/assessment/htmltest/api/v1/make-answer-files-persistent/',
                config: {
                    isLambda: false,
                    removeBlockUI: true,
                    addDebugTimeStamp: false
                }
            },
            renderCandidateAnswer: {
                url: '/py/assessment/eval/api/v1/render_candidate_answer/',
                config: {
                    isLambda: true,
                    removeBlockUI: true,
                    addDebugTimeStamp: false
                }
            },
            getNextTestInfo: {
                url: '/py/assessment/htmltest/api/v1/test-user-next_test/',
                config: {
                    isLambda: true,
                    removeBlockUI: false,
                    addDebugTimeStamp: true
                }
            },
            getHvs: {
                url: '/py/conference_app/hpro_vs/api/v1/get_hvs/',
                config: {
                    isLambda: true,
                    removeBlockUI: false,
                    addDebugTimeStamp: true
                }
            },
            getMyRoom: {
                url: getUrl,
                config: {
                    isLambda: true,
                    removeBlockUI: false,
                    addDebugTimeStamp: true
                }
            },
            getJoiningInfo: {
                url: getUrl,
                config: {
                    isLambda: true,
                    removeBlockUI: true,
                    addDebugTimeStamp: true
                }
            },
            stopPublishing: {
                url: getUrl,
                config: {
                    isLambda: true,
                    removeBlockUI: false,
                    addDebugTimeStamp: true
                }
            },
            startPublishing: {
                url: getUrl,
                config: {
                    isLambda: true,
                    removeBlockUI: false,
                    addDebugTimeStamp: true
                }
            },
            saveToElastic: {
                url: '/py/conference_app/conference/v1/save_stats_to_elastic/',
                config: {
                    isLambda: true,
                    removeBlockUI: true,
                    addDebugTimeStamp: true
                }
            },
            saveLogsToElastic: {
                url: '/py/conference_app/conference/v1/save_logs_to_elastic/',
                config: {
                    isLambda: true,
                    removeBlockUI: true,
                    addDebugTimeStamp: false
                }
            },
            saveChatDataForTu: {
                url: '/py/common/chat_history/api/v1/save_chat_data_for_tu/',
                config: {
                    isLambda: true,
                    removeBlockUI: true,
                    addDebugTimeStamp: true
                }
            },
            analyzeImage: {
                url: '/py/common/face_comparison/v2/analyze_image',
                config: {
                    isLambda: true,
                    removeBlockUI: false,
                    addDebugTimeStamp: false
                }
            },
            retestConsent: {
                url: '/py/assessment/testuser/api/v1/retest_consent/',
                config: {
                    isLambda: false,
                    addDebugTimeStamp: true
                }
            },
            consentToNextTest: {
                url:'/py/assessment/testuser/api/v1/save_tu_consent_on_next_test/',
                config:{
                    isLambda: false,
                    addDebugTimeStamp: true
                }    
            },
            checkAudioDistortion: {
                url: '/py/common/voice_distortion/check_audio_distortion/',
                config: {
                    isLambda: false,
                    addDebugTimeStamp: true
                }
            },
            getLoginInfo: {
                url: '/py/assessment/htmltest/api/v2/get_login_to_test_for_secondary_camera/',
                config: {
                    isLambda: true,
                    addDebugTimeStamp: true,
                    removeBlockUI: false
                }
            },
            getSecondaryCameraQrCodeImage: {
                url: '/py/assessment/htmltest/api/v2/get_secondary_camera_qr_code_image/',
                config: {
                    isLambda: true,
                    removeBlockUI: false,
                    addDebugTimeStamp: true
                }
            },
            getSecondaryCameraPairingCode: {
                url: '/py/assessment/htmltest/api/v2/get_pairing_code_for_secondary_camera/',
                config: {
                    isLambda: true,
                    removeBlockUI: false,
                    addDebugTimeStamp: true
                }
            },
            getTenantDetails: {
                url: '/py/common/get_tenant_details/',
                config: {
                    isLambda: false,
                    removeBlockUI: false,
                    addDebugTimeStamp: true
                }
            },
            passcodeVerification: {
                url: '/py/assessment/htmltest/api/v2/get_url_from_pairing_code_for_secondary_camera/',
                config: {
                    isLambda: false,
                    removeBlockUI: false,
                    addDebugTimeStamp: false
                }
            },
            getNodeInfoForSocketCompatibilityCheck: {
                url: '/py/conference_app/node/api/v1/get_node_wss_info/',
                config: {
                    isLambda: true,
                    removeBlockUI: false,
                    addDebugTimeStamp: false
                }
            }
        };
        return {
            execute: function(methodNameOrUrl, request, httpMethodType, contentType, header, constraint) {
                var serviceUrl = "",
                    apiUrl = null,
                    isFileToBeUploaded = false;
                if (methodNameOrUrl.match(/\b(http:\/\/)\b/g) || methodNameOrUrl.match(/\b(https:\/\/)\b/g)) {
                    serviceUrl = methodNameOrUrl;
                } else {
                    try {
                        apiUrl = apiInfoCollection[methodNameOrUrl].url;
                    } catch(ex) {
                        apiUrl = methodNameOrUrl;
                    }
                    serviceUrl = typeof(apiUrl) === "function" ? apiUrl(methodNameOrUrl) : apiUrl;
                }
                if (_.includes(serviceUrl, apiInfoCollection.uploadFileToS3WithOutVirusScan.url) ||
                    _.includes(serviceUrl, apiInfoCollection.uploadFileToS3WithVirusScan.url)) {
                    isFileToBeUploaded = true;
                    serviceUrl = serviceUrl + "" + constraint.fileExtentions + "/" + constraint.fileSizeLimit + "/";
                }
                if (_.includes(serviceUrl, apiInfoCollection.analyzeImage.url)) {
                    isFileToBeUploaded = true;
                    serviceUrl = serviceUrl + "/" + constraint.detectFaces + "/" + constraint.detectObjects + "/" + constraint.isSync;
                }
                if (_.includes(methodNameOrUrl, 'is-alive.txt')) {
                    methodNameOrUrl = 'isAlive';
                }
                if (angular.isUndefined(contentType) && !isFileToBeUploaded) {
                    contentType = 'application/json';
                } else if (contentType === null) {
                    contentType = undefined;
                } else if (methodNameOrUrl === 'isAlive') {
                    contentType = 'text';
                }
                if (!httpMethodType) {
                    httpMethodType = 'POST';
                }
                var $http_request = {
                    method: httpMethodType,
                    url: serviceUrl,
                    data: request,
                    headers: {
                        'Content-Type': contentType
                    }
                };
                /////////////////////////////Header Part///////////////////
                if (header) {
                    $http_request.headers = angular.merge($http_request.headers, header);
                }
                ///////////////////////////////////////////////////////////
                var xAuthToken = sessionStorage.getItem('X-AUTH-TOKEN');
                var old_xAuthToken = sessionStorage.getItem('OLD-X-AUTH-TOKEN');
                if (xAuthToken) {
                    if ((methodNameOrUrl === 'LoginToTest' && request && request.IsOnlinePreview) 
                    || (methodNameOrUrl !== 'LoginToTest' 
                        && methodNameOrUrl !== 'GetCompanyInfo' 
                        && methodNameOrUrl !== 'getNodeInfoForSocketCompatibilityCheck'
                        && methodNameOrUrl.indexOf('access_token') === -1)) { // && methodNameOrUrl !== "GetTenantByIdOrAlias"
                        $http_request.headers['X-AUTH-TOKEN'] = xAuthToken;
                    }
                }
                if(methodNameOrUrl === 'getNodeInfoForSocketCompatibilityCheck') {
                    var tokenString = sessionStorage['AuthorizationTokenType'] + ' ' + sessionStorage['AuthorizationTokenAuthorizationToken'];
                    $http_request.headers['Authorization'] = tokenString;
                }
                if (old_xAuthToken && methodNameOrUrl === 'setloginstats') {
                    $http_request.headers['X-AUTH-TOKEN'] = old_xAuthToken;
                }
                if (isFileToBeUploaded) {
                    $http_request.transformRequest = angular.identity;
                }
                if (methodNameOrUrl === 'SubmitTestResult') {
                    $http_request.timeout = 60000;
                }
                if (methodNameOrUrl === 'isAlive' || methodNameOrUrl === 'videoAnswers') {
                    $http_request.timeout = 30000;
                }
                if (apiInfoCollection[methodNameOrUrl] && apiInfoCollection[methodNameOrUrl].config) {
                    $http_request.apiConfig = apiInfoCollection[methodNameOrUrl].config;
                }
                return $http($http_request)
                    .then(function(res) {
                        if (shouldWeRetry(res)) {
                            //$http_request.headers['X-APPLMA'] = false;
                            $http_request.headers['X-APPLMA-RETRY'] = true;
                            if (res.config && res.config.headers && res.config.headers['x-guid']) {
                                $http_request.headers['x-guid'] = res.config.headers['x-guid'];
                            }
                            return $http($http_request);
                        }
                        return res;
                    })
                    .catch(function(res) {
                        if (shouldWeRetry(res)) {
                            //$http_request.headers['X-APPLMA'] = false;
                            $http_request.headers['X-APPLMA-RETRY'] = true;
                            if (res.config && res.config.headers && res.config.headers['x-guid']) {
                                $http_request.headers['x-guid'] = res.config.headers['x-guid'];
                            }
                            return $http($http_request);
                        } else {
                            return $q.reject(res);
                        }
                    });
            }
        };
    }

    var retryGuids = {};

    function getUrl(apiName) {
        var apiNameUrlCollecion = {
            "getMyRoom": "/py/assessment/htmltest/api/" + getVersion("getMyRoom") + "/get_my_room/",
            "getJoiningInfo": "/py/conference_app/conference/" + getVersion("getJoiningInfo") + "/join/",
            "startPublishing": "/py/conference_app/conference/" + getVersion("startPublishing") + "/publishing/PublishingStarted/",
            "stopPublishing": "/py/conference_app/conference/" + getVersion("stopPublishing") + "/publishing/PublishingStopped/"
        };
        return apiNameUrlCollecion[apiName];
    }

    function getVersion(apiName) {
        var isSecondaryCameraEnable = sessionStorage.getItem("isSecondaryCameraEnable") === "true" ? true : false,
            condition_secondaryCamera = isSecondaryCameraEnable && (apiName === "getMyRoom" || apiName === "getJoiningInfo" || apiName === "startPublishing" || apiName === "stopPublishing");
        if (condition_secondaryCamera) {
            return "v2";
        }
        return "v1";
    }

    function shouldWeRetry(res) {
        if (!res) {
            return false;
        }
        if (res.status !== 504) {
            return false;
        }
        if (!_.size(res.config)) {
            return false;
        }
        if (!_.size(res.config.headers)) {
            return false;
        }
        if (!res.config.headers['X-APPLMA']) {
            return false;
        }
        if (!res.config.headers['x-guid']) {
            return false;
        }
        if (retryGuids[res.config.headers['x-guid']]) {
            return false;
        }
        retryGuids[res.config.headers['x-guid']] = true;
        return true;
    }
})();

(function() {
    'use strict';

    angular
        .module('OnlineAssessmentAngular')
        .factory("videoAnsRecorder", videoAnsRecorderService);

    function videoAnsRecorderService($rootScope, proctoringService, mediaRecorder, webService) {
        var service = {
            localVar: {
                mediaStream: null,
                mediaRecorder: null,
                recordedMediaChunks: [],
                isLocalSaveEnable: false,
                startDeferred: null,
                stopDeferred: null,
                param: null,
                uploadIntervalObj: null,
                uploadInterval: 2, //in seconds
                stopIntervalObj: null,
                stopInterval: 1, //in seconds
                requestQ: [],
                isPartialSavingEnable: false,
                mediaRecorderBlobType: "video/webm"
            },
            start: startRecorder,
            stop: stopRecorder
        };
        return service;

        function startRecorder(param) {
            var sl = service.localVar,
                startRecorderPromise = null;
            return initRecorder(param)
                .then(function() {
                    startRecorderPromise = sl.isLocalSaveEnable ? startSavingLocally(param) : startSavingRemotely(param);
                    return startRecorderPromise.then(function(res) {
                        return res;
                    });
                })
                .catch(function(res) {
                    $log.error(res);
                });
        }

        function stopRecorder() {
            var sl = service.localVar,
                stopRecorderPromise = null;
            $rootScope.growlError && $rootScope.growlError.destroy();
            stopRecorderPromise = sl.isLocalSaveEnable ? stopSavingLocally() : stopSavingRemotely();
            return stopRecorderPromise.then(function(res) {
                return res;
            });
        }

        /// privare methods ///

        function initRecorder(param) {
            var sl = service.localVar;
            sl.videoQuestionId = param.vqId;
            sl.vidElem = param.vidElem;
            sl.param = param;
            return proctoringService.utility.getProctoringConfig()
                .then(function(procInfo) {
                    if (!procInfo) {
                        return $q.reject("not able to fetch procotirng config!");
                    }
                    sl.isLocalSaveEnable = !!procInfo.isStoreMediaStrmLocally;
                });
        }

        function startSavingLocally(param) {
            param.fileName = 'vq_' + param.videoQuestionId;
            return mediaRecorder.start(param);
        }

        function startSavingRemotely(param) {
            var sl = service.localVar;
            return proctoringService.start({
                    'vqId': sl.param.vqId,
                    'vidElem': sl.param.vidElem,
                    'isAutoStart': sl.param.isAutoStart,
                    'durationInMins': sl.param.durationInMins,
                    'procType': sl.param.procType
                })
                .then(function(res) {
                    if (param.isPartialSavingEnable) {
                        sl.isPartialSavingEnable = true;
                        startSavingLocally(param); // this is to save audio locally also
                    }
                    return res;
                });
        }

        function stopSavingLocally() {
            var sl = service.localVar;
            !sl.isPartialSavingEnable && assessmentUtility.localStorage.setData('isQuestionVideoStarted', false);
            sl.isPartialSavingEnable = false;
            return mediaRecorder.stop();
        }

        function stopSavingRemotely() {
            /*var sl = service.localVar;
            if (sl.isPartialSavingEnable) {
                stopSavingLocally()
                    .then(function(res) {
                        return res.videoUplodedDeferred;
                    })
                    .then(function(res) {
                        console.log(res);
                    }, function(res) {
                        console.log(res);
                    }, function(res) {
                        var rqst = {
                            "questionId": res.param.vqId,
                            "sectionId": res.param.sectionId,
                            "videoUrl": res.s3Url,
                            "disableBlockUI": true
                        };
                        webService.execute("submitVideoAnswer", rqst);
                    });
            }*/
            return proctoringService.stop();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module("OnlineAssessmentAngular")
        .factory("trackerService", trackerService);

    trackerService.$inject = [
        "$rootScope",
        "$window",
        "$interval",
        "$q",
        "$log",
        "growl",
        "loginService",
        "commonService",
        "proctoringService",
        "faceTracker",
        "imageTracker",
        "speechTracker",
        "muteTracker",
        "loggerService",
        "assessmentUtility",
        "$timeout",
        "deviceDetector",
        "hps",
        "faceLandmarks",
        "objectDetection"
    ];

    function trackerService($rootScope, $window, $interval, $q, $log, growl, loginService, commonService, proctoringService, faceTracker, imageTracker, speechTracker, muteTracker, loggerService, assessmentUtility, $timeout, deviceDetector, hps, faceLandmarks, objectDetection) {
        var ft = faceTracker,
            service = {
                getTrackerTypes: getTrackerTypes,
                getTrackerStat: getTrackerStat,
                getMediaStream: getMediaStream,
                startTrackers: startTrackers,
                stopMediaStream: stopMediaStream,
                stopTrackers: stopTrackers,
                pushLog: pushLog,
                handleFaceTracking: handleFaceTracking,
                systemSpeedLog: systemSpeedLog,
                noiseCheckLog: noiseCheckLog,
                brightnessCheckLog: brightnessCheckLog,
                systemNetSpeedLog: systemNetSpeedLog,
                pushTrackerStatStartLog: pushTrackerStatStartLog,
                pushTrackerStatStopLog: pushTrackerStatStopLog,
                registerWatchOnMediastreamAvailability: initOnMediaStreamStateChange,
                config: {
                    mediaStreamCollection: [],
                    isFaceTrackingEnabled: false,
                    isImageTrackingEnabled: false,
                    isSpeechTrackingEnabled: false,
                    audiotracking: false,
                    isVideoProctoringEnabled: false,
                    isSampleVideoRecordingEnable: false,
                    allowedFrameRate: 9,
                    allowedDownloadBandWidth: 1, //Mbps
                    allowedUploadBandWidth: 1, //Mbps
                    loginInfo: null,
                    growlMessageObjFace: null,
                    loggingIntervalObj: null,
                    mediaPromise: null,
                    mediaStream: null,
                    faceIntervalCount: 0,
                    maxTimeSpan: 10,
                    minTimespan: 3,
                    timeSpan: 10,
                    faceCount: -1,
                    rootWatch: null,
                    counterMultiFace: 0,
                    isFaceTrackerEnableForMobile: null,
                    isSpeechTrackerEnableForMobile: null,
                    isDesktop: true,
                    isOnlyTracker: false
                }
            },
            faceNumber = null;
        return service;

        function getTrackerTypes() {
            var isFaceLandmarks = JSON.parse(sessionStorage.getItem('faceLandmarks'));
            if (isFaceLandmarks) {
                ft = faceLandmarks;
            }
            fetchLoginInfo();
            var trackerType = [];
            if (service.config.isFaceTrackingEnabled) {
                trackerType.push("face");
            }
            if (!commonService.testIsOnlinePreview()) {
                if (service.config.isImageTrackingEnabled) {
                    trackerType.push("image");
                }
                if (service.config.isSpeechTrackingEnabled || service.config.audiotracking) {
                    trackerType.push("speech");
                }
                //Dependency:speec tracker is depended on min tracker...
                if (service.config.isSpeechTrackingEnabled || service.config.isVideoProctoringEnabled) {
                    trackerType.push("mic");
                }
                if (service.config.isObjectDetectionAllowed) {
                    trackerType.push("objectDetection");
                }
            }
            return trackerType;
        }

        function fetchLoginInfo() {
            var sc = service.config,
                conf = null;
            sc.loginInfo = loginService.getLoginInfo();
            if (sc.loginInfo && sc.loginInfo.Config) {
                conf = sc.loginInfo.Config;
                sc.isVideoProctoringEnabled = !!conf.VideoProctoring;
                sc.isSpeechTrackingEnabled = !!conf.isSpeechTrackingEnabled;
                sc.isImageTrackingEnabled = !!conf.isImageTrackingEnabled;
                sc.isFaceTrackingEnabled = !!conf.isFaceTrackingEnabled;
                sc.isSampleVideoRecordingEnable = !!conf.isSampleVideoRecordingEnable;
                sc.VideoProctoringIsMandat = !!conf.VideoProctoringIsMandat;
                sc.audiotracking = !!conf.audiotracking;
                sc.isObjectDetectionAllowed = _.get(sc.loginInfo, 'assessmentConfig.objectDetectionConfig.enabled', false);

                sc.allowedFrameRate = _.get(sc.loginInfo, 'assessmentConfig.framerateRequiredForFaceTracking', sc.allowedFrameRate);
                // sc.allowedFrameRate = conf.frameRate && conf.frameRate !== "" ?
                //     conf.frameRate : sc.allowedFrameRate;

                sc.allowedDownloadBandWidth = conf.downloadBandWidth && conf.downloadBandWidth !== "" ?
                    conf.downloadBandWidth : sc.allowedDownloadBandWidth;

                sc.allowedUploadBandWidth = conf.uploadBandWidth && conf.uploadBandWidth !== "" ?
                    conf.uploadBandWidth : sc.allowedUploadBandWidth;
            }
            if (sc.loginInfo.assessmentConfig) {
                sc.multiFaceDetectionMsg = !!sc.loginInfo.assessmentConfig.multiFaceDetectionMsg;
            }
        }

        function getTrackerStat() {
            fetchLoginInfo();
            var sc = service.config;
            return sc.isSpeechTrackingEnabled || sc.isImageTrackingEnabled || sc.isFaceTrackingEnabled || sc.audiotracking || sc.isObjectDetectionAllowed;
        }

        function getMediaStream(_constraints, isCreateNewStrm, isCreateStreamWithNoDependency) {
            var sc = service.config,
                constraints = _constraints ? _constraints : { audio: true, video: true },
                strm = proctoringService.mediaStream ?
                proctoringService.mediaStream :
                sc.mediaStream;
            if (!isCreateNewStrm && strm) {
                return $q.when(strm);
            }
            if (sc.mediaPromise) {
                return sc.mediaPromise;
            }
            sc.isCreateStreamWithNoDependency = isCreateStreamWithNoDependency;
            if (!sc.isCreateStreamWithNoDependency) {
                $rootScope.vidStrmId = null;
                $rootScope.vidStrm = null;
            }
            sc.mediaPromise = navigator.mediaDevices.getUserMedia(constraints)
                .then(function(stream) {
                    if (!stream) {
                        return $q.reject("Unable to get media stream!");
                    }
                    sc.mediaStream = stream;
                    if (!sc.isCreateStreamWithNoDependency) {
                        $rootScope.vidStrm = stream;
                        $rootScope.vidStrmId = stream.id;
                    }
                    sc.isLocalStream = true;
                    var request = {
                        "canLoginActivityLog": {
                            "MediaStreamStatInfo": {
                                streamId: stream.id,
                                isLocalStream: true,
                                name: 'proctoringCompatibilityTest',
                                timeStamp: new Date()
                            }
                        }
                    };
                    pushLog(request);
                    return $q.resolve(stream);
                })
                .catch(function(err) {
                    var errMsg = getMediaStreamErrorMsg(err.name),
                        request = {
                            "canLoginActivityLog": {
                                "MediaStreamStatInfo": {
                                    "name": err.name,
                                    "sysMessage": err.message,
                                    "uiMessage": errMsg,
                                    "timeStamp": new Date()
                                }
                            }
                        };
                    pushLog(request);
                    return $q.reject(errMsg);
                });
            return sc.mediaPromise;
        }

        function getMediaStreamErrorMsg(errorName) {
            var errMsg = "There is some issue ";
            switch (errorName) {
                case "AbortError":
                case "NotAllowedError":
                case "Permission Denied":
                case "PERMISSION_DENIED":
                case "PermissionDeniedError":
                case "PermissionDismissedError":
                    errMsg = "Camera/Mic access denied";
                    break;
                case "DevicesNotFoundError":
                case "NO_DEVICES_FOUND":
                case "NotFoundError":
                case "NotFoundError: The object can not be found here.":
                    errMsg = "Camera/Mic device not found";
                    break;
                case "CONSTRAINT_NOT_SATISFIED":
                case "ConstraintNotSatisfiedError":
                case "Error":
                case "HARDWARE_UNAVAILABLE":
                case "InternalError":
                case "InvalidAccessError":
                case "InvalidSecurityOriginError":
                case "InvalidStateError":
                case "MANDATORY_UNSATISFIED_ERROR":
                case "MediaDeviceFailedDueToShutdown":
                case "MediaDeviceNotSupported":
                case "NOT_SUPPORTED_ERROR":
                case "NotReadableError":
                case "NotSupportedError":
                case "OverconstrainedError":
                case "SecurityError":
                case "SourceUnavailableError":
                case "Starting video failed":
                case "TabCaptureError":
                case "TrackStartError":
                    errMsg = "Camera/Mic device unavailable";
                    break
            }
            return errMsg;
        }

        function startTrackers(obj) {
            var scnf = service.config,
                trackerTypes = getTrackerTypes(),
                mediaStream = null,
                isSystemCompatibleForFaceTracking = true,
                qId = obj && obj.qId ? obj.qId : null;
            scnf.isOnlyTracker = !proctoringService.mediaStream;
            proctoringService.utility.getProctoringConfig()
                .then(function(res) {
                    if (!res) {
                        return false;
                    }
                    if (res.isFaceTrackerEnableForMobile === undefined) {
                        scnf.isFaceTrackerEnableForMobile = true;
                    } else {
                        scnf.isFaceTrackerEnableForMobile = res.isFaceTrackerEnableForMobile;
                    }

                    if (res.frameReadDuringFaceTrackingPerMs && res.frameReadDuringFaceTrackingPerMs.versant) {
                        sessionStorage.setItem('frameDelayTime', res.frameReadDuringFaceTrackingPerMs.versant);
                    } else {
                        sessionStorage.setItem('frameDelayTime', 1000);
                    }
               
                    if (res.frameReadDuringFaceTrackingPerMs) {
                        sessionStorage.setItem('frameReadDuringFaceTrackingPerMs', JSON.stringify(res.frameReadDuringFaceTrackingPerMs));
                    }
                    //*******
                    scnf.isSpeechTrackerEnableForMobile = res.isSpeechTrackerEnableForMobile;
                    sessionStorage.setItem('isModifiedFPSRequired', res.isModifiedFPSRequired);
                    scnf.isDesktop = deviceDetector.isDesktop();
                    scnf.calculateFaceCount = !!res.calculateFaceCount;
                    scnf.calculateFaceCountPercent = res.calculateFaceCountPercent || 25;
                    scnf.testTerminationOnMuteAfter = res.testTerminationOnMuteAfter;
                    scnf.imageTrackingBufferInterval = res.imageTrackingBufferInterval;
                    return getMediaStream();
                })
                .then(function(res) {
                    scnf.mediaStream = res;
                    if (scnf.isOnlyTracker) {
                        return hps.start(trackerTypes);
                    } else {
                        return $q.when(res);
                    }

                })
                .then(function() {
                    /*if (getTrackerStat() && !service.config.rootWatch) {
                        initOnMediaStreamStateChange();
                    }*/
                    _.forEach(trackerTypes, function(type) {
                        switch (type) {
                            case 'face':
                                if (!scnf.isDesktop && scnf.isFaceTrackerEnableForMobile === false) {
                                    break;
                                }
                                var stopFaceTrackerAsSystemSlow = $window.sessionStorage.getItem("stopFaceTrackerAsSystemSlow");
                                isSystemCompatibleForFaceTracking = !(stopFaceTrackerAsSystemSlow ? JSON.parse(stopFaceTrackerAsSystemSlow) : !!stopFaceTrackerAsSystemSlow);
                                if (isSystemCompatibleForFaceTracking) {
                                    var opt = {
                                        stream: scnf.mediaStream,
                                        calculateFaceCount: scnf.calculateFaceCount,
                                        calculateFaceCountPercent: scnf.calculateFaceCountPercent
                                    };
                                    ft.start(opt);
                                    scnf.loggingIntervalObj = $interval(function() {
                                        handleFaceTracking(qId);
                                    }, 1000);
                                }
                                break;
                            case 'image':
                                imageTracker.start(scnf.mediaStream, {
                                    qId: qId,
                                    imageTrackingBufferInterval: scnf.imageTrackingBufferInterval,
                                    proctoringImagePath: scnf.isOnlyTracker ?
                                        hps.proctoringImagePath : proctoringService.proctoringImagePath
                                });
                                break;
                            case 'speech':
                                if (!scnf.isDesktop && scnf.isSpeechTrackerEnableForMobile === false) {
                                    break;
                                }
                                speechTracker.start(scnf.mediaStream, qId);
                                break;
                            case 'mic':
                                muteTracker.start(scnf.mediaStream, qId, scnf.testTerminationOnMuteAfter);
                                break;
                            case 'objectDetection':
                                objectDetection.start({stream: scnf.mediaStream});
                        }
                    });
                });
            service.pushTrackerStatStartLog(qId);
        }

        function pushTrackerStatStartLog(qId) {
            var request = {
                "canLoginActivityLog": {
                    "trackerStatInfo": {
                        "qId": qId,
                        "trackerStat": "started",
                        "timeStamp": new Date()
                    }
                }
            };
            pushLog(request);
        }

        function systemSpeedLog(data) {
            var request = {
                "canLoginActivityLog": {
                    "systemSpeedLog": {
                        "trackingSpeedSlow": data.flag,
                        "frameSpeed": Math.round(data.frameSpeed)
                    }
                }
            };
            pushLog(request);
        }

        function systemNetSpeedLog(data) {
            var request = {
                "canLoginActivityLog": {
                    "systemInternetSpeed": {
                        "uploadSpeed": data.upload,
                        "downloadSpeed": data.download,
                        "thresholdUpload": data.thresholdUpload,
                        "thresholdDownload": data.thresholdDownload
                    }
                }
            };
            pushLog(request);
        }

        function noiseCheckLog(data) {
            var request = {
                "canLoginActivityLog": {
                    "noiseCheckLog": data
                }
            };
            pushLog(request);
        }

        function brightnessCheckLog(data) {
            var request = {
                "canLoginActivityLog": {
                    "brightnessCheckLog": data
                }
            };
            pushLog(request);
        }

        function handleFaceTracking(qId) {
            var cnf = service.config,
                data = {},
                request = {};
            cnf.qId = qId;
            ft.processRawFaceCountCollection(cnf.timeSpan);
            cnf.faceIntervalCount++;
            if (_.isEqual(cnf.faceIntervalCount, cnf.timeSpan)) {
                cnf.faceIntervalCount = 0;
                data = ft.getUserPresenceStatus(cnf.timeSpan === cnf.maxTimeSpan ? "MAX" : "MIN");
                console.log('Handle face', data);
                if (data.isOutOfFocus) {
                    /*------------------ Not infront of camera ----------------*/
                    request = {
                        "isOutOfFocus": data.isOutOfFocus,
                        "faceCount": 0,
                        "message": "Please be available in front of the Camera!!",
                        "timeStamp": new Date()
                    };
                    handleMessageAndMirror(request);
                    pushFaceTrackerLog(request);
                    cnf.timeSpan = cnf.minTimespan;
                } else {
                    cnf.timeSpan = cnf.maxTimeSpan;
                    var msgInFocus = "User in front of Camera";
                    /* --------------- Multiple users infront of camera ---------*/
                    if (data.decidedFaceCount > 1) {
                        msgInFocus = "Multiple user detected in front of Camera!!";
                    }
                    request = {
                        "isOutOfFocus": data.isOutOfFocus,
                        "faceCount": data.decidedFaceCount,
                        "message": msgInFocus,
                        "timeStamp": new Date()
                    };
                    handleMessageAndMirror(request);
                    pushFaceTrackerLog(request);

                }
                if (faceNumber == null || faceNumber !== data.decidedFaceCount) {
                    faceNumber = data.decidedFaceCount;
                    var tempResul = ft.keepRawInfo('get');
                    //console.log('Handle RESULT', tempResul);
                    request = {
                        "isOutOfFocus": data.isOutOfFocus,
                        "faceCountRawInfo": JSON.stringify(tempResul),
                        "decidedFaceCount": data.decidedFaceCount,
                        "timeStamp": new Date()
                    };
                    console.log('Handle FINAL LOG', request);
                    pushLog(request);
                }
            }
        }

        function initOnMediaStreamStateChange() {
            var activeQ = null,
                activeQid = null;
            if (service.config.rootWatch) {
                service.config.rootWatch();
            }
            service.config.rootWatch = $rootScope.$watch('vidStrmId', function(newV, oldV) {
                if (angular.isUndefined(newV) || angular.isUndefined(oldV) || newV === oldV) return false;
                //imageTracker.config.isStreamAvail = service.config.isLocalStream ? true : !!$rootScope.vidStrm;
                //$rootScope.vidStrm && imageTracker.updateStream($rootScope.vidStrm);

                activeQ = assessmentUtility.getActiveQuestion();
                if (activeQ && activeQ.questionType == 17) {
                    activeQid = activeQ.id;
                }

                if (!$rootScope.vidStrm) {
                    stopTrackers(null, activeQid);
                } else {
                    startTrackers({ qId: activeQid });
                }
            });
        }

        function handleMessageAndMirror(data) {
            // TODO: IF versant test opened in new tab then do a postmessage
            var cnf = service.config,
                growlMessageObj_temp = null;
            if (!service.config.isLocalStream && !$rootScope.vidStrm) {
                return false;
            }
            if (data.isOutOfFocus && cnf.VideoProctoringIsMandat) {
                $log.log("isOutOfFocus--", data.isOutOfFocus);
                //growlMessageObj_temp = growl.error(data.message);
                showMirror(data.faceCount);
                if (growlMessageObj_temp) {
                    if (cnf.growlMessageObjFace) {
                        cnf.growlMessageObjFace.destroy();
                    }
                    //cnf.growlMessageObjFace = growlMessageObj_temp;
                }
            } else if (data.faceCount > 1 && cnf.multiFaceDetectionMsg) {
                showMirror(data.faceCount);
            } else {
                //destroyGrowlObj();
                hideMirror();
            }
        }

        function pushFaceTrackerLog(data) {
            var cnf = service.config,
                predection = null, tracker = 'trackingjs';
            if (!data) { return false; }
            if (data.faceCount !== cnf.faceCount) {
                if (typeof ft.getPredictions === "function") {
                    predection = ft.config.rawFacePredictions;
                    tracker = 'tensorflow';
                }
                cnf.faceCount = data.faceCount;
                var json = {
                    faceTrackingInfo: {
                        faceTracker: tracker,
                        noOfUsersInScope: data.faceCount,
                        predection: predection,
                        timeStamp: new Date(),
                        qId: cnf.qId
                    }
                };
                pushLog(json);
                if (data.faceCount > 1) {
                    cnf.counterMultiFace++;
                    if (cnf.counterMultiFace < 16) {
                        clickImageMultipleUser();
                    }
                }

            }
        }

        function stopTrackers(trackerTypes, qId) {
            var promiseCollection = [],
                sc = service.config;
            if (!trackerTypes) {
                trackerTypes = getTrackerTypes();
            }
            _.forEach(trackerTypes, function(type) {
                switch (type) {
                    case 'face':
                        if (sc.loggingIntervalObj) {
                            $interval.cancel(sc.loggingIntervalObj);
                        }
                        sc.faceCount = -1;
                        promiseCollection.push(ft.stop());
                        break;
                    case 'image':
                        promiseCollection.push(imageTracker.stop());
                        break;
                    case 'speech':
                        promiseCollection.push(speechTracker.stop());
                        break;
                    case 'mic':
                        promiseCollection.push(muteTracker.stop());
                        break;
                    case 'objectDetection':
                        promiseCollection.push(objectDetection.stop());
                        break;
                }
            });
            /* ----------- Log push..................*/
            if (_.size(promiseCollection) > 0) {
                return $q.all(promiseCollection)
                    .then(function(res) {
                        if (!sc.isLocalStream || (sc.isLocalStream && !$rootScope.isNetworkGotFailed)) {
                            service.stopMediaStream(sc.mediaStream);
                        } else {
                            sc.mediaStream = null;
                        }
                        //destroyGrowlObj();
                        hideMirror();
                        service.pushTrackerStatStopLog(qId);
                        if (sc.isOnlyTracker) {
                            return hps.stop();
                        } else {
                            return $q.when(res);
                        }
                    })
                    .catch(function(err) {
                        $log.log(err);
                    });
            } else {
                return $q.when();
            }
        }

        function stopMediaStream(strm) {
            var sc = service.config;
            if (!strm && !sc.mediaStream) {
                $log.error("Stream not found!");
                return false;
            }
            if (!strm) {
                strm = sc.mediaStream;
            }
            var trks = strm.getTracks();
            if (_.size(trks) === 0) {
                $log.error("No tracks found!");
                return false;
            }
            _.forEach(trks, function(trk) {
                if (trk) {
                    trk.stop();
                }
            });
            if (!sc.isCreateStreamWithNoDependency) {
                $rootScope.vidStrmId = null;
                $rootScope.vidStrm = null;
            }
            sc.mediaStream = null;
            sc.mediaPromise = null;
            if (service.config.rootWatch) {
                service.config.rootWatch();
            }
        }

        /*function destroyGrowlObj() {
            if (service.config.growlMessageObjFace) {
                service.config.growlMessageObjFace.destroy();
                service.config.growlMessageObjFace = null;
            }
        }*/

        function hideMirror() {
            var mirror = document.getElementById("userPositionCheck");
            if (mirror) {
                mirror.setAttribute('style', "top:-91px");
            }
            if (sessionStorage.typeOfTest === 'versant') {
                var iframe = document.getElementById('thirdPartyIframe');
                if (iframe && iframe.contentWindow && iframe.contentWindow.wdtWindow) {
                    var message = { type: 'userinfrontofcamera' };
                    iframe.contentWindow.wdtWindow.postMessage(message, '*')
                }
            }
        }

        function showMirror(faceCount) {
            var mirror = document.getElementById("userPositionCheck"),
                msgSpan = document.getElementById("userCheckMsg");
            if (msgSpan) {
                if (faceCount === 0) {
                    msgSpan.innerText = 'Please make sure you are visible in the camera';
                } else {
                    msgSpan.innerText = 'Multiple face detected.';
                }
            }
            if (mirror) {
                mirror.setAttribute('style', "top:0px");
            }
            if (sessionStorage.typeOfTest === 'versant') {
                var iframe = document.getElementById('thirdPartyIframe');
                if (iframe && iframe.contentWindow && iframe.contentWindow.wdtWindow) {
                    if (faceCount === 0) {
                        var message = { type: 'nouserinfrontofcamera' };
                        iframe.contentWindow.wdtWindow.postMessage(message, '*');
                    } else if (faceCount > 0) {
                        var message = { type: 'multipleuserinfrontofcamera' };
                        iframe.contentWindow.wdtWindow.postMessage(message, '*');
                    }

                }
            }
        }

        function pushTrackerStatStopLog(qId) {
            var request = {
                "canLoginActivityLog": {
                    "trackerStatInfo": {
                        "qId": qId,
                        "trackerStat": "stopped",
                        "timeStamp": new Date()
                    }
                }
            };
            pushLog(request);
        }

        function pushLog(request) {
            if (!commonService.testIsOnlinePreview() && request) {
                loggerService.push(request);
            }
        }

        function clickImageMultipleUser() {
            var guid = window.getUUID(),
                option = {
                    isTimeIntervalRequired: false,
                    proctoringImagePath: proctoringService.proctoringImagePath,
                    metaData: {
                        multiUserUI: true,
                        guid: guid
                    }
                },
                mediaStream = service.config.mediaStream,
                image1Time = 10,
                image2Time = 30;
            imageTracker.start(mediaStream, option);
            // $timeout(function() {
            //     $log.log('AFTER ' + image1Time + ' SEC', new Date());
            //     option.metaData.nextClickTime = image1Time;
            //     option.metaData.guid = guid + '_1';
            //     imageTracker.start(mediaStream, option);
            // }, image1Time * 1000);
            // $timeout(function() {
            //     $log.log('AFTER ' + image2Time + ' SEC', new Date());
            //     option.metaData.nextClickTime = image2Time;
            //     option.metaData.guid = guid + '_2';
            //     imageTracker.start(mediaStream, option);
            // }, image2Time * 1000);
        }
    }
})();

(function() {
    'use strict';
    angular
        .module("OnlineAssessmentAngular")
        .factory("streamListner", streamListnerService);

    function streamListnerService($q, $timeout, hvsService, hps, debuggerService) {

        var userId = null,
            localFeedHandlerInstance = null,
            remoteFeedHandlerInstance = null,
            joiningInfo = null,
            displayName = null,
            roomId = null,
            sessionId = null,
            attachLocalHandlerPromise = null,
            isOtherParticipantJoinedPromise = null,
            getRemoteStreamPromise = getPromise(getRemoteStreamPromise),
            opaqueId = "in.hirepro.assessment.SecondaryCamera-" + Janus.randomString(12),
            rTCIceTransportPolicy = null,
            remoteStream = null,
            opts = null,
            isParticipantJoined = false,
            joinResponse = {
                "roomInfo": null,
                "sessionInfo": null,
                "handlerInfo": null
            },
            service = {
                "join": join,
                "getRemoteStream": getRemoteStream,
                "isOtherParticipantJoined": isOtherParticipantJoined,
                "leave": leave
            };
        return service;

        function join(_opts) {
            isParticipantJoined = false;
            opts = _opts || {};
            return hps.getMyRoom()
                .then(function(res) {
                    if (!res || !res.data || res.data.status === "KO") {
                        return { "data": null, "msg": "not able to fetch room info!" };
                    }
                    joinResponse.roomInfo = res.data;
                    roomId = res.data.roomId;
                    rTCIceTransportPolicy = res.data.rTCIceTransportPolicy;
                    joiningInfo = angular.fromJson(sessionStorage.getItem(sessionStorage.getItem('X-AUTH-TOKEN') + '-joiningInfo'));
                    displayName = joiningInfo.data.displayName;

                    return hvsService.initJanus({ 
                        "rTCIceTransportPolicy": rTCIceTransportPolicy,
                        "serverRelativePath": res.data.serverRelativePath 
                    });
                })
                .then(function(res) {
                    console.log("streamListner_session", res);
                    joinResponse.sessionInfo = res;
                    sessionId = res.data.sessionId;
                    return attachLocalHandler();
                })
                .then(function(handlerInstance) {
                    joinConference();
                    joinResponse.handlerInfo = handlerInstance;
                    return { "data": joinResponse, "msg": "Joined successfully" };
                    //return $q.when();
                })
                .catch(function(err) {
                    return { "data": joinResponse, "msg": "Something went wrong.", "err": err };
                });
        }

        function getRemoteStream() {
            if (remoteStream) {
                $timeout(function() {
                    getRemoteStreamPromise.notify({ "strm": remoteStream });
                }, 10);
            }
            return getRemoteStreamPromise.promise;
        }

        function isOtherParticipantJoined() {
            isOtherParticipantJoinedPromise = getPromise();
            if (isParticipantJoined) {
                //If participant joined before calling this function
                isOtherParticipantJoinedPromise.resolve();
            }
            return isOtherParticipantJoinedPromise.promise;
        }

        function leave() {
            isParticipantJoined = false;
            if (localFeedHandlerInstance) {
                localFeedHandlerInstance.send({
                    "message": { "request": "leave" }
                });
                localFeedHandlerInstance.hangup();
                attachLocalHandlerPromise = null;
            }
            if (remoteFeedHandlerInstance) {
                remoteFeedHandlerInstance.send({
                    "message": { "request": "leave" }
                });
                remoteFeedHandlerInstance.hangup();
            }
        }
        /*....................Private Methods..............*/

        function attachLocalHandler() {
            attachLocalHandlerPromise = getPromise(attachLocalHandlerPromise);
            !localFeedHandlerInstance && hvsService.attachHandler(localFeedHandler());
            return attachLocalHandlerPromise.promise;
        }

        function joinConference() {
            var register = {
                "request": "join",
                "room": roomId,
                "ptype": "publisher",
                "display": displayName
            };
            localFeedHandlerInstance &&
                localFeedHandlerInstance.send({
                    "message": register
                });
        }

        function localFeedHandler() {
            return {
                plugin: "janus.plugin.videoroom",
                opaqueId: opaqueId,
                success: function(_pluginHandle) {
                    localFeedHandlerInstance = _pluginHandle;
                    debuggerService.log({
                        msg: {
                            activity: 'localFeedHandler',
                            callback: 'success',
                            timestamp: new Date(),
                            participantType: 'Publisher',
                            participantName: displayName,
                            eventDetails: {
                                typeOfEvent: "Handle",
                                timestamp: new Date(),
                                sessionId: sessionId,
                                pluginName: 'videoroom',
                                pluginId: localFeedHandlerInstance.getId(),
                                data: {
                                    callback: 'success',
                                    comment: 'plugin attached'
                                }
                            }
                        },
                        source: 'assess_streamListener'
                    });
                    attachLocalHandlerPromise.resolve(localFeedHandlerInstance);
                },
                error: function(error) {
                    debuggerService.log({
                        msg: {
                            activity: 'localFeedHandler',
                            callback: 'error',
                            timestamp: new Date(),
                            participantType: 'Publisher',
                            participantName: displayName,
                            eventDetails: {
                                typeOfEvent: "Handle",
                                timestamp: new Date(),
                                sessionId: sessionId,
                                pluginName: 'videoroom',
                                pluginId: null,
                                data: {
                                    callback: 'error',
                                    error: error,
                                    comment: 'plugin attached failed'
                                }
                            }
                        },
                        source: 'assess_streamListener'
                    });
                },
                webrtcState: function(on) {
                    debuggerService.log({
                        msg: {
                            activity: 'localFeedHandler',
                            callback: 'webrtcState',
                            timestamp: new Date(),
                            participantType: 'Publisher',
                            participantName: displayName,
                            eventDetails: {
                                typeOfEvent: "WEBRtc",
                                timestamp: new Date(),
                                sessionId: sessionId,
                                pluginName: 'videoroom',
                                pluginId: localFeedHandlerInstance.getId(),
                                data: {
                                    webrtcState: on ? 'ON' : 'OFF'
                                }
                            }
                        },
                        source: 'assess_streamListener'
                    });
                },
                iceState: function(stat) {
                    debuggerService.log({
                        msg: {
                            activity: 'localFeedHandler',
                            callback: 'iceState',
                            timestamp: new Date(),
                            participantType: 'Publisher',
                            participantName: displayName,
                            eventDetails: {
                                typeOfEvent: "WEBRtc",
                                timestamp: new Date(),
                                sessionId: sessionId,
                                pluginName: 'videoroom',
                                pluginId: localFeedHandlerInstance.getId(),
                                data: {
                                    iceState: stat
                                }
                            }
                        },
                        source: 'assess_streamListener'
                    });
                },
                onmessage: function(msg, jsep) {
                    debuggerService.log({
                        msg: {
                            activity: 'localFeedHandler',
                            callback: 'onmessage',
                            msg: msg,
                            jsep: _.omit(jsep, 'sdp'),
                            success: true,
                            timestamp: new Date()
                        },
                        source: 'assess_streamListener'
                    });
                    var event = msg["videoroom"],
                        publishers = null,
                        handlerPrivateId = msg["private_id"];
                    if ((event === "joined" || event === "event") && _.size(msg.publishers) > 0) {
                        userId = msg["id"];
                        publishers = msg.publishers;
                        for (var p in publishers) {
                            var publisherId = publishers[p]["id"],
                                display = publishers[p]["display"];
                            if (opts.type && display.indexOf(opts.type) > -1) {
                                console.log("sap2ndCamera_participant joined", new Date());
                                isParticipantJoined = true;
                                opts.publisherId = publisherId;
                                attachRemoteHandler(publisherId, display, handlerPrivateId);
                                isOtherParticipantJoinedPromise.resolve();
                            }

                        }
                    }
                    if (jsep !== undefined && jsep !== null) {
                        Janus.debug("Handling SDP as well...");
                        Janus.debug(jsep);
                        localFeedHandlerInstance.handleRemoteJsep({
                            jsep: jsep
                        });
                    }
                    if (msg["request"] === "unpublished") {
                        localFeedHandlerInstance.hangup();
                    }

                    if (msg.leaving && msg.leaving === opts.publisherId) {
                        console.log("sap2ndCamera_participant left", new Date());
                        isParticipantJoined = false;
                        opts.onLeavingCallback && opts.onLeavingCallback();
                    }
                },
                onlocalstream: function(stream) {
                    debuggerService.log({
                        msg: {
                            activity: 'localFeedHandler',
                            callback: 'onlocalstream',
                            timestamp: new Date(),
                            participantType: 'Publisher',
                            participantName: displayName,
                            eventDetails: {
                                typeOfEvent: "Media",
                                timestamp: new Date(),
                                sessionId: sessionId,
                                pluginName: 'videoroom',
                                pluginId: localFeedHandlerInstance.getId(),
                                data: {
                                    comment: 'local media attached'
                                }
                            }
                        },
                        source: 'assess_streamListener'
                    });
                },
                onremotestream: function(stream) {
                    debuggerService.log({
                        msg: {
                            activity: 'localFeedHandler',
                            callback: 'onremotestream',
                            success: true,
                            timestamp: new Date()
                        },
                        source: 'assess_streamListener'
                    });
                },
                oncleanup: function() {
                    debuggerService.log({
                        msg: {
                            activity: 'localFeedHandler',
                            callback: 'oncleanup',
                            success: true,
                            sessionId: sessionId,
                            timestamp: new Date()
                        },
                        source: 'assess_streamListener'
                    });
                },
                mediaState: function(res, on) {
                    debuggerService.log({
                        msg: {
                            activity: 'localFeedHandler',
                            callback: 'mediaState',
                            timestamp: new Date(),
                            participantType: 'Publisher',
                            participantName: displayName,
                            eventDetails: {
                                typeOfEvent: "Media",
                                timestamp: new Date(),
                                sessionId: sessionId,
                                pluginName: 'videoroom',
                                pluginId: localFeedHandlerInstance.getId(),
                                data: {
                                    media: res,
                                    status: on ? 'ON' : 'OFF'
                                }
                            }
                        },
                        source: 'assess_streamListener'
                    });
                },
                detached: function(res) {
                    debuggerService.log({
                        msg: {
                            activity: 'localFeedHandler',
                            callback: 'detached',
                            timestamp: new Date(),
                            participantType: 'Publisher',
                            participantName: displayName,
                            eventDetails: {
                                typeOfEvent: "Handle",
                                timestamp: new Date(),
                                sessionId: sessionId,
                                pluginName: 'videoroom',
                                pluginId: null,
                                data: {
                                    response: res,
                                    comment: 'session detached'
                                }
                            }
                        },
                        source: 'assess_streamListener'
                    });
                }
            };
        }

        function attachRemoteHandler(publisherId, display, handlerPrivateId) {
            //!remoteFeedHandlerInstance &&
            hvsService.attachHandler(remoteFeedHandler(publisherId, display, handlerPrivateId))
        }

        function remoteFeedHandler(publisherId, display, handlerPrivateId) {
            return {
                plugin: "janus.plugin.videoroom",
                opaqueId: opaqueId,
                success: function(pluginHandle) {
                    remoteFeedHandlerInstance = pluginHandle;
                    // We wait for the plugin to send us an offer
                    debuggerService.log({
                        msg: {
                            activity: 'remoteFeedHandler',
                            callback: 'success',
                            timestamp: new Date(),
                            participantName: displayName,
                            eventDetails: {
                                typeOfEvent: "Handle",
                                timestamp: new Date(),
                                sessionId: sessionId,
                                pluginName: 'videoroom',
                                pluginId: remoteFeedHandlerInstance.getId(),
                                data: {
                                    callback: 'success',
                                    comment: 'plugin attached'
                                }
                            }
                        },
                        source: 'assess_streamListener'
                    });
                    var listen = {
                        "request": "join",
                        "room": roomId,
                        "ptype": "subscriber",
                        "feed": publisherId,
                        "private_id": handlerPrivateId
                    };
                    remoteFeedHandlerInstance.send({
                        "message": listen
                    });
                },
                error: function(error) {
                    debuggerService.log({
                        msg: {
                            activity: 'remoteFeedHandler',
                            callback: 'error',
                            timestamp: new Date(),
                            participantName: displayName,
                            eventDetails: {
                                typeOfEvent: "Handle",
                                timestamp: new Date(),
                                sessionId: sessionId,
                                pluginName: 'videoroom',
                                pluginId: remoteFeedHandlerInstance.getId(),
                                data: {
                                    callback: 'error',
                                    error: error,
                                    comment: 'plugin attached failed'
                                }
                            }
                        },
                        source: 'assess_streamListener'
                    });
                },
                onmessage: function(msg, jsep) {
                    var event = msg["videoroom"];
                    Janus.debug("Event: " + event);
                    debuggerService.log({
                        msg: {
                            activity: 'remoteFeedHandler',
                            callback: 'onmessage',
                            msg: msg,
                            jsep: _.omit(jsep, 'sdp'),
                            success: true,
                            timestamp: new Date()
                        },
                        source: 'assess_streamListener'
                    });
                    if (event != undefined && event != null) {
                        if (event === "attached") {
                            // Subscriber created and attached
                            console.log("sap_janus.remotefeed.onmessage :: Successfully attached to feed" + publisherId +
                                " (" +
                                display + ") in room " + msg["room"]);
                        } else {
                            // What has just happened?
                        }
                    }
                    if (jsep !== undefined && jsep !== null) {
                        Janus.debug("Handling SDP as well...");
                        Janus.debug(jsep);
                        // Answer and attach
                        remoteFeedHandlerInstance.createAnswer({
                            jsep: jsep,
                            media: {
                                audioSend: false,
                                videoSend: false
                            }, // We want recvonly audio/video
                            success: function(jsep) {
                                //jsep is here RTCSessionDescription
                                debuggerService.log({
                                    msg: {
                                        activity: 'remoteFeedHandler_createAnswer',
                                        callback: 'success',
                                        jsep: _.omit(jsep.toJSON(), 'sdp'),
                                        success: true,
                                        timestamp: new Date()
                                    },
                                    source: 'assess_streamListener'
                                });
                                var body = {
                                    "request": "start",
                                    "room": roomId
                                };
                                remoteFeedHandlerInstance.send({
                                    "message": body,
                                    "jsep": jsep
                                });
                            },
                            error: function(error) {
                                console.log("sap_janus.remotefeed.onmessage.createAnswer.error", error);
                                Janus.error("WebRTC error:", error);
                                debuggerService.log({
                                    msg: {
                                        activity: 'remoteFeedHandler_createAnswer',
                                        callback: 'error',
                                        success: false,
                                        error: error,
                                        timestamp: new Date()
                                    },
                                    source: 'assess_streamListener'
                                });
                            }
                        });
                    }
                },
                onremotestream: function(stream) {
                    debuggerService.log({
                        msg: {
                            activity: 'remoteFeedHandler',
                            callback: 'onremotestream',
                            success: true,
                            timestamp: new Date()
                        },
                        source: 'assess_streamListener'
                    });
                    remoteStream = stream;
                    getRemoteStreamPromise.notify({ "strm": stream });
                },
                oncleanup: function() {
                    debuggerService.log({
                        msg: {
                            activity: 'remoteFeedHandler',
                            callback: 'oncleanup',
                            success: true,
                            sessionId: sessionId,
                            timestamp: new Date()
                        },
                        source: 'assess_streamListener'
                    });
                },
                mediaState: function(res, on) {
                    debuggerService.log({
                        msg: {
                            activity: 'remoteFeedHandler',
                            callback: 'mediaState',
                            timestamp: new Date(),
                            participantType: 'Publisher',
                            participantName: displayName,
                            eventDetails: {
                                typeOfEvent: "Media",
                                timestamp: new Date(),
                                sessionId: sessionId,
                                pluginName: 'videoroom',
                                pluginId: localFeedHandlerInstance.getId(),
                                data: {
                                    media: res,
                                    status: on ? 'ON' : 'OFF'
                                }
                            }
                        },
                        source: 'assess_streamListener'
                    });
                },
                detached: function(res) {
                    debuggerService.log({
                        msg: {
                            activity: 'remoteFeedHandler',
                            callback: 'detached',
                            timestamp: new Date(),
                            participantType: 'Publisher',
                            participantName: displayName,
                            eventDetails: {
                                typeOfEvent: "Handle",
                                timestamp: new Date(),
                                sessionId: sessionId,
                                pluginName: 'videoroom',
                                pluginId: null,
                                data: {
                                    response: res,
                                    comment: 'session detached'
                                }
                            }
                        },
                        source: 'assess_streamListener'
                    });
                }
            };
        }

        function getPromise(prmObj) {
            return prmObj &&
                prmObj.promise &&
                prmObj.promise.$$state &&
                prmObj.promise.$$state.status !== 2 ? prmObj : $q.defer();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module("OnlineAssessmentAngular")
        .factory("speechTracker", speechTracker);
    speechTracker.$inject = [
        '$q',
        '$log',
        '$interval',
        'commonService',
        'assessmentUtility',
        'loggerService',
        'loginService'
    ];

    function speechTracker($q, $log, $interval, commonService, assessmentUtility, loggerService, loginService) {
        var service = {
            start: start,
            stop: stop,
            config: {
                loggingIntervalObj: null,
                isInitialized: false,
                wordCollection: [],
                wordsArray: [],
                loggingInterval: 60, // in seconds...
                recognition: null,
                isSpeechRecorderStopped: false,
                mediaStream: null
            }
        };
        return service;

        function start(mediaStream, qId) {
            return $q(function(resolve, reject) {
                var cnf = service.config;
                cnf.loginInfo = loginService.getLoginInfo();
                if (cnf.loginInfo !== null) {
                    var loginConf = cnf.loginInfo.Config;
                    if (loginConf && loginConf.speechTrackingInterval) {
                        cnf.loggingInterval = loginConf.speechTrackingInterval;
                    }
                }
                cnf.qId = qId;
                cnf.mediaStream = mediaStream;
                cnf.isInitialized = window.hasOwnProperty('webkitSpeechRecognition');
                if (cnf.isInitialized) {
                    speechDetection("en-IN");
                    setSpeechLog();
                    cnf.isSpeechRecorderStopped = false;
                }
                resolve(true);
            });
        }

        function speechDetection(language) {
            if (!language) {
                return;
            }
            if (!service.config.recognition) {
                service.config.recognition = new webkitSpeechRecognition();
            }
            var recognition = service.config.recognition;
            recognition.continuous = false;
            recognition.interimResults = false;
            recognition.lang = language;

            recognition.start();

            recognition.onresult = function(e) {
                collectWord(e);
            };
            recognition.onerror = function(e) {
                recognition.stop(e);
            };
            recognition.onend = function() {
                if (service.config.mediaStream.getAudioTracks()[0].muted) {
                    stop();
                }
                if (!service.config.isSpeechRecorderStopped) {
                    $log.log('Speech recognition service disconnected');
                    recognition.start();
                    $log.log('Speech recognition service Initiated');
                } else {
                    $log.log('Speech recorder got stoppped');
                }
            };
        }

        function setSpeechLog() {
            service.config.loggingIntervalObj = $interval(function() {
                pushSpeechLog()
            }, (service.config.loggingInterval * 1000));
        }

        function pushSpeechLog() {
            if (_.size(service.config.wordCollection) > 0) {
                var wordCollection_tmp = angular.copy(service.config.wordCollection);
                var wordCount = service.config.wordsArray.length;
                if (wordCount > 0) {
                    var request = {
                        "speechTrackingInfo": {
                            "noOfWords": wordCount,
                            "wordsSpoken": wordCollection_tmp.toString(),
                            "secondsElapsed": assessmentUtility.timer.time(),
                            "timeStamp": new Date()
                        }
                    };
                    if (service.config.qId) {
                        request.speechTrackingInfo.qId = service.config.qId;
                    }
                    if (!commonService.testIsOnlinePreview() && request) {
                        loggerService.push(request);
                    }
                    service.config.wordCollection.length = 0;
                    service.config.wordsArray.length = 0;
                }
            }
        }

        function collectWord(speechDetectionResult) {
            console.log("sap-", JSON.stringify(angular.copy(speechDetectionResult)));
            if (speechDetectionResult.results.length) {
                var wordsSpoken = speechDetectionResult.results[speechDetectionResult.results.length - 1][0].transcript;
                service.config.wordCollection.push(wordsSpoken);
                service.config.wordsArray = _.concat(service.config.wordsArray, wordsSpoken.split(' '));
            }
        }

        function stop() {
            return $q(function(resolve, reject) {
                if (service.config.loggingIntervalObj) {
                    $interval.cancel(service.config.loggingIntervalObj);
                }
                pushSpeechLog();
                if (service.config.recognition) {
                    service.config.recognition.stop();
                    service.config.isSpeechRecorderStopped = true;
                }
                resolve(true);
            });
        }
    }

})();

(function() {
    "use strict";

    angular
        .module("OnlineAssessmentAngular")
        .factory("socketService", socketService);

    function socketService($q, $timeout, $interval, loginService, webService) {
        var pollingIntervalForWebscketReconnection = 15000,
            pollingIntervalForPingServer = 15000,
            pollingLimitToCreateNewConnection = 60000, //60sec
            app = null,
            service = {
                localVar: {
                    adminUserId: 0, //5540,
                    candidateId: 0,
                    eventCallback: {},
                    loginInfo: null,
                    socket: null,
                    testId: 0
                },
                lastEpocRecevied: null,
                init: initSocket,
                close: closeSocket,
                sendMessage: sendMessage
            };
        return service;

        /** WebSocket readyState:

            WebSocket.CONNECTING    0
            WebSocket.OPEN          1
            WebSocket.CLOSING       2
            WebSocket.CLOSED        3
        */

        /*........................Public Methods.....................*/

        /**
        param: data:{
            candidateId: int,
            testId: int,
            chatUserId: int,
            apps: Array,
            eventCallback:{
                chat: fn,
                chatStat: fn,
                terminate: fn,
                reload_conf: fn,
                debugging_log_start: fn,
                debugging_log: fn,
                debugging_log_stop: fn,
                thirdPartyTestCompleted: fn,
                end_test: fn
            }
        }
        */
        function initSocket(data) {
            var sl = service.localVar;

            updateLocalVar(data);

            if (sl.socket) {
                if (data && data.app && data.app.length > 0) {
                    app = _.union(app, data.app);
                    closeSocket(1000, "registering new app-" + data.app)
                        .then(function() {
                            sl.socket = createSocket();
                            if (!sl.socket) {
                                return $q.when(null);
                            }
                            registerSocketEvents();
                            return $q.when(sl.socket);
                        });
                } else {
                    return $q.when(sl.socket);
                }
            } else {
                app = data && data.app ? data.app : ["generic_msg_delivery"];
                sl.socket = createSocket();
                if (!sl.socket) {
                    return $q.when(null);
                }
                registerSocketEvents();
                return $q.when(sl.socket);
            }
        }

        function registerSocketEvents() {
            var sl = service.localVar;
            sl.socket.onopen = function(msg) {
                console.log("WebSocket initiated successfully.");
                console.log("socket event: open ", msg);
                service.lastEpocRecevied = Number(moment().format("X"));
                pingServer();
                checkWebsocketAndConnectAgain();
            };
            sl.socket.onmessage = function(msg) {
                console.log("socket event: message ", msg);
                service.lastEpocRecevied = Number(moment().format("X"));
                handleMessage(msg.data);
            };
            sl.socket.onerror = function(msg) {
                console.log("socket event: error ", msg);
            };
            sl.socket.onclose = function(msg) {
                console.log("socket event: close ", msg);
            };
        }

        /**
        param: data:{
            guid: UUID,
            app: String,
            msgType: String,
            msgBody: String
        }
        */
        function sendMessage(data) {
            var sl = service.localVar;
            if (!data) {
                return false;
            }
            sendMessageToUser(data);
            //sl.socket && emitMsg(data);
            console.log("socket event: message::chat_send ", data);
        }

        /**
        param:
            code: int,[find from: https://developer.mozilla.org/en-US/docs/Web/API/CloseEvent#Status_codes]
            reason: String
                
        */
        function closeSocket(code, reason) {
            var sl = service.localVar,
                deffered = $q.defer(),
                coloseInterval = null;
            code = code ? code : 1000;
            reason = reason ? "Closing socket_" + reason : "Closing socket";

            console.log("WebSocket closing: [code: " + code + " | reason: " + reason);

            sl.socket &&
                sl.socket.readyState == 1 &&
                sl.socket.close(code, reason);

            coloseInterval = $interval(function() {
                if (sl.socket && sl.socket.readyState == 3) {
                    sl.socket = null;
                    deffered.resolve();
                    $interval.cancel(coloseInterval);
                }
            }, 100);

            return deffered.promise;
        }

        /*..........................Private Methods........................*/

        function createSocket() {
            var socket = null,
                sl = service.localVar,
                loginInfo = loginService.getLoginInfo(),
                url = loginInfo.WebsocketConf &&
                loginInfo.WebsocketConf.WSS_URL,
                token = sessionStorage['X-AUTH-TOKEN'],
                scoketUrl = url + "?" +
                'token=' + token +
                '&version=1' +
                '&app=' + app.toString() +
                '&guid=' + window.getUUID();
            if (!"WebSocket" in window) {
                console.error("WebSocket is not supported by your browser!");
                return null;
            } else if (!url) {
                console.error("Socket url is not defined!");
                return null;
            }
            console.log("Socket url:", scoketUrl);
            socket = new WebSocket(scoketUrl);

            return socket;
        }

        function updateLocalVar(data) {
            var sl = service.localVar;
            if (!data) return false;
            addEventCallback(data.eventCallback);
            sl.candidateId = validateAndGetId(data.candidateId, sl.candidateId);
            sl.testId = validateAndGetId(data.testId, sl.testId);
            //sl.adminUserId = validateAndGetId(Number(data.chatUserId), sl.adminUserId, 5540); //165607;
        }

        function addEventCallback(eventsCallBack) {
            var sl = service.localVar;
            eventsCallBack && _.merge(sl.eventCallback, eventsCallBack);
        }

        function validateAndGetId(newValue, oldValue, defaultValue) {
            defaultValue = isNullOrUndefined(defaultValue) ? 0 : defaultValue;
            if (oldValue >= 0 && oldValue != defaultValue && newValue != oldValue) {
                return oldValue;
            }
            return !isNullOrUndefined(newValue) && newValue >= 0 ? newValue : defaultValue;
        }

        function isNullOrUndefined(data) {
            return data == null || angular.isUndefined(data);
        }

        function handleMessage(msg) {
            if (!msg) {
                return false;
            }
            msg = JSON.parse(msg);
            switch (msg.type) {
                case "proctor_init":
                    handleMsgTypeProctorInit(msg);
                    break;
                case "chat":
                    handleMsgTypeChat(msg);
                    break;
                case "chat_resp":
                    handleMsgTypeChatResp(msg);
                    break;
                case "ping_tu":
                    handleMsgTypePingTu(msg);
                    break;
                case "terminate":
                    handleMsgTypeTerminate(msg);
                    break;
                case "reload_conf":
                    handleMsgTypeReloadConf(msg);
                    break;
                case "close_socket":
                    handleMsgTypeCloseSocket(msg);
                    break;
                case "debugging_log_start":
                    handleMsgTypeDebuggingLogStart(msg);
                    break;
                case "debugging_log":
                    handleMsgTypeDebuggingLog(msg);
                    break;
                case "debugging_log_resp":
                    handleMsgTypeDebuggingLogResp(msg);
                    break;
                case "debugging_log_stop":
                    handleMsgTypeDebuggingLogStop(msg);
                    break;
                case "thirdPartyTestCompleted":
                    handleMsgTypeSubmitTest(msg);
                    break;
                case "end_test":
                    handleMsgTypeEndTest(msg);
                    break;
                default:
                    console.log("Message type-" + msg.type + "is not being handled !")
            }
        }

        /*...............proctor_init.............*/
        function handleMsgTypeProctorInit(msg) {
            console.log("socket event: message::proctor_init ", msg);
            sendMsgTypeProctorInitResp(msg);
        }

        function sendMsgTypeProctorInitResp(msg) {
            console.log("socket event: message::proctor_init_resp ", msg);
            var sl = service.localVar,
                data = null;
            if (msg && msg.body && msg.body.userId) {
                sl.adminUserId = Number(msg.body.userId);
                data = {
                    guid: msg.guid,
                    msgType: "proctor_init_resp",
                    msgBody: null
                };
                //emitMsg(data);
                sendMessage(data);
            }
        }

        /*...............chat....................*/
        function handleMsgTypeChat(msg) {
            var sl = service.localVar;
            console.log("socket event: message::chat ", msg);
            sendMsgTypeChatResp(msg);
            executeCallBack(sl.eventCallback.chat, msg);
        }

        function sendMsgTypeChatResp(msg) {
            console.log("socket event: message::chat_resp ", msg);
            var data = {
                guid: msg.guid,
                msgType: "chat_resp",
                msgBody: null
            };
            //emitMsg(data);
            sendMessage(data);
        }

        /*...............chat_resp....................*/
        function handleMsgTypeChatResp(msg) {
            var sl = service.localVar;
            console.log("socket event: message::chat_resp ", msg);
            executeCallBack(sl.eventCallback.chatStat, msg);
        }

        /*...............Ping_tu.................*/
        function handleMsgTypePingTu(msg) {
            console.log("socket event: message::ping_tu ", msg);
            sendMsgTypePongTu(msg);
        }

        function sendMsgTypePongTu(msg) {
            console.log("socket event: message::pong_tu ", msg);
            var data = {
                guid: msg.guid,
                msgType: "pong_tu",
                msgBody: null
            };
            //emitMsg(data);
            sendMessage(data);
        }

        /*................terminate..............*/
        function handleMsgTypeTerminate(msg) {
            var sl = service.localVar;
            console.log("socket event: message::terminate ", msg);
            executeCallBack(sl.eventCallback.terminate, msg);
        }

        /*................submit test..............*/
        function handleMsgTypeSubmitTest(msg) {
            var sl = service.localVar;
            console.log("socket event: message::submitTest ", msg);
            sendMsgTypeSubmitTestResp(msg);
            executeCallBack(sl.eventCallback.submitTest, msg);
        }

        function sendMsgTypeSubmitTestResp(msg) {
            console.log("socket event: message::thirdPartyTestCompleted_resp ", msg);
            var data = {
                guid: msg.guid,
                msgType: "thirdPartyTestCompleted_resp",
                msgBody: null
            };
            //emitMsg(data);
            sendMessage(data);
        }

        /*...............reload_conf............*/
        function handleMsgTypeReloadConf(msg) {
            var sl = service.localVar;
            console.log("socket event: message::reload_conf ", msg);
            sendMsgTypeReloadConfResp(msg);
            executeCallBack(sl.eventCallback.reload_conf, msg);
        }

        function sendMsgTypeReloadConfResp(msg) {
            var sl = service.localVar;
            console.log("socket event: message::reload_conf_resp ", msg);
            var data = {
                guid: msg.guid,
                msgType: "reload_conf_resp",
                msgBody: null
            };
            //emitMsg(data);
            sendMessage(data);
        }

        /*...............End Test..............*/
        function handleMsgTypeEndTest(msg) {
            var sl = service.localVar;
            console.log("socket event: message::end_test ", msg);
            executeCallBack(sl.eventCallback.end_test, msg);
        }

        /*...............close_socket.............*/
        function handleMsgTypeCloseSocket(msg) {
            var sl = service.localVar;
            console.log("socket event: message::close_socket ", msg);
            closeSocket(1000, "Closing as per proctor[" + sl.adminUserId + "] rqst.");
        }

        /**..............................Debug Log.........................../

        /*...............START::debugging_log_start.............*/
        function handleMsgTypeDebuggingLogStart(msg) {
            var sl = service.localVar;
            console.log("socket event: message::debugging_log_start ", msg);
            sendMsgTypeDebuggingLogStartResp();
            executeCallBack(sl.eventCallback.debugging_log_start, msg);
        }

        function sendMsgTypeDebuggingLogStartResp(msg) {
            var sl = service.localVar;
            console.log("socket event: message::debugging_log_start_resp ", msg);
            var data = {
                guid: msg.guid,
                msgType: "debugging_log_start_resp",
                msgBody: null
            };
            //emitMsg(data);
            sendMessage(data);
        }

        /*...............debugging_log.............*/
        function handleMsgTypeDebuggingLog(msg) {
            var sl = service.localVar;
            console.log("socket event: message::debugging_log ", msg);
            executeCallBack(sl.eventCallback.debugging_log, msg);
        }

        /*...............STOP::debugging_log_stop.............*/
        function handleMsgTypeDebuggingLogStop(msg) {
            var sl = service.localVar;
            console.log("socket event: message::debugging_log_stop ", msg);
            sendMsgTypeDebuggingLogStopResp();
            executeCallBack(sl.eventCallback.debugging_log_stop, msg);
        }

        function sendMsgTypeDebuggingLogStopResp(msg) {
            var sl = service.localVar;
            console.log("socket event: message::debugging_log_stop_resp ", msg);
            var data = {
                guid: msg.guid,
                msgType: "debugging_log_stop_resp",
                msgBody: null
            };
            //emitMsg(data);
            sendMessage(data);
        }

        /*.................................................................*/

        function executeCallBack(clbk, param) {
            clbk && clbk(param);
        }

        function pingServer() {
            console.log("WebSocket pingServer:");
            var sl = service.localVar,
                data = {
                    app: "ping_pong",
                    msgType: "ping"
                };
            emitMsg(data);
            if (!sl.socket || sl.socket.readyState == 0) {
                return false;
            }
            $timeout(function() { pingServer(); }, pollingIntervalForPingServer);
        }

        function checkWebsocketAndConnectAgain() {
            var sl = service.localVar,
                currentEpoc = Number(moment().format("X")),
                difference = currentEpoc - service.lastEpocRecevied;
            console.log("WebSocket checkWebsocketAndConnectAgain:difference ", difference);
            if (!sl.socket || sl.socket.readyState == 0) {
                return false;
            }
            if (difference >= pollingLimitToCreateNewConnection) {
                closeSocket("polling time limit exceeded.")
                    .then(function() {
                        initSocket();
                    });
                return false;
            }
            $timeout(function() { checkWebsocketAndConnectAgain(); }, pollingIntervalForWebscketReconnection);
        }

        /** ::Data Structure for emiting emssage through WebSocket::
        var dataToBeSend = {
                to: int(Listener ID)
                tkn: X-AUTH-TOKEN
                app: "ping_pong"/"generic_msg_delivery"/..
                msg:{
                    guid: window.getUUID(),
                    type: "proctor_init_resp"/"chat"/..
                    testId: int,
                    candidateId: int,
                    body:{
                        text: String
                    }
                }
            }
        */
        function emitMsg(data) {
            var sl = service.localVar,
                guid = null,
                dataToBeSend = null;

            if (!data || !sl.socket || sl.socket.readyState == 3) {
                return false;
            }

            //If socket.readyState is in connecting state(0)
            if (sl.socket.readyState == 0) {
                $timeout(function() { emitMsg(data); }, 100);
                return false;
            }
            sl = service.localVar;
            guid = data.guid ? data.guid : window.getUUID();
            dataToBeSend = {
                tkn: sessionStorage['X-AUTH-TOKEN'],
                app: data.app ? data.app : "generic_msg_delivery",
                msg: {
                    guid: guid,
                    type: data.msgType ? data.msgType : "chat"
                }
            };
            if (data.app != "ping_pong") {

                dataToBeSend["to"] = sl.adminUserId;
                dataToBeSend.msg["testId"] = sl.testId;
                dataToBeSend.msg["candidateId"] = sl.candidateId;
                dataToBeSend.msg["body"] = {
                    text: data.msgBody
                };
            }
            sl.socket &&
                sl.socket.readyState == 1 &&
                sl.socket.send(JSON.stringify(dataToBeSend));
        }

        function sendMessageToUser(data) {
            var sl = service.localVar,
                apiToCall = data.app === "secondary_camera_msg_delivery" ?
                "sendMessageToTestUser" : "sendMessageToUser",
                guid = data.guid ? data.guid : window.getUUID(),
                rqst = {
                    "toUserId": data.toUserId ? data.toUserId : sl.adminUserId,
                    "appsToSend": data.app ? data.app : "generic_msg_delivery",
                    "message": {
                        "guid": guid,
                        "type": data.msgType ? data.msgType : "chat",
                        "testId": sl.testId,
                        "candidateId": sl.candidateId,
                        "body": {
                            "text": data.msgBody
                        }
                    }

                };
            webService.execute(apiToCall, rqst)
                .then(function(res) {
                    console.log(res);
                })
                .catch(function(err) {
                    console.log(err);
                });
        }
    }
})();

(function() {
    'use strict';
    angular
        .module("OnlineAssessmentAngular")
        .factory("screenRecordingService", screenProctoringJanusService);

    function screenProctoringJanusService($q, $timeout, $rootScope, hvsService, webService, loggerService, commonService, assessmentUtility, loginService, webRtcStatsService, socketService, debuggerService) {
        var userId = null,
            handlerInstance = null,
            sessionId = null,
            streamId = null,
            displayName = "",
            opaqueId = "in.hirepro.onlineassessment.screenProctoring-" + Janus.randomString(12),
            loginInfo = loginService.getLoginInfo(),
            tenantId = sessionStorage.getItem('_tId'),
            startProcPromise = null,
            ProcStartStat = [],
            ProcStopStat = [],
            mediaConstrint = {
                recordingType: "screen",
                screenRecordConstraints: {
                    frameRate: 1,
                    logicalSurface: true
                },
                audio: false
            },
            isTrackingRequire = false,
            isIceRestarted = false,
            isIceDisconnected = false,
            publishers = [],
            allowTestTerminationOnDemand = !!_.get(loginInfo, 'Config.allowTestTerminationOnDemand'),
            enableChatting = !!_.get(loginInfo, 'Config.enableChatting'),
            enableLiveStream = !!_.get(loginInfo, 'Config.liveStream'),
            isThirdPartyProctoringTestType = _.get(loginInfo, 'Config.isThirdPartyProctoringTestType'),
            isInternalStart = false,
            restartHvsTimeout = null,
            service = {
                "goldenImagePath": null,
                "proctoringImagePath": null,
                "mediaStream": null,
                "isScreenProctoringStarted": false,
                "start": startRecording,
                "stop": stopRecording,
                "localVar": {},
                "status": null, //starting/started/stopping/stopped
                "utility": {
                    "getProctoringConfig": getProctoringConfig,
                    "getTenantSpecificProctoringConfig": getTenantSpecificProctoringConfig,
                    "getGlobalProctoringConfig": getGlobalProctoringConfig
                }
            };
        return service;

        /*...........................Public Methods......................*/

        function startRecording(opts) {
            var sl = service.localVar;
            service.status = "starting";
            startProcPromise = getPromise(startProcPromise);

            initializeTrackingData(null);

            ProcStartStat.length = 0;
            ProcStopStat.length = 0;
            publishers.length = 0;
            if (opts) {
                mediaConstrint.audio = !!opts.userMediaAudioCapture;
                isTrackingRequire = !!opts.isTrackingRequire;
            }
            getProctoringConfig()
                .then(function(res) {
                    updateMediaConstraint(res);
                    return hvsService.startConference(getHandler(), false, { isPresentation: true }, "screenProctoring")
                })
                .then(function(res) {
                    var data = {
                        eventCallback: {
                            reload_conf: reloadConference
                        }
                    };
                    if (enableChatting ||
                        enableLiveStream ||
                        allowTestTerminationOnDemand ||
                        isThirdPartyProctoringTestType) {
                        socketService.init(data);
                    }
                    service.status = "started";
                    sessionId = res.data.sessionId;
                    debuggerService.log({
                        msg: {
                            activity: 'startProctoring',
                            success: true,
                            sessionId: sessionId,
                            timestamp: new Date()
                        },
                        source: 'screenProctorhvsLog'
                    });
                })
                .catch(function(res) {
                    debuggerService.log({
                        msg: {
                            activity: 'startProctoring',
                            success: false,
                            response: res,
                            timestamp: new Date()
                        },
                        source: 'screenProctorhvsLog'
                    });
                    startProcPromise.reject({
                        'strm': null,
                        'msg': 'Not able to start proctoring service.',
                        'isOnline': undefined
                    });
                })
                .finally(function() {});
            return startProcPromise.promise;
        }

        function stopRecording() {
            service.status = "stopping";
            startProcPromise = null;
            if (!handlerInstance) {
                debuggerService.log({
                    msg: {
                        activity: 'stopProctoring',
                        success: false,
                        response: 'no handlerInstance',
                        timestamp: new Date()
                    },
                    source: 'screenProctorhvsLog'
                });
                return $q.when({ data: { isStopped: false }, msg: "Not able to stop confrence!" });
            }
            return hvsService.stopConference(handlerInstance)
                .then(function() {
                    service.status = "stopped";
                    return unPublishedFeed(streamId);
                });
        }

        function reloadConference(msg) {
            debuggerService.log({
                msg: {
                    activity: 'Restarting ICE as per proctor request.',
                    response: msg,
                    timestamp: new Date()
                },
                source: 'screenProctorhvsLog'
            });
            restartIce();
        }

        /*.............................Private Methods...................*/

        function updateMediaConstraint(procConf) {
            var msg = "Didn't find any media config for screen proctoring,using default media config.",
                videoConf = null,
                audioConf = null;
            if (procConf && procConf.screenProctoring && procConf.screenProctoring.media) {

                msg = "Media constraint uapdated as per tenant specification.";
                videoConf = procConf.screenProctoring.media.video;
                if (videoConf) {
                    /*...Update FrameRate...*/
                    mediaConstrint.screenRecordConstraints.frameRate = videoConf.frameRate ?
                        videoConf.frameRate : mediaConstrint.screenRecordConstraints.frameRate;
                    /*...Update LogicalSurface...*/
                    mediaConstrint.screenRecordConstraints.logicalSurface = videoConf.logicalSurface ?
                        videoConf.logicalSurface : mediaConstrint.screenRecordConstraints.logicalSurface;
                    /*...Add Video Height..*/
                    if (videoConf.height) {
                        mediaConstrint.screenRecordConstraints.height = videoConf.height;
                    }
                    /*...Add Video Width..*/
                    if (videoConf.width) {
                        mediaConstrint.screenRecordConstraints.width = videoConf.width;
                    }
                }
                mediaConstrint.audio = !!procConf.screenProctoring.media.audio;
            }
            debuggerService.log({
                msg: {
                    activity: 'startProctoring_getProctoringConfig',
                    msg: msg,
                    response: mediaConstrint,
                    timestamp: new Date()
                },
                source: 'screenProctorhvsLog'
            });
        }

        function restartIce() {
            /*socketService.close(1000, "restart ICE")
                .then(function() {
                    socketService.init();
                });*/
            console.log("screenProctor_hvs_log.iceServer.refresh");
            handlerInstance.createOffer({
                iceRestart: true,
                media: {
                    video: mediaConstrint.recordingType,
                    screenRecordConstraints: mediaConstrint.screenRecordConstraints,
                    audioRecv: false,
                    videoRecv: false,
                    audioSend: mediaConstrint.audio,
                    videoSend: mediaConstrint.video
                },
                success: function(jsep) {
                    var publish = { request: "configure", refresh: true };
                    handlerInstance.send({ message: publish, jsep: jsep });
                    debuggerService.log({
                        msg: {
                            activity: 'JSEP',
                            timestamp: new Date(),
                            participantType: 'Publisher',
                            participantName: displayName,
                            eventDetails: {
                                typeOfEvent: 'JSEP',
                                timestamp: new Date(),
                                sessionId: sessionId,
                                pluginName: 'videoroom',
                                pluginId: handlerInstance.getId(),
                                data: {
                                    callback: 'success',
                                    // SDP: jsep,
                                    comment: 'ice restart'
                                }
                            }
                        },
                        source: 'screenProctorhvsLog'
                    });
                },
                error: function(error) {
                    hvsService.restartHVS('refresh ice failed');
                    debuggerService.log({
                        msg: {
                            activity: 'JSEP',
                            timestamp: new Date(),
                            participantType: 'Publisher',
                            participantName: displayName,
                            eventDetails: {
                                typeOfEvent: "JSEP",
                                timestamp: new Date(),
                                sessionId: sessionId,
                                pluginName: 'videoroom',
                                pluginId: handlerInstance.getId(),
                                data: {
                                    callback: 'error',
                                    error: error,
                                    comment: 'ice restart failed'
                                }
                            }
                        },
                        source: 'screenProctorhvsLog'
                    });
                }
            });
        }

        function getHandler() {
            return {
                plugin: "janus.plugin.videoroom",
                opaqueId: opaqueId,
                success: function(_pluginHandle) {
                    console.log("screenProctor_hvs_log.handler.success");
                    displayName = sessionStorage.getItem('assess_janus_screen_displayName');
                    handlerInstance = _pluginHandle;
                    hvsService.publishFeedToJanus(handlerInstance, displayName);
                    hvsService.addHandlerInstance(handlerInstance, "screenProctoring");
                    debuggerService.log({
                        msg: {
                            activity: 'Handle',
                            timestamp: new Date(),
                            participantType: 'Publisher',
                            participantName: displayName,
                            eventDetails: {
                                typeOfEvent: "Handle",
                                timestamp: new Date(),
                                sessionId: sessionId,
                                pluginName: 'videoroom',
                                pluginId: handlerInstance.getId(),
                                data: {
                                    callback: 'success',
                                    comment: 'plugin attached'
                                }
                            }
                        },
                        source: 'screenProctorhvsLog'
                    });
                },
                error: function(error) {
                    console.log("screenProctor_hvs_log.handler.error", error);
                    debuggerService.log({
                        msg: {
                            activity: 'Handle',
                            timestamp: new Date(),
                            participantType: 'Publisher',
                            participantName: displayName,
                            eventDetails: {
                                typeOfEvent: "Handle",
                                timestamp: new Date(),
                                sessionId: sessionId,
                                pluginName: 'videoroom',
                                pluginId: null,
                                data: {
                                    callback: 'error',
                                    error: error,
                                    comment: 'plugin attached failed'
                                }
                            }
                        },
                        source: 'screenProctorhvsLog'
                    });
                },
                consentDialog: function(res) {
                    console.log("screenProctor_hvs_log.handler.consentDialog", res);
                },
                webrtcState: function(on) {
                    console.log("screenProctor_hvs_log.handler.webrtcState", on);
                    debuggerService.log({
                        msg: {
                            activity: 'WEBRtc',
                            timestamp: new Date(),
                            participantType: 'Publisher',
                            participantName: displayName,
                            eventDetails: {
                                typeOfEvent: "WEBRtc",
                                timestamp: new Date(),
                                sessionId: sessionId,
                                pluginName: 'videoroom',
                                pluginId: handlerInstance.getId(),
                                data: {
                                    webrtcState: on ? 'ON' : 'OFF'
                                }
                            }
                        },
                        source: 'screenProctorhvsLog'
                    });
                    if (!on && !isInternalStart) {
                        console.log("sap1_screen_webrtcState_restartHvsTimeout", restartHvsTimeout);
                        if (restartHvsTimeout) {
                            $timeout.cancel(restartHvsTimeout);
                            restartHvsTimeout = null;
                        }
                        console.log("videoProctor_hvs_log.handler.webrtcState restarted HVS ");
                        console.log("sap1_screen_webrtcState_restartHVS");
                        hvsService.restartHVS('webrtcState is false');
                    }
                },
                iceState: function(stat) {
                    console.log("screenProctor_hvs_log.handler.iceState", stat);
                    debuggerService.log({
                        msg: {
                            activity: 'WEBRtc',
                            timestamp: new Date(),
                            participantType: 'Publisher',
                            participantName: displayName,
                            eventDetails: {
                                typeOfEvent: "WEBRtc",
                                timestamp: new Date(),
                                sessionId: sessionId,
                                pluginName: 'videoroom',
                                pluginId: handlerInstance.getId(),
                                data: {
                                    iceState: stat
                                }
                            }
                        },
                        source: 'screenProctorhvsLog'
                    });
                    console.log("sap1_screen_iceState_stat", stat);
                    if (stat === "disconnected" && !isInternalStart) {
                        restartHvsTimeout = hvsService.restartHVS('iceState', 30);
                    } else if (stat === "connected") {
                        if (restartHvsTimeout) {
                            $timeout.cancel(restartHvsTimeout);
                            restartHvsTimeout = null;
                        }
                    }
                },
                onmessage: function(msg, jsep) {
                    debuggerService.log({
                        msg: {
                            activity: 'getHandler',
                            callback: 'onmessage',
                            msg: msg,
                            jsep: _.omit(jsep, 'sdp'),
                            success: true,
                            timestamp: new Date()
                        },
                        source: 'screenProctorhvsLog'
                    });
                    console.log("screenProctor_hvs_log.handler.onmessage", msg);
                    var event = msg["videoroom"];
                    if (event === "joined") {
                        userId = msg["id"];
                        if (_.size(msg.publishers) > 0) {
                            publishers = msg.publishers;
                        }
                        hvsService.publishFeedToWebRtc(handlerInstance, userId, mediaConstrint, displayName)
                            .then(function(res) {
                                sessionId = res.data.sessionId;
                                isInternalStart = false;
                                console.log("screenProctor_hvs_log.handler.onlocalstream.publishFeedToWebRtc", res.msg);
                                return startPublishing();
                            })
                            .then(function(res) {
                                startProcPromise.resolve({
                                    'strm': service.mediaStream,
                                    'msg': 'Successfully started proctoring service.',
                                    'isOnline': $rootScope.isNetworkGotFailed
                                });
                            })
                            .catch(function(res) {
                                console.log("screenProctor_hvs_log.handler.onlocalstream.publishFeedToWebRtc", res.error);
                                var msg = 'Not able to initialize proctoring service!';
                                if (res.error === "NotAllowedError: Permission denied") {
                                    msg = "Screen sharing is mandatory!<br/>Without sharing your screen,you will not be able to start the test.";
                                    isInternalStart && restartSharing();
                                }
                                startProcPromise.reject({
                                    'strm': null,
                                    'msg': msg,
                                    'isOnline': $rootScope.isNetworkGotFailed
                                });
                                stopRecording();
                            });
                    }
                    if (jsep !== undefined && jsep !== null) {
                        Janus.debug("Handling SDP as well...");
                        Janus.debug(jsep);
                        handlerInstance.handleRemoteJsep({
                            jsep: jsep
                        });
                    }
                    if (msg["request"] === "unpublished") {
                        handlerInstance.hangup();
                    }
                },
                onlocalstream: function(stream) {
                    var sharedScreenInfo = getSelectedDisplaySurface(stream);
                    if (!sharedScreenInfo.isAllowed) {
                        startProcPromise.reject({
                            'strm': null,
                            'msg': sharedScreenInfo.msg,
                            'isOnline': $rootScope.isNetworkGotFailed
                        });
                        stopRecording();
                        return false;
                    }
                    /*startPublishing()
                        .then(function(res) {
                            startProcPromise.resolve({
                                'strm': stream,
                                'msg': 'Successfully started proctoring service.',
                                'isOnline': $rootScope.isNetworkGotFailed
                            });
                        })
                        .catch(function(res) {
                            startProcPromise.reject({
                                'strm': null,
                                'msg': 'Not able to initialize proctoring service!',
                                'isOnline': $rootScope.isNetworkGotFailed
                            });
                        });*/
                    handleOnScreenSharingStop(stream);
                    console.log("screenProctor_hvs_log.handler.onlocalstream");
                    debuggerService.log({
                        msg: {
                            activity: 'Media',
                            timestamp: new Date(),
                            participantType: 'Publisher',
                            participantName: displayName,
                            eventDetails: {
                                typeOfEvent: "Media",
                                timestamp: new Date(),
                                sessionId: sessionId,
                                pluginName: 'videoroom',
                                pluginId: handlerInstance.getId(),
                                data: {
                                    comment: 'local media attached'
                                }
                            }
                        },
                        source: 'screenProctorhvsLog'
                    });
                    service.isScreenProctoringStarted = true;
                    service.mediaStream = stream;
                    initializeTrackingData(stream);

                    service.goldenImagePath = hvsService.goldenImagePath;
                    service.proctoringImagePath = hvsService.proctoringImagePath;
                    var data = {
                        type: 'publisher',
                        id: displayName,
                        wrtcConnection: handlerInstance.webrtcStuff
                    };
                    //webRtcStatsService.start(data);
                },
                onremotestream: function(stream) {
                    debuggerService.log({
                        msg: {
                            activity: 'getHandler',
                            callback: 'onremotestream',
                            success: true,
                            timestamp: new Date()
                        },
                        source: 'screenProctorhvsLog'
                    });
                    console.log("screenProctor_hvs_log.handler.onremotestream");
                },
                oncleanup: function() {
                    debuggerService.log({
                        msg: {
                            activity: 'getHandler',
                            callback: 'oncleanup',
                            success: true,
                            sessionId: sessionId,
                            timestamp: new Date()
                        },
                        source: 'screenProctorhvsLog'
                    });
                    service.mediaStream = null;
                    initializeTrackingData(null);
                    //webRtcStatsService.stopAll();
                    console.log("screenProctor_hvs_log.handler.oncleanup");
                },
                mediaState: function(res, on) {
                    debuggerService.log({
                        msg: {
                            activity: 'Media',
                            timestamp: new Date(),
                            participantType: 'Publisher',
                            participantName: displayName,
                            eventDetails: {
                                typeOfEvent: "Media",
                                timestamp: new Date(),
                                sessionId: sessionId,
                                pluginName: 'videoroom',
                                pluginId: handlerInstance.getId(),
                                data: {
                                    media: res,
                                    status: on ? 'ON' : 'OFF'
                                }
                            }
                        },
                        source: 'screenProctorhvsLog'
                    });
                    console.log("screenProctor_hvs_log.handler.mediaState", res, on);
                    /*if (!isIceRestarted && !on) {
                        if (restartHvsTimeout) {
                            $timeout.cancel(restartHvsTimeout);
                            restartHvsTimeout = null;
                        }
                        isIceRestarted = true;
                        restartIce();
                    }
                    if (on) {
                        isIceRestarted = false;
                    }*/
                },
                detached: function(res) {
                    debuggerService.log({
                        msg: {
                            activity: 'Handle',
                            timestamp: new Date(),
                            participantType: 'Publisher',
                            participantName: displayName,
                            eventDetails: {
                                typeOfEvent: "Handle",
                                timestamp: new Date(),
                                sessionId: sessionId,
                                pluginName: 'videoroom',
                                pluginId: null,
                                data: {
                                    response: res,
                                    comment: 'session detached'
                                }
                            }
                        },
                        source: 'screenProctorhvsLog'
                    });
                    console.log("screenProctor_hvs_log.handler.detached", res);
                }
            };
        }

        function getSelectedDisplaySurface(strm) {
            if (!strm) {
                return { isAllowed: false };
            }
            var displaySurface = strm.getVideoTracks()[0].getSettings().displaySurface,
                selectedDisplaySurface = "Your Entire Screen",
                isAllowed = true,
                msg = "";

            if (displaySurface === "window") {
                selectedDisplaySurface = "Application Window";
            } else if (displaySurface === "browser") {
                selectedDisplaySurface = "Chrome Tab";
            }
            if (displaySurface !== "monitor") {
                msg = "You have to select <b>Your Entire Screen</b> option to share,which is mandatory." +
                    "<br/>" +
                    "You have selected <i>" + selectedDisplaySurface + "</i> option to share."
                isAllowed = false;
                console.log("screenProctor_hvs_log.handler.onlocalstream:: " + msg);
                debuggerService.log({
                    msg: {
                        activity: 'Media',
                        timestamp: new Date(),
                        success: false,
                        selectedDisplaySurface: selectedDisplaySurface
                    },
                    source: 'screenProctorhvsLog'
                });
            }
            return {
                isAllowed: isAllowed,
                msg: msg
            };
        }

        function initializeTrackingData(strm) {
            if (!isTrackingRequire) return false;
            if (strm == null) {
                $rootScope.vidStrm = null;
                $rootScope.vidStrmId = null;
            } else if (strm) {
                $rootScope.vidStrm = strm;
                $rootScope.vidStrmId = strm.id;
            }
        }

        function handleOnScreenSharingStop(stream) {
            if (!stream) return false;
            var videoTrack = stream.getVideoTracks()[0];
            if (!videoTrack) return false;
            if (videoTrack.onended) return false;
            videoTrack.onended = function(res) {
                console.log("screenProctor_hvs_log.screenRecordnig_stopped");
                isInternalStart = true;
                debuggerService.log({
                    msg: {
                        activity: 'Screen scaring stopped',
                        timestamp: new Date()
                    },
                    source: 'screenProctorhvsLog'
                });
                if (service.status === "started") {
                    restartSharing();
                }
            }
        }

        function restartSharing() {
            console.log("sap1_screen_restartSharing");
            hvsService.stopConference(handlerInstance, true, false)
                .then(function() {
                    console.log("sap1_screen_restartSharing_unPublishedFeed");
                    return unPublishedFeed(streamId);
                })
                .then(function() {
                    console.log("sap1_screen_restartSharing_startConference");
                    return hvsService.startConference(
                        getHandler(),
                        true, { isPresentation: true }, "screenProctoring")
                })
                .then(function(res) {
                    console.log("sap1_onStartReording_success", res);
                })
                .catch(function(res) {
                    console.log("sap1_onStartReording_fail", res);
                });
        }

        function startPublishing() {
            var request = {
                serverUserId: userId,
                serverSessionId: sessionId,
                pluginHandleId: handlerInstance.getId(),
                goldenImagePath: assessmentUtility.localStorage.getData('savedinS3GoldenImagePath'),
                isRefresh: false,
                isPresentation: true
            };
            return webService.execute('startPublishing', request)
                .then(function(res) {
                        if (!res || !res.data || (_.get(res, 'data.status') === 'KO')) {
                            debuggerService.log({
                                msg: {
                                    activity: 'startPublishing',
                                    response: res,
                                    success: false,
                                    timestamp: new Date()
                                },
                                source: 'screenProctorhvsLog'
                            });
                            onPublishingFail(request, res);
                            return $q.reject({
                                data: { isPublished: false },
                                msg: "Error occured,while trying to publishing!"
                            });
                        } else {
                            debuggerService.log({
                                msg: {
                                    activity: 'startPublishing',
                                    success: true,
                                    request: request,
                                    response: { data: res.data, xGuid: res.xGuid },
                                    apiCall: true,
                                    timestamp: new Date()
                                },
                                source: 'screenProctorhvsLog'
                            });
                            if (res.data.data) {
                                streamId = res.data.data.streamId;
                            }
                            return $q.resolve({
                                data: { isPublished: true },
                                msg: "Successfully published."
                            });
                        }
                    },
                    function(res) {
                        debuggerService.log({
                            msg: {
                                activity: 'startPublishing',
                                response: res,
                                success: false,
                                timestamp: new Date()
                            },
                            source: 'screenProctorhvsLog'
                        });
                        onPublishingFail(request, res);
                        return $q.reject({
                            data: { isPublished: false },
                            msg: "Error occured,while trying to publishing!"
                        });
                    });
        }

        function unPublishedFeed(streamId) {
            return stopPublishing(streamId)
                .then(function(res) {
                    service.isVideoProctoringStarted = false;
                    return res;
                })
                .finally(function() {});
        }

        function stopPublishing(streamId) {
            if (!streamId) {
                return $q.resolve({
                    data: { isStopped: true },
                    msg: "Confrence is stopped successfully."
                });
            }
            var rq = {
                isFinalInterviewEnd: true,
                streamId: streamId,
                isPresentation: true
            };
            return webService.execute('stopPublishing', rq)
                .then(function(res) {
                    if (!res || !res.data || !res.data.status === 'KO') {
                        debuggerService.log({
                            msg: {
                                activity: 'stopPublishing',
                                success: false,
                                apiCall: true,
                                timestamp: new Date()
                            },
                            source: 'screenProctorhvsLog'
                        });
                        return $q.reject({
                            data: { isStopped: false },
                            msg: "Unable to stop Confrence!"
                        });
                    }
                    debuggerService.log({
                        msg: {
                            activity: 'stopPublishing',
                            success: true,
                            request: rq,
                            response: { data: res.data, xGuid: res.xGuid },
                            apiCall: true,
                            timestamp: new Date()
                        },
                        source: 'screenProctorhvsLog'
                    });
                    return $q.resolve({
                        data: { isStopped: true },
                        msg: "Confrence is stopped successfully."
                    });
                }, function(res) {
                    debuggerService.log({
                        msg: {
                            activity: 'stopPublishing',
                            success: false,
                            request: rq,
                            response: { data: res.data, xGuid: res.xGuid },
                            apiCall: true,
                            timestamp: new Date()
                        },
                        source: 'screenProctorhvsLog'
                    });
                    return $q.reject({
                        data: { isStopped: false },
                        msg: "Unable to stop Confrence!"
                    });
                });
        }

        function onPublishingFail(req, res) {
            hvsService.destroyHandler(handlerInstance);
            hvsService.destroyJanus();
            debuggerService.log({
                msg: {
                    activity: 'startPublishing',
                    success: false,
                    request: req,
                    response: { data: res.data, xGuid: res.xGuid },
                    apiCall: true,
                    timestamp: new Date()
                },
                source: 'screenProctorhvsLog'
            });
        }

        function getPromise(prmObj) {
            return prmObj &&
                prmObj.promise &&
                prmObj.promise.$$state &&
                prmObj.promise.$$state.status !== 2 ? prmObj : $q.defer();
        }

        /*...................Proctoring Config..................*/

        function getProctoringConfig(isOnlyGlobal, hvs) {
            var utilityObj = service.utility;

            return utilityObj.getTenantSpecificProctoringConfig(isOnlyGlobal, hvs)
                .then(function(tConf) {
                    if (!tConf) {
                        tConf = {};
                    }
                    return utilityObj.getGlobalProctoringConfig(hvs).then(
                        function(config) {
                            config = config ? config : {};
                            return _.merge(config, tConf);
                        },
                        function(res) {
                            return tconf;
                        }
                    );
                    // return conf;
                });

        }

        function getTenantSpecificProctoringConfig(isOnlyGlobal, hvs) {
            var getAllAppPreference_Request = {
                Type: "assessment.proctoring.config",
                IsTenantGlobal: true
            };
            if (hvs) {
                getAllAppPreference_Request.Type = "assessment.hvs.conf";
            }
            if (isOnlyGlobal) {
                return $q.when(null);
            } else {
                return commonService.GetAllAppPreference(getAllAppPreference_Request);
            }
        }

        function getGlobalProctoringConfig(hvs) {
            var getAllAppPreference_Request = {
                Type: "assessment.proctoring.config",
                IsGlobal: true
            };
            if (hvs) {
                getAllAppPreference_Request.Type = "assessment.hvs.conf";
            }
            return commonService.GetAllAppPreference(getAllAppPreference_Request);
        }
    }
})();

(function() {
    'use strict';
    angular
        .module("OnlineAssessmentAngular")
        .factory("proctoringSocialvidService", proctoringService);
    proctoringService.$inject = [
        'commonService',
        'webService',
        'loginService',
        'assessmentUtility',
        '$log',
        'blockUI',
        '$state',
        '$window',
        '$q',
        '$rootScope',
        'connection',
        'imageTracker',
        '$timeout',
        'growl',
        'loggerService'
    ];

    function proctoringService(commonService, webService, loginService, assessmentUtility, $log, blockUI, $state, $window, $q, $rootScope, connection, imageTracker, $timeout, growl, loggerService) {
        var service = {
            localVar: {
                candidate: -1,
                candidateEmail: null,
                deferred: null,
                isScreenProctoringEnabled: false,
                isScreenProctoringIsMandatEnabled: false,
                isSnapShotProctoringEnabled: false,
                isSnapShotProctoringIsMandatEnabled: false,
                isVideoProctoringEnabled: false,
                isVideoProctoringIsMandatEnabled: false,
                isOnlinePreview: false,
                //networkPingerJsForProctoring: "/static/js/networkpinger.js",
                networkPingerJsForProctoring: (window.location.hostname == 'localhost' ? "https://amsin.hirepro.in" : window.location.origin) + "/s3_cached/hirepro-content/hirepro/proctoring-resources/js/networkpinger.js",
                netWorkPollingWebWorker: null,
                proctoringClient: null,
                testId: -1,
                tenantId: -1,
                proctoringServer: "",
                // proctoringJsLibraryServer: "",
                mediaStream: null,
                proctoringPollingTimer: [10000, 10000, 10000, 10000, 10000],
                opts: null,
                loadWebWorkerJsFilePollingCounter: 0,
                isNetworkGotFailed: false,
                videoAnswerAutoStartAfter: 60, //In seconds
                allowedTimeForNoNetwork: -1, //In seconds
                logoutTimeout: null,
                proctorStats: [],
                proctorStatType: 'Video Proctoring',
                proctorStatIsStartedAutomatically: true,
                connectionLostTimeStamp: null,
                snapshotAttempt: 0,
                recordingConfId: null,
                networkFluctuationLimit: 0,
                setBandwidth: false,
                networkFluctuationCounter: 0,
                isWorkerStarted: false,
                isVideoProctoringStarted: false
            },
            /*  return type: promise
                return value: object {'strm':sl.mediaStream,'msg':null}
            */
            mediaStream: this.mediaStream,
            isVideoProctoringStarted: this.isVideoProctoringStarted,
            start: function(opts) {
                blockUI.start();
                var self = this,
                    loginInfo = loginService.getLoginInfo(),
                    sl = service.localVar,
                    asmUtil = assessmentUtility;
                sl.isOnlinePreview = asmUtil.localStorage.getData("_isOnlinePreview");
                sl.isOnlinePreview = sl.isOnlinePreview ? true : false;
                sl.netWorkPollingWebWorker = null;
                sl.opts = opts;
                $rootScope.vidStrm = null;
                $rootScope.vidStrmId = null;
                sl.isLoadBalancingEnabled = true;
                if (sl.opts) {
                    sl.proctorStatType = sl.opts.procType;
                    sl.proctorStatIsStartedAutomatically = !!sl.opts.isAutoStart;
                }
                if (sl.opts && sl.opts.isAuthenticated === false) {
                    sl.testId = sl.opts.testId;
                    sl.candidate = 0;
                    sl.tenantId = sl.opts.tenantId;
                    sl.candidateEmail = sl.opts.candidateEmail;
                    sl.isVideoProctoringEnabled = true;
                    sl.isVideoProctoringIsMandatEnabled = true;
                    sl.isLoadBalancingEnabled = false;
                } else if (loginInfo && loginInfo.Config) {
                    var cnf = loginInfo.Config;
                    sl.testId = loginInfo.TestId;
                    sl.candidate = loginInfo.CandidateId;
                    sl.tenantId = loginService.getTenantId();
                    sl.isScreenProctoringEnabled = cnf.ScreenProctoring;
                    sl.isScreenProctoringIsMandatEnabled = cnf.ScreenProctoringIsMandat;
                    sl.isSnapShotProctoringEnabled = cnf.SnapShotdProctoring;
                    sl.isSnapShotProctoringIsMandatEnabled = cnf.ScreenProctoring;
                    sl.isVideoProctoringEnabled = cnf.VideoProctoring;
                    sl.isVideoProctoringIsMandatEnabled = cnf.VideoProctoringIsMandat;
                    sl.ContainsMediaQuestion = loginInfo.ContainsMediaQuestion;
                    sl.allowedTimeForNoNetwork = cnf.logoutIfNoInternetIn;
                }
                return connection.isOnline()
                    .then(function(_isOnline) {
                        if (!_isOnline) {
                            blockUI.stop();
                            return {
                                'strm': null,
                                'isOnline': false
                            };
                        }
                        return self.utility.getProctoringConfig()
                            .then(function(procInfo) {
                                if (procInfo) {
                                    if (procInfo.networkFluctuationLimit && procInfo.networkFluctuationLimit > 0) {
                                        sl.networkFluctuationLimit = procInfo.networkFluctuationLimit;
                                    }
                                    sl.setBandwidth = !!procInfo.enableSetBandwidth;
                                    //sl.proctoringServer = procInfo.proctoringServer;
                                    // sl.proctoringJsLibraryServer = procInfo.proctoringJsLibraryServer;
                                } else {
                                    $log.log('assessment proctor config not found');
                                    sl.proctoringServer = 'exam.hirepro.in';
                                    // sl.proctoringJsLibraryServer = 'exam.hirepro.in';
                                }
                                return initProctoring(sl.isOnlinePreview);
                            });

                    });
            },
            stop: function() {
                var sl = service.localVar,
                    proctorStat = {},
                    data = { "stat": false, "msg": null };
                return $q(function(resolve, reject) {
                    $rootScope.isNetworkGotFailed = false;
                    sl.deferred = null;
                    sl.mediaStream = null;
                    sl.isWorkerStarted = false;
                    if (sl.opts && sl.opts.vidElem) {
                        sl.opts.vidElem.srcObject = null;
                    }
                    if (sl.opts && sl.opts.videoStrmWatch) {
                        sl.opts.videoStrmWatch(); //clear error handling watch.... 
                    }
                    sl.opts = null;
                    if (sl.proctoringClient && sl.proctoringClient.started) {
                        sl.proctoringClient.stopCall();
                        sl.isVideoProctoringStarted = false;
                        if (service.localVar.netWorkPollingWebWorker) {
                            service.localVar.netWorkPollingWebWorker.terminate();
                            service.localVar.netWorkPollingWebWorker = null;
                        }
                        assessmentUtility.localStorage.setData('isQuestionVideoStarted', false);
                        $rootScope.isNetworkGotFailed = true;
                        $rootScope.vidStrm = null;
                        $rootScope.vidStrmId = null;
                        /*.............For Log..............*/
                        proctorStat["type"] = sl.proctorStatType;
                        proctorStat["isStartedAutomatically"] = sl.proctorStatIsStartedAutomatically;
                        proctorStat["stat"] = "stopped";
                        proctorStat["timeStamp"] = new Date();
                        sl.proctorStats.push(proctorStat);
                        /*.................................*/
                        loggerService.push({
                            "canLoginActivityLog": {
                                "proctorStats": angular.copy(sl.proctorStats)
                            }
                        });
                        sl.proctorStats.length = 0;
                        /*......Promise Response......*/
                        data.stat = true;
                        data.msg = "Proctoring service stopped successfully."
                    } else {
                        /*......Promise Response......*/
                        data.stat = false;
                        data.msg = "Proctoring service is not started yet."
                    }
                    resolve(data);
                });
            },
            setConfig: function(conf) {
                var sl = service.localVar;
                sl.opts = sl.opts || {};
                if (conf) {
                    _.merge(sl.opts, conf);
                }
            }
        };
        return service;

        function loadWebWorkerJsFile() {
            var sl = service.localVar,
                loadNetworkpingerUrl = sl.networkPingerJsForProctoring + "?v=" + (new Date()).getTime();
            // loadNetworkpingerUrl = "https://" + sl.proctoringJsLibraryServer +
            // sl.networkPingerJsForProctoring + "?v=" + (new Date()).getTime();
            sl.loadWebWorkerJsFilePollingCounter++;
            return webService.execute(loadNetworkpingerUrl, null, "GET", "text")
                .then(function(res) {
                        return $q.resolve(res)
                    },
                    function(res) {
                        $log.log(res);
                        if (sl.loadWebWorkerJsFilePollingCounter < 5) {
                            return loadWebWorkerJsFile();
                        } else {
                            return $q.reject({ 'msg': 'Network Failure:Not able to load Web worker js file!' })
                        }
                    });
        }

        function initWebWorker() {
            var sl = service.localVar;
            if (angular.isUndefined(Worker)) {
                return $q.reject({ 'msg': 'incompatible browser[webWorker is not defined]' });
            }
            if (sl.netWorkPollingWebWorker) {
                return $q.when({ 'msg': 'webWorker is already loadeded.' });
            }
            return loadWebWorkerJsFile()
                .then(function(res) {
                    var blob_networkpinger = new Blob([res.data]),
                        sl = service.localVar;
                    sl.netWorkPollingWebWorker = new Worker(window.URL.createObjectURL(blob_networkpinger));
                    // add Event listener............
                    sl.netWorkPollingWebWorker
                        .addEventListener("message", function(res) {
                            res = angular.fromJson(res.data);
                            if (res && res.status !== "OK" && res.msg !== "SERVER IS REACHABLE NOW") {
                                $log.log(res.msg);
                                return false;
                            }
                            sl.isWorkerStarted = false;
                            $log.warn("Junk Log: Video Recording Startted after network failure. ", new Date());
                            if (res.context === "initFailed") {
                                initProctoring(sl.isOnlinePreview);
                            } else if (res.context === "callDisconnected") {
                                startProctoring();
                            }
                        });

                    return $q.resolve({ 'msg': 'webWorker is loaded successfully.' });
                });
        }

        function startWebWorker(_state, _context) {
            var sl = service.localVar,
                messageToWebWorker = null;
            messageToWebWorker = angular.toJson({
                "cmd": "startPolling",
                "params": {
                    "postBody": {
                        "state": _state,
                        "testUser": sl.tenantId + '-' + sl.candidate + "-" + sl.testId,
                        "timeStamp": new Date(),
                        "assessmentHost": window.location.hostname == 'localhost' ? 'amsin.hirepro.in' : window.location.hostname
                    },
                    "context": _context,
                    "pollingInterval": 60000,
                    "serverUrl": sl.proctoringServer
                }
            });
            if (sl.netWorkPollingWebWorker) {
                sl.netWorkPollingWebWorker.postMessage(messageToWebWorker);
                sl.isWorkerStarted = true;
            } else {
                blockUI.stop();
                sl.deferred.reject({
                    'strm': null,
                    'msg': 'Not able to initialize proctoring service.',
                    'isOnline': $rootScope.isNetworkGotFailed
                });
            }
        }

        function initProctoring(isOnlinePreview) {
            var sl = service.localVar,
                hostname = window.location.hostname,
                procConf = {
                    "isOnlinePreview": isOnlinePreview,
                    "assessmentHost": (hostname == 'localhost' ||
                        hostname == 'amsin.hirepro.in' ||
                        hostname == 'pearson.hirepro.in' ||
                        hostname == 'pearson1.hirepro.in' ||
                        hostname == 'pearsonstg.hirepro.in' ||
                        hostname == 'talentlensstg.hirepro.in' ||
                        hostname == 'talentlensstg1.hirepro.in' ||
                        location.hostname == 'qaassesscocubes.hirepro.in' ||
                        location.hostname == 'betaqaassesscocubes.hirepro.in') ? 'amsin.hirepro.in' : 'ams.hirepro.in',
                    "recordingServerHost": service.localVar.proctoringServer,
                    "maxBitRateKbps": 1024,
                    // "X-AUTH-TOKEN": assessmentUtility.cookies.get('X-AUTH-TOKEN')
                    "X-AUTH-TOKEN": sessionStorage.getItem('X-AUTH-TOKEN'),
                    //"hasOptionalGroup": sl.opts.hasOptionalGroup,
                    "isLoadBalancingEnabled": sl.isLoadBalancingEnabled
                },
                assessmentInfo = {
                    "tenantId": sl.tenantId,
                    "candidateId": sl.candidate,
                    "testId": sl.testId
                };
            sl.deferred = sl.deferred &&
                sl.deferred.promise &&
                sl.deferred.promise.$$state &&
                sl.deferred.promise.$$state.status !== 2 ? sl.deferred : $q.defer();
            sl.proctoringClient = new ProctoringClient();
            sl.loadWebWorkerJsFilePollingCounter = 0;
            if (sl.opts && sl.opts.durationInMins) {
                procConf.durationInMins = sl.opts.durationInMins;
            }
            if (sl.opts && sl.opts.hasOptionalGroup) {
                procConf.hasOptionalGroup = sl.opts.hasOptionalGroup;
            }
            if (sl.opts && sl.opts.vqId != null) {
                procConf.recordScreen = { "isEnabled": false, "isMust": false };
                procConf.recordVideo = { "isEnabled": true, "isMust": true };
                procConf.takeSnapShots = { "isEnabled": false, "isMust": false };
                assessmentInfo.questionId = sl.opts.vqId;
            } else {
                procConf.recordScreen = { "isEnabled": sl.isScreenProctoringEnabled, "isMust": sl.isScreenProctoringIsMandatEnabled };
                procConf.recordVideo = { "isEnabled": sl.isVideoProctoringEnabled, "isMust": sl.isVideoProctoringIsMandatEnabled };
                procConf.takeSnapShots = { "isEnabled": sl.isSnapShotProctoringEnabled, "isMust": sl.isSnapShotProctoringIsMandatEnabled };
            }
            if (sl.opts && sl.opts.isAuthenticated === false) {
                procConf["X-TEST-AUTHENTICATION"] = false;
                procConf["X-TENANT-ID"] = sl.tenantId;
                procConf["X-USER-ID"] = 0;
                assessmentInfo.emailAddr = sl.candidateEmail;
            }
            initWebWorker()
                .then(function(res) {
                    $log.log(res.msg);
                })
                .catch(function(res) {
                    $log.log(res.msg);
                })
                .finally(function() {
                    sl.proctoringClient.init(procConf, assessmentInfo,
                        function(initVideoProctoringResponse) {
                            $log.log('got response');
                            $log.log(initVideoProctoringResponse);
                            initProctoringCallBack(initVideoProctoringResponse);
                        },
                        sl.proctoringClient
                    );
                });
            return sl.deferred.promise;
        }

        function initProctoringCallBack(initResponse) {
            var sl = service.localVar,
                errorMsg = null;
            if (!initResponse) {
                $log.log("Error occurred while fetching video proctoring service.");
                return false;
            }
            if (initResponse.code === 200) {
                if (initResponse.detail) {
                    sl.recordingConfId = initResponse.detail.confId;
                    sl.proctoringServer = initResponse.detail.recordingServerHost;
                }
                startProctoring();
            } else if (initResponse.code === 308) {
                !sl.isWorkerStarted && startWebWorker("getRecordingIdFailed", "initFailed");
            } else if (initResponse.code === 503) {
                errorMsg = "All assessment slots are full.Please try after 30 minutes.";
            } else if (initResponse.code === 440) {
                errorMsg = "Session Expired !";
            } else {
                errorMsg = "Poor Internet Connection!<br>Switch to a better network and retry.";
            }
            if (errorMsg) {
                $log.log(initResponse);
                blockUI.stop();
                sl.deferred.reject({
                    'strm': null,
                    'errorCode': initResponse.code,
                    'msg': errorMsg
                });
            }
        }

        function getSnapshotWhenOffline() {
            var constraints = { audio: true, video: true },
                options = {
                    videoElementId: 'secondVid',
                    isTimeIntervalRequired: false
                };

            return $q(function(resolve, reject) {
                navigator.mediaDevices.getUserMedia(constraints)
                    .then(function(mediaStream) {
                        $log.log('offline stream', mediaStream);
                        imageTracker.slowNetworkImageCreation(mediaStream, options)
                            .then(function(res) {
                                if (res === true) {
                                    mediaStream.getTracks()[0].stop();
                                    mediaStream.getTracks()[1].stop();
                                    resolve(true);
                                }
                            }, function() {
                                mediaStream.getTracks()[0].stop();
                                mediaStream.getTracks()[1].stop();
                                reject(true);
                            });
                    })
                    .catch(function(err) {
                        $log.log('navigation error');
                        $log.log(err.name + ": " + err.message);
                    });
            });
        }

        function startProctoring() {
            service.localVar.proctoringClient.startCall(function(startProctoringResponse) {
                startProctoringCallBack(startProctoringResponse);
            });
        }

        function startProctoringCallBack(startProctoringResponse) {
            blockUI.stop();
            var sl = service.localVar;
            if (!startProctoringResponse) {
                $log.log("Error occurred while fetching video proctoring service.");
                sl.deferred.reject({ 'strm': null, 'msg': 'Error occurred while fetching video proctoring service.' });
            }
            if (startProctoringResponse.code != 200) {
                if (startProctoringResponse.code === 183) {
                    if (sl.logoutTimeout) {
                        $timeout.cancel(sl.logoutTimeout);
                        sl.logoutTimeout = null;
                    }
                    sl.mediaStream = startProctoringResponse.detail;
                    $rootScope.vidStrm = sl.mediaStream;
                    $rootScope.vidStrmId = $rootScope.vidStrm.id;
                    if (sl.opts && sl.opts.vidElem) {
                        sl.opts.vidElem.srcObject = sl.mediaStream;
                    }
                }
                var errorMessage = startProctoringResponse.message + "\n";
                if (startProctoringResponse.details) {
                    errorMessage += startProctoringResponse.details;
                }
                $log.log(errorMessage);
                if (startProctoringResponse.code === 307) {
                    //logout if network is not there upto mentioned time period
                    if (sl.opts && sl.opts.procType === "videoProctoring") {
                        logOutIfNetworkIsNotAvail();
                    }
                    //.........................................................
                    $log.log("Junk Log: Network failure[Status code:307] ", new Date());
                    $rootScope.isNetworkGotFailed = true;
                    $rootScope.vidStrm = null;
                    $rootScope.vidStrmId = null;
                    /*.............For Log..............*/
                    var proctorStat = {};
                    proctorStat["type"] = sl.proctorStatType;
                    proctorStat["isStartedAutomatically"] = sl.proctorStatIsStartedAutomatically;
                    proctorStat["stat"] = "Network Failure";
                    proctorStat["responseCode"] = 307;
                    proctorStat["timeStamp"] = new Date();
                    sl.proctorStats.push(proctorStat);
                    /*.................................*/
                    if (service.localVar.connectionLostTimeStamp === null) {
                        getSnapshotWhenOffline()
                            .then(function(res) {
                                    service.localVar.connectionLostTimeStamp = new Date();
                                    if (res === true) {
                                        startProctoring();
                                    }
                                },
                                function() {
                                    startProctoring()
                                });
                    } else if (service.localVar.connectionLostTimeStamp !== null) {
                        var timeDiff = (new Date().getTime() - service.localVar.connectionLostTimeStamp.getTime()) / 1000;
                        if (timeDiff > 59) {
                            getSnapshotWhenOffline()
                                .then(function(res) {
                                        service.localVar.connectionLostTimeStamp = new Date();
                                        if (res === true) {
                                            startProctoring();
                                        }
                                    },
                                    function() {
                                        startProctoring()
                                    });
                        } else {
                            startProctoring();
                        }
                    }
                    //startProctoring();
                } else if (startProctoringResponse.code === 308) {
                    //logout if network is not there upto mentioned time period
                    if (sl.opts && sl.opts.procType === "videoProctoring" && !$rootScope.isNetworkGotFailed) {
                        logOutIfNetworkIsNotAvail();
                        if (sl.networkFluctuationLimit) {
                            sl.networkFluctuationCounter++;
                            if (sl.networkFluctuationCounter >= sl.networkFluctuationLimit) {
                                logOutToMsgPage();
                                return false;
                            }
                        }
                    }
                    //.........................................................
                    $log.log("Junk Log: Video Recording Stopped");
                    $log.log("Junk Log: Starting Web Worker[Status code:308] ", new Date());
                    $rootScope.isNetworkGotFailed = true;
                    $rootScope.vidStrm = null;
                    $rootScope.vidStrmId = null;
                    /*.............For Log..............*/
                    var proctorStat = {};
                    proctorStat["type"] = sl.proctorStatType;
                    proctorStat["isStartedAutomatically"] = sl.proctorStatIsStartedAutomatically;
                    proctorStat["stat"] = "Network Failure";
                    proctorStat["responseCode"] = 308;
                    proctorStat["timeStamp"] = new Date();
                    sl.proctorStats.push(proctorStat);
                    /*.................................*/
                    !sl.isWorkerStarted && startWebWorker("callDisconnected", "callDisconnected");
                } else if (startProctoringResponse.code === 403) {
                    if (sl.isVideoProctoringIsMandatEnabled) {
                        alert("Camera and Microphone access is mandatory for this test.\nPlease go to the browser 'Settings->Advanced Settings->Content Settings' and remove the blocked settings of the Camera and Microphone.");
                        location.reload();
                    }
                }
                return;
            } else {
                if (sl.setBandwidth) {
                    updateSendBitrate(32, 'video');
                    updateSendBitrate(8, 'audio');
                }
                return startProctor(startProctoringResponse);
            }
        }

        function updateSendBitrate(newBitRateInKbps, mediaType) {
            var senders = window.proctoringClient.sVidClient.aa.aa.getSenders();
            for (var sIdx = 0; sIdx < senders.length; sIdx++) {
                if (senders[sIdx] && senders[sIdx].track && mediaType === senders[sIdx].track.kind) {
                    var s = senders[sIdx].getParameters();
                    s.encodings = s.encodings ? s.encodings : [];
                    s.encodings[0].maxBitrate = newBitRateInKbps * 1000;
                    senders[sIdx].setParameters(s)
                        .then(function() {
                            console.error("Set bitrate to " + newBitRateInKbps);
                            loggerService.push({
                                canLoginActivityLog: {
                                    proctorStats: {
                                        timeStamp: new Date(),
                                        type: mediaType,
                                        bandwidthInKbps: newBitRateInKbps
                                    }
                                }
                            });
                        })
                        .catch(function(e) {
                            console.error("Set bitrate failed " + e);
                        });
                }
            }
        }


        function startProctor(startProctoringResponse) {
            var sl = service.localVar;
            if (sl.proctoringClient && startProctoringResponse.type == "startCall") {
                $rootScope.isNetworkGotFailed = false;
                if (sl.isVideoProctoringIsMandatEnabled && (!sl.mediaStream || sl.mediaStream.getVideoTracks().length <= 0)) {
                    $log.log("Error:Video tracks or Video Camera not found");
                    //Stop proctoring................
                    sl.deferred.reject({ 'strm': null, 'msg': 'Video tracks or Video Camera not found.' });
                    service.stop();
                } else {
                    /*.............For Log..............*/
                    var proctorStat = {};
                    proctorStat["type"] = sl.proctorStatType;
                    proctorStat["isStartedAutomatically"] = sl.proctorStatIsStartedAutomatically;
                    proctorStat["stat"] = "started";
                    proctorStat["responseCode"] = 200;
                    proctorStat["timeStamp"] = new Date();
                    sl.proctorStats.push(proctorStat);
                    /*.................................*/
                    sl.isVideoProctoringStarted = true;
                    loggerService.push({
                        "canLoginActivityLog": {
                            "proctorStats": angular.copy(sl.proctorStats)
                        }
                    });
                    sl.proctorStats.length = 0;
                    sl.deferred.resolve({
                        'strm': sl.mediaStream,
                        'msg': null,
                        'recordingConfId': sl.recordingConfId,
                        "recordingServerHost": sl.proctoringServer
                    });
                    $log.log("Proctoring Started ", new Date());
                }
            }
        }

        function logOutIfNetworkIsNotAvail() {
            var sl = service.localVar;
            if (sl.allowedTimeForNoNetwork > 0 && !sl.logoutTimeout) {
                sl.logoutTimeout = $timeout(function() {
                    logOutToMsgPage();
                }, sl.allowedTimeForNoNetwork * 1000);
            }
        }

        function logOutToMsgPage() {
            var loginInfo = loginService.getLoginInfo(),
                candidateName = loginInfo.CandidateName;
            var message = '<div class="row text-left no-internet-row">' +
                '<div class="col-md-10 col-md-offset-2">' +
                '<span class="no-wifi">' +
                '<i class="fa fa-4x fa-wifi" aria-hidden="true"></i>' +
                '<i class="fa fa-2x fa-exclamation" aria-hidden="true"></i>' +
                '</span>' +
                '</br>' +
                '<span>' +
                '<h3 class="color-gray">' +
                'Sorry! ' + candidateName + ', you have been logged out due to poor internet connection.' +
                '</h3>' +
                '<p class="msg-sub-msg">' +
                'Please switch to a stable internet connection and start the test again. The test will resume from its last saved state.' +
                '</p>' +
                '</span>' +
                '</div>' +
                '</div>';
            $state.go('msgPage', { stateParams: btoa(message) }, { location: 'replace' });
        }
    }
})();

(function() {
    "use strict";
    angular
        .module("OnlineAssessmentAngular")
        .factory("proctoringService", proctoringServiceFactory);

    function proctoringServiceFactory($q, commonService, loginService, proctoringJanusService, proctoringSocialvidService) {
        var procService = null,
            loginInfo = loginService.getLoginInfo(),
            procConf = {
                "getProctoringConfig": getProctoringConfig,
                "getTenantSpecificProctoringConfig": getTenantSpecificProctoringConfig,
                "getGlobalProctoringConfig": getGlobalProctoringConfig
            },
            service = proctoringJanusService;
        return service;

        /*.............................Public Methods....................*/

        function get() {
            // !procService && getProctoringService();
            // return procService;
            if (procService) {
                return procService;
            } else {
                var procServerType = null;
                if (loginInfo && loginInfo.assessmentConfig &&
                    loginInfo.assessmentConfig.proctoringServerType) {
                    procServerType = loginInfo.assessmentConfig.proctoringServerType;
                    procService = procServerType.isJanus ? proctoringJanusService : proctoringSocialvidService;
                    procService["utility"] = procConf;
                    procService["localVar"] = {};
                    return procService;
                } else {
                    console.error('assessment proctoring server type not found');
                    return null;
                }
            }
        }


        /*.............................Private Methods....................*/

        function getProctoringService() {
            var procServerType = null;
            if (loginInfo && loginInfo.assessmentConfig &&
                loginInfo.assessmentConfig.proctoringServerType) {

                procServerType = loginInfo.assessmentConfig.proctoringServerType;
                procService = procServerType.isJanus ? proctoringJanusService : proctoringSocialvidService;
                procService["utility"] = procConf;
                procService["localVar"] = {};
            } else {
                console.error('assessment proctoring server type not found');
            }
        }

        /*...................Proctoring Config..................*/

        function getProctoringConfig(isOnlyGlobal) {
            var utilityObj = this;
            return utilityObj.getTenantSpecificProctoringConfig(isOnlyGlobal)
                .then(function(tConf) {
                    if (!tConf) {
                        tConf = {};
                        // return utilityObj.getGlobalProctoringConfig();
                    }
                    return utilityObj.getGlobalProctoringConfig(hvs).then(
                        function(config) {
                            config = config ? config : {};
                            return _.merge(config, tConf);
                        },
                        function(res) {
                            return tconf;
                        }
                    );
                    // return conf;
                });
        }

        function getTenantSpecificProctoringConfig(isOnlyGlobal) {
            var getAllAppPreference_Request = {
                Type: "assessment.proctoring.config",
                IsTenantGlobal: true
            };
            if (isOnlyGlobal) {
                return $q.when(null);
            } else {
                return commonService.GetAllAppPreference(getAllAppPreference_Request);
            }
        }

        function getGlobalProctoringConfig() {
            var getAllAppPreference_Request = {
                Type: "assessment.proctoring.config",
                IsGlobal: true
            };
            return commonService.GetAllAppPreference(getAllAppPreference_Request);
        }
    }
})();

(function() {
    'use strict';
    angular
        .module("OnlineAssessmentAngular")
        .factory("proctoringJanusService", proctoringJanusService);

    function proctoringJanusService($q, $timeout, $rootScope, hvsService, webService, loggerService, commonService, assessmentUtility, loginService, webRtcStatsService, socketService, debuggerService, mediaRecorder) {
        var userId = null,
            handlerInstance = null,
            sessionId = null,
            displayName = "",
            opaqueId = "in.hirepro.onlineassessment.videoProctoring-" + Janus.randomString(12),
            loginInfo = loginService.getLoginInfo(),
            tenantId = sessionStorage.getItem('_tId'),
            startProcPromise = null,
            ProcStartStat = [],
            ProcStopStat = [],
            isStartingProctoring = false,
            isStoppingProctoring = false,
            restartHvsTimeout = null,
            mediaConstrint = {
                video: true,
                audio: true
            },
            isVideroomDestroyed = false,
            isIceRestarted = false,
            isIceDisconnected = false,
            isHVSRestarted = false,
            publishers = [],
            allowTestTerminationOnDemand = !!_.get(loginInfo, 'Config.allowTestTerminationOnDemand'),
            enableChatting = !!_.get(loginInfo, 'Config.enableChatting'),
            enableLiveStream = !!_.get(loginInfo, 'Config.liveStream'),
            isThirdPartyProctoringTestType = _.get(loginInfo, 'Config.isThirdPartyProctoringTestType'),
            service = {
                "goldenImagePath": null,
                "proctoringImagePath": null,
                "mediaStream": null,
                "isVideoProctoringStarted": false,
                "start": startProctoring,
                "stop": stopProctoring,
                "localVar": {},
                "setConfig": setConfig,
                "utility": {
                    "getProctoringConfig": getProctoringConfig,
                    "getTenantSpecificProctoringConfig": getTenantSpecificProctoringConfig,
                    "getGlobalProctoringConfig": getGlobalProctoringConfig
                }
            };
        return service;

        /*...........................Public Methods......................*/

        function startProctoring(opts) {
            var sl = service.localVar,
                isSecondaryCameraEnable = sessionStorage.getItem("isSecondaryCameraEnable") === "true" ? true : false,
                recordVideoInFileIfNoNetwork = sessionStorage.getItem('recordVideoInFileIfNoNetwork') === 'true' ? true : false;
            sl.opts = opts || {};
            startProcPromise = getPromise(startProcPromise);
            $rootScope.vidStrm = null;
            $rootScope.vidStrmId = null;
            ProcStartStat.length = 0;
            ProcStopStat.length = 0;
            isStartingProctoring = true;
            publishers.length = 0;
            sl.opts.procType = opts && opts.procType ? opts.procType : 'videoProctoring';
            hvsService.startConference(getHandler(sl.opts.procType), false, null, sl.opts.procType)
                .then(function(res) {
                    /* Initiating socket on enabled Chatting,enabled LiveStream allowTestTerminationOnDemand 
                    and thirdPartyTestTypeInLowerCase === 'thirdpartyproctoring'*/
                    if (enableChatting ||
                        enableLiveStream ||
                        allowTestTerminationOnDemand ||
                        isThirdPartyProctoringTestType ||
                        isSecondaryCameraEnable) {

                        var data = {
                            app: ["generic_msg_delivery"],
                            eventCallback: {
                                reload_conf: reloadConference
                            }
                        };
                        if (isSecondaryCameraEnable) {
                            data.app.push("secondary_camera_msg_delivery");
                        }
                        socketService.init(data);
                    }
                    sessionId = res.data.sessionId;
                    debuggerService.log({
                        msg: {
                            activity: 'startProctoring',
                            success: true,
                            sessionId: sessionId,
                            timestamp: new Date()
                        },
                        source: 'proctorhvsLog'
                    });
                    if (recordVideoInFileIfNoNetwork) {
                        localRecordingInit();
                    }
                }, function(res) {
                    debuggerService.log({
                        msg: {
                            activity: 'startProctoring',
                            success: false,
                            response: res,
                            timestamp: new Date()
                        },
                        source: 'proctorhvsLog'
                    });
                    startProcPromise.reject({
                        'strm': null,
                        'msg': 'Not able to start proctoring service.',
                        'isOnline': undefined
                    });
                })
                .finally(function() {
                    isStartingProctoring = false;
                });
            return startProcPromise.promise;
        }

        function stopProctoring() {
            var sl = service.localVar;
            isStoppingProctoring = true;
            $rootScope.isNetworkGotFailed = false;
            if (sl.opts && sl.opts.vidElem) {
                sl.opts.vidElem.srcObject = null;
            }
            if (sl.opts && sl.opts.videoStrmWatch) {
                sl.opts.videoStrmWatch(); //clear error handling watch.... 
            }
            if (!handlerInstance) {
                debuggerService.log({
                    msg: {
                        activity: 'stopProctoring',
                        success: false,
                        response: 'no handlerInstance',
                        timestamp: new Date()
                    },
                    source: 'proctorhvsLog'
                });
                return $q.when({ data: { isStopped: false }, msg: "Not able to stop confrence!" });
            }
            return hvsService.stopConference(handlerInstance)
                .then(function() {
                    var isSessionExpired = JSON.parse(sessionStorage.getItem('isSessionExpired'));
                    if (isSessionExpired) {
                        return true;
                    }
                    return unPublishedFeed(hvsService.getStreamId());
                });
        }

        function reloadConference(msg) {
            debuggerService.log({
                msg: {
                    activity: 'Restarting ICE as per proctor request.',
                    response: msg,
                    timestamp: new Date()
                },
                source: 'proctorhvsLog'
            });
            restartIce();
        }

        function setConfig(conf) {
            var sl = service.localVar;
            sl.opts = sl.opts || {};
            if (conf) {
                _.merge(sl.opts, conf);
            }
        }

        /*.............................Private Methods...................*/

        function localRecordingInit() {
            $rootScope.$watch('isNetworkGotFailed', function(newValue, oldValue) {
                if(angular.equals(newValue, oldValue)){
                    return;
                }
                if (newValue === true) {
                    mediaRecorder.start({
                        disableLoading: true,
                        testId: loginInfo.TestId,
                        candidateId: loginInfo.CandidateId,
                        isAutoStart: true,
                        isPartialSavingEnable: true,
                        MediaDeviceConstraints: {
                            audio: true,
                            video: {
                                width: { max: 320 },
                                height: { max: 240 },
                                frameRate: {
                                    ideal: 1,
                                    min: 1,
                                    max: 1
                                }
                            }
                        },
                        MediaRecorderConstraints: {
                            audioBitsPerSecond: 8000,
                            mimeType: 'video/webm; codecs=vp9'
                        }
                    });
                } else {
                    mediaRecorder.stop().then(
                        function(res) {
                            if (res && res.videoUplodedDeferred) {
                                return res.videoUplodedDeferred;
                            }
                        }
                    ).then(null, null,
                        function(res) {
                            if (res && res.s3Url) {
                                var localVideoLog = {
                                    canLoginActivityLog: {
                                        localVideo: {
                                           url: res.s3Url,
                                           timestamp: res.startTime
                                        }
                                    }
                                };
                                loggerService.push(localVideoLog);
                            }
                        }
                    );
                }
            });
        }

        function restartIce() {
            console.log("sap1_video_restartIce");
            $rootScope.isNetworkGotFailed = true;
            socketService.close(1000, "restart ICE")
                .then(function() {
                    if (enableChatting ||
                        enableLiveStream ||
                        allowTestTerminationOnDemand ||
                        isThirdPartyProctoringTestType) {

                        var data = {
                            app: ["generic_msg_delivery", "secondary_camera_msg_delivery"],
                            eventCallback: {
                                reload_conf: reloadConference
                            }
                        };
                        socketService.init();
                    }
                });
            console.log("videoProctor_hvs_log.iceServer.refresh");
            handlerInstance.createOffer({
                iceRestart: true,
                media: { audioRecv: false, videoRecv: false, audioSend: true, videoSend: true },
                success: function(jsep) {
                    console.log("sap1_video_restartIce_success", jsep);
                    var publish = { request: "configure", refresh: true };
                    handlerInstance.send({ message: publish, jsep: jsep });
                    debuggerService.log({
                        msg: {
                            activity: 'JSEP',
                            timestamp: new Date(),
                            participantType: 'Publisher',
                            participantName: displayName,
                            eventDetails: {
                                typeOfEvent: 'JSEP',
                                timestamp: new Date(),
                                sessionId: sessionId,
                                pluginName: 'videoroom',
                                pluginId: handlerInstance.getId(),
                                data: {
                                    callback: 'success',
                                    // SDP: jsep,
                                    comment: 'ice restart'
                                }
                            }
                        },
                        source: 'proctorhvsLog'
                    });
                },
                error: function(error) {
                    console.log("sap1_video_restartIce_error", error);
                    hvsService.restartHVS('refresh ice failed');
                    debuggerService.log({
                        msg: {
                            activity: 'JSEP',
                            timestamp: new Date(),
                            participantType: 'Publisher',
                            participantName: displayName,
                            eventDetails: {
                                typeOfEvent: "JSEP",
                                timestamp: new Date(),
                                sessionId: sessionId,
                                pluginName: 'videoroom',
                                pluginId: handlerInstance.getId(),
                                data: {
                                    callback: 'error',
                                    error: error,
                                    comment: 'ice restart failed'
                                }
                            }
                        },
                        source: 'proctorhvsLog'
                    });
                }
            });
        }

        function getHandler() {
            return {
                plugin: "janus.plugin.videoroom",
                opaqueId: opaqueId,
                success: function(_pluginHandle) {
                    console.log("videoProctor_hvs_log.handler.success");
                    displayName = sessionStorage.getItem('assess_janus_video_displayName');
                    handlerInstance = _pluginHandle;
                    hvsService.publishFeedToJanus(handlerInstance, displayName);
                    var sl = service.localVar;
                    hvsService.addHandlerInstance(handlerInstance, sl.opts.procType);
                    debuggerService.log({
                        msg: {
                            activity: 'Handle',
                            timestamp: new Date(),
                            participantType: 'Publisher',
                            participantName: displayName,
                            eventDetails: {
                                typeOfEvent: "Handle",
                                timestamp: new Date(),
                                sessionId: sessionId,
                                pluginName: 'videoroom',
                                pluginId: handlerInstance.getId(),
                                data: {
                                    callback: 'success',
                                    comment: 'plugin attached'
                                }
                            }
                        },
                        source: 'proctorhvsLog'
                    });
                },
                error: function(error) {
                    console.log("videoProctor_hvs_log.handler.error", error);
                    debuggerService.log({
                        msg: {
                            activity: 'Handle',
                            timestamp: new Date(),
                            participantType: 'Publisher',
                            participantName: displayName,
                            eventDetails: {
                                typeOfEvent: "Handle",
                                timestamp: new Date(),
                                sessionId: sessionId,
                                pluginName: 'videoroom',
                                pluginId: null,
                                data: {
                                    callback: 'error',
                                    error: error,
                                    comment: 'plugin attached failed'
                                }
                            }
                        },
                        source: 'proctorhvsLog'
                    });
                },
                consentDialog: function(res) {
                    console.log("videoProctor_hvs_log.handler.consentDialog", res);
                },
                webrtcState: function(on) {
                    console.log("videoProctor_hvs_log.handler.webrtcState", on);
                    debuggerService.log({
                        msg: {
                            activity: 'WEBRtc',
                            timestamp: new Date(),
                            participantType: 'Publisher',
                            participantName: displayName,
                            eventDetails: {
                                typeOfEvent: "WEBRtc",
                                timestamp: new Date(),
                                sessionId: sessionId,
                                pluginName: 'videoroom',
                                pluginId: handlerInstance.getId(),
                                data: {
                                    webrtcState: on ? 'ON' : 'OFF'
                                }
                            }
                        },
                        source: 'proctorhvsLog'
                    });
                    var msg = "";
                    if (on) {
                        isHVSRestarted = false;
                        isIceRestarted = false;
                        msg = "Video Proctoring session has just started.";
                        console.log("videoProctor_hvs_log.handler: " + msg);
                        getProctoringConfig(false, 'hvs').then(function(res) {
                            console.log('sap1_SS', res);
                            if (loginInfo && loginInfo.ContainsMediaQuestion && res.videoRoom && res.videoRoom.videoAnswer && res.videoRoom.videoAnswer.clientAudioBitrateinKB) {
                                var audioBitrateChange = res.videoRoom.videoAnswer.clientAudioBitrateinKB;

                            } else if (res.videoRoom && res.videoRoom.clientAudioBitrateinKB) {
                                var audioBitrateChange = res.videoRoom.clientAudioBitrateinKB;

                            } else {
                                var audioBitrateChange = 16;
                            }
                            updateSendBitrate(window.testWebRTC.pc, 'audio', audioBitrateChange);
                            if (loginInfo && loginInfo.ContainsMediaQuestion && res.videoRoom && res.videoRoom.videoAnswer && res.videoRoom.videoAnswer.clientVideoBitrateinKB) {
                                var videoBitrateChange = res.videoRoom.videoAnswer.clientVideoBitrateinKB;
                                updateSendBitrate(window.testWebRTC.pc, 'video', videoBitrateChange);
                            } else if (res.videoRoom && res.videoRoom.clientVideoBitrateinKB) {
                                var videoBitrateChange = res.videoRoom.clientVideoBitrateinKB;
                                updateSendBitrate(window.testWebRTC.pc, 'video', videoBitrateChange);
                            }
                        })
                        getProctoringConfig().then(function(res) {
                            hvsService.receiveProctConfig(res);
                        })
                    } else {
                        msg = "Video Proctoring session has just stopped.";
                        console.log("videoProctor_hvs_log.handler: " + msg);
                    }
                    if (!on && !isVideroomDestroyed) {
                        console.log("sap1_video_webrtcState_restartHvsTimeout", restartHvsTimeout);
                        if (restartHvsTimeout) {
                            $timeout.cancel(restartHvsTimeout);
                            restartHvsTimeout = null;
                        }
                        console.log("videoProctor_hvs_log.handler.webrtcState restarted HVS ");
                        isHVSRestarted = true;
                        console.log("sap1_video_webrtcState_restartHVS");
                        hvsService.restartHVS('webrtcState is false');
                    }
                },
                iceState: function(stat) {
                    console.log("videoProctor_hvs_log.handler.iceState", stat);
                    debuggerService.log({
                        msg: {
                            activity: 'WEBRtc',
                            timestamp: new Date(),
                            participantType: 'Publisher',
                            participantName: displayName,
                            eventDetails: {
                                typeOfEvent: "WEBRtc",
                                timestamp: new Date(),
                                sessionId: sessionId,
                                pluginName: 'videoroom',
                                pluginId: handlerInstance.getId(),
                                data: {
                                    iceState: stat
                                }
                            }
                        },
                        source: 'proctorhvsLog'
                    });
                    // if (stat === 'checking') {
                    //     isIceDisconnected = false;
                    //     isIceRestarted = false;
                    // }
                    // if (stat === 'disconnected') {
                    //     isIceDisconnected = true;
                    //     isIceRestarted = false;
                    // }
                    // if (!isIceRestarted && isIceDisconnected && stat === 'connected') {
                    //     isIceDisconnected = false;
                    //     isIceRestarted = true;
                    //     restartIce();
                    // }
                    console.log("sap1_video_iceState_stat", stat);
                    if (stat === "disconnected") {
                        restartHvsTimeout = hvsService.restartHVS('iceState', 30);
                    } else if (stat === "connected") {
                        if (restartHvsTimeout) {
                            $timeout.cancel(restartHvsTimeout);
                            restartHvsTimeout = null;
                        }
                    }
                },
                onmessage: function(msg, jsep) {
                    var sl = service.localVar,
                        publisherJoined = false;
                    if (msg.publishers && msg.publishers.length > 0) {
                        publisherJoined = true;
                    }
                    debuggerService.log({
                        msg: {
                            activity: 'getHandler',
                            callback: 'onmessage',
                            msg: msg,
                            jsep: _.omit(jsep, 'sdp'),
                            success: true,
                            timestamp: new Date()
                        },
                        source: 'proctorhvsLog'
                    });
                    console.log("videoProctor_hvs_log.handler.onmessage", msg);
                    Janus.debug(" ::: Got a message (publisher) :::");
                    Janus.debug(msg);
                    var event = msg["videoroom"];
                    Janus.debug("Event: " + event);
                    if (event === "joined") {
                        userId = msg["id"];
                        isVideroomDestroyed = false;
                        //if (role === "publisher") {
                        if (_.size(msg.publishers) > 0) {
                            publishers = msg.publishers;
                        }
                        // This is our session, publish our stream
                        hvsService.publishFeedToWebRtc(handlerInstance, userId, mediaConstrint, displayName)
                            .then(function(res) {
                                return startPublishing(res.data.sessionId);
                            })
                            .then(function(res) {
                                console.log(res.msg);
                                startProcPromise.resolve({
                                    'strm': service.mediaStream,
                                    'msg': 'Successfully started proctoring service.',
                                    'isOnline': $rootScope.isNetworkGotFailed
                                });
                            })
                            .catch(function(res) {
                                console.error(res.msg);
                                startProcPromise.reject({
                                    'strm': null,
                                    'msg': 'Not able to initialize proctoring service!',
                                    'isOnline': $rootScope.isNetworkGotFailed
                                });
                            });
                        //}
                    } else if (event === "destroyed") {
                        isVideroomDestroyed = true;
                    }
                    if (jsep !== undefined && jsep !== null) {
                        Janus.debug("Handling SDP as well...");
                        Janus.debug(jsep);
                        handlerInstance.handleRemoteJsep({
                            jsep: jsep
                        });
                    }
                    if (msg["request"] === "unpublished") {
                        handlerInstance.hangup();
                    }
                    if (sl.opts.procType === 'envProctoring') {
                        if (event === 'event' && msg.leaving && msg.leaving !== null) {
                            /* either refresh or net gone of link generator */
                            //var errMsg = "You landed on this page. Either the test is over or there is some internet connectivity issue.";
                            //"Their is some issue with the internet. Please follow the previous step to take test again."
                            var errMsg = "The current session has been terminated abruptly.Possible reasons could be" +
                                "<br>&nbsp;&nbsp;- Internet failure in primary or secondary device" +
                                "<br>&nbsp;&nbsp;- Browser window is closed in the primary device";

                            stopProctoring();
                            hvsService.logOutToMsgPage(errMsg);
                        }
                        /*if (event === 'destroyed' && publisherJoined) {
                            var errMsg = "The test has been submitted. Thanks for attending the test.";
                            hvsService.logOutToMsgPage(errMsg);
                        }*/
                    }
                },
                onlocalstream: function(stream) {
                    var sl = service.localVar;
                    console.log("videoProctor_hvs_log.handler.onlocalstream");
                    debuggerService.log({
                        msg: {
                            activity: 'Media',
                            timestamp: new Date(),
                            participantType: 'Publisher',
                            participantName: displayName,
                            eventDetails: {
                                typeOfEvent: "Media",
                                timestamp: new Date(),
                                sessionId: sessionId,
                                pluginName: 'videoroom',
                                pluginId: handlerInstance.getId(),
                                data: {
                                    comment: 'local media attached'
                                }
                            }
                        },
                        source: 'proctorhvsLog'
                    });
                    if (stream && sl.opts.vidElem) {
                        sl.opts.vidElem.srcObject = stream;
                    }
                    service.isVideoProctoringStarted = true;
                    service.mediaStream = stream;
                    $rootScope.vidStrm = stream;
                    $rootScope.vidStrmId = stream.id;
                    service.goldenImagePath = hvsService.goldenImagePath;
                    service.proctoringImagePath = hvsService.proctoringImagePath;
                    var data = {
                        type: 'publisher',
                        id: displayName,
                        wrtcConnection: handlerInstance.webrtcStuff
                    };
                    webRtcStatsService.start(data);
                },
                onremotestream: function(stream) {
                    debuggerService.log({
                        msg: {
                            activity: 'getHandler',
                            callback: 'onremotestream',
                            success: true,
                            timestamp: new Date()
                        },
                        source: 'proctorhvsLog'
                    });
                    console.log("videoProctor_hvs_log.handler.onremotestream");
                },
                oncleanup: function() {
                    debuggerService.log({
                        msg: {
                            activity: 'getHandler',
                            callback: 'oncleanup',
                            success: true,
                            sessionId: sessionId,
                            timestamp: new Date()
                        },
                        source: 'proctorhvsLog'
                    });
                    service.mediaStream = null;
                    $rootScope.vidStrm = null;
                    $rootScope.vidStrmId = null;
                    webRtcStatsService.stopAll();
                    console.log("videoProctor_hvs_log.handler.oncleanup");
                },
                mediaState: function(res, on) {
                    debuggerService.log({
                        msg: {
                            activity: 'Media',
                            timestamp: new Date(),
                            participantType: 'Publisher',
                            participantName: displayName,
                            eventDetails: {
                                typeOfEvent: "Media",
                                timestamp: new Date(),
                                sessionId: sessionId,
                                pluginName: 'videoroom',
                                pluginId: handlerInstance.getId(),
                                data: {
                                    media: res,
                                    status: on ? 'ON' : 'OFF'
                                }
                            }
                        },
                        source: 'proctorhvsLog'
                    });
                    console.log("videoProctor_hvs_log.handler.mediaState", res, on);
                    // if (!on) {
                    //     restartHvsTimeout = hvsService.restartHVS('mediaState', 40);
                    // } else {
                    //     if (restartHvsTimeout) {
                    //         $timeout.cancel(restartHvsTimeout);
                    //         restartHvsTimeout = null;
                    //     }
                    // }
                    if (!isIceRestarted && !on && !restartHvsTimeout) {
                        console.log("sap1_video_mediaState_restartHvsTimeout", restartHvsTimeout);
                        /*if (restartHvsTimeout) {
                            $timeout.cancel(restartHvsTimeout);
                            restartHvsTimeout = null;
                        }*/
                        isIceRestarted = true;
                        restartIce();
                    }
                    if (on) {
                        isIceRestarted = false;
                    }
                },
                detached: function(res) {
                    debuggerService.log({
                        msg: {
                            activity: 'Handle',
                            timestamp: new Date(),
                            participantType: 'Publisher',
                            participantName: displayName,
                            eventDetails: {
                                typeOfEvent: "Handle",
                                timestamp: new Date(),
                                sessionId: sessionId,
                                pluginName: 'videoroom',
                                pluginId: null,
                                data: {
                                    response: res,
                                    comment: 'session detached'
                                }
                            }
                        },
                        source: 'proctorhvsLog'
                    });
                    console.log("videoProctor_hvs_log.handler.detached", res);
                }
            };
        }

        function startPublishing(sessionId) {
            var sl = service.localVar,
                request = {
                    serverUserId: userId,
                    serverSessionId: sessionId,
                    pluginHandleId: handlerInstance.getId(),
                    goldenImagePath: assessmentUtility.localStorage.getData('savedinS3GoldenImagePath'),
                    isRefresh: false
                };
            if (sl.opts.vqId) {
                request.ctxData = {
                    videoAnswerCtx: { questionId: sl.opts.vqId }
                };
            }
            if (sl.opts.procType === 'envProctoring') {
                request.streamType = 'SECONDARY_CAMERA';
            }
            return webService.execute('startPublishing', request)
                .then(function(res) {
                        if (!res || !res.data || (_.get(res, 'data.status') === 'KO')) {
                            debuggerService.log({
                                msg: {
                                    activity: 'startPublishing',
                                    response: res,
                                    success: false,
                                    timestamp: new Date()
                                },
                                source: 'proctorhvsLog'
                            });
                            onPublishingFail(request, res);
                            return $q.reject({
                                data: { isPublished: false },
                                msg: "Error occured,while trying to publishing!"
                            });
                        } else {
                            debuggerService.log({
                                msg: {
                                    activity: 'startPublishing',
                                    success: true,
                                    request: request,
                                    response: { data: res.data, xGuid: res.xGuid },
                                    apiCall: true,
                                    timestamp: new Date()
                                },
                                source: 'proctorhvsLog'
                            });
                            return $q.resolve({
                                data: { isPublished: true },
                                msg: "Successfully published."
                            });
                        }
                    },
                    function(res) {
                        debuggerService.log({
                            msg: {
                                activity: 'startPublishing',
                                response: res,
                                success: false,
                                timestamp: new Date()
                            },
                            source: 'proctorhvsLog'
                        });
                        onPublishingFail(request, res);
                        return $q.reject({
                            data: { isPublished: false },
                            msg: "Error occured,while trying to publishing!"
                        });
                    }
                );
        }

        function unPublishedFeed(streamId) {
            return stopPublishing(streamId)
                .then(function(res) {
                    service.isVideoProctoringStarted = false;
                    startProcPromise = null;
                    return res;
                })
                .finally(function() {
                    isStoppingProctoring = false;
                });
        }

        function stopPublishing(streamId) {
            var rq = {
                isFinalInterviewEnd: true,
                streamId: streamId
            };
            return webService.execute('stopPublishing', rq)
                .then(function(res) {
                    if (!res || !res.data || !res.data.status === 'KO') {
                        debuggerService.log({
                            msg: {
                                activity: 'stopPublishing',
                                success: false,
                                apiCall: true,
                                timestamp: new Date()
                            },
                            source: 'proctorhvsLog'
                        });
                        return $q.reject({
                            data: { isStopped: false },
                            msg: "Unable to stop Confrence!"
                        });
                    }
                    debuggerService.log({
                        msg: {
                            activity: 'stopPublishing',
                            success: true,
                            request: rq,
                            response: { data: res.data, xGuid: res.xGuid },
                            apiCall: true,
                            timestamp: new Date()
                        },
                        source: 'proctorhvsLog'
                    });
                    return $q.resolve({
                        data: { isStopped: true },
                        msg: "Confrence is stopped successfully."
                    });
                }, function(res) {
                    debuggerService.log({
                        msg: {
                            activity: 'stopPublishing',
                            success: false,
                            request: rq,
                            response: { data: res.data, xGuid: res.xGuid },
                            apiCall: true,
                            timestamp: new Date()
                        },
                        source: 'proctorhvsLog'
                    });
                    return $q.reject({
                        data: { isStopped: false },
                        msg: "Unable to stop Confrence!"
                    });
                });
        }

        function onPublishingFail(req, res) {
            hvsService.destroyHandler(handlerInstance);
            hvsService.destroyJanus();
            debuggerService.log({
                msg: {
                    activity: 'startPublishing',
                    success: false,
                    request: req,
                    response: { data: res.data, xGuid: res.xGuid },
                    apiCall: true,
                    timestamp: new Date()
                },
                source: 'proctorhvsLog'
            });
        }

        function getPromise(prmObj) {
            return prmObj &&
                prmObj.promise &&
                prmObj.promise.$$state &&
                prmObj.promise.$$state.status !== 2 ? prmObj : $q.defer();
        }

        // function pushActivityLog(log) {
        //     var janusActivityLog = {
        //         canLoginActivityLog: {
        //             janusLog: log
        //         }
        //     };
        //     loggerService.push(janusActivityLog);
        // }

        /*...................Proctoring Config..................*/

        function getProctoringConfig(isOnlyGlobal, hvs) {
            var utilityObj = service.utility;

            return utilityObj.getTenantSpecificProctoringConfig(isOnlyGlobal, hvs)
                .then(function(tConf) {
                    if (!tConf) {
                        tConf = {};
                    }
                    return utilityObj.getGlobalProctoringConfig(hvs).then(
                        function(config) {
                            config = config ? config : {};
                            return _.merge(config, tConf);
                        },
                        function(res) {
                            return tconf;
                        }
                    );
                    // return conf;
                });

        }

        function getTenantSpecificProctoringConfig(isOnlyGlobal, hvs) {
            var getAllAppPreference_Request = {
                Type: "assessment.proctoring.config",
                IsTenantGlobal: true
            };
            if(!loginInfo){
                loginInfo = loginService.getLoginInfo();
            }
            if (hvs) {
                getAllAppPreference_Request.Type = "assessment.hvs.conf";
            }
            if (isOnlyGlobal) {
                return $q.when(null);
            } else {
                try {
                    if (hvs) {
                        return $q.when(loginInfo.hvsConfig);
                    } else {
                        return $q.when(loginInfo.proctoringConfig);
                    }
                } catch(ex){
                    return commonService.GetAllAppPreference(getAllAppPreference_Request);
                }
            }
        }

        function getGlobalProctoringConfig(hvs) {
            var getAllAppPreference_Request = {
                Type: "assessment.proctoring.config",
                IsGlobal: true
            };
            if(!loginInfo){
                loginInfo = loginService.getLoginInfo();
            }
            try {
                if (hvs) {
                    getAllAppPreference_Request.Type = "assessment.hvs.conf";
                    return $q.when(loginInfo.hvsConfigGlobal);
                }
                return $q.when(loginInfo.proctoringConfigGlobal);
            } catch(ex){
                return commonService.GetAllAppPreference(getAllAppPreference_Request);
            }
        }

        function updateSendBitrate(rtcPeerConnObject, typeOfMedia, newBitRateInKbps) {
            debuggerService.log({
                msg: {
                    activity: 'updateSendBitrate',
                    typeOfMedia: typeOfMedia,
                    newBitRateInKbps: newBitRateInKbps,
                    timestamp: new Date()
                },
                source: 'proctorhvsLog'
            });
            for (var senders = rtcPeerConnObject.getSenders(), sIdx = 0; sIdx < senders.length; sIdx++) {
                if (senders[sIdx] && senders[sIdx].track && typeOfMedia === senders[sIdx].track.kind) {
                    var s = senders[sIdx].getParameters();
                    s.encodings ? s.encodings[0].maxBitrate = newBitRateInKbps * 1000 : s.encodings = [{ maxBitrate: newBitRateInKbps * 1000 }], senders[sIdx].setParameters(s).then(function() { console.error("Set bitrate to " + newBitRateInKbps); }).catch(function(e) { console.error("Set bitrate failed " + e); })
                }
            }
        }

    }
})();

(function() {
    'use strict';

    angular
        .module("OnlineAssessmentAngular")
        .factory("proctorMessage", proctorMessage);

    function proctorMessage(growl, $interval, $q, webService, $log) {
        var shownMessageIdList = [];
        var service = {
            start: start,
            stop: stop,
            info: {
                candidateId: -1,
                testId: -1
            },
            config: {
                intervalObj: null,
                callInterval: 10,
                msgDuration: 5
            }
        };
        return service;

        function start(candidateId, testId) {
            if (candidateId && testId) {
                service.info.candidateId = candidateId;
                service.info.testId = testId;
                service.info.disableBlockUI = true;
                service.config.intervalObj = $interval(function() {
                    getMessages();
                }, (service.config.callInterval * 1000));
            } else {
                $log.log('Infomation not pressent for proctor message service');
            }
        }

        function stop() {
            if (service.config.intervalObj) {
                $interval.cancel(service.config.intervalObj);
            }
        }

        function getMessages() {
            webService.execute("GetTestUserMessagesLogs", service.info).then(
                function(response) {
                    if (!response.data) {
                        return false;
                    }
                    response = response.data;
                    if (response.statusId === 200 && response.data) {
                        var _messageList = _.last(response.data.Messages);
                        if (_messageList && _messageList.message && _messageList.message.length > 0) {
                            var _messages = _.filter(_messageList.message, function(msg) {
                                return _.indexOf(shownMessageIdList, msg.id) == -1 && !msg.isDisplayed;
                            });
                            if (_messages && _messages.length > 0) {
                                _.forEach(_messages, function(msg) {
                                    if (msg && msg.message) {
                                        growl.error(msg.message, { ttl: service.config.callInterval * 1000, disableCloseButton: false, disableCountDown: true });
                                        shownMessageIdList.push(msg.id);
                                    }
                                });
                            }
                        }
                    }
                },
                function() {
                    $log.log("Error occurred when fetching TestUser Messages Logs!");
                }
            );
        }
    }
})();

(function() {
    'use strict';

    angular.
    module('OnlineAssessmentAngular')
        .factory("proctorService", proctorService);

    function proctorService($log, $interval, $timeout, $q, faceTracker, imageTracker, trackerService, loginService, hvsService, webService, commonService, faceLandmarks, afterSubmission) {
        var ft = faceTracker,
            isAllOne = function(element) {
                return element === 1;
            },
            service = {
                localVar: {
                    videoObjectId: '',
                    cameraOk: true,
                    videoProctoringMode: 'strict',
                    mediaQuestion: loginService.getLoginInfo()
                },
                promiseReturn: function(trackDetailJson) {
                    var promiseReturnVal = null;
                    return $q.when(service.faceTracking.initiate(trackDetailJson)
                        .then(function(val) {
                            promiseReturnVal = val;
                            if (trackDetailJson.standAlone) {
                                return true;
                            }
                            // if (trackDetailJson.isDesktop) {
                            return hvsService.getMyRoom(getMyRoomRequest());
                            // }
                            // return val;
                        })
                        .then(function(roomInfo) {
                            if (trackDetailJson.standAlone) {
                                return promiseReturnVal;
                            }
                            var option = {
                                videoElementId: service.localVar.videoObjectId,
                                isTimeIntervalRequired: false,
                                proctoringImagePath: roomInfo.data.goldenImageProctoringPath,
                                metaData: { faceTracked: true },
                                isFileUploadToS3PermanentPath: true
                            };
                            imageTracker.start(service.localVar.videoStream, option);
                            return promiseReturnVal;
                        })
                    );
                },
                captureImageTemp: function(imageType) {
                    var roomInfo = JSON.parse(sessionStorage.getItem(sessionStorage.getItem('X-AUTH-TOKEN') + '-myRoomInfo')),
                        option = {
                            videoElementId: service.localVar.videoObjectId,
                            isTimeIntervalRequired: false,
                            isTemorarySaved: true,
                            proctoringImagePath: roomInfo.goldenImageProctoringPath,
                            isFileUploadToS3PermanentPath: true
                        };
                    return imageTracker.start(service.localVar.videoStream, option);
                },
                startCapturingGoldenImages: function() {
                    var roomInfo = JSON.parse(sessionStorage.getItem(sessionStorage.getItem('X-AUTH-TOKEN') + '-myRoomInfo'));

                    var numberOfImagesToClick = angular.isDefined(roomInfo.initialImagesCount) ? roomInfo.initialImagesCount : 15;
                    // fallback to collecting 15 images if the key is not present

                    // used to calculate the delay between the subsequent frameCaptures
                    var imageClickFrequency = 5000 / numberOfImagesToClick;
                    var promiseHolder = $q.defer();
                    // Given the count of images to click, collect balance images with the same frequency
                    var existingCountOfInitialImages = angular.isDefined(roomInfo.existingCountOfInitialImages) ? roomInfo.existingCountOfInitialImages : 0;
                    var balanceNumberOfImagesToClick = numberOfImagesToClick - existingCountOfInitialImages;
                    balanceNumberOfImagesToClick = balanceNumberOfImagesToClick > 0 ? balanceNumberOfImagesToClick : 0;
                    if (balanceNumberOfImagesToClick == 0) {
                        var formCount = balanceNumberOfImagesToClick + 1;
                    } else {
                        var formCount = balanceNumberOfImagesToClick;
                    }
                    var type = "initial";
                    return commonService.generateMultipleFormsForSnapshots({
                            relativePath: roomInfo.initialImagesPath,
                            noOfForms: formCount
                        }, type)
                        .then(function() {
                            var goldenImageUploadPromises = _.range(0, balanceNumberOfImagesToClick + 1)
                                .map(function(delayFactor, index) {
                                    return $timeout(function() {
                                        commonService.generateMultipleFormsForSnapshots({
                                                relativePath: roomInfo.initialImagesPath,
                                                noOfForms: 1
                                            })
                                            .then(function(formTemplateResponse) {
                                                var camData = imageTracker.getImage(true);
                                                var fd = new FormData();
                                                if (balanceNumberOfImagesToClick === index) {
                                                    commonService.clearFormForSnapshots();
                                                    promiseHolder.resolve()
                                                }
                                                _.forEach(formTemplateResponse.s3FormFields.fields, function(value, key) {
                                                    fd.append(key, value);
                                                });
                                                fd.append('file', camData.get('file'));
                                                var constraints = {
                                                        fileExtentions: ".jpeg",
                                                        fileSizeLimit: 102400
                                                    },
                                                    formPrintingDynamicUrls = _.chain(sessionStorage.getItem('formPrintingDynamicUrls'))
                                                    .union([_.get(formTemplateResponse, 's3FormFields.url')])
                                                    .uniq()
                                                    .value();
                                                sessionStorage.setItem('formPrintingDynamicUrls', JSON.stringify(formPrintingDynamicUrls));
                                                return webService.execute(formTemplateResponse.s3FormFields.url, fd, "POST", null, null, constraints).then(
                                                    function(res) {
                                                        $log.log(res);
                                                        if (!!res && (res.status >= 200 && res.status < 300)) {
                                                            return $q.resolve({ "msg": "Golden image uploaded successfully for training" });
                                                        } else {
                                                            return $q.reject({ "msg": "Error occurred when Uploading File", "error": null });
                                                        }
                                                    },
                                                    function(res) {
                                                        return $q.reject({ "msg": "Error occurred when Uploading File", "error": res });
                                                    }
                                                );
                                            })
                                            .catch(function(errResponse) {
                                                return $q.reject({
                                                    "msg": "Error occurred while fetching required fields",
                                                    "error": errResponse
                                                });
                                            })
                                    }, delayFactor * imageClickFrequency);
                                })
                            //return goldenImageUploadPromises;
                            return promiseHolder.promise;
                        })

                },
                checkForFace: function(fd,backgroundProcess) {
                    var self = this,
                    constraints = {
                        detectFaces: true,
                        detectObjects: false
                    };
                    if(backgroundProcess || backgroundProcess == undefined){
                        constraints.isSync = false;
                    }else{
                        constraints.isSync = true;
                    }
                    
                    return webService.execute("analyzeImage", fd, "POST", null, null, constraints)
                        .then(function(res) {
                            if (res.data.ContextId) {
                                //blockUI.start();
                                if (!res || res.status !== 200 || !res.data) {
                                return $q.reject({});
                                }
                                
                                return afterSubmission.getBgTaskCompletionStat(res.data.ContextId)
                                    .then(function(faceInfo) {
                                        return faceInfo;
                                    });
                            } else if(!backgroundProcess){
                                return res;
                            }
                            else{
                                return $q.reject({});
                            }

                            });

                    /*********************************************/

                },
                savePersistence: function(url) {
                    return hvsService.getMyRoom(getMyRoomRequest())
                        .then(function(roomInfo) {
                            ft.stop();
                            return imageTracker.saveImageToS3(url, roomInfo.data.goldenImageProctoringPath, { goldenimage: true })
                        });
                    /*var response = imageTracker.saveImageToS3(url, { goldenimage: true });
                    ft.stop();
                    return response;*/
                },
                getMyRoomSecondaryCam: function() {
                    return hvsService.getMyRoom(getMyRoomRequest());
                },
                faceTracking: {
                    localReturnObj: {
                        candidatefaces: [],
                        count: 0,
                        checkStatus: [],
                        intevalObj: null,
                        availableStatus: false,
                        systemPerformance: []
                    },
                    internalObj: {
                        faceIntervalCount: 0,
                        maxTimeSpan: 3,
                        minTimespan: 3
                    },

                    initiate: function(trackDetailJson) {
                        var self = this,
                            isFaceLandmarks = JSON.parse(sessionStorage.getItem('faceLandmarks'));
                        if (isFaceLandmarks) {
                            ft = faceLandmarks;
                        }
                        service.localVar.videoObjectId = (trackDetailJson.videoTagId) ? trackDetailJson.videoTagId : 'video';
                        service.localVar.isVideoEnabled = (trackDetailJson.isVideoEnabled) ? trackDetailJson.isVideoEnabled : true;
                        service.localVar.isAudioEnabled = (trackDetailJson.isAudioEnabled) ? trackDetailJson.isAudioEnabled : true;
                        service.localVar.canvasObjectId = (trackDetailJson.canvasTagId) ? trackDetailJson.canvasTagId : 'overlay';

                        return service.faceTracking.testWebCam(trackDetailJson).then(function(res) {
                            if (!res) {
                                return false;
                            }
                            var faceTrackOptions = {
                                videoElementId: service.localVar.videoObjectId,
                                stream: service.localVar.videoStream
                            };
                            ft.start(faceTrackOptions);
                            return self.start().then(
                                function(res) {
                                    console.log(self.localReturnObj.intevalObj);
                                    $interval.cancel(self.localReturnObj.intevalObj);
                                    return res;
                                },
                                function(res) {
                                    $log.log(res);
                                }
                            );

                        }).catch(function(err) {
                            $log.error(err);
                        });

                    },
                    start: function() {
                        var self = this;
                        return $q(function(resolve, reject) {
                            return self.localReturnObj.intevalObj = $interval(function() {
                                self.handleFaceTracking();
                                if (self.localReturnObj.availableStatus) {
                                    resolve(self.localReturnObj);
                                }
                            }, 1000);
                        });
                    },
                    testWebCam: function() {
                        var self = this;
                        return trackerService.getMediaStream({ audio: false, video: true })
                            .then(function(stream) {
                                service.localVar.videoStream = stream;
                                return self.handleVideo(stream);
                            })
                            .catch(function(err) {
                                $log.log(err);
                                service.localVar.cameraOk = false;
                                self.videoError(err);
                            });

                    },
                    handleVideo: function(stream) {
                        var self = this,
                            video = document.querySelector('#' + service.localVar.videoObjectId);
                        $log.log(service.localVar.cameraOk);
                        video.srcObject = stream;
                        if (!stream.getVideoTracks().length) {
                            self.videoError();
                            service.localVar.cameraOk = false;
                            return false;
                        } else {
                            return (
                                service.localVar.cameraOk = true
                            );
                        }
                    },
                    videoError: function(e) {
                        $log.log(e);
                    },
                    startCamera: function() {
                        var video = service.localVar.videoObjectId,
                            tracker = new tracking.ObjectTracker("face");
                        tracker.setInitialScale(2);
                        tracker.setStepSize(2);
                        tracker.setEdgesDensity(0.1);
                        tracking.track('#' + video, tracker, { camera: true });
                    },
                    handleFaceTracking: function() {
                        var self = this,
                            timeSpan = 1,
                            localReturnObj = service.faceTracking.localReturnObj,
                            faceCountCollection = [],
                            meanVal;
                        ft.processRawFaceCountCollection(timeSpan);
                        self.internalObj.faceIntervalCount++;
                        faceCountCollection = ft.config.faceCountCollection;
                        //service.faceTracking.localReturnObj.systemPerformance.push(ft.config.trackingspeed);
                        if (faceCountCollection.length === timeSpan) {
                            //meanVal = _.mean(service.faceTracking.localReturnObj.systemPerformance);
                            //service.faceTracking.localReturnObj.systemPerformance = [];
                            var typeOfTest = sessionStorage.getItem('typeOfTest');
                            if (typeOfTest === 'CoCubes' || typeOfTest === 'nseit' || typeOfTest === 'talentlens') {
                                trackerService.config.allowedFrameRate = 4;
                            }
                            localReturnObj.allowedFrameRate = trackerService.config.allowedFrameRate;
                            ft.getFps()
                                .then(function(fps) {
                                    var testStatus = sessionStorage.getItem('testStarted');
                                    if (fps < trackerService.config.allowedFrameRate) {
                                        localReturnObj.availableStatus = true;
                                        localReturnObj.isCandidateProctored = true;
                                        localReturnObj.systemSlow = {
                                            flag: true,
                                            frameSpeed: fps
                                        };
                                        if (testStatus !== 'continue') {
                                            ft.stop();
                                        }
                                    } else if (faceCountCollection.every(isAllOne)) {
                                        sessionStorage.hasproctorfacetrackingincremented = true;
                                        localReturnObj.availableStatus = true;
                                        localReturnObj.isCandidateProctored = true;
                                        localReturnObj.systemSlow = {
                                            flag: false,
                                            frameSpeed: fps
                                        };
                                        if (testStatus !== 'continue') {
                                            ft.stop();
                                        }
                                    }
                                });
                        }
                    }

                }
            };
        return service;

        function getMyRoomRequest() {
            var isEnvProctoring = sessionStorage.getItem("isSecondaryCamera") === 'true' ? true : false,
                loginInfo = loginService.getLoginInfo(),
                isContainsMediaQuestion = loginInfo && loginInfo.ContainsMediaQuestion,
                roomRequest = isEnvProctoring ? { "streamType": "SECONDARY_CAMERA" } :
                isContainsMediaQuestion ? { "streamType": "VIDEO_ANSWERS" } : null;
            return roomRequest;
        }
    }

})();

(function() {
    'use strict';
    angular
        .module('OnlineAssessmentAngular')
        .factory('objectDetection', objectDetection);

    function objectDetection($timeout, $injector, loggerService) {
        var service = {
                init: init,
                start: start,
                stop: stop
            },
            loginService = $injector.get('loginService'),
            loginInfo = loginService.getLoginInfo(),
            opt,
            model,
            modelPromise = null,
            isTrackerRunning = false,
            eventListenerOnPlay = false,
            videoElementId = 'faceTracVid',
            videoElement,
            modelWeight = 320,
            modelHeight = 320,
            config = {enabled: false, intervalInSec: 5, minScore: 0.40, minAreaPercentPerson: 10},
            minScore = config.minScore,
            minAreaPercentPerson = config.minAreaPercentPerson,
            detectObjectsTimeout = 5,
            frameDetectionCounterValue = 1,
            frameDetectionCounter = frameDetectionCounterValue,
            lastPredictionCount = 0,
            lastPredictionObjects = [],
            predictionCollection = [],
            maxAddedScore = {},
            sendDetailedLog = _.get(loginInfo, 'assessmentConfig.sendDetailedLog', false),
            names = [
                'person', 'bicycle', 'car', 'motorcycle', 'airplane', 'bus', 'train', 'truck', 'boat', 'traffic light',
                'fire hydrant', 'stop sign', 'parking meter', 'bench', 'bird', 'cat', 'dog', 'horse', 'sheep', 'cow',
                'elephant', 'bear', 'zebra', 'giraffe', 'backpack', 'umbrella', 'handbag', 'tie', 'suitcase', 'frisbee',
                'skis', 'snowboard', 'sports ball', 'kite', 'baseball bat', 'baseball glove', 'skateboard', 'surfboard',
                'tennis racket', 'bottle', 'wine glass', 'cup', 'fork', 'knife', 'spoon', 'bowl', 'banana', 'apple',
                'sandwich', 'orange', 'broccoli', 'carrot', 'hot dog', 'pizza', 'donut', 'cake', 'chair', 'couch',
                'potted plant', 'bed', 'dining table', 'toilet', 'tv', 'laptop', 'mouse', 'remote', 'keyboard', 'cell phone',
                'microwave', 'oven', 'toaster', 'sink', 'refrigerator', 'book', 'clock', 'vase', 'scissors', 'teddy bear',
                'hair dryer', 'toothbrush'
            ];
        return service;

        function init() {
            var host = location.origin,
                modelUrl = host + '/assessment/VideoTestCode/Model/model.json';
            if(!loginService) {
                loginService = $injector.get('loginService');
                loginInfo = loginService.getLoginInfo();
                console.log('loginService found null, injecting again', 'cha');
            }
            if(!loginInfo) {
                loginInfo = loginService.getLoginInfo();
                console.log('loginInfo found null, getting again', 'cha');
            }
            console.log(loginInfo, 'cha');
            config = _.get(loginInfo, 'assessmentConfig.objectDetectionConfig', config);
            if (config.modelUrl) {
                modelUrl = config.modelUrl;
            }
            if (config.objectList) {
                names = config.objectList.split(',');
            }
            if (config.intervalInSec) {
                detectObjectsTimeout = config.intervalInSec;
            }
            if (config.minScore) {
                minScore = config.minScore;
            }
            if (config.minAreaPercentPerson) {
                minAreaPercentPerson = config.minAreaPercentPerson;
            }
            modelPromise = tf.loadGraphModel(modelUrl).then(
                function(res) {
                    model = res;
                    startVideo();
                }
            );
        }

        function start(options) {
            if (angular.isDefined(options) && angular.isObject(options)) {
                opt = options;
                if (!options.stream) {
                    $log.error("stream is not defined");
                    return false;
                }
            }
            isTrackerRunning = true;
            if (modelPromise) {
                startVideo();
            } else {
                init();
            }
        }

        function stop() {
            isTrackerRunning = false;
            modelPromise = null;
            eventListenerOnPlay = false;
        }

        function startVideo() {
            videoElement = document.getElementById(videoElementId);
            videoElement.srcObject = opt.stream;
            videoElement.onloadeddata = function(e) {
                videoElement.play();
            };
            if (!eventListenerOnPlay) {
                videoElement.addEventListener('play', function() {
                    eventListenerOnPlay = true;
                    setTimeout(function() { callDetection(); }, 500);
                }, false);
            }
        }

        function callDetection() {
            if (!isTrackerRunning) {
                return false;
            }
            detectObjects();
            $timeout(function() {
                callDetection();
            }, detectObjectsTimeout * 1000);
        }

        function detectObjects() {
            if (!isTrackerRunning) {
                return false;
            }
            frameDetectionCounter -= 1;
            tf.tidy(function() {
                var input = tf.image.resizeBilinear(tf.browser.fromPixels(videoElement), [modelWeight, modelHeight]).div(255.0).expandDims(0);
                 var videoTimestamp = videoElement.currentTime;
                model.executeAsync(input).then(
                    function(result) {
                        var predictions = [],
                            currentPredictionObjects,
                            addedScoreKlasswise = [];
                        for (var i = 0; i < result[3].dataSync()[0]; ++i) {
                            var klass = names[result[2].dataSync()[i]],
                                score = result[1].dataSync()[i].toFixed(2),
                                bb = result[0].dataSync().slice(i * 4, (i + 1) * 4),
                                boxArea = (((bb[3] - bb[1]) * (bb[2] - bb[0])).toFixed(2) * 100);
                            bb = _.transform(bb, function(result, value, key) {
                                return result[key] = value.toFixed(4);
                            });
                            if ((score > minScore && boxArea > minAreaPercentPerson && klass.toLowerCase() === 'person') || (score > minScore && klass.toLowerCase() !== 'person')) {
                                predictions.push({ klass: klass, score: score, bb: bb, timeStamp: videoTimestamp, boxArea: boxArea });
                            }
                        }
                        console.log("objects : ", i, "prediction : ", predictions);
                        predictionCollection.push(predictions);
                        addedScoreKlasswise = _.reduce(predictions, function(result, value, key) {
                            result[value.klass] = result[value.klass] ? result[value.klass] : 0;
                            result[value.klass] = result[value.klass] + parseFloat(value.score);
                            return result;
                        }, {});
                        _.forEach(addedScoreKlasswise, function(value, key) {
                            if (!maxAddedScore[key] || maxAddedScore[key].score < value) {
                                maxAddedScore[key] = {};
                                maxAddedScore[key].score = value;
                                maxAddedScore[key].value = _.filter(predictions, { klass: key });
                            }
                        });
                        _.forEach(result, function(value) {
                            value.dispose();
                        });
                        input.dispose();
                        tf.disposeVariables();
                    },
                    function(error) {
                        console.log(error);
                        // pushLog([{ klass: 'none', score: 0 }]);
                        // if (isTrackerRunning) {
                        //     callDetection();
                        // }
                    }
                ).finally(
                    function() {
                        if (frameDetectionCounter > 0) {
                            $timeout(function() {
                                detectObjects();
                            }, 100);
                        } else {
                            fetchPrediction();
                        }
                    }
                );
            });
        }

        function fetchPrediction() {
            var predictions = [],
                currentPredictionObjects;
            _.forEach(maxAddedScore, function(value) {
                predictions.push(value.value);
            });
            predictions = _.flatten(predictions);
            currentPredictionObjects = _.map(predictions, 'klass');
            if (_.size(predictions) > 0 && (lastPredictionCount != _.size(predictions) || _.xor(currentPredictionObjects, lastPredictionObjects).length > 0)) {
                pushLog(predictions);
            }
            lastPredictionCount = _.size(predictions);
            lastPredictionObjects = currentPredictionObjects;
            /// reset variables
            frameDetectionCounter = frameDetectionCounterValue;
            predictionCollection = [];
            maxAddedScore = {};
        }

        function pushLog(predictions) {
            var request = {
                canLoginActivityLog: {
                    ob: {
                        pred: predictions,
                        timeStamp: new Date()
                    }
                }
            };
            if (sendDetailedLog) {
                request.canLoginActivityLog.objectDetection.predictionCollection = predictionCollection;
            }
            loggerService.push(request);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module("OnlineAssessmentAngular")
        .factory("muteTracker", muteTracker);

    function muteTracker($state, $q, growl, $timeout, $interval, commonService, loggerService) {
        var newMedia,
            service = {
                start: start,
                stop: stop,
                config: {
                    muteStatus: false,
                    timeInterval: 30, //45
                    muteIntervalObj: null,
                    unmutedAfterMuted: false,
                    growlMessageObjMic: null,
                    qId: null,
                    testTerminationTimeOut: null,
                    testTerminationOnMuteAfter: false
                }
            };
        return service;

        function start(mediaStream, qId, testTerminationOnMuteAfter) {
            return $q(function(resolve, reject) {
                service.config.qId = qId;
                service.config.testTerminationOnMuteAfter = testTerminationOnMuteAfter;
                if (!testTerminationOnMuteAfter) {
                    getMedia(mediaStream);
                } else {
                    getMediaNewStream();
                }
                resolve(true);
            });
        }

        function getMedia(mediaStream) {
            var cnf = service.config;
            cnf.muteIntervalObj = $interval(function() {
                cnf.muteStatus = mediaStream.getAudioTracks()[0].muted;
                checkMuteStatus();
            }, (cnf.timeInterval * 1000));
        }

        function getMediaNewStream() {
            var cnf = service.config;
            cnf.muteIntervalObj = $interval(function() {
                navigator.getUserMedia = navigator.getUserMedia ||
                    navigator.webkitGetUserMedia ||
                    navigator.mozGetUserMedia;
                if (navigator.getUserMedia) {
                    navigator.getUserMedia({
                            audio: true
                        },
                        function(stream) {
                            newMedia = stream;
                            cnf.muteStatus = stream.getAudioTracks()[0].muted;
                            checkMuteStatus();
                            newMedia.getTracks().forEach(function(track) {
                                if (track.readyState == 'live') {
                                    track.stop();
                                }
                            });
                        },
                        function(err) {
                            console.log("The following error occured: " + err.name);
                            cnf.muteStatus = true;
                            checkMuteStatus();
                        });
                } else {
                    console.log("getUserMedia not supported");
                    cnf.muteStatus = true;
                    checkMuteStatus();
                }
            }, (cnf.timeInterval * 1000));
        }

        function checkMuteStatus() {
            var cnf = service.config;
            if (cnf.muteStatus) {
                cnf.unmutedAfterMuted = true;
                if (cnf.testTerminationOnMuteAfter) {
                    cnf.testTerminationTimeOut = $timeout(function() {
                        terminateCandidate();
                    }, cnf.testTerminationOnMuteAfter * 1000);
                }
            } else if (cnf.unmutedAfterMuted) {
                //start(mediaStream, cnf.callBack);
                cnf.unmutedAfterMuted = false;
                if (cnf.testTerminationTimeOut) {
                    $timeout.cancel(cnf.testTerminationTimeOut);
                    cnf.testTerminationTimeOut = null;
                }
            }
            sendMuteStatus();
        }

        function sendMuteStatus() {
            var request = {
                muteStatus: service.config.muteStatus,
                timeStamp: new Date(),
                message: 'Ensure your mic is unmuted else you will be disqualified'
            };
            if (service.config.testTerminationOnMuteAfter) {
                request.message += ' and logged out';
            }
            pushMuteTrackerLog(request);
        }

        function pushMuteTrackerLog(data) {
            var cnf = service.config;
            if (data.muteStatus) {
                var growlMessageObj_microphone = growl.error(data.message);
                if (growlMessageObj_microphone) {
                    if (cnf.growlMessageObjMic) {
                        cnf.growlMessageObjMic.destroy();
                    }
                    cnf.growlMessageObjMic = growlMessageObj_microphone;
                }
            } else {
                destroyGrowlObj();
            }
            if (data.muteStatus !== cnf.muteStatus) {
                var json = {
                    "micActionTracking": {
                        "event": data.muteStatus ? "muted" : "unmuted",
                        "timeStamp": new Date(),
                        "qId": cnf.qId
                    }
                };
                loggerService.push(json);
                service.config.muteStatus = data.muteStatus;
            }
        }

        function stop() {
            return $q(function(resolve, reject) {
                $interval.cancel(service.config.muteIntervalObj);
                $timeout.cancel(service.config.testTerminationTimeOut);
                destroyGrowlObj();
                resolve(true);
            });
        }

        function destroyGrowlObj() {
            var cnf = service.config;
            if (cnf.growlMessageObjMic) {
                cnf.growlMessageObjMic.destroy();
                cnf.growlMessageObjMic = null;
            }
        }

        function terminateCandidate() {
            navigator.getUserMedia({
                    audio: true
                },
                function(stream) {
                    if (stream.getAudioTracks()[0].muted) {
                        stop();
                        var msgStr = "Your test has been terminated because your mic is muted!",
                            messageHtml = "<h2>" + msgStr + "</h2>",
                            logoutMsg = 'Mic found muted';
                        $state.go('msgPage', { stateParams: btoa(messageHtml), isLogout: btoa('true'), msg: btoa(logoutMsg) }, { location: 'replace', reload: true });
                    }

                },
                function(err) {
                    stop();
                    var msgStr = "Your test has been terminated because your mic is muted!",
                        messageHtml = "<h2>" + msgStr + "</h2>",
                        logoutMsg = 'Error while checking mic';
                    $state.go('msgPage', { stateParams: btoa(messageHtml), isLogout: btoa('true'), msg: btoa(logoutMsg) }, { location: 'replace', reload: true });
                });
        }
    }
})();

    (function() {
        'use strict';

        angular
            .module('OnlineAssessmentAngular')
            .factory('openModalService', openModalService);

        function openModalService($q, $modal, $rootScope, $window, $timeout) {
            var mapUrl = {
                optGrpTemplate: 'app/template/modal/modal.optionalGroups.tpl.html',
                notificationTemplate: 'app/template/modal/modal.notification.tpl.html',
                proctorCompatibility: 'app/template/modal/modal.onlineProctoring.tpl.html',
                provideAliasTemplate: 'app/template/modal/modal.alias.tpl.html',
                userChoiceGroupTemplate: 'app/template/modal/modal.userChoiceGroup.tpl.html',
                generateAnswerKey: 'app/template/modal/modal.generateKey.tpl.html',
                optionalGroupsPreview: 'app/template/modal/modal.optionalPreview.tpl.html',
                nextTestNotificationTemplate: 'app/template/modal/modal.nextTestNotification.html',
                provideTestSecurityKey: 'app/template/modal/modal.securityKey.html',
                alertTemplate: 'app/template/modal/modal.alert.html',
                videoAnswer: 'app/template/modal/modal.videoAnswer.tpl.html',
                provideEmailTemplate: 'app/template/modal/modal.candidateEmail.tpl.html',
                basicInstruction: 'app/template/modal/modal.basicInstruction.tpl.html',
                link: 'app/template/modal/modal.link.html',
                qaTakePhotoTemplate: 'app/template/modal/modal.qaTakePhoto.tpl.html',
                stopProctoringWarningTemplate: 'app/template/modal/modal.stopProctoringWarning.tpl.html',
                roomScan360Template: 'app/template/modal/modal.roomScan.tpl.html'
            };
            var modals = [];
            var service = {
                openModal: openModal,
                showModal: showModal,
                getModal: getModal,
                closeModal:closeModal,
                closeAllModals: closeAllModals
            };
            return service;

            ////////////////
            //code => code can be the key which refers to a template url,
            //code => code can also be templateUrl,
            //data => data can be any thing(string, json, numeric) which can be passed to the respective modal controller
            //scope => scope will be send only when the modal has to be created in the same scope.default rootScope.
            function openModal(code, data, scope) {
                var deferred = $q.defer(),
                    modalScope = angular.isDefined(scope) ? scope : $rootScope,
                    modal = angular.isDefined(mapUrl[code]) ? getModal(mapUrl[code], modalScope) : getModal(code, modalScope);
                modals.push(modal);
                modal.$scope.data = angular.isDefined(data) ? data : {};
                modal.$scope.$on('modal.hide', function() {
                    if (modal.$scope) {
                        deferred.resolve({
                            code: code,
                            result: angular.isDefined(modal.$scope.result) ? modal.$scope.result : modal.$scope.data
                        });
                    } else {
                        deferred.reject({
                            code: code,
                            reason: 'hidden'
                        });
                    }
                });
                modal.$scope.$on('modal.show', function(event) {});
                modal.$promise.then(modal.show);
                return deferred.promise;
            }

            //////////////////////////////////////////////////
            // templateUrl is compulsary..
            // scope if not sent rootScope will be taken.
            function getModal(templateUrl, scope, isEscapeEnabled, code) {
                isEscapeEnabled = !!isEscapeEnabled;
                //var uiViewElement = document.getElementsByClassName('main-ui-view');
                var modal = $modal({
                    templateUrl: templateUrl,
                    scope: angular.isDefined(scope) ? scope : $rootScope,
                    placement: 'center',
                    backdrop: 'static',
                    container: 'body',
                    keyboard: isEscapeEnabled,
                    show: false,
                    onShow: function() {
                        $window.sessionStorage.setItem(code + "_modal_isOpened", true);
                        angular.element(document.body).on('keydown', function(e) {
                            if (e.keyCode == 9) {
                                e.preventDefault();
                            }
                        });
                        //=========== Blur effect added from ui-view [Start] ================
                        //angular.element(document.querySelector('.main-ui-view')).addClass('modal-overlay');
                        //uiViewElement.className = 'modal-overlay main-ui-view';
                        //=========== Blur effect added from ui-view [End] ================
                    },
                    onHide: function() {
                        $window.sessionStorage.setItem(code + "_modal_isOpened", false);
                        modals.pop();
                        if (modals.length == 0)
                            angular.element(document.body).unbind('keydown');
                        //=========== Blur effect removed from ui-view [Start] ================
                        // angular.element(document.querySelector('.main-ui-view')).removeClass('modal-overlay');
                        //if (modals.length == 0)
                        //    uiViewElement.className = 'main-ui-view';
                        //=========== Blur effect removed from ui-view [End] ================
                    }
                });
                modal.$scope.$on('closeModals', function() {
                    modal.$scope.$hide();
                });
                return modal;
            }

            ////////////////
            //code => code can be the key which refers to a template url,
            //code => code can also be templateUrl,
            //data => data can be any thing(string, json, numeric) which can be passed to the respective modal controller
            //scope => scope will be send only when the modal has to be created in the same scope.default rootScope.
            function showModal(code, data, scope, isEscapeEnabled) {
                var modalScope = angular.isDefined(scope) ? scope : $rootScope,
                    modal = angular.isDefined(mapUrl[code]) ? getModal(mapUrl[code], modalScope, isEscapeEnabled, code) : getModal(code, modalScope, isEscapeEnabled, code);
                modal.$id = code;
                modal.$scope.data = data;
                modal.$promise.then(modal.show);
                modals.push(modal);
                return modal;
            }

            function closeModal(code) {
                var deferred = $q.defer(),
                    modal = _.find(modals, function(modal) {
                    return modal.$id === code;
                });
                modal && modal.destroy();
                $timeout(function(){
                    deferred.resolve(modal);
                },500);
                return deferred.promise;
            }

            function closeAllModals() {
                //=========== Blur effect removed from ui-view [Start] ================
                //var ele = document.getElementsByClassName('main-ui-view')[0];
                //if(ele){
                //    ele.className = 'main-ui-view';
                //}
                //=========== Blur effect removed from ui-view [End] ================
                if (modals.length) {
                    angular.forEach(modals, function(modal) {
                        if (modal)
                            modal.destroy();
                    });
                }
            }
        }
    })();

(function() {
    'use strict';

    angular
        .module('OnlineAssessmentAngular')
        .factory('modalService', modalService);

    function modalService($uibModal, assessmentUtility, $injector) {
        var mapUrl = {
            optGrpTemplate: 'app/template/modal/modal.optionalGroups.html',
            notificationTemplate: 'app/template/modal/modal.notification.html',
            newNotificationTemplate: 'app/assessment/proctor.tpl.html',
            provideAliasTemplate: 'app/template/modal/modal.alias.html',
            userChoiceGroupTemplate: 'app/template/modal/modal.userChoiceGroup.html',
            generateAnswerKey: 'app/template/modal/modal.generateKey.html',
            optionalGroupsPreviewTemplate: 'app/template/modal/modal.optionalPreview.html',
            nextTestNotificationTemplate: 'app/template/modal/modal.nextTestNotification.html',
            provideTestSecurityKey: 'app/template/modal/modal.securityKey.html',
            alertTemplate: 'app/template/modal/modal.alert.html',
            proctorCompatibility: 'app/template/modal/modal.proctorCompatibility.html',
            provideEmailTemplate: 'app/template/modal/modal.candidateEmail.tpl.html',
            link:'app/template/modal/modal.link.html'
        };
        var service = {
            showModal: showModal
        };
        return service;

        function showModal(modalOpt) {
            // template, data, headingStr, isActionEnable, isOkEnable, isCancelEnable, backdropCss, errorMessage, buttonNameObj, styleProp, callback, onlyOptional, isOptionalPreviewEnable, optionalPreviewtime, isAlert
            // var requestObj = { 'template': modalOpt.template, 'data': modalOpt.data, 'headingStr': modalOpt.headingStr, 'isActionEnable': modalOpt.isActionEnable, 'isOkEnable': modalOpt.isOkEnable, 'isCancelEnable': modalOpt.isCancelEnable, 'backdropCss': modalOpt.backdropCss, 'errorMessage': modalOpt.errorMessage, 'buttonNameObj': modalOpt.buttonNameObj, 'styleProp': modalOpt.styleProp, 'callback': modalOpt.callback, 'onlyOptional': modalOpt.onlyOptional, 'isOptionalPreviewEnable': modalOpt.isOptionalPreviewEnable, 'optionalPreviewtime': modalOpt.optionalPreviewtime, 'isAlert': modalOpt.isAlert };

            var modalOption = {
                animation: false,
                backdrop: 'static',
                keyboard: false,
                ariaLabelledBy: 'modal-title',
                ariaDescribedBy: 'modal-body',
                windowClass: modalOpt.backdropCss ? modalOpt.backdropCss : 'notification',
                templateUrl: mapUrl[modalOpt.template],
                controller: modalController,
                controllerAs: 'vm'
            };

            if(modalOpt.scope){
                modalOption.scope = modalOpt.scope;
            }

            function getUcIsAllMandatoryGrpSelectionStat(grps, selectedGroups) {
                var ucIsAllMandatoryGrpSelected = true;
                var mandatGrpIds = _.map(_.filter(grps, function(grp) {
                    if (grp.isMandat) {
                        return grp;
                    }
                }), 'gpId');
                if (mandatGrpIds && mandatGrpIds.length > 0 && selectedGroups && selectedGroups.length > 0) {
                    _.forEach(mandatGrpIds, function(gpId) {
                        var isAlreadyAdded = getIsAlreadyAddedStat(selectedGroups, gpId);
                        if (isAlreadyAdded === -1) {
                            ucIsAllMandatoryGrpSelected = false;
                        }
                    });
                } else {
                    ucIsAllMandatoryGrpSelected = false;
                }
                return ucIsAllMandatoryGrpSelected;
            }

            function getIsAlreadyAddedStat(selectedGroups, gpId) {
                return _.findIndex(selectedGroups, function(selectedGpId) {
                    return parseInt(selectedGpId) == gpId;
                });
            }


            modalController.$inject = ['$uibModalInstance', '$rootScope'];

            function modalController($uibModalInstance, $rootScope) {
                /* jshint validthis: true */
                var vm = this;
                //===================== Set ok/cancel button name ==========================
                vm.ok = 'Ok';
                vm.cancel = 'Cancel';
                if (modalOpt.buttonNameObj) {
                    vm.ok = modalOpt.buttonNameObj.ok;
                    vm.cancel = modalOpt.buttonNameObj.cancel;
                }
                //===========================================================================

                //================= Cancel other modals =====================================
                if (!modalOpt.isAlert && $rootScope.uibModalInstance) {
                    $rootScope.uibModalInstance.dismiss();
                }
                //===========================================================================

                //===================== header text in case of optional groups ==============
                if (!modalOpt.headingStr && modalOpt.template === "optGrpTemplate") {
                    modalOpt.headingStr = "Choose Group";
                }
                //===========================================================================

                //================ GE .......userChoiceGroupTemplate ========================
                if (modalOpt.template === "userChoiceGroupTemplate") {
                    var colors = ["rgba(0, 0, 0, 0.3)", "rgba(239, 95, 19, 0.42)", "rgba(19, 173, 239, 0.42)", "rgba(9, 123, 46, 0.42)", "rgba(228, 148, 18, 0.42)", "rgba(228, 42, 18, 0.42)", "rgba(18, 127, 228, 0.42)", "rgba(11, 171, 124, 0.42)", "rgba(228, 18, 43, 0.42)", "rgba(51, 122, 183, 0.592157)", "rgba(51, 122, 183, 0.59)", "rgba(19, 173, 239, 0.419608)", "rgba(239, 95, 19, 0.419608)", "rgba(0, 0, 0, 0.298039)"]; //["rgba(51, 122, 183, 0.592157)","rgba(51, 122, 183, 0.59)","rgba(19, 173, 239, 0.419608)","rgba(239, 95, 19, 0.419608)","rgba(0, 0, 0, 0.298039)"];
                    vm.items = _.flatMap(data, function(item) {
                        // item.groups.color = colors[Math.floor(Math.random()*colors.length)];
                        return _.map(item.groups, function(grp) {
                            grp.color = colors[Math.floor(Math.random() * colors.length)];
                            return grp;
                        });
                    });
                    var selectedGroups = assessmentUtility.localStorage.getData("selectedOptionalGroupIdCollection");
                    vm.addGroup = function(gpId, isMandat) {
                        var isAlreadyAdded = -1;
                        if (isMandat === false) {
                            var ucIsAllMandatoryGrpSelected = getUcIsAllMandatoryGrpSelectionStat(vm.items, selectedGroups);
                            if (!ucIsAllMandatoryGrpSelected) {
                                return false;
                            }
                        }
                        if (selectedGroups && selectedGroups.length > 0) {
                            isAlreadyAdded = getIsAlreadyAddedStat(selectedGroups, gpId);
                        }
                        if (selectedGroups && isAlreadyAdded > -1) {
                            return false;
                        }
                        $uibModalInstance.close(gpId);
                    };
                    vm.showGroup = function(gpId, isMandatGrp) {
                        var isAlreadyAdded = -1;
                        if (selectedGroups && selectedGroups.length > 0) {
                            isAlreadyAdded = getIsAlreadyAddedStat(selectedGroups, gpId);
                        }
                        var currentGrp = _.find(vm.items, { 'gpId': gpId });
                        //if (isAlreadyAdded === -1) {
                        return isMandatGrp ? currentGrp.isMandat : !currentGrp.isMandat;
                        //}
                        //return false;
                    };
                    vm.getDisabilityStat = function(gpId, isOptional) {
                        var isAlreadyAdded = -1;
                        if (selectedGroups && selectedGroups.length > 0) {
                            isAlreadyAdded = getIsAlreadyAddedStat(selectedGroups, gpId);
                        }
                        if (isOptional) {
                            var ucIsAllMandatoryGrpSelected = assessmentUtility.localStorage.getData("ucIsAllMandatoryGrpSelected");
                            if (!selectedGroups) {
                                return true;
                            } else if (!ucIsAllMandatoryGrpSelected) {
                                ucIsAllMandatoryGrpSelected = getUcIsAllMandatoryGrpSelectionStat(vm.items, selectedGroups);
                                if (!ucIsAllMandatoryGrpSelected) {
                                    return true;
                                } else {
                                    assessmentUtility.localStorage.setData("ucIsAllMandatoryGrpSelected", true);
                                }
                            }
                        }
                        return isAlreadyAdded > -1;
                    };
                    vm.getLockingStat = function() {
                        var lockingStat = assessmentUtility.localStorage.getData("ucIsAllMandatoryGrpSelected");
                        return !lockingStat;
                    };
                } else {
                    vm.items = modalOpt.data;
                }
                //===========================================================================

                //===================== Notification style setting ==============
                vm.styleProp = {};
                if (modalOpt.template === "notificationTemplate" && modalOpt.styleProp) {
                    vm.styleProp.maxHeight = modalOpt.styleProp.maxHeight ? modalOpt.styleProp.maxHeight : '400px';
                    if (modalOpt.styleProp.template && modalOpt.styleProp.template === 'proctorCompatibilitytestPage') {
                        vm.styleProp = {};
                    }
                    vm.styleProp.padding = modalOpt.styleProp.padding ? modalOpt.styleProp.padding : '15px 15px 5px 15px';
                }
                //===========================================================================

                //========================Modal header/error==================================
                //vm.items = data;
                vm.heading = modalOpt.headingStr;
                vm.errorMessage = modalOpt.errorMessage;
                //===========================================================================

                if (sessionStorage.hasproctorfacetrackingstarted === 'true') {
                    vm.message = 'Ensure your face is within box and there is adequate light on your face.';
                    if (document.getElementById('okBtnModalNotification')) {
                        document.getElementById('okBtnModalNotification').style.display = 'none';
                    }
                }

                //===========================================================================

                //========================Action Button settings=============================
                vm.isActionEnable = modalOpt.isActionEnable === false ? modalOpt.isActionEnable : true;
                vm.isOkEnable = modalOpt.isOkEnable === false ? modalOpt.isOkEnable : true;
                vm.isCancelEnable = modalOpt.isCancelEnable === false ? modalOpt.isCancelEnable : true;
                vm.onOk = function() {
                    if (!vm.data && modalOpt.template === "optGrpTemplate") {
                        vm.errorMessage = "Please select any group!";
                        return;
                    }
                    if (modalOpt.template === "optionalGroupsPreviewTemplate") {
                        assessmentUtility.stopWatch.stop(null, null, "optionalPreview");
                    }
                    if (modalOpt.template === "generateAnswerKey") {
                        $injector.get('assessmentService').handleTestSubmission(false, true);
                        return;
                    }
                    if (!vm.data && modalOpt.template === 'provideTestSecurityKey') {
                        vm.errorMessage = "Please provide Test Password!";
                        return;
                    }
                    $uibModalInstance.close(vm.data);
                };
                vm.close = function() {
                    $uibModalInstance.dismiss('cancel');
                };
                //===========================================================================
                
                //========================Optional group preview=============================
                vm.isPreviewEnable = modalOpt.isOptionalPreviewEnable;
                vm.optionalPreviewtime = parseInt(modalOpt.optionalPreviewtime);
                if (vm.isPreviewEnable && modalOpt.template === "optGrpTemplate") {
                    vm.isOptionalPreviewTimeOver = assessmentUtility.localStorage.getData("isOptionalPreviewTimeOver");
                    if (vm.isOptionalPreviewTimeOver !== true) {
                        vm.isOptionalPreviewTimeOver = false;
                    }
                }
                vm.previewOptionalGroups = function() {
                    modalOpt.optionalPreviewtime = modalOpt.optionalPreviewtime;
                    modalOpt.callback(vm.items, modalOpt);
                };
                if (modalOpt.template === "optionalGroupsPreviewTemplate") {
                    vm.grpInfo = vm.items[0];
                    vm.selectedGrpId = vm.items[0].gpId;
                }
                vm.setGroup = function(grpId) {
                    angular.element(document.querySelector('.group-info-questions'))[0].scrollTop = 0;
                    vm.grpInfo = _.filter(vm.items, { 'gpId': grpId })[0];
                    vm.selectedGrpId = grpId;
                };
                //===========================================================================
                $rootScope.uibModalInstance = $uibModalInstance;
            }
            return $uibModal.open(modalOption).result;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('OnlineAssessmentAngular')
        .factory("mediaRecorder", mediaRecorderService);

    mediaRecorderService.$inject = [
        '$q',
        '$log',
        '$interval',
        'blockUI',
        'commonService',
        'assessmentUtility',
        '$rootScope'
    ];

    function mediaRecorderService($q, $log, $interval, blockUI, commonService, assessmentUtility, $rootScope) {
        var service = {
            localVar: {
                startTime: null,
                mediaStream: null,
                mediaRecorder: null,
                recordedMediaChunks: [],
                startDeferred: null,
                stopDeferred: null,
                param: null,
                uploadIntervalObj: null,
                uploadInterval: 2, //in seconds
                stopIntervalObj: null,
                stopInterval: 1, //in seconds
                requestQ: [],
                isFinalStopCall: false,
                isMediaRecorderStarted: false,
                mediaRecorderBlobType: "video/webm",
                videoUplodedDeferred: null
            },
            cnf: {
                fileExtentions: ".gif,.png,.jpg,.jpeg,.doc,.docx," +
                    ".rtf,.pdf,.txt,.xls,.xlsx,.zip,.rar,.7z,.gz,.ppt,.pps,.pptx,.mp4,.mvw,.3gp,.webm",
                fileSizeLimit: 102400
            },
            start: startRecorder,
            stop: stopRecorder,
            mediaUploader: {
                stat: 'not initiated',
                pushRqToQ: function(rq) {
                    var self = this,
                        sl = service.localVar,
                        rqQindex = -1;
                    /*if (!rq || self.stat === "finallyStopped") {
                        return rqQindex;
                    }*/
                    rqQindex = sl.requestQ.push({
                        'data': rq,
                        'param': sl.param,
                        'status': 'Queued'
                    });
                    if (!sl.uploadIntervalObj) {
                        self.init();
                    }
                    return rqQindex;
                },
                init: function() {
                    var self = this,
                        sl = service.localVar;
                    if (sl.uploadIntervalObj) {
                        return false;
                    } else {
                        self.stat = 'initiated';
                    }
                    sl.uploadIntervalObj = $interval(function() {
                        _.remove(sl.requestQ, { 'status': 'Success' });
                        if (_.size(sl.requestQ) > 0) {
                            //var rq = sl.requestQ.shift();
                            var rq = _.find(sl.requestQ, { 'status': 'Queued' });
                            if (_.size(rq) > 0) {
                                self.pushToS3(rq);
                            }
                        } else {
                            self.stop();
                        }
                    }, sl.uploadInterval * 1000);
                },
                stop: function(_isFinal) {
                    var self = this,
                        sl = service.localVar,
                        isFinal = !!_isFinal,
                        deferred = $q.defer();
                    sl.stat = isFinal ? 'finallyStopped' : 'temporaryStopped';
                    if (!sl.uploadIntervalObj) {
                        return $q.when({});
                    } else {
                        $interval.cancel(sl.uploadIntervalObj);
                        sl.uploadIntervalObj.catch(function() {
                            sl.uploadIntervalObj = null;
                            if (self.isAllPushed()) {
                                $log.log("MediaUploader stopped successfully");
                                deferred.resolve();
                                sl.videoUplodedDeferred.resolve();
                                sl.videoUplodedDeferred = null;
                            } else if (isFinal) {
                                self.waitForInprocessRq().then(function() {
                                    sl.stopIntervalObj = $interval(function() {
                                        var rq = _.find(sl.requestQ, { 'status': 'Queued' });
                                        if (_.size(rq) > 0) {
                                            self.pushToS3(rq);
                                        } else if (self.isAllPushed()) {
                                            self.kill(isFinal, deferred);
                                            sl.videoUplodedDeferred.resolve();
                                            sl.videoUplodedDeferred = null;
                                        }
                                    }, 500);
                                });
                            } else {
                                deferred.reject();
                            }
                        });
                    }
                    return deferred.promise;
                },
                kill: function(isFinal, deferred) {
                    var sl = service.localVar;
                    $interval.cancel(sl.stopIntervalObj);
                    sl.stopIntervalObj.catch(function() {
                        sl.stopIntervalObj = null;
                        $log.log("Media recorder stopped successfully.");
                        if (deferred) {
                            deferred.resolve();
                        }
                    });
                },
                isAllPushed: function() {
                    var sl = service.localVar;
                    return _.every(sl.requestQ, ['status', 'Success']);
                },
                waitForInprocessRq: function() {
                    var self = this,
                        inprocessIntervalObj = null;
                    return $q(function(resolve, reject) {
                        inprocessIntervalObj = $interval(function() {
                            if (!self.isAnyInProcess()) {
                                $interval.cancel(inprocessIntervalObj);
                                inprocessIntervalObj = null;
                                resolve();
                            }
                        }, 500);
                    });
                },
                isAnyInProcess: function() {
                    var sl = service.localVar;
                    return _.every(sl.requestQ, ['status', 'InProcess']);
                },
                uploadFile: function(_rq) {
                    var cnf = service.cnf,
                        _res = {
                            "data": {
                                "s3_url": _rq.s3_url
                            }
                        },
                        params = {
                            "data": _rq.data,
                            "fileExtentions": cnf.fileExtentions,
                            "fileSizeLimit": cnf.fileSizeLimit,
                            "meta": null,
                            "testId": _rq.param.testId,
                            "candidateId": _rq.param.candidateId,
                            "targetBucket": "recording-bucket"
                        };
                    if (_rq.type) {
                        params.type = _rq.type;
                    }
                    return _rq.s3_url ? $q.when(_res) : commonService.uploadFile(params);
                },
                pushToS3: function(rq) {
                    var self = this,
                        sl = service.localVar,
                        util = assessmentUtility,
                        isOnlinePreview = !!util.localStorage.getData(util.getAlias() + "_isOnlinePreview");
                    if (isOnlinePreview) {
                        return false;
                    }
                    rq.status = 'InProcess';
                    return self.uploadFile(rq)
                        .then(function(res) {
                            if (!res) {
                                return $q.reject("Unable to upload");
                            }
                            rq.status = 'Success';
                            rq.s3Url = res.data.s3_url;
                            rq.startTime = sl.startTime;
                            sl.videoUplodedDeferred.notify(rq);
                        })
                        .catch(function(res) {
                            if ((res && res.error && res.error.status) || (res && !res.error))  {
                                rq.status = 'Success';// server issue should not stop submitionof test or retry to upload.
                            } else {
                                rq.status = 'Queued';
                                $log.error(res.msg);
                                $log.error(res.error);
                            }
                        });
                }
            }
        };
        return service;
        /*............................Push to S3 Worker............................*/

        /*.........................................................................*/

        /*............................ .Start Recorder.............................*/
        /*
        param = {
            'vqId': vm.question.id,
            'vidElem': vidElem,
            'isAutoStart': isAutoStart,
            'durationInMins': video recording time,
            'candidateId': candidateId,
            'testId': testId,
            'sectionId': vm.question.scId,
            'isPartialSavingEnable': true,
            "MediaDeviceConstraints": { "audio": true },
            "MediaRecorderConstraints": {
                "audioBitsPerSecond": 16000,
                "mimeType": "audio/webm\;codecs=opus"
            },
            'procType': vm.question.id ? 'Video Question' : 'Sample Video'
        }*/
        function startRecorder(param) {
            var sl = service.localVar,
                startRecorderPromise = null;
            sl.fileName = param.fileName;
            sl.param = param;
            sl.isMediaRecorderStarted = true;
            return startSavingLocally(param);
        }

        function registerMediaRecorderEvents() {
            var sl = service.localVar,
                recordedBlob = null,
                recordedVidUrl = null;
            sl.mediaRecorder.onstart = function() {
                if (!sl.param.disableLoading) {
                    blockUI.stop();
                }
                sl.stopDeferred = null;
                sl.startDeferred.resolve({ 'strm': service.localVar.mediaStream });
            }
            sl.mediaRecorder.ondataavailable = function(e) {
                sl.recordedMediaChunks.push(e.data);
            }
            sl.mediaRecorder.onstop = function() {
                try {
                    sl.startDeferred = null
                    recordedBlob = new Blob(sl.recordedMediaChunks, { type: sl.mediaRecorderBlobType });
                    recordedVidUrl = URL.createObjectURL(recordedBlob);
                    uploadStream(recordedBlob);
                    sl.recordedMediaChunks.length = 0;
                    if (!sl.videoUplodedDeferred) {
                        sl.videoUplodedDeferred = $q.defer();
                    }
                    if (!sl.isFinalStopCall) {
                        sl.stopDeferred.resolve({ 'stat': true, 'url': recordedVidUrl, 'videoUplodedDeferred': sl.videoUplodedDeferred.promise, startTime: sl.startTime });
                    }
                    $log.info(recordedVidUrl);
                } catch (e) {
                    sl.stopDeferred.reject({ 'error': e });
                    $log.error(e);
                }
            }
            sl.mediaRecorder.onerror = function(event) {
                var error = event.error,
                    errmsg = null,
                    deferred = sl.startDeferred ? sl.startDeferred : sl.stopDeferred;
                sl.recordedMediaChunks.length = 0;
                switch (error.name) {
                    case 'InvalidStateError':
                        errmsg = "You can't record the video right now. Try again later.";
                        break;
                    case 'SecurityError':
                        errmsg = "Recording the specified source is not allowed due to security restrictions.";
                        break;
                    default:
                        errmsg = "A problem occurred while trying to record the video.";
                        break;
                }
                if (deferred) {
                    deferred.reject({ 'error': { 'msg': errmsg } });
                }
                $log.error(errmsg);
            }
        }

        function startSavingLocally(rqst) {
            var sl = service.localVar,
                constraints = {
                    audio: true,
                    video: {
                        width: { max: 320 },
                        height: { max: 240 }
                    }
                };
            if (!sl.param.disableLoading) {
                blockUI.start();
            }
            sl.startDeferred = $q.defer();
            if (rqst.MediaDeviceConstraints) {
                constraints = rqst.MediaDeviceConstraints;
                if (!rqst.MediaDeviceConstraints.video) {
                    sl.mediaRecorderBlobType = "audio/webm";
                }
            }
            getMediaStream(constraints)
                .then(function(strm) {
                    service.localVar.mediaStream = strm;
                    sl.startTime = new Date();
                    initiateLocalSaving(strm, rqst.MediaRecorderConstraints);
                })
                .catch(function(res) {
                    sl.startDeferred.reject(res);
                });
            return sl.startDeferred.promise;
        }

        function initiateLocalSaving(strm, MediaRecorderConstraints) {
            var sl = service.localVar,
                constraints = MediaRecorderConstraints ? MediaRecorderConstraints : { "mimeType": 'video/webm' };
            sl.mediaRecorder = new MediaRecorder(strm, constraints);
            registerMediaRecorderEvents();
            sl.mediaRecorder.start();
        }

        /*................................Stop Recorder.............................*/

        function stopRecorder(isFinalStopCall) {
            var sl = service.localVar,
                stopRecorderPromise = null;
            if (!sl.isMediaRecorderStarted) {
                return $q.when(null);
            }
            sl.isMediaRecorderStarted = false;
            sl.isFinalStopCall = isFinalStopCall;
            $rootScope.growlError && $rootScope.growlError.destroy();
            return stopSavingLocally();
        }

        function stopSavingLocally() {
            var sl = service.localVar;
            sl.stopDeferred = $q.defer();
            stopMediaStream(sl.mediaStream);
            sl.mediaRecorder.stop();
            return sl.stopDeferred.promise;
        }

        function uploadStream(recordedBlob) {

            if (!recordedBlob) {
                $log.log("No reorded media found!");
                return false;
            }
            var recordedMedia_formData = blobToFormData(recordedBlob);
            if (!recordedMedia_formData) {
                return false;
            }
            service.mediaUploader.pushRqToQ(recordedMedia_formData);
        }

        function blobToFormData(recordedBlob) {
            var fd = new FormData(),
                sl = service.localVar,
                fileName = sl.fileName ? sl.fileName : 'localVideo_' + new Date().getTime();
            fd.append("file", recordedBlob, fileName + '.webm');
            return fd;
        }

        /*................................Media stream.............................*/

        function getMediaStream(_constraints) {
            var constraints = _constraints ? _constraints : { audio: true, video: true };

            return navigator.mediaDevices.getUserMedia(constraints)
                .then(function(stream) {
                    if (!stream) {
                        return $q.reject("Unable to get media stream!");
                    }
                    return stream;
                })
                .catch(function(err) {
                    return $q.reject(err);
                });
        }

        function stopMediaStream(strm) {
            if (!strm) {
                $log.error("Stream not found!");
                return false;
            }
            var trks = strm.getTracks();
            if (_.size(trks) === 0) {
                $log.error("No tracks found!");
                return false;
            }
            _.forEach(trks, function(trk) {
                if (trk) {
                    trk.stop();
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module("OnlineAssessmentAngular")
        .factory("loginService", loginService);

    loginService.$inject = ['$q', '$log', '$rootScope', 'webService', 'assessmentUtility', '$window', '$state', '$injector', 'deviceDetector', 'blockUI'];

    function loginService($q, $log, $rootScope, webService, assessmentUtility, $window, $state, $injector, deviceDetector, blockUI) {
        var service = {
                login: login,
                getTenantId: getTenantId,
                getLoginInfo: getLoginInfo,
                setLoginInfo: setLoginInfo,
                setLoginConfig: setLoginConfig,
                getTestSecurityKeyEncryptString: getTestSecurityKeyEncryptString,
                getCompanyInfo: getCompanyInfo,
                applyTenantSpecificTheme: applyTenantSpecificTheme,
                getCandidateDetails: getCandidateDetails,
                getNextTestInfo: getNextTestInfo
            },
            isSecureBrowserMandatory = false,
            MACAddress = 'dummy';
        return service;

        function login(loginToTestRequest, isOnlinePreview) {
            if (!isOnlinePreview) {
                // assessmentUtility.cookies.clear('X-AUTH-TOKEN');
                sessionStorage.removeItem('X-AUTH-TOKEN');
            }
            return loginToTest(loginToTestRequest, isOnlinePreview)
                .then(function(loginInfo) {
                    if (loginInfo && loginInfo.Config && loginInfo.Config.isSecureBrowserMandatory) {
                        isSecureBrowserMandatory = loginInfo.Config.isSecureBrowserMandatory ? true : false;
                        console.log(deviceDetector.os);
                        return ((deviceDetector.os === 'mac') ?
                                $q.when(startSEBSecureKeyWatch()) : $q.when(initMacSocket()))
                            .then(function() {
                                return loginInfo;
                            });

                    } else {
                        return loginInfo;
                    }
                });
        }

        function getTenantId() {
            return $window.sessionStorage.getItem('_tId');
        }

        function getLoginInfo() {
            var loginInfo = assessmentUtility.localStorage.getData('TestLoginInformation');
            if (!loginInfo) {
                loginInfo = assessmentUtility.sessionStorage.getData('TestLoginInformation');
            }
            return loginInfo;
        }

        function setLoginInfo(inf) {
            var loginInfo = getLoginInfo();
            if (!loginInfo) {
                return false;
            }
            _.merge(loginInfo, inf);
            /// ======================== nseit hardcode changes [start] ===================== ///
            // if (sessionStorage.isNseitTenant) {
            //     loginInfo.Config.thirdPartyTestType = 'nseit';
            // }
            /// ======================== nseit hardcode changes [ends] ===================== ///
            assessmentUtility.localStorage.setData('TestLoginInformation', loginInfo);
            assessmentUtility.sessionStorage.setData('TestLoginInformation', loginInfo);
            if (loginInfo && loginInfo.Config && loginInfo.Config.thirdPartyTestType) {
                sessionStorage.setItem('typeOfTest', loginInfo.Config.thirdPartyTestType);
            }
            return loginInfo;
        }

        function setLoginConfig(cnf) {
            var loginInfo = getLoginInfo();
            if (!loginInfo) {
                return false;
            }
            loginInfo.Config = loginInfo.Config || {};
            _.merge(loginInfo.Config, cnf);
            assessmentUtility.localStorage.setData('TestLoginInformation', loginInfo);
            assessmentUtility.sessionStorage.setData('TestLoginInformation', loginInfo);
            if (loginInfo && loginInfo.Config && loginInfo.Config.thirdPartyTestType) {
                sessionStorage.setItem('typeOfTest', loginInfo.Config.thirdPartyTestType);
            }
            return loginInfo.Config;
        }

        function getTestSecurityKeyEncryptString(inputKey) {
            return webService.execute("GetTestSecurityKeyEncryptString", { 'securityKey': inputKey }, 'POST').then(
                function(response) {
                    return response;
                },
                function(response) {
                    $log.log('error');
                    return null;
                }
            );
        }

        function getCandidateDetails() {
            var loginInfo = getLoginInfo(),
                request = {
                    'testId': parseInt(loginInfo.TestId),
                    'candidateId': parseInt(loginInfo.CandidateId)
                };
            return webService.execute("GetCandidateDetails", request)
                .then(function(res) {
                        if (!res || res.status === "KO" || !res.data || !res.data.data) {
                            return $q.reject(res);
                        }
                        res = res.data.data;
                        return res.testUserBasicInfo;
                    },
                    function(res) {
                        $log.log(res);
                        return null;
                    }
                );
            // var data = {
            //     candidatePhoto: 'https://s3-ap-southeast-1.amazonaws.com/test-all-hirepro-files/AT/candidateFiles/cb2e88b1-695d-440b-9cea-6b192327e28dat.jpeg',
            //     candidateId: 12345,
            //     name: 'Student',
            //     email: 'qwe@dsad.cdff',
            //     mobile: 1231231233,
            //     usn: 3321123,
            //     dob: '12/12/12',
            //     gender: 'Male',
            //     college: 'qwe cmfjrj',
            //     degree: 'asde erece'
            // };
            // return $q.when(data);
        }

        function getCompanyInfo(alias) {
            return webService.execute("GetCompanyInfo", {}, 'GET', '', { 'T-ALIAS': alias }).then(
                function(res) {
                    if (!res || !res.data || res.data.status !== "OK") {
                        return $q.reject({ 'msg': 'not able to fetch company info.' });
                    }
                    res = res.data;
                    if (res.tenantId) {
                        $window.sessionStorage.setItem('_tId', res.tenantId);
                    }
                    $rootScope.companyLogoUrl = null;
                    sessionStorage.isEuTenant = res.isEuTenant;
                    sessionStorage.isPy3Tenant = res.isPy3Tenant === 0 || res.isPy3Tenant === false ? false : true;
                    if (res.content) {
                        $rootScope.companyLogoUrl = res.content.logoUrl;
                        if (!$rootScope.companyLogoUrl && res.content.CompanyLogo) {
                            $rootScope.companyLogoUrl = "/amsweb/App_Themes/Client/" + alias + "/images/" + res.content.CompanyLogo;
                        }
                        if (location.hostname === "localhost" || location.port != "") {
                            $rootScope.companyLogoUrl = "assets/images/hirepro_logo.png";
                        }
                        if (res.content.theme) {
                            $window.sessionStorage.setItem('tenantSpecificTheme', JSON.stringify(res.content.theme));
                        }
                        if (res.content.privacyPolicy) {
                            sessionStorage.privacyPolicy = res.content.privacyPolicy;
                        }
                        if (res.content.isNseitTenant) {
                            sessionStorage.isNseitTenant = true;
                        }
                        if (res.content.hideTermsAndConditions) {
                            sessionStorage.hideTermsAndConditions = true;
                        } else {
                            sessionStorage.hideTermsAndConditions = false;
                        }
                        /*if (res.content.hideTermsAndConditionsInSEB) {
                            sessionStorage.hideTermsAndConditionsInSEB = true;
                        }*/
                        applyTenantSpecificTheme();
                    }
                    if (res.branding && res.branding.logoUrl) {
                        $rootScope.companyLogoUrl = res.branding.logoUrl;
                    }
                    return res;
                },
                function(response) {
                    $log.log(response);
                    return ({ 'msg': 'not able to fetch tenant info.' });
                }
            );
        }

        function applyTenantSpecificTheme() {
            var backgroundColor_hex = "#292947",
                backgroundColor_rgb = "41,41,71",
                borderColor_hex = "#292947",
                appInstructionTextColor = "#cccccc",
                termsAndCondition = "#60C0DE",
                startTestBtn_color = "#ffffff",
                startTestBtn_bgcolor = "#55abdd",
                startTestBtn_bgcolor_hover = "#2a96d5",
                theme = $window.sessionStorage.getItem('tenantSpecificTheme'),
                thm = null;
            if (theme) {
                thm = JSON.parse(theme);
                backgroundColor_hex = thm.background ? thm.background : backgroundColor_hex;
                borderColor_hex = thm.border ? thm.border : borderColor_hex;
                appInstructionTextColor = thm.appInstructionText ? thm.appInstructionText : appInstructionTextColor;
                termsAndCondition = thm.termsAndCondition ? thm.termsAndCondition : termsAndCondition;
                if (thm.background) {
                    backgroundColor_rgb = assessmentUtility.color.hexToRgb(thm.background);
                }
                if (thm.startTestBtn) {
                    startTestBtn_color = thm.startTestBtn.color ?
                        thm.startTestBtn.color :
                        startTestBtn_color;
                    startTestBtn_bgcolor = thm.startTestBtn.background_color ?
                        thm.startTestBtn.background_color :
                        startTestBtn_bgcolor;
                    startTestBtn_bgcolor_hover = thm.startTestBtn.background_color_hover ?
                        thm.startTestBtn.background_color_hover :
                        startTestBtn_bgcolor_hover;
                }
                document.documentElement.style.setProperty('--themeHEX_background', backgroundColor_hex);
                document.documentElement.style.setProperty('--themeRGBA_background', backgroundColor_rgb);
                document.documentElement.style.setProperty('--themeHEX_border', borderColor_hex);
                document.documentElement.style.setProperty('--appInstructionTextColor', appInstructionTextColor);
                document.documentElement.style.setProperty('--termsAndCondition', termsAndCondition);
                document.documentElement.style.setProperty('--startTestBtn_color', startTestBtn_color);
                document.documentElement.style.setProperty('--startTestBtn_bgcolor', startTestBtn_bgcolor);
                document.documentElement.style.setProperty('--startTestBtn_bgcolor_hover', startTestBtn_bgcolor_hover);
            }
        }

        function loginToTest(loginToTestRequest, isOnlinePreview) {
            assessmentUtility.localStorage.setData('isQuestionVideoStarted', false);
            var loginInfo = null;
            return webService.execute("LoginToTest", loginToTestRequest, 'POST').then(
                function(response) {
                    if (!response || !response.data) {
                        $log.error("Unable to fetch login info!");
                        return null;
                    }
                    loginInfo = response.data;
                    if (!loginInfo || loginInfo.status === "KO" || loginInfo.statusCode !== 200) {
                        loginInfo.IsException = true;
                        return loginInfo;
                    }
                    if (isOnlinePreview) {
                        loginInfo.CandidateId = -1;
                    }
                    /*.......Save data to LocalStorage........*/
                    loginInfo.testUserId = loginToTestRequest.LoginName;
                    /*This code should be removed after DB migration*/
                    loginInfo = transformLoginInfo(loginInfo);
                    /// ======================== nseit hardcode changes [start] ===================== ///
                    // if (sessionStorage.isNseitTenant) {
                    //     loginInfo.Config.thirdPartyTestType = 'nseit';
                    // }
                    /// ======================== nseit hardcode changes [ends] ===================== ///
                    assessmentUtility.localStorage.setData('TestLoginInformation', loginInfo);
                    assessmentUtility.sessionStorage.setData('TestLoginInformation', loginInfo);
                    if (loginInfo && loginInfo.Config && loginInfo.Config.thirdPartyTestType) {
                        sessionStorage.setItem('typeOfTest', loginInfo.Config.thirdPartyTestType);
                    }
                    if (loginInfo.assessmentConfig && loginInfo.assessmentConfig.consolelog && loginInfo.assessmentConfig.consolelog.enabled) {
                        if (!loginInfo.assessmentConfig.consolelog.testType || loginInfo.assessmentConfig.consolelog.testType === 'all') {
                            sessionStorage.consolelogEnabled = true;
                        } else {
                            var types = loginInfo.assessmentConfig.consolelog.testType.split(',');
                            if (types.indexOf(sessionStorage.typeOfTest) > -1) {
                                sessionStorage.consolelogEnabled = true;
                            }
                        }
                        if (loginInfo.assessmentConfig.consolelog.donotshowinconsole) {
                            sessionStorage.donotshowinconsole = true;
                        }
                    }
                    if (!isOnlinePreview && loginInfo.Token) {
                        // assessmentUtility.cookies.set('X-AUTH-TOKEN', loginInfo.Token);
                        // assessmentUtility.cookies.set('OLD-X-AUTH-TOKEN', null);
                        sessionStorage.setItem('X-AUTH-TOKEN', loginInfo.Token);
                        sessionStorage.setItem('OLD-X-AUTH-TOKEN', '');
                    }
                    return loginInfo;
                },
                function(response) {
                    if (response) {
                        $log.error(response.data);
                        response.IsException = true;
                        response.error = {};
                        response.error.description = "Internal Server error!";
                    }
                    return response;
                }
            );
        }

        function transformLoginInfo(loginInfo) {
            loginInfo.Config = angular.fromJson(loginInfo.Config);
            if (loginInfo.Config) {
                if (loginInfo.Config.PreviewSecurityKey) {
                    loginInfo.Config.previewSecurityKey = loginInfo.Config.PreviewSecurityKey;
                }
                if (loginInfo.Config.TestSecurityKey) {
                    loginInfo.Config.testSecurityKey = loginInfo.Config.TestSecurityKey;
                }
                if (loginInfo.Config.IsAnsMandat) {
                    loginInfo.Config.isAnsMandt = loginInfo.Config.IsAnsMandat;
                }
                if (loginInfo.Config.madatGrpIds && !_.isArray(loginInfo.Config.madatGrpIds)) {
                    var strMadatGrpIds = loginInfo.Config.madatGrpIds.split(',');
                    var intMadatGrpIds = [];
                    for (var i = 0; i < strMadatGrpIds.length; i++) {
                        intMadatGrpIds[intMadatGrpIds.length] = parseInt(strMadatGrpIds[i]);
                    }
                    loginInfo.Config.madatGrpIds = intMadatGrpIds;
                }
                /*=====overriding the full screen view with test config=========*/
                if (_.has(loginInfo.Config, 'isLoadFullScreen') &&
                    !_.isNull(loginInfo.Config.isLoadFullScreen) &&
                    !_.isUndefined(loginInfo.Config.isLoadFullScreen)) {
                    console.log('test level isLoadFullScreen', loginInfo.Config.isLoadFullScreen);
                    console.log('Tenant level isLoadFullScreen', loginInfo.assessmentConfig.isLoadFullScreen);
                    loginInfo.assessmentConfig = _.merge(loginInfo.assessmentConfig, {
                        isLoadFullScreen: loginInfo.Config.isLoadFullScreen
                    });
                }
                /*========end overrinding===============================*/
                loginInfo.Config = _.merge(loginInfo.Config, checkForThirdPartyTestType(loginInfo.Config.thirdPartyTestType))
            }
            return loginInfo;
        }

        function getNextTestInfo(request) {
            return webService.execute("getNextTestInfo", request, 'POST');
        }

        function checkForThirdPartyTestType(thirdPartyTestType) {
            if (!thirdPartyTestType) {
                return {};
            }
            var isThirdPartyProctoringTestType = false,
                thirdPartyTestTypeInLowerCase = thirdPartyTestType.toLowerCase();
            if (thirdPartyTestType && (thirdPartyTestTypeInLowerCase === "thirdpartyproctoring")) {
                isThirdPartyProctoringTestType = true;
            }
            return {
                'isThirdPartyProctoringTestType': isThirdPartyProctoringTestType
            };
        }

        function startSEBSecureKeyWatch() {
            startLoading();
            const startTime = new Date();
            var secureEnvironmentInterval = setInterval(sebSecureKeyExists, 100),
                defer = $q.defer();

            function sebSecureKeyExists() {
                if (window && window.sebSecureVariable) {
                    //document.getElementsByClassName("mac-id")[0].innerHTML = Mac Address here on new page isis: ${window.sebSecureVariable};
                    //alert(`Mac Address here on new page in login service: ${window.sebSecureVariable}`);
                    assessmentUtility.sessionStorage.setData('MACAddress', window.sebSecureVariable);
                    clearInterval(secureEnvironmentInterval);
                    stopLoading();
                    defer.resolve({});
                } else {
                    if (((new Date() - startTime) / (1000 * 60)) > (1)) {
                        clearInterval(secureEnvironmentInterval);
                        redirectToMsgPage();
                    }
                }
            }
            return defer.promise;
        }

        function initMacSocket() {
            //alert('connecting to ws://127.0.0.1:8706');
            var macSocket = new WebSocket('ws://127.0.0.1:8706'),
                socketDefer = $q.defer();

            macSocket.onopen = function() {
                //alert('onopen');
                var request = {
                    Handler: 'MacAddress'
                };
                //alert(JSON.stringify(request));
                macSocket.send(JSON.stringify(request));
            };

            macSocket.onmessage = function(evt) {
                //alert('onmessage');
                //alert(JSON.stringify(evt.data));
                var result = JSON.parse(evt.data);
                //alert('onmessage-result');
                //alert(JSON.stringify(result));
                if (result) {
                    var loggerService = $injector.get("loggerService");
                    loggerService.push({
                        "canLoginActivityLog": {
                            "systemInformation": result
                        }
                    });
                }
                if (result && result.OnLineMacAddress) {
                    MACAddress = result.OnLineMacAddress;
                    assessmentUtility.sessionStorage.setData('MACAddress', MACAddress);
                    //sessionStorage.inSecureBrowserCurrently = true;
                    socketDefer.resolve({});
                } else if (isSecureBrowserMandatory) {
                    //alert("redirectToMsgPage entered onmessage");
                    redirectToMsgPage();
                }
                //alert('ommessage-address');
                //alert(result.OnLineMacAddress);
                macSocket.close();
            };

            macSocket.onerror = function(evt) {
                //alert('onerror');
                //alert(JSON.stringify(evt));
                console.log(evt);
                MACAddress = 'dummy';
                if (isSecureBrowserMandatory) {
                    //alert("redirectToMsgPage entered onerror");
                    redirectToMsgPage();
                }
            };
            return socketDefer.promise;
        }

        function redirectToMsgPage() {
            var msgStr = "Please take this test in secure browser !";
            var messageHtml = "<h2>" + msgStr + "</h2>";
            stopLoading();
            $state.go('msgPage', { stateParams: btoa(messageHtml) }, { location: 'replace', reload: true });
        }

        function startLoading() {
            blockUI.start();
        }

        function stopLoading() {
            blockUI.stop();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('OnlineAssessmentAngular')
        .factory('loggerService', loggerService)

    function loggerService($q, $log, $interval, webService, commonService) {

        var service = {
            localVar: {
                'logIntervalObj': null,
                'logPushingInterval': 3, //in seconds,
                'logPushingIntervalCounter': 0,
                'stopIntervalObj': null,
                'stopInterval': 1, //in seconds
                'requestQ': [],
                'isSync': true,
                'logPushingIntervalObj': {
                    'setloginstats': 300 //in seconds
                }
            },
            cnf: {
                'fileExtentions': ".gif,.png,.jpg,.jpeg,.doc,.docx,.rtf,.pdf,.txt,.xls," +
                    ".xlsx,.zip,.rar,.7z,.gz,.ppt,.pps,.pptx,.mp4,.mvw,.3gp",
                'fileSizeLimit': 5000
            },
            'stop': stop,
            'push': pushToRequestQueue,
            'stat': ''
        };
        return service;

        //rqObj:{} [Json Object]
        //rqObj.hvsLog.logPushingIntervalVal will contain positive int value to override log push interval 
        //options :{webServiceUrl:'setTestHistory','isImageLog':true/false}, which has attributes like isImageLog,webUrl
        //webServiceUrl: string,which is the requestUrl or keyMapping requestUrl
        //groupReqData:boolean [true:requestUrl accepts array of elements]
        //isImageLog: boolean [true:image will be saved to s3]
        //return type :: request index in queue
        //Everytime when rq is being pushed to queue
        //it will check loggerService is initialized or not
        //if it is not,it will initialized by calling init method
        function pushToRequestQueue(rqObj, options) {
            var self = this,
                sl = service.localVar,
                rqNotFound = -1,
                rqQindex = rqNotFound,
                logPushingIntervalVal = rqObj && rqObj.hvsLog && rqObj.hvsLog.logPushingIntervalVal ? rqObj.hvsLog.logPushingIntervalVal : 0,
                isImageLog = options && options.isImageLog ? true : false,
                webUrl = options && options.webServiceUrl ? options.webServiceUrl : "setloginstats",
                groupReqData = options && _.has(options, 'groupReqData') ? options.groupReqData : true;

            if (!rqObj || sl.stat === "finallyStopped") {
                return rqNotFound;
            }
            rqQindex = sl.requestQ.push({
                'data': rqObj,
                'isImageLog': isImageLog,
                'status': 'Queued',
                'webUrl': webUrl,
                'groupReqData': groupReqData,
                'logPushingIntervalVal': logPushingIntervalVal
            });
            if (!sl.logIntervalObj) {
                init();
            }
            return rqQindex;
        }

        //init is a private method
        //This method is setting an interval
        //after every interval it will remove all rq obj with {'status':'Success'} from request queue 
        //it will extract all available rq with {'status':'Queued'}
        //and will send to pushLog for further processing
        function init() {
            var sl = service.localVar,
                isFinal = false;
            /*checks for the url logpushingInterval is a factor of default 
            pushingInterval(logPushingInterval)*/
            _.forIn(sl.logPushingIntervalObj, function(value, key) {
                if ((value % (sl.logPushingInterval)) !== 0) {
                    alert(key + " url is a not satisfying pushlog time interval");
                }
            });
            if (sl.logIntervalObj) {
                return false;
            } else {
                sl.stat = 'initiated';
            }
            sl.logIntervalObj = $interval(function() {
                sl.logPushingIntervalCounter = sl.logPushingIntervalCounter + sl.logPushingInterval;
                //sl.isSync = true;
                _.remove(sl.requestQ, { 'status': 'Success' });
                if (_.size(sl.requestQ) > 0) {
                    //var rq = sl.requestQ.shift();
                    var rqs = getQueuedRqs(true);
                    if (_.size(rqs) > 0) {
                        pushLog(rqs);
                    }
                } else {
                    stop(isFinal);
                }
            }, sl.logPushingInterval * 1000);
        }

        //Return : Array
        //it will return all Queued(which is not sent to be logged/failed) 
        //rq from request queue
        function getQueuedRqs(filterWithPushingInterval) {
            var sl = service.localVar,
                rqs = null;
            if (filterWithPushingInterval) {
                rqs = _.transform(sl.requestQ, function(res, rq) {
                    if (_.get(rq, 'status') === 'Queued') {
                        if (_.has(sl.logPushingIntervalObj, rq.webUrl)) {
                            if (checkForIntervalCounterVal(rq)) {
                                res.push(rq);
                            }
                        } else {
                            res.push(rq);
                        }
                    }
                    return res;
                }, null);
            } else {
                rqs = _.filter(sl.requestQ, { 'status': 'Queued' });
            }
            return rqs;
        }

        //checks whether the weburl data has to be sent in the current interval or not
        function checkForIntervalCounterVal(req) {
            var sl = service.localVar,
                intervalVal = req && sl.logPushingIntervalObj[req.webUrl],
                changeLogPushingIntervalValue = sessionStorage.getItem('changeLogPushingIntervalValue');
            if (!changeLogPushingIntervalValue) {
                return true;
            }
            if (req && req.logPushingIntervalVal) {
                intervalVal = req.logPushingIntervalVal;
            }
            if (sl.logPushingIntervalCounter < intervalVal) {
                return false;
            }
            if (sl.logPushingIntervalCounter === intervalVal) {
                return true;
            }
            if (sl.logPushingIntervalCounter > intervalVal) {
                return ((sl.logPushingIntervalCounter % intervalVal) === 0) ? true : false;
            }
            return false;
        }
        //This method will stop loggerService by clearing the interval object
        //This method should be called before submit
        //Once this method is called,it will wait to stop service until all log is pushed
        function stop(_isFinal) {
            var sl = service.localVar,
                isFinal = !!_isFinal,
                deferred = $q.defer();
            //sl.isSync = !isFinal;
            sl.stat = isFinal ? 'finallyStopped' : 'temporaryStopped';
            if (!sl.logIntervalObj) {
                return $q.when({});
            } else {
                $interval.cancel(sl.logIntervalObj);
                sl.logIntervalObj.catch(function() {
                    sl.logIntervalObj = null;
                    if (isAllPushed()) {
                        $log.log("loggerService stopped successfully");
                        deferred.resolve();
                    } else if (isFinal) {
                        waitForInprocessRq().then(function() {
                            sl.stopIntervalObj = $interval(function() {
                                var rqs = getQueuedRqs();
                                if (_.size(rqs) > 0) {
                                    pushLog(rqs);
                                } else if (isAllPushed()) {
                                    kill(isFinal, deferred);
                                }
                            }, 500);
                        });
                    } else {
                        deferred.reject();
                    }
                });
            }
            return deferred.promise;
        }

        function waitForInprocessRq() {
            return $q(function(resolve, reject) {
                var inprocessIntervalObj = $interval(function() {
                    if (!isAnyInProcess()) {
                        $interval.cancel(inprocessIntervalObj);
                        inprocessIntervalObj = null;
                        resolve();
                    }
                }, 500);
            });
        }

        function kill(isFinal, deferred) {
            var sl = service.localVar;
            $interval.cancel(sl.stopIntervalObj);
            sl.stopIntervalObj.catch(function() {
                sl.stopIntervalObj = null;
                $log.log("loggerService stopped successfully");
                if (deferred) {
                    deferred.resolve();
                }
            });
        }

        function pushLog(rqs, isFinal) {
            var isOnlinePreview = false,
                otherLogObjs = null,
                imagLogObjs = null,
                imagLogObj = null,
                setLoginStatusObjs;
            if (!rqs) {
                return false;
            }
            isOnlinePreview = window.localStorage.getItem('_isOnlinePreview');
            if (isOnlinePreview == "true") {
                return false;
            }
            imagLogObjs = _.filter(rqs, { 'isImageLog': true });
            setLoginStatusObjs = _.filter(rqs, { 'isImageLog': false, 'groupReqData': true }) || [];
            otherLogObjs = _.filter(rqs, { 'isImageLog': false, 'groupReqData': false }) || [];
            if (_.size(imagLogObjs) > 0 && imagLogObjs[0]) {
                imagLogObj = imagLogObjs[0];
                imagLogObj.status = "InProcess";
                uploadImageToDB(imagLogObj);
            }
            if (_.size(setLoginStatusObjs) > 0) {
                setStatus(setLoginStatusObjs, "InProcess");
                callWebService(setLoginStatusObjs);
            }
            if (_.size(otherLogObjs) > 0) {
                var otherLogObj = otherLogObjs[0];
                otherLogObj.status = "InProcess";
                callWebService([otherLogObj], otherLogObj.webUrl);
            }

        }

        function callWebService(rqs, webUrl) {
            var data = rqs.length > 1 ? transformRequest(rqs) : rqs[0].data,
                webUrl = webUrl ? webUrl : "setloginstats";
            //tmStmp = new Date(),
            //sl = service.localVar;
            //data.isSync = sl.isSync;
            data.isSync = (rqs.length === 1);
            return webService.execute(webUrl, data).then(
                function(res) {
                    $log.log("Successfully Logged");
                    setStatus(rqs, "Success");
                },
                function(res) {
                    //appendFailureTmStmp(rqs, tmStmp);
                    setStatus(rqs, "Queued");
                    $log.error("Error occurred when pushing Log");
                }
            );
        }

        function transformRequest(rqs) {
            return _.transform(rqs, function(result, rq) {
                _.mapKeys(rq.data, function(v, k) {
                    _.isArray(v) ?
                        (result[k] || (result[k] = [])).concat(v) :
                        (result[k] || (result[k] = [])).push(v);
                });
                return result;
            }, {});
        }

        function setStatus(arr, status) {
            _.forEach(arr, function(obj) {
                obj.status = status;
            })
        }

        /*function appendFailureTmStmp(rqs, tmStmp) {
            _.forEach(rqs, function(rq) {
                _.forEach(rq.data, function(data) {
                    if (!data.tmStmp) data.tmStmp = [];
                    (data.tmStmp).push(tmStmp);
                });
            });
        }*/

        function isAllPushed() {
            var sl = service.localVar;
            return _.every(sl.requestQ, ['status', 'Success']) || _.size(sl.requestQ) === 0;
        }

        function isAnyInProcess() {
            var sl = service.localVar;
            return _.every(sl.requestQ, ['status', 'InProcess']);
        }

        /*........................Save Image Log............................*/
        function uploadImageToDB(rqstObj) {
            var cnf = service.cnf,
                sl = service.localVar,
                data = rqstObj.data,
                params = {
                    "data": data,
                    "fileExtentions": cnf.fileExtentions,
                    "fileSizeLimit": cnf.fileSizeLimit,
                    "meta": null,
                    "testId": sl.param.testId,
                    "candidateId": sl.param.candidateId,
                    "targetBucket": "rekognition-images"
                };
            return commonService.uploadFile(params)
                .then(function(res) {
                        if (!res.data) {
                            $log.error(res.msg);
                            return $q.reject();
                        }
                        $log.log("Successfully Logged");
                        rqstObj.status = "Success";
                    },
                    function(res) {
                        $log.error(res.msg);
                        $log.error(res.error);
                        $log.error("Error occurred when pushing Log");
                        rqstObj.status = "Queued";
                    });
        }
        /*.................................................................*/
    }
})();

/*******************************
File: WebRtc JS Wowza Publish
Author:csk@toprankers.com
Date: 21-March-2018
WebRTC - Playback
*******************************/

(function() {
    'use strict';

    angular
        .module('OnlineAssessmentAngular')
        .factory('liveStream', liveStream);

    function liveStream($q,$log) {
        var service = {
                start: start
            },
            config = {
                wsurl: 'wss://5a308835f271b.streamlock.net/webrtc-session.json',
                videoBitrate: 128,
                audioBitrate: 24,
                videoFrameRate: 15
            },
            objs = {},
            wsConnection = null,
            localVideo = null,
            remoteVideo = null,
            peerConnection = null,
            peerConnectionConfig = { 'iceServers': [] },
            localStream = null,
            streamInfo = { applicationName: "webrtc", streamName: "myStream", sessionId: "[empty]" },
            userData = { param1: "value1" },
            userAgent = null,
            newAPI = false,
            constraints = {
                video: true,
                audio: true
            };
        navigator.getUserMedia = navigator.getUserMedia || navigator.mozGetUserMedia || navigator.webkitGetUserMedia;
        window.RTCPeerConnection = window.RTCPeerConnection || window.mozRTCPeerConnection || window.webkitRTCPeerConnection;
        window.RTCIceCandidate = window.RTCIceCandidate || window.mozRTCIceCandidate || window.webkitRTCIceCandidate;
        window.RTCSessionDescription = window.RTCSessionDescription || window.mozRTCSessionDescription || window.webkitRTCSessionDescription;
        return service;

        function start(opts) {
            if (peerConnection === null) {
                if (opts) {
                    if (opts.stream) {
                        localStream = opts.stream;
                    }
                    if (opts.streamName) {
                        streamInfo.streamName = opts.streamName;
                    }

                }
                startPublisher();
            } else
                stopPublisher();
        }

        function wsConnect() {
            getStream().then(function() {
                wsConnection = new WebSocket(config.wsurl);
                wsConnection.binaryType = 'arraybuffer';
                wsConnection.onopen = function() {
                    $log.log('LiveStream' + "wsConnection.onopen");

                    peerConnection = new RTCPeerConnection(peerConnectionConfig);
                    peerConnection.onicecandidate = gotIceCandidate;

                    if (newAPI) {
                        var localTracks = localStream.getTracks();
                        for (localTrack in localTracks) {
                            peerConnection.addTrack(localTracks[localTrack], localStream);
                        }
                    } else {
                        peerConnection.addStream(localStream);
                    }

                    peerConnection.createOffer(gotDescription, errorHandler);
                };

                wsConnection.onmessage = function(evt) {
                    $log.log('LiveStream' + "wsConnection.onmessage: " + evt.data);

                    var msgJSON = JSON.parse(evt.data);

                    var msgStatus = Number(msgJSON.status);
                    var msgCommand = msgJSON.command;

                    if (msgStatus != 200) {
                        stopPublisher();
                    } else {
                        var sdpData = msgJSON['sdp'];
                        if (sdpData !== undefined) {
                            $log.log('LiveStream' + 'sdp: ' + msgJSON.sdp);

                            peerConnection.setRemoteDescription(new RTCSessionDescription(sdpData), function() {
                                //peerConnection.createAnswer(gotDescription, errorHandler);
                            }, errorHandler);
                        }

                        var iceCandidates = msgJSON.iceCandidates;
                        if (iceCandidates !== undefined) {
                            for (var index in iceCandidates) {
                                $log.log('LiveStream' + 'iceCandidates: ' + iceCandidates[index]);

                                peerConnection.addIceCandidate(new RTCIceCandidate(iceCandidates[index]));
                            }
                        }
                    }

                    if (wsConnection !== null)
                        wsConnection.close();
                    wsConnection = null;
                };

                wsConnection.onclose = function() {
                    $log.log('LiveStream' + "wsConnection.onclose");
                };

                wsConnection.onerror = function(evt) {
                    $log.log('LiveStream' + "wsConnection.onerror: " + JSON.stringify(evt));
                    stopPublisher();
                };
            });
        }

        function getStream() {
            var defer = $q.defer();
            if (localStream) {
                defer.resolve(localStream);
            } else if (navigator.mediaDevices.getUserMedia) {
                navigator.mediaDevices.getUserMedia(constraints).then(function(stream) {
                    $log.log('LiveStream' + "getUserMediaSuccess: " + stream);
                    localStream = stream;
                    defer.resolve(stream);
                }).catch(function(res) {
                    defer.reject(res);
                });
                newAPI = false;
            } else {
                defer.reject();
            }
            return defer.promise;
        }

        function startPublisher() {
            wsConnect();
        }

        function stopPublisher() {
            if (peerConnection != null)
                peerConnection.close();
            peerConnection = null;

            if (wsConnection != null)
                wsConnection.close();
            wsConnection = null;
            $log.log('LiveStream' + "stopPublisher");
        }

        function gotIceCandidate(event) {
            if (event.candidate != null) {
                $log.log('LiveStream' + 'gotIceCandidate: ' + JSON.stringify({ 'ice': event.candidate }));
            }
        }

        function gotDescription(description) {
            var enhanceData = new Object();

            enhanceData.audioBitrate = Number(config.audioBitrate);
            enhanceData.videoBitrate = Number(config.videoBitrate);
            enhanceData.videoFrameRate = Number(config.videoFrameRate);


            description.sdp = enhanceSDP(description.sdp, enhanceData);

            $log.log('LiveStream' + 'gotDescription: ' + JSON.stringify({ 'sdp': description }));

            peerConnection.setLocalDescription(description, function() {

                wsConnection.send('{"direction":"publish", "command":"sendOffer", "streamInfo":' + JSON.stringify(streamInfo) + ', "sdp":' + JSON.stringify(description) + ', "userData":' + JSON.stringify(userData) + '}');

            }, function() { $log.log('LiveStream' + 'set description error') });
        }

        function enhanceSDP(sdpStr, enhanceData) {
            var sdpLines = sdpStr.split(/\r\n/);
            var sdpSection = 'header';
            var hitMID = false;
            var sdpStrRet = '';

            for (var sdpIndex in sdpLines) {
                var sdpLine = sdpLines[sdpIndex];

                if (sdpLine.length <= 0)
                    continue;

                sdpStrRet += sdpLine;

                if (sdpLine.indexOf("m=audio") === 0) {
                    sdpSection = 'audio';
                    hitMID = false;
                } else if (sdpLine.indexOf("m=video") === 0) {
                    sdpSection = 'video';
                    hitMID = false;
                } else if (sdpLine.indexOf("a=rtpmap") == 0) {
                    sdpSection = 'bandwidth';
                    hitMID = false;
                }

                if (sdpLine.indexOf("a=mid:") === 0 || sdpLine.indexOf("a=rtpmap") == 0) {
                    if (!hitMID) {
                        if ('audio'.localeCompare(sdpSection) == 0) {
                            if (enhanceData.audioBitrate !== undefined) {
                                sdpStrRet += '\r\nb=CT:' + (enhanceData.audioBitrate);
                                sdpStrRet += '\r\nb=AS:' + (enhanceData.audioBitrate);
                            }
                            hitMID = true;
                        } else if ('video'.localeCompare(sdpSection) == 0) {
                            if (enhanceData.videoBitrate !== undefined) {
                                sdpStrRet += '\r\nb=CT:' + (enhanceData.videoBitrate);
                                sdpStrRet += '\r\nb=AS:' + (enhanceData.videoBitrate);
                                if (enhanceData.videoFrameRate !== undefined) {
                                    sdpStrRet += '\r\na=framerate:' + enhanceData.videoFrameRate;
                                }
                            }
                            hitMID = true;
                        } else if ('bandwidth'.localeCompare(sdpSection) == 0) {
                            var rtpmapID;
                            rtpmapID = getrtpMapID(sdpLine);
                            if (rtpmapID !== null) {
                                var match = rtpmapID[2].toLowerCase();
                                if (('vp9'.localeCompare(match) == 0) || ('vp8'.localeCompare(match) == 0) || ('h264'.localeCompare(match) == 0) ||
                                    ('red'.localeCompare(match) == 0) || ('ulpfec'.localeCompare(match) == 0) || ('rtx'.localeCompare(match) == 0)) {
                                    if (enhanceData.videoBitrate !== undefined) {
                                        sdpStrRet += '\r\na=fmtp:' + rtpmapID[1] + ' x-google-min-bitrate=' + (enhanceData.videoBitrate) + ';x-google-max-bitrate=' + (enhanceData.videoBitrate);
                                    }
                                }

                                if (('opus'.localeCompare(match) == 0) || ('isac'.localeCompare(match) == 0) || ('g722'.localeCompare(match) == 0) || ('pcmu'.localeCompare(match) == 0) ||
                                    ('pcma'.localeCompare(match) == 0) || ('cn'.localeCompare(match) == 0)) {
                                    if (enhanceData.audioBitrate !== undefined) {
                                        sdpStrRet += '\r\na=fmtp:' + rtpmapID[1] + ' x-google-min-bitrate=' + (enhanceData.audioBitrate) + ';x-google-max-bitrate=' + (enhanceData.audioBitrate);
                                    }
                                }
                            }
                        }
                    }
                }
                sdpStrRet += '\r\n';
            }
            return sdpStrRet;
        }

        function getrtpMapID(line) {
            var findid = new RegExp('a=rtpmap:(\\d+) (\\w+)/(\\d+)');
            var found = line.match(findid);
            return (found && found.length >= 3) ? found : null;
        }

        function errorHandler(error) {
            $log.log('LiveStream' + error);
        }
    }

})();

(function() {
    'use strict';
    angular
        .module("OnlineAssessmentAngular")
        .factory("imageTracker", imageTracker);

    imageTracker.$inject = [
        '$q',
        '$log',
        '$interval',
        '$timeout',
        'webService',
        'loginService',
        'commonService',
        'assessmentUtility',
        'faceRecognitionService'
    ];

    function imageTracker($q, $log, $interval, $timeout, webService, loginService, commonService, assessmentUtility, faceRecognitionService) {
        var service = {
            start: start,
            stop: stop,
            saveImageToS3: saveImageToS3,
            saveImage: saveImage,
            updateStream: updateStream,
            slowNetworkImageCreation: slowNetworkImageCreation,
            config: {
                loggingIntervalObj: null,
                timeInterval: 120, // in seconds...
                imageTrackingBufferInterval: 15,
                faceCountTimeOutCounter: 0,
                canvas: null,
                callBack: null,
                videoElement: null,
                chkReadystateMxtm: 100, // in seconds...
                checkingTimeCount: 0, // in seconds...
                fileExtentions: ".gif,.png,.jpg,.jpeg,.doc,.docx,.rtf,.pdf,.txt,.xls,.xlsx,.zip,.rar,.7z,.gz,.ppt,.pps,.pptx,.mp4,.mvw,.3gp,.ogg",
                fileSizeLimit: 5000,
                loginInfo: null,
                testId: -1,
                candidateId: -1,
                meta: null,
                isStreamAvail: false,
                timeDiff: null,
                qId: null,
                imgCaptureCount: 0,
                newTimeInterval: null
            },
            getImage: getImage
        };
        return service;
        //options:{
        //   videoElementId,   (default element id:'faceTracVid')
        //   isTimeIntervalRequired,  (true/false)
        //   metaData,
        //   isTemorarySaved    (true[uploadFileToS3] / false[persistentSave]) -- in case of undefined or null it will perform both
        //}
        //uploadToS3PermanentPath : Calling 'generate-form-for-saving-snapshots' API from there getting image permanent path and URL then uploading image file to that particular URL
        function start(mediaStream, options) {
            var cnf = service.config,
                vidElemId = "faceTracVid",
                fileSaveMode = "both",
                isTimeIntervalRequired = true,
                proctorConfig = null;
            if (!mediaStream) {
                $log.log("MediaStream is not defined!");
                return $q.when(null);
            }
            cnf.meta = null;
            cnf.loginInfo = loginService.getLoginInfo();
            if (angular.isDefined(sessionStorage.imageCaptureCount)) {
                proctorConfig = parseInt(sessionStorage.imageCaptureCount);
            }
            // proctoringService.utility.getProctoringConfig()
            //     .then(function(res) {
            //      if(res && res.imageTrackingCaptureCount ){
            //       proctorConfig = res.imageTrackingCaptureCount;
            //       }
            //     });
            if (cnf.loginInfo !== null) {
                cnf.testId = cnf.loginInfo.TestId;
                cnf.candidateId = cnf.loginInfo.CandidateId;
                var loginConf = cnf.loginInfo.Config;
                if (loginConf && loginConf.imageTrackingInterval) {
                    cnf.timeInterval = loginConf.imageTrackingInterval;
                }
                if (proctorConfig !== null) {
                    if (proctorConfig == 0 || proctorConfig < 1) {
                        proctorConfig = 1;
                    }
                    cnf.newTimeInterval = cnf.timeInterval / proctorConfig <= 30 ? 30 : cnf.timeInterval / proctorConfig;
                }

            }
            cnf.canvas = angular.element(document.getElementById('overlay'))[0];
            if (angular.isDefined(options) && angular.isObject(options)) {
                if (angular.isDefined(options.videoElementId) && options.videoElementId !== null) {
                    vidElemId = options.videoElementId;
                }
                if (angular.isDefined(options.isTimeIntervalRequired)) {
                    isTimeIntervalRequired = options.isTimeIntervalRequired;
                }
                if (angular.isDefined(options.metaData)) {
                    cnf.meta = options.metaData;
                }
                if (angular.isDefined(options.isTemorarySaved)) {
                    fileSaveMode = options.isTemorarySaved ? "uploadFileToS3" : "persistentSave";
                }
                if (angular.isDefined(options.isFileUploadToS3PermanentPath)) {
                    fileSaveMode = 'uploadToS3PermanentPath';
                }
                if (angular.isDefined(options.imageTrackingBufferInterval)) {
                    cnf.imageTrackingBufferInterval = options.imageTrackingBufferInterval || 15;
                }
                cnf.qId = options.qId;
                cnf.relativePath = options.proctoringImagePath;
            }
            //service.config.meta = metaData;
            cnf.videoElement = angular.element(document.getElementById(vidElemId))[0];
            if (!cnf.videoElement.srcObject) {
                updateStream(mediaStream);
            }
            if (isTimeIntervalRequired) {
                $timeout(setTimeInterval(), (cnf.timeInterval * 1000));
                return $q.when(true);
            }
            if (options && options.metaData && options.metaData.multiUserUI) {
                uplaodByForm();
                return $q.when(true);
            }
            return uploadData(fileSaveMode, options.proctoringImagePath).then(
                function(res) {
                    if (!res) {
                        return $q.reject(null);
                    } else {
                        return $q.resolve(res);
                    }
                },
                function() {
                    return $q.reject(null);
                });
        }

        function saveImageToS3(imgUrl, goldenImagePath, meta) {
            var cnf = service.config;
            cnf.meta = meta;
            cnf.relativePath = goldenImagePath;
            return saveImage(imgUrl, "persistentSave");
        }

        /* capture image for slow network and promise for image creation not storing */

        function slowNetworkImageCreation(mediaStream, options) {
            var vidElemId = "faceTracVid",
                imageRawData = null,
                defer = $q.defer();
            service.config.loginInfo = loginService.getLoginInfo();
            if (service.config.loginInfo !== null) {
                service.config.testId = service.config.loginInfo.TestId;
                service.config.candidateId = service.config.loginInfo.CandidateId;
            }
            service.config.canvas = angular.element(document.getElementById('overlay2'))[0];
            if (angular.isDefined(options) && angular.isObject(options)) {
                if (angular.isDefined(options.videoElementId) && options.videoElementId !== null) {
                    vidElemId = options.videoElementId;
                }

                if (angular.isDefined(options.metaData)) {
                    service.config.meta = options.metaData;
                }
            }
            service.config.videoElement = angular.element(document.getElementById(vidElemId))[0];
            // if (!service.config.videoElement.srcObject) {
            if (angular.isUndefined(mediaStream) && mediaStream !== null) {
                defer.reject();
            }
            try {
                service.config.videoElement.srcObject = mediaStream;
            } catch (error) {
                service.config.videoElement.src = URL.createObjectURL(mediaStream);
            }
            service.config.timeDiff = new Date().getTime()
            // }
            $timeout(function() {
                imageRawData = captureImage();
                if (!imageRawData) {
                    defer.reject();
                } else {
                    saveImage(imageRawData);
                    defer.resolve(true);
                }
            }, 500);
            return defer.promise;
        }
        /* ************************ */
        function updateStream(strm) {
            try {
                service.config.videoElement.srcObject = strm;
            } catch (error) {
                service.config.videoElement.src = URL.createObjectURL(strm);
            }
        }

        // function setTimeInterval() {
        //     var cnf = service.config;
        //     cnf.loggingIntervalObj = $interval(function() {
        //         cnf.imgCaptureCount++;
        //         console.log('SURAJ COUNT----'+ cnf.imgCaptureCount +'at time ---', new Date());
        //         uplaodByForm(); // uploadData();
        //     }, (service.config.timeInterval * 1000));
        // }

        function setTimeInterval() {
            var cnf = service.config,
                timeInterval = service.config.timeInterval;
            if (cnf.newTimeInterval !== null) {
                timeInterval = cnf.newTimeInterval
            }
            cnf.loggingIntervalObj = $interval(function() {
                cnf.imgCaptureCount++;
                if (cnf.newTimeInterval !== null) {
                    if ((cnf.imgCaptureCount * cnf.newTimeInterval) % cnf.timeInterval === 0) {
                        var countMeta = true;
                        checkForFaceCount(countMeta);
                    } else {
                        checkForFaceCount();
                    }
                } else {
                    checkForFaceCount();
                }
                // uploadData();
            }, (timeInterval * 1000));
        }



        function checkForFaceCount(countMeta) {
            var cnf = service.config,
                currentFaceCount = parseInt(sessionStorage.getItem('currentFaceCount'));
            if (currentFaceCount > 0 || cnf.faceCountTimeOutCounter === cnf.imageTrackingBufferInterval) {
                cnf.faceCountTimeOutCounter = 0;
                countMeta ? uplaodByForm(countMeta) : uplaodByForm();
            } else {
                $timeout(function() {
                    cnf.faceCountTimeOutCounter++;
                    countMeta ? checkForFaceCount(countMeta) : checkForFaceCount();
                }, 1000);
            }
        }

        function uplaodByForm(setMeta) {
            var data = captureImage(),
                cnf = service.config;
            if (!data) {
                return null;
            }
            if (!cnf.meta) {
                cnf.meta = {
                    timeStamp: new Date(),
                    secondsElapsed: assessmentUtility.timer.time().toString(),
                    qId: service.config.qId
                };
            }
            if (cnf.meta.multiUserUI) {
                var preDefined = {
                    timeStamp: new Date(),
                    secondsElapsed: assessmentUtility.timer.time().toString(),
                    qId: service.config.qId
                };
                Object.assign(cnf.meta, preDefined);
            }
            if (setMeta) {
                cnf.meta.isTrackingImage = true;
            }
            var request = {
                relativePath: cnf.relativePath,
                metaData: cnf.meta
            };

            if (commonService.testIsOnlinePreview()) {
                return $q.when({ 'msg': 'File cant be saved in online preview mode!', 'data': null });
            } else if (!data) {
                return $q.when({ 'msg': 'File to be saved not found!', 'data': null });
            }
            cnf.meta.timeStamp = new Date();
            console.log('ImageCompare Starts', new Date());
            var roomScanModalVisible = sessionStorage.getItem('roomScanModalVisible');
            if (roomScanModalVisible !== undefined && roomScanModalVisible) {
                roomScanModalVisible = JSON.parse(roomScanModalVisible);
            } else {
                roomScanModalVisible = false;
            }
            console.log(roomScanModalVisible, 'charuk');
            if (roomScanModalVisible) {
                return null;
            } else {
                return getImageFaceRecog(data.get('file'))
                    .then(function(res) {
                        console.log('ImageCompare ends', new Date());
                        cnf.meta.faceRecog = res;

                        return commonService.generateFormForSnapshots(request);
                    })
                    .then(function(res) {
                        if (!res.s3FormFields) {
                            return $q.reject(res);
                        }
                        var formPrintingDynamicUrls, fd = new FormData();
                        _.forEach(res.s3FormFields.fields, function(value, key) {
                            fd.append(key, value);
                        });
                        fd.append('file', data.get('file'));
                        formPrintingDynamicUrls = _.chain(sessionStorage.getItem('formPrintingDynamicUrls'))
                            .union([_.get(res, 's3FormFields.url')])
                            .uniq()
                            .value();
                        sessionStorage.setItem('formPrintingDynamicUrls', JSON.stringify(formPrintingDynamicUrls));
                        return webService.execute(res.s3FormFields.url, fd, "POST", null);
                    })
                    .then(function(res) {
                        $log.log(res);
                        return false;
                    })
                    .catch(function(res) {
                        $log.log(res.msg);
                        return false;
                    })
                    .finally(function() {
                        cnf.meta = null;
                    });
            }
        }

        function getImageFaceRecog(fileData) {
            var goldenImageUrl = assessmentUtility.localStorage.getData('savedinS3GoldenImagePath'),
                isFaceRecognitionRequired = assessmentUtility.sessionStorage.getData("isFaceRecognitionRequired"),
                isGoldenImageProcessedEnd = assessmentUtility.sessionStorage.getData("isGoldenImageProcessedEnd"),
                isGoldenImageProcessedStarted = assessmentUtility.sessionStorage.getData("isGoldenImageProcessedStarted");
            if (!goldenImageUrl || !isFaceRecognitionRequired) {
                return $q.when();
            }
            if (!isGoldenImageProcessedEnd) {
                if (isGoldenImageProcessedStarted) {
                    return $q.when();
                }
                $timeout(function() {
                    assessmentUtility.sessionStorage.setData("isGoldenImageProcessedStarted", true);
                    faceRecognitionService.getImageInfo(goldenImageUrl)
                        .then(function() {
                            assessmentUtility.sessionStorage.setData("isGoldenImageProcessedEnd", true);
                        });
                }, 100);
                return $q.when();
            }
            return faceRecognitionService.getImageCompareInfo(goldenImageUrl, fileData)
                .then(function(res) {
                    if (res) {
                        return btoa(JSON.stringify(res));
                    }
                })
                .catch(function(err) {
                    return $q.when();
                })
        }

        function uploadData(action, s3imagePath) {
            var data = captureImage();
            if (!data) {
                return null;
            }
            if (action === 'uploadToS3PermanentPath') {
                return uploadFileToPermanentS3(data, action, s3imagePath);
            } else {
                return saveImage(data, action);
            }
        }

        function captureImage() {
            if (checkForReadyState()) {
                return getImage();
            }
            return null;
        }

        function checkForReadyState() {
            if (service.config.videoElement.readyState === 4) {
                var timeCount = new Date().getTime() - service.config.timeDiff;
                console.log('TIME DIFF', timeCount);
                $log.log("videoElem.readyState.checkingTimeCount:", service.config.checkingTimeCount);
                service.config.checkingTimeCount = 0;
                return true;
            } else {
                service.config.checkingTimeCount++;
                if (service.config.checkingTimeCount <= service.config.chkReadystateMxtm) {
                    return $timeout(checkForReadyState(), 1000);
                } else {
                    service.config.checkingTimeCount = 0;
                    $log.log("Error:video element did not get ready with in 30sec.");
                    return false;
                }
            }
        }

        function getImage(forceClearExistingCanvas, blobImage) {
            if (!service.config.canvas) {
                return;
            }
            var context = service.config.canvas.getContext('2d'),
                dataDataUri,
                dataBlob,
                fd;
            if (forceClearExistingCanvas) {
                context.clearRect(0, 0, service.config.canvas.width, service.config.canvas.height);
                service.config.videoElement = document.getElementById(service.config.videoElement.id);
            }
            $log.log(service.config.videoElement.srcObject);
            context.drawImage(service.config.videoElement, 0, 0, service.config.canvas.width, service.config.canvas.height);
            dataDataUri = service.config.canvas.toDataURL('image/jpeg');
            if (blobImage) {
                return dataDataUri;
            }
            dataBlob = dataURItoBlob(dataDataUri, "canvasImage.jpeg");

            fd = new FormData();
            fd.append("file", dataBlob);
            return fd;
        }

        function dataURItoBlob(dataurl, filename) {
            var arr = dataurl.split(',');
            try {
                arr[0].match(/:(.*?);/)[1]
            } catch (e) {
                return $q.reject({});
            }
            var mime = arr[0].match(/:(.*?);/)[1],
                bstr = atob(arr[1]),
                n = bstr.length,
                u8arr = new Uint8Array(n);
            while (n--) {
                u8arr[n] = bstr.charCodeAt(n);
            }
            var newFileName = filename.substr(0, filename.lastIndexOf('.')) || filename,
                mineExtension = mime.substr(mime.lastIndexOf('/') + 1) || mime;
            filename = newFileName + '.' + mineExtension;
            return new File([u8arr], filename, {
                type: mime
            });
        }

        function saveImage(data, action, type) {
            var cnf = service.config,
                params = {
                    "action": action,
                    "fileExtentions": cnf.fileExtentions,
                    "fileSizeLimit": cnf.fileSizeLimit,
                    "testId": cnf.testId,
                    "candidateId": cnf.candidateId,
                    "relativePath": cnf.relativePath,
                    "targetBucket": "rekognition-images",
                    "type": type
                };

            if (!cnf.meta) {
                cnf.meta = {
                    "timeStamp": new Date(),
                    "secondsElapsed": "" + assessmentUtility.timer.time() + "",
                    "qId": service.config.qId
                };
            }
            if (cnf.meta.multiUserUI) {
                var preDefined = {
                    "timeStamp": new Date(),
                    "secondsElapsed": "" + assessmentUtility.timer.time() + "",
                    "qId": service.config.qId
                };
                Object.assign(cnf.meta, preDefined);
            }
            if (action !== "uploadFileToS3" && commonService.testIsOnlinePreview()) {
                return $q.when({ 'msg': 'File cant be saved in online preview mode!', 'data': null });
            } else if (!data) {
                return $q.when({ 'msg': 'File to be saved not found!', 'data': null });
            }
            params.meta = cnf.meta;
            params.data = data;
            return commonService.uploadFile(params, false)
                .then(function(res) {
                        if (!res) {
                            return false;
                        }
                        if (!res.data) {
                            $log.log(res.msg);
                            return false;
                        } else {
                            return res.data;
                        }
                    },
                    function(res) {
                        $log.log(res.msg);
                        return false;
                    })
                .finally(function() {
                    cnf.meta = null;
                });
        }

        function stop() {
            return $q(function(resolve, reject) {
                service.config.videoElement.srcObject = null;
                $interval.cancel(service.config.loggingIntervalObj);
                resolve(true);
            });
        }

        function uploadFileToPermanentS3(data, action, s3imagePath) {
            var cnf = service.config,
                params = {
                    "action": action,
                    "fileExtentions": cnf.fileExtentions,
                    "fileSizeLimit": cnf.fileSizeLimit,
                    "testId": cnf.testId,
                    "candidateId": cnf.candidateId,
                    "relativePath": cnf.relativePath,
                    "targetBucket": "rekognition-images",
                    "type": s3imagePath
                };

            if (!cnf.meta) {
                cnf.meta = {
                    "timeStamp": new Date(),
                    "secondsElapsed": "" + assessmentUtility.timer.time() + "",
                    "qId": service.config.qId
                };
            }
            if (cnf.meta.multiUserUI) {
                var preDefined = {
                    "timeStamp": new Date(),
                    "secondsElapsed": "" + assessmentUtility.timer.time() + "",
                    "qId": service.config.qId
                };
                Object.assign(cnf.meta, preDefined);
            }
            if (action !== "uploadFileToS3" && commonService.testIsOnlinePreview()) {
                return $q.when({ 'msg': 'File cant be saved in online preview mode!', 'data': null });
            } else if (!data) {
                return $q.when({ 'msg': 'File to be saved not found!', 'data': null });
            }
            params.meta = cnf.meta;
            params.data = data;
            var camData = getImage(true);
            return commonService.uploadToPermanentPathS3(params, camData, s3imagePath)
                .then(function(res) {
                        if (!res) {
                            return false;
                        }
                        if (!res.data) {
                            $log.log(res.msg);
                            return false;
                        } else {
                            return res.data;
                        }
                    },
                    function(res) {
                        $log.log(res.msg);
                        return false;
                    })
                .finally(function() {
                    cnf.meta = null;
                });
        }
    }
})();

(function() {
    'use strict';
    angular
        .module("OnlineAssessmentAngular")
        .factory("hvsService", hvsService);

    function hvsService($q, $rootScope, $timeout, webService, loginService, loggerService, assessmentUtility, imageTracker, debuggerService, socketService, $state, growl, openModalService) {
        var janus = null,
            server = null,
            serverRelativePath = null,
            iceServers = null,
            rTCIceTransportPolicy = null,
            roomId = null,
            conferenceId = null,
            streamId = null,
            videocodec = null,
            displayName = null,
            //opaqueId = "onlineassessment-" + Janus.randomString(12),
            janusStatslog = [],
            handler = null,
            handlerInstance = null,
            params = null,
            initDeferred = null,
            restartConferenceDeferred = null,
            myRoomInfo = null,
            /* Networker */
            isConnectionRefreshed = false,
            testInfo = loginService.getLoginInfo(),
            tenantId = -1,
            isWorkerStarted = false,
            netWorkPollingWebWorker = null,
            loadWebWorkerJsFilePollingCounter = 0,
            networkPingerJsForProctoring = (window.location.hostname == 'localhost' ? "https://amsin.hirepro.in" : window.location.origin) + "/s3_cached/hirepro-content/hirepro/proctoring-resources/js/networkpinger_v2.js",
            restartHvsTimeout = null,
            initJanusFailCounter = 0,
            isInternalCall = false,
            isPresentation = false,
            allowTestTerminationOnDemand = !!_.get(testInfo, 'Config.allowTestTerminationOnDemand'),
            enableChatting = !!_.get(testInfo, 'Config.enableChatting'),
            enableLiveStream = !!_.get(testInfo, 'Config.liveStream'),
            isThirdPartyProctoringTestType = _.get(testInfo, 'Config.isThirdPartyProctoringTestType'),
            communicationProtocol = "https",
            isDestroyJanus = true,
            isHvsRestartInitiated = false,
            handlers = [],
            mediaFileName = null,
            logoutNoInternetWarning = null,
            logoutNoInternetModal = null,
            networkFluctuationLog = {},
            joinRetryCallInterval = [15, 30, 45, 45, 45].concat(new Array(36).fill(45)), //Retry upto 30 minutes...
            /* Networker */
            service = {
                "initJanus": initJanus,
                "goldenImagePath": null,
                "proctoringImagePath": null,
                "getMyRoom": getMyRoom,
                "startConference": startConference,
                "stopConference": stopConference,
                "addHandlerInstance": addHandlerInstance,
                "destroyHandler": destroyHandler,
                "attachHandler": attachHandler,
                "destroyJanus": destroyJanus,
                "publishFeedToJanus": publishFeedToJanus,
                "publishFeedToWebRtc": publishFeedToWebRtc,
                "restartHVS": restartHVS,
                "getStreamId": getStreamId,
                "receiveProctConfig": receiveProctConfig,
                "logOutToMsgPage": logOutToMsgPage,
                localVar: {
                    connectionLostTimeStamp: null,
                    logoutTimeout: null,
                    networkFluctuationLimit: null,
                    networkFluctuationCounter: 0
                }
            };
        return service;

        /*......................Public Methods....................*/

        function startConference(_handler, _isInternalCall, opts, type) {
            handler = _handler;
            console.log("sap1_hvs_startConference_handler", _handler);
            console.log("sap1_hvs_startConference_isInternalCall", _isInternalCall);
            console.log("sap1_hvs_startConference_opts", opts);
            console.log("sap1_hvs_startConference_type", type);
            console.log("sap1_hvs_startConference_handlers", handlers);

            isInternalCall = !!_isInternalCall;
            opts = opts || {};
            if (opts) {
                isPresentation = !!opts.isPresentation;
            }
            if (type && !_.find(handlers, { "type": type })) {
                handlers.push({
                    "type": type,
                    "handler": _handler,
                    "opts": opts,
                    "isPresentation": isPresentation
                });
            }
            console.log("sap1_hvs_startConference_handlers_after", handlers);
            if (!Janus) {
                return $q.reject({
                    data: { sessionId: null },
                    msg: "Janus not defined"
                });
            }
            /*if (janus && isInternalCall) {
                isHvsRestartInitiated = false;
                attachHandler();
                debuggerService.log({
                    msg: {
                        activity: 'startConference',
                        sessionId: janus.getSessionId(),
                        success: true,
                        timestamp: new Date()
                    },
                    source: 'hvsLog'
                });
                return $q.when({
                    data: {
                        sessionId: janus.getSessionId()
                    },
                    msg: "Session created successfully."
                });
            } else {
                return init(type);
            }*/
            if (isInternalCall) {
                isHvsRestartInitiated = false;
            }
            return init(type);
        }

        function stopConference(_handlerInstance, isNetworkGotFailure, _isDestroyJanus) {
            console.log("sap1_hvs_stopConference_handlerInstance", _handlerInstance);
            console.log("sap1_hvs_stopConference_isNetworkGotFailure", isNetworkGotFailure);
            console.log("sap1_hvs_stopConference_isDestroyJanus", _isDestroyJanus);
            handlerInstance = _handlerInstance;
            isDestroyJanus = (angular.isUndefined(_isDestroyJanus) ||
                _isDestroyJanus == null) ? true : _isDestroyJanus;
            return $q(function(resolve, reject) {
                unpublishFeed();
                leaveRoom();
                destroyHandler(_handlerInstance);
                isDestroyJanus && destroyJanus();
                /*network polling*/
                console.log("sap1_hvs_isInternalCall", isInternalCall);
                if (!isNetworkGotFailure) {
                    if (netWorkPollingWebWorker) {
                        netWorkPollingWebWorker.terminate();
                        netWorkPollingWebWorker = null;
                    }
                    isWorkerStarted = false;
                }
                /*network polling*/
                debuggerService.log({
                    msg: {
                        activity: 'stopConference',
                        sessionId: janus && janus.getSessionId(),
                        success: true,
                        timestamp: new Date()
                    },
                    source: 'hvsLog'
                });
                if (isDestroyJanus) {
                    console.log('SS from stopConference', janus);
                    janus = null;
                }
                myRoomInfo = null;
                resolve({ data: { isStopped: true }, msg: "Confrence is stopped successfully." });
            });
        }

        function addHandlerInstance(_handlerInstance, type) {
            console.log("sap1_hvs_addHandlerInstance_handlerInstance", _handlerInstance);
            console.log("sap1_hvs_addHandlerInstance_type", type);
            var handler = _.find(handlers, { "type": type });
            //handler.isPresentation = isPresentation;
            handler.instance = _handlerInstance;
            console.log("sap1_hvs_addHandlerInstance_handlers", handlers);
        }

        function publishFeedToWebRtc(handlerInstance, userId, mediaConstrint, _displayName) {
            console.log("sap1_hvs_publishFeedToWebRtc_handlerInstance", handlerInstance);
            return $q(function(resolve, reject) {
                console.log("sap_hvs.publishFeedToWebRtc");
                var videoConstraint = {
                    "frameRate": {
                        "ideal": 10,
                        "min": 1,
                        "max": 10
                    },
                    "width": { "ideal": 320 },
                    "height": { "ideal": 180 }
                };
                handlerInstance.createOffer({
                    media: {
                        video: mediaConstrint.recordingType ? mediaConstrint.recordingType : videoConstraint,
                        screenRecordConstraints: mediaConstrint.screenRecordConstraints,
                        audioRecv: false,
                        videoRecv: false,
                        audioSend: mediaConstrint.audio,
                        videoSend: mediaConstrint.video
                    },
                    simulcast: false,
                    simulcast2: false,
                    success: function(jsep) {
                        Janus.debug('Got publisher SDP!');
                        Janus.debug(jsep);
                        console.log("sap1_hvs_publishFeedToWebRtc_success");
                        var filename = _displayName + '_' +
                            userId + '_' +
                            janus.getSessionId(),
                            publish = {
                                request: 'configure',
                                audio: mediaConstrint.audio,
                                video: mediaConstrint.video,
                                filename: mediaFileName,
                                videocodec: videocodec
                            };
                        handlerInstance.send({
                            message: publish,
                            jsep: jsep
                        });
                        debuggerService.log({
                            msg: {
                                logPushingIntervalVal: 1,
                                activity: 'JSEP',
                                timestamp: new Date(),
                                participantType: 'Publisher',
                                participantName: _displayName,
                                eventDetails: {
                                    typeOfEvent: "JSEP",
                                    timestamp: new Date(),
                                    sessionId: janus.getSessionId(),
                                    pluginName: 'videoroom',
                                    pluginId: handlerInstance.getId(),
                                    data: {
                                        callback: 'success',
                                        comment: 'SDP send',
                                        SDP: {
                                            'type': jsep.type,
                                            'sdp': ''
                                        }
                                    }
                                }
                            },
                            source: 'hvsLog'
                        });
                        restartConferenceDeferred && restartConferenceDeferred.resolve();
                        resolve({
                            data: { isPublished: true, sessionId: janus.getSessionId() },
                            msg: 'Successfully published feed.'
                        });

                    },
                    error: function(error) {
                        console.log("sap1_hvs_publishFeedToWebRtc_error", error);
                        Janus.error('WebRTC error:', error);
                        debuggerService.log({
                            msg: {
                                logPushingIntervalVal: 1,
                                activity: 'JSEP',
                                timestamp: new Date(),
                                participantType: 'Publisher',
                                participantName: displayName,
                                eventDetails: {
                                    typeOfEvent: "JSEP",
                                    timestamp: new Date(),
                                    sessionId: janus.getSessionId(),
                                    pluginName: 'videoroom',
                                    pluginId: handlerInstance.getId(),
                                    data: {
                                        callback: 'error',
                                        error: error ? error.toString() : null
                                    }
                                }
                            },
                            source: 'hvsLog'
                        });
                        restartConferenceDeferred && restartConferenceDeferred.reject();
                        reject({
                            data: { isPublished: false },
                            error: error ? error.toString() : null,
                            msg: 'Error occured,while trying to publish feed!'
                        });
                    }
                });
            });
        }

        function restartHVS(by, interval) {
            console.log("sap1_hvs_restartHVS_by", by);
            if (interval) {
                if (!restartHvsTimeout) {
                    restartHvsTimeout = $timeout(function() {
                        restartHVSConnection(by, interval);
                    }, interval * 1000);
                }
                return restartHvsTimeout;
            } else {
                restartHVSConnection(by);
            }
            return null;
        }

        function restartHVSConnection(by, interval) {
            console.log("sap1_hvs_restartHVSConnection_by", by);
            console.log("sap1_hvs_restartHVSConnection_isHvsRestartInitiated", isHvsRestartInitiated);
            var isSecondaryCameraEnable = sessionStorage.getItem("isSecondaryCameraEnable") === "true" ? true : false;
            if (isHvsRestartInitiated) return false;
            debuggerService.log({
                msg: {
                    activity: 'restartHVS',
                    response: {
                        by: by,
                        interval: interval
                    },
                    success: false,
                    timestamp: new Date()
                },
                source: 'hvsLog'
            });
            isHvsRestartInitiated = true;
            $rootScope.isNetworkGotFailed = true;
            socketService.close(1000, "restart hvs by " + by)
                .then(function() {
                    if (enableChatting ||
                        enableLiveStream ||
                        allowTestTerminationOnDemand || isThirdPartyProctoringTestType) {
                        var data = {
                            app: ["generic_msg_delivery"]
                        };
                        if (isSecondaryCameraEnable) {
                            data.app.push("secondary_camera_msg_delivery");
                        }
                        socketService.init();
                    }
                });
            var stopChain = $q.when(),
                destroyJanus = false;
            _.forEach(handlers, function(handler, index, destroyJanus) {
                destroyJanus = index === (handlers.length - 1);
                stopChain = stopChain.then(function() {
                    console.log("sap1_hvs_restartHVSConnection_stopConference_handler", handler);
                    console.log("sap1_hvs_restartHVSConnection_stopConference_destroyJanus", destroyJanus);
                    return stopConference(handler.instance, true, destroyJanus);
                });
            });

            if (service.localVar.connectionLostTimeStamp === null) {
                getSnapshotWhenOffline()
                    .then(function(res) {
                            service.localVar.connectionLostTimeStamp = new Date();
                            if (res === true) {
                                console.log('Offline SnapShot');
                            }
                        },
                        function() {
                            console.log('Offline SnapShot Fail');
                        });
            } else if (service.localVar.connectionLostTimeStamp !== null) {
                var timeDiff = (new Date().getTime() - service.localVar.connectionLostTimeStamp.getTime()) / 1000;
                if (timeDiff > 59) {
                    getSnapshotWhenOffline()
                        .then(function(res) {
                                service.localVar.connectionLostTimeStamp = new Date();
                                if (res === true) {
                                    console.log('Offline SnapShot');
                                }
                            },
                            function() {
                                console.log('Offline SnapShot Fail');
                            });
                }
            }
            console.log("sap1_hvs_restartHVSConnection_isWorkerStarted", isWorkerStarted);
            !isWorkerStarted && startWebWorker("callDisconnected", "callDisconnected");
            console.log('SS suraj logoutNoInternet called');
            logoutNoInternet();
        }

        function getMyRoom(_rqst) {
            testInfo = loginService.getLoginInfo();
            var rqst = _rqst || {};
            if (testInfo && testInfo.CandidateId && testInfo.TestId) {
                myRoomInfo = angular.fromJson(sessionStorage.getItem(sessionStorage.getItem('X-AUTH-TOKEN') + '-myRoomInfo'));
            }
            if (myRoomInfo) {
                return $q.when({ data: myRoomInfo, msg: "Successfully fetched conference room info!" });
            }

            return webService.execute('getMyRoom', rqst)
                .then(function(res) {
                    if (!res || !res.data) {
                        debuggerService.log({
                            msg: {
                                activity: 'getMyRoom',
                                success: false,
                                apiCall: true,
                                timestamp: new Date()
                            },
                            source: 'hvsLog'
                        });
                        return $q.reject({ data: null, msg: "Unable to fetch room info!" });
                    }
                    var xGuid = res.xGuid;
                    res = res.data;
                    myRoomInfo = res;
                    if (res.status === "OK") {
                        if (testInfo.CandidateId && testInfo.TestId) {
                            sessionStorage.setItem(sessionStorage.getItem('X-AUTH-TOKEN') + '-myRoomInfo', angular.toJson(myRoomInfo));
                        }
                        debuggerService.log({
                            msg: {
                                activity: 'getMyRoom',
                                success: true,
                                response: {
                                    conferenceId: res.conferenceId,
                                    displayName: res.displayName,
                                    roomId: res.roomId,
                                    xGuid: xGuid
                                },
                                apiCall: true,
                                timestamp: new Date()
                            },
                            source: 'hvsLog'
                        });
                        return $q.resolve({ data: res, msg: "Successfully fetched conference room info!" });

                    } else {
                        var errorMsg = null;
                        if (_.get(res, 'error.errorCode') === 300) {
                            errorMsg = 'Sorry! One candidate is already active.';
                        } else if (_.get(res, 'error.errorCode') === 440) {
                            errorMsg = 'Session Expired';
                        } else {
                            errorMsg = _.get(res, 'error.message');
                        }
                        debuggerService.log({
                            msg: {
                                activity: 'getMyRoom',
                                success: false,
                                response: { data: res, xGuid: xGuid },
                                apiCall: true,
                                timestamp: new Date()
                            },
                            source: 'hvsLog'
                        });
                        return $q.reject({ data: 'get my room api failure', msg: errorMsg, activity: 'getMyRoom' });
                    }
                }, function(res) {
                    debuggerService.log({
                        msg: {
                            activity: 'getMyRoom',
                            success: false,
                            response: { data: res.data, xGuid: res.xGuid },
                            apiCall: true,
                            timestamp: new Date()
                        },
                        source: 'hvsLog'
                    });
                    return $q.reject({ data: res, msg: 'Login Failed', activity: 'getMyRoom' });
                });
        }

        function destroyHandler(handlerInstance) {
            console.log("sap1_hvs_destroyHandler_handlerInstance", handlerInstance);
            debuggerService.log({
                msg: {
                    activity: 'destroyHandler',
                    timestamp: new Date()
                },
                source: 'hvsLog'
            });
            handlerInstance.hangup();
        }

        function destroyJanus() {
            console.log("sap1_hvs_destroyJanus");
            debuggerService.log({
                msg: {
                    activity: 'destroyJanus',
                    timestamp: new Date()
                },
                source: 'hvsLog'
            });
            janus && janus.destroy();
        }

        function publishFeedToJanus(handlerInstance, _displayName) {
            console.log("sap1_hvs_publishFeedToJanus");
            var register = {
                "request": "join",
                "room": roomId,
                "ptype": "publisher",
                "display": _displayName
            };
            handlerInstance && handlerInstance.send({
                "message": register
            });
            debuggerService.log({
                msg: {
                    activity: 'publishFeedToJanus',
                    sessionId: janus.getSessionId(),
                    request: {
                        roomId: roomId,
                        displayName: _displayName
                    },
                    success: true,
                    janusCall: true,
                    timestamp: new Date()
                },
                source: 'hvsLog'
            });
        }

        function getStreamId() {
            return streamId;
        }

        /*......................Private Methods..................*/

        function restartConference(handler) {
            restartConferenceDeferred = getPromise(restartConferenceDeferred);

            startConference(handler.handler, true, handler.opts, handler.type);

            return restartConferenceDeferred.promise;
        }

        function init(type) {
            console.log("sap1_hvs_init_type", type);
            return getMyRoom()
                .then(function(res) {
                    var roomInfo = res.data;
                    conferenceId = roomInfo.conferenceId;
                    iceServers = roomInfo.iceServer;
                    rTCIceTransportPolicy = roomInfo.rTCIceTransportPolicy;
                    streamId = roomInfo.id;
                    roomId = roomInfo.roomId;
                    serverRelativePath = roomInfo.serverRelativePath;
                    service.goldenImagePath = roomInfo.goldenImageProctoringPath;
                    return initJoiningInfo(type);
                })
                .then(function(res) {
                    console.log("sap1_hvs_init_initJoiningInfo", res);

                    var joiningInfo = res.data,
                        diplayNameLocalStorageKey = isPresentation ?
                        "assess_janus_screen_displayName" : "assess_janus_video_displayName";

                    streamId = joiningInfo.streamId;
                    videocodec = joiningInfo.videocodec;
                    displayName = joiningInfo.displayName;
                    mediaFileName = joiningInfo.mediaFileName;
                    serverRelativePath = joiningInfo.serverRelativePath ?
                        joiningInfo.serverRelativePath : serverRelativePath;
                    service.proctoringImagePath = joiningInfo.proctoringImagePath;

                    sessionStorage.setItem(diplayNameLocalStorageKey, displayName);

                    return initJanus();
                })
                .then(function(res) {
                    console.log("sap1_hvs_init_initJanus", res);
                    attachHandler();
                    return $q.resolve(res);
                })
                .catch(function(err) {
                    console.log("sap1_hvs_init_catch", err);
                    debuggerService.log({
                        msg: {
                            activity: 'init',
                            success: false,
                            response: err,
                            timestamp: new Date()
                        },
                        source: 'hvsLog'
                    });
                    return $q.reject({ data: err.data, msg: err.msg });
                });
        }

        function initJoiningInfo(type) {
            var deffered = $q.defer(),
                counter = 0;
            getJoiningInfo(deffered, counter, type);
            return deffered.promise;
        }

        function getJoiningInfo(deffered, counter, type) {
            var data = {
                isRefresh: isConnectionRefreshed,
                isPresentation: isPresentation,
                isMediaFileNameRequired: true
            };
            if (type === 'envProctoring') {
                data.streamType = "SECONDARY_CAMERA";

            }
            testInfo = loginService.getLoginInfo();
            var joiningInfo = null;
            if (testInfo && testInfo.CandidateId && testInfo.TestId) {
                joiningInfo = angular.fromJson(sessionStorage.getItem(sessionStorage.getItem('X-AUTH-TOKEN') + '-joiningInfo'));
            }
            if (joiningInfo && handlers.length === 1 && !isConnectionRefreshed) {
                isConnectionRefreshed = false;
                deffered.resolve(joiningInfo);
                sessionStorage.setItem(sessionStorage.getItem('X-AUTH-TOKEN') + '-joiningInfo', null);
                return true;
            }
            counter++;
            webService.execute('getJoiningInfo', data)
                .then(function(res) {
                    console.log("sap1_hvs_getJoiningInfo_success", res);
                    var isSuccess = false,
                        result = { data: null, msg: 'Unable to get joining info!' };
                    if (res && res.data && res.data.status === 'OK') {
                        isSuccess = true;
                        result = { data: res.data.data, msg: 'Successfully fetched joining info!' };
                    }
                    debuggerService.log({
                        msg: {
                            activity: 'getJoiningInfo',
                            success: isSuccess,
                            response: { data: res.data, xGuid: res.xGuid },
                            apiCall: true,
                            timestamp: new Date()
                        },
                        source: 'hvsLog'
                    });
                    if (!isSuccess) {
                        return $q.reject(result);
                    }
                    isConnectionRefreshed = false;
                    deffered.resolve(result);
                })
                .catch(function(res) {
                    console.log("sap1_hvs_getJoiningInfo_fail", res);
                    res = res ? { data: res.data, xGuid: res.xGuid } : null;
                    debuggerService.log({
                        msg: {
                            activity: 'getJoiningInfo',
                            success: false,
                            response: res,
                            apiCall: true,
                            timestamp: new Date()
                        },
                        source: 'hvsLog'
                    });
                    if (isInternalCall && counter < joinRetryCallInterval.length) {
                        console.log("sap1_hvs_getJoiningInfo_recursion_counter", counter);
                        $timeout(function() {
                            getJoiningInfo(deffered, counter);
                        }, joinRetryCallInterval[counter] * 1000);
                    } else {
                        deffered.reject({ data: null, msg: 'Unable to get joining info!' });
                    }
                });
        }

        function initJanus(opts) {
            if (opts) {
                rTCIceTransportPolicy = opts.rTCIceTransportPolicy ? opts.rTCIceTransportPolicy : rTCIceTransportPolicy;
                serverRelativePath = opts.serverRelativePath ? opts.serverRelativePath : serverRelativePath;
            }
            if (janus) {
                console.log("sap1_hvs_initJanus_existed");
                return $q.when({
                    data: {
                        sessionId: janus.getSessionId()
                    },
                    msg: "Session created successfully."
                });
            }
            try {
                server = getServerPath();
                console.log("sap1_hvs_initJanus_server", server);
                initDeferred = getPromise(initDeferred);
                Janus.init({
                    debug: 'all',
                    callback: initJanusCallback
                });
                initWorkerProcess();
                return initDeferred.promise;
            } catch (res) {
                console.log("sap1_hvs_initJanus_catch", res);
                debuggerService.log({
                    msg: {
                        activity: 'initJanus',
                        success: false,
                        response: res,
                        timestamp: new Date()
                    },
                    source: 'hvsLog'
                });
                return $q.reject(res);
            }
        }

        function getServerPath() {
            var server = null;
            /*if (window.location.hostname === 'localhost') {
                path = 'https://amsin.hirepro.in/';
            } else {
                path = 'https://' + window.location.hostname + '/';
            }
            if (serverRelativePath) {
                path = path + serverRelativePath;
            } else {
                path = path + 'janus';
            }*/

            if (assessmentUtility.sessionStorage.getData("enableHVScommunicationUsingWSS")) {
                communicationProtocol = "wss";
            }

            if (window.location.hostname === 'localhost') {
                server = 'https://amsin.hirepro.in/';
            } else {
                server = communicationProtocol + '://' + window.location.hostname + '/';
            }
            if (serverRelativePath) {
                server = server + serverRelativePath;
                server += communicationProtocol === "wss" ? "wss" : "";
            } else {
                server = server + 'janus';
            }

            debuggerService.log({
                msg: {
                    activity: 'getServerPath',
                    path: server.replace('https://', ''),
                    success: true,
                    timestamp: new Date()
                },
                source: 'hvsLog'
            });
            return server;
        }

        function initJanusCallback() {
            console.log("sap1_hvs_initJanusCallback");
            // Make sure the browser supports WebRTC
            if (!Janus.isWebrtcSupported()) {
                debuggerService.log({
                    msg: {
                        activity: 'initJanusCallback',
                        success: false,
                        janusCall: true,
                        response: 'webrtc not supported',
                        timestamp: new Date()
                    },
                    source: 'hvsLog'
                });
                return;
            }
            // Create session
            janus = new Janus({
                server: server,
                iceTransportPolicy: rTCIceTransportPolicy,
                iceServers: iceServers,
                success: function(res) {
                    if (logoutNoInternetWarning) {
                        logoutNoInternetWarning.destroy();
                    }
                    if (logoutNoInternetModal) {
                        logoutNoInternetModal.destroy();
                    }
                    console.log("sap1_hvs_initJanusCallback_success", res);
                    debuggerService.log({
                        msg: {
                            activity: 'Session',
                            timestamp: new Date(),
                            participantType: 'Publisher',
                            participantName: displayName,
                            eventDetails: {
                                typeOfEvent: "Session",
                                timestamp: new Date(),
                                sessionId: janus.getSessionId(),
                                pluginName: 'videoroom',
                                pluginId: null,
                                data: {
                                    callback: 'success',
                                    comment: 'session created'
                                }
                            }
                        },
                        source: 'hvsLog'
                    });
                    initDeferred.resolve({
                        data: {
                            sessionId: janus.getSessionId()
                        },
                        msg: "Session created successfully."
                    });
                },
                error: function(error) {
                    console.log("sap1_hvs_initJanusCallback_error", error);
                    debuggerService.log({
                        msg: {
                            activity: 'Session',
                            timestamp: new Date(),
                            participantType: 'Publisher',
                            participantName: displayName,
                            eventDetails: {
                                typeOfEvent: "Session",
                                timestamp: new Date(),
                                //sessionId: janus.getSessionId(),
                                retryCount: initJanusFailCounter,
                                pluginName: 'videoroom',
                                pluginId: null,
                                data: {
                                    callback: 'error',
                                    error: error
                                }
                            }
                        },
                        source: 'hvsLog'
                    });

                    if (initJanusFailCounter < joinRetryCallInterval.length) {
                        console.log("sap1_hvs_initJanusCallback_error_retry_counter", initJanusFailCounter);
                        
                        $timeout(function() {
                            
                            initJanusFailCounter++;
                            
                            if (restartHvsTimeout) {
                                $timeout.cancel(restartHvsTimeout);
                                restartHvsTimeout = null;
                            }
                            restartHVSConnection('janusError');

                        }, joinRetryCallInterval[initJanusFailCounter] * 1000);
                    }

                    console.log('ss Inside error of HVS');
                    var offlineLogoutTime;
                    if (testInfo.Config && testInfo.Config.logoutIfNoInternetIn) {
                        if (logoutNoInternetWarning) {
                            logoutNoInternetWarning.destroy();
                        }
                        logoutNoInternetWarning = growl.warning('Your network connectivity to our servers has stopped working.');
                        if (logoutNoInternetModal) {
                            logoutNoInternetModal.destroy();
                        }
                        var data = {
                            bodyStr: "Please ensure you have stable Internet connectivity. The test will stop unless the internet connectivity is restored.",
                            headerStr: 'Alert',
                            isAction: true,
                            action: {
                                isOkBtn: true
                            }
                        };
                        logoutNoInternetModal = openModalService.showModal('notificationTemplate', data);
                        offlineLogoutTime = testInfo.Config.logoutIfNoInternetIn;
                        console.log('ss logout time defines', offlineLogoutTime);
                        if (service.localVar.logoutTimeout) {
                            $timeout.cancel(service.localVar.logoutTimeout);
                            service.localVar.logoutTimeout = null;
                            // logoutNoInternetWarning.destroy();
                        }
                        //console.log('SS from logoutNoInternet isconnect error outside', janus.isConnected());
                        service.localVar.logoutTimeout = $timeout(function() {
                            console.log('ss inside timeout hvs Var', janus);
                            if (logoutNoInternetWarning) {
                                logoutNoInternetWarning.destroy();
                            }
                            if (logoutNoInternetModal) {
                                logoutNoInternetModal.destroy();
                            }
                            if (janus === null) {
                                logOutToMsgPage();
                            } else if (janus !== null && janus.isConnected() == false) {
                                logOutToMsgPage();
                            }
                            //console.log('SS from logoutNoInternet isconnect error timeout', janus.isConnected());
                        }, offlineLogoutTime * 1000);
                    }
                    initDeferred.reject({ data: error, msg: "Not able to create Session!" });

                },
                destroyed: function(response) {
                    console.log("sap1_hvs_initJanusCallback_destroyed", response);
                    debuggerService.log({
                        msg: {
                            activity: 'Session',
                            timestamp: new Date(),
                            participantType: 'Publisher',
                            participantName: displayName,
                            eventDetails: {
                                typeOfEvent: "Session",
                                timestamp: new Date(),
                                sessionId: null,
                                pluginName: 'videoroom',
                                pluginId: null,
                                data: {
                                    callback: 'destroyed',
                                    comment: 'session destroyed',
                                    response: response
                                }
                            }
                        },
                        source: 'hvsLog'
                    });
                    initDeferred.reject({ data: response, msg: "Session destroyed successfully." });
                }
            });
        }

        function attachHandler(_handler) {
            console.log("sap1_hvs_attachHandler");
            if (_handler) {
                handler = _handler;
            }
            console.log("sap1_hvs_attachHandler", handler);
            if (!handler) {
                console.error("handler is Undefined!");
                return false;
            }
            janus && janus.attach(handler);
        }

        function unpublishFeed() {
            var handlerId;
            console.log("sap1_hvs_unpublishFeed_handlerInstance", handlerInstance);
            if (handlerInstance) {
                handlerInstance.send({
                    "message": { "request": "unpublish" }
                });
                handlerId = handlerInstance.getId();
            } else {
                handlerId = "handler not Defined";
            }
            debuggerService.log({
                msg: {
                    activity: 'Plugin',
                    timestamp: new Date(),
                    participantType: 'Publisher',
                    participantName: displayName,
                    eventDetails: {
                        typeOfEvent: "Plugin",
                        timestamp: new Date(),
                        sessionId: janus && janus.getSessionId(),
                        pluginName: 'videoroom',
                        pluginId: handlerId,
                        data: {
                            comment: 'unpublish publisher feed'
                        }
                    }
                },
                source: 'hvsLog'
            });
        }

        function leaveRoom() {
            console.log("sap1_hvs_leaveRoom_handlerInstance", handlerInstance);
            handlerInstance.send({
                "message": { "request": "leave" }
            });
            debuggerService.log({
                msg: {
                    activity: 'Plugin',
                    timestamp: new Date(),
                    participantType: 'Publisher',
                    participantName: displayName,
                    eventDetails: {
                        typeOfEvent: "Plugin",
                        timestamp: new Date(),
                        sessionId: janus && janus.getSessionId(),
                        pluginName: 'videoroom',
                        pluginId: handlerInstance.getId(),
                        data: {
                            comment: 'publisher leave room'
                        }
                    }
                },
                source: 'hvsLog'
            });
        }

        function getPromise(prmObj) {
            return prmObj &&
                prmObj.promise &&
                prmObj.promise.$$state &&
                prmObj.promise.$$state.status === 0 ? prmObj : $q.defer();
        }

        function stopPublishing(streamId, isPresentation) {
            var rq = {
                isFinalInterviewEnd: true,
                streamId: streamId,
                isPresentation: isPresentation
            };
            return webService.execute('stopPublishing', rq)
                .then(function(res) {
                    console.log("sap1_hvs_stopPublishing_success", res);
                    if (!res || !res.data || !res.data.status === 'KO') {
                        debuggerService.log({
                            msg: {
                                activity: 'stopPublishing',
                                success: false,
                                apiCall: true,
                                timestamp: new Date()
                            },
                            source: 'proctorhvsLog'
                        });
                        return $q.reject({
                            data: { isStopped: false },
                            msg: "Unable to stop Confrence!"
                        });
                    }
                    debuggerService.log({
                        msg: {
                            activity: 'stopPublishing',
                            success: true,
                            request: rq,
                            response: { data: res.data, xGuid: res.xGuid },
                            apiCall: true,
                            timestamp: new Date()
                        },
                        source: 'proctorhvsLog'
                    });
                    return $q.resolve({
                        data: { isStopped: true },
                        msg: "Confrence is stopped successfully."
                    });
                }, function(res) {
                    console.log("sap1_hvs_stopPublishing_error", res);
                    debuggerService.log({
                        msg: {
                            activity: 'stopPublishing',
                            success: false,
                            request: rq,
                            response: { data: res.data, xGuid: res.xGuid },
                            apiCall: true,
                            timestamp: new Date()
                        },
                        source: 'proctorhvsLog'
                    });
                    return $q.reject({
                        data: { isStopped: false },
                        msg: "Unable to stop Confrence!"
                    });
                });
        }

        // function pushActivityLog(log) {
        //     var janusActivityLog = {
        //         canLoginActivityLog: {
        //             janusLog: log
        //         }
        //     };
        //     loggerService.push(janusActivityLog);
        // }

        /*........................Handle Worker.......................*/

        function initWorkerProcess() {
            initWebWorker()
                .then(function(res) {
                    console.log(res.msg);
                })
                .catch(function(res) {
                    console.log(res.msg);
                });
        }

        function loadWebWorkerJsFile() {
            var loadNetworkpingerUrl = networkPingerJsForProctoring + "?v=" + (new Date()).getTime();
            loadWebWorkerJsFilePollingCounter++;
            return webService.execute(loadNetworkpingerUrl, null, "GET", "text")
                .then(function(res) {
                        console.log("sap1_hvs_loadWebWorkerJsFile_success", res);
                        debuggerService.log({
                            msg: {
                                activity: 'loadWebWorkerJsFile',
                                success: true,
                                timestamp: new Date()
                            },
                            source: 'hvsLog'
                        });
                        return $q.resolve(res);
                    },
                    function(res) {
                        console.log("sap1_hvs_loadWebWorkerJsFile_error", res);
                        console.log(res);
                        debuggerService.log({
                            msg: {
                                activity: 'loadWebWorkerJsFile',
                                response: res,
                                count: loadWebWorkerJsFilePollingCounter,
                                success: false,
                                timestamp: new Date()
                            },
                            source: 'hvsLog'
                        });
                        if (loadWebWorkerJsFilePollingCounter < 5) {
                            console.log("sap1_hvs_loadWebWorkerJsFile_recursion");
                            return loadWebWorkerJsFile();
                        } else {
                            return $q.reject({ 'msg': 'Network Failure:Not able to load Web worker js file!' })
                        }
                    });
        }

        function initWebWorker() {
            if (angular.isUndefined(Worker)) {
                return $q.reject({ 'msg': 'incompatible browser[webWorker is not defined]' });
            }
            if (netWorkPollingWebWorker) {
                return $q.when({ 'msg': 'webWorker is already loadeded.' });
            }
            return loadWebWorkerJsFile()
                .then(function(res) {
                    console.log("sap1_hvs_initWebWorker_success", res);
                    debuggerService.log({
                        msg: {
                            activity: 'initWebWorker',
                            success: true,
                            timestamp: new Date()
                        },
                        source: 'hvsLog'
                    });
                    var blob_networkpinger = new Blob([res.data]);
                    netWorkPollingWebWorker = new Worker(window.URL.createObjectURL(blob_networkpinger));
                    // add Event listener............
                    netWorkPollingWebWorker
                        .addEventListener("message", function(res) {
                            res = angular.fromJson(res.data);
                            console.log("sap1_hvs_initWebWorker_listen", res);
                            debuggerService.log({
                                msg: {
                                    activity: 'netWorkPollingWebWorker',
                                    response: res,
                                    success: true,
                                    timestamp: new Date()
                                },
                                source: 'hvsLog'
                            });
                            if (res && res.status !== "OK" && res.msg !== "SERVER IS REACHABLE NOW") {
                                console.log(res.msg);
                                return false;
                            }
                            $rootScope.isNetworkGotFailed = false;
                            networkFluctuationLog.endTimestamp = new Date();
                            networkFluctuationLog.duration = networkFluctuationLog.endTimestamp - networkFluctuationLog.startTimestamp;
                            if (networkFluctuationLog.duration) {
                                networkFluctuationLog.duration = Math.round(networkFluctuationLog.duration / 1000);
                            }
                            var networkFluctuationLogList = JSON.parse(localStorage.getItem('networkFluctuationLogList_' + testInfo.testUserId)) || [];
                            networkFluctuationLogList.push(networkFluctuationLog);
                            localStorage.setItem('networkFluctuationLogList_' + testInfo.testUserId, JSON.stringify(networkFluctuationLogList));
                            socketService.close(1000, "On networkFailure")
                                .then(function() {
                                    if (enableChatting ||
                                        enableLiveStream ||
                                        allowTestTerminationOnDemand || isThirdPartyProctoringTestType) {
                                        socketService.init();
                                    }
                                });
                            handler.opaqueId = "in.hirepro.onlineassessment.videoProctoring-" + Janus.randomString(12);
                            try {
                                isWorkerStarted = false;
                                console.log('SS from initWebWorker', janus);
                                janus = null;
                                var startChain = $q.when(),
                                    stopChain = $q.when();
                                _.forEach(handlers, function(handler) {
                                    stopChain = stopChain.then(function() {
                                        console.log("sap1_hvs_initWebWorker_stopPublishing_handler", handler);
                                        return stopPublishing(handler.streamId, handler.isPresentation);
                                    });
                                });
                                stopChain
                                    .finally(function() {
                                        _.forEach(handlers, function(handler) {
                                            startChain = startChain.then(function() {
                                                console.log("sap1_hvs_initWebWorker_startConference_handler", handler);
                                                isConnectionRefreshed = true;
                                                return restartConference(handler);
                                                //return startConference(handler.handler, true, handler.opts, handler.type);
                                            });
                                        });
                                    });
                            } catch (err) {
                                console.log("sap1_hvs_initWebWorker_catch", err);
                                debuggerService.log({
                                    msg: {
                                        activity: 'reinit by worker',
                                        success: false,
                                        response: err,
                                        timestamp: new Date()
                                    },
                                    source: 'hvsLog'
                                });
                                console.log("sap1_hvs_initWebWorker_catch_isWorkerStarted", isWorkerStarted);
                                !isWorkerStarted && startWebWorker("callDisconnected", "callDisconnected");
                                //return $q.reject({ data: res.data, msg: res.msg });
                            }
                        });
                    return $q.resolve({ 'msg': 'webWorker is loaded successfully.' });
                });
        }

        function startWebWorker(_state, _context) {
            console.log("sap1_hvs_startWebWorker", _state, _context);
            var messageToWebWorker = null,
                tenantId = sessionStorage.getItem('_tId'),
                isAliveApiUrl = location.origin + "/is-alive.txt?" + new Date().getTime();
            testInfo = loginService.getLoginInfo();

            messageToWebWorker = angular.toJson({
                cmd: 'startPolling',
                params: {
                    postBody: {
                        state: _state,
                        testUser: tenantId + '-' + testInfo.CandidateId + '-' + testInfo.TestId,
                        timeStamp: new Date(),
                        assessmentHost: window.location.hostname == 'localhost' ? 'amsin.hirepro.in' : window.location.hostname
                    },
                    context: _context,
                    pollingInterval: 60000,
                    serverUrl: isAliveApiUrl
                }
            });
            if (netWorkPollingWebWorker) {
                netWorkPollingWebWorker.postMessage(messageToWebWorker);
                isWorkerStarted = true;
                networkFluctuationLog = {
                    startTimestamp: new Date()
                };
            } else {
                initDeferred.reject({
                    strm: null,
                    msg: 'Not able to initialize proctoring service.',
                    isOnline: $rootScope.isNetworkGotFailed
                });
            }
        }

        function getSnapshotWhenOffline() {
            var constraints = { audio: true, video: true },
                options = {
                    videoElementId: 'secondVid',
                    isTimeIntervalRequired: false
                };

            return $q(function(resolve, reject) {
                navigator.mediaDevices.getUserMedia(constraints)
                    .then(function(mediaStream) {
                        console.log('offline stream', mediaStream);
                        imageTracker.slowNetworkImageCreation(mediaStream, options)
                            .then(function(res) {
                                if (res === true) {
                                    mediaStream.getTracks()[0].stop();
                                    mediaStream.getTracks()[1].stop();
                                    resolve(true);
                                }
                            }, function() {
                                mediaStream.getTracks()[0].stop();
                                mediaStream.getTracks()[1].stop();
                                reject(true);
                            });
                    })
                    .catch(function(err) {
                        console.log("sap1_hvs_getSnapshotWhenOffline", err);
                        console.log('navigation error');
                        console.log(err.name + ": " + err.message);
                    });
            });
        }

        function receiveProctConfig(resp) {
            if (resp) {
                service.localVar.networkFluctuationLimit = resp.networkFluctuationLimit;
            }
        }

        function logOutToMsgPage(msg) {
            var loginInfo = loginService.getLoginInfo(),
                candidateName = loginInfo.CandidateName,
                logoutMsg = 'Candidate logout due to network error';
            if (msg == null || msg == undefined) {
                var message = '<div class="row text-left no-internet-row">' +
                    '<div class="col-md-10 col-md-offset-2">' +
                    '<span class="no-wifi">' +
                    '<i class="fa fa-4x fa-wifi" aria-hidden="true"></i>' +
                    '<i class="fa fa-2x fa-exclamation" aria-hidden="true"></i>' +
                    '</span>' +
                    '</br>' +
                    '<span>' +
                    '<h3 class="color-gray">' +
                    'Sorry! ' + candidateName + ', you have been logged out due to poor internet connection.' +
                    '</h3>' +
                    '<p class="msg-sub-msg">' +
                    'Please switch to a stable internet connection and start the test again. The test will resume from its last saved state.' +
                    '</p>' +
                    '</span>' +
                    '</div>' +
                    '</div>';
            } else {
                var message = '<div class="row text-left no-internet-row">' +
                    '<div class="col-md-10 col-md-offset-2">' +
                    '<span class="no-wifi">' +
                    '<i class="fa fa-4x fa-wifi" aria-hidden="true"></i>' +
                    '<i class="fa fa-2x fa-exclamation" aria-hidden="true"></i>' +
                    '</span>' +
                    '</br>' +
                    '<span>' +
                    '<h3 class="color-gray">' +
                    msg +
                    '</h3>' +
                    '</span>' +
                    '</div>' +
                    '</div>';
            }

            $state.go('msgPage', { stateParams: btoa(message), isLogout: btoa('true'), msg: btoa(logoutMsg) }, { location: 'replace' });
        }

        function logoutNoInternet() {
            var offlineLogoutTime,
                sl = service.localVar;
            sl.networkFluctuationCounter++;

            if (testInfo.Config && testInfo.Config.logoutIfNoInternetIn) {
                offlineLogoutTime = testInfo.Config.logoutIfNoInternetIn;
                console.log('ss logout time defines', offlineLogoutTime);
                if (sl.logoutTimeout) {
                    $timeout.cancel(service.localVar.logoutTimeout);
                    sl.logoutTimeout = null;
                }
                sl.logoutTimeout = $timeout(function() {
                    console.log('ss inside timeout hvs Var', janus);
                    //console.log('SS from logoutNoInternet isconnect', janus.isConnected());
                    if ((!janus || janus !== null && janus.isConnected() == false) && 
                        sessionStorage.isTestCompleted !== "true") {
                        logOutToMsgPage();
                    }
                }, offlineLogoutTime * 1000);
            }

            if (sl.networkFluctuationLimit && sl.networkFluctuationLimit > 0) {
                if (sl.networkFluctuationCounter >= sl.networkFluctuationLimit) {
                    //console.log('SS from logoutNoInternet isconnect', janus.isConnected());
                    if (janus !== null && janus.isConnected() == false) {
                        logOutToMsgPage();
                    }
                }
            }
        }

        // function killLogoutTimer() {
        //     if (service.localVar.logoutTimeout) {
        //         $timeout.cancel(service.localVar.logoutTimeout);
        //         service.localVar.logoutTimeout = null;
        //     }
        // }
    }
})();

(function() {

    "use strict";

    angular
        .module("OnlineAssessmentAngular")
        .factory("hps", hireproProctoringSupportService);

    function hireproProctoringSupportService($q, $timeout, loginService, webService, debuggerService, assessmentUtility) {
        
        var isRefresh = false,
            joinRetryCallInterval = [15, 30, 45, 45, 45].concat(new Array(36).fill(45)),//Retry upto 30 minutes...
            streamId = null,
            testInfo = loginService.getLoginInfo(),
            types = [],
            service = {
                "goldenImagePath": null,
                "proctoringImagePath": null,
                "start": startSupport,
                "stop": stopSupport,
                "join": initJoiningInfo,
                "getMyRoom": getMyRoom
            };
        return service;

        function startSupport(_types) {
            console.log("sap2_startSupport");
            types = _types;
            return getMyRoom()
                .then(function(res) {
                    var roomInfo = res.data;
                    service.goldenImagePath = roomInfo.goldenImageProctoringPath;
                    return initJoiningInfo(null,null,{
                        "isFetchFromCache":true
                    });
                })
                .then(function(res) {
                    console.log("sap2_startSupport_initJoiningInfo", res);
                    var joiningInfo = res.data;
                    streamId = joiningInfo.streamId;
                    service.proctoringImagePath = joiningInfo.proctoringImagePath;
                    return startPublishing();
                })
                .then(function(res) {
                    console.log("sap2_startSupport_initJanus", res);
                    return $q.resolve(res);
                })
                .catch(function(err) {
                    console.log("sap2_startSupport_catch", err);
                    debuggerService.log({
                        msg: {
                            activity: 'init',
                            success: false,
                            response: err,
                            timestamp: new Date()
                        },
                        source: 'hireproProctoringSupport'
                    });
                    return $q.reject({ data: err.data, msg: err.msg });
                });
        }

        function stopSupport() {
            return stopPublishing();
        }

        function getMyRoom(_rqst) {
            var myRoomInfo = null,
                rqst = _rqst || {};
            testInfo = loginService.getLoginInfo();
            if (testInfo && testInfo.CandidateId && testInfo.TestId) {
                myRoomInfo = angular.fromJson(sessionStorage.getItem(sessionStorage.getItem('X-AUTH-TOKEN') + '-myRoomInfo'));
            }
            if (myRoomInfo) {
                return $q.when({ data: myRoomInfo, msg: "Successfully fetched conference room info!" });
            }

            return webService.execute('getMyRoom', rqst)
                .then(function(res) {
                    if (!res || !res.data) {
                        debuggerService.log({
                            msg: {
                                activity: 'getMyRoom',
                                success: false,
                                apiCall: true,
                                timestamp: new Date()
                            },
                            source: 'hireproProctoringSupport'
                        });
                        return $q.reject({ data: null, msg: "Unable to fetch room info!" });
                    }
                    var xGuid = res.xGuid;
                    res = res.data;
                    myRoomInfo = res;
                    if (res.status === "OK") {
                        if (testInfo.CandidateId && testInfo.TestId) {
                            sessionStorage.setItem(sessionStorage.getItem('X-AUTH-TOKEN') + '-myRoomInfo', angular.toJson(myRoomInfo));
                        }
                        debuggerService.log({
                            msg: {
                                activity: 'getMyRoom',
                                success: true,
                                response: {
                                    conferenceId: res.conferenceId,
                                    displayName: res.displayName,
                                    roomId: res.roomId,
                                    xGuid: xGuid
                                },
                                apiCall: true,
                                timestamp: new Date()
                            },
                            source: 'hireproProctoringSupport'
                        });
                        return $q.resolve({ data: res, msg: "Successfully fetched conference room info!" });

                    } else {
                        var errorMsg = null;
                        if (_.get(res, 'error.errorCode') === 300) {
                            errorMsg = 'Sorry! One candidate is already active.';
                        } else if (_.get(res, 'error.errorCode') === 440) {
                            errorMsg = 'Session Expired';
                        } else {
                            errorMsg = _.get(res, 'error.message');
                        }
                        debuggerService.log({
                            msg: {
                                activity: 'getMyRoom',
                                success: false,
                                response: { data: res, xGuid: xGuid },
                                apiCall: true,
                                timestamp: new Date()
                            },
                            source: 'hireproProctoringSupport'
                        });
                        return $q.reject({ data: 'get my room api failure', msg: errorMsg, activity: 'getMyRoom' });
                    }
                }, function(res) {
                    debuggerService.log({
                        msg: {
                            activity: 'getMyRoom',
                            success: false,
                            response: { data: res.data, xGuid: res.xGuid },
                            apiCall: true,
                            timestamp: new Date()
                        },
                        source: 'hireproProctoringSupport'
                    });
                    return $q.reject({ data: res, msg: 'Login Failed', activity: 'getMyRoom' });
                });
        }

        function initJoiningInfo(isPresentation, _isRefresh, opts) {
            var deffered = $q.defer(),
                joinFailCounter = 0;
            isRefresh = _isRefresh;
            getJoiningInfo(deffered, joinFailCounter, isPresentation, opts);
            return deffered.promise;
        }

        function getJoiningInfo(deffered, joinFailCounter, isPresentation, opts) {
            console.log("sap2_hvs_getJoiningInfo_counter", joinFailCounter);
            testInfo = loginService.getLoginInfo();
            if (!isRefresh) {
                isRefresh = joinFailCounter > 0;
            }
            var joiningInfo = null,
                isFetchFromCache = opts && opts.isFetchFromCache;
            if (testInfo && testInfo.CandidateId && testInfo.TestId) {
                joiningInfo = angular.fromJson(sessionStorage.getItem(sessionStorage.getItem('X-AUTH-TOKEN') + '-joiningInfo'));
            }
            if (isFetchFromCache && joiningInfo && !isRefresh) {
                deffered.resolve(joiningInfo);
                return true;
            }
            var rqst = {
                isRefresh: isRefresh,
                isPresentation: !!isPresentation,
                isMediaFileNameRequired: true
            };
            if(opts && opts.rqst){
                _.merge(rqst,opts.rqst);
            }
            webService.execute('getJoiningInfo', rqst)
                .then(function(res) {
                    console.log("sap2_hvs_getJoiningInfo_success", res);
                    var isSuccess = false,
                        result = { data: null, msg: 'Unable to get joining info!' };
                    if (res && res.data && res.data.status === 'OK') {
                        isSuccess = true;
                        result = { data: res.data.data, msg: 'Successfully fetched joining info!' };
                    }
                    debuggerService.log({
                        msg: {
                            activity: 'getJoiningInfo',
                            success: isSuccess,
                            response: { data: res.data, xGuid: res.xGuid },
                            apiCall: true,
                            timestamp: new Date()
                        },
                        source: 'hireproProctoringSupport'
                    });
                    if (!isSuccess) {
                        return $q.reject(result);
                    }
                    if (testInfo.CandidateId && testInfo.TestId) {
                        sessionStorage.setItem(sessionStorage.getItem('X-AUTH-TOKEN') + '-joiningInfo', angular.toJson(result));
                    }
                    deffered.resolve(result);
                })
                .catch(function(res) {
                    console.log("sap2_hvs_getJoiningInfo_success", res);
                    res = res ? { data: res.data, xGuid: res.xGuid } : null;
                    debuggerService.log({
                        msg: {
                            activity: 'getJoiningInfo',
                            success: false,
                            response: res,
                            apiCall: true,
                            timestamp: new Date()
                        },
                        source: 'hireproProctoringSupport'
                    });
                    if (joinFailCounter < joinRetryCallInterval.length) {
                        console.log("sap2_hvs_getJoiningInfo_recursion_counter", joinFailCounter);
                        $timeout(function() {
                            joinFailCounter++;
                            getJoiningInfo(deffered, joinFailCounter, isPresentation, opts);
                        }, joinRetryCallInterval[joinFailCounter] * 1000);
                    } else {
                        deffered.reject({ data: null, msg: 'Unable to get joining info!' });
                    }
                });
        }

        function startPublishing() {
            var sl = service.localVar,
                request = {
                    goldenImagePath: assessmentUtility.localStorage.getData('savedinS3GoldenImagePath'),
                    isRefresh: false
                };
            return webService.execute('startPublishing', request)
                .then(function(res) {
                        if (!res || !res.data || !res.data.status === 'KO') {
                            debuggerService.log({
                                msg: {
                                    activity: 'startPublishing',
                                    response: res,
                                    success: false,
                                    timestamp: new Date()
                                },
                                source: 'hireproProctoringSupport'
                            });
                            return $q.reject({
                                data: { isPublished: false },
                                msg: "Error occured,while trying to publishing!"
                            });
                        } else {
                            debuggerService.log({
                                msg: {
                                    activity: 'startPublishing',
                                    success: true,
                                    request: request,
                                    response: { data: res.data, xGuid: res.xGuid },
                                    apiCall: true,
                                    timestamp: new Date()
                                },
                                source: 'hireproProctoringSupport'
                            });
                            return $q.resolve({
                                data: { isPublished: true },
                                msg: "Successfully published."
                            });
                        }
                    },
                    function(res) {
                        debuggerService.log({
                            msg: {
                                activity: 'startPublishing',
                                response: res,
                                success: false,
                                timestamp: new Date()
                            },
                            source: 'hireproProctoringSupport'
                        });
                        return $q.reject({
                            data: { isPublished: false },
                            msg: "Error occured,while trying to publishing!"
                        });
                    }
                );
        }

        function stopPublishing() {
            var rq = {
                isFinalInterviewEnd: true,
                streamId: streamId
            };
            return webService.execute('stopPublishing', rq)
                .then(function(res) {
                    console.log("sap2_hvs_stopPublishing_success", res);
                    if (!res || !res.data || !res.data.status === 'KO') {
                        debuggerService.log({
                            msg: {
                                activity: 'stopPublishing',
                                success: false,
                                apiCall: true,
                                timestamp: new Date()
                            },
                            source: 'hireproProctoringSupport'
                        });
                        return $q.reject({
                            data: { isStopped: false },
                            msg: "Unable to stop Confrence!"
                        });
                    }
                    debuggerService.log({
                        msg: {
                            activity: 'stopPublishing',
                            success: true,
                            request: rq,
                            response: { data: res.data, xGuid: res.xGuid },
                            apiCall: true,
                            timestamp: new Date()
                        },
                        source: 'hireproProctoringSupport'
                    });
                    return $q.resolve({
                        data: { isStopped: true },
                        msg: "Confrence is stopped successfully."
                    });
                }, function(res) {
                    console.log("sap2_hvs_stopPublishing_error", res);
                    debuggerService.log({
                        msg: {
                            activity: 'stopPublishing',
                            success: false,
                            request: rq,
                            response: { data: res.data, xGuid: res.xGuid },
                            apiCall: true,
                            timestamp: new Date()
                        },
                        source: 'hireproProctoringSupport'
                    });
                    return $q.reject({
                        data: { isStopped: false },
                        msg: "Unable to stop Confrence!"
                    });
                });
        }
    }

})();

(function() {
    'use strict';
    angular
        .module('OnlineAssessmentAngular')
        .service('folderViewSvc', folderViewSvc);

    function folderViewSvc($log, webService, $q, loginService, commonService) {

        var service = {
                CreateFolderTree: CreateFolderTree(),
                S3FileData: S3FileData()
            },
            cnf = {
                loginInfo: loginService.getLoginInfo()
            };
        return service;

        function CreateFolderTree() {
            var Node = function(label, id, filePath) {
                    return {
                        label: label,
                        id: id,
                        filePath: filePath,
                        children: []
                    }
                },
                addNode = function(parent, child) {
                    parent.children.push(child);
                    return child;
                },
                findNamedNode = function(label, parent) {
                    var data = undefined;
                    if (_.size(parent.children)) {
                        var newData = _.map(parent.children, function(child) {
                            if (data) {
                                return;
                            }
                            if (child.label === label) {
                                data = child;
                                return child
                            }
                            var found = findNamedNode(label, child);
                            if (found) {
                                data = found
                                return found;
                            }
                        });
                        if (data) {
                            return data;
                        }
                    }
                },
                expandAllNodes = function(tree, expandableNodes) {
                    var isLastChild = _.map(tree, function(leaf) {
                        if (leaf.children) {
                            expandableNodes.push(leaf);
                            expandAllNodes(leaf.children, expandableNodes);
                        } else {
                            return expandableNodes;
                        }
                    });
                    return expandableNodes;
                };
            return {
                //[['coding', 'ui', 'index.html'], ['coding', 'ui', 'config.js']]
                create: function(arr, topItem) {
                    var top = Node(topItem),
                        current,
                        filePath,
                        selectableNode;
                    _.forEach(arr, function(children, parentIndex) {
                        current = top;
                        filePath = null;
                        _.forEach(children, function(label, index) {
                            var found = findNamedNode(label, current),
                                filePath = _.slice(children, 0, index + 1).join('/'),
                                currentNodeId = (index + 1) + '.' + (parentIndex + 1);
                            current = found ? found : addNode(current, Node(label, currentNodeId, filePath));
                            if (label === 'app.ts' || label === 'index.jsx') {
                                top.selectableNode = current;
                            }
                        })
                    });
                    return top;
                },
                setOptions: function(unSelecteableFiles) {
                    return {
                        isSelectable: function(node) {
                            return node.label.indexOf("config.js") !== 0 && node.label.indexOf("index.html") !== 0;
                        },
                        injectClasses: {
                            "ul": "c-ul",
                            "li": "c-li",
                            "liSelected": "c-liSelected",
                            "iExpanded": "c-iExpanded",
                            "iCollapsed": "c-iCollapsed",
                            "iLeaf": "c-iLeaf",
                            "label": "c-label",
                            "labelSelected": "c-labelSelected"
                        }
                    };
                },
                expandAllNodes: expandAllNodes
            };
        }

        function S3FileData() {
            var filesData = function(files, stringToBeSplit) {
                    var promises = _.reduce(files, function(acc, data) {
                        var splitByStr = stringToBeSplit || 'test-all-hirepro-files/',
                            key = data.substr(data.indexOf(splitByStr) + splitByStr.length),
                            locationOrigin = (location.origin).search(/\blocalhost\b/) > -1 ? location.origin : 'https://amsin.hirepro.in',
                            apiUrl = data.substr(data.indexOf('https://amsin.hirepro.in') + 'https://amsin.hirepro.in'.length),
                            contentType = 'text/plain';
                        // if (data.search(new RegExp('.html$')) > 0) {
                        //     contentType = 'text/html'
                        // }
                        // if (data.search(new RegExp('.js$')) > 0) {
                        //     contentType = 'application/javascript'
                        // }
                        acc[key] = webService.execute(apiUrl, {}, 'GET', contentType);
                        return acc;
                    }, {});
                    return $q.all(promises)
                        .then(function(res) {
                            var files = _.reduce(res, function(acc, fileData, fileUrl) {
                                if (fileData.status !== 200) {
                                    return acc;
                                }
                                acc[fileUrl] = fileData.data;
                                return acc;
                            }, {});
                            if (_.size(res) !== _.size(files)) {
                                return $q.reject('some file content is missing');
                            }
                            return files;
                        })
                        .catch(function(err) {
                            return $q.reject(err);
                        });
                },
                //--------input------------
                /*
                    {
                        questionId: 1111,
                        isPartialSubmission: Boolean,
                        urlList: {
                            "coding/UI/dubey/config.js": https://s3-ap-southeast-1.amazonaws.com/ams-in-self-expiring-files/1-24h/AT/uploaded/8ff2b7c9-6946-4263-b6bc-5e1ca941993econfig.js",
                            "coding/UI/dubey/index.html": "https://s3-ap-southeast-1.amazonaws.com/ams-in-self-expiring-files/1-24h/AT/uploaded/5ed5aae2-f8fc-4453-91e4-e0293060eb81index.html",
                            "coding/UI/dubey/src/main.ts": "https://s3-ap-southeast-1.amazonaws.com/ams-in-self-expiring-files/1-24h/AT/uploaded/c44ba34a-4f68-41d1-97b9-0f500c6c3f67main.ts",
                            "coding/UI/dubey/src/app.view.html": "https://s3-ap-southeast-1.amazonaws.com/ams-in-self-expiring-files/1-24h/AT/uploaded/4aafdd3e-b991-4048-987e-03113732bad8app.view.html",
                            "coding/UI/dubey/src/app.ts": "https://s3-ap-southeast-1.amazonaws.com/ams-in-self-expiring-files/1-24h/AT/uploaded/1e795655-26d9-4589-9a2e-d60b3f45b593app.ts",
                            "coding/UI/dubey/src/app.css": "https://s3-ap-southeast-1.amazonaws.com/ams-in-self-expiring-files/1-24h/AT/uploaded/96dfde27-459e-4480-859e-1d36dde44d48app.css"
                            }
                    }
                */
                getPersistanceSaveFilesRequest = function(req) {
                    return $q.when().then(function() {
                        var request = {
                            questionId: req.questionId,
                            isPartialSubmission: req.isPartialSubmission,
                            urlsList: _.reduce(req.urlsList, function(acc, url, path) {
                                acc.push({
                                    tempUrl: url,
                                    fileName: path.substr(_.lastIndexOf(path, '/') + 1),
                                    relativePath: path.substr()
                                })
                                return acc;
                            }, [])
                        };
                        return request;
                    })
                },
                /*
                    {
                        “questionId”:<INT| primary key question>,
                        “isPartialSubmission”:”BOOLEAN| true/false”
                        “urlsList”:  [
                            {
                                tempUrl : ”<s3 path>”,
                                relativePth: “<relative path of the folder structure>/<file name>”
                            }
                        ]
                    }

                */
                persistanceSaveForCandidates = function(request) {
                    return webService.execute('makePersistanceSaveCandidateFiles', request).then(function(res) {
                        if (res.error) {
                            return {};
                        }
                        return res.data;
                    });
                };
            return {
                getAllData: function(files, stringToBeSplit) {
                    return filesData(files, stringToBeSplit).then(function(res) {
                        return res;
                    }).catch(function(err) {
                        return $q.reject(err);
                    })
                },
                saveAllFilesUrlFromFileContent: function(fileObject) {
                    var promises = _.reduce(fileObject, function(acc, data, index) {
                        var fileName = index.substr(_.lastIndexOf(index, '/') + 1),
                            typeMap = {
                                html: 'text/html',
                                js: 'text/plain',
                                css: 'text/css',
                                ts: 'text/plain'
                            },
                            type = _.last(fileName.split('.')),
                            blobData = new Blob([data], { type: typeMap[type] }),
                            fd = new FormData(),
                            constraint = {
                                "fileExtentions": '.' + type + ',',
                                "fileSizeLimit": 5000
                            },
                            request = {
                                // "data": fd,
                                "action": "uploadFileToS3",
                                "fileExtentions": constraint.fileExtentions,
                                "fileSizeLimit": constraint.fileSizeLimit,
                                "meta": {},
                                "testId": cnf.loginInfo.TestId,
                                "candidateId": cnf.loginInfo.CandidateId,
                                "targetBucket": ''
                            };
                        fd.append("file", blobData, fileName);
                        request.data = fd;
                        acc[index] = commonService.uploadFile(request)
                        return acc;
                    }, {});
                    return $q.all(promises)
                        .then(function(res) {
                            return _.reduce(res, function(acc, files, foldrUrl) {
                                if (files.data) {
                                    acc[foldrUrl] = files.data
                                }
                                return acc;
                            }, {});
                        }).catch(function(err) {
                            return $q.reject(err);
                        })
                },
                //--------input------------
                /*
                    {
                        questionId: 1111,
                        isPartialSubmission: Boolean,
                        urlsList: {
                            "coding/UI/dubey/config.js": https://s3-ap-southeast-1.amazonaws.com/ams-in-self-expiring-files/1-24h/AT/uploaded/8ff2b7c9-6946-4263-b6bc-5e1ca941993econfig.js",
                            "coding/UI/dubey/index.html": "https://s3-ap-southeast-1.amazonaws.com/ams-in-self-expiring-files/1-24h/AT/uploaded/5ed5aae2-f8fc-4453-91e4-e0293060eb81index.html",
                            "coding/UI/dubey/src/main.ts": "https://s3-ap-southeast-1.amazonaws.com/ams-in-self-expiring-files/1-24h/AT/uploaded/c44ba34a-4f68-41d1-97b9-0f500c6c3f67main.ts",
                            "coding/UI/dubey/src/app.view.html": "https://s3-ap-southeast-1.amazonaws.com/ams-in-self-expiring-files/1-24h/AT/uploaded/4aafdd3e-b991-4048-987e-03113732bad8app.view.html",
                            "coding/UI/dubey/src/app.ts": "https://s3-ap-southeast-1.amazonaws.com/ams-in-self-expiring-files/1-24h/AT/uploaded/1e795655-26d9-4589-9a2e-d60b3f45b593app.ts",
                            "coding/UI/dubey/src/app.css": "https://s3-ap-southeast-1.amazonaws.com/ams-in-self-expiring-files/1-24h/AT/uploaded/96dfde27-459e-4480-859e-1d36dde44d48app.css"
                            }
                    }
                */
                persistanceSaveCandidateFiles: function(request) {
                    return getPersistanceSaveFilesRequest(request).then(function(req) {
                        return persistanceSaveForCandidates(req)
                    }).then(function(res) {
                        if (!_.size(res)) {
                            return [];
                        }
                        return res.persistentUrls || [];
                    })
                }
            }
        }
    }
})();

(function() {
    "use strict";

    angular
        .module("OnlineAssessmentAngular")
        .service("fileIOHelper", fileIOHelperService);

    function fileIOHelperService($q, $log, growl, loginService, assessmentUtility, commonService, webService) {
    	var fileExtensionAllowed = ".gif,.png,.jpg,.jpeg,.doc,.docx,.rtf,.pdf,.txt,.xls,.xlsx,.csv,.zip,.rar,.7z,.gz,.r,.ipynb,.ppt,.pps,.pptx,.ods,.rmd,.py,.json",
    		fileSizeAllowed = 5.6,
    		service = {
            	blobToBase: blobToBase,
            	dataURItoBlob: dataURItoBlob,
            	uploadToTemp: uploadToTemp,
                uploadWithVirusScan: uploadWithVirusScan
        	};
        return service;

        function blobToBase(blob) {
        	var deffered = $q.defer(),
            	reader = new FileReader();
            reader.readAsDataURL(blob);
            reader.onloadend = function() {
                deffered.resolve(reader.result);
            };
            return deffered.promise;
        }

        function dataURItoBlob(dataurl, filename) {
            var arr = dataurl.split(',');
            try {
                arr[0].match(/:(.*?);/)[1]
            } catch (e) {
                return $q.reject({});
            }
            var mime = arr[0].match(/:(.*?);/)[1],
                bstr = atob(arr[1]),
                n = bstr.length,
                u8arr = new Uint8Array(n);
            while (n--) {
                u8arr[n] = bstr.charCodeAt(n);
            }
            var newFileName = filename.substr(0, filename.lastIndexOf('.')) || filename,
                mineExtension = mime.substr(mime.lastIndexOf('/') + 1) || mime;
            filename = newFileName + '.' + mineExtension;
            return $q.when(new File([u8arr], filename, {
                type: mime
            }));
        }

        function uploadToTemp(data, allowedFileExtension, allowedFileSize) {
            // var errorUploadedAttachment = "",
            //     files = evt.target.files,
            //     data = getFormData(files);
            // evt.target.value = '';
            if (commonService.testIsOnlinePreview() || !data) {
                return false;
            }
            // vm.isSwitchingFromCurrentQuestionEnable = false;
            allowedFileExtension = allowedFileExtension || fileExtensionAllowed;
            allowedFileSize = allowedFileSize || fileSizeAllowed;
            var constraint = {
                "fileExtentions": allowedFileExtension,
                "fileSizeLimit": parseInt(allowedFileSize * 1024)
            };
            return webService.execute("uploadFileToS3WithOutVirusScan", data, "POST", null, null, constraint)
                .then(function(res) {
                        if (!res || !res.data) {
                            $log.error("Unable to upload file!");
                            return false;
                        }
                        res = res.data;
                        if (res.error && res.status == 'KO') {
                            errorUploadedAttachment = res.error.errorDescription || "File upload failed";
                            // growl.error(errorUploadedAttachment, { ttl: 4000, disableCountDown: true });
                            // vm.isSwitchingFromCurrentQuestionEnable = true;
                            return false;
                        }
                        if (res.data) {
                            $log.log("File Uploaded Successfully");
                            //console.log(response.data.data.fileUrl);
                            var fileUrls = getAttachmentUrls(res.data, "fileUrl");
                            return persistenceSave(fileUrls);
                        }
                    },
                    function(res) {
                        // growl.error("Error occurred when Uploading File", { ttl: 4000, disableCountDown: true });
                        // vm.isSwitchingFromCurrentQuestionEnable = true;
                        return false;
                    }
                );
        }

        function persistenceSave(fileUrls) {
            var aliasText = assessmentUtility.getAlias(),
            	loginInfo = loginService.getLoginInfo(),
                persistentSaveRq = [],
                testId,
                candidateId;
            if (aliasText) {
                aliasText = aliasText.toLowerCase();
            }
            if (loginInfo) {
	            candidateId = loginInfo.CandidateId;
	            testId = loginInfo.TestId;
	        }
            if (_.size(fileUrls) == 0) {
                return false;
            }
            _.forEach(fileUrls, function(fileUrl) {
                var rq = {
                    "origFileUrl": fileUrl,
                    "relativePath": aliasText + "/testResultAnswers/" + testId + "/" + candidateId,
                    "isSync": true
                };
                rq.metaData = {
                    "timeStamp": new Date()
                };
                persistentSaveRq.push(rq);
            });
            if (commonService.testIsOnlinePreview()) {
                return false;
            }
            // vm.isSwitchingFromCurrentQuestionEnable = false;
            return webService.execute("persistentSave", persistentSaveRq)
                .then(
                    function(response) {
                        if (response) {
                            $log.log("Files saved Successfully");
                            growl.success("File Uploaded Successfully", { ttl: 4000, disableCountDown: true });
                            return getAttachmentUrls(response.data.data, "s3_url");
                            // appendAttachmentsToQuestionObj(s3Urls);
                        }
                    },
                    function() {
                        $log.log("Error occurred when persisting File");
                        return null;
                    }
                )
                // .finally(function() {
                //     vm.isSwitchingFromCurrentQuestionEnable = true;
                // })
                ;
        }

        function uploadWithVirusScan (data, allowedFileExtension, allowedFileSize) {
            var errorUploadedAttachment = "";
            if (commonService.testIsOnlinePreview() || !data) {
                return false;
            }
            allowedFileExtension = allowedFileExtension || fileExtensionAllowed;
            allowedFileSize = allowedFileSize || fileSizeAllowed;
            var constraint = {
                "fileExtentions": allowedFileExtension,
                "fileSizeLimit": parseInt(allowedFileSize * 1024)
            };
            return webService.execute("uploadFileToS3WithVirusScan", data, "POST", null, null, constraint)
                .then(function(res) {
                        if (!res || !res.data) {
                            growl.error('Unable to upload file!', { ttl: 4000, disableCountDown: true });
                            $log.error("Unable to upload file!");
                            return false;
                        }
                        res = res.data;
                        if (res.error && res.status == 'KO') {
                            errorUploadedAttachment = res.error.errorDescription || "File upload failed";
                            growl.error(errorUploadedAttachment, { ttl: 4000, disableCountDown: true });
                            return false;
                        }
                        if (res.data) {
                            $log.log("File Uploaded Successfully");
                            //console.log(response.data.data.fileUrl);
                            var fileUrls = getAttachmentUrls(res.data, "fileUrl");
                            return persistenceSave(fileUrls);
                        }
                    },
                    function(res) {
                        growl.error("Error occurred when Uploading File", { ttl: 4000, disableCountDown: true });
                        return false;
                    }
                );
        }

        function getAttachmentUrls(res, prop) {
            var fileUrls = [];
            res = res.successList || res.SuccessList || res;
            if (res[prop]) {
                fileUrls.push(res[prop]);
            } else if (_.size(res) > 0) {
                _.map(res, function(file) {
                    fileUrls.push(file[prop]);
                });
            }
            return fileUrls;
        }
    }
})();

(function() {
    'use strict';
    angular
        .module("OnlineAssessmentAngular")
        .factory("faceTracker", faceTracker);

    function faceTracker($injector, $q) {
        var isFaceLandmarks = JSON.parse(sessionStorage.getItem('faceLandmarks'));
        if (!isFaceLandmarks) {
            // window.myWorker = new Worker("/s3_cached/hirepro-content/hirepro/proctoring-resources/js/tracker-worker_v2.js");
            window.myWorker = new Worker("/s3_cached/hirepro-content/hirepro/proctoring-resources/js/tracker-worker_v3.js");
            //window.myWorker = new Worker("/assessmentsuraj/worker/worker_v2.js"); 
            // /s3_cached/hirepro-content/hirepro/proctoring-resources/js/tracker-worker.js
        }

        var $log = $injector.get('$log'),
            $q = $injector.get('$q'),
            service = {
                start: start,
                stop: stop,
                processRawFaceCountCollection: processRawFaceCountCollection,
                getUserPresenceStatus: getUserPresenceStatus,
                checkAllTheSame: checkAllTheSame,
                getFps: getFps,
                keepRawInfo: keepRawInfo,
                config: {
                    getFpsDefer: null,
                    trackerTask: null,
                    samplingSize: 3,
                    faceCount: 0,
                    fps: 0,
                    faceCountCollection: [],
                    videoElementId: 'faceTracVid',
                    rawFaceCountCollection: [],
                    rawFaceRecord: []
                },
                utility: {
                    getMaxOccuredElem: function(arr) {
                        var maxOccuredElem = false;
                        if (!arr || _.size(arr) === 0) {
                            return maxOccuredElem;
                        }
                        var occurrenceCount = 1,
                            checkedElem = {};
                        maxOccuredElem = arr[0];
                        for (var i = 0; i < arr.length; i++) {
                            if (arr[i] <= 0) {
                                continue;
                            }
                            var count = 1;
                            if (checkedElem[arr[i]]) {
                                continue;
                            }
                            for (var j = (i + 1); j < arr.length; j++) {
                                if (arr[i] == arr[j]) {
                                    count++;
                                }
                            }
                            if (count > 1) {
                                checkedElem[arr[i]] = count;
                            }
                            if (count > occurrenceCount || (count == occurrenceCount && arr[i] > maxOccuredElem)) {
                                occurrenceCount = count;
                                maxOccuredElem = arr[i];
                            }
                        }
                        return maxOccuredElem;
                    },
                    getConsecutivelyOccuredElem: function(arr, samplingSize) {
                        var self = this;
                        if (samplingSize <= 0) {
                            return false;
                        }
                        var faceCount = 0,
                            consicutiveOccurence = false;
                        if (arr.length > samplingSize) {
                            var conOc = false,
                                abort = false;
                            for (var i = 0; i < arr.length && !abort; i++) {
                                if (arr[i] <= 0) {
                                    continue;
                                }
                                for (var j = 0; j < samplingSize - 1; j++) {
                                    conOc = true;
                                    if ((i + j + 1) > arr.length || (i + j) > arr.length) {
                                        abort = true;
                                        break;
                                    } else if (arr[i + j] != arr[i + j + 1]) {
                                        conOc = false;
                                        break;
                                    }
                                }
                                if (!conOc) {
                                    continue;
                                }
                                consicutiveOccurence = true;
                                if (arr[i] >= faceCount) {
                                    faceCount = arr[i];
                                }
                            }
                        }
                        if (!consicutiveOccurence) {
                            consicutiveOccurence = true;
                            //return self.getMaxElem(arr);
                            return self.getMaxOccuredElem(arr);
                        } else {
                            return faceCount;
                        }
                    }
                }
            },
            tempFaceRecord = [];
        return service;
        //options:{
        //   videoElementId   (default element id:'faceTracVid'  Id without #),
        //   stream : mediastream
        //}
        function start(options) {
            if (!window.myWorker) {
                // window.myWorker = new Worker("/s3_cached/hirepro-content/hirepro/proctoring-resources/js/tracker-worker_v2.js");
                window.myWorker = new Worker("/s3_cached/hirepro-content/hirepro/proctoring-resources/js/tracker-worker_v3.js");

                //window.myWorker = new Worker("/assessmentsuraj/worker/worker_v2.js");
                // window.myWorker = new Worker("/assessmentsuraj/worker/tracker-worker.js");
            }

            var videoElementId = 'faceTracVid',
                cnf = service.config,
                stream = null;
            return $q(function(resolve, reject) {
                if (angular.isDefined(options) && angular.isObject(options)) {
                    if (angular.isDefined(options.videoElementId)) {
                        videoElementId = options.videoElementId;
                    }
                    stream = options.stream;
                }
                if (!stream) {
                    $log.error("stream is not defined");
                    return false;
                }
                try {
                    var tracker = new tracking.ObjectTracker('face');
                    tracker.setInitialScale(2);
                    tracker.setStepSize(2);
                    tracker.setEdgesDensity(0.1);
                    cnf.trackerTask = tracking.track(
                        '#' + videoElementId,
                        tracker, stream
                    );
                    window.myWorker.onmessage = function(event) {
                        tracker.emit('track', event);
                    };

                    var typeOfTest = sessionStorage.getItem('typeOfTest'),
                        testStatus = sessionStorage.getItem('testStarted'),
                        isDesktop = sessionStorage.getItem('isDesktop') === 'true' ? true : false,
                        // frameDuration = parseInt(sessionStorage.getItem('frameDelayTime')),
                        // frameReadTimeInMs = parseInt(sessionStorage.getItem('frameReadTimeInMs'));
                        frameReadDuringFaceTrackingPerMs = JSON.parse(sessionStorage.getItem('frameReadDuringFaceTrackingPerMs')),
                        frameReadTimeVersantInMs = parseInt(sessionStorage.getItem('frameDelayTime')),
                        // frameReadTimeGenInMs = parseInt(sessionStorage.getItem('frameReadTimeGenInMs')),
                        workerObject = {
                            context: 'default',
                            typeOfTest: typeOfTest,
                            testStatus: testStatus,
                            isDesktop: isDesktop
                        };
                    if (typeOfTest == 'versant') {
                        workerObject.context = 'modifyDelay';
                        workerObject.frameDuration = frameReadTimeVersantInMs;
                    } else if (frameReadDuringFaceTrackingPerMs !== null && frameReadDuringFaceTrackingPerMs.hasOwnProperty(typeOfTest)) {
                        workerObject.context = 'modifyDelayGeneral';
                        workerObject.frameReadTimeInMs = parseInt(frameReadDuringFaceTrackingPerMs[typeOfTest]);
                    } else if (frameReadDuringFaceTrackingPerMs !== null && frameReadDuringFaceTrackingPerMs.hasOwnProperty('generic')) {
                        workerObject.context = 'modifyDelayGeneral';
                        workerObject.frameReadTimeInMs = parseInt(frameReadDuringFaceTrackingPerMs['generic']);
                    }
                    if (window.myWorker) {
                        window.myWorker.postMessage(workerObject);
                    }
                    var fps = 0,
                        date1, date2, facesArray = [];
                    tracker.on('track', function(event) {
                        if (event.data) {
                            var data = event.data;
                            // cnf.rawFaceCountCollection.push(event.data.length);
                            if (options.calculateFaceCount) {
                                data = calculateArea(event.data, options.calculateFaceCountPercent);
                            }
                            cnf.rawFaceCountCollection.push(data.length);
                            facesArray.push(data.length);
                        }

                        fps++;
                        if (!date1) {
                            date1 = Date.now();
                        }
                        date2 = Date.now();
                        if (date2 - date1 > 1000) {
                            //console.log("sap_fps", fps, facesArray);
                            cnf.getFpsDefer = cnf.getFpsDefer || $q.defer();
                            cnf.getFpsDefer.resolve(fps);
                            date1 = Date.now();
                            fps = 0;
                            facesArray = [];
                        }
                    });
                    //tracker.on('updateFps', function(event) {
                    //if (event.fps) {
                    //console.log("sap_fps", event.fps);
                    //cnf.getFpsDefer = cnf.getFpsDefer || $q.defer();
                    //cnf.getFpsDefer.resolve(event.fps);
                    //}
                    //});
                } catch (e) {
                    $log.error(e);
                    reject(false);
                }
                resolve(true);
            });
        }

        function calculateArea(data, per) {
            if (data.length < 2) {
                return data;
            } else {
                data = _.sortBy(data, [function(o) { return o.height * o.width; }]);
                var maxValue = _.last(data),
                    maxArea = maxValue.height * maxValue.width,
                    minArea = (maxArea / 100) * (per);
                return _.remove(data, function(n) {
                    return n.height * n.width <= minArea;
                });
            }
        }

        function processRawFaceCountCollection(timeSpan) {
            var sc = service.config;
            if (!timeSpan) {
                timeSpan = 10;
            }
            //console.log('Initial Raw', sc.rawFaceCountCollection);
            if (_.size(sc.rawFaceCountCollection) > 0) {
                keepRawInfo('add', sc.rawFaceCountCollection);
                sc.faceCount = service.utility.getMaxOccuredElem(sc.rawFaceCountCollection);
                sc.trackingspeed = sc.rawFaceCountCollection.length;
            } else if (_.size(sc.faceCountCollection) > 0) {
                sc.faceCount = sc.faceCountCollection[sc.faceCountCollection.length - 1];
            }
            sc.faceCountCollection.push(sc.faceCount);
            // console.log('face Count', sc.faceCountCollection);
            sessionStorage.setItem('currentFaceCount', _.last(sc.faceCountCollection));
            if (sc.faceCountCollection.length > timeSpan) {
                sc.faceCountCollection.shift();
            }
            //console.log('SSRAWC',sc.rawFaceCountCollection);
            //console.log(sc.faceCountCollection, 'SSFC');
            sc.rawFaceCountCollection.length = 0;
        }

        function getUserPresenceStatus(arrayType) {
            var data = {},
                sc = service.config;
            data.isOutOfFocus = checkAllTheSame(sc.faceCountCollection);
            switch (arrayType) {
                case "MAX":
                    data.decidedFaceCount = service.utility.getConsecutivelyOccuredElem(sc.faceCountCollection, service.config.samplingSize);
                    break;
                case "MIN":
                    data.decidedFaceCount = service.utility.getMaxOccuredElem(sc.faceCountCollection);
                    break;
            }
            return data;
        }

        function checkAllTheSame(array) {
            if (_.size(array) === 0) {
                return;
            }
            var first = 0;
            return array.every(function(element) {
                return element === first;
            });
        }

        function stop() {
            if (window.myWorker) {
                window.myWorker.terminate();
                window.myWorker = null;
            }

            return $q(function(resolve, reject) {
                if (!service.config.trackerTask) {
                    return reject(false);
                }
                try {
                    service.config.trackerTask.stop();
                    service.config.faceCount = 0;
                } catch (e) {
                    $log.error(e);
                    reject(false);
                }
                service.config.getFpsDefer = null;
                resolve(true);
            });
        }

        function getFps() {
            var cnf = service.config;
            cnf.getFpsDefer = cnf.getFpsDefer || $q.defer();
            return cnf.getFpsDefer.promise;
        }

        function keepRawInfo(type, data) {
            var sc = service.config,
                tempHolding = [];
            if (type === 'add') {
                if (data.length >= 10) {
                    sc.rawFaceRecord.push(_.takeRight(data, 10));
                } else if (data.length < 10 && tempFaceRecord.length < 10) {
                    tempFaceRecord.push(data);
                    if (tempFaceRecord.length >= 10) {
                        sc.rawFaceRecord.push(tempFaceRecord);
                        tempFaceRecord.length = 0;
                    }
                    if (sc.rawFaceRecord.length > 40) {
                        sc.rawFaceRecord.shift();
                    }
                }

            } else if (type === 'get') {
                //console.log('Handle keepRawInfo', sc.rawFaceRecord);
                Object.assign(tempHolding, sc.rawFaceRecord);
                sc.rawFaceRecord.length = 0;
                /*if(tempHolding && tempHolding.length > 0) {
                    tempHolding.splice(0,20);
                }*/
                return tempHolding;
            }
        }
    }
})();

(function() {
    'use strict';
    angular
        .module("OnlineAssessmentAngular")
        .factory("faceRecognitionService", faceRecognitionService);

    /* @ngInject */
    function faceRecognitionService($q, loginService, commonService, assessmentUtility) {
        var service = {
                preProccessingImageInfos: {},
                preProccessingFaceMatchData: {},
                allSecondaryImageConfidence: {},
                getImageInfo: getImageInfo,
                loadFaceApiAllModals: loadFaceApiAllModals,
                getImageCompareInfo: getImageCompareInfo,
                setFaceRecogConfig: setFaceRecogConfig
            },
            isServiceLoaded = false,
            faceRecogConfig = undefined;
        return service;

        function setFaceRecogConfig(proctoringInfo) {
            return $q.when().then(function() {
                faceRecogConfig = proctoringInfo.clientFaceRecognitionConfig;
            })
        }
        /*
         * load all required modal
         * ageGenderNet is required to load ages and genders
         * faceExpressionNet required for face expression
         * faceLandmark68Net required for landmark info
         * faceLandmark68TinyNet required for landmark with tiny algorithm
         * faceRecognitionNet required for face recognition
         * ssdMobilenetv1 (Single Shot Multibox Detector) this modal is required 
            to create a box arround faces
         * tinyFaceDetector another way of loading faces
        */
        function loadFaceApiAllModals() {
            return $q.all([
                // faceapi.nets.ageGenderNet.loadFromUri('/thirdParty/models'),
                // faceapi.nets.faceExpressionNet.loadFromUri('/thirdParty/models'),
                faceapi.nets.faceLandmark68Net.loadFromUri('/thirdParty/models'),
                // faceapi.nets.faceLandmark68TinyNet.loadFromUri('/thirdParty/models'),
                faceapi.nets.faceRecognitionNet.loadFromUri('/thirdParty/models'),
                faceapi.nets.ssdMobilenetv1.loadFromUri('/thirdParty/models')
                // faceapi.nets.tinyFaceDetector.loadFromUri('/thirdParty/models')
            ]).then(function() {
                isServiceLoaded = true;
                assessmentUtility.sessionStorage.setData("isFaceRecognitionRequired", true);
            });
        }
        // single image information
        /*
         * input of this function is 
           ** imageUrl
         * output is 
         {
           isFaceDetected: true| false,// this property will tell wether we ll recognized a face or not
           totalFaceDetectedCount: 1, // how many faces we recognized
           confidence: 60, how much % we are sure that we recognized faces
           infos: [{
             age: 23.63,//age
             gender: 'male'| 'female',//gender
             genderConfidence: 98// how much percent we are sure that we recognized gender of the person
           }],
           faceDetections: []//detections object, this is for development purpose
          }
        */
        function getImageInfo(imageUrl) {
            var detections, isThreshold;
            if (service.preProccessingImageInfos[imageUrl]) {
                return $q.when(service.preProccessingImageInfos[imageUrl]);
            }
            return $q.when()
                .then(function() {
                    if (!isServiceLoaded) {
                        return loadFaceApiAllModals();
                    }
                })
                .then(function() {
                    return getImgByImgUrl(imageUrl);
                })
                .then(function(img) {
                    // if (_.get(faceRecogConfig, 'faceDetectionModel', undefined) === 'ssdMobilenetv1') {
                    //     return faceapi.detectAllFaces(img, new faceapi.SsdMobilenetv1Options(
                    //         _.get(faceRecogConfig, 'ssdMobilenetv1Options'))).withFaceDescriptors();
                    // }
                    // if (_.get(faceRecogConfig, 'faceDetectionModel', undefined) === 'tinyFaceDetector') {
                    //     return faceapi.detectAllFaces(img, new faceapi.TinyFaceDetectorOptions(
                    //         _.get(faceRecogConfig, 'tinyFaceDetectorOptions'))).withFaceDescriptors();
                    // }
                    // faceapi.detectAllFaces(img).withFaceLandmarks().withFaceExpressions().withAgeAndGender().withFaceDescriptors();
                    return faceapi.detectAllFaces(img).withFaceLandmarks().withFaceDescriptors();
                })
                .then(function(results) {
                    if (!_.size(results)) {
                        return $q.when()
                    }
                    detections = results;
                    return new faceapi.FaceMatcher(results, 0.6)
                })
                .then(function(resultData) {
                    if (!resultData) {
                        return {
                            sourceImageFace: {
                                Confidence: 0,
                                BoundingBox: undefined
                            },
                            faceDetections: [] //this object stores the detection of a single image
                        };
                    }
                    var scoreMatch = _.get(detections, [0, 'detection', 'score']) || 0,
                        box = _.get(detections, [0, 'detection', 'box']);
                    return {
                        sourceImageFace: {
                            Confidence: Number((scoreMatch * 100).toFixed()),
                            BoundingBox: {
                                Width: box.width,
                                Height: box.height,
                                Left: box.x,
                                Top: box.y
                            }
                        },
                        faceDetections: {
                            detections: detections,
                            matchesAgainst: resultData
                        } //this object stores the detection of a single image
                    };
                })
                .then(function(infoData) {
                    service.preProccessingImageInfos[imageUrl] = infoData;
                    return infoData;
                });
        }

        function getImgByImgUrl(imageUrl) {
            var img = new Image();
            img.src = imageUrl;
            img.crossOrigin = "Anonymous";
            var dataURL;
            img.onload = function() {
                var canvas = document.createElement('CANVAS');
                var ctx = canvas.getContext('2d');
                canvas.height = this.height;
                canvas.width = this.width;
                ctx.drawImage(this, 0, 0);
                dataURL = canvas.toDataURL("image/jpeg");
                canvas = null;
            };
            return img;
        }

        /*
         * {
             primaryImageUrl: url,
             secondaryImageFileData: fileData,

         }
        */
        function getImageCompareInfo(primaryImageUrl, secondaryImageFileData) {
            var json = {
                FaceMatches: []
            }
            return $q.when()
                .then(function() {
                    if (!isServiceLoaded) {
                        return loadFaceApiAllModals();
                    }
                })
                .then(function() {
                    return $q.all({
                        primaryImageInfo: getImageInfo(primaryImageUrl),
                        secondaryImageInfo: loadSnapshotImages(secondaryImageFileData)
                    })
                })
                .then(function(res) {
                    return imageCompare({
                        primaryImageData: res.primaryImageInfo,
                        secondaryImageFileData: res.secondaryImageInfo
                    });
                })
                .then(function(faceCompared) {
                    if (_.size(faceCompared.faceMatched)) {
                        json.FaceMatches = _.orderBy(faceCompared.faceMatched, ['Similarity'], ['desc']);
                    }
                    if (_.size(faceCompared.faceUnmatched)) {
                        var unmatchedList = faceCompared.faceUnmatched,
                            matchedFaceArea = json.FaceMatches[0].Face.BoundingBox.Width * json.FaceMatches[0].Face.BoundingBox.Height;
                        if (faceRecogConfig.NeglectFaceWithAreaRatio) {
                            unmatchedList = _.filter(faceCompared.faceUnmatched, function(matches) {
                                var areaInRespectToPrimary = (matches.Face.BoundingBox.Width * matches.Face.BoundingBox.Height) * faceRecogConfig.NeglectFaceWithAreaRatio;
                                return areaInRespectToPrimary > matchedFaceArea;
                            });
                        }
                        json.FaceMatches = json.FaceMatches.concat(unmatchedList);
                    }
                    return _.size(json.FaceMatches) ? json : undefined;
                });
        }

        function loadSnapshotImages(secondaryImageFileData) {
            return faceapi.bufferToImage(secondaryImageFileData).then(function(img) {
                return faceapi.detectAllFaces(img).withFaceLandmarks().withFaceDescriptors();
            }).then(function(detections) {
                return {
                    faceDetections: {
                        detections: detections
                    }
                }
            })
        }

        function imageCompare(data) {
            var matchedResultJson = {};
            if (!data || !data.primaryImageData || !data.secondaryImageFileData) {
                return $q.reject();
            }
            return $q.when()
                .then(function() {
                    var results = _.map(data.secondaryImageFileData.faceDetections.detections, function(d) {
                        return data.primaryImageData.faceDetections.matchesAgainst.findBestMatch(d.descriptor);
                    });
                    return _.reduce(results, function(faceMatchAndUnMatch, result, index) {
                        var scoreMatch = _.get(data.secondaryImageFileData.faceDetections.detections, [index, 'detection', 'score']) || 0,
                            box = _.get(data.secondaryImageFileData.faceDetections.detections, [index, 'detection', 'box']);

                        if (result._label === 'unknown') {
                            faceMatchAndUnMatch.faceUnmatched.push({
                                Similarity: Number(((1 - result.distance) * 100).toFixed()),
                                Face: {
                                    Confidence: Number((scoreMatch * 100).toFixed()),
                                    BoundingBox: {
                                        Width: box.width,
                                        Height: box.height,
                                        Left: box.x,
                                        Top: box.y
                                    }
                                }
                            })
                            return faceMatchAndUnMatch;
                        }
                        faceMatchAndUnMatch.faceMatched.push({
                            Similarity: Number(((1 - result.distance) * 100).toFixed()),
                            Face: {
                                Confidence: Number((scoreMatch * 100).toFixed()),
                                BoundingBox: {
                                    Width: box.width,
                                    Height: box.height,
                                    Left: box.x,
                                    Top: box.y
                                }
                            }
                        })
                        return faceMatchAndUnMatch;
                    }, {
                        faceMatched: [],
                        faceUnmatched: []
                    });
                });
        }

    }
})();

(function() {
    'use strict';
    angular
        .module("OnlineAssessmentAngular")
        .factory("faceLandmarks", faceLandmarks);

    function faceLandmarks($q, $timeout, blockUI, commonService, loggerService) {
        var service = {
                init: init,
                start: start,
                stop: stop,
                processRawFaceCountCollection: processRawFaceCountCollection,
                getUserPresenceStatus: getUserPresenceStatus,
                keepRawInfo: keepRawInfo,
                getFps: getFps,
                getPredictions: getPredictions,
                config: {
                    getFpsDefer: null,
                    trackerTask: null,
                    samplingSize: 3,
                    faceCount: 0,
                    fps: 0,
                    faceCountCollection: [],
                    rawFaceCountCollection: [],
                    rawFaceRecord: [],
                    rawFacePredictions: []
                }
            },
            tempFaceRecord = [],
            opt,
            callType,
            isTrackerRunning = false,
            eventListenerOnPlay = false,
            modelPromise,
            model,
            renderPredictionTimeout = 20,
            videoElementId = 'faceTracVid',
            video,
            frameDuration = 1,
            fps = 0,
            fpsFirstSecSkip = false,
            checkFaceLandmark = false,
            date1, date2;
        return service;

        function start(options) {
            var typeOfTest = sessionStorage.getItem('typeOfTest'),
                testStatus = sessionStorage.getItem('testStarted'),
                isDesktop = sessionStorage.getItem('isDesktop') === 'true' ? true : false;
            if (testStatus === 'continue' && (typeOfTest === 'versant' || !isDesktop)) {
                frameDuration = parseInt(sessionStorage.getItem('frameDelayTime'));
                if (frameDuration) {
                    renderPredictionTimeout = frameDuration;
                }
            }
            if (angular.isDefined(options) && angular.isObject(options)) {
                opt = options;
                // if (angular.isDefined(options.videoElementId)) {
                //     videoElementId = options.videoElementId;
                // }
                if (!options.stream) {
                    $log.error("stream is not defined");
                    return false;
                }
                //video = document.getElementById(videoElementId);
                //video.srcObject = options.stream;
            }
            isTrackerRunning = true;
            if (modelPromise) {
                startVideo();
            } else {
                init();
            }
        }

        function stop() {
            isTrackerRunning = false;
            modelPromise = null;
            service.config.getFpsDefer = null;
        }

        function getFps() {
            var cnf = service.config;
            cnf.getFpsDefer = cnf.getFpsDefer || $q.defer();
            return cnf.getFpsDefer.promise;
        }

        function getPredictions() {
            var data = service.config.rawFacePredictions;
            return data;
        }

        function processRawFaceCountCollection(timeSpan) {
            var sc = service.config;
            if (!timeSpan) {
                timeSpan = 10;
            }
            if (_.size(sc.rawFaceCountCollection) > 0) {
                keepRawInfo('add', sc.rawFaceCountCollection);
                sc.faceCount = getMaxOccuredElem(sc.rawFaceCountCollection);
                sc.trackingspeed = sc.rawFaceCountCollection.length;
            } else if (_.size(sc.faceCountCollection) > 0) {
                sc.faceCount = sc.faceCountCollection[sc.faceCountCollection.length - 1];
            }
            sc.faceCountCollection.push(sc.faceCount);
            sessionStorage.setItem('currentFaceCount', _.last(sc.faceCountCollection));
            if (sc.faceCountCollection.length > timeSpan) {
                sc.faceCountCollection.shift();
            }
            sc.rawFaceCountCollection.length = 0;
        }

        function getUserPresenceStatus(arrayType) {
            var data = {},
                sc = service.config;
            data.isOutOfFocus = checkAllTheSame(sc.faceCountCollection);
            switch (arrayType) {
                case "MAX":
                    data.decidedFaceCount = getConsecutivelyOccuredElem(sc.faceCountCollection, service.config.samplingSize);
                    break;
                case "MIN":
                    data.decidedFaceCount = getMaxOccuredElem(sc.faceCountCollection);
                    break;
            }
            return data;
        }

        function keepRawInfo(type, data) {
            var sc = service.config,
                tempHolding = [];
            if (type === 'add') {
                if (data.length >= 10) {
                    sc.rawFaceRecord.push(_.takeRight(data, 10));
                } else if (data.length < 10 && tempFaceRecord.length < 10) {
                    tempFaceRecord.push(data);
                    if (tempFaceRecord.length >= 10) {
                        sc.rawFaceRecord.push(tempFaceRecord);
                        tempFaceRecord.length = 0;
                    }
                    if (sc.rawFaceRecord.length > 40) {
                        sc.rawFaceRecord.shift();
                    }
                }

            } else if (type === 'get') {
                Object.assign(tempHolding, sc.rawFaceRecord);
                sc.rawFaceRecord.length = 0;
                /*if(tempHolding && tempHolding.length > 0) {
                    tempHolding.splice(0,20);
                }*/
                return tempHolding;
            }
        }

        function init(type) {
            var conf = {
                maxFaces: 2,
                shouldLoadIrisModel: false,
                maxContinuousChecks: 1
            };
            blockUI.start();
            // Load the MediaPipe Facemesh package.
            // if (type === 'init') {
            //     document.getElementById(videoElementId).src = 'https://amsin.hirepro.in/assessmentere2.0/blankVideo.mp4';
            // }
            modelPromise = faceLandmarksDetection.load(faceLandmarksDetection.SupportedPackages.mediapipeFacemesh, conf).then(function(res) {
                model = res;
                startVideo(type);
            });
        }

        function startVideo(type) {
            video = document.getElementById(videoElementId);
            if (type === 'init') {
                callType = 'init';
                document.getElementById(videoElementId).src = '/s3_cached/hirepro-content/hirepro/static-resources/blankVideo.mp4';
            } else {
                callType = '';
                video.srcObject = opt.stream;
            }
            video.onloadeddata = function(e) {
                video.play();
            };
            if (!eventListenerOnPlay) {
                video.addEventListener('play', function() {
                    eventListenerOnPlay = true;
                    setTimeout(function() { renderPrediction(); }, 500);
                    if (callType === 'init') {
                        setTimeout(function() {
                            if (!checkFaceLandmark) {
                                pushLog();
                            }
                        }, 3500);
                    }
                }, false);
            }
        }

        function renderPrediction() {

            // Pass in a video stream (or an image, canvas, or 3D tensor) to obtain an
            // array of detected faces from the MediaPipe graph. If passing in a video
            // stream, a single prediction per frame will be returned.
            model.estimateFaces({
                input: document.getElementById(videoElementId),
                predictIrises: false
            }).then(function(predictions) {
                var cnf = service.config,
                    data = predictions.length,
                    predictionsData = [];
                checkFaceLandmark = true;
                // if (opt.calculateFaceCount) {
                //     data = calculateArea(data, opt.calculateFaceCountPercent);
                // }
                _.forEach(predictions, function(val, i) {
                    predictionsData.push(_.pick(val, ['faceInViewConfidence', 'boundingBox']));
                });
                cnf.rawFacePredictions = predictionsData;
                cnf.rawFaceCountCollection.push(data);
                if (data == 0) {
                    fps += 1 / 2.7;
                } else {
                    fps += 1;
                }

                if (!date1) {
                    date1 = Date.now();
                }
                date2 = Date.now();
                if (date2 - date1 > 1000) {
                    if (fpsFirstSecSkip) {
                        cnf.getFpsDefer = cnf.getFpsDefer || $q.defer();
                        cnf.getFpsDefer.resolve(fps);
                    } else {
                        fpsFirstSecSkip = true;
                    }
                    date1 = Date.now();
                    fps = 0;
                }
                if (isTrackerRunning && callType !== 'init') {
                    $timeout(function() {
                        renderPrediction();
                    }, renderPredictionTimeout);
                }
                blockUI.stop();
            }, function(res) {
                checkFaceLandmark = true;
                if (callType === 'init') {
                    pushLog(res);
                }
            });
        }

        function pushLog(error) {
            var request = {
                faceTrackingInfo: {
                    msg: 'faceLandmarks changed to faceTracking',
                    error: error,
                    timeStamp: new Date()
                }
            };
            blockUI.stop();
            sessionStorage.setItem('faceLandmarks', false);
            if (!commonService.testIsOnlinePreview() && request) {
                loggerService.push(request);
            }
        }

        function checkAllTheSame(array) {
            if (_.size(array) === 0) {
                return;
            }
            var first = 0;
            return array.every(function(element) {
                return element === first;
            });
        }

        function getMaxOccuredElem(arr) {
            var maxOccuredElem = false;
            if (!arr || _.size(arr) === 0) {
                return maxOccuredElem;
            }
            var occurrenceCount = 1,
                checkedElem = {};
            maxOccuredElem = arr[0];
            for (var i = 0; i < arr.length; i++) {
                if (arr[i] <= 0) {
                    continue;
                }
                var count = 1;
                if (checkedElem[arr[i]]) {
                    continue;
                }
                for (var j = (i + 1); j < arr.length; j++) {
                    if (arr[i] == arr[j]) {
                        count++;
                    }
                }
                if (count > 1) {
                    checkedElem[arr[i]] = count;
                }
                if (count > occurrenceCount || (count == occurrenceCount && arr[i] > maxOccuredElem)) {
                    occurrenceCount = count;
                    maxOccuredElem = arr[i];
                }
            }
            return maxOccuredElem;
        }

        function calculateArea(data, per) {
            if (data.length < 2) {
                return data;
            } else {
                data = _.sortBy(data, [function(o) { return o.height * o.width; }]);
                var maxValue = _.last(data),
                    maxArea = maxValue.height * maxValue.width,
                    minArea = (maxArea / 100) * (per);
                return _.remove(data, function(n) {
                    return n.height * n.width <= minArea;
                });
            }
        }

        function getConsecutivelyOccuredElem(arr, samplingSize) {
            if (samplingSize <= 0) {
                return false;
            }
            var faceCount = 0,
                consicutiveOccurence = false;
            if (arr.length > samplingSize) {
                var conOc = false,
                    abort = false;
                for (var i = 0; i < arr.length && !abort; i++) {
                    if (arr[i] <= 0) {
                        continue;
                    }
                    for (var j = 0; j < samplingSize - 1; j++) {
                        conOc = true;
                        if ((i + j + 1) > arr.length || (i + j) > arr.length) {
                            abort = true;
                            break;
                        } else if (arr[i + j] != arr[i + j + 1]) {
                            conOc = false;
                            break;
                        }
                    }
                    if (!conOc) {
                        continue;
                    }
                    consicutiveOccurence = true;
                    if (arr[i] >= faceCount) {
                        faceCount = arr[i];
                    }
                }
            }
            if (!consicutiveOccurence) {
                consicutiveOccurence = true;
                return getMaxOccuredElem(arr);
            } else {
                return faceCount;
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module("OnlineAssessmentAngular")
        .factory("debuggerService", debuggerService);

    function debuggerService($timeout, loggerService, socketService) {
        var isConfigured = false,
            isSlowLinkLog = false,
            socketLogEnabled = false,
            activityLogEnabled = false,
            slLnkLogObj = null,
            slwLnkLogPushingTimeout = null,
            slLnkLogObjElastic = null,
            slwLnkLogPushingTimeoutElastic = null,
            slwLnkLogPushingInterval = 5, //minute
            service = {
                log: log,
                elasticLog: {
                    debugLogs: []
                }
            };
        return service;

        function log(logData) {
            if (!isConfigured) {
                init(logData);
            } else {
                var isSessionExpired = JSON.parse(sessionStorage.getItem('isSessionExpired'));
                if (isSessionExpired) {
                    return true;
                }
                pushDebugLogToElastic(logData.msg);
                if (activityLogEnabled) {
                    isSlowLinkLog = pushSlowlinkLog(logData.msg, logData.source);
                    !isSlowLinkLog && pushActivityLog(logData.msg, logData.source);
                }
                if (socketLogEnabled) {
                    var data = {
                        msgType: "debugging_log",
                        msgBody: logData.msg
                    };
                    socketService.sendMessage(data);
                }
            }
        }

        function init(logData) {
            socketLogEnabled = false;
            activityLogEnabled = true;
            isConfigured = true;
            log(logData);
        }

        function pushDebugLogToElastic(log) {
            if (log && log.msg && log.msg.videoroom === "slow_link") {
                if (!slwLnkLogPushingTimeoutElastic) {
                    slLnkLogObjElastic = { slow_link: { timeStamp: new Date(), count: 1 } };
                    slwLnkLogPushingTimeoutElastic = $timeout(function() {
                        service.elasticLog.debugLogs.push(slLnkLogObjElastic);
                        slwLnkLogPushingTimeoutElastic = null;
                    }, slwLnkLogPushingInterval * 60 * 1000);
                } else {
                    slLnkLogObjElastic.slow_link.count++;
                }
            } else {
                service.elasticLog.debugLogs.push(log);
            }

        }

        function pushSlowlinkLog(log, source) {
            if (log && log.msg && log.msg.videoroom === "slow_link") {
                if (!slwLnkLogPushingTimeout) {
                    slLnkLogObj = { slow_link: { timeStamp: new Date(), count: 1 } };
                    slwLnkLogPushingTimeout = $timeout(function() {
                        pushActivityLog(slLnkLogObj, "proctorhvsLog");
                        slwLnkLogPushingTimeout = null;
                    }, slwLnkLogPushingInterval * 60 * 1000);
                } else {
                    slLnkLogObj.slow_link.count++;
                }
                return true;
            }
            return false;
        }

        function pushActivityLog(log, source) {
            var logObj = {};
            if (source.match(/hvs/ig)) {
                logObj[source] = log;
            } else {
                logObj.canLoginActivityLog = {};
                logObj.canLoginActivityLog[source] = log;
            }
            loggerService.push(logObj);
        }
    }
})();

(function() {
    'use strict';
    angular
        .module('OnlineAssessmentAngular')
        .service('connection', connection);

    function connection($log, webService, $q) {

        var service = {
            isOnline: isOnline
        };
        return service;

        function isOnline() {
            if (location.hostname === "localhost") {
                return $q(function(resolve,reject){return resolve(true);});
            } else {
                var d = new Date(),
                    isAliveApiUrl = location.origin + "/is-alive.txt?" + d.getTime();
                return webService.execute(isAliveApiUrl, null, "GET")
                    .then(function(res) {
                        if (!res && res.status !== 200) {
                            $log.log("I am not ALIVE");
                            return false;
                        }
                        $log.log(res.data);
                        return true;
                    }, function(res) {
                        $log.log("I am not ALIVE");
                        $log.log("isAliveResponse:", res);
                        return false;
                    });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('OnlineAssessmentAngular')
        .factory('webRtcStatsService', webRtcStatsService); // service name

    function webRtcStatsService($timeout, $interval, webService, $log, debuggerService, loggerService) {
        var participants = [], // local array to hold all webrtc connections
            statusLoggerInterval = null, // variable to hold timer promise so that it can be killer to stop
            statusBWLoggerInterval = null,
            logInterval = 300, // in sec
            service = {
                start: start, // public function for starting service
                stopAll: stopAll // public function for stoping service
            };
        return service;

        function start(data) { // public function for starting service definition

            var newConnection = _.find(participants, {
                id: data.id
            }); // find if same id is already presant in connection array
            if (!newConnection) {
                data.bandwidthContainer = [];
                data.bytesContainer = [];
                participants.push(data); // push to connection array if not present
            } else {
                // override the wrtc connection
                if (data.wrtcConnection) {
                    newConnection.wrtcConnection = data.wrtcConnection;
                }
            }
            if (participants.length === 1 && !statusLoggerInterval && !statusBWLoggerInterval) { // we'll start interval as soon, we received first connection
                $timeout(function() {
                    statusLoggerInterval = $interval(startLogger, 300 * 1000);
                    statusBWLoggerInterval = $interval(startBandwidthLogging, 10 * 1000);
                }, 3);
            }
        }

        function startLogger() { // private function which is called every 30 sec to fetch webrtc status
            var rtcStatDict = {
                snapshot_granularity: 5
            };
            _.forEach(participants, function(item) {
                if (item.wrtcConnection && item.wrtcConnection.pc) {
                    if (item.type === 'publisher') {
                        fetchWrtcStats(item).then(function(res) {
                            var stat = getTxStatDict(res);
                            var merged_obj = _.merge(rtcStatDict, stat);
                            storeWebRTCLog(merged_obj);
                        });

                    } else {
                        fetchWrtcStats(item).then(function(res) {
                            var stat = getRxStatDict(res);
                            _.merge(rtcStatDict, stat);
                        });

                    }
                } else {
                    console.log('Web rtc connection is undefined or closed');
                }
            });
        }

        function startBandwidthLogging() {
            _.forEach(participants, function(item) {
                fetchWrtcStats(item).then(function(res) {
                    (item.type === 'publisher') ?
                    fetchTxBandwidth(res): fetchRxBandwidth(res);
                });
            });
        }

        function fetchWrtcStats(wrtcCandidate) {
            return wrtcCandidate.wrtcConnection.pc.getStats().then(
                function(stats) {
                    return { stats: stats, wrtcCandidate: wrtcCandidate };
                },
                function(res) {
                    console.log('error while fetch wrtc stats', res);
                    return null;
                }
            );
        }

        function getTxStatDict(statObj) {
            if (!statObj) {
                console.log('stat obj Not found');
                return {};
            }
            var statReports = statObj.stats;
            if (!statReports) {
                console.log('stat report Not found');
                return {};
            }
            var txFunc = parseAndGetData(),
                statsData = { candidatePairs: { tx: {} } };
            statReports.forEach(function(report) {
                if (!statsData.timeStampInIST && report.timeStamp) {
                    statsData.timeStampInIST = report.timestamp;
                }
                if (report.type === 'media-source') {
                    var ms = mediaSource();
                    if (report.kind === 'audio') {
                        console.log('collect audio media source');
                        var audioObj = ms.audio(report);
                        console.log(JSON.stringify(audioObj));
                        statsData.micInput = audioObj;
                        statsData.micInputArr = txFunc.micInput(statObj.wrtcCandidate);
                    }
                    if (report.kind === 'video') {
                        console.log('collect video media source');
                        var videoObject = ms.video(report);
                        console.log(JSON.stringify(videoObject));
                        statsData.cameraInput = videoObject;
                    }

                } else if (report.type === 'local-candidate') {
                    var localCan = txFunc.candidateLocalPairs(report);
                    statsData.candidatePairs.tx.localCandidate = localCan;
                } else if (report.type === 'remote-candidate') {
                    var remoteCan = txFunc.candidateRemotePairs(report);
                    statsData.candidatePairs.tx.remoteCandidate = remoteCan;
                } else if (report.type === 'remote-inbound-rtp') {
                    if (report.kind === 'audio') {
                        statsData.audioTx = txFunc.audio(report, statObj.wrtcCandidate);
                    }
                    if (report.kind === 'video') {
                        var videoRData = statsData.videoTx;
                        statsData.videoTx = txFunc.videoRemote(report, videoRData);
                    }

                } else if (report.type === 'outbound-rtp') {
                    if (report.kind === 'video' && report.mediaType === 'video') {
                        var videoLData = statsData.videoTx;
                        statsData.videoTx = txFunc.video(report, videoLData, statObj.wrtcCandidate);
                    }

                } else if (report.type === 'candidate-pair') {
                    statsData.overallTxAudioPlusVideo = txFunc.audioVideoOverall(report, statObj.wrtcCandidate);

                }
            });
            //console.log(JSON.stringify(stats_data));
            console.log(JSON.stringify(statsData));
            return statsData;
        }

        function getRxStatDict(statObj) {
            if (!statObj) {
                console.log('stat obj not found for rx data');
                return {};
            }
            var statReports = statObj.stats,
                item = statObj.wrtcCandidate;
            if (!statReports) {
                console.log('stats array not found for rx data');
                return {};
            }
            var rxFunc = parseAndGetData(),
                statsData = { candidatePairs: {} },
                displayName = item.id;
            var candidatePairKey = 'rx' + '_' + displayName,
                videoRx = 'videoRx' + '_' + displayName,
                audioRx = 'audioRx' + '_' + displayName;
            statsData.candidatePairs[candidatePairKey] = {};
            statReports.forEach(function(report) {
                if (!statsData.timeStampEpoch && report.timeStamp) {
                    statsData.timeStampEpoch = report.timestamp;
                }
                if (report.type === 'media-source') {
                    var ms = mediaSource();
                    if (report.kind === 'audio') {
                        statsData.micInputArr = txFunc.micInput(statObj.wrtcCandidate);
                    }
                }
                if (report.type === 'local-candidate') {
                    var localCan = rxFunc.candidateLocalPairs(report);
                    statsData.candidatePairs[candidatePairKey].localCandidate = localCan;
                } else if (report.type === 'remote-candidate') {
                    var remoteCan = rxFunc.candidateRemotePairs(report);
                    statsData.candidatePairs[candidatePairKey].remoteCandidate = remoteCan;
                } else if (report.type === 'remote-inbound-rtp') {
                    if (report.kind === 'audio') {
                        statsData[audioRx] = rxFunc.audio(report, item);
                    }
                    if (report.kind === 'video') {
                        var videoRData = statsData[videoRx];
                        statsData[videoRx] = rxFunc.videoRemote(report, videoRData);
                    }

                } else if (report.type === 'outbound-rtp') {
                    if (report.kind === 'video' && report.mediaType === 'video') {
                        var videoLData = statsData[videoRx];
                        statsData[videoRx] = rxFunc.video(report, videoLData, item);
                    }

                } else if (report.type === 'candidate-pair') {
                    statsData['overallRxAudioPlusVideo' + '_' + displayName] = rxFunc.audioVideoOverall(report, item);

                }
            });
            //console.log(JSON.stringify(stats_data));
            console.log(JSON.stringify(statsData));
            return statsData;
        }

        function mediaSource() {
            var ms = {
                audio: audio,
                video: video
            };

            function audio(report) {
                return {
                    audioLevel: report.audioLevel.toFixed(4),
                    totalAudioEnergy: report.totalAudioEnergy.toFixed(4),
                    timeStamp: new Date()
                };
            }

            function video(report) {
                return {
                    width: report.width,
                    height: report.height,
                    fps: report.framesPerSecond
                };

            }
            return ms;
        }

        function parseAndGetData() {
            var tx = {
                micInput: micInput,
                audio: audio,
                video: video,
                videoRemote: videoRemote,
                audioVideoOverall: audioVideoOverall,
                candidateLocalPairs: candidateLocalPairs,
                candidateRemotePairs: candidateRemotePairs
            };
            return tx;

            function mapBws(bwlist, key) {
                return _.map(bwlist, function(bw) {
                    return bw[key];
                });
            }

            function micInput(candidate) {
                return mapBws(candidate.bandwidthContainer, 'micInput');
            }

            function audio(report, candidate) {
                return {
                    actualAudioBwInKbps: mapBws(candidate.bandwidthContainer, 'audioBw'),
                    audioCodec: 'opus',
                    remotePktsLost: report.packetsLost,
                    remoteJitter: report.jitter,
                    remoteRTT: report.roundTripTime
                };
            }

            function video(report, obj, candidate) {
                var videoObj = obj || {};
                videoObj.videoCodec = 'vp9';
                videoObj.nackCount = report.nackCount;
                videoObj.firCount = report.firCount;
                videoObj.pliCount = report.pliCount;
                videoObj.actualVideoBwInKbps = mapBws(candidate.bandwidthContainer, 'videoBw');
                return videoObj;
            }

            function videoRemote(report, obj) {
                var videoObj = obj || {};
                videoObj.remoteJitter = report.jitter;
                videoObj.remoteRTT = report.roundTripTime;
                videoObj.remotePktsLost = report.packetsLost;
                return videoObj;

            }

            function audioVideoOverall(report, candidate) {
                return {
                    currentRoundTripTime: report.currentRoundTripTime,
                    availableSendBWInKbps: [report.availableOutgoingBitrate / 1000],
                    actualBeingSentBWInKbps: mapBws(candidate.bandwidthContainer, 'overall')
                };
            }

            function candidateLocalPairs(report) {
                return {
                    IP: report.ip,
                    port: report.port,
                    CandidateType: report.candidateType,
                    NetworkType: report.networkType
                };
            }

            function candidateRemotePairs(report) {
                return {
                    IP: report.ip,
                    port: report.port,
                    CandidateType: report.candidateType
                };
            }
        }

        function totalToPerSecond(lastDataPoint, secondLastDataPoint) {
            try {
                var bps = Math.floor(
                    (lastDataPoint.bytes - secondLastDataPoint.bytes) * 8 /
                    (lastDataPoint.timeStamp - secondLastDataPoint.timeStamp));
                // convert bps to kbps
                return bps / 1000;
            } catch (err) {
                console.log(err.message);
            }
            return 0;
        }

        function bandwidthCalculator(bandwidthContainer) {
            var length = bandwidthContainer.length;
            if (length < 2) {
                return {
                    audioBw: 0,
                    videoBw: 0,
                    overall: 0
                };
            }
            var lastDataPoint = bandwidthContainer[length - 1];
            var secondLastDataPoint = bandwidthContainer[length - 2];

            return {
                audioBw: totalToPerSecond(lastDataPoint.audio, secondLastDataPoint.audio),
                videoBw: totalToPerSecond(lastDataPoint.video, secondLastDataPoint.video),
                overall: totalToPerSecond(lastDataPoint.overall, secondLastDataPoint.overall)
            };
        }

        function fetchTxBandwidth(stats) {
            var audio = {},
                video = {},
                overall = {},
                micInput = {},
                reports = stats.stats,
                candidate = stats.wrtcCandidate;
            reports.forEach(function(report) {
                if (report.type === 'media-source') {
                    var ms = mediaSource();
                    if (report.kind === 'audio') {
                        micInput = ms.audio(report);
                    }
                }
                if (report.type === 'outbound-rtp') {
                    if (report.kind === 'audio') {
                        audio.bytes = report.bytesSent;
                        audio.timeStamp = report.timestamp / 1000;
                    }
                    if (report.kind === 'video') {
                        video.bytes = report.bytesSent;
                        video.timeStamp = report.timestamp / 1000;
                    }
                } else if (report.type === 'candidate-pair') {
                    overall.bytes = report.bytesSent;
                    overall.timeStamp = report.timestamp / 1000;
                }
            });
            if (candidate.bytesContainer.length > 2) {
                candidate.bytesContainer.shift();
            }
            if (candidate.bandwidthContainer.length > 30) {
                candidate.bandwidthContainer.shift();
            }
            candidate.bytesContainer.push({ audio: audio, video: video, overall: overall });
            var calculatedBws = bandwidthCalculator(candidate.bytesContainer);
            calculatedBws.micInput = micInput;
            candidate.bandwidthContainer.push(calculatedBws);
        }

        function fetchRxBandwidth(stats) {
            var audio = {},
                video = {},
                overall = {},
                micInput = {},
                reports = stats.stats,
                candidate = stats.wrtcCandidate;
            reports.forEach(function(report) {
                if (report.type === 'media-source') {
                    var ms = mediaSource();
                    if (report.kind === 'audio') {
                        micInput = ms.audio(report);
                    }
                }
                if (report.type === 'outbound-rtp') {
                    if (report.kind === 'audio') {
                        audio.bytes = report.bytesReceived;
                        audio.timeStamp = report.timestamp / 1000;
                    }
                    if (report.kind === 'video') {
                        video.bytes = report.bytesReceived;
                        video.timeStamp = report.timestamp / 1000;
                    }
                } else if (report.type === 'candidate-pair') {
                    overall.bytes = report.bytesReceived;
                    overall.timeStamp = report.timestamp / 1000;
                }
            });
            if (candidate.bytesContainer.length > 2) {
                candidate.bandwidthContainer.shift();
            }
            if (candidate.bandwidthContainer.length > 30) {
                candidate.bandwidthContainer.shift();
            }
            candidate.bytesContainer.push({ audio: audio, video: video, overall: overall });
            var calculatedBws = bandwidthCalculator(candidate.bytesContainer);
            calculatedBws.micInput = micInput;
            candidate.bandwidthContainer.push(calculatedBws);
        }


        function stopAll() { // public function for stopping service
            participants.length = 0;
            if (statusLoggerInterval && statusBWLoggerInterval) { // check if interval was started
                $interval.cancel(statusLoggerInterval); // kill interval
                statusLoggerInterval = null;
                $interval.cancel(statusBWLoggerInterval);
                statusBWLoggerInterval = null;
            }
        }

        function storeWebRTCLog(val) {
            if (val) {
                val.timeStampInIST = new Date();
            }
            var info = {
                    webrtcLog: val
                };
            //     debugLogs = angular.copy(debuggerService.elasticLog.debugLogs);
            // if (_.size(debugLogs) > 0) {
            //     info.webrtcLog.debugLogs = debugLogs;
            //     debuggerService.elasticLog.debugLogs.length = 0;
            // }
            loggerService.push(info, {
                'webServiceUrl': 'saveToElastic',
                'groupReqData': false
            });

            if (window._consolelogs && window._consolelogs.length > 0) {
                var req = {
                    'logs': {
                        'consoleLogs': window._consolelogs
                    }
                }
                var temp = window._consolelogs;
                window._consolelogs = [];
                webService.execute('saveLogsToElastic', req)
                    .then(function() {
                            console.log('Successfully Logged storeConsoleLog');
                        },
                        function() {
                            window._consolelogs = temp.concat(window._consolelogs);
                        }
                    );
            }

        }
    }
})();

(function() {
    'use strict';

    angular
        .module('OnlineAssessmentAngular')
        .factory('commonQuestionActions', commonQuestionActions);

    commonQuestionActions.$inject = [
        '$state',
        '$log',
        '$q',
        'loginService',
        '$rootScope',
        '$window',
        'assessmentUtility',
        'assessmentService',
        'modalService',
        '$injector',
        'blockUI',
        'webService',
        'openModalService',
        '$interval',
        'videoAnsRecorder',
        'CaptureCodeActivitySvc'
    ];

    function commonQuestionActions($state, $log, $q, loginService, $rootScope, $window, assessmentUtility, assessmentService, modalService, $injector, blockUI, webService, openModalService, $interval, videoAnsRecorder, CaptureCodeActivitySvc) {
        var loginInfo = loginService.getLoginInfo();
        var alias = assessmentUtility.getAlias();
        var isOnlinePreview = assessmentUtility.localStorage.getData("_isOnlinePreview");
        isOnlinePreview = isOnlinePreview ? isOnlinePreview : false;
        var totalQuestionCount = assessmentService.questionpaper.getTotalQuestionCount();
        var currentOptionalGroupIndex = assessmentService.questionpaper.getCurrentOptionalGroupIndex() + 1;
        var qIndex = 0; //assessmentUtility.getActiveQuestionIndex();
        var grpFirstIndex = 0;
        //var currentQuestionIndex = qIndex + 1;
        var currentQuestionIndex = qIndex;
        var isFirstIndex = qIndex === 0;
        var groupTotalTime = 0;
        //var groupWiseTimeOver = false;
        var GroupWiseTimingEnabled = false;
        var mandatQCollection = null;
        var optGrpCollection = null;
        var groupInfoCollection = null;
        var isLastIndex = false;
        var firstQuestionIndex = -1;
        var isLastGroup = false;
        //var isExecuted = false;
        var isUserGroupChoiceEnable = false;
        var optionalGroupModal = null;
        var nextgroupModal = null;
        //var containsMediaQuestion = loginInfo.ContainsMediaQuestion;

        var service = {
            localVar: {
                tenantId: -1,
                testId: -1,
                candidateId: -1,
                codingPollingTimer: [1000, 1000, 2000, 2000, 2000, 2000, 3000, 3000, 5000, 5000, 5000, 7000, 7000, 7000, 7000],
                codingResponses: {},
                isOptionalPreviewEnable: false,
                optionalPreviewtime: 0,
                isVideoProctoringEnabled: false,
                isSpeechTrackingEnabled: false,
                isMikeTrackingEnabled: false,
                isImageTrackingEnabled: false,
                isFaceTrackingEnabled: false,
                deferred: null,
                audiotracking: false
            },
            isFirstQ: function() {
                return isFirstIndex;
            },
            getIsGroupWiseTimingEnabled: function() {
                return GroupWiseTimingEnabled;
            },
            setIsgroupWiseTimeOver: function(val) {
                var groupWiseTimeOver = val;
                assessmentUtility.localStorage.setData("groupWiseTimeOver", groupWiseTimeOver);
                if (val) {
                    assessmentService.questionpaper.get().then(function(response) {
                        if (response) {
                            assessmentUtility.localStorage.setData("isGrpWiseTimeOver", true);
                            assessmentService.addRemainingTimeToLastActiveQuestion(response, true, false);
                        }
                    });
                }
            },
            getTotalQuestionCount: function() {
                return totalQuestionCount;
            },
            getIsAnswerMandatory: function() {
                var loginInfo = loginService.getLoginInfo();
                var isAnswerMandatory = false;
                if (loginInfo && loginInfo.Config) {
                    isAnswerMandatory = !!loginInfo.Config.isAnsMandt;
                }
                return isAnswerMandatory;
            },
            getIsLastIndex: function() {
                return isLastIndex;
            },
            getIsFirstIndex: function() {
                return isFirstIndex;
            },
            setFirstQuestionIndex: function(firstQindex) {
                firstQuestionIndex = firstQindex;
            },
            getFirstQuestionIndex: function() {
                return firstQuestionIndex;
            },
            setIsFirstIndex: function(_isFirstIndex) {
                isFirstIndex = _isFirstIndex;
            },
            setCurrentQuestionIndex: function(_qIndex) {
                currentQuestionIndex = _qIndex;
            },
            getCurrentQuestionIndex: function() {
                return currentQuestionIndex;
            },
            setGrpFirstIndex: function(_grpFirstIndex) {
                grpFirstIndex = _grpFirstIndex;
            },
            updateQpInfos: function(response) {
                qIndex = assessmentUtility.getActiveQuestionIndex();
                loginInfo = loginService.getLoginInfo();
                if (loginInfo) {
                    service.localVar.tenantId = loginService.getTenantId();
                    service.localVar.testId = loginInfo.TestId;
                    service.localVar.candidateId = loginInfo.CandidateId;
                    if (loginInfo.Config) {
                        service.localVar.isOptionalPreviewEnable = !loginInfo.Config.HideOptionalGroup;
                        if (service.localVar.isOptionalPreviewEnable) {
                            service.localVar.optionalPreviewtime = loginInfo.Config.OptionalPreviewtime;
                        }
                    }
                }
                currentOptionalGroupIndex = assessmentService.questionpaper.getCurrentOptionalGroupIndex() + 1;
                updateQpInfos(response);
            },
            setQindex: function(_qIndex) {
                qIndex = _qIndex;
            },
            showQuestion: showQuestion,
            moveToPrevQuestion: moveToPrevQuestion,
            moveToNextQuestion: moveToNextQuestion,
            switchToNextGroup: switchToNextGroup,
            showOptional: showOptional,
            unAnswerQuestion: unAnswerQuestion,
            execute: execute,
            loadQuestion: loadQuestion,
            flagQuestion: flagQuestion,
            /*getIsExecuteStat: function() {
                return isExecuted;
            },*/
            onOptionalPreviewTimerStop: function(data) {
                assessmentUtility.localStorage.setData("isOptionalPreviewTimeOver", true);
                $rootScope.uibModalInstance.close(data);
            }
        };

        return service;

        function moveToPrevQuestion() {
            if (isFirstIndex) {
                return false;
            }
            if (qIndex > 0) {
                $state.go('assess.loadTest', { 'questionIndex': (qIndex - 1) }, { location: 'replace' }).then(
                    function(data) {
                        currentQuestionIndex--;
                        assessmentUtility.scrollToElement();
                        if ((qIndex - 1) === grpFirstIndex) {
                            isFirstIndex = true;
                            isLastIndex = false;
                        }
                        //assessmentUtility.scrollToTop();
                    });
            }
            /*else if (qIndex === 0) {
                isFirstIndex = true;
            }*/
        }

        function moveToNextQuestion() {
            if (isLastIndex) {
                return false;
            }
            if (qIndex >= 0 && (qIndex < (totalQuestionCount - 1))) {
                if (GroupWiseTimingEnabled) {
                    switchToNextGroup();
                } else {
                    showQuestion(currentQuestionIndex, false);
                }
            } else if (optGrpCollection.length > 0) {
                showOptional();
            }
        }

        function switchToNextGroup() {
            var isOptional = optGrpCollection.length > 0;
            var activeGrpId = assessmentService.questionpaper.activeGroup.getId();
            var qObj = mandatQCollection[qIndex + 1];
            var groupWiseTimeOver = assessmentUtility.localStorage.getData("groupWiseTimeOver"),
                prevQId;
            groupWiseTimeOver = groupWiseTimeOver ? groupWiseTimeOver : false;
            if (qObj && groupWiseTimeOver) {
                var nextGroupQindex = getNextGroup1stQindex(activeGrpId);
                qObj = mandatQCollection[nextGroupQindex];
                updateGroupTotaltime(qObj.gpId);
            }
            if (qObj && activeGrpId != qObj.gpId) {
                var vidQautoStartIntervalObj = assessmentUtility.sessionStorage.getPromise("vidQautoStartIntervalObj");
                if (vidQautoStartIntervalObj) {
                    $interval.cancel(vidQautoStartIntervalObj);
                    vidQautoStartIntervalObj = null;
                    assessmentUtility.sessionStorage.setPromise("vidQautoStartIntervalObj", vidQautoStartIntervalObj);
                }
                var submitType = 'manualGroupChange';
                var message = "<b style='font-size:18px;'>Are you sure you want to move to the next group?</b>" +
                    "<br>* You will not be able to revisit this group once you start the next group.";
                if (groupWiseTimeOver) {
                    submitType = 'autoGroupChange';
                    message = "<p><strong>The timer for this group has ended.</strong></p>" +
                        "<p>Please click \"Take me to the next group\".</p>";
                    if (assessmentUtility.localStorage.getData('isQuestionVideoStarted') === true) {
                        videoAnsRecorder.stop();
                    }
                }
                // var isActionEnable = true,
                //     isOkEnable = true,
                //     isCancelEnable = true;
                var isCancelEnable = true;
                if (groupWiseTimeOver) {
                    isCancelEnable = false;
                }
                var data = {
                    bodyStr: message,
                    headerStr: 'Alert',
                    isAction: true,
                    action: {
                        isOkBtn: true,
                        okText: 'Take me to the next group',
                        isCancelBtn: isCancelEnable
                    }
                };
                if (nextgroupModal) {
                    openModalService.closeAllModals();
                    //nextgroupModal.hide();
                    //nextgroupModal = null;
                }
                nextgroupModal = openModalService.openModal('notificationTemplate', data).then(function(res) {
                    if (res.result.result.modalResponse) {
                        assessmentUtility.localStorage.setData("isManuallySwitchedToNextGroup", true);
                        assessmentUtility.localStorage.setData("lastSubmittedTotalTimeSpent", angular.toJson(0));
                        //if (!groupWiseTimeOver) {
                        assessmentUtility.timer.stop();
                        prevQId = mandatQCollection[qIndex] && mandatQCollection[qIndex].id;
                        CaptureCodeActivitySvc.submitUserQuestionHistory(prevQId);
                        assessmentService.handleTestSubmission(true, false, submitType);
                        //}
                        if (assessmentUtility.localStorage.getData('isQuestionVideoStarted') === true) {
                            videoAnsRecorder.stop();
                        }
                        groupWiseTimeOver = true;
                        assessmentUtility.localStorage.setData("groupWiseTimeOver", groupWiseTimeOver);
                        qIndex = getNextGroup1stQindex(activeGrpId);
                        isFirstIndex = true;
                        grpFirstIndex = qIndex;
                        updateGroupTotaltime(qObj.gpId);
                        if (assessmentUtility.localStorage.getData('isQuestionVideoStarted') === true) {
                            videoAnsRecorder.stop();
                        }
                        var loginInfo = loginService.getLoginInfo();
                        if (loginInfo && loginInfo.assessmentConfig && loginInfo.assessmentConfig.isLoadFullScreen && !assessmentUtility.isInFullScreen()) {
                            assessmentUtility.localStorage.setData("fullScreenAlertModalOpened", true);
                            var data = {
                                bodyStr: 'This test is designed to run on full screen. Please click the button below to go back to full screen.',
                                headerStr: 'Alert',
                                isAction: true,
                                action: {
                                    isOkBtn: true,
                                    isOnClick: true,
                                    okText: "Go back to full screen",
                                    onOk: function() {
                                        assessmentUtility.loadFullScreen();
                                        assessmentUtility.localStorage.setData("fullScreenAlertModalOpened", false);
                                    }
                                }
                            };
                            openModalService.showModal('notificationTemplate', data);
                        }
                        showQuestion(qIndex, false);
                    } else {
                        assessmentUtility.localStorage.setData("isManuallySwitchedToNextGroup", false);
                    }
                });
            } else if ((!qObj || groupWiseTimeOver) && isOptional && !isLastGroup) {
                showOptional();
            } else if (!groupWiseTimeOver) {
                showQuestion();
            }
        }

        function getNextGroup1stQindex(activeGrpId) {
            var counter = 0,
                isPresent = false;
            _.each(mandatQCollection, function(q) {
                counter++;
                if (q.gpId === activeGrpId) {

                    isPresent = true;
                } else if (isPresent && q.gpId !== activeGrpId) {

                    return false;
                }
            });
            return counter - 1;
        }

        function showOptional(onlyOptional, isRequestedFromSubmitModal) {
            var sl = service.localVar,
                hdStr = null,
                message = null,
                isCancelEnable = true,
                optGrps = null,
                optModalBackdrop = 'optional-group-modal',
                modalTemplateName = 'optGrpTemplate',
                groupWiseTimeOver = assessmentUtility.localStorage.getData("groupWiseTimeOver");
            groupWiseTimeOver = groupWiseTimeOver ? groupWiseTimeOver : false;
            sl.deferred = sl.deferred &&
                sl.deferred.promise &&
                sl.deferred.promise.$$state &&
                sl.deferred.promise.$$state.status !== 2 ? sl.deferred : $q.defer();
            if (isRequestedFromSubmitModal !== true) {
                isRequestedFromSubmitModal = false;
            }
            /*if ($rootScope.uibModalInstance) {
                $rootScope.uibModalInstance.dismiss();
            }*/
            // var isActionEnable = true,
            //     isOkEnable = true,
            //     isCancelEnable = true;
            if (onlyOptional) {
                optModalBackdrop = 'optional-group-modal modal_backdrop_white';
                isCancelEnable = false;
            }
            optGrps = isUserGroupChoiceEnable ? optGrpCollection : optGrpCollection[currentOptionalGroupIndex].groups;
            if (isUserGroupChoiceEnable) {
                modalTemplateName = 'userChoiceGroupTemplate';
                hdStr = "Choose Group";
                if (onlyOptional) {
                    optModalBackdrop = 'user-choice-group-modal modal_backdrop_white';
                } else {
                    optModalBackdrop = 'user-choice-group-modal';
                }
            }
            message = "Are you sure you want to submit current group?" +
                "<br>You will <b>not</b> be able to revisit this group once you submit current group.";
            if (groupWiseTimeOver) {
                isCancelEnable = false;
                message = "<p><strong>The timer for this group has ended.</strong></p>" +
                    "<p>Please click \"Take me to the next group\".</p>";
                if (assessmentUtility.localStorage.getData('isQuestionVideoStarted') === true) {
                    videoAnsRecorder.stop();
                }
            }
            /*if ($rootScope.uibModalInstance) {
                $rootScope.uibModalInstance.dismiss();
            }*/
            if (isUserGroupChoiceEnable && !onlyOptional && !isRequestedFromSubmitModal) {
                var data = {
                    bodyStr: message,
                    headerStr: 'Alert',
                    isAction: true,
                    action: {
                        isOkBtn: true,
                        okText: 'Take me to the next group',
                        isCancelBtn: isCancelEnable
                    }
                };
                openModalService.openModal('notificationTemplate', data).then(function(res) {
                    if (res.result.result.modalResponse)
                        showOptionalGroupList(modalTemplateName, optGrps, hdStr, true, true, isCancelEnable, optModalBackdrop, onlyOptional);
                });
            } else {
                showOptionalGroupList(modalTemplateName, optGrps, hdStr, true, true, isCancelEnable, optModalBackdrop, onlyOptional);
            }
            return sl.deferred.promise;
        }

        function showOptionalGroupList(_modalTemplateName, _optGrps, _hdStr, _isActionEnable, _isOkEnable, _isCancelEnable, _optModalBackdrop, _onlyOptional) {
            var requestObj = {
                    groups: _optGrps,
                    headingStr: _hdStr,
                    isOkEnable: _isOkEnable,
                    isCancelEnable: _isCancelEnable,
                    onlyOptional: _onlyOptional,
                    isOptionalPreviewEnable: service.localVar.isOptionalPreviewEnable,
                    totalPreviewtime: parseInt(service.localVar.optionalPreviewtime)
                },
                prevQId;
            if (_modalTemplateName == 'userChoiceGroupTemplate') {
                requestObj.modalSize = 'lg';
            }
            if (!optionalGroupModal) {
                optionalGroupModal = openModalService.openModal(_modalTemplateName, requestObj)
                    .then(function(res) {
                        optionalGroupModal = null;
                        var selectedGroup = res.result.selectedGroup;
                        if (selectedGroup) {
                            assessmentUtility.localStorage.setData("isManuallySwitchedToNextGroup", true);
                            var groupWiseTimeOver = assessmentUtility.localStorage.getData("groupWiseTimeOver");
                            groupWiseTimeOver = groupWiseTimeOver ? groupWiseTimeOver : false;
                            if (!_onlyOptional && GroupWiseTimingEnabled) {
                                //switchToNextGroup(true);
                                assessmentUtility.timer.stop();
                                assessmentUtility.localStorage.setData("lastSubmittedTotalTimeSpent", angular.toJson(0));
                                groupWiseTimeOver = true;
                                assessmentUtility.localStorage.setData("groupWiseTimeOver", groupWiseTimeOver);
                            }
                            prevQId = mandatQCollection[qIndex] && mandatQCollection[qIndex].id;
                            assessmentService.questionpaper.addOptionalGroup(selectedGroup);
                            CaptureCodeActivitySvc.submitUserQuestionHistory(prevQId);
                            if (!_onlyOptional) {
                                assessmentService.handleTestSubmission(true, false, 'optionalGroupChange');
                            }
                            assessmentService.questionpaper.get().then(function(response) {
                                updateQpInfos(response);
                                assessmentUtility.localStorage.setData("previewTimer", null);
                                if (GroupWiseTimingEnabled || isUserGroupChoiceEnable) {
                                    if (!_onlyOptional) {
                                        isFirstIndex = true;
                                        var activeGrpId = assessmentService.questionpaper.activeGroup.getId();
                                        qIndex = getNextGroup1stQindex(activeGrpId);
                                        grpFirstIndex = qIndex;
                                    } else {
                                        qIndex = 0;
                                        groupWiseTimeOver = true;
                                        assessmentUtility.localStorage.setData("groupWiseTimeOver", groupWiseTimeOver);
                                    }
                                    var qObj = mandatQCollection[qIndex];
                                    if (GroupWiseTimingEnabled) {
                                        updateGroupTotaltime(qObj.gpId);
                                    }
                                }
                                showQuestion(-1, _onlyOptional);
                            });
                        }
                    });
            }
        }

        function showQuestion(qButtonIndex, onlyOptional) {
            /*if (onlyOptional && service.localVar.isVideoProctoringEnabled) {
                $injector.get('proctoringService').init()
                    .then(function() {
                        loadQuestion(qButtonIndex, onlyOptional, isUserGroupChoiceEnable);
                    });
            } else {*/
            loadQuestion(qButtonIndex, onlyOptional, isUserGroupChoiceEnable);
            //}
        }

        function loadQuestion(qButtonIndex, onlyOptional, isUserGroupChoiceEnable) {
            var isSwitchedToNextGroup = assessmentUtility.localStorage.getData("isManuallySwitchedToNextGroup"),
                sl = service.localVar,
                groupWiseTimeOver = assessmentUtility.localStorage.getData("groupWiseTimeOver");
            groupWiseTimeOver = groupWiseTimeOver ? groupWiseTimeOver : false;
            if (qButtonIndex >= 0) {
                qIndex = qButtonIndex;
            } else if (!groupWiseTimeOver && !(isUserGroupChoiceEnable && isSwitchedToNextGroup)) {
                qIndex++;
            }
            assessmentUtility.disableBackButton(location.href);
            assessmentService.questionpaper.get()
                .then(function(qPaper) {
                    $state.go('assess.loadTest', { 'alias': alias, 'questionIndex': qIndex, 'questionPaper': qPaper }, { location: 'replace' })
                        .then(function(data) {
                            if (groupWiseTimeOver) {
                                currentQuestionIndex = qIndex + 1;
                                isLastGroup = (_.findLastIndex(groupInfoCollection, { 'gpId': qPaper.mandatoryQuestionCollection[qIndex].gpId }) + 1) === groupInfoCollection.length;
                                if (isUserGroupChoiceEnable) {
                                    isLastGroup = _.groupBy(qPaper.mandatoryQuestionCollection, 'gpId').length === groupInfoCollection.length;
                                }
                                if (optGrpCollection.length > 0) {
                                    isLastGroup = !assessmentService.questionpaper.isOptionalGrpPresentToBeSelected();
                                }
                                $window.sessionStorage.setItem("isLastGroup", isLastGroup);
                                assessmentUtility.timer.start(assessmentService.handleTestSubmission, GroupWiseTimingEnabled, isLastGroup);
                            } else if (qButtonIndex >= 0) {
                                currentQuestionIndex = qButtonIndex + 1;
                            } else {
                                currentQuestionIndex++;
                                isFirstIndex = !!onlyOptional;
                            }
                            service.setCurrentQuestionIndex(currentQuestionIndex);
                            if (qButtonIndex >= 0 || (isUserGroupChoiceEnable && isSwitchedToNextGroup)) {
                                if (qIndex === grpFirstIndex) {
                                    isFirstIndex = true;
                                    isLastIndex = false;
                                } else {
                                    isFirstIndex = false;
                                }
                            }
                            if (!groupWiseTimeOver && onlyOptional) {
                                assessmentUtility.timer.start(assessmentService.handleTestSubmission, GroupWiseTimingEnabled, isLastGroup);
                            }
                            groupWiseTimeOver = false;
                            assessmentUtility.localStorage.setData("groupWiseTimeOver", groupWiseTimeOver);
                            assessmentUtility.scrollToElement();
                            assessmentUtility.localStorage.setData("isManuallySwitchedToNextGroup", false);
                            //assessmentUtility.scrollToTop();
                            sl.deferred && sl.deferred.resolve();
                        });
                });
        }

        function updateGroupTotaltime(gpId) {
            var groupWiseTimeInfo = _.filter(groupInfoCollection, { "gpId": gpId });
            if (groupWiseTimeInfo && groupWiseTimeInfo.length > 0) {
                groupTotalTime = groupWiseTimeInfo[0].gpTime;
            }
        }

        function updateQpInfos(response) {
            alias = assessmentUtility.getAlias();
            var loginInfo = loginService.getLoginInfo();
            mandatQCollection = response.mandatoryQuestionCollection;
            optGrpCollection = response.optionalGroupCollection;
            groupInfoCollection = response.groupInfoCollection;
            totalQuestionCount = assessmentService.questionpaper.getTotalQuestionCount();
            isLastIndex = (qIndex == (totalQuestionCount - 1) && (optGrpCollection.length === 0 || currentOptionalGroupIndex == optGrpCollection.length) ? true : false);
            GroupWiseTimingEnabled = loginInfo ? loginInfo.Config.isGroupWiseTimingEnabled : false;
            isUserGroupChoiceEnable = loginInfo ? loginInfo.Config.IsUserGroupChoiceEnable : false;
            if (loginInfo && !GroupWiseTimingEnabled) {
                groupTotalTime = loginInfo.TestDuration;
            }
            if (loginInfo && loginInfo.Config) {
                var config = loginInfo.Config;
                service.localVar.isVideoProctoringEnabled = config.VideoProctoring ? true : false;
                service.localVar.isVideoProctoringIsMandatEnabled = config.VideoProctoringIsMandat ? true : false;
                service.localVar.isSpeechTrackingEnabled = config.isSpeechTrackingEnabled ? true : false;
                service.localVar.isMikeTrackingEnabled = config.isMikeTrackingEnabled ? true : false;
                service.localVar.isImageTrackingEnabled = config.isImageTrackingEnabled ? true : false;
                service.localVar.isFaceTrackingEnabled = config.isFaceTrackingEnabled ? true : false;
                service.localVar.audiotracking = config.audiotracking ? true : false;
            }
        }

        function unAnswerQuestion(currentQuestion, questionPaper, editorInstance) {
            if (!(currentQuestion.isAnswered || (currentQuestion.selectedAns && currentQuestion.selectedAns.length > 0))) {
                return false;
            }
            var message = "Are you sure you want to remove your answer?" +
                "<br>* Your answer for this question will be removed." +
                "<br> Press <b>OK</b> to remove or <b>Cancel</b> to retain your answer.";
            var qConfig = currentQuestion.config;
            if (currentQuestion.questionType === 8 || currentQuestion.questionType === 16 || (qConfig && qConfig.IsMultipleAnswer)) {
                var data = {
                    bodyStr: message,
                    headerStr: 'Alert',
                    isAction: true,
                    action: {
                        isOkBtn: true,
                        isCancelBtn: true
                    }
                };
                openModalService.openModal('notificationTemplate', data).then(function(res) {
                    if (res.result.result.modalResponse) {
                        clearAnswer(qConfig, currentQuestion, questionPaper, editorInstance);
                    }
                });
            } else {
                clearAnswer(qConfig, currentQuestion, questionPaper, editorInstance);
            }
        }

        function clearAnswer(qConfig, currentQuestion, questionPaper, editorInstance) {
            if ((qConfig && qConfig.IsMultipleAnswer) ||
                (currentQuestion && currentQuestion.questionType && currentQuestion.questionType === 9)) {
                var selectedOptions = _.filter(currentQuestion.answerChoices, { isSelected: true });
                if (selectedOptions.length > 0) {
                    _.map(selectedOptions, function(option) {
                        option.isSelected = false;
                    });
                }
            }
            var editor = editorInstance;
            var selectedLang = currentQuestion.selectedLanguage;
            if (currentQuestion.questionType === 16 && selectedLang) {
                selectedLang.modifiedCodeSnippet = selectedLang.codeSnipet;
                editor.setValue(selectedLang.codeSnipet, -1);
            } else if (currentQuestion.questionType === 8) {
                currentQuestion.selectedAns = "";
                currentQuestion.qaWordCount = 0;
                if (currentQuestion.jAns) {
                    _.transform(currentQuestion.jAns, function(result, val, key, obj) {
                        obj[key] = '';
                    });
                }
            } else if (currentQuestion.questionType === 2) {
                var target = document.getElementById('spanFillInTheBlank'),
                    input = target.getElementsByTagName('input');
                for (var i = 0; i < input.length; i++) {
                    input[i].value = '';
                }
                if (currentQuestion.jAns) {
                    _.transform(currentQuestion.jAns, function(result, val, key, obj) {
                        obj[key] = '';
                    });
                }
            } else {
                currentQuestion.selectedAns = [];
            }
            currentQuestion.isAnswered = false;
            currentQuestion.isUnanswered = true;
            if (questionPaper) {
                assessmentUtility.localStorage.setData("questionPaper", questionPaper);
                $window.sessionStorage.setItem("questionPaper", questionPaper);
            }
        }

        function execute(_editor, qObj, customInputVal, isExecuteAgainstTestCases) {
            //isExecuted = true;
            var compileDataOfCodeActivityReq = {};
            assessmentUtility.localStorage.setData("isExecuteAgainstTestCases", isExecuteAgainstTestCases);
            var snippet = _editor.getValue();
            var qId = qObj.id;
            var langId = qObj.selectedLanguage ? qObj.selectedLanguage.languageId : 0;
            var langCode = null;
            if (qObj.selectedLanguage && qObj.selectedLanguage.languageCode) {
                langCode = angular.fromJson(qObj.selectedLanguage.languageCode).code;
            } else {
                $log.error("Language code not found.");
            }
            var customInput = "dummy";
            if (customInputVal && customInputVal.trim() !== "") {
                customInput = customInputVal;
            }
            service.localVar.codingResponses[qId] = {
                'input': snippet,
                'CodeToken': '',
                'response': '',
                'action': 'execute',
                'code': snippet,
                'pollingCounter': 0,
                'langId': langId,
                'xguid': null
            };
            if (qObj.codingQuestionSubTypeText === 'SQLProgramming') {
                service.localVar.codingResponses[qId].action = 'execute_sql';
                if (customInput !== "dummy") {
                    service.localVar.codingResponses[qId].isSampleTestCaseResult = true;
                }
            }
            var tempCid = service.localVar.candidateId > 0 ? service.localVar.candidateId : 0;
            var cid = service.localVar.tenantId + ':' + qId + ':' + service.localVar.testId + ':' + tempCid;
            var data = {
                'Source': snippet,
                'Lang': langCode,
                'callback_url': 'callback_url_string',
                'cid': cid //,
                //'TestCases': [customInput]
            };

            if (qObj.codingQuestionSubTypeText === 'SQLProgramming' && customInput !== "dummy") {
                data.testcase_url = "testcase_url_string";
                delete(data.TestCases);
            }
            var request = {
                //'data': angular.toJson(data),
                'action': 'execute',
                'TenantId': service.localVar.tenantId,
                'UserId': '0',
                'cid': cid,
                'languageId': langId,
                'disableBlockUI': true
            };
            if (isExecuteAgainstTestCases) {
                data.testcase_url = "testcase_url_string";
                request.isForTestCaseResult = true;
            } else {
                data.TestCases = [customInput];
            }

            request.data = angular.toJson(data);

            if (qObj.codingQuestionSubTypeText === 'SQLProgramming') {
                request.action = 'execute_sql';
                if (customInput !== "dummy") {
                    request.isSampleTestCaseResult = true;
                }
            }
            compileDataOfCodeActivityReq = {
                'data': angular.toJson(_.omit(data, ['Source'])),
                'action': 'execute',
                'TenantId': service.localVar.tenantId,
                'UserId': '0',
                'cId': cid,
                'languageId': langId,
                'testCaseType': isExecuteAgainstTestCases,
                'type': 'compileData',
                't': new Date().getTime()
            };
            //assessmentUtility.scrollToTop();
            return webService.execute("CodingCompile", request).then(function(response) {
                    if (response) {
                        compileDataOfCodeActivityReq = _.assign({}, compileDataOfCodeActivityReq, {
                            codeToken: _.chain(response).get('data.codeToken').value()
                        });
                        return successCallBackCompileCode(response.data, qId, response.xGuid);
                    }
                },
                function(response) {
                    return failCallBackCompileCode(response.data, qId);
                }
            ).finally(function() {
                /*logging compile information*/
                CaptureCodeActivitySvc.setEventsSequenceWithQuestionId(qId, compileDataOfCodeActivityReq);
            });
        }

        function successCallBackCompileCode(response, qId, guid) {
            return $q(function(resolve, reject) {
                if (response && response.codingCompileResponse && response.codingCompileResponse.codeToken) {
                    service.localVar.codingResponses[qId].response = response;
                    if (service.localVar.codingResponses[qId].codeToken == response.codingCompileResponse.codeToken) {
                        service.localVar.codingResponses[qId].xguid = null;
                        resolve(service.localVar.codingResponses[qId]);
                    }
                } else if (response != null && response.codeToken) {
                    if (service.localVar.codingResponses[qId] && service.localVar.codingResponses[qId].pollingCounter >= 0 && service.localVar.codingResponses[qId].pollingCounter < service.localVar.codingPollingTimer.length) {
                        var pollingCount = service.localVar.codingResponses[qId].pollingCounter++;
                        service.localVar.codingResponses[qId].codeToken = response.codeToken;
                        service.localVar.codingResponses[qId].xguid = guid;
                        setTimeout(function() {
                            resolve(codingResponsePolling(qId));
                        }, service.localVar.codingPollingTimer[pollingCount]);
                    } else {
                        service.localVar.codingResponses[qId].response = { 'IsFailure': true, 'Message': 'Request Timed Out' };
                        if (service.localVar.codingResponses[qId].codeToken == response.codingCompileResponse.codeToken)
                            service.localVar.codingResponses[qId].xguid = null;
                        resolve(service.localVar.codingResponses[qId]);
                    }
                } else if (response != null && response.IsException) {
                    service.localVar.codingResponses[qId].response = { 'IsFailure': true, 'Message': response.Message };
                    service.localVar.codingResponses[qId].xguid = null;
                    resolve(service.localVar.codingResponses[qId]);
                } else if (response && response.error) {
                    service.localVar.codingResponses[qId].response = { 'IsFailure': true, 'Message': response.error.errorDescription };
                    service.localVar.codingResponses[qId].xguid = null;
                    reject(service.localVar.codingResponses[qId]);
                }
            });
        }

        function failCallBackCompileCode(response, qId) {
            return $q(function(resolve, reject) {
                var msg = "Not able to reach server.";
                if (!navigator.onLine) {
                    msg = "No internet connection.";
                }
                service.localVar.codingResponses[qId].response = { 'IsFailure': true, 'Message': msg };
                reject(service.localVar.codingResponses[qId]);
            });
        }

        function codingResponsePolling(qId) {
            var isExecuteAgainstTestCases = assessmentUtility.localStorage.getData("isExecuteAgainstTestCases");
            var cid = service.localVar.tenantId + ':' + qId + ':' + service.localVar.testId + ':' + service.localVar.candidateId;
            var request = {
                "codeToken": service.localVar.codingResponses[qId].codeToken,
                "TenantId": service.localVar.tenantId,
                "UserId": "0",
                'cid': cid,
                'languageId': service.localVar.codingResponses[qId].langId,
                'disableBlockUI': true
            };
            if (isExecuteAgainstTestCases) {

                request.isForTestCaseResult = true;
            }
            var header = null;
            if (service.localVar.codingResponses[qId].xguid) {
                header = { 'x-guid': service.localVar.codingResponses[qId].xguid }
            }
            return webService.execute("CodingCompile", request, null, null, header).then(
                function(response) {
                    if (response) {
                        return successCallBackCompileCode(response.data, qId, response.xGuid);
                    }
                },
                function(response) {
                    failCallBackCompileCode(response.data);
                }
            );
        }

        function flagQuestion(currentQuestion) {
            var qPaper = assessmentUtility.localStorage.getData("questionPaper");
            currentQuestion.isFlagged = currentQuestion.isFlagged ? false : true;
            _.find(qPaper.mandatoryQuestionCollection, { 'id': currentQuestion.id }).isFlagged = currentQuestion.isFlagged;
            assessmentUtility.localStorage.setData('questionPaper', qPaper);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('OnlineAssessmentAngular')
        .factory('commonService', commonService);

    commonService.$inject = [
        '$window',
        '$log',
        '$q',
        'webService',
        'assessmentUtility'
    ];

    function commonService($window, $log, $q, webService, assessmentUtility) {
        var service = {
                testIsOnlinePreview: testIsOnlinePreview,
                uploadFile: uploadToS3,
                GetAllAppPreference: GetAllAppPreference,
                readFile: readFile,
                generateFormForSnapshots: generateFormForSnapshots,
                generateFormForGoldenImage: generateFormForGoldenImage,
                generateMultipleFormsForSnapshots: generateMultipleFormsForSnapshots,
                uploadToPermanentPathS3: uploadToPermanentPathS3,
                clearFormForSnapshots: clearFormForSnapshots
            },
            storedFormsForSnapshots = [];
        return service;

        function testIsOnlinePreview() {
            return !!assessmentUtility.localStorage.getData("_isOnlinePreview");
        }

        function GetAllAppPreference(request) {
            var content = null;
            var GetAllAppPreference_request = request,
                checkAvailableData = CheckDataAvailable(request);
            if (checkAvailableData) {
                return $q.when(checkAvailableData);
            } else {
                return webService.execute("GetAllAppPreference", GetAllAppPreference_request, "POST")
                    .then(function(response) {
                            response = response.data;
                            if (!response || response.IsException || _.size(response.AppPreferenceList) === 0) {
                                return null;
                            }
                            content = response.AppPreferenceList[0].Content;
                            content = content && !!_.size(content) ? angular.fromJson(content) : null;
                            // assessmentUtility.localStorage.setData("appPreferenceContent", content);
                            if (request.Type == "assessment.proctoring.config" && request.IsTenantGlobal) {
                                sessionStorage.setItem('IsTenantGlobalProctoring', JSON.stringify(content));
                            } else if (request.Type == "assessment.proctoring.config" && request.IsGlobal) {
                                sessionStorage.setItem('IsGlobalProctoring', JSON.stringify(content));
                            }
                            return content;
                        },
                        function(response) {
                            $log.error("Unable to fetch Organization Info.");
                        }
                    );
            }
        }

        function CheckDataAvailable(request) {
            if (request.Type == "assessment.proctoring.config" && request.IsTenantGlobal) {
                if (sessionStorage.IsTenantGlobalProctoring !== undefined) {
                    return JSON.parse(sessionStorage.IsTenantGlobalProctoring);
                } else {
                    return false;
                }
            } else if (request.Type == "assessment.proctoring.config" && request.IsGlobal) {
                if (sessionStorage.IsGlobalProctoring !== undefined) {
                    return JSON.parse(sessionStorage.IsGlobalProctoring);
                } else {
                    return false;
                }
            }
        }

        function readFile(f) {
            var deferred = $q.defer(),
                fr = new FileReader();
            fr.onload = function(f) {
                var contents = f.target.result;
                deferred.resolve({
                    'content': contents
                });
            };
            fr.readAsText(f);
            return deferred.promise;

        }

        /*...................File Upload and persistence save in S3...................*/
        //params = {
        //  "data": fileData [formDta],
        //  "action": "uploadFileToS3" / "persistentSave" / "both"  //default value
        //  "fileExtentions": string [comma separated],
        //  "fileSizeLimit": int,
        //  "meta": {} [for persistence save],
        //  "testId": int,
        //  "candidateId": int,
        //  "targetBucket": string [for persistence save]
        //}
        function uploadToS3(params, isSync) {
            if (!params && !params.data && !params.testId && !params.candidateId) {
                return $q.when({ 'msg': 'Bad request(file data,test id and candidate Id are mandatory.)', 'data': null });
            }
            if (!params.action) { params.action = "both"; }
            var constraint = {
                "fileExtentions": params.fileExtentions,
                "fileSizeLimit": params.fileSizeLimit
            };
            if (params.action === "persistentSave") {
                return persitenceSave(params, isSync);
            }
            return webService.execute("uploadFileToS3WithOutVirusScan", params.data, "POST", null, null, constraint).then(
                function(res) {
                    $log.log(res);
                    if (!res || !res.data || !res.data.data) {
                        return $q.reject({ "msg": "Error occurred when Uploading File", "error": null });
                    }
                    res = res.data.data;
                    if (res.fileUrl) {
                        $log.log("File Uploaded Successfully");
                        params.data = res.fileUrl;
                        if (params.action === "both") {
                            return persitenceSave(params, isSync);
                        } else {
                            return $q.resolve({ "msg": "File Uploaded Successfully", "data": res.fileUrl })
                        }
                    }
                },
                function(res) {
                    return $q.reject({ "msg": "Error occurred when Uploading File", "error": res });
                }
            );
        }

        function persitenceSave(params, isSync) {
            var aliasText = assessmentUtility.getAlias(),
                persistentSaveRq = [];
            if (aliasText) {
                aliasText = aliasText.toLowerCase();
            }
            isSync = _.isUndefined(isSync) ? true : isSync;
            var rq = {
                "origFileUrl": params.data,
                "relativePath": params.relativePath ? params.relativePath : aliasText + "/proctor/image/" + params.testId + "/" + params.candidateId,
                "isSync": isSync
            };
            if (params.type && params.type === 'bgsample') {
                rq.relativePath = aliasText + "/proctor/audio/bgsample/" + params.testId + "/" + params.candidateId;
            } else {
                rq.targetBucket = params.targetBucket;
                rq.metaData = params.meta;
            }
            persistentSaveRq.push(rq);
            persistentSaveRq.isSync = isSync;
            return webService.execute("persistentSave", persistentSaveRq).then(
                function(res) {
                    if (!res || !res.data || !res.data.data) {
                        return $q.reject({ "msg": "Error occurred when persisting File", "error": null });
                    }
                    res = res.data.data;
                    if (res && res.SuccessList && _.size(res.SuccessList) > 0) {
                        return $q.resolve({ "msg": "File saved Successfully", "data": res.SuccessList[0] });
                    }
                },
                function(res) {
                    return $q.reject({ "msg": "Error occurred when persisting File", "error": res });
                }
            );
        }

        function generateFormForSnapshots(data) {
            return webService.execute("generateS3Form", data, "POST", null, null, null).then(
                function(res) {
                    $log.log(res);
                    if (!res || !res.data || !res.data.data) {
                        return $q.reject({ "msg": "Error occurred generating form data", "error": null });
                    }
                    res = res.data.data;
                    if (res) {
                        $log.log("form data received");
                        return res;
                    } else {
                        return $q.reject({ "msg": "Error occurred generating form data", "error": res });
                    }
                },
                function(res) {
                    return $q.reject({ "msg": "Error occurred generating form data", "error": res });
                }
            );
        }

        function generateMultipleFormsForSnapshots(data, type) {
            if (storedFormsForSnapshots.length > 0) {
                return $q.when(storedFormsForSnapshots.shift());
            } else {
                return webService.execute("generateS3MultipleForms", data, "POST", null, null, null).then(
                    function(res) {
                        $log.log(res);
                        if (!res || !res.data || !res.data.data) {
                            return $q.reject({ "msg": "Error occurred generating form data", "error": null });
                        }
                        storedFormsForSnapshots = res.data.data;
                        res = res.data.data;
                        if (type !== undefined && type == "initial" && res) {
                            return $q.resolve({ "msg": "Data Collected Successfully" });
                        } else {
                            if (res) {
                                $log.log("form data received");
                                return storedFormsForSnapshots.shift();
                            } else {
                                return $q.reject({ "msg": "Error occurred generating form data", "error": res });
                            }
                        }

                    },
                    function(res) {
                        return $q.reject({ "msg": "Error occurred generating form data", "error": res });
                    }
                );
            }
        }

        function generateFormForGoldenImage(data) {
            return webService.execute("uploadGoldenImageForTraining", data, "POST", null, null, null).then(
                function(res) {
                    $log.log(res);
                    if (!res || !res.data || !res.data.data) {
                        return $q.reject({ "msg": "Error occurred generating form data", "error": null });
                    }
                    res = res.data.data;
                    if (res) {
                        $log.log("form data received");
                        return res;
                    } else {
                        return $q.reject({ "msg": "Error occurred generating form data", "error": res });
                    }
                },
                function(res) {
                    return $q.reject({ "msg": "Error occurred generating form data", "error": res });
                }
            );
        }

        function clearFormForSnapshots() {
            storedFormsForSnapshots = [];
        }

        function uploadToPermanentPathS3(params, camData, s3ImagePath) {
            return generateFormForGoldenImage({
                    relativePath: s3ImagePath
                })
                .then(function(uploadSelfie) {
                    var fd = new FormData();
                    _.forEach(uploadSelfie.s3FormFields.fields, function(value, key) {
                        fd.append(key, value);
                    });
                    fd.append('file', camData.get('file'));
                    var constraints = {
                            fileExtentions: ".jpeg",
                            fileSizeLimit: 102400
                        },
                        imageUrl = uploadSelfie.destinationLocation,
                        formPrintingDynamicUrls = _.chain(sessionStorage.getItem('formPrintingDynamicUrls'))
                        .union([_.get(uploadSelfie, 's3FormFields.url')])
                        .uniq()
                        .value();
                    sessionStorage.setItem('formPrintingDynamicUrls', JSON.stringify(formPrintingDynamicUrls));
                    return webService.execute(uploadSelfie.s3FormFields.url, fd, "POST", null, null, constraints).then(
                        function(res) {
                            $log.log(res);
                            if (!!res && (res.status >= 200 && res.status < 300)) {
                                params.data = imageUrl;
                                return $q.resolve({ "msg": "File Uploaded Successfully", "data": imageUrl });
                            } else {
                                return $q.reject({ "msg": "Error occurred when Uploading File", "error": null });
                            }
                        },
                        function(res) {
                            return $q.reject({ "msg": "Error occurred when Uploading File", "error": res });
                        }
                    );
                })
                .catch(function(errResponse) {
                    return $q.reject({
                        "msg": "Error occurred while fetching required fields",
                        "error": errResponse
                    });
                })
        }

    }
})();

(function() {

    "use strict";

    angular
        .module('OnlineAssessmentAngular')
        .factory("audioRecorder", audioRecorderService);

    function audioRecorderService($q, trackerService) {
        var mediaRecorder = null,
        	mediaStream = null,
            recordedMediaChunks = [],
            startDeferred = null,
            stopDeferred = null,
            opts = null,
            videoStreamReq = false,
            service = {
                start: startRecording,
                stop: stopRecording
            };
        return service;

        /*............Public Methods.........*/
        /*
        options = {
            'constraints': {"mimeType":..},
            'blobType': "audio/ogg"/..
        }*/
        function startRecording(options) {
            var userMediaConstraints = { video: false, audio: true },
                mediaRecorderConstraints = { "mimeType": "audio/webm; codecs=opus" },
                isCreateNewStrm = true,
                isCreateStreamWithNoDependency = true;
            opts = options;

            if (opts && opts.constraints) {
                mediaRecorderConstraints = opts.constraints;
            }
            if (opts && opts.video) {
                userMediaConstraints = { video: true, audio: true };
                videoStreamReq = opts.video;
                mediaRecorderConstraints = { "mimeType": "video/webm; codecs=vp8,opus" }
            }

            startDeferred = $q.defer();

            trackerService.getMediaStream(userMediaConstraints, isCreateNewStrm, isCreateStreamWithNoDependency)
                .then(function(strm) {
                    mediaStream = strm;
                    // if(videoStreamReq){
                    //     strm = strm.getAudioTracks();
                    // }                    
                    mediaRecorder = new MediaRecorder(strm, mediaRecorderConstraints);
                    registerMediaRecorderEvents();
                    mediaRecorder.start();
                })
                .catch(function(res) {
                    startDeferred.reject(res);
                });

            return startDeferred.promise;
        }

        //return type blob...
        function stopRecording() {
            stopDeferred = $q.defer();

            trackerService.stopMediaStream(mediaStream);
            mediaRecorder.stop();

            return stopDeferred.promise;
        }

        /*............Private Methods.......*/
        function registerMediaRecorderEvents() {
            var recordedBlob = null,
                recordedBlobVideo = null,
                blobType = "audio/ogg",
                blobTypeVideo = "video/webm";// "audio/ogg";
            mediaRecorder.onstart = function() {
                stopDeferred = null;
                startDeferred.resolve({ 'strm': mediaStream });
            }
            mediaRecorder.ondataavailable = function(e) {
                recordedMediaChunks.push(e.data);
            }
            mediaRecorder.onstop = function() {
                try {
                    if (opts && opts.blobType) {
                        blobType = opts.blobType;
                    }
                    recordedBlob = new Blob(recordedMediaChunks, { type: blobType });
                    if(videoStreamReq){
                       recordedBlobVideo = new Blob(recordedMediaChunks, { type: blobTypeVideo });
                    }  
                    
                    recordedMediaChunks.length = 0;
                    stopDeferred.resolve({ 'blob': recordedBlob, 'blobVideo': recordedBlobVideo });
                } catch (e) {
                    stopDeferred.reject({ 'error': e });
                }
            }
            mediaRecorder.onerror = function(event) {
                var error = event.error,
                    errmsg = null,
                    deferred = startDeferred ? startDeferred : stopDeferred;
                recordedMediaChunks.length = 0;
                switch (error.name) {
                    case 'InvalidStateError':
                        errmsg = "You can't record the video right now. Try again later.";
                        break;
                    case 'SecurityError':
                        errmsg = "Recording the specified source is not allowed due to security restrictions.";
                        break;
                    default:
                        errmsg = "A problem occurred while trying to record the video.";
                        break;
                }
                if (deferred) {
                    deferred.reject({ 'error': { 'msg': errmsg } });
                }
            }
        }
    }

})();

(function() {
    'use strict';

    angular
        .module("OnlineAssessmentAngular")
        .factory("assessmentUtility", assessmentUtility);

    assessmentUtility.$inject = [
        '$state',
        '$log',
        '$window',
        '$location',
        '$cookies',
        '$interval',
        '$injector',
        '$q',
        '$timeout',
        'deviceDetector'
    ];

    function assessmentUtility($state, $log, $window, $location, $cookies, $interval, $injector, $q, $timeout, deviceDetector) {
        // var time = 0;
        //var service.localVar.timerPromise = null;
        // var ls = new SecureLS({ encodingType: '', isCompression: true });       
        var loggerService = null;
        var localStorageVarables = [
            'TestLoginInformation',
            '_isOnlinePreview',
            'isTimerStarted',
            'lastSubmittedTotalTimeSpent',
            'isQPmergeWithPrevAns',
            'updateCounterPromise',
            'timerPromise',
            'isSwitchedToNextGroup',
            'isGrpWiseTimeOver',
            'groupInfoCollection',
            'groupWiseTimeOver',
            'stopwatchTime',
            'timeSpentBeforeOptionalPreview',
            'fullScreenAlertModalOpened',
            'previewTimer',
            'questionPaper',
            'timeSpent',
            'ucIsAllMandatoryGrpSelected',
            'timer._time',
            'activeGroupId',
            'currentOptionalGroupIndex',
            'selectedOptionalGroupIdCollection',
            'isLastQuestionVisited',
            'lastSessionSpentTime',
            'stopwatchTimePromise',
            'isOptionalPreviewTimeOver',
            'lastAnsweredTimeStamp',
            'isQuestionVideoStarted',
            'submitTestRequest',
            '_isLastGroup',
            '_availTime',
            'isManuallySwitchedToNextGroup',
            'isExecuteAgainstTestCases',
            'captureCodeActivityInformation',
            'savedinS3GoldenImagePath'
        ];
        var totalTestTime = 0;
        var service = {
            localVar: {
                'timerPromise': null,
                'stopwatchTimePromise': null,
                'totalStopWatchTime': 0,
                'isTimeCorrectionRequired': null,
                'timeCorrectionInterval': 1,
                'tickerStartTimeStamp': null,
                'lagging': 0
            },
            resize: resize,
            getActiveQuestionIndex: getActiveQuestionIndex,
            getActiveQuestion: getActiveQuestion,
            scrollToElement: scrollToElement,
            getClientInfo: getClientInfo,
            getBrowserInfo: getBrowserInfo,
            getSateParameters: getSateParameters,
            disableBackButton: disableBackButton,
            getAlias: getAlias,
            getFileNameFromUrl: getFileNameFromUrl,
            modifyFileName: modifyFileName,
            isInFullScreen: isInFullScreen,
            loadFullScreen: loadFullScreen,
            exitFullScreen: exitFullScreen,
            getEventListenerResponse: getEventListenerResponse,
            scrollToTop: scrollToTop,
            checkLocalStorageUsedSize: checkLocalStorageUsedSize,
            getPrivateIP: getPrivateIP,
            parseFlagValToBoolean: parseFlagValToBoolean,
            sessionStorage: {
                setPromise: function(key, promiseObj) {
                    $window.sessionStorage && $window.sessionStorage.setItem(key, JSON.stringify(promiseObj));
                },
                getPromise: function(key) {
                    return JSON.parse($window.sessionStorage && $window.sessionStorage.getItem(key));
                },
                setData: function(key, val) {
                    try {
                        $window.sessionStorage.setItem(key, val && angular.toJson(val));
                    } catch (res) {
                        console.error(res);
                    }
                },
                getData: function(key) {
                    return $window.sessionStorage && jsonParse($window.sessionStorage.getItem(key));
                },
                removeItem: function(key) {
                    $window.sessionStorage && $window.sessionStorage.removeItem(key);
                }
            },
            localStorage: {
                setData: function(key, val) {
                    // if (angular.isNumber(val) && val == 0) {
                    //     val = "__zero__";
                    // }
                    // ls.set(key, val);
                    try {
                        $window.localStorage && $window.localStorage.setItem(key, val && angular.toJson(val));
                    } catch (res) {
                        var request = {
                            "canLoginActivityLog": {
                                "localStorageError": {
                                    "response": res,
                                    "timeStamp": new Date()
                                }
                            }
                        };
                        loggerService = loggerService ? loggerService : $injector.get("loggerService");
                        loggerService.push(request);
                        if (res.name && (res.name == 'QuotaExceededError' || res.name == 'NS_ERROR_DOM_QUOTA_REACHED')) {
                            checkLocalStorageUsedSize(key, val, true);
                        }
                    }
                },
                getData: function(key) {
                    // var value = "";
                    // try {
                    //     value = ls.get(key);
                    //     if (!value)
                    //         value = jsonParse($window.localStorage.getItem(key));
                    // } catch (e) {
                    //     value = jsonParse($window.localStorage.getItem(key));
                    // }
                    // return value ? (value == "__zero__" ? 0 : value) : null;
                    return $window.localStorage && jsonParse($window.localStorage.getItem(key));
                },
                /* eslint-disable */
                setPromise: function(key, promiseObj) {
                    // ls.set(key, promiseObj);
                    $window.localStorage && $window.localStorage.setItem(key, JSON.stringify(promiseObj));
                },
                getPromise: function(key) {
                    // return ls.get(key);
                    return JSON.parse($window.localStorage && $window.localStorage.getItem(key));
                },
                /* eslint-enable */
                clearData: function() {
                    // ls.clear();
                    $window.localStorage && $window.localStorage.clear();
                },
                clearItem: function(key) {
                    // ls.remove(key);
                    $window.localStorage && $window.localStorage.removeItem(key);
                }
            },
            cookies: {
                set: function(key, val, saveAsItIs) {
                    var now = new Date();
                    now.setDate(now.getDate() + 1);
                    var options = {
                        path: '/',
                        //domain: location.hostname,
                        expires: now,
                        secure: false
                    };
                    if (key !== "X-AUTH-TOKEN" && !saveAsItIs) {
                        val = angular.toJson(val);
                    }
                    $cookies && $cookies.put(key, val, options);
                },
                get: function(key) {
                    if (key !== "X-AUTH-TOKEN") {
                        return $cookies && jsonParse($cookies.get(key, { path: '/', domain: location.hostname }));
                    } else {
                        return $cookies && $cookies.get(key, { path: '/', domain: location.hostname });
                    }
                },
                clear: function(key) {
                    $cookies.remove(key, { path: '/', domain: location.hostname });
                }
            },
            timer: {
                _time: 0,
                _partialSubmissionInterval: 0,
                _nextPartialSubmission: 0,
                time: function() {
                    service.timer._time = service.localStorage.getData("timeSpent");
                    return service.timer._time;
                },
                totalTestTime: function() {
                    if (totalTestTime === service.timer._time) {
                        service.timer._time = 0;
                        totalTestTime = 0;
                    }
                    return totalTestTime;
                },
                start: function(callBack, GroupWiseTimingEnabled, isLastGroup) {

                    var assessmentService = $injector.get('assessmentService'),
                        allocatedTime = assessmentService.getAllocatedTimeForGroupOrTest(),
                        loginInfo = service.localStorage.getData('TestLoginInformation'),
                        isThirdPartyTest = !!(loginInfo && loginInfo.Config &&
                            loginInfo.Config.thirdPartyTestType),
                        randomInterval = isThirdPartyTest ? _.random(900, 1200) : _.random(300, 480);
                    // _.random(900, 1200)--> random interval between 15-20 minutes
                    //_.random(300, 480); //random interval between 5-8 minutes
                    $window.sessionStorage.setItem("isTimerStarted", true);
                    service.timer._time = service.localStorage.getData("timeSpent");
                    totalTestTime = allocatedTime;
                    service.localVar.timerPromise = service.sessionStorage.getPromise("timerPromise");

                    if (!service.localVar.timerPromise) {
                        service.localVar.tickerStartTimeStamp = new Date();

                        service.timer._partialSubmissionInterval = randomInterval;
                        service.timer._nextPartialSubmission = service.timer._partialSubmissionInterval;

                        var stopFaceTrackerAsSystemSlow = $window.sessionStorage.getItem("stopFaceTrackerAsSystemSlow");

                        service.localVar.isTimeCorrectionRequired = (stopFaceTrackerAsSystemSlow == "false");
                        service.localVar.timerPromise = $interval(function() {
                            updateTime(service, allocatedTime, callBack, GroupWiseTimingEnabled, isLastGroup);
                        }, 1000);
                        service.sessionStorage.setPromise("timerPromise", service.localVar.timerPromise);
                    }
                },
                pause: function() {
                    service.localVar.timerPromise = service.sessionStorage.getPromise("timerPromise");
                    if (service.localVar.timerPromise) {
                        $interval.cancel(service.localVar.timerPromise);
                        service.sessionStorage.setPromise("timerPromise", null);
                        $window.sessionStorage.setItem("isTimerStarted", false);
                        service.localStorage.setData("timer._time", service.timer._time);
                        service.localStorage.setData("timeSpent", service.timer._time);
                        service.localStorage.setData("timeSpentBeforeOptionalPreview", service.timer._time);
                    }
                },
                pauseFor360RoomScan: function() {
                    service.localVar.timerPromise = service.sessionStorage.getPromise("timerPromise");
                    if (service.localVar.timerPromise) {
                        $interval.cancel(service.localVar.timerPromise);
                        service.sessionStorage.setPromise("timerPromise", null);
                        $window.sessionStorage.setItem("isTimerStarted", false);
                        service.localStorage.setData("timer._time", service.timer._time);
                        service.localStorage.setData("timeSpent", service.timer._time);
                    }
                },
                stop: function(stopBy) {
                    service.localVar.timerPromise = service.sessionStorage.getPromise("timerPromise");
                    if (service.localVar.timerPromise) {
                        $interval.cancel(service.localVar.timerPromise);
                        service.sessionStorage.setPromise("timerPromise", null);
                        $window.sessionStorage.setItem("isTimerStarted", false);
                        service.localStorage.setData("timer._time", service.timer._time);
                        if (stopBy !== "optionalPreview") {
                            service.timer._time = 0;
                        }
                        service.localStorage.setData("timeSpent", 0);
                    }
                }
            },
            stopWatch: {
                stopwatchTime: 0,
                getTotalTime: function() {
                    return service.localVar.totalStopWatchTime;
                },
                start: function(_totalStopWatchTime, onStopCallBack, onStopCallBackData, startBy) {
                    /*...............Stop Test Timer...............*/
                    service.timer.stop(startBy);
                    /*............................................*/
                    service.stopWatch.stopwatchTime = service.localStorage.getData("stopwatchTime");
                    service.localVar.totalStopWatchTime = _totalStopWatchTime;
                    if (!service.stopWatch.stopwatchTime) {
                        service.stopWatch.stopwatchTime = 0;
                    }
                    service.localVar.stopwatchTimePromise = service.localStorage.getPromise("stopwatchTimePromise");
                    if (!service.localVar.stopwatchTimePromise) {
                        service.localVar.stopwatchTimePromise = $interval(function() {
                            if (_totalStopWatchTime === service.stopWatch.stopwatchTime) {
                                service.stopWatch.stop(onStopCallBack, onStopCallBackData, startBy);
                            } else {
                                service.stopWatch.stopwatchTime += 1;
                                service.localStorage.setData("stopwatchTime", service.stopWatch.stopwatchTime);
                            }
                        }, 1000);
                        service.localStorage.setPromise("stopwatchTimePromise", service.localVar.stopwatchTimePromise);
                    }
                },
                stop: function(callBack, callBackData, stopBy) {
                    /*...............Start Test Timer...............*/
                    //var avilTestTime = service.localStorage.getData("_availTime");
                    var isLastGroup = angular.fromJson($window.sessionStorage.getItem("isLastGroup"));
                    var assessmentService = $injector.get('assessmentService');
                    var isGroupWiseTimingEnable = assessmentService.getGroupWiseTimingStatus();
                    var isOnlyOptional = assessmentService.checkOnlyOptionalStatus();
                    var activeGrpWiseTimeOver = service.localStorage.getData("groupWiseTimeOver");
                    var isGrpTimerToBeStarted = activeGrpWiseTimeOver ? false : true;
                    if (stopBy === "optionalPreview") {
                        isGrpTimerToBeStarted = isOnlyOptional ? false : isGrpTimerToBeStarted;
                        service.localStorage.setData("timeSpentBeforeOptionalPreview", service.timer._time);
                        service.localStorage.setData("timeSpent", service.timer._time);
                        //service.timer._time = 0;                        
                    }
                    if (stopBy !== "onbeforeunload") {
                        if (isGrpTimerToBeStarted) {
                            service.timer.start(assessmentService.handleTestSubmission, isGroupWiseTimingEnable, isLastGroup);
                        }
                    }
                    /*............................................*/
                    service.localVar.stopwatchTimePromise = service.localStorage.getPromise("stopwatchTimePromise");
                    if (service.localVar.stopwatchTimePromise) {
                        $interval.cancel(service.localVar.stopwatchTimePromise);
                        service.localStorage.setPromise("stopwatchTimePromise", null);
                        if (callBack) {
                            callBack(callBackData);
                        }
                    }
                    assessmentService.questionpaper.get().then(function(response) {
                        if (response) {
                            assessmentService.addRemainingTimeToLastActiveQuestion(response, false, true);
                        }
                    });
                }
            },
            color: {
                hexToRgb: function(hex) {
                    // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
                    var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
                    hex = hex.replace(shorthandRegex, function(m, r, g, b) {
                        return r + r + g + g + b + b;
                    });

                    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
                    if (!result) {
                        $log.log("Wrong HEX code !");
                        return null;
                    }
                    return (
                        parseInt(result[1], 16) + "," +
                        parseInt(result[2], 16) + "," +
                        parseInt(result[3], 16)
                    );
                }
            }
        };
        return service;

        function updateTime(assessmentUtility, allocatedTime, callBack, GroupWiseTimingEnabled, isLastGroup) {
            var sl = service.localVar,
                elapsedAsPerTimeStamp = null,
                laggedSec = 0,
                tickerStopTimeStamp = new Date();
            service.timer._time = assessmentUtility.localStorage.getData("timeSpent");
            $window.sessionStorage.setItem("manualRefresh", false);
            if (service.timer._time < allocatedTime) {
                service.timer._time += 1;
                /*...................Time Correction......................*/
                if (service.localVar.isTimeCorrectionRequired &&
                    service.timer._time % sl.timeCorrectionInterval === 0) {
                    elapsedAsPerTimeStamp = tickerStopTimeStamp - sl.tickerStartTimeStamp;
                    sl.tickerStartTimeStamp = tickerStopTimeStamp;
                    sl.lagging += (elapsedAsPerTimeStamp - (sl.timeCorrectionInterval * 1000));
                    laggedSec = parseInt(sl.lagging / 1000);
                    //console.log("sap_laggedSec : ", laggedSec);
                    if (laggedSec > 0 && laggedSec < 5) {
                        if (service.timer._time + laggedSec < allocatedTime) {
                            service.timer._time += laggedSec;
                        } else {
                            service.timer._time = allocatedTime;
                        }
                    }
                    sl.lagging = sl.lagging % 1000;
                }
                /*.......................................................*/
                assessmentUtility.localStorage.setData("lastSessionSpentTime", service.timer._time);
                assessmentUtility.localStorage.setData("timeSpent", service.timer._time);
                assessmentUtility.localStorage.setData("_availTime", allocatedTime - service.timer._time);
                if (service.timer._time >= service.timer._nextPartialSubmission) {
                    service.timer._nextPartialSubmission += service.timer._partialSubmissionInterval;
                    callBack(true, false, 'autoSubmition');
                }
            } else if (service.timer._time >= allocatedTime) {
                assessmentUtility.timer.stop();
                if (!isLastGroup && GroupWiseTimingEnabled) {
                    $window.sessionStorage.setItem("isTimerStarted", true);
                    callBack(true, false, 'autoGroupChange');
                } else {
                    callBack(false, false, 'autoFinalSubmition');
                }
            }
        }

        function resize(win) {
            var winHeight = win.innerHeight - 200;
            return winHeight;
        }

        function getActiveQuestionIndex() {
            var location = $location;
            var path = location.url();
            var qIndex = -1;
            if (location) {
                qIndex = parseInt(path.substring((path.lastIndexOf("/") + 1), path.length));
            }
            return isNaN(qIndex) ? -1 : qIndex;
        }

        function getActiveQuestion() {
            var qPaper = service.localStorage.getData("questionPaper"),
                currentQindex = service.getActiveQuestionIndex(),
                mandatQs = qPaper ? qPaper.mandatoryQuestionCollection : null,
                currentQ = null;

            if (mandatQs && mandatQs.length > 0) {
                currentQ = mandatQs[currentQindex];
            }
            return currentQ;
        }

        function scrollToElement(elemId) {
            if (elemId) {
                var scrollIntoViewElem = document.getElementById(elemId);
                scrollIntoViewElem.scrollIntoView({ behavior: 'smooth' });
            } else {
                var qIndex = this.getActiveQuestionIndex();
                elemId = 'q' + qIndex;
                //$location.hash(elemId);
                $timeout(function() {
                    var qIndexButtonPanel = document.getElementsByClassName("qindex-row")[0];
                    var qElem = document.getElementById(elemId);
                    if (qElem) {
                        qIndexButtonPanel.scrollLeft = qElem.offsetLeft;
                    }
                }, 500);
            }
        }

        function scrollToTop() {
            var uiViewElement = document.getElementsByClassName('main-ui-view')[0];
            uiViewElement.scrollTop = 0;
        }

        function getSateParameters(current_state_params) {
            var paramObj = null;
            if (current_state_params && current_state_params.stateParams) {
                if (_.indexOf(current_state_params.stateParams, '%') > -1) {
                    current_state_params = angular.fromJson(atob(decodeURIComponent(current_state_params.stateParams)));
                } else {
                    current_state_params = angular.fromJson(atob(current_state_params.stateParams));
                }

            }
            if (current_state_params) {
                paramObj = current_state_params;
                if (current_state_params.alias && current_state_params.alias !== "") {
                    paramObj.alias = current_state_params.alias;
                }
                if (current_state_params.uid && current_state_params.uid !== "") {
                    paramObj.uid = atob(current_state_params.uid);
                }
                if (current_state_params.pswd && current_state_params.pswd !== "") {
                    paramObj.pswd = atob(current_state_params.pswd);
                }
                if (current_state_params.autologin && current_state_params.autologin !== "") {
                    paramObj.autologin = angular.fromJson(atob(current_state_params.autologin));
                }
                if (current_state_params.isOnlinePreview && current_state_params.isOnlinePreview !== "") {
                    paramObj.isOnlinePreview = angular.fromJson(atob(current_state_params.isOnlinePreview));
                }
                if (current_state_params.previewToken && current_state_params.previewToken !== "") {
                    paramObj.previewToken = atob(current_state_params.previewToken);
                }
                if (current_state_params.loginToken && current_state_params.loginToken !== "") {
                    paramObj.loginToken = atob(current_state_params.loginToken);
                }
            }
            return paramObj;
        }

        function disableBackButton(locationHref) {
            // history.pushState(null, null, locationHref);
            // window.onpopstate = function(event) {
            //     history.go(1);
            // };
        }

        function jsonParse(json) {
            try {
                var data = angular.fromJson(json);
                if (!data && data !== 0 && data != false) {
                    data = null;
                }
                return data;
            } catch (e) {
                //service.cookies.clear('X-AUTH-TOKEN');
                return null;
            }
        }

        function getClientInfo() {
            var clientInfo = null;
            var browserInfo = 'Browser:' + deviceDetector.browser + '-' + deviceDetector.browser_version; //getBrowserInfo($window.navigator.userAgent);
            var OSInfo = ', OS:' + deviceDetector.os;
            OSInfo += deviceDetector.os_version && deviceDetector.os_version != 'unknown' ? '-' + deviceDetector.os_version : ''; //$window.navigator.platform + ',';
            var device = deviceDetector.device;
            var isDesktop = deviceDetector.isDesktop();
            var deviceInfo = device && (device.toLowerCase() == 'ipad' || device.toLowerCase() == 'iphone') ? ', Device:' + deviceDetector.device : '';
            var privateIPInfo = ', IPAddress:';
            var timeZone = moment.tz.guess(true);
            return getPrivateIP().then(function(ipInfo) {
                privateIPInfo += ipInfo;
                clientInfo = browserInfo + OSInfo + deviceInfo + privateIPInfo + ", timeZone:" + timeZone;
                return $q.when({ "clientInfo": clientInfo, "ip": ipInfo && ipInfo.toString(), "isDesktop": isDesktop });
            });
        }

        function getAlias() {
            var paramObj = {};
            console.log($state);
            if ($state.current.name !== 'compatibility') {
                paramObj = service.getSateParameters($state.params);
            } else if ($state.current.name === 'compatibility' && $state.params) {
                paramObj.alias = $state.params.stateParams;
            }
            var alias = paramObj && paramObj.alias;
            return alias ? alias : "";
        }

        function getFileNameFromUrl(url) {
            var fileName = url.split('\\').pop().split('/').pop();
            return fileName;
        }

        function modifyFileName(fileNameWithExtention, data, delimiter, modificationType) {
            switch (modificationType) {
                case "append":
                    var fileName_ext = fileNameWithExtention.split(".");
                    var mdFileNm = fileName_ext[0] + delimiter + data + "." + fileName_ext[1];
                    return mdFileNm;
                default:
                    return fileNameWithExtention;
            }
        }

        function getBrowserInfo(ua) {
            ua = ua.toLowerCase();
            var detail = {},
                match = /(edge)[ \/]([\w.]+)/.exec(ua) || /(chrome)[ \/]([\w.]+)/.exec(ua) ||
                /(webkit)[ \/]([\w.]+)/.exec(ua) ||
                /(opera)(?:.*version|)[ \/]([\w.]+)/.exec(ua) ||
                /(msie) ([\w.]+)/.exec(ua) ||
                ua.indexOf("compatible") < 0 && /(mozilla)(?:.*? rv:([\w.]+)|)/.exec(ua) || [];
            detail.browser = match[1] ? match[1] : '';
            detail.version = parseInt(match[2]) ? parseInt(match[2]) : 0;
            return detail;
        }
        /* eslint-disable */
        function getPrivateIP() {
            // NOTE: window.RTCPeerConnection is "not a constructor" in FF22/23
            try {
                return new Promise(function(resolve, reject) {
                    try {
                        var RTCPeerConnection = /*window.RTCPeerConnection ||*/ window.webkitRTCPeerConnection || window.mozRTCPeerConnection;
                        var displayAddrs = null;
                        if (RTCPeerConnection) {
                            var rtc = new RTCPeerConnection({ iceServers: [] });
                            if (1 || window.mozRTCPeerConnection) { // FF [and now Chrome!] needs a channel/stream to proceed
                                rtc.createDataChannel('', { reliable: false });
                            }
                            rtc.onicecandidate = function(evt) {
                                // convert the candidate to SDP so we can run it through our general parser
                                // see https://twitter.com/lancestout/status/525796175425720320 for details
                                if (evt.candidate) {
                                    grepSDP("a=" + evt.candidate.candidate);
                                } else {
                                    resolve("Unable.to.detect.ip");
                                }
                            };
                            rtc.createOffer(function(offerDesc) {
                                grepSDP(offerDesc.sdp);
                                rtc.setLocalDescription(offerDesc);
                            }, function(e) { $log.warn("offer failed", e); });
                            var addrs = Object.create(null);

                            addrs["0.0.0.0"] = false;

                            function updateDisplay(newAddr) {
                                if (newAddr in addrs) return;
                                else addrs[newAddr] = true;
                                displayAddrs = Object.keys(addrs).filter(function(k) { return addrs[k]; });
                                $log.error(displayAddrs.join(" or perhaps "));
                                resolve(displayAddrs);
                            }

                            function grepSDP(sdp) {
                                var hosts = [],
                                    parts = null,
                                    type = null,
                                    addr = null;
                                sdp.split('\r\n').forEach(function(line) { // c.f. http://tools.ietf.org/html/rfc4566#page-39
                                    if (~line.indexOf("a=candidate")) { // http://tools.ietf.org/html/rfc4566#section-5.13
                                        parts = line.split(' '); // http://tools.ietf.org/html/rfc5245#section-15.1
                                        addr = parts[4];
                                        type = parts[7];
                                        if (type === 'host') updateDisplay(addr);
                                    } else if (~line.indexOf("c=")) { // http://tools.ietf.org/html/rfc4566#section-5.7
                                        parts = line.split(' ');
                                        addr = parts[2];
                                        updateDisplay(addr);
                                    }
                                });
                            }
                        } else {
                            resolve("");
                        }
                    } catch (e) {
                        resolve("");
                    }
                });
            } catch (e) {
                return $q.when('');
            }
        }

        function isInFullScreen() {
            return (document.fullscreenElement && document.fullscreenElement !== null) ||
                (document.webkitFullscreenElement && document.webkitFullscreenElement !== null) ||
                (document.mozFullScreenElement && document.mozFullScreenElement !== null) ||
                (document.msFullscreenElement && document.msFullscreenElement !== null);
        }

        function loadFullScreen() {
            var checkFullScreen = isInFullScreen();
            if (!checkFullScreen)
                requestFullScreen(document.documentElement);
        }

        function requestFullScreen(element) {
            if (element.requestFullscreen)
                element.requestFullscreen();
            else if (element.msRequestFullscreen)
                element.msRequestFullscreen();
            else if (element.mozRequestFullScreen)
                element.mozRequestFullScreen();
            else if (element.webkitRequestFullscreen)
                element.webkitRequestFullscreen();
        }

        function exitFullScreen() {
            var checkFullScreen = isInFullScreen();
            // var docElm = document.documentElement;
            if (checkFullScreen) {
                if (document.exitFullscreen) {
                    document.exitFullscreen();
                } else if (document.webkitExitFullscreen) {
                    document.webkitExitFullscreen();
                } else if (document.mozCancelFullScreen) {
                    document.mozCancelFullScreen();
                } else if (document.msExitFullscreen) {
                    document.msExitFullscreen();
                }
            }
        }

        function getEventListenerResponse() {
            return $q.when(
                window.addEventListener("message", function(e) {
                    if (e.origin !== location.origin) {
                        return false;
                    }
                    var eventListenerResponse = null;
                    if (e.data) {
                        eventListenerResponse = e.data;
                    }
                    return eventListenerResponse;
                })
            );
        }

        function checkLocalStorageUsedSize(key, value, isForced) {
            var usedLocalStorageSpace = 0;
            if (!isForced) {
                usedLocalStorageSpace = JSON.stringify(localStorage).length;
                usedLocalStorageSpace = angular.isNumber(usedLocalStorageSpace) ? parseFloat(usedLocalStorageSpace / 1024 / 1024).toFixed(2) : 0;
            }
            if (usedLocalStorageSpace > 4 || isForced) {
                _.forEach(localStorage, function(value, key) {
                    if (_.lastIndexOf(localStorageVarables, key) == -1) {
                        localStorage.removeItem(key);
                    }
                });
            }
            if (key && value) {
                service.localStorage.setData(key, value);
            }
        }

        function parseFlagValToBoolean(flagVal) {

            if (!flagVal) return false; // undefined,null,false,0

            if (typeof(flagVal) === "boolean") {
                return flagVal;
            }

            if (!isNaN(flagVal)) { // Integers
                
                return parseInt(flagVal) > 0 ? true : false;
            } else {
                
                flagVal = flagVal.toLowerCase();
                
                return flagVal === "true" ||
                    flagVal === "yes" ? true : false;
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module("OnlineAssessmentAngular")
        .factory("assessmentService", assessmentService);

    assessmentService.$inject = ['$rootScope', 'webService', '$q', 'assessmentUtility', '$http', 'loginService', 'blockUI', '$log', '$state', '$window', '$timeout', '$injector', 'modalService', '$uibModalStack', 'afterSubmission', 'proctorMessage', 'proctoringService', 'openModalService', 'deviceDetector', 'trackerService', 'mediaRecorder', 'loggerService'];

    function assessmentService($rootScope, webService, $q, assessmentUtility, $http, loginService, blockUI, $log, $state, $window, $timeout, $injector, modalService, $uibModalStack, afterSubmission, proctorMessage, proctoringService, openModalService, deviceDetector, trackerService, mediaRecorder, loggerService) {

        var questionPaper = null,
            totalQustionCount = 0,
            activeGroupId = -1,
            localStorageAvail = false,
            testSubmissionFailureCount = 0,
            submissionAttemptsConfig = 5,
            submissionAttempts = 0;
        var service = {
            localVar: {
                currentOptionalGroupIndex: -1,
                isOptionalGrpPresentToBeSelected: false,
                containsRTCquestion: false,
                isUserGroupChoiceEnable: false,
                isClientSideRandomizationEnable: false,
                isRandomized: false,
                testQuestionInfoCollection: null
            },
            /*codingLanguageMapper: {
                "bash": "sh",
                "c": "c_cpp",
                "coffee": "coffee",
                "cpp": "c_cpp",
                "csharp": "csharp",
                "d": "d",
                "erlang": "erlang",
                "fsharp": "csharp",
                "go": "golang",
                "haskell": "haskell",
                "java": "java",
                "java8": "java",
                "js": "javascript",
                "ocaml": "ocaml",
                "perl": "perl",
                "php": "php",
                "python": "python",
                "python3": "python",
                "ruby": "ruby",
                "rust": "rust",
                "scala": "scala",
                "html": "html",
                "css": "css",
                "MySql": "sql",
                "MsSQLServer": "sql",
                "ts": "typescript"
            },*/
            codingLanguageMapper: {
                "abc": "abc",
                "actionscript": "actionscript",
                "ada": "ada",
                "alda": "alda",
                "apacheConf": "apache_conf",
                "apex": "apex",
                "aql": "aql",
                "asciidoc": "asciidoc",
                "asl": "asl",
                "assemblyX86": "assembly_x86",
                "autohotkey": "autohotkey",
                "bash": "sh",
                "batchfile": "batchfile",
                "c9search": "c9search",
                "c": "c_cpp",
                "cpp": "c_cpp",
                "cirru": "cirru",
                "clojure": "clojure",
                "cobol": "cobol",
                "coffee": "coffee",
                "coldfusion": "coldfusion",
                "crystal": "crystal",
                "csharp": "csharp",
                "csoundDocument": "csound_document",
                "csoundOrchestra": "csound_orchestra",
                "csoundScore": "csound_score",
                "css": "css",
                "curly": "curly",
                "d": "d",
                "dart": "dart",
                "diff": "diff",
                "django": "django",
                "dockerfile": "dockerfile",
                "dot": "dot",
                "drools": "drools",
                "edifact": "edifact",
                "eiffel": "eiffel",
                "ejs": "ejs",
                "elixir": "elixir",
                "elm": "elm",
                "erlang": "erlang",
                "forth": "forth",
                "fortran": "fortran",
                "fsharp": "fsharp",
                "fsl": "fsl",
                "ftl": "ftl",
                "gcode": "gcode",
                "gherkin": "gherkin",
                "gitignore": "gitignore",
                "glsl": "glsl",
                "gobstones": "gobstones",
                "go": "golang",
                "graphqlschema": "graphqlschema",
                "groovy": "groovy",
                "haml": "haml",
                "handlebars": "handlebars",
                "haskell": "haskell",
                "haskellCabal": "haskell_cabal",
                "haxe": "haxe",
                "hjson": "hjson",
                "html": "html",
                "htmlElixir": "html_elixir",
                "htmlRuby": "html_ruby",
                "ini": "ini",
                "io": "io",
                "jack": "jack",
                "jade": "jade",
                "java": "java",
                "java8": "java",
                "js": "javascript",
                "json": "json",
                "json5": "json5",
                "jsoniq": "jsoniq",
                "jsp": "jsp",
                "jssm": "jssm",
                "jsx": "jsx",
                "julia": "julia",
                "kotlin": "kotlin",
                "latex": "latex",
                "less": "less",
                "liquid": "liquid",
                "lisp": "lisp",
                "livescript": "livescript",
                "logiql": "logiql",
                "lsl": "lsl",
                "lua": "lua",
                "luapage": "luapage",
                "lucene": "lucene",
                "makefile": "makefile",
                "markdown": "markdown",
                "mask": "mask",
                "matlab": "matlab",
                "maze": "maze",
                "mediawiki": "mediawiki",
                "mel": "mel",
                "mixal": "mixal",
                "mushcode": "mushcode",
                "MySql": "mysql",
                "MsSQLServer": "sql",
                "nginx": "nginx",
                "nim": "nim",
                "nix": "nix",
                "nsis": "nsis",
                "nunjucks": "nunjucks",
                "objectivec": "objectivec",
                "ocaml": "ocaml",
                "pascal": "pascal",
                "perl": "perl",
                "perl6": "perl6",
                "pgsql": "pgsql",
                "php": "php",
                "phpLaravelBlade": "php_laravel_blade",
                "pig": "pig",
                "powershell": "powershell",
                "praat": "praat",
                "prisma": "prisma",
                "prolog": "prolog",
                "properties": "properties",
                "protobuf": "protobuf",
                "puppet": "puppet",
                "python": "python",
                "python3": "python",
                "qml": "qml",
                "r": "r",
                "razor": "razor",
                "rdoc": "rdoc",
                "red": "red",
                "rhtml": "rhtml",
                "rst": "rst",
                "ruby": "ruby",
                "rust": "rust",
                "sass": "sass",
                "scad": "scad",
                "scala": "scala",
                "scheme": "scheme",
                "scss": "scss",
                "sjs": "sjs",
                "slim": "slim",
                "smarty": "smarty",
                "snippets": "snippets",
                "soyTemplate": "soy_template",
                "space": "space",
                "sql": "sql",
                "sqlserver": "sqlserver",
                "stylus": "stylus",
                "svg": "svg",
                "swift": "swift",
                "tcl": "tcl",
                "terraform": "terraform",
                "tex": "tex",
                "text": "text",
                "textile": "textile",
                "toml": "toml",
                "tsx": "tsx",
                "twig": "twig",
                "ts": "typescript",
                "vala": "vala",
                "vbscript": "vbscript",
                "velocity": "velocity",
                "verilog": "verilog",
                "vhdl": "vhdl",
                "visualforce": "visualforce",
                "wollok": "wollok",
                "xml": "xml",
                "xquery": "xquery",
                "yaml": "yaml",
                "zeek": "zeek"
            },
            questionpaper: {
                load: function() {
                    var loginInfo = loginService.getLoginInfo(),
                        scriptFilesUrls = [],
                        //alias = assessmentUtility.getAlias(),
                        //isOnlinePreview = commonService.testIsOnlinePreview(),
                        scriptTagFiles = _.map(angular.element(document).find('script'), 'src'),
                        loadtestRequest = {
                            userAgent: navigator.userAgent,
                            isDeviceTypeDesktop: deviceDetector.isDesktop(),
                            scriptFiles: _.filter(scriptTagFiles, function(script) {
                                if (script.indexOf('hirepro.in') > -1) {
                                    scriptFilesUrls.push(_.replace(script, 'https://', ''));
                                    return script;
                                }
                            })
                        };
                    if (loadtestRequest && loadtestRequest.scriptFiles) {
                        loadtestRequest.scriptFiles = scriptFilesUrls;
                    }
                    var _localVar = {
                        currentOptionalGroupIndex: -1,
                        isOptionalGrpPresentToBeSelected: false,
                        containsRTCquestion: false,
                        isUserGroupChoiceEnable: false,
                        isClientSideRandomizationEnable: false,
                        isRandomized: false,
                        testQuestionInfoCollection: null
                    };
                    service.localVar = _localVar;
                    return webService.execute("LoadTest", loadtestRequest, "POST").then(
                        function(response) {
                            if (response && response.data && response.data.status === 'OK') {
                                if (response.data) {
                                    questionPaper = creteFlatStructure(response.data, loginInfo);
                                    totalQustionCount = questionPaper.mandatoryQuestionCollection.length;
                                }
                                return questionPaper;
                            }
                        },
                        function() {
                            //blockUI.stop();
                        }
                    );
                },
                get: function() {
                    questionPaper = assessmentUtility.localStorage.getData("questionPaper");
                    if (questionPaper !== null) {
                        updateQPaperInfos();
                    }
                    var qPromise = $q.when(!angular.isObject(questionPaper) ? this.load() : questionPaper);
                    //blockUI.stop();
                    return qPromise;
                },
                getTotalQuestionCount: function() {
                    return totalQustionCount;
                },
                addOptionalGroup: function(selectedGroupId) {
                    localStorageAvail = false;
                    addOptionalGrp(selectedGroupId, localStorageAvail);
                },
                getCurrentOptionalGroupIndex: function() {
                    var cgi = assessmentUtility.localStorage.getData("currentOptionalGroupIndex");
                    return cgi;
                },
                activeGroup: {
                    getId: function() {
                        if (activeGroupId === -1 && questionPaper.mandatoryQuestionCollection && questionPaper.mandatoryQuestionCollection.length > 0) {
                            activeGroupId = questionPaper.mandatoryQuestionCollection[0].gpId;
                        }
                        return activeGroupId;
                    },
                    setId: function(activeGrpId) {
                        activeGroupId = activeGrpId;
                        /*.......Save data to LocalStorage........*/
                        assessmentUtility.localStorage.setData("activeGroupId", activeGroupId);
                    }
                },
                isOptionalGrpPresentToBeSelected: function() {
                    return service.localVar.isOptionalGrpPresentToBeSelected;
                }
            },
            handleTestSubmission: handleTestSubmission,
            submitTest: submitTest,
            checkForPendingTask: checkForPendingTask,
            getNextUnansweredQuestion: getNextUnansweredQuestion,
            getLastAnsweredQuestion: getLastAnsweredQuestion,
            //getPrevUnansweredQuestion: getPrevUnansweredQuestion,
            getLastSubmittedResult: getLastSubmittedResult,
            getSubmitTestRequest: getSubmitTestRequest,
            submitTestBeforeUnload: submitTestBeforeUnload,
            getGroupWiseTimingStatus: getGroupWiseTimingStatus,
            getLastActiveGroup1stQuestionIndex: getLastActiveGroup1stQuestionIndex,
            getQuestionWiseTimeSpent: getQuestionWiseTimeSpent,
            addRemainingTimeToLastActiveQuestion: addRemainingTimeToLastActiveQuestion,
            //getLoginCredentialsByCandidateIdOrEmail: getLoginCredentialsByCandidateIdOrEmail,
            //handleAutoTest: handleAutoTest,
            generateOfflineAnswerKey: generateOfflineAnswerKey,
            getAllocatedTimeForGroupOrTest: getAllocatedTimeForGroupOrTest,
            checkOnlyOptionalStatus: checkOnlyOptionalStatus,
            RenderFileFromContent: RenderFileFromContent()
        };
        return service;

        function updateQPaperInfos() {
            /*.......Get data to LocalStorage........*/
            questionPaper = assessmentUtility.localStorage.getData("questionPaper");
            activeGroupId = assessmentUtility.localStorage.getData("activeGroupId");
            activeGroupId = !activeGroupId ? -1 : activeGroupId;
            var loginInfo = loginService.getLoginInfo();
            if (loginInfo && loginInfo.Config) {
                if (loginInfo.Config.madatGrpIds && !_.isArray(loginInfo.Config.madatGrpIds)) {
                    var strMadatGrpIds = loginInfo.Config.madatGrpIds.split(',');
                    var intMadatGrpIds = [];
                    for (var i = 0; i < strMadatGrpIds.length; i++) {
                        intMadatGrpIds[intMadatGrpIds.length] = parseInt(strMadatGrpIds[i]);
                    }
                    loginInfo.Config.madatGrpIds = intMadatGrpIds;
                }
                loginService.setLoginConfig({ "isGroupWiseTimingEnabled": !!questionPaper.groupWiseTiming });
            }
            if (questionPaper != null) {
                /*.......Get data to LocalStorage........*/
                var selectedOptionalGroupIdCollection = assessmentUtility.localStorage.getData("selectedOptionalGroupIdCollection");
                if (!selectedOptionalGroupIdCollection) {
                    selectedOptionalGroupIdCollection = [];
                }
                if (selectedOptionalGroupIdCollection && selectedOptionalGroupIdCollection.length > 0) {

                    _.forEach(selectedOptionalGroupIdCollection, function(grpId) {
                        if (_.indexOf(selectedOptionalGroupIdCollection, grpId) === -1) {
                            localStorageAvail = true;
                            addOptionalGrp(grpId, localStorageAvail);
                        }
                    });
                    service.localVar.currentOptionalGroupIndex = assessmentUtility.localStorage.getData("currentOptionalGroupIndex");
                    if (questionPaper.optionalGroupCollection && service.localVar.currentOptionalGroupIndex === (questionPaper.optionalGroupCollection.length) - 1) {
                        service.localVar.isOptionalGrpPresentToBeSelected = false;
                    } else {
                        service.localVar.isOptionalGrpPresentToBeSelected = true;
                    }
                } else if (questionPaper.optionalGroupCollection.length > 0) {
                    service.localVar.isOptionalGrpPresentToBeSelected = true;
                }
                totalQustionCount = questionPaper.mandatoryQuestionCollection.length;
                //selectedOptionalGroupIdCollection = !selectedOptionalGroupIdCollection ? [] : selectedOptionalGroupIdCollection;
            }
            return questionPaper;
        }

        function addOptionalGrp(selectedGroupId, localStorageAvail) {

            service.localVar.currentOptionalGroupIndex = assessmentUtility.localStorage.getData("currentOptionalGroupIndex");
            service.localVar.currentOptionalGroupIndex++;
            assessmentUtility.localStorage.setData("currentOptionalGroupIndex", service.localVar.currentOptionalGroupIndex);
            var selectedOptionalGroupIdCollection = assessmentUtility.localStorage.getData("selectedOptionalGroupIdCollection");
            if (!selectedOptionalGroupIdCollection) {
                selectedOptionalGroupIdCollection = [];
            }
            selectedOptionalGroupIdCollection.push(parseInt(selectedGroupId));
            var grpInfo = _.find(questionPaper.groupInfoCollection, { 'gpId': parseInt(selectedGroupId) });
            grpInfo.isSelectedOptionalGroup = true;
            if (service.localVar.currentOptionalGroupIndex === (questionPaper.optionalGroupCollection.length) - 1) {
                service.localVar.isOptionalGrpPresentToBeSelected = false;
            } else {
                service.localVar.isOptionalGrpPresentToBeSelected = true;
            }
            if (!localStorageAvail) {
                questionPaper.mandatoryQuestionCollection = mergeSelectedOptionalGroupToMandatGroup(selectedGroupId);
            }
            totalQustionCount = questionPaper.mandatoryQuestionCollection.length;
            /*.......Save data to LocalStorage........*/
            assessmentUtility.localStorage.setData("questionPaper", questionPaper);
            assessmentUtility.localStorage.setData("selectedOptionalGroupIdCollection", selectedOptionalGroupIdCollection);
        }

        function creteFlatStructure(questionPaper, loginInfo) {
            var flatQuestionPaper = {},
                isOptionalGrpPresent = false,
                isOptionRandomize = !!questionPaper.isOptionRandomize;
            if (questionPaper.isOptionRandomize === "undefined") {
                isOptionRandomize = false;
            }
            loginInfo = loginService.setLoginInfo({ "isOptionRandomize": isOptionRandomize });
            if (loginInfo && loginInfo.Config) {
                loginInfo.Config = loginService.setLoginConfig({ "isGroupWiseTimingEnabled": !!questionPaper.groupWiseTiming });
                service.localVar.isUserGroupChoiceEnable = loginInfo.Config.IsUserGroupChoiceEnable;
                if (loginInfo.Config.randomizeLevel !== null && angular.isDefined(loginInfo.Config.randomizeLevel)) {
                    service.localVar.isClientSideRandomizationEnable = true;
                }
            }
            flatQuestionPaper.groupWiseTiming = !!questionPaper.groupWiseTiming;
            flatQuestionPaper.TestQuestionInfoCollection = questionPaper.testQuestionInfoCollection;
            service.localVar.testQuestionInfoCollection = questionPaper.testQuestionInfoCollection;
            //Append Mandatory Question Collection......
            flatQuestionPaper.mandatoryQuestionCollection = getFlatCollection(questionPaper.mandatoryGroups, questionPaper.testQuestionInfoCollection, isOptionalGrpPresent);
            //Append Optional Question Collection.......
            flatQuestionPaper.optionalGroupCollection = [];
            var optionalGroupCollection = questionPaper.optionalGroups;
            if (optionalGroupCollection && optionalGroupCollection.length > 0) {
                service.localVar.isOptionalGrpPresentToBeSelected = true;
                _.map(optionalGroupCollection, function(grp) {

                    if (grp.groupcollection && grp.groupcollection.length > 0) {

                        isOptionalGrpPresent = true;
                        var optionalQuestionCollection = getFlatCollection(grp.groupcollection, questionPaper.testQuestionInfoCollection, isOptionalGrpPresent);
                        if (optionalQuestionCollection.length > 0) {
                            for (var i = 0; i < grp.noOfgrpsToBeSeleted; i++) {
                                flatQuestionPaper.optionalGroupCollection.push({
                                    "OptionalGroupName": grp.Name,
                                    "groups": groupBy(optionalQuestionCollection)
                                });
                            }
                        }
                    }
                });
            }
            if (service.localVar.isUserGroupChoiceEnable) {
                var optionalGrpCollection = _.groupBy(flatQuestionPaper.mandatoryQuestionCollection, 'gpId');
                _.map(optionalGrpCollection, function(optGrp) {
                    flatQuestionPaper.optionalGroupCollection.push({
                        "OptionalGroupName": "",
                        "groups": groupBy(optGrp, loginInfo.Config.madatGrpIds)
                    });
                });
                flatQuestionPaper.mandatoryQuestionCollection = [];
            }
            //Append Group Info Collection....
            var groupInfoCollection = assessmentUtility.localStorage.getData("groupInfoCollection");
            if (!groupInfoCollection) {
                groupInfoCollection = [];
            }
            if (groupInfoCollection.length > 0) {
                flatQuestionPaper.groupInfoCollection = groupInfoCollection;
            }
            if (flatQuestionPaper.mandatoryQuestionCollection.length > 0 && loginInfo.Config.randomizeLevel !== null && angular.isDefined(loginInfo.Config.randomizeLevel)) {
                flatQuestionPaper.mandatoryQuestionCollection = randomizeQuestionPaper(loginInfo.Config.randomizeLevel, flatQuestionPaper.mandatoryQuestionCollection, loginInfo.Config.isGroupWiseTimingEnabled);
                service.localVar.isRandomized = true;
                var containsRTCinMandatCollection = _.findIndex(flatQuestionPaper.mandatoryQuestionCollection, { 'questionType': 10 }) < 0 ? false : true;
                if (service.localVar.containsRTCquestion && containsRTCinMandatCollection) {
                    flatQuestionPaper.mandatoryQuestionCollection = getFlatCollection(flatQuestionPaper.mandatoryQuestionCollection);
                }
            }
            if (loginInfo.isOptionRandomize) {
                flatQuestionPaper.mandatoryQuestionCollection = randomizeOptions(flatQuestionPaper.mandatoryQuestionCollection);
            }
            if (questionPaper.thirdPartyTestUrl) {
                if (!_.size(flatQuestionPaper.mandatoryQuestionCollection)) {
                    flatQuestionPaper.mandatoryQuestionCollection = [];
                }
                flatQuestionPaper.mandatoryQuestionCollection[0]['thirdPartyTestUrl'] = questionPaper.thirdPartyTestUrl;
            }
            // flatQuestionPaper.isVideoControlRequired = loginInfo.Config.VideoProctoringIsMandat;
            /*.......Save data to LocalStorage........*/
            assessmentUtility.localStorage.setData("questionPaper", flatQuestionPaper);
            return flatQuestionPaper;
        }

        function getFlatCollection(gpCollection, qInfoCollection, isOptionalGrpPresent) {
            //var loginInfo = loginService.getLoginInfo();
            var groupInfoCollection = assessmentUtility.localStorage.getData("groupInfoCollection");
            if (!groupInfoCollection) {
                groupInfoCollection = [];
            } //To flat RTC........
            if (service.localVar.containsRTCquestion && service.localVar.isClientSideRandomizationEnable && service.localVar.isRandomized) {
                var questionCollection = gpCollection;
                return _.flatMap(questionCollection, function(q) {
                    if (q.questionType === 10) {
                        return getFlatRtc(q);
                    } else {
                        return q;
                    }
                });
            } else {
                return _.flatMap(gpCollection, function(gp) {
                    var isGrpWiseTimeAvail = gp.totalTime && gp.totalTime > 0;
                    if (gp && (isOptionalGrpPresent || isGrpWiseTimeAvail || service.localVar.isUserGroupChoiceEnable)) {
                        var grpInfoCollectionLength = groupInfoCollection.length;
                        groupInfoCollection[grpInfoCollectionLength] = {
                            'gpId': gp.id //,
                            //'gpTime': gp.TotalTime
                        };
                        if (isGrpWiseTimeAvail) {
                            groupInfoCollection[grpInfoCollectionLength].gpTime = gp.totalTime;
                        }
                        if (service.localVar.isUserGroupChoiceEnable) {
                            groupInfoCollection[grpInfoCollectionLength].isSelectedOptionalGroup = false;
                        }
                        assessmentUtility.localStorage.setData("groupInfoCollection", groupInfoCollection);
                    }
                    return _.flatMap(gp && gp.sections, function(sc) {
                        return _.flatMap(sc && sc.questionDetails, function(q) {
                            var qInfo = null;
                            if (qInfoCollection && qInfoCollection.length > 0) {
                                qInfo = _.filter(qInfoCollection, { 'questionId': q.id })[0];
                            }
                            //In case of RTC(qType=10) question......
                            if (q.questionType === 10) {
                                service.localVar.containsRTCquestion = true;
                                if (q.childQuestions && q.childQuestions.length > 0 && !service.localVar.isClientSideRandomizationEnable) {

                                    return _.map(q.childQuestions, function(cq) {
                                        var dummy_q = angular.copy(q);
                                        dummy_q.parentHtmlString = dummy_q.htmlString;
                                        dummy_q.htmlString = cq.htmlString;
                                        dummy_q.parentQuestionId = dummy_q.id;
                                        dummy_q.id = cq.id;
                                        dummy_q.answerChoices = cq.answerChoices;
                                        var childTestQuestionInfo = _.filter(qInfo.childTestQuestionInfos, { 'questionId': cq.id })[0];
                                        return modifyQuestionObject(childTestQuestionInfo, gp, sc, dummy_q);
                                    });
                                } else {
                                    return modifyQuestionObject(qInfo, gp, sc, q);
                                }

                                // } else if (!service.localVar.isRandomized) {
                            } else {
                                return modifyQuestionObject(qInfo, gp, sc, q);
                            }
                        });
                    });
                });
            }
        }

        function getFlatRtc(parentQuestion) {
            var gp = {
                'gpId': parentQuestion.gpId,
                'gpName': parentQuestion.gpName
            };
            var sec = {
                'SectionId': parentQuestion.scId,
                'Name': parentQuestion.scName,
                'Instruction': parentQuestion.qInstruction
            };
            var qInfoCollection = service.localVar.testQuestionInfoCollection;
            var qInfo = null;
            if (qInfoCollection && qInfoCollection.length > 0) {
                qInfo = _.filter(qInfoCollection, { 'questionId': parentQuestion.id })[0];
            }
            return _.map(parentQuestion.childQuestions, function(cq) {
                var dummy_q = angular.copy(parentQuestion);
                dummy_q.parentHtmlString = dummy_q.htmlString;
                dummy_q.htmlString = cq.htmlString;
                dummy_q.parentQuestionId = dummy_q.id;
                dummy_q.id = cq.id;
                dummy_q.answerChoices = cq.answerChoices;
                var childTestQuestionInfo = _.filter(qInfo.childTestQuestionInfos, { 'questionId': cq.id })[0];
                return modifyQuestionObject(childTestQuestionInfo, gp, sec, dummy_q);
            });
        }

        function modifyQuestionObject(testQInfo, grp, sec, qObj) {
            var qInfo = {
                'gpId': grp.id,
                'gpName': grp.name,
                'scId': sec.id,
                'scName': sec.name,
                'qInstruction': sec.instructionText
            };
            if (testQInfo) {
                qInfo.correctMark = testQInfo.mark;
                qInfo.inCorrectMark = testQInfo.incorrectMark;
                if (qObj.questionType === 16) {
                    qInfo.codingLangs = testQInfo.codingLanguages;
                    if (testQInfo.evaluationMethod) {
                        qInfo.evaluationMethodtype = testQInfo.evaluationMethod;
                    } else {
                        qInfo.evaluationMethodtype = 0;
                    }
                }
                if (testQInfo.optionLimit) {
                    qInfo.optionLimit = testQInfo.optionLimit;
                }
                qInfo.TimeSpent = 0;
                qInfo.TimeSpentOnTicker = 0;
                qInfo.isAnswered = false;
                qInfo.isAnsAttachmentRequired = testQInfo.isAnswerAttachmentRequired;
            }
            qObj.config = qObj.config && angular.fromJson(qObj.config);
            return _.merge({}, qObj, qInfo);
        }

        function randomizeQuestionPaper(level, questionCollection, isGroupWiseTimingEnabled) {
            if (level || level === 0) {
                level = level.toString();
            }
            if (level === "0" && isGroupWiseTimingEnabled) {
                /*Test Level randomization and Group wise timing can't co-exist*/
                return questionCollection;
            }
            var grpList, sectionList, finalRandomizedArray = [];
            switch (level) {
                case "0":
                    //test level                    
                    finalRandomizedArray = _.shuffle(questionCollection);
                    break;
                case "1":
                    //group level                    
                    grpList = _.groupBy(questionCollection, 'gpId');
                    finalRandomizedArray = _.flatten(_.transform(grpList, function(result, eachgroup) {
                        eachgroup = _.shuffle(eachgroup);
                        result.push(eachgroup);
                        return result;
                    }, []));
                    break;
                case "2":
                    //section level                                    
                    sectionList = _.groupBy(questionCollection, 'scId');
                    finalRandomizedArray = _.flatten(_.transform(sectionList, function(result, eachSection) {
                        eachSection = _.shuffle(eachSection);
                        result.push(eachSection);
                        return result;
                    }, []));
                    break;
            }
            return finalRandomizedArray;
        }

        function randomizeOptions(questionCollection) {
            _.forEach(questionCollection, function(eachQuestion) {
                if (eachQuestion.answerChoices && eachQuestion.answerChoices.length > 0) {
                    eachQuestion.answerChoices = _.shuffle(eachQuestion.answerChoices);
                }
            });
            return questionCollection;
        }

        function groupBy(optGrps, mandatGroups) {
            var groupByCollection = _.groupBy(optGrps, 'gpId');
            var flatOptGrpCollection = [];
            _.map(groupByCollection, function(questionsPerGroup) {
                if (questionsPerGroup && questionsPerGroup.length > 0) {
                    var grpObj = {
                        "gpId": questionsPerGroup[0].gpId,
                        "gpName": questionsPerGroup[0].gpName,
                        "questions": questionsPerGroup
                    };
                    if (mandatGroups && mandatGroups.length > 0) {
                        grpObj.isMandat = _.indexOf(mandatGroups, questionsPerGroup[0].gpId) > -1;
                    }
                    flatOptGrpCollection.push(grpObj);
                }
            });
            return flatOptGrpCollection;
        }

        function mergeSelectedOptionalGroupToMandatGroup(selectedGroupId) {
            var questionPaper = assessmentUtility.localStorage.getData("questionPaper");
            var selectedOptionalGroup = _.find(_.flatMap(questionPaper.optionalGroupCollection, function(optGrp) {
                return optGrp.groups;
            }), { 'gpId': parseInt(selectedGroupId) });
            var loginInfo = loginService.getLoginInfo();
            if (loginInfo.Config.randomizeLevel !== null && angular.isDefined(loginInfo.Config.randomizeLevel)) {
                selectedOptionalGroup.questions = randomizeQuestionPaper(loginInfo.Config.randomizeLevel, selectedOptionalGroup.questions, loginInfo.Config.isGroupWiseTimingEnabled);
                service.localVar.isRandomized = true;
                //check if rtc questions are added
                var containsRTCinOptCollection = _.findIndex(selectedOptionalGroup.questions, { 'questionType': 10 }) < 0 ? false : true;
                service.localVar.containsRTCquestion = containsRTCinOptCollection;
                if (loginInfo.Config.randomizeLevel !== null && angular.isDefined(loginInfo.Config.randomizeLevel)) {
                    service.localVar.isClientSideRandomizationEnable = true;
                }
                service.localVar.testQuestionInfoCollection = questionPaper.TestQuestionInfoCollection;
                if (containsRTCinOptCollection) {
                    selectedOptionalGroup.questions = getFlatCollection(selectedOptionalGroup.questions);
                }
            } else {
                service.localVar.isRandomized = false;
            }
            if (loginInfo.isOptionRandomize) {
                selectedOptionalGroup.questions = randomizeOptions(selectedOptionalGroup.questions);
            }
            return _.concat(questionPaper.mandatoryQuestionCollection, selectedOptionalGroup.questions);
        }

        function submitTestBeforeUnload() {
            questionPaper = assessmentUtility.localStorage.getData("questionPaper");
            var loginInfo = loginService.getLoginInfo(),
                submitTestRequest = service.getSubmitTestRequest(questionPaper, loginInfo, true, "unload"),
                submitTestResultUrl = "/py/assessment/htmltest/api/v1/submitTestResult/",
                data = angular.toJson(submitTestRequest);

            sessionStorage.setItem('OLD-X-AUTH-TOKEN', sessionStorage.getItem('X-AUTH-TOKEN'));
            assessmentUtility.localStorage.setData("submitTestRequest", submitTestRequest);
            setTestHistoryBeforeUnload();
            xmlHttpRequestCall(submitTestResultUrl, data);
        }

        function setTestHistoryBeforeUnload() {
            var isOnlinePreview = assessmentUtility.localStorage.getData("_isOnlinePreview");
            if (isOnlinePreview) {
                return;
            }
            var setTestHistoryData = assessmentUtility.localStorage.getData("captureCodeActivityInformation") || {},
                currentQindex = assessmentUtility.getActiveQuestionIndex(),
                currentQuestionId = questionPaper.mandatoryQuestionCollection[currentQindex].id,
                setTestHistoryUrl = '/py/assessment/htmltest/api/v1/create-test-user-history/',
                setTestHistoryDataByQId = setTestHistoryData[currentQuestionId] || [],
                data = angular.toJson({
                    'compileTestCaseJson': {
                        questionId: currentQuestionId,
                        code: setTestHistoryDataByQId,
                        timeStamp: new Date(),
                        testCaseResult: '',
                        selectedLanguage: undefined
                    },
                    'historyType': 1
                });
            xmlHttpRequestCall(setTestHistoryUrl, data);
        }

        function xmlHttpRequestCall(url, data) {
            var xmlhttp = new XMLHttpRequest(),
                isLambdaRequired = JSON.parse(sessionStorage.getItem('isLambdaRequired'));
            xmlhttp.open("POST", url, false);
            if (sessionStorage.isEuTenant == 'true') {
                xmlhttp.setRequestHeader("APP-NAME", "pyappe1");
            } else {
                xmlhttp.setRequestHeader("APP-NAME", "onlineassessment");
            }
            if (isLambdaRequired) {
                xmlhttp.setRequestHeader("X-APPLMA", "true");
                xmlhttp.setRequestHeader('x-guid', window.getUUID(url));
            }
            xmlhttp.setRequestHeader("Content-type", "application/json");
            // xmlhttp.setRequestHeader("X-AUTH-TOKEN", assessmentUtility.cookies.get('X-AUTH-TOKEN'));
            xmlhttp.setRequestHeader("X-AUTH-TOKEN", sessionStorage.getItem('X-AUTH-TOKEN'));
            xmlhttp.send(data);
        }

        function handleTestSubmission(isPartialSubmission, isAnswerScriptGenerated, submitType) {
            var alias = assessmentUtility.getAlias(),
                ls = assessmentUtility.localStorage,
                isOnlinePreview = !!ls.getData("_isOnlinePreview"),
                currentQindex = assessmentUtility.getActiveQuestionIndex(),
                currentQId = questionPaper.mandatoryQuestionCollection[currentQindex].id;

            if (!isPartialSubmission) {
                openModalService.closeAllModals();
                if ($uibModalStack) {
                    $uibModalStack.dismissAll();
                }
                /*if (isOnlinePreview) {
                    $state.go('submitConfirmation', { 'alias': alias }, { location: 'replace' });
                    return false;
                }*/
                $state.go('assess.endTest', { alias: alias, questionIndex: assessmentUtility.getActiveQuestionIndex() }, { location: 'replace', reload: true });
                return false;
            }
            service.submitTest(isPartialSubmission, submitType)
                .then(function(response) {
                    if (response && !isPartialSubmission) {
                        submissionAttempts = 0;
                        testSubmissionFailureCount = 0;
                        afterSubmission.do(response);
                    }
                })
                .catch(function(response) {
                    if (isPartialSubmission) {
                        return false;
                    }
                    if (!isAnswerScriptGenerated) {
                        reattemptSubmissiononFailure(response);
                    } else {
                        generateOfflineAnswerKey();
                    }
                });
        }
        /*function goToSubmitConfirmationState(isAutoTest,stateParams){
            //blockUI.stop();
            var alias = assessmentUtility.getAlias();
            $state.go('submitConfirmation', { 'alias': alias, 'nextTestStateParams':stateParams, 'isAutoTestEnabled': isAutoTest }, { location: 'replace' });
        }*/
        function reattemptSubmissiononFailure(response) {
            //This function tries to submit configured number of times before showing the network error message
            submissionAttempts++;
            if (submissionAttempts < submissionAttemptsConfig) {
                handleTestSubmission(false, false);
            } else if (submissionAttempts === submissionAttemptsConfig) {
                testSubmissionFailureCount++;
                submissionAttempts = 0;
                if (testSubmissionFailureCount < 3) {
                    redoSubmit(response);
                }
            }
            if (testSubmissionFailureCount === 3) {
                generateOfflineAnswerKey();
            }
        }

        function redoSubmit(response) {
            // var optModalBackdrop = 'submit-confirmation';
            // var isOkEnable = true;
            var message = "Results Cannot be Submitted Now";
            message += "<br/>Click <b>OK</b> to retry.";
            var data = {
                bodyStr: message,
                headerStr: 'Network ERROR-assessment',
                isAction: true,
                action: {
                    isOkBtn: true
                }
            };
            openModalService.openModal('notificationTemplate', data).then(function(res) {
                handleTestSubmission(false, false);
            });
        }
        var checkForPendingTaskCount = 0;

        function submitTest(isPartialSubmission, submitType, saveHistoryQuestionId) {
            // blockUI.start();
            if (!isPartialSubmission) {
                openModalService.closeAllModals();
                if ($uibModalStack) {
                    $uibModalStack.dismissAll();
                }
                setLogNetworkFluctuation();
            }
            return checkForPendingTask(isPartialSubmission, 0)
                .then(function() {
                    // blockUI.stop();
                    return submit(isPartialSubmission, submitType, saveHistoryQuestionId);
                });
        }

        function checkForPendingTask(isPartialSubmission, checkForPendingTaskCount) {
            if (isPartialSubmission) {
                return $q.when({});
            }
            var isFinal = true;
            checkForPendingTaskCount++;
            return submit(true, 'autoSubmitionBeforeFinalSubmit') //partial submission to secure candidate answer
                .then(function() {
                        return $q.all([
                            mediaRecorder.mediaUploader.stop(isFinal),
                            loggerService.stop(isFinal)
                        ]);
                    },
                    function(res) {
                        if (res && res.status === "KO" &&
                            res.error &&
                            res.error.ErrorMessage === "Session Expired" &&
                            checkForPendingTaskCount > 2) {
                            return $q.reject(res);
                        }
                        return $timeout(function() {
                            return checkForPendingTask(false, checkForPendingTaskCount);
                        }, 1000);
                    });
        }

        function submit(isPartialSubmission, submitType, saveHistoryQuestionId) {
            var ls = assessmentUtility.localStorage,
                ss = assessmentUtility.sessionStorage,
                sl = service.localVar,
                submitTestResponse = null,
                loginInfo = loginService.getLoginInfo(),
                submitRequest = null,
                isQuestionVideoStarted = false;
            questionPaper = ls.getData("questionPaper");
            if (!questionPaper && submitType) {
                questionPaper = ss.getData("questionPaper");
            }

            if (!questionPaper && !loginInfo) {
                $log.error("Data is removed from localStorage.");
                return $q.when(false);
            }
            if (!isPartialSubmission) {
                assessmentUtility.timer.stop();
                // proctorMessage.stop();
                /*if (!!ls.getData('isQuestionVideoStarted')) {
                    $injector.get('proctoringService').stop();
                }*/
            }
            /*if (isPartialSubmission && submitType !== 'autoSubmition') {
                need to work here
                submitType(autoGroupChange) --isPartialSubmission(true)
                submitType(autoSubmition) --isPartialSubmission(true)
                autoFinalSubmition-- false
            }*/
            submitRequest = service.getSubmitTestRequest(questionPaper, loginInfo, isPartialSubmission, submitType);
            if (saveHistoryQuestionId) {
                var index = _.findIndex(submitRequest.testResultCollection, { q: saveHistoryQuestionId });
                if (index > -1) {
                    submitRequest.testResultCollection[index].isSubmit = true;
                }
            }
            var serviceCall = 'SubmitTestResult';
            if (!isPartialSubmission) {
                serviceCall = 'finalSubmitTestResult';
            }
            return webService.execute(serviceCall, submitRequest, "POST")
                .then(function(res) {
                        if (!res || !res.data || res.data.statusId !== 200) {
                            return $q.reject(res.data);
                        }
                        submitTestResponse = res.data;
                        /*isQuestionVideoStarted = !!ls.getData('isQuestionVideoStarted');
                        if (isQuestionVideoStarted) {
                            $injector.get('proctoringService').stop();
                        }*/
                        if (!isPartialSubmission) {
                            sl.currentOptionalGroupIndex = -1;
                            ls.setData("currentOptionalGroupIndex", sl.currentOptionalGroupIndex);
                        }
                        if(serviceCall === 'finalSubmitTestResult' && !isPartialSubmission){
                            sessionStorage.setItem('testStarted', 'end');
                        }
                        
                        return $q.resolve(submitTestResponse);
                    },
                    function(res) {
                        if (res && res.data) {
                            $log.error(res.data.Message);
                        }
                        return $q.reject(res.data);
                    }
                );
        }

        function getSubmitTestRequest(questionPaper, loginInfo, isPartialSubmission, type) {
            questionPaper = service.addRemainingTimeToLastActiveQuestion(questionPaper);
            var currentQindex = assessmentUtility.getActiveQuestionIndex(),
                currentQId = questionPaper.mandatoryQuestionCollection[currentQindex].id,
                submitRequest = {
                    'isPartialSubmission': isPartialSubmission,
                    'disableBlockUI': !!isPartialSubmission,
                    'debug': {
                        'type': type,
                        'qId': currentQId,
                        'timerTimeSpent': assessmentUtility.timer._time
                    }
                    //'TestId': loginInfo.TestId,
                    //'TenantId': loginInfo.TenantId,
                    //'UserId': "0",
                    //'TestUserId': loginInfo.CandidateId,  
                    //'TimeStamp': new Date()
                };
            submitRequest.totalTimeSpent = _.sumBy(questionPaper.mandatoryQuestionCollection, 'TimeSpent');
            submitRequest.testResultCollection = [];
            _.forEach(questionPaper.mandatoryQuestionCollection, function(question) {
                var candAns = {
                    'q': question.id,
                    //'A': question.selectedAns.toString(),
                    'timeSpent': question.TimeSpent,
                    'timeSpentOnTicker': question.TimeSpentOnTicker,
                    'secId': question.scId,
                    'debug': question.debug,
                    'isSubmit': question.isSubmit
                    //'Flag': question.isFlagged ? true : false
                };
                if (question.isUnanswered) {
                    candAns.isUnanswered = true;
                }
                if (question.QuestionTenantId) {
                    candAns.QTenantId = question.QuestionTenantId;
                }
                var condition_singleSelect = question.isAnswered && question.selectedAns;
                var condition_multiSelect = !question.isAnswered && question.config && question.config.IsMultipleAnswer && question.selectedAns && question.selectedAns.length > 0;
                //candAns['A'] = (condition_singleSelect || condition_multiSelect) ? question.selectedAns.toString() : null;
                if (condition_singleSelect || condition_multiSelect) {
                    candAns['a'] = question.selectedAns.toString();
                    if (question.questionType === 16 && question.config && question.config.isUITypeQuestion === true) {
                        candAns['l'] = question.selectedLanguage ? question.selectedLanguage.languageId : undefined;
                    }
                } else if (question.isAnswered && question.questionType === 16 && question.selectedLanguage) {
                    candAns['a'] = question.selectedLanguage.modifiedCodeSnippet;
                    candAns['l'] = question.selectedLanguage.languageId;
                } else if (question.questionType === 17) {
                    candAns['a'] = question.selectedAns;
                } else if (question.isAnswered && question.questionType === 16 && question.config && question.config.isUITypeQuestion === true) {
                    candAns['a'] = question.selectedAns;
                    candAns['l'] = question.selectedLanguage ? question.selectedLanguage.languageId : undefined;
                } else {
                    candAns['a'] = null;
                }
                if (question.questionType === 8) { //QA
                    candAns.isSubjective = true;
                    // new qa type questions, changes for
                    if (question.jAns) {
                        var jAns = _.pickBy(question.jAns, function(o) { return _.trim(o) !== ''; });
                        if (jAns && _.size(jAns) > 0) {
                            candAns['a'] = null;
                            candAns['jAns'] = jAns;
                        } else {
                            candAns['jAns'] = null;
                        }
                    }
                }
                if (question.questionType === 2 || question.questionType === 20) {
                    candAns['a'] = null;
                    if (question.jAns) {
                        var jAns = _.pickBy(question.jAns, function(o) { return _.trim(o) !== ''; });
                        if (jAns && _.size(jAns) > 0) {
                            candAns['jAns'] = jAns;
                        } else {
                            candAns['jAns'] = null;
                        }
                    }
                }
                if (_.size(question.ansFiles) > 0) {
                    candAns['ansFiles'] = question.ansFiles;
                }
                submitRequest.testResultCollection.push(candAns);
            });
            if (questionPaper.groupInfoCollection && questionPaper.groupInfoCollection.length > 0) {
                submitRequest.testUserGroupInfos = getTestUserGroupInfoCollection();
            }
            submitRequest.config = JSON.stringify({ 'TimeStamp': new Date() });

            assessmentUtility.localStorage.setData('OfflineAnswerKey', submitRequest);
            return submitRequest;
        }

        function getTestUserGroupInfoCollection() {
            var groupbyQuestionPaper = _.groupBy(questionPaper.mandatoryQuestionCollection, 'gpId');
            var testUserGroupInfoCollection = [];
            _.forEach(questionPaper.groupInfoCollection, function(grpInfo) {
                var testUserGroupInfo = {};
                testUserGroupInfo.groupId = grpInfo.gpId;
                testUserGroupInfo.isSelectedOptionalGroup = grpInfo.isSelectedOptionalGroup ? true : false;
                testUserGroupInfo.timeSpent = getGroupTimeSpent(groupbyQuestionPaper, grpInfo.gpId);
                if (testUserGroupInfo.timeSpent > 0 || testUserGroupInfo.isSelectedOptionalGroup) { //|| testUserGroupInfo.isSelectedOptionalGroup
                    testUserGroupInfoCollection.push(testUserGroupInfo);
                }
            });
            return testUserGroupInfoCollection;
        }

        function getGroupTimeSpent(groupbyQuestionPaper, gpId) {
            var grpQCollection = groupbyQuestionPaper[gpId];
            var timeSpent = 0;
            _.forEach(grpQCollection, function(grpQ) {
                timeSpent += grpQ.TimeSpent;
            });
            return timeSpent;
        }

        function addRemainingTimeToLastActiveQuestion(questionPaper, isGrpWiseTimeOver, onStopWatchStop) {
            var timeSpent = 0;
            var isGroupWiseTimingEnabled = service.getGroupWiseTimingStatus();
            var questionWiseTimeSpent = 0;
            //var loginInfo = loginService.getLoginInfo();
            /*var isOptionalPreviewEnable = false;
            if (loginInfo && loginInfo.Config) {
                isOptionalPreviewEnable = !loginInfo.Config.HideOptionalGroup
            }*/
            /*var lastSubmittedTotalTimeSpent = !isGrpWiseTimeOver ? parseInt(assessmentUtility.localStorage.getData("lastSubmittedTotalTimeSpent")) : 0;
            var splitTime = lastSubmittedTotalTimeSpent;*/
            questionWiseTimeSpent = service.getQuestionWiseTimeSpent();
            /*if (isGroupWiseTimingEnabled && lastSubmittedTotalTimeSpent === 0) {
                
                splitTime = isGroupWiseTimingEnabled ? (questionWiseTimeSpent - lastSubmittedTotalTimeSpent) : questionWiseTimeSpent;
            }*/
            var totalTimeSpent = assessmentUtility.timer._time;

            var activeGroupId = service.questionpaper.activeGroup.getId();

            if (isGrpWiseTimeOver) {
                totalTimeSpent = _.find(questionPaper.groupInfoCollection, { 'gpId': activeGroupId }).gpTime * 60;
            } else if (onStopWatchStop) {
                totalTimeSpent = assessmentUtility.localStorage.getData("timeSpentBeforeOptionalPreview");
            } else if (isGroupWiseTimingEnabled) {
                var curentGroupAvailTime = assessmentUtility.localStorage.getData("_availTime");
                var currentGroupAllotedTime = _.find(questionPaper.groupInfoCollection, { 'gpId': activeGroupId }).gpTime * 60;
                totalTimeSpent = currentGroupAllotedTime - curentGroupAvailTime;
            }
            if (totalTimeSpent === 0) {
                totalTimeSpent = assessmentUtility.localStorage.getData("lastSessionSpentTime");
            }
            /*if(lastSubmittedTotalTimeSpent !== 0){
               totalTimeSpent -= questionWiseTimeSpent;
            }
            else{
               splitTime = questionWiseTimeSpent; 
            }*/
            var splitTime = questionWiseTimeSpent;

            timeSpent = totalTimeSpent - splitTime;
            //assessmentUtility.localStorage.setData("addRemainingTimeToLastActiveQuestion||timeRemain", timeSpent);
            if (timeSpent > 0) {
                var currentQindex = assessmentUtility.getActiveQuestionIndex();
                questionPaper.mandatoryQuestionCollection[currentQindex].TimeSpent += timeSpent;
                assessmentUtility.localStorage.setData("questionPaper", questionPaper);
                assessmentUtility.sessionStorage.setData("questionPaper", questionPaper);
            }
            return questionPaper;
        }

        function getQuestionWiseTimeSpent() {
            var _questionWiseTimeSpent = 0;
            var _questionCollection = assessmentUtility.localStorage.getData("questionPaper");
            if (!_questionCollection) {
                _questionCollection = assessmentUtility.sessionStorage.getData("questionPaper");
            }
            _questionCollection = _questionCollection.mandatoryQuestionCollection;
            var isGroupWiseTimingEnabled = service.getGroupWiseTimingStatus();
            if (isGroupWiseTimingEnabled) {

                var activeGroupId = service.questionpaper.activeGroup.getId();
                var groupWiseQcollection = _.groupBy(_questionCollection, 'gpId');
                var activeGroupQuestionCollection = groupWiseQcollection[activeGroupId];
                _.forEach(activeGroupQuestionCollection, function(q) {
                    _questionWiseTimeSpent += q.TimeSpent;
                });
            } else {
                _questionWiseTimeSpent = _.sumBy(_questionCollection, 'TimeSpent');
            }
            return _questionWiseTimeSpent;
        }

        function getAllocatedTimeForGroupOrTest() {
            var allocatedTime = 0;
            var prevTestResult = assessmentUtility.localStorage.getData("prevTestResult");
            var isGroupWiseTimingEnabled = service.getGroupWiseTimingStatus();
            var questionPaper = assessmentUtility.localStorage.getData("questionPaper");
            if (isGroupWiseTimingEnabled) {
                var activeGroupId = service.questionpaper.activeGroup.getId();
                // allocatedTime = _.find(questionPaper.groupInfoCollection, { 'gpId': activeGroupId }).gpTime * 60;
                var groupWiseTime = _.find(questionPaper.groupInfoCollection, { 'gpId': activeGroupId }).gpTime;
                var groupWiseGraceTime = 0;
                if (prevTestResult && prevTestResult.graceTimeInfo && prevTestResult.graceTimeInfo.groupGraceTime) {
                    var graceGroupInfo = _.find(prevTestResult.graceTimeInfo.groupGraceTime, { 'groupId': activeGroupId });
                    if (graceGroupInfo && graceGroupInfo.graceTime)
                        groupWiseGraceTime = graceGroupInfo.graceTime;
                }
                if (!prevTestResult || !prevTestResult.graceTimeInfo || !groupWiseGraceTime) {
                    allocatedTime = groupWiseTime * 60;
                } else {
                    allocatedTime = (groupWiseTime + groupWiseGraceTime) * 60;
                }
            } else {
                var loginInfo = loginService.getLoginInfo();
                if (!prevTestResult || !prevTestResult.graceTimeInfo || !prevTestResult.graceTimeInfo.graceTime)
                    allocatedTime = loginInfo.TestDuration * 60;
                else
                    allocatedTime = (loginInfo.TestDuration + prevTestResult.graceTimeInfo.graceTime) * 60;
            }
            return allocatedTime;
        }

        function getLastSubmittedResult() {
            var req = {
                    // CandidateId: loginInfo.CandidateId,
                    // TenantId: loginInfo.TenantId,
                    // TestId: loginInfo.TestId,
                    // UserId: '0'
                },
                prevTestResult = null;
            return webService.execute("GetTestResult", req, "POST").then(
                function(response) {
                    if (response && response.data && !response.data.IsException) {
                        prevTestResult = response.data;
                        assessmentUtility.localStorage.setData("prevTestResult", prevTestResult);
                    } else {
                        assessmentUtility.localStorage.setData("prevTestResult", null);
                    }
                    return prevTestResult;
                }
            );
        }

        function getNextUnansweredQuestion(currentIndex) {
            //check in mandatory collection and then move to optional section   
            currentIndex = currentIndex ? currentIndex : 0;
            var questions = assessmentUtility.localStorage.getData("questionPaper");
            var qUnAnsweredQuestion = _.findIndex(questions.mandatoryQuestionCollection, { 'isAnswered': false }, currentIndex);
            if (qUnAnsweredQuestion === -1) {

                qUnAnsweredQuestion = totalQustionCount - 1;
            }
            //if not in mandotyr collection check in optional
            return qUnAnsweredQuestion;
        }

        function getLastAnsweredQuestion() {
            var questions = assessmentUtility.localStorage.getData("questionPaper");
            var qLastAnsweredQuestion = _.findLastIndex(questions.mandatoryQuestionCollection, function(qObj) {
                if (qObj.TimeSpent > 0 || qObj.isAnswered) {
                    return qObj;
                }
            });
            return qLastAnsweredQuestion;
        }

        /*function getPrevUnansweredQuestion(currentIndex) {
            //todo
            var qUnAnsweredQuestion = _.findLastIndex(questionPaper.mandatoryQuestionCollection, { 'TimeSpent': 0 }, currentIndex - 1);
        }*/

        function getGroupWiseTimingStatus() {
            var qPaper = assessmentUtility.localStorage.getData("questionPaper");
            var isGroupWiseTimingEnabled = false;
            if (qPaper && qPaper.groupInfoCollection && qPaper.groupInfoCollection.length > 0 && qPaper.groupInfoCollection[0].gpTime > 0) {
                isGroupWiseTimingEnabled = true;
            }
            return isGroupWiseTimingEnabled;
        }

        function getLastActiveGroup1stQuestionIndex(grpInfos) {
            var ls = assessmentUtility.localStorage,
                questions = ls.getData("questionPaper"),
                lastActiveGroup1stQuestionIndex = 0,
                lastActiveGrpId = -1;
            lastActiveGrpId = _.size(grpInfos) > 0 ? grpInfos[grpInfos.length - 1].groupId : ls.getData("activeGroupId");
            if (questions && _.size(questions.mandatoryQuestionCollection) > 0 && lastActiveGrpId > -1) {

                lastActiveGroup1stQuestionIndex = _.findIndex(questions.mandatoryQuestionCollection, { 'gpId': lastActiveGrpId });
            }
            return lastActiveGroup1stQuestionIndex;
        }

        function generateOfflineAnswerKey() {
            var alias = assessmentUtility.getAlias();
            var data = {
                isAction: true,
                action: {
                    isOkBtn: true
                }
            };
            openModalService.openModal('generateAnswerKey', data).then(function(res) {
                var response = res.result.result;
                submissionAttempts = 0;
                testSubmissionFailureCount = 0;
                afterSubmission.do(response);
                $state.go('submitConfirmation', { 'alias': alias }, { location: 'replace' });
            });
        }

        function checkOnlyOptionalStatus() {
            questionPaper = assessmentUtility.localStorage.getData("questionPaper");
            var isOnlyOptional = false;
            if (questionPaper) {
                isOnlyOptional = questionPaper.mandatoryQuestionCollection.length > 0 ? false : true;
            }
            return isOnlyOptional;
        }

        //Render file from file content
        function RenderFileFromContent() {
            var getRequest = function(requestData) {
                    var loginInfo = loginService.getLoginInfo(),
                        request = {
                            testId: loginInfo.TestId,
                            questionId: requestData.questionId,
                            dataJson: _.forEach(requestData.dataSetJson, function(data, index) {
                                if (index !== 'index.html' && index !== 'config.js') {
                                    data.content = data.content.replace(new RegExp('(<a.*?href=)([\'\"])(.*?)([\'\"])', 'g'), "\$1\"javascript:window.location.replace('\$3')\"");
                                }
                            })
                        };
                    return $q.when(request);
                },
                validateRequest = function(req) {
                    if (!req.testId) {
                        return $q.reject('No Test Id found');
                    }
                    if (!req.questionId) {
                        return $q.reject('No Question Id Fond');
                    }
                    if (!_.size(req.dataJson)) {
                        return $q.reject('No Json Found');
                    };
                    return $q.when(req);
                };
            return {
                /*
                    {
                        "questionId":112654,
                        "dataJson": datajson
                    }
                */
                render: function(request) {
                    return getRequest(request).then(function(req) {
                        return validateRequest(req);
                    }).then(function(req) {
                        return webService.execute('renderCandidateAnswer', req, "POST");
                    }).then(function(tempRes) {
                        if (tempRes.data.error) {
                            return [];
                        }
                        return _.get(tempRes, 'data.data.renderFiles', []);
                    })
                }
            }
        }

        function setLogNetworkFluctuation() {
            var loginInfo = loginService.getLoginInfo(), networkLog, log = JSON.parse(localStorage.getItem('networkFluctuationLogList_' + loginInfo.testUserId));
            if (log) {
                networkLog = {
                    canLoginActivityLog: {
                        networkFluctuationLog: log
                    }
                };
                loggerService.push(networkLog);
            }
        }
    }
})();

/* eslint-disable */
(function() {
    'use strict';

    angular
        .module('OnlineAssessmentAngular')
        .factory('anchorSmoothScroll', anchorSmoothScroll);

    function anchorSmoothScroll() {
        return {
            scrollTo: function(eID) {
                // This scrolling function 
                // is from http://www.itnewb.com/tutorial/Creating-the-Smooth-Scroll-Effect-with-JavaScript
                var startY = currentYPosition();
                var stopY = elmYPosition(eID);
                var distance = stopY > startY ? stopY - startY : startY - stopY;
                if (distance < 100) {
                    scrollTo(0, stopY);
                    return;
                }
                var speed = Math.round(distance / 100);
                if (speed >= 20) speed = 20;
                var step = Math.round(distance / 25);
                var leapY = stopY > startY ? startY + step : startY - step;
                var timer = 0;
                if (stopY > startY) {
                    for (var i = startY; i < stopY; i += step) {
                        setTimeout("window.scrollTo(0, " + leapY + ")", timer * speed);
                        leapY += step;
                        if (leapY > stopY) leapY = stopY;
                        timer++;
                    }
                    return;
                }
                for (var i = startY; i > stopY; i -= step) {
                    setTimeout("window.scrollTo(0, " + leapY + ")", timer * speed);
                    leapY -= step;
                    if (leapY < stopY) leapY = stopY;
                    timer++;
                }

                function currentYPosition() {
                    // Firefox, Chrome, Opera, Safari
                    if (self.pageYOffset) return self.pageYOffset;
                    // Internet Explorer 6 - standards mode
                    if (document.documentElement && document.documentElement.scrollTop)
                        return document.documentElement.scrollTop;
                    // Internet Explorer 6, 7 and 8
                    if (document.body.scrollTop) return document.body.scrollTop;
                    return 0;
                }

                function elmYPosition(eID) {
                    var elm = document.getElementById(eID);
                    var y = 0;
                    if (elm) {
                        y = elm.offsetTop;
                        var node = elm;
                        while (node.offsetParent && node.offsetParent != document.body) {
                            node = node.offsetParent;
                            y += node.offsetTop;
                        }
                    }
                    return y;
                }
            }
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('OnlineAssessmentAngular')
        .factory('afterSubmission', afterSubmission);

    //afterSubmission.$inject = ['$q', '$log', '$state', 'blockUI', 'webService', 'assessmentUtility', 'loginService', '$timeout'];

    function afterSubmission($state, blockUI, $injector, hvsService) {
        var $q = $injector.get('$q'),
            webService = $injector.get('webService'),
            assessmentUtility = $injector.get('assessmentUtility'),
            loginService = $injector.get('loginService'),
            $log = $injector.get('$log'),
            $timeout = $injector.get('$timeout'),
            service = {
                localVar: {
                    alias: null,
                    candidateId: -1,
                    testId: -1,
                    isAutoTest: false,
                    shortlistingStat: -1, //shortlistingStat = -1(not available) | shortlistingStat = 0(true) | shortlistingStat = 1(false)
                    shortlistingMessage: null,
                    isConsentRequired:null,
                    errormessage: null,
                    timeInterval: 5000
                },
                init: function(submitTestResponse) {
                    service.localVar.shortlistingStat = -1;
                    service.localVar.alias = assessmentUtility.getAlias();
                    var loginInfo = loginService.getLoginInfo();
                    if (loginInfo) {
                        service.localVar.candidateId = loginInfo.CandidateId;
                        service.localVar.testId = loginInfo.TestId;
                    }
                    if (submitTestResponse) {
                        // assessmentUtility.cookies.set('OLD-X-AUTH-TOKEN', assessmentUtility.cookies.get('X-AUTH-TOKEN'));
                        // assessmentUtility.cookies.set('X-AUTH-TOKEN', submitTestResponse.systemTkn);
                        sessionStorage.setItem('OLD-X-AUTH-TOKEN', sessionStorage.getItem('X-AUTH-TOKEN'));
                        sessionStorage.setItem('X-AUTH-TOKEN', submitTestResponse.systemTkn);
                    }
                },
                do: function(submitTestResponse) {
                    var self = this,
                        automationUIWaitTime = 0;
                    self.init(submitTestResponse);
                    if (sessionStorage.getItem('automationUIWaitTime')) {
                        automationUIWaitTime = parseInt(sessionStorage.getItem('automationUIWaitTime'));
                        console.log('Waiting for time ' + automationUIWaitTime);
                    }
                    $timeout(function() {
                        self.checkForAutoTest().then(
                            function(nextStateParams) {
                                // if auto test and we have to start next text
                                self.redirectToAfterSubmissionPage(nextStateParams);
                            },
                            function() {
                                // if there is no next text to start
                                self.redirectToAfterSubmissionPage(null);
                            }
                        );
                    }, automationUIWaitTime * 1000);
                },
                checkForAutoTest: function() {
                    var self = this;
                    var initiateAutomationRequest = {
                        "candidateId": service.localVar.candidateId,
                        "testId": service.localVar.testId
                    };
                    return webService.execute('initiateAutomation', initiateAutomationRequest)
                        .then(function(res) {
                            if (!res || res.status !== 200 || !res.data) {
                                return $q.reject({});
                            }
                            res = res.data.data;
                            console.log(res, 'initiateAutomation');
                            // if (!res.isAutoTest && !res.contextId && !res.isUnscorable) {
                            //     console.log('initiateAutomation - reject');
                            //     return $q.reject({});
                            // }
                            var nextStateParams = null;
                            // service.localVar.isAutoTest = res.isAutoTest;
                            // if (!res.contextId && _.size(res.nextTestInfos)) {
                            //     nextStateParams = res.nextTestInfos[0];
                            //     nextStateParams = self.getNextTestParamObj(nextStateParams);
                            //     return nextStateParams;
                            // } else if (!res.contextId && _.size(res.nextTestLinks)) {
                            //     nextStateParams = self.getNextTestParamObj({nextTestUrl: res.nextTestLinks[0]});
                            //     return nextStateParams;
                            // } else if (!res.contextId && res.isUnscorable) {
                            //     console.log('initiateAutomation - isUnscorable');
                            //     service.localVar.isUnscorable = res.isUnscorable;
                            //     return {};
                            // } else if (res.contextId) {
                            if (res.contextId) {
                                //blockUI.start();
                                return self.getBgTaskCompletionStat(res.contextId)
                                    .then(function(backgroudInfo) {
                                        nextStateParams = self.getNextTestParamObj(backgroudInfo);
                                        return nextStateParams;
                                    });
                            } else {
                                return $q.reject({});
                            }

                        });
                },
                getBgTaskCompletionStat: function(contextId) {
                    var self = this;
                    var data = {
                        disableBlockUI: true,
                        GetStatusOfAsyncApiRq: {
                            "ContextGUID": contextId,
                            "disableBlockUI": true
                        }
                    };
                    return webService.execute("GetStatusOfAsyncAPI", data.GetStatusOfAsyncApiRq)
                        .then(function(res) {
                            var nextTestInfos = null;
                            // Checking for Invalid cases
                            if (!res || !res.data || !res.data.data) {
                                res = { JobState: 'PENDING' };
                            } else {
                                res = res.data.data;
                            }
                            // Checking whether task has completed or not
                            if (res.ExecutionComplete) {
                                //blockUI.stop();
                                // finally the execution has been copmpleted
                                try {
                                    //data on result
                                    /* {
                                        status: "OK",
                                        data: {
                                            isSuccess: false,
                                            isAutoShortlisting: false,
                                            nextTestInfos: null
                                        },
                                        statusId: 200
                                    }*/

                                    data.jsonResponse = angular.fromJson(res.Result);
                                } catch (e) {
                                    return $q.reject({
                                        msg: "JSON responsed by api can not be parsed"
                                    });
                                }

                                //Analyse Image API

                                if(data.jsonResponse.appspecific && data.jsonResponse.appspecific.message === "Completed analyzing image."){
                                    return $q.resolve(data.jsonResponse);
                                }


                                if (data.jsonResponse.status !== 'OK' || !data.jsonResponse.data) {
                                    return $q.reject({
                                        msg: "JSON responsed by api has error"
                                    });
                                }

                                // Always positive
                                // if (data.jsonResponse.data.isShortlisted === true) {
                                //     service.localVar.shortlistingStat = 0;
                                // } else if (data.jsonResponse.data.isShortlisted === false) {
                                //     service.localVar.shortlistingStat = 1;
                                // }


                                if (data.jsonResponse.data.isAutoShortlisting) {
                                    service.localVar.shortlistingStat = data.jsonResponse.data.nextTestInfos || data.jsonResponse.data.nextTestLinks ? 0 : 1;
                                }

                                if (data.jsonResponse.data.isSuccess === false) {
                                    service.localVar.errormessage = '<h4 style="margin-bottom: 35px;line-height: 0px;">Someone from the talent team will contact you for the next steps.</h4>';
                                    //service.localVar.errormessage = 'We are unable to process you for next Assessment. Please contact Admin/Coordinator';
                                }
                                if (_.size(data.jsonResponse.data.nextTestInfos)) {
                                    nextTestInfos = data.jsonResponse.data.nextTestInfos[0];
                                    //service.localVar.shortlistingMessage = response.Result.data.message;
                                } else if (_.size(data.jsonResponse.data.nextTestLinks)) {
                                    nextTestInfos = { nextTestUrl: data.jsonResponse.data.nextTestLinks[0] };
                                    //service.localVar.shortlistingMessage = response.Result.data.message;
                                } else {
                                    $log.error("No Next Test found.");
                                }

                                service.localVar.isAutoTest = (data.jsonResponse.data.isAutoShortlisting || nextTestInfos) ? true : false;
                                // if (data.jsonResponse.data.isUnscorable) {
                                // service.localVar.isUnscorable = data.jsonResponse.data.isUnscorable;
                                //service.localVar.shortlistingMessage = response.Result.data.message;
                                // }
                                service.localVar.isUnscorable = data.jsonResponse.data.isUnscorable;
                                if (data.jsonResponse.data.isUnscorable) {
                                    service.localVar.isAutoTest = false;
                                }
                                return nextTestInfos;
                            } else if (res.JobState === 'PENDING' || res.JobState === 'PROGRESS') {
                                // execution still in pending or it has failed
                                return $timeout(function() {
                                    if (service.localVar.timeInterval <= 90 * 1000) {
                                        service.localVar.timeInterval += 5000;
                                    }
                                    return self.getBgTaskCompletionStat(contextId);
                                }, service.localVar.timeInterval);
                            } else if (res.JobState === 'FAILURE') {
                                blockUI.stop();
                                return $q.reject({
                                    msg: "Error: Background task has return FAILURE."
                                });
                            }
                        }, function() {
                            blockUI.stop();
                            $log.log("Error: unable to fetch GetStatusOfAsyncAPI");
                            return $timeout(function() {
                                if (service.localVar.timeInterval <= 90 * 1000) {
                                    service.localVar.timeInterval += 5000;
                                }
                                return self.getBgTaskCompletionStat(contextId);
                            }, service.localVar.timeInterval);
                        }).then(function(res) {
                            if (res) {
                                return res;
                            }
                        }, function(err) {
                            blockUI.stop();
                            $log.error(err.msg);
                        });
                },
                getNextTestParamObj: function(_nextStateParams) {
                    var nextStateParams = null;
                    var uid = null,
                        pswd = null;
                    if (!_nextStateParams) {
                        return nextStateParams;
                    }
                    if (_nextStateParams.loginId && !_.isEmpty(_nextStateParams.loginId.trim())) {
                        uid = btoa(_nextStateParams.loginId);
                    }
                    if (_nextStateParams.password && !_.isEmpty(_nextStateParams.password.trim())) {
                        pswd = btoa(_nextStateParams.password);
                    }
                    if (_nextStateParams) {
                        nextStateParams = {
                            'alias': service.localVar.alias,
                            'autologin': btoa(true),
                            'uid': uid,
                            'pswd': pswd,
                            'isOnlinePreview': btoa(false),
                            'proxyUrl': _nextStateParams.proxyUrl,
                            'nextTestUrl': _nextStateParams.nextTestUrl
                        };
                    }
                    return nextStateParams;
                },
                redirectToAfterSubmissionPage: function(stateParams) {
                    //blockUI.stop();
                    var nxtTestParamObj = {
                        'alias': service.localVar.alias,
                        'nextTestStateParams': stateParams,
                        'isAutoTestEnabled': service.localVar.isAutoTest,
                        'shortlistingStat': service.localVar.shortlistingStat,
                        'shortlistingMessage': service.localVar.shortlistingMessage,
                        'errormessage': service.localVar.errormessage,
                        'isUnscorable': service.localVar.isUnscorable,
                        'isConsentRequired':service.localVar.isConsentRequired
                    };
                    console.log(nxtTestParamObj, 'initiateAutomation - nextparams');
                    $state.go('submitConfirmation', nxtTestParamObj, { 'reload': true, 'location': 'replace' });
                }
            };
        return service;
    }
})();

(function() {
    "use strict";

    angular
        .module("OnlineAssessmentAngular")
        .service("aceHelper", aceHelperService);

    function aceHelperService(webService, $q, $http) {
        var service = {
                addCompleter: addCompleter,
                handleHeader: handleHeader,
                setCompletionData: getLanguageData,
                completionsData: [],
                autoCompleteSuggestion: {}
            },
            completions = {},
            javaPredefinedData = [],
            langTools = null,
            languageMapper = {
                "bash": "sh",
                "c": "c_cpp",
                "coffee": "coffee",
                "cpp": "c_cpp",
                "csharp": "csharp",
                "d": "d",
                "erlang": "erlang",
                "fsharp": "csharp",
                "go": "golang",
                "haskell": "haskell",
                "java": "java",
                "java8": "java8",
                "js": "javascript",
                "ocaml": "ocaml",
                "perl": "perl",
                "php": "php",
                "python": "python",
                "python3": "python",
                "ruby": "ruby",
                "rust": "rust",
                "scala": "scala",
                "html": "html",
                "css": "css",
                "MySql": "sql"
            },
            langHeaderMapper = {
                "java": "import",
                "java8": "import",
                "c": "#include",
                "cpp": "#include"
            };
        return service;

        function handleHeader(delta, languageStr) {
            var data = _.first(delta),
                column = data.lines.length > 1 ? 0 : data.end.column,
                count = 0,
                languageCode = languageStr && angular.fromJson(languageStr);
            if (!data.lines.length) {
                return;
            }
            if (!isContainsHeader(data, delta[1], languageCode.code)) {
                return;
            }
            //insert header
            if (data.action === 'insert') {
                insertHeader(data, delta[1], languageCode.code, column);
            }
            // remove header
            if (data.action === "remove") {
                if (data.lines.length === 1) {
                    removeSingleHeader(data, delta, languageCode.code);
                } else {
                    removeMultipleHeader(data, delta, languageCode.code);
                }
            }
        }

        /*..............................................Insert header..................................................*/
        /*
            data: {start: {row: 0}, end:{ row: 0}}
            delta: //editor
            languageCode:
        */
        function insertHeader(data, delta, languageCode) {
            for (var i = data.start.row; i <= data.end.row; i++) {
                var currentLine = delta.getSession().getLine(i);
                if (isHeader(currentLine, languageCode)) {
                    addHeader(currentLine, languageCode);
                }
            }
        }

        function addHeader(line, languageCode) {
            service.completionsData = _.size(service.completionsData) ? service.completionsData : completions[languageCode] || [];
            if (_.size(service.completionsData)) {
                addHeaderData(line, service.completionsData, languageCode);
            }
        }
        // set import data for custom completion
        /*
            line: <string>
            completor: <language wise data>
            column: <which column cursor is present>
        */
        function addHeaderData(line, completor, languageCode) {
            // var separateLine = column ? line.substr(0, column) : line,
            var packageNameStr, suggestions;
            if (languageCode === 'java' || languageCode === 'java8') {
                packageNameStr = line.replace(/\s|import|;/g, ''); // "import java.io.*;" --> "java.io.*"
                suggestions = setAutoCompleteSuggestion(packageNameStr, true);
            }
            if (languageCode === 'c' || languageCode === 'cpp') {
                packageNameStr = line.replace(/\s|#include|;/g, ''); // "#include <stdio.h>" --> "<stdio.h>" 
                suggestions = setAutoCompleteSuggestionForCppAndC(packageNameStr, true);
            }
            if (!service.autoCompleteSuggestion[packageNameStr] && _.size(suggestions)) {
                service.autoCompleteSuggestion[packageNameStr] = suggestions;
            }
        }

        /*..............................................Remove header..................................................*/
        //remove single header
        function removeSingleHeader(data, delta, languageCode) {
            var currentLine = delta[1].getSession().getLine(data.start.row),
                removedStr = data.lines[0],
                column = data.start.column,
                replacedByStringLength = 0,
                actualLine = null;
            if (_.isEmpty(removedStr)) {
                return false;
            }
            replacedByStringLength = getReplacedByStringLength(delta[1]);
            actualLine = currentLine.substring(0, column) + removedStr + currentLine.substring(column + replacedByStringLength);
            if (isHeader(actualLine, languageCode)) {
                removeHeaderData(actualLine, delta[1], languageCode);
            }
        }

        //remove multiple headers
        function removeMultipleHeader(data, delta, languageCode) {
            var i = 0,
                line = 0,
                currentLine = null,
                actualLine = null,
                lineToBeDelete = null,
                rows = null,
                cursorPosition = null;
            for (i = 0; i < data.lines.length; i++) {
                line = data.lines[i];
                if (_.isEmpty(line)) {
                    continue;
                } else if (isHeader(line, languageCode)) {
                    removeHeaderData(line, delta[1], languageCode);
                } else if (i === 0) {
                    currentLine = delta[1].getSession().getLine(data.start.row);
                    actualLine = currentLine.substring(0, data.start.column) + line;
                    isHeader(actualLine, languageCode) && removeHeaderData(actualLine, delta[1], languageCode);
                } else if (i === data.lines.length - 1) {
                    cursorPosition = delta[1].getCursorPosition();
                    currentLine = delta[1].getSession().getLine(cursorPosition.row);
                    lineToBeDelete = line + currentLine.substring(cursorPosition.column);
                    // lineToBeDelete = line + delta[1].getSession().getLine(data.start.row).substring(data.start.column);
                    if (!findIndexOfHeader([lineToBeDelete], langHeaderMapper[languageCode])) {
                        return;
                    }
                    removeHeaderData(lineToBeDelete, delta[1], languageCode);
                    rows = {
                        start: {
                            row: cursorPosition.row
                        },
                        end: {
                            row: cursorPosition.row
                        }
                    }
                    insertHeader(rows, delta[1], languageCode);
                } else {
                    continue;
                }
            }
        }

        /*............................................Remove header data...............................................*/
        // delte data from main object
        function removeHeaderData(currentLine, editor, languageCode) {
            var packageNameStr,
                matchedValueThroughOutLines = editor.getSession().doc.$lines;
            if (languageCode === 'java' || languageCode === 'java8') {
                packageNameStr = currentLine.replace(/\s|import|;/g, ''); // "import java.io.*;" --> "java.io.*"
            }
            if (languageCode === 'c' || languageCode === 'cpp') {
                packageNameStr = currentLine.replace(/\s|#include|;/g, ''); // "#include <stdio.h>" --> "<stdio.h>" 
            }
            if (service.autoCompleteSuggestion[packageNameStr]) {
                service.autoCompleteSuggestion = _.omit(service.autoCompleteSuggestion, packageNameStr);
            }
        }

        /*...........................................Start:Is Header Validation........................................*/
        // check lines start with depending on langHeaderMapper
        function isContainsHeader(data, delta, languageCode) {
            var editorLine = getAllLine(data.start.row, data.end.row, delta),
                importStatus = findIndexOfHeader(data.lines, langHeaderMapper[languageCode]) ? true : findIndexOfHeader(editorLine, langHeaderMapper[languageCode]);
            return importStatus;
        }

        // find index of matching string from string[]
        function findIndexOfHeader(lines, matchingStr) {
            return _.findIndex(lines, function(line) {
                return line.match(_.trim(matchingStr));
            }) > -1 ? true : false;
        }
        // check match for current line depending on languageCode
        function isHeader(currentLine, languageCode) {
            var matchedThrough;
            if (languageCode === 'java' || languageCode === 'java8') {
                matchedThrough = new RegExp('(?=.*import)(?=.*;)'); // checks starts with import and ends with ;
            }
            if (languageCode === 'c' || languageCode === 'cpp') {
                matchedThrough = new RegExp('(?=.*#include)'); // checks for c and cpp starts with #include
            }
            return currentLine.match(matchedThrough) ? true : false;
        }
        /*...........................................End:Is Header Validation..........................................*/

        //get all lines
        function getAllLine(startRow, endRow, editor) {
            return editor.getSession().getLines(startRow, endRow);
        }

        // get string startwith length
        function getReplacedByStringLength(editor) {
            return editor.prevOp ? _.isObject(editor.prevOp.args) ? _.size(editor.prevOp.args.text) :
                _.size(editor.prevOp.args) : 0;
        }


        /*................................................Handle Completions............................................*/
        //set classes and interfaces
        /*
        line: <string>
        */
        function setAutoCompleteSuggestion(line, isSavePackage) {
            var lineData = line.split('.'),
                result = [],
                firstData = _.chain(service.completionsData)
                .find({ name: lineData[0] })
                .get('packages')
                .map(function(item) {
                    item.matchingIndex = item.name.indexOf('<') > -1 ? item.name.substr(0, item.name.indexOf('<')) : item.name;
                    return item;
                })
                .value();
            if (lineData.length == 2) {
                result = firstData;
                if (lineData[lineData.length - 1] === '*') {
                    return _.chain(result)
                        .get('subChild')
                        .map(function(item) {
                            item.matchingIndex = item.name.indexOf('<') > -1 ? item.name.substr(0, item.name.indexOf('<')) : item.name;
                            return item;
                        })
                        .value() || [];
                }
                if (lineData[lineData.length - 1] === '') {
                    return result || [];
                }
                if (result && isSavePackage) {
                    return _.chain(result).reduce(function(acc, keyword) {
                        if (lineData[lineData.length - 1].toLowerCase() === keyword.name.toLowerCase()) {
                            acc.push(keyword);
                        }
                        return acc;
                    }, []).value();
                }
                if (result && !isSavePackage) {
                    return _.chain(result).reduce(function(acc, keyword) {
                        if (_.startsWith(keyword.name.toLowerCase(), lineData[lineData.length - 1].toLowerCase())) {
                            acc.push(keyword);
                        }
                        return acc;
                    }, []).value();
                }
            } else if (lineData.length == 3) {
                result = _.chain(firstData)
                    .find(function(packages) {
                        if (packages.matchingIndex.toLowerCase() === lineData[1].toLowerCase()) {
                            return packages;
                        }
                    })
                    .get('subChild')
                    .map(function(item) {
                        item.matchingIndex = item.name.indexOf('<') > -1 ? item.name.substr(0, item.name.indexOf('<')) : item.name;
                        return item;
                    })
                    .value();
                if (lineData[lineData.length - 1] === '*' || lineData[lineData.length - 1] === '') {
                    return result || [];
                }
                if (result && isSavePackage) {
                    return _.chain(result).reduce(function(acc, keyword) {
                        if (lineData[lineData.length - 1].toLowerCase() === keyword.matchingIndex.toLowerCase()) {
                            acc.push(keyword);
                        }
                        return acc;
                    }, []).value();
                }
                if (result && !isSavePackage) {
                    return _.chain(result).reduce(function(acc, keyword) {
                        if (_.startsWith(keyword.name.toLowerCase(), lineData[lineData.length - 1].toLowerCase())) {
                            acc.push(keyword);
                        }
                        return acc;
                    }, []).value();
                }
            } else if (lineData.length == 4) {
                result = _.chain(firstData)
                    .find({ matchingIndex: lineData[1] + '.' + lineData[2] })
                    .get('subChild')
                    .map(function(item) {
                        item.matchingIndex = item.name.indexOf('<') > -1 ? item.name.substr(0, item.name.indexOf('<')) : item.name;
                        return item;
                    })
                    .value();
                if (lineData[lineData.length - 1] === '*' || lineData[lineData.length - 1] === '') {
                    return result || [];
                }
                if (result && isSavePackage) {
                    return _.chain(result)
                        .reduce(function(acc, keyword) {
                            if (lineData[lineData.length - 1].toLowerCase() === keyword.matchingIndex.toLowerCase()) {
                                acc.push(keyword);
                            }
                            return acc;
                        }, []).value();
                }
                if (result && !isSavePackage) {
                    return _.chain(result)
                        .reduce(function(acc, keyword) {
                            if (_.startsWith(keyword.name.toLowerCase(), lineData[lineData.length - 1].toLowerCase())) {
                                acc.push(keyword);
                            }
                            return acc;
                        }, []).value();
                }
            }
        }

        function addCompleter(editor, langCode, isEnableAutocompleteHelp) {
            if (langCode === 'java' || langCode === 'java8' || langCode === 'c' || langCode === 'cpp') {
                editor.commands.on("afterExec", function(e) {
                    if (e.args && e.command.name === "insertstring" && /^[\w.]$/.test(e.args)) {
                        editor.execCommand("startAutocomplete");
                    }
                });
            }
            if (langTools) {
                editor.completers && editor.completers.pop();
            }
            langTools = !langTools ? ace.require("ace/ext/language_tools") : langTools;
            service.completionsData = completions[langCode] || []
            var mappedWordList = [],
                customCompleter = {
                    getCompletions: function(editor, session, pos, prefix, callback) {
                        console.log(service.autoCompleteSuggestion);
                        service.completionsData = _.size(service.completionsData) ? service.completionsData : completions[langCode] || [];
                        if (langCode === 'java' || langCode === 'java8' || langCode === 'c' || langCode === 'cpp') {
                            mappedWordList = gatherMappedCompletionsForDifferentLangs(editor, session, langCode) || [];
                        } else {
                            if (prefix.length === 0) { callback(null, []); return }
                            mappedWordList = gatherMappedCompletions(langCode, prefix);
                        }
                        // if (prefix.length === 0) { callback(null, []); return }
                        // mappedWordList = gatherMappedCompletions(langCode, prefix);
                        // if (mappedWordList.length === 0) { callback(null, []); return }
                        callback(null, mappedWordList);
                    },
                    getDocTooltip: isEnableAutocompleteHelp ? function(item) {
                        if (item.description) {
                            var str = '',
                                splittedWord = item.description ? _.chunk(item.description.split(' '), 5) : [],
                                value = item.value ? _.replace(item.value, /[<,>]/g, function(data) {
                                    if (data === '<') {
                                        return '&lt;';
                                    } else {
                                        return '&gt;';
                                    }
                                }) : '';
                            _.forEach(splittedWord, function(resdata) {
                                str = str + _.join(resdata, ' ') + '<br>';
                            });
                            item.docHTML = ["<b>", value, "</b>", "<hr></hr>", '<div style="max-height: 200px;max-width: 500px;overflow-y: scroll;font-size:15px;word-wrap: break-word;">' + str + '</div>'].join("");
                        }
                    } : null
                };
            /*if (langCode === "java") {
                customCompleter.insertMatch = function(editor, data) {
                    if (editor.completer.insertMatch({ value: data.caption }), "import" !== data.meta) {
                        var t = editor.selection.getCursor();
                        void 0 === editor.find("import " + data.meta + "." + data.value) && void 0 === editor.find("import " + data.meta + ".*") ? (editor.moveCursorTo(0, 0), editor.clearSelection(), editor.insert("import " + data.meta + "." + data.value + ";\n"), void 0 !== t && (editor.moveCursorTo(t.row + 1, t.column + data.value.length), editor.clearSelection())) : void 0 !== t && (editor.moveCursorTo(t.row, t.column), editor.clearSelection())
                    }
                }
            }*/
            langTools.addCompleter(customCompleter);
        }

        function getLanguageData(isAutocompleteHelp) {
            return !_.isEmpty(completions) ? $q.when(completions) :
                $q.all({
                    hireproLanguageTools: webService.execute("hireproLanguageTools", {}, 'GET'),
                    cAndCppTools: webService.execute("cAndCppTools", {}, 'GET'),
                    javaTools: webService.execute(isAutocompleteHelp?'java7WithDescriptionTools':'java7WithOutDescriptionTools', {}, 'GET'),
                    java8Tools: webService.execute(isAutocompleteHelp?'java8WithDescriptionTools':'java8WithOutDescriptionTools', {}, 'GET')
                }).then(function(res) {
                    if (!res) {
                        return [];
                    }
                    completions = _.merge(
                        _.get(res, 'hireproLanguageTools.data', {}),
                        _.get(res, 'cAndCppTools.data', {}),
                        _.get(res, 'javaTools.data', {}),
                        _.get(res, 'java8Tools.data', {})
                    );
                    return completions;
                });
        }

        function gatherMappedCompletions(langCode, prefix) {
            var wordList = gatherCompletions(langCode),
                matches = [];
            if (!wordList || !_.size(wordList)) {
                return matches;
            }
            /*_.forEach(wordList, function(wrd) {
                (wrd.name).startsWith(prefix) && matches.push({
                    name: wrd.name,
                    value: wrd.name,
                    score: 500,
                    meta: wrd.meta
                });
            });*/
            return _.chain(wordList).map(function(data, key) {
                    return _.map(data, function(keyword) {
                        if (_.startsWith(keyword, prefix)) {
                            return {
                                name: keyword,
                                value: keyword,
                                score: 500,
                                meta: key
                            }
                        }
                    })
                })
                .flatten()
                .compact()
                .value();
            // return matches
        }

        function gatherCompletions(langCode) {
            var wrdLst = null;
            if (!langCode) {
                return [];
            }
            wrdLst = service.completionsData;
            if (!wrdLst) {
                return [];
            }
            return wrdLst;
        }

        // auto completer for java,c and c++(cpp)
        function gatherMappedCompletionsForDifferentLangs(editor, session, langCode) {
            if (_.isEmpty(service.autoCompleteSuggestion) && _.size(service.completionsData)) {
                var data = {
                        start: {
                            row: 0
                        },
                        end: {
                            row: session.doc.$lines.length - 1
                        }
                    },
                    delta = editor;
                insertHeader(data, delta, langCode);
            }
            var selectedCursorPOsition = editor.getCursorPosition(),
                currentLine = session.getLine(selectedCursorPOsition.row),
                line = currentLine.length ? currentLine.substring(0, selectedCursorPOsition.column) : '',
                javaPackage = line.indexOf('java.') > -1 ? line.indexOf('java.') : line.indexOf('javax.') > -1 ? line.indexOf('javax.') :
                line.indexOf('org.') > -1 ? line.indexOf('org.') : -1,
                customKeywordsWithClasses = service.autoCompleteSuggestion,
                customSuggestions = [],
                result = [],
                staticClass;
            if (javaPackage > -1) {
                customSuggestions = setAutoCompleteSuggestion(line.slice(javaPackage), false);
            }
            if ((langCode === 'c' || langCode === 'cpp') && line.indexOf('#include <') > -1) {
                customSuggestions = setAutoCompleteSuggestionForCppAndC(line.replace(/\s|#include|;/g, ''), false);
            }
            if (!_.size(customSuggestions) && _.size(customKeywordsWithClasses)) {
                var splittedBySpaceAndDot = line.split(/[\s,.]/),
                    regexForConstructor = getRegexForContructor(line),
                    flattenCustomData = _.chain(customKeywordsWithClasses)
                    .map()
                    .flatten()
                    .compact()
                    .value();
                if (line.indexOf('.') > -1 && line.search(/java|org/) === -1) {
                    staticClass = getStaticClassDetails(flattenCustomData, line);
                    if (staticClass) {
                        result = _.chain(staticClass).pick('fields', 'methods').reduce(function(acc, staticData, index) {
                            acc.push(_.map(staticData, function(data) {
                                if ((data.isStatic || data.isfinal) && splittedBySpaceAndDot[splittedBySpaceAndDot.length - 1] === '') {
                                    return {
                                        name: data.name,
                                        type: staticClass.name + ' Class' + (data.isStatic ? ' Static ' : ' Final ') + index,
                                        description: data.description
                                    }
                                } else if ((data.isStatic || data.isfinal) && _.startsWith(data.name.toLowerCase(), splittedBySpaceAndDot[splittedBySpaceAndDot.length - 1].toLowerCase())) {
                                    return {
                                        name: data.name,
                                        type: staticClass.name + ' Class' + (data.isStatic ? ' Static ' : ' Final ') + index,
                                        description: data.description
                                    }
                                }
                            }));
                            return acc;
                        }, []).flatten().compact().value() || [];
                    } else if (line.match(regexForConstructor)) {
                        result = getCustomConstructor(flattenCustomData, session, line);
                    } else {
                        result = getCustomMethodsAndConstructor(flattenCustomData, session, line, 'methods');
                    }
                } else if (line.match(regexForConstructor) && line.search(/java|org/) === -1) {
                    result = getCustomConstructor(flattenCustomData, session, line);
                } else {
                    result = _.chain(flattenCustomData)
                        .map(function(data) {
                            return _.startsWith(data.name.toLowerCase(), splittedBySpaceAndDot[splittedBySpaceAndDot.length - 1].toLowerCase()) ? data : null
                        })
                        .compact()
                        .value();
                }
            }
            if (_.size(customSuggestions)) {
                result = _.chain(customSuggestions).map(function(suggestion) {
                    return {
                        name: suggestion.matchingIndex,
                        value: suggestion.name,
                        type: suggestion.type,
                        description: suggestion.description
                    }
                }).value();
            }
            return _.reduce(result, function(acc, data) {
                acc.push({
                    name: data.name,
                    value: data.name,
                    score: 500,
                    meta: data.type,
                    description: data.description
                })
                return acc;
            }, []);
        }

        function getCustomConstructor(customData, session, line) {
            var str = line.match(/= new |=new |new/g),
                latestValue = _.last(str),
                lineSubstring = line.substring(line.lastIndexOf(latestValue), line.length),
                result = [];
            if (getRegexForMatchingContructor(latestValue)) {
                result = getCustomMethodsAndConstructor(customData, session, line, 'constructors') || []
            } else {
                result = getAllConstructor(customData, lineSubstring)
            }
            return result;
        }

        function getAllConstructor(customData, currentText) {
            console.log(customData);
            var startWithStr = currentText.split('new ')[1];
            if (_.isUndefined(startWithStr)) {
                return [];
            }
            return _.chain(customData).map(function(data) {
                return _.map(data.constructors, function(constructor) {
                    if (startWithStr === '' || (constructor && constructor.name && _.startsWith(constructor.name.toLowerCase(), startWithStr.toLowerCase()))) {
                        return {
                            name: constructor.name,
                            type: data.name + ' - constructor()',
                            description: constructor.description
                        }
                    }
                })
            }).flatten().compact().value();

            // return _.chain(customData)
        }

        function getCustomMethodsAndConstructor(customData, session, line, type) {
            var objectSplittedByDot = _.map(line.split(/[.,\s,=]/), _.trim),
                objectThroughSearch = type === 'methods' ? getSearchObject(line) : ' ' + getClassObject(line),
                startsWith = type === 'methods' ? objectSplittedByDot[objectSplittedByDot.length - 1] :
                line.slice(line.lastIndexOf(' ') + 1, line.length);
            for (var i = session.doc.$lines.length - 1; i >= 0; i--) {
                if (session.doc.$lines[i].search(objectThroughSearch) > -1) {
                    var searchStr = _.map(session.doc.$lines[i].split(objectThroughSearch), _.trim)[0],
                        str = searchStr.indexOf('<') > -1 ? searchStr.substr(0, searchStr.indexOf('<')) : searchStr;
                    if (!str) {
                        continue;
                    }
                    return _.chain(customData)
                        .map(function(res) {
                            if (res.matchingIndex === str && type === 'methods') {
                                return _.map(res[type], function(dataNew) {
                                    if (startsWith === '' && (!dataNew.isStatic && !dataNew.isfinal)) {
                                        return {
                                            name: dataNew.name,
                                            type: res.name + ' - ' + type + '()',
                                            description: dataNew.description
                                        }
                                    }
                                    if (dataNew && (!dataNew.isStatic && !dataNew.isfinal) && dataNew.name && _.startsWith(dataNew.name.toLowerCase(), startsWith.toLowerCase())) {
                                        return {
                                            name: dataNew.name,
                                            type: res.name + ' - ' + type + '()',
                                            description: dataNew.description
                                        }
                                    }
                                })
                            }
                            if (res.matchingIndex === str && type === 'constructors') {
                                return _.map(res[type], function(dataNew) {
                                    if (startsWith === '') {
                                        return {
                                            name: dataNew.name,
                                            type: res.name + ' - ' + type + '()',
                                            description: dataNew.description
                                        }
                                    }
                                    if (dataNew && dataNew.name && _.startsWith(dataNew.name.toLowerCase(), startsWith.toLowerCase())) {
                                        return {
                                            name: dataNew.name,
                                            type: res.name + ' - ' + type + '()',
                                            description: dataNew.description
                                        }
                                    }
                                })
                            }
                        })
                        .flattenDeep()
                        .compact()
                        .value();
                }
            }
        }

        function getClassObject(line) {
            var str = _.map(line.split(/=new|= new| = new/), _.trim)[0],
                lastIndexOfSpace = str.lastIndexOf(' ') === -1 ? 0 : str.lastIndexOf(' ');
            return _.trim(str.slice(lastIndexOfSpace, str.length));
        }

        function getRegexForContructor(currentLine) {
            var pattern1 = ' new ',
                pattern2 = 'new ',
                regex = new RegExp(pattern1 + '|' + pattern2);
            return regex;
        }

        function getRegexForMatchingContructor(currentLine) {
            var pattern1 = '= new ',
                pattern2 = '=new ',
                regex = new RegExp(pattern1 + '|' + pattern2);
            return currentLine.match(regex) ? true : false;
        }

        function getSearchObject(line) {
            var object = _.map(line.split(/[.,(,),=]/), _.trim),
                pattern1 = ' ' + object[object.length - 2] + ' =',
                pattern2 = ' ' + object[object.length - 2] + ';',
                pattern3 = ' ' + object[object.length - 2] + '=',
                pattern4 = ' ' + object[object.length - 2] + ' ;',
                regex = new RegExp(pattern1 + '|' + pattern2 + '|' + pattern3 + '|' + pattern4);
            return regex;
        }

        function getStaticClassDetails(customData, line) {
            var object = _.map(line.split(/[.,(,),\s,=]/), _.trim),
                data = _.chain(customData)
                .filter({
                    name: object[object.length - 2]
                })
                .first()
                .value() || undefined;
            return data;
        }
        /*auto complete for c and cpp*/
        function setAutoCompleteSuggestionForCppAndC(line, isSavePackage) {
            var result = [],
                firstData = _.chain(service.completionsData)
                .map(function(item) {
                    item.matchingIndex = (item.name).replace(/<|>/g, "");
                    return item;
                })
                .value();
            if (line === "") {
                return result;
            }
            if ((line.startsWith("<") && line.endsWith(">")) || isSavePackage) {
                //returns subChild
                return _.chain(firstData)
                    .find({
                        name: line
                    })
                    .get('subChild')
                    .map(function(item) {
                        item.matchingIndex = (item.name).replace(/<|>/g, "");
                        return item;
                    })
                    .value();
            }
            if ((line.startsWith("<")) || !isSavePackage) {
                //returns libraries
                return _.chain(firstData)
                    .reduce(function(acc, keyword) {
                        if (_.startsWith(keyword.name.toLowerCase(), (line).toLowerCase())) {
                            acc.push(keyword);
                        }
                        return acc;
                    }, [])
                    .value();
            }
            return result;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('OnlineAssessmentAngular')
        .component('userCameraElement', {
            'templateUrl': 'app/assessment/userCameraElement.tpl.html',
            'controller': userCameraController,
            'controllerAs': 'vm'
        });

    function userCameraController($rootScope, $log) {
        var vm = this,
            vidElem = document.getElementById("vid-mirror");
        $rootScope.$watch('vidStrmId', function() {
            if (!vidElem) {
                $log.error("video element with id 'vid-mirror' is not found.");
                return false;
            }
            if (!$rootScope.vidStrm) {
                return false;
            }
            try {
                vidElem.srcObject = $rootScope.vidStrm;
            } catch (error) {
                vidElem.src = URL.createObjectURL($rootScope.vidStrm);
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('OnlineAssessmentAngular')
        .component('testLinkByEmail', {
            'templateUrl': 'app/assessment/testLinkByEmail.html',
            'controller': getTestLinkByEmail,
            'controllerAs': 'vm'
        });

    function getTestLinkByEmail($log, $state, $window, assessmentUtility, webService, loginService, openModalService) { // commonService
        var vm = this,
            tenantId = -1,
            openWindow = null;

        vm.testLinks = null;
        vm.isError = false;
        vm.errorMessage = "";
        vm.testLinkStat = "Your Test Links will appear here";
        var paramObj = {};
        try {
            paramObj = assessmentUtility.getSateParameters($state.params);
        } catch (error) {
            showAliasModal(null);
            return;
        }
        if (!paramObj.alias) {
            showAliasModal(null);
        } else {
            loginService.getCompanyInfo(paramObj.alias).then(function(res) {
                if (res && res.status == "OK") {
                    tenantId = loginService.getTenantId();
                } else {
                    showAliasModal('Please provide correct Tenant alias.');
                    return;
                }
            });
        }

        vm.getTestLinksByCandEmail = function() {
            // tenantId = loginService.getTenantId(); //$window.sessionStorage.getItem("oa_tenantId");
            vm.errorMessage = "";
            if (vm.candEmail) {
                //blockUI.start();
                vm.testLinkStat = "NO TESTS FOUND";
                vm.testLinks = null;
                vm.isError = false;
                var request = {
                    // 'TenantId': tenantId,
                    'email': vm.candEmail
                };
                webService.execute('GetLoginCredentialsByCandidateIdOrEmail', request, 'POST', '', { 'T-ALIAS': paramObj.alias }).then(
                    function(response) {
                        //blockUI.stop();
                        if (response.data && response.data.data && !response.data.error) {
                            if (response.data.data.candidateIds) {
                                vm.isError = true;
                                vm.errorMessage = "Multiple candidate found against this email id.Please contact to your administrator.";
                            } else {
                                if (response.data.data && response.data.data.credentials && response.data.data.credentials.length > 0) {
                                    vm.testLinks = response.data.data.credentials;
                                }
                            }
                        } else if (response.data.error) {
                            $log.error(response.data.error.errorDescription);
                            vm.isError = true;
                            vm.testLinks = [];
                            //vm.errorMessage = response.data.error.errorDescription;
                        } else {
                            $log.error('Unable to process data');
                        }
                    },
                    function(response) {
                        //blockUI.stop();
                    }
                );
            } else {
                //vm.isError = true;
                return false;
            }
        };

        vm.startTest = function(testLinkInfo) {
            if (testLinkInfo) {
                var appName = "onlineassessment/";
                var locationOrigin = location.origin;
                if (locationOrigin.search(/\blocalhost\b/) > -1) {
                    appName = "";
                }
                var stateparams = {
                    alias: paramObj.alias,
                    uid: btoa(testLinkInfo.loginId),
                    pswd: btoa(testLinkInfo.password),
                    autologin: btoa("true")
                };
                stateparams = encodeURIComponent(btoa(JSON.stringify(stateparams)));
                var url = $state.href('assess.login', { stateParams: stateparams });
                try {
                    if (!openWindow || openWindow.closed) {
                        openWindow = window.open(url, '_blank');
                    } else {
                        var data = {
                            bodyStr: "<div><p>Are you sure you want to continue? Any ongoing tests will be closed.</div>",
                            headerStr: "Confirm",
                            isAction: true,
                            action: {
                                isOkBtn: true,
                                isCancelBtn: true
                            }
                        };
                        openModalService.openModal('notificationTemplate', data).then(function(res) {
                            if(res.result.result.modalResponse){
                                openWindow.close();
                                if (!openWindow || openWindow.closed) {
                                    openWindow = window.open(url, '_blank');
                                }
                            }
                            openWindow.focus();
                        });
                    }
                } catch(ex) {
                    openWindow = window.open(url, '_blank');
                    openWindow.focus();
                }
            }
        };

        function showAliasModal(msg) {
            openModalService.openModal('provideAliasTemplate', { 'errorMessage': msg }).then(function(res) {
                if (res.result.alias) {
                    paramObj.alias = res.result.alias;
                    $state.go('testLinkByEmail', { stateParams: btoa(JSON.stringify(paramObj)) }, { location: 'replace' });
                } else {
                    showAliasModal('Please provide correct Tenant alias.');
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('OnlineAssessmentAngular')
        .component('surroundNoiseCheck', {
            controller: surroundNoiseCheckController,
            controllerAs: 'vm',
            templateUrl: 'app/assessment/surroundNoiseCheck.tpl.html',
            bindings: {
                thresholdValue: '<',
                responseData: '&',
                instantNoise: '<',
                noiseAttempt: '<'
            }
        });

    function surroundNoiseCheckController($scope, $log, $timeout, trackerService, imageTracker, $interval, $sce) {
        var vm = this,
            audioBlob,
            chunk = 0,
            totalForAvg,
            rmsArray = [],
            instantrmsArray = [],
            stoppedRecording,
            javascriptNode,
            fullStream,
            recordingTimer,
            mediaRecorder,
            waitTimer,
            noiseCheckAttempt = 0,
            maxAttemptStatus,
            audioValue = {
                mandatory: {
                    googEchoCancellation: false,
                    googAutoGainControl: false,
                    googNoiseSuppression: false,
                    googHighpassFilter: false
                }
            };

        vm.noiseMeter = 0;
        vm.noiseCheckingInProcess = true;
        vm.noiseCheckingSuccess = true;
        vm.countDownShow = true;
        vm.countDownTimer = 3;
        vm.showNoiseBlocker = false;
        vm.microphoneIsMuted = false;

        vm.reStartRecording = reStartRecording;

        vm.$onInit = function() {
            vm.noiseAttempt = vm.noiseAttempt;
            active();
        };

        function active() {
            var i = 3,
                countdownInterval;
            console.log('SS noise attempt in activate', vm.noiseAttempt);
            countdownInterval = $interval(function() {
                vm.countDownTimer = i;
                i--;
            }, 1000);

            if (vm.noiseAttempt && vm.noiseAttempt > 0) {
                maxAttemptStatus = true;
            } else {
                maxAttemptStatus = false;
            }
            sessionStorage.setItem("noiseCheckCount", noiseCheckAttempt);
            waitTimer = $timeout(function() {
                $interval.cancel(countdownInterval);
                vm.countDownShow = false;
                startRecording();
                $scope.$apply();
            }, 4000);
        }

        function colorPid(val) {
            if (val) {
                vm.noiseMeter = Math.round(val / 5);
                $scope.$apply();
            }
        }

        function instantNoiseCheck(val) {
            if (val) {
                $log.log('SS NOISEMETER', val);
                if (vm.instantNoise) {
                    if (Math.round(val) > vm.thresholdValue) {
                        stopRecording(true);
                        vm.noiseCheckingSuccess = false;
                        reStartBlocker();
                        vm.responseData({ proceed: false, type: 'noise' });
                    }
                }
            }
        }

        function getAudioMeter(res) {
            rmsArray = [];
            instantrmsArray = [];
            var audioContext = new AudioContext();
            var analyser = audioContext.createAnalyser();
            var microphone = audioContext.createMediaStreamSource(res);
            javascriptNode = audioContext.createScriptProcessor(4096, 2, 2);

            analyser.smoothingTimeConstant = 0.8; //0.8;
            analyser.fftSize = 64;

            microphone.connect(analyser);
            analyser.connect(javascriptNode);
            javascriptNode.connect(audioContext.destination);
            javascriptNode.onaudioprocess = null;
            javascriptNode.onaudioprocess = function(evt) {
                var input = evt.inputBuffer.getChannelData(0),
                    len = input.length,
                    total = 0,
                    i = 0,
                    rms, instantrms;
                while (i < len) total += Math.abs(input[i++]);
                rms = Math.sqrt(total / len);
                rmsArray.push((rms * 100));
                instantrmsArray.push((rms * 100));
                colorPid((rms * 100));
                if (instantrmsArray.length >= 10) {
                    instantrms = _.mean(instantrmsArray);
                    instantNoiseCheck(instantrms);
                    instantrmsArray = [];
                }
            };
        }

        function startRecording() {
            navigator.mediaDevices.getUserMedia({ audio: true })
                .then(function(stream) {
                    if (stream.getAudioTracks()[0].muted) {
                        vm.microphoneIsMuted = true;
                    } else {
                        var chunks = [],
                            timeOutFunc = stopRecording;
                        stoppedRecording = false;

                        var recordingStopped = function(e) {
                            //var audsrc;
                            // audsrc = window.URL.createObjectURL(blob);
                            audioBlob = new Blob(chunks, {
                                'type': 'audio/ogg; codecs=opus'
                            });
                            if (!vm.instantNoise || vm.fullNoiseTimerEnded) {
                                chunk = _.ceil(rmsArray.length / 3);
                                if (chunk) {
                                    var chunkArray = [];
                                    totalForAvg = 0;
                                    chunkArray = _.chunk(rmsArray, chunk);
                                    _.forEach(chunkArray, function(values, key) {
                                        var total = 0;
                                        _.forEach(values, function(val) {
                                            total += val;
                                            console.log('SS for loop total', total);
                                        });
                                        totalForAvg += total / values.length;
                                        $log.log("i", total / values.length);
                                    });
                                    totalForAvg = totalForAvg / 3;
                                    vm.noiseMeter = Math.round(totalForAvg / 5);
                                    if (totalForAvg <= vm.thresholdValue) {
                                        vm.noiseCheckingSuccess = true;
                                        vm.responseData({ proceed: true, type: 'noise' });
                                    } else {
                                        vm.noiseCheckingSuccess = false;
                                        reStartBlocker();
                                        vm.responseData({ proceed: false, type: 'noise' });
                                    }
                                }
                            }
                            if (vm.instantNoise) {
                                console.log('condition true', vm.instantNoise)
                            }
                            sendLog();
                        };
                        var recordedDataAvailable = function(mChunk) {
                            chunks.push(mChunk.data);
                        };
                        navigator.getUserMedia = navigator.getUserMedia ||
                            navigator.webkitGetUserMedia ||
                            navigator.mozGetUserMedia;
                        if (navigator.getUserMedia) {
                            navigator.getUserMedia({
                                    audio: audioValue
                                },
                                function(stream) {
                                    getAudioMeter(stream);
                                    if (!stream.getAudioTracks().length) {
                                        return false;
                                    }
                                    fullStream = stream;
                                    mediaRecorder = new MediaRecorder(stream);
                                    Object.defineProperties(mediaRecorder, {
                                        mimeType: {
                                            value: 'audio/ogg',
                                            writable: true
                                        }
                                    });
                                    mediaRecorder.start();
                                    mediaRecorder.ondataavailable = recordedDataAvailable;
                                    mediaRecorder.onstop = recordingStopped;
                                    recordingTimer = $timeout(timeOutFunc, 15000);
                                },
                                function(err) {
                                    $log.log("The following error occurred: " + err.name);
                                }
                            );
                        } else {
                            $log.log("getUserMedia not supported");
                        }
                    }
                })
                .catch(function(err) {
                    console.log(err);
                    vm.microphoneIsMuted = true;
                });
        }

        function stopRecording(stoppedbyInstantCheck) {
            var i;
            $timeout.cancel(recordingTimer);
            if (!stoppedbyInstantCheck) {
                vm.fullNoiseTimerEnded = true;
            }
            if (fullStream) {
                // tracksList = fullStream.getTracks();
                for (i = 0; i < fullStream.getTracks().length; i++) {
                    var track = fullStream.getTracks()[i];
                    track.stop();
                    $log.log("tracker stoped", i);
                }
            }
            if (mediaRecorder && false == stoppedRecording) {
                $log.log("recorder being stopped.");
                mediaRecorder.stop();
                stoppedRecording = true;
            }
            javascriptNode.onaudioprocess = null;
            vm.noiseCheckingInProcess = false;
        }

        function reStartRecording() {
            vm.noiseCheckingInProcess = true;
            vm.noiseCheckingSuccess = true;
            vm.microphoneIsMuted = false;
            vm.fullNoiseTimerEnded = false;
            vm.noiseMeter = 0;
            rmsArray = [];
            instantrmsArray = [];
            audioBlob = '';
            noiseCheckAttempt++;
            if (maxAttemptStatus) {
                sessionStorage.setItem("noiseCheckCount", noiseCheckAttempt);
            }
            startRecording();
        }

        function reStartBlocker() {
            if (maxAttemptStatus && vm.noiseAttempt !== 0) {
                var noiseCheckCount = parseInt(sessionStorage.getItem("noiseCheckCount"));
                if (noiseCheckCount >= vm.noiseAttempt) {
                    vm.showNoiseBlocker = true;
                }
            }
        }

        function sendLog() {
            var dataBlob = dataURItoBlob(audioBlob, "surroundNoiseCheck.ogg");
            var fd = new FormData();
            fd.append("file", dataBlob);
            imageTracker.saveImage(fd, 'both', 'bgsample').then(function(response) {
                var audioUrl = '';
                if (response && response.s3_url) {
                    audioUrl = response.s3_url;
                    $timeout(function() {
                        document.getElementById("noiseCheckPlayback").src = $sce.trustAsResourceUrl(audioUrl);
                    }, 500);
                }
                var log = {
                    chunk: chunk,
                    avg: totalForAvg,
                    audioUrl: audioUrl,
                    threshold: vm.thresholdValue,
                    status: vm.noiseCheckingSuccess
                };
                trackerService.noiseCheckLog(log);
            });
        }

        function dataURItoBlob(dataurl, filename) {
            return new File([dataurl], filename);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('OnlineAssessmentAngular')
        .component('submitConfirmation', {
            bindings: {
                'submitCnfParams': '=submitCnfParams'
            },
            controller: submitConfirmationController,
            controllerAs: 'vm',
            templateUrl: 'app/assessment/submitConfirmation.tpl.html'
        });

    function submitConfirmationController($state, $rootScope, $sce, assessmentUtility, webService, loginService, deviceDetector) {
        var vm = this,
            nextTestStateParams = null, //In sec
            loginInfo = loginService.getLoginInfo();
        vm.showButton = false;
        vm.winHeight = window.innerHeight;
        vm.retestRequest = retestRequest;
        vm.sendToMsgPage = sendToMsgPage;
        vm.saveConsentForNextTest = saveConsentForNextTest;

        vm.$onInit = function() {
            console.log(vm.submitCnfParams, 'submitConfirmation');
            nextTestStateParams = vm.submitCnfParams.nextTestStateParams;
            vm.ApplicationViewType = sessionStorage.getItem('ApplicationViewType');
            vm.isAutoTestEnabled = vm.submitCnfParams.isAutoTestEnabled;
            vm.shortlistingMessage = vm.submitCnfParams.shortlistingMessage;
            vm.shortlistingStat = vm.submitCnfParams.shortlistingStat;
            vm.newUIShow = false;
            vm.chainTestNewUI = false;
            if (sessionStorage.TestLoginInformation && JSON.parse(sessionStorage.TestLoginInformation).Config) {
                var chainTestNewUI = JSON.parse(sessionStorage.TestLoginInformation).Config.nextTestConfig;
                if (chainTestNewUI && chainTestNewUI.isConsentRequired !== undefined) {
                    vm.chainTestNewUI = JSON.parse(sessionStorage.TestLoginInformation).Config.nextTestConfig.isConsentRequired ? true : false;
                }
            } else if (vm.submitCnfParams.isConsentRequired !== null || vm.submitCnfParams.isConsentRequired !== undefined) {
                vm.chainTestNewUI = vm.submitCnfParams.isConsentRequired;
            }
            if (vm.submitCnfParams.data) {
                vm.submitCnfParams.data = JSON.parse(atob(vm.submitCnfParams.data));
            }
            vm.showButton = false;
            if (vm.isAutoTestEnabled) {
                vm.nextTestMsg = 'We have another test lined up for you.';
                vm.nextTestMsgColor = '';
                vm.showButton = true;
                if (vm.submitCnfParams.errormessage) {
                    vm.nextTestMsg = vm.submitCnfParams.errormessage;
                    //vm.nextTestMsgColor = '#FF6057';
                    vm.showButton = false;
                } else if (vm.shortlistingStat == 1) {
                    vm.nextTestMsg = 'Sorry! You are not eligible for the next test.';
                    vm.nextTestMsgColor = '#FF6057';
                    vm.showButton = false;
                } else if (vm.shortlistingStat == 0 && vm.chainTestNewUI) {
                    vm.nextTestMsg = 'Congratulations! You are eligible for the next test.';
                    vm.nextTestMsgColor = '#36B37E';
                    vm.newUIShow = true;
                } else if (vm.shortlistingStat == 0) {
                    vm.nextTestMsg = 'Congratulations! You are eligible for the next test.';
                    vm.nextTestMsgColor = '#36B37E';
                }
                vm.nextTestMsg = $sce.trustAsHtml(vm.nextTestMsg);
            }

            // if (!(vm.isAutoTestEnabled && nextTestStateParams && nextTestStateParams.uid && nextTestStateParams.pswd)) {
            //     vm.isAutoTestEnabled = false;
            // }
            $rootScope.$watch('companyLogoUrl', function() {
                vm.companyLogoUrl = $rootScope.companyLogoUrl ? $rootScope.companyLogoUrl : "assets/images/hirepro_logo.png";
            });
            if (!vm.isAutoTestEnabled && !nextTestStateParams)
                assessmentUtility.exitFullScreen();
            // history.pushState(null, null, location.href);
            // window.onpopstate = function(event) {
            //     history.go(1);
            // };
            assessmentUtility.localStorage.setData('onlineAssessmentStatus', 'testOver');
            history.pushState(null, null, location.href);
        };

        function retestRequest(isRetest) {
            var req = { "candidateId": 0, "testId": 0, "isRetest": isRetest };
            if (sessionStorage.TestLoginInformation) {
                var userDetails = JSON.parse(sessionStorage.TestLoginInformation);
                if (userDetails) {
                    req.candidateId = userDetails.CandidateId;
                    req.testId = userDetails.TestId;
                }
            }
            //if(req.candidateId && req.testId) {
            webService.execute('retestConsent', req).then(function(res) {
                if (isRetest) {
                    vm.retestRequestSuccess = true;
                } else {
                    vm.submitCnfParams.isUnscorable = false;
                }
            });
            /*} else {
                alert('Invalid Data');
            }*/
        }

        function saveConsentForNextTest(status) {
            var req = { "candidateId": 0, "testId": 0, "consentStatus": status };
            if (sessionStorage.TestLoginInformation) {
                var userDetails = JSON.parse(sessionStorage.TestLoginInformation);
                if (userDetails) {
                    req.candidateId = userDetails.CandidateId;
                    req.testId = userDetails.TestId;
                }
            } else if (sessionStorage.candidateId && sessionStorage.testId) {
                req.candidateId = sessionStorage.candidateId;
                req.testId = sessionStorage.testId;
            }
            webService.execute('consentToNextTest', req).then(function(res) {
                if (status) {
                    vm.redirectToNextTest();
                } else {
                    sendToMsgPage();
                }
            });
        }

        vm.redirectToNextTest = function() {
            console.log(nextTestStateParams, 'nextTestStateParams - submitConfirmation');
            sessionStorage.clear();
            if (vm.isAutoTestEnabled && nextTestStateParams) {
                //$state.go('assessment', nextTestStateParams, {location: 'replace'});
                var url;
                if (nextTestStateParams.uid) {
                    url = $state.href('assessment', nextTestStateParams);
                    if (nextTestStateParams.proxyUrl && (nextTestStateParams.proxyUrl.indexOf('cocubes') > -1 || nextTestStateParams.proxyUrl.indexOf('ccbs') > -1)) {
                        url = nextTestStateParams.proxyUrl + url.replace('#/assessment', '/hprotest/#/assessment');
                    } else if (nextTestStateParams.proxyUrl) {
                        url = nextTestStateParams.proxyUrl + location.pathname + url;
                    }
                } else if (nextTestStateParams.nextTestUrl) {
                    url = nextTestStateParams.nextTestUrl;
                }
                console.log('next test url', url);
                if (url) {
                    if ((deviceDetector.os === 'mac') && _.get(loginInfo, 'Config.isSecureBrowserMandatory')) {
                        location.assign(url);
                        location.reload();
                    } else {
                        window.open(url, '_blank');
                    }
                }
            }
        };
        vm.closeBrowser = function() {
            window.close();
        };

        function sendToMsgPage() {
            var savedAlias = sessionStorage.getItem("oa_tenantAlias"),
            obj = { isError: false};
             $state.go('submitConfirmation', { 'alias': savedAlias, 'data': btoa(JSON.stringify(obj)) }, { location: 'replace' });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('OnlineAssessmentAngular')
        .factory('socket', socket)
        .component('startTest', {
            controller: startTestController,
            controllerAs: 'vm',
            templateUrl: 'app/assessment/startTest.tpl.html'
        });

    startTestController.$inject = [
        '$log',
        'assessmentUtility',
        '$state',
        '$window',
        'assessmentService',
        'loginService',
        '$scope',
        'modalService',
        'blockUI',
        'commonService',
        'commonQuestionActions',
        'proctoringService',
        '$sce',
        '$timeout',
        'webService',
        '$q',
        '$injector',
        '$rootScope',
        'proctorMessage',
        'socket',
        'openModalService',
        'trackerService',
        'deviceDetector',
        'growl',
        'liveStream',
        'socketService',
        'aceHelper',
        'hvsService',
        'screenRecordingService',
        'afterSubmission',
        'faceRecognitionService',
        'connection'
    ];

    function startTestController($log, assessmentUtility, $state, $window, assessmentService, loginService, $scope, modalService, blockUI, commonService, commonQuestionActions, proctoringService, $sce, $timeout, webService, $q, $injector, $rootScope, proctorMessage, socket, openModalService, trackerService, deviceDetector, growl, liveStream, socketService, aceHelper, hvsService, screenRecordingService, afterSubmission, faceRecognitionService, connection) {

        var vm = this,
            nextQuestionIndex = 0,
            isScreenProctoringEnable = false,
            isVideoProctoringEnabled = false,
            isVideoProctoringIsMandatEnabled = false,
            isLoadFullScreen = false,
            isOnlinePreview = false,
            isScreenSharingEnabled = false,
            qPaper = null,
            loginInfo = loginService.getLoginInfo(),
            timespent = 0,
            alias = -1,
            testDuration = 0,
            isLastGroup = false,
            GroupWiseTimingEnabled = false,
            isReactivated = false,
            trackerStatus = trackerService.getTrackerStat(),
            isDeviceTypeDesktop = true,
            isOptional = false,
            isFaceDetectingFrameVisible = false,
            isAutoStart = false,
            termsAndConditionModal = null,
            proctorCompatibilityModal = null,
            isMobileViewEnable = false,
            isTabletViewEnable = false,
            isFaceTrackingEnabled = false,
            allowTestTerminationOnDemand = false,
            enableChatting = false,
            enableLiveStream = false,
            isTopRankerStreaming = false,
            grwlObj = null,
            cnf = null,
            thirdPartyTestType = null,
            socketIO = null,
            checkForTerminateTimeout = null;
        vm.showHeader = false;
        vm.scrollToStartTestPage = scrollToStartTestPage;
        vm.ApplicationViewType = sessionStorage.getItem('ApplicationViewType');
        vm.winHeight = assessmentUtility.resize($window);
        vm.testInstructions = $sce.trustAsHtml(loginInfo.TestInstructions);
        vm.isScreenSharing = true;
        vm.isPracticeTestEnabled = false;
        vm.startSampleTest = startSampleTest;
        vm.isThirdParty = false;
        vm.onlyProctoringTest = null;
        vm.termsAndPrivacyPolicy = termsAndPrivacyPolicy;
        vm.privacyPolicy = '/s3_cached/hirepro-content/hirepro/static-resources/privacypolicy.html';
        vm.chatLoaded = sessionStorage.getItem('chatBeforeLogin');
        vm.loginInfoConfig = loginInfo ? loginInfo.Config : {};
        // vm.chatUserId = 0;
        // vm.enableChatting = false;
        if (sessionStorage.privacyPolicy) {
            vm.privacyPolicy = sessionStorage.privacyPolicy;
        }
        vm.tenantAlias = sessionStorage.getItem('oa_tenantAlias');
        if (vm.tenantAlias) {
            vm.tenantAlias = vm.tenantAlias.toLowerCase();
        }
        vm.hideTermsAndConditions = sessionStorage.hideTermsAndConditions === 'true' ? true : false;
        /*if(sessionStorage.hideTermsAndConditionsInSEB === 'true' && sessionStorage.inSecureBrowserCurrently === 'true') {
            vm.hideTermsAndConditions = true;
        }*/
        if (vm.hideTermsAndConditions) {
            vm.isTermsAccepted = true;
        }
        assessmentUtility.disableBackButton(location.href);
        sessionStorage.setItem('currentFaceCount', 1);
        if (loginInfo && loginInfo.Config) {
            cnf = loginInfo.Config;
            isScreenProctoringEnable = !!cnf.ScreenProctoringIsMandat;
            isVideoProctoringEnabled = !!cnf.VideoProctoring;
            isVideoProctoringIsMandatEnabled = !!cnf.VideoProctoringIsMandat;
            isAutoStart = !!cnf.isAutoStart;
            isScreenSharingEnabled = !!cnf.isScreenSharingEnabled;
            isFaceTrackingEnabled = !!cnf.isFaceTrackingEnabled;
            isMobileViewEnable = !!cnf.mobileView;
            isTabletViewEnable = !!cnf.tabletView;
            vm.testType = loginInfo.TypeOfTestType;
            //vm.isPasswordNeverExpire = !!cnf.isPasswordNeverExpire;
            vm.candidateName = loginInfo.CandidateName;
            if (loginInfo && loginInfo.assessmentConfig && loginInfo.assessmentConfig.showCandidateID) {
                vm.candidateId = loginInfo.CandidateId;
            }
            allowTestTerminationOnDemand = !!loginInfo.Config.allowTestTerminationOnDemand;
            //vm.TestDuration = loginInfo.TestDuration;
            enableChatting = !!loginInfo.Config.enableChatting;
            enableLiveStream = !!loginInfo.Config.liveStream;
            // vm.chatUserId = loginInfo.Config.chatUserId;
            thirdPartyTestType = loginInfo.Config.thirdPartyTestType;
        }
        if (thirdPartyTestType &&
            (thirdPartyTestType.toLowerCase() === "versant" ||
                thirdPartyTestType.toLowerCase() === "cocubes" ||
                thirdPartyTestType.toLowerCase() === "talentlens" ||
                thirdPartyTestType.toLowerCase() === "nseit" ||
                thirdPartyTestType.toLowerCase() === "mettl" ||
                thirdPartyTestType.toLowerCase() === "wheebox" ||
                thirdPartyTestType.toLowerCase() === "testnav" ||
                thirdPartyTestType.toLowerCase() === "thirdpartyproctoring" ||
                thirdPartyTestType.toLowerCase() === "force" ||
                thirdPartyTestType.toLowerCase() === "symbiosis" ||
                thirdPartyTestType.toLowerCase() === "poptest" ||
                thirdPartyTestType.toLowerCase() === "padplayer" ||
                thirdPartyTestType.toLowerCase() === "dotin")) {
            vm.isThirdParty = true;
            vm.thirdParty = thirdPartyTestType.toLowerCase();
            if (thirdPartyTestType.toLowerCase() === "nseit") {
                vm.showHeader = false;
            } else {
                vm.showHeader = true;
            }
            if (thirdPartyTestType.toLowerCase() === "testnav" || thirdPartyTestType.toLowerCase() === "thirdpartyproctoring" || thirdPartyTestType.toLowerCase() === "force") {
                vm.onlyProctoringTest = true;
                vm.isTermsAccepted = true;
            } else {
                vm.onlyProctoringTest = false;
            }
        } else {
            vm.onlyProctoringTest = false;
        }
        if (loginInfo && loginInfo.assessmentConfig) {
            isLoadFullScreen = !!loginInfo.assessmentConfig.isLoadFullScreen;
            vm.isPracticeTestEnabled = loginInfo.assessmentConfig.isPracticeTestLink;
            // if (loginInfo.assessmentConfig.enableZohoChatAtEndTestWaitPage) {
            //     isZohoChatEnable = loginInfo.assessmentConfig.enableZohoChatAtEndTestWaitPage;
            // }
            // sessionStorage.setItem('isZohoChatEnable', isZohoChatEnable);

        }
        if (loginInfo && loginInfo.TestId) {
            webService.execute("getTestBasicInfo", {})
                .then(function(res) {
                        if (!res || !res.data || res.data.status === "KO") {
                            vm.questionPaper = {};
                            return false;
                        }
                        res = res.data;
                        vm.questionPaper = {
                            isGroupWiseTiming: res.isGroupWiseTiming,
                            isOptionalGroup: res.isOptionalGroup,
                            mandatGroupsInfo: getGroupInfo(res.mandatoryGroupWithSections),
                            optionalGroupsInfo: [],
                            testDuration: loginInfo.TestDuration,
                            testInstructions: vm.testInstructions
                        };
                        if (cnf) {
                            vm.questionPaper.isPasswordNeverExpire = !!cnf.isPasswordNeverExpire;
                        }
                        if(!loginInfo.LoginCount){
                            loginInfo.LoginCount = 1;
                        }
                        if(!cnf.isPasswordNeverExpire && cnf.maxLoginAllowed && cnf.maxLoginAllowed !== null && cnf.maxLoginAllowed !== 0){
                            vm.questionPaper.attemptCount = cnf.maxLoginAllowed - loginInfo.LoginCount + 1;
                        }else{
                            vm.questionPaper.attemptCount = 1;
                        }
                        if (loginInfo && loginInfo.eventAssessmentConfig && loginInfo.eventAssessmentConfig.tenantDisplayName) {
                            vm.questionPaper.tenantName = loginInfo.eventAssessmentConfig.tenantDisplayName;
                        } else if (loginInfo && loginInfo.assessmentConfig && loginInfo.assessmentConfig.tenantDisplayName) {
                            vm.questionPaper.tenantName = loginInfo.assessmentConfig.tenantDisplayName;
                        } else if (res.tenantName) {
                            vm.questionPaper.tenantName = res.tenantName;
                        }
                        if (res.optionalGroupWithSections && res.optionalGroupWithSections.length > 0) {
                            _.forEach(res.optionalGroupWithSections, function(optGrp) {
                                var optGrpInfo = {
                                    "noOfgrpsToBeSeleted": optGrp.noOfgrpsToBeSeleted,
                                    "grps": getGroupInfo(optGrp.groupcollection)
                                };
                                vm.questionPaper.optionalGroupsInfo.push(optGrpInfo);
                            });
                        }
                    },
                    function(res) {
                        vm.questionPaper = {};
                    }
                ).finally(function() {
                    sessionStorage.setItem('questionPaperInfo', angular.toJson(vm.questionPaper));
                });
        }
        var paramObj = assessmentUtility.getSateParameters($state.params);
        alias = paramObj && paramObj.alias;
        isOnlinePreview = assessmentUtility.localStorage.getData("_isOnlinePreview");
        isOnlinePreview = !!isOnlinePreview;
        // if (vm.enableChatting) {
        //     window.fcWidget.init({
        //         token: "1daa6ea1-2e3d-40c5-887e-7b915b07170b",
        //         host: "https://wchat.freshchat.com",
        //         externalId: location.host + '_' + alias + '_' + loginInfo.TestId + '_' + (isOnlinePreview ? 'Preview' : loginInfo.CandidateId),
        //         firstName: isOnlinePreview ? 'Preview' : loginInfo.CandidateName,
        //         email: isOnlinePreview ? 'Preview' : loginInfo.CandidateEmail
        //     });
        // }
        vm.TermsAndCondition = $window.sessionStorage.getItem(paramObj.alias + "_termsAndCondition");
        $rootScope.$watch('companyLogoUrl', function() {
            vm.companyLogoUrl = $rootScope.companyLogoUrl ? $rootScope.companyLogoUrl : "assets/images/hirepro_logo.png";
        });

        if (enableLiveStream || allowTestTerminationOnDemand) {
            var data = {
                candidateId: loginInfo.CandidateId,
                testId: loginInfo.TestId,
                eventCallback: {
                    terminate: terminateTestonDemand
                }
            };
            socketService.init(data);
        }

        function getGroupInfo(groupWithSections) {
            var grpInfos = [];
            if (groupWithSections && groupWithSections.length > 0) {
                _.forEach(groupWithSections, function(grp) {
                    var grpInfo = {
                        "name": grp.name,
                        "qCount": grp.questionCount,
                        "grpTime": grp.totalTime
                    };
                    grpInfo.qTypes = _.reduce(
                        _.uniq(_.map(
                            _.filter(grp.sections, { "qpgroupId": grp.groupId }),
                            "questionTypeText")),
                        function(result, value) {
                            result += ', ' + value;
                            return result;
                        });
                    grpInfos.push(grpInfo);
                });
            }
            return grpInfos;
        }

        checkMobileCompatibility();


        function scrollToStartTestPage() {
            assessmentUtility.scrollToElement("start-test-col");
        }

        function initSocket() {
            var socketObj = socket.init();
            vm.isScreenSharing = true;
            socketObj.onmessage(function(data) {
                try {
                    data = angular.fromJson(data);
                } catch (e) {
                    $log.log(e);
                }
                if (angular.isObject(data)) {
                    vm.isScreenSharing = data.ChromeShareRunning || data.RDPRunning || data.TeamViewerRunning;
                    if (vm.isScreenSharing)
                        showScreenSharingMsg();
                    else
                        checkProctoring();
                } else {
                    $log.warn(data);
                }
            });
            socketObj.onerror(function(error) {
                var data = {
                    bodyStr: "<div><p>Please download jar file and run on your system and then press ok button. </p><a download href='/s3_cached/hirepro-content/hirepro/common/091f17de-e4f3-43da-be10-3d044f8c4fe9scan-screen-sharing.jar'>Download jar file</a></div>",
                    headerStr: "Screen Sharing",
                    isAction: true,
                    action: {
                        isOkBtn: true
                    }
                };
                openModalService.openModal('notificationTemplate', data).then(function(res) {
                    initSocket();
                });
            });
        }

        function showScreenSharingMsg() {
            var data = {
                bodyStr: "<div><p>Screen sharing application is running on your system, please close all screen sharing applications and then press OK button.</div>",
                headerStr: "Screen Sharing",
                isAction: true,
                action: {
                    isOkBtn: true
                }
            };
            openModalService.openModal('notificationTemplate', data).then(function(res) {
                if (vm.isScreenSharing) {
                    socket.send('Hello');
                } else {
                    checkProctoring();
                }
            });
        }

        function checkMobileCompatibility() {
            proctoringService.utility.getProctoringConfig().then(
                function(proctoringInfo) {
                    if (!proctoringInfo) {
                        return false;
                    }
                    if (proctoringInfo.facetrackingModel && proctoringInfo.facetrackingModel === 'tensorflow') {
                        sessionStorage.setItem('isfaceLandmarksOn', true);
                    }
                    if (proctoringInfo.tensorFaceTrackingFPS) {
                        sessionStorage.setItem('tensorFaceTrackingFPS', proctoringInfo.tensorFaceTrackingFPS);
                    }
                    if (proctoringInfo.recordVideoInFileIfNoNetwork) {
                        sessionStorage.setItem('recordVideoInFileIfNoNetwork', proctoringInfo.recordVideoInFileIfNoNetwork);
                    }
                    if (proctoringInfo.enableHVScommunicationUsingWSS) {
                        assessmentUtility.sessionStorage.setData("enableHVScommunicationUsingWSS", proctoringInfo.enableHVScommunicationUsingWSS);
                    }
                    //================= Mobile device check for tracker [Start]=======================
                    isDeviceTypeDesktop = deviceDetector.isDesktop();
                    // if (!isDeviceTypeDesktop && isFaceTrackingEnabled &&
                    //     (angular.isUndefined(proctoringInfo.isFaceTrackerEnableForMobile) ||
                    //         proctoringInfo.isFaceTrackerEnableForMobile === null)) { // || !isTabletViewEnable || !isMobileViewEnable
                    //     var data = {
                    //         bodyStr: "<div><p>This device is not compatible for the test you are attending.<br>Please attend this test on a laptop/desktop.</p></div>",
                    //         headerStr: "Device not Compatible",
                    //         isCloseBtnRequired: false
                    //     };
                    //     openModalService.showModal('notificationTemplate', data);
                    // } else {
                    checkScreenSharing(proctoringInfo);
                    checkFaceRecognotion(proctoringInfo);
                    // }
                });
        }

        //================= Mobile device check for tracker [Ends]=======================
        //=============================[isScreenSharingEnabled start]========================================================
        function checkScreenSharing(proctoringInfo) {
            if (isScreenSharingEnabled) {
                initSocket();
                return false;
            }
            vm.isScreenSharing = false;
            checkProctoring(proctoringInfo);
        }

        function checkProctoring(proctoringInfo) {
            if (proctoringInfo.videoAnswer_autoStartAfter_inSeconds) {
                proctoringService.localVar.videoAnswerAutoStartAfter = proctoringInfo.videoAnswer_autoStartAfter_inSeconds;
            }
            isFaceDetectingFrameVisible = proctoringInfo.isFaceDetectingFrameVisible ? proctoringInfo.isFaceDetectingFrameVisible : false;
            assessmentUtility.localStorage.setData("isFaceDetectingFrameVisible", isFaceDetectingFrameVisible);
            if (trackerStatus || isVideoProctoringEnabled || loginInfo.ContainsMediaQuestion) {
                var data = {
                    isAction: true,
                    action: {
                        isOkBtn: true
                    }
                };
                proctorCompatibilityModal = openModalService.showModal('proctorCompatibility', data, $scope);
            }
        }

        function checkFaceRecognotion(proctoringInfo) {
            var loginInfo = assessmentUtility.localStorage.getData('TestLoginInformation');
            if (!loginInfo || !loginInfo.Config || !loginInfo.Config.VideoProctoring || !loginInfo.Config.VideoProctoringIsMandat) {
                return;
            }
            assessmentUtility.sessionStorage.setData("isFaceRecognitionRequired", false);
            faceRecognitionService.setFaceRecogConfig(proctoringInfo)
                .then(function() {
                    if (proctoringInfo.clientFaceRecognitionConfig && _.get(proctoringInfo, 'clientFaceRecognitionConfig.isFaceRecognitionEnabled', undefined)) {
                        faceRecognitionService.loadFaceApiAllModals();
                    }
                })

        }

        vm.showTermsAndCondition = function() {
            var data = {
                bodyStr: vm.TermsAndCondition,
                headerStr: 'Terms and Conditions',
                isAction: false,
                modalSize: 'lg',
                isCloseBtnRequired: true
            };
            termsAndConditionModal = openModalService.showModal('notificationTemplate', data);
        };

        vm.checkLoadTestPrereq = function() {
            if (isLoadFullScreen) {
                if (thirdPartyTestType != 'versant' || sessionStorage.pearsonTestMode != 'popup') {
                    assessmentUtility.loadFullScreen();
                }
            }
            sessionStorage.setItem('testStarted', 'continue');
            var testSecurityKey = loginInfo.Config.testSecurityKey,
                isSecureBrowserMandatory = _.get(loginInfo, 'Config.isSecureBrowserMandatory'),
                delayPushIntervalObj = null;
            delayPushIntervalObj = $timeout(function() {
                sessionStorage.setItem('changeLogPushingIntervalValue', true);
                if (delayPushIntervalObj) {
                    $timeout.cancel(delayPushIntervalObj);
                    delayPushIntervalObj = undefined;
                }
            }, 10 * 1000);
            if (!vm.isTermsAccepted || !loginInfo || (isScreenSharingEnabled && vm.isScreenSharing)) {
                return false;
            }
            //if (!isOnlinePreview && angular.isDefined(testSecurityKey) && !testSecurityKey && testSecurityKey !== 'vB4VBFG9wR8=') {
            if (!isOnlinePreview && angular.isDefined(testSecurityKey) && testSecurityKey !== 'vB4VBFG9wR8=') {
                validateSecurityKey();
            } else if ((deviceDetector.os === 'mac') && isScreenProctoringEnable && !window.canRecordScreen && isSecureBrowserMandatory) {
                return showErrorMsg("please enable screen recording permission to proceed \n \n System Preferences > Security and Privacy > Privacy Tab > Screen Recording > Secure Exam Browser.");
            } else {
                gotoTestPage();
            }
        };

        function startSampleTest() {
            var windowName = 'sampletestpage',
                url = 'https://demoams.hirepro.in/onlineassessment/#/assess/login/eyJhbGlhcyI6IkRPTkUiLCJ1aWQiOiIiLCJwc3dkIjoiIiwiYXV0b2xvZ2luIjoiIiwiaXNPbmxpbmVQcmV2aWV3IjoiZEhKMVpRIiwicHJldmlld1Rva2VuIjoiVkd0dU9tTmpZV0k0TVRKa0xXVmxNelF0TkRObFppMDVabVJsTFRka1ltRTBOVEEyTmpobE5RPT0ifQ==';
            var popUp = window.open(url, windowName, 'resizable=no,menubar=no,status=no,toolbar=no,scrollbars=no,location=0, directories=0,dependant=yes,dialog=yes,modal=yes,unadorned=yes,top=0,left=0,width=' + screen.width + ', height=' + screen.height);
            if (popUp === null || typeof(popUp) === 'undefined') {
                alert('Please disable your pop-up blocker to take the practice test.');
            } else {
                popUp.focus();
            }
        }

        function validateSecurityKey() {
            openModalService.openModal('provideTestSecurityKey', { headerStr: 'Candidate Verification', modalSize: 'md', isOnlinePreview: isOnlinePreview }).then(function(res) {
                if (res.result.result.isAuthorised) {
                    gotoTestPage();
                } else {
                    validateSecurityKey();
                }
            });
        }

        function gotoTestPage() {
            if (trackerStatus) {
                trackerService.registerWatchOnMediastreamAvailability();
            }
            if (vm.thirdParty === 'thirdpartyproctoring') {
                var data = {
                    candidateId: loginInfo.CandidateId,
                    testId: loginInfo.TestId,
                    eventCallback: {
                        submitTest: submitThirdPartyTest
                    }
                };
                socketService.init(data);
            }
            if (allowTestTerminationOnDemand || vm.thirdParty === 'thirdpartyproctoring' || vm.thirdParty === 'nseit') { // || vm.thirdParty === 'mettl'
                terminateTestonDemandByApi();
            }

            blockUI.start();

            var param = {
                stream: null,
                streamName: loginInfo.TestId + '-' + loginInfo.CandidateId
            };

            if (isScreenProctoringEnable || isVideoProctoringEnabled) {
                startScreenRecording()
                    .then(function(res) {
                        if (res) {
                            console.log("screen_recording_start_success ", res);
                            param.stream = res.strm;
                        }
                        return startVideoRecording();
                    })
                    .then(function(res) {
                        if (res) {
                            console.log("video_recording_start_success ", res);
                            param.stream = res.strm;
                            if (loginInfo.Config && loginInfo.Config.liveStream && isTopRankerStreaming) {
                                liveStream.start(param);
                            }
                        }
                        loadTest();
                        // proctorMessage.start(loginInfo.CandidateId, loginInfo.TestId);
                    })
                    .catch(function(res) {
                        $log.log(res);
                        if (res.errorCode === 404) {
                            location.reload(true);
                        } else {
                            showErrorMsg(res.msg);
                            location.reload(true);
                        }
                    })
                    .finally(function() {
                        blockUI.stop();
                    });

            }
            if (!isScreenProctoringEnable && !isVideoProctoringEnabled) {
                trackerStatus &&
                    !loginInfo.ContainsMediaQuestion &&
                    trackerService.getMediaStream();
                blockUI.stop();
                loadTest();
            }
        }

        function startScreenRecording() {
            if (isScreenProctoringEnable) {
                var constraints = {
                    userMediaAudioCapture: false,
                    isTrackingRequire: !isVideoProctoringEnabled
                };
                return screenRecordingService.start(constraints);
            }
            return $q.when();
        }

        function startVideoRecording() {
            if (isVideoProctoringEnabled) {
                return proctoringService.start();
            }
            return $q.when();
        }

        function loadTest() {
            var ALoginId = assessmentUtility.cookies.get('ALoginId'),
                isCodingQuestionCount = 0,
                isRoomScanEnabled, isZohoChatEnabled;
            isReactivated = loginInfo.ReactivatedCount > 0 ? true : false;
            testDuration = loginInfo ? (loginInfo.TestDuration * 60) : 0;
            isZohoChatEnabled = JSON.parse(sessionStorage.getItem('zohoChatStatus'));
            if (isZohoChatEnabled) {
                window.$zoho.salesiq.ready = function() {
                    window.$zoho.salesiq.floatwindow.visible("hide");
                    window.$zoho.salesiq.floatbutton.visible("hide");
                }();
            }
            isRoomScanEnabled = JSON.parse(sessionStorage.getItem('isroomScanEnabled'));
            if (isRoomScanEnabled) {
                roomScan360();
            }
            setLoginStat()
                .then(function() {
                    if (!isReactivated || ALoginId !== loginInfo.testUserId) { //In case of Candidate first login....
                        configureUserSpecificData();
                    }
                    return assessmentService.questionpaper.get();
                })
                .then(function(res) {
                    if (!res) {
                        return $q.reject("Unable to fetch question paper");
                    }
                    qPaper = res;
                    isCodingQuestionCount = _.chain(qPaper)
                        .get('mandatoryQuestionCollection')
                        .filter({ questionType: 16 })
                        .size()
                        .value()
                    if (isCodingQuestionCount && loginInfo.Config.codingAutocomplete) {
                        aceHelper.setCompletionData(loginInfo.Config.showCodingAutocompleteHelp);
                    }
                    qPaper.isVideoControlRequired = loginInfo.Config.VideoProctoringIsMandat && isFaceDetectingFrameVisible;
                    assessmentUtility.localStorage.setData("questionPaper", qPaper);
                    assessmentUtility.sessionStorage.setData("questionPaper", qPaper);
                    if (qPaper.groupInfoCollection) {
                        GroupWiseTimingEnabled = assessmentService.getGroupWiseTimingStatus();
                    }
                })
                .then(function() {
                    if (isReactivated) {
                        var qs = assessmentUtility.localStorage.getData("questionPaper");
                        if (!qs || ALoginId !== loginInfo.testUserId) {
                            assessmentUtility.cookies.set('reactiveLogin_cacheRemoved', true);
                        }
                        return assessmentService.getLastSubmittedResult();
                    }
                })
                .then(function(res) {
                    if (isReactivated) {
                        if (!res) {
                            return $q.reject("Unable to fetch last submitted result!");
                        }
                        /*var lastSessionTestContent = res;
                        if (_.size(lastSessionTestContent) > 0) {*/
                        mergeTestContentWithLastSessionTestContent(res);
                        //}
                    }
                    processAndLoadTestContent(alias, nextQuestionIndex, qPaper);
                    assessmentUtility.scrollToTop();
                })
                .catch(function(msg) {
                    $log.error(msg);
                });
        }

        function setLoginStat() {
            if (isOnlinePreview) {
                return $q.when({ 'stat': true, 'msg': null });
            }
            return webService.execute('initiateTua', {})
                .then(function(res) {
                        if (!res || !res.data || res.data.status === "KO") {
                            return $q.reject({ 'stat': false, 'msg': "Unable to set loggedIn status" });
                        }
                        if (res.data.automationWaitTime) {
                            sessionStorage.setItem('automationUIWaitTime', res.data.automationWaitTime);
                        }
                        if (res.data.jupyterHubUrl) {
                            assessmentUtility.localStorage.setData("jupyterHubUrl", res.data.jupyterHubUrl);
                        } else if (res.data.versantLoginUrl) {
                            sessionStorage.versantLoginUrl = res.data.versantLoginUrl;
                            //sessionStorage.versantLoginUrl = 'https://pearson.hirepro.in/assessment/#/callBackVersant/';
                            /*var input = document.createElement('input');
                            input.type = 'text';
                            input.id = '__focus';
                            input.style.position = 'absolute';
                            input.style.top = '-50px';
                            document.body.appendChild(input);
                            window.__checkVersantFocus = function() {
                                var activeElement = document.activeElement,
                                    forceFocus = true, element;
                                if (activeElement.nodeName.toLowerCase() === 'iframe') {
                                    try {
                                        element =  document.activeElement.contentWindow.document.activeElement.nodeName.toLowerCase();
                                        if (element === 'input' || element === 'textarea') {
                                            forceFocus = false;
                                        }
                                    } catch (e) {}
                                }
                                if (forceFocus) {
                                    var input = document.getElementById('__focus');
                                    if (input) {
                                        input.focus();
                                    }
                                }
                            };*/
                        } else if (res.data.cocubesLoginUrl) {
                            sessionStorage.cocubesLoginUrl = res.data.cocubesLoginUrl;
                        } else if (res.data.nseitLoginUrl) {
                            sessionStorage.nseitLoginUrl = res.data.nseitLoginUrl.replace('nseit.hirepro.in', 'rp.onlineregistrationform.org'); //'https://nseitstg.hirepro.in/ExaminationPortalWeb/loginPage.jsp'; // res.data.nseitLoginUrl;
                        } else if (res.data.mettlLoginUrl) {
                            sessionStorage.mettlLoginUrl = res.data.mettlLoginUrl;
                        } else if (res.data.wheeboxLoginUrl) {
                            sessionStorage.wheeboxLoginUrl = res.data.wheeboxLoginUrl;
                        } else if (res.data.wheeboxproctoringLoginUrl) {
                            sessionStorage.wheeboxLoginUrl = res.data.wheeboxproctoringLoginUrl;
                        } else if (res.data.talentlensLoginUrl) {
                            sessionStorage.talentlensLoginUrl = res.data.talentlensLoginUrl; //.replace('https://talentlensstg.hirepro.in/v1/', 'https://talentlensstg.hirepro.in/run/v1/'); //'https://talentlensstg.hirepro.in/run/v1/scd:sandbox:6aa330f9-53ad-4af5-aaf8-5f3a6e6eed9a/test_1uL4P3HSz2'; // res.data.talentlensLoginUrl;
                        } else if (res.data.thirdpartyProctoringLoginUrl) {
                            sessionStorage.thirdpartyProctoringLoginUrl = res.data.thirdpartyProctoringLoginUrl;
                        }
                        /// ======================== nseit hardcode changes [start] ===================== ///
                        // if (sessionStorage.isNseitTenant) {
                        //     sessionStorage.versantLoginUrl = null;
                        //     sessionStorage.cocubesLoginUrl = null;
                        //     sessionStorage.nseitLoginUrl = 'https://nseitstg.hirepro.in/ExaminationPortalWeb/loginPage.jsp';
                        // }
                        /// ======================== nseit hardcode changes [ends] ===================== ///
                        return $q.resolve({ 'stat': true, 'msg': null });
                    },
                    function(res) {
                        return $q.reject({ 'stat': false, 'msg': "Unable to set loggedIn status" });
                    }
                );
        }

        function processAndLoadTestContent(alias, nextQuestionIndex, qPaper) {
            var optionalGrps = qPaper.optionalGroupCollection;
            //In case of Only optional................
            if (_.size(qPaper.mandatoryQuestionCollection) === 0 && _.size(optionalGrps) > 0) {
                commonQuestionActions.updateQpInfos(qPaper);
                commonQuestionActions.showOptional(true)
                    .then(function() {
                        /*if (trackerStatus && !loginInfo.ContainsMediaQuestion) {
                            trackerService.startTrackers();
                            trackerService.pushTrackerStatStartLog();
                        }*/
                    });
            } else if (qPaper.mandatoryQuestionCollection.length > 0) {
                /*if (!_.find(qPaper.mandatoryQuestionCollection, { questionType: 16 })) {
                    if (isLoadFullScreen) {
                        assessmentUtility.loadFullScreen();
                    }
                } else {
                    sessionStorage.HasCodingQuestion = true;
                }*/
                loadTestPage(alias, nextQuestionIndex, qPaper);
            }
        }

        function mergeTestContentWithLastSessionTestContent(lastSubmittedResult) {
            //lsr-->lastSubmittedResult
            //ls-->localStorage
            var lsr_timeStamp = lastSubmittedResult.config ? (angular.fromJson(lastSubmittedResult.config)).TimeStamp : null,
                localTimeStamp = assessmentUtility.localStorage.getData("lastAnsweredTimeStamp"),
                ls_timeStamp = localTimeStamp ? localTimeStamp : null,
                grpFirstIndex = 0;
            isOptional = qPaper.optionalGroupCollection && qPaper.optionalGroupCollection.length > 0;
            timespent = assessmentUtility.localStorage.getData("lastSessionSpentTime");
            assessmentUtility.localStorage.setData("timeSpent", timespent);
            //First condition will check localStorage is available or not
            //if not service response will be candidate answer
            //Other wise candidate answer will be decided as per timeStamp
            //TODO: check flow if local time stamp is greater then server time stap
            $log.info("lastSubmittedResult", lsr_timeStamp);
            $log.info("localStorage", ls_timeStamp);
            if (!ls_timeStamp || lsr_timeStamp && (Date.parse(lsr_timeStamp) > Date.parse(ls_timeStamp))) {
                $log.info("----merge Content----");
                mergeContents(lastSubmittedResult);
            } else {
                if (GroupWiseTimingEnabled) {
                    nextQuestionIndex = assessmentService.getLastActiveGroup1stQuestionIndex(null);
                    grpFirstIndex = assessmentService.getLastActiveGroup1stQuestionIndex();
                    commonQuestionActions.setGrpFirstIndex(grpFirstIndex);
                    updateIsLastGroup();
                }
            }
            //var lastSubmittedQuestionCollection = assessmentUtility.localStorage.getData("questionPaper").mandatoryQuestionCollection;
            var lastSubmittedTotalTimeSpent = assessmentService.getQuestionWiseTimeSpent();
            assessmentUtility.localStorage.setData("lastSubmittedTotalTimeSpent", lastSubmittedTotalTimeSpent);
        }

        function mergeContents(prevresult) {
            var testUsrGrpInfos = prevresult.testUserGroupInfos,
                isUserGroupChoiceEnable = loginInfo && loginInfo.Config && loginInfo.Config.IsUserGroupChoiceEnable;

            appendSelectedOptionalGrpsToQpaper(testUsrGrpInfos);
            mergeAnswersToQpaper(prevresult);
            updateNextQuestionIndex(prevresult);
            updateTimeAndSetActiveGrp(testUsrGrpInfos);
            if (isUserGroupChoiceEnable) {
                var ls = assessmentUtility.localStorage,
                    currentOptionalGroupIndex = ls.getData("currentOptionalGroupIndex"),
                    selectedGroups = ls.getData("selectedOptionalGroupIdCollection"),
                    ucIsAllMandatoryGrpSelectionStat = getUcIsAllMandatoryGrpSelectionStat(qPaper.optionalGroupCollection[currentOptionalGroupIndex], selectedGroups);
                assessmentUtility.localStorage.setData("ucIsAllMandatoryGrpSelected", ucIsAllMandatoryGrpSelectionStat);
            }
        }

        function appendSelectedOptionalGrpsToQpaper(testUsrGrpInfos) {
            if (assessmentUtility.cookies.get('reactiveLogin_cacheRemoved')) {
                _.forEach(testUsrGrpInfos, function(tstUsrGrpInfo) {
                    if (tstUsrGrpInfo && tstUsrGrpInfo.isSelectedOptionalGroup) {
                        assessmentService.questionpaper.addOptionalGroup(tstUsrGrpInfo.groupId);
                    }
                });
            } else {
                var selectedOptionalGps = _.filter(testUsrGrpInfos, { isSelectedOptionalGroup: true });
                _.forEach(selectedOptionalGps, function(selectedOptionalGp) {
                    var isOptionalGroupQPresent = _.findIndex(qPaper.mandatoryQuestionCollection, { gpId: selectedOptionalGp.groupId });
                    if (isOptionalGroupQPresent === -1) {
                        assessmentService.questionpaper.addOptionalGroup(selectedOptionalGp.groupId);
                    }
                });
            }
            qPaper = assessmentUtility.localStorage.getData("questionPaper");
        }

        function mergeAnswersToQpaper(prevresult) {
            _.forEach(prevresult.answers, function(prevQ, index) {
                var qObj = _.find(qPaper.mandatoryQuestionCollection, { id: prevQ.q });
                if (!qObj) {
                    $log.error("Question[" + prevQ.q + "] from last session is not present in current session qpaper");
                    return false;
                }
                var isMultipleAnswer = qObj.config ? qObj.config.IsMultipleAnswer : false;
                //if (prevQ.a !== null && angular.isDefined(prevQ.a)) {
                if (qObj.questionType !== 16 && qObj.questionType !== 8) {
                    qObj.selectedAns = (isMultipleAnswer && !!prevQ.a) ? prevQ.a.split(',') : prevQ.a;
                } else if (prevQ.a !== null && qObj.config && qObj.config.isUITypeQuestion === true) { //coding question only UI Type
                    qObj.selectedLanguage = null;
                } else if (prevQ.questionType === 16) { //coding question
                    qObj.selectedLanguage = _.find(qObj.codingLangs, { 'languageId': prevQ.l });
                    qObj.selectedLanguage.modifiedCodeSnippet = prevQ.a;
                    qObj.selectedLanguage.LanguageId = prevQ.l;
                    qObj.selectedAns = null;
                } else if (qObj.selectedLanguage) { //unanswer coding question
                    qObj.selectedLanguage = null;
                }
                if (qObj.questionType == 3) {
                    if (qObj && qObj.ansFiles) {
                        qObj.isAnswered = true;
                    } else {
                        qObj.isAnswered = false;
                    }
                } else if (isMultipleAnswer) {
                    if (qObj.optionLimit) {
                        qObj.isAnswered = (qObj.selectedAns && qObj.selectedAns.length === qObj.optionLimit) ? true : false;
                    } else {
                        qObj.isAnswered = (qObj.selectedAns && qObj.selectedAns.length > 0) ? true : false;
                    }
                } else if (qObj.questionType === 8) {
                    if (qObj.jAns) { // new qa type questions
                        angular.forEach(qObj.jAns, function(value, key) {
                            if (qObj.isAnswered) {
                                return false;
                            }
                            qObj.isAnswered = qObj.isAnswered || (_.isEmpty(value) ? false : true);
                            console.log('answer check', index, qObj.isAnswered);
                        });
                    } else {
                        qObj.isAnswered = !!prevQ.a;
                    }
                } else if (qObj.questionType === 2) { // fill in the blank type questions
                    angular.forEach(qObj.jAns, function(value, key) {
                        qObj.isAnswered = qObj.isAnswered || (_.isEmpty(value) ? false : true);
                        console.log('answer check', index, qObj.isAnswered);
                    });
                } else {
                    qObj.isAnswered = !!prevQ.a;
                }
                console.log('answer set', index);
                if (_.size(prevQ.ansFiles) > 0) {
                    qObj.ansFiles = prevQ.ansFiles;
                }
                //}
                qObj.TimeSpent = prevQ.timeSpent;
                //check if the question is answered and mandatory options are selected properly
                if (isMultipleAnswer) {
                    _.map(qObj.AnswerChoiceCollection, function(qObjAnswerChoice) {
                        if (qObj.selectedAns && qObj.selectedAns.indexOf(qObjAnswerChoice.Choice) > -1) {
                            qObjAnswerChoice.isSelected = true;
                        }
                    });
                }
            });
            assessmentUtility.localStorage.setData("questionPaper", qPaper);
        }

        function updateNextQuestionIndex(prevresult) {
            nextQuestionIndex = 0;
            if (GroupWiseTimingEnabled) {
                nextQuestionIndex = assessmentService.getLastActiveGroup1stQuestionIndex(prevresult.testUserGroupInfos);
            }
            commonQuestionActions.setGrpFirstIndex(nextQuestionIndex);
            commonQuestionActions.setIsFirstIndex(true);
            if (loginInfo.Config && loginInfo.Config.isAnsMandt) {
                if (loginInfo.Config.randomizeLevel !== null) {
                    nextQuestionIndex = assessmentService.getNextUnansweredQuestion(nextQuestionIndex);
                } else {
                    nextQuestionIndex = assessmentService.getLastAnsweredQuestion();
                }
            }
        }

        function updateTimeAndSetActiveGrp(testUsrGrpInfos) {
            var grpInfos = qPaper.groupInfoCollection,
                qObj = null,
                activeGroupTotalTime = 0,
                testUserGroupInfo = null,
                activeGroupSpentTime = 0,
                timeSpent_local = 0,
                timeSpent_server = 0;
            if (GroupWiseTimingEnabled && _.size(testUsrGrpInfos) > 0) {
                qObj = qPaper.mandatoryQuestionCollection[nextQuestionIndex];
                assessmentService.questionpaper.activeGroup.setId(qObj.gpId);
                activeGroupTotalTime = (_.find(grpInfos, { 'gpId': qObj.gpId })).gpTime;
                testUserGroupInfo = _.find(testUsrGrpInfos, { 'groupId': qObj.gpId });
                if (testUserGroupInfo) {
                    activeGroupSpentTime = (_.find(testUsrGrpInfos, { 'groupId': qObj.gpId })).timeSpent;
                }
                testDuration = (activeGroupTotalTime * 60) - activeGroupSpentTime;
                updateIsLastGroup();
            }
            timeSpent_local = timespent;
            timeSpent_server = loginInfo.TimeSpent ? loginInfo.TimeSpent : 0;
            if (!timeSpent_local || timeSpent_server > timeSpent_local) {
                if (GroupWiseTimingEnabled) {
                    timeSpent_server = activeGroupSpentTime;
                }
                //timeSpent_server = activeGroupSpentTime;
                assessmentUtility.localStorage.setData("timeSpent", timeSpent_server);
                assessmentUtility.localStorage.setData("timer._time", timeSpent_server);
                timespent = timeSpent_server;
            }
        }

        function updateIsLastGroup() {
            var grpTimeInfoLastIndex = -1,
                qObj = qPaper.mandatoryQuestionCollection[nextQuestionIndex];
            if (!isOptional) {
                grpTimeInfoLastIndex = (_.findLastIndex(qPaper.groupInfoCollection, { 'gpId': qObj.gpId })) + 1;
            }
            if ((isOptional &&
                    !assessmentService.questionpaper.isOptionalGrpPresentToBeSelected()) ||
                grpTimeInfoLastIndex === qPaper.groupInfoCollection.length) {
                isLastGroup = true;
            }
        }

        function loadTestPage(alias, nextQuestionIndex, qPaper) {
            $state.go('assess.loadTest', { 'alias': alias, 'questionIndex': nextQuestionIndex, 'questionPaper': qPaper }, { location: 'replace' }).then(
                function(response) {
                    $window.sessionStorage.setItem("isLastGroup", isLastGroup);
                    commonQuestionActions.setCurrentQuestionIndex(nextQuestionIndex + 1);
                    assessmentUtility.timer.start(assessmentService.handleTestSubmission, GroupWiseTimingEnabled, isLastGroup);
                }
            );
        }

        function getUcIsAllMandatoryGrpSelectionStat(grps, selectedGroups) {
            var ucIsAllMandatoryGrpSelected = false;
            var mandatGrpIds = _.map(_.filter(grps, function(grp) {
                if (grp.isMandat) {
                    return grp;
                }
            }), 'gpId');
            if (_.size(mandatGrpIds) > 0 && _.size(selectedGroups) > 0) {
                ucIsAllMandatoryGrpSelected = false;
                return ucIsAllMandatoryGrpSelected;
            }
            _.forEach(mandatGrpIds, function(gpId) {
                var isAlreadyAdded = getIsAlreadyAddedStat(selectedGroups, gpId);
                if (isAlreadyAdded === -1) {
                    ucIsAllMandatoryGrpSelected = false;
                }
            });
            return ucIsAllMandatoryGrpSelected;
        }

        function getIsAlreadyAddedStat(selectedGroups, gpId) {
            return _.findIndex(selectedGroups, function(selectedGpId) {
                return parseInt(selectedGpId) == gpId;
            });
        }

        function configureUserSpecificData() {
            var ls = assessmentUtility.localStorage;
            var ck = assessmentUtility.cookies;

            ls.setData('questionPaper', null);
            ls.setData('activeGroupId', -1);
            ls.setData("currentOptionalGroupIndex", -1);
            ls.setData('selectedOptionalGroupIdCollection', null);
            ls.setData('isLastQuestionVisited', false);
            ls.setData("ucIsAllMandatoryGrpSelected", false);
            ls.setData("timeSpent", 0);
            ls.setData("lastSessionSpentTime", 0);
            ls.setPromise("stopwatchTimePromise", null);
            ls.setData("isOptionalPreviewTimeOver", false);
            ls.setData("previewTimer", null);
            ls.setData("lastAnsweredTimeStamp", null);

            ck.set('ALoginId', loginInfo.testUserId);
        }

        function showErrorMsg(errorMsg) {
            grwlObj = growl.error(errorMsg, {
                disableCloseButton: true,
                onopen: function() {
                    $timeout(function() {
                        document.getElementsByClassName("growl-item")[0].classList.add("growl-error-custom");
                    }, 2);
                }
            });
            $timeout(function() { grwlObj && grwlObj.destroy(); }, 10000);
        }

        function terminateTestonDemand(msg) {
            msg = msg && msg.body && msg.body.text;
            terminateCandidate(msg, "socket");
        }

        function terminateTestonDemandByApi() {
            if ($state.current.name === 'assess.loadTest' || $state.current.name === 'assess.startTest') {
                checkForTerminateTimeout = $timeout(function() {
                    checkForTerminateOnApi();
                }, 60 * 1000);
            }
        }

        function checkForTerminateOnApi() {
            webService.execute('getTestUserAuthorization', { disableBlockUI: true })
                .then(function(res) {
                        if (!res || !res.data) {
                            return false;
                        }
                        res = res.data;
                        if (res && res.proctoringStatus && res.proctoringStatus === "CANDIDATE_BLOCKED_BY_PROCTOR") {
                            var comment = _.get(res, 'eventHistory[0].comment');
                            terminateCandidate(comment, "api_get-test-user-authorization");
                        } else if (vm.thirdParty === 'thirdpartyproctoring' && res && res.proctoringStatus && res.proctoringStatus === "THIRD_PARTY_TEST_COMPLETED") {
                            submitTestResult(vm.thirdParty, res.redirectUrl);
                        } else {
                            terminateTestonDemandByApi();
                        }
                    },
                    function() {
                        terminateTestonDemandByApi();
                    });
        }

        function termsAndPrivacyPolicy(url, header) {
            var str, hirepro,
                urlString = document.createElement('a');
            urlString.href = url;
            str = urlString.hostname;
            hirepro = str.includes("hirepro");

            if (hirepro) {
                var data = {
                    url: url,
                    header: header
                }
                openModalService.openModal('link', data);
            } else {
                window.open(url);
            }
        }

        function submitThirdPartyTest(msg) {
            msg = msg && msg.body && msg.body.redirectUrl;
            submitTestResult(vm.thirdParty, msg);
        }

        // test submission after thrid party submission
        function submitTestResult(thirdPartyName, redirectUrl) {
            $timeout.cancel(checkForTerminateTimeout);
            if (checkForTerminateTimeout) {
                checkForTerminateTimeout = null;
            }
            var isOnlinePreview = assessmentUtility.localStorage.getData("_isOnlinePreview"),
                isVideoProctoringEnabled = false,
                loginInfo = loginService.getLoginInfo();
            if (loginInfo && loginInfo.Config) {
                isVideoProctoringEnabled = loginInfo.Config.VideoProctoring;
            }
            if (isVideoProctoringEnabled) {
                proctoringService.stop();
            }
            /*else if(_.size(trackerTypes) > 0){
                trackerService.stopMediaStream();
            }*/
            isOnlinePreview = isOnlinePreview ? isOnlinePreview : false;
            if (!isOnlinePreview) {
                assessmentService.submitTest(false, "autoFinalSubmition-" + thirdPartyName)
                    .then(function(response) {
                        if (response) {
                            if (redirectUrl) {
                                location.replace(redirectUrl);
                            } else {
                                afterSubmission.do(response);
                            }
                        }
                    });
            } else {
                if (redirectUrl) {
                    location.replace(redirectUrl);
                } else {
                    $state.go('submitConfirmation', { 'alias': vm.alias }, { location: 'replace' });
                }
            }
        }

        function terminateCandidate(msg, terminate_by) {
            $timeout.cancel(checkForTerminateTimeout);
            if (checkForTerminateTimeout) {
                checkForTerminateTimeout = null;
            }
            trackerService.stopMediaStream();
            var msgStr = "Your test has been terminated by proctor !";
            if (msg && msg.trim() != "") {
                msgStr = msg;
            }
            var messageHtml = "<h2>" + msgStr + "</h2>",
                logoutMsg = 'Test has been terminated by proctor';
            $state.go('msgPage', { stateParams: btoa(messageHtml), isLogout: btoa('true'), msg: btoa(logoutMsg) }, { location: 'replace', reload: true });
        }

        function roomScan360() {
            var timeAtwhichVidShallRecord = [],
                sesdata = JSON.parse(sessionStorage.TestLoginInformation);
            if (sesdata.assessmentConfig && sesdata.assessmentConfig["360Deg"]) {
                var roomScanShowCount = sesdata.assessmentConfig["360Deg"].maxNoOfTimesInaTest,
                    delayInMins = sesdata.assessmentConfig["360Deg"].delayInMins;
            }

            for (var i = 0; i < roomScanShowCount; i++) {
                var r = (delayInMins * i + delayInMins / 2) * 60;
                timeAtwhichVidShallRecord.push(getRandomInt(r - 120, r + 120));
            }

            for (var j = 0; j < timeAtwhichVidShallRecord.length; j++) {
                $timeout(function() {
                    var testStatus = sessionStorage.getItem('testStarted'),
                        leftTimeInSec = localStorage.getItem('_availTime'),
                        timeRemainingInMins = _.get(loginInfo, 'assessmentConfig.360Deg.timeRemainingInMins', 10);
                    if (testStatus == 'continue' && testStatus !== 'end' && $state.current.name === 'assess.loadTest' && leftTimeInSec > timeRemainingInMins * 60) {
                        showRoomScanModal(j + 1);
                    }
                }, timeAtwhichVidShallRecord[j] * 1000);
            }
        }

        function showRoomScanModal(count) {
            var dataToPass = {
                testStatus: 'started',
                attempt: count
            }
            openModalService.openModal('roomScan360Template', dataToPass);
            sessionStorage.setItem('roomScanModalVisible',true);
        }

        function getRandomInt(min, max) {
            var min = Math.ceil(min),
                max = Math.floor(max);
            return Math.floor(Math.random() * (max - min + 1)) + min;
        }

        if (isAutoStart) {
            vm.isTermsAccepted = true;
            vm.checkLoadTestPrereq();
        }

        $scope.$on('$destroy', function() {
            if (termsAndConditionModal)
                termsAndConditionModal.hide();
            if (proctorCompatibilityModal)
                proctorCompatibilityModal.hide();
        });
    }

    function socket($rootScope) {
        //var url = atob('d3M6Ly9sb2NhbGhvc3Q6NTA2NzcvdGVzdA==');
        var socketLclVar;
        return {
            init: function() {
                socketLclVar = null;
                socketLclVar = new WebSocket(atob('d3M6Ly9sb2NhbGhvc3Q6NTA2NzcvdGVzdA=='));
                return this;
            },
            onopen: function(callback) {
                socketLclVar.onopen = function() {
                    $rootScope.$apply(function() {
                        callback.apply(socketLclVar);
                    });
                };
            },
            onmessage: function(callback) {
                socketLclVar.onmessage = function(e) {
                    var data = e.data;
                    $rootScope.$apply(function() {
                        if (callback) {
                            callback.apply(socketLclVar, [data]);
                        }
                    });
                };
            },
            onerror: function(callback) {
                socketLclVar.onerror = function(error) {
                    $rootScope.$apply(function() {
                        if (callback) {
                            callback.apply(socketLclVar, [error]);
                        }
                    });
                };
            },
            send: function(message) {
                socketLclVar.send(message);
            }
        };
    }
})();

(function() {
    "use strict";

    angular
        .module("OnlineAssessmentAngular")
        .component('soundQualityCheck', {
            controller: soundQualityCheckController,
            controllerAs: 'vm',
            templateUrl: 'app/assessment/soundQualityCheck.tpl.html',
            bindings: {
                responseData: '&',
                videoInclude: '<'
            }
        });

    function soundQualityCheckController($sce, $timeout, audioRecorder, loginService, commonService, webService, loggerService) {
        var vm = this,
            candidateId = 0,
            testId = 0,
            recordingDuration = 15, // In seconds...
            fileExtentions = ".gif,.png,.jpg,.jpeg,.doc,.docx," +
            ".rtf,.pdf,.txt,.xls,.xlsx,.zip,.rar,.7z,.gz,.ppt,.pps,.pptx,.mp4,.mvw,.3gp,.webm",
            fileSizeLimit = 102400;

        /*................variables...................*/
        vm.isAnalyzing = false;
        vm.textToRead = '';

        /*................Methods...................*/
        vm.startRecording = startRecording;
        vm.retry = retry;

        vm.$onInit = function() {
            vm.videoInclude = vm.videoInclude;
            reset();
        }



        /*.................Public Methods...........*/

        function startRecording() {
            if (vm.recordingStat === 0) { //if recording is going on...
                return false;
            }
            vm.recordingStat = 0;
            if (vm.videoInclude) {
                var opt = { video: true };
            } else {
                var opt = null;
            }
            audioRecorder.start(opt)
                .then(function() {
                    showNumbers();
                    autoStop();
                });
        }

        function retry() {
            reset();
            startRecording();
            vm.responseData({ proceed: false, type: 'soundQuality' });
        }

        /*.................Private Methods...........*/
        function showNumbers() {
            if (vm.recordingStat === 0) {
                switch (vm.textToRead) {
                    case '':
                    case '1 2 3 4':
                        vm.textToRead = '1';
                        break;
                    case '1':
                        vm.textToRead = '1 2';
                        break;
                    case '1 2':
                        vm.textToRead = '1 2 3';
                        break;
                    case '1 2 3':
                        vm.textToRead = '1 2 3 4';
                        break;
                }
                $timeout(function() {
                    showNumbers();
                }, 1250);
            } else {
                vm.textToRead = '';
            }
        }

        function reset() {
            vm.recordingStat = -1; // {-1 : not started | 0 : started | 1 : stopped}
            vm.isAnalyzed = false;
            vm.isCompatibleForTest = null;
            vm.isError = null;
            vm.isAnalyzing = false;
        }

        function autoStop() {
            $timeout(function() {
                stopRecording();
            }, recordingDuration * 1000);
        }

        function stopRecording() {
            vm.recordingStat = 1;
            audioRecorder.stop()
                .then(function(res) {
                    if (!res || !res.blob) {
                        vm.isError = true;
                        vm.isAnalyzed = true;
                        return false;
                    }
                    vm.isAnalyzing = true;
                    if (vm.videoInclude) {
                        uploadToS3(res.blobVideo, vm.videoInclude);
                    }
                    return uploadToS3(res.blob);
                })
                .then(function(fileUrl) {
                    if (!fileUrl) {
                        vm.isError = true;
                        vm.isAnalyzed = true;
                        return false;
                    }
                    soundQualityCheck(fileUrl);
                })
                .catch(function(res) {
                    vm.isError = true;
                    vm.isAnalyzed = true;
                });
        }

        function soundQualityCheck(fileUrl) {

            webService.execute("checkAudioDistortion", { "FileUrl": fileUrl })
                .then(function(res) {
                    if (!res || !res.data || res.data.status === "KO") {
                        vm.isError = true;
                        return false;
                    }
                    res = res.data;
                    if (res.Result && res.Result.trim() === "Clear") {
                        vm.isCompatibleForTest = true;
                        $timeout(function() {
                            document.getElementById("audioCheckPlayback").src = $sce.trustAsResourceUrl(fileUrl);
                        }, 500);
                        vm.responseData({ proceed: true, type: 'soundQuality' });
                    } else { //if (res.Result && res.Result.trim() === "Distorted")
                        vm.isCompatibleForTest = false;
                        $timeout(function() {
                            document.getElementById("audioCheckPlayback").src = $sce.trustAsResourceUrl(fileUrl);
                        }, 500);
                        vm.responseData({ proceed: false, type: 'soundQuality' });
                    }
                    var request = {
                        "canLoginActivityLog": {
                            "micSpeechCheckLog": {
                                "url": fileUrl,
                                "result": res
                            }
                        }
                    };
                    loggerService.push(request);
                })
                .finally(function() {
                    vm.isAnalyzed = true;
                    vm.isAnalyzing = false;
                });
        }

        function uploadToS3(recordedBlob, videoStatus) {
            var loginInfo = loginService.getLoginInfo(),
                params = null,
                formData = null;

            if (loginInfo) {
                candidateId = loginInfo.CandidateId;
                testId = loginInfo.TestId;
            }
            formData = blobToFormData(recordedBlob);
            if (videoStatus) {
                formData = blobToFormData(recordedBlob, videoStatus);
            }
            params = {
                "data": formData,
                "fileExtentions": fileExtentions,
                "fileSizeLimit": fileSizeLimit,
                "meta": null,
                "testId": testId,
                "candidateId": candidateId,
                "targetBucket": "recording-bucket"
            };
            return commonService.uploadFile(params)
                .then(function(res) {
                    if (!res || !res.data || !res.data.s3_url) {
                        return null;
                    }
                    if (videoStatus) {
                        sendVideoLoggerService(res.data.s3_url);
                    }
                    return res.data.s3_url;
                });
        }

        function blobToFormData(recordedBlob, videoFile) {
            var fd = new FormData();
            if (videoFile) {
                fd.append("file", recordedBlob, 'audioSample_' + candidateId + '_' + testId + '.webm');
            } else {
                fd.append("file", recordedBlob, 'audioSample_' + candidateId + '_' + testId + '.ogg');
            }
            return fd;
        }

        function sendVideoLoggerService(fileUrl) {
            var request = {
                "canLoginActivityLog": {
                    "micSpeechCheckLog": {
                        "videoUrl": fileUrl
                    }
                }
            };
            loggerService.push(request);
        }
    }
})();

(function() {
    "use strict";

    angular
        .module("OnlineAssessmentAngular")
        .component('secondaryCameraPreview', {
            controller: secondaryCameraPreviewController,
            controllerAs: 'vm',
            templateUrl: 'app/assessment/secondaryCameraPreview.tpl.html',
            bindings: {
                responseData: '&'
            }
        });

    function secondaryCameraPreviewController(streamListner) {
        var vm = this;

        vm.$onInit = function() {
            vm.responseData = vm.responseData;
            init();
        }

        function init() {
            var vidElem = document.getElementById("secondCamPreviewVidElem");
            if (vidElem) {
                streamListner.getRemoteStream()
                    .then(null, null, function(res) {
                        vidElem.srcObject = res.strm;
                    });
            }
            vm.responseData({ proceed: true, type: 'secondaryCameraPreview' });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('OnlineAssessmentAngular')
        .controller('PasscodeVerificationCtrl', PasscodeVerificationCtrl);

    /* @ngInject */
    function PasscodeVerificationCtrl($stateParams, webService, $injector, $q, growl, $timeout) {
        var vm = this,
            vcRecaptchaService = $injector.get('vcRecaptchaService'),
            grwlObj = null;
        vm.tenantDetails = {};
        vm.data = {};

        vm.setWidgetId = setWidgetId;
        vm.onCaptchaExpire = onCaptchaExpire;
        vm.verifyPasscode = verifyPasscode;

        activate();

        ////////////////

        function activate() {
            getTenantDetails();
        }

        function getTenantDetails() {
            if (!$stateParams.alias) {
                return;
            }
            return webService.execute('getTenantDetails', { "TenantAlias": $stateParams.alias })
                .then(function(res) {
                    vm.tenantDetails.googleRecaptchaKey = _.get(res, 'data.TenantInfo.ui_recapcha_key');
                })
                .catch(function(err) {
                    console.log(err);
                });
        }


        function setWidgetId(widgetId) {
            vm.widgetId = widgetId;
        }

        function onCaptchaExpire(a) {
            vcRecaptchaService.reload(vm.widgetId);
            vm.data.googleRecaptchaResponse = null;
        }

        function verifyPasscode() {
            if (!isValid()) {
                return;
            }
            return webService.execute('passcodeVerification', { 'pairingCode': vm.data.passcode })
                .then(function(res) {
                    if (_.get(res, 'data.statusCode') !== 200) {
                        return $q.reject('error on verifing the code');
                    }
                    vm.data.isPairingCodeExpired = _.get(res, 'data.data.isPairingCodeExpired');
                    if (_.get(res, 'data.data.url')) {
                        window.open(_.get(res, 'data.data.url'), "_self")
                    }
                }).catch(function(error) {
                    console.log(error);
                    if (vm.tenantDetails.googleRecaptchaKey) {
                        onCaptchaExpire();
                    }
                });
        }

        function isValid() {
            if (!vm.data.passcode) {
                showErrorMsg('Please provide Passcode');
                return false;
            }
            if (!vm.data.googleRecaptchaResponse) {
                showErrorMsg('Please fill captcha');
                return false;
            }
            return true;
        }

        function showErrorMsg(errorMsg) {
            grwlObj = growl.error(errorMsg, {
                disableCloseButton: true,
                onopen: function() {
                    $timeout(function() {
                        document.getElementsByClassName("growl-item")[0].classList.add("growl-error-custom");
                    }, 2);
                }
            });
            $timeout(function() { grwlObj && grwlObj.destroy(); }, 10000);
        }
    }
})();

(function() {
    "use strict";

    angular
        .module("OnlineAssessmentAngular")
        .component('secondaryCamera', {
            controller: secondaryCameraController,
            controllerAs: 'vm',
            templateUrl: 'app/assessment/secondaryCamera.tpl.html',
            bindings: {
                responseData: '&'
            }
        });

    function secondaryCameraController($window, $timeout, $interval, webService, streamListner, openModalService) {
        var vm = this,
            expiryTimerInterval = null,
            modalOpeningTimeout = null,
            modalOpeningDelay = 30; //seconds

        vm.$onInit = function() {
            vm.qrCodeImage = null;
            vm.passcode = "";
            vm.passcodeExpiryMsg = "";
            vm.SecondCameraAppUrl = location.origin +
                location.pathname +
                "#/verification/" +
                sessionStorage.getItem("oa_tenantAlias");
            vm.responseData = vm.responseData;
            vm.passcodeExpiryTime = null;
            vm.isPassCodeExpire = false;

            vm.getPairingCode = refetchSecondaryCameraPairingCode;

            init();
        }

        function init() {
            getSecondaryCameraQrCodeImage()
                .then(function(res) {
                    return getSecondaryCameraPairingCode();
                })
                .then(function() {
                    if (vm.passcodeExpiryTime) {
                        startPasscodeExpiryTimer();
                    }
                    return streamListner.join({
                        "type": "SecondaryCamera",
                        "onLeavingCallback": reopenSecondaryCameraReviewModal
                    });
                })
                .then(function(res) {
                    console.log("secondaryCameraController_join", res);
                    return streamListner.isOtherParticipantJoined();
                })
                .then(function() {
                    vm.responseData({ proceed: true, type: 'secondaryCamera' });
                })
                .catch(function(err) {
                    console.log(err);
                });
        }

        function getSecondaryCameraQrCodeImage() {
            return webService.execute("getSecondaryCameraQrCodeImage", {})
                .then(function(res) {
                    if (!res || !res.data || res.data.status === "KO" || !res.data.secondaryCameraQRCodeUrl) {
                        $q.reject(res);
                    }
                    vm.qrCodeImage = res.data.secondaryCameraQRCodeUrl;
                });
        }

        function getSecondaryCameraPairingCode() {
            return webService.execute("getSecondaryCameraPairingCode", {})
                .then(function(res) {
                    if (!res || !res.data || res.data.status === "KO" || !res.data.pairingCode) {
                        $q.reject(res);
                    }
                    vm.passcode = res.data.pairingCode;
                    if (res.data.pairingCodeTtl) {
                        vm.passcodeExpiryTime = res.data.pairingCodeTtl;
                    }
                });
        }

        function refetchSecondaryCameraPairingCode() {
            getSecondaryCameraPairingCode()
                .then(function() {
                    startPasscodeExpiryTimer();
                });
        }

        function startPasscodeExpiryTimer() {
            expiryTimerInterval = $interval(function() {
                if (vm.passcodeExpiryTime === 1) {
                    vm.isPassCodeExpire = true;
                    $interval.cancel(expiryTimerInterval);
                } else {
                    vm.isPassCodeExpire = false;
                    vm.passcodeExpiryTime--;
                }
            }, 1000);
        }

        function reopenSecondaryCameraReviewModal() {
            var isTestStarted = $window.sessionStorage.getItem("isTimerStarted"),
                proctorCompatibilityModalIsOpened = $window.sessionStorage.getItem("proctorCompatibility_modal_isOpened");
            if (isTestStarted) {
                isTestStarted = JSON.parse(isTestStarted);
            }
            if (proctorCompatibilityModalIsOpened) {
                proctorCompatibilityModalIsOpened = JSON.parse(proctorCompatibilityModalIsOpened);
            }
            if (!isTestStarted) {
                return false;
            }

            modalOpeningTimeout = $timeout(function() {
                openReviewModal(proctorCompatibilityModalIsOpened);
            }, modalOpeningDelay * 1000);

            streamListner.isOtherParticipantJoined()
                .then(function() {
                    console.log("sap2ndCamera_participant joined before 3 sec.")
                    modalOpeningTimeout && $timeout.cancel(modalOpeningTimeout);
                })
        }

        function openReviewModal(isOpened) {
            var data = {
                isAction: true,
                action: {
                    isOkBtn: true
                },
                opts: {
                    openedby: "secondaryCameraRecheck"
                }
            };
            if (isOpened) {
                openModalService.closeModal("proctorCompatibility")
                    .then(function() {
                        openModalService.showModal('proctorCompatibility', data);
                    });
            } else {
                openModalService.showModal('proctorCompatibility', data);
            }
        }
    }
})();

(function() {
    "use strict";

    angular
        .module("OnlineAssessmentAngular")
        .component('roomScan', {
            controller: roomScanController,
            controllerAs: 'vm',
            templateUrl: 'app/assessment/roomScan.tpl.html',
            bindings: {
                responseData: '&',
                intestData: '='
            }
        });

    function roomScanController($interval, $timeout, $window, $rootScope, $scope, mediaRecorder, trackerService, webService, loggerService, openModalService, hvsService) {

        var vm = this,
            recordingInterval = null,
            startTimeRecord = null;

        vm.$onInit = function() {
            vm.toStartRecord = true;
            vm.toStopRecord = false;
            vm.toRecordAgain = false;
            vm.recordedStream = false;
            vm.recordingInterval = 60;
            vm.defaultView = true;
            vm.showendCountdown = false;
            vm.startRecording = startRecording;
            vm.stopRecording = stopRecording;
            vm.reRecord = reRecord;
            vm.responseData = vm.responseData;
            vm.intestData = vm.intestData;
            activate();
        }


        function activate() {
            if (vm.intestData && vm.intestData.testStatus === 'started') {
                vm.defaultView = false; //off all default button
                vm.startCountShow = true;
                startCountDown('start');
            } else {
                trackerService.getMediaStream().then(function(res) {
                    attachStreamToVideoElem(res);
                });
            }
        }

        function startCountDown(type) {
            var i = 3,
                countdownInterval, waitTimer;
            if (type !== 'end') {
                attachStreamToVideoElem($rootScope.vidStrm);
            }
            countdownInterval = $interval(function() {
                if (i > 0) {
                    vm.countDownTimer = i;
                }
                i--;
            }, 1000);
            waitTimer = $timeout(function() {
                $interval.cancel(countdownInterval);
                vm.countDownShow = false;
                if (type == 'start') {
                    vm.startCountShow = false;
                    startRecordingMidTest();
                } else if (type == 'end') {
                    vm.showendCountdown = true;
                    stopRecordingMidTest();
                }
                $scope.$apply();
            }, 3500);
        }

        function startRecordingMidTest() {
            vm.toStopRecord = true;
            sendMidTestStreamLog('start');
            startRecording();   
        }

        function stopRecordingMidTest() {
            vm.toStopRecord = false;
            sendMidTestStreamLog('stop');
            vm.responseData({ action: true, type: 'midTestroomScan' });

        }

        function sendMidTestStreamLog(type) {
            var log = {
                'canLoginActivityLog': {
                    'scanInfo360': {
                        'type': 'afterStartTest',
                        'streamId': hvsService.getStreamId(),
                        'debugTimeStamp': new Date()
                    }
                }
            };
            if (type == 'start') {
                log.canLoginActivityLog.scanInfo360.startTime = new Date();
                startTimeRecord = log.canLoginActivityLog.scanInfo360.startTime;
            } else if (type == 'stop') {
                log.canLoginActivityLog.scanInfo360.stopTime = new Date();
                log.canLoginActivityLog.scanInfo360.startTime = startTimeRecord;
            }
            loggerService.push(log);
        }

        function startRecording() {
            vm.toStartRecord = false;
            vm.toStopRecord = true;
            if (vm.defaultView) {
                trackerService.stopMediaStream();
            }

            var quickData = JSON.parse(sessionStorage.TestLoginInformation),
                opt = {
                    'vqId': 'roomScanVid',
                    'candidateId': quickData.CandidateId,
                    'testId': quickData.TestId
                };
            mediaRecorder.start(opt).then(function(res) {
                attachStreamToVideoElem(res.strm);
                recordingInterval = $interval(function() {
                    vm.recordingInterval -= 1;
                    if (vm.recordingInterval < 0) {
                        if (recordingInterval) {
                            $interval.cancel(recordingInterval);
                            recordingInterval = null;
                        }
                        stopRecording();
                        if (vm.intestData && vm.intestData.testStatus === 'started') {
                            startCountDown('end');
                            vm.startCountShow = false;
                        }

                    }
                }, 1000);
            });
        }

        function stopRecording() {
            if (recordingInterval) {
                $interval.cancel(recordingInterval);
                recordingInterval = null;
            }
            vm.toStopRecord = false;
            if (vm.defaultView) {
                vm.toRecordAgain = true;
            }
            mediaRecorder.stop()
                .then(function(res) {
                    if (vm.defaultView) {
                        attachStreamToVideoElem(res.url, 'blob');
                    }
                    return res.videoUplodedDeferred;
                })
                .then(function(res) {
                    console.log(res);
                }, function(res) {
                    console.log(res);
                }, function(res) {
                    var req = {
                        'canLoginActivityLog': {
                            'scanInfo360': {
                                'type': 'beforeStartTest',
                                'roomScanUrl': res.s3Url,
                                'debugTimeStamp': new Date()
                            }
                        }
                    };
                    if (!vm.defaultView) {
                        req.canLoginActivityLog.scanInfo360.type = "duringTest";
                    }
                    loggerService.push(req);
                    vm.responseData({ proceed: true, type: 'roomScan' });
                });
        }

        function reRecord() {
            vm.toRecordAgain = false;
            vm.recordedStream = false;
            vm.recordingInterval = 60;
            vm.responseData({ proceed: false, type: 'roomScan' });
            startRecording();
        }

        function attachStreamToVideoElem(strm, type) {
            var video = document.getElementById('roomScanVid');
            if (type === 'blob') {
                vm.recordedStream = true;
                video.src = strm;
            } else {
                video.srcObject = strm;
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('OnlineAssessmentAngular')
        .component('questionTemplate', {
            bindings: {
                'currentqindex': '=currentQIndex',
                'questionpaper': '=questionPaper',
                'currentquestion': '=currentQuestion',
                'srcId': '=srcId'
            },
            controller: questionTemplateController,
            controllerAs: 'vm',
            template: '<ng-include src="vm.questionTemplateUrl"/>',
            bindToController: true
        });

    function questionTemplateController($q, $http, fileIOHelper, assessmentUtility, $window, assessmentService, $interval, $state, loginService, $scope, $rootScope, blockUI, $log, $timeout, $sce, proctoringService, openModalService, commonService, webService, growl, CaptureCodeActivitySvc, afterSubmission, trackerService, aceHelper, videoAnsRecorder, loggerService, commonQuestionActions, deviceDetector) {
        var vm = this,
            editorName = null,
            loginInfo = loginService.getLoginInfo(),
            tenantId = null,
            candidateId = null,
            testId = null,
            ls = assessmentUtility.localStorage,
            ss = assessmentUtility.sessionStorage,
            startTime = new Date(),
            startTimeOnTicker = assessmentUtility.timer.time(),
            videoStrmWatch = null,
            isMobileDevice = !deviceDetector.isDesktop(),
            isVideoProctoringEnabled = false,
            liveStream = false,
            isTopRankerStreaming = false,
            readonlyMarkerId = 0,
            editableMarkerId = 0,
            paramObj = assessmentUtility.getSateParameters($state.params),
            prevSelectedLang = null,
            codingLanguageMapper = assessmentService.codingLanguageMapper,
            isThirdPartyEndProctoringInitiated = false,
            isAddEventListenerAdded = assessmentUtility.sessionStorage.getData('isAddEventListenerAdded') || false;
        /*.........................Video Question.......................*/
        var autoStartRecordingInterval = null;
        var autoStartAfter = proctoringService.localVar.videoAnswerAutoStartAfter; //In seconds...
        vm.count = autoStartAfter;
        /*.........................end of Video Question prerequisite.......................*/

        vm.today = new Date();
        vm.isRecordingStarted = false;
        vm.isRecordingStopped = false;
        vm.showHistory = false;
        vm.isExpanded = false;
        vm.isExecuting = false;
        vm.accordianOpen = true;
        vm.isShowQMarksEnabled = true;
        vm.ApplicationViewType = sessionStorage.getItem('ApplicationViewType');
        vm.userDefinedAceSettings = {
            tabSize: 4,
            theme: 'ace/theme/merbivore', //white---'ace/theme/textmate',
            keybinding: 'ace',
            fontsize: 14
        };
        vm.errorUploadedAttachment = '';
        if (loginInfo && loginInfo.Config) {
            var cnf = loginInfo.Config;
            tenantId = loginService.getTenantId();
            candidateId = loginInfo.CandidateId;
            testId = loginInfo.TestId;
            vm.isShowQMarksEnabled = cnf.isShowQMarksEnabled;
            vm.codingCopyPasteEnabled = cnf.codingCopyPaste;
            vm.codingAutocompleteEnabled = cnf.codingAutocomplete;
            vm.isUploadCodeAsFileEnable = cnf.isUploadCodeAsFileEnable;
            vm.showHelpFileForCodingQuestion = cnf.showHelpFileForCodingQuestion;
            isVideoProctoringEnabled = !!cnf.VideoProctoring;
            liveStream = !!cnf.liveStream;
        }
        //loginInfo.IsTraversalAllowed = false;
        //read from config traversal property
        vm.enableNextbutton = angular.copy(loginInfo.IsTraversalAllowed);
        //$scope.currState = $state;
        //$scope.$watch('currState.params', function(currentStateParams) {
        vm.alias = paramObj && paramObj.alias;
        //});
        vm.winHeight = assessmentUtility.resize($window);
        vm.templateLayout = "vertical";
        vm.panelHeight = (vm.winHeight * 92.90) / 100;
        vm.qPanelBodyHeight = (vm.winHeight * 74) / 100;
        vm.ansPanelBodyHeight = (vm.winHeight * 75) / 100;
        vm.qaTextareaHeight = (vm.winHeight * 66) / 100;
        vm.aceEditorHeight = (vm.panelHeight - 55);
        vm.videoElementHeight = (vm.panelHeight - 80);
        vm.isSecureBrowserMandatoryTest = false;

        /*Methods*/
        vm.toscroll = toscroll;
        vm.parseInt = parseInt;
        vm.onaceEditorSettingsChange = onaceEditorSettingsChange;
        vm.uploadCaptureCallback = uploadCaptureCallback;
        vm.endOnlyProctoringTest = endOnlyProctoringTest;
        vm.onFillBlank = onFillBlank;
        vm.onBlurFillBlank = onBlurFillBlank;
        vm.isPlainTextEnabled = false;
        vm.richTextforSubjectiveQuestionsAllowed = false;

        vm.$onInit = function() {
            vm.qPaper = ls.getData("questionPaper");
            vm.testProctoringSrcId = ls.getData("testProctoringSrcId");
            if (vm.qPaper && vm.qPaper.mandatoryQuestionCollection && vm.qPaper.mandatoryQuestionCollection.length > 0) {
                vm.questionpaper = vm.qPaper;
                if (vm.questionpaper.mandatoryQuestionCollection[0].thirdPartyTestUrl) {
                    vm.questionpaper.mandatoryQuestionCollection[0].thirdPartyTestUrl = $sce.trustAsResourceUrl(vm.questionpaper.mandatoryQuestionCollection[0].thirdPartyTestUrl);
                }
                vm.questionpaper.trustedProctoringSrcId = $sce.trustAsResourceUrl(vm.testProctoringSrcId);
            }
            getQTemplateUrl();
        };

        CKEDITOR.on('instanceReady', function() {
            editorName = _.values(CKEDITOR.instances)[0].name;
            CKEDITOR.instances[editorName].on('contentDom', function() {
                CKEDITOR.instances[editorName].document.on('contextmenu', function(event) {
                    event.data.preventDefault();
                });
            });
            CKEDITOR.instances[editorName].on('paste', function(evt) {
                evt.cancel();
            });
        });
        /*.........................Load Question with respective template.........................*/
        function getQTemplateUrl() {
            return getQuestionByIndex().then(function(res) {
                //console.log(res);
                vm.question = res || {};
                vm.question.srcId = $state.params.srcId;
                vm.trustedQString = $sce.trustAsHtml(vm.question.htmlString);
                var qType = vm.question.typeOfQuestionText ? (vm.question.typeOfQuestionText).toLowerCase() : "";
                qType = (qType === "boolean") ? "mcq" : qType;
                qType = (qType === "draw") ? "drawio" : qType;
                qType = (qType === "mcqwithweightage") ? "mcq" : qType;
                if (isVideoProctoringEnabled) {

                    if (qType === "video") {
                        proctoringService.stop();
                    } else if (!proctoringService.isVideoProctoringStarted) {
                        proctoringService.start({
                                procType: "videoProctoring",
                                //hasOptionalGroup: !!qPaper.optionalGroupCollection.length,
                                durationInMins: loginInfo.TestDuration
                            })
                            .then(function(res) {
                                var param = {
                                    stream: res.strm,
                                    streamName: loginInfo.TestId + '-' + loginInfo.CandidateId
                                };
                                if (liveStream && isTopRankerStreaming) {
                                    liveStream.start(param);
                                }
                            }, function(res) {
                                $log.log(res);
                                if (res.errorCode === 404) {
                                    location.reload();
                                } else {
                                    showErrorMsg(res.msg);
                                }
                            });
                    }
                }
                if (qType === "video" && isMobileDevice) {
                    qType = 'mvideo';
                }
                if (qType === 'coding' && vm.question.config !== null) {
                    //var UITemplate = vm.question.config;
                    if (vm.question.codingQuestionSubTypeText === "ClientSideProgramming") {
                        qType = 'html_css_js';
                    }
                }
                //thrid party qType set
                var testLoginInfo = ls.getData('TestLoginInformation'),
                    versantCallbackHandle;
                if (testLoginInfo && testLoginInfo.assessmentConfig && testLoginInfo.assessmentConfig.richTextforSubjectiveQuestionsAllowed) {
                    vm.richTextforSubjectiveQuestionsAllowed = true;
                }
                if (!vm.richTextforSubjectiveQuestionsAllowed) {
                    vm.isPlainTextEnabled = true;
                }
                if (testLoginInfo && testLoginInfo.Config && testLoginInfo.Config.isSecureBrowserMandatory) {
                    vm.isSecureBrowserMandatoryTest = testLoginInfo.Config.isSecureBrowserMandatory ? true : false;
                }
                if (testLoginInfo && testLoginInfo.Config && testLoginInfo.Config.thirdPartyTestType) {
                    if (testLoginInfo.Config.thirdPartyTestType === "DotIn") {
                        qType = 'dotIn';
                    } else if (testLoginInfo.Config.thirdPartyTestType === "jupyterNotebook") {
                        qType = 'jupyterUi';
                        getJupyterNotebook();
                    } else if (testLoginInfo.Config.thirdPartyTestType.toLowerCase() === "versant") {
                        qType = 'thirdPartyTest';
                        vm.question.thirdPartyTestUrl = $sce.trustAsResourceUrl(sessionStorage.versantLoginUrl);
                        $interval(function() {
                            // window.__checkVersantFocus()
                            var iframe = document.getElementById('thirdPartyIframe');
                            if (iframe) {
                                try {
                                    if (iframe.contentWindow.document.getElementById('endoftest_submit') && !versantCallbackHandle) {
                                        versantCallbackHandle = $timeout(function() {
                                            if (iframe.contentWindow.document.getElementById('endoftest_submit')) {
                                                //submitTestResult('versantCallback');
                                                iframe.src = location.origin + location.pathname + '#/callBackVersant/';
                                            }
                                        }, 30 * 1000);
                                    }
                                } catch (e) {}


                                // New experiment. For allowing pearson in a popup
                                if (iframe.contentWindow.wdtWindow && iframe.contentWindow.wdtWindow.location.href) {
                                    window.__pearsonChildWindowOpened = true;
                                    if (iframe.contentWindow.wdtWindow.document) {
                                        if (!iframe.contentWindow.wdtWindow.document.getElementById('__dynamicScript')) {
                                            var script = document.createElement('script');
                                            script.type = 'text/javascript';
                                            script.id = "__dynamicScript";
                                            script.innerHTML = "window.addEventListener('message', function(event) { try { var nouserinfrontofcamera = document.getElementById('__nouserinfrontofcamera'); if (!nouserinfrontofcamera) { $('body').append('<div id=\"__nouserinfrontofcamera\" class=\"ui-widget middle-top-float-custom\"> <div class=\"ui-state-error ui-corner-all\"> <p id=\"__nouserinfrontofcameraMessage\"></p> </div> </div>'); $('body').append('<link rel=\"stylesheet\" href=\"//code.jquery.com/ui/1.12.1/themes/base/jquery-ui.css\">'); $('body').append('<style>.middle-top-float-custom { position: absolute; top: 5px; margin-left: auto; margin-right: auto; left: calc(50vw - 15%); font-size: 16px; font-weight: bold; opacity: 0.9; z-index: 999;} .middle-top-float-custom p { padding: 10px; }</style> '); window.__jqueryUIcssadded = true; } if (event.data) { switch (event.data.type) { case 'nouserinfrontofcamera': $('#__nouserinfrontofcamera').show(); $('#__nouserinfrontofcameraMessage').html('Please be available in front of the camera.'); break; case 'userinfrontofcamera': $('#__nouserinfrontofcamera').hide(); break; case 'multipleuserinfrontofcamera': $('#__nouserinfrontofcamera').show(); $('#__nouserinfrontofcameraMessage').html('Multiple users detected in front of the camera.'); break; } } } catch (ex) {} }, false); window.setInterval(function() { if (!window.opener) { window.onbeforeunload = null; window.close(); } }, 2 * 1000);";
                                            if (iframe.contentWindow.wdtWindow.document.body) {
                                                iframe.contentWindow.wdtWindow.document.body.append(script);
                                            }
                                        }
                                        var finishButton = iframe.contentWindow.wdtWindow.document.getElementById('endoftest_submit');
                                        if (finishButton) {
                                            finishButton.click();
                                        }
                                    }
                                } else if (iframe.contentWindow.wdtWindow && !iframe.contentWindow.wdtWindow.location.href && window.__pearsonChildWindowOpened) {
                                    $timeout(function() {
                                        try {
                                            var iframe = document.getElementById('thirdPartyIframe');
                                            if (iframe && iframe.contentWindow.location.href.indexOf('callBackVersant') === -1) {
                                                var message = "<h2>" +
                                                    "<i class='fa fa-exclamation-triangle text-warning' aria-hidden='true'></i>You are seeing this message because test window was closed." +
                                                    "</h2>" +
                                                    "</br>" +
                                                    "If needed, start your test again in new browser tab.";
                                                var logoutMsg = 'Versant iframe not found';
                                                $state.go('msgPage', { stateParams: encodeURIComponent(btoa(message)), isLogout: btoa('true'), msg: btoa(logoutMsg) }, { location: 'replace' });
                                            }
                                        } catch (ex) {}
                                    }, 1000);
                                }
                            }
                        }, 1000);

                    } else if (testLoginInfo.Config.thirdPartyTestType.toLowerCase() === "cocubes") {
                        qType = 'thirdPartyTest';
                        vm.question.thirdPartyTestUrl = $sce.trustAsResourceUrl(sessionStorage.cocubesLoginUrl);
                    } else if (testLoginInfo.Config.thirdPartyTestType.toLowerCase() === "nseit") {
                        qType = 'thirdPartyTest';
                        vm.question.thirdPartyTestUrl = $sce.trustAsResourceUrl(sessionStorage.nseitLoginUrl);
                    } else if (testLoginInfo.Config.thirdPartyTestType.toLowerCase() === "mettl") {
                        qType = 'thirdPartyTest';
                        vm.question.thirdPartyTestUrl = $sce.trustAsResourceUrl(sessionStorage.mettlLoginUrl ? sessionStorage.mettlLoginUrl : 'https://tests.mettl.com/take-test?ecc=Ck4KqYPgY2oun57Wffs5nQlsjegPKZDrATIB91hEO0I%3D');
                    } else if (testLoginInfo.Config.thirdPartyTestType.toLowerCase() === "wheebox") {
                        qType = 'thirdPartyTest';
                        vm.question.thirdPartyTestUrl = $sce.trustAsResourceUrl(sessionStorage.wheeboxLoginUrl);
                    } else if (testLoginInfo.Config.thirdPartyTestType.toLowerCase() === "talentlens") {
                        qType = 'thirdPartyTest';
                        vm.question.thirdPartyTestUrl = $sce.trustAsResourceUrl(sessionStorage.talentlensLoginUrl);
                        //vm.question.thirdPartyTestUrl = 'https://talentlensstg.hirepro.in/run/v1/scd:sandbox:6aa330f9-53ad-4af5-aaf8-5f3a6e6eed9a/test_1uL4P3HSz2';
                    } else if (testLoginInfo.Config.thirdPartyTestType.toLowerCase() === "testnav") {
                        qType = 'onlyProctoringTestPage';
                        vm.thirdpartyproctoring = false;
                    } else if (testLoginInfo.Config.thirdPartyTestType.toLowerCase() === "thirdpartyproctoring") {
                        qType = 'onlyProctoringTestPage';
                        vm.thirdpartyproctoring = true;
                        if (sessionStorage.getItem('external_token') && sessionStorage.thirdpartyProctoringLoginUrl) {
                            if (sessionStorage.thirdpartyProctoringLoginUrl.indexOf('?') == -1) {
                                sessionStorage.thirdpartyProctoringLoginUrl = sessionStorage.thirdpartyProctoringLoginUrl + '?token=' + sessionStorage.getItem('external_token');
                            } else {
                                sessionStorage.thirdpartyProctoringLoginUrl = sessionStorage.thirdpartyProctoringLoginUrl + '&token=' + sessionStorage.getItem('external_token');
                            }
                        }
                        //vm.question.thirdpartyProctoringLoginUrl = sessionStorage.thirdpartyProctoringLoginUrl ? $sce.trustAsResourceUrl(sessionStorage.thirdpartyProctoringLoginUrl) : 'https://google.com';
                        vm.question.thirdpartyProctoringLoginUrl = sessionStorage.thirdpartyProctoringLoginUrl ? sessionStorage.thirdpartyProctoringLoginUrl : '';
                        console.log(sessionStorage.thirdpartyProctoringLoginUrl, vm.question.thirdpartyProctoringLoginUrl, 'thirdpartyproctoring');
                        if (vm.question.thirdpartyProctoringLoginUrl) {
                            $rootScope.thirdpartyproctoringTab = window.open(vm.question.thirdpartyProctoringLoginUrl, '_blank');
                        }
                        // window.onbeforeunload = function() {
                        //     if(thirdpartyproctoringTab) {
                        //         thirdpartyproctoringTab.close();
                        //     }
                        // };
                    } else if (testLoginInfo.Config.thirdPartyTestType.toLowerCase() === "symbiosis") {
                        qType = 'thirdPartyTest';
                        vm.question.thirdPartyTestUrl = $sce.trustAsResourceUrl('https://stageoas.scdl.net/AssessmentServer/renderingEngine/Main.html');
                    } else if (testLoginInfo.Config.thirdPartyTestType.toLowerCase() === "force") {
                        qType = 'onlyProctoringTestPage';
                        vm.thirdpartyproctoring = false;
                        vm.question.thirdpartyProctoringLoginUrl = testLoginInfo.Config.forceThirdPartyUrl ? $sce.trustAsResourceUrl(testLoginInfo.Config.forceThirdPartyUrl) : 'https://google.com';
                        //$rootScope.thirdpartyproctoringTab = window.open(vm.question.thirdpartyProctoringLoginUrl, '_blank');
                    } else if (testLoginInfo.Config.thirdPartyTestType.toLowerCase() === "poptest") {
                        qType = 'thirdPartyTest';
                        vm.question.thirdPartyTestUrl = $sce.trustAsResourceUrl(location.origin + '/QA/PQS.Web.TestDeliveryPlatform/');
                        $interval(function() {
                            var iframe = document.getElementById('thirdPartyIframe');
                            if (iframe) {
                                try {
                                    if (iframe.contentWindow.document.getElementsByClassName('baseWhiteSpace').length) {
                                        if (iframe.contentWindow.document.getElementsByClassName('baseWhiteSpace').length > 0 && iframe.contentWindow.document.getElementsByClassName('baseWhiteSpace')[0].innerText.indexOf('End of Exam') > -1) {
                                            iframe.src = 'https://endingproctor.hirepro.in/assessmenthvs/#/callback/eyJ0eXBlIjoicG9wdGVzdCIsInN1Y2Nlc3MiOnRydWV9';
                                        }
                                    }
                                } catch (e) {}
                            }
                        }, 1000);
                    } else if (testLoginInfo.Config.thirdPartyTestType.toLowerCase() === "padplayer") {
                        qType = 'thirdPartyTest';
                        //vm.question.thirdPartyTestUrl = $sce.trustAsResourceUrl(location.origin + '/sign-in');
                        vm.question.thirdPartyTestUrl = $sce.trustAsResourceUrl('https://assessment.dev.passess.co.uk/sign-in');
                        $interval(function() {
                            var iframe = document.getElementById('thirdPartyIframe');
                            if (iframe) {
                                try {
                                    if (iframe.contentWindow.document.getElementsByClassName('baseWhiteSpace').length) {
                                        if (iframe.contentWindow.document.getElementsByClassName('baseWhiteSpace').length > 0 && iframe.contentWindow.document.getElementsByClassName('baseWhiteSpace')[0].innerText.indexOf('End of Exam') > -1) {
                                            iframe.src = 'https://endingproctor.hirepro.in/assessmenthvs/#/callback/eyJ0eXBlIjoicG9wdGVzdCIsInN1Y2Nlc3MiOnRydWV9';
                                        }
                                    }
                                } catch (e) {}
                            }
                        }, 1000);
                    }

                }
                // Draw IO
                // if (qType === 'drawio') {
                //     if (vm.question && vm.question.ansFiles) {
                //         vm.drawIoFileUrl = vm.question.ansFiles[0];
                //     } else if (vm.question && vm.question.dataSetJson && vm.question.dataSetJson.questionDataSet && vm.question.dataSetJson.questionDataSet[0].fileUrl) {
                //         vm.drawIoFileUrl = vm.question.dataSetJson.questionDataSet[0].fileUrl;
                //     }
                // }
                vm.questionTemplateUrl = 'app/template/default/question.' + qType + '.tpl.html';
                return $q.when(vm.questionTemplateUrl);
            }).then(function() {
                //Code need to be corrected.........
                if (vm.question && vm.question.questionType === 16 && (vm.question.selectedLanguage || vm.question.codingLangs.length === 1)) {
                    prevSelectedLang = vm.question.selectedLanguage = _.filter(vm.question.codingLangs, vm.question.selectedLanguage)[0];
                }
                if (vm.question && vm.question.questionType === 15 && !vm.question.selectedAns) {
                    vm.question.selectedAns = [];
                }
                //..................................
                if (vm.question && vm.question.questionType === 8) {
                    if (!vm.isPlainTextEnabled) {
                        CKEDITOR.plugins.addExternal('wordcount', '/s3_cached/hirepro-content/hirepro/static-resources/ckeditor/wordcount/', 'plugin.js');
                        CKEDITOR.config.extraPlugins = "wordcount";
                        CKEDITOR.config.wordcount = {
                            showParagraphs: false
                        };
                        $scope.$watch('vm.question.selectedAns', function(newValue, oldValue) {
                            getWordCount();
                            handlingAnswer();
                        });
                    }
                    if (vm.question.config) {
                        if (!vm.richTextforSubjectiveQuestionsAllowed) {
                            vm.isPlainTextEnabled = true;
                        } else if (vm.question.config.isPlainTextEnabled) {
                            vm.isPlainTextEnabled = vm.question.config.isPlainTextEnabled;
                        }
                        if (!vm.question.qaConfig) {
                            vm.question.qaConfig = angular.fromJson(vm.question.config.answerConfig);
                            if (vm.question.qaConfig) {
                                vm.question.jAns = vm.question.jAns || {};
                                vm.question.qaControls = _.keyBy(vm.question.qaConfig, 'type');
                                if (_.has(vm.question.qaControls, 'attachment.allowedExtentions')) {
                                    _.set(vm.question.qaControls, 'attachment.accept', '.' + _.join(vm.question.qaControls.attachment.allowedExtentions, ',.'));
                                }
                            }
                        }
                        if (_.has(vm.question.qaControls, 'text.id') && _.size(vm.question.jAns) > 0) {
                            var qaControlId = _.get(vm.question, 'qaControls.text.id');
                            vm.question.selectedAns = _.get(vm.question.jAns, qaControlId);
                        }
                    }
                    getWordCount();
                }
                if (vm.question.questionType === 2) {
                    $timeout(function() {
                        var ansType,
                            target = document.getElementById('spanFillInTheBlank'),
                            input = target.getElementsByTagName('input');
                        for (var i = 0; i < input.length; i++) {
                            var precision = 5;
                            input[i].disabled = false;
                            input[i].setAttribute('oncopy', 'return false');
                            input[i].setAttribute('onpaste', 'return false');
                            input[i].setAttribute('autocomplete', 'off');
                            input[i].setAttribute('autocorrect', 'off');
                            input[i].setAttribute('spellcheck', 'false');
                            input[i].setAttribute('data-gramm', 'false');
                            if (vm.question.jAns && vm.question.jAns[input[i].id]) {
                                input[i].value = vm.question.jAns[input[i].id];
                                vm.onBlurFillBlank(input[i]);
                            }
                            if (vm.question.jsonAnswerRules && vm.question.jsonAnswerRules[input[i].id]) {
                                ansType = vm.question.jsonAnswerRules[input[i].id].dataType;
                                if (ansType) {
                                    switch (ansType) {
                                        case 'float':
                                            if (vm.question.jsonAnswerRules[input[i].id].precision) {
                                                precision = vm.question.jsonAnswerRules[input[i].id].precision;
                                            }
                                            precision = '.' + _.padStart('1', precision, '0');
                                            input[i].setAttribute('step', precision);
                                        case 'integer':
                                            input[i].setAttribute('type', 'number');
                                            break;
                                    }
                                }
                            }
                            input[i].addEventListener('keyup', function(e) { vm.onFillBlank(e) });
                            //input[i].addEventListener('blur', function(e) { vm.onBlurFillBlank(e) });
                        }
                    }, 500);
                }

                if (vm.question.questionType === 17) {
                    autoStartRecordingInterval = $interval(function() {
                        vm.count--;
                        if (vm.count === 0) {
                            $interval.cancel(autoStartRecordingInterval);
                            autoStartRecordingInterval = null;
                            assessmentUtility.sessionStorage.setPromise("vidQautoStartIntervalObj", autoStartRecordingInterval);
                            vm.startRecording(true);
                        }
                    }, 1000);
                    assessmentUtility.sessionStorage.setPromise("vidQautoStartIntervalObj", autoStartRecordingInterval);
                }
            }).catch(function(error) {
                console.log(error);
            }).finally(function() {
                vm.isCurrentQisLastQ = vm.currentqindex === vm.questionpaper.mandatoryQuestionCollection.length - 1;
            });
        }
        //========= fill in the blank ==================================
        function onFillBlank(event) {
            var ansType, borderColor,
                ans;
            if (vm.question.jsonAnswerRules && vm.question.jsonAnswerRules[event.target.id]) {
                ansType = vm.question.jsonAnswerRules[event.target.id].dataType;
            }
            vm.question.jAns = vm.question.jAns || {};
            ans = event.target.value;
            if (ansType) {
                switch (ansType) {
                    case 'float':
                        ans = parseFloat(ans);
                        break;
                    case 'integer':
                        ans = parseInt(ans);
                        break;
                }
            }
            vm.question.jAns[event.target.id] = ans;
            vm.question.isAnswered = false;
            vm.question.isUnanswered = true;
            _.forEach(vm.question.jAns, function(v, k) {
                if (v) {
                    vm.question.isAnswered = true;
                    vm.question.isUnanswered = false;
                    return false;
                }
            });
            handlingAnswer();
            onBlurFillBlank(event.target);
        }

        function onBlurFillBlank(target) {
            var ansType, borderColor = '#ddd',
                ans, precision = 5;
            ans = target.value;
            if (ans && vm.question.jsonAnswerRules && vm.question.jsonAnswerRules[target.id]) {
                ansType = vm.question.jsonAnswerRules[target.id].dataType;
                if (ansType) {
                    switch (ansType) {
                        case 'float':
                            if (vm.question.jsonAnswerRules[target.id].precision) {
                                precision = vm.question.jsonAnswerRules[target.id].precision;
                            }
                            var floatRegex = new RegExp("^[-+]?(\\d*\\.)?\\d{0," + precision + "}$");
                            if (ans.match(floatRegex)) {
                                borderColor = '#ddd';
                            } else {
                                borderColor = 'red';
                            }
                            break;
                        case 'integer':
                            if (ans.match(/^[-+]?[0-9]+$/)) {
                                borderColor = '#ddd';
                            } else {
                                borderColor = 'red';
                            }
                            break;
                    }
                }
            }
            target.style.borderColor = borderColor;
        }
        /*===========================JupyterUI============================================*/
        var jupyterHubUrl;

        function getJupyterNotebook() {
            var token = $window.sessionStorage.getItem('X-AUTH-TOKEN'),
                jupyterHubUrl = ls.getData("jupyterHubUrl");
            $http({
                method: 'POST',
                url: jupyterHubUrl + "/hub/login?next=",
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                },
                transformRequest: function(obj) {
                    var str = [];
                    for (var p in obj)
                        str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
                    return str.join("&");
                },
                data: {
                    authCode: token
                }
            }).then(function(res) {
                vm.jupyterUi = $sce.trustAsHtml(res.data);
            });
        }
        /*===========================JupyterUI============================================*/
        /* ============================save code============================================*/

        vm.saveCodeHistory = function() {
            assessmentService.submitTest(true, 'submit question', vm.question.id)
                .then(function() {

                });
        };

        vm.loadPreviousAnswer = function(answer) {
            var data = {
                bodyStr: 'Are you sure you want to change the code?',
                headerStr: 'Alert',
                isAction: true,
                action: {
                    isOkBtn: true,
                    isCancelBtn: true,
                    onOk: function() {
                        setData(vm.aceEditor, answer);
                    }
                }
            };
            openModalService.showModal('notificationTemplate', data);
        };
        /* ============================save code============================================*/

        /* ============================Draw attach img file============================================*/
        vm.attachImageToQuestion = function(fileUrls) {
            if (fileUrls) {
                vm.question.ansFiles = [fileUrls];
                vm.question.isAnswered = true;
                vm.question.isUnanswered = false;
                vm.question.answer = ' ';
                vm.question.selectedAns = tenantId + '-' + candidateId + '-' + testId + '-' + vm.question.id;
                handlingAnswer();
                growl.success("Answer Saved Successfully", { ttl: 4000, disableCountDown: true });
            }
        };
        /* ============================Draw attach img file============================================*/

        function showErrorMsg(errorMsg) {
            grwlObj = growl.error(errorMsg, {
                disableCloseButton: true,
                onopen: function() {
                    $timeout(function() {
                        document.getElementsByClassName("growl-item")[0].classList.add("growl-error-custom");
                    }, 2);
                }
            });
            $timeout(function() { grwlObj && grwlObj.destroy() }, 10000);
        }

        function getQuestionByIndex() {
            sessionStorage.setItem('currentQIndex', vm.currentqindex);
            var qObj = null;
            var mandatQCollection = vm.questionpaper.mandatoryQuestionCollection;
            //var activeGrpId = assessmentService.questionpaper.activeGroup.getId();
            if (mandatQCollection.length > 0 && (vm.currentqindex <= (mandatQCollection.length - 1))) {
                qObj = mandatQCollection[vm.currentqindex];
                assessmentService.questionpaper.activeGroup.setId(qObj.gpId);
            }
            return $q.when(qObj);
        }

        /*.........................MCQ/Boolean..........................*/
        vm.onChecked = function() {
            vm.question.isAnswered = true;
            vm.question.isUnanswered = false;
            handlingAnswer();
        };

        /*.........................Video Question.......................*/
        vm.startRecording = function(isAutoStart) {
            isAutoStart = !!isAutoStart;
            $rootScope.growlError && $rootScope.growlError.destroy();
            $rootScope.growlError = null;
            if (autoStartRecordingInterval) {
                $interval.cancel(autoStartRecordingInterval);
                autoStartRecordingInterval = null;
                assessmentUtility.sessionStorage.setPromise("vidQautoStartIntervalObj", autoStartRecordingInterval);
            }
            onIFrameLoading();
            var vidElem = document.getElementById("recording-video");
            var durationInMins = (assessmentService.getAllocatedTimeForGroupOrTest() / 60) || 0;
            videoAnsRecorder.start({
                    'vqId': vm.question.id,
                    'vidElem': vidElem,
                    'isAutoStart': isAutoStart,
                    'durationInMins': durationInMins,
                    'candidateId': candidateId,
                    'testId': testId,
                    'sectionId': vm.question.scId,
                    'isPartialSavingEnable': true,
                    "MediaDeviceConstraints": { "audio": true, "video": false },
                    "MediaRecorderConstraints": {
                        "audioBitsPerSecond": 16000,
                        "mimeType": "audio/webm\;codecs=opus"
                    },
                    'procType': vm.question.id ? 'Video Question' : 'Sample Video'
                })
                .then(function(res) {
                    vm.count = -1;
                    if (!res || !res.strm) {
                        $log.log("video recording:", res);
                        handleRecodingError(res);
                        proctoringService.stop();
                        //videoStrmWatch && videoStrmWatch(); //clear wwatch...
                        return false;
                    }
                    vm.question.isAnswered = true;
                    vm.question.isUnanswered = false;
                    ls.setData("questionPaper", vm.questionpaper);
                    registerRecordingStatWatch();
                    proctoringService.setConfig({ 'videoStrmWatch': videoStrmWatch });
                    vm.question.selectedAns = tenantId + '-' + candidateId + '-' + testId + '-' + vm.question.id;
                    vm.questionpaper.TimeStamp = new Date();
                    //document.getElementById("recording-video").srcObject = res.strm;
                    vm.isRecordingStarted = true;
                    ls.setData("lastAnsweredTimeStamp", new Date());
                    ls.setData("questionPaper", vm.questionpaper);
                    ls.setData('isQuestionVideoStarted', true);
                }, function(res) {
                    $log.log(res);
                })
                .finally(function() {
                    //blockUI.stop();
                });
        };

        vm.stopRecording = function() {
            vm.isRecordingStopped = true;
            assessmentService.submitTest(true)
                .then(function() {
                    return videoAnsRecorder.stop();
                })
                .then(function(res) {
                    $log.log(res);
                    ls.setData('isQuestionVideoStarted', false);
                    if (!vm.isLastQuestionVisited) {
                        vm.stopRecordingMsg = 'Your answer has been recorded successfully.<br/>' +
                            'Click Next button to proceed to the next question.';
                    } else {
                        vm.stopRecordingMsg = 'Your answer has been recorded successfully.<br/>' +
                            'Click Submit Test button to submit this test.';
                    }
                    document.getElementById("recording-video").srcObject = null;
                });
        };

        function handleRecodingError(res) {
            var errorMsg = "Not able to start recording!";
            if (res && res.displayMsg) {
                errorMsg = res.displayMsg;
            }
            if (!navigator.onLine) {
                errorMsg += "<br>No Internet Connection!";
            } else if (res && !res.isOnline) {
                errorMsg += "<br>Unable to reach our server!<br>Please check your internet connection.";
            }
            if (res && res.displayMsg) {
                errorMsg += "<br>Recording will be started automatically,once network will come back.";
                errorMsg += "<br>Check your Internet connection."
            } else {
                errorMsg += "<br>Try Again.";
            }
            $rootScope.growlError = growl.error(errorMsg, {
                disableCloseButton: false,
                onopen: function() {
                    $timeout(function() {
                        document.getElementsByClassName("growl-item")[0].classList.add("growl-error-custom");
                    }, 1);
                }
            });
        }

        function registerRecordingStatWatch() {
            videoStrmWatch = $rootScope.$watch('vidStrmId', function() {
                if ($rootScope.vidStrmId && !$rootScope.vidStrm) {
                    handleRecodingError({
                        isOnline: $rootScope.isNetworkGotFailed,
                        displayMsg: "Recording stopped!"
                    });
                } else {
                    $rootScope.growlError && $rootScope.growlError.destroy();
                }
            });
        }

        /*.........................QA..................................*/
        //vm.qaWordCount = 0;
        vm.onTextareaChange = function() {
            getWordCount();
            handlingAnswer();
        };


        function getWordCount() {
            var data = vm.question.selectedAns || '',
                qaControlId;
            data = data.replace(/\s+/g, " ").trim(); //data.replace(/<\/?[^>]+(>|$)/g, " ").replace(/[&nbsp;\s]+/g, ' ').replace(/(?:\\[rn]|[\r\n]+)+/g, ' ').trim(); //replace all carriage returns \r, newlines \n and also literal \r and '\n`
            if (data && data != "") {
                vm.question.qaWordCount = data.split(" ").length;
                vm.question.isAnswered = true;
                vm.question.isUnanswered = false;
            } else {
                vm.question.qaWordCount = 0;
                vm.question.isAnswered = false;
                vm.question.isUnanswered = true;
            }
            // new qa version
            if (vm.question.jAns) {
                vm.question.isAnswered = false;
                vm.question.isUnanswered = true;
                qaControlId = _.get(vm.question, 'qaControls.text.id');
                if (qaControlId) {
                    vm.question.jAns[qaControlId] = vm.question.selectedAns ? vm.question.selectedAns : '';
                }
                _.forIn(vm.question.jAns, function(value, key) {
                    //vm.question.isAnswered = vm.question.isAnswered || _.isEmpty(value)? false : true;
                    if (!_.isEmpty(value)) {
                        vm.question.isAnswered = true;
                        vm.question.isUnanswered = false;
                    }
                });
            }
        }


        /*.........................Coding.............................*/
        vm.onAceLoad = function(editor) {
            $scope._ace = editor;
            if (sessionStorage.userDefinedAceSettings) {
                vm.userDefinedAceSettings = JSON.parse(sessionStorage.userDefinedAceSettings);
            }
            setReadonlyBlock(editor);
            onaceEditorSettingsChange();
            editor.addEventListener('keydown', function(e) {
                e.stopPropagation();
                e.preventDefault();
            });

            if (vm.question.selectedLanguage) {
                setData(editor);
            }
            editor.$blockScrolling = Infinity;
            vm.aceEditor = editor;
            if (!vm.codingCopyPasteEnabled) {
                editor.commands.addCommand({
                    name: "paste",
                    exec: function(event) {
                        editor.session._emit('paste');
                    },
                    bindKey: { mac: "Command-V", win: "Ctrl-V" }
                });
                editor.commands.addCommand({
                    name: "copy",
                    exec: function(event) {
                        editor.session._emit('copy');
                    },
                    bindKey: { mac: "Command-C", win: "Ctrl-C" }
                });
                editor.commands.addCommand({
                    name: "cut",
                    exec: function(event) {
                        editor.session._emit('cut');
                    },
                    bindKey: { mac: "Command-X", win: "Ctrl-X" }
                });
            }
        };

        function setReadonlyBlock(editor) {
            // Prevent editing first and last line of editor
            editor.commands.on("exec", function(e) {
                var nonEditableArea = false,
                    content = editor.getValue().split('\n'),
                    startEditable = _.findIndex(content, function(line) {
                        return line.match(/<editable>/);
                    }),
                    endEditable = _.findIndex(content, function(line) {
                        return line.match(/<\/editable>/);
                    }),
                    startReadonly = _.findIndex(content, function(line) {
                        return line.match(/<readonly>/);
                    }),
                    endReadonly = _.findIndex(content, function(line) {
                        return line.match(/<\/readonly>/);
                    });

                var selectedRange = editor.selection.getAllRanges();

                for (var i = 0; i < selectedRange.length; i++) {
                    if (startEditable > -1) {
                        nonEditableArea = (((selectedRange[i].start.row <= startEditable || selectedRange[i].start.row >= endEditable) || (selectedRange[i].end.row <= startEditable || selectedRange[i].end.row >= endEditable))) ? true : false;
                    }
                    if (startReadonly > -1) {
                        if (vm.codingAutocompleteEnabled && startReadonly <= selectedRange[i].start.row && selectedRange[i].start.row <= endReadonly) {
                            editor.setOptions({ enableBasicAutocompletion: false, enableLiveAutocompletion: false });
                        } else {
                            if (vm.codingAutocompleteEnabled) {
                                editor.setOptions({ enableBasicAutocompletion: true, enableLiveAutocompletion: true });
                            }
                        }
                        nonEditableArea = ((selectedRange[i].start.row <= startReadonly && selectedRange[i].end.row >= startReadonly) || (selectedRange[i].start.row <= endReadonly && selectedRange[i].end.row >= endReadonly)) ? true : false;
                    }
                }

                var rowCol = editor.selection.getCursor();
                if (nonEditableArea || (startEditable > -1 && (rowCol.row <= startEditable || rowCol.row >= endEditable)) || (rowCol.row >= startReadonly && rowCol.row <= endReadonly)) {
                    switch (event.keyCode) {
                        case 37:
                        case 38:
                        case 39:
                        case 40:
                            break;
                        default:
                            e.preventDefault();
                            e.stopPropagation();
                            break;
                    }
                }
                setAceHighlight(editor);
            });
        }

        function setAceHighlight(editor) {
            var Range = ace.require('ace/range').Range;
            var markerRangeReadonly,
                markerRangeEditable,
                content = editor.getValue().split('\n'),
                startEditable = _.findIndex(content, function(line) {
                    return line.match(/<editable>/);
                }),
                endEditable = _.findIndex(content, function(line) {
                    return line.match(/<\/editable>/);
                }),
                startReadonly = _.findIndex(content, function(line) {
                    return line.match(/<readonly>/);
                }),
                endReadonly = _.findIndex(content, function(line) {
                    return line.match(/<\/readonly>/);
                });

            // setTimeout(function() {
            editor.getSession().removeMarker(readonlyMarkerId);
            editor.getSession().removeMarker(editableMarkerId);
            markerRangeReadonly = new Range(startReadonly, 0, endReadonly + 1, 0);
            markerRangeEditable = new Range(startEditable, 0, endEditable + 1, 0);
            if (vm.userDefinedAceSettings.theme == 'ace/theme/textmate') { // light
                readonlyMarkerId = editor.session.addMarker(markerRangeReadonly, "light-readonly-highlight", "fullline");
            } else {
                readonlyMarkerId = editor.session.addMarker(markerRangeReadonly, "dark-readonly-highlight", "fullline");
            }
            //editableMarkerId = editor.session.addMarker(markerRangeEditable, "editonly-highlight", "fullline");
            // }, 1000);
        }

        vm.onAceChange = function(delta, w, s, r) {
            aceHelper.handleHeader(delta, vm.question.selectedLanguage.languageCode);
            var delta = _.first(delta),
                changeset = {};
            changeset = {
                d: {
                    l: delta.lines,
                    r: {
                        sr: delta.start.row,
                        sc: delta.start.column,
                        er: delta.end.row,
                        ec: delta.end.column
                    },
                    a: delta.action
                },
                t: new Date().getTime(),
                type: 'coding'
            };
            CaptureCodeActivitySvc.setEventsSequenceWithQuestionId(vm.question.id, changeset);
            if (vm.question.selectedLanguage) {
                getmodifiedCodeSnippet();
                //f (angular.isDefined(vm.question.selectedLanguage.modifiedCodeSnippet) && 
                if (vm.question.selectedLanguage.modifiedCodeSnippet.trim() != '' && vm.question.selectedLanguage.modifiedCodeSnippet !== vm.question.selectedLanguage.codeSnipet) {
                    vm.question.isAnswered = true;
                    vm.question.isUnanswered = false;
                } else {
                    vm.question.isAnswered = false;
                    vm.question.isUnanswered = true;
                }
                handlingAnswer();
            } else {
                vm.question.isAnswered = false;
                vm.question.isUnanswered = true;
            }
            setAceHighlight($scope._ace);
        };

        vm.setSnippet = function() {
            if (prevSelectedLang) {
                var data = {
                    bodyStr: 'Are you sure you want to change the language?',
                    headerStr: 'Alert',
                    isAction: true,
                    action: {
                        isOkBtn: true,
                        isCancelBtn: true,
                        onOk: function() {
                            vm.isLangChanged = true;
                            prevSelectedLang = vm.question.selectedLanguage;
                            setSnippetAsperSelection();
                        },
                        onCancel: function() {
                            vm.isLangChanged = false;
                            vm.question.selectedLanguage = prevSelectedLang;
                            setSnippetAsperSelection();
                        }
                    }
                };
                openModalService.showModal('notificationTemplate', data);
            } else {
                prevSelectedLang = vm.question.selectedLanguage;
                setSnippetAsperSelection();
            }
        };

        vm.readFile = function(evt) {
            var f = evt.target.files[0];
            commonService.readFile(f)
                .then(function(res) {
                    setData(vm.aceEditor, res.content);
                });
        };

        vm.setActiveCodingTab = function(tabIndex) {
            vm.showEditor = tabIndex == 0;
            vm.showHistory = tabIndex == 1;
            vm.showLangDoc = tabIndex == 2;
        };

        vm.unAnswerQuestionCoding = function() {
            commonQuestionActions.unAnswerQuestion(vm.question, vm.questionpaper, vm.aceEditor);
        };

        vm.toggleFullscreen = function() {
            vm.isExpanded = !vm.isExpanded;
        };

        vm.typingHandleAnswer = function() {
            handlingAnswer();
        };

        /*........................Psychometric and MultipleCorrectAnswer.......................*/
        vm.handleMultipleAnswers = function() {

            var selectedOptions = _.filter(vm.question.answerChoices, { isSelected: true });
            var selectedAnsLength = selectedOptions.length;
            vm.question.selectedAns = selectedAnsLength > 0 && _.map(selectedOptions, 'choice');
            if (!vm.question.selectedAns) {
                vm.question.selectedAns = [];
            }
            vm.question.isAnswered = vm.question.optionLimit ? ((selectedAnsLength === vm.question.optionLimit) ? true : false) : (selectedAnsLength > 0) ? true : false;
            vm.question.isUnanswered = !vm.question.isAnswered;
            handlingAnswer();
        };

        vm.changeLayout = function(qBlockId) {

            if (vm.templateLayout == "horizontal") {
                vm.templateLayout = "vertical";
                assessmentUtility.scrollToElement(qBlockId);
            } else {
                vm.templateLayout = "horizontal";
            }
        };

        vm.openThirdPartyLinkAgain = function() {
            if ($rootScope.thirdpartyproctoringTab) {
                $rootScope.thirdpartyproctoringTab.close();
            }
            $rootScope.thirdpartyproctoringTab = window.open(vm.question.thirdpartyProctoringLoginUrl, '_blank');
            vm.thirdpartyTestLinkLaunched = true;
        }

        /*..............................................Private Methods....................................*/

        /*...................Coding..........................*/
        var getmodifiedCodeSnippet = function() {

            var _session = vm.aceEditor.getSession();
            vm.question.selectedLanguage.modifiedCodeSnippet = _session.getDocument().getValue();
        };

        var setData = function(_editor, val) {
            var _session = _editor.getSession();
            var langCodeStr = vm.question.selectedLanguage.languageCode;
            var languageCode = langCodeStr && angular.fromJson(langCodeStr);
            var value = vm.question.selectedLanguage.modifiedCodeSnippet;
            if (val) {
                value = val;
            } else if (!value) {
                value = vm.question.selectedLanguage.codeSnipet;
            }
            if (!value) {
                value = "";
            }
            /*value && _session.setValue(value);*/
            angular.isString(value) && _session.setValue(value);
            var langCode = null;
            if (languageCode.code) {
                langCode = languageCode.code.toLowerCase();
            }
            _session.setMode('ace/mode/' + codingLanguageMapper[langCode]);
            aceHelper.completionsData = [];
            aceHelper.autoCompleteSuggestion = {};
            aceHelper.addCompleter(_editor, languageCode.code, loginInfo.Config.showCodingAutocompleteHelp);
            setLangSpecificDocFileUrl(languageCode.code);
        };

        var setSnippetAsperSelection = function() {
            if (vm.question.selectedLanguage) {
                vm.isAccordianOpen = true;
                setData(vm.aceEditor);
                getmodifiedCodeSnippet();
            } else {
                vm.isAccordianOpen = false;
                vm.aceEditor.getSession().setValue("");
            }
        };

        var setLangSpecificDocFileUrl = function(langCode) {
            var docs = {
                "java": "/hirepro-proxy/javase/7/docs/api/overview-summary.html",
                "java8": "/hirepro-proxy/javase/8/docs/api/overview-summary.html",
                "python": "/hirepro-proxy/2.7/",
                "python3": "/hirepro-proxy/3.7/",
                "cpp": "/ccppreference/en/cpp.html",
                "c": "/ccppreference/en/c.html" //"/s3_cached/hirepro-content/hirepro/static-resources/C-language.pdf"
            };
            vm.langDocUrl = $sce.trustAsResourceUrl(docs[langCode]);

            if (!vm.codingLanguageHelpInterval) {
                vm.codingLanguageHelpInterval = $interval(function() {
                    var iframe = document.getElementById('iframeLanguageHelp');
                    if (iframe) {
                        var d = iframe.contentWindow.document;
                        var objstoRemoveInPY = d.getElementsByClassName('sphinxsidebar');
                        var selectToRemove = d.getElementsByTagName('select');
                        var objstoRemoveInPY1 = d.getElementsByTagName('form');
                        var anchors = d.getElementsByTagName('a');
                        for (var j = 0; j < objstoRemoveInPY1.length; j++) {
                            objstoRemoveInPY1[j].parentNode.removeChild(objstoRemoveInPY1[j]);
                        }
                        for (var j = 0; j < selectToRemove.length; j++) {
                            selectToRemove[j].parentNode.removeChild(selectToRemove[j]);
                        }
                        for (var j = 0; j < anchors.length; j++) {
                            var anchor = anchors[j];
                            if (anchor.target === '_top' || anchor.target === '_blank') {
                                anchor.parentNode.removeChild(anchor);
                                break;
                            }
                            if (anchor.href === 'https://www.python.org/doc/versions/' || anchor.href === 'search.html') {
                                anchor.parentNode.removeChild(anchor);
                                break;
                            }
                            if (anchor.href && anchor.href.indexOf('javascript:') === -1) {
                                if (anchor.href.indexOf('https://') === 0 && anchor.href.indexOf('https://docs.python.org') === -1 && anchor.href.indexOf(location.origin) === -1) {
                                    anchor.removeAttribute('href');
                                } else {
                                    anchor.href = 'javascript:window.location.replace(\'' + anchor.href + '\')';
                                    anchor.href = anchor.href.replace('https://docs.python.org', location.origin + '/hirepro-proxy');
                                }

                            }
                        }
                    }
                }, 500);
            }
        };

        /*...................Handling Answer.................*/
        var handlingAnswer = function(qObj) {
            /*.......Save data to LocalStorage........*/
            var questionPaper = ls.getData("questionPaper");
            var mandatQs = questionPaper && questionPaper.mandatoryQuestionCollection;
            if (qObj && mandatQs && mandatQs.length > vm.questionpaper.mandatoryQuestionCollection.length) {
                _.find(mandatQs, { 'id': qObj.id }).TimeSpent = qObj.TimeSpent;
                vm.questionpaper = questionPaper;
            }
            if (qObj) {
                addDebugToAnswer();
            }
            //vm.questionpaper.TimeStamp = new Date();
            ls.setData("lastAnsweredTimeStamp", new Date());
            ls.setData("questionPaper", vm.questionpaper);
            ss.setData("questionPaper", vm.questionpaper);
        };

        var stateChangeStart_rootScope = $rootScope.$on("$stateChangeStart", function(event, toState, toStateParams, fromState, fromStateParams) {
            var isGroupWiseTimingEnabled = assessmentService.getGroupWiseTimingStatus(),
                isSwitchedToNextGroup = ls.getData("isManuallySwitchedToNextGroup"),
                isRequired = (isGroupWiseTimingEnabled && isSwitchedToNextGroup) ? false : true,
                isGrpWiseTimeOver = ls.getData("isGrpWiseTimeOver");
            if (autoStartRecordingInterval) {
                $interval.cancel(autoStartRecordingInterval);
                autoStartRecordingInterval = null;
            }
            if (!isGrpWiseTimeOver &&
                isRequired &&
                fromState.name === "assess.loadTest" &&
                (
                    (
                        vm.currentqindex === "0" &&
                        (
                            toState.name === "assess.startTest" ||
                            toState.name === "assess.loadTest"
                        )
                    ) ||
                    toState.name === "assess.loadTest"
                )) {
                var timeSpent = getQuestionTimeSpent();
                vm.question.TimeSpent += timeSpent;
                CaptureCodeActivitySvc.submitUserQuestionHistory(vm.question.id);
                handlingAnswer(vm.question);
            } else if (isGrpWiseTimeOver) {
                ls.clearItem("isGrpWiseTimeOver");
            }
        });

        $scope.$on('$destroy', function() {
            stateChangeStart_rootScope();
        });

        function getQuestionTimeSpent() {
            var timeSpent = new Date() - startTime;
            //$log.log("sap_timespent_asPerTimeStamp :", vm.currentqindex, " : ", timeSpent);
            /*.................correction.................*/
            //$log.log("sap_startTimeOnTicker :", vm.currentqindex, " : ", startTimeOnTicker);
            //$log.log("sap_endTimeOnTicker :", vm.currentqindex, " : ", assessmentUtility.timer.time());
            var timeSpentOnTicker = (assessmentUtility.timer.time() - startTimeOnTicker) * 1000,
                timeDiff1 = timeSpent - timeSpentOnTicker,
                timeDiff2 = timeSpentOnTicker - timeSpent;
            //$log.log("sap_timespent_asPerTicker :", vm.currentqindex, " : ", timeSpentOnTicker);
            if (timeSpent < 0 || timeDiff1 > 5000 || timeDiff2 > 5000) {
                var timeMissMatchLogInfoRq = {
                    "candidateActivityLog": {
                        "perQuestionTimer": {
                            "qId": vm.question.id,
                            "timeSpent": timeSpent,
                            "timeSpentOnTicker": timeSpentOnTicker
                        }
                    },
                    "canLoginActivityLog": {
                        "perQuestionTimer": {
                            "qId": vm.question.id,
                            "timeSpent": timeSpent,
                            "timeSpentOnTicker": timeSpentOnTicker
                        }
                    }
                };
                loggerService.push(timeMissMatchLogInfoRq);
                timeSpent = timeSpentOnTicker;
                $log.log("sap_timeCorrected :", vm.currentqindex);
            }
            /*............................................*/
            timeSpent = timeSpent > 0 ? parseInt(timeSpent / 1000) : 0;
            //$log.log("sap_timespent :", vm.currentqindex, " : ", timeSpent);
            return timeSpent;
        }

        //$timeout(onIFrameLoading, 5000);
        function onIFrameLoading() {
            vm.videoElementHeight = vm.videoElementHeight * 0.057851578974870026;
        }

        function showScrollIcon() {
            var divId = angular.element(document.querySelector('#answerSection'));
            if (divId[0]) {
                var hasVerticalScrollbar = divId[0].scrollHeight > divId[0].clientHeight;
                vm.showScrollIcon = false;
                if (hasVerticalScrollbar) {
                    vm.showScrollIcon = hasVerticalScrollbar;
                }
            }
        }

        function toscroll() {
            var divId = angular.element(document.querySelector('#answerSection'));
            divId[0].scrollTop += 100;
            if (divId[0].scrollTop + divId[0].offsetHeight >= divId[0].scrollHeight) {
                vm.showScrollIcon = false;
            }
        }

        $timeout(function() {
            showScrollIcon();
        }, 500);

        function onaceEditorSettingsChange() {
            var editor = $scope._ace;
            var session = editor.getSession();
            editor.setTheme(vm.userDefinedAceSettings.theme);
            session.setTabSize(vm.userDefinedAceSettings.tabSize);
            if (vm.userDefinedAceSettings.keybinding === 'ace') {
                editor.setKeyboardHandler(null);
            } else {
                editor.setKeyboardHandler(vm.userDefinedAceSettings.keybinding);
            }
            editor.setFontSize(vm.userDefinedAceSettings.fontsize);
            sessionStorage.userDefinedAceSettings = JSON.stringify(vm.userDefinedAceSettings);
            setAceHighlight(editor);
        }

        function uploadCaptureCallback() {
            handlingAnswer();
        }

        function addDebugToAnswer() {
            if (!vm.question.debug) {
                vm.question.debug = {
                    url: _.replace(location.href, 'https://', ''),
                    timeRemaining: [],
                    timeStampOnLeaving: []
                };
            }
            vm.question.debug.timeRemaining.push(assessmentUtility.localStorage.getData("_availTime"));
            vm.question.debug.timeStampOnLeaving.push(new Date());
        }

        if (!isAddEventListenerAdded) {
            //thrid party post message after submission
            window.addEventListener('message', function(postMessage) {
                isAddEventListenerAdded = true;
                assessmentUtility.sessionStorage.setData('isAddEventListenerAdded', isAddEventListenerAdded);
                $log.log('postMessage', postMessage);
                if (!postMessage && !postMessage.data) {
                    return;
                }
                var postMessageData = (typeof postMessage.data) === 'object' ? postMessage.data : JSON.parse(postMessage.data);
                if (!postMessageData.type) {
                    $log.log("Post message type is undefined");
                    return;
                }
                switch (postMessageData.type) {
                    case 'dotin':
                        $log.log('submiting ---dotin test');
                        if (postMessageData.success !== 1) {
                            break;
                        } else {
                            submitTestResult('dotin');
                        }
                        break;
                    case 'versantCallback':
                        $log.log('submiting ---versantCallback');
                        if (postMessageData.isSuccess) {
                            submitTestResult('versantCallback');
                        } else {
                            //In case of error
                            var isVideoProctoringEnabled = false,
                                loginInfo = loginService.getLoginInfo();
                            if (loginInfo && loginInfo.Config) {
                                isVideoProctoringEnabled = loginInfo.Config.VideoProctoring;
                            }
                            assessmentService.checkForPendingTask(false, 0);
                            if (isVideoProctoringEnabled) {
                                proctoringService.stop();
                            }
                            var obj = { isError: true, message: postMessageData.errorDesc };

                            $state.go('submitConfirmation', { 'alias': vm.alias, 'data': btoa(JSON.stringify(obj)) }, { location: 'replace' });
                        }
                        break;
                    case 'cocubesCallback':
                        if (postMessageData.ismessage && postMessageData.data) {
                            var message = "<h2>" +
                                "<i class='fa fa-exclamation-triangle text-warning' aria-hidden='true'></i> " +
                                postMessageData.data +
                                "</h2>" +
                                "</br>" +
                                "If needed start your test in new browser tab.";
                            var logoutMsg = 'CoCubes error msg: ' + postMessageData.data;
                            $state.go('msgPage', { stateParams: encodeURIComponent(btoa(message)), isLogout: btoa('true'), msg: btoa(logoutMsg) }, { location: 'replace' });
                        } else {
                            $log.log('submiting ---cocubes test');
                            submitTestResult('cocubes');
                        }
                        loadZohoChat();
                        break;
                    case 'thirdPartyProctoringStart':
                        var loginInfo = loginService.getLoginInfo(),
                            isVideoProctoringEnabled = _.get(loginInfo, 'Config.VideoProctoring');
                        if (!proctoringService.isVideoProctoringStarted && isVideoProctoringEnabled) {
                            return proctoringService.start();
                        }
                        break;
                    case 'thirdPartyProctoringPause':
                        var loginInfo = loginService.getLoginInfo(),
                            isVideoProctoringEnabled = _.get(loginInfo, 'Config.VideoProctoring');
                        assessmentService.checkForPendingTask(false, 0);
                        if (proctoringService.isVideoProctoringStarted && isVideoProctoringEnabled) {
                            proctoringService.stop();
                        }
                        break;
                    case 'thirdPartyProctoringEnd':
                        if (isThirdPartyEndProctoringInitiated) {
                            return;
                        }
                        isThirdPartyEndProctoringInitiated = true;
                        submitTestResult(postMessageData.type);
                        break;
                    case 'thirdPartyDebugLog':
                        var log = {};
                        if (postMessageData.data) {
                            log = {
                                canLoginActivityLog: {
                                    thirdPartyDebugLog: postMessageData.data
                                }
                            };
                            loggerService.push(log);
                        }
                        break;
                    default:
                        $log.log('submiting ---' + postMessageData.type);
                        if (postMessageData.success) {
                            submitTestResult(postMessageData.type);
                        } else {
                            //In case of error
                            var isVideoProctoringEnabled = false,
                                loginInfo = loginService.getLoginInfo();
                            if (loginInfo && loginInfo.Config) {
                                isVideoProctoringEnabled = loginInfo.Config.VideoProctoring;
                            }
                            assessmentService.checkForPendingTask(false, 0);
                            if (isVideoProctoringEnabled) {
                                proctoringService.stop();
                            }
                            var obj = { isError: true, message: postMessageData.message };

                            $state.go('submitConfirmation', { 'alias': vm.alias, 'data': btoa(JSON.stringify(obj)) }, { location: 'replace' });
                        }
                        if (postMessageData.type == "mettl") {
                            loadZohoChat();
                        }
                        break;
                }
            });
        }

        // test submission after thrid party submission
        function submitTestResult(thirdPartyName) {
            var isOnlinePreview = assessmentUtility.localStorage.getData("_isOnlinePreview"),
                isVideoProctoringEnabled = false,
                loginInfo = loginService.getLoginInfo();
            if (loginInfo && loginInfo.Config) {
                isVideoProctoringEnabled = loginInfo.Config.VideoProctoring;
            }
            isOnlinePreview = isOnlinePreview ? isOnlinePreview : false;
            if (loginInfo.Config && loginInfo.Config.logoutIfNoInternetIn) {
                sessionStorage.setItem("isTestCompleted", true);
                // hvsService.killLogoutTimer();
            }
            if (!isOnlinePreview) {
                if (isVideoProctoringEnabled) {
                    proctoringService.stop();
                }
                /*else if(_.size(trackerTypes) > 0){
                                   trackerService.stopMediaStream();
                               }*/
                assessmentService.submitTest(false, "autoFinalSubmition-" + thirdPartyName)
                    .then(function(response) {
                        if (response) {
                            $log.log('thrid party submission End');
                            afterSubmission.do(response);
                        }
                    }).catch(function(err) {
                        isThirdPartyEndProctoringInitiated = false;
                    });
            } else {
                if (isVideoProctoringEnabled) {
                    proctoringService.stop();
                }
                $state.go('submitConfirmation', { 'alias': vm.alias }, { location: 'replace' });
            }
        }

        function endOnlyProctoringTest() {
            openModalService.openModal('stopProctoringWarningTemplate', {})
                .then(function(res) {
                    if (res && res.result && res.result.stopProctoringEndTest) {
                        submitTestResult('onlyProctoring');
                    }
                });
        }

        function loadZohoChat() {
            var isZohoChatEnabled = JSON.parse(sessionStorage.getItem('zohoChatStatus'));
            if (isZohoChatEnabled) {
                setTimeout(function() {
                    window.$zoho.salesiq.ready = function() {
                        window.$zoho.salesiq.floatbutton.visible("show");
                    }();
                }, 5000)
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('OnlineAssessmentAngular')
        .component('proctorCompatibility', {
            controller: proctorCompatibilityController,
            controllerAs: 'vm',
            templateUrl: 'app/assessment/proctorCompatibility.tpl.html',
            bindings: {
                hideActionPannel: '<',
                videoSampleOpts: '<',
                responseData: '&',
                isAuthenticated: '<',
                internetSpeed: '=',
                overAllStatus: '=',
                otherConfig: '<' 
            }
        })
        .directive('imageonload', imageonload);

    proctorCompatibilityController.$inject = [
        '$q',
        '$log',
        '$interval',
        '$timeout',
        'proctorService',
        '$sce',
        '$rootScope',
        'assessmentUtility',
        '$scope',
        'trackerService',
        'openModalService',
        'loginService',
        'proctoringService',
        '$http',
        'loggerService',
        'deviceDetector',
        'webService',
        'imageTracker',
        'blockUI',
        'fileIOHelper'
    ];

    function proctorCompatibilityController($q, $log, $interval, $timeout, proctorService, $sce, $rootScope, assessmentUtility, $scope, trackerService, openModalService, loginService, proctoringService, $http, loggerService, deviceDetector, webService, imageTracker, blockUI, fileIOHelper) {
        var vm = this,
            systemSlow,
            javascriptNode,
            goldenImageUrl,
            recordingTimer = null,
            mediaRecorder = null,
            faceTrackJson = {
                videoTagId: 'videoElement',
                isVideoEnabled: true,
                isAudioEnabled: true,
                canvasTagId: 'overlay'
            },
            mediaStream = null,
            audioTracks = null,
            fullStream = null,
            autoStartRecordingInterval = null,
            stoppedRecording = false,
            browserLowerLimit = 80,
            browserUpperLimit = null,
            startTime, imgsize = 1408049,
            flag = {},
            networkCheckingDuration = 25000,
            completeTestInterval,
            loginInfo = loginService.getLoginInfo(),
            autoStartRecording = false,
            prevDebugInfoSent = {},
            janus = null,
            systemNetworkFlag = {},
            echotest = null,
            janusUrl,
            bitrateTimer = null,
            bitrateTimerSet = false,
            acodec = null,
            vcodec = null,
            counter = 0,
            setIceTransportPolicy = null,
            minFPSRequired = 4,
            standaloneMinFps = 8,
            zohoChatStatus = false,
            zohoChatWidgetCode;

        vm.faceDetectionErrorMessage = false;
        vm.isVideoEnabled = true;
        vm.isAudioEnabled = true;
        vm.isCandidateProctored = false;
        vm.browserApproved = false;
        vm.micCheck = false;
        vm.cameraCheck = false;
        vm.faceDetectionFound = false;
        vm.successMessage = "";
        vm.message = "Please ensure your face is within box and there is adequate light on your face.";
        vm.errorMessage = "";
        vm.ok = "Ok";
        vm.imgfile = "/s3_cached/hirepro-content/hirepro/common/e930854a-9d71-4eac-9d3c-f3ac90b24607BandwidthTestImage.jpg?v=" + Date.now();
        //vm.isActionEnable = true;
        vm.recordButton = true;
        vm.audioRecordStarted = false;
        vm.startRecordingCounter = 30;
        vm.isMediaQuestion = (proctorService.localVar.mediaQuestion &&
            proctorService.localVar.mediaQuestion.ContainsMediaQuestion) || false;
        vm.videoProctoringMode = (proctorService.localVar.mediaQuestion &&
            proctorService.localVar.mediaQuestion.Config &&
            proctorService.localVar.mediaQuestion.Config.VideoProctoring &&
            proctorService.localVar.videoProctoringMode == 'strict') || false;
        vm.showImage = false;
        vm.captured = false;
        vm.maxMicSensitivityValue = 0;
        vm.systemSpeedSlow = false;
        vm.slowSystemInstruction = '<div><ul>' +
            '<li>Please close all other applications</li>' +
            '<li>Please close any other open browser/tabs.</li>' +
            '<li>Retest by reloading the page.</li>' +
            '<li>Try this system test on other system.</li>' +
            '</ul></div>';
        vm.toCheckSpeedTest = false;
        vm.inProgress = true;
        vm.needPermission = true;
        vm.needPermissionStage = 1;
        vm.systemInfo = {};
        vm.apiErrorMsgStatus = false;
        vm.isSecondaryCamera = sessionStorage.isSecondaryCamera && sessionStorage.isSecondaryCamera === "true" ? true : false;
        /*methods*/
        vm.startRecording = startRecording;
        vm.stopRecording = stopRecording;
        vm.trustSrc = trustSrc;
        vm.onOk = onOk;
        vm.clickImage = clickImage;
        vm.captureAgain = captureAgain;
        vm.savePersistance = savePersistance;
        vm.sampleVideo = sampleVideo;
        vm.startCamera = startCamera;
        vm.onImageLoad = onImageLoad;
        vm.debugInfo = {};
        vm.socketCheckStatus = {};
        vm.selfieCheckErrorMessages = {
            "default": "Please take the picture again. Please ensure that your face is clearly visible, with no other faces in the background.",
            "noFace": "Please take the picture again. Please ensure that your face is fully and clearly visible.",
            "multipleFaces": "Please take the picture again. Please ensure that only you are in the camera view, with no other faces or pictures with faces in the background.",
            "poorLight": "Please take the picture again. Please ensure that there is adequate light on your face."
        };

        activate();

        vm.$onInit = function() {
            vm.isActionEnable = vm.hideActionPannel ? false : true;
            vm.internetSpeed = vm.internetSpeed;
            checkForCameraApproval();
            // assessmentUtility.getClientInfo().then(function(res) {
            //     vm.deviceType = res.isDesktop;
            //     faceTrackJson.isDesktop = vm.deviceType;
            //     startFaceTracking();
            // });
            checkBrowserCompatibility();
            if(vm.otherConfig && vm.otherConfig.socketCheckConfig){
                getOath2Access().then(function(data) {
                    vm.oath2Data = data;
                    sessionStorage.setItem('AuthorizationTokenAuthorizationToken', data.access_token);
                    sessionStorage.setItem('AuthorizationTokenType', data.token_type);
                    return getNodeInfoForSocketCompatibilityCheck();
                }).then(function(data) {
                    var host = 'wss://ams.hirepro.in';
                    if(location.host === 'amsin.hirepro.in'){
                        host = 'wss://amsin.hirepro.in';
                    }
                    if(data) {
                        var url = '?token=' + vm.oath2Data.access_token + '&token_type=' + vm.oath2Data.token_type +'&app=standaloneCompatibility';
                        checkSocketCompatibiliy(host + '/' + data.data.hvsDetails.serverRelativePath + 'wss', 'janus-protocol').then(function(result) {
                            vm.socketCheckStatus.hvs = result;
                        });
                        checkSocketCompatibiliy(data.data.wssDetails.PROXY_PASS_WSS_URL + url ).then(function(result) {
                            vm.socketCheckStatus.aws = result;
                        });
                        checkSocketCompatibiliy(host + '/socket.io/?EIO=4&transport=websocket').then(function(result) {
                            vm.socketCheckStatus.hirepro = result;
                        });
                    }
                });
            }
            // checkMic();
            startTime = new Date();
            if (vm.isAuthenticated != false) {
                startSpeedTest();
            }
            if (vm.isAuthenticated === false) {
                faceTrackJson.standAlone = true;
                getHvs()
                speedTestStandAlone();
            }
            zohoChatStatus = _.get(loginInfo, 'assessmentConfig.enableZohoChat', zohoChatStatus);
            zohoChatWidgetCode = _.get(loginInfo, 'assessmentConfig.zohoChatWidgetCode');
            sessionStorage.setItem('zohoChatStatus', zohoChatStatus);
            if (zohoChatStatus && zohoChatWidgetCode) {
                loadZohoChat();
            }
            vm.debugInfoInterval = $interval(function() {
                var obj = {};
                obj.cameraCheck = vm.cameraCheck;
                obj.browserApproved = vm.browserApproved;
                obj.faceDetectionFound = vm.faceDetectionFound;
                obj.micCheck = vm.micCheck;
                obj.micAudioUrl = vm.micAudioUrl;
                obj.isSystemTooSlow = vm.isSystemTooSlow;
                obj.maxMicSensitivityValue = vm.maxMicSensitivityValue;
                obj.micLessSensitivity = vm.micLessSensitivity;
                obj.micMuted = vm.micMuted;
                obj.needPermission = vm.needPermission;
                obj.needPermissionStage = vm.needPermissionStage;
                obj.speedTestStatus = vm.speedTestStatus;
                obj.systemInfo = vm.systemInfo;
                obj.otherInfo = vm.debugInfo;
                obj.selfieURL = goldenImageUrl;
                try {
                    obj.mediaSupportedConstraints = navigator.mediaDevices.getSupportedConstraints();
                } catch (error) {
                    obj.mediaSupportedConstraints = 'unable to fetch data';
                }
                obj.systemNetworkFlag = systemNetworkFlag;
                if (!_.isEqual(obj, prevDebugInfoSent)) {
                    prevDebugInfoSent = obj;
                    var req = {
                        "canLoginActivityLog": {
                            "proctorCompatibilityStats": obj
                        }
                    };
                    loggerService.push(req);
                    console.log('Sending from Proctor Compatibility page');
                } else {
                    console.log('No change in proctor compatibility debug info');
                }
                console.log('cha_', vm);
            }, 30 * 1000);

        };

        vm.$onDestroy = function() {
            var req = {
                "canLoginActivityLog": {
                    "proctorCompatibilityStats": 'OnDestroy'
                }
            };
            loggerService.push(req);
            if (vm.debugInfoInterval) {
                $interval.cancel(vm.debugInfoInterval);
            }
        }

        function activate() {}

        function getHvs() {
            webService.execute('getHvs', {}).then(
                function(res) {
                    if (res.data.status === 'OK' && res.data.data && res.data.data.iceServer) {
                        vm.iceServers = res.data.data.iceServer;
                        janusUrl = null;
                        if (window.location.hostname === 'localhost') {
                            janusUrl = 'https://amsin.hirepro.in/';
                        } else {
                            janusUrl = 'https://' + window.location.hostname + '/';
                        }
                        if (res.data.data.serverRelativePath) {
                            janusUrl = janusUrl + res.data.data.serverRelativePath;
                        } else {
                            janusUrl = janusUrl + 'janus';
                        }
                        echoTest();
                    } else {
                        vm.echoTestStatus = 'end';
                    }
                },
                function() {}
            );
        }

        function echoTest() {
            vm.echoTestStatus = 'start';
            Janus.init({
                debug: 'all',
                callback: echoTestJanusCallback
            });
        }

        function echoTestJanusCallback(policyType) {
            // Make sure the browser supports WebRTC
            if (policyType == undefined) {
                var policyType = 'all';
            }
            if (!Janus.isWebrtcSupported()) {
                console.log('No WebRTC support... ');
                logNetworkCheck();
                return;
            }
            // Create session
            janus = new Janus({
                server: janusUrl,
                iceServers: vm.iceServers,
                iceTransportPolicy: policyType,
                success: function() {
                    // Attach to echo test plugin
                    janus.attach({
                        plugin: 'janus.plugin.echotest',
                        opaqueId: 'echotest-' + Janus.randomString(12),
                        success: function(pluginHandle) {
                            echotest = pluginHandle;
                            console.log('Plugin attached! (' + echotest.getPlugin() + ', id=' + echotest.getId() + ')');

                            // Negotiate WebRTC
                            var body = {
                                audio: true,
                                video: true
                            };
                            // We can try and force a specific codec, by telling the plugin what we'd prefer
                            // For simplicity, you can set it via a query string (e.g., ?vcodec=vp9)
                            if (acodec) {
                                body.audiocodec = acodec;
                            }
                            if (vcodec) {
                                body.videocodec = vcodec;
                            }
                            Janus.debug('Sending message (' + JSON.stringify(body) + ')');
                            echotest.send({
                                message: body
                            });
                            Janus.debug('Trying a createOffer too (audio/video sendrecv)');
                            echotest.createOffer({
                                media: {
                                    data: true
                                },
                                success: function(jsep) {
                                    Janus.debug('Got SDP!');
                                    Janus.debug(jsep);
                                    echotest.send({
                                        message: body,
                                        jsep: jsep
                                    });
                                },
                                error: function(error) {
                                    Janus.error('WebRTC error:', error);
                                    console.log('WebRTC error... ' + JSON.stringify(error));
                                    logNetworkCheck();
                                }
                            });
                        },
                        error: function(error) {
                            console.error(' -- Error attaching plugin...', error);
                            console.log('Error attaching plugin... ' + error);
                            logNetworkCheck();
                        },
                        consentDialog: function(on) {
                            Janus.debug('Consent dialog should be ' + (on ? 'on' : 'off') + ' now');
                            // if(on) {
                            //  // Darken screen and show hint
                            // } else {
                            //  // Restore screen
                            // }
                        },
                        iceState: function(state) {
                            systemNetworkFlag.iceState = state;
                            console.log('ICE state changed to ' + state);
                        },
                        mediaState: function(medium, on) {
                            if (medium === 'audio') {
                                systemNetworkFlag.audio = on;
                            } else if (medium === 'video') {
                                systemNetworkFlag.video = on;
                            }
                            console.log('Janus ' + (on ? 'started' : 'stopped') + ' receiving our ' + medium);
                        },
                        webrtcState: function(on) {
                            systemNetworkFlag.webrtcState = on;
                            console.log('Janus says our WebRTC PeerConnection is ' + (on ? 'up' : 'down') + ' now');
                        },
                        slowLink: function(uplink, nacks) {
                            Janus.warn('Janus reports problems ' + (uplink ? 'sending' : 'receiving') +
                                ' packets on this PeerConnection (' + nacks + ' NACKs/s ' + (uplink ? 'received' :
                                    'sent') + ')');
                            console.log('---slowLink---', 'Janus reports problems ' + (uplink ? 'sending' : 'receiving') +
                                ' packets on this PeerConnection (' + nacks + ' NACKs/s ' + (uplink ? 'received' :
                                    'sent') + ')');
                        },
                        onmessage: function(msg, jsep) {
                            Janus.debug(' ::: Got a message :::');
                            Janus.debug(msg);
                            if (jsep !== undefined && jsep !== null) {
                                Janus.debug('Handling SDP as well...');
                                Janus.debug(jsep);
                                echotest.handleRemoteJsep({
                                    jsep: jsep
                                });
                            }
                            var result = msg.result;
                            if (result !== null && result !== undefined) {
                                if (result === 'done') {
                                    // The plugin closed the echo test
                                    console.log('The Echo Test is over');
                                    return;
                                }
                                // Any loss?
                                var status = result.status;
                                if (status === 'slow_link') {
                                    //~ var bitrate = result["bitrate"];
                                    //~ toastr.warning("The bitrate has been cut to " + (bitrate/1000) + "kbps", "Packet loss?", {timeOut: 2000});
                                    console.log(
                                        'Janus apparently missed many packets we sent, maybe we should reduce the bitrate');
                                }
                            }
                        },
                        onlocalstream: function(stream) {
                            Janus.debug(' ::: Got a local stream :::');
                            Janus.debug(stream);
                            // Janus.attachMediaStream($('#videoElement').get(0), stream);
                            // options.mediaStream = stream;
                            // if (vm.toProctor) {
                            //   proctor.init(options);
                            //   startFaceTracking();
                            // } else {
                            //   vm.faceDetected = true;
                            //   vm.loginCheck = true;
                            //   vm.showSelfie = true;
                            // }
                        },
                        onremotestream: function(stream, q, w, e, r) {
                            Janus.debug(' ::: Got a remote stream :::');
                            Janus.debug(stream);
                            // Janus.attachMediaStream($('#videoElementRemote').get(0), stream);
                            var videoTrack = stream.getVideoTracks(),
                                totalBitrate = 0;

                            systemNetworkFlag.resolution = [];
                            if (Janus.webRTCAdapter.browserDetails.browser === 'chrome' || Janus.webRTCAdapter.browserDetails
                                .browser === 'firefox' ||
                                Janus.webRTCAdapter.browserDetails.browser === 'safari') {
                                if (!bitrateTimerSet) {
                                    bitrateTimerSet = true;
                                    bitrateTimer = $interval(function() {
                                        // Display updated bitrate, if supported
                                        var bitrate = echotest.getBitrate();
                                        Janus.debug('Current bitrate is ' + bitrate);
                                        if (counter > 4) {
                                            totalBitrate += parseInt(bitrate);
                                        }
                                        counter += 1;
                                        if (counter >= 11) {
                                            // Check if the resolution changed too
                                            // var width = $('#videoElementRemote').get(0).videoWidth;
                                            // var height = $('#videoElementRemote').get(0).videoHeight;
                                            // // Janus.debug('Resolution is ' + width+'x'+height);
                                            // systemNetworkFlag.resolution.push(width + ' x ' + height);
                                            if (totalBitrate > 0) {
                                                systemNetworkFlag.avgBitrate = (totalBitrate / 7).toFixed(2);
                                            }
                                            if (videoTrack) {
                                                echotest.detach({
                                                    noRequest: false
                                                });
                                                systemNetworkFlag.candidateTransportType = policyType;
                                                if (setIceTransportPolicy === null) {
                                                    var transportType = 'relay';
                                                    setIceTransportPolicy = true;
                                                    bitrateTimerSet = false;
                                                    counter = 0;
                                                    echoTestJanusCallback(transportType);
                                                } else {
                                                    vm.echoCheck = true;
                                                    if (vm.overAllStatus) {
                                                        vm.overAllStatus.echoCheck = true;
                                                    }
                                                    logNetworkCheck()
                                                }
                                                //vm.echoCheck = true;
                                            }
                                            //logNetworkCheck();
                                            // janus.destroy();
                                        }
                                    }, 1000);
                                }
                            }
                        },
                        ondataopen: function(data) {
                            console.log('The DataChannel is available!');
                            // $('#videos').removeClass('hide').show();
                            // $('#datasend').removeAttr('disabled');
                        },
                        ondata: function(data) {
                            Janus.debug('We got data from the DataChannel! ' + data);
                        },
                        oncleanup: function() {
                            console.log(' ::: Got a cleanup notification :::');
                            if (angular.isDefined(bitrateTimer)) {
                                $interval.cancel(bitrateTimer);
                            }
                            bitrateTimer = undefined;
                        }
                    });
                },
                error: function(error) {
                    // Janus.error(error);
                    console.log(error);
                    logNetworkCheck();
                },
                destroyed: function() {
                    console.log(' ::: Got a destroyed notification :::');
                    //window.location.reload();
                }
            });
        }

        function logNetworkCheck() {
            vm.echoTestStatus = 'end';
            if (vm.overAllStatus) {
                vm.overAllStatus.echoTestStatus = vm.echoTestStatus;
            }
            if (angular.isDefined(bitrateTimer)) {
                $interval.cancel(bitrateTimer);
            }
            bitrateTimer = undefined;
            vm.responseData({ info: { echoTestFlags: systemNetworkFlag, finalStatus: vm.echoCheck } });
            // if (!vm.isForInterviewer && vm.toProctor) {
            //     var setlogInfo = {
            //         userActivityLog: {
            //             echoTestFlags: systemNetworkFlag,
            //             finalStatus: vm.echoCheck
            //         }
            //     };
            //     webService.execute('activitylogStats', setlogInfo).then(
            //         function() {
            //             console.log('Successfully Logged');
            //         },
            //         function() {
            //             $log.log('Error occurred when pushing Log');
            //         });
            // }
        }

        function checkForCameraApproval() {
            navigator.mediaDevices.enumerateDevices().then(function(e) {
                e.forEach(function(e) {
                    $log.log(e.label);
                    if (e.label) {
                        vm.needPermission = false;
                    }
                });
                if (!vm.needPermission) {
                    startCamera();
                }
            });
        }

        function startCamera() {
            vm.needPermissionStage = 2;
            // assessmentUtility.getClientInfo().then(function(res) {
            //     vm.deviceType = res.isDesktop;
            //     faceTrackJson.isDesktop = vm.deviceType;
            //     startFaceTracking();
            // });
            checkMic();
        }

        function startFaceTracking() {
            proctorService.promiseReturn(faceTrackJson)
                .then(function(value) {
                    var typeOfTest = sessionStorage.getItem('typeOfTest'),
                        tensorFaceTrackingFPS = JSON.parse(sessionStorage.getItem('tensorFaceTrackingFPS')) || 9,
                        isFaceLandmarks = JSON.parse(sessionStorage.getItem('isfaceLandmarksOn'));
                    console.log('cha_facetrack', value);
                    if (deviceDetector.raw && deviceDetector.raw.os && deviceDetector.raw.os.mac) {
                        value.systemSlow.flag = false;
                    }
                    /*if (loginInfo && loginInfo.Config && !loginInfo.Config.isFaceTrackingEnabled) {
                        value.systemSlow.flag = false;
                    }*/
                    minFPSRequired = _.get(loginInfo, 'assessmentConfig.minFPSRequired', minFPSRequired);
                    minFPSRequired = _.get(loginInfo, ['assessmentConfig', 'minFPSConfig', typeOfTest], minFPSRequired);
                    if (!deviceDetector.isDesktop()) {
                        minFPSRequired = _.get(loginInfo, 'assessmentConfig.minFPSRequiredForMobile', minFPSRequired);
                    }
                    vm.debugInfo.systemSlow = value.systemSlow;
                    vm.needPermission = false;
                    vm.systemSpeedSlow = false;
                    vm.isSystemTooSlow = false;
                    if (value.isCandidateProctored) {
                        vm.faceDetectionFound = value.isCandidateProctored;
                        systemSlow = value.systemSlow;
                        sessionStorage.stopFaceTrackerAsSystemSlow = value.systemSlow.flag;
                        vm.systemSpeed = value.systemSlow.frameSpeed;
                        $log.log('FRAME', value);
                        vm.slowSystemMsg = null;
                        trackerService.systemSpeedLog(value.systemSlow);
                        if (value.systemSlow.flag) {
                            vm.slowSystemMsg = "- Slow system detected";
                        }
                        if (value.systemSlow.frameSpeed <= minFPSRequired) {
                            vm.slowSystemMsg = "- Your system is too slow to take the test";
                            vm.responseData({ proceed: false, type: 'image', url: '', systemSlow: true, reloadEnabled: true });
                        }
                        if (vm.isAuthenticated === false && value.systemSlow.frameSpeed <= standaloneMinFps) {
                            if (vm.overAllStatus) {
                                vm.overAllStatus.standaloneMinFps = true;
                                var data = {
                                    frameSpeed: value.systemSlow.frameSpeed,
                                    systemIsSlow: true
                                };
                                vm.responseData({ info: data });
                            }
                        } else {
                            var data = {
                                frameSpeed: value.systemSlow.frameSpeed,
                                systemIsSlow: false
                            };
                            vm.responseData({ info: data });
                        }
                        if (vm.slowSystemMsg) {
                            vm.debugInfo.systemSlow.message = vm.slowSystemMsg;
                            //sessionStorage.stopFaceTrackerAsSystemSlow = true;
                            $log.log("NOT COMPATIBLE FOR FACE TRACKING!!");
                            vm.systemSpeedSlow = true;
                            vm.isSystemTooSlow = value.systemSlow.frameSpeed <= minFPSRequired;
                            if (!vm.isActionEnable) {
                                var data = {
                                    systemSlow: systemSlow
                                };
                                vm.responseData({ info: data });
                            }
                        }
                        // check if possible for tensor flow
                        if (isFaceLandmarks && value.allowedFrameRate < tensorFaceTrackingFPS && value.systemSlow.frameSpeed > tensorFaceTrackingFPS) {
                            sessionStorage.setItem('faceLandmarks', true);
                        }
                        // check if possible for tensor flow
                        /*else if (!value.systemSlow) {
                               sessionStorage.stopFaceTrackerAsSystemSlow = false;
                           }*/
                        sessionStorage.hasproctorfacetrackingfacedetected = true;
                        checkToProcced();
                        // if (value.isCandidateProctored && vm.cameraCheck && vm.micCheck) {
                        //     vm.isCandidateProctored = value.isCandidateProctored;
                        // }
                    }
                }, function(errorRes) {
                    console.error(errorRes);
                    if (_.get(errorRes, 'activity') === 'getMyRoom') {
                        vm.responseData({ proceed: false, showReloadOnGetMyRoomFailure: true });
                    }
                });
        }

        function skipFaceTracking(res) {
            var video = document.querySelector('#' + faceTrackJson.videoTagId);
            if (res) {
                vm.responseData({ proceed: true, type: 'image' });
                video.srcObject = res;
            }
            proctorService.getMyRoomSecondaryCam();
        }

        function trustSrc(src) {
            return $sce.trustAsResourceUrl(src);
        }

        function colorPids(vol) {
            var color = '#69ce2b';
            var reqVol = 8;
            var queryResult = document.getElementsByClassName('pid');
            var all_pids = angular.element(queryResult);
            // var all_pids = $('.pid');
            if (all_pids.length > 0) {
                var amout_of_pids = Math.round(vol / 10);
                vm.maxMicSensitivityValue = _.max([vm.maxMicSensitivityValue, amout_of_pids]);
                var elem_range = _.slice(all_pids, 0, amout_of_pids);
                if (vm.maxMicSensitivityValue >= reqVol) {
                    vm.micCheck = true;
                    vm.micMuted = false;
                    vm.micLessSensitivity = false;
                    if (vm.overAllStatus) {
                        vm.overAllStatus.micCheck = true;
                    }
                    /*if(mediaRecorder && mediaRecorder.state == 'recording') {
                        mediaRecorder.stop();
                    }*/

                } else {
                    vm.micCheck = false;
                    if (vm.maxMicSensitivityValue == 0) {
                        vm.micMuted = true;
                        vm.micLessSensitivity = false;
                    } else {
                        vm.micLessSensitivity = true;
                        vm.micMuted = false;
                    }
                }
                checkToProcced();
                if (elem_range.length < reqVol) {
                    color = '#BD0A0D';
                } else {
                    color = '#69ce2b';
                }
                for (var i = 0; i < all_pids.length; i++) {
                    all_pids[i].style.backgroundColor = '#e6e7e8';
                }
                for (var i = 0; i < elem_range.length; i++) {
                    // $log.log(elem_range[i]);
                    all_pids[i].style.backgroundColor = color;
                }
            }
        }
        // vm.mediaErrorMessage = "Camera is not Available!";
        function checkMic() {
            trackerService.getMediaStream()
                .then(function(res) {
                    if (res) {
                        assessmentUtility.getClientInfo().then(function(resp) {
                            vm.debugInfo.clientInfo = resp;
                            vm.deviceType = resp.isDesktop;
                            sessionStorage.setItem('isDesktop', vm.deviceType);
                            faceTrackJson.isDesktop = vm.deviceType;
                            if (vm.isSecondaryCamera) {
                                skipFaceTracking(res);
                            } else {
                                startFaceTracking();
                            }
                        });
                        $scope.$watch(function() {
                            return proctorService.localVar.cameraOk;
                        }, function(newVal, oldVal) {
                            vm.cameraCheck = newVal;
                            if (vm.overAllStatus) {
                                vm.overAllStatus.cameraCheck = newVal;
                            }
                            checkToProcced();
                        }, true);
                    }
                    vm.needPermission = false;
                    vm.micLessSensitivity = false;
                    //vm.micCheck = true;
                    mediaStream = res;
                    audioTracks = mediaStream.getAudioTracks();
                    if (!audioTracks.length) {
                        vm.micCheck = false;
                    } else {
                        if (audioTracks[0].muted) {
                            vm.micCheck = false;
                            vm.micMuted = true;
                            // vm.responseData({ proceed: false, type: 'image', url: '', systemSlow: vm.systemSpeedSlow, reloadEnabled: true });
                        }
                        audioTracks[0].onunmute = function() {
                            //vm.micCheck = true;
                            vm.micMuted = false;
                            // vm.responseData({ proceed: false, type: 'image', url: '', systemSlow: vm.systemSpeedSlow, reloadEnabled: vm.systemSpeedSlow ? true : false});
                            checkToProcced();
                        };
                        audioTracks[0].onmute = function() {
                            vm.maxMicSensitivityValue = 0;
                            vm.micCheck = false;
                            vm.micMuted = true;
                            // vm.responseData({ proceed: false, type: 'image', url: '', systemSlow: vm.systemSpeedSlow, reloadEnabled: true });
                            checkToProcced();
                        };
                        /*if (vm.isMediaQuestion) {
                            if (!mediaStream.getVideoTracks().length) {
                                vm.cameraCheck = false;
                            } else {
                                vm.faceDetectionFound = true;
                            }
                        }*/
                        var chunks = [],
                            counter = 0,
                            interval = 1;
                        var audoStream = new MediaStream();
                        audoStream.addTrack(audioTracks[0]);
                        mediaRecorder = new MediaRecorder(audoStream);
                        Object.defineProperties(mediaRecorder, {
                            mimeType: {
                                value: 'audio/ogg',
                                writable: true
                            }
                        });
                        mediaRecorder.start();
                        mediaRecorder.ondataavailable = recordedDataAvailable;
                        mediaRecorder.onstop = function() {
                            var blob = new Blob(chunks, {
                                'type': 'audio/ogg; codecs=opus'
                            });
                            var dataBlob = new File([blob], "microphoneCheck.ogg");
                            var fd = new FormData();
                            fd.append("file", dataBlob);
                            imageTracker.saveImage(fd, 'both', 'bgsample').then(function(response) {
                                var audioUrl = '';
                                if (response && response.s3_url) {
                                    audioUrl = response.s3_url;
                                }
                                vm.micAudioUrl = audioUrl;
                                var req = {
                                    'canLoginActivityLog': {
                                        'micCheckURL': audioUrl,
                                        'micCheckPassed': vm.micCheck,
                                        'micMuted': vm.micMuted,
                                        'maxMicSensitivityValue': vm.maxMicSensitivityValue
                                    }
                                };
                                loggerService.push(req);
                            });
                        }

                        function recordedDataAvailable(chunk) {
                            chunks.push(chunk.data);
                        }

                        $interval(function() {
                            if (vm.micCheck && mediaRecorder && mediaRecorder.state == 'recording') {
                                mediaRecorder.stop();
                            }
                            if ((interval * counter) >= 30 && mediaRecorder && mediaRecorder.state == 'recording') {
                                mediaRecorder.stop();
                            }
                            counter++;
                        }, interval * 1000);

                        /*====================audio sensevitity[Start]=======================*/
                        var audioContext = new AudioContext();
                        var analyser = audioContext.createAnalyser();
                        var microphone = audioContext.createMediaStreamSource(res);
                        javascriptNode = audioContext.createScriptProcessor(2048, 1, 1);

                        analyser.smoothingTimeConstant = 0.8;
                        analyser.fftSize = 1024;

                        microphone.connect(analyser);
                        analyser.connect(javascriptNode);
                        javascriptNode.connect(audioContext.destination);
                        javascriptNode.onaudioprocess = null;
                        javascriptNode.onaudioprocess = function() {
                            var array = new Uint8Array(analyser.frequencyBinCount);
                            analyser.getByteFrequencyData(array);
                            var values = 0;

                            var length = array.length;
                            for (var i = 0; i < length; i++) {
                                values += (array[i]);
                            }

                            var average = values / length;

                            // $log.log(Math.round(average));
                            colorPids(_.max(array));
                            $scope.$apply();
                        };
                        /*====================audio sensevitity[End]=======================*/
                    }
                    checkToProcced();
                })
                .catch(function(err) {
                    vm.mediaErrorMessage = err;
                    vm.needPermission = false;
                    $log.error("The following error occurred: " + err);
                    vm.responseData({ proceed: false, type: 'image', url: '', systemSlow: vm.systemSpeedSlow, reloadEnabled: true });
                });
        }

        function checkToProcced() {
            if (vm.isSecondaryCamera) {
                vm.faceDetectionFound = true;
            }
            if (vm.isActionEnable) {
                if (vm.faceDetectionFound && vm.cameraCheck && vm.micCheck && vm.browserApproved) {
                    vm.isCandidateProctored = true;
                }
            } else {
                if (vm.cameraCheck && vm.micCheck && vm.browserApproved && vm.videoSampleOpts) {
                    vm.isCandidateProctored = true;
                    if (autoStartRecording && !autoStartRecordingInterval) {
                        autoStartRecordingInterval = $interval(function() {
                            vm.startRecordingCounter -= 1;
                            if (vm.startRecordingCounter == 0) {
                                $interval.cancel(autoStartRecordingInterval);
                                vm.sampleVideo();
                            }
                        }, 1000);
                    }
                } else {
                    vm.isCandidateProctored = false;
                    $interval.cancel(autoStartRecordingInterval);
                    autoStartRecordingInterval = null;
                    vm.startRecordingCounter = 30;
                }
            }
        }

        function startRecording() {
            var chunks = [],
                timeOutFunc = vm.stopRecording;
            stoppedRecording = false;
            vm.recordButton = !vm.recordButton;
            var recordingStopped = function(e) {
                var blob = new Blob(chunks, {
                    'type': 'audio/ogg; codecs=opus'
                });
                vm.audsrc = window.URL.createObjectURL(blob);
                vm.audioRecordStarted = true;
            };
            var recordedDataAvailable = function(mChunk) {
                chunks.push(mChunk.data);
            };
            navigator.getUserMedia = navigator.getUserMedia ||
                navigator.webkitGetUserMedia ||
                navigator.mozGetUserMedia;
            if (navigator.getUserMedia) {
                navigator.getUserMedia({
                        audio: true
                    },
                    function(stream) {
                        if (!stream.getAudioTracks().length) {
                            return false;
                        }
                        vm.micCheck = true;
                        fullStream = stream;
                        mediaRecorder = new MediaRecorder(stream);
                        Object.defineProperties(mediaRecorder, {
                            mimeType: {
                                value: 'audio/ogg',
                                writable: true
                            }
                        });
                        mediaRecorder.start();
                        mediaRecorder.ondataavailable = recordedDataAvailable;
                        mediaRecorder.onstop = recordingStopped;
                        recordingTimer = $timeout(timeOutFunc, 7000);
                    },
                    function(err) {
                        $log.log("The following error occurred: " + err.name);
                    }
                );
            } else {
                $log.log("getUserMedia not supported");
            }
        }

        function stopRecording() {
            var i;
            $timeout.cancel(recordingTimer);
            vm.recordButton = !vm.recordButton;
            if (fullStream) {
                tracksList = fullStream.getTracks();
                for (i = 0; i < fullStream.getTracks().length; i++) {
                    var track = fullStream.getTracks()[i];
                    track.stop();
                }
            }
            if (mediaRecorder && false == stoppedRecording) {
                $log.log("recorder being stopped.");
                mediaRecorder.stop();
                vm.audioRecordStarted = true;
                stoppedRecording = true;
            }
        }

        function onOk() {
            trackerService.stopMediaStream();
            if ($rootScope.uibModalInstance) {
                $rootScope.uibModalInstance.dismiss();
            }
        }

        function checkBrowserCompatibility() {
            var cnf = null,
                browserInfo = assessmentUtility.getBrowserInfo(navigator.userAgent),
                isOnlyGlobal = false;
            getBrowserVersionInfo(isOnlyGlobal)
                .then(function(res) {
                    browserLowerLimit = res && res.browserLowerLimit ? res.browserLowerLimit : browserLowerLimit;
                    browserUpperLimit = res && res.browserUpperLimit ? res.browserUpperLimit : null;
                    if (vm.isMediaQuestion && res && res.videoAnswerFrameRate) {
                        sessionStorage.setItem('frameRate', JSON.stringify(res.videoAnswerFrameRate));
                    } else if (res && res.videoRecordingFrameRate) {
                        sessionStorage.setItem('frameRate', JSON.stringify(res.videoRecordingFrameRate));
                    }
                    if (browserInfo.browser === 'chrome' && browserInfo.version >= browserLowerLimit) {
                        vm.browserApproved = browserUpperLimit ? browserInfo.version <= browserUpperLimit : true;
                        if (vm.overAllStatus) {
                            vm.overAllStatus.browserApproved = vm.browserApproved;
                        }
                    }
                    /*else if (browserInfo.browser === 'mozilla' && browserInfo.version > 58) {
                                   vm.browserApproved = true;
                               }*/
                    else {
                        vm.browserApproved = false;
                    }
                    if (!vm.browserApproved) {
                        if (!browserUpperLimit) {
                            vm.brwsrCompatibilityMsg = "Please use Chrome " + browserLowerLimit + " or above.";
                        } else if (browserLowerLimit) {
                            vm.brwsrCompatibilityMsg = "Unsupported browser or browser version. Please use Google Chrome version " + browserLowerLimit + " to " + browserUpperLimit + ".";
                        } else {
                            vm.brwsrCompatibilityMsg = "Please use Chrome below " + browserUpperLimit + " .";
                        }
                    }
                    if (angular.isDefined(res.imageTrackingCaptureCount)) {
                        sessionStorage.setItem('imageCaptureCount', res.imageTrackingCaptureCount);
                    }
                    checkToProcced();
                });
        }

        function getBrowserVersionInfo(isOnlyGlobal) {
            if (vm.isAuthenticated === false) {
                $q.when(null);
            }
            return proctoringService.utility.getProctoringConfig(isOnlyGlobal)
                .then(function(res) {
                    if (!res) {
                        $log.log("Not able to fetch proctoring config");
                        return null;
                    }
                    return res;
                });
        }

        function clickImage() {
            vm.showImage = true;
            vm.captured = true;
            vm.loading = true;
            vm.imageURL = imageTracker.getImage(true, true);
            proctorService.captureImageTemp().then(function(val) {
                goldenImageUrl = val;
                vm.loading = false;
                var backgroundProcess = true;
                if(flag.faceThresholds && flag.faceThresholds.backgroundProcess !== undefined){
                    backgroundProcess = flag.faceThresholds.backgroundProcess;
                }
                if (flag.faceThresholds && flag.faceThresholds.toCheck == true) {
                    fileIOHelper.dataURItoBlob(vm.imageURL, "goldenimage.jpeg").then(function(resp) {
                        var fd = new FormData();
                        fd.append('file', resp);
                        blockUI.start();
                        proctorService.checkForFace(fd,backgroundProcess).then(function(res) {
                            console.log('IMAGE CLICK KE BAAD', res);
                            vm.processed = true;
                            blockUI.stop();
                            processFaceData(res.data);                            
                            startCapturingGoldenImages();
                        },function(){
                            console.log('IMAGE CLICK FAIL');
                            blockUI.stop();
                            vm.captured = false;
                            vm.showImage = false;
                        });
                    });
                } else {
                    vm.responseData({ proceed: true, type: 'image', url: val });
                    startCapturingGoldenImages();
                }
            });
        }

        function startCapturingGoldenImages() {
            if (assessmentUtility.sessionStorage.getData("collectedInitialImages") === "true") {
                return true;
            }
            proctoringService.utility.getProctoringConfig().then(function(proctoringConfig) {
                if (proctoringConfig.serverFaceRecognitionConfig && proctoringConfig.serverFaceRecognitionConfig.isHireProFaceRecognitionEnabled) {
                    vm.collectingGoldenImages = true;
                    blockUI.start();
                    // var goldenImageUploadPromises = proctorService.startCapturingGoldenImages();
                    // $q.all([goldenImageUploadPromises]).then(function() {
                    //     assessmentUtility.sessionStorage.setData("collectedInitialImages", "true");
                    //     vm.collectingGoldenImages = false;
                    //     blockUI.stop();
                    // })
                    proctorService.startCapturingGoldenImages().then(function() {
                        assessmentUtility.sessionStorage.setData("collectedInitialImages", "true");
                        vm.collectingGoldenImages = false;
                        blockUI.stop();
                    })
                }
            })
        }

        function processFaceData(temp) {
            console.log('processing FACE', temp);
            if (temp.faceObjects && temp.faceObjects.face_count === 1) {
                var brightness = parseInt(temp.faceObjects.faces[0].brightness),
                    sharpness = parseInt(temp.faceObjects.faces[0].sharpness);
                if (brightness >= flag.faceThresholds.brightness && sharpness >= flag.faceThresholds.sharpness) {
                    vm.responseData({ proceed: true, type: 'image', url: goldenImageUrl });
                } else {
                    vm.apiErrorMsgStatus = true;
                    vm.apiErrorMsg = vm.selfieCheckErrorMessages['poorLight'];
                }
            } else if (temp.faceObjects && temp.faceObjects.face_count === 0) {
                vm.apiErrorMsgStatus = true;
                vm.apiErrorMsg = vm.selfieCheckErrorMessages['noFace'];
            } else if (temp.faceObjects && temp.faceObjects.face_count > 1) {
                vm.apiErrorMsgStatus = true;
                vm.apiErrorMsg = vm.selfieCheckErrorMessages['multipleFaces'];
            } else {
                vm.apiErrorMsgStatus = true;
                vm.apiErrorMsg = vm.selfieCheckErrorMessages['default'];
            }
            trackerService.brightnessCheckLog(temp.faceObjects);
        }

        function captureAgain() {
            vm.showImage = false;
            vm.captured = false;
            vm.imageURL = '';
            vm.apiErrorMsgStatus = false;
            vm.apiErrorMsg = '';
            vm.responseData({ proceed: false, type: 'image' });
        }

        function savePersistance() {
            proctorService.savePersistence(goldenImageUrl).then(function(res) {
                assessmentUtility.localStorage.setData('savedinS3GoldenImagePath', res);
            });
            trackerService.stopMediaStream();
            $scope.$parent.$hide();
            if ((vm.isMediaQuestion || vm.videoProctoringMode) &&
                trackerService.config.isSampleVideoRecordingEnable) {
                var data = {
                    opts: {
                        type: vm.isMediaQuestion ? 'videoAnswer' : 'videoProctoring'
                    },
                    isAction: true,
                    modalSize: 'lg',
                    action: {
                        isOkBtn: true
                    }
                };
                openModalService.showModal('videoAnswer', data, $scope);
            }
        }

        function sampleVideo() {
            $interval.cancel(autoStartRecordingInterval);
            vm.startRecordingCounter = 0;
            // autoStartRecordingInterval = null;
            if (vm.videoSampleOpts) {
                trackerService.stopMediaStream();
                javascriptNode.disconnect();
                openModalService.openModal('videoAnswer', vm.videoSampleOpts, $scope).then(function(res) {
                    activate();
                    // startFaceTracking();
                    // checkMic({ audio: true, video: true });
                    res.result.videoCompatibilityInfo.systemSlow = systemSlow;
                    vm.responseData({ info: res.result.videoCompatibilityInfo });
                });
            }
        }

        function getGuid() {
            var uuid = sessionStorage.getItem('x-guid'),
                xGuidCounter = Number(sessionStorage.getItem('xGuidCounter') || 0) + 1;
            uuid = uuid || 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
                var r = Math.random() * 16 | 0,
                    v = c == 'x' ? r : (r & 0x3 | 0x8);
                return v.toString(16);
            });
            sessionStorage.setItem('x-guid', uuid); //added this line to keep same quid through out the application
            sessionStorage.setItem('xGuidCounter', xGuidCounter);
            return uuid + '_' + xGuidCounter;
        }

        function callServices(url, json, method, headers) {
            var config = {};
            if (headers) {
                config.headers = headers;
            }
            method = method ? method : 'post';

            return $http[method](url, json, config).then(
                function(data) {
                    return data;
                },
                function(data) {
                    return data;
                });
        }

        function startSpeedTest() {
            var downloadSpeed, uploadSpeed, domainName;
            flag = loginInfo.assessmentConfig;
            vm.inProgress = true;
            if (flag && flag.isSpeedTestAllowed && flag.isSpeedTestAllowed === true) {
                vm.toCheckSpeedTest = true;
                $timeout(function() {
                    if (angular.isUndefined(vm.systemInfo.upload) || angular.isUndefined(vm.systemInfo.download)) {
                        vm.systemInfo.timedOutInSec = networkCheckingDuration;
                        $log.log('TIMEOUT HAPPENEND');
                        vm.inProgress = false;
                        vm.speedTestStatus = false;
                        vm.speedClass = 'bad one-bar';
                        // vm.responseData({ proceed: false, type: 'image', url: '', systemSlow: vm.systemSpeedSlow, reloadEnabled: true });
                    }
                }, networkCheckingDuration);
                var req = { d: '', 'disableBlockUI': true },
                    bytes8 = '.......!',
                    reqSizeInbytes = 1 * 1024 * 1024;
                for (var i = 0; i < reqSizeInbytes / 8; i++) {
                    req.d += bytes8;
                }
                var header = { 'x-guid': getGuid() };
                if (flag && flag.uploadBandwidthDomainName) {
                    domainName = flag.uploadBandwidthDomainName;
                } else {
                    domainName = 'https://bwidthnew.hirepro.in'
                }
                callServices(domainName + '/bwidth/measure', req, 'post', header).then(function(res) {
                    callServices(domainName + '/bwidth/bwidth.txt', {}, 'post', header).then(function(res) {
                        uploadSpeed = 8 / res.data;
                        $log.log('UPLOAD SPEED', uploadSpeed)
                        vm.systemInfo.upload = uploadSpeed;
                    });
                });
            } else {
                vm.speedTestStatus = true;
                // vm.responseData({ proceed: false, type: 'image', url: '', systemSlow: vm.systemSpeedSlow, reloadEnabled: vm.systemSpeedSlow ? true : false });
            }
        }

        function speedTestStandAlone() {
            var downloadSpeed, uploadSpeed, domainName;
            if (loginInfo && loginInfo.assessmentConfig) {
                flag = loginInfo.assessmentConfig;
            }
            // vm.inProgress = true;
            // if (flag && flag.isSpeedTestAllowed && flag.isSpeedTestAllowed === true) {
            //   vm.toCheckSpeedTest = true;
            $timeout(function() {
                if (angular.isUndefined(vm.systemInfo.upload) || angular.isUndefined(vm.systemInfo.download)) {
                    vm.systemInfo.timedOutInSec = networkCheckingDuration;
                    $log.log('TIMEOUT HAPPENEND');
                    vm.inProgress = false;
                    vm.speedTestStatus = false;
                    vm.speedClass = 'bad one-bar';
                    // vm.responseData({ proceed: false, type: 'image', url: '', systemSlow: vm.systemSpeedSlow, reloadEnabled: true });
                }
            }, networkCheckingDuration);
            var req = { d: '', 'disableBlockUI': true },
                bytes8 = '.......!',
                reqSizeInbytes = 1 * 1024 * 1024;
            for (var i = 0; i < reqSizeInbytes / 8; i++) {
                req.d += bytes8;
            }
            var header = { 'x-guid': getGuid() };
            if (flag && flag.uploadBandwidthDomainName) {
                domainName = flag.uploadBandwidthDomainName;
            } else {
                domainName = 'https://bwidthnew.hirepro.in'
            }
            callServices(domainName + '/bwidth/measure', req, 'post', header).then(function(res) {
                callServices(domainName + '/bwidth/bwidth.txt', {}, 'post', header).then(function(res) {
                    uploadSpeed = 8 / res.data;
                    $log.log('UPLOAD SPEED', uploadSpeed);
                    vm.internetSpeed.uploadSpeed = Number(parseFloat(uploadSpeed).toFixed(2));
                    vm.internetSpeed.uploadBandwidthText = getBandwidthLevel(uploadSpeed * 1024);
                    console.log('SS ', vm.internetSpeed);
                });
            });
            // } else {
            //     vm.speedTestStatus = true;
            //     // vm.responseData({ proceed: false, type: 'image', url: '', systemSlow: vm.systemSpeedSlow, reloadEnabled: vm.systemSpeedSlow ? true : false });
            // }
        }

        function onTestCompleted(request) {
            vm.inProgress = false;
            $interval.cancel(completeTestInterval);
            completeTestInterval = undefined;
            $log.log('TEST COMPLETED', request);
            var downloadSpeed = request.download,
                uploadSpeed = request.upload,
                thresholdUploadVal, thresholdDownloadVal,
                logData = {};
            if (vm.isMediaQuestion && (angular.isDefined(flag.videoAnswer))) {
                if (((angular.isDefined(flag.videoAnswer.downloadNetSpeedLimit)) && (Math.round(downloadSpeed * 100) >= Math.round(flag.videoAnswer.downloadNetSpeedLimit * 100))) &&
                    ((angular.isDefined(flag.videoAnswer.uploadNetSpeedLimit)) && (Math.round(uploadSpeed * 100) >= Math.round(flag.videoAnswer.uploadNetSpeedLimit * 100)))) {
                    vm.speedTestStatus = true;
                    if (downloadSpeed >= 2 && uploadSpeed >= 2) {
                        vm.speedClass = 'good three-bars';
                    } else {
                        vm.speedClass = 'ok two-bars';
                    }
                } else {
                    vm.speedTestStatus = false;
                    vm.speedClass = 'bad one-bar';
                    // vm.responseData({ proceed: false, type: 'image', url: '', systemSlow: vm.systemSpeedSlow, reloadEnabled: true });
                }
                thresholdUploadVal = flag.videoAnswer.uploadNetSpeedLimit;
                thresholdDownloadVal = flag.videoAnswer.downloadNetSpeedLimit;
            } else {
                if (((angular.isDefined(flag.downloadNetSpeedLimit)) && (Math.round(downloadSpeed * 100) >= Math.round(flag.downloadNetSpeedLimit * 100))) &&
                    ((angular.isDefined(flag.uploadNetSpeedLimit)) && (Math.round(uploadSpeed * 100) >= Math.round(flag.uploadNetSpeedLimit * 100)))) {
                    vm.speedTestStatus = true;
                    if (downloadSpeed >= 2 && uploadSpeed >= 2) {
                        vm.speedClass = 'good three-bars';
                    } else {
                        vm.speedClass = 'ok two-bars';
                    }
                    // vm.responseData({ proceed: false, type: 'image', url: '', systemSlow: vm.systemSpeedSlow, reloadEnabled: vm.systemSpeedSlow ? true : false });
                } else {
                    vm.speedTestStatus = false;
                    vm.speedClass = 'bad one-bar';
                    // vm.responseData({ proceed: false, type: 'image', url: '', systemSlow: vm.systemSpeedSlow, reloadEnabled: true });
                }
                thresholdUploadVal = flag.uploadNetSpeedLimit;
                thresholdDownloadVal = flag.downloadNetSpeedLimit;
            }

            logData = {
                'upload': uploadSpeed,
                'download': downloadSpeed,
                'thresholdUpload': thresholdUploadVal,
                'thresholdDownload': thresholdDownloadVal
            }
            trackerService.systemNetSpeedLog(logData);
        }

        function onImageLoad() {
            var endTime = new Date();
            vm.systemInfo.timetaken = (endTime.getTime() - startTime.getTime()) / 1000;
            $log.log(vm.systemInfo.timetaken);
            vm.systemInfo.bandWidthLevel = (imgsize * 8 / vm.systemInfo.timetaken) * 100;
            vm.systemInfo.bandWidth = Math.round(vm.systemInfo.bandWidthLevel / 1048576) / 100;
            vm.systemInfo.bandWidthLevel = Math.round(vm.systemInfo.bandWidthLevel / 1024) / 100;
            $log.log('IMAGE DOWNLOAD', vm.systemInfo);
            vm.systemInfo.download = vm.systemInfo.bandWidth;
            if (vm.internetSpeed) {
                vm.internetSpeed.downloadSpeed = vm.systemInfo.bandWidth;
                vm.internetSpeed.downloadBandwidthText = getBandwidthLevel(vm.systemInfo.bandWidthLevel);
            }
            if (angular.isDefined(vm.systemInfo.upload)) {
                onTestCompleted(vm.systemInfo);
            } else {
                if (angular.isDefined(completeTestInterval)) return;
                completeTestInterval = $interval(function() {
                    if (angular.isDefined(vm.systemInfo.upload)) {
                        onTestCompleted(vm.systemInfo);
                    }
                }, 1000);
            }



        }

        function getBandwidthLevel(bandwidth) {
            if (bandwidth < 1024)
                return 'Low';
            else if (bandwidth < 1024 * 5)
                return 'Medium';
            else
                return 'High';
        }

        function loadZohoChat() {
            window.$zoho = window.$zoho || {};
            window.$zoho.salesiq = window.$zoho.salesiq || { widgetcode: zohoChatWidgetCode, values: {}, ready: function() {} };
            var d = document;
            var s = d.createElement("script");
            s.type = "text/javascript";
            s.id = "zsiqscript";
            s.defer = true;
            s.src = "https://salesiq.zoho.in/widget";
            var t = d.getElementsByTagName("script")[0];
            t.parentNode.insertBefore(s, t);
            var u = d.createElement('div');
            u.setAttribute("id", "zsiqwidget");
            d.body.appendChild(u);
            window.$zoho.salesiq.ready = function() {
                window.$zoho.salesiq.floatbutton.coin.hidetooltip();
                getChatDataReady();
            }            
        }

        function getChatDataReady() {
            var info = {
                CandidateName: loginInfo.CandidateName,
                CandidateEmail: loginInfo.CandidateEmail,
                CandidateId: loginInfo.CandidateId,
                TestId: loginInfo.TestId,
                TestUserId: loginInfo.testUserId
            };
            window.$zoho.salesiq.ready = function() {
                $zoho.salesiq.visitor.info(info);
            }();
        }

        function getOath2Access() {
            var request = {client_id: 'e81c8616-45d3-467f-92a9-5879f6f025f1'},
                integrationGUID = 'b856455e56444f96a9dd998b7347b549';
            if(vm.otherConfig.clientId) {
                request.client_id = vm.otherConfig.clientId;
            }
            if(vm.otherConfig.integrationGUID) {
                integrationGUID = vm.otherConfig.integrationGUID;
            }
            return webService.execute('/py/oauth2/' + integrationGUID + '/access_token/', request).then(
                function(res) {
                    return res.data;
                },
                function() {
                }
            );
        }

        function getNodeInfoForSocketCompatibilityCheck() {
            return webService.execute('getNodeInfoForSocketCompatibilityCheck', {}).then(
                function(res) {
                    return res.data;
                },
                function() {
                }
            );
        }

        function checkSocketCompatibiliy(url, subProtocol) {
            var deffered = $q.defer();
            try {
                var socket;
                if(subProtocol) {
                    socket = new WebSocket(url, subProtocol);    
                } else {
                    socket = new WebSocket(url);
                }
                

                socket.onopen = function(e) {
                    console.log(url + ': Pass');
                    deffered.resolve(true);
                    //socket.send("My name is John");
                };

                socket.onmessage = function(event) {
                  //alert(`[message] Data received from server: ${event.data}`);
                };

                socket.onclose = function(event) {
                  if (event.wasClean) {
                    //alert(`[close] Connection closed cleanly, code=${event.code} reason=${event.reason}`);
                  } else {
                    // e.g. server process killed or network down
                    // event.code is usually 1006 in this case
                    //alert('[close] Connection died');
                  }
                };

                socket.onerror = function(error) {
                    console.log(url + ': Fail');
                    deffered.resolve(false);
                };
            } catch(ex) {
                console.log(url + ': Fail');
                deffered.resolve(false);
            }
                
            return deffered.promise;
        }
    }

    function imageonload() {
        return {
            restrict: 'A',
            link: function(scope, element, attrs) {
                element.bind('load', function() {
                    //call the function that was passed
                    scope.$apply(attrs.imageonload);
                });
            }
        };
    }

})();

(function() {
    'use strict';
    angular
        .module('OnlineAssessmentAngular')
        .controller('MsgPageController', MsgPageController);
    /* @ngInject */

    function MsgPageController($stateParams, $sce, debuggerService, webRtcStatsService) {
        var vm = this,
            isLogout = false,
            logoutMsg = '';

        vm.message = '';

        init();

        function init() {
            var isSessionExpired = JSON.parse(sessionStorage.getItem('isSessionExpired'));
            sessionStorage.setItem('changeLogPushingIntervalValue', '');
            webRtcStatsService.stopAll();
            console.log($stateParams.stateParams);
            vm.message = ($stateParams && $stateParams.stateParams) ? atob($sce.trustAsHtml(decodeURIComponent($stateParams.stateParams))) : '';
            logoutMsg = vm.message;
            if ($stateParams && $stateParams.isLogout) {
                isLogout =  atob(decodeURIComponent($stateParams.isLogout)) === 'true' ? true : false;
                logoutMsg =  ($stateParams && $stateParams.msg) ? atob(decodeURIComponent($stateParams.msg)) : vm.message;
            }
            console.log(vm.message);
            if (!isSessionExpired) {
                sendDebugLog();
            }
        }

        function sendDebugLog() {
            var log = {
                msg: {
                    message: vm.message,
                    timestamp: new Date()
                },
                source: 'messagePageLog'
            };
            if (isLogout) {
                log.msg.message = logoutMsg;
                log.source = 'logoutReason';
            }
            debuggerService.log(log);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('OnlineAssessmentAngular')
        .component('loginTest', {
            controller: loginController,
            controllerAs: 'vm',
            templateUrl: 'app/assessment/login.tpl.html'
        });

    loginController.$inject = [
        '$rootScope',
        'loginService',
        '$state',
        'assessmentUtility',
        '$window',
        '$scope',
        '$location',
        '$timeout',
        'blockUI',
        '$log',
        'commonService',
        '$q',
        'openModalService',
        '$interval',
        'deviceDetector',
        'afterSubmission',
        '$sce'
    ];

    function loginController($rootScope, loginService, $state, assessmentUtility, $window, $scope, $location, $timeout, blockUI, $log, commonService, $q, openModalService, $interval, deviceDetector, afterSubmission, $sce) {
        /* jshint validthis: true */
        var vm = this,
            isLoginStarted = false,
            delayUpto;

        // vm.ApplicationViewType = sessionStorage.getItem('ApplicationViewType');
        vm.isOnlinePreview = false;
        //vm.IsLocalStorageAvailable = true;
        // vm.currentDate = new Date();
        // vm.winHeight = window.innerHeight;
        vm.isDesktop = deviceDetector.isDesktop();
        vm.termsOfUse = '/s3_cached/hirepro-content/hirepro/static-resources/termsandconditions.html';
        vm.privacyPolicy = '/s3_cached/hirepro-content/hirepro/static-resources/privacypolicy.html';
        vm.hideHireproBranding = null;

        /*Methods*/
        vm.LoginToTest = LoginToTest;
        vm.termsAndPrivacyPolicy = termsAndPrivacyPolicy;
        vm.simulateUnscore = simulateUnscore;
        vm.isDebugMode = sessionStorage.debug === 'true' ? true : false;
        vm.debugData;
        vm.disableLoginButton = false;

        $rootScope.$watch('companyLogoUrl', function() {
            vm.companyLogoUrl = $rootScope.companyLogoUrl;
            /// ======================== nseit hardcode changes [start] ===================== ///
            if (sessionStorage.isNseitTenant) {
                vm.companyLogoUrl = 'assets/images/nse-logo.png';
            }
            /// ======================== nseit hardcode changes [ends] ===================== ///
            vm.defaultLogoUrl = 'assets/images/hirepro_logo.png';
            console.log(vm.companyLogoUrl, vm.defaultLogoUrl);
        });
        vm.$onInit = function() {
            readUrl();
        };

        function readUrl() {
            vm.tenantId = -1;
            //blockUI.start();
            var paramObj;
            try {
                paramObj = assessmentUtility.getSateParameters($state.params);
                if (paramObj.viewType) {
                    sessionStorage.setItem('ApplicationViewType', paramObj.viewType);
                }
            } catch (error) {
                $state.go('landing', {}, { location: 'replace' });
                return;
            }
            if (!paramObj) {
                //blockUI.stop();
                $state.go('default', {}, { location: 'replace' });
                return false;
            }
            vm.alias = paramObj.alias;
            var savedAlias = $window.sessionStorage.getItem("oa_tenantAlias");
            savedAlias = !savedAlias ? vm.alias : savedAlias;
            if (!vm.alias || vm.alias !== savedAlias) {
                return false;
            }
            $window.sessionStorage.setItem("oa_tenantAlias", vm.alias);
            preLogin(paramObj);
            assessmentUtility.disableBackButton(location.href);
            assessmentUtility.checkLocalStorageUsedSize();
            assessmentUtility.localStorage.setData('onlineAssessmentStatus', 'testStarted');
            sessionStorage.removeItem('X-AUTH-TOKEN');
            sessionStorage.removeItem('OLD-X-AUTH-TOKEN');
            // Read Query params added by client
            var data = $location.search();
            console.log('qyery param', data);
            if (data) {
                _.each(data, function(val, key) {
                    sessionStorage.setItem('external_' + key, val);
                });
            }
        }

        function preLogin(paramObj) {
            vm.autologin = !!paramObj.autologin;
            vm.isOnlinePreview = !!paramObj.isOnlinePreview;
            var previewToken = paramObj.previewToken;

            vm.userId = paramObj.uid;
            vm.userPassword = paramObj.pswd;
            vm.loginToken = paramObj.loginToken;
            if (vm.userId && vm.userPassword) {
                vm.loginName = vm.userId;
                vm.loginPassword = vm.userPassword;
            }
            loginService.getCompanyInfo(paramObj.alias)
                .then(function(response) {
                        if (!response.tenantId) {
                            $log.info('Tenant not found!');
                            return false;
                        }
                        if (vm.alias.startsWith('accenture')) {
                            vm.privacyPolicy = 'https://www.accenture.com/in-en/about/privacy-policy';
                            vm.termsOfUse = '/s3_cached/hirepro-content/hirepro/static-resources/termsandconditions-accenture.html';
                        } else if (sessionStorage.privacyPolicy) {
                            vm.privacyPolicy = sessionStorage.privacyPolicy;
                        }
                        if (response.content) {
                            vm.companyInfo = response.content.CompanyInfo;
                            $window.sessionStorage.setItem(paramObj.alias + "_termsAndCondition", response.content.TermsAndCondition);
                            vm.hideHireproBranding = response.content.hideHireproBranding ? true : false;
                            /// ======================== nseit hardcode changes [start] ===================== ///
                            if (sessionStorage.isNseitTenant) {
                                vm.isNseitTenant = true;
                                vm.hideHireproBranding = true;
                                vm.termsOfUse = null;
                                vm.privacyPolicy = null;
                            }
                            /// ======================== nseit hardcode changes [ends] ===================== ///
                            if (response.content.hideTermsAndConditions) {
                                vm.hideTermsAndConditions = true;
                            }
                        }
                        if (vm.autologin || (vm.isOnlinePreview && previewToken && previewToken.trim() !== "")) {
                            if (vm.isOnlinePreview) {
                                assessmentUtility.localStorage.setData("_isOnlinePreview", vm.isOnlinePreview);
                                // assessmentUtility.cookies.set('X-AUTH-TOKEN', previewToken);
                                sessionStorage.setItem('X-AUTH-TOKEN', previewToken);
                            }
                            LoginToTest();
                        }
                    },
                    function(res) {
                        $log.log(res.msg);
                        return false;
                    }
                );
        }

        function checkLoginPrereq() {
            vm.loginInfo = loginService.getLoginInfo();
            var previewSecurityKey = vm.loginInfo.Config.PreviewSecurityKey;
            if (vm.isOnlinePreview &&
                angular.isDefined(previewSecurityKey) &&
                !!previewSecurityKey &&
                previewSecurityKey !== 'vB4VBFG9wR8=') {
                validatePreviewKey();
            } else {
                switchToStartTest();
                // $state.go('assess.startTest', { 'alias': vm.alias }, { location: 'replace' });
            }
        }

        function simulateUnscore() {
            /*var nextTestInfos = null, jjj = {};
            var res ={"status": "OK", "data": {"JobState": "SUCCESS", "Result": "{\"status\": \"OK\", \"data\": {\"isSuccess\": true, \"isAutoShortlisting\": false, \"nextTestLinks\": [\"https://amsin.hirepro.in/assessment/#/assess/login/eyJhbGlhcyI6ICJBVCIsICJwc3dkIjogIlZDNC9kMHRXWVVVPSIsICJhdXRvbG9naW4iOiAiZEhKMVpRPT0iLCAidWlkIjogIlFWUXhNREV4TlRFeU9UazJORGs9In0=\"], \"nextTestInfos\": [{\"proxyUrl\": null, \"password\": \"T.?wKVaE\", \"loginId\": \"AT101151299649\", \"testId\": 10115, \"candidateId\": 1299649}]}, \"statusId\": 200}", "ExecutionComplete": true}};
            // Checking for Invalid cases
            if (!res || !res.data) {
                return $q.reject({
                    msg: "API Failed"
                });
            }
            res = res.data;
            if (res.ExecutionComplete) {
                try {
                    res = JSON.parse(res.Result);
                } catch (e) {
                    return $q.reject({
                        msg: "JSON responsed by api can not be parsed"
                    });
                }
                if (res.status !== 'OK' || !res.data) {
                    return $q.reject({
                        msg: "JSON responsed by api can not be parsed"
                    });
                }

                if (res.data.isAutoShortlisting) {
                    jjj.shortlistingStat = res.data.nextTestInfos || res.data.nextTestLinks ? 0 : 1;
                }

                if(res.data.isSuccess === false) {
                    jjj.errormessage = '<h4 style="margin-bottom: 35px;line-height: 0px;">Someone from the talent team will contact you for the next steps.</h4>';
                }
                if (_.size(res.data.nextTestInfos)) {
                    nextTestInfos = res.data.nextTestInfos[0];
                } else if (_.size(res.data.nextTestLinks)) {
                    nextTestInfos = {nextTestUrl: res.data.nextTestLinks[0]};
                }else {
                    $log.error("No Next Test found.");
                }

                jjj.isAutoTest = (res.data.isAutoShortlisting || nextTestInfos) ? true : false;

                jjj.isUnscorable = res.data.isUnscorable;
                if (res.data.isUnscorable) {
                    jjj.isAutoTest = false;
                }*/

            var nextTestInfos = null,
                jjj = {},
                data = {};
            var res = { "status": "OK", "data": { "JobState": "SUCCESS", "Result": "{\"status\": \"OK\", \"data\": {\"isSuccess\": true, \"isAutoShortlisting\": false, \"nextTestLinks\": [\"https://amsin.hirepro.in/assessment/#/assess/login/eyJhbGlhcyI6ICJBVCIsICJwc3dkIjogIlZDNC9kMHRXWVVVPSIsICJhdXRvbG9naW4iOiAiZEhKMVpRPT0iLCAidWlkIjogIlFWUXhNREV4TlRFeU9UazJORGs9In0=\"], \"nextTestInfos\": [{\"proxyUrl\": null, \"password\": \"T.?wKVaE\", \"loginId\": \"AT101151299649\", \"testId\": 10115, \"candidateId\": 1299649}]}, \"statusId\": 200}", "ExecutionComplete": true } };
            if (vm.debugData) {
                res = JSON.parse(vm.debugData);
            }
            // Checking for Invalid cases
            if (!res || !res.data) {
                res = { JobState: 'PENDING' };
            } else {
                res = res.data;
            }
            // Checking whether task has completed or not
            if (res.ExecutionComplete) {
                // finally the execution has been copmpleted
                try {
                    data.jsonResponse = angular.fromJson(res.Result);
                } catch (e) {
                    return $q.reject({
                        msg: "JSON responsed by api can not be parsed"
                    });
                }

                if (data.jsonResponse.status !== 'OK' || !data.jsonResponse.data) {
                    return $q.reject({
                        msg: "JSON responsed by api has error"
                    });
                }

                if (data.jsonResponse.data.isAutoShortlisting) {
                    jjj.shortlistingStat = data.jsonResponse.data.nextTestInfos || data.jsonResponse.data.nextTestLinks ? 0 : 1;
                }

                if (data.jsonResponse.data.isSuccess === false) {
                    jjj.errormessage = '<h4 style="margin-bottom: 35px;line-height: 0px;">Someone from the talent team will contact you for the next steps.</h4>';
                }
                if (_.size(data.jsonResponse.data.nextTestInfos)) {
                    nextTestInfos = data.jsonResponse.data.nextTestInfos[0];
                } else if (_.size(data.jsonResponse.data.nextTestLinks)) {
                    nextTestInfos = { nextTestUrl: data.jsonResponse.data.nextTestLinks[0] };
                } else {
                    $log.error("No Next Test found.");
                }

                jjj.isAutoTest = (data.jsonResponse.data.isAutoShortlisting || nextTestInfos) ? true : false;
                jjj.isUnscorable = data.jsonResponse.data.isUnscorable;
                if (data.jsonResponse.data.isUnscorable) {
                    jjj.isAutoTest = false;
                }

                if (nextTestInfos) {
                    var nextStateParams = null;
                    var uid = null,
                        pswd = null;
                    if (nextTestInfos.loginId && !_.isEmpty(nextTestInfos.loginId.trim())) {
                        uid = btoa(nextTestInfos.loginId);
                    }
                    if (nextTestInfos.password && !_.isEmpty(nextTestInfos.password.trim())) {
                        pswd = btoa(nextTestInfos.password);
                    }
                    if (nextTestInfos) {
                        nextStateParams = {
                            'alias': 'at',
                            'autologin': btoa(true),
                            'uid': uid,
                            'pswd': pswd,
                            'isOnlinePreview': btoa(false),
                            'proxyUrl': nextTestInfos.proxyUrl,
                            'nextTestUrl': nextTestInfos.nextTestUrl
                        };
                    }
                }

                var nxtTestParamObj = {
                    'alias': 'at',
                    'nextTestStateParams': nextStateParams,
                    'isAutoTestEnabled': jjj.isAutoTest,
                    'shortlistingStat': jjj.shortlistingStat,
                    'shortlistingMessage': jjj.shortlistingMessage,
                    'errormessage': jjj.errormessage,
                    'isUnscorable': jjj.isUnscorable
                };
                $state.go('submitConfirmation', nxtTestParamObj, { 'reload': true, 'location': 'replace' });
            }
        }

        function LoginToTest() {
            vm.disableLoginButton = true;
            blockUI.start();
            if (isLoginStarted) {
                return false;
            }
            isLoginStarted = true;
            var alias = assessmentUtility.getAlias(),
                cnf = null,
                ls = assessmentUtility.localStorage;
            //ck = assessmentUtility.cookies;
            vm.tenantId = loginService.getTenantId();
            if (!vm.isOnlinePreview && (!vm.loginName || !vm.loginPassword) && (!vm.autologin && !vm.loginToken)) {
                vm.loginInfo = { "IsException": true };
                if (vm.tenantId === -1) {
                    vm.loginInfo.description = "Try again";
                }
                vm.loginInfo.description = "Please enter username or password.";
                return false;
            }
            //blockUI.start();
            assessmentUtility.getClientInfo()
                .then(function(res) {
                    var loginToTestRequest = {
                        'ClientSystemInfo': res.clientInfo,
                        'IPAddress': res.ip,
                        'IsOnlinePreview': vm.isOnlinePreview,
                        'LoginName': vm.loginName ? vm.loginName.trim() : "",
                        'Password': vm.loginPassword ? vm.loginPassword.trim() : "",
                        'TenantAlias': vm.alias,
                        'LoginToken': vm.loginToken,
                        'clientDateTime': new Date()
                    };
                    return loginService.login(loginToTestRequest, vm.isOnlinePreview); //, vm.tenantId.toString()
                })
                .then(function(res) {
                    vm.loginInfo = res || {};
                    if (vm.loginInfo.status === 'OK') {
                        blockUI.stop();
                    } else {
                        $timeout(function() {
                            blockUI.stop();
                            vm.disableLoginButton = false;
                        }, 10 * 1000);
                    }
                    if (vm.loginInfo.Config) {
                        cnf = vm.loginInfo.Config;
                        if (cnf.isSecureBrowserMandatory) {
                            sessionStorage.setItem('isSecureBrowserMandatory', vm.loginInfo.Config.isSecureBrowserMandatory);
                        }
                        if (cnf.secondaryCamera) {
                            sessionStorage.setItem("isSecondaryCameraEnable", !!cnf.secondaryCamera.isEnabled);
                        }
                        if (cnf.roomScan360Config && cnf.roomScan360Config.isRequired) {
                            sessionStorage.setItem("isroomScanEnabled", cnf.roomScan360Config.isRequired);
                        } else {
                            sessionStorage.setItem("isroomScanEnabled", false);
                        }

                    }
                    if (vm.loginInfo.assessmentConfig) {

                        // if (vm.loginInfo.assessmentConfig && vm.loginInfo.assessmentConfig.roomScan360 !== undefined || vm.loginInfo.assessmentConfig !== null){
                        //     sessionStorage.setItem("isroomScanEnabled",!!vm.loginInfo.assessmentConfig.roomScan360);
                        // }
                        var assCnf = vm.loginInfo.assessmentConfig;

                        if (assCnf.cheatingWarning) {
                            var cheat = assCnf.cheatingWarning;

                            sessionStorage.setItem("initialCheatingWarning", cheat.initialCheatingWarning);
                            sessionStorage.setItem("inTestCheatingWarning", cheat.inTestCheatingWarning);
                        }
                        //Below cookie has meaning for Pearson test only
                        var pearsonTestMode = 'iframe'; //iframe/popup
                        if (vm.loginInfo.assessmentConfig && vm.loginInfo.assessmentConfig.pearsonTestMode === 'popup') {
                            pearsonTestMode = 'popup';
                        }
                        sessionStorage.setItem('pearsonTestMode', pearsonTestMode);
                        assessmentUtility.cookies.set('X-P-TESTMODE', pearsonTestMode, true); // X-P-TEST-MODE = X-Pearson-TEST-MODE


                    }
                    if (res.statusCode !== 200 || res.status !== "OK") {
                        return $q.reject(res);
                    }
                    ls.setData("_isOnlinePreview", vm.isOnlinePreview);
                    if (!vm.isOnlinePreview && vm.loginInfo.Token) {
                        // ck.set('X-AUTH-TOKEN', vm.loginInfo.Token);
                        // ck.set('OLD-X-AUTH-TOKEN', null);
                        sessionStorage.setItem('X-AUTH-TOKEN', vm.loginInfo.Token);
                        sessionStorage.setItem('OLD-X-AUTH-TOKEN', '');
                        window.name = "onlineassessment";
                    }
                    resetLocalStorage();
                    resetCookies();
                    $window.sessionStorage.setItem("pageRefreshCount", angular.toJson(0));
                    isLoginStarted = false;
                    checkLoginPrereq();
                })
                .catch(function(res) {
                    isLoginStarted = false;
                    $log.error(res);
                    var msg = null,
                        nexttest, hasnexttest = false,
                        waitTime = 0;
                    vm.loginInfo = vm.loginInfo || {};
                    if (!navigator.onLine) {
                        msg = "No internet connection.";
                    } else if (res.error && res.error.isAutoTest) {
                        nexttest = res.error.nextTestFlags;
                        if (nexttest) {
                            if (_.has(nexttest, 'waitTime') && nexttest.waitTime > 0) {
                                waitTime = parseInt(nexttest.waitTime / 60) + 1;
                            } else if (nexttest.isRegistered === true && nexttest.isScoreFetched === true && nexttest.isShortlisted === true) {
                                hasnexttest = true;
                            } else if (nexttest.isRegistered === true && nexttest.isShortlisted === true && nexttest.isScoreFetched !== false) {
                                hasnexttest = true;
                            } else if (nexttest.isRegistered === true && nexttest.isShortlisted !== false && nexttest.isScoreFetched !== false) {
                                hasnexttest = true;
                            } else if (nexttest.isHproTest === true && nexttest.isShortlisted === true && nexttest.isRegistered !== false) {
                                hasnexttest = true;
                            } else if (nexttest.isHproTest === true && nexttest.isShortlisted !== false && nexttest.isRegistered !== false) {
                                hasnexttest = true;
                            }
                        }
                        if (hasnexttest && waitTime == 0) {
                            var request = {
                                'loginName': vm.loginName ? vm.loginName.trim() : "",
                                'password': vm.loginPassword ? vm.loginPassword.trim() : "",
                                'tenantAlias': vm.alias,
                            };
                            loginService.getNextTestInfo(request).then(function(res) {
                                if (res && res.data && res.data.nextTestInfos && res.data.nextTestInfos.length > 0) {
                                    var tempObj = res.data.nextTestInfos[0];
                                    var nxtTestParamObj = {
                                        'alias': vm.alias,
                                        'nextTestStateParams': afterSubmission.getNextTestParamObj(tempObj),
                                        'isAutoTestEnabled': true
                                    };
                                    if (tempObj.isShortlisted === true) {
                                        nxtTestParamObj.shortlistingStat = 0; // 0 is considered to be true in submitConfirmation. TODO: Needs to change
                                    }
                                    var loginTemp = vm.loginInfo;
                                    if(loginTemp.error && loginTemp.error.nextTestFlags && loginTemp.error.nextTestFlags.nextTestConfig){
                                        nxtTestParamObj.isConsentRequired = loginTemp.error.nextTestFlags.nextTestConfig.isConsentRequired;
                                    }
                                    if(loginTemp.error && loginTemp.error.nextTestFlags){
                                        if(loginTemp.error.nextTestFlags.testId){
                                            sessionStorage.setItem('testId',loginTemp.error.nextTestFlags.testId)
                                        }
                                        if(loginTemp.error.nextTestFlags.candidateId){
                                           sessionStorage.setItem('candidateId',loginTemp.error.nextTestFlags.candidateId)
                                        }
                                        if(loginTemp.error.nextTestFlags.systemTkn){
                                           sessionStorage.setItem('X-AUTH-TOKEN',loginTemp.error.nextTestFlags.systemTkn)
                                        }
                                    }
                                    nxtTestParamObj.nextTestStateParams.alias = vm.alias;
                                    $state.go('submitConfirmation', nxtTestParamObj, { 'reload': true, 'location': 'replace' });
                                } else if (res && res.data && res.data.nextTestLinks && res.data.nextTestLinks.length > 0) {
                                    var tempObj = { nextTestUrl: res.data.nextTestLinks[0] };
                                    var nxtTestParamObj = {
                                        'alias': vm.alias,
                                        'nextTestStateParams': afterSubmission.getNextTestParamObj(tempObj),
                                        'isAutoTestEnabled': true
                                    };
                                    if (tempObj.isShortlisted === true) {
                                        nxtTestParamObj.shortlistingStat = 0; // 0 is considered to be true in submitConfirmation. TODO: Needs to change
                                    }
                                    nxtTestParamObj.nextTestStateParams.alias = vm.alias;
                                    var loginTemp = vm.loginInfo;
                                    if(loginTemp.error && loginTemp.error.nextTestFlags && loginTemp.error.nextTestFlags.nextTestConfig){
                                        nxtTestParamObj.isConsentRequired = loginTemp.error.nextTestFlags.nextTestConfig.isConsentRequired;
                                    }
                                    console.log(nxtTestParamObj, 'nxtTestParamObj');
                                    $state.go('submitConfirmation', nxtTestParamObj, { 'reload': true, 'location': 'replace' });
                                }
                                return;
                            });
                        } else if (waitTime > 0) {
                            msg = 'Please try again after ' + waitTime + ' minute';
                            msg += (waitTime > 1) ? 's' : '';
                        } else {
                            msg = res.error.description;
                        }

                    } else if (res.error && res.error.description) {
                        msg = res.error.description;
                    }
                    vm.loginInfo.IsException = true;
                    vm.loginInfo.Message = msg;
                    $scope.$apply();
                });
        }

        function resetLocalStorage() {
            var ls = assessmentUtility.localStorage;
            //ls.setData("isTimerStarted", false);
            $window.sessionStorage.setItem("isTimerStarted", false);
            ls.setData("lastSubmittedTotalTimeSpent", angular.toJson(0));
            ls.clearItem('isQPmergeWithPrevAns');
            ls.clearItem('updateCounterPromise');
            var timerPromise = assessmentUtility.sessionStorage.getPromise('timerPromise');
            if (timerPromise) {
                $interval.cancel(timerPromise);
            }
            assessmentUtility.sessionStorage.removeItem("timerPromise");
            ls.clearItem("isSwitchedToNextGroup");
            ls.clearItem("isGrpWiseTimeOver");
            ls.setData("groupWiseTimeOver", false);
            ls.setData("groupInfoCollection", null);
            ls.setData("stopwatchTime", 0);
            ls.setData("timeSpentBeforeOptionalPreview", 0);
            ls.setData("fullScreenAlertModalOpened", false);
            ls.setData("previewTimer", null);
            ls.setData("prevTestResult", null);
            ls.setData("isQuestionVideoStarted", null);
        }

        function resetCookies() {
            var ck = assessmentUtility.cookies;
            ck.set('reactiveLogin_cacheRemoved', false);
        }

        function validatePreviewKey() {
            openModalService.openModal('provideTestSecurityKey', { headerStr: 'Security Key', isOnlinePreview: vm.isOnlinePreview })
                .then(function(res) {
                    if (res.result.result.isAuthorised) {
                        switchToStartTest();
                        // $state.go('assess.startTest', { 'alias': vm.alias }, { location: 'replace' });
                    } else {
                        validatePreviewKey();
                    }
                });
        }

        vm.scrollToLoginPage = function() {
            assessmentUtility.scrollToElement("login-col");
        }

        function termsAndPrivacyPolicy(url, header) {
            var str, hirepro,
                urlString = document.createElement('a');
            urlString.href = url;
            str = urlString.hostname;
            hirepro = str.includes("hirepro");

            if (hirepro) {
                var data = {
                    url: url,
                    header: header
                }
                openModalService.openModal('link', data);
            } else {
                window.open(url);
            }
        }

        // function startLoading() {
        //     blockUI.start();
        //     return stopLoadingAfterXTime().then(function() {
        //         //stopLoading();
        //         blockUI.stop();

        //     })
        // }

        function switchToStartTest() {
            var delayStatus;
            if (vm.loginInfo.assessmentConfig.delayStartTest) {
                delayStatus = vm.loginInfo.assessmentConfig.delayStartTest.isEnabled;
            } else {
                delayStatus = false;
            }
            if (vm.loginInfo.assessmentConfig.delayStartTest && vm.loginInfo.assessmentConfig.delayStartTest.delayUpto) {
                delayUpto = vm.loginInfo.assessmentConfig.delayStartTest.delayUpto;
            } else {
                delayUpto = 45;
            }

            if (delayStatus) {
                console.log('SS switchToStartTest');
                stopLoadingAfterXTime().then(function() {
                    console.log('SS inside switchToStartTest')
                    $state.go('assess.startTest', { 'alias': vm.alias }, { location: 'replace' });
                });
            } else {
                $state.go('assess.startTest', { 'alias': vm.alias }, { location: 'replace' });
            }
        }

        function stopLoadingAfterXTime() {
            blockUI.start();
            return $timeout(function() {
                console.log('SS timeOut');
                blockUI.stop();
            }, getRandomIntInclusive(1, delayUpto) * 1000);
        }

        function getRandomIntInclusive(min, max) {
            var min = Math.ceil(min),
                max = Math.floor(max),
                randomNum = Math.floor(Math.random() * (max - min + 1) + min);
            return randomNum;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('OnlineAssessmentAngular')
        .controller('HtmlEditorController', HtmlEditorController);

    function HtmlEditorController(assessmentService, $scope, $sce, webService, $q, $log, $timeout, assessmentUtility, folderViewSvc, blockUI, loginService, commonService) {
        var vm = this,
            prVm = $scope.$parent.vm,
            codingLanguageMapper = assessmentService.codingLanguageMapper,
            libContent,
            ls = assessmentUtility.localStorage,
            prevOutputWindowStatus = true,
            editorCode = {
                "html": "",
                "js": "",
                "css": "",
                "selectedLibraryName": "",
                "selectedLibraryUrl": "",
                "questionDataSetJson": {}
            },
            fileSeparator = 'MyFiles',
            loginInfo = loginService.getLoginInfo();
        /*.......................Public Mathods..................*/
        vm.onAceLoadHTML = onAceLoadHTML;
        vm.onAceLoadJS = onAceLoadJS;
        vm.onAceLoadCSS = onAceLoadCSS;
        vm.setLibrary = setLibrary;
        vm.calculateWidthofColumn = calculateWidthofColumn;
        vm.onAceChangeHTML = onAceChangeHTML;
        vm.onAceChangeJS = onAceChangeJS;
        vm.onAceChangeCSS = onAceChangeCSS;
        vm.checkCode = checkCode;
        vm.submitCode = submitCode;
        vm.toggleFullscreen = toggleFullscreen;
        vm.onaceEditorSettingsChange = onaceEditorSettingsChange;
        /*.......................Public Variable..................*/
        vm.aceEditorHeight = prVm.aceEditorHeight;
        vm.isSwitchingFromCurrentQuestionEnable = prVm.isSwitchingFromCurrentQuestionEnable;
        vm.templateLayout = prVm.templateLayout;
        vm.question = prVm.question;
        vm.questionpaper = prVm.questionpaper;
        vm.trustedQString = prVm.trustedQString;
        vm.currentqindex = prVm.currentqindex;
        vm.isShowQMarksEnabled = prVm.isShowQMarksEnabled;
        vm.codingAutocompleteEnabled = prVm.codingAutocompleteEnabled;
        vm.codingCopyPasteEnabled = prVm.codingCopyPasteEnabled;
        vm.parseInt = parseInt;
        vm.htmlState = true;
        vm.cssState = true;
        vm.jsState = true;
        vm.iframeState = false;
        vm.consoleState = true;
        vm.codeColumnClass = 'col-md-4';
        vm.outputUrl = "";
        vm.isExpanded = false;
        vm.saveCodeHistory = prVm.saveCodeHistory
        vm.selectedControls = {
            html: true,
            js: true,
            css: true,
            output: true
        };
        vm.userDefinedAceSettings = {
            tabSize: 4,
            theme: 'ace/theme/merbivore', //white---'ace/theme/textmate',
            keybinding: 'ace',
            fontsize: 10
        };
        vm.htmlDefaultValue = "<!DOCTYPE html>\n<html>\n\t<head>\n\t\t<title>\n\t\t</title>\n\t</head>\n\t<body>\n\t</body>\n</html>";

        vm.urlList = {
            'jQuery 1.12.4': 'https://code.jquery.com/jquery-1.12.4.js',
            'jQuery 2.2.4': 'https://code.jquery.com/jquery-2.2.4.js',
            'jQuery 3.2.1': 'https://code.jquery.com/jquery-3.2.1.js',
            'AngularJS 1.2': 'https://ajax.googleapis.com/ajax/libs/angularjs/1.2.32/angular.min.js',
            'AngularJS 1.6': 'https://ajax.googleapis.com/ajax/libs/angularjs/1.6.6/angular.js'
            // 'Angular': 'Angular'
        };
        vm.isSelectionIndependent = false;
        vm.folderTreeView = {
            data: {},
            showSelected: function(sel) {
                if (!angular.isUndefined(vm.fileData[sel.filePath])) {
                    savePreviousData(vm.aceEditorForFramework, sel);
                    vm.folderTreeView.selected = sel;
                    vm.selectedNode = sel.label;
                }
            }
        };
        vm.selectedNodeData = {
            previousSelectedFilePath: null,
            data: '',
            type: null
        };
        vm.data = {
            questionType: {
                jsTypeQuestion: undefined,
                isFrameWorkTypeQuestion: undefined
            },
            templates: {
                jsUiTypeQuestion: 'app/template/default/js_ui_type_question.html',
                frameworkUiTypeQuestion: 'app/template/default/framework_ui_type_question.html'
            },
            hideLanguageSelection: false,
            selectedLanguage: null
        };
        vm.onFrameworkAceLoad = onFrameworkAceLoad;
        vm.onFrameworkAceChange = onFrameworkAceChange;

        function init() {
            editorCode = vm.question.selectedAns &&
                vm.question.selectedAns.trim !== "" ?
                JSON.parse(vm.question.selectedAns) : editorCode;
            // vm.selectedLibrary = editorCode.selectedLibraryUrl || null;
            return initialSelectedLibrary().then(function() {
                return codingLanguageTemplate();
            })
        }
        init();

        function initialSelectedLibrary() {
            return $q.when().then(function() {
                var library = editorCode.selectedLibraryUrl || null,
                    isFrameworkLanguageAvailable = _.find(vm.question.codingLangs, function(languages) {
                        return _.indexOf(['Angular', 'React'], languages.languageText) > -1;
                    }) || undefined,
                    selectedLibrary = isFrameworkLanguageAvailable ? isFrameworkLanguageAvailable.languageText : null;
                if (selectedLibrary && !vm.urlList[selectedLibrary]) {
                    vm.data.hideLanguageSelection = true;
                    vm.urlList[selectedLibrary] = selectedLibrary;
                    vm.selectedLibrary = selectedLibrary;
                } else {
                    vm.selectedLibrary = library;
                }
                if (isFrameworkLanguageAvailable) {
                    vm.data.selectedLanguage = isFrameworkLanguageAvailable;
                    return setFrameWorkData();
                }
            })
        }

        function codingLanguageTemplate() {
            return $q.when().then(function() {
                vm.data.questionType = {
                    jsTypeQuestion: undefined,
                    isFrameWorkTypeQuestion: undefined
                }
                if (!vm.selectedLibrary) {
                    vm.data.questionType['jsTypeQuestion'] = true;
                }
                if (_.indexOf(['Angular', 'React'], vm.selectedLibrary) > -1) {
                    vm.data.questionType['isFrameWorkTypeQuestion'] = true;
                } else {
                    vm.data.questionType['jsTypeQuestion'] = true;
                }
            });
        }

        function setFrameWorkData() {
            blockUI.start();
            vm.folderTreeView.isEnableFramework = false;
            return $q.when().then(function() {
                    if (!_.size(editorCode.questionDataSetJson)) {
                        return angular.copy(_.get(vm.question, 'dataSetJson.questionDataSet'));
                    }
                    return editorCode['questionDataSetJson'];
                }).then(function(res) {
                    if (!res) {
                        return $q.reject();
                    }
                    vm.fileData = _.reduce(res, function(acc, fileData, fileName) {
                        var path = fileData.relativePath + '/' + fileName;
                        acc[path] = fileData;
                        return acc;
                    }, {});
                    var requestForCreateTree = _.map(_.keys(vm.fileData), function(data) {
                        return data.split('/');
                    });
                    vm.folderTreeView.data = folderViewSvc.CreateFolderTree.create(requestForCreateTree, fileSeparator);
                    vm.folderTreeView.options = folderViewSvc.CreateFolderTree.setOptions();
                    vm.folderTreeView.expandedNodes = folderViewSvc.CreateFolderTree.expandAllNodes(vm.folderTreeView.data.children, []) || [];
                })
                .then(function(res) {
                    vm.folderTreeView.isEnableFramework = true;
                    editorCode.selectedLibraryUrl = vm.selectedLibrary;
                    editorCode.selectedLibraryName = _.invert(vm.urlList)[vm.selectedLibrary];
                    return;
                })
                .catch(function(err) {
                    console.log(err);
                })
                .finally(function() {
                    blockUI.stop();
                })
        };

        function onFrameworkAceLoad(editor) {
            var _session = editor.getSession();
            if (vm.selectedNodeData.data && vm.selectedNodeData.data.trim() !== "" && vm.selectedNodeData.type) {
                _session.setValue(vm.selectedNodeData.data);
                _session.setMode('ace/mode/' + codingLanguageMapper[vm.selectedNodeData.type.toLowerCase()]);
            }
            vm.aceEditorForFramework = editor;
            vm.folderTreeView.showSelected(vm.folderTreeView.data.selectableNode);
            enableDisableCopyPaste(vm.aceEditorForFramework);
        }

        function savePreviousData(editor, sel) {
            var _session = editor.getSession();
            if (vm.selectedNodeData.previousSelectedFilePath) {
                vm.fileData[vm.selectedNodeData.previousSelectedFilePath].content = _session.getDocument().getValue();
                editorCode['questionDataSetJson'] = getFrameWorkDatSetJson();
            }
            vm.selectedNodeData = {
                previousSelectedFilePath: sel.filePath,
                data: vm.fileData[sel.filePath].content,
                type: null
            };
            if (!angular.isUndefined(vm.selectedNodeData.data)) {
                if (sel.filePath.search(new RegExp('.html$')) > 0) {
                    vm.selectedNodeData.type = 'html'
                }
                if (sel.filePath.search(new RegExp('.js$')) > 0) {
                    vm.selectedNodeData.type = 'js'
                }
                if (sel.filePath.search(new RegExp('.css$')) > 0) {
                    vm.selectedNodeData.type = 'css'
                }
                if (sel.filePath.search(new RegExp('.ts$')) > 0) {
                    vm.selectedNodeData.type = 'ts'
                }
                if (sel.filePath.search(new RegExp('.jsx$')) > 0) {
                    vm.selectedNodeData.type = 'js'
                }
                if (vm.selectedNodeData.type) {
                    _session.setValue(vm.selectedNodeData.data);
                    _session.setMode('ace/mode/' + codingLanguageMapper[vm.selectedNodeData.type.toLowerCase()]);
                }
                vm.aceEditorForFramework = editor;
            }
        }

        function getFrameWorkDatSetJson() {
            return _.reduce(vm.fileData, function(acc, fileData, filePath) {
                var fileName = filePath.substr(_.lastIndexOf(filePath, '/') + 1);
                acc[fileName] = fileData;
                return acc;
            }, {});
        }

        function onFrameworkAceChange() {
            if (vm.selectedNodeData.previousSelectedFilePath) {
                vm.fileData[vm.selectedNodeData.previousSelectedFilePath].content = getmodifiedCodeSnippet(vm.aceEditorForFramework);
                editorCode['questionDataSetJson'] = getFrameWorkDatSetJson();
            }
            if (_.size(vm.fileData)) {
                vm.question.selectedAns = JSON.stringify(_.omit(editorCode, ['html', 'js', 'css']));
            }
            handlingAnswer(vm.question);
            vm.question.isAnswered = isFrameWorkQuestionIsAnswered();
        }

        function onAceLoadHTML(editor) {
            var _session = editor.getSession();
            if (editorCode.html && !!editorCode.html.trim()) {
                _session.setValue(editorCode.html);
            } else {
                _session.setValue(vm.htmlDefaultValue);
            }

            _session.setMode('ace/mode/' + codingLanguageMapper["html"]);
            vm.aceEditorHTML = editor;
            enableDisableCopyPaste(vm.aceEditorHTML);
            //onaceEditorSettingsChange();
        };

        function onAceLoadJS(editor) {
            var _session = editor.getSession();
            if (editorCode.js && editorCode.js.trim() !== "") {
                _session.setValue(editorCode.js);
            }
            _session.setMode('ace/mode/' + codingLanguageMapper["js"]);
            vm.aceEditorJS = editor;
            enableDisableCopyPaste(vm.aceEditorJS);
        };

        function onAceLoadCSS(editor) {
            var _session = editor.getSession();
            if (editorCode.css && editorCode.css.trim() !== "") {
                _session.setValue(editorCode.css);
            }
            _session.setMode('ace/mode/' + codingLanguageMapper['css']);
            vm.aceEditorCSS = editor;
            enableDisableCopyPaste(vm.aceEditorCSS);
        };

        function setLibrary() {
            return codingLanguageTemplate().then(function() {
                if (_.indexOf(['Angular', 'React'], vm.selectedLibrary) > -1) {
                    return setFrameWorkData();
                }
                editorCode.selectedLibraryUrl = vm.selectedLibrary;
                editorCode.selectedLibraryName = _.invert(vm.urlList)[vm.selectedLibrary];
                vm.question.selectedAns = editorCode && JSON.stringify(editorCode);
                handlingAnswer(vm.question);
            })
        }

        function onAceChangeHTML() {
            editorCode.html = getmodifiedCodeSnippet(vm.aceEditorHTML);
            vm.question.isAnswered = isAnswered();
            vm.question.selectedAns = editorCode && JSON.stringify(editorCode);
            handlingAnswer(vm.question);
        }

        function onAceChangeJS() {
            editorCode.js = getmodifiedCodeSnippet(vm.aceEditorJS);
            vm.question.isAnswered = isAnswered();
            vm.question.selectedAns = editorCode && JSON.stringify(editorCode);
            handlingAnswer(vm.question);
        }

        function onAceChangeCSS() {
            editorCode.css = getmodifiedCodeSnippet(vm.aceEditorCSS);
            vm.question.isAnswered = isAnswered();
            vm.question.selectedAns = editorCode && JSON.stringify(editorCode);
            handlingAnswer(vm.question);
        }

        function toggleFullscreen() {
            vm.isExpanded = !vm.isExpanded;
            if (vm.isExpanded) {
                prevOutputWindowStatus = vm.selectedControls.output;
                vm.selectedControls.output = false;
            } else {
                vm.selectedControls.output = prevOutputWindowStatus;
            }
        }
        //=============Start Answer validation==================================
        // -----------validate ui type answer except framework type-------------------------------
        function isAnswered() {
            var _isAnswered = !!(editorCode.html && editorCode.html.trim() && editorCode.html !== vm.htmlDefaultValue ||
                editorCode.js && editorCode.js.trim() ||
                editorCode.css && editorCode.css.trim());
            return _isAnswered;
        }
        // -----------validate only type framework type answer-------------------------------
        function isFrameWorkQuestionIsAnswered() {
            if (!vm.question.dataSetJson || !_.size(vm.question.dataSetJson.questionDataSet) || !_.size(editorCode['questionDataSetJson'])) {
                return false;
            }
            return _.isMatch(vm.question.dataSetJson.questionDataSet, editorCode.questionDataSetJson) ? false : true;
        }
        //=============End Answer validation==================================

        function checkCode() {
            return $q.when().then(function() {
                    vm.question.isAnswered = false;
                    if (_.indexOf(['Angular', 'React'], vm.selectedLibrary) > -1) {
                        return getPlayableUrlsFromContent();
                    } else {
                        return executeCodeWithBlob();
                    }
                })
                .finally(function() {
                    vm.question.isAnswered = true;
                })
        }

        //--------------------execute code--------------------------
        function executeCodeWithBlob() {
            var deffered = $q.defer(),
                frameCreated,
                jsUrl = "",
                cssUrl = "";
            editorCode.html = vm.aceEditorHTML.getSession().getDocument().getValue();
            editorCode.js = vm.aceEditorJS.getSession().getDocument().getValue();
            editorCode.css = vm.aceEditorCSS.getSession().getDocument().getValue();

            if (editorCode.js !== "") {
                jsUrl = createBlobURL(editorCode.js, 'js');
            }
            if (editorCode.css !== "") {
                cssUrl = createBlobURL(editorCode.css, 'css');
            }

            frameCreated = creatingHtmlContent(cssUrl, jsUrl);
            if (frameCreated) {
                deffered.resolve();
            }

            return deffered.promise;
        }
        //---------------------------------------------------------

        //--------------get urls for displaying into iframe temporary urls------------------
        function getPlayableUrlsFromContent() {
            vm.showIframe = false;
            return assessmentService.RenderFileFromContent.render({
                questionId: vm.question.id,
                dataSetJson: _.reduce(angular.copy(editorCode.questionDataSetJson), function(acc, dataJson, index) {
                    dataJson.relativePath = fileSeparator + '/' + dataJson.relativePath;
                    acc[index] = dataJson;
                    return acc
                }, {})
            }).then(function(res) {
                if (!_.size(res)) {
                    return;
                }
                var timeOut = $timeout(function() {
                    var iframeUrl = findIndexFile(res); //$sce.trustAsResourceUrl(htmlUrl);
                    if (!iframeUrl) {
                        return;
                    }
                    if (!vm.iframeState) {
                        vm.showIframe = true;
                        vm.outputUrl = $sce.trustAsResourceUrl(iframeUrl);
                        vm.selectedControls.output = true;
                        calculateWidthofColumn();
                    }
                });
            })
        }
        //------------------------------------------------------------
        //--------------get index file to run-------------------------
        function findIndexFile(filesArray) {
            return _.chain(filesArray)
                .filter(function(data) {
                    var indexOfData = data.split(fileSeparator);
                    return indexOfData[1].match(new RegExp('index.html$'));
                })
                .first()
                .value();
        }

        function createBlobURL(content, type) {
            var typeMap = {
                    html: 'text/html',
                    js: 'text/plain',
                    css: 'text/css',
                    ts: 'text/plain'
                },
                blobCreated = new Blob([content], { type: typeMap[type] }),
                blobUrl = URL.createObjectURL(blobCreated);

            return blobUrl;
        }

        function creatingHtmlContent(cssUrl, jsUrl, cloudContent) {
            var htmlUrl,
                htmlContent;

            if (vm.selectedLibrary) {
                htmlContent = addScriptTag(editorCode.html, vm.selectedLibrary);
            } else {
                htmlContent = editorCode.html;
            }

            if (cssUrl.length > 0) {
                htmlContent = addStyleTag(htmlContent, cssUrl);
            }
            if (jsUrl.length > 0) {
                htmlContent = addScriptTag(htmlContent, jsUrl);
            }
            if (cloudContent === true) {
                return htmlContent;
            } else {
                htmlContent = htmlContent.replace(new RegExp('(<a.*?href=)([\'\"])(.*?)([\'\"])', 'g'), "\$1\"javascript:window.location.replace('\$3')\"");
                htmlUrl = createBlobURL(htmlContent, 'html');
                vm.showIframe = false;
                var timeOut = $timeout(function() {
                    vm.showIframe = true;
                    vm.outputUrl = $sce.trustAsResourceUrl(htmlUrl);
                    if (!vm.iframeState) {
                        vm.selectedControls.output = true;
                        calculateWidthofColumn();
                    }
                }, 10);

                return true;
            }
        }

        function submitCode() {
            checkCode().then(function(response) {
                if (_.indexOf(['Angular', 'React'], vm.selectedLibrary) > -1) {
                    return vm.saveCodeHistory();
                }
                return storeUiTypeCode()
            }).then(function() {
                vm.question.isAnswered = true;
                handlingAnswer(vm.question);
            });
        }

        function storeUiTypeCode() {
            var cssData = {
                    fileContent: editorCode.css,
                    fileName: "style.css",
                    relativePath: "coding/UI/"
                },
                jsData = {
                    fileContent: editorCode.js,
                    fileName: "custom.js",
                    relativePath: "coding/UI/"
                },
                promiseCollection = [],
                cssCloudUrl, jsCloudUrl, htmlCloudContent, htmlData,
                cloudContent = true;
            promiseCollection.push(storeCodeonCloud(cssData));
            promiseCollection.push(storeCodeonCloud(jsData));
            return $q.all(promiseCollection).then(function(data) {
                cssCloudUrl = data[0].persistentUrl;
                jsCloudUrl = data[1].persistentUrl;
                htmlCloudContent = creatingHtmlContent(cssCloudUrl, jsCloudUrl, cloudContent);
                htmlData = {
                    fileContent: htmlCloudContent,
                    fileName: "index.html",
                    relativePath: "coding/UI/"
                };
                return storeCodeonCloud(htmlData).then(function(response) {
                    //vm.question.selectedAns = htmlCloudContent;
                    vm.question.ansFiles = [response.persistentUrl];
                    /*vm.question.tempCode = {
                        js: editorCode.js,
                        css: editorCode.css,
                        html: editorCode.html,
                        lib: vm.selectedLibrary
                    };*/
                });
            });
        }

        function storeCodeonCloud(data) {
            return webService.execute('storefileContentGetUrl', data).then(
                function(response) {
                    $log.log(response);
                    if (response && response.data && response.data.status === 'OK') {
                        $log.log("File Uploaded Successfully");
                        return response.data;
                    }
                },
                function() {
                    $log.log("Error occurred when Uploading File");
                    $q.reject(null);
                }
            );
        }

        function calculateWidthofColumn() {
            var activeEditors = _.pickBy(vm.selectedControls, function(item) {
                return item == true;
            });
            var activeEditorsSize = _.size(activeEditors);

            if (activeEditorsSize == 1 || (activeEditorsSize == 2 && activeEditors.output)) {
                vm.isHtmlDisabled = activeEditors.html ? true : false;
                vm.isJsDisabled = activeEditors.js ? true : false;
                vm.isCssDisabled = activeEditors.css ? true : false;
            } else {
                vm.isHtmlDisabled = false;
                vm.isJsDisabled = false;
                vm.isCssDisabled = false;
            }
            activeEditorsSize = vm.selectedControls.output ? activeEditorsSize : activeEditorsSize + 1;
            switch (activeEditorsSize) {
                case 4:
                    vm.codeColumnClass = 'col-md-4';
                    break;
                case 3:
                    vm.codeColumnClass = 'col-md-6';
                    break;
                case 2:
                    vm.codeColumnClass = 'col-md-12';
                    break;
            }
        }

        function addScriptTag(str, url) {
            String.prototype.insertAt = function(index, string) {
                index = index ? index : 0;
                return this.substr(0, index) + string + this.substr(index);
            }
            var index, scriptStringAdd;
            if (str.indexOf('</body>') > -1) {
                index = str.indexOf('</body>');
            }
            scriptStringAdd = "<script type='text/javascript' src='" + url + "'>\<\/script>"
            str = str.insertAt(index, scriptStringAdd);
            return str;
        }

        function addStyleTag(code, url) {
            String.prototype.insertAt = function(index, string) {
                index = index ? index : 0;
                return this.substr(0, index) + string + this.substr(index);
            }
            var index, styleStringAdd;
            if (code.indexOf('</head>') > -1) {
                index = code.indexOf('</head>');
            }
            styleStringAdd = "<link rel='stylesheet' type='text/css' id='insertCSS' href='" + url + "'>"
            code = code.insertAt(index, styleStringAdd);
            return code;
        }

        function getmodifiedCodeSnippet(editor) {
            var _session = editor.getSession();
            return _session.getDocument().getValue();
        };

        function handlingAnswer(qObj) {
            /*.......Save data to LocalStorage........*/
            var questionPaper = ls.getData("questionPaper");
            var mandatQs = questionPaper && questionPaper.mandatoryQuestionCollection;
            if (qObj && mandatQs && mandatQs.length > vm.questionpaper.mandatoryQuestionCollection.length) {
                var q = _.find(mandatQs, { 'id': qObj.id });
                q.selectedAns = qobj.selectedAns;
                q.ansFiles = qObj.ansFiles;
                q.tempCode = qObj.tempCode;
                q.selectedLanguage = vm.data.selectedLanguage ? vm.data.selectedLanguage : undefined;
                vm.questionpaper = q;
            }
            ls.setData("questionPaper", vm.questionpaper);
        };

        function onaceEditorSettingsChange() {
            /*.........................HTML..........................*/
            if (vm.aceEditorHTML) {
                vm.aceEditorHTML.setTheme(vm.userDefinedAceSettings.theme);
                vm.aceEditorHTML.getSession().setTabSize(vm.userDefinedAceSettings.tabSize);
                if (vm.userDefinedAceSettings.keybinding === 'ace') {
                    vm.aceEditorHTML.setKeyboardHandler(null);
                } else {
                    vm.aceEditorHTML.setKeyboardHandler(vm.userDefinedAceSettings.keybinding);
                }
                vm.aceEditorHTML.setFontSize(vm.userDefinedAceSettings.fontsize);
                sessionStorage.userDefinedAceSettings = JSON.stringify(vm.userDefinedAceSettings);
            }

            /*.........................JS..........................*/
            if (vm.aceEditorJS) {
                vm.aceEditorJS.setTheme(vm.userDefinedAceSettings.theme);
                vm.aceEditorJS.getSession().setTabSize(vm.userDefinedAceSettings.tabSize);
                if (vm.userDefinedAceSettings.keybinding === 'ace') {
                    vm.aceEditorJS.setKeyboardHandler(null);
                } else {
                    vm.aceEditorJS.setKeyboardHandler(vm.userDefinedAceSettings.keybinding);
                }
                vm.aceEditorJS.setFontSize(vm.userDefinedAceSettings.fontsize);
                sessionStorage.userDefinedAceSettings = JSON.stringify(vm.userDefinedAceSettings);
            }

            /*.........................CSSS..........................*/
            if (vm.aceEditorCSS) {
                vm.aceEditorCSS.setTheme(vm.userDefinedAceSettings.theme);
                vm.aceEditorCSS.getSession().setTabSize(vm.userDefinedAceSettings.tabSize);
                if (vm.userDefinedAceSettings.keybinding === 'ace') {
                    vm.aceEditorCSS.setKeyboardHandler(null);
                } else {
                    vm.aceEditorCSS.setKeyboardHandler(vm.userDefinedAceSettings.keybinding);
                }
                vm.aceEditorCSS.setFontSize(vm.userDefinedAceSettings.fontsize);
                sessionStorage.userDefinedAceSettings = JSON.stringify(vm.userDefinedAceSettings);
            }

            /*.........................Frame work Ace editor..........................*/
            if (vm.aceEditorForFramework) {
                vm.aceEditorForFramework.setTheme(vm.userDefinedAceSettings.theme);
                vm.aceEditorForFramework.getSession().setTabSize(vm.userDefinedAceSettings.tabSize);
                if (vm.userDefinedAceSettings.keybinding === 'ace') {
                    vm.aceEditorForFramework.setKeyboardHandler(null);
                } else {
                    vm.aceEditorForFramework.setKeyboardHandler(vm.userDefinedAceSettings.keybinding);
                }
                vm.aceEditorForFramework.setFontSize(vm.userDefinedAceSettings.fontsize);
                sessionStorage.userDefinedAceSettings = JSON.stringify(vm.userDefinedAceSettings);
            }
        }
        // enable/disable copy/paste
        function enableDisableCopyPaste(editor) {
            if (!vm.codingCopyPasteEnabled) {
                editor.commands.addCommand({
                    name: "paste",
                    exec: function(event) {
                        editor.session._emit('paste');
                    },
                    bindKey: { mac: "Command-V", win: "Ctrl-V" }
                });
                editor.commands.addCommand({
                    name: "copy",
                    exec: function(event) {
                        editor.session._emit('copy');
                    },
                    bindKey: { mac: "Command-C", win: "Ctrl-C" }
                });
                editor.commands.addCommand({
                    name: "cut",
                    exec: function(event) {
                        editor.session._emit('cut');
                    },
                    bindKey: { mac: "Command-X", win: "Ctrl-X" }
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('OnlineAssessmentAngular')
        .component('groupDetails', {
            bindings: {
                'loginInfo': '=loginInfo'
                // 'isInfoDisplayed' : '=isInfoDisplayed'
            },
            templateUrl: 'app/assessment/groupDetails.tpl.html',
            controller: groupDetailsController,
            controllerAs: 'vm'
        });

    function groupDetailsController($state, $injector) {
        var vm = this,
            loginService = $injector.get('loginService'),
            $interval = $injector.get('$interval'),
            counter,
            intervalObj = null;
        vm.currentDate = new Date();
        
        vm.$onInit = function() {
            vm.loginInfo = loginService.getLoginInfo();
            vm.testDuration = secondsToDateTime(vm.loginInfo.TestDuration * 60);
            counter = (vm.loginInfo.TestDuration * 60) - vm.loginInfo.TimeSpent;
            updateCounter();
        };


        function updateCounter() {
            counter--;
            // vm.timeRemaining = counter;
            vm.timeRemaining = secondsToDateTime(counter);
            if (vm.timeRemaining === 0 && intervalObj !== null) {
                $interval.cancel(intervalObj);
                alert('Test needs to be sumitted');
            }
            if (vm.timeRemaining !== 0) {
                intervalObj = $interval(function() {
                    updateCounter();
                }, 1000);
            }
        }

        function secondsToDateTime(seconds) {
            return new Date(1970, 0, 1).setSeconds(seconds);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('OnlineAssessmentAngular')
        .component('freshChat', {
            controller: freshChatController,
            controllerAs: 'vm',
            templateUrl: 'app/assessment/freshChat.tpl.html',
            bindToController: true
        });

    function freshChatController(loginService, $interval) {
        var vm = this,
            loginInfo = loginService.getLoginInfo(),
            chatStatus,
            enableChatting,
            iconInterval;

        vm.showIcon = false;
        vm.activateFreshChat = activateFreshChat;
        activate();

        function activate() {
            chatStatus = sessionStorage.getItem('chatBeforeLogin') === 'true' ? true : false;
            if (chatStatus && sessionStorage.freshChatId) {
                vm.showIcon = true;
            }
            if (loginInfo && loginInfo.assessmentConfig) {
                enableChatting = !!loginInfo.assessmentConfig.enableChatting;
            }
            if (enableChatting && sessionStorage.freshChatId && !chatStatus) {
                vm.showIcon = true;
            }
            iconInterval = $interval(function() {
                if (sessionStorage.freshChatId) {
                    vm.data = {
                        // this default if for internal ams
                        freshChatId: sessionStorage.freshChatId //."16027e80-cb24-4844-a180-0386d208b1bd"
                    };
                }
                chatStatus = sessionStorage.getItem('chatBeforeLogin') === 'true' ? true : false;
                loginInfo = loginService.getLoginInfo();
                if (chatStatus && sessionStorage.freshChatId) {
                    vm.showIcon = true;
                }
                if (loginInfo && loginInfo.assessmentConfig) {
                    enableChatting = !!loginInfo.assessmentConfig.enableChatting;
                }
                if (enableChatting && sessionStorage.freshChatId && !chatStatus) {
                    vm.showIcon = true;
                }
            }, 5000)
        }

        function activateFreshChat() {
            loadFreshChat();
            vm.showIcon = false;
            $interval.cancel(iconInterval);
        }

        function loadFreshChat() {
            if (chatStatus && sessionStorage.freshChatId) {
                chatBeforeLogin();
            }
            if (enableChatting && sessionStorage.freshChatId) {
                checkForLiveChatConfig();
            }
        }

        function chatBeforeLogin() {
            var initObjectBeforeLogin = {
                tenant: sessionStorage.oa_tenantAlias,
                firstName: "Prior_Login"
            };
            if (!window.fcWidget.isLoaded()) {
                window.fcWidget.init({
                    token: vm.data.freshChatId,
                    host: "https://wchat.freshchat.com"
                });
                window.fcWidget.user.setProperties(initObjectBeforeLogin);
                window.fcWidget.open();
            }
        }

        function checkForLiveChatConfig() {
            if (sessionStorage.TestLoginInformation) {
                var userDetails = JSON.parse(sessionStorage.TestLoginInformation);
                var initObject = {
                    tenant: sessionStorage.oa_tenantAlias,
                    externalId: userDetails.CandidateId,
                    firstName: userDetails.CandidateName,
                    lastName: userDetails.LastName,
                    email: userDetails.CandidateEmail,
                    "loginId/EmpId": userDetails.testUserId
                };
            }


            if (!window.fcWidget.isLoaded()) {
                window.fcWidget.init({
                    token: vm.data.freshChatId,
                    host: "https://wchat.freshchat.com"
                });
            }

            window.fcWidget.user.get(function(resp) {
                var status = resp && resp.status;
                // data = resp && resp.data;
                if (status !== 200) {
                    window.fcWidget.user.setProperties(initObject);
                    window.fcWidget.open();
                    window.fcWidget.on("user:created", function(resp) {
                        console.log(resp);
                        // var status = resp && resp.status,
                        //   data = resp && resp.data;
                        // if (status === 200) {
                        //   if (data.restoreId) {
                        //     // Update restoreId in your database
                        //   }
                        // }
                    });
                } else if (status === 200 && resp.data.firstName == "Prior_Login") {
                    window.fcWidget.user.setProperties(initObject);
                    window.fcWidget.open();
                }
            });
            //}
        }
    }
})();

(function() {
    'use strict';
    angular
        .module('OnlineAssessmentAngular')
        .controller('envProctoring', envProctoring);
    /* @ngInject */

    function envProctoring($rootScope, $scope, $state, $log, openModalService, proctoringService, assessmentUtility, webService, growl, $timeout, hvsService, socketService) {
        var vm = this,
            vidElem = null,
            params = null,
            loginInfo = {},
            proctorCompatibilityModal = null;

        vm.proctoringStarted = false;

        vm.startProctoring = startProctoring;
        vm.stopProctoring = stopProctoring;

        active();

        function active() {
            sessionStorage.setItem('isSecondaryCamera', 'true');
            // sessionStorage.setItem('oa_tenantAlias', 'at');
            // sessionStorage.setItem('X-AUTH-TOKEN', 'Tkn:9c10f700-9489-45b1-b000-74504a2735ad');
            params = $state.params;
            if (params && params.stateParams) {
                if (_.indexOf(params.stateParams, '%') > -1) {
                    params = angular.fromJson(atob(decodeURIComponent(params.stateParams)));
                } else {
                    params = angular.fromJson(atob(params.stateParams));
                }

            }
            if (params && params.tName) {
                sessionStorage.setItem('oa_tenantAlias', params.tName);
            }
            if (params && params.tkn) {
                sessionStorage.setItem('X-AUTH-TOKEN', params.tkn);
                sessionStorage.removeItem('X-AUTH-TOKEN');
            }
            webService.execute('getLoginInfo', {}).then(
                function(res) {
                    if (res && res.data.statusCode === 200) {
                        assessmentUtility.localStorage.setData('TestLoginInformation', res.data);
                        assessmentUtility.sessionStorage.setData('TestLoginInformation', res.data);
                        // if (loginInfo.Config) {
                        //     var cnf = vm.loginInfo.Config;
                        //     if (cnf.secondaryCamera) {
                        //         sessionStorage.setItem("isSecondaryCameraEnable", !!cnf.secondaryCamera.isEnabled);
                        //     }
                        // }
                        sessionStorage.setItem("isSecondaryCameraEnable", true);
                        var data = {
                            isAction: true,
                            action: {
                                isOkBtn: true
                            }
                        };
                        proctorCompatibilityModal = openModalService.showModal('proctorCompatibility', data, $scope);
                    }
                },
                function(res) {}
            );

            var data = {
                app: ["secondary_camera_msg_delivery"],
                eventCallback: {
                    end_test: onEndTest
                }
            };
            socketService.init(data);
        }

        function startProctoring() {
            proctoringService.start({
                    procType: "envProctoring",
                    durationInMins: 60
                })
                .then(function(res) {
                    vm.proctoringStarted = true;
                    $log.log('proctoring started');
                }, function(res) {
                    $log.log(res);
                    if (res.errorCode === 404) {
                        location.reload();
                    } else {
                        showErrorMsg(res.msg);
                    }
                });

            $rootScope.$watch('vidStrmId', function() {
                vidElem = document.getElementById("vid-mirror");
                if (!vidElem) {
                    $log.error("video element with id 'vid-mirror' is not found.");
                    return false;
                }
                if (!$rootScope.vidStrm) {
                    return false;
                }
                try {
                    vidElem.srcObject = $rootScope.vidStrm;
                } catch (error) {
                    vidElem.src = URL.createObjectURL($rootScope.vidStrm);
                }
            });
        }

        function stopProctoring() {
            proctoringService.stop();
        }

        function showErrorMsg(errorMsg) {
            var grwlObj = growl.error(errorMsg, {
                disableCloseButton: true,
                onopen: function() {
                    $timeout(function() {
                        document.getElementsByClassName("growl-item")[0].classList.add("growl-error-custom");
                    }, 2);
                }
            });
            $timeout(function() { grwlObj && grwlObj.destroy() }, 10000);
        }

        /*............Send to message page...........*/

        function onEndTest() {
            var errMsg = "The test has been submitted. Thanks for attending the test.";
            hvsService.logOutToMsgPage(errMsg);
        }
    }
})();

(function() {
    'use strict';
    angular
        .module('OnlineAssessmentAngular')
        .controller('endTestController', endTestController);
    /* @ngInject */

    function endTestController($q, $log, $rootScope, $state, $interval, loginService, assessmentUtility, assessmentService, afterSubmission, proctoringService, trackerService, CaptureCodeActivitySvc, videoAnsRecorder, screenRecordingService, hvsService, socketService) {
        var vm = this,
            loginInfo = loginService.getLoginInfo(),
            currentQIndex = sessionStorage.getItem('currentQIndex'),
            questionPaper = assessmentUtility.localStorage.getData('questionPaper'),
            currentQuestion,
            alias = sessionStorage.getItem("oa_tenantAlias"),
            isOnlinePreview = assessmentUtility.localStorage.getData("_isOnlinePreview"),
            testSubmissionFailureCount = 0,
            submissionAttemptsConfig = 5,
            submissionAttempts = 0,
            trackerTypes = trackerService.getTrackerTypes(),
            endTestCalls = 0,
            isVideoProctoringEnabled = false,
            isScreenProctoringEnable = false;

        vm.message = {};
        vm.submittingTest = false;
        vm.backToTest = backToTest;
        vm.endTest = endTest;
        vm.isGoBackIsAllowed = true,
            vm.isAutoSubmission = false;

        active();

        function active() {

            if (currentQIndex > -1 && questionPaper && questionPaper.mandatoryQuestionCollection && questionPaper.mandatoryQuestionCollection.length > 0) {
                currentQuestion = questionPaper.mandatoryQuestionCollection[currentQIndex];
                vm.questionsAnswered = _.filter(questionPaper.mandatoryQuestionCollection, { isAnswered: true }).length;
                vm.questionsUnanswered = _.filter(questionPaper.mandatoryQuestionCollection, { isAnswered: false }).length;
            }
            if (currentQuestion && currentQuestion.id) {
                CaptureCodeActivitySvc.submitUserQuestionHistory(currentQuestion.id);
            }
            //Auto Submission.....
            if (assessmentUtility.timer._time == 0 || assessmentUtility.timer._time >= assessmentUtility.timer.totalTestTime()) {
                vm.message = {
                    title: 'The timer for this test has ended',
                    info: 'Auto submission of your answers is in progress'
                };
                vm.isAutoSubmission = true;
                endTest();
            } else if (currentQuestion.questionType === 17 && currentQuestion.isAnswered) {
                vm.message = {
                    title: 'Thank you! Your responses have been captured.',
                    info: null
                };
            } else {
                vm.message = {
                    title: 'Are you sure you want to end the test?',
                    info: 'Once you end the test, you will not be able to access it again.'
                };
                //checktimer();
            }
            if (currentQuestion && currentQuestion.questionType === 17 && currentQuestion.isAnswered) {
                vm.isGoBackIsAllowed = false;
            }
        }

        function backToTest() {
            $state.go('assess.loadTest', { alias: alias, questionIndex: currentQIndex, questionPaper: questionPaper }, { location: 'replace' });
        }

        function endTest() {
            endTestCalls++;
            if (endTestCalls === 1) {
                // if ($rootScope.endTestInterval) {
                //     $interval.cancel($rootScope.endTestInterval);
                //     $rootScope.endTestInterval = null;
                // }
                vm.submittingTest = true;
                if (loginInfo.Config.isFaceTrackingEnable) {
                    clearInterval($rootScope.captureKeyInterval);
                }
                if (loginInfo.Config && loginInfo.Config.logoutIfNoInternetIn) {
                    sessionStorage.setItem("isTestCompleted", true);
                    // hvsService.killLogoutTimer();
                }
                $rootScope.captureKeyInterval = null;
                // if (!isOnlinePreview) {
                //     submitTestResult();
                // } else {
                //     console.log('submitUserQuestionHistory', currentQuestion.id);
                //     $state.go('submitConfirmation', { 'alias': alias }, { location: 'replace' });
                // }
                submitTestResult();
            }
        }

        function submitTestResult() {
            var isSecondaryCameraEnable = sessionStorage.getItem("isSecondaryCameraEnable") === "true" ? true : false,
                roomInfo = angular.fromJson(sessionStorage.getItem(sessionStorage.getItem('X-AUTH-TOKEN') + '-myRoomInfo')),
                loginInfo = loginService.getLoginInfo();

            if (isSecondaryCameraEnable) {
                var data = {
                    app: "secondary_camera_msg_delivery",
                    toUserId: roomInfo && roomInfo.invokingEntityId,
                    msgType: "end_test",
                    msgBody: null
                };
                socketService.sendMessage(data);
            }

            if (loginInfo && loginInfo.Config) {
                isVideoProctoringEnabled = loginInfo.Config.VideoProctoring;
                isScreenProctoringEnable = loginInfo.Config.ScreenProctoringIsMandat;
            }
            if (currentQuestion && currentQuestion.id) {
                CaptureCodeActivitySvc.submitUserQuestionHistory(currentQuestion.id);
            }
            if (!assessmentUtility.localStorage.getData('isQuestionVideoStarted')) {
                if (isScreenProctoringEnable || isVideoProctoringEnabled) {
                    stopScreenRecording()
                        .then(function(res) {
                            res && console.log("screen_recording_stop_success ", res);
                            return stopVideoRecording();
                        })
                        .then(function(res) {
                            res && console.log("video_recording_stop_success ", res);
                        })
                        .catch(function(res) {
                            console.log("proctor_stop_error ", res);
                        })
                        .finally(function() {
                            submitTest();
                        });

                } else {
                    if (_.size(trackerTypes) > 0) {
                        trackerService.stopMediaStream();
                    }
                    submitTest();
                }
                //submitTest();
                /*if (!isOnlinePreview) {
                    submitTest();
                } else {
                    console.log('submitUserQuestionHistory', currentQuestion.id);
                    $state.go('submitConfirmation', { 'alias': alias }, { location: 'replace' });
                }*/
                /*if (_.size(trackerTypes) > 0) {
                    trackerService.stopTrackers(trackerTypes)
                        .then(function() {
                            submitTest();
                        });
                } else {
                    trackerService.pushTrackerStatStopLog();
                }*/
            } else {
                videoAnsRecorder.stop().then(function() {
                    submitTest();
                });
            }
        }

        function stopScreenRecording() {
            if (isScreenProctoringEnable) {
                return screenRecordingService.stop();
            }
            return $q.when();
        }

        function stopVideoRecording() {
            if (isVideoProctoringEnabled) {
                return proctoringService.stop();
            }
            return $q.when();
        }

        function submitTest() {
            if (isOnlinePreview) {
                $state.go('submitConfirmation', { 'alias': alias }, { location: 'replace' });
            }
            var submitionType = vm.isAutoSubmission ? "AutoSubmission" : "ManualSubmission";

            assessmentService.submitTest(false, submitionType + "-" + endTestCalls)
                .then(function(response) {
                    if (response) {
                        submissionAttempts = 0;
                        testSubmissionFailureCount = 0;
                        afterSubmission.do(response);
                    }
                })
                .catch(function(res) {
                    if (res && res.status === "KO" &&
                        res.error &&
                        res.error.ErrorMessage === "Session Expired") {
                        $log.log(res.error.ErrorMessage);
                        return false;
                    }
                    reattemptSubmissiononFailure(res);
                });
        }

        function reattemptSubmissiononFailure(response) {
            submissionAttempts++;
            if (submissionAttempts < submissionAttemptsConfig) {
                submitTestResult();
            } else if (submissionAttempts === submissionAttemptsConfig) {
                testSubmissionFailureCount++;
                submissionAttempts = 0;
                if (testSubmissionFailureCount < 3) {
                    redoSubmit(response);
                }
            }
            if (testSubmissionFailureCount === 3) {
                assessmentService.generateOfflineAnswerKey();
            }
        }

        function redoSubmit(response) {
            var message = (response && response.Message) ? response.Message : "Results Cannot be Submitted Now";
            message += "<br/>Click <b>OK</b> to retry.";
            var data = {
                bodyStr: message,
                headerStr: 'Network ERROR',
                isAction: true,
                action: {
                    isOkBtn: true
                }
            };
            openModalService.openModal('notificationTemplate', data).then(function(res) {
                submitTestResult();
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('OnlineAssessmentAngular')
        .component('captureId', {
            bindings: {
                'responseData': '&'
            },
            controller: captureIdController,
            controllerAs: 'vm',
            templateUrl: 'app/assessment/captureId.tpl.html'
        });

    function captureIdController(trackerService, imageTracker) {
        var vm = this;

        vm.stream = null;
        vm.imgCaptured = false;

        vm.captureImage = captureImage;
        vm.recaptureImage = recaptureImage;

        active();

        function active() {
            trackerService.getMediaStream()
                .then(function(stream) {
                        vm.stream = stream;
                        document.getElementById('videoToCapture').srcObject = stream;
                    },
                    function(res) {
                        console.log(res);
                    });
        }

        function captureImage() {
            var roomInfo = JSON.parse(sessionStorage.getItem(sessionStorage.getItem('X-AUTH-TOKEN') + '-myRoomInfo')),
                option = {
                    videoElementId: 'videoToCapture',
                    isTimeIntervalRequired: false,
                    isTemorarySaved: true,
                    proctoringImagePath: roomInfo.photoIdPath,
                    isFileUploadToS3PermanentPath: true
                };
            vm.imgCaptured = true;
            var canvas = document.createElement("canvas"),
                context = canvas.getContext('2d');
            canvas.width = videoToCapture.width;
            canvas.height = videoToCapture.height;
            context.drawImage(videoToCapture, 0, 0, videoToCapture.width, videoToCapture.height);
            vm.imgUrl = canvas.toDataURL('image/jpeg');
            imageTracker.start(vm.stream, option).then(function(imgUrl) {
                if (imgUrl) {
                    console.log(imgUrl);
                    vm.responseData({ proceed: true, type: 'idProof', url: imgUrl });
                } else {
                    vm.responseData({ proceed: false, type: 'idProof', url: null });
                }
            });
        }

        function recaptureImage() {
            document.getElementById('videoToCapture').srcObject = vm.stream;
            vm.imgCaptured = false;
            vm.imgUrl = "";
            vm.responseData({ proceed: false, type: 'idProof', url: null });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('OnlineAssessmentAngular')
        .component('captureResponse', {
            bindings: {
                'responseData': '&'
            },
            controller: captureIdResponseController,
            controllerAs: 'vm',
            templateUrl: 'app/assessment/captureIdResponse.tpl.html'
        });

    function captureIdResponseController($timeout, $interval, webService) {
        var vm = this,
            pollCounter = 0,
            msgPollingInterval = null,
            waitInterval = null;

        vm.progressStatus = 'pendding';
        vm.waitCounter = 10 * 60;

        vm.recaptureIdImage = recaptureIdImage;

        active();

        function active() {
            // $rootScope.msgPollingInterval && clearInterval($rootScope.msgPollingInterval);
            // waitInterval = $interval(function(){
            //     --vm.waitCounter;
            //     if (vm.waitCounter === 0) {
            //         vm.waitCounter = 5 * 60;
            //     }
            // }, 1000);
            $timeout(function() {
                startMsgPolling();
            }, 10 * 1000);
        }

        function startMsgPolling() {
            //msgPollingInterval = $interval(function() {
            webService.execute('getTestUserAuthorization', { disableBlockUI: true })
                .then(function(res) {
                        pollCounter++;
                        res = res.data;
                        if (res && res.proctoringStatus && (res.proctoringStatus === "CANDIDATE_PROCTOR_APPROVED") || (res.proctoringStatus === "CANDIDATE_PHOTO_REJECTED_BY_PROCTOR")) {
                            // $interval.cancel(msgPollingInterval);
                            // msgPollingInterval = null;
                            // if(res.proctoring_status === "CANDIDATE_WAITING_FOR_PROCTOR_APPROVAL"){
                            //    setTimeout(function(){
                            //     startMsgPolling();
                            //    },5000);
                            // }
                            if (waitInterval) {
                                $interval.cancel(waitInterval);
                                waitInterval = null;
                            }
                            if (res.proctoringStatus === "CANDIDATE_PROCTOR_APPROVED") {
                                vm.progressStatus = 'approved';
                                vm.responseData({ proceed: true, type: 'idProofApprove', url: null });
                            }
                            if (res.proctoringStatus === "CANDIDATE_PHOTO_REJECTED_BY_PROCTOR") {
                                vm.progressStatus = 'rejected';
                                if (res.eventHistory && res.eventHistory.length > 0) {
                                    vm.rejectMsg = _.unescape(_.last(res.eventHistory).comment);
                                }
                                // vm.responseData({ proceed: false, type: 'idProofApprove', url: null});
                            }
                        } else {
                            var interval = pollCounter > 9 ? 30 : 5;
                            $timeout(function() {
                                startMsgPolling();
                            }, interval * 1000);
                        }
                    },
                    function() {
                        var interval = pollCounter > 9 ? 30 : 5;
                        $timeout(function() {
                            startMsgPolling();
                        }, interval * 1000);
                    });
            //}, 5000);
        }

        function recaptureIdImage() {
            vm.responseData({ proceed: false, type: 'idProofApprove', url: null });
        }
    }
})();

(function() {
    'use strict';
    angular
        .module('OnlineAssessmentAngular')
        .controller('callbackController', callbackController);
    /* @ngInject */

    function callbackController($location, $interval, $stateParams) {
        var vm = this;
        vm.params = {};
        vm.remainingTime = 180;
        vm.showTime = '00:00';
        vm.submessage = 'This process can take several minutes.';
        active();

        function active() {
            if ($stateParams && $stateParams.data) {
                var data = $stateParams.data;
                console.log(data, 'b4');
                try {
                    data = JSON.parse(atob($stateParams.data));
                    console.log(data, 'hafter');
                    if (data && data.type) {
                        switch (data.type) {
                            case 'nseit':
                                window.parent.parent.parent.postMessage(JSON.stringify(data), '*');
                                break;
                            default:
                                window.parent.postMessage(JSON.stringify(data), '*');
                                break;
                        }
                        if (sessionStorage.getItem('automationUIWaitTime')) {
                            vm.remainingTime = parseInt(sessionStorage.getItem('automationUIWaitTime'));
                            vm.remainingTime = vm.remainingTime + 120;
                        }
                        convertTime();
                        waitTimer();
                    } else {
                        window.parent.postMessage(JSON.stringify(data), '*');
                    }
                } catch (ex) {
                    vm.params.message = 'Unexpected Error.';
                }
            }
        }

        function waitTimer() {
            $interval(function() {
                if (vm.remainingTime === 0) {
                    vm.remainingTime = 120;
                    vm.submessage = 'Still working on it.. thank you for your patience.'
                }
                vm.remainingTime--;
                convertTime();
            }, 1000);
        }

        function convertTime() {
            var mins = parseInt(vm.remainingTime / 60);
            var secs = vm.remainingTime % 60;
            if (mins < 10) {
                vm.showTime = '0';
            }
            vm.showTime += mins + ':';
            if (secs < 10) {
                vm.showTime += '0';
            }
            vm.showTime += secs;
        }
    }
})();

(function() {
    'use strict';
    angular
        .module('OnlineAssessmentAngular')
        .controller('callBackVersantController', callBackVersantController);
    /* @ngInject */

    function callBackVersantController($location, $interval) {
        var vm = this;
        vm.remainingTime = 180;
        vm.showTime = '00:00';
        vm.submessage = 'This process can take several minutes.';
        active();

        function active() {
            var msg = { type: 'versantCallback' };
            if ($location.$$search && $location.$$search.lti_errorlog) {
                if ($location.$$search.lti_errorlog === 'LAUNCH_UNSUCCESSFUL') {
                    msg.errorDesc = '<p>Versant test could not be started. Please close this window and start the test again.</p>';
                } else if ($location.$$search.lti_errorlog === 'DELIVERY_INTERRUPTED') {
                    msg.errorDesc = '<p>Versant test could not be completed. Please close this window and start the test again.</p>';
                } else {
                    msg.errorDesc = $location.$$search.lti_errorlog;
                }
            } else {
                msg.isSuccess = true;
            }
            console.log('Versant Message', msg);
            if (sessionStorage.getItem('automationUIWaitTime')) {
                vm.remainingTime = parseInt(sessionStorage.getItem('automationUIWaitTime'));
                vm.remainingTime = vm.remainingTime + 120;
            }
            window.parent.postMessage(JSON.stringify(msg), '*');
            convertTime();
            waitTimer();
        }

        function waitTimer() {
            $interval(function() {
                if (vm.remainingTime === 0) {
                    vm.remainingTime = 120;
                    vm.submessage = 'Still working on it.. thank you for your patience.'
                }
                vm.remainingTime--;
                convertTime();
            }, 1000);
        }

        function convertTime() {
            var mins = parseInt(vm.remainingTime / 60);
            var secs = vm.remainingTime % 60;
            if (mins < 10) {
                vm.showTime = '0';
            }
            vm.showTime += mins + ':';
            if (secs < 10) {
                vm.showTime += '0';
            }
            vm.showTime += secs;
        }
    }
})();

 (function() {
     'use strict';
     angular
         .module('OnlineAssessmentAngular')
         .controller('BrowserCompatibility', BrowserCompatibility);
     //.directive('imageonload', imageonload);
     /* @ngInject */

     function BrowserCompatibility($log, $state, $scope, $rootScope, $window, $stateParams, $interval, deviceDetector, openModalService, loginService, webService) {
         var vm = this,
             imgsize = 1408049,
             startTime, options = {},
             candidate = {},
             prevDebugInfoSent = {};

         vm.imgfile = "/s3_cached/hirepro-content/hirepro/common/e930854a-9d71-4eac-9d3c-f3ac90b24607BandwidthTestImage.jpg?v=" + Date.now();
         vm.systemInfo = {
             isBrowserCompatible: null,
             bandWidth: 0,
             checkSEB: false
         };
         vm.isProctoringCheck = false;
         vm.practiceTestEnabled = false;
         //vm.onImageLoad = onImageLoad;
         vm.startSampleTest = startSampleTest;
         vm.submitComment = submitComment;
         vm.internetSpeed = {};
         vm.overAllStatus = {};
         vm.otherConfig = {};
         vm.slowSystemInstruction = '<div>' +
             '<p>Processor: <strong>i3 5th gen, 2.2Ghz equivalent/higher</strong></p>' +
             '<p>RAM: <strong>4 GB or higher</strong></p>' +
             '<p>Resolution: <strong>1366 X 768 or higher</strong></p>' +
             '</div>';
        vm.isFeedbackAllowed = true;

         active();

         function active() {
             localStorage.clear();
             openModalService.closeAllModals();
             startTime = new Date();
             vm.systemInfo.os = deviceDetector.os;
             vm.systemInfo.osVersion = navigator.platform; //deviceDetector.os_version;
             vm.systemInfo.device = deviceDetector.device;
             vm.systemInfo.deviceSize = screen.width + ' x ' + screen.height;

             vm.systemInfo.browser = deviceDetector.browser;
             vm.systemInfo.browserVersion = deviceDetector.browser_version;
             vm.systemInfo.browserCookies = navigator.cookieEnabled ? 'Enabled' : 'Disabled';
             var test = window.open(null, "", "width=1,height=1");
             try {
                 test.close();
                 vm.systemInfo.browserPopup = "Enabled";
             } catch (e) {
                 vm.systemInfo.browserPopup = "Blocked";
             }
             vm.systemInfo.browserSize = window.innerWidth + ' x ' + window.innerHeight;
             if (navigator.cookieEnabled && vm.browserPopup === 'Enabled') {
                 vm.systemInfo.isBrowserCompatible = true;
             }
             if ($stateParams && $stateParams.stateParams) {
                 try {
                     options = angular.fromJson(atob(unescape($stateParams.stateParams)));
                     //$state.transitionTo('compatibility', { stateParams: options.alias }, { notify: false });
                 } catch (e) {
                     options.alias = $stateParams.stateParams;
                 }
                 options.video = {
                     sampleVideo: {
                         type: "videoAnswer"
                     }
                 };
                 if(options.socketCheckConfig) {
                    vm.otherConfig.socketCheckConfig = options.socketCheckConfig;   
                 }
                 if(options.integrationGUID) {
                    vm.otherConfig.integrationGUID = options.integrationGUID;
                 }
                 if(options.clientId) {
                    vm.otherConfig.clientId = options.clientId;
                 }
                 console.log(options, 'cha');
                 var today = new Date();
                 var dd = today.getDate().toString();
                 var mm = (today.getMonth() + 1).toString();
                 var yyyy = today.getFullYear().toString();
                 options.testId = dd + mm + yyyy;
                 if (options.alias) {
                     setInitValue();
                     // options.hostName = location.host === "localhost:3000" ? "amsin.hirepro.in" : location.host;
                     // options.videoServerHost = 'exam.hirepro.in';
                     // vm.practiceTestEnabled = true; //options.practiceTest;
                     // if(options.video) {
                     //     vm.isProctoringCheck = options.video.sampleVideo;
                     // }
                     // if(options.alias) {
                     //     loginService.getCompanyInfo(options.alias).then(function(res) {
                     //         if (res && res.status == "OK") {
                     //             options.tenantId = loginService.getTenantId();
                     //             $rootScope.companyLogoUrl = res.content.logoUrl;
                     //             candidate = angular.fromJson(sessionStorage.getItem('candidate')) || {};
                     //             if (!candidate.email) {
                     //                 showEmailModal();
                     //             } else {
                     //                 setVideoOptions();
                     //             }
                     //         }
                     //     });
                     // }
                 } else {
                     showAliasModal();
                 }
             } else {
                 showAliasModal();
             }
             $interval(function() {
                 if (candidate.email && !_.isEqual(vm.systemInfo.videoInfo, prevDebugInfoSent)) {
                     vm.getVideoCompatibilityInfo(vm.systemInfo.videoInfo);
                     prevDebugInfoSent = vm.systemInfo.videoInfo;
                 }
             }, 15 * 1000);
             if ($stateParams && $stateParams.seb && $stateParams.seb === "seb") {
                 vm.systemInfo.checkSEB = true;
                 checkSEB();
             }
         }

         function setInitValue() {
             options.hostName = location.host === "localhost:3000" ? "amsin.hirepro.in" : location.host;
             options.videoServerHost = 'exam.hirepro.in';
             if(options.hideFeedback) {
                vm.isFeedbackAllowed = false;
             }
             if(options.hideHeader) {
                sessionStorage.hideHeader = true;
             }
             //vm.practiceTestEnabled = true; //options.practiceTest;

             if (options.alias) {
                 loginService.getCompanyInfo(options.alias)
                     .then(function(res) {
                             if (res && res.status == "OK") {
                                 options.tenantId = loginService.getTenantId();
                                 $rootScope.companyLogoUrl = res.content.logoUrl;
                                 candidate = angular.fromJson(sessionStorage.getItem('candidate')) || {};
                                 if(options.emailId) {
                                    candidate.email = options.emailId;
                                 }
                                 if (options.video) {
                                     vm.isProctoringCheck = options.video.sampleVideo;
                                 }
                                 if (!candidate.email) {
                                     showEmailModal();
                                 } else {
                                     setVideoOptions();
                                 }
                             } else {
                                 showAliasModal('Please provide correct Tenant alias.');
                             }
                         },
                         function() {
                             showAliasModal('Please provide correct Tenant alias.');
                         });
             }
         }

         function startSampleTest() {
             if (vm.practiceTestEnabled) {
                 var windowName = 'sampletestpage',
                     url = 'https://goo.gl/wnWMvN';
                 var popUp = window.open(url, windowName, 'resizable=no,menubar=no,status=no,toolbar=no,scrollbars=no,location=0, directories=0,dependant=yes,dialog=yes,modal=yes,unadorned=yes,top=0,left=0,width=' + screen.width + ', height=' + screen.height);
                 if (popUp === null || typeof(popUp) === 'undefined') {
                     alert('Please disable your pop-up blocker to take practice test.');
                 } else {
                     popUp.focus();
                 }
             }
         }

         // function onImageLoad() {
         //     var endTime = new Date();
         //     vm.systemInfo.timetaken = (endTime.getTime() - startTime.getTime()) / 1000;
         //     $log.log(vm.systemInfo.timetaken);
         //     vm.systemInfo.bandWidthLevel = (imgsize * 8 / vm.systemInfo.timetaken) * 100;
         //     vm.systemInfo.bandWidth = Math.round(vm.systemInfo.bandWidthLevel / 1048576) / 100;
         //     vm.systemInfo.bandWidthLevel = Math.round(vm.systemInfo.bandWidthLevel / 1024) / 100;
         //     vm.systemInfo.bandwidthText = getBandwidthLevel(vm.systemInfo.bandWidthLevel);
         // }

         function getBandwidthLevel(bandwidth) {
             if (bandwidth < 1024)
                 return 'Low';
             else if (bandwidth < 1024 * 5)
                 return 'Medium';
             else
                 return 'High';
         }

         function showEmailModal(msg) {
             openModalService.openModal('provideEmailTemplate', { 'errorMessage': msg }).then(function(res) {
                 if (res.result.email) {
                     candidate.email = res.result.email;
                     sessionStorage.setItem('candidate', angular.toJson(candidate));
                     setVideoOptions();
                     if (vm.systemInfo.isPendding) {
                         vm.getVideoCompatibilityInfo(vm.systemInfo.videoInfo);
                     }
                 } else {
                     showEmailModal('Please provide registered email.');
                 }
             });
         }

         function setVideoOptions() {
             vm.videoSampleOpts = {
                 opts: {
                     type: 'videoAnswer',
                     tenantId: options.tenantId,
                     testId: options.testId,
                     candidateEmail: candidate.email,
                     videoServerHost: options.videoServerHost,
                     isAuthenticated: false
                 },
                 isAction: true,
                 modalSize: 'lg',
                 action: {
                     isOkBtn: true,
                     okButtonText: 'Submit'
                 }
             };
         }

         function showAliasModal(msg) {
             openModalService.openModal('provideAliasTemplate', { 'errorMessage': msg }).then(function(res) {
                 if (res.result.alias) {
                     options.alias = res.result.alias;
                     options.video = {
                         sampleVideo: {
                             type: "videoAnswer"
                         }
                     };
                     $state.transitionTo('compatibility', { stateParams: res.result.alias }, { notify: false });
                     setInitValue();
                 } else {
                     showAliasModal('Please provide correct Tenant alias.');
                 }
             });
         }

         function submitComment() {
             var data = {
                     module: 'sampleProctorRecording',
                     type: 'diagnostics',
                     context: {
                         tenantId: options.tenantId,
                         participantEmail: candidate.email,
                         participantName: "" /* Optional */
                     },
                     data: {
                         confName: options.hostName + '-' + candidate.email + '-' + options.testId,
                         /* e.g: < assessmentHostName >-< email-id >-< testId > */
                         comment: vm.systemInfo.userComment
                     }
                 },
                 header = {
                     "X-TEST-AUTHENTICATION": false,
                     "X-TENANT-ID": options.tenantId,
                     "X-USER-ID": 0,
                     "X-ASSESSMENT-SERVER-HOST": options.hostName
                 };
             webService.execute('https://' + options.videoServerHost + '/py/proctoring/log/api/v1/video-logs', data, null, null, header)
                 .then(function(res) {
                         if (!res || !res.data || res.data.status === "KO") {
                             $log.log(res);
                         }
                         //alert('System testing result submitted successfully');
                         //sessionStorage.removeItem('candidate');
                         //$window.location.reload();
                         var data = {
                             bodyStr: "<div><p>Thanks for sharing your feedback. </p></div>",
                             headerStr: "Feedback",
                             isAction: true,
                             action: {
                                 isOkBtn: true,
                                 okText: 'Close'
                             }
                         };
                         openModalService.openModal('notificationTemplate', data);
                     },
                     function(res) {
                         $log.log(res);
                     }
                 );
         }

         function checkSEB() {
             vm.systemInfo.os = deviceDetector.os;
             vm.systemInfo.osVersion = navigator.platform;
             var isWindow = deviceDetector.raw.os.windows,
                 isWindow8 = deviceDetector.raw.os_version["windows-8"],
                 isWindow8dot1 = deviceDetector.raw.os_version["windows-8-1"],
                 isWindow10 = deviceDetector.raw.os_version["windows-10"];

             if (isWindow && (isWindow8 || isWindow8dot1 || isWindow10)) {
                 vm.systemInfo.sebSatus = true;
                 vm.systemInfo.sebText = "Yes";
             } else {
                 vm.systemInfo.sebSatus = false;
                 vm.systemInfo.sebText = "No";
             }




         }

         vm.getVideoCompatibilityInfo = function(info) {
             vm.videoCompatibilityInfo = info;
             vm.systemInfo.videoInfo = info;
             if (vm.overAllStatus && vm.overAllStatus.echoTestStatus === 'end') {
                 if (vm.overAllStatus.micCheck && vm.overAllStatus.cameraCheck && vm.overAllStatus.browserApproved && vm.overAllStatus.echoCheck && !vm.overAllStatus.standaloneMinFps) {
                     vm.systemInfo.overAllStatus = true;
                 } else {
                     vm.systemInfo.overAllStatus = false;
                 }
                 var message = {success: vm.systemInfo.overAllStatus, message: 'Hirepro compatibility check completed'};
                 window.parent.postMessage(message, '*');
             }
             if (candidate && candidate.email) {
                 var data = {
                         module: 'sampleProctorRecording',
                         type: 'diagnostics',
                         context: {
                             tenantId: options.tenantId,
                             participantEmail: candidate.email,
                             participantName: "" /* Optional */
                         },
                         data: {
                             confName: options.hostName + '-' + candidate.email + '-' + options.testId,
                             /* e.g: < assessmentHostName >-< email-id >-< testId > */
                             systemInfo: vm.systemInfo
                         }
                     },
                     header = {
                         "X-TEST-AUTHENTICATION": false,
                         "X-TENANT-ID": options.tenantId,
                         "X-USER-ID": 0,
                         "X-ASSESSMENT-SERVER-HOST": options.hostName
                     };
                 webService.execute('https://' + options.videoServerHost + '/py/proctoring/log/api/v1/video-logs', data, null, null, header)
                     .then(function(res) {
                             if (!res || !res.data || res.data.status === "KO") {
                                 $log.log(res);
                             }
                             vm.systemInfo.isPendding = false;
                             if (info && info.recordedVideos && info.recordedVideos.length > 0) {
                                 var data = {
                                     bodyStr: "<div><p>Thanks for completing system compatibility check. You can close the browser.</p></div>",
                                     headerStr: "System Test",
                                     isAction: true,
                                     action: {
                                         isOkBtn: true,
                                         okText: 'Close'
                                     }
                                 };
                                 openModalService.openModal('notificationTemplate', data);
                             }
                             // $window.location.reload();
                             //alert('System testing result submitted successfully');
                         },
                         function(res) {
                             $log.log(res);
                         }
                     );
             } else {
                 vm.systemInfo.isPendding = true;
             }
         };
     }

     // function imageonload() {
     //     return {
     //         restrict: 'A',
     //         link: function(scope, element, attrs) {
     //             element.bind('load', function() {
     //                 //call the function that was passed
     //                 scope.$apply(attrs.imageonload);
     //             });
     //         }
     //     };
     // }
 })();

(function() {
    'use strict';

    angular
        .module('OnlineAssessmentAngular')
        .component('basicInstruction', {
            bindings: {
                'questionPaper': '=questionPaper',
                'isThirdParty': '<'
            },
            controller: basicInstructionController,
            controllerAs: 'vm',
            templateUrl: 'app/assessment/basicInstruction.tpl.html'
        });

    function basicInstructionController() {
        var vm = this;

        active();

        function active(){}
    }
})();

(function() {
    "use strict";

    angular
        .module("OnlineAssessmentAngular")
        .component("assessmentTermsAndConditons", {
            controller: assessmentTcController,
            controllerAs: "vm",
            templateUrl: "app/assessment/assessmentTermsAndConditions.tpl.html",
            bindings: {
                responseData: '&'
            }
        });

    function assessmentTcController() {
        var vm = this;

        vm.isAssessmentTc1Accepted = false;
        vm.isAssessmentTc2Accepted = false;

        vm.isAssessmentTcAccepted = isAssessmentTcAccepted;
        vm.getTypeOfTest = getTypeOfTest;

        vm.$onInit = function() {
            vm.responseData = vm.responseData;
            init();
        }

        function init() {
            
        }

        function isAssessmentTcAccepted(){
            var isTcAccepted = vm.isAssessmentTc1Accepted && vm.isAssessmentTc2Accepted;
            vm.responseData({ proceed: isTcAccepted, type: 'assessmentTermsAndConditons' });
        }

        function getTypeOfTest() {
            return sessionStorage.typeOfTest ? sessionStorage.typeOfTest : 'hirepro';
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('OnlineAssessmentAngular')
        .component('submitButton', {
            bindings: {
                "currentQuestion": "=",
                "buttonType": "="
            },
            controller: submitButtonController,
            controllerAs: 'vm',
            //templateUrl: 'app/common/submitBtn.tpl.html'
            template: '<ng-include src="vm.submitButtonTemplateUrl"/>'
        });
    /*.component('modalSubmitButton', {
        bindings: {
            "buttonType": "="
        },
        controller: submitButtonController,
        controllerAs: 'vm',
        templateUrl: 'app/common/modalSubmitBtn.tpl.html'
    });*/

    submitButtonController.$inject = ['$rootScope', 'assessmentService', 'assessmentUtility', '$state', '$interval', 'modalService', 'blockUI', 'loginService', 'commonQuestionActions', 'proctoringService', '$window', '$timeout', '$scope', 'afterSubmission', 'openModalService', 'CaptureCodeActivitySvc', 'trackerService'];

    function submitButtonController($rootScope, assessmentService, assessmentUtility, $state, $interval, modalService, blockUI, loginService, commonQuestionActions, proctoringService, $window, $timeout, $scope, afterSubmission, openModalService, CaptureCodeActivitySvc, trackerService) {
        var vm = this;
        var ls = assessmentUtility.localStorage,
            submitButtonTemplateUrl = 'app/common/submitBtn.tpl.html',
            paramObj = assessmentUtility.getSateParameters($state.params),
            loginInfo = loginService.getLoginInfo(),
            isUserGroupChoiceEnable = false,
            activeQIndex = assessmentUtility.getActiveQuestionIndex(),
            totalQCount = assessmentService.questionpaper.getTotalQuestionCount(),
            isOptionalGrpPresentToBeSelected = assessmentService.questionpaper.isOptionalGrpPresentToBeSelected(),
            ucIsAllMandatoryGrpSelected = ls.getData("ucIsAllMandatoryGrpSelected"),
            isMandatGrp = false,
            testSubmissionFailureCount = 0,
            submissionAttemptsConfig = 5,
            submissionAttempts = 0,
            savedAlias = $window.sessionStorage.getItem("oa_tenantAlias");
            //isOnlinePreview = ls.getData(savedAlias + "_isOnlinePreview"),
            //optModalBackdrop = 'submit-confirmation',
            //isOkEnable = true,
            //message = null,
            //testInfo = null;

        vm.isSecureBrowserMandatory = false;
        if(sessionStorage.isSecureBrowserMandatory == 'true') {
            vm.isSecureBrowserMandatory = true;
        }
        vm.isLastQuestionVisited = ls.getData("isLastQuestionVisited");
        vm.submitButtonTemplateUrl = getsubmitButtonTemplateUrl();
        $scope.$watch(function(){
          return ls.getData('isQuestionVideoStarted');
        },function(){
            var isQuestionVideoStarted = ls.getData('isQuestionVideoStarted');
            vm.isDisabled = isQuestionVideoStarted === null ? false : isQuestionVideoStarted;
        });

        function getsubmitButtonTemplateUrl() {
            if (vm.buttonType === "modalSubmit") {
                submitButtonTemplateUrl = 'app/common/modalSubmitBtn.tpl.html';
            }
            return submitButtonTemplateUrl;
        }
        vm.alias = paramObj && paramObj.alias;
        if (loginInfo && loginInfo.Config) {
            vm.isAnswerMandatory = !!loginInfo.Config.isAnsMandt;
            vm.isAutoTest = !!loginInfo.Config.IsAutoTest;
            isUserGroupChoiceEnable = !!loginInfo.Config.IsUserGroupChoiceEnable;
        }
        if (isUserGroupChoiceEnable && vm.currentQuestion) {
            isMandatGrp = _.indexOf(loginInfo.Config.madatGrpIds, vm.currentQuestion.gpId) > -1;
        }
        vm.isVisible = (activeQIndex >= 0) &&
            (activeQIndex === totalQCount - 1) &&
            !isOptionalGrpPresentToBeSelected ||
            (!isUserGroupChoiceEnable && vm.isLastQuestionVisited) ||
            (isUserGroupChoiceEnable && ucIsAllMandatoryGrpSelected && !isMandatGrp);

        if (vm.isVisible) {
            ls.setData("isLastQuestionVisited", true);
        }

        vm.submitTestResult = function() {
            $state.go('assess.endTest', { 'alias': vm.alias, questionIndex: assessmentUtility.getActiveQuestionIndex() }, { location: 'replace' });
        };
        //var testSubmissionFailureCount = 0;
        vm.isVisibleCandAnswer = false;

        function submitTestResult() {
            CaptureCodeActivitySvc.submitUserQuestionHistory(vm.currentQuestion.id);
            assessmentService.submitTest(false, "manualFinalSubmition")
                .then(function(response) {
                    if (response) {
                        submissionAttempts = 0;
                        testSubmissionFailureCount = 0;
                        afterSubmission.do(response);
                    }
                })
                .catch(function(response) {
                    reattemptSubmissiononFailure(response);
                });
        }

        function reattemptSubmissiononFailure(response) {
            submissionAttempts++;
            if (submissionAttempts < submissionAttemptsConfig) {
                submitTestResult();
            } else if (submissionAttempts === submissionAttemptsConfig) {
                testSubmissionFailureCount++;
                submissionAttempts = 0;
                if (testSubmissionFailureCount < 3) {
                    redoSubmit(response);
                }
            }
            if (testSubmissionFailureCount === 3) {
                assessmentService.generateOfflineAnswerKey();
            }
        }

        function redoSubmit(response) {
            var message = (response && response.Message) ? response.Message : "Results Cannot be Submitted Now";
            message += "<br/>Click <b>OK</b> to retry.";
            var data = {
                bodyStr: message,
                headerStr: 'Network ERROR',
                isAction: true,
                action: {
                    isOkBtn: true
                }
            };
            openModalService.openModal('notificationTemplate', data).then(function(res) {
                submitTestResult();
            });
        }

        // $scope.$on('$destroy', function() {
        //     openModalService.closeAllModals();
        // });
    }
})();

(function() {
    'use strict';

    angular
        .module('OnlineAssessmentAngular')
        .component('header', {
            templateUrl: 'app/common/header.tpl.html',
            controller: headerController,
            controllerAs: 'vm',
            bindToController: true
        });

    //headerController.$inject = ['$scope', '$anchorScroll', 'loginService', 'assessmentUtility', '$rootScope', 'openModalService'];

    function headerController($scope, $anchorScroll, $document, loginService, assessmentUtility, $rootScope, openModalService, $timeout) {
        var vm = this,
            loginInfo = null,
            isFaceDetectingFrameVisible = false,
            inTestCheatingWarning = false;
        // vm.isSampleTest = false;
        // vm.isVisible = false;
        // vm.testDuration = 0;
        // vm.timeRemain = 0;
        // vm.ApplicationViewType = sessionStorage.getItem('ApplicationViewType');

        // $rootScope.$watch('companyLogoUrl', function() {
        //     vm.companyLogoUrl = $rootScope.companyLogoUrl ? $rootScope.companyLogoUrl : "assets/images/hirepro_logo.png";
        // });
        vm.util = assessmentUtility;
        //vm.parseInt = parseInt;
        vm.candidateName = "";
        //vm.today = moment().format('ddd, MMM D');

        vm.showBasicInstruction = showBasicInstruction;
        vm.onMenuClick = onMenuClick;
        vm.showHeader = false;
        vm.showSubHeader = false;
        vm.showInTestCheatingWarning = false;

        var stateChangeSuccess_rootScope = $rootScope.$on("$stateChangeSuccess", function(event, toState, toParams, fromState, fromParams) {
            $anchorScroll();
            var currentStateName = toState.name;
            vm.currentState = toState.name;
            var testLoginInfo = assessmentUtility.localStorage.getData('TestLoginInformation');
            var isThirdParty = testLoginInfo && testLoginInfo.Config && testLoginInfo.Config.thirdPartyTestType &&
                (testLoginInfo.Config.thirdPartyTestType.toLowerCase() === "versant" ||
                    testLoginInfo.Config.thirdPartyTestType.toLowerCase() === "cocubes" ||
                    testLoginInfo.Config.thirdPartyTestType.toLowerCase() === "nseit" ||
                    testLoginInfo.Config.thirdPartyTestType.toLowerCase() === "mettl" ||
                    testLoginInfo.Config.thirdPartyTestType.toLowerCase() === "wheebox" ||
                    testLoginInfo.Config.thirdPartyTestType.toLowerCase() === "dotin" ||
                    testLoginInfo.Config.thirdPartyTestType.toLowerCase() === "talentlens" ||
                    testLoginInfo.Config.thirdPartyTestType.toLowerCase() === "thirdpartyproctoring" ||
                    testLoginInfo.Config.thirdPartyTestType.toLowerCase() === "force" ||
                    testLoginInfo.Config.thirdPartyTestType.toLowerCase() === "symbiosis" ||
                    testLoginInfo.Config.thirdPartyTestType.toLowerCase() === "poptest" ||
                    testLoginInfo.Config.thirdPartyTestType.toLowerCase() === "padplayer" ||
                    testLoginInfo.Config.thirdPartyTestType.toLowerCase() === "testnav");
            vm.showHeader = (vm.currentState && vm.currentState != 'assess.login' && vm.currentState != 'callBackVersant' && vm.currentState != 'callback' && vm.currentState != 'landing') && !(isThirdParty && testLoginInfo.Config.thirdPartyTestType.toLowerCase() === "nseit");
            inTestCheatingWarning = assessmentUtility.parseFlagValToBoolean(sessionStorage.getItem("inTestCheatingWarning"));
            $timeout(function() {
                if (sessionStorage.hideHeader) {
                    vm.showHeader = false;
                }
            }, 10);
            vm.showSubHeader = (currentStateName === "assess.loadTest" || currentStateName === "assess.endTest") && !isThirdParty;
            if (currentStateName === "assess.loadTest" || currentStateName === "assess.endTest") {
                //vm.showSubHeader = !isThirdParty;
                isFaceDetectingFrameVisible = assessmentUtility.localStorage.getData("isFaceDetectingFrameVisible");
            }
            vm.showCandidateName = (currentStateName !== "testLinkByEmail" && currentStateName !== "compatibility");
            //vm.isVisible = currentStateName === "assess.loadTest" || currentStateName === "compatibility" || currentStateName === "testLinkByEmail";
            loginInfo = loginService.getLoginInfo();
            if (loginInfo && loginInfo.CandidateName) {
                vm.candidateName = loginInfo.CandidateName;
                if (isThirdParty || !vm.showSubHeader || currentStateName === "submitConfirmation") {
                    vm.showInstructions = false;
                } else {
                    vm.showInstructions = true;
                }
                vm.showInTestCheatingWarning = isThirdParty &&
                    currentStateName === "assess.loadTest" ?
                    inTestCheatingWarning : false;
            } else {
                vm.showInstructions = false;
            }
            if (loginInfo && loginInfo.assessmentConfig && loginInfo.assessmentConfig.showCandidateID) {
                vm.candidateId = loginInfo.CandidateId;
            }
            vm.isVideoControlRequired = loginInfo && loginInfo.Config && ((loginInfo.Config.VideoProctoringIsMandat && isFaceDetectingFrameVisible) || loginInfo.Config.multiFaceDetectionMsg);
            // for compatibility page tenant check //
            if (toState.name === 'compatibility' && toParams.stateParams) {
                sessionStorage.setItem('oa_tenantAlias', toParams.stateParams);
            }
            var tenantName = sessionStorage.getItem("oa_tenantAlias");
            vm.brandLogo = "/s3_cached/all-hirepro-files/hirepro/attachments/HP_light_small_v1.png";
            if (tenantName && tenantName.indexOf('accenture') > -1) {
                vm.brandLogo = '/s3_cached/hirepro-content/accenture/branding_v4/accenture_logo_for_dark_background.png';
                //vm.brandLogo = "/s3_cached/hirepro-content/accenture/branding_v3/accenture_logo_for_dark_background.png";
            }
            /// ======================== nseit hardcode changes [start] ===================== ///
            if (sessionStorage.isNseitTenant) {
                vm.brandLogo = 'assets/images/nse-logo.png';
            }
            /// ======================== nseit hardcode changes [ends] ===================== ///

            //vm.showActiveTestHeaderElements = currentStateName === "assess.loadTest";
            //if (vm.isVisible) {
            //if (!loginInfo) {
            //loginInfo = loginService.getLoginInfo();
            //}
            //if (loginInfo && loginInfo.CandidateName) {
            //    vm.candidateName = loginInfo.CandidateName;
            //}
            //vm.testDuration = loginInfo && (loginInfo.TestDuration * 60);
            //var testIns = loginInfo && loginInfo.TestInstructions;
            //if (testIns) {
            //    testIns = testIns.replace(/<a.*?>(.*?)<\/a>/g, "");
            //    vm.testInstruction = $sce.trustAsHtml(testIns);
            //}
            // if (location.hostname.indexOf("demo") >= 0) {
            //     vm.isSampleTest = true;
            // }
            //}
            if (currentStateName === "submitConfirmation") {
                $scope.$on('$destroy', stateChangeSuccess_rootScope);
            }
            if (loginInfo && loginInfo.Config) {
                vm.enableChatting = !!loginInfo.Config.enableChatting;
                vm.chatUserId = loginInfo.Config.chatUserId;
            }
        });

        function showBasicInstruction() {
            var data = {
                isAction: true,
                action: {
                    isOkBtn: false,
                    isCancelBtn: false
                }
            };
            openModalService.showModal('basicInstruction', data, $scope, true);
        }

        function onMenuClick(event) {
            if (angular.element($document[0].querySelector('#sideMenu'))) {
                angular.element($document[0].querySelector('#sideMenu')).toggleClass('collapse');
                event.stopPropagation();
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('OnlineAssessmentAngular')
        .component('goToLogin', {
            templateUrl: 'app/common/goToLogin.html',
            controller: gotologinController,
            controllerAs: 'vm'
        });

    gotologinController.$inject = [
        '$log',
        '$state',
        '$window',
        '$scope',
        '$rootScope',
        'modalService',
        'assessmentUtility',
        'commonService',
        'openModalService'
    ];

    function gotologinController($log, $state, $window, $scope, $rootScope, modalService, assessmentUtility, commonService, openModalService) {

        var vm = this;
        vm.gotologin = gotologin;
        vm.winHeight = window.innerHeight;
        $rootScope.$watch('companyLogoUrl', function() {
            vm.companyLogoUrl = $rootScope.companyLogoUrl ? $rootScope.companyLogoUrl : "assets/images/hirepro_logo.png";
            /// ======================== nseit hardcode changes [start] ===================== ///
            if (sessionStorage.isNseitTenant) {
                vm.companyLogoUrl = 'assets/images/nse-logo.png';
            }
            /// ======================== nseit hardcode changes [ends] ===================== ///
        });
        assessmentUtility.localStorage.setData('TestLoginInformation', null);
        assessmentUtility.sessionStorage.setData('TestLoginInformation', null);
        // history.pushState(null, null, location.href);
        // window.onpopstate = function(event) {
        //     history.go(1);
        // };
        var paramObj = assessmentUtility.getSateParameters($state.params);
        if (paramObj) {
            vm.alias = paramObj.alias;
            vm.userId = paramObj.uid;
            vm.userPassword = paramObj.pswd;
            vm.autologin = paramObj.autologin;
            vm.isOnlinePreview = paramObj.isOnlinePreview;
            vm.previewToken = paramObj.previewToken;
            if (vm.alias) {
                vm.gotologin();
            } else {
                showAliasModal();
            }
        } else {
            showAliasModal();
        }
        assessmentUtility.disableBackButton(location.href);

        function gotologin() {
            if (vm.alias == -1 || !vm.alias || (vm.alias && vm.alias.trim() === "")) {
                showAliasModal();
                return false;
            }
            var stateParams = {};
            stateParams.alias = vm.alias ? vm.alias : '';
            if (vm.autologin)
                stateParams.autologin = vm.autologin;
            if (vm.userId)
                stateParams.uid = btoa(vm.userId);
            if (vm.userPassword)
                stateParams.pswd = btoa(vm.userPassword);
            if (vm.isOnlinePreview) {
                stateParams.isOnlinePreview = btoa(vm.isOnlinePreview);
            }
            if (vm.previewToken) {
                stateParams.previewToken = btoa(vm.previewToken);
            }
            if (vm.viewType) {
                stateParams.viewType = vm.viewType;
            }
            $state.go('assess.login', { stateParams: btoa(angular.toJson(stateParams)) }, { location: 'replace' });
        }

        function showAliasModal(msg) {
            openModalService.openModal('provideAliasTemplate', { 'errorMessage': msg }).then(function(res) {
                if (res.result.alias) {
                    vm.alias = res.result.alias;
                    vm.ogrUrl = res.result.ogrUrl;
                    vm.isIFrameVisible = vm.ogrUrl ? true : false;
                } else {
                    showAliasModal('Please provide correct Tenant alias.');
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('OnlineAssessmentAngular')
        .component('footer', {
            templateUrl: 'app/common/footer.tpl.html',
            controller: headerController,
            controllerAs: 'vm',
            bindToController: true
        });

    function headerController() {
        var vm = this;
        vm.currentYear = moment().year();
        vm.ApplicationViewType = sessionStorage.getItem('ApplicationViewType');
    }
})();

(function() {
    'use strict';

    angular
        .module('OnlineAssessmentAngular')
        .filter('formatTime', formatTime)
        .filter('extractFileNameFromS3Path', ['assessmentUtility', extractFileNameFromS3Path])
        .filter('questionTypeView', questionTypeView);


    function formatTime() {
        return function(tm, mode) {
            var value;
            var secs = tm % 60;
            tm = (tm - secs) / 60;
            var mins = tm % 60;
            var hrs = (tm - mins) / 60;
            hrs = hrs === 0 ? "00" : pad(hrs);
            mins = mins === 0 ? "00" : pad(mins);
            secs = secs === 0 ? "00" : pad(secs);
            if (mode && mode == 'mins') {
                value = mins + ':' + secs;
            } else {
                value = hrs + ':' + mins + ':' + secs;
            }
            return value;
        };
    }

    function pad(number) {
        if (number < 10) {
            number = "0" + number;
        }
        return number;
    }

    function extractFileNameFromS3Path(assessmentUtility) {
        return function(filePath) {
            var fileName = assessmentUtility.getFileNameFromUrl(filePath);
            return fileName.substring(36).split('?')[0];
        };
    }

    function questionTypeView() {
        return function(qtype) {
            if(qtype === 'ReferenceToContext') {
              qtype = 'Reference To Context';
            }
            return qtype;
        }
        
    }

})();

(function() {
    'use strict';

    angular
        .module('OnlineAssessmentAngular')
        .run(runBlock);

    runBlock.$inject = [
        '$document',
        '$log',
        '$window',
        '$state',
        '$rootScope',
        'assessmentUtility',
        'assessmentService',
        'loginService',
        'proctoringService',
        'modalService',
        '$uibModalStack',
        'growl',
        'trackerService',
        '$timeout',
        '$interval',
        'proctorMessage',
        'openModalService',
        'loggerService',
        'deviceDetector',
        '$location'
    ];

    function runBlock($document, $log, $window, $state, $rootScope, assessmentUtility, assessmentService, loginService, proctoringService, modalService, $uibModalStack, growl, trackerService, $timeout, $interval, proctorMessage, openModalService, loggerService, deviceDetector, $location) {

        var logoutMsg = '',
            browserNavigationCount = 0,
            browserNavigationLimit = 0,
            keyCodeCollection = [],
            growlMessageObjNav = null,
            focusOutTimeStamp = null,
            focusInTimeStamp = null,
            allowedTime = 0,
            browserNavigationCountModal = null,
            openWindow = null,
            isMobileDevice = !deviceDetector.isDesktop(),
            navigationInterval = null,
            previousFocusStatus = true,
            useHasFocus = false,
            mettlMsgTimeout = null,
            remainingNavigationCount = 0,
            isOnlinePreview = assessmentUtility.localStorage.getData("_isOnlinePreview"),
            versantFlow = 1; //2 - This mode to be used if versant window is opened separate

        var stateChangeStart_fordefault = $rootScope.$on("$stateChangeStart", function(event, toState, toStateParams, fromState, fromStateParams) {
            var stateparams = {};
            var historyLength = history.length,
                typ = null;
            if ((deviceDetector.os === 'mac') && window && window.sebSecureVariable) {
                historyLength = 0;
            }
            // Bypass history restriction for cocubes test as they use iframes.
            if (sessionStorage.typeOfTest) {
                typ = sessionStorage.typeOfTest.toLowerCase();
                if (typ === 'cocubes' || typ === 'talentlens' || typ === 'symbiosis' || typ === 'poptest' || typ === 'padplayer') {
                    historyLength = 0;
                }
            }
            console.log(window.location.hash, 'history' + historyLength);
            if (toState.name === "assess.loadTest") {
                var xAuthToken = $window.sessionStorage.getItem('X-AUTH-TOKEN'),
                    loginInfo = loginService.getLoginInfo();
                if (!xAuthToken ||
                    angular.isUndefined(xAuthToken) ||
                    fromState.name == "" ||
                    ((fromState.name == "assess.loadTest" || fromState.name == "assess.endTest") &&
                        historyLength > 1)
                ) {
                    event.preventDefault();
                    sessionStorage.setItem('moveToMsgPage', true);
                    if (fromState.name == "assess.loadTest" && historyLength > 1) {
                        logoutMsg = 'Authentication Token not found';
                        gotoLoginPage(true);
                    }
                    return false;
                }
                // useHasFocus = loginInfo && loginInfo.assessmentConfig && loginInfo.assessmentConfig.useHasFocus ? true : false;
                useHasFocus = true;
                var typeOfTest = sessionStorage.getItem('typeOfTest');
                if (!useHasFocus && versantFlow == 2 && typeOfTest && typeOfTest == 'versant') {
                    setWatchForVersantChildWindow();
                }
                setNavigationCheck(typ);
            } else if (fromState.name == "assess.loadTest" && toState.name === "msgPage") {
                if (window.name) {
                    stopProctoring();
                    stopServices();
                }
            } else if (fromState.name == 'submitConfirmation' && toState.name == 'assess.endTest') {
                event.preventDefault();
                return false;
            }
            if (toState.redirectTo) {
                event.preventDefault();
                stateparams.alias = toStateParams.alias || '';
                stateparams.uid = toStateParams.uid || '';
                stateparams.pswd = toStateParams.pswd || '';
                stateparams.autologin = toStateParams.autologin || '';
                stateparams.isOnlinePreview = toStateParams.isOnlinePreview || '';
                stateparams.previewToken = toStateParams.previewToken || '';
                stateparams = encodeURIComponent(btoa(JSON.stringify(stateparams)));
                $state.go(toState.redirectTo, { stateParams: stateparams }, { location: 'replace' });
                return false;
            } else {
                if (historyLength > 1 &&
                    toState.name != 'landing' &&
                    toState.name != 'testLinkByEmail' &&
                    toState.name != 'msgPage' &&
                    toState.name != 'compatibility' &&
                    toState.name != 'callBackVersant' &&
                    toState.name != 'callback') {
                    if (sessionStorage.typeOfTest && (sessionStorage.typeOfTest === 'versant' || sessionStorage.typeOfTest === 'nseit' || sessionStorage.typeOfTest === 'mettl' || sessionStorage.typeOfTest === 'wheebox' || sessionStorage.typeOfTest === 'poptest' || sessionStorage.typeOfTest === 'padplayer')) {
                        return;
                    }

                    event.preventDefault();
                    var url = $state.href(toState, toStateParams);
                    if (location.hash.indexOf('?') >= 0) {
                        url = url + location.hash.substr(location.hash.indexOf('?'));
                    }

                    /*var data = $location.search();
                    if(data) {
                        url = url + '?';
                        var index =0;
                        _.each(data, function(key, val) {
                            if(index > 0) {
                                url = url + '&';
                            }
                            url = url +  key '=' val;
                            index = index + 1;
                        });
                    }*/
                    console.log(toStateParams, url, 'history');
                    // var newWin = window.open(url, '_blank');
                    // if (!newWin || newWin.closed || typeof newWin.closed === 'undefined') {
                    //     alert('Please allow browser to open popup to continue test.');
                    // }
                    try {
                        if (!openWindow || openWindow.closed) {
                            openWindow = window.open(url, '_blank');
                        } else {
                            var data = {
                                bodyStr: "<div><p>Are you sure you want to continue? Any ongoing tests will be closed.</div>",
                                headerStr: "Confirm",
                                isAction: true,
                                action: {
                                    isOkBtn: true,
                                    isCancelBtn: true
                                }
                            };
                            openModalService.openModal('notificationTemplate', data).then(function(res) {
                                if (res.result.result.modalResponse) {
                                    openWindow.close();
                                    if (!openWindow || openWindow.closed) {
                                        openWindow = window.open(url, '_blank');
                                    }
                                }
                                openWindow.focus();
                            });
                        }
                    } catch (ex) {
                        openWindow = window.open(url, '_blank');
                        openWindow.focus();
                    }
                }
            }
        });

        window.onbeforeunload = function() {
            if ($rootScope.thirdpartyproctoringTab) {
                $rootScope.thirdpartyproctoringTab.close();
            }
            if (location.href.search(/\btest\b/) > -1 || location.href.search(/\bendTest\b/) > -1) {
                var loginInfo = loginService.getLoginInfo();
                var refreshCount = angular.fromJson($window.sessionStorage.getItem("pageRefreshCount"));
                if (!refreshCount) {
                    refreshCount = 0;
                }
                $window.sessionStorage.setItem("manualRefresh", true);
                assessmentService.submitTestBeforeUnload();
                if (sessionStorage.typeOfTest === 'versant') {
                    var iframe = document.getElementById('thirdPartyIframe');
                    if (iframe) {
                        if (iframe.contentWindow.onunload) {
                            alert('On Parent window, going to call unload of ' + iframe.contentWindow.href);
                            iframe.contentWindow.onunload();
                            $log.log('explicitly called third party unload');
                        }
                    }
                }
                if (loginInfo && loginInfo.Config && loginInfo.Config.pageRefresh && refreshCount >= loginInfo.Config.pageRefresh) {
                    logoutMsg = 'Page reload limit exceeded';
                    gotoLoginPage(true, 'Reload is not allowed');
                } else {
                    $window.sessionStorage.setItem("pageRefreshCount", angular.toJson(refreshCount + 1));
                    return "";
                }
            }
        };

        window.onunload = function() {
            if (window._thirdPartyChildWin && !window._thirdPartyChildWin.closed) {
                window._thirdPartyChildWin.close();
                return "";
            }
        };

        window.onload = function() {
            loginService.applyTenantSpecificTheme();
            var loginInfo = loginService.getLoginInfo();
            var isOptionalPreviewEnable = false;
            var isOptionalPreviewTimeOver = assessmentUtility.localStorage.getData("isOptionalPreviewTimeOver");
            if (isOptionalPreviewTimeOver !== true) {
                isOptionalPreviewTimeOver = false;
            }
            if (loginInfo && loginInfo.Config) {
                isOptionalPreviewEnable = !loginInfo.Config.HideOptionalGroup;
            }
            $window.sessionStorage.setItem("manualRefresh", false);
            if (location.href.search(/\btest\b/) > -1 || location.href.search(/\bendTest\b/) > -1 || (isOptionalPreviewEnable && isOptionalPreviewTimeOver && location.href.indexOf("info") > -1)) {
                var moveToMsgPage = sessionStorage.getItem('moveToMsgPage');
                moveToMsgPage = moveToMsgPage ? true : false;
                //assessmentUtility.timer.stop();
                gotoLoginPage(moveToMsgPage);
            }
            return false;
        };

        window.onresize = function(e) {
            var isLoadFullScreen = isFullScreen();
            var _isOnlyOptionalOrTestSecurityKeyEnable = isOnlyOptionalOrTestSecurityKeyEnable();
            currentOrientation();
            if (isLoadFullScreen && (location.href.search(/\btest\b/) > -1 || location.href.search(/\bendTest\b/) > -1 || (_isOnlyOptionalOrTestSecurityKeyEnable && (location.href.search(/\binfo\b/) > -1)))) {
                // var maxHeight = window.screen.height,
                //     maxWidth = window.screen.width,
                //     curHeight = window.innerHeight,
                //     curWidth = window.innerWidth;

                if (!assessmentUtility.isInFullScreen()) { //&& !sessionStorage.HasCodingQuestion //(maxWidth !== curWidth || maxHeight !== curHeight) {

                    var isfullScreenAlertModalOpened = assessmentUtility.localStorage.getData("fullScreenAlertModalOpened");
                    // var msg = "<b>Click ok to go to full screen mode.</b>";
                    if (!isfullScreenAlertModalOpened) {

                        assessmentUtility.localStorage.setData("fullScreenAlertModalOpened", true);
                        var data = {
                            bodyStr: 'This test is designed to run on full screen. Please click the button below to go back to full screen.',
                            headerStr: 'Alert',
                            isAction: true,
                            action: {
                                isOkBtn: true,
                                isOnClick: true,
                                okText: "Go back to full screen",
                                onOk: function() {
                                    assessmentUtility.loadFullScreen();
                                    assessmentUtility.localStorage.setData("fullScreenAlertModalOpened", false);
                                }
                            }
                        };
                        openModalService.showModal('notificationTemplate', data);
                    }
                }
            } else {
                return false;
            }
        };

        function setWatchForVersantChildWindow() {
            $rootScope.$watch(
                function() {
                    return window._thirdPartyChildWin;
                },
                function(n) {
                    $log.log("changed ", n);
                    if (window._thirdPartyChildWin && !window._thirdPartyChildWin.closed) {
                        setChildNavigationCheck();
                    }
                }
            );
        }

        function setChildNavigationCheck() {
            if (window._thirdPartyChildWin && !window._thirdPartyChildWin.closed) {
                window.removeEventListener('blur', navigateAway);
                window.removeEventListener('focus', focusIn);
                window._thirdPartyChildWin.addEventListener('blur', navigateAway);
                window._thirdPartyChildWin.addEventListener('focus', focusIn);
            }
        }

        function setNavigationCheck(thirdPartyType) {
            var checkInterval = 500;
            if (useHasFocus) {
                navigationInterval = $interval(function() {
                    checkFocus(thirdPartyType);
                }, checkInterval);
            } else {
                window.addEventListener('blur', navigateAway);
                window.addEventListener('focus', focusIn);
            }
        }

        function navigateAway() {
            if (sessionStorage.isSecureBrowserMandatory == 'true') {
                return;
            }
            var data = null,
                bypassNavigationcheck = document.activeElement.getAttribute('bypassNavigationcheck'),
                windowactive = !document.hidden;
            if (bypassNavigationcheck && windowactive) {
                return;
            }
            if (location.href.search(/\btest\b/) > -1 || location.href.search(/\bendTest\b/) > -1) {
                if (!window._thirdPartyChildWin || window._thirdPartyChildWin.closed) {
                    window.removeEventListener('blur', navigateAway);
                } else {
                    window._thirdPartyChildWin.removeEventListener('blur', navigateAway);
                }
                browserNavigationLimit = getBrowserNavigationCount();
                if (browserNavigationLimit > 0) {

                    if (browserNavigationCount === browserNavigationLimit) {
                        if (browserNavigationCountModal) {
                            browserNavigationCountModal.destroy();
                        }
                        data = {
                            bodyStr: 'You are logged out as you navigated away from the test screen multiple times.',
                            headerStr: 'Alert',
                            isAction: true,
                            action: {
                                isOkBtn: true
                            }
                        };
                        openModalService.openModal('notificationTemplate', data)
                            .then(function() {
                                browserNavigationCount = 0;
                                try {
                                    assessmentService.submitTestBeforeUnload();
                                } catch (e) {
                                    $log.log(e);
                                }
                                logoutMsg = 'Navigation limit exceeded';
                                gotoLoginPage(
                                    true,
                                    "You have been logged out of the test because a proctoring rule has been invoked.",
                                    "Examples: Left the test window multiple times, refreshed the test window multiple times, left the test window for a long duration, proctoring was disabled.",
                                    "Please start the test again in a new browser tab. Based on the test settings, you might be able to resume your test. Otherwise please contact your test administrator."
                                );
                            });
                        $timeout(function() {
                            if (!window._thirdPartyChildWin || window._thirdPartyChildWin.closed) {
                                window.addEventListener('blur', navigateAway);
                            } else {
                                window._thirdPartyChildWin.addEventListener('blur', navigateAway);
                            }
                        }, 100);
                        //stopProctoring();
                        //gotoLoginPage();
                        pushFocusLog("Logging out : navigation limit exceeded");
                        browserNavigationCount += 1;
                    } else if (browserNavigationCount < browserNavigationLimit) {
                        remainingNavigationCount = browserNavigationLimit - browserNavigationCount;
                        if (browserNavigationCountModal) {
                            browserNavigationCountModal.destroy();
                        }
                        data = {
                            bodyStr: "Please don't navigate away from the test. Navigating " + remainingNavigationCount + " more time will disable your login.",
                            headerStr: 'Alert',
                            isAction: true,
                            action: {
                                isOkBtn: true
                            }
                        };
                        browserNavigationCountModal = openModalService.showModal('notificationTemplate', data);
                        browserNavigationCount += 1;
                        /*var typeOfTest = sessionStorage.getItem('typeOfTest');
                        if(!typeOfTest || typeOfTest !== 'versant') {
                            browserNavigationCountModal = openModalService.showModal('notificationTemplate', data);
                            browserNavigationCount += 1;
                        }*/
                        /*To be switched on for next release*/
                    }
                }
                $timeout(function() {
                    if (!window._thirdPartyChildWin || window._thirdPartyChildWin.closed) {
                        window.addEventListener('blur', navigateAway);
                    } else {
                        window._thirdPartyChildWin.addEventListener('blur', navigateAway);
                    }
                }, 100);
                focusOutTimeStamp = new moment();
                pushFocusLog("focusOut");
                return false;
            }
        }

        function focusIn() {
            if (sessionStorage.isSecureBrowserMandatory == 'true') {
                return;
            }
            var outOfFocusTimeSpan = 0;
            if (location.href.search(/\btest\b/) > -1 || location.href.search(/\bendTest\b/) > -1) {
                focusInTimeStamp = new moment();
                pushFocusLog("focusIn");
                if (allowedTime > 0) {
                    outOfFocusTimeSpan = moment.duration(focusInTimeStamp.diff(focusOutTimeStamp)).as('seconds');
                    if (outOfFocusTimeSpan > allowedTime) {
                        assessmentService.submitTestBeforeUnload();
                        //stopProctoring();
                        logoutMsg = 'Navigation time limit exceeded';
                        gotoLoginPage(true);
                    }
                }
            }
            return false;
        }

        // Changed logic for navigation from blur/focus to document.hasFocus
        function checkFocus(thirdPartyType) {
            if (location.href.search(/\bsubmitSuccess\b/) > -1 && angular.isDefined(navigationInterval)) {
                if (mettlMsgTimeout) {
                    $timeout.cancel(mettlMsgTimeout);
                    mettlMsgTimeout = null;
                }
                $interval.cancel(navigationInterval);
                navigationInterval = undefined;
                return false;
            }
            if (previousFocusStatus === document.hasFocus()) {
                return false;
            }
            previousFocusStatus = document.hasFocus();
            if (previousFocusStatus) {
                focusBack();
            } else {
                focusOut(thirdPartyType);
            }
        }

        function focusOut(thirdPartyType) {
            if (sessionStorage.isSecureBrowserMandatory == 'true') {
                return;
            }
            var msgTimeout = 2500;
            if (location.href.search(/\btest\b/) > -1 || location.href.search(/\bendTest\b/) > -1) {
                browserNavigationLimit = getBrowserNavigationCount();
                if (browserNavigationLimit > 0) {
                    if (mettlMsgTimeout) {
                        $timeout.cancel(mettlMsgTimeout);
                        mettlMsgTimeout = null;
                    }
                    if (browserNavigationCount === browserNavigationLimit) {
                        if (thirdPartyType == 'mettl') {
                            mettlMsgTimeout = $timeout(showLogOutModal, msgTimeout);
                        } else {
                            showLogOutModal();
                        }
                        pushFocusLog("Logging out : navigation limit exceeded");
                        browserNavigationCount += 1;
                    } else if (browserNavigationCount < browserNavigationLimit) {
                        remainingNavigationCount = browserNavigationLimit - browserNavigationCount;
                        if (thirdPartyType == 'mettl') {
                            mettlMsgTimeout = $timeout(showAlertModal, msgTimeout);
                        } else {
                            showAlertModal();
                        }
                        browserNavigationCount += 1;
                    }
                }
                focusOutTimeStamp = new moment();
                pushFocusLog("focusOut");
                return false;
            }
        }

        function showLogOutModal() {
            if ((location.href.search(/\bsubmitSuccess\b/) > -1 || sessionStorage.getItem('isTestCompleted') == 'true') && mettlMsgTimeout) {
                $timeout.cancel(mettlMsgTimeout);
                mettlMsgTimeout = null;
                return false;
            }
            if (browserNavigationCountModal) {
                browserNavigationCountModal.destroy();
            }
            var data = {
                bodyStr: 'You are logged out as you navigated away from the test screen multiple times.',
                headerStr: 'Alert',
                isAction: true,
                action: {
                    isOkBtn: true
                }
            };
            openModalService.openModal('notificationTemplate', data)
                .then(function() {
                    browserNavigationCount = 0;
                    try {
                        assessmentService.submitTestBeforeUnload();
                    } catch (e) {
                        $log.log(e);
                    }
                    logoutMsg = 'navigateAway limit exceeded';
                    gotoLoginPage(
                        true,
                        "You have been logged out of the test because a proctoring rule has been invoked.",
                        "Examples: Left the test window multiple times, refreshed the test window multiple times, left the test window for a long duration, proctoring was disabled.",
                        "Please start the test again in a new browser tab. Based on the test settings, you might be able to resume your test. Otherwise please contact your test administrator."
                    );
                });
        }

        function showAlertModal() {
            if ((location.href.search(/\bsubmitSuccess\b/) > -1 || sessionStorage.getItem('isTestCompleted') == 'true') && mettlMsgTimeout) {
                $timeout.cancel(mettlMsgTimeout);
                mettlMsgTimeout = null;
                return false;
            }
            if (browserNavigationCountModal) {
                browserNavigationCountModal.destroy();
            }
            var data = {
                bodyStr: "Please don't navigate away from the test. Navigating " + remainingNavigationCount + " more time will disable your login.",
                headerStr: 'Alert',
                isAction: true,
                action: {
                    isOkBtn: true
                }
            };
            browserNavigationCountModal = openModalService.showModal('notificationTemplate', data);
        }

        function focusBack() {
            var outOfFocusTimeSpan = 0;
            if (location.href.search(/\btest\b/) > -1 || location.href.search(/\bendTest\b/) > -1) {
                focusInTimeStamp = new moment();
                pushFocusLog("focusIn");
                if (allowedTime > 0) {
                    outOfFocusTimeSpan = moment.duration(focusInTimeStamp.diff(focusOutTimeStamp)).as('seconds');
                    if (outOfFocusTimeSpan > allowedTime) {
                        assessmentService.submitTestBeforeUnload();
                        //stopProctoring();
                        logoutMsg = 'Navigation time limit exceeded';
                        gotoLoginPage(
                            true,
                            "You have been logged out of the test because a proctoring rule has been invoked.",
                            "Examples: Left the test window multiple times, refreshed the test window multiple times, left the test window for a long duration, proctoring was disabled.",
                            "Please start the test again in a new browser tab. Based on the test settings, you might be able to resume your test. Otherwise please contact your test administrator."
                        );
                    }
                }
            }
            return false;
        }
        /*************************Namvigation check ends******************************************/


        //Block right click......
        document.addEventListener("contextmenu", function(event) {
            event.preventDefault();
        })

        window.addEventListener('keydown', captureKey);

        function captureKey(event) {
            /*..........Block F12..........*/
            if (event.keyCode == 123) { // Prevent F12
                event.preventDefault();
            } else if (event.ctrlKey && event.shiftKey && event.keyCode == 73) { // Prevent Ctrl+Shift+I        
                event.preventDefault();
            } else if (event.ctrlKey && event.shiftKey && event.keyCode == 67) { // Prevent Ctrl + Shift + C
                event.preventDefault();
            } else if (event.ctrlKey && event.shiftKey && event.keyCode == 74) { // Prevent Ctrl + Shift + J
                event.preventDefault();
            } else if (event.ctrlKey && event.keyCode == 85) { // Prevent Ctrl + U
                event.preventDefault();
            } else if (event.metaKey && event.altKey && event.keyCode == 73) { // Prevent command + option + C (Mac OS)
                event.preventDefault();
            } else if (event.metaKey && event.altKey && event.keyCode == 67) { // Prevent command + option + C (Mac OS)
                event.preventDefault();
            } else if (event.metaKey && event.altKey && event.keyCode == 74) { // Prevent command + option + C (Mac OS)
                event.preventDefault();
            } else if (event.metaKey && event.altKey && event.keyCode == 85) { // Prevent command + option + C (Mac OS)
                event.preventDefault();
            }
            /*............................*/
            var isBrowsernavigationEnable = getBrowserNavigationCount() > 0 ? true : false;
            if (location.href.search(/\btest\b/) > -1 || location.href.search(/\bendTest\b/) > -1) {

                if (event.keyCode === 17 || event.keyCode === 18 || event.keyCode === 91) {

                    var keyObj = {
                        keyCode: event.keyCode,
                        timeStamp: new Date(event.timeStamp)
                    };
                    keyCodeCollection.push(keyObj);
                    /*........Show Navigation Warning Message........*/
                    if (isBrowsernavigationEnable && event.keyCode != 17) {

                        var growlNavMessageObj_temp = growl.error("Navigating from the current screen is prohibited.");
                        if (growlNavMessageObj_temp) {
                            if (growlMessageObjNav) {
                                growlMessageObjNav.destroy();
                            }
                            growlMessageObjNav = growlNavMessageObj_temp;
                        }
                        $timeout(function() {

                            if (growlMessageObjNav) {
                                growlMessageObjNav.destroy();
                                growlMessageObjNav = null;
                            }
                        }, 3000);
                    }
                    /*.............................................*/
                }
                if (!$rootScope.captureKeyInterval) {
                    $rootScope.captureKeyInterval = $interval(function() {

                        if (keyCodeCollection.length > 0) {

                            pushKeyPressLog(keyCodeCollection);
                        }
                        keyCodeCollection.length = 0;
                    }, 300000); //5*60*1000//5min
                }
            }
        }

        window.document.body.onclick = function() {
            if (isMobileDevice) {
                if (angular.element($document[0].querySelector('#sideMenu'))) {
                    angular.element($document[0].querySelector('#sideMenu')).addClass('collapse');
                }
            }
        };

        function pushFocusLog(_focusStat) {
            var isOptionalPreviewEnable = assessmentUtility.localStorage.getData("_isOnlinePreview");
            if (!isOptionalPreviewEnable) {

                var focusInOutLogInfoRq = {
                    "canLoginActivityLog": {
                        "focusInOutLogInfo": {
                            "window": (!window._thirdPartyChildWin || window._thirdPartyChildWin.closed) ? 'parent' : 'child',
                            "focusStat": _focusStat,
                            "timeStamp": new Date()
                        }
                    }
                };
                loggerService.push(focusInOutLogInfoRq);
            }
        }

        function pushKeyPressLog(keyCollection) {
            var isOptionalPreviewEnable = assessmentUtility.localStorage.getData("_isOnlinePreview");
            if (!isOptionalPreviewEnable && keyCollection && keyCollection.length > 0) {

                var keyPressLogInfoRq = {
                    "canLoginActivityLog": {
                        "keyPressLogInfo": {
                            "keyCollection": angular.toJson(keyCollection),
                            "timeStamp": new Date()
                        }
                    }
                };
                loggerService.push(keyPressLogInfoRq);
            }
        }

        function gotoLoginPage(moveToMsgPage, msg, exampleMsg, suggestionMsg) {
            var alias = window.sessionStorage.getItem("oa_tenantAlias"), isLogout = btoa('false');
            assessmentUtility.exitFullScreen();
            if (window.name) {
                stopProctoring();
                stopServices();
            }
            if ($uibModalStack) {

                $uibModalStack.dismissAll();
            }
            /*if ($rootScope.uibModalInstance) {
                $rootScope.uibModalInstance.dismiss();
            }*/
            openModalService.closeAllModals();
            var stateparams = {
                alias: alias
            };
            stateparams = btoa(JSON.stringify(stateparams));
            if (moveToMsgPage) {
                msg = msg ? msg : "An invalid operation was attempted.";
                exampleMsg = exampleMsg ?
                    "</br>" +
                    '<span class="example-msg">' +
                    exampleMsg +
                    "</span>" :
                    "";
                suggestionMsg = suggestionMsg ?
                    suggestionMsg :
                    "Please close this tab, and start the test again in a new browser tab.";
                var message =
                    "<h2>" +
                    "<i class='fa fa-exclamation-triangle text-warning' aria-hidden='true'></i>" +
                    " " +
                    msg +
                    exampleMsg +
                    "</h2>" +
                    "</br>" +
                    suggestionMsg;
                if (logoutMsg && logoutMsg !== '') {
                    isLogout = btoa('true');
                }
                $state.go("msgPage", { stateParams: encodeURIComponent(btoa(message)), isLogout: isLogout, msg: btoa(logoutMsg) }, { location: "replace" });
            } else {
                $state.go('assess.login', { stateParams: stateparams }, { location: 'replace' });
            }

            // $state.go('assessment', { 'alias': alias }, { location: 'replace' });
        }

        function stopServices() {
            assessmentUtility.timer.stop();
            assessmentUtility.stopWatch.stop(null, null, "onbeforeunload");
        }

        function stopProctoring() {
            var loginInfo = loginService.getLoginInfo();
            var isVideoProctoringEnabled, isContainsMediaQuestion;
            if (loginInfo && loginInfo.Config) {
                isVideoProctoringEnabled = loginInfo.Config.VideoProctoring;
            }
            isContainsMediaQuestion = loginInfo.ContainsMediaQuestion ? loginInfo.ContainsMediaQuestion : false;
            if (isVideoProctoringEnabled || isContainsMediaQuestion) {
                proctoringService.stop();
                // proctorMessage.stop();
            }
            /*if (_.size(trackerService.getTrackerTypes()) > 0) {
                trackerService.stopTrackers();
            } else {
                trackerService.pushTrackerStatStopLog();
            }*/
        }

        function isFullScreen() {
            var loginInfo = loginService.getLoginInfo();
            var isLoadFullScreen = false;
            if (loginInfo && loginInfo.assessmentConfig) {
                isLoadFullScreen = loginInfo.assessmentConfig.isLoadFullScreen;
            }
            isLoadFullScreen = isLoadFullScreen ? true : false;
            return isLoadFullScreen;
        }

        function getBrowserNavigationCount() {
            var loginInfo = loginService.getLoginInfo();
            var browserNavigationCount = 0;
            if (loginInfo && loginInfo.Config) {
                browserNavigationCount = parseInt(loginInfo.Config.browserNavigation);
                allowedTime = parseInt(loginInfo.Config.allowedTime);
            }
            return browserNavigationCount;
        }

        function isOnlyOptionalOrTestSecurityKeyEnable() {
            var loginInfo = loginService.getLoginInfo();
            var testSecurityKey = false;
            var isOnlyOptional = false;
            if (loginInfo && loginInfo.Config) {
                testSecurityKey = loginInfo.Config.testSecurityKey;
            }
            testSecurityKey = testSecurityKey ? (testSecurityKey === "vB4VBFG9wR8=" ? false : true) : false;
            isOnlyOptional = assessmentService.checkOnlyOptionalStatus();
            return (testSecurityKey || isOnlyOptional);
        }

        window.getUUID = function(apiUrl) {
            if (apiUrl) {
                var uuid = sessionStorage.getItem('x-guid'),
                    xGuidCounter = Number(sessionStorage.getItem('xGuidCounter') || 0) + 1;
                //added xGuidCounter for incrementing only counter keeping same guid through out app
                uuid = uuid || 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
                    var r = Math.random() * 16 | 0,
                        v = c == 'x' ? r : (r & 0x3 | 0x8);
                    return v.toString(16);
                });
                sessionStorage.setItem('x-guid', uuid); //added this line to keep same quid through out the application
                sessionStorage.setItem('xGuidCounter', xGuidCounter);
                //sessionStorage.setItem(apiUrl, uuid);  Commented coz debug is taking lot of time
                if (isOnlinePreview) {
                    uuid = uuid + '_PREVIEW';
                }
                return uuid + '_' + xGuidCounter;
            } else {
                return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
                    var r = Math.random() * 16 | 0,
                        v = c == 'x' ? r : (r & 0x3 | 0x8);
                    return v.toString(16);
                });
            }
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('OnlineAssessmentAngular')
        .config(routerConfig);

    /** @ngInject */
    function routerConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('testLinkByEmail', {
                url: '/testlink/:stateParams',
                templateUrl: 'app/assessment/testLinkByEmailContainer.html',
                params: {
                    stateParams: { squash: true, value: null }
                }
            })
            .state('envProctoring', {
                url: '/envProctoring/:stateParams',
                templateUrl: 'app/assessment/envProctoring.tpl.html',
                controller: 'envProctoring',
                controllerAs: 'vm',
                bindToController: true,
                params: {
                    stateParams: { squash: true, value: null }
                }
            })
            .state('compatibility', {
                url: '/compatibility/:stateParams/:seb',
                templateUrl: 'app/assessment/browserCompatibility.tpl.html',
                params: {
                    stateParams: { squash: true, value: null },
                    seb: { squash: true, value: null }
                },
                controller: 'BrowserCompatibility',
                controllerAs: 'vm',
                bindToController: true
            })
            .state('default', {
                url: '/default/:alias/:autologin/:uid/:pswd/:isOnlinePreview/:previewToken',
                redirectTo: 'landing',
                params: {
                    alias: { squash: true, value: null },
                    uid: { squash: true, value: null },
                    pswd: { squash: true, value: null },
                    autologin: { squash: true, value: null },
                    isOnlinePreview: { squash: true, value: null },
                    previewToken: { squash: true, value: null },
                    viewType: { squash: true, value: null }
                }
            })
            .state('assessment', {
                url: '/assessment/:alias/:autologin/:uid/:pswd/:isOnlinePreview/:previewToken',
                redirectTo: 'assess.login',
                params: {
                    alias: { squash: true, value: null },
                    uid: { squash: true, value: null },
                    pswd: { squash: true, value: null },
                    autologin: { squash: true, value: null },
                    isOnlinePreview: { squash: true, value: null },
                    previewToken: { squash: true, value: null },
                    viewType: { squash: true, value: null }
                }
            })
            .state('landing', {
                url: '/landing/:stateParams',
                templateUrl: 'app/common/main.html',
                params: {
                    stateParams: { squash: true, value: null }
                }
            })
            .state('callBackVersant', {
                url: '/callBackVersant/:data',
                templateUrl: 'app/assessment/callBackVersant.tpl.html',
                controller: 'callBackVersantController',
                controllerAs: 'vm',
                bindToController: true
            })
            .state('callback', {
                url: '/callback/:data',
                templateUrl: 'app/assessment/callback.tpl.html',
                controller: 'callbackController',
                controllerAs: 'vm',
                bindToController: true
            })
            .state('assess', {
                url: '/assess',
                templateUrl: 'app/assessment/assessment.html',
                abstract: true
            })
            .state('assess.login', {
                url: '/login/:stateParams',
                templateUrl: 'app/assessment/loginToTest.html'
            })
            .state('assess.startTest', {
                url: '/info/:alias',
                templateUrl: 'app/assessment/startTest.html'
            })
            .state('assess.loadTest', {
                url: '/test/:alias/:questionIndex',
                /*resolve: {
                    questionPaper: ['assessmentService', function(assessmentService) {
                        var questionPaper = assessmentService.questionpaper.get();
                        return questionPaper;
                    }]
                },*/
                params: {
                    questionPaper: null
                },
                controller: loadTestController,
                controllerAs: 'vm',
                templateUrl: 'app/assessment/test.html',
                bindToController: true
            })
            .state('assess.screenrecording', {
                url: '/screenrecording/:alias',
                templateUrl: 'app/assessment/screenrecording.html',
                controller: 'screenRecordingController',
                controllerAs: 'vm'
            })
            .state('assess.endTest', {
                url: '/endTest/:alias/:questionIndex',
                templateUrl: 'app/assessment/endTest.tpl.html',
                controller: 'endTestController',
                controllerAs: 'vm',
                bindToController: true
            })
            .state('submitConfirmation', {
                url: '/submitSuccess/:alias/:data',
                templateUrl: 'app/assessment/submitConfirmationPage.html',
                params: {
                    nextTestStateParams: null,
                    isAutoTestEnabled: false,
                    shortlistingStat: -1,
                    shortlistingMessage: null,
                    errormessage: null,
                    isUnscorable: false,
                    isConsentRequired:null
                },
                controller: submitConfirmationController,
                controllerAs: 'vm',
                bindToController: true
            })
            .state('msgPage', {
                url: '/message/:stateParams',
                templateUrl: 'app/assessment/msgPage.html',
                params: {
                    stateParams: { squash: true, value: null },
                    isLogout: { squash: true, value: false },
                    msg: { squash: true, value: null }
                },
                controller: 'MsgPageController',
                controllerAs: 'vm',
                bindToController: true
            })
            .state('passCodeVerification', {
                url: '/verification/:alias',
                templateUrl: 'app/assessment/secondaryCameraPassCodeVerification.html',
                params: {
                    alias: { squash: true, value: null },
                },
                controller: 'PasscodeVerificationCtrl',
                controllerAs: 'vm',
                bindToController: true
            });

        $urlRouterProvider.otherwise('/landing/');

        //Controllers........

        /*....................................PopulateQuestion...............................*/

        loadTestController.$inject = ['$stateParams', 'assessmentUtility', 'loginService'];

        function loadTestController($stateParams, assessmentUtility, loginService) {
            var vm = this;
            vm.showHeader = false;
            vm.showSubHeader = false;
            vm.loginInfo = loginService.getLoginInfo();
            //vm.questionPaper = questionPaper;
            vm.currentQIndex = parseInt($stateParams.questionIndex);
            vm.questionPaper = $stateParams.questionPaper;
            vm.currentQuestion = vm.questionPaper.mandatoryQuestionCollection[vm.currentQIndex];
            vm.ApplicationViewType = sessionStorage.getItem('ApplicationViewType');

            var testLoginInfo = assessmentUtility.localStorage.getData('TestLoginInformation');
            vm.debugMode = testLoginInfo && testLoginInfo.Config && testLoginInfo && testLoginInfo.Config.debug == true;
            vm.isThirdParty = testLoginInfo && testLoginInfo.Config &&
                testLoginInfo.Config.thirdPartyTestType &&
                (testLoginInfo.Config.thirdPartyTestType.toLowerCase() === "versant" ||
                    testLoginInfo.Config.thirdPartyTestType.toLowerCase() === "cocubes" ||
                    testLoginInfo.Config.thirdPartyTestType.toLowerCase() === "nseit" ||
                    testLoginInfo.Config.thirdPartyTestType.toLowerCase() === "mettl" ||
                    testLoginInfo.Config.thirdPartyTestType.toLowerCase() === "wheebox" ||
                    testLoginInfo.Config.thirdPartyTestType.toLowerCase() === "dotin" ||
                    testLoginInfo.Config.thirdPartyTestType.toLowerCase() === "talentlens" ||
                    testLoginInfo.Config.thirdPartyTestType.toLowerCase() === "thirdpartyproctoring" ||
                    testLoginInfo.Config.thirdPartyTestType.toLowerCase() === "force" ||
                    testLoginInfo.Config.thirdPartyTestType.toLowerCase() === "symbiosis" ||
                    testLoginInfo.Config.thirdPartyTestType.toLowerCase() === "poptest" ||
                    testLoginInfo.Config.thirdPartyTestType.toLowerCase() === "padplayer" ||
                    testLoginInfo.Config.thirdPartyTestType.toLowerCase() === "testnav");
            if (vm.isThirdParty) {
                vm.showSubHeader = false;
                if (testLoginInfo.Config.thirdPartyTestType.toLowerCase() === "nseit") {
                    vm.showHeader = false;
                } else {
                    vm.showHeader = true;
                }
                sessionStorage.typeOfTest = testLoginInfo.Config.thirdPartyTestType;
            } else {
                vm.showSubHeader = true;
                vm.showHeader = true;
            }
            /// ======================== nseit hardcode changes [start] ===================== ///
            // if (sessionStorage.isNseitTenant) {
            //     vm.isThirdParty = true;
            //     vm.showHeader = false;
            //     sessionStorage.typeOfTest = 'nseit';
            // }
            /// ======================== nseit hardcode changes [ends] ===================== ///
        }
        /*.....................................resize.........................................*/

        resize.$inject = ['$window'];

        function resize($window) {
            var vm = this;
            vm.winHeight = $window.innerHeight - 200;
        }
        submitConfirmationController.$inject = ['$stateParams'];

        function submitConfirmationController($stateParams) {
            var vm = this;
            vm.submitCnfParams = $stateParams;
        }
    }
})();


(function() {
  'use strict';

  angular
    .module('OnlineAssessmentAngular')
    .constant('moment', moment);
})();

(function() {
    'use strict';

    angular
        .module('OnlineAssessmentAngular')
        .factory('httpInterceptor', httpInterceptor)
        .config(config);

    /** @ngInject */
    function config($locationProvider, $compileProvider, $logProvider, $httpProvider, growlProvider, blockUIConfig) {
        /*Enable log*/
        $logProvider.debugEnabled(true);

        /*growl config*/
        if (screen.width <= 768) {
            growlProvider.globalPosition('top-left');
        } else {
            growlProvider.globalPosition('top-center');
        }
        growlProvider.globalDisableCloseButton(true);

        /*blockUI config*/
        //blockUIConfig.autoBlock = false;
        blockUIConfig.resetOnException = false;
        if (sessionStorage.getItem('ApplicationViewType') === 'App-Angular-Material') {
            blockUIConfig.templateUrl = 'app/template/default/blockUiPlzWait.tpl.html';
        } else {
            blockUIConfig.templateUrl = 'app/template/default/blockUiAjaxLoader.tpl.html';
        }

        blockUIConfig.delay = 0;
        blockUIConfig.requestFilter = function(config) {
            if ((config.data && config.data.disableBlockUI) ||
                (config.apiConfig && config.apiConfig.removeBlockUI) ||
                (config.url).match(/\b(\/filehandler\/api\/)\b/g) ||
                (config.url).match(/\b(\/setloginstats\/)/g) ||
                checkForDynamicUrl(config.url)) {
                return false;
            }
        };

        /*Interceptor*/
        $httpProvider.interceptors.push('httpInterceptor');

        $locationProvider.hashPrefix('');
        //$compileProvider.preAssignBindingsEnabled(true);

        /*checking dynamic url*/
        var checkForDynamicUrl = function(dynamicUrl) {
            return _.find(JSON.parse(sessionStorage.getItem('formPrintingDynamicUrls')), function(url) {
                return _.startsWith(dynamicUrl, url);
            });
        };
    }

    function httpInterceptor($injector, $q, growl, $log) {
        return {
            request: function(config) {
                if (!config.url.match(/\/exam.hirepro.in($|\/).*/)) {
                    config.headers["APP-NAME"] = 'onlineassessment';
                    if (sessionStorage.isEuTenant == 'true') {
                        config.headers["APP-NAME"] = 'pyappe1';
                    }
                    if (sessionStorage.isPy3Tenant == 'false') {
                        config.headers["APP-NAME"] = 'py2app';
                    }
                    // if (config && config.data && 
                    //     !config.url.match(/\/get_video_ans_of_question_for_test($|\/)/) && 
                    //     !config.url.match(/\/create-test-user-history($|\/)/) &&
                    //     !config.url.match(/\b(\/filehandler\/api\/)\b/g)) {
                    //     config.data.debugTimeStamp = new Date();
                    // }
                    // if (config && config.data && config.url.match(/\/create-test-user-history($|\/)/)) {
                    //     config.data = _.omit(config.data, 'disableBlockUI');
                    // }
                    if (config.apiConfig) {
                        var isLambdaRequired = JSON.parse(sessionStorage.getItem("isLambdaRequired"));

                        if ((config.apiConfig.isLambda && isLambdaRequired) || config.url.match(/\/company-info($|\/).*/)) {
                            if (!config.headers['x-guid']) {
                                config.headers['x-guid'] = window.getUUID(config.url);
                            } else if (config.headers['X-APPLMA-RETRY']) {
                                config.headers['x-guid'] = window.getUUID(config.url) + '-Lambda-Retry';
                            }

                            if (config.headers["X-APPLMA"] !== false) {
                                config.headers["X-APPLMA"] = 'true';
                            }
                        }
                        if (config.apiConfig.removeBlockUI && config.data) {
                            config.data = _.omit(config.data, 'disableBlockUI');
                        }
                        if (config.apiConfig.addDebugTimeStamp && config.data) {
                            config.data.debugTimeStamp = new Date();
                        }
                        config = _.omit(config, 'apiConfig');
                    }
                }
                return config;
            },
            response: function(response) {

                var headers = response.headers(),
                    config = response.config,
                    data = response.data,
                    companyInfo = null,
                    isSessionExpired = JSON.parse(sessionStorage.getItem('isSessionExpired'));

                if (headers && headers['content-type'] === "application/json") {

                    response.xGuid = headers['x-guid'];

                    //Session Expired...
                    if (data && data.status == 'KO' && data.error &&
                        data.error.errorCode == '440' && !isSessionExpired) {

                        sessionStorage.setItem('isSessionExpired', true);
                        console.error(data.error.ErrorMessage);

                        var messageHtml = "<h2>Your login session has been expired !</h2>" +
                            "<h2>It seems your login credentials were used to login again.</h2>";
                        $injector.get("$state").go('msgPage', { stateParams: btoa(messageHtml) }, { location: 'replace', reload: true });
                    }

                    //Setting Company-info data...
                    if (data && response.config.url === '/py/assessment/htmltest/api/v1/company-info/') {

                        if (data.content) {

                            companyInfo = data.content;

                            sessionStorage.isLambdaRequired = companyInfo.isLambdaRequired === false ||
                                companyInfo.isLambdaRequired === 0 ? false : true;

                            sessionStorage.setItem('chatBeforeLogin', !!companyInfo.chatBeforeLogin);
                        }
                        if (data.branding && data.branding.freshChatId) {
                            sessionStorage.setItem('freshChatId', response.data.branding.freshChatId);
                        }
                    }
                }
                return response;
            },
            responseError: function(response) {
                $log.error("httpInterceptor_responseError", response);
                return $q.reject(response);
            }
        };
    }
})();

angular.module("OnlineAssessmentAngular").run(["$templateCache", function($templateCache) {$templateCache.put("app/assessment/assessment.html","<div ui-view></div><fresh-chat></fresh-chat>");
$templateCache.put("app/assessment/assessmentTermsAndConditions.tpl.html","<div class=row><div class=col-md-12><p style=font-size:18px;font-weight:700;color:#007EFC>Assessment Terms & Conditions</p><div class=tc-font-style><ul class=tc-li-with-header><!-- Header --><li>Please carefully review and accept the Assessment Terms & Conditions.</li><!-- Body--><li>I confirm that I will keep my camera and mic on throughout the assessment.</li><li>I confirm that I will remain clearly visible in the camera throughout the assessment.</li><li>I confirm that I will not take any external help throughout the assessment.</li><li class=\"margin-top-30px-important font-weight-500-important\"><p class=form-group><!-- TC 1 --><label class=\"custom-checkbox font-weight-700\">I agree to the Assessment Terms & Conditions above. <input name=chkProctorTermCondition type=checkbox id=termsChk ng-model=vm.isAssessmentTc1Accepted ng-change=vm.isAssessmentTcAccepted() class=\"ng-pristine ng-untouched ng-valid ng-empty\" aria-invalid=false> <span class=chk></span></label></p></li><li class=margin-top-30px-important><p><!-- TC 2 --><label class=\"custom-checkbox font-weight-700\">I fully understand and agree that if I am found to be engaged in any act of fraud, misrepresentation or any use of unfair means,I would be disqualified from the process. <input name=chkProctorTermCondition type=checkbox id=termsChk ng-model=vm.isAssessmentTc2Accepted ng-change=vm.isAssessmentTcAccepted() class=\"ng-pristine ng-untouched ng-valid ng-empty\" aria-invalid=false> <span class=chk></span></label></p></li></ul></div></div></div>");
$templateCache.put("app/assessment/basicInstruction.tpl.html","<div class=row><!-- Test Duration --><div class=\"col-md-6 start-section\" ng-if=!vm.isThirdParty><p class=\"start-section-header text-bold\">TEST DURATION</p><div class=start-info-box><h3><span ng-bind=vm.questionPaper.testDuration>75</span> Minutes</h3><p>After <span ng-bind=vm.questionPaper.testDuration>75</span> minutes, your test will be auto submitted</p></div></div><!-- Password dissable Enable or not --><div class=\"col-md-6 start-section\" ng-if=!vm.isThirdParty><p class=\"start-section-header text-bold\">NUMBER OF ATTEMPTS</p><div class=start-info-box ng-if=!vm.questionPaper.isPasswordNeverExpire><h3 ng-if=\"vm.questionPaper.attemptCount == 1\">Only 1 Attempt</h3><h3 ng-if=\"vm.questionPaper.attemptCount > 1\">Only {{vm.questionPaper.attemptCount}} Attempts</h3><p>DO NOT reload, refresh or close the browser without submitting the test.</p></div><div class=start-info-box ng-if=vm.questionPaper.isPasswordNeverExpire><h3>Unlimited Attempt</h3><p>You can login multiple times to finish the test. Once done, please be sure to click “End Test” and Confirm.</p></div></div><div class=\"col-md-12 start-section\" ng-if=\"vm.questionPaper.tenantName && !vm.isThirdParty\"><p class=start-section-header>Test Structure</p><!-- Mandatory Groups --><div class=table-responsive><table class=\"table test-structure table-hover\" ng-if=\"vm.questionPaper.mandatGroupsInfo.length > 0\"><thead style=\"background: #F9F9F9\"><tr ng-if=vm.questionPaper.isOptionalGroup><th colspan=4>MANDATORY GROUPS</th></tr><tr><th>Groups</th><th>Type of Questions</th><th>No. of Questions</th><th ng-if=vm.questionPaper.isGroupWiseTiming>Duration</th></tr></thead><tbody><tr ng-repeat=\"grp in vm.questionPaper.mandatGroupsInfo\"><td ng-bind=grp.name></td><td ng-bind=\"grp.qTypes | questionTypeView\"></td><td ng-bind=grp.qCount></td><td ng-if=vm.questionPaper.isGroupWiseTiming><span ng-bind=grp.grpTime></span>&nbsp;mins</td></tr></tbody></table></div><!-- Optional Groups --><div class=table-responsive><table class=\"table test-structure table-hover\" ng-if=vm.questionPaper.isOptionalGroup ng-repeat=\"optGrp in vm.questionPaper.optionalGroupsInfo\"><thead style=\"background: #F9F9F9\"><tr><th colspan=4>OPTIONAL SECTION - Choose any <span ng-bind=optGrp.noOfgrpsToBeSeleted></span></th></tr><tr><th>Groups</th><th>Type of Questions</th><th>No. of Questions</th><th ng-if=vm.questionPaper.isGroupWiseTiming>Duration</th></tr></thead><tbody><tr ng-repeat=\"grp in optGrp.grps\"><td ng-bind=grp.name></td><td ng-bind=\"grp.qTypes | questionTypeView\"></td><td ng-bind=grp.qCount></td><td ng-if=vm.questionPaper.isGroupWiseTiming><span ng-bind=grp.grpTime></span>&nbsp;mins</td></tr></tbody></table></div></div><!-- Special Instructions --><div class=\"col-md-12 start-section\" ng-if=vm.questionPaper.testInstructions><p class=start-section-header>Special Instructions</p><div class=\"start-info-box test-instruction\"><p ng-bind-html=vm.questionPaper.testInstructions></p></div></div><!-- HOW TO NAVIGATE --><div class=\"col-md-12 start-section\" ng-if=!vm.isThirdParty><p class=start-section-header>HOW TO NAVIGATE</p><div class=start-info-box><img src=assets/images/onlineassementTollInstruction.png class=img-responsive><ol class=start-info-box-ol><li><p>Access these instructions during the test by clicking the Instructions button.</p></li><li><p>Get to know the time left for your test by looking at the Timer on top right of your page.</p></li><li><p>Navigate between questions by clicking on the Question Numbers. Flag and Unflag question by clicking on the Star. Answered questions will appear in blue.</p></li><li><p>You can also navigate between questions by click Next and Previous.</p></li><li><p>Questions will appear on top, and you can answer them below Note: The answer section will appear differently based on the question type..</p></li><li><p>You can also Unanswer the question by clicking the Unanswer button. The button will appear automatically once you have answered</p></li><li><p>Once you are done with the test, please make sure you click End Test and also Confirm.</p></li></ol></div></div></div>");
$templateCache.put("app/assessment/browserCompatibility.html","<div class=\"row row-panel-padding-top\" style=margin-top:70px><div class=row><div class=col-md-10><h4 style=margin-left:15px>Online Assessment Compatibility Test</h4></div><div class=\"col-md-2 text-center\" ng-if=vm.practiceTestEnabled><button class=\"btn btn-info btn-start-practice\" ng-click=vm.startSampleTest();><i class=\"fa fa-play fa-fw\" aria-hidden=true></i> Start Practice Test</button></div></div><div class=row><div class=col-md-4><div class=\"panel panel-default\"><div class=panel-heading><h3 class=panel-title>Operating System</h3></div><div class=\"panel-body compatibility-panel\"><dl><dt class=pull-left>System :</dt><dd ng-bind=vm.systemInfo.os></dd><dt class=pull-left>Version :</dt><dd ng-bind=vm.systemInfo.osVersion></dd><dt class=pull-left ng-if=\"vm.systemInfo.device!=\'unknown\'\">Device :</dt><dd ng-bind=vm.systemInfo.device ng-if=\"vm.systemInfo.device!=\'unknown\'\"></dd><dt class=pull-left>Dimension :</dt><dd ng-bind=vm.systemInfo.deviceSize></dd></dl></div></div></div><div class=col-md-4><div class=\"panel panel-default\"><div class=panel-heading><h3 class=panel-title>Internet Bandwidth</h3></div><div class=\"panel-body compatibility-panel\"><img style=display:none ng-src={{vm.imgfile}} imageonload=vm.onImageLoad()><div ng-if=!vm.systemInfo.bandWidth>Running bandwidth test, please wait...</div><dl ng-if=vm.systemInfo.bandWidth><dt class=pull-left>Download Bandwidth :</dt><dd><span ng-bind=vm.systemInfo.bandwidthText ng-class=vm.systemInfo.bandwidthText>Medium</span> @ <span ng-bind=vm.systemInfo.bandWidth>5.6</span> Mbps</dd><dt class=pull-left>Time Taken :</dt><dd><span ng-bind=vm.systemInfo.timetaken>11.917</span> Sec</dd><dt class=pull-left>File Size :</dt><dd>10.74 Mb</dd></dl></div></div></div><div class=col-md-4><div class=\"panel panel-default\"><div class=panel-heading><h3 class=panel-title>Browser Info</h3></div><div class=\"panel-body compatibility-panel\"><dl><dt>Name :</dt><dd ng-bind=\"vm.systemInfo.browser + \' - \' + vm.systemInfo.browserVersion +\' (\'+vm.systemInfo.browserSize+\')\'\"></dd><dt>Cookies :</dt><dd ng-bind=vm.systemInfo.browserCookies ng-class=\"{\'passed\' : vm.systemInfo.browserCookies==\'Enabled\', \'failed\' : vm.systemInfo.browserCookies != \'Enabled\'}\"></dd><dt>Popup :</dt><dd ng-bind=vm.systemInfo.browserPopup ng-class=\"{\'passed\' : vm.systemInfo.browserPopup==\'Enabled\', \'failed\' : vm.systemInfo.browserPopup != \'Enabled\'}\"></dd></dl></div></div></div></div><div class=row><div class=\"col-md-6 col-md-offset-3\" ng-if=vm.isProctoringCheck><div class=\"panel panel-default\"><div class=panel-heading><h3 class=panel-title>Camera</h3></div><div class=panel-body><proctor-compatibility hide-action-pannel=true video-sample-opts=vm.videoSampleOpts response-data=vm.getVideoCompatibilityInfo(info) is-authenticated=false></proctor-compatibility><!--  <button class=\"btn btn-info btn-start-practice\" ng-click=\"vm.sampleVideo();\">\n                    Start Sample Video\n                    </button> --><p style=\"border-top:2px solid rgba(5, 130, 175, 0.34)\"><br>Please submit your system testing result after recording sample video.</p><textarea rows=5 style=width:100% placeholder=Comments... ng-model=vm.systemInfo.userComment></textarea><button class=\"btn btn-info btn-start-practice pull-right\" ng-click=vm.submitResult(); ng-disabled=!vm.videoCompatibilityInfo.isVideoRecorded>Submit Result</button></div></div></div></div></div>");
$templateCache.put("app/assessment/browserCompatibility.tpl.html","<style type=text/css>.pids-wrapper {\n    left: 10px !important;\n}\n\n.pid {\n    width: 8px !important;\n    margin-right: 3px;\n}</style><div class=container-fluid style=\"margin-top:50px;overflow:auto;height:calc(100vh - 50px)\"><div class=row><div class=col-md-7><h4 style=margin-left:15px>Compatibility Test Page For Proctored Online Assessment</h4></div><div class=col-md-5 ng-if=false><!-- vm.overAllStatus.echoTestStatus == \'end\' --><h4 class=pull-right>Overall Status : <span ng-if=\"!vm.overAllStatus.micCheck || !vm.overAllStatus.cameraCheck || !vm.overAllStatus.browserApproved || !vm.overAllStatus.echoCheck || vm.overAllStatus.standaloneMinFps || vm.internetSpeed.uploadBandwidthText ===\'Low\' ||  vm.internetSpeed.downloadBandwidthText ===\'Low\' \" style=color:#ff0000>Fail</span> <span ng-if=\"vm.overAllStatus.micCheck && vm.overAllStatus.cameraCheck && vm.overAllStatus.browserApproved && vm.overAllStatus.echoCheck && !vm.overAllStatus.standaloneMinFps && vm.internetSpeed.uploadBandwidthText !==\'Low\' &&  vm.internetSpeed.downloadBandwidthText !==\'Low\'\" style=color:#008000>Success</span></h4></div><div class=\"col-md-2 text-center\" ng-if=vm.practiceTestEnabled><button class=\"btn btn-info btn-start-practice\" ng-click=vm.startSampleTest();><i class=\"fa fa-play fa-fw\" aria-hidden=true></i> Start Practice Test</button></div></div><div class=row><div class=col-md-12><div class=\"panel panel-default\"><div class=panel-heading><h3 class=panel-title>Overall Status</h3></div><div class=\"panel-body compatibility-panel\"><b style=color:#7CB6E7 ng-if=\"vm.overAllStatus.echoTestStatus != \'end\'\">Please wait while we complete the system compatibility check. </b><span ng-if=\"vm.overAllStatus.echoTestStatus == \'end\'\"><b ng-if=\"!vm.overAllStatus.micCheck || !vm.overAllStatus.cameraCheck || !vm.overAllStatus.browserApproved || !vm.overAllStatus.echoCheck || vm.overAllStatus.standaloneMinFps || vm.internetSpeed.uploadBandwidthText ===\'Low\' ||  vm.internetSpeed.downloadBandwidthText ===\'Low\' \" style=color:#F34325>Failure: Your system compatibility check has failed. Please fix the issues reported below and refresh this page.</b> <b ng-if=\"vm.overAllStatus.micCheck && vm.overAllStatus.cameraCheck && vm.overAllStatus.browserApproved && vm.overAllStatus.echoCheck && !vm.overAllStatus.standaloneMinFps && vm.internetSpeed.uploadBandwidthText !==\'Low\' &&  vm.internetSpeed.downloadBandwidthText !==\'Low\'\" style=color:#4FA535>Success: Your system is compatible. Please make sure to use the same System & Internet settings for your assessment/interview.</b></span></div></div></div></div><div class=row><div class=col-md-7 ng-if=vm.isProctoringCheck><div class=\"panel panel-default\"><div class=panel-heading><h3 class=panel-title>Camera</h3></div><div class=\"panel-body compatibility-panel\" style=height:auto><p>Steps to follow</p><ul><li>Please be infront of camera.</li><li>Please ensure your face is within box and there is adequate light on your face.</li><!-- <li>\n                            Record your 1 minute video.\n                        </li> --><li>If you face any challenge, mention it in feedback box and submit.</li></ul><proctor-compatibility hide-action-pannel=true video-sample-opts=vm.videoSampleOpts response-data=vm.getVideoCompatibilityInfo(info) is-authenticated=false internet-speed=vm.internetSpeed over-all-status=vm.overAllStatus other-config=vm.otherConfig></proctor-compatibility><p style=color:#F46A62;font-weight:500 ng-if=vm.overAllStatus.standaloneMinFps>Your system is either too slow or running too many applications.<br>Please restart your system after closing all applications, and then try again.<br>If you still see this error, please upgrade to a <u popover-placement=right-bottom popover-title=\"Compatible hardware configuration\" uib-popover-html=vm.slowSystemInstruction popover-trigger=\"\'mouseenter\'\" popover-append-to-body=true>faster machine.</u></p></div></div></div><div class=col-md-5><div class=\"panel panel-default\"><div class=panel-heading><h3 class=panel-title>System Info</h3></div><div class=\"panel-body compatibility-panel\"><dl><dt class=pull-left>System :</dt><dd ng-bind=vm.systemInfo.os></dd><dt class=pull-left>Version :</dt><dd ng-bind=vm.systemInfo.osVersion></dd><dt class=pull-left ng-if=\"vm.systemInfo.device!=\'unknown\'\">Device :</dt><dd ng-bind=vm.systemInfo.device ng-if=\"vm.systemInfo.device!=\'unknown\'\"></dd><dt class=pull-left>Dimension :</dt><dd ng-bind=vm.systemInfo.deviceSize></dd><dt class=pull-left ng-if=vm.systemInfo.checkSEB>Safe Browser Compatible :</dt><dd ng-bind=vm.systemInfo.sebText ng-class=\"{\'passed\' : vm.systemInfo.sebSatus, \'failed\' : !vm.systemInfo.sebSatus}\"></dd></dl></div></div><div class=\"panel panel-default\"><div class=panel-heading><h3 class=panel-title>Browser Info</h3></div><div class=\"panel-body compatibility-panel\"><dl><dt class=pull-left>Name :</dt><dd ng-bind=\"vm.systemInfo.browser + \' - \' + vm.systemInfo.browserVersion\"></dd><dt class=pull-left>Screen :</dt><dd ng-bind=vm.systemInfo.browserSize></dd><dt class=pull-left>Cookies :</dt><dd ng-bind=vm.systemInfo.browserCookies ng-class=\"{\'passed\' : vm.systemInfo.browserCookies==\'Enabled\', \'failed\' : vm.systemInfo.browserCookies != \'Enabled\'}\"></dd><dt class=pull-left>Popup :</dt><dd ng-bind=vm.systemInfo.browserPopup ng-class=\"{\'passed\' : vm.systemInfo.browserPopup==\'Enabled\', \'failed\' : vm.systemInfo.browserPopup != \'Enabled\'}\"></dd></dl></div></div><div class=\"panel panel-default\"><div class=panel-heading><h3 class=panel-title>Internet Bandwidth</h3></div><div class=\"panel-body compatibility-panel\"><!-- <img style=\"display:none;\" ng-src=\"{{vm.imgfile}}\" imageonload=\"vm.onImageLoad()\" /> --><div ng-if=!vm.internetSpeed.downloadSpeed>Running bandwidth test, please wait...</div><!-- <dl ng-if=\"vm.systemInfo.bandWidth\">\n                        <dt class=\"pull-left\"> Download speed : </dt>\n                        <dd><span ng-bind=\"vm.systemInfo.bandwidthText\" ng-class=\"vm.systemInfo.bandwidthText\">Medium</span>@<span ng-bind=\"vm.systemInfo.bandWidth\">5.6</span> Mbps</dd>\n                        {{vm.internetSpeed}}\n                    </dl> --><dl ng-if=vm.internetSpeed.downloadSpeed><dt class=pull-left>Download speed :</dt><dd><span ng-bind=vm.internetSpeed.downloadBandwidthText ng-class=vm.internetSpeed.downloadBandwidthText>Medium</span>@<span ng-bind=vm.internetSpeed.downloadSpeed>5.6</span> Mbps</dd></dl><dl ng-if=vm.internetSpeed.uploadSpeed><dt class=pull-left>Upload speed :</dt><dd><span ng-bind=vm.internetSpeed.uploadBandwidthText ng-class=vm.internetSpeed.uploadBandwidthText>Medium</span>@<span ng-bind=vm.internetSpeed.uploadSpeed>5.6</span> Mbps</dd></dl><!-- <dt class=\"pull-left\"> Time Taken : </dt>\n                        <dd> <span ng-bind=\"vm.systemInfo.timetaken\">11.917</span> Sec </dd>\n                        <dt class=\"pull-left\"> Data Size : </dt>\n                        <dd> 10.74 Mb </dd> --></div></div></div><div class=col-md-5 ng-if=vm.isFeedbackAllowed><div class=\"panel panel-default\"><div class=panel-heading><h3 class=panel-title>Feedback</h3></div><div class=\"panel-body compatibility-panel\"><textarea rows=3 style=width:100% placeholder=Feedback... ng-model=vm.systemInfo.userComment></textarea><button ng-disabled=!vm.systemInfo.userComment class=\"btn btn-info btn-start-practice pull-right\" ng-click=vm.submitComment();>Submit feedback</button></div></div><div class=\"panel panel-default\" ng-if=false><div class=panel-heading><h3 class=panel-title>Things To Do</h3></div><div class=\"panel-body compatibility-panel\"><ul><li>Please be infront of camera.</li><li>Please ensure your face is within box and there is adequate light on your face.</li><li>Record your 1 minute video.</li><li>If you face any challenge, mention it in feedback box and submit.</li></ul></div></div></div></div></div>");
$templateCache.put("app/assessment/callBackVersant.tpl.html","<div class=end-test-body><div><div class=text-center style=margin-top:32px><h1 ng-bind-html=vm.params.message>This is a call back page</h1></div><div ng-if=!vm.params.message><h3><b>Please wait while we submit your test.</b></h3><div style=color:red;line-height:8px>Please do NOT close this window or press refresh/back button.</div><div><div style=\"margin-top: 45px;font-size: 60px;line-height: 24px;margin-bottom: 16px\">{{vm.showTime}}</div><div>Remaining</div></div><div style=\"color: grey;margin-top:20px\">{{vm.submessage}}</div></div></div></div>");
$templateCache.put("app/assessment/callback.tpl.html","<div class=end-test-body><div><div class=text-center style=margin-top:32px><h1 ng-bind-html=vm.params.message>This is a call back page</h1></div><div ng-if=!vm.params.message><h3><b>Please wait while we submit your test.</b></h3><div style=color:red;line-height:8px>Please do NOT close this window or press refresh/back button.</div><div><div style=\"margin-top: 45px;font-size: 60px;line-height: 24px;margin-bottom: 16px\">{{vm.showTime}}</div><div>Remaining</div></div><div style=\"color: grey;margin-top:20px\">{{vm.submessage}}</div></div></div></div>");
$templateCache.put("app/assessment/captureId.tpl.html","<div class=row><div class=col-md-12><p style=color:#007EFC;font-weight:700;font-size:18px>Capture Photo ID(Aadhar card, Voter ID, PAN card, Driving License etc..)</p></div></div><div class=row><div class=col-md-6><p style=font-size:16px>Please bring your photo ID in front of the camera</p></div></div><div class=row><div class=\"col-md-8 col-md-offset-2 text-center\"><video autoplay id=videoToCapture muted ng-show=!vm.imgCaptured class=capture-element width=480 height=360></video><p ng-show=!vm.imgCaptured style=font-size:14px>Please make sure that your photo ID is clear and completely visible in the camera.</p><img ng-src={{vm.imgUrl}} ng-show=vm.imgCaptured class=capture-element></div></div><div class=row><div class=\"col-md-12 text-center\"><button class=\"btn btn-primary\" ng-click=vm.captureImage() ng-if=!vm.imgCaptured ng-disabled=!vm.stream>Capture</button> <button class=\"btn btn-default\" ng-click=vm.recaptureImage() ng-if=vm.imgCaptured>Recapture</button></div></div>");
$templateCache.put("app/assessment/captureIdResponse.tpl.html","<div class=row><div class=col-md-12 ng-if=\"vm.progressStatus == \'pendding\'\"><p class=capture-modal-header>Examiner Approval Pending</p><!-- <p style=\"font-size:16px;\">\n            Examiner Approval Pending\n        </p> --><div class=\"text-center noise-div\"><div style=margin-bottom:10px><h4 style=color:#36B37E>Please wait for the examiner’s approval.</h4><p>Please do not reload, go back, or close the browser.</p><!-- <p>\n                    <h2 ng-bind=\"vm.waitCounter | formatTime: \'mins\'\"></h2>\n                </p> --><p>Note: This process can take several minutes.</p></div></div></div><div class=col-md-12 ng-if=\"vm.progressStatus == \'rejected\'\"><p class=capture-modal-header>Resubmission Required</p><!-- <p style=\"font-size:16px;\">\n            Please bring your photo ID in front of the camera\n        </p> --><div class=\"text-center noise-div\"><div style=margin-bottom:10px><h4 style=color:#FF6057>Resubmission Required</h4><p ng-if=!vm.rejectMsg>The examiner has asked you to resubmit your photo ID. Please bring your photo ID in front of the camera again.</p><p ng-if=vm.rejectMsg ng-bind=vm.rejectMsg></p></div><div><button class=\"btn btn-primary\" ng-click=vm.recaptureIdImage()>Go to Photo ID Capture</button></div></div></div></div>");
$templateCache.put("app/assessment/consentFormAccenture.tpl.html","<div class=row><div class=col-md-12><p>This is an online proctored test, where we will monitor the entire session to ensure the integrity of the test.</p><p style=font-weight:700>Please make sure that your webcam and microphone is on throughout the test, and that you are present and clearly visible in the camera throughout the test.</p></div></div><div class=row><div class=col-md-4><div class=proctor-check-instruction><!--You certify that you are attending the test yourself, and you certify that you will not utilize any unfair means or external help to complete the test--> You certify that you are attending the test yourself, and you certify that <b>&ldquo;If found to be engaged in any act of fraudulent, misrepresentation or any use of unfair means candidate would be disqualified from the process&rdquo;</b></div></div><div class=col-md-4><div class=proctor-check-instruction>You agree that your information (answers, video, audio, online session) will be recorded, stored, viewed, and analyzed to ensure the integrity of the assessment</div></div><div class=col-md-4><div class=proctor-check-instruction>You understand that the use of your information will be in accordance with the applicable data privacy law and in line with our Global Privacy Statement as shared and agreed at the time of registration</div></div></div><div class=row><div class=col-md-12><p class=form-group><label class=\"custom-checkbox font-weight-700\">I agree to the terms & conditions above, and I fully understand my rights to access, correct or withdraw my information anytime. <input name=chkProctorTermCondition type=checkbox id=termsChk ng-model=vm.isTermsAccepted ng-change=\"vm.wizard[vm.wizardCurrentStep].stateCheck = vm.isTermsAccepted\"> <span class=chk></span></label></p></div></div>");
$templateCache.put("app/assessment/consentFormDefault.tpl.html","<div class=row><div class=col-md-12><p>This is an online proctored test, where we will monitor the entire session to ensure the integrity of the test.</p><p style=font-weight:700>Please make sure that your webcam and microphone is on throughout the test, and that you are present and clearly visible in the camera throughout the test.</p></div></div><div class=row><div class=col-md-4><div class=proctor-check-instruction>You certify that you are attending the test yourself, and you certify that you will not utilize any unfair means or external help to complete the test</div></div><div class=col-md-4><div class=proctor-check-instruction>You agree that your information (answers, video, audio, online session) will be recorded, stored, viewed, and analyzed to ensure the integrity of the assessment</div></div><div class=col-md-4><div class=proctor-check-instruction>You understand that the use of your information will be in accordance with the applicable data privacy law and in line with our privacy policy available here</div></div></div><div class=row><div class=col-md-12><p class=form-group><label class=\"custom-checkbox font-weight-700\">I agree to the terms & conditions above, and I fully understand my rights to access, correct or withdraw my information anytime. <input name=chkProctorTermCondition type=checkbox id=termsChk ng-model=vm.isTermsAccepted ng-change=\"vm.wizard[vm.wizardCurrentStep].stateCheck = vm.isTermsAccepted\"> <span class=chk></span></label></p></div></div>");
$templateCache.put("app/assessment/consentFormVersant.tpl.html","<div class=row><div class=col-md-12><p style=font-weight:700>This is an online proctored test, where we will monitor your session via webcam, microphone, and browser.</p></div></div><div class=row><div class=col-xs-12><div class=\"proctor-check-instruction versant-instruction\"><p>By accessing this website and ticking the box you indicate your acceptance of the Versant, <a href={{vm.privacyPolicy}} target=_blank>Privacy Policy</a> (“Privacy Policy”), by NCS Pearson, Inc. (“Pearson”), Terms and Conditions and use of cookies to support your experience. You also understand, acknowledge and agree that the Assigning Institution has its own, possibly different, privacy policy.</p><span><label class=custom-checkbox>I agree <input name=chkAccept1 type=checkbox id=termsChk1 ng-model=vm.acceptPrivacyPolicy ng-change=vm.setConsentStatusCheck();> <span class=chk></span></label></span></div></div><div class=col-xs-12><div class=\"proctor-check-instruction versant-instruction\"><p>By providing your personal information, as described in our Privacy Policy, you acknowledge and agree to the video and audio recording of your facial image, voice, desk and workspace for the purposes of test quality, security and the integrity of the testing process, and you agree to the processing of such personal information and test data by Pearson and to the transfer of such data to Pearson’s hub servers, located in Ireland and the United States, as the data processor, its authorized third parties, if any, both in the capacity as data processors for the processing of your personal information and test data on behalf of the Assigning Institution, as the data controller, located in the USA or elsewhere. Pearson and other data processing entities, if any, are the recipients of your personal information and test data and are or may be located outside of the European Union and the European Economic Area; however, Pearson will enter into reasonable data transfer agreements with such entities for the purpose of communicating and following the instructions of your testing program sponsor and for establishing reasonable security measures to protect the confidentiality and integrity of your personal information and test data.</p><span><label class=custom-checkbox>I agree <input name=chkAccept2 type=checkbox id=termsChk2 ng-model=vm.acceptPersonalInfo ng-change=vm.setConsentStatusCheck();> <span class=chk></span></label></span></div></div><div class=col-xs-12><div class=\"proctor-check-instruction versant-instruction\"><p>You will be recorded during the testing session so that your face, voice, desk and workspace will be captured and recorded during the testing session. You understand, acknowledge and agree that your privacy at your current location during the exam testing session is limited due to the video and audio monitoring and you explicitly waive any and all claims asserting a right to individual privacy or other similar claims. You also agree to get appropriate agreement from anyone else present during your test for them to be audio and video recorded. By accessing this website and ticking this box you signify your acknowledgement and agreement that any inappropriate or wrongful conduct, at the Assigning Institution’s sole discretion, witnessed while monitoring your testing session at your current location will be reported to the appropriate governmental authorities, including, but not limited to, any law enforcement officials.</p><span><label class=custom-checkbox>I agree <input name=chkAccept3 type=checkbox id=termsChk3 ng-model=vm.acceptDataCapture ng-change=vm.setConsentStatusCheck();> <span class=chk></span></label></span></div></div></div>");
$templateCache.put("app/assessment/endTest.tpl.html","<div class=end-test-body><div class=end-test-pannel><div class=row><div class=col-md-12><p class=end-test-msg-title ng-bind=vm.message.title>Are you sure you want to end the test?</p><p class=end-test-msg-info ng-if=vm.message.info ng-bind=vm.message.info>Once you end the test, you will not be able to access it again.</p></div></div><!-- Question Answer & Unswer Count --><div class=row><div class=col-md-6><div class=\"end-test-info-box pull-right\"><p name=questionsAnswered class=end-test-info-box-header ng-bind=vm.questionsAnswered>0</p><p class=end-test-info-box-text>Answered</p></div></div><div class=col-md-6><div class=end-test-info-box><p name=questionsUnanswered class=end-test-info-box-header ng-bind=vm.questionsUnanswered>0</p><p class=end-test-info-box-text>Unanswered</p></div></div></div><!-- Go Back / End Test Buttons --><div class=\"row text-center\" style=margin-top:32px ng-if=!vm.submittingTest><div class=col-md-6 ng-if=vm.isGoBackIsAllowed><button name=btnGoBackToTest type=button class=\"btn btn-default btn-lg pull-right btn-block squre-btn-corner back-to-test\" ng-click=vm.backToTest();><i class=\"fa fa-chevron-left\" aria-hidden=true></i> Go back to the test</button></div><div ng-class=\"vm.isGoBackIsAllowed ? \'col-md-6\' : \'col-md-12\'\"><button name=btnCloseTest type=button id=closeTest class=\"btn btn-danger btn-lg pull-left btn-block squre-btn-corner done-with-test\" ng-click=vm.endTest();>I am done with the test <i class=\"fa fa-chevron-right\" aria-hidden=true></i></button></div></div><!-- Loading icon --><div class=row><div class=col-md-12><div ng-if=vm.submittingTest style=margin-top:32px;height:60px><div class=\"ripple ripple1\"></div><div class=\"ripple ripple2\"></div><div class=\"ripple ripple3\"></div></div><span name=endTestMsg ng-if=vm.submittingTest style=margin-top:20px;font-size:14px>Please wait while we submit your answers</span></div></div></div></div>");
$templateCache.put("app/assessment/envProctoring.tpl.html","<div class=container><div class=row style=\"margin-top:100px;overflow:auto;height:calc(100vh - 100px);padding:20px\"><div class=\"col-md-6 col-md-offset-3 text-center\" ng-show=!vm.proctoringStarted><button class=\"btn btn-primary\" ng-click=vm.startProctoring()>Start Proctoring</button></div><div class=\"col-md-6 col-md-offset-3\" ng-show=vm.proctoringStarted><h3 class=text-center>Proctoring has started</h3><div class=\"well row\"><div class=\"col-md-6 col-sm-12\"><p>Rotate your phone in the landscape mode.</p><p>Connect your phone to a power source.</p></div><div class=\"col-md-6 col-sm-12\"><p>Place your phone on a stable phone stand.</p><p>Ensure that you and your desk are fully visible.</p></div></div><div class=video-panel><video id=vid-mirror class=mirror autoplay muted></video></div><div class=text-center><div>Please DO NOT close this window until you are done with the test.</div><button class=\"btn btn-danger\" ng-click=vm.stopProctoring() ng-if=false>Stop Proctoring</button></div></div></div></div>");
$templateCache.put("app/assessment/freshChat.tpl.html","<div ng-if=vm.showIcon class=chat-icon><div class=\"d-hotline h-btn animated zoomIn faster\"><div class=chat-content><i class=\"fa fa-align-justify\" ng-click=vm.activateFreshChat()></i></div></div></div>");
$templateCache.put("app/assessment/groupDetails.tpl.html","<div class=group-details-section style=font-weight:bold><div class=pull-left ng-if=vm.isInfoDisplayed>{{vm.loginInfo.CandidateName}} <span ng-if=\"vm.loginInfo && vm.loginInfo.assessmentConfig && vm.loginInfo.assessmentConfig.showCandidateID\">({{vm.loginInfo.CandidateId}})</span></div><div class=pull-right><div>{{ vm.currentDate | date: \'fullDate\' }}</div><div ng-if=vm.isInfoDisplayed><i class=\"fa fa-clock-o\" aria-hiden=true></i> <b>[Total Time: {{vm.testDuration | date:\'HH:mm:ss\'}} | Time Remaining: {{vm.timeRemaining | date:\'HH:mm:ss\'}}]</b></div></div></div>");
$templateCache.put("app/assessment/login.tpl.html","<!--\r\n<div class=\"row\" ng-class=\"{\'appViewAngularMaterial\': vm.ApplicationViewType ===\'App-Angular-Material\'}\" style=\"padding:0px;\">\r\n    <div class=\"col-md-7 company-info-span\">\r\n        <div class=\"panel-heading panel-heading-material\">\r\n            <img ng-src=\"{{vm.companyLogoUrl}}\" alt=\"HirePro\" class=\"company-logo\">\r\n        </div>\r\n        <div class=\"company-info-panel-body login-template-font-family\" ng-bind-html=\"vm.companyInfo\">\r\n        </div>\r\n        <div class=\"btn btn-info floating-fixed-button\" ng-if=\"vm.companyInfo\" fade-on-scroll ng-click=\"vm.scrollToLoginPage()\">Login\r\n            <i class=\"fa fa-angle-double-down\" aria-hidden=\"true\" \r\n            style=\"position:relative;left:30%;\"></i>\r\n        </div>\r\n    </div>\r\n    <div class=\"col-md-5 login-col-span\" style=\"height:100vh;\">\r\n        <div class=\"login-panel-body\">\r\n            <div class=\"login-label login-template-font-family\">\r\n                Login\r\n            </div>\r\n            <div style=\"margin-bottom: 19px\" class=\"form-group\">\r\n                <input name=\"loginUsername\" type=\"text\" class=\"form-control login-input login-template-font-family\" name=\"username\" value=\"\" placeholder=\"username\" ng-model=\"vm.loginName\" ng-keyup=\"$event.keyCode == 13 && vm.LoginToTest()\">\r\n            </div>\r\n            <div style=\"margin-bottom: 19px\" class=\"form-group\">\r\n                <input name=\"loginPassword\" type=\"password\" class=\"form-control login-input login-template-font-family\" name=\"password\" placeholder=\"password\" ng-model=\"vm.loginPassword\" ng-keyup=\"$event.keyCode == 13 && vm.LoginToTest()\">\r\n            </div>\r\n            <div class=\"controls\" style=\"margin-bottom: 15px\">\r\n                <button name=\"btnLogin\" ng-disabled=\"!vm.loginName || !vm.loginPassword\" ng-click=\"vm.LoginToTest()\" class=\"btn btn-default login-btn login-template-font-family\">Login</button>\r\n            </div>\r\n            <div class=\"alert-danger-font login-template-font-family\" ng-if=\"vm.loginInfo.IsException\">\r\n                {{vm.loginInfo.Message}}\r\n            </div>\r\n        </div>\r\n        <browser-version id=\"login-col\"></browser-version>\r\n    </div>\r\n</div>\r\n--><div class=\"row login-body\"><div class=login-panel-peer>&nbsp;</div><div class=\"col-xs-12 login-panel\"><div class=\"row login-panel-head\" ng-class=\"{\'login-panel-head-none\' : vm.hideHireproBranding && !vm.companyLogoUrl}\"><div ng-if=\"vm.hideHireproBranding !== null\"><!-- nseit hardcode changes background color --><div class=logo ng-class=\"vm.hideHireproBranding || vm.alias.startsWith(\'accenture\') ? \'col-xs-12\' : \'col-xs-6\'\" ng-style=\"vm.isNseitTenant && {\'background\': \'rgba(58,46,126,.9)\'}\" ng-if=vm.companyLogoUrl><img class=login-logo ng-src={{vm.companyLogoUrl}} alt={{vm.alias}} class=company-logo></div><div class=logo ng-class=\"vm.companyLogoUrl ? \'col-xs-6\' : \'col-xs-12\'\" ng-if=\"!vm.hideHireproBranding && !vm.alias.startsWith(\'accenture\')\"><img class=login-logo ng-src={{vm.defaultLogoUrl}} alt={{vm.alias}} class=company-logo></div></div></div><!-- <div class=\"row login-panel-head\" ng-if=\"vm.companyLogoUrl && !vm.alias.startsWith(\'accenture\')\">\r\n            <div class=\"col-md-6 col-xs-6 logo1\">\r\n                <img class=\"login-logo\" ng-if=\"vm.companyLogoUrl\" ng-src=\"{{vm.companyLogoUrl}}\" alt=\"{{vm.alias}}\" class=\"company-logo\">\r\n            </div>\r\n            <div class=\"col-md-6 col-xs-6 logo2\">\r\n                <img class=\"login-logo\" ng-src=\"{{vm.defaultLogoUrl}}\" alt=\"{{vm.alias}}\" class=\"company-logo\">\r\n            </div>\r\n        </div>\r\n        <div class=\"row login-panel-head\" ng-if=\"!vm.companyLogoUrl && !vm.alias.startsWith(\'accenture\')\">\r\n            <div class=\"col-md-12 col-xs-12 logo2\">\r\n                <img class=\"login-logo\" ng-src=\"{{vm.defaultLogoUrl}}\" alt=\"HirePro\" class=\"company-logo\">\r\n            </div>\r\n        </div>\r\n        <div class=\"row login-panel-head\" ng-if=\"vm.alias.startsWith(\'accenture\')\">\r\n            <div class=\"col-md-12 col-xs-12 logo2\">\r\n                <img class=\"login-logo\" ng-if=\"vm.companyLogoUrl\" ng-src=\"{{vm.companyLogoUrl}}\" alt=\"{{vm.alias}}\" class=\"company-logo\">\r\n            </div>\r\n        </div> --><div class=login-panel-body><div class=login-label>Login</div><form><div class=form-group><label>Username</label><input ng-disabled=vm.disableLoginButton name=loginUsername class=form-control type=text class=\"form-control login-input login-template-font-family\" name=username placeholder=\"Enter Username\" ng-model=vm.loginName ng-keyup=\"$event.keyCode == 13 && vm.LoginToTest()\"></div><div class=form-group><label for=exampleInputPassword1>Password</label><input ng-disabled=vm.disableLoginButton name=loginPassword class=form-control type=password class=\"form-control login-input login-template-font-family\" name=password placeholder=\"Enter Password\" ng-model=vm.loginPassword ng-keyup=\"vm.isDesktop && $event.keyCode == 13 && vm.LoginToTest()\"></div><button name=btnLogin ng-disabled=\"!vm.loginName || !vm.loginPassword || vm.disableLoginButton\" ng-click=vm.LoginToTest() class=\"btn btn-primary login-button\">Login</button> <input type=text ng-if=vm.isDebugMode ng-model=vm.debugData> <button name=btnLogin ng-if=vm.isDebugMode ng-click=vm.simulateUnscore() class=\"btn btn-primary login-button\">Simulate</button></form><div class=\"text-center login-error\" ng-if=vm.loginInfo.IsException>{{vm.loginInfo.Message}}</div></div><browser-version id=login-col></browser-version></div><div class=login-panel-peer>&nbsp;</div></div><div class=\"row login-footer\"><div class=\"col-md-2 hidden-xs hidden-sm\" ng-if=!vm.hideTermsAndConditions><!-- <a style=\"color: #A1A2A4\" ng-if=\"vm.alias === \'accenture\' || vm.alias === \'accenturetest\'\" href=\"https://all-hirepro-files.s3-ap-southeast-1.amazonaws.com/hirepro/static-resources/termsandconditions-accenture.html\" target=\"_blank\">Terms of Use</a>&nbsp;\r\n        <a style=\"color: #A1A2A4\" ng-if=\"vm.alias !== \'accenture\' && vm.alias !== \'accenturetest\'\" href=\"https://all-hirepro-files.s3-ap-southeast-1.amazonaws.com/hirepro/static-resources/termsandconditions.html\" target=\"_blank\">Terms of Use</a> --> <span style=color:#A1A2A4 ng-click=\"vm.termsAndPrivacyPolicy(vm.termsOfUse, \'Terms Of Use\');\">Terms of Use</span></div><div class=\"col-md-2 hidden-xs hidden-sm\" ng-if=!vm.hideTermsAndConditions><!-- <a style=\"color: #A1A2A4\" ng-if=\"vm.alias === \'accenture\' || vm.alias === \'accenturetest\'\" href=\"https://www.accenture.com/in-en/about/privacy-policy\" target=\"_blank\">Privacy Policy</a>\r\n        <a style=\"color: #A1A2A4\" ng-if=\"vm.alias !== \'accenture\' && vm.alias !== \'accenturetest\'\" href=\"{{vm.privacyPolicy}}\" target=\"_blank\">Privacy Policy</a> --> <span style=color:#A1A2A4 ng-if=!vm.loginInfo.Config.isSecureBrowserMandatory ng-click=\"vm.termsAndPrivacyPolicy(vm.privacyPolicy, \'Privacy Policy\');\">Privacy Policy</span></div><div class=\"col-md-4 col-xs-12 col-sm-12 login-footer-text\" ng-if=!vm.hideHireproBranding>© HirePro Consulting Pvt. Ltd. All rights reserved</div><div class=\"col-md-4 hidden-xs hidden-sm\"></div></div>");
$templateCache.put("app/assessment/loginToTest.html","<login-test></login-test>");
$templateCache.put("app/assessment/msgPage.html","<div class=\"row row-panel-padding-top\" style=padding:14px><div class=\"col-md-12 text-center\"><p ng-bind-html=vm.message></p></div></div>");
$templateCache.put("app/assessment/proctor.tpl.html","<proctor-compatibility></proctor-compatibility>");
$templateCache.put("app/assessment/proctorCompatibility.tpl.html","<div class=row><div class=col-md-12><p style=color:#007EFC;font-weight:700;font-size:18px>System Check + Verification Photo</p></div></div><div class=row><div class=col-md-6 ng-if=!vm.readyToTakeSelfie><p style=font-size:16px><strong>System Check:</strong></p><div class=proctor-check-device-items ng-class=\"{\'proctor-check-has-error\': !vm.cameraCheck}\"><div><i class=\"fa fa-video-camera fa-fw proctor-check-device-items-icon\" aria-hidden=true></i> <span class=proctor-check-device-items-text>Camera</span></div><div><i ng-class=\"vm.cameraCheck  ? \'fa fa-check-circle fa-lg icon-green\' : \'fa fa-times-circle fa-lg icon-red\'\"></i></div><i ng-if=!vm.cameraCheck class=proctor-check-error-msg>Camera is not available</i></div><div class=proctor-check-device-items ng-style=\"{\'height\' : vm.micCheck && \'49px\'}\" ng-class=\"{\'proctor-check-has-error\': !vm.micCheck}\"><div><i class=\"fa fa-microphone fa-fw proctor-check-device-items-icon\" aria-hidden=true></i> <span class=\"proctor-check-device-items-text visible-xs-inline\">Mic</span> <span class=\"proctor-check-device-items-text hidden-xs\">Microphone</span><div class=pids-wrapper><span style=margin-right:4px></span><div class=pid></div><div class=pid></div><div class=pid></div><div class=pid></div><div class=pid></div><div class=pid></div><div class=pid></div><div class=pid></div><div class=pid></div><div class=pid></div><div class=pid></div><div class=pid></div><div class=pid></div><div class=pid></div><div class=pid></div><div class=pid></div><div class=pid></div><div class=pid></div><div class=pid></div><div class=pid></div></div></div><div><i ng-class=\"vm.micCheck ? \'fa fa-check-circle fa-lg icon-green\' : \'fa fa-times-circle fa-lg icon-red\'\"></i></div><i ng-if=!vm.micCheck class=proctor-check-error-msg>Please speak higher or set microphone level</i></div><div class=proctor-check-device-items ng-class=\"{\'proctor-check-has-error\': !vm.browserApproved}\"><div><i class=\"fa fa-globe fa-fw proctor-check-device-items-icon\" aria-hidden=true></i> <span class=proctor-check-device-items-text>Browser</span></div><div><i ng-class=\"vm.browserApproved ? \'fa fa-check-circle fa-lg icon-green\' : \'fa fa-times-circle fa-lg icon-red\'\"></i></div><i ng-if=!vm.browserApproved class=proctor-check-error-msg ng-bind=vm.brwsrCompatibilityMsg>Unsupported version of chrome</i></div><div ng-if=\"vm.toCheckSpeedTest && !vm.isAuthenticated\" class=proctor-check-device-items-internet ng-class=\"{\'proctor-check-has-error\': !vm.speedTestStatus && !vm.inProgress}\"><div><i class=\"fa fa-bolt fa-fw proctor-check-device-items-icon\" aria-hidden=true></i> <span class=proctor-check-device-items-text>Internet</span></div><div><!-- <i ng-class=\"vm.speedTestStatus ? \'fa fa-check-circle fa-lg icon-green\' : \'fa fa-times-circle fa-lg icon-red\'\"></i> --><div ng-if=!vm.inProgress class=\"signal-bars mt1 sizing-box\" ng-class=vm.speedClass><div class=\"first-bar bar\"></div><div class=\"second-bar bar\"></div><div class=\"third-bar bar\"></div></div><div ng-if=vm.inProgress class=fa-1x><i class=\"fa fa-spinner fa-pulse fa-1x fa-fw\"></i></div></div><i ng-if=\"!vm.speedTestStatus && !vm.inProgress\" class=proctor-check-error-msg>Your Internet speed is too slow to take a proctored test. Please switch to a faster internet connection, and then try again.</i></div><!-- janus echo test *****************--><div ng-if=\"vm.isAuthenticated == false\" class=proctor-check-device-items ng-class=\"{\'proctor-check-has-error\': !vm.echoCheck}\"><div><i class=\"fas fa-fw fa-stream proctor-check-device-items-icon\" aria-hidden=true></i> <span class=proctor-check-device-items-text>Your Network is</span> <span ng-if=\"vm.echoTestStatus == \'start\'\" class=Progress>Loading...</span> <span ng-if=\"vm.echoTestStatus == \'end\' && !vm.echoCheck\" class=InActive>Not Compatible</span> <span ng-if=\"vm.echoTestStatus == \'end\' && vm.echoCheck\">Compatible</span></div><div><i ng-class=\"vm.echoCheck ? \'fa fa-check-circle fa-lg icon-green\' : \'fa fa-times-circle fa-lg icon-red\'\"></i></div></div><div class=proctor-check-device-items ng-if=vm.otherConfig.socketCheckConfig><span class=proctor-check-device-items-text>WebSocket</span> <span class=col-xs-4 ng-if=vm.otherConfig.socketCheckConfig.hvs><span>A</span> <i ng-class=\"vm.socketCheckStatus.hvs  ? \'fa fa-check-circle fa-lg icon-green\' : \'fa fa-times-circle fa-lg icon-red\'\"></i> </span><span class=col-xs-4 ng-if=vm.otherConfig.socketCheckConfig.aws><span>B</span> <i ng-class=\"vm.socketCheckStatus.aws  ? \'fa fa-check-circle fa-lg icon-green\' : \'fa fa-times-circle fa-lg icon-red\'\"></i> </span><span class=col-xs-4 ng-if=vm.otherConfig.socketCheckConfig.hirepro><span>C</span> <i ng-class=\"vm.socketCheckStatus.hirepro  ? \'fa fa-check-circle fa-lg icon-green\' : \'fa fa-times-circle fa-lg icon-red\'\"></i></span></div><!-- ************************* --></div><div class=col-md-6><div class=\"camera_permission text-center\" ng-if=vm.needPermission><p style=font-size:14px ng-if=\"vm.needPermissionStage === 1\"><strong>We need access to your camera and mic</strong><br>Please click the button below to allow access <button class=\"btn btn-primary btn-block\" style=\"margin-top: 32px\" ng-click=vm.startCamera()>Allow camera and mic access</button></p><div ng-if=\"vm.needPermissionStage === 2\"><div class=allow-camera-overlay><div class=allow-camera-modal><div class=row><div class=\"col-md-6 col-md-offset-6\"><div class=\"camera_permission text-center\"><img src=assets/images/allowCamera.png style=width:100%;height:100% class=hidden-sm></div></div></div></div></div></div></div><div class=camera_container ng-class=\"{\'camera_container_selfie\': vm.readyToTakeSelfie}\" ng-style=\"(vm.showImage || vm.needPermission) && {\'position\': \'absolute\',\'z-index\': -1,\'visibility\': \'hidden\',\'top\':\'0px\'}\"><span id=cameraAvailabilityStat ng-if=!vm.cameraCheck style=\"position: absolute;left: 50%; margin-left: -65px; top: 50%; margin-top: -15px; color: var(--secondry-color-red); font-size: 12px; font-style: italic;z-index:99\" ng-bind=vm.mediaErrorMessage></span><video autoplay id=videoElement class=transformnrotate width=480 height=360 muted onplaying=\"\" ng-class=\"{\'videoElement_selfie\': vm.readyToTakeSelfie}\"></video><div id=coverFace ng-class=\"vm.faceDetectionFound ? \'coverFaceGreen\' : \'coverFaceRed\'\" ng-if=!vm.readyToTakeSelfie></div><span class=text-center style=\"height: 60px;width:100%;z-index: 9999;position: absolute;bottom: 0;background-color: rgba(0,0,0,0.5)\" ng-if=vm.readyToTakeSelfie><div class=circle ng-click=vm.clickImage();></div></span></div><div id=imageContainer ng-if=vm.showImage style=display:flex;justify-content:center><span ng-if=vm.loading>Loading ...</span> <img ng-if=!vm.loading class=\"image-show transformnrotate-img\" ng-src={{vm.imageURL}}> <span class=text-center style=\"height: 60px;width:100%;z-index: 9999;position: absolute;bottom: 0;background-color: rgba(0,0,0,0.5)\" ng-if=\"vm.readyToTakeSelfie && vm.imageURL\"><div class=\"circle circle-icon\" ng-click=vm.captureAgain();><i class=\"fa fa-repeat fa-fw\" aria-hidden=true style=top:6px;position:relative></i></div></span></div><div class=text-center ng-if=\"!vm.faceDetectionFound && !vm.needPermission && vm.cameraCheck\"><i style=\"color: var(--secondry-color-red); font-size: 12px;font-style: normal; line-height: 19px\">Please ensure your face is within box and there is adequate light on your face.</i></div><div class=text-center ng-if=vm.apiErrorMsgStatus><i style=\"color: var(--secondry-color-red); font-size: 12px;font-style: normal; line-height: 19px\">{{vm.apiErrorMsg}}</i></div></div><div class=\"col-md-6 col-md-offset-6\" ng-if=\"!vm.needPermission && !vm.isSecondaryCamera\"><button class=\"btn btn-primary center-block\" ng-click=vm.clickImage(); ng-disabled=\"!vm.isActionEnable || vm.isSystemTooSlow || !vm.isCandidateProctored || vm.captured || !vm.speedTestStatus\" style=width:50% ng-if=\"!vm.captured && vm.isActionEnable\">Click a Selfie</button> <button class=\"btn btn-default center-block\" ng-click=vm.captureAgain(); style=width:50% ng-if=\"vm.captured && vm.isActionEnable\">Retake Selfie</button><!-- <button ng-if=\"!vm.isActionEnable && !vm.successMessage\" class=\"btn btn-info btn-start-practice\" ng-click=\"vm.sampleVideo();\" tabindex=\"-1\">\n            Record Sample Video <span data-ng-if=\"vm.startRecordingCounter\">(<span>{{vm.startRecordingCounter | formatTime : \'mins\'}}</span>)</span>\n        </button> --></div></div><div id=outerContainer ng-if=false><div><!--Audio--><div style=\"float:left;width:45%;text-align: left\" id=audioDiv><div style=\"height:45px;margin: 10px 0 0 10px\"><span id=cameraCompatibilityStatus></span> <i ng-class=\"vm.cameraCheck  ? \'fa fa-check-circle fa-lg icon-green\' : \'fa fa-times-circle fa-lg icon-red\'\"></i> <span class=\"bold_text text_color\">Camera</span></div><div id=innerContainer_desktop style=\"height:40px;margin: 10px 0 0 10px\"><div><span id=browserCompatibilityStatus></span> <i ng-class=\"vm.browserApproved ? \'fa fa-check-circle fa-lg icon-green\' : \'fa fa-times-circle fa-lg icon-red\'\"></i> <span class=\"bold_text text_color\">Browser</span></div></div><div id=innerContainer_mobile style=\"height:45px;margin: 10px 0 0 10px\"><span id=browserName_mobile></span> <span id=browserVersion_mobile>&nbsp;</span><p id=outdatedBrowser_mobile style=display:none><i class=\"fa fa-exclamation-triangle\" aria-hidden=true style=color:#F9975C;margin-top:4%;margin-left:5%></i> <span style=color:orange>Browser is outdated.</span></p></div><div style=\"height:34px;margin: 10px 0 0 10px\"><span id=audioCompatibilityStatus></span> <i ng-class=\"vm.micCheck ? \'fa fa-check-circle fa-lg icon-green\' : \'fa fa-times-circle fa-lg icon-red\'\"></i> <span class=\"bold_text text_color\">Microphone</span></div><div style=\"height:30px;margin:10px 0 0 10px\"><div class=pids-wrapper><span style=margin-right:4px>Input Volume:</span><div class=pid></div><div class=pid></div><div class=pid></div><div class=pid></div><div class=pid></div><div class=pid></div><div class=pid></div><div class=pid></div><div class=pid></div><div class=pid></div><div class=pid></div><div class=pid></div><div class=pid></div><div class=pid></div><div class=pid></div><div class=pid></div><div class=pid></div><div class=pid></div><div class=pid></div><div class=pid></div></div></div><!-- <div id=\"audio_container\" style=\"padding-left: 30px;\" ng-if=\"false\">\n                <div class=\"recordContainer\">\n                    <span id=\"audioAvailabilityStat\" style=\"display:none;font-weight:bold,color:red\"></span>\n                    <button type=\"button\" style=\"width:70px;\" id=\"audio-start-test\" ng-click=\"vm.startRecording();\" ng-if=\"vm.recordButton\">\n                        <i class=\"fa fa-microphone\" aria-hidden=\"true\"></i>\n                         Test\n                    </button>\n                    <button type=\"button\" style=\"width:70px;\" id=\"audio-stop-test\" ng-click=\"vm.stopRecording();\" ng-if=\"!vm.recordButton\">\n                        <i class=\"fa fa-stop\" aria-hidden=\"true\" style=\"color:red\"></i>\n                         Stop\n                    </button>\n                </div>\n                <div>\n                    <span id=\"stopWatch\" style=\"position:relative;top:6px\">\n                        <span id=\"sw_status\" style=\"color:green\"></span>\n                    </span>\n                </div>\n                <div class=\"audioClip\">\n                    <audio id=\"recorder\" controls=\"controls\" controlsList=\"nodownload\" ng-src=\"{{vm.trustSrc(vm.audsrc)}}\" ng-if=\"vm.audioRecordStarted\" style=\"width:180px;height:25px\">You browser does not support Html5 Audio Player</audio>\n                </div>\n            </div> --></div><!--Video--><div id=cameraDiv style=\"float:right;margin: 0px 0px 0 0;width: 45%\"><div id=camera_container><span id=cameraAvailabilityStat ng-if=!vm.cameraCheck style=\"position: absolute;left: 50%; margin-left: -65px; top: 50%; margin-top: -15px; color: var(--secondry-color-red); font-size: 12px; font-style: italic; z-index:99\">Camera is not Available!</span><video autoplay id=videoElement class=transformnrotate width=480 height=360 muted onplaying=\"\"></video><div id=coverFace ng-class=\"vm.faceDetectionFound ? \'coverFaceGreen\' : \'coverFaceRed\'\"></div></div><br></div></div></div><div class=\"modal-footer modal-footer-hirepro\" ng-if=false><div class=text-left style=padding:10px><strong id=messageModalNotification ng-if=\"!vm.isCandidateProctored && !vm.faceDetectionFound && vm.cameraCheck && vm.deviceType\" style=\"color: #ff5600;font-size: 16px\">- {{vm.message}} </strong><strong id=outdatedBrowser class=clearfix ng-if=!vm.browserApproved style=\"color: #ff5600;font-size: 16px\" ng-bind-html=vm.brwsrCompatibilityMsg></strong> <strong data-ng-if=vm.micMuted class=clearfix style=\"color: #ff5600;font-size: 16px\">- Please unmute your microphone. </strong><strong data-ng-if=vm.micLessSensitivity class=clearfix style=\"color: #ff5600;font-size: 16px\">- Please speak higher or set microphone level </strong><strong ng-if=\"vm.systemSpeedSlow && !vm.isActionEnable\"><span style=\"color: #ff5600;font-size: 16px\" ng-bind=vm.slowSystemMsg>Slow system detected </span><i class=\"fa fa-info-circle\" aria-hidden=true popover-placement=right-top popover-class=test-instruction-popover uib-popover-html=vm.slowSystemInstruction popover-trigger=\"\'mouseenter\'\" data-ng-if=\"vm.systemSpeed > 3\"></i> </strong><strong ng-if=vm.isSystemTooSlow><span style=\"color: #ff5600;font-size: 16px\" ng-bind=vm.slowSystemMsg>Slow system detected</span></strong></div><span class=\"btn btn-primary\" ng-click=vm.captureAgain() ng-if=vm.captured style=\"float: left\"><i class=\"fa fa-chevron-left\" aria-hidden=true></i> Go back for different selfie </span><span class=\"btn btn-primary\" ng-click=vm.savePersistance() ng-if=vm.captured>Continue <i class=\"fa fa-chevron-right\" aria-hidden=true></i></span><div ng-if=\"vm.isCandidateProctored && !vm.captured\" ng-class=\"{\'text-center\' : !vm.isActionEnable}\"><span ng-if=\"!vm.deviceType && vm.isActionEnable && !vm.isSystemTooSlow\">Take a selfie <span class=\"btn btn-primary\" type=button ng-click=vm.clickImage() title=\"Take a selfie\" style=\"padding: 4px 26px\"><i class=\"fa fa-camera fa-2x\" aria-hidden=true></i> </span></span><span ng-if=\"vm.deviceType && vm.isActionEnable && !vm.isSystemTooSlow\">Take a selfie <span class=\"btn btn-primary\" type=button ng-click=vm.clickImage() title=\"Take a selfie\" style=\"padding: 4px 26px\"><i class=\"fa fa-camera fa-2x\" aria-hidden=true></i> </span></span><button ng-if=\"!vm.isActionEnable && !vm.successMessage\" class=\"btn btn-info btn-start-practice\" ng-click=vm.sampleVideo(); tabindex=-1>Record Sample Video <span data-ng-if=vm.startRecordingCounter>(<span>{{vm.startRecordingCounter | formatTime : \'mins\'}}</span>)</span></button> <span ng-if=vm.errorMessage ng-bind=vm.errorMessage></span> <span ng-if=vm.successMessage ng-bind=vm.successMessage></span></div><span class=\"btn btn-primary\" type=button ng-if=vm.isCancelEnable ng-click=vm.close()>{{vm.cancel}}</span></div><div id=imageContainer ng-if=false><!-- ng-if=\"vm.showImage\" --><div class=image-show><span ng-if=vm.loading>Loading ...</span> <img class=transformnrotate ng-src={{vm.imageURL}} style=max-width:100%></div></div><img style=display:none ng-src={{vm.imgfile}} imageonload=vm.onImageLoad()>");
$templateCache.put("app/assessment/roomScan.tpl.html","<div class=row><div class=\"col-md-12 wizard-header\"><div class=wizard-heading>360<sup>o</sup> Room Scan</div><div>We need to record a 360<sup>o</sup> view of your room incuding your desk area</div></div></div><div class=\"container-fluid justify-content-center\" style=\"margin-top: 20px\"><div class=\"row justify-content-center\"><div ng-if=\" vm.toStartRecord && vm.defaultView\" class=\"col-md-12 text-center\">Please click \"<b>Scan My Room</b>\" to begin recording.</div><div ng-if=vm.toStopRecord class=\"col-md-12 text-center\">Recording has started. Please scan your room 360<sup>0</sup>.</div><div ng-if=vm.toRecordAgain class=\"col-md-12 text-center\">Does the recording show a 360<sup>o</sup> view including the desk?<br>If not, please click \"<b>Rescan My Room</b>\". If yes, please click \"<b>Next</b>\".</div><div ng-if=\"vm.startCountShow && !vm.defaultView\" class=\"col-md-12 text-center\">Your recording will start in <b>{{vm.countDownTimer}}</b> seconds.</div><div ng-if=\"vm.showendCountdown && !vm.defaultView\" class=\"col-md-12 text-center\">Your room\'s recording is complete. Your test will resume in <b>{{vm.countDownTimer}}</b></div><div class=\"col-md-6 col-md-offset-3 text-center\" style=padding-top:15px;padding-bottom:15px><!-- style=\"margin: 20px 0 20px 0;\" --><video height=240 width=320 id=roomScanVid autoplay muted onplaying=\"\" class=text-center preload=\"{{vm.recordedStream ? \'metadata\': false}}\" disablepictureinpicture controlslist=nodownload></video><!-- Recording icon | Recording time count --><div class=recording-icon-time-count style=left:18% ng-style=\"{ \'top\' : (vm.defaultView) ? \'10%\' : \'17%\' }\" ng-if=vm.toStopRecord><div class=recording-icon><i class=\"fa fa-dot-circle-o blink\" aria-hidden=true></i>&nbsp;Recording</div><div class=recording-time-count><span ng-bind=\"vm.recordingInterval | formatTime : \'mins\'\"></span></div></div></div><div class=\"col-md-12 text-center\" ng-if=vm.defaultView><button class=\"btn btn-danger center-block\" ng-click=vm.startRecording() ng-if=\" vm.toStartRecord\">Scan My Room</button> <button class=\"btn btn-default center-block\" ng-click=vm.stopRecording() ng-if=vm.toStopRecord>Stop Recording</button> <button class=\"btn btn-danger center-block\" ng-click=vm.reRecord() ng-if=vm.toRecordAgain>Rescan My Room</button></div></div></div>");
$templateCache.put("app/assessment/screenrecording.html","<div class=container style=\"margin-top: 10%\"><!-- Create Session --><div class=row style=\"margin-bottom: 50px\"><div class=col-sm-12><b style=font-size:20px>Screen Sharing Demo</b>&nbsp;&nbsp; <button name=shareScreen type=button class=btn ng-click=vm.createSession() style=border-radius:5px>Create session</button>&nbsp;&nbsp; <span ng-show=!!vm.createdSessionId><span class=\"label label-success\"><b>Session Created&nbsp;&nbsp;</b></span><!-- <span class=\"label label-info\" ng-bind=\"vm.createdSessionId\" style=\"font-weight:bold;\"></span> --> </span><span ng-show=!!vm.createdRoomId><span class=\"label label-warning\"><b>Room Created&nbsp;&nbsp;</b></span> <span class=\"label label-info\" ng-bind=vm.createdRoomId style=font-weight:bold></span></span></div></div><div ng-show=!vm.isScreenShared class=row><div class=col-sm-12><!-- Share Screen --><div class=row><div class=col-sm-12><div class=\"input-group margin-bottom-md\" id=createnow><span class=input-group-addon><i class=\"fa fa-users fa-1\"></i></span> <input class=form-control type=text placeholder=\"Insert a title for the session\" autocomplete=off ng-model=vm.sessionTitle ng-keyup=\"$event.keyCode == 13 && vm.shareScreen()\"> <span class=input-group-btn><button name=shareScreen type=button class=\"btn btn-primary\" ng-click=vm.shareScreen() style=\"padding: 6px 12px;border-top-left-radius: 0px;border-top-right-radius: 4px;border-bottom-left-radius: 0px;border-bottom-right-radius: 4px\">Share your screen</button></span></div></div></div><!-- Separator --><div class=row style=margin-top:15px;margin-bottom:15px><div class=col-sm-12><div class=separator><b>Or</b></div></div></div><!-- Join Screen --><div class=row><div class=col-sm-12><div class=\"input-group margin-bottom-md\"><span class=input-group-addon><i class=\"fa fa-play-circle-o fa-1\"></i></span> <input class=form-control type=text placeholder=\"Insert the numeric session identifier\" autocomplete=off ng-model=vm.roomId ng-keyup=\"$event.keyCode == 13 && vm.joinScreen()\"> <span class=input-group-btn><button name=joinScreen type=button class=\"btn btn-success\" autocomplete=off ng-click=vm.joinScreen() style=\"padding: 6px 12px;border-top-left-radius: 0px;border-top-right-radius: 4px;border-bottom-left-radius: 0px;border-bottom-right-radius: 4px\">Join an existing session</button></span></div></div></div></div></div><div class=row ng-show=vm.isScreenShared><div class=col-md-12><div class=\"panel panel-default\"><div class=panel-heading><h3 class=panel-title>Shared Screen <span class=\"label label-info\" ng-bind=vm.roomName></span> <span class=\"label label-success\" ng-bind=vm.roomId></span></h3></div><div class=panel-body id=screencapture><video class=\"rounded centered\" id=screenvideo width=100% height=100% autoplay playsinline=\"\"></video></div></div></div></div></div>");
$templateCache.put("app/assessment/secondaryCamera.tpl.html","<div class=row><div class=\"col-md-12 wizard-header\"><div class=wizard-heading>Room Camera Setup</div><div>This test requires a second camera to monitor your room</div></div></div><div class=\"row flex-row\"><div class=\"col-md-5 col-border col-padding text-center\"><img ng-src={{vm.qrCodeImage}} class=qrcode></div><div class=\"col-md-2 flex-col\"><div class=round-div><b>OR</b></div></div><div class=\"col-md-5 col-border col-padding\"><div class=heading>Following these steps on your mobile phone</div><ul class=second-camera-guide><li>Open Google Chrome</li><li>Go to <span class=\"bold-blue url-text-decoration\" ng-bind=vm.SecondCameraAppUrl></span></li><li>Enter Passcode <span class=bold-blue ng-if=!vm.isPassCodeExpire ng-bind=vm.passcode></span><div class=passcode-expiry-msg ng-if=\"vm.passcodeExpiryTime && !vm.isPassCodeExpire\">(Passcode will be expired after {{vm.passcodeExpiryTime}} seconds)</div><span class=\"btn btn-primary btn-slim-icon\" ng-if=vm.isPassCodeExpire ng-click=vm.getPairingCode()><i class=\"fa fa-repeat\" aria-hidden=true></i> &nbsp;Get new passcode</span></li><li>Complete Captcha Verification</li><li>Click next</li></ul></div><!-- <div class=\"col-md-12 col-border col-padding text-center\">\n        <img ng-src=\"{{vm.qrCodeImage}}\" class=\"qrcode\">\n    </div> --></div>");
$templateCache.put("app/assessment/secondaryCameraPassCodeVerification.html","<div class=\"row passcode-verification-container\"><div class=\"col-xs-12 passcode-validation-panel\"><div class=\"row passcode-verification-panel-header\"><h3 class=passcode-verification-panel-header-text>Online Proctoring Setup</h3></div><div class=login-panel-body><div class=login-label>Verification</div><form name=passcodeVerificationForm><div class=form-group><label>Enter Passcode</label><input type=text class=form-control placeholder=\"Enter passcode\" ng-model=vm.data.passcode name=passcode required ng-pattern=/^[0-9]*$/ ></div><div class=form-group ng-if=vm.tenantDetails.googleRecaptchaKey><label for=Captcha>Captcha</label><div vc-recaptcha key=vm.tenantDetails.googleRecaptchaKey ng-model=vm.data.googleRecaptchaResponse on-expire=vm.onCaptchaExpire() on-create=vm.setWidgetId(widgetId) required></div></div><button name=btnLogin ng-disabled=\"!passcodeVerificationForm.passcode.$valid || !vm.data.passcode\" ng-click=vm.verifyPasscode(); class=\"btn btn-primary login-button\">Next</button></form><div class=\"text-center passcode-verification-panel-error\" ng-if=vm.data.isPairingCodeExpired><p>Your passcode has been expired.</p></div></div></div></div>");
$templateCache.put("app/assessment/secondaryCameraPreview.tpl.html","<div class=row><div class=\"col-md-12 wizard-header\"><div class=wizard-heading>Room Camera Setup</div><div>This test requires a second camera to monitor your room</div></div></div><div class=row><div class=\"col-md-12 text-center\"><b>Room Camera Detected</b></div></div><div class=\"row flex-row justify-content-space-between\"><div class=\"col-md-5 col-border col-padding\"><ul class=second-camera-guide><li>rotate your phone in the landscape mode</li><li>Connect your phone to a power source</li><li>Place your phone on a stable phone stand</li><li>Ensure that you and your desk are fully visible</li></ul></div><div class=\"col-md-5 col-border col-padding\"><video autoplay id=secondCamPreviewVidElem class=secondCamPreview muted onplaying=\"\"></video></div></div>");
$templateCache.put("app/assessment/soundQualityCheck.tpl.html","<div class=row><div class=col-md-12><p style=font-size:18px;font-weight:700;color:#007EFC>Microphone Check</p><div class=\"text-center align-center sound-quality-check\" ng-if=\"!vm.isAnalyzed && !vm.isAnalyzing\"><!-- Recording Section --><div class=row style=\"margin-bottom: 15px\"><div class=col-md-12><span ng-if=\"vm.recordingStat === -1\">Please click the Mic button below</span><!-- <span ng-if=\"vm.recordingStat === 0\">The audio recording has started</span>\n                    <span ng-if=\"vm.recordingStat === 1\">The audio recording has stopped</span> --></div><!-- Mic Icon button --><div class=col-md-12 ng-class=\"{\'mic-recording\':vm.recordingStat === 0}\" style=\"margin-bottom: 30px\"><!-- ripple --><div ng-class=\"{\'ripple\':vm.recordingStat === 0}\" class=\"btn-circle circle-ripple\"></div><!-- Mic Button --><div class=\"btn-circle circle-mic\" ng-click=vm.startRecording()><i class=\"fa fa-microphone\"></i></div><!-- Progress brar --><div class=\"progress blue\"><span class=progress-left><span class=progress-bar ng-class=\"{\'progress-left-animate\':vm.recordingStat === 0}\"></span> </span><span class=progress-right><span class=progress-bar ng-class=\"{\'progress-right-animate\':vm.recordingStat === 0}\"></span></span></div></div><div class=\"col-md-12 recording-text-col\"><div class=recording-text ng-show=\"vm.recordingStat === 0\">Recording</div></div><div class=col-md-12 ng-show=\"vm.recordingStat === 0\"><div class=instruction-msg-bold>Please read out the numbers below in a normal voice</div><p class=text-to-read ng-bind=vm.textToRead><!-- 1 2 3 4&nbsp;&nbsp;1 2 3 4&nbsp;&nbsp;1 2 3 4 --></p></div></div><!-- Text to read --><!--  <div class=\"col-md-12\" ng-if=\"vm.recordingStat === 0\">\n                <div class=\"instruction-msg-bold\">\n                    Please read out the numbers below in a normal voice\n                </div>\n                <p class=\"text-to-read\">\n                    1,2,3,4&nbsp;1,2,3,4&nbsp;1,2,3,4\n                </p>\n            </div> --></div><div class=\"text-center align-center sound-quality-check\" ng-if=\"vm.isAnalyzing && !vm.isError\"><div class=col-md-12 ng-if=\"vm.recordingStat === 1\"><p><i class=\"fa fa-cog fa-spin fa-3x fa-fw spinning-gear\"></i></p><p>Please wait while we analyze your mic input</p></div></div><div class=\"text-center sound-quality-check\" ng-if=vm.isAnalyzed><!-- Analyzation Status --><div class=\"row result-analyze\"><div class=col-md-12><div ng-if=vm.isError><div class=error-msg>Something went wrong!</div><div>Please click Retry,and try speaking clearly</div><div class=\"btn btn-info\" ng-click=vm.retry()>Retry</div></div><div ng-if=vm.isCompatibleForTest><!-- <div class=\"success-msg\">Everything looks fine</div> --><div class=success-msg>Please review your audio playback</div><div><audio id=audioCheckPlayback class=audio-plain controls autoplay>Your browser does not support the audio element.</audio></div><div>Note: Please proceed forward only if your audio input is clear.<br>If your audio input is poor, then your test score can get affected.<br>If you think your audio input is clear,then click Proceed to test</div><div class=\"btn btn-info\" ng-click=vm.retry()>Try Again</div><!-- <div>Please click Next/Proceed to test</div> --></div><div ng-if=\"vm.isCompatibleForTest == false\"><div class=error-msg>Your mic input was not clear</div><div class=instruction-msg>Please click Retry, and try speaking clearly at a normal volume</div><div><audio id=audioCheckPlayback class=audio-plain controls autoplay>Your browser does not support the audio element.</audio></div><div class=\"btn btn-info\" ng-click=vm.retry()>Retry</div></div></div></div></div></div></div>");
$templateCache.put("app/assessment/startTest.html","<start-test></start-test>");
$templateCache.put("app/assessment/startTest.tpl.html","<div class=start-test-container><div class=container-fluid ng-if=\"vm.onlyProctoringTest === false\"><div class=row><div class=start-test-header><div class=container><div class=row><div class=\"col-md-8 start-test-welcome-text\"><span>Welcome <b><span ng-bind=vm.candidateName></span> <span ng-if=vm.candidateId>({{vm.candidateId}})</span></b><span ng-if=vm.questionPaper.tenantName> to the online assessment for <b ng-bind=vm.questionPaper.tenantName></b></span>.</span></div><div class=col-md-4><div class=form-group name=chkTermsPolicy ng-if=!vm.hideTermsAndConditions><label ng-if=\"vm.tenantAlias === \'accenture\' || vm.tenantAlias === \'accenturetest\'\" class=custom-checkbox style=color:#fff>I agree to the <a ng-click=\"vm.termsAndPrivacyPolicy(\'/s3_cached/hirepro-content/hirepro/static-resources/termsandconditions-accenture.html\', \'Terms Of Use\');\">Terms of Use </a><span ng-if=!vm.loginInfoConfig.isSecureBrowserMandatory>& <a ng-click=\"vm.termsAndPrivacyPolicy(\'https://www.accenture.com/in-en/about/privacy-policy\', \'Privacy Policy\');\">Privacy Policy </a></span><input type=checkbox id=termsChk ng-model=vm.isTermsAccepted> <span class=chk></span></label><label ng-if=\"vm.tenantAlias !== \'accenture\' && vm.tenantAlias !== \'accenturetest\'\" class=custom-checkbox style=color:#fff ng-if=false>I agree to the <a ng-click=\"vm.termsAndPrivacyPolicy(\'/s3_cached/hirepro-content/hirepro/static-resources/termsandconditions.html\', \'Terms Of Use\');\">Terms of Use </a><span ng-if=!vm.loginInfoConfig.isSecureBrowserMandatory>& <a ng-click=\"vm.termsAndPrivacyPolicy(vm.privacyPolicy, \'Privacy Policy\');\">Privacy Policy </a></span><input name=chkTermsPolicy type=checkbox id=termsChk ng-model=vm.isTermsAccepted> <span class=chk></span></label></div><button class=\"btn btn-success btn-lg btn-block squre-btn-corner\" name=btnStartTest ng-disabled=\"!vm.isTermsAccepted || vm.isScreenSharing\" ng-click=vm.checkLoadTestPrereq()>Start Test</button></div></div></div></div></div></div><div class=container ng-if=!vm.isThirdParty><div class=test-instruction-container><div class=row><div class=col-md-8><p style=font-weight:700>Please read the instructions carefully before you start the test.</p><basic-instruction question-paper=vm.questionPaper is-third-party=vm.isThirdParty></basic-instruction></div></div></div></div><div ng-include=\"\'app/template/default/onlyProctoringStartPage.tpl.html\'\" ng-if=vm.onlyProctoringTest style=height:100%></div></div>");
$templateCache.put("app/assessment/startTestOld.tpl.html","<div class=start-test-row ng-class=\"{\'appViewAngularMaterial\': vm.ApplicationViewType ===\'App-Angular-Material\'}\"><div class=\"col-md-7 company-info-span\" style=padding-right:0px><div class=test-details-panel><div class=\"panel-heading panel-heading-material\" style=\"padding-bottom: 0px;padding-top: 0px\"><div class=\"panel-heading panel-heading-material\"><img ng-src={{vm.companyLogoUrl}} alt=HirePro class=company-logo style=\"margin: 0px\"><h3 class=instruction-label ng-if=vm.testInstructions>Instructions</h3></div></div><div class=\"panel-body auto_overflow test-instruction-panel-body test-details-panel-body-heights\" ng-if=vm.testInstructions ng-bind-html=vm.testInstructions></div><div class=\"btn floating-fixed-button\" ng-if=vm.testInstructions ng-click=vm.scrollToStartTestPage() style=\"padding-right: 0px;padding-left: 10%\" fade-on-scroll>START&nbsp;&nbsp;TEST <i class=\"fa fa-angle-double-down\" aria-hidden=true style=position:relative;left:15%></i></div></div></div><div class=col-md-5 style=\"padding-left:0px;height:calc(100vh - 50px)\"><div class=test-instruction-panel ng-class=\"{\'test-instruction-panel-height\':vm.ApplicationViewType !==\'App-Angular-Material\'}\"><div class=\"panel-body auto_overflow\" ng-if=\"vm.testType === 1\"><b>1.</b>You can view the instructions anytime by mouse hover on the&nbsp;<img id=imgTestBtnInstruction src=assets/images/qInfo.png alt=\"\">&nbsp;icon.<br><br><b>2.</b>You cannot skip any question.<br><br><b>3.</b>You cannot go back to a previously attempted question.<br><br><b>4.</b>You can move to the next question (by clicking on the “Next” button) only after submitting a response.<br><!-- <img id=\"imgTestBtnInstruction\" src=\"assets/images/buttonimg.jpg\" alt=\"\">\r\n                <img id=\"imgTestFlagBtnInstruction\" src=\"assets/images/flagimg.jpg\" alt=\"\"> --><!-- <img src=\"assets/images/nextButton.png\" alt=\"\"> --><!-- <span style=\"color:white\">[1 / 9]</span> --><!-- <button class=\"btn btn-info btn-slim-icon\" title=\"Flag/UnFlag\" style=\"border-color:white;\">\r\n                    <i class=\"fa fa-flag nav-icon \" aria-hidden=\"true\"></i>\r\n                </button>\r\n                <button class=\"btn btn-info btn-slim-icon\" title=\"Previous Question\" style=\"border-color:white;\">\r\n                    <i class=\"fa fa-chevron-left nav-icon \"></i>\r\n                </button> --> <button class=\"btn btn-info btn-slim-icon\" style=margin-left:1px;border-color:white title=\"Next Question\"><i class=\"fa fa-chevron-right nav-icon\"></i></button><br><br><!-- <b>3.</b>You can directly go to any question by clicking on the question number appearing at the bottom left. --> <b>5.Blue Marked Question:</b> Question Attempted.<br>&nbsp;&nbsp;&nbsp;<b>White Marked Question:</b> Question Not Attempted.<br>&nbsp;&nbsp;&nbsp;<b>Red Marked Question:</b> Flagged Question.<br><!-- <img src=\"assets/images/navIndexButton.png\" alt=\"\"> --> <button class=\"btn btn-default btn-qindex btn-qindex-answered-default\">1</button> <button class=\"btn btn-default btn-qindex btn-qindex-flagged-default\">2</button> <button class=\"btn btn-default btn-qindex btn-qindex-unanswered-default\">3</button><br><!-- <b>4.</b>You can flag any question for the ease of attempting the same at a later point during the test. You can view the flagged question on click of the orange question buttons.\r\n                <br> --><br><!-- <b>5.</b>Please choose the programming language before attempting coding problems. --><!-- <br> --><!-- <br> --> <b>6.</b>You will be forced to leave the test, if you try to navigate anywhere from current test window/tab more than 2 times.<br><br><b>7.</b>Disable pop ups and Screen Saver, including software popup, anti-virus software popup, Outlook mail notification, Yahoo and Google Chat popup, etc.<br><br></div><div class=\"panel-body auto_overflow text-justify test-instruction-panel-body-height\" ng-if=\"vm.testType === 0\"><!-- style=\"margin-top:10%;\" --> <span ng-if=vm.isPracticeTestEnabled>Click <a href=javascript:void(0) ng-click=vm.startSampleTest()><b>here</b></a> to take a sample test.<br><br></span><ol class=app-instruction><li>You can view the instructions anytime by mouse hover on the \'i\' icon.</li><li>You can move to the next question or previous question by clicking on next or previous button.<div><!-- <img src=\"assets/images/nextPrevButton.png\" alt=\"\"> --><!-- <span style=\"color:white\">[1 / 9]</span> --> <button class=\"btn btn-info btn-slim-icon\" title=Flag/UnFlag style=border-color:white><i class=\"fa fa-flag nav-icon\" aria-hidden=true></i></button> <button class=\"btn btn-info btn-slim-icon\" title=\"Previous Question\" style=border-color:white><i class=\"fa fa-chevron-left nav-icon\"></i></button> <button class=\"btn btn-info btn-slim-icon\" style=margin-left:1px;border-color:white title=\"Next Question\"><i class=\"fa fa-chevron-right nav-icon\"></i></button></div></li><li>You can directly go to any question by clicking on the question number appearing at the bottom left.<div><!-- <img src=\"assets/images/navIndexButton.png\" alt=\"\"> --> <button class=\"btn btn-default btn-qindex btn-qindex-answered-default\">1</button> <button class=\"btn btn-default btn-qindex btn-qindex-flagged-default\">2</button> <button class=\"btn btn-default btn-qindex btn-qindex-unanswered-default\">3</button></div><ul><li>Blue Marked Question: Question Attempted.</li><li>Red Marked Question: Flagged Question.</li><li>White Marked Question: Question Not Attempted.</li></ul></li><!-- <li>Please choose the programming language before attempting coding problems.</li>\r\n                    <li>You can maximize or minimize coding window as per the requirement.</li>\r\n                    <li>Execute options have been provided to test your program.</li> --></ol></div></div><div style=\"display: flex;flex-wrap: wrap\" id=start-test-col><div class=\"checkbox terms-btn\"><label class=custom-chk-container style=\"padding-left: 0px\"><!-- <input type=\"checkbox\" style=\"margin-top:6px;\" ng-model=\"vm.isTermsAccepted\"> --><label class=custom-chk-label><input type=checkbox id=termsChk ng-model=vm.isTermsAccepted><label class=custom-chk for=termsChk></label><span style=color:#fff>I agree to the</span>&nbsp;</label></label><span class=terms-condition ng-click=vm.showTermsAndCondition()>Terms and Conditions</span></div><button name=btnStartTest ng-disabled=\"!vm.isTermsAccepted || vm.isScreenSharing\" ng-click=vm.checkLoadTestPrereq() type=button class=\"btn btn-primary btn-lg btn-block\">START&nbsp;&nbsp;TEST</button><!-- <button name=\"btnStartTest\" ng-disabled=\"!vm.isTermsAccepted || vm.isScreenSharing\" class=\"btn start-test-btn\" ng-click=\"vm.checkLoadTestPrereq()\">START&nbsp;&nbsp;TEST</button> --></div></div></div>");
$templateCache.put("app/assessment/submitConfirmation.tpl.html","<!-- <div class=\"start-test-row\" ng-class=\"{\'appViewAngularMaterial\': vm.ApplicationViewType ===\'App-Angular-Material\'}\" style=\"padding:0px;\" ng-style=\"{\'height\':\'{{vm.winHeight}}px\'}\">\n    <div class=\"col-md-7 submit-confirmation-left-panel\" style=\"padding-right:0px\">\n        <div class=\"test-details-panel\">\n            <div class=\"panel-heading panel-heading-material\">\n                <div class=\"panel-heading panel-heading-material\">\n                    <img ng-src=\"{{vm.companyLogoUrl}}\" alt=\"HirePro\" class=\"company-logo\" style=\"margin-left: 0px;\">\n                </div>\n                </div>\n                <div class=\"submit-confirmation-left-panel-body auto_overflow\">\n                    <p class=\"submit-confirmation-text text-green\">\n                        Thanks for attending the test.\n                    </p>\n                    <p class=\"submit-confirmation-text\" ng-if=\"vm.shortlistingStat === 0\">\n                        Congratulations you have <b class=\"text-green\">\"CLEARED\"</b> this Test.\n                    </p>\n                    <p class=\"submit-confirmation-text text-red\" ng-if=\"vm.shortlistingStat === 1\">\n                        Sorry, you were not able to clear this test.\n                    </p>\n                    <p ng-if=\"!vm.isAutoTestEnabled || vm.shortlistingStat === 1\" class=\"submit-confirmation-text\">\n                        It is now safe to close or navigate away from the current window\n                    </p>\n                    <div class=\"controls\" style=\"margin-top: 40px;\" ng-if=\"vm.isAutoTestEnabled\">\n                        <p style=\"color:#337ab7;\">You can start next test by clicking on \"Continue to Next Test\"</p>\n                        <button class=\"btn btn-info go-to-login-page-btn login-template-font-family btn-colored\" ng-click=\"vm.redirectToNextTest();\">Continue to Next Test</button>\n                    </div>\n                </div>\n            </div>\n        </div>\n        <div class=\"col-md-5 login-col-span submit-confirmation-right-panel\">\n            <div class=\"submit-confirmation-right-panel-body\">\n                <div>\n                    <span class=\"app-label font-color-white\">Online Assessment</span>\n                    <br>\n                    <span class=\"font-color-white\">powered by </span>\n                    <span class=\"font-color-white\" style=\"font-size: 1.2em;\">HirePro</span>\n                    <img src=\"assets/images/hirepro_logo_clip_art.png\" class=\"hirepro-logo-clip-art\" />\n            </div>\n                </div>\n            </div>\n        </div>\n --><div class=container><div class=row><div class=col-md-12 style=text-align:center ng-style=\"vm.submitCnfParams.isUnscorable && !vm.retestRequestSuccess && {\'margin-top\':\'25vh\'} || vm.newUIShow && {\'margin-top\':\'15vh\'} || {\'margin-top\':\'40vh\'}\"><div ng-if=\"!vm.isAutoTestEnabled && !vm.submitCnfParams.isUnscorable\"><p style=font-size:22px;color:var(--primary-color-blue);font-weight:700;line-height:22px><span ng-if=vm.submitCnfParams.data.isError><i class=\"fa fa-exclamation-triangle\" aria-hidden=true></i> <span ng-bind-html=vm.submitCnfParams.data.message></span> </span><span ng-if=!vm.submitCnfParams.data.isError>Thanks for attending the test.</span></p><p name=safeToCloseMsg style=line-height:19px ng-if=!vm.submitCnfParams.data.isError>It is now safe to close or navigate away from the current window.</p></div><div ng-if=\"vm.isAutoTestEnabled && !vm.submitCnfParams.isUnscorable && !vm.chainTestNewUI\"><p style=line-height:19px>Thanks for attending the test.</p><p name=nextTestMsg ng-bind-html=vm.nextTestMsg style=font-size:22px;font-weight:700;line-height:22px ng-style=\"{\'color\': vm.nextTestMsgColor}\">We have another test lined up for you.</p><p ng-if=\"vm.shortlistingStat === 0\" style=line-height:19px>Please click the button below to proceed</p><p ng-if=\"vm.shortlistingStat === 1\" style=line-height:19px>It is now safe to close or navigate away from the current window.</p></div><!-- new ui design configurable --><div ng-if=\"vm.isAutoTestEnabled && !vm.submitCnfParams.isUnscorable && vm.chainTestNewUI\"><p ng-if=\"vm.shortlistingStat === 0\" style=line-height:19px>Thanks for attending the previous test.</p><p name=nextTestMsg ng-bind-html=vm.nextTestMsg style=font-size:22px;font-weight:700;line-height:30px ng-style=\"{\'color\': vm.nextTestMsgColor}\"></p><p ng-if=\"vm.shortlistingStat === 0\" style=line-height:25px></p><div class=next-msg ng-if=vm.newUIShow>Congratulations! You have cleared Cognitive assessment and you qualify for “Communication Assessment”. You will be notified about the communication assessment schedule by e-mail.<br><br>You also have an option to participate in the “Technical assessment”. If you are interested in participating press \"Yes\". If you are not interested click the \"No\" button.<br><br>Note: Technical assessment is not an elimination round but scores of the technical assessment will be factored into the overall selection process score which will determine final selection.<br></div><p></p><p ng-if=\"vm.shortlistingStat === 1\" style=line-height:25px>It is now safe to close or navigate away from the current window.</p><p style=line-height:25px ng-if=vm.newUIShow><b>Would you like to take the next test?</b></p><div ng-if=vm.newUIShow><button name=btnStartNextTest class=\"btn btn-success btn-yes\" ng-click=vm.saveConsentForNextTest(true);>Yes, Take me to the next test</button> <button name=btnStartNextTest class=\"btn btn-default red-button\" ng-click=vm.saveConsentForNextTest(false);>No, i don\'t wish to take the next test</button></div><p></p></div><!-- -------------------- --><div ng-if=\"vm.showButton && !vm.newUIShow\"><button name=btnStartNextTest class=btn ng-class=\"vm.shortlistingStat === 0 ? \'btn-success\' : \'btn-primary\'\" ng-click=vm.redirectToNextTest();>Take me to next test</button></div><div ng-if=vm.submitCnfParams.isUnscorable><div ng-if=!vm.retestRequestSuccess><p style=font-size:22px;color:var(--primary-color-red);font-weight:700;line-height:22px><span><i class=\"fa fa-exclamation-triangle failed\" aria-hidden=true></i><h3 class=failed>The system could not score your test submission.</h3></span></p><div class=row><div class=col-md-4></div><div class=\"jumbotron col-md-4\" style=\"font-size:13px;padding: 10px;color: black\"><b>This can happen due to:</b><br>Poor/Unintelligible Pronunciation<br>Poor Quality Microphone<br>Too Much Background Noise</div><div class=col-md-4></div></div><p></p><p style=line-height:19px><b>Would you like to take the test again?</b></p><div><button name=btnStartNextTest class=\"btn btn-success\" ng-click=vm.retestRequest(true);>Yes, Request for Retest</button> <button name=btnStartNextTest class=\"btn btn-default\" ng-click=vm.retestRequest(false);>No, Don’t wish to Retest</button></div><p></p></div><div ng-if=vm.retestRequestSuccess><p><span style=font-size:20px;font-weight:700;line-height:18px;color:var(--primary-color-blue)>Your request for Retest has been received </span><span style=\"display: block;color: black;margin-top: 5px\">You will receive an email invitation in the next few hours.</span></p><p name=safeToCloseMsg style=line-height:19px>It is now safe to close or navigate away from the current window.</p></div></div></div></div></div>");
$templateCache.put("app/assessment/submitConfirmationPage.html","<submit-confirmation submit-cnf-params=vm.submitCnfParams></submit-confirmation>");
$templateCache.put("app/assessment/surroundNoiseCheck.tpl.html","<div class=row><div class=col-md-12><p style=font-size:18px;font-weight:700;color:#007EFC>Background Noise Check</p><div class=\"text-center noise-div\" ng-if=vm.countDownShow><div style=margin-bottom:10px><h4>Countdown Begin</h4><h2>{{vm.countDownTimer}}</h2><p>Be ready background noise check is going to start.</p></div></div><div class=\"text-center noise-div\" ng-if=\"vm.noiseCheckingInProcess && !vm.countDownShow && !vm.microphoneIsMuted\"><div style=margin-bottom:10px><h4>Please be very quiet.</h4><p>We need to check for background noise, if any</p></div><div><div class=noise-meter><div ng-class=\"{\'filled\': vm.noiseMeter >= 1}\"></div><div ng-class=\"{\'filled\': vm.noiseMeter >= 2}\"></div><div ng-class=\"{\'filled\': vm.noiseMeter >= 3}\"></div><div ng-class=\"{\'filled\': vm.noiseMeter >= 4}\"></div><div ng-class=\"{\'filled\': vm.noiseMeter >= 5}\"></div></div><p>Checking...</p></div></div><div class=\"text-center noise-div\" ng-if=vm.showNoiseBlocker><div style=margin-bottom:10px><h4>You have exceeded the maximum number of attempts.</h4><p>Please close your window, move to a quiet place or use high quality noise cancellation mic, and try again.</p></div></div><div class=\"text-center noise-div\" ng-if=vm.microphoneIsMuted><div style=margin-bottom:10px><h4 style=color:#FF6057>Please unmute the microphone and try again.</h4><p><button class=\"btn btn-default\" ng-click=vm.reStartRecording()><i class=\"fa fa-fw fa-repeat\" aria-hidden=true></i> Retry</button></p></div></div><div class=\"text-center noise-div\" ng-if=\"!vm.noiseCheckingInProcess && !vm.showNoiseBlocker\"><div style=margin-bottom:10px ng-if=\"vm.noiseCheckingSuccess && !vm.microphoneIsMuted\"><h4 style=color:#36B37E>Everything looks fine!</h4><p>Please click Next/Proceed to test.</p><div><audio id=noiseCheckPlayback class=audio-plain controls autoplay>Your browser does not support the audio element.</audio></div><p><button class=\"btn btn-default\" ng-click=vm.reStartRecording()><i class=\"fa fa-fw fa-repeat\" aria-hidden=true></i> Retry</button></p></div><div style=margin-bottom:10px ng-if=\"!vm.noiseCheckingSuccess && !vm.showNoiseBlocker\"><h4 style=color:#FF6057>Too much background noise</h4><p>Please move to a quiet place or use high quality noise cancellation mic, and try again.</p><div><audio id=noiseCheckPlayback class=audio-plain controls autoplay>Your browser does not support the audio element.</audio></div><p><button class=\"btn btn-default\" ng-click=vm.reStartRecording()><i class=\"fa fa-fw fa-repeat\" aria-hidden=true></i> Retry</button></p></div></div></div></div>");
$templateCache.put("app/assessment/test.html","<div class=test-body ng-class=\"{\'test-body-top50\': !vm.showSubHeader && vm.showHeader ,\'test-body-top0\': !vm.showHeader}\"><!-- Question Traverser --><div class=\"test-question-index-div collapse navbar-collapse\" ng-if=!vm.isThirdParty id=sideMenu><div class=\"nav navbar-nav\" style=margin:0px><question-indexes current-qindex=vm.currentQIndex mandat-q-collection=vm.questionPaper.mandatoryQuestionCollection></question-indexes></div></div><!-- Question Body--><div class=test-question-container ng-style=\"vm.isThirdParty && {\'margin-left\': \'0px\', \'padding\': \'0px 15px\', \'height\': \'100%\'}\"><!-- Q index | Marks | Group name | Section name --><div class=\"row q-header\" ng-init=\"vm.question = vm.questionPaper.mandatoryQuestionCollection[vm.currentQIndex]\" ng-include=\"\'app/template/default/questionHeader.tpl.html\'\" ng-if=!vm.isThirdParty></div><!-- Question Template as per question type--><div class=row><div class=\"col-md-12 q-template-style\"><question-template current-q-index=vm.currentQIndex question-paper=vm.questionPaper></question-template></div></div><!-- UnAnswer --><div class=row ng-if=\"!vm.isThirdParty && vm.questionPaper.mandatoryQuestionCollection[vm.currentQIndex].questionType !== 20\"><div class=col-md-12><answer-action-panel class=animate-show-hide question-paper=vm.questionPaper ng-show=vm.questionPaper.mandatoryQuestionCollection[vm.currentQIndex].isAnswered current-question=vm.questionPaper.mandatoryQuestionCollection[vm.currentQIndex]></answer-action-panel></div></div></div></div><!-- Next | Previous | End Test --><question-action-panel question-paper=vm.questionPaper current-question=vm.questionPaper.mandatoryQuestionCollection[vm.currentQIndex] ng-if=\"!vm.isThirdParty || vm.debugMode\"></question-action-panel>");
$templateCache.put("app/assessment/testLinkByEmail.html","<!-- <div class=\"row  style-testLink-candEmail-welcomenote\">\n    <div class=\"col-md-12\" style=\"color:#0e94c5;\">\n        <b>Dear Candidate,</b>\n        <br/> &nbsp;&nbsp;&nbsp;Welcome to Online Assessment Platform. Please fill your Email Id to proceed to next step of Assessment process.\n    </div>\n</div>\n<div class=\"row\" style=\"padding-left:14px;padding-right:14px;padding-top:1%;\">\n    <div class=\"col-md-12\">\n        <div class=\"panel panel-default panel-cand-email\">\n            <div class=\"panel-body \">\n                <div class=\"form-group \">\n                    <div class=\"input-group style-testLink-candEmail\">\n                        <div class=\"input-group-addon\" style=\"border:1px solid #419dec;border-right:0px;\">\n                            <i class=\"fa fa-envelope\" aria-hidden=\"true\" style=\"color:#0a77d4\"></i>\n                        </div>\n                        <input class=\"form-control\" name=\"email\" type=\"text\" style=\"height:3em;border:1px solid #2196F3;\" placeholder=\"example@domain.com\" ng-model=\"vm.candEmail\" ng-keyup=\"$event.keyCode == 13 && vm.getTestLinksByCandEmail()\" />\n                        <div class=\"input-group-addon\" style=\"background: #419dec;color:white;border: 1px solid #2196F3;\" ng-style=\"!vm.candEmail?{\'cursor\':\'not-allowed\'}:{\'cursor\':\'pointer\'}\" ng-click=\"vm.getTestLinksByCandEmail()\">\n                            Get Test Links\n                        </div>\n                    </div>\n                    <div class=\"email-error\" ng-if=\"vm.isError && vm.errorMessage !== \'\' \">{{vm.errorMessage}}</div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n<div class=\"row\" style=\"padding-left:14px;padding-right:14px;\">\n    <div class=\"col-md-12\">\n        <div class=\"panel panel-default test-link-panel\">\n            <div class=\"panel-body test-link-panel-body\">\n                <div class=\"row\" style=\"padding-left:14px;padding-top:1%;\" ng-repeat=\"testLink in vm.testLinks\">\n                    <div class=\"col-md-12\">\n                        <div class=\"form-group\">\n                            <div class=\"input-group style-testLink-candEmail\" style=\"cursor:pointer;padding-top:0px;\" ng-click=\"vm.startTest(testLink)\">\n                                <div class=\"input-group-addon\" style=\"border-right:0px;width: 10%;font-weight: bold;color: #0a77d4;\">\n                                    START TEST\n                                </div>\n                                <div class=\"form-control testLink-name-container\">\n                                    <span class=\"testLink-name\">{{testLink.testName}}</span>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n                <div ng-if=\"!vm.testLinks\" class=\"row\" style=\"padding-left:14px;padding-top:1%;\">\n                    <div class=\"col-md-12\">\n                        <h2 class=\"testlink-Stat-style\">{{vm.testLinkStat}}</h2>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div> --><div class=container><div class=row style=\"margin-top:50px;overflow:auto;height:calc(100vh - 50px)\"><div class=\"col-md-6 col-md-offset-3\"><h3>Get Assessment Link</h3><hr style=\"margin:20px -15px\"><p style=\"font-weight: 500\">Welcome to HirePro online assessments!</p><p style=\"font-weight: 500\">Please provide your registered Email ID to proceed further.</p><form class=row><div class=col-md-8><div class=form-group><label for=exampleInputEmail1>Email address</label><input name=candidateEmail type=email class=form-control id=exampleInputEmail1 placeholder=\"Enter email address\" ng-model=vm.candEmail ng-keyup=\"$event.keyCode == 13 && vm.getTestLinksByCandEmail()\"></div></div><div class=col-md-4><button name=submitCandidateEmail type=button class=\"btn btn-primary btn-mobile-block\" ng-click=vm.getTestLinksByCandEmail() style=margin-top:33px>Get Assessment Link</button></div></form><div style=margin-top:32px><p ng-if=!vm.candEmail class=text-center style=\"color:#919496; font-weight: 400; line-height: 30px\"><img style=\"height: 70px\" class=\"img-responsive center-block\" src=assets/images/get-link.png> Your test link will appear here</p><div ng-if=\"vm.testLinks && vm.testLinks.length > 0\"><p>You have <strong><span ng-bind=vm.testLinks.length>4</span></strong> tests assigned</p><div class=card ng-repeat=\"testLink in vm.testLinks\" style=margin-bottom:8px><div class=card-body style=\"display:flex;justify-content:space-between;padding:15px; font-weight: 500\"><div ng-bind=testLink.testName></div><button name=\"{{\'startTest\' + ($index+1)}}\" type=button class=\"btn btn-success\" ng-click=vm.startTest(testLink)>Start Test</button></div></div></div><div style=\"border-radius:3px;border:1px solid #c7c7c7;padding:15px;font-size:14px;color:#919496; font-weight: 400\" ng-if=\"vm.testLinks && vm.testLinks.length == 0 && vm.isError\"><div class=row><div class=col-md-3><img style=\"height: 60px\" class=\"img-responsive center-block\" src=assets/images/no-test-link.png></div><div class=col-md-9><p>No tests were found…..</p><p>Please make sure that your Email ID is the same as the one used for registration.</p><p>If you email ID is correct, then please contact your Test Administrator.</p></div></div></div><div ng-if=\"!vm.testLinks && vm.isError && vm.errorMessage\"><p ng-bind=vm.errorMessage></p></div></div></div></div></div>");
$templateCache.put("app/assessment/testLinkByEmailContainer.html","<test-link-by-email></test-link-by-email>");
$templateCache.put("app/assessment/userCameraElement.tpl.html","<!-- <div id=\"userPositionCheck\" class=\"mirror-container\" style=\"display: none;\">\n    <video id=\"vid-mirror\" class=\"mirror\" autoplay muted></video>\n</div> --><div class=\"alert alert-custom-danger\" id=userPositionCheck><div class=row><div class=\"col-sm-6 col-md-10 col-xs-7\"><p><i class=\"fa fa-exclamation-triangle\" aria-hidden=true></i> <span id=userCheckMsg>Please make sure you are visible in the camera</span></p></div><div class=\"col-sm-6 col-md-2 col-xs-5\"><div class=video-panel><video id=vid-mirror class=mirror autoplay muted></video></div></div></div></div>");
$templateCache.put("app/common/footer.tpl.html","<div class=footer-section style=z-index:10000 ng-class=\"{\'appViewAngularMaterial\': vm.ApplicationViewType ===\'App-Angular-Material\'}\"><div class=pull-right-material><p style=\"font-size:12px;padding-right: 10px;color:white;padding-top: 5px\">Copyright © <span ng-bind=vm.currentYear>2010</span> HiRePro. All rights reserved.</p></div></div>");
$templateCache.put("app/common/goToLogin.html","<div class=row ng-class=\"{\'appViewAngularMaterial\': vm.ApplicationViewType ===\'App-Angular-Material\'}\" style=margin:0px><div class=\"col-md-7 company-info-span\"><div class=\"panel-heading panel-heading-material\"><img src={{vm.companyLogoUrl}} alt=HirePro class=company-logo></div><div ng-if=vm.ogrUrl class=\"panel-body compant-url\" style=overflow:auto;height:40vh><iframe ng-src={{vm.ogrUrl}} style=width:100%;height:97%;border:0px></iframe></div></div><div class=\"col-md-5 login-col-span\" style=height:100vh><div class=gotologin-panel-body><div><span class=\"app-label font-color-white\">Online Assessment</span><!-- <br>\r\n                <span class=\"font-color-white\">powered by </span>\r\n                <span class=\"font-color-white\" style=\"font-size: 1.2em;\">HirePro</span>\r\n                <img src=\"assets/images/hirepro_logo_clip_art.png\" class=\"hirepro-logo-clip-art\" /> --></div><div class=\"controls gotologin-controls\"><button name=btnLogin ng-click=vm.gotologin() class=\"btn btn-default go-to-login-page-btn login-template-font-family\">Go To Login Page</button></div></div><browser-version></browser-version></div></div>");
$templateCache.put("app/common/header.tpl.html","<nav class=\"navbar navbar-inverse navbar-fixed-top\" ng-if=vm.showHeader><!-- ng-if=\"vm.currentState && vm.currentState != \'assess.login\' && vm.currentState != \'callBackVersant\' && vm.currentState != \'landing\'\" --><div class=container-fluid><div class=hp-navbar-header><a href=javascript:void(0) class=navbar-brand><img alt=HirePro ng-src={{vm.brandLogo}}></a><div ng-if=vm.showInstructions class=header-instruction-div><button class=\"btn btn-default header-instruction-btn center-block\" ng-click=vm.showBasicInstruction()><i class=\"fa fa-fw fa-question-circle\" aria-hidden=true></i> <span class=hidden-xs>Instructions</span></button></div><p ng-if=vm.showInTestCheatingWarning class=\"navbar-text text-bold\">Please note: Your video and audio is being recorded.It will be reviewed to check for integrity.</p><p ng-if=vm.showCandidateName class=\"navbar-text ng-binding pull-right hidden-xs\"><span ng-bind=vm.candidateName>Online Preview</span> <span ng-if=vm.candidateId>({{vm.candidateId}})</span></p></div></div></nav><div class=navbar-bottom ng-if=vm.showSubHeader><div class=navbar-inverse><button type=button class=\"navbar-toggle collapsed\" data-toggle=collapse data-target=\"\" aria-expanded=false style=margin:2px;float:left ng-click=vm.onMenuClick($event);><span class=sr-only>Toggle navigation</span> <span class=icon-bar></span> <span class=icon-bar></span> <span class=icon-bar></span></button></div><span class=\"visible-xs-inline index-text\">Index</span> <span class=clock><span class=hidden-xs>TIME LEFT:</span><div>{{(vm.util.timer.totalTestTime() - vm.util.timer._time) | formatTime}}</div></span></div><!-- chatting tool --><hp-chatting chat-user-id=vm.chatUserId ng-if=\"vm.currentState && vm.currentState != \'assess.login\' && vm.currentState != \'landing\' && vm.currentState != \'msgPage\' && vm.enableChatting && vm.showCandidateName\"></hp-chatting><!-- Face track :: No face detected :: Mirror to adjest face --><user-camera-element ng-if=vm.isVideoControlRequired></user-camera-element>");
$templateCache.put("app/common/main.html","<go-to-login></go-to-login>");
$templateCache.put("app/common/modalSubmitBtn.tpl.html","<button name=btnSubmit class=\"btn btn-info btn-slim inthemiddle\" style=\"font-size: 15px;line-height: 1.9;margin-right: 1%\" ng-disabled=\"!(vm.isAnswerMandatory ? vm.currentQuestion.isAnswered : true)\" ng-if=vm.isVisible ng-click=vm.submitTestResult()>Submit Test</button>{{}}");
$templateCache.put("app/common/submitBtn.tpl.html","<!-- <div class=\"row\">\n    <div class=\"col-md-12\">\n        <div class=\"middle\">\n            <button name=\"btnSubmit\" class=\"btn btn-slim inthemiddle btn-submit-margin red-btn\" ng-disabled=\"!(vm.isAnswerMandatory ? vm.currentQuestion.isAnswered : true)\" ng-if=\"vm.isVisible\" ng-click=\"vm.submitTestResult()\" ng-keypress=\"$event.preventDefault();\">End Test</button>\n        </div>\n    </div>\n</div> --><!-- <div class=\"side-index-bar btn-end-test\" ng-click=\"vm.submitTestResult()\">\n    <span class=\"side-index-font\">End Test</span>\n</div> --> <button class=\"btn btn-danger\" ng-if=vm.isVisible ng-disabled=\"vm.isDisabled || !(vm.isAnswerMandatory ? vm.currentQuestion.isAnswered : true)\" ng-click=vm.submitTestResult() ng-keypress=$event.preventDefault(); ng-style=\"vm.isSecureBrowserMandatory && {\'right\':\'100px\'}\">End Test</button>");
$templateCache.put("app/template/default/answerAction.tpl.html","<button class=\"btn btn-default btnUnanswer\" ng-if=\"vm.currentQuestion.questionType !== 16 && vm.currentQuestion.questionType !== 17\" ng-disabled=\"(!((vm.currentQuestion.selectedAns && vm.currentQuestion.selectedAns.length > 0) || vm.currentQuestion.isAnswered)) || vm.isDisabled\" ng-click=vm.unAnswerQuestion()><i class=\"fa fa-undo nav-icon unanswer-icon\" aria-hidden=true></i><span ng-if=\"vm.ApplicationViewType !== \'App-Angular-Material\'\">Unanswer</span></button>");
$templateCache.put("app/template/default/blockUiAjaxLoader.tpl.html","<div class=block-ui-overlay></div><div aria-live=assertive aria-atomic=true class=block-ui-message-container style=top:49%><!-- <img src=\"assets/images/2716372.gif\">\n    <div \n    style=\"font-weight: bold;\n    font-size: 1.1em;\n    margin-top: 10px;\">Please wait ...</div> --><div class=loading-container><svg class=spinner width=65px height=65px viewBox=\"0 0 66 66\" xmlns=http://www.w3.org/2000/svg><circle class=path fill=none stroke-width=6 stroke-linecap=round cx=33 cy=33 r=30></circle></svg></div></div>");
$templateCache.put("app/template/default/blockUiPlzWait.tpl.html","<div class=block-ui-overlay-material></div><div aria-live=assertive aria-atomic=true class=block-ui-message-container><div style=\"font-family: monospace\">Please wait ...</div></div>");
$templateCache.put("app/template/default/chat.tpl.html","<div class=\"floating-chat enter\" ng-class=\"{\'expand\': !vm.showIcon}\" ng-click=\"vm.showIcon && vm.openElement();\" ng-if=!vm.removeChat><i class=\"fa fa-comment\" aria-hidden=true ng-if=vm.showIcon></i><div class=chat ng-class=\"{\'enter\': !vm.showIcon}\"><div class=header><span class=title>Help </span><button><i class=\"fa fa-times\" aria-hidden=true ng-click=vm.closeElement(event);$event.stopPropagation();></i></button></div><div class=messages><ul class=message-list id=messages-list><li ng-repeat=\"msgObj in vm.chatList\" ng-class=\"msgObj.send ? \'self\' : \'other\'\"><p ng-bind-html=msgObj.msg></p><i ng-bind=\"msgObj.timeStamp | date: \'mediumTime\'\" class=text-right></i></li></ul></div><div class=footer><div class=text-box contenteditable=true disabled ng-keydown=vm.onMetaAndEnter($event);></div><!-- <textarea class=\"text-box\" ng-model=\"vm.newMessage\"></textarea> --> <button id=sendMessage ng-click=vm.sendNewMessage();><svg viewBox=\"0 0 24 24\" width=24px height=24px class=\"GfYBMd v6TC2e btnSendMsg\"><path d=\"M6.7,17.9v-3.7l4-1.8c0.4-0.2,0.4-0.7,0-0.9l-4-1.8V6.1L19.8,12L6.7,17.9z M23.7,11.5L5.4,3.3  c-0.1,0-0.1,0-0.2,0C5,3.3,4.7,3.5,4.7,3.8v5.9v4.8v5.9c0,0.3,0.2,0.5,0.5,0.5c0.1,0,0.1,0,0.2,0l18.3-8.2  C24.1,12.3,24.1,11.7,23.7,11.5z\"></path></svg></button></div></div></div>");
$templateCache.put("app/template/default/codingEditorSettings.tpl.html","<div class=popover style=min-width:300px;color:var(--themeHEX_background)><h3 class=popover-title><b>Configure</b></h3><div style=\"padding:10px 0px 10px 10px;width: 100%\"><table cellspacing=0 cellpadding=0 style=\"table-layout: fixed;width: 100%\"><tr style=\"padding-bottom: 4px\"><td style=width:24%>Theme</td><td style=\"width:76%;padding-bottom: 4px\"><div class=\"btn-group col-md-12\" ng-model=vm.userDefinedAceSettings.theme bs-radio-group><label class=\"btn btn-primary btn-info-active\" style=width:50%><input type=radio class=\"btn btn-info\" ng-change=vm.onaceEditorSettingsChange(); value=ace/theme/textmate>Light</label><label class=\"btn btn-primary btn-info-active\" style=width:50%><input type=radio class=\"btn btn-primary\" ng-change=vm.onaceEditorSettingsChange(); value=ace/theme/merbivore>Dark</label></div></td></tr><tr><td>Font Size</td><td><div class=col-md-12 style=\"padding-left:15px;padding-bottom: 4px\"><input class=\"btn btn-primary\" type=number ng-model=vm.userDefinedAceSettings.fontsize ng-change=vm.onaceEditorSettingsChange(); min=8 max=24 style=\"width: 51%;border-radius: 4px;border-style: groove\"></div></td></tr><tr ng-if=false><td>Editor Type</td><td><div class=\"btn-group col-md-12\" ng-model=vm.userDefinedAceSettings.keybinding bs-radio-group style=\"padding-bottom: 4px\"><label class=\"btn btn-primary btn-info-active\" style=width:33%><input type=radio class=\"btn btn-primary\" ng-change=vm.onaceEditorSettingsChange(); value=ace>Normal</label><label class=\"btn btn-primary btn-info-active\" style=width:33%><input type=radio class=\"btn btn-primary\" ng-change=vm.onaceEditorSettingsChange(); value=ace/keyboard/vim>Vim</label><label class=\"btn btn-primary btn-info-active\" style=width:33%><input type=radio class=\"btn btn-primary\" ng-change=vm.onaceEditorSettingsChange(); value=ace/keyboard/emacs>Emacs</label></div></td></tr><tr><td>Tab space</td><td><div class=\"btn-group col-md-12\" ng-model=vm.userDefinedAceSettings.tabSize bs-radio-group style=\"padding-bottom: 4px\"><label class=\"btn btn-info btn-info-active\" style=width:33.37%><input type=radio class=\"btn btn-info\" ng-change=vm.onaceEditorSettingsChange(); value=2>2</label><label class=\"btn btn-info btn-info-active\" style=width:33.37%><input type=radio class=\"btn btn-info\" ng-change=vm.onaceEditorSettingsChange(); value=4>4</label><label class=\"btn btn-info btn-info-active\" style=width:33.37%><input type=radio class=\"btn btn-info\" ng-change=vm.onaceEditorSettingsChange(); value=8>8</label></div></td></tr></table></div></div>");
$templateCache.put("app/template/default/codingExecution.tpl.html","<div class=\"row coding-execution-container padding-left-right\"><!-- Custom Input --><div class=\"col-md-4 border\" ng-if=\"vm.eveluationMode.customInput && vm.currentQuestion.evaluationMethodtype != 2\"><!-- Custom Input Checkbox --><dl class=custom-input-dl><dt style=float:left><input type=checkbox id=testAgainstCustomInput ng-model=vm.isCustomInputChecked ng-disabled=\"vm.disableCustomInput || !vm.currentQuestion.isAnswered\" ng-change=vm.clearCustomInput()></dt><dd><label for=testAgainstCustomInput ng-bind=vm.testAgainstInputLabel ng-class=\"{\'disabled\': vm.disableCustomInput || !vm.currentQuestion.isAnswered}\"></label></dd></dl><!-- Custom Input textArea--><div ng-if=\"vm.isCustomInputChecked && !vm.sqlTypeQuestion\"><textarea class=coding-custom-input-textarea ng-model=vm.customInputVal ng-disabled=vm.disableCustomInput rows=4 autocomplete=off autocorrect=off autocapitalize=off spellcheck=false data-gramm=false></textarea></div></div><!-- Upload Attachments --><div class=\"border uploadedAttachments-container\" ng-class=\"vm.currentQuestion.evaluationMethodtype == 2 ? \'col-md-12\' : \'col-md-7\'\" ng-style=\"{{vm.currentQuestion.evaluationMethodtype}} == 2 && {\'width\':\'100%\',\'padding-top\':\'15px\'}\" ng-if=vm.currentQuestion.isAnsAttachmentRequired><button class=\"btn btn-default upload-attachment-button\" ng-style=\"{{vm.currentQuestion.evaluationMethodtype}} == 2 && {\'width\':\'auto\'} \" title=\"Max: {{vm.allowedFileSize}} MB\" ng-disabled=\"!vm.currentQuestion.isAnswered || vm.isExecuting || !vm.isSwitchingFromCurrentQuestionEnable\" parent-to-child-bubling child-index=2><span ng-if=vm.isSwitchingFromCurrentQuestionEnable><i class=\"fa fa-paperclip\" aria-hidden=true></i> <span class=visibility>Upload Attachments</span> </span><span ng-if=!vm.isSwitchingFromCurrentQuestionEnable><img src=assets/images/upload.gif style=width:30px> <span class=visibility style=padding-left:2px>Uploading ...</span> </span><input type=file file-input on-upload=uploadRelatedFiles multiple ng-if=vm.isSwitchingFromCurrentQuestionEnable></button><div class=\"alert alert-info uploadedAttachments\" title=\"{{file | extractFileNameFromS3Path}}\" ng-repeat=\"file in vm.currentQuestion.ansFiles\"><span class=elipsis ng-bind=\"file | extractFileNameFromS3Path\"></span> <span ng-click=vm.removeUploadedFile($index) class=\"close uploadedAttachments-remove\" data-dismiss=alert aria-label=close>&times;</span></div></div></div><!-- Compile & Execute | Submit & Continue Coding --><div class=\"row padding-left-right compile-execute-button-container\" ng-if=\"vm.currentQuestion.evaluationMethodtype != 2\"><div class=col-md-5><!-- Compile & Execute --> <button class=\"btn btn-default btn-slim\" ng-if=vm.isButtonExecuteEnabled ng-disabled=\"(vm.isCustomInputChecked && !vm.customInputVal) || !vm.currentQuestion.isAnswered || vm.isExecuting\" ng-click=vm.execute(vm.isExecuteAgainstTestCases) ng-bind=vm.compileAndExecuteButtonLabel></button> <button class=\"btn btn-primary btn-slim\" ng-disabled=\"(vm.isCustomInputChecked && !vm.customInputVal) || !vm.currentQuestion.isAnswered || vm.isExecuting\" ng-click=vm.saveCode(); ng-if=\"vm.currentQuestion.evaluationMethodtype == 0\">Submit & Continue Coding</button></div><div class=col-md-7><!-- Loding gif && message --> <span><span ng-if=vm.isExecuting class=testCase-execution-loading-span><img src=assets/images/clock.gif style=\"width: 24px\"> Executing... </span><!-- Error Message --> <span ng-if=vm.isErrorOccured class=testCase-execution-loading-span><i class=\"fa fa-exclamation-triangle\" aria-hidden=true style=\"margin-right: 5px;color:#d47e00\"></i> <span ng-bind=vm.errorMsg class=color-red></span></span></span></div></div><!-- Coding Results --><div class=\"row padding-left-right execution-result-container\" ng-if=\"vm.isExecuted && vm.currentQuestion.evaluationMethodtype != 2\" scroll-me-up><div class=\"col-md-3 testcase-container tst-case-col-hight\" ng-if=\"!vm.isCompilationError && !vm.onlyCompilation\"><uib-tabset active=activePill vertical=true type=pills class=tc-tab><uib-tab index=$index ng-repeat=\"tcRslt in vm.tcRslts\" select=vm.showTcRslt(tcRslt)><uib-tab-heading><span ng-bind=\"\'Test Case \' + ($index + 1)\"></span> <span class=tc-stat-tags><span ng-if=!tcRslt.isSystem class=\"tc-stat color-blue-background\">Sample TC</span> <span ng-if=\"tcRslt.testCaseResult === \'Fail\'\" class=\"tc-stat color-red-background\">Fail</span> <span ng-if=\"tcRslt.testCaseResult === \'Pass\'\" class=\"tc-stat color-green-background\">Pass</span></span></uib-tab-heading></uib-tab></uib-tabset></div><div ng-class=\"(vm.isCompilationError || vm.onlyCompilation) ? \'col-md-12\' : \'col-md-9\'\" class=\"col-tc-rslt tst-case-col-hight\" id=testCaseContainer><div class=tc-rslt-container><!-- TestCase Stat--><div class=tc-rslt-stat-container ng-class=\"vm.tcRsltStat == \'Fail\'?\'tc-rslt-stat-container-fail\':\'tc-rslt-stat-container-pass\'\"><div><b>Result : </b><span ng-class=\"vm.tcRsltStat == \'Fail\'?\'color-red\':\'color-green\'\" ng-bind=vm.tcRsltReason></span></div><hr class=tc-rslt-stat-container-devider><div class=row><div class=col-md-4><b>Time (sec)</b></div><div class=col-md-4><b>Memory (KiB)</b></div><div class=col-md-4><b>Language</b></div></div><div class=row><div class=col-md-4 ng-bind=vm.time></div><div class=col-md-4 ng-bind=vm.memory></div><div class=col-md-4 ng-bind=vm.lang></div></div></div><!-- Compiler Message --><div><span>Compiler Message</span><pre ng-class=vm.compilationMessageColor ng-bind=vm.compilationMsg></pre></div><!-- Error Log --><div ng-if=vm.errorMsg><span>Error Log</span><pre class=color-red ng-bind=vm.errorMsg></pre></div><!-- Your Input --><div ng-if=vm.input ng-class=\"{\'disable-content\':vm.isSystem}\"><span>Input</span><pre ng-bind=vm.input></pre></div><!-- Your Output --><div ng-if=vm.yourOutput ng-class=\"{\'disable-content\':vm.isSystem}\"><span>Your Output</span><pre ng-bind=vm.yourOutput></pre></div><!-- Expected Output --><div ng-if=vm.expectedOutput ng-class=\"{\'disable-content\':vm.isSystem}\"><span>Expected Output</span><pre ng-bind=vm.expectedOutput></pre></div></div></div></div>");
$templateCache.put("app/template/default/drawio.tpl.html","<!-- <button class=\"btn btn-default\" ng-click=\"vm.saveDrawImage(fileUrls);\">\n	Save\n</button> --><div id=drawioIframeDiv><iframe ng-if=vm.drawioUrl id=drawioIframe class=ifrm-container src={{vm.drawioUrl}} bypassnavigationcheck=true></iframe></div>");
$templateCache.put("app/template/default/framework_ui_type_question.html","<div class=col-md-12><div class=\"panel panel-default coding-panel-default\" ng-class=\"vm.isExpanded ? \'expandElem\' : \'compressElem\'\"><div class=panel-heading style=\"padding-left: 10px;padding-top: 4px;line-height: 1.8; position: relative\"><!-- Languages --><!-- Select Library --><select class=\"form-control input-sm\" ng-if=!vm.data.hideLanguageSelection ng-change=vm.setLibrary() name=codingLang ng-model=vm.selectedLibrary ng-options=\"x for (x, y) in vm.urlList\" style=width:150px><option value=\"\">Select Library</option></select><!-- Upload Code as file | Select Lang | Expand editor | Editor settings --><div class=coding-editor-actions style=\"position: absolute; right: 0\"><!-- Expand | Shrink editor --> <span><button type=button class=\"btn btn-ghost\" ng-click=vm.toggleFullscreen()><i class=\"fa fa-expand\" aria-hidden=true ng-if=!vm.isExpanded title=Fullscreen></i> <i class=\"fa fa-compress\" aria-hidden=true ng-if=vm.isExpanded title=\"Exit Fullscreen\"></i></button> </span><!-- Editor Settings --> <span><button type=button class=\"btn btn-ghost\" data-animation=am-flip-x data-auto-close=1 bs-popover data-title=Configure placement=bottom-right viewport=\"{ selector: \'body\', padding: \'50px\' }\" data-template=app/template/default/codingEditorSettings.tpl.html title=Configure><i class=\"fa fa-cog\" aria-hidden=true></i></button></span></div></div><div class=panel-body style=\"padding:0px 15px\"><div class=row ng-if=vm.folderTreeView.isEnableFramework><div class=col-sm-2 style=\"padding:20px 0px\"><treecontrol class=tree-classic tree-model=vm.folderTreeView.data.children options=vm.folderTreeView.options on-selection=vm.folderTreeView.showSelected(node) expanded-nodes=vm.folderTreeView.expandedNodes selected-node=vm.folderTreeView.selected>{{node.label}}</treecontrol></div><div class=col-sm-10><div class=\"panel panel-default zero-margin-bottom\"><div class=\"panel-heading ui-control-header\">{{vm.selectedNode}}</div><div class=\"panel-body ui-control-body\" style=\"padding:0px 1px\"><div ui-ace=\"{\n                                    useWrapMode : true,\n                                    showPrintMargin:false,\n                                    showGutter: false,\n                                    theme: \'merbivore\',\n                                    onLoad: vm.onFrameworkAceLoad,\n                                    onChange: vm.onFrameworkAceChange,\n                                    displayIndentGuides: true,\n                                    highlightSelectedWord: true,\n                                    showLineNumbers:false,\n                                    require: [\'ace/ext/language_tools\'],\n                                    advanced: {\n                                        enableBasicAutocompletion: vm.codingAutocompleteEnabled,\n                                        enableLiveAutocompletion: vm.codingAutocompleteEnabled,\n                                        foldStyle: \'markbeginend\',\n                                        tabSize: 4\n                                    }\n                                }\" ng-readonly=false></div></div></div></div></div></div></div></div>");
$templateCache.put("app/template/default/js_ui_type_question.html","<div class=col-md-12><div class=\"panel panel-default coding-panel-default\" ng-class=\"vm.isExpanded ? \'expandElem\' : \'compressElem\'\"><div class=panel-heading style=\"padding-left: 10px;padding-top: 4px;line-height: 1.8\"><!-- Languages --><div class=\"btn-group btn-group-sm\" ng-model=vm.selectedControls bs-checkbox-group ng-click=vm.calculateWidthofColumn();><label class=\"btn btn-default\" ng-disabled=vm.isHtmlDisabled><input type=checkbox value=html ng-disabled=vm.isHtmlDisabled> HTML</label><label class=\"btn btn-default\" ng-disabled=vm.isJsDisabled><input type=checkbox value=js ng-disabled=vm.isJsDisabled> JS</label><label class=\"btn btn-default\" ng-disabled=vm.isCssDisabled><input type=checkbox value=css ng-disabled=vm.isCssDisabled> CSS</label><label class=\"btn btn-default\" ng-disabled=vm.isExpanded><input type=checkbox value=output ng-disabled=vm.isExpanded> Output</label></div><!-- Select Library --><select class=\"form-control input-sm\" ng-change=vm.setLibrary() name=codingLang ng-model=vm.selectedLibrary ng-options=\"x for (x, y) in vm.urlList\" style=width:150px><option value=\"\">Select Library</option></select><!-- Upload Code as file | Select Lang | Expand editor | Editor settings --><div class=coding-editor-actions><!-- Expand | Shrink editor --> <span><button type=button class=\"btn btn-ghost\" ng-click=vm.toggleFullscreen()><i class=\"fa fa-expand\" aria-hidden=true ng-if=!vm.isExpanded title=Fullscreen></i> <i class=\"fa fa-compress\" aria-hidden=true ng-if=vm.isExpanded title=\"Exit Fullscreen\"></i></button> </span><!-- Editor Settings --> <span><button type=button class=\"btn btn-ghost\" data-animation=am-flip-x data-auto-close=1 bs-popover data-title=Configure placement=bottom-right viewport=\"{ selector: \'body\', padding: \'50px\' }\" data-template=app/template/default/codingEditorSettings.tpl.html title=Configure><i class=\"fa fa-cog\" aria-hidden=true></i></button></span></div></div><div class=panel-body style=\"padding:0px 15px\"><div class=row><!-- HTML --><div ng-class=vm.codeColumnClass ng-show=vm.selectedControls.html style=padding:0px><div class=\"panel panel-default zero-margin-bottom\"><div class=\"panel-heading ui-control-header\">HTML</div><div class=\"panel-body ui-control-body\" style=\"padding:0px 1px\"><div ui-ace=\"{\n                                    useWrapMode : true,\n                                    showPrintMargin:false,\n                                    showGutter: false,\n                                    theme: \'merbivore\',\n                                    onLoad: vm.onAceLoadHTML,\n                                    onChange: vm.onAceChangeHTML,\n                                    displayIndentGuides: true,\n                                    highlightSelectedWord: true,\n                                    showLineNumbers:false,\n                                    require: [\'ace/ext/language_tools\'],\n                                    advanced: {\n                                        enableBasicAutocompletion: vm.codingAutocompleteEnabled,\n                                        enableLiveAutocompletion: vm.codingAutocompleteEnabled,\n                                        foldStyle: \'markbeginend\',\n                                        tabSize: 4\n                                    }\n                                }\" ng-readonly=false></div></div></div></div><!-- JS --><div ng-class=vm.codeColumnClass ng-show=vm.selectedControls.js style=padding:0px><div class=\"panel panel-default zero-margin-bottom\"><div class=\"panel-heading ui-control-header\">JS</div><div class=\"panel-body ui-control-body\" style=\"padding:0px 1px\"><div ui-ace=\"{\n                                    useWrapMode : true,\n                                    showPrintMargin:false,\n                                    showGutter: false,\n                                    theme: \'merbivore\',\n                                    onLoad: vm.onAceLoadJS,\n                                    onChange: vm.onAceChangeJS,\n                                    displayIndentGuides: true,\n                                    highlightSelectedWord: true,\n                                    showLineNumbers:false,\n                                    require: [\'ace/ext/language_tools\'],\n                                    advanced: {\n                                        enableBasicAutocompletion: vm.codingAutocompleteEnabled,\n                                        enableLiveAutocompletion: vm.codingAutocompleteEnabled,\n                                        foldStyle: \'markbeginend\',\n                                        tabSize: 4\n                                    }\n                                }\" ng-readonly=false></div></div></div></div><!-- CS --><div ng-class=vm.codeColumnClass ng-show=vm.selectedControls.css style=padding:0px><div class=\"panel panel-default zero-margin-bottom\"><div class=\"panel-heading ui-control-header\">CSS</div><div class=\"panel-body ui-control-body\" style=\"padding:0px 1px\"><div ui-ace=\"{\n                                    useWrapMode : true,\n                                    showPrintMargin:false,\n                                    showGutter: false,\n                                    theme: \'merbivore\',\n                                    onLoad: vm.onAceLoadCSS,\n                                    onChange: vm.onAceChangeCSS,\n                                    displayIndentGuides: true,\n                                    highlightSelectedWord: true,\n                                    require: [\'ace/ext/language_tools\'],\n                                    advanced: {\n                                        enableBasicAutocompletion: vm.codingAutocompleteEnabled,\n                                        enableLiveAutocompletion: vm.codingAutocompleteEnabled,\n                                        foldStyle: \'markbeginend\',\n                                        tabSize: 4\n                                    }\n                                }\" ng-readonly=false></div></div></div></div></div></div></div></div>");
$templateCache.put("app/template/default/onlyProctoringStartPage.tpl.html","<div class=container-fluid style=\"height: 100%\"><div class=row style=height:100%><div class=col-md-12 style=height:100%;display:flex;justify-content:center;align-items:center;flex-direction:column;text-align:center><h3>Please click the button below to start proctoring.</h3><button class=\"btn btn-success\" style=width:160px ng-click=vm.checkLoadTestPrereq()>Start Proctoring</button></div></div></div>");
$templateCache.put("app/template/default/question.coding.tpl.html","<!-- Question --><div class=row><div class=\"col-md-12 coding-question-div\"><span ng-bind-html=vm.trustedQString name=questionHtmlString></span></div></div><!-- Answer --><div class=row><div class=col-md-12><div class=\"panel panel-default coding-panel-default\" ng-class=\"vm.isExpanded ? \'expandElem\' : \'compressElem\'\"><div class=panel-heading><!-- Current Code | SUbmission History --><uib-tabset active=active vertical=false><!-- Current Code --><uib-tab select=vm.setActiveCodingTab(0) index=0 heading=\"Current Code\"></uib-tab><!-- SUbmission History --><uib-tab select=vm.setActiveCodingTab(1) index=1 heading=\"Previous Versions\" disable=vm.isExecuting ng-if=\"vm.question.evaluationMethodtype == 0\"></uib-tab><!-- Lang Doc --><uib-tab ng-if=vm.showHelpFileForCodingQuestion select=vm.setActiveCodingTab(2) index=2 heading=Docs disable=\"!vm.question.selectedLanguage || vm.isExecuting\"></uib-tab></uib-tabset><!-- Select Language --><div class=coding-lang-select><select ng-change=vm.setSnippet() name=codingLang ng-model=vm.question.selectedLanguage ng-options=\"option as option.languageText for option in vm.question.codingLangs\" ng-disabled=\"vm.isExecuting || vm.question.codingLangs.length === 1 || vm.showHistory || vm.showLangDoc\"><option value=\"\">Select Language</option></select></div><!-- Upload Code as file | Select Lang | Expand editor | Editor settings --><div class=coding-editor-actions><!-- Upload code via file --> <span ng-if=vm.isUploadCodeAsFileEnable><button class=\"btn btn-default upload-file-button\" ng-disabled=\"vm.isExecuting || !vm.question.selectedLanguage || vm.showHistory\" parent-to-child-bubling child-index=3><i class=\"fa fa-upload\" aria-hidden=true></i> <span class=visibility>Upload code via file</span> <input type=file file-input on-upload=readFile ng-disabled=!vm.question.selectedLanguage></button> </span><!-- Expand | Shrink editor --> <span><button type=button class=\"btn btn-ghost\" ng-click=vm.toggleFullscreen() ng-disabled=\"vm.isExecuting || vm.showHistory\"><i class=\"fa fa-expand\" aria-hidden=true ng-if=!vm.isExpanded title=Fullscreen></i> <i class=\"fa fa-compress\" aria-hidden=true ng-if=vm.isExpanded title=\"Exit Fullscreen\"></i></button> </span><!-- unanswer --> <span><button type=button class=\"btn btn-ghost\" ng-click=vm.unAnswerQuestionCoding() ng-disabled=\"vm.isExecuting || vm.showHistory || vm.showLangDoc\" title=Unanswer><!-- <i class=\"fa fa-undo\" aria-hidden=\"true\"></i> --> <i class=\"fa fa-eraser\" aria-hidden=true></i></button> </span><!-- Editor Settings --> <span><button type=button class=\"btn btn-ghost\" ng-disabled=\"vm.isExecuting || vm.showHistory || vm.showLangDoc\" data-animation=am-flip-x data-auto-close=1 bs-popover data-title=Configure placement=bottom-right viewport=\"{ selector: \'body\', padding: \'50px\' }\" data-template=app/template/default/codingEditorSettings.tpl.html title=Configure><i class=\"fa fa-cog\" aria-hidden=true></i></button></span></div></div><div class=panel-body><!-- Ace Editor --><div ng-show=vm.showEditor ui-ace=\"{\r\n                            showPrintMargin:false,\r\n                            showGutter: true,\r\n                            theme: \'textmate\',\r\n                            onLoad: vm.onAceLoad,\r\n                            onChange: vm.onAceChange,\r\n                            displayIndentGuides: true,\r\n                            highlightSelectedWord: true,\r\n                            advanced: {\r\n                                enableBasicAutocompletion: vm.codingAutocompleteEnabled,\r\n                                enableLiveAutocompletion: vm.codingAutocompleteEnabled,\r\n                                foldStyle: \'markbeginend\',\r\n                                tabSize: 4\r\n                            }\r\n                        }\" ng-readonly=!vm.question.selectedLanguage></div><!-- Submission History --><div ng-if=vm.showHistory style=padding:20px class=code-history-div><submit-answer-log question-id=vm.question.id load-answer=vm.loadPreviousAnswer(answer)></submit-answer-log></div><div ng-if=vm.showLangDoc class=coding-doc><!--sandbox=\"allow-scripts allow-same-origin\"--><iframe title=\"HirePro Online Assessment\" bypassnavigationcheck=true ng-src={{vm.langDocUrl}} ng-if=vm.langDocUrl id=iframeLanguageHelp sandbox=\"allow-scripts allow-same-origin\"></iframe><div ng-if=!vm.langDocUrl class=no-previous-v-found><img src=data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjQiIGhlaWdodD0iNDEiIHZpZXdCb3g9IjAgMCA2NCA0MSIgIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMCAxKSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgIDxlbGxpcHNlIGZpbGw9IiNGNUY1RjUiIGN4PSIzMiIgY3k9IjMzIiByeD0iMzIiIHJ5PSI3Ii8+CiAgICA8ZyBmaWxsLXJ1bGU9Im5vbnplcm8iIHN0cm9rZT0iI0Q5RDlEOSI+CiAgICAgIDxwYXRoIGQ9Ik01NSAxMi43Nkw0NC44NTQgMS4yNThDNDQuMzY3LjQ3NCA0My42NTYgMCA0Mi45MDcgMEgyMS4wOTNjLS43NDkgMC0xLjQ2LjQ3NC0xLjk0NyAxLjI1N0w5IDEyLjc2MVYyMmg0NnYtOS4yNHoiLz4KICAgICAgPHBhdGggZD0iTTQxLjYxMyAxNS45MzFjMC0xLjYwNS45OTQtMi45MyAyLjIyNy0yLjkzMUg1NXYxOC4xMzdDNTUgMzMuMjYgNTMuNjggMzUgNTIuMDUgMzVoLTQwLjFDMTAuMzIgMzUgOSAzMy4yNTkgOSAzMS4xMzdWMTNoMTEuMTZjMS4yMzMgMCAyLjIyNyAxLjMyMyAyLjIyNyAyLjkyOHYuMDIyYzAgMS42MDUgMS4wMDUgMi45MDEgMi4yMzcgMi45MDFoMTQuNzUyYzEuMjMyIDAgMi4yMzctMS4zMDggMi4yMzctMi45MTN2LS4wMDd6IiBmaWxsPSIjRkFGQUZBIi8+CiAgICA8L2c+CiAgPC9nPgo8L3N2Zz4K><div class=faded-text>No Documentation Found For The Selected Language</div></div></div></div></div></div></div><div class=\"row coding-execution\"><div class=col-md-12><coding-execution-panel current-question=vm.question editor-instance=vm.aceEditor is-accordian-open=vm.isAccordianOpen save-code-history=vm.saveCodeHistory() is-executing=vm.isExecuting ng-if=vm.showEditor></coding-execution-panel></div></div>");
$templateCache.put("app/template/default/question.dotIn.tpl.html","<div class=\"row dotin-row-panel-padding-top\"><div class=col-md-12 style=\"padding: 0px\"><iframe ng-src={{vm.questionpaper.mandatoryQuestionCollection[0].thirdPartyTestUrl}} id=dotinIframe ng-style=\"{\'height\':\'{{vm.panelHeight + 130}}px\', \'width\': \'100%\', \'border\': \'none\'}\"></iframe></div><!-- src: http://sandbox-careernet.dotin.us/user/survey/7f48257b-634a-4523-adbd-c6ada313b63b--></div><submit-button ng-hide=true current-question=vm.question></submit-button>");
$templateCache.put("app/template/default/question.drawio.tpl.html","<!-- Question --><div class=row><div class=col-md-12><span ng-bind-html=vm.trustedQString></span></div></div><!-- Answer --><div class=row><div class=col-md-12><div class=\"panel panel-default coding-panel-default drawIo\" ng-class=\"vm.isExpanded ? \'expandElem\' : \'compressElem\'\"><div class=panel-heading style=\"padding:5px 10px;line-height:1.9\">DrawIO<!-- Expand | Shrink editor --> <span><button type=button class=\"btn btn-ghost\" ng-click=vm.toggleFullscreen()><i class=\"fa fa-expand\" aria-hidden=true ng-if=!vm.isExpanded title=Fullscreen></i> <i class=\"fa fa-compress\" aria-hidden=true ng-if=vm.isExpanded title=\"Exit Fullscreen\"></i></button></span></div><div class=panel-body style=\"height:calc(100% - 41px)\"><draw-io question=vm.question attach-image=vm.attachImageToQuestion(fileUrls)></draw-io><!-- <iframe id=\"drawioIframe\" class=\"ifrm-container\" src=\"{{vm.drawioUrl}}\"></iframe> --></div></div></div></div>");
$templateCache.put("app/template/default/question.fillintheblank.tpl.html","<div class=row><div class=col-md-12><span ng-bind-html=vm.trustedQString id=spanFillInTheBlank name=questionHtmlString></span></div></div>");
$templateCache.put("app/template/default/question.html_css_js.tpl.html","<style>.c-ul {\n            border: 1px solid #abcdef;\n            border-width: 0px 0px 0px 1px;\n    }\n     .c-li {\n        background-color: transparent;\n    }\n    .c-liSelected {background-color: #fedbca}\n     /*.c-liSelected {background-color: #fedbca}*/\n     /*.c-iExpanded {border: 1px solid #77a}*/\n     /*.c-iCollapsed {border: 1px solid #7c7}*/\n     /*.c-iLeaf {border: 1px solid #a77}*/\n     treecontrol.tree-classic li .tree-label.c-label {color: #44c}\n     treecontrol.tree-classic li .tree-label.c-label.tree-unselectable {\n        color: rgb(131, 126, 126);\n     }\n     treecontrol.tree-classic li .tree-selected.c-labelSelected {background-color: yellow}</style><!-- Face track :: No face detected :: Mirror to adjest face --><user-camera-element question-paper=vm.questionpaper ng-if=vm.questionpaper.isVideoControlRequired></user-camera-element><!-- Question --><div class=row><div class=\"col-md-12 coding-question-div\"><span ng-bind-html=vm.trustedQString name=questionHtmlString></span></div></div><div ng-controller=\"HtmlEditorController as vm\"><!-- Editors & Controls --><div class=row><div class=col-sm-12 ng-if=\"vm.data.questionType[\'jsTypeQuestion\']\" ng-include=vm.data.templates.jsUiTypeQuestion></div><div class=col-sm-12 ng-if=\"vm.data.questionType[\'isFrameWorkTypeQuestion\']\" ng-include=vm.data.templates.frameworkUiTypeQuestion></div></div><!-- Execute & SUbmit --><div class=row><div class=col-md-12><!-- Execute --> <button class=\"btn btn-default btn-sm\" name=Execute value=Execute ng-click=vm.checkCode(); ng-disabled=!vm.question.isAnswered><b><span>Execute</span></b></button><!-- Submit & Continue --> <button class=\"btn btn-primary btn-sm\" name=Submit value=Submit ng-click=vm.submitCode(); ng-disabled=!vm.question.isAnswered><b><span>Submit & Continue Coding</span></b></button></div></div><!-- Submit --><div class=row style=margin-top:20px><div class=col-md-12 ng-show=vm.selectedControls.output><div class=\"panel panel-default zero-margin-bottom\"><div class=\"panel-heading ui-control-header\">Output</div><div class=panel-body style=\"padding:0px 1px\" ng-style=\"{\'height\':\'{{vm.aceEditorHeight}}px\'}\"><iframe class=ifrm-container ng-if=vm.showIframe id=resultFrame ng-src={{vm.outputUrl}} style=border:none ng-style=\"{\'height\':\'{{vm.aceEditorHeight}}px\'}\" bypassnavigationcheck=true></iframe></div></div></div></div></div>");
$templateCache.put("app/template/default/question.jupyterUi.tpl.html","<div class=row><div ng-if=\"vm.templateLayout!=\'horizontal\'\" class=\"row row-panel-padding-top sticky\"><fieldset class=col-md-12 ng-disabled=!vm.isSwitchingFromCurrentQuestionEnable><question-action-panel current-question=vm.question></question-action-panel></fieldset></div><div class=row ng-class=\"{\'row-panel-padding-top\':vm.templateLayout==\'horizontal\'}\"><user-camera-element question-paper=vm.questionpaper ng-if=vm.questionpaper.isVideoControlRequired></user-camera-element><div ng-class=\"vm.templateLayout==\'horizontal\' ? \'col-md-6\' : \'col-md-12\'\"><div class=row><fieldset class=col-md-12 ng-disabled=!vm.isSwitchingFromCurrentQuestionEnable><question-action-panel ng-if=\"vm.templateLayout==\'horizontal\'\" question-paper=vm.questionpaper current-question=vm.question ng-disabled=!vm.isSwitchingFromCurrentQuestionEnable></question-action-panel></fieldset><div class=col-md-12><div class=\"panel panel-default qa-panel-default auto_overflow_vertical\" ng-style=\"vm.templateLayout === \'horizontal\' && {\'height\':\'{{vm.panelHeight - 10}}px\'}\"><div class=\"panel-heading qa-panel-heading\"><span class=\"btn-expand btn-expand-q visibility\"><button class=\"btn btn-info btn-icon-expand\" title=\"{{vm.templateLayout==\'horizontal\' ? \'Expand\' : \'Reversed\'}}\" ng-disabled={{flase}} ng-click=vm.changeLayout()><i class=\"fa fa-arrows-alt nav-icon\" aria-hidden=true ng-show=\"vm.templateLayout==\'horizontal\'\"></i> <i class=\"fa fa-compress nav-icon\" aria-hidden=true ng-show=\"vm.templateLayout==\'vertical\'\"></i></button> </span><span><b class=panel-title>Q : {{ vm.parseInt(vm.currentqindex) + 1}} | <span ng-if=vm.isShowQMarksEnabled name=qCrctMrk>Mark:{{vm.question.correctMark}} </span></b><span class=instruction-icon style=float:right;padding-right:2px title={{vm.question.qInstruction}}><i class=\"fa fa-info-circle fa-lg\" aria-hidden=\"true \"></i></span></span></div><div class=panel-body oncontextmenu=\"return false\" style=\"overflow: auto\" ng-style=\"vm.templateLayout === \'horizontal\' && {\'max-height\':\'{{vm.qPanelBodyHeight}}px\',\'min-height\':\'{{vm.qPanelBodyHeight}}px\'}\"><span ng-bind-html=vm.trustedQString></span></div></div></div></div></div><div ng-class=\"vm.templateLayout==\'horizontal\' ? \'col-md-6\' : \'col-md-12\'\"><div class=row><!-- <answer-action-panel question-paper=\"vm.questionpaper\" current-question=\"vm.question\" editor-instance=\"vm.aceEditor\"></answer-action-panel> --><div class=col-md-12><div class=\"panel panel-default qa-panel-default\" ng-style=\"{\'height\':\'{{vm.panelHeight - 10}}px\'}\"><div class=\"panel-body auto_overflow coding-panel-body\" style=height:100%><iframe class=ifrm-container srcdoc={{vm.jupyterUi}} style=border:none ng-style=\"{\'max-height\':\'{{vm.aceEditorHeight}}px\',\'min-height\':\'{{vm.aceEditorHeight}}px\'}\"></iframe></div></div></div></div></div></div><!-- <div class=\"row\">\n        <div class=\"librarySelect\">\n            <button class=\"btn btn-default btn-sm\" name=\"Execute\" value=\"Execute\" ng-click=\"vm.checkCode();\">\n                <b><span>Execute</span></b>\n            </button>\n            <button class=\"btn btn-primary btn-sm\" name=\"Submit\" value=\"Submit\" ng-click=\"vm.submitCode();\">\n                <b><span>Submit</span></b>\n            </button>\n        </div>\n    </div> --><div id=codingAnswerPanel class=\"row qindex-row qindex-row-mcq\"><fieldset class=\"col-md-12 qindex-col\" ng-disabled=!vm.isSwitchingFromCurrentQuestionEnable><!-- <question-indexes current-qindex=\"vm.currentqindex\" mandat-q-collection=\"vm.questionpaper.mandatoryQuestionCollection\"></question-indexes> --></fieldset></div><submit-button current-question=vm.question></submit-button></div>");
$templateCache.put("app/template/default/question.mcq.tpl.html","<!-- Question --><div class=row><div class=col-md-12><span ng-bind-html=vm.trustedQString name=questionHtmlString></span></div></div><!-- Answer --><div class=row><div class=col-md-12><form><div id=questionOptions><div class=\"form-group ans-option-radio\" ng-repeat=\"option in vm.question.answerChoices\" ng-class=\"{\'ans-option-radio-checked\':option.choice && (vm.question.selectedAns==option.choice)}\"><label class=custom-radio><span ng-bind-html=option.htmlString></span> <input type=radio name=answerOptions value={{option.choice}} ng-model=vm.question.selectedAns ng-checked=\"{{option.choice && (vm.question.selectedAns==option.choice)}}\" ng-change=vm.onChecked()> <span class=cradio></span></label></div></div></form></div></div>");
$templateCache.put("app/template/default/question.multiplecorrectanswer.tpl.html","<!-- Question --><div class=row><div class=col-md-12><span ng-bind-html=vm.trustedQString name=questionHtmlString></span></div></div><!-- Answer --><div class=row><div class=col-md-12><form><!-- Multiple Answer --><div class=\"form-group ans-option-chk col-md-12\" ng-repeat=\"option in vm.question.answerChoices\" ng-class=\"{\'ans-option-radio-checked\':option.choice && (vm.question.selectedAns==option.choice)}\"><label class=custom-checkbox><span ng-bind-html=option.htmlString></span> <input name=optionSelected type=checkbox id=option{{$index}} value=option.choice ng-model=option.isSelected ng-checked=\"vm.question.selectedAns.indexOf(option.choice) > -1\" ng-change=vm.handleMultipleAnswers() ng-disabled=\"!(vm.question.selectedAns.indexOf(option.choice) > -1) && vm.question.selectedAns.length > 0 && vm.question.optionLimit === vm.question.selectedAns.length\"> <span class=chk></span></label></div></form></div></div>");
$templateCache.put("app/template/default/question.mvideo.tpl.html","<div class=row><div class=col-md-12 style=height:63vh;overflow:hidden;position:relative><div ng-if=!vm.isRecordingStopped class=\"font-size-small vid-ans-q\" ng-bind-html=vm.trustedQString name=questionHtmlString style=padding-bottom:260px></div><!-- After Recoding Cover Page --><div ng-if=vm.isRecordingStopped class=text-center style=position:absolute;bottom:50%;width:100%;color:#007EFC><div><i class=\"fa fa-4x fa-check-circle-o\" aria-hidden=true></i></div><div>Your video answer has been captured.</div><div ng-if=!vm.isCurrentQisLastQ>Proceed to Next Question</div></div></div></div><div style=position:fixed;bottom:42px;width:98%;left:1%><!-- Start Recording --> <button class=\"btn btn-danger btn-block\" ng-click=vm.startRecording(); ng-if=!vm.isRecordingStarted style=height:50px>Start now <span ng-if=\"vm.count > -1\" class=vid-ans-start-recording-time-count ng-class=\"vm.count > 9 ? \'double-digit-circle-padding\' : \'single-digit-circle-padding\'\"><b>{{vm.count}}</b></span></button><!--Stop Recording --> <button ng-if=\"vm.isRecordingStarted && !vm.isRecordingStopped\" class=\"btn btn-primary btn-block\" ng-click=vm.stopRecording(); style=height:50px><i class=\"fa fa-stop\" aria-hidden=true></i> Stop Recording</button></div><div style=position:fixed;bottom:14vh;width:100px;right:23.7% ng-show=vm.isRecordingStarted><video id=recording-video autoplay muted ng-show=!vm.isRecordingStopped style=height:165px;background:transparent></video></div>");
$templateCache.put("app/template/default/question.onlyProctoringTestPage.tpl.html","<div class=row style=margin-bottom:0px><div class=col-md-12 style=\"padding: 0px\"><div style=\"height:calc(100vh - 50px);display:flex;justify-content:center;align-items:center;flex-direction:column;text-align:center\"><h3>Proctoring has started. You can now go to your test application.</h3><p ng-if=!vm.thirdpartyproctoring style=\"margin: 0 0 48px 0\">Once you are done with the test, please remember to come back and click Stop Proctoring</p><div class=row><div ng-class=\"{\'col-md-6\': vm.thirdpartyTestLinkLaunched, \'col-md-12\': !vm.thirdpartyTestLinkLaunched}\" ng-if=!vm.thirdpartyproctoring><button class=\"btn btn-success\" style=width:160px ng-click=vm.openThirdPartyLinkAgain();>Launch Test</button></div><div class=col-md-6 ng-if=\"!vm.thirdpartyproctoring && vm.thirdpartyTestLinkLaunched\"><button class=\"btn btn-danger\" style=width:200px ng-click=vm.endOnlyProctoringTest();>Stop Proctoring & End Test</button></div></div><p class=text-danger style=\"margin-top: 28px\">Please DO NOT close this window until you are done with the test.</p></div></div></div>");
$templateCache.put("app/template/default/question.psychometric.tpl.html","<!-- Question --><div class=row><div class=col-md-12><span ng-bind-html=vm.trustedQString name=questionHtmlString></span></div></div><!-- Answer --><div class=row><!-- checked option count [In case of multiple answer] --><div class=col-md-12 ng-if=\"vm.question.optionLimit > 0\"><span>Please select <b>{{vm.question.optionLimit}}</b> options: <b>{{vm.question.selectedAns.length}}</b> of <b>{{vm.question.optionLimit}}</b> selected</span></div><div class=col-md-12><form><!-- Single Answer --><div class=\"form-group ans-option-radio\" ng-if=!vm.question.config.IsMultipleAnswer ng-repeat=\"option in vm.question.answerChoices\" ng-class=\"{\'ans-option-radio-checked\':option.choice && (vm.question.selectedAns==option.choice)}\"><label class=custom-radio><span ng-bind-html=option.htmlString></span> <input type=radio name=answerOptions value={{option.choice}} ng-model=vm.question.selectedAns ng-checked=\"{{option.choice && (vm.question.selectedAns==option.choice)}}\" ng-change=vm.onChecked()> <span class=cradio></span></label></div><!-- Multiple Answer --><div class=\"form-group ans-option-chk col-md-2\" ng-if=vm.question.config.IsMultipleAnswer ng-repeat=\"option in vm.question.answerChoices\" ng-class=\"{\'ans-option-radio-checked\':option.choice && (vm.question.selectedAns==option.choice)}\"><label class=custom-checkbox><span ng-bind-html=option.htmlString></span> <input name=optionSelected type=checkbox id=option{{$index}} value=option.choice ng-model=option.isSelected ng-checked=\"vm.question.selectedAns.indexOf(option.choice) > -1\" ng-change=vm.handleMultipleAnswers() ng-disabled=\"!(vm.question.selectedAns.indexOf(option.choice) > -1) && vm.question.selectedAns.length > 0 && vm.question.optionLimit === vm.question.selectedAns.length\"> <span class=chk></span></label></div></form></div></div>");
$templateCache.put("app/template/default/question.qa.tpl.html","<!-- Question --><div class=row><div class=col-md-12><span ng-bind-html=vm.trustedQString name=questionHtmlString></span></div></div><!-- Answer --><div class=row><div class=col-md-12><div class=\"panel panel-default qa-panel-default\" ng-if=\"!vm.question.qaControls || vm.question.qaControls.text\"><div class=panel-heading><span>Write your answer here</span> <span ng-if=vm.isPlainTextEnabled style=float:right>Word Count: <b>{{vm.question.qaWordCount}}</b></span></div><div class=panel-body><textarea ng-if=vm.isPlainTextEnabled name=qaTextArea class=qa-textarea ng-model=vm.question.selectedAns ng-change=vm.onTextareaChange() ng-model-options=\"{ debounce: 10 }\" ng-cut=$event.preventDefault() ng-copy=$event.preventDefault() ng-paste=$event.preventDefault() autocomplete=off autocorrect=off autocapitalize=off spellcheck=false data-gramm=false autofocus>\r\n                </textarea><textarea ng-if=!vm.isPlainTextEnabled ckeditor=\"{language: \'en\',allowedContent: true,entities: false,toolbarGroups:[\r\n                { name: \'document\', groups: [\'mode\', \'document\', \'doctools\'] },\r\n                { name: \'clipboard\', groups: [\'clipboard\', \'undo\'] },\r\n                { name: \'editing\', groups: [\'find\', \'selection\', \'spellchecker\', \'editing\'] },\r\n                { name: \'forms\', groups: [\'forms\'] },\r\n                { name: \'basicstyles\', groups: [\'basicstyles\', \'cleanup\'] },\r\n                { name: \'paragraph\', groups: [\'list\', \'indent\', \'blocks\', \'align\', \'bidi\', \'paragraph\'] },\r\n                { name: \'links\', groups: [\'links\'] },\r\n                { name: \'insert\', groups: [\'insert\'] },\r\n                { name: \'styles\', groups: [\'styles\'] },\r\n                { name: \'colors\', groups: [\'colors\'] },\r\n                { name: \'tools\', groups: [\'tools\'] },\r\n                { name: \'others\', groups: [\'others\'] },\r\n                { name: \'about\', groups: [\'about\'] }\r\n            ],removeButtons:\'Source,Save,NewPage,ExportPdf,Preview,Print,Templates,Cut,Copy,Paste,PasteText,PasteFromWord,Undo,Redo,Find,Replace,Scayt,SelectAll,Form,Checkbox,Radio,TextField,Textarea,Select,Button,ImageButton,HiddenField,CopyFormatting,RemoveFormat,Blockquote,CreateDiv,BidiLtr,BidiRtl,Language,Link,Unlink,Anchor,Image,Flash,Smiley,PageBreak,Iframe,Styles,ShowBlocks,About\'}\" ng-model=vm.question.selectedAns></textarea></div></div></div></div><upload-capture ng-if=vm.question.qaControls json-answer=vm.question.jAns control-list=vm.question.qaControls is-answered=vm.question.isAnswered call-back=vm.uploadCaptureCallback()></upload-capture><div class=\"row upload-attachment-row\" ng-if=vm.question.isAnsAttachmentRequired><div class=\"col-md-2 upload-attachment-button-container\"><button class=\"btn btn-default btn-block upload-attachment-button\" parent-to-child-bubling child-index=3 ng-if=vm.isSwitchingFromCurrentQuestionEnable title=\"Max: {{vm.allowedFileSize}} MB\"><i class=\"fa fa-paperclip\" aria-hidden=true></i> <span class=visibility>Upload Attachments</span> <input type=file file-input on-upload=uploadRelatedFiles multiple></button> <button class=\"btn btn-default btn-block upload-attachment-button btn-uloading btn-colored\" parent-to-child-bubling child-index=3 ng-if=!vm.isSwitchingFromCurrentQuestionEnable title=\"Please wait,While uploading file\"><img src=assets/images/upload.gif style=width:30px> <span class=visibility style=padding-left:2px>Uploading ...</span></button></div><div class=\"col-md-10 uploadedAttachments-container flex-wrap-container\"><div class=\"alert alert-info col-md-1 uploadedAttachments\" title=\"{{file | extractFileNameFromS3Path}}\" ng-repeat=\"file in vm.question.ansFiles\"><span class=elipsis ng-bind=\"file | extractFileNameFromS3Path\"></span> <span ng-click=vm.removeUploadedFile($index) class=\"close uploadedAttachments-remove\" data-dismiss=alert aria-label=close>&times;</span></div></div></div>");
$templateCache.put("app/template/default/question.referencetocontext.tpl.html","<!-- Question --><div class=row><div class=col-md-12><b ng-if=false>Passage:</b><div ng-bind-html=vm.question.parentHtmlString name=questionParentHtmlString></div><b>Question:</b><div ng-bind-html=vm.trustedQString name=questionHtmlString></div></div></div><!-- Answer --><div class=row><div class=col-md-12><form><div id=questionOptions><div class=\"form-group ans-option-radio\" ng-repeat=\"option in vm.question.answerChoices\" ng-class=\"{\'ans-option-radio-checked\':option.choice && (vm.question.selectedAns==option.choice)}\"><label class=custom-radio><span ng-bind-html=option.htmlString></span> <input type=radio name=answerOptions value={{option.choice}} ng-model=vm.question.selectedAns ng-checked=\"{{option.choice && (vm.question.selectedAns==option.choice)}}\" ng-change=vm.onChecked()> <span class=cradio></span></label></div></div></form></div></div>");
$templateCache.put("app/template/default/question.thirdPartyTest.tpl.html","<div class=row style=margin-bottom:0px><!--Added inline css, for 1 screen in pearson, pearson logo is being cut--><div class=col-md-12 style=\"padding: 0px\"><iframe id=thirdPartyIframe style=width:100%;border:none ng-src={{vm.question.thirdPartyTestUrl}} allow=\"camera; microphone\" ng-style=\"{\'width\': \'100%\', \'border\': \'none\'}\" bypassnavigationcheck=true ng-class=\"{ \'thirdPartyTest-secureBrowser-iframe-height\': vm.isSecureBrowserMandatoryTest, \'thirdPartyTest-nonSecureBrowser-iframe-height\': !vm.isSecureBrowserMandatoryTest }\"></iframe></div></div>");
$templateCache.put("app/template/default/question.typing.tpl.html","<div class=row><div class=col-md-12><typing-test question=vm.question call-back=vm.typingHandleAnswer()></typing-test></div></div>");
$templateCache.put("app/template/default/question.video.tpl.html","<div class=row><div class=\"col-md-4 video-answer-col\"><div class=\"font-size-small vid-ans-q\" ng-bind-html=vm.trustedQString name=questionHtmlString></div></div><div class=\"col-md-8 video-answer-col\"><div class=video-answer><div class=vid-ans-header-txt>Your answer will be recorded here</div><div class=vid-ans-recording-icon ng-if=\"vm.isRecordingStarted && !vm.isRecordingStopped\"><i class=\"fa fa-dot-circle-o blink\" aria-hidden=true></i> Recording</div><div class=video-elem ng-class=\"{\'video-elem-top\':vm.isRecordingStarted,\'video-elem-top-zero\':vm.isRecordingStopped}\"><video id=recording-video autoplay muted></video></div><!-- Start recording --><div class=btn-vid-ans-recording-container ng-if=!vm.isRecordingStarted><div>Start recording your answer</div><button class=\"btn btn-danger btn-vid-ans-start-recording\" ng-click=vm.startRecording();>Start now <span ng-if=\"vm.count > -1\" class=vid-ans-start-recording-time-count ng-class=\"vm.count > 9 ? \'double-digit-circle-padding\' : \'single-digit-circle-padding\'\"><b>{{vm.count}}</b></span></button><div></div></div><!--Stop Recording --><div ng-if=\"vm.isRecordingStarted && !vm.isRecordingStopped\" class=btn-vid-ans-stop-recording><button class=\"btn btn-primary\" ng-click=vm.stopRecording();><i class=\"fa fa-stop\" aria-hidden=true></i> Stop Recording</button></div><!-- After Recoding Cover Page --><div class=vid-ans-cover ng-class=\"{\'vid-ans-cover-visible\':vm.isRecordingStopped}\"><div><i class=\"fa fa-check-circle-o\" aria-hidden=true></i></div><div>Your video answer has been captured.</div><div ng-if=!vm.isCurrentQisLastQ>Proceed to Next Question</div></div></div></div></div>");
$templateCache.put("app/template/default/questionAction.tpl.html","<div class=bottom-action-bar ng-style=\"vm.isSecureBrowserMandatory && {\'margin-bottom\':\'30px\'}\"><submit-button current-question=vm.currentQuestion name=btnEndTest></submit-button><div class=\"center-block text-center\"><button class=\"btn btn-secondry-success-ghost\" ng-if=\"vm.currentQuestion.questionType != 17 && !vm.isAnswerMandatory\" ng-disabled=!vm.isQBackwardNavAllowed ng-click=vm.moveToPrevQuestion() name=btnPreviousQuestion><i class=\"fa fa-chevron-left visible-xs-inline\" aria-hidden=true></i> <span class=hidden-xs>Previous Question</span></button> <button class=\"btn btn-secondry-success\" ng-disabled=\"vm.isDisabled || (vm.isAnswerMandatory ? (!vm.currentQuestion.isAnswered || vm.isLastIndex): vm.isLastIndex)\" ng-click=vm.moveToNextQuestion() name=btnNextQuestion><i class=\"fa fa-chevron-right visible-xs-inline\" aria-hidden=true></i> <span class=hidden-xs>Next Question</span></button></div></div>");
$templateCache.put("app/template/default/questionAnswerAction.tpl.html","<div class=col-md-12><div class=\"panel panel-default question-navigation-panel\"><div class=\"panel-body question-navigation-panel-body\"><div class=controls><span><span name=btnUnanswer style=\"margin-left:44%;visibility: hidden\" class=\"btn btn-info btn-slim-icon\" ng-disabled=\"!((vm.currentQuestion.selectedAns && vm.currentQuestion.selectedAns.length > 0) || vm.currentQuestion.isAnswered)\" ng-click=vm.unAnswerQuestion()><i class=\"fa fa-undo nav-icon unanswer-icon\" aria-hidden=true></i>Unanswer </span><span style=float:right><b name=currentTotalq style=color:#31708f>{{vm.currentQuestionIndex}} / {{vm.totalQuestionCount}}</b> <button name=btnPrev class=\"btn btn-info btn-slim-icon\" ng-if=!vm.isAnswerMandatory ng-disabled=vm.isFirstQIndex ng-click=vm.moveToPrevQuestion()><i class=\"fa fa-chevron-left nav-icon\"></i></button> <button name=btnNext class=\"btn btn-info btn-slim-icon\" ng-if=!vm.isLastIndex ng-disabled=\"(vm.isAnswerMandatory ? !vm.currentQuestion.isAnswered : false) \" ng-click=\"vm.moveToNextQuestion() \" style=margin-left:1px><i class=\"fa fa-chevron-right nav-icon\"></i></button></span></span></div></div></div></div>");
$templateCache.put("app/template/default/questionHeader.tpl.html","<div class=col-md-12><span><span>QUESTION:&nbsp;</span> <b ng-bind=\"{{vm.currentQIndex + 1}}\" name=currentQuestionIndex></b> </span><span ng-if=\"vm.question.questionType !== 17 && vm.question.questionType !== 15\"><span>GROUP:&nbsp;</span> <b ng-bind=vm.question.gpName name=groupName></b> </span><span ng-if=\"vm.question.questionType !== 17 && vm.question.questionType !== 15\"><span>SECTION:&nbsp;</span> <b ng-bind=vm.question.scName name=sectionName></b></span><div class=qheader-mark ng-if=\"vm.loginInfo.Config.isShowQMarksEnabled && vm.currentQuestion.questionType != 15\"><span>Mark(s):&nbsp;</span> <span ng-bind=vm.question.correctMark name=correctMarkForCurrentQuestion></span></div></div><!-- \n    questionType = 17 | Video\n    questionType = 15 | Psychometric \n-->");
$templateCache.put("app/template/default/questionTraverser.tpl.html","<div style=padding-right:10px;overflow:hidden><div class=side-index-panel id=side-index-panel><div name=\"{{\'btnQuestionIndex\' + ($index+1)}}\" class=side-index-bar ng-repeat=\"question in vm.mandatQCollection track by question.id\" ng-class=\"{\'active\': $index == vm.currentQindex, \'isAnswered\': question.isAnswered && $index != vm.currentQindex, \'bar-disabled\': !vm.isIndexTraversingAllowed}\" ng-click=\"vm.isIndexTraversingAllowed && vm.goToQuestion($index)\" ng-init=\"vm.setOffSet() && $last;\" ng-if=vm.isActiveGroup(question)><span class=side-index-font ng-bind=\"$index + 1\">1</span> <i name=\"{{\'btnQuestionFlag\' + ($index+1)}}\" class=\"side-index-flag-icon fa\" aria-hidden=true ng-show=\"!vm.isMediaQueston && question.questionType != 15 && ($index == vm.currentQindex || question.isFlagged)\" ng-class=\"question.isFlagged ? \'fa-star isFlagged\' : \'fa-star-o\'\" ng-click=\"$index == vm.currentQindex && vm.flagQuestion(question);vm.isIndexTraversingAllowed && vm.goToQuestion($index);$event.stopPropagation();\" uib-tooltip=\"{{!question.isFlagged && \'Flag this question\' || \'\'}}\" tooltip-placement=right tooltip-append-to-body=true></i></div></div></div>");
$templateCache.put("app/template/default/sampleVideoRecording.tpl.html","<div class=sample-video-container><div class=row><div class=col-md-12><div>Network Check</div><p class=font-size-medium>We need to check if your network connection is stable</p></div></div><div class=row><div class=col-md-12><p class=font-size-medium>Please click <b>\"Start Recording\"</b> and then read out the paragraph below</p></div></div><div class=row><div class=sample-video-container><div class=col-md-6><div class=\"font-size-small style-sample-text\" ng-bind-html=vm.sampleText></div></div><div class=col-md-6><div class=sample-video-recording-container><iframe ng-if=\"vm.isRecordingStopped && !vm.isProctoting\" ng-src={{vm.playbackVideo}}></iframe><video id=recording-video autoplay muted></video><!-- Start recording --><div class=btn-recording-container ng-if=!vm.isRecordingStarted><div ng-bind=vm.startRecordingLabel class=font-size-small></div><button class=\"btn btn-danger btn-recording\" ng-click=vm.startRecording();>Start Recording</button><div></div></div><!-- Recording icon | Recording time count --><div class=recording-icon-time-count ng-if=\"vm.isRecordingStarted && !vm.isRecordingStopped\"><div class=recording-icon><i class=\"fa fa-dot-circle-o blink\" aria-hidden=true></i>&nbsp;Recording</div><div class=recording-time-count><span ng-bind=\"vm.count | formatTime : \'mins\'\"></span></div></div></div><p class=font-size-small><b>Note:</b>&nbsp; Adjust your distance from camera/mic for better video/audio quality</p><!-- After Recoding Cover Page --><div class=\"after-recording-cover font-size-medium\" ng-show=\"vm.isRecordingStopped && !vm.isErrorOcured && vm.isProctoting\"><div><p><span>Thank you!</span><br><span>Your network check was successful.</span></p><p>Please click Proceed To Test.</p></div></div><button ng-show=\"vm.isRecordingStopped && !vm.isProctoring\" class=\"btn btn-primary ng-binding pull-right\" style=margin-left:10px type=button ng-click=vm.onSubmit(); aria-hidden=false>Submit</button><!-- Re-rcord --> <button class=\"btn btn-default pull-right\" ng-if=vm.isRecordingStopped ng-click=vm.reStartRecording();>Record your video again</button></div></div></div></div>");
$templateCache.put("app/template/default/submitAnswerLog.tpl.html","<script type=text/ng-template id=group-template.html><div class=\"panel-heading\">\n		<h4 class=\"panel-title\">\n			<a href tabindex=\"0\" class=\"accordion-toggle\" ng-click=\"toggleOpen()\" uib-accordion-transclude=\"heading\" style=\"outline:none;\">\n				<span uib-accordion-header>\n					{{heading}}\n				</span>\n			</a>\n		</h4>\n	</div>\n	<div class=\"panel-collapse collapse\" uib-collapse=\"!isOpen\">\n		<div class=\"panel-body\" ng-transclude>\n		</div>\n	</div></script><uib-accordion close-others=true class=submit-answer-log ng-if=\"vm.questionLog.length > 0\"><div uib-accordion-group is-open=log.isOpen template-url=group-template.html ng-repeat=\"log in vm.questionLog\" ng-class=\"{\'accordian-open\':log.isOpen}\"><uib-accordion-heading><div class=flex-center><div class=accordion-header-row-icon><i class=\"fa fa-fw\" aria-hidden=true ng-class=\"{ \'fa-chevron-down\' : log.isOpen, \'fa-chevron-right\' : !log.isOpen}\"></i></div><div class=\"accordion-header-info flex-center\"><div><div><b ng-bind=\"log.submittedOn | date:\'shortTime\'\">Time</b></div><div ng-bind=\"log.submittedOn | date:\'mediumDate\'\">Date</div></div><div ng-if=!log.isOpen><div><b>Compilation Status</b></div><div ng-bind=log.codingCompileResponse.stat ng-class=\"log.codingCompileResponse.stat === \'Compiled\' ?\'color-green\':\'color-red\'\"></div></div><div ng-if=!log.isOpen><div><b>Test Cases Passed</b></div><div ng-bind=log.testCasePassedCountLavel></div></div><div ng-if=!log.isOpen><div><b>Avg. Execution Time(Sec)</b></div><div><span ng-bind=\"log.avgExecutionTime || \'-\'\"></span></div></div><div ng-if=!log.isOpen><div><b>Avg. Memory Consumed(KB)</b></div><div><span ng-bind=\"log.avgMemoryConsumed || \'-\'\"></span></div></div><div ng-if=!log.isOpen><div><b>Programming Language</b></div><div ng-bind=log.languageText></div></div></div></div></uib-accordion-heading><!------------------------ Panel Body -----------------------><!-- Test case stat --><div class=\"row log-tc-stat-result\"><div class=\"col-md-12 tc-rslt-stat-container\" ng-class=\"log.codingCompileResponse.stat === \'Compiled\' ?\'tc-rslt-stat-container-pass\':\'tc-rslt-stat-container-fail\'\"><div><b>Compilation Status : </b><span ng-bind=log.codingCompileResponse.stat ng-class=\"log.codingCompileResponse.stat === \'Compiled\' ?\'color-green\':\'color-red\'\"></span></div><hr class=tc-rslt-stat-container-devider><div class=row><div class=col-md-3><b>Test Case Passed</b></div><div class=col-md-3><b>Avg. Execution Time(Sec)</b></div><div class=col-md-3><b>Avg. Memory(KB) Consumed</b></div><div class=col-md-3><b>Language</b></div></div><div class=row><div class=col-md-3 ng-bind=log.testCasePassedCountLavel></div><div class=col-md-3 ng-bind=\"log.avgExecutionTime || \'-\'\"></div><div class=col-md-3 ng-bind=\"log.avgMemoryConsumed || \'-\'\"></div><div class=col-md-3 ng-bind=log.languageText></div></div></div></div><!-- Test case result summery --><div ng-if=log.testCaseResults class=row><b class=col-md-12>Test Case Summary</b><div class=\"col-md-12 log-testcase-result\"><table style=width:100%><tr><th align=center>Test Case</th><th align=center>Result</th><th align=center>Time(sec)</th><th align=center>Memory</th></tr><tr ng-repeat=\"testCaseResult in log.testCaseResults\"><td>Test Case {{$index + 1}}</td><td><i class=\"fa fa-check-circle color-green\" aria-hidden=true ng-if=\"testCaseResult.testCaseResult !== \'Fail\'\"></i> <i class=\"fa fa-times-circle color-red\" aria-hidden=true ng-if=\"testCaseResult.testCaseResult === \'Fail\'\"></i></td><td>{{testCaseResult.time}}</td><td>{{testCaseResult.memory}}</td></tr></table></div></div><!-- Compilation Log --><div class=row><b class=col-md-12>Compilation Log</b><div class=col-md-12><pre ng-bind-html=log.codingCompileResponse.compilationMessage></pre></div></div><!-- Submitted code --><div class=row><b class=col-md-12>Source Code</b><div class=col-md-12><pre ng-bind=log.submittedAnswer></pre><span class=btn-copy ng-click=\"vm.loadAnswer({\'answer\': log.submittedAnswer})\">Use this code in editor</span></div></div></div></uib-accordion><div ng-if=\"vm.questionLog.length == 0\" class=no-previous-v-found><img src=data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjQiIGhlaWdodD0iNDEiIHZpZXdCb3g9IjAgMCA2NCA0MSIgIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMCAxKSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgIDxlbGxpcHNlIGZpbGw9IiNGNUY1RjUiIGN4PSIzMiIgY3k9IjMzIiByeD0iMzIiIHJ5PSI3Ii8+CiAgICA8ZyBmaWxsLXJ1bGU9Im5vbnplcm8iIHN0cm9rZT0iI0Q5RDlEOSI+CiAgICAgIDxwYXRoIGQ9Ik01NSAxMi43Nkw0NC44NTQgMS4yNThDNDQuMzY3LjQ3NCA0My42NTYgMCA0Mi45MDcgMEgyMS4wOTNjLS43NDkgMC0xLjQ2LjQ3NC0xLjk0NyAxLjI1N0w5IDEyLjc2MVYyMmg0NnYtOS4yNHoiLz4KICAgICAgPHBhdGggZD0iTTQxLjYxMyAxNS45MzFjMC0xLjYwNS45OTQtMi45MyAyLjIyNy0yLjkzMUg1NXYxOC4xMzdDNTUgMzMuMjYgNTMuNjggMzUgNTIuMDUgMzVoLTQwLjFDMTAuMzIgMzUgOSAzMy4yNTkgOSAzMS4xMzdWMTNoMTEuMTZjMS4yMzMgMCAyLjIyNyAxLjMyMyAyLjIyNyAyLjkyOHYuMDIyYzAgMS42MDUgMS4wMDUgMi45MDEgMi4yMzcgMi45MDFoMTQuNzUyYzEuMjMyIDAgMi4yMzctMS4zMDggMi4yMzctMi45MTN2LS4wMDd6IiBmaWxsPSIjRkFGQUZBIi8+CiAgICA8L2c+CiAgPC9nPgo8L3N2Zz4K><div class=faded-text>No Previous Versions Found</div></div>");
$templateCache.put("app/template/default/typing.tpl.html","<!-- Question --><div class=row><div class=col-md-12><p ondragstart=\"return false\"><span class=per-word ng-repeat=\"word in vm.typingArray track by $index\" data-ng-style=\"$index == vm.typingWordIndex && {\'background\': \'yellow\'}\">{{word}}</span></p></div></div><!-- Answer --><div class=row><div class=col-md-12 oncontextmenu=\"return false\"><div style=display:flex;justify-content:center><input type=text ng-model=vm.enteredValue ng-keypress=vm.enterWord($event) onpaste=\"return false\" ondrop=\"return false\" style=\"width:50%;height:40px;margin: 6px;border: 0;padding-left: 10px;outline:0;font-size:20px;border-bottom: 1px solid #c7c7c7\" ng-disabled=\"vm.typingArray.length <= vm.typingWordIndex\" placeholder=\"Type Here..\" angular-auto-focus></div><div style=\"width:80%;margin:0 auto;padding:10px;border:1px solid #f1f1f1; background: #f9f9f9; min-height: 120px\"><p ondragstart=\"return false\" ng-bind=vm.typedText style=margin:4px;word-break:break-word></p></div></div></div>");
$templateCache.put("app/template/default/uploadCapture.tpl.html","<div class=row ng-if=\"vm.controlList.capture || vm.controlList.attachment\"><div class=col-md-12>Please upload supporting documents.</div><div class=col-md-12><button class=\"btn btn-primary\" ng-click=vm.openCameraModal(); ng-if=vm.controlList.capture>Add New</button> <button class=\"btn btn-default\" parent-to-child-bubling child-index=2 ng-disabled=vm.isInproccessing title=\"{{vm.controlList.attachment.allowedFileSize && \'Max:\' + vm.controlList.attachment.allowedFileSize + \' MB\'}}\" ng-if=vm.controlList.attachment><span>Upload Files</span> <input type=file style=display:none accept={{vm.controlList.attachment.accept}} file-input on-upload=uploadAttachmentFiles multiple></button></div><div class=\"col-md-12 upload-capture-preview-container\" ng-if=vm.controlList.capture><div class=upload-capture-preview-wrap ng-repeat=\"url in vm.jsonAnswer[vm.controlList.capture.id]\"><span class=upload-capture-preview-del ng-click=\"vm.removeUrl(vm.jsonAnswer[vm.controlList.capture.id], $index);\"><i class=\"fa fa-trash\" aria-hidden=true></i> </span><img ng-src={{url}} class=upload-capture-preview-img ng-if=vm.checkForImg(url)> <i class=\"fa fa-fw fa-3x fa-file-o\" aria-hidden=true ng-if=!vm.checkForImg(url)></i></div></div><div class=\"col-md-12 upload-capture-preview-container\" ng-if=vm.controlList.attachment><div class=upload-capture-preview-wrap ng-repeat=\"url in vm.jsonAnswer[vm.controlList.attachment.id]\"><span class=\"elipsis upload-capture-preview-name\" title=\"{{url | extractFileNameFromS3Path}}\" ng-bind=\"url | extractFileNameFromS3Path\"></span> <span class=upload-capture-preview-del ng-click=\"vm.removeUrl(vm.jsonAnswer[vm.controlList.attachment.id], $index);\"><i class=\"fa fa-trash\" aria-hidden=true></i> </span><img ng-src={{url}} class=upload-capture-preview-img ng-if=vm.checkForImg(url)> <i class=\"fa fa-fw fa-3x fa-file-o\" aria-hidden=true ng-if=!vm.checkForImg(url)></i></div></div></div>");
$templateCache.put("app/template/modal/modal.alias.html","<div class=modal-content><div class=modal-header><span class=modal-title>Please enter alias</span></div><div class=modal-body><div class=form-group><label>Alias</label><input type=text name=tenantName ng-model=vm.data class=form-control ng-keyup=\"$event.keyCode == 13 && vm.onOk()\" placeholder=\"Enter alias\" autofocus><p style=\"color: var(--secondry-color-red)\">{{vm.errorMessage}}</p></div></div><div class=modal-footer><button name=submitTenantName class=\"btn btn-primary pull-right\" type=button ng-click=vm.onOk()>Proceed</button></div></div>");
$templateCache.put("app/template/modal/modal.alias.tpl.html","<div class=modal tabindex=-1 role=dialog><div class=modal-dialog ng-controller=\"GetTenantAlias as vm\"><div class=\"modal-content md-modal-content\"><div class=modal-header><h4 class=\"modal-title selectn_modal_header\">Please enter tenant alias</h4></div><div class=modal-body><div class=form-group><label>Tenant Alias</label><input name=tenantName type=text ng-model=vm.alias class=form-control ng-keyup=\"$event.keyCode == 13 && vm.onOk()\" placeholder=\"Enter tenant alias\" autofocus> <span style=\"color: var(--secondry-color-red)\">{{vm.errorMessage}}</span></div></div><div class=modal-footer><button name=submitTenantName class=\"btn btn-primary\" type=button ng-click=vm.onOk()>Proceed</button></div></div></div></div>");
$templateCache.put("app/template/modal/modal.basicInstruction.tpl.html","<div class=modal tabindex=-1 role=dialog><div class=modal-dialog ng-controller=\"ShowBasicInstruction as vm\"><div class=modal-content style=height:99vh;overflow:hidden><div class=modal-header><button aria-hidden=true data-dismiss=modal class=close type=button ng-click=$hide();>×</button><h4 class=\"modal-title selectn_modal_header\">Instructions</h4></div><div class=modal-body style=height:90%;overflow:auto;padding-bottom:20px><basic-instruction question-paper=vm.questionPaper></basic-instruction></div><!-- <div class=\"modal-footer\">\n                <button class=\"btn btn-primary\" type=\"button\" ng-click=\"$hide();\">\n                    Close\n                </button>\n            </div> --></div></div></div>");
$templateCache.put("app/template/modal/modal.candidateEmail.tpl.html","<div class=modal tabindex=-1 role=dialog><div class=modal-dialog ng-controller=\"GetCandidateEmail as vm\"><div class=\"modal-content md-modal-content\"><div class=modal-header><h4 class=\"modal-title selectn_modal_header\">Please enter registered email</h4></div><div class=modal-body><div class=form-group><label>Enter registered email</label><input name=candidateEmail type=email pattern=[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\\.[A-Za-z]{2,}$ ng-model=vm.email class=form-control ng-keyup=\"$event.keyCode == 13 && vm.onOk()\" placeholder=Email autofocus> <span style=\"color: var(--secondry-color-red)\">{{vm.errorMessage}}</span></div></div><div class=modal-footer><button name=submitCandidateEmail class=\"btn btn-primary\" type=button ng-click=vm.onOk()>OK</button></div></div></div></div>");
$templateCache.put("app/template/modal/modal.generateKey.html","<div class=modal-content><div class=\"modal-header modal-alias-modal-header modal-header-hirepro\"><span class=\"modal-title modal-alias-modal-title\">Answer Key for Offline Submission</span></div><div class=modal-body><textarea ng-model=vm.items style=\"margin:0px; width: 100%;height: 100%\" readonly></textarea></div><div class=\"modal-footer modal-alias-modal-footer modal-footer-hirepro\" style=\"margin-top: 0%\"><button class=\"btn btn-default\" style=background:#ccc type=button ng-click=vm.onOk()>Retry</button></div></div>");
$templateCache.put("app/template/modal/modal.generateKey.tpl.html","<div class=modal tabindex=-1 role=dialog><div class=modal-dialog ng-controller=\"GenerateKey as vm\"><div class=\"modal-content md-modal-content\"><div class=modal-header><h4 class=\"modal-title selectn_modal_header\">Answer Key for Offline Submission</h4></div><div class=modal-body><textarea ng-model=vm.encAnswerKey style=\"margin:0px; width: 100%;height: 100%\" readonly></textarea></div><div class=modal-footer><strong style=\"float: left;color: #ff5600\">{{vm.errorMessage}}</strong> <button class=\"btn btn-primary\" type=button ng-click=vm.onOk();>Ok</button></div></div></div></div>");
$templateCache.put("app/template/modal/modal.link.html","<div class=modal tabindex=-1 role=dialog><div class=modal-dialog ng-controller=\"link as vm\"><div class=\"modal-content md-modal-content\"><div class=modal-header><span class=\"modal-title selectn_modal_header\">{{vm.header}}</span> <span type=button class=close ng-click=vm.close() style=\"margin-top: 10px\">&times;</span></div><div class=modal-body><div class=form-group><div ng-if=vm.url class=\"panel-body compant-url\" style=overflow:auto;height:40vh><iframe ng-src={{vm.url}} style=width:100%;height:97%;border:0px></iframe></div></div></div></div></div></div>");
$templateCache.put("app/template/modal/modal.nextTestNotification.html","<div class=modal-content><div class=\"modal-header modal-alias-modal-header modal-header-hirepro\"><span class=\"modal-title modal-alias-modal-title\">Move to Next Test</span></div><div class=\"modal-footer modal-alias-modal-footer modal-footer-hirepro\" style=\"margin-top: 0%\"><span style=\"float: left\">Click Ok to attempt the next test</span> <button class=\"btn btn-default\" style=background:#ccc type=button ng-click=vm.onOk()>Ok</button></div></div>");
$templateCache.put("app/template/modal/modal.notification.html","<div class=modal-content><div class=\"modal-header modal-header-hirepro\"><a ng-if=!vm.isActionEnable type=button class=close ng-click=vm.close()>&times;</a> <i class=\"fa fa-exclamation-triangle fa-lg modal-notification-modal-title\" aria-hidden=true>&nbsp; {{vm.heading}}</i></div><div class=modal-body ng-style=\"{\'max-height\':vm.styleProp.maxHeight,\'padding\':vm.styleProp.padding}\"><span ng-bind-html=vm.items></span></div><div class=\"modal-footer modal-footer-hirepro\" ng-if=vm.isActionEnable><strong id=\"messageModalNotification pull-left\" ng-if=vm.message style=\"color: #ff5600;font-size: 14px\">{{vm.message}} </strong><strong ng-if=\"!vm.data && vm.errorMessage\" style=\"float: left;color: #ff5600\">{{vm.errorMessage}} </strong><span id=okBtnModalNotification class=\"btn btn-primary\" type=button ng-if=vm.isOkEnable ng-click=vm.onOk()>{{vm.ok}} </span><span class=\"btn btn-primary\" type=button ng-if=vm.isCancelEnable ng-click=vm.close()>{{vm.cancel}}</span></div></div>");
$templateCache.put("app/template/modal/modal.notification.tpl.html","<div class=\"modal modal-z-index\" tabindex=1 role=dialog><div class=modal-dialog ng-controller=\"NotificationModal as vm\" ng-class=\"{\'modal-lg\' : vm.modalSize == \'lg\'}\"><div class=\"modal-content md-modal-content\"><div class=modal-header><button ng-if=\"!vm.isAction && vm.isCloseBtnRequired\" aria-hidden=true data-dismiss=modal class=close type=button ng-click=$hide(); ng-if=vm.isAction>×</button><h4 class=\"modal-title selectn_modal_header\" ng-bind=vm.headerStr></h4></div><div class=modal-body><p ng-bind-html=vm.bodyStr></p></div><div class=modal-footer ng-if=vm.isAction><button type=button class=\"btn btn-default\" ng-if=vm.action.isCancelBtn ng-click=vm.onCancelCall(); ng-bind=vm.action.cancelText>Cancel</button> <button class=\"btn btn-primary\" type=button ng-bind=vm.action.okText ng-if=\"vm.action.isOkBtn && vm.action.isOnClick\" ng-click=$hide();vm.action.onOk();>Ok</button> <button class=\"btn btn-primary\" type=button ng-bind=vm.action.okText ng-if=\"vm.action.isOkBtn && !vm.action.isOnClick\" ng-click=vm.onOkCall();>Ok</button></div></div></div></div>");
$templateCache.put("app/template/modal/modal.onlineProctoring.tpl.html","<div class=modal tabindex=-1 role=dialog><div class=modal-dialog ng-controller=\"OnlineProctoringCtrl as vm\"><div class=\"modal-content md-modal-content\"><div class=modal-header><h4 class=\"modal-title selectn_modal_header\">Online Proctoring Setup</h4></div><div class=modal-body style=\"padding:20px 50px\" ng-if=\"vm.versantFileIssueStatue==\'end\'\"><!-- steps indicator icon --><div class=row><div class=col-xs-12><div class=wizard-step><ul><li ng-repeat=\"wizard in vm.wizard\" ng-class=\"{\'current\' : vm.wizardCurrentStep == $index}\"></li></ul></div></div></div><!-- consent Page --><div ng-if=\"vm.wizard[vm.wizardCurrentStep].type == \'consent\'\"><!-- ng-if=\"vm.wizardStep == 1\" --><div class=row><div class=col-md-12><p style=font-size:18px;font-weight:700;color:#007EFC>About Online Proctoring</p></div></div><div ng-include=vm.consentPage></div></div><!-- Assessment Terms And Conditons Page --><div ng-if=\"vm.wizard[vm.wizardCurrentStep].type == \'assessmentTermsAndConditons\'\"><assessment-terms-and-conditons response-data=\"vm.callBackFormComponent(proceed, type)\"></assessment-terms-and-conditons></div><!-- Proctor Compatibility --><div ng-if=\"vm.wizard[vm.wizardCurrentStep].type == \'proctor\'\"><!-- ng-if=\"vm.wizardStep == 2\" --><div class=row><proctor-compatibility response-data=\"vm.callBackFormComponent(proceed, type, url, systemSlow, reloadEnabled, showReloadOnGetMyRoomFailure)\"></proctor-compatibility></div></div><!-- ID Capture --><div ng-if=\"vm.wizard[vm.wizardCurrentStep].type == \'captureId\'\"><div class=row><capture-id response-data=\"vm.callBackFormComponent(proceed, type, url, systemSlow)\"></capture-id></div></div><!-- ID Approval --><div ng-if=\"vm.wizard[vm.wizardCurrentStep].type == \'idApproval\'\"><div class=row><capture-response response-data=\"vm.callBackFormComponent(proceed, type, url, systemSlow)\"></capture-response></div></div><!-- Noise Check --><div ng-if=\"vm.wizard[vm.wizardCurrentStep].type == \'noiseCheck\'\"><surround-noise-check ng-if=vm.isNoiseCheckEnable response-data=\"vm.callBackFormComponent(proceed, type)\" threshold-value=vm.threshold instant-noise=vm.noiseInstantCheck noise-attempt=vm.maxnoiseAttempt></surround-noise-check></div><!-- Sound Quality Check --><div ng-if=\"vm.wizard[vm.wizardCurrentStep].type == \'soundQualityCheck\'\"><sound-quality-check response-data=\"vm.callBackFormComponent(proceed, type)\" video-include=vm.videoInMicTest></sound-quality-check></div><!-- 2nd Camera --><div ng-if=\"vm.wizard[vm.wizardCurrentStep].type == \'secondaryCamera\'\"><secondary-camera response-data=\"vm.callBackFormComponent(proceed, type)\"></secondary-camera></div><!-- 2nd Camera Preview --><div ng-if=\"vm.wizard[vm.wizardCurrentStep].type == \'secondaryCameraPreview\'\"><secondary-camera-preview response-data=\"vm.callBackFormComponent(proceed, type)\"></secondary-camera-preview></div><!-- Sample Video Recording --><div ng-if=\"vm.wizard[vm.wizardCurrentStep].type == \'sampleVideo\'\"><sample-video-recording ng-if=vm.isSampleVideoRecordingEnable is-proctoring=true response-data=\"vm.callBackFormComponent(proceed, type)\"></sample-video-recording></div><!-- 360 Room Scan --><div ng-if=\"vm.wizard[vm.wizardCurrentStep].type == \'roomScan\'\"><room-scan response-data=\"vm.callBackFormComponent(proceed, type)\"></room-scan></div></div><div class=modal-body style=\"padding:20px 50px\" ng-if=\"vm.versantFileIssueStatue==\'error\'\"><div class=row><div class=col-md-12><div class=\"text-center noise-div\"><div style=margin-bottom:10px><h4 style=color:#36B37E>Unable to access server files!</h4><p>please reach out to your assessment coordinator for assistance.</p></div></div></div></div></div><div class=modal-footer ng-if=\"vm.versantFileIssueStatue==\'end\'\"><div class=row><div class=\"col-md-8 text-left\"><p style=color:#F46A62;font-weight:500 ng-if=vm.isSystemSlow>Your system is either too slow or running too many applications.<br>Please restart your system after closing all applications, and then try again.<br>If you still see this error, please upgrade to a <u popover-placement=right-bottom popover-title=\"Compatible hardware configuration\" uib-popover-html=vm.slowSystemInstruction popover-trigger=\"\'mouseenter\'\" popover-append-to-body=true>faster machine.</u></p><p style=color:#007EFC;font-weight:500 ng-if=vm.reloadEnabled>Please <button class=\"btn btn-primary btn-sm\" ng-click=vm.reloadPage()>reload</button> this page if you believe that you have fixed the reported issue.</p><p style=color:#007EFC;font-weight:500 ng-if=vm.showReloadOnGetMyRoomFailure>Problem detected. Please <button class=\"btn btn-primary btn-sm\" ng-click=vm.reloadPage()>reload</button> to retry.</p></div><div class=col-md-4><!-- <button name=\"btnProctorNext\" class=\"btn btn-primary\" type=\"button\" ng-click=\"vm.onNextClick()\" ng-disabled=\"(vm.wizardStep == 1 && !vm.isTermsAccepted) || (vm.wizardStep == 2 && !vm.selfieTaken) || (vm.wizardStep == 3 && !vm.idProofTaken) || (vm.wizardStep == 4 && !vm.idProofApproved) || (vm.wizardStep == 5 && !vm.noiseChecked) || (vm.wizardStep == 6 && !vm.videoRecorded)\">\n                            <span ng-bind=\"vm.submitOrNext\"></span>\n                        </button> --> <button name=btnProctorNext class=\"btn btn-primary\" type=button ng-click=vm.onNextClick(); ng-disabled=!vm.wizard[vm.wizardCurrentStep].stateCheck><span ng-if=\"vm.wizardCurrentStep + 1 != vm.wizard.length || vm.onlyProctoringTest\">Next<!-- <span>\n                                    <img style=\"margin:5px; height:20px;\" src=\"assets/images/counter10.gif\">\n                                </span> --> </span><span ng-if=\"vm.wizardCurrentStep + 1 == vm.wizard.length && !vm.onlyProctoringTest\">Proceed to test</span></button> <button class=\"btn btn-default\" ng-if=vm.isLocalHost ng-click=$hide();>Skip</button></div></div></div></div></div></div>");
$templateCache.put("app/template/modal/modal.optionalGroups.html","<div class=modal-content><div class=\"modal-header modal-header-hirepro\"><a ng-if=!vm.isActionEnable type=button class=close ng-click=vm.close();>&times;</a><h4 class=modal-title>{{vm.heading}}</h4></div><div class=modal-body style=max-height:261px;overflow:auto><dl ng-repeat=\"grp in vm.items\"><label><dt style=float:left><label class=radio-container><input name=optionGrpChk class=modal-optional-chkgrp type=radio value={{grp.gpId}} ng-model=vm.data> <span class=checkmark></span></label></dt><dd class=modal-optional-grpname title={{grp.gpName}}><b ng-bind=grp.gpName></b></dd></label><hr class=answerSeprator></dl></div><div class=\"modal-footer modal-footer-hirepro\" ng-if=vm.isActionEnable><div ng-if=\"(vm.isPreviewEnable && vm.optionalPreviewtime > 0 && !vm.isOptionalPreviewTimeOver)\" style=\"text-align: left;color: #5088be;font-weight: bold\">Optional Preview Time : {{vm.optionalPreviewtime | formatTime}}<br></div><div><strong ng-if=\"!vm.data && vm.errorMessage\" style=\"float: left;color: #ff5600\">{{vm.errorMessage}}</strong> <strong ng-if=vm.data style=\"float: left;color: #286090\">You can\'t revert back after selection.</strong> <button class=\"btn btn-primary\" type=button ng-if=vm.isOkEnable ng-click=vm.onOk()>Add</button> <span class=\"btn btn-primary\" type=button ng-if=vm.isCancelEnable ng-click=vm.close()>Cancel</span> <span class=\"btn btn-primary\" type=button ng-if=\"(vm.isPreviewEnable && !vm.isOptionalPreviewTimeOver)\" ng-click=vm.previewOptionalGroups()>Preview</span></div></div></div>");
$templateCache.put("app/template/modal/modal.optionalGroups.tpl.html","<div class=modal tabindex=-1 role=dialog><div class=\"modal-dialog modal-dialog-full-screen\" ng-controller=\"OptionalGroups as vm\" ng-class=\"{\'modal-dialog-full-margin\': vm.activeGroupId != -1}\"><div class=\"modal-content md-modal-content\"><!-- <div class=\"modal-header\">\n                <button aria-hidden=\"true\" ng-if=\"vm.isCancelEnable\" data-dismiss=\"modal\" class=\"close\" type=\"button\" ng-click=\"vm.onCancel()\">×</button>\n                <h4 class=\"modal-title selectn_modal_header\" ng-bind=\"vm.headerStr\"></h4>\n            </div> --><div class=modal-body style=height:100%><div class=row style=height:100%><div ng-class=\"vm.previewTimer? \'col-md-4\': \'col-md-4 col-md-offset-4\'\"><h4 class=\"modal-title selectn_modal_header\" ng-bind=vm.headerStr></h4><p><strong>Please choose one of the following options</strong></p><div ng-repeat=\"grp in vm.groups\" class=option-item ng-style=\"{\'border-color\' : vm.selectedGroup == grp.gpId ? \'#007EFC\' : \'#C7C7C7\'}\"><label class=custom-radio><span ng-bind-html=grp.gpName></span> <input type=radio value={{grp.gpId}} ng-model=vm.selectedGroup name=optionGrpChk ng-click=vm.resetPreview()> <span class=cradio></span></label></div><button name=btnCancel class=\"btn btn-default\" type=button ng-if=vm.isCancelEnable ng-click=vm.onCancel() autofocus>Cancel</button> <button name=btnSelectGroup ng-disabled=!vm.selectedGroup class=\"btn btn-primary pull-right\" ng-click=vm.onOk()>Take me to the chosen group <i class=\"fa fa-chevron-right\" aria-hidden=true></i></button><div class=row><div class=col-md-12><p ng-if=\"!vm.selectedGroup && vm.errorMessage\" ng-bind-html=vm.errorMessage class=\"text-center optional-error\"></p></div></div></div><div class=\"col-md-8 optional_grp_content_preview_window\" ng-if=vm.previewTimer><p><strong>Preview </strong><span class=pull-right>You have <strong><span ng-bind=\"vm.previewTimer | formatTime\"></span></strong> for the preview</span></p><div class=option-preview-container ng-style=\"{\'border\': vm.selectedGroup && \'1px solid #57A9FA\'}\" style=height:90%><div class=option-preview-content ng-if=!vm.grpInfo><span ng-if=!vm.selectedGroup>Select group to see preview </span><button class=\"btn btn-default\" ng-if=vm.selectedGroup ng-click=vm.showPreview();>View Preview</button></div><div ng-if=vm.grpInfo><div title={{vm.grpInfo.gpName}} class=text-center><b ng-bind=vm.grpInfo.gpName></b></div><div style=\"background: #fff\"><div ng-repeat=\"qs in vm.grpInfo.questions | groupBy:\'scId\'\"><div class=\"well well-sm\"><b>Section {{$index+1}}: <span style=margin-left:1px;color:#31708f title=\"Section Name: {{qs[0].scName}}\">{{qs[0].scName}}</span></b><p style=\"margin-bottom: 0px\">Type of Question: <span style=color:#31708f>{{qs[0].typeOfQuestionText}}</span></p><p>Instruction: <span style=\"font-weight: normal;white-space: normal\">{{qs[0].qInstruction}}</span></p></div><dl ng-repeat=\"q in qs\" class=group-info-questions-q><dt ng-style=\"{\'float\': \'left\'}\">{{$index+1}})</dt><dd class=modal-optional-grpname><span ng-bind-html=q.htmlString></span><div ng-if=\"q.childQuestions && q.childQuestions.length > 0\"><b>Questions :</b><div ng-repeat=\"cq in q.childQuestions\" style=margin-left:1%><div><b>Q{{$parent.$index+1}}.{{$index+1}} :</b></div><div ng-bind-html=cq.htmlString></div></div></div></dd></dl></div></div></div></div></div></div></div><!-- <div class=\"modal-footer\">\n                <div>\n                    <strong ng-if=\"!vm.selectedGroup && vm.errorMessage\" style=\"float: left;color: #ff5600;\">\n                        {{vm.errorMessage}}\n                    </strong>\n                    <strong ng-if=\"vm.selectedGroup\" style=\"float: left;color: #286090;\">\n                        You can\'t revert back after selection.\n                    </strong>\n                    <button class=\"btn btn-primary\" type=\"button\" ng-if=\"vm.isOkEnable\" ng-click=\"vm.onOk()\">\n                        Add\n                    </button>\n                    <button class=\"btn btn-primary\" type=\"button\" ng-if=\"vm.isCancelEnable\" ng-click=\"vm.onCancel()\" autofocus>\n                        Cancel\n                    </button>\n                    <span class=\"btn btn-primary\" type=\"button\" ng-if=\"vm.previewTimer > 0\" ng-click=\"vm.onPreview()\">\n                        Preview\n                    </span>\n                </div>\n            </div> --></div></div><style>.modal-backdrop {\n            display: none;\n        }</style></div>");
$templateCache.put("app/template/modal/modal.optionalGroupsOld.tpl.html","<div class=modal tabindex=-1 role=dialog><div class=\"modal-dialog modal-dialog-full-screen\" ng-controller=\"OptionalGroups as vm\"><div class=\"modal-content md-modal-content\"><div class=modal-header><button aria-hidden=true ng-if=vm.isCancelEnable data-dismiss=modal class=close type=button ng-click=vm.onCancel()>×</button><h4 class=\"modal-title selectn_modal_header\" ng-bind=vm.headerStr></h4></div><div class=modal-body><dl ng-repeat=\"grp in vm.groups\" class=raio-option><dt ng-style=\"{\'float\': \'left\'}\"><label class=radio-container><input id={{grp.gpId}} name=optionGrpChk type=radio value={{grp.gpId}} ng-model=vm.selectedGroup class=modal-optional-chkgrp> <span class=checkmark></span></label></dt><dd class=modal-optional-grpname title={{grp.gpName}}><label for={{grp.gpId}}><span ng-bind-html=grp.gpName></span></label></dd></dl><!-- <hr ng-repeat-end ng-if=\"vm.ApplicationViewType !== \'App-Angular-Material\' && !$last\" class=\"answerSeprator\" /> --></div><div class=modal-footer><div ng-if=\"vm.previewTimer > 0\" style=\"text-align: left;color: #5088be;font-weight: bold\">Optional Preview Time : {{vm.totalPreviewtime | formatTime}}</div><div><strong ng-if=\"!vm.selectedGroup && vm.errorMessage\" style=\"float: left;color: #ff5600\">{{vm.errorMessage}} </strong><strong ng-if=vm.selectedGroup style=\"float: left;color: #286090\">You can\'t revert back after selection. </strong><button class=\"btn btn-primary\" type=button ng-if=vm.isOkEnable ng-click=vm.onOk()>Add</button> <button class=\"btn btn-primary\" type=button ng-if=vm.isCancelEnable ng-click=vm.onCancel() autofocus>Cancel</button> <span class=\"btn btn-primary\" type=button ng-if=\"vm.previewTimer > 0\" ng-click=vm.onPreview()>Preview</span></div></div></div></div><style>.modal-backdrop {\n            display: none;\n        }</style></div>");
$templateCache.put("app/template/modal/modal.optionalPreview.html","<div class=modal-content><div class=\"modal-header modal-header-hirepro\"><a ng-if=!vm.isActionEnable type=button class=close ng-click=vm.close()>&times;</a><h4 class=modal-title style=display:inline>{{vm.heading}}</h4><div style=float:right;font-weight:bold title=\"Remaining optional preview time\"><i class=\"fa fa-hourglass-start\" aria-hidden=true style=font-size:1.3em ng-if=\"vm.util.stopWatch.stopwatchTime < (vm.util.stopWatch.getTotalTime()/2)\"></i> <i class=\"fa fa-hourglass-half\" aria-hidden=true style=font-size:1.3em ng-if=\"vm.util.stopWatch.stopwatchTime >= (vm.util.stopWatch.getTotalTime()/2) && vm.util.stopWatch.stopwatchTime < (vm.util.stopWatch.getTotalTime() - 1)\"></i> <i class=\"fa fa-hourglass-end\" aria-hidden=true style=font-size:1.3em ng-if=\"vm.util.stopWatch.stopwatchTime === vm.util.stopWatch.getTotalTime()-1\"></i> <span style=\"font-weight:bold;color: #3c763d;font-size: 1.3em\">{{(vm.util.stopWatch.getTotalTime() - vm.util.stopWatch.stopwatchTime) | formatTime}}</span></div></div><div class=\"modal-body optional-preview-modal-body\"><div class=row><div class=col-md-4><table class=\"table table-bordered\"><thead><tr><th colspan=2>Group Name</th><th>No. of Q</th></tr></thead><tbody><tr ng-repeat=\"grp in vm.items\" ng-click=vm.setGroup(grp.gpId) class=row-hover><td class=col-md-1 title=\"{{(vm.selectedGrpId === grp.gpId) ? \'viewing\' : \'Click to view\'}}\"><i class=\"fa fa-eye\" aria-hidden=true ng-if=\"(vm.selectedGrpId === grp.gpId)\" style=color:#033a77></i> <i class=\"fa fa-eye-slash\" aria-hidden=true ng-if=\"!(vm.selectedGrpId === grp.gpId)\" style=color:#033a77></i></td><td class=\"col-md-9 col-hover text-ellipsis\" ng-class=\"{\'col-selected\':(vm.selectedGrpId === grp.gpId)}\" style=color:#2e94ea title={{grp.gpName}}>{{grp.gpName}}</td><td class=\"col-md-2 col-hover\" ng-class=\"{\'col-selected\':(vm.selectedGrpId === grp.gpId)}\" style=text-align:center>{{grp.questions.length}}</td></tr></tbody></table></div><div class=\"col-md-8 group-info-details\"><div><div class=group-info-details-gp-name title={{vm.grpInfo.gpName}}><b>{{vm.grpInfo.gpName}}</b></div></div><div class=group-info-questions><dl ng-repeat=\"qs in vm.grpInfo.questions | groupBy:\'scId\'\"><dd><dt class=group-info-details-sec-name><b>Section {{$index+1}}: <span style=margin-left:1px;color:#31708f title=\"Section Name: {{qs[0].scName}}\">{{qs[0].scName}}</span></b><p style=\"margin-bottom: 0px\">Type of Question: <span style=color:#31708f>{{qs[0].typeOfQuestionText}}</span></p><p>Instruction: <span style=\"font-weight: normal;white-space: normal\">{{qs[0].qInstruction}}</span></p></dt></dd><dd></dd><dl ng-repeat=\"q in qs\" class=group-info-questions-q><dt ng-style=\"{\'float\': \'left\'}\">{{$index+1}})</dt><dd class=modal-optional-grpname><span ng-bind-html=q.htmlString></span><div ng-if=\"q.childQuestions && q.childQuestions.length > 0\"><b>Questions :</b><div ng-repeat=\"cq in q.childQuestions\" style=margin-left:1%><div><b>Q{{$parent.$index+1}}.{{$index+1}} :</b></div><div ng-bind-html=cq.htmlString></div></div></div></dd></dl></dl></div></div></div></div><div class=\"modal-footer modal-footer-hirepro\" ng-if=vm.isActionEnable><strong ng-if=\"!vm.data && vm.errorMessage\" style=\"float: left;color: #ff5600\">{{vm.errorMessage}}</strong> <button class=\"btn btn-primary\" type=button ng-if=vm.isOkEnable ng-click=vm.onOk()>Ok</button></div></div>");
$templateCache.put("app/template/modal/modal.optionalPreview.tpl.html","<div class=modal tabindex=-1 role=dialog><div class=\"modal-dialog-full-screen modal-lg\" ng-controller=\"OptionalPreviewModal as vm\"><div class=\"modal-content lg-modal-content\"><div class=modal-header><div style=float:right;font-weight:bold title=\"Remaining optional preview time\"><i class=fa aria-hidden=true style=font-size:1.3em ng-class=vm.clockClass></i> <span style=\"font-weight:bold;color: #3c763d;font-size: 1.3em\">{{vm.previewTimer | formatTime}}</span></div></div><div class=modal-body><div class=row><div class=col-md-4><table class=\"table table-bordered\"><thead><tr><th colspan=2>Group Name</th><th>No. of Q</th></tr></thead><tbody><tr ng-repeat=\"grp in vm.groups\" ng-click=vm.onSelectGroup(grp); class=row-hover><td class=col-md-1 title=\"{{(vm.grpInfo.gpId === grp.gpId) ? \'viewing\' : \'Click to view\'}}\"><i class=\"fa fa-eye\" aria-hidden=true ng-if=\"(vm.grpInfo.gpId === grp.gpId)\" style=color:#033a77></i> <i class=\"fa fa-eye-slash\" aria-hidden=true ng-if=\"!(vm.grpInfo.gpId === grp.gpId)\" style=color:#033a77></i></td><td class=\"col-md-9 col-hover text-ellipsis\" ng-class=\"{\'col-selected\':(vm.grpInfo.gpId === grp.gpId)}\" style=color:#2e94ea title={{grp.gpName}}>{{grp.gpName}}</td><td class=\"col-md-2 col-hover\" ng-class=\"{\'col-selected\':(vm.grpInfo.gpId === grp.gpId)}\" style=text-align:center><b>{{grp.questions.length}}</b></td></tr></tbody></table></div><div class=\"col-md-8 group-info-details\"><div class=group-info-details-gp-name title={{vm.grpInfo.gpName}}><b>{{vm.grpInfo.gpName}}</b></div><div class=group-info-questions><div class=\"panel panel-default\" ng-repeat=\"qs in vm.grpInfo.questions | groupBy:\'scId\'\"><!-- Default panel contents --><div class=panel-heading><b>Section {{$index+1}}: <span style=margin:1px;color:#31708f title=\"Section Name: {{qs[0].scName}}\">{{qs[0].scName}}</span></b><p>Type of Question: <span style=color:#31708f>{{qs[0].typeOfQuestionText}}</span></p><p>Instruction: <span style=font-weight:normal;white-space:normal>{{qs[0].qInstruction}}</span></p></div><ul class=list-group><li class=list-group-item ng-repeat=\"q in qs | unique:\'parentQuestionId\'\"><span>{{$index+1}}) </span><span ng-bind-html=\"!q.childQuestions ? q.htmlString : q.parentHtmlString\"></span><div ng-if=\"q.childQuestions && q.childQuestions.length > 0\"><b>Questions :</b><div ng-repeat=\"cq in q.childQuestions\" style=margin-left:1%><div><b>Q{{$parent.$index+1}}.{{$index+1}} :</b></div><div ng-bind-html=cq.htmlString></div></div></div></li></ul></div></div></div></div></div><div class=modal-footer><button class=\"btn btn-primary\" type=button ng-click=vm.onOk();>Ok</button></div></div></div></div>");
$templateCache.put("app/template/modal/modal.proctor.tpl.html","<div class=modal tabindex=-1 role=dialog><div class=modal-dialog><div class=\"modal-content md-modal-content\"><div class=modal-header><h4 class=\"modal-title selectn_modal_header\">Proctoring Compatibility</h4></div><div class=modal-body><proctor-compatibility></proctor-compatibility></div></div></div></div>");
$templateCache.put("app/template/modal/modal.qaTakePhoto.tpl.html","<div class=modal tabindex=-1 role=dialog><div class=modal-dialog ng-controller=\"QaTakePhoto as vm\" style=width:65%!important><div class=\"modal-content md-modal-content\"><div class=modal-header><button aria-hidden=true data-dismiss=modal class=close type=button ng-click=vm.stopCamera();$hide();>×</button><h4 class=\"modal-title selectn_modal_header\">Take Photo</h4></div><div class=\"modal-body take-photo\"><div class=row><div class=col-md-12><div class=video-container><video height=300 width=400 id=video autoplay>Video stream not available.</video></div></div><div class=col-md-12 style=display:flex;justify-content:center><button class=\"btn btn-primary\" ng-click=vm.grabFrame(); ng-disabled=!vm.enableTakePhoto>Take Picture</button></div><div class=col-md-12><canvas id=canvas style=display:none></canvas></div><div class=col-md-12 style=display:flex;justify-content:flex-start;overflow-y:auto;width:100%><img ng-repeat=\"img in vm.newUploadedPhotos\" ng-src={{img}} style=margin:5px;height:100px></div></div></div><div class=modal-footer><button name=submitTenantName class=\"btn btn-primary\" type=button ng-click=vm.onOk()>Save & Proceed</button></div></div></div></div>");
$templateCache.put("app/template/modal/modal.roomScan.tpl.html","<div class=modal tabindex=-1 role=dialog><div class=modal-dialog ng-controller=\"RoomScan as vm\"><div class=\"modal-content md-modal-content\"><div class=modal-header><h4 class=\"modal-title selectn_modal_header\">Online Proctoring Setup</h4></div><div class=modal-body><room-scan intest-data=vm.data response-data=vm.closeWindow(action,type)></room-scan></div></div></div></div>");
$templateCache.put("app/template/modal/modal.securityKey.html","<div class=modal tabindex=-1 role=dialog><div class=modal-dialog ng-controller=\"SecurityKeyValidate as vm\"><div class=modal-content><div class=modal-header><h4 class=modal-title>{{vm.headerStr}}</h4></div><div class=modal-body><div class=row data-ng-if=!vm.isOnlinePreview><div class=\"col-md-5 text-center\" ng-if=!!vm.candidateDetails><!-- <span class=\"thumbnail text-center\" ng-style=\"!vm.candidateDetails.candidatePhotoPath && {\'height\':\'180px\'}\">\n                            <img ng-src=\"{{vm.candidateDetails.candidatePhotoPath}}\" data-ng-if=\"vm.candidateDetails.candidatePhotoPath\">\n                            <h4 data-ng-if=\"!vm.candidateDetails.candidatePhotoPath\">No Image</h4>\n                        </span> --> <img style=width:100%;height:290px;object-fit:cover;object-position:center ng-src={{vm.candidateDetails.candidatePhotoPath}} data-ng-if=vm.candidateDetails.candidatePhotoPath></div><div class=col-md-7 ng-if=!!vm.candidateDetails><div><span>Name: </span><strong style=margin-left:4px data-ng-bind=\"vm.candidateDetails.name || \'-\'\"></strong></div><div><span>Id: </span><strong style=margin-left:4px data-ng-bind=\"vm.candidateDetails.candidateId || \'-\'\"></strong></div><div><span>Mobile: </span><strong style=margin-left:4px data-ng-bind=\"vm.candidateDetails.mobile || \'-\'\"></strong></div><div><span>Email: </span><strong style=margin-left:4px;word-wrap:break-word data-ng-bind=\"vm.candidateDetails.email || \'-\'\"></strong></div><br><div><span>URN: </span><strong style=margin-left:4px data-ng-bind=\"vm.candidateDetails.usn || \'-\'\"></strong></div><div><span>Gender: </span><strong style=margin-left:4px data-ng-bind=\"vm.candidateDetails.gender || \'-\'\"></strong></div><div><span>Degree: </span><strong style=margin-left:4px data-ng-bind=\"vm.candidateDetails.degree || \'-\'\"></strong></div><div><span>Date Of Birth: </span><strong style=margin-left:4px data-ng-bind=\"vm.candidateDetails.dob | date : \'longDate\' || \'-\'\"></strong></div><div><span>College: </span><strong style=margin-left:4px data-ng-bind=\"vm.candidateDetails.college || \'-\'\"></strong></div></div><div class=col-md-12><p style=\"color: var(--primary-color-blue);font-size: 22px;font-weight: 500\">Please wait for instructions from your test administrator</p><p style=font-weight:500>To allow access, please enter the security key below.</p></div><!-- <div class=\"col-md-12\">\n                        <h3>Other Details</h3>\n                    </div>\n                    <div class=\"col-md-6\">\n                        <div class=\"form-group\">\n                            <label>URN: </label>\n                            <span style=\"color:var(--startTestBtn_bgcolor);margin-left:4px;\" data-ng-bind=\"vm.candidateDetails.usn || \'-\'\"></span>\n                        </div>\n                        <div class=\"form-group\">\n                            <label>Gender: </label>\n                            <span style=\"color:var(--startTestBtn_bgcolor);margin-left:4px;\" data-ng-bind=\"vm.candidateDetails.gender || \'-\'\"></span>\n                        </div>\n                        <div class=\"form-group\">\n                            <label>Degree: </label>\n                            <span style=\"color:var(--startTestBtn_bgcolor);margin-left:4px;\" data-ng-bind=\"vm.candidateDetails.degree || \'-\'\"></span>\n                        </div>\n                    </div>\n                    <div class=\"col-md-6\">\n                        <div class=\"form-group\">\n                            <label>Date Of Birth: </label>\n                            <span style=\"color:var(--startTestBtn_bgcolor);margin-left:4px;\" data-ng-bind=\"vm.candidateDetails.dob | date : \'longDate\' || \'-\'\"></span>\n                        </div>\n                        <div class=\"form-group\">\n                            <label>College: </label>\n                            <span style=\"color:var(--startTestBtn_bgcolor);margin-left:4px;\" data-ng-bind=\"vm.candidateDetails.college || \'-\'\"></span>\n                        </div>\n                    </div> --></div><div ng-if=vm.isOnlinePreview><p>This online assessment preview is protected by a security key.</p><p>Please enter the security key below. If you don\'t have the security key, please reach out to your point of contact for this assessment.</p></div><form autocomplete=off class=row><div class=\"form-group col-md-10\"><label for=disabledTextInput>Security Key</label><input name=securityKey type=password ng-model=vm.data class=form-control ng-keyup=\"$event.keyCode == 13 && vm.onOk()\" placeholder=\"Security Key\" autofocus> <i style=float:left;color:#ff5600;font-size:14px;height:26px>{{vm.errorMessage}}</i></div><div class=col-md-2><button name=btnSecurityKey class=\"btn btn-primary\" style=margin-top:33px type=button ng-click=vm.onOk();>Verify</button></div></form></div><!-- <div class=\"modal-footer\">\n                <strong style=\"float: left;color: #ff5600;\">{{vm.errorMessage}}</strong>\n                <button class=\"btn btn-primary\" type=\"button\" ng-click=\"vm.onOk();\">Verify</button>\n            </div> --></div></div></div>");
$templateCache.put("app/template/modal/modal.stopProctoringWarning.tpl.html","<div class=\"modal-dialog justify-content-center ng-scope center am-fade\" style=\"width: 750px;position: fixed;top: 50%;left: 50%;transform: translate(-50%, -50%);z-index: 1050;display: block\"><div class=\"modal-content md-modal-content\" style=\"padding: 40px 60px 40px 60px\"><div class=modal-body><div class=row><div class=col-md-12><p style=\"padding-bottom: 30px;font-family: \'Roboto\';font-weight: bold;font-size: 21px;color: #FF6156;text-align: center\"><i class=\"fa fa-exclamation-circle\" aria-hidden=true style=\"font-size: 30px\"></i> Are You sure you want to stop proctoring &amp; end test?</p><p style=\"text-align: justify;font-family: \'Roboto\';font-size: 14px;font-weight: bold;padding-bottom: 10px\">Your submission will be disqualified, if you stop proctoring before completing the test.</p><p style=\"font-family: \'Roboto\';font-size: 14px;font-weight: bold;text-align: justify;padding-bottom: 30px\">You will not be able to login into the test, once you stop proctoring &amp; end test.</p></div></div><div class=row><div class=col-md-12><button class=\"btn btn-primary\" type=button ng-click=$hide();><b>Go back to the test</b></button> <button class=\"btn btn-default\" type=button ng-click=\"data.stopProctoringEndTest = true;$hide();\"><b>Stop proctoring &amp; End test</b></button></div></div></div></div></div>");
$templateCache.put("app/template/modal/modal.userChoiceGroup.html","<div class=modal-content><div class=\"modal-header modal-header-hirepro\"><a ng-if=!vm.isActionEnable type=button class=close ng-click=vm.close()>&times;</a> <b style=\"font-size: 1.4em\">{{vm.heading}}</b></div><div class=modal-body style=max-height:461px;overflow:auto><div class=container><div class=\"row center\"><b style=color:#337ab7;font-size:1.2em>Mandatory Groups</b><ul class=sprite><li ng-repeat=\"grp in vm.items\" ng-class=\"{\'disabled-group\':vm.getDisabilityStat(grp.gpId)}\" ng-show=vm.showGroup(grp.gpId,true) ng-click=vm.addGroup(grp.gpId,true) title={{grp.gpName}}><div class=\"multi-line-ellipsis content\">{{grp.gpName}}</div><div ng-class=\"vm.getDisabilityStat(grp.gpId) ? \'fixed-hover-disabled-item\' : \'hover-item\'\" ng-style=\"{\'background\':grp.color}\"><i ng-show=!vm.getDisabilityStat(grp.gpId) class=\"fa fa-plus fa-2x content\" aria-hidden=true></i> <i ng-show=vm.getDisabilityStat(grp.gpId) class=\"fa fa-check fa-3x content\" aria-hidden=true></i></div></li></ul></div><hr style=\"border:1px solid #5bc0de\"><div class=\"row center\"><b style=color:#337ab7;font-size:1.2em>Optional Groups</b><ul class=sprite><li ng-repeat=\"grp in vm.items\" ng-class=\"{\'disabled-group\':vm.getDisabilityStat(grp.gpId,true)}\" ng-show=vm.showGroup(grp.gpId,false) ng-click=vm.addGroup(grp.gpId,false) title={{grp.gpName}}><div class=\"multi-line-ellipsis content\">{{grp.gpName}}</div><div ng-class=\"vm.getDisabilityStat(grp.gpId,true) ? \'fixed-hover-disabled-item\' : \'hover-item\'\" ng-style=\"{\'background\':grp.color}\"><i ng-show=!vm.getDisabilityStat(grp.gpId,true) class=\"fa fa-plus fa-2x content\" aria-hidden=true></i> <i ng-show=\"vm.getDisabilityStat(grp.gpId,true) && !vm.getLockingStat()\" class=\"fa fa-check fa-3x content\" aria-hidden=true></i> <i ng-show=\"vm.getDisabilityStat(grp.gpId,true) && vm.getLockingStat()\" class=\"fa fa-lock fa-3x content\" aria-hidden=true style=color:#ffa2a2></i></div></li></ul></div></div></div><div class=\"modal-footer modal-footer-hirepro middle\"><submit-button button-type=\"\'modalSubmit\'\" ng-if=\"vm.isOkEnable && !vm.getLockingStat()\"></submit-button><!-- <span class=\"btn btn-primary\" ng-if=\"vm.isCancelEnable\" type=\"button\" ng-click=\"vm.close()\">Go Back</span> --></div></div>");
$templateCache.put("app/template/modal/modal.userChoiceGroup.tpl.html","<div class=modal tabindex=-1 role=dialog><div class=modal-dialog ng-controller=\"RandomGroupSelection as vm\" ng-class=\"{\'modal-lg\' : vm.modalSize == \'lg\'}\"><div class=\"modal-content md-modal-content\"><div class=modal-header><a ng-if=vm.isCancelEnable type=button class=close ng-click=$hide()>&times;</a><h4 class=\"modal-title selectn_modal_header\" ng-bind=vm.headingStr></h4></div><div class=modal-body><div class=\"row center\"><div class=col-md-12><div style=color:var(--themeHEX_background);font-size:1.2em>Mandatory Groups</div><ul class=sprite><li ng-repeat=\"grp in vm.groups | filter:{\'isMandat\': true}\" ng-class=\"{\'disabled-group\':vm.getDisabilityStat(grp.gpId)}\" ng-click=vm.addGroup(grp.gpId,true) title={{grp.gpName}}><div class=\"multi-line-ellipsis content\">{{grp.gpName}}</div><div ng-class=\"vm.getDisabilityStat(grp.gpId) ? \'fixed-hover-disabled-item\' : \'hover-item\'\" ng-style=\"{\'background\':grp.color}\"><i ng-show=!vm.getDisabilityStat(grp.gpId) class=\"fa fa-plus fa-2x content\" aria-hidden=true></i> <i ng-show=vm.getDisabilityStat(grp.gpId) class=\"fa fa-check fa-3x content\" aria-hidden=true></i></div></li></ul></div></div><hr style=\"border:1px solid var(--themeHEX_background)\"><div class=\"row center\"><div class=col-md-12><div style=color:var(--themeHEX_background);font-size:1.2em>Optional Groups</div><ul class=sprite><li ng-repeat=\"grp in vm.groups | filter:{\'isMandat\': false}\" ng-class=\"{\'disabled-group\':vm.getDisabilityStat(grp.gpId,true)}\" ng-click=vm.addGroup(grp.gpId,false) title={{grp.gpName}}><div class=\"multi-line-ellipsis content\">{{grp.gpName}}</div><div ng-class=\"vm.getDisabilityStat(grp.gpId,true) ? \'fixed-hover-disabled-item\' : \'hover-item\'\" ng-style=\"{\'background\':grp.color}\"><i ng-show=!vm.getDisabilityStat(grp.gpId,true) class=\"fa fa-plus fa-2x content\" aria-hidden=true></i> <i ng-show=\"vm.getDisabilityStat(grp.gpId,true) && !vm.getLockingStat()\" class=\"fa fa-check fa-3x content\" aria-hidden=true></i> <i ng-show=\"vm.getDisabilityStat(grp.gpId,true) && vm.getLockingStat()\" class=\"fa fa-lock fa-3x content\" aria-hidden=true style=color:#ffa2a2></i></div></li></ul></div></div></div></div></div></div>");
$templateCache.put("app/template/modal/modal.videoAnswer.tpl.html","<div class=modal tabindex=-1 role=dialog ng-controller=\"videoCompatibilityController as vm\"><div class=modal-dialog><div class=modal-content><div class=modal-header><a ng-if=vm.isCancelEnable type=button class=close ng-click=vm.cancel()>&times;</a><h4 class=\"modal-title selectn_modal_header\" ng-bind=vm.headingStr></h4></div><div class=modal-body style=\"padding:20px 50px\"><div class=row><div class=col-md-12><sample-video-recording is-proctoring=false response-data=vm.onOk(info) options=vm.opts></sample-video-recording></div></div></div><!-- <div class=\"modal-footer\">\n                <button ng-if=\"vm.isRecordingStopped\" class=\"btn btn-primary\" type=\"button\" ng-click=\"vm.reStartRecording();\">Re-record</button>\n                <button ng-show=\"vm.isCompatible\" class=\"btn btn-primary\" type=\"button\" ng-click=\"vm.onOk();\">{{vm.action.okButtonText || \'Proceed To Test\'}}</button>\n            </div> --></div></div></div>");
$templateCache.put("app/thirdparty/messagePosting/getResponse.html","<!DOCTYPE html><html><head><title></title><style type=text/css media=screen>body {\n        font-family: \'Roboto\', sans-serif;\n        font-size: 14px;\n        line-height: 1.9;\n        color: #50555a;\n        font-weight: 300;\n        background-color: var(--primary-color-white);\n    }\n\n    h3 {\n        margin-top: 20px;\n        margin-bottom: 10px;\n        font-size: 24px;\n        line-height: 1.1;\n        color: #24292E;\n    }</style><script type=text/javascript>var remainingTime = 180,\n        showTime = \'00:00\';\n\n    function getURLParameter() {\n        var location, argument, data, submessage;\n\n        location = window.location.href;\n        argument = location.substring(location.lastIndexOf(\'#\') + 1);\n        console.log(\'Location\', location);\n        console.log(\'argument\', argument);\n        try {\n            data = JSON.parse(atob(argument));;\n            console.log(data, \'hafter\');\n            if (data && data.type) {\n                switch (data.type) {\n                    case \'nseit\':\n                        window.parent.parent.parent.postMessage(JSON.stringify(data), \'*\');\n                        break;\n                    default:\n                        window.parent.postMessage(JSON.stringify(data), \'*\');\n                        break;\n                }\n                convertTime();\n                waitTimer();\n            } else {\n                window.parent.postMessage(JSON.stringify(data), \'*\');\n            }\n        } catch (ex) {\n            var message = \'Unexpected Error.\';\n        }\n    }\n\n    window.onload = function() {\n        getURLParameter();\n    };\n\n    function waitTimer() {\n        setInterval(function() {\n            if (remainingTime === 0) {\n                remainingTime = 120;\n                submessage = \'Still working on it.. thank you for your patience.\'\n            }\n            remainingTime--;\n            convertTime();\n        }, 1000);\n    }\n\n    function convertTime() {\n        var mins = parseInt(remainingTime / 60);\n        var secs = remainingTime % 60;\n        if (mins < 10) {\n            showTime = \'0\';\n        }\n        showTime += mins + \':\';\n        if (secs < 10) {\n            showTime += \'0\';\n        }\n        showTime += secs;\n        changeText(\"showTimer\", showTime);\n    }\n\n    function changeText(id, val) {\n        document.getElementById(id).innerHTML = val;\n\n    }</script></head><body><div class=end-test-body style=\"margin: auto 0; text-align: center;\n    margin-top: 16%\"><div><div class=text-center style=margin-top:32px><h1></h1></div><div><h3><b>Please wait while we submit your test.</b></h3><div style=\"color:red;line-height:8px;font-size: medium\">Please do NOT close this window or press refresh/back button.</div><div><div style=\"margin-top: 45px;font-size: 60px;line-height: 24px;margin-bottom: 16px\" id=showTimer></div><div>Remaining</div></div><div style=\"color: grey;margin-top:20px\">This process can take several minutes.</div></div></div></div></body></html>");
$templateCache.put("app/assessment/component/browserVersion/browserVersion.tpl.html","<div ng-if=vm.browserApproved style=\"margin: auto;\n    background-color: transparent;\n    padding: 5px;\n    text-align: center\"><i class=\"fa fa-exclamation-triangle\" aria-hidden=true style=color:#F9975C></i> <span style=color:orange>You are using an unsupported web browser. Please upgrade to a <a href=\"\" ng-click=vm.showSupportedBrowserList()>supported browser.</a></span></div>");}]);